var Wf = Object.defineProperty;
var _f = (Bi) => {
  throw TypeError(Bi);
};
var Gf = (Bi, e, qi) => e in Bi ? Wf(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi;
var cd = (Bi, e, qi) => Gf(Bi, typeof e != "symbol" ? e + "" : e, qi), Gd = (Bi, e, qi) => e.has(Bi) || _f("Cannot " + qi);
var Vl = (Bi, e, qi) => (Gd(Bi, e, "read from private field"), qi ? qi.call(Bi) : e.get(Bi)), $u = (Bi, e, qi) => e.has(Bi) ? _f("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(Bi) : e.set(Bi, qi), Hu = (Bi, e, qi, Xi) => (Gd(Bi, e, "write to private field"), Xi ? Xi.call(Bi, qi) : e.set(Bi, qi), qi), rc = (Bi, e, qi) => (Gd(Bi, e, "access private method"), qi);
var Yd = (Bi, e, qi, Xi) => ({
  set _(Qi) {
    Hu(Bi, e, Qi, qi);
  },
  get _() {
    return Vl(Bi, e, Xi);
  }
});
import * as a$8 from "react";
import a__default, { useState, createContext, useContext, useLayoutEffect, useEffect, useRef, useCallback, useMemo, forwardRef, createElement as createElement$1, cloneElement, Children, isValidElement, Component, memo, PureComponent, useReducer, useImperativeHandle, Fragment } from "react";
import $4AOtR$reactdom, { flushSync as flushSync$1, createPortal, unstable_batchedUpdates } from "react-dom";
import styled, { keyframes as keyframes$2 } from "styled-components";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useField } from "formik";
import { Link } from "react-router-dom";
import { Outlet } from "react-router";
import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
function getDefaultExportFromCjs(Bi) {
  return Bi && Bi.__esModule && Object.prototype.hasOwnProperty.call(Bi, "default") ? Bi.default : Bi;
}
function getAugmentedNamespace(Bi) {
  if (Object.prototype.hasOwnProperty.call(Bi, "__esModule")) return Bi;
  var e = Bi.default;
  if (typeof e == "function") {
    var qi = function Xi() {
      return this instanceof Xi ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    qi.prototype = e.prototype;
  } else qi = {};
  return Object.defineProperty(qi, "__esModule", { value: !0 }), Object.keys(Bi).forEach(function(Xi) {
    var Qi = Object.getOwnPropertyDescriptor(Bi, Xi);
    Object.defineProperty(qi, Xi, Qi.get ? Qi : {
      enumerable: !0,
      get: function() {
        return Bi[Xi];
      }
    });
  }), qi;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var Bi = a__default, e = Symbol.for("react.element"), qi = Symbol.for("react.fragment"), Xi = Object.prototype.hasOwnProperty, Qi = Bi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, ta = { key: !0, ref: !0, __self: !0, __source: !0 };
  function ra(na, la, Ma) {
    var Va, to = {}, Eo = null, So = null;
    Ma !== void 0 && (Eo = "" + Ma), la.key !== void 0 && (Eo = "" + la.key), la.ref !== void 0 && (So = la.ref);
    for (Va in la) Xi.call(la, Va) && !ta.hasOwnProperty(Va) && (to[Va] = la[Va]);
    if (na && na.defaultProps) for (Va in la = na.defaultProps, la) to[Va] === void 0 && (to[Va] = la[Va]);
    return { $$typeof: e, type: na, key: Eo, ref: So, props: to, _owner: Qi.current };
  }
  return reactJsxRuntime_production_min.Fragment = qi, reactJsxRuntime_production_min.jsx = ra, reactJsxRuntime_production_min.jsxs = ra, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Bi = a__default, e = Symbol.for("react.element"), qi = Symbol.for("react.portal"), Xi = Symbol.for("react.fragment"), Qi = Symbol.for("react.strict_mode"), ta = Symbol.for("react.profiler"), ra = Symbol.for("react.provider"), na = Symbol.for("react.context"), la = Symbol.for("react.forward_ref"), Ma = Symbol.for("react.suspense"), Va = Symbol.for("react.suspense_list"), to = Symbol.for("react.memo"), Eo = Symbol.for("react.lazy"), So = Symbol.for("react.offscreen"), eo = Symbol.iterator, rs = "@@iterator";
    function ko(Hl) {
      if (Hl === null || typeof Hl != "object")
        return null;
      var nc = eo && Hl[eo] || Hl[rs];
      return typeof nc == "function" ? nc : null;
    }
    var Hs = Bi.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Ks(Hl) {
      {
        for (var nc = arguments.length, qu = new Array(nc > 1 ? nc - 1 : 0), Yu = 1; Yu < nc; Yu++)
          qu[Yu - 1] = arguments[Yu];
        Ys("error", Hl, qu);
      }
    }
    function Ys(Hl, nc, qu) {
      {
        var Yu = Hs.ReactDebugCurrentFrame, nd = Yu.getStackAddendum();
        nd !== "" && (nc += "%s", qu = qu.concat([nd]));
        var fd = qu.map(function(ad) {
          return String(ad);
        });
        fd.unshift("Warning: " + nc), Function.prototype.apply.call(console[Hl], console, fd);
      }
    }
    var Xs = !1, Cs = !1, Fs = !1, ws = !1, ls = !1, ks;
    ks = Symbol.for("react.module.reference");
    function Js(Hl) {
      return !!(typeof Hl == "string" || typeof Hl == "function" || Hl === Xi || Hl === ta || ls || Hl === Qi || Hl === Ma || Hl === Va || ws || Hl === So || Xs || Cs || Fs || typeof Hl == "object" && Hl !== null && (Hl.$$typeof === Eo || Hl.$$typeof === to || Hl.$$typeof === ra || Hl.$$typeof === na || Hl.$$typeof === la || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Hl.$$typeof === ks || Hl.getModuleId !== void 0));
    }
    function pl(Hl, nc, qu) {
      var Yu = Hl.displayName;
      if (Yu)
        return Yu;
      var nd = nc.displayName || nc.name || "";
      return nd !== "" ? qu + "(" + nd + ")" : qu;
    }
    function _l(Hl) {
      return Hl.displayName || "Context";
    }
    function bl(Hl) {
      if (Hl == null)
        return null;
      if (typeof Hl.tag == "number" && Ks("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Hl == "function")
        return Hl.displayName || Hl.name || null;
      if (typeof Hl == "string")
        return Hl;
      switch (Hl) {
        case Xi:
          return "Fragment";
        case qi:
          return "Portal";
        case ta:
          return "Profiler";
        case Qi:
          return "StrictMode";
        case Ma:
          return "Suspense";
        case Va:
          return "SuspenseList";
      }
      if (typeof Hl == "object")
        switch (Hl.$$typeof) {
          case na:
            var nc = Hl;
            return _l(nc) + ".Consumer";
          case ra:
            var qu = Hl;
            return _l(qu._context) + ".Provider";
          case la:
            return pl(Hl, Hl.render, "ForwardRef");
          case to:
            var Yu = Hl.displayName || null;
            return Yu !== null ? Yu : bl(Hl.type) || "Memo";
          case Eo: {
            var nd = Hl, fd = nd._payload, ad = nd._init;
            try {
              return bl(ad(fd));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var xl = Object.assign, Rl = 0, Cl, Dl, kl, Ul, Bl, Zl, Pl;
    function yl() {
    }
    yl.__reactDisabledLog = !0;
    function hl() {
      {
        if (Rl === 0) {
          Cl = console.log, Dl = console.info, kl = console.warn, Ul = console.error, Bl = console.group, Zl = console.groupCollapsed, Pl = console.groupEnd;
          var Hl = {
            configurable: !0,
            enumerable: !0,
            value: yl,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Hl,
            log: Hl,
            warn: Hl,
            error: Hl,
            group: Hl,
            groupCollapsed: Hl,
            groupEnd: Hl
          });
        }
        Rl++;
      }
    }
    function Tl() {
      {
        if (Rl--, Rl === 0) {
          var Hl = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: xl({}, Hl, {
              value: Cl
            }),
            info: xl({}, Hl, {
              value: Dl
            }),
            warn: xl({}, Hl, {
              value: kl
            }),
            error: xl({}, Hl, {
              value: Ul
            }),
            group: xl({}, Hl, {
              value: Bl
            }),
            groupCollapsed: xl({}, Hl, {
              value: Zl
            }),
            groupEnd: xl({}, Hl, {
              value: Pl
            })
          });
        }
        Rl < 0 && Ks("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Il = Hs.ReactCurrentDispatcher, jl;
    function Al(Hl, nc, qu) {
      {
        if (jl === void 0)
          try {
            throw Error();
          } catch (nd) {
            var Yu = nd.stack.trim().match(/\n( *(at )?)/);
            jl = Yu && Yu[1] || "";
          }
        return `
` + jl + Hl;
      }
    }
    var _s = !1, Gs;
    {
      var vl = typeof WeakMap == "function" ? WeakMap : Map;
      Gs = new vl();
    }
    function gl(Hl, nc) {
      if (!Hl || _s)
        return "";
      {
        var qu = Gs.get(Hl);
        if (qu !== void 0)
          return qu;
      }
      var Yu;
      _s = !0;
      var nd = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var fd;
      fd = Il.current, Il.current = null, hl();
      try {
        if (nc) {
          var ad = function() {
            throw Error();
          };
          if (Object.defineProperty(ad.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ad, []);
            } catch (Cd) {
              Yu = Cd;
            }
            Reflect.construct(Hl, [], ad);
          } else {
            try {
              ad.call();
            } catch (Cd) {
              Yu = Cd;
            }
            Hl.call(ad.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Cd) {
            Yu = Cd;
          }
          Hl();
        }
      } catch (Cd) {
        if (Cd && Yu && typeof Cd.stack == "string") {
          for (var rd = Cd.stack.split(`
`), gd = Yu.stack.split(`
`), pd = rd.length - 1, vd = gd.length - 1; pd >= 1 && vd >= 0 && rd[pd] !== gd[vd]; )
            vd--;
          for (; pd >= 1 && vd >= 0; pd--, vd--)
            if (rd[pd] !== gd[vd]) {
              if (pd !== 1 || vd !== 1)
                do
                  if (pd--, vd--, vd < 0 || rd[pd] !== gd[vd]) {
                    var xd = `
` + rd[pd].replace(" at new ", " at ");
                    return Hl.displayName && xd.includes("<anonymous>") && (xd = xd.replace("<anonymous>", Hl.displayName)), typeof Hl == "function" && Gs.set(Hl, xd), xd;
                  }
                while (pd >= 1 && vd >= 0);
              break;
            }
        }
      } finally {
        _s = !1, Il.current = fd, Tl(), Error.prepareStackTrace = nd;
      }
      var Id = Hl ? Hl.displayName || Hl.name : "", $f = Id ? Al(Id) : "";
      return typeof Hl == "function" && Gs.set(Hl, $f), $f;
    }
    function El(Hl, nc, qu) {
      return gl(Hl, !1);
    }
    function Ol(Hl) {
      var nc = Hl.prototype;
      return !!(nc && nc.isReactComponent);
    }
    function wl(Hl, nc, qu) {
      if (Hl == null)
        return "";
      if (typeof Hl == "function")
        return gl(Hl, Ol(Hl));
      if (typeof Hl == "string")
        return Al(Hl);
      switch (Hl) {
        case Ma:
          return Al("Suspense");
        case Va:
          return Al("SuspenseList");
      }
      if (typeof Hl == "object")
        switch (Hl.$$typeof) {
          case la:
            return El(Hl.render);
          case to:
            return wl(Hl.type, nc, qu);
          case Eo: {
            var Yu = Hl, nd = Yu._payload, fd = Yu._init;
            try {
              return wl(fd(nd), nc, qu);
            } catch {
            }
          }
        }
      return "";
    }
    var dl = Object.prototype.hasOwnProperty, Sl = {}, Ml = Hs.ReactDebugCurrentFrame;
    function Fl(Hl) {
      if (Hl) {
        var nc = Hl._owner, qu = wl(Hl.type, Hl._source, nc ? nc.type : null);
        Ml.setExtraStackFrame(qu);
      } else
        Ml.setExtraStackFrame(null);
    }
    function Ll(Hl, nc, qu, Yu, nd) {
      {
        var fd = Function.call.bind(dl);
        for (var ad in Hl)
          if (fd(Hl, ad)) {
            var rd = void 0;
            try {
              if (typeof Hl[ad] != "function") {
                var gd = Error((Yu || "React class") + ": " + qu + " type `" + ad + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Hl[ad] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw gd.name = "Invariant Violation", gd;
              }
              rd = Hl[ad](nc, ad, Yu, qu, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (pd) {
              rd = pd;
            }
            rd && !(rd instanceof Error) && (Fl(nd), Ks("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Yu || "React class", qu, ad, typeof rd), Fl(null)), rd instanceof Error && !(rd.message in Sl) && (Sl[rd.message] = !0, Fl(nd), Ks("Failed %s type: %s", qu, rd.message), Fl(null));
          }
      }
    }
    var Nl = Array.isArray;
    function ql(Hl) {
      return Nl(Hl);
    }
    function Jl(Hl) {
      {
        var nc = typeof Symbol == "function" && Symbol.toStringTag, qu = nc && Hl[Symbol.toStringTag] || Hl.constructor.name || "Object";
        return qu;
      }
    }
    function zl(Hl) {
      try {
        return tc(Hl), !1;
      } catch {
        return !0;
      }
    }
    function tc(Hl) {
      return "" + Hl;
    }
    function Ku(Hl) {
      if (zl(Hl))
        return Ks("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Jl(Hl)), tc(Hl);
    }
    var tu = Hs.ReactCurrentOwner, Gu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Qu, ed;
    function td(Hl) {
      if (dl.call(Hl, "ref")) {
        var nc = Object.getOwnPropertyDescriptor(Hl, "ref").get;
        if (nc && nc.isReactWarning)
          return !1;
      }
      return Hl.ref !== void 0;
    }
    function od(Hl) {
      if (dl.call(Hl, "key")) {
        var nc = Object.getOwnPropertyDescriptor(Hl, "key").get;
        if (nc && nc.isReactWarning)
          return !1;
      }
      return Hl.key !== void 0;
    }
    function ld(Hl, nc) {
      typeof Hl.ref == "string" && tu.current;
    }
    function sd(Hl, nc) {
      {
        var qu = function() {
          Qu || (Qu = !0, Ks("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", nc));
        };
        qu.isReactWarning = !0, Object.defineProperty(Hl, "key", {
          get: qu,
          configurable: !0
        });
      }
    }
    function bd(Hl, nc) {
      {
        var qu = function() {
          ed || (ed = !0, Ks("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", nc));
        };
        qu.isReactWarning = !0, Object.defineProperty(Hl, "ref", {
          get: qu,
          configurable: !0
        });
      }
    }
    var $d = function(Hl, nc, qu, Yu, nd, fd, ad) {
      var rd = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: Hl,
        key: nc,
        ref: qu,
        props: ad,
        // Record the component responsible for creating this element.
        _owner: fd
      };
      return rd._store = {}, Object.defineProperty(rd._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(rd, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Yu
      }), Object.defineProperty(rd, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: nd
      }), Object.freeze && (Object.freeze(rd.props), Object.freeze(rd)), rd;
    };
    function _d(Hl, nc, qu, Yu, nd) {
      {
        var fd, ad = {}, rd = null, gd = null;
        qu !== void 0 && (Ku(qu), rd = "" + qu), od(nc) && (Ku(nc.key), rd = "" + nc.key), td(nc) && (gd = nc.ref, ld(nc, nd));
        for (fd in nc)
          dl.call(nc, fd) && !Gu.hasOwnProperty(fd) && (ad[fd] = nc[fd]);
        if (Hl && Hl.defaultProps) {
          var pd = Hl.defaultProps;
          for (fd in pd)
            ad[fd] === void 0 && (ad[fd] = pd[fd]);
        }
        if (rd || gd) {
          var vd = typeof Hl == "function" ? Hl.displayName || Hl.name || "Unknown" : Hl;
          rd && sd(ad, vd), gd && bd(ad, vd);
        }
        return $d(Hl, rd, gd, nd, Yu, tu.current, ad);
      }
    }
    var ec = Hs.ReactCurrentOwner, Xl = Hs.ReactDebugCurrentFrame;
    function Ql(Hl) {
      if (Hl) {
        var nc = Hl._owner, qu = wl(Hl.type, Hl._source, nc ? nc.type : null);
        Xl.setExtraStackFrame(qu);
      } else
        Xl.setExtraStackFrame(null);
    }
    var Wu;
    Wu = !1;
    function Xu(Hl) {
      return typeof Hl == "object" && Hl !== null && Hl.$$typeof === e;
    }
    function ud() {
      {
        if (ec.current) {
          var Hl = bl(ec.current.type);
          if (Hl)
            return `

Check the render method of \`` + Hl + "`.";
        }
        return "";
      }
    }
    function dd(Hl) {
      return "";
    }
    var Ed = {};
    function Od(Hl) {
      {
        var nc = ud();
        if (!nc) {
          var qu = typeof Hl == "string" ? Hl : Hl.displayName || Hl.name;
          qu && (nc = `

Check the top-level render call using <` + qu + ">.");
        }
        return nc;
      }
    }
    function wd(Hl, nc) {
      {
        if (!Hl._store || Hl._store.validated || Hl.key != null)
          return;
        Hl._store.validated = !0;
        var qu = Od(nc);
        if (Ed[qu])
          return;
        Ed[qu] = !0;
        var Yu = "";
        Hl && Hl._owner && Hl._owner !== ec.current && (Yu = " It was passed a child from " + bl(Hl._owner.type) + "."), Ql(Hl), Ks('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', qu, Yu), Ql(null);
      }
    }
    function md(Hl, nc) {
      {
        if (typeof Hl != "object")
          return;
        if (ql(Hl))
          for (var qu = 0; qu < Hl.length; qu++) {
            var Yu = Hl[qu];
            Xu(Yu) && wd(Yu, nc);
          }
        else if (Xu(Hl))
          Hl._store && (Hl._store.validated = !0);
        else if (Hl) {
          var nd = ko(Hl);
          if (typeof nd == "function" && nd !== Hl.entries)
            for (var fd = nd.call(Hl), ad; !(ad = fd.next()).done; )
              Xu(ad.value) && wd(ad.value, nc);
        }
      }
    }
    function Pd(Hl) {
      {
        var nc = Hl.type;
        if (nc == null || typeof nc == "string")
          return;
        var qu;
        if (typeof nc == "function")
          qu = nc.propTypes;
        else if (typeof nc == "object" && (nc.$$typeof === la || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        nc.$$typeof === to))
          qu = nc.propTypes;
        else
          return;
        if (qu) {
          var Yu = bl(nc);
          Ll(qu, Hl.props, "prop", Yu, Hl);
        } else if (nc.PropTypes !== void 0 && !Wu) {
          Wu = !0;
          var nd = bl(nc);
          Ks("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", nd || "Unknown");
        }
        typeof nc.getDefaultProps == "function" && !nc.getDefaultProps.isReactClassApproved && Ks("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ad(Hl) {
      {
        for (var nc = Object.keys(Hl.props), qu = 0; qu < nc.length; qu++) {
          var Yu = nc[qu];
          if (Yu !== "children" && Yu !== "key") {
            Ql(Hl), Ks("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Yu), Ql(null);
            break;
          }
        }
        Hl.ref !== null && (Ql(Hl), Ks("Invalid attribute `ref` supplied to `React.Fragment`."), Ql(null));
      }
    }
    function kd(Hl, nc, qu, Yu, nd, fd) {
      {
        var ad = Js(Hl);
        if (!ad) {
          var rd = "";
          (Hl === void 0 || typeof Hl == "object" && Hl !== null && Object.keys(Hl).length === 0) && (rd += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var gd = dd();
          gd ? rd += gd : rd += ud();
          var pd;
          Hl === null ? pd = "null" : ql(Hl) ? pd = "array" : Hl !== void 0 && Hl.$$typeof === e ? (pd = "<" + (bl(Hl.type) || "Unknown") + " />", rd = " Did you accidentally export a JSX literal instead of a component?") : pd = typeof Hl, Ks("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pd, rd);
        }
        var vd = _d(Hl, nc, qu, nd, fd);
        if (vd == null)
          return vd;
        if (ad) {
          var xd = nc.children;
          if (xd !== void 0)
            if (Yu)
              if (ql(xd)) {
                for (var Id = 0; Id < xd.length; Id++)
                  md(xd[Id], Hl);
                Object.freeze && Object.freeze(xd);
              } else
                Ks("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              md(xd, Hl);
        }
        return Hl === Xi ? Ad(vd) : Pd(vd), vd;
      }
    }
    function hd(Hl, nc, qu) {
      return kd(Hl, nc, qu, !0);
    }
    function Dd(Hl, nc, qu) {
      return kd(Hl, nc, qu, !1);
    }
    var Rd = Dd, jd = hd;
    reactJsxRuntime_development.Fragment = Xi, reactJsxRuntime_development.jsx = Rd, reactJsxRuntime_development.jsxs = jd;
  }()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
const FlexBox = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ...Bi });
function r$3(Bi) {
  var e, qi, Xi = "";
  if (typeof Bi == "string" || typeof Bi == "number") Xi += Bi;
  else if (typeof Bi == "object") if (Array.isArray(Bi)) {
    var Qi = Bi.length;
    for (e = 0; e < Qi; e++) Bi[e] && (qi = r$3(Bi[e])) && (Xi && (Xi += " "), Xi += qi);
  } else for (qi in Bi) Bi[qi] && (Xi && (Xi += " "), Xi += qi);
  return Xi;
}
function clsx() {
  for (var Bi, e, qi = 0, Xi = "", Qi = arguments.length; qi < Qi; qi++) (Bi = arguments[qi]) && (e = r$3(Bi)) && (Xi && (Xi += " "), Xi += e);
  return Xi;
}
const falsyToString = (Bi) => typeof Bi == "boolean" ? "".concat(Bi) : Bi === 0 ? "0" : Bi, cx = clsx, cva = (Bi, e) => (qi) => {
  var Xi;
  if (e?.variants == null) return cx(Bi, qi?.class, qi?.className);
  const { variants: Qi, defaultVariants: ta } = e, ra = Object.keys(Qi).map((Ma) => {
    const Va = qi?.[Ma], to = ta?.[Ma];
    if (Va === null) return null;
    const Eo = falsyToString(Va) || falsyToString(to);
    return Qi[Ma][Eo];
  }), na = qi && Object.entries(qi).reduce((Ma, Va) => {
    let [to, Eo] = Va;
    return Eo === void 0 || (Ma[to] = Eo), Ma;
  }, {}), la = e == null || (Xi = e.compoundVariants) === null || Xi === void 0 ? void 0 : Xi.reduce((Ma, Va) => {
    let { class: to, className: Eo, ...So } = Va;
    return Object.entries(So).every((eo) => {
      let [rs, ko] = eo;
      return Array.isArray(ko) ? ko.includes({
        ...ta,
        ...na
      }[rs]) : {
        ...ta,
        ...na
      }[rs] === ko;
    }) ? [
      ...Ma,
      to,
      Eo
    ] : Ma;
  }, []);
  return cx(Bi, ra, la, qi?.class, qi?.className);
};
function twJoin() {
  for (var Bi = 0, e, qi, Xi = ""; Bi < arguments.length; )
    (e = arguments[Bi++]) && (qi = toValue(e)) && (Xi && (Xi += " "), Xi += qi);
  return Xi;
}
function toValue(Bi) {
  if (typeof Bi == "string")
    return Bi;
  for (var e, qi = "", Xi = 0; Xi < Bi.length; Xi++)
    Bi[Xi] && (e = toValue(Bi[Xi])) && (qi && (qi += " "), qi += e);
  return qi;
}
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(Bi) {
  var e = createClassMap(Bi), qi = Bi.conflictingClassGroups, Xi = Bi.conflictingClassGroupModifiers, Qi = Xi === void 0 ? {} : Xi;
  function ta(na) {
    var la = na.split(CLASS_PART_SEPARATOR);
    return la[0] === "" && la.length !== 1 && la.shift(), getGroupRecursive(la, e) || getGroupIdForArbitraryProperty(na);
  }
  function ra(na, la) {
    var Ma = qi[na] || [];
    return la && Qi[na] ? [].concat(Ma, Qi[na]) : Ma;
  }
  return {
    getClassGroupId: ta,
    getConflictingClassGroupIds: ra
  };
}
function getGroupRecursive(Bi, e) {
  if (Bi.length === 0)
    return e.classGroupId;
  var qi = Bi[0], Xi = e.nextPart.get(qi), Qi = Xi ? getGroupRecursive(Bi.slice(1), Xi) : void 0;
  if (Qi)
    return Qi;
  if (e.validators.length !== 0) {
    var ta = Bi.join(CLASS_PART_SEPARATOR);
    return e.validators.find(function(ra) {
      var na = ra.validator;
      return na(ta);
    })?.classGroupId;
  }
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(Bi) {
  if (arbitraryPropertyRegex.test(Bi)) {
    var e = arbitraryPropertyRegex.exec(Bi)[1], qi = e?.substring(0, e.indexOf(":"));
    if (qi)
      return "arbitrary.." + qi;
  }
}
function createClassMap(Bi) {
  var e = Bi.theme, qi = Bi.prefix, Xi = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, Qi = getPrefixedClassGroupEntries(Object.entries(Bi.classGroups), qi);
  return Qi.forEach(function(ta) {
    var ra = ta[0], na = ta[1];
    processClassesRecursively(na, Xi, ra, e);
  }), Xi;
}
function processClassesRecursively(Bi, e, qi, Xi) {
  Bi.forEach(function(Qi) {
    if (typeof Qi == "string") {
      var ta = Qi === "" ? e : getPart(e, Qi);
      ta.classGroupId = qi;
      return;
    }
    if (typeof Qi == "function") {
      if (isThemeGetter(Qi)) {
        processClassesRecursively(Qi(Xi), e, qi, Xi);
        return;
      }
      e.validators.push({
        validator: Qi,
        classGroupId: qi
      });
      return;
    }
    Object.entries(Qi).forEach(function(ra) {
      var na = ra[0], la = ra[1];
      processClassesRecursively(la, getPart(e, na), qi, Xi);
    });
  });
}
function getPart(Bi, e) {
  var qi = Bi;
  return e.split(CLASS_PART_SEPARATOR).forEach(function(Xi) {
    qi.nextPart.has(Xi) || qi.nextPart.set(Xi, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), qi = qi.nextPart.get(Xi);
  }), qi;
}
function isThemeGetter(Bi) {
  return Bi.isThemeGetter;
}
function getPrefixedClassGroupEntries(Bi, e) {
  return e ? Bi.map(function(qi) {
    var Xi = qi[0], Qi = qi[1], ta = Qi.map(function(ra) {
      return typeof ra == "string" ? e + ra : typeof ra == "object" ? Object.fromEntries(Object.entries(ra).map(function(na) {
        var la = na[0], Ma = na[1];
        return [e + la, Ma];
      })) : ra;
    });
    return [Xi, ta];
  }) : Bi;
}
function createLruCache(Bi) {
  if (Bi < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, qi = /* @__PURE__ */ new Map(), Xi = /* @__PURE__ */ new Map();
  function Qi(ta, ra) {
    qi.set(ta, ra), e++, e > Bi && (e = 0, Xi = qi, qi = /* @__PURE__ */ new Map());
  }
  return {
    get: function(ra) {
      var na = qi.get(ra);
      if (na !== void 0)
        return na;
      if ((na = Xi.get(ra)) !== void 0)
        return Qi(ra, na), na;
    },
    set: function(ra, na) {
      qi.has(ra) ? qi.set(ra, na) : Qi(ra, na);
    }
  };
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(Bi) {
  var e = Bi.separator || ":", qi = e.length === 1, Xi = e[0], Qi = e.length;
  return function(ra) {
    for (var na = [], la = 0, Ma = 0, Va, to = 0; to < ra.length; to++) {
      var Eo = ra[to];
      if (la === 0) {
        if (Eo === Xi && (qi || ra.slice(to, to + Qi) === e)) {
          na.push(ra.slice(Ma, to)), Ma = to + Qi;
          continue;
        }
        if (Eo === "/") {
          Va = to;
          continue;
        }
      }
      Eo === "[" ? la++ : Eo === "]" && la--;
    }
    var So = na.length === 0 ? ra : ra.substring(Ma), eo = So.startsWith(IMPORTANT_MODIFIER), rs = eo ? So.substring(1) : So, ko = Va && Va > Ma ? Va - Ma : void 0;
    return {
      modifiers: na,
      hasImportantModifier: eo,
      baseClassName: rs,
      maybePostfixModifierPosition: ko
    };
  };
}
function sortModifiers(Bi) {
  if (Bi.length <= 1)
    return Bi;
  var e = [], qi = [];
  return Bi.forEach(function(Xi) {
    var Qi = Xi[0] === "[";
    Qi ? (e.push.apply(e, qi.sort().concat([Xi])), qi = []) : qi.push(Xi);
  }), e.push.apply(e, qi.sort()), e;
}
function createConfigUtils(Bi) {
  return {
    cache: createLruCache(Bi.cacheSize),
    splitModifiers: createSplitModifiers(Bi),
    ...createClassUtils(Bi)
  };
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(Bi, e) {
  var qi = e.splitModifiers, Xi = e.getClassGroupId, Qi = e.getConflictingClassGroupIds, ta = /* @__PURE__ */ new Set();
  return Bi.trim().split(SPLIT_CLASSES_REGEX).map(function(ra) {
    var na = qi(ra), la = na.modifiers, Ma = na.hasImportantModifier, Va = na.baseClassName, to = na.maybePostfixModifierPosition, Eo = Xi(to ? Va.substring(0, to) : Va), So = !!to;
    if (!Eo) {
      if (!to)
        return {
          isTailwindClass: !1,
          originalClassName: ra
        };
      if (Eo = Xi(Va), !Eo)
        return {
          isTailwindClass: !1,
          originalClassName: ra
        };
      So = !1;
    }
    var eo = sortModifiers(la).join(":"), rs = Ma ? eo + IMPORTANT_MODIFIER : eo;
    return {
      isTailwindClass: !0,
      modifierId: rs,
      classGroupId: Eo,
      originalClassName: ra,
      hasPostfixModifier: So
    };
  }).reverse().filter(function(ra) {
    if (!ra.isTailwindClass)
      return !0;
    var na = ra.modifierId, la = ra.classGroupId, Ma = ra.hasPostfixModifier, Va = na + la;
    return ta.has(Va) ? !1 : (ta.add(Va), Qi(la, Ma).forEach(function(to) {
      return ta.add(na + to);
    }), !0);
  }).reverse().map(function(ra) {
    return ra.originalClassName;
  }).join(" ");
}
function createTailwindMerge() {
  for (var Bi = arguments.length, e = new Array(Bi), qi = 0; qi < Bi; qi++)
    e[qi] = arguments[qi];
  var Xi, Qi, ta, ra = na;
  function na(Ma) {
    var Va = e[0], to = e.slice(1), Eo = to.reduce(function(So, eo) {
      return eo(So);
    }, Va());
    return Xi = createConfigUtils(Eo), Qi = Xi.cache.get, ta = Xi.cache.set, ra = la, la(Ma);
  }
  function la(Ma) {
    var Va = Qi(Ma);
    if (Va)
      return Va;
    var to = mergeClassList(Ma, Xi);
    return ta(Ma, to), to;
  }
  return function() {
    return ra(twJoin.apply(null, arguments));
  };
}
function fromTheme(Bi) {
  var e = function(Xi) {
    return Xi[Bi] || [];
  };
  return e.isThemeGetter = !0, e;
}
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i, fractionRegex = /^\d+\/\d+$/, stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]), tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|^0$/, shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength(Bi) {
  return isNumber(Bi) || stringLengths.has(Bi) || fractionRegex.test(Bi) || isArbitraryLength(Bi);
}
function isArbitraryLength(Bi) {
  return getIsArbitraryValue(Bi, "length", isLengthOnly);
}
function isArbitrarySize(Bi) {
  return getIsArbitraryValue(Bi, "size", isNever);
}
function isArbitraryPosition(Bi) {
  return getIsArbitraryValue(Bi, "position", isNever);
}
function isArbitraryUrl(Bi) {
  return getIsArbitraryValue(Bi, "url", isUrl);
}
function isArbitraryNumber(Bi) {
  return getIsArbitraryValue(Bi, "number", isNumber);
}
function isNumber(Bi) {
  return !Number.isNaN(Number(Bi));
}
function isPercent(Bi) {
  return Bi.endsWith("%") && isNumber(Bi.slice(0, -1));
}
function isInteger(Bi) {
  return isIntegerOnly(Bi) || getIsArbitraryValue(Bi, "number", isIntegerOnly);
}
function isArbitraryValue(Bi) {
  return arbitraryValueRegex.test(Bi);
}
function isAny() {
  return !0;
}
function isTshirtSize(Bi) {
  return tshirtUnitRegex.test(Bi);
}
function isArbitraryShadow(Bi) {
  return getIsArbitraryValue(Bi, "", isShadow);
}
function getIsArbitraryValue(Bi, e, qi) {
  var Xi = arbitraryValueRegex.exec(Bi);
  return Xi ? Xi[1] ? Xi[1] === e : qi(Xi[2]) : !1;
}
function isLengthOnly(Bi) {
  return lengthUnitRegex.test(Bi);
}
function isNever() {
  return !1;
}
function isUrl(Bi) {
  return Bi.startsWith("url(");
}
function isIntegerOnly(Bi) {
  return Number.isInteger(Number(Bi));
}
function isShadow(Bi) {
  return shadowRegex.test(Bi);
}
function getDefaultConfig() {
  var Bi = fromTheme("colors"), e = fromTheme("spacing"), qi = fromTheme("blur"), Xi = fromTheme("brightness"), Qi = fromTheme("borderColor"), ta = fromTheme("borderRadius"), ra = fromTheme("borderSpacing"), na = fromTheme("borderWidth"), la = fromTheme("contrast"), Ma = fromTheme("grayscale"), Va = fromTheme("hueRotate"), to = fromTheme("invert"), Eo = fromTheme("gap"), So = fromTheme("gradientColorStops"), eo = fromTheme("gradientColorStopPositions"), rs = fromTheme("inset"), ko = fromTheme("margin"), Hs = fromTheme("opacity"), Ks = fromTheme("padding"), Ys = fromTheme("saturate"), Xs = fromTheme("scale"), Cs = fromTheme("sepia"), Fs = fromTheme("skew"), ws = fromTheme("space"), ls = fromTheme("translate"), ks = function() {
    return ["auto", "contain", "none"];
  }, Js = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, pl = function() {
    return ["auto", e];
  }, _l = function() {
    return ["", isLength];
  }, bl = function() {
    return ["auto", isNumber, isArbitraryValue];
  }, xl = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Rl = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, Cl = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, Dl = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, kl = function() {
    return ["", "0", isArbitraryValue];
  }, Ul = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Bl = function() {
    return [isNumber, isArbitraryNumber];
  }, Zl = function() {
    return [isNumber, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength],
      blur: ["none", "", isTshirtSize, isArbitraryLength],
      brightness: Bl(),
      borderColor: [Bi],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryLength],
      borderSpacing: [e],
      borderWidth: _l(),
      contrast: Bl(),
      grayscale: kl(),
      hueRotate: Zl(),
      invert: kl(),
      gap: [e],
      gradientColorStops: [Bi],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: pl(),
      margin: pl(),
      opacity: Bl(),
      padding: [e],
      saturate: Bl(),
      scale: Bl(),
      sepia: kl(),
      skew: Zl(),
      space: [e],
      translate: [e]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Ul()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Ul()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(xl(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Js()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Js()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Js()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: ks()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": ks()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": ks()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [rs]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [rs]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [rs]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [rs]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [rs]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [rs]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [rs]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [rs]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [rs]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: pl()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: kl()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: kl()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": bl()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": bl()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": bl()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": bl()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [Eo]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [Eo]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [Eo]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(Dl())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(Dl(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(Dl(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [Ks]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [Ks]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [Ks]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [Ks]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [Ks]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [Ks]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [Ks]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [Ks]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [Ks]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [ko]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [ko]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [ko]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [ko]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [ko]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [ko]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [ko]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [ko]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [ko]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [ws]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [ws]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryLength]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isLength]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryLength]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [Bi]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [Hs]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [Bi]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [Hs]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Rl(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [Bi]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [e]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryLength]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [Hs]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(xl(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [Bi]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [eo]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [eo]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [eo]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [So]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [So]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [So]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [ta]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [ta]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [ta]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [ta]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [ta]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [ta]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [ta]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [ta]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [ta]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [ta]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [ta]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [ta]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [ta]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [ta]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [ta]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [na]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [na]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [na]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [na]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [na]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [na]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [na]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [na]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [na]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [Hs]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Rl(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [na]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [na]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [Hs]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Rl()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [Qi]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [Qi]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [Qi]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [Qi]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [Qi]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [Qi]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [Qi]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [Qi]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Rl())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [Bi]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: _l()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [Bi]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [Hs]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [Bi]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Hs]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": Cl()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Cl()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [qi]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Xi]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [la]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [Ma]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Va]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [to]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Ys]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [Cs]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [qi]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Xi]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [la]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [Ma]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Va]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [to]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Hs]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Ys]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [Cs]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [ra]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [ra]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [ra]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Zl()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Zl()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [Xs]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [Xs]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [Xs]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [ls]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [ls]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [Fs]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [Fs]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", Bi]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [Bi]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [e]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [e]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [e]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [e]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [e]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [e]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [e]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [e]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [e]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [e]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [e]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [e]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [e]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [e]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [e]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [e]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [e]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [e]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [Bi, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [Bi, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
const buttonVariants = cva(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), Button = ({
  variant: Bi = "black",
  className: e,
  ...qi
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    ...qi,
    className: twMerge(buttonVariants({ variant: Bi }), e)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const faBars = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, faChevronUp = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, faClipboard = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, faUserGear = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, faUserCog = faUserGear, faChevronDown = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, faX = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function _defineProperty$8(Bi, e, qi) {
  return (e = _toPropertyKey$1(e)) in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function ownKeys$4(Bi, e) {
  var qi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Xi = Object.getOwnPropertySymbols(Bi);
    e && (Xi = Xi.filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(Bi, Qi).enumerable;
    })), qi.push.apply(qi, Xi);
  }
  return qi;
}
function _objectSpread2$1(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$4(Object(qi), !0).forEach(function(Xi) {
      _defineProperty$8(Bi, Xi, qi[Xi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(qi)) : ownKeys$4(Object(qi)).forEach(function(Xi) {
      Object.defineProperty(Bi, Xi, Object.getOwnPropertyDescriptor(qi, Xi));
    });
  }
  return Bi;
}
function _toPrimitive$1(Bi, e) {
  if (typeof Bi != "object" || !Bi) return Bi;
  var qi = Bi[Symbol.toPrimitive];
  if (qi !== void 0) {
    var Xi = qi.call(Bi, e);
    if (typeof Xi != "object") return Xi;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(Bi);
}
function _toPropertyKey$1(Bi) {
  var e = _toPrimitive$1(Bi, "string");
  return typeof e == "symbol" ? e : e + "";
}
const noop$2 = () => {
};
let _WINDOW = {}, _DOCUMENT = {}, _MUTATION_OBSERVER = null, _PERFORMANCE = {
  mark: noop$2,
  measure: noop$2
};
try {
  typeof window < "u" && (_WINDOW = window), typeof document < "u" && (_DOCUMENT = document), typeof MutationObserver < "u" && (_MUTATION_OBSERVER = MutationObserver), typeof performance < "u" && (_PERFORMANCE = performance);
} catch {
}
const {
  userAgent = ""
} = _WINDOW.navigator || {}, WINDOW = _WINDOW, DOCUMENT = _DOCUMENT, MUTATION_OBSERVER = _MUTATION_OBSERVER, PERFORMANCE = _PERFORMANCE;
WINDOW.document;
const IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener == "function" && typeof DOCUMENT.createElement == "function", IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var p$4 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, g$4 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, S$2 = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, A$2 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, P$3 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], s$5 = "classic", t$7 = "duotone", r$2 = "sharp", o$1 = "sharp-duotone", L$3 = [s$5, t$7, r$2, o$1], G$3 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, lt$3 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, pt$3 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), xt$3 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Ft$3 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], St$3 = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, At$3 = ["kit"], Ct$3 = {
  kit: {
    "fa-kit": "fak"
  }
}, Lt$3 = ["fak", "fakd"], Wt$3 = {
  kit: {
    fak: "fa-kit"
  }
}, Et$3 = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, t$1$1 = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, r$1$1 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], bt$1$1 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], Yt$3 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, ua$1 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, I$1$1 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, ga$1 = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, x$3 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Ia$1 = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...r$1$1, ...x$3], m$1$1 = ["solid", "regular", "light", "thin", "duotone", "brands"], c$1$1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], F$1$1 = c$1$1.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), ma$1 = [...Object.keys(I$1$1), ...m$1$1, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", t$1$1.GROUP, t$1$1.SWAP_OPACITY, t$1$1.PRIMARY, t$1$1.SECONDARY].concat(c$1$1.map((Bi) => "".concat(Bi, "x"))).concat(F$1$1.map((Bi) => "w-".concat(Bi))), wa$1 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const NAMESPACE_IDENTIFIER = "___FONT_AWESOME___", UNITS_IN_GRID = 16, DEFAULT_CSS_PREFIX = "fa", DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa", DATA_FA_I2SVG = "data-fa-i2svg", DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element", DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending", DATA_PREFIX = "data-prefix", DATA_ICON = "data-icon", HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg", MUTATION_APPROACH_ASYNC = "async", TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"], PRODUCTION$1 = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function familyProxy(Bi) {
  return new Proxy(Bi, {
    get(e, qi) {
      return qi in e ? e[qi] : e[s$5];
    }
  });
}
const _PREFIX_TO_STYLE = _objectSpread2$1({}, S$2);
_PREFIX_TO_STYLE[s$5] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  "fa-duotone": "duotone"
}), S$2[s$5]), St$3.kit), St$3["kit-duotone"]);
const PREFIX_TO_STYLE = familyProxy(_PREFIX_TO_STYLE), _STYLE_TO_PREFIX = _objectSpread2$1({}, xt$3);
_STYLE_TO_PREFIX[s$5] = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  duotone: "fad"
}), _STYLE_TO_PREFIX[s$5]), Et$3.kit), Et$3["kit-duotone"]);
const STYLE_TO_PREFIX = familyProxy(_STYLE_TO_PREFIX), _PREFIX_TO_LONG_STYLE = _objectSpread2$1({}, ga$1);
_PREFIX_TO_LONG_STYLE[s$5] = _objectSpread2$1(_objectSpread2$1({}, _PREFIX_TO_LONG_STYLE[s$5]), Wt$3.kit);
const PREFIX_TO_LONG_STYLE = familyProxy(_PREFIX_TO_LONG_STYLE), _LONG_STYLE_TO_PREFIX = _objectSpread2$1({}, ua$1);
_LONG_STYLE_TO_PREFIX[s$5] = _objectSpread2$1(_objectSpread2$1({}, _LONG_STYLE_TO_PREFIX[s$5]), Ct$3.kit);
familyProxy(_LONG_STYLE_TO_PREFIX);
const ICON_SELECTION_SYNTAX_PATTERN = p$4, LAYERS_TEXT_CLASSNAME = "fa-layers-text", FONT_FAMILY_PATTERN = g$4, _FONT_WEIGHT_TO_PREFIX = _objectSpread2$1({}, G$3);
familyProxy(_FONT_WEIGHT_TO_PREFIX);
const ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], DUOTONE_CLASSES = A$2, RESERVED_CLASSES = [...At$3, ...ma$1], initial$1 = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(Bi) {
  var e = DOCUMENT.querySelector("script[" + Bi + "]");
  if (e)
    return e.getAttribute(Bi);
}
function coerce(Bi) {
  return Bi === "" ? !0 : Bi === "false" ? !1 : Bi === "true" ? !0 : Bi;
}
DOCUMENT && typeof DOCUMENT.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((e) => {
  let [qi, Xi] = e;
  const Qi = coerce(getAttrConfig(qi));
  Qi != null && (initial$1[Xi] = Qi);
});
const _default = {
  styleDefault: "solid",
  familyDefault: s$5,
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
initial$1.familyPrefix && (initial$1.cssPrefix = initial$1.familyPrefix);
const _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial$1);
_config.autoReplaceSvg || (_config.observeMutations = !1);
const config = {};
Object.keys(_default).forEach((Bi) => {
  Object.defineProperty(config, Bi, {
    enumerable: !0,
    set: function(e) {
      _config[Bi] = e, _onChangeCb.forEach((qi) => qi(config));
    },
    get: function() {
      return _config[Bi];
    }
  });
});
Object.defineProperty(config, "familyPrefix", {
  enumerable: !0,
  set: function(Bi) {
    _config.cssPrefix = Bi, _onChangeCb.forEach((e) => e(config));
  },
  get: function() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
const _onChangeCb = [];
function onChange(Bi) {
  return _onChangeCb.push(Bi), () => {
    _onChangeCb.splice(_onChangeCb.indexOf(Bi), 1);
  };
}
const d$2$1 = UNITS_IN_GRID, meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function insertCss(Bi) {
  if (!Bi || !IS_DOM)
    return;
  const e = DOCUMENT.createElement("style");
  e.setAttribute("type", "text/css"), e.innerHTML = Bi;
  const qi = DOCUMENT.head.childNodes;
  let Xi = null;
  for (let Qi = qi.length - 1; Qi > -1; Qi--) {
    const ta = qi[Qi], ra = (ta.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(ra) > -1 && (Xi = ta);
  }
  return DOCUMENT.head.insertBefore(e, Xi), Bi;
}
const idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId$1() {
  let Bi = 12, e = "";
  for (; Bi-- > 0; )
    e += idPool[Math.random() * 62 | 0];
  return e;
}
function toArray(Bi) {
  const e = [];
  for (let qi = (Bi || []).length >>> 0; qi--; )
    e[qi] = Bi[qi];
  return e;
}
function classArray(Bi) {
  return Bi.classList ? toArray(Bi.classList) : (Bi.getAttribute("class") || "").split(" ").filter((e) => e);
}
function htmlEscape(Bi) {
  return "".concat(Bi).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(Bi) {
  return Object.keys(Bi || {}).reduce((e, qi) => e + "".concat(qi, '="').concat(htmlEscape(Bi[qi]), '" '), "").trim();
}
function joinStyles(Bi) {
  return Object.keys(Bi || {}).reduce((e, qi) => e + "".concat(qi, ": ").concat(Bi[qi].trim(), ";"), "");
}
function transformIsMeaningful(Bi) {
  return Bi.size !== meaninglessTransform.size || Bi.x !== meaninglessTransform.x || Bi.y !== meaninglessTransform.y || Bi.rotate !== meaninglessTransform.rotate || Bi.flipX || Bi.flipY;
}
function transformForSvg(Bi) {
  let {
    transform: e,
    containerWidth: qi,
    iconWidth: Xi
  } = Bi;
  const Qi = {
    transform: "translate(".concat(qi / 2, " 256)")
  }, ta = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), ra = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), na = "rotate(".concat(e.rotate, " 0 0)"), la = {
    transform: "".concat(ta, " ").concat(ra, " ").concat(na)
  }, Ma = {
    transform: "translate(".concat(Xi / 2 * -1, " -256)")
  };
  return {
    outer: Qi,
    inner: la,
    path: Ma
  };
}
function transformForCss(Bi) {
  let {
    transform: e,
    width: qi = UNITS_IN_GRID,
    height: Xi = UNITS_IN_GRID,
    startCentered: Qi = !1
  } = Bi, ta = "";
  return Qi && IS_IE ? ta += "translate(".concat(e.x / d$2$1 - qi / 2, "em, ").concat(e.y / d$2$1 - Xi / 2, "em) ") : Qi ? ta += "translate(calc(-50% + ".concat(e.x / d$2$1, "em), calc(-50% + ").concat(e.y / d$2$1, "em)) ") : ta += "translate(".concat(e.x / d$2$1, "em, ").concat(e.y / d$2$1, "em) "), ta += "scale(".concat(e.size / d$2$1 * (e.flipX ? -1 : 1), ", ").concat(e.size / d$2$1 * (e.flipY ? -1 : 1), ") "), ta += "rotate(".concat(e.rotate, "deg) "), ta;
}
var baseStyles = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function css() {
  const Bi = DEFAULT_CSS_PREFIX, e = DEFAULT_REPLACEMENT_CLASS, qi = config.cssPrefix, Xi = config.replacementClass;
  let Qi = baseStyles;
  if (qi !== Bi || Xi !== e) {
    const ta = new RegExp("\\.".concat(Bi, "\\-"), "g"), ra = new RegExp("\\--".concat(Bi, "\\-"), "g"), na = new RegExp("\\.".concat(e), "g");
    Qi = Qi.replace(ta, ".".concat(qi, "-")).replace(ra, "--".concat(qi, "-")).replace(na, ".".concat(Xi));
  }
  return Qi;
}
let _cssInserted = !1;
function ensureCss() {
  config.autoAddCss && !_cssInserted && (insertCss(css()), _cssInserted = !0);
}
var InjectCSS = {
  mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg() {
        ensureCss();
      }
    };
  }
};
const w$3 = WINDOW || {};
w$3[NAMESPACE_IDENTIFIER] || (w$3[NAMESPACE_IDENTIFIER] = {});
w$3[NAMESPACE_IDENTIFIER].styles || (w$3[NAMESPACE_IDENTIFIER].styles = {});
w$3[NAMESPACE_IDENTIFIER].hooks || (w$3[NAMESPACE_IDENTIFIER].hooks = {});
w$3[NAMESPACE_IDENTIFIER].shims || (w$3[NAMESPACE_IDENTIFIER].shims = []);
var namespace = w$3[NAMESPACE_IDENTIFIER];
const functions = [], listener = function() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener), loaded = 1, functions.map((Bi) => Bi());
};
let loaded = !1;
IS_DOM && (loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState), loaded || DOCUMENT.addEventListener("DOMContentLoaded", listener));
function domready(Bi) {
  IS_DOM && (loaded ? setTimeout(Bi, 0) : functions.push(Bi));
}
function toHtml(Bi) {
  const {
    tag: e,
    attributes: qi = {},
    children: Xi = []
  } = Bi;
  return typeof Bi == "string" ? htmlEscape(Bi) : "<".concat(e, " ").concat(joinAttributes(qi), ">").concat(Xi.map(toHtml).join(""), "</").concat(e, ">");
}
function iconFromMapping(Bi, e, qi) {
  if (Bi && Bi[e] && Bi[e][qi])
    return {
      prefix: e,
      iconName: qi,
      icon: Bi[e][qi]
    };
}
var reduce$6 = function(e, qi, Xi, Qi) {
  var ta = Object.keys(e), ra = ta.length, na = qi, la, Ma, Va;
  for (Xi === void 0 ? (la = 1, Va = e[ta[0]]) : (la = 0, Va = Xi); la < ra; la++)
    Ma = ta[la], Va = na(Va, e[Ma], Ma, e);
  return Va;
};
function ucs2decode(Bi) {
  const e = [];
  let qi = 0;
  const Xi = Bi.length;
  for (; qi < Xi; ) {
    const Qi = Bi.charCodeAt(qi++);
    if (Qi >= 55296 && Qi <= 56319 && qi < Xi) {
      const ta = Bi.charCodeAt(qi++);
      (ta & 64512) == 56320 ? e.push(((Qi & 1023) << 10) + (ta & 1023) + 65536) : (e.push(Qi), qi--);
    } else
      e.push(Qi);
  }
  return e;
}
function toHex(Bi) {
  const e = ucs2decode(Bi);
  return e.length === 1 ? e[0].toString(16) : null;
}
function codePointAt(Bi, e) {
  const qi = Bi.length;
  let Xi = Bi.charCodeAt(e), Qi;
  return Xi >= 55296 && Xi <= 56319 && qi > e + 1 && (Qi = Bi.charCodeAt(e + 1), Qi >= 56320 && Qi <= 57343) ? (Xi - 55296) * 1024 + Qi - 56320 + 65536 : Xi;
}
function normalizeIcons(Bi) {
  return Object.keys(Bi).reduce((e, qi) => {
    const Xi = Bi[qi];
    return !!Xi.icon ? e[Xi.iconName] = Xi.icon : e[qi] = Xi, e;
  }, {});
}
function defineIcons(Bi, e) {
  let qi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: Xi = !1
  } = qi, Qi = normalizeIcons(e);
  typeof namespace.hooks.addPack == "function" && !Xi ? namespace.hooks.addPack(Bi, normalizeIcons(e)) : namespace.styles[Bi] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[Bi] || {}), Qi), Bi === "fas" && defineIcons("fa", e);
}
const {
  styles: styles$1,
  shims
} = namespace, FAMILY_NAMES = Object.keys(PREFIX_TO_LONG_STYLE), PREFIXES_FOR_FAMILY = FAMILY_NAMES.reduce((Bi, e) => (Bi[e] = Object.keys(PREFIX_TO_LONG_STYLE[e]), Bi), {});
let _defaultUsablePrefix = null, _byUnicode = {}, _byLigature = {}, _byOldName = {}, _byOldUnicode = {}, _byAlias = {};
function isReserved(Bi) {
  return ~RESERVED_CLASSES.indexOf(Bi);
}
function getIconName(Bi, e) {
  const qi = e.split("-"), Xi = qi[0], Qi = qi.slice(1).join("-");
  return Xi === Bi && Qi !== "" && !isReserved(Qi) ? Qi : null;
}
const build = () => {
  const Bi = (Xi) => reduce$6(styles$1, (Qi, ta, ra) => (Qi[ra] = reduce$6(ta, Xi, {}), Qi), {});
  _byUnicode = Bi((Xi, Qi, ta) => (Qi[3] && (Xi[Qi[3]] = ta), Qi[2] && Qi[2].filter((na) => typeof na == "number").forEach((na) => {
    Xi[na.toString(16)] = ta;
  }), Xi)), _byLigature = Bi((Xi, Qi, ta) => (Xi[ta] = ta, Qi[2] && Qi[2].filter((na) => typeof na == "string").forEach((na) => {
    Xi[na] = ta;
  }), Xi)), _byAlias = Bi((Xi, Qi, ta) => {
    const ra = Qi[2];
    return Xi[ta] = ta, ra.forEach((na) => {
      Xi[na] = ta;
    }), Xi;
  });
  const e = "far" in styles$1 || config.autoFetchSvg, qi = reduce$6(shims, (Xi, Qi) => {
    const ta = Qi[0];
    let ra = Qi[1];
    const na = Qi[2];
    return ra === "far" && !e && (ra = "fas"), typeof ta == "string" && (Xi.names[ta] = {
      prefix: ra,
      iconName: na
    }), typeof ta == "number" && (Xi.unicodes[ta.toString(16)] = {
      prefix: ra,
      iconName: na
    }), Xi;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = qi.names, _byOldUnicode = qi.unicodes, _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange((Bi) => {
  _defaultUsablePrefix = getCanonicalPrefix(Bi.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(Bi, e) {
  return (_byUnicode[Bi] || {})[e];
}
function byLigature(Bi, e) {
  return (_byLigature[Bi] || {})[e];
}
function byAlias(Bi, e) {
  return (_byAlias[Bi] || {})[e];
}
function byOldName(Bi) {
  return _byOldName[Bi] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(Bi) {
  const e = _byOldUnicode[Bi], qi = byUnicode("fas", Bi);
  return e || (qi ? {
    prefix: "fas",
    iconName: qi
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
const emptyCanonicalIcon = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function getFamilyId(Bi) {
  let e = s$5;
  const qi = FAMILY_NAMES.reduce((Xi, Qi) => (Xi[Qi] = "".concat(config.cssPrefix, "-").concat(Qi), Xi), {});
  return L$3.forEach((Xi) => {
    (Bi.includes(qi[Xi]) || Bi.some((Qi) => PREFIXES_FOR_FAMILY[Xi].includes(Qi))) && (e = Xi);
  }), e;
}
function getCanonicalPrefix(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: qi = s$5
  } = e, Xi = PREFIX_TO_STYLE[qi][Bi];
  if (qi === t$7 && !Bi)
    return "fad";
  const Qi = STYLE_TO_PREFIX[qi][Bi] || STYLE_TO_PREFIX[qi][Xi], ta = Bi in namespace.styles ? Bi : null;
  return Qi || ta || null;
}
function moveNonFaClassesToRest(Bi) {
  let e = [], qi = null;
  return Bi.forEach((Xi) => {
    const Qi = getIconName(config.cssPrefix, Xi);
    Qi ? qi = Qi : Xi && e.push(Xi);
  }), {
    iconName: qi,
    rest: e
  };
}
function sortedUniqueValues(Bi) {
  return Bi.sort().filter((e, qi, Xi) => Xi.indexOf(e) === qi);
}
function getCanonicalIcon(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: qi = !1
  } = e;
  let Xi = null;
  const Qi = Ia$1.concat(bt$1$1), ta = sortedUniqueValues(Bi.filter((to) => Qi.includes(to))), ra = sortedUniqueValues(Bi.filter((to) => !Ia$1.includes(to))), na = ta.filter((to) => (Xi = to, !P$3.includes(to))), [la = null] = na, Ma = getFamilyId(ta), Va = _objectSpread2$1(_objectSpread2$1({}, moveNonFaClassesToRest(ra)), {}, {
    prefix: getCanonicalPrefix(la, {
      family: Ma
    })
  });
  return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, Va), getDefaultCanonicalPrefix({
    values: Bi,
    family: Ma,
    styles: styles$1,
    config,
    canonical: Va,
    givenPrefix: Xi
  })), applyShimAndAlias(qi, Xi, Va));
}
function applyShimAndAlias(Bi, e, qi) {
  let {
    prefix: Xi,
    iconName: Qi
  } = qi;
  if (Bi || !Xi || !Qi)
    return {
      prefix: Xi,
      iconName: Qi
    };
  const ta = e === "fa" ? byOldName(Qi) : {}, ra = byAlias(Xi, Qi);
  return Qi = ta.iconName || ra || Qi, Xi = ta.prefix || Xi, Xi === "far" && !styles$1.far && styles$1.fas && !config.autoFetchSvg && (Xi = "fas"), {
    prefix: Xi,
    iconName: Qi
  };
}
const newCanonicalFamilies = L$3.filter((Bi) => Bi !== s$5 || Bi !== t$7), newCanonicalStyles = Object.keys(ga$1).filter((Bi) => Bi !== s$5).map((Bi) => Object.keys(ga$1[Bi])).flat();
function getDefaultCanonicalPrefix(Bi) {
  const {
    values: e,
    family: qi,
    canonical: Xi,
    givenPrefix: Qi = "",
    styles: ta = {},
    config: ra = {}
  } = Bi, na = qi === t$7, la = e.includes("fa-duotone") || e.includes("fad"), Ma = ra.familyDefault === "duotone", Va = Xi.prefix === "fad" || Xi.prefix === "fa-duotone";
  if (!na && (la || Ma || Va) && (Xi.prefix = "fad"), (e.includes("fa-brands") || e.includes("fab")) && (Xi.prefix = "fab"), !Xi.prefix && newCanonicalFamilies.includes(qi) && (Object.keys(ta).find((Eo) => newCanonicalStyles.includes(Eo)) || ra.autoFetchSvg)) {
    const Eo = pt$3.get(qi).defaultShortPrefixId;
    Xi.prefix = Eo, Xi.iconName = byAlias(Xi.prefix, Xi.iconName) || Xi.iconName;
  }
  return (Xi.prefix === "fa" || Qi === "fa") && (Xi.prefix = getDefaultUsablePrefix() || "fas"), Xi;
}
class Library {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var e = arguments.length, qi = new Array(e), Xi = 0; Xi < e; Xi++)
      qi[Xi] = arguments[Xi];
    const Qi = qi.reduce(this._pullDefinitions, {});
    Object.keys(Qi).forEach((ta) => {
      this.definitions[ta] = _objectSpread2$1(_objectSpread2$1({}, this.definitions[ta] || {}), Qi[ta]), defineIcons(ta, Qi[ta]);
      const ra = PREFIX_TO_LONG_STYLE[s$5][ta];
      ra && defineIcons(ra, Qi[ta]), build();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(e, qi) {
    const Xi = qi.prefix && qi.iconName && qi.icon ? {
      0: qi
    } : qi;
    return Object.keys(Xi).map((Qi) => {
      const {
        prefix: ta,
        iconName: ra,
        icon: na
      } = Xi[Qi], la = na[2];
      e[ta] || (e[ta] = {}), la.length > 0 && la.forEach((Ma) => {
        typeof Ma == "string" && (e[ta][Ma] = na);
      }), e[ta][ra] = na;
    }), e;
  }
}
let _plugins = [], _hooks = {};
const providers = {}, defaultProviderKeys = Object.keys(providers);
function registerPlugins(Bi, e) {
  let {
    mixoutsTo: qi
  } = e;
  return _plugins = Bi, _hooks = {}, Object.keys(providers).forEach((Xi) => {
    defaultProviderKeys.indexOf(Xi) === -1 && delete providers[Xi];
  }), _plugins.forEach((Xi) => {
    const Qi = Xi.mixout ? Xi.mixout() : {};
    if (Object.keys(Qi).forEach((ta) => {
      typeof Qi[ta] == "function" && (qi[ta] = Qi[ta]), typeof Qi[ta] == "object" && Object.keys(Qi[ta]).forEach((ra) => {
        qi[ta] || (qi[ta] = {}), qi[ta][ra] = Qi[ta][ra];
      });
    }), Xi.hooks) {
      const ta = Xi.hooks();
      Object.keys(ta).forEach((ra) => {
        _hooks[ra] || (_hooks[ra] = []), _hooks[ra].push(ta[ra]);
      });
    }
    Xi.provides && Xi.provides(providers);
  }), qi;
}
function chainHooks(Bi, e) {
  for (var qi = arguments.length, Xi = new Array(qi > 2 ? qi - 2 : 0), Qi = 2; Qi < qi; Qi++)
    Xi[Qi - 2] = arguments[Qi];
  return (_hooks[Bi] || []).forEach((ra) => {
    e = ra.apply(null, [e, ...Xi]);
  }), e;
}
function callHooks(Bi) {
  for (var e = arguments.length, qi = new Array(e > 1 ? e - 1 : 0), Xi = 1; Xi < e; Xi++)
    qi[Xi - 1] = arguments[Xi];
  (_hooks[Bi] || []).forEach((ta) => {
    ta.apply(null, qi);
  });
}
function callProvided() {
  const Bi = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return providers[Bi] ? providers[Bi].apply(null, e) : void 0;
}
function findIconDefinition(Bi) {
  Bi.prefix === "fa" && (Bi.prefix = "fas");
  let {
    iconName: e
  } = Bi;
  const qi = Bi.prefix || getDefaultUsablePrefix();
  if (e)
    return e = byAlias(qi, e) || e, iconFromMapping(library.definitions, qi, e) || iconFromMapping(namespace.styles, qi, e);
}
const library = new Library(), noAuto = () => {
  config.autoReplaceSvg = !1, config.observeMutations = !1, callHooks("noAuto");
}, dom = {
  i2svg: function() {
    let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return IS_DOM ? (callHooks("beforeI2svg", Bi), callProvided("pseudoElements2svg", Bi), callProvided("i2svg", Bi)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: e
    } = Bi;
    config.autoReplaceSvg === !1 && (config.autoReplaceSvg = !0), config.observeMutations = !0, domready(() => {
      autoReplace({
        autoReplaceSvgRoot: e
      }), callHooks("watch", Bi);
    });
  }
}, parse$1 = {
  icon: (Bi) => {
    if (Bi === null)
      return null;
    if (typeof Bi == "object" && Bi.prefix && Bi.iconName)
      return {
        prefix: Bi.prefix,
        iconName: byAlias(Bi.prefix, Bi.iconName) || Bi.iconName
      };
    if (Array.isArray(Bi) && Bi.length === 2) {
      const e = Bi[1].indexOf("fa-") === 0 ? Bi[1].slice(3) : Bi[1], qi = getCanonicalPrefix(Bi[0]);
      return {
        prefix: qi,
        iconName: byAlias(qi, e) || e
      };
    }
    if (typeof Bi == "string" && (Bi.indexOf("".concat(config.cssPrefix, "-")) > -1 || Bi.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      const e = getCanonicalIcon(Bi.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: e.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(e.prefix, e.iconName) || e.iconName
      };
    }
    if (typeof Bi == "string") {
      const e = getDefaultUsablePrefix();
      return {
        prefix: e,
        iconName: byAlias(e, Bi) || Bi
      };
    }
  }
}, api = {
  noAuto,
  config,
  dom,
  parse: parse$1,
  library,
  findIconDefinition,
  toHtml
}, autoReplace = function() {
  let Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: e = DOCUMENT
  } = Bi;
  (Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg && api.dom.i2svg({
    node: e
  });
};
function domVariants(Bi, e) {
  return Object.defineProperty(Bi, "abstract", {
    get: e
  }), Object.defineProperty(Bi, "html", {
    get: function() {
      return Bi.abstract.map((qi) => toHtml(qi));
    }
  }), Object.defineProperty(Bi, "node", {
    get: function() {
      if (!IS_DOM) return;
      const qi = DOCUMENT.createElement("div");
      return qi.innerHTML = Bi.html, qi.children;
    }
  }), Bi;
}
function asIcon(Bi) {
  let {
    children: e,
    main: qi,
    mask: Xi,
    attributes: Qi,
    styles: ta,
    transform: ra
  } = Bi;
  if (transformIsMeaningful(ra) && qi.found && !Xi.found) {
    const {
      width: na,
      height: la
    } = qi, Ma = {
      x: na / la / 2,
      y: 0.5
    };
    Qi.style = joinStyles(_objectSpread2$1(_objectSpread2$1({}, ta), {}, {
      "transform-origin": "".concat(Ma.x + ra.x / 16, "em ").concat(Ma.y + ra.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: Qi,
    children: e
  }];
}
function asSymbol(Bi) {
  let {
    prefix: e,
    iconName: qi,
    children: Xi,
    attributes: Qi,
    symbol: ta
  } = Bi;
  const ra = ta === !0 ? "".concat(e, "-").concat(config.cssPrefix, "-").concat(qi) : ta;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
        id: ra
      }),
      children: Xi
    }]
  }];
}
function makeInlineSvgAbstract(Bi) {
  const {
    icons: {
      main: e,
      mask: qi
    },
    prefix: Xi,
    iconName: Qi,
    transform: ta,
    symbol: ra,
    title: na,
    maskId: la,
    titleId: Ma,
    extra: Va,
    watchable: to = !1
  } = Bi, {
    width: Eo,
    height: So
  } = qi.found ? qi : e, eo = Lt$3.includes(Xi), rs = [config.replacementClass, Qi ? "".concat(config.cssPrefix, "-").concat(Qi) : ""].filter((Cs) => Va.classes.indexOf(Cs) === -1).filter((Cs) => Cs !== "" || !!Cs).concat(Va.classes).join(" ");
  let ko = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, Va.attributes), {}, {
      "data-prefix": Xi,
      "data-icon": Qi,
      class: rs,
      role: Va.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(Eo, " ").concat(So)
    })
  };
  const Hs = eo && !~Va.classes.indexOf("fa-fw") ? {
    width: "".concat(Eo / So * 16 * 0.0625, "em")
  } : {};
  to && (ko.attributes[DATA_FA_I2SVG] = ""), na && (ko.children.push({
    tag: "title",
    attributes: {
      id: ko.attributes["aria-labelledby"] || "title-".concat(Ma || nextUniqueId$1())
    },
    children: [na]
  }), delete ko.attributes.title);
  const Ks = _objectSpread2$1(_objectSpread2$1({}, ko), {}, {
    prefix: Xi,
    iconName: Qi,
    main: e,
    mask: qi,
    maskId: la,
    transform: ta,
    symbol: ra,
    styles: _objectSpread2$1(_objectSpread2$1({}, Hs), Va.styles)
  }), {
    children: Ys,
    attributes: Xs
  } = qi.found && e.found ? callProvided("generateAbstractMask", Ks) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", Ks) || {
    children: [],
    attributes: {}
  };
  return Ks.children = Ys, Ks.attributes = Xs, ra ? asSymbol(Ks) : asIcon(Ks);
}
function makeLayersTextAbstract(Bi) {
  const {
    content: e,
    width: qi,
    height: Xi,
    transform: Qi,
    title: ta,
    extra: ra,
    watchable: na = !1
  } = Bi, la = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, ra.attributes), ta ? {
    title: ta
  } : {}), {}, {
    class: ra.classes.join(" ")
  });
  na && (la[DATA_FA_I2SVG] = "");
  const Ma = _objectSpread2$1({}, ra.styles);
  transformIsMeaningful(Qi) && (Ma.transform = transformForCss({
    transform: Qi,
    startCentered: !0,
    width: qi,
    height: Xi
  }), Ma["-webkit-transform"] = Ma.transform);
  const Va = joinStyles(Ma);
  Va.length > 0 && (la.style = Va);
  const to = [];
  return to.push({
    tag: "span",
    attributes: la,
    children: [e]
  }), ta && to.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [ta]
  }), to;
}
function makeLayersCounterAbstract(Bi) {
  const {
    content: e,
    title: qi,
    extra: Xi
  } = Bi, Qi = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, Xi.attributes), qi ? {
    title: qi
  } : {}), {}, {
    class: Xi.classes.join(" ")
  }), ta = joinStyles(Xi.styles);
  ta.length > 0 && (Qi.style = ta);
  const ra = [];
  return ra.push({
    tag: "span",
    attributes: Qi,
    children: [e]
  }), qi && ra.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [qi]
  }), ra;
}
const {
  styles: styles$1$1
} = namespace;
function asFoundIcon(Bi) {
  const e = Bi[0], qi = Bi[1], [Xi] = Bi.slice(4);
  let Qi = null;
  return Array.isArray(Xi) ? Qi = {
    tag: "g",
    attributes: {
      class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
        fill: "currentColor",
        d: Xi[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
        fill: "currentColor",
        d: Xi[1]
      }
    }]
  } : Qi = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: Xi
    }
  }, {
    found: !0,
    width: e,
    height: qi,
    icon: Qi
  };
}
const missingIconResolutionMixin = {
  found: !1,
  width: 512,
  height: 512
};
function maybeNotifyMissing(Bi, e) {
  !PRODUCTION$1 && !config.showMissingIcons && Bi && console.error('Icon with name "'.concat(Bi, '" and prefix "').concat(e, '" is missing.'));
}
function findIcon(Bi, e) {
  let qi = e;
  return e === "fa" && config.styleDefault !== null && (e = getDefaultUsablePrefix()), new Promise((Xi, Qi) => {
    if (qi === "fa") {
      const ta = byOldName(Bi) || {};
      Bi = ta.iconName || Bi, e = ta.prefix || e;
    }
    if (Bi && e && styles$1$1[e] && styles$1$1[e][Bi]) {
      const ta = styles$1$1[e][Bi];
      return Xi(asFoundIcon(ta));
    }
    maybeNotifyMissing(Bi, e), Xi(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && Bi ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
const noop$1$1 = () => {
}, p$2$1 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
}, preamble = 'FA "6.7.2"', begin = (Bi) => (p$2$1.mark("".concat(preamble, " ").concat(Bi, " begins")), () => end(Bi)), end = (Bi) => {
  p$2$1.mark("".concat(preamble, " ").concat(Bi, " ends")), p$2$1.measure("".concat(preamble, " ").concat(Bi), "".concat(preamble, " ").concat(Bi, " begins"), "".concat(preamble, " ").concat(Bi, " ends"));
};
var perf = {
  begin,
  end
};
const noop$2$1 = () => {
};
function isWatched$1(Bi) {
  return typeof (Bi.getAttribute ? Bi.getAttribute(DATA_FA_I2SVG) : null) == "string";
}
function hasPrefixAndIcon(Bi) {
  const e = Bi.getAttribute ? Bi.getAttribute(DATA_PREFIX) : null, qi = Bi.getAttribute ? Bi.getAttribute(DATA_ICON) : null;
  return e && qi;
}
function hasBeenReplaced(Bi) {
  return Bi && Bi.classList && Bi.classList.contains && Bi.classList.contains(config.replacementClass);
}
function getMutator() {
  return config.autoReplaceSvg === !0 ? mutators.replace : mutators[config.autoReplaceSvg] || mutators.replace;
}
function createElementNS(Bi) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", Bi);
}
function createElement(Bi) {
  return DOCUMENT.createElement(Bi);
}
function convertSVG(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: qi = Bi.tag === "svg" ? createElementNS : createElement
  } = e;
  if (typeof Bi == "string")
    return DOCUMENT.createTextNode(Bi);
  const Xi = qi(Bi.tag);
  return Object.keys(Bi.attributes || []).forEach(function(ta) {
    Xi.setAttribute(ta, Bi.attributes[ta]);
  }), (Bi.children || []).forEach(function(ta) {
    Xi.appendChild(convertSVG(ta, {
      ceFn: qi
    }));
  }), Xi;
}
function nodeAsComment(Bi) {
  let e = " ".concat(Bi.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
const mutators = {
  replace: function(Bi) {
    const e = Bi[0];
    if (e.parentNode)
      if (Bi[1].forEach((qi) => {
        e.parentNode.insertBefore(convertSVG(qi), e);
      }), e.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        let qi = DOCUMENT.createComment(nodeAsComment(e));
        e.parentNode.replaceChild(qi, e);
      } else
        e.remove();
  },
  nest: function(Bi) {
    const e = Bi[0], qi = Bi[1];
    if (~classArray(e).indexOf(config.replacementClass))
      return mutators.replace(Bi);
    const Xi = new RegExp("".concat(config.cssPrefix, "-.*"));
    if (delete qi[0].attributes.id, qi[0].attributes.class) {
      const ta = qi[0].attributes.class.split(" ").reduce((ra, na) => (na === config.replacementClass || na.match(Xi) ? ra.toSvg.push(na) : ra.toNode.push(na), ra), {
        toNode: [],
        toSvg: []
      });
      qi[0].attributes.class = ta.toSvg.join(" "), ta.toNode.length === 0 ? e.removeAttribute("class") : e.setAttribute("class", ta.toNode.join(" "));
    }
    const Qi = qi.map((ta) => toHtml(ta)).join(`
`);
    e.setAttribute(DATA_FA_I2SVG, ""), e.innerHTML = Qi;
  }
};
function performOperationSync(Bi) {
  Bi();
}
function perform(Bi, e) {
  const qi = typeof e == "function" ? e : noop$2$1;
  if (Bi.length === 0)
    qi();
  else {
    let Xi = performOperationSync;
    config.mutateApproach === MUTATION_APPROACH_ASYNC && (Xi = WINDOW.requestAnimationFrame || performOperationSync), Xi(() => {
      const Qi = getMutator(), ta = perf.begin("mutate");
      Bi.map(Qi), ta(), qi();
    });
  }
}
let disabled = !1;
function disableObservation() {
  disabled = !0;
}
function enableObservation() {
  disabled = !1;
}
let mo$1 = null;
function observe(Bi) {
  if (!MUTATION_OBSERVER || !config.observeMutations)
    return;
  const {
    treeCallback: e = noop$2$1,
    nodeCallback: qi = noop$2$1,
    pseudoElementsCallback: Xi = noop$2$1,
    observeMutationsRoot: Qi = DOCUMENT
  } = Bi;
  mo$1 = new MUTATION_OBSERVER((ta) => {
    if (disabled) return;
    const ra = getDefaultUsablePrefix();
    toArray(ta).forEach((na) => {
      if (na.type === "childList" && na.addedNodes.length > 0 && !isWatched$1(na.addedNodes[0]) && (config.searchPseudoElements && Xi(na.target), e(na.target)), na.type === "attributes" && na.target.parentNode && config.searchPseudoElements && Xi(na.target.parentNode), na.type === "attributes" && isWatched$1(na.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(na.attributeName))
        if (na.attributeName === "class" && hasPrefixAndIcon(na.target)) {
          const {
            prefix: la,
            iconName: Ma
          } = getCanonicalIcon(classArray(na.target));
          na.target.setAttribute(DATA_PREFIX, la || ra), Ma && na.target.setAttribute(DATA_ICON, Ma);
        } else hasBeenReplaced(na.target) && qi(na.target);
    });
  }), IS_DOM && mo$1.observe(Qi, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function disconnect() {
  mo$1 && mo$1.disconnect();
}
function styleParser(Bi) {
  const e = Bi.getAttribute("style");
  let qi = [];
  return e && (qi = e.split(";").reduce((Xi, Qi) => {
    const ta = Qi.split(":"), ra = ta[0], na = ta.slice(1);
    return ra && na.length > 0 && (Xi[ra] = na.join(":").trim()), Xi;
  }, {})), qi;
}
function classParser(Bi) {
  const e = Bi.getAttribute("data-prefix"), qi = Bi.getAttribute("data-icon"), Xi = Bi.innerText !== void 0 ? Bi.innerText.trim() : "";
  let Qi = getCanonicalIcon(classArray(Bi));
  return Qi.prefix || (Qi.prefix = getDefaultUsablePrefix()), e && qi && (Qi.prefix = e, Qi.iconName = qi), Qi.iconName && Qi.prefix || (Qi.prefix && Xi.length > 0 && (Qi.iconName = byLigature(Qi.prefix, Bi.innerText) || byUnicode(Qi.prefix, toHex(Bi.innerText))), !Qi.iconName && config.autoFetchSvg && Bi.firstChild && Bi.firstChild.nodeType === Node.TEXT_NODE && (Qi.iconName = Bi.firstChild.data)), Qi;
}
function attributesParser(Bi) {
  const e = toArray(Bi.attributes).reduce((Qi, ta) => (Qi.name !== "class" && Qi.name !== "style" && (Qi[ta.name] = ta.value), Qi), {}), qi = Bi.getAttribute("title"), Xi = Bi.getAttribute("data-fa-title-id");
  return config.autoA11y && (qi ? e["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(Xi || nextUniqueId$1()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: qi,
    prefix: Xi,
    rest: Qi
  } = classParser(Bi), ta = attributesParser(Bi), ra = chainHooks("parseNodeAttributes", {}, Bi);
  let na = e.styleParser ? styleParser(Bi) : [];
  return _objectSpread2$1({
    iconName: qi,
    title: Bi.getAttribute("title"),
    titleId: Bi.getAttribute("data-fa-title-id"),
    prefix: Xi,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: Qi,
      styles: na,
      attributes: ta
    }
  }, ra);
}
const {
  styles: styles$2
} = namespace;
function generateMutation(Bi) {
  const e = config.autoReplaceSvg === "nest" ? parseMeta(Bi, {
    styleParser: !1
  }) : parseMeta(Bi);
  return ~e.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME) ? callProvided("generateLayersText", Bi, e) : callProvided("generateSvgReplacementMutation", Bi, e);
}
function getKnownPrefixes() {
  return [...Ft$3, ...Ia$1];
}
function onTree(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  const qi = DOCUMENT.documentElement.classList, Xi = (Va) => qi.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(Va)), Qi = (Va) => qi.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(Va)), ta = config.autoFetchSvg ? getKnownPrefixes() : P$3.concat(Object.keys(styles$2));
  ta.includes("fa") || ta.push("fa");
  const ra = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(ta.map((Va) => ".".concat(Va, ":not([").concat(DATA_FA_I2SVG, "])"))).join(", ");
  if (ra.length === 0)
    return Promise.resolve();
  let na = [];
  try {
    na = toArray(Bi.querySelectorAll(ra));
  } catch {
  }
  if (na.length > 0)
    Xi("pending"), Qi("complete");
  else
    return Promise.resolve();
  const la = perf.begin("onTree"), Ma = na.reduce((Va, to) => {
    try {
      const Eo = generateMutation(to);
      Eo && Va.push(Eo);
    } catch (Eo) {
      PRODUCTION$1 || Eo.name === "MissingIcon" && console.error(Eo);
    }
    return Va;
  }, []);
  return new Promise((Va, to) => {
    Promise.all(Ma).then((Eo) => {
      perform(Eo, () => {
        Xi("active"), Xi("complete"), Qi("pending"), typeof e == "function" && e(), la(), Va();
      });
    }).catch((Eo) => {
      la(), to(Eo);
    });
  });
}
function onNode(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(Bi).then((qi) => {
    qi && perform([qi], e);
  });
}
function resolveIcons(Bi) {
  return function(e) {
    let qi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const Xi = (e || {}).icon ? e : findIconDefinition(e || {});
    let {
      mask: Qi
    } = qi;
    return Qi && (Qi = (Qi || {}).icon ? Qi : findIconDefinition(Qi || {})), Bi(Xi, _objectSpread2$1(_objectSpread2$1({}, qi), {}, {
      mask: Qi
    }));
  };
}
const render = function(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: qi = meaninglessTransform,
    symbol: Xi = !1,
    mask: Qi = null,
    maskId: ta = null,
    title: ra = null,
    titleId: na = null,
    classes: la = [],
    attributes: Ma = {},
    styles: Va = {}
  } = e;
  if (!Bi) return;
  const {
    prefix: to,
    iconName: Eo,
    icon: So
  } = Bi;
  return domVariants(_objectSpread2$1({
    type: "icon"
  }, Bi), () => (callHooks("beforeDOMElementCreation", {
    iconDefinition: Bi,
    params: e
  }), config.autoA11y && (ra ? Ma["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(na || nextUniqueId$1()) : (Ma["aria-hidden"] = "true", Ma.focusable = "false")), makeInlineSvgAbstract({
    icons: {
      main: asFoundIcon(So),
      mask: Qi ? asFoundIcon(Qi.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: to,
    iconName: Eo,
    transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), qi),
    symbol: Xi,
    title: ra,
    maskId: ta,
    titleId: na,
    extra: {
      attributes: Ma,
      styles: Va,
      classes: la
    }
  })));
};
var ReplaceElements = {
  mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(Bi) {
        return Bi.treeCallback = onTree, Bi.nodeCallback = onNode, Bi;
      }
    };
  },
  provides(Bi) {
    Bi.i2svg = function(e) {
      const {
        node: qi = DOCUMENT,
        callback: Xi = () => {
        }
      } = e;
      return onTree(qi, Xi);
    }, Bi.generateSvgReplacementMutation = function(e, qi) {
      const {
        iconName: Xi,
        title: Qi,
        titleId: ta,
        prefix: ra,
        transform: na,
        symbol: la,
        mask: Ma,
        maskId: Va,
        extra: to
      } = qi;
      return new Promise((Eo, So) => {
        Promise.all([findIcon(Xi, ra), Ma.iconName ? findIcon(Ma.iconName, Ma.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((eo) => {
          let [rs, ko] = eo;
          Eo([e, makeInlineSvgAbstract({
            icons: {
              main: rs,
              mask: ko
            },
            prefix: ra,
            iconName: Xi,
            transform: na,
            symbol: la,
            maskId: Va,
            title: Qi,
            titleId: ta,
            extra: to,
            watchable: !0
          })]);
        }).catch(So);
      });
    }, Bi.generateAbstractIcon = function(e) {
      let {
        children: qi,
        attributes: Xi,
        main: Qi,
        transform: ta,
        styles: ra
      } = e;
      const na = joinStyles(ra);
      na.length > 0 && (Xi.style = na);
      let la;
      return transformIsMeaningful(ta) && (la = callProvided("generateAbstractTransformGrouping", {
        main: Qi,
        transform: ta,
        containerWidth: Qi.width,
        iconWidth: Qi.width
      })), qi.push(la || Qi.icon), {
        children: qi,
        attributes: Xi
      };
    };
  }
}, Layers = {
  mixout() {
    return {
      layer(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: qi = []
        } = e;
        return domVariants({
          type: "layer"
        }, () => {
          callHooks("beforeDOMElementCreation", {
            assembler: Bi,
            params: e
          });
          let Xi = [];
          return Bi((Qi) => {
            Array.isArray(Qi) ? Qi.map((ta) => {
              Xi = Xi.concat(ta.abstract);
            }) : Xi = Xi.concat(Qi.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers"), ...qi].join(" ")
            },
            children: Xi
          }];
        });
      }
    };
  }
}, LayersCounter = {
  mixout() {
    return {
      counter(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: qi = null,
          classes: Xi = [],
          attributes: Qi = {},
          styles: ta = {}
        } = e;
        return domVariants({
          type: "counter",
          content: Bi
        }, () => (callHooks("beforeDOMElementCreation", {
          content: Bi,
          params: e
        }), makeLayersCounterAbstract({
          content: Bi.toString(),
          title: qi,
          extra: {
            attributes: Qi,
            styles: ta,
            classes: ["".concat(config.cssPrefix, "-layers-counter"), ...Xi]
          }
        })));
      }
    };
  }
}, LayersText = {
  mixout() {
    return {
      text(Bi) {
        let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: qi = meaninglessTransform,
          title: Xi = null,
          classes: Qi = [],
          attributes: ta = {},
          styles: ra = {}
        } = e;
        return domVariants({
          type: "text",
          content: Bi
        }, () => (callHooks("beforeDOMElementCreation", {
          content: Bi,
          params: e
        }), makeLayersTextAbstract({
          content: Bi,
          transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), qi),
          title: Xi,
          extra: {
            attributes: ta,
            styles: ra,
            classes: ["".concat(config.cssPrefix, "-layers-text"), ...Qi]
          }
        })));
      }
    };
  },
  provides(Bi) {
    Bi.generateLayersText = function(e, qi) {
      const {
        title: Xi,
        transform: Qi,
        extra: ta
      } = qi;
      let ra = null, na = null;
      if (IS_IE) {
        const la = parseInt(getComputedStyle(e).fontSize, 10), Ma = e.getBoundingClientRect();
        ra = Ma.width / la, na = Ma.height / la;
      }
      return config.autoA11y && !Xi && (ta.attributes["aria-hidden"] = "true"), Promise.resolve([e, makeLayersTextAbstract({
        content: e.innerHTML,
        width: ra,
        height: na,
        transform: Qi,
        title: Xi,
        extra: ta,
        watchable: !0
      })]);
    };
  }
};
const CLEAN_CONTENT_PATTERN = new RegExp('"', "ug"), SECONDARY_UNICODE_RANGE = [1105920, 1112319], _FONT_FAMILY_WEIGHT_TO_PREFIX = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), lt$3), wa$1), Yt$3), FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys(_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((Bi, e) => (Bi[e.toLowerCase()] = _FONT_FAMILY_WEIGHT_TO_PREFIX[e], Bi), {}), FONT_FAMILY_WEIGHT_FALLBACK = Object.keys(FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((Bi, e) => {
  const qi = FONT_FAMILY_WEIGHT_TO_PREFIX[e];
  return Bi[e] = qi[900] || [...Object.entries(qi)][0][1], Bi;
}, {});
function hexValueFromContent(Bi) {
  const e = Bi.replace(CLEAN_CONTENT_PATTERN, ""), qi = codePointAt(e, 0), Xi = qi >= SECONDARY_UNICODE_RANGE[0] && qi <= SECONDARY_UNICODE_RANGE[1], Qi = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: toHex(Qi ? e[0] : e),
    isSecondary: Xi || Qi
  };
}
function getPrefix(Bi, e) {
  const qi = Bi.replace(/^['"]|['"]$/g, "").toLowerCase(), Xi = parseInt(e), Qi = isNaN(Xi) ? "normal" : Xi;
  return (FONT_FAMILY_WEIGHT_TO_PREFIX[qi] || {})[Qi] || FONT_FAMILY_WEIGHT_FALLBACK[qi];
}
function replaceForPosition(Bi, e) {
  const qi = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(e.replace(":", "-"));
  return new Promise((Xi, Qi) => {
    if (Bi.getAttribute(qi) !== null)
      return Xi();
    const ra = toArray(Bi.children).filter((Eo) => Eo.getAttribute(DATA_FA_PSEUDO_ELEMENT) === e)[0], na = WINDOW.getComputedStyle(Bi, e), la = na.getPropertyValue("font-family"), Ma = la.match(FONT_FAMILY_PATTERN), Va = na.getPropertyValue("font-weight"), to = na.getPropertyValue("content");
    if (ra && !Ma)
      return Bi.removeChild(ra), Xi();
    if (Ma && to !== "none" && to !== "") {
      const Eo = na.getPropertyValue("content");
      let So = getPrefix(la, Va);
      const {
        value: eo,
        isSecondary: rs
      } = hexValueFromContent(Eo), ko = Ma[0].startsWith("FontAwesome");
      let Hs = byUnicode(So, eo), Ks = Hs;
      if (ko) {
        const Ys = byOldUnicode(eo);
        Ys.iconName && Ys.prefix && (Hs = Ys.iconName, So = Ys.prefix);
      }
      if (Hs && !rs && (!ra || ra.getAttribute(DATA_PREFIX) !== So || ra.getAttribute(DATA_ICON) !== Ks)) {
        Bi.setAttribute(qi, Ks), ra && Bi.removeChild(ra);
        const Ys = blankMeta(), {
          extra: Xs
        } = Ys;
        Xs.attributes[DATA_FA_PSEUDO_ELEMENT] = e, findIcon(Hs, So).then((Cs) => {
          const Fs = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, Ys), {}, {
            icons: {
              main: Cs,
              mask: emptyCanonicalIcon()
            },
            prefix: So,
            iconName: Ks,
            extra: Xs,
            watchable: !0
          })), ws = DOCUMENT.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? Bi.insertBefore(ws, Bi.firstChild) : Bi.appendChild(ws), ws.outerHTML = Fs.map((ls) => toHtml(ls)).join(`
`), Bi.removeAttribute(qi), Xi();
        }).catch(Qi);
      } else
        Xi();
    } else
      Xi();
  });
}
function replace(Bi) {
  return Promise.all([replaceForPosition(Bi, "::before"), replaceForPosition(Bi, "::after")]);
}
function processable(Bi) {
  return Bi.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(Bi.tagName.toUpperCase()) && !Bi.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!Bi.parentNode || Bi.parentNode.tagName !== "svg");
}
function searchPseudoElements(Bi) {
  if (IS_DOM)
    return new Promise((e, qi) => {
      const Xi = toArray(Bi.querySelectorAll("*")).filter(processable).map(replace), Qi = perf.begin("searchPseudoElements");
      disableObservation(), Promise.all(Xi).then(() => {
        Qi(), enableObservation(), e();
      }).catch(() => {
        Qi(), enableObservation(), qi();
      });
    });
}
var PseudoElements = {
  hooks() {
    return {
      mutationObserverCallbacks(Bi) {
        return Bi.pseudoElementsCallback = searchPseudoElements, Bi;
      }
    };
  },
  provides(Bi) {
    Bi.pseudoElements2svg = function(e) {
      const {
        node: qi = DOCUMENT
      } = e;
      config.searchPseudoElements && searchPseudoElements(qi);
    };
  }
};
let _unwatched = !1;
var MutationObserver$1 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          disableObservation(), _unwatched = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto() {
        disconnect();
      },
      watch(Bi) {
        const {
          observeMutationsRoot: e
        } = Bi;
        _unwatched ? enableObservation() : observe(chainHooks("mutationObserverCallbacks", {
          observeMutationsRoot: e
        }));
      }
    };
  }
};
const parseTransformString = (Bi) => {
  let e = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return Bi.toLowerCase().split(" ").reduce((qi, Xi) => {
    const Qi = Xi.toLowerCase().split("-"), ta = Qi[0];
    let ra = Qi.slice(1).join("-");
    if (ta && ra === "h")
      return qi.flipX = !0, qi;
    if (ta && ra === "v")
      return qi.flipY = !0, qi;
    if (ra = parseFloat(ra), isNaN(ra))
      return qi;
    switch (ta) {
      case "grow":
        qi.size = qi.size + ra;
        break;
      case "shrink":
        qi.size = qi.size - ra;
        break;
      case "left":
        qi.x = qi.x - ra;
        break;
      case "right":
        qi.x = qi.x + ra;
        break;
      case "up":
        qi.y = qi.y - ra;
        break;
      case "down":
        qi.y = qi.y + ra;
        break;
      case "rotate":
        qi.rotate = qi.rotate + ra;
        break;
    }
    return qi;
  }, e);
};
var PowerTransforms = {
  mixout() {
    return {
      parse: {
        transform: (Bi) => parseTransformString(Bi)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const qi = e.getAttribute("data-fa-transform");
        return qi && (Bi.transform = parseTransformString(qi)), Bi;
      }
    };
  },
  provides(Bi) {
    Bi.generateAbstractTransformGrouping = function(e) {
      let {
        main: qi,
        transform: Xi,
        containerWidth: Qi,
        iconWidth: ta
      } = e;
      const ra = {
        transform: "translate(".concat(Qi / 2, " 256)")
      }, na = "translate(".concat(Xi.x * 32, ", ").concat(Xi.y * 32, ") "), la = "scale(".concat(Xi.size / 16 * (Xi.flipX ? -1 : 1), ", ").concat(Xi.size / 16 * (Xi.flipY ? -1 : 1), ") "), Ma = "rotate(".concat(Xi.rotate, " 0 0)"), Va = {
        transform: "".concat(na, " ").concat(la, " ").concat(Ma)
      }, to = {
        transform: "translate(".concat(ta / 2 * -1, " -256)")
      }, Eo = {
        outer: ra,
        inner: Va,
        path: to
      };
      return {
        tag: "g",
        attributes: _objectSpread2$1({}, Eo.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$1({}, Eo.inner),
          children: [{
            tag: qi.icon.tag,
            children: qi.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, qi.icon.attributes), Eo.path)
          }]
        }]
      };
    };
  }
};
const ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(Bi) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Bi.attributes && (Bi.attributes.fill || e) && (Bi.attributes.fill = "black"), Bi;
}
function deGroup(Bi) {
  return Bi.tag === "g" ? Bi.children : [Bi];
}
var Masks = {
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const qi = e.getAttribute("data-fa-mask"), Xi = qi ? getCanonicalIcon(qi.split(" ").map((Qi) => Qi.trim())) : emptyCanonicalIcon();
        return Xi.prefix || (Xi.prefix = getDefaultUsablePrefix()), Bi.mask = Xi, Bi.maskId = e.getAttribute("data-fa-mask-id"), Bi;
      }
    };
  },
  provides(Bi) {
    Bi.generateAbstractMask = function(e) {
      let {
        children: qi,
        attributes: Xi,
        main: Qi,
        mask: ta,
        maskId: ra,
        transform: na
      } = e;
      const {
        width: la,
        icon: Ma
      } = Qi, {
        width: Va,
        icon: to
      } = ta, Eo = transformForSvg({
        transform: na,
        containerWidth: Va,
        iconWidth: la
      }), So = {
        tag: "rect",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: "white"
        })
      }, eo = Ma.children ? {
        children: Ma.children.map(fillBlack)
      } : {}, rs = {
        tag: "g",
        attributes: _objectSpread2$1({}, Eo.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: Ma.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, Ma.attributes), Eo.path)
        }, eo))]
      }, ko = {
        tag: "g",
        attributes: _objectSpread2$1({}, Eo.outer),
        children: [rs]
      }, Hs = "mask-".concat(ra || nextUniqueId$1()), Ks = "clip-".concat(ra || nextUniqueId$1()), Ys = {
        tag: "mask",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: Hs,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [So, ko]
      }, Xs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: Ks
          },
          children: deGroup(to)
        }, Ys]
      };
      return qi.push(Xs, {
        tag: "rect",
        attributes: _objectSpread2$1({
          fill: "currentColor",
          "clip-path": "url(#".concat(Ks, ")"),
          mask: "url(#".concat(Hs, ")")
        }, ALL_SPACE)
      }), {
        children: qi,
        attributes: Xi
      };
    };
  }
}, MissingIconIndicator = {
  provides(Bi) {
    let e = !1;
    WINDOW.matchMedia && (e = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches), Bi.missingIconAbstract = function() {
      const qi = [], Xi = {
        fill: "currentColor"
      }, Qi = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      qi.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Xi), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const ta = _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
        attributeName: "opacity"
      }), ra = {
        tag: "circle",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Xi), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return e || ra.children.push({
        tag: "animate",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Qi), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ta), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), qi.push(ra), qi.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Xi), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: e ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, ta), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), e || qi.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, Xi), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, ta), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: qi
      };
    };
  }
}, SvgSymbols = {
  hooks() {
    return {
      parseNodeAttributes(Bi, e) {
        const qi = e.getAttribute("data-fa-symbol"), Xi = qi === null ? !1 : qi === "" ? !0 : qi;
        return Bi.symbol = Xi, Bi;
      }
    };
  }
}, plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
const parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
const icon = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = { exports: {} }, reactIs = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var Bi = typeof Symbol == "function" && Symbol.for, e = Bi ? Symbol.for("react.element") : 60103, qi = Bi ? Symbol.for("react.portal") : 60106, Xi = Bi ? Symbol.for("react.fragment") : 60107, Qi = Bi ? Symbol.for("react.strict_mode") : 60108, ta = Bi ? Symbol.for("react.profiler") : 60114, ra = Bi ? Symbol.for("react.provider") : 60109, na = Bi ? Symbol.for("react.context") : 60110, la = Bi ? Symbol.for("react.async_mode") : 60111, Ma = Bi ? Symbol.for("react.concurrent_mode") : 60111, Va = Bi ? Symbol.for("react.forward_ref") : 60112, to = Bi ? Symbol.for("react.suspense") : 60113, Eo = Bi ? Symbol.for("react.suspense_list") : 60120, So = Bi ? Symbol.for("react.memo") : 60115, eo = Bi ? Symbol.for("react.lazy") : 60116, rs = Bi ? Symbol.for("react.block") : 60121, ko = Bi ? Symbol.for("react.fundamental") : 60117, Hs = Bi ? Symbol.for("react.responder") : 60118, Ks = Bi ? Symbol.for("react.scope") : 60119;
  function Ys(Cs) {
    if (typeof Cs == "object" && Cs !== null) {
      var Fs = Cs.$$typeof;
      switch (Fs) {
        case e:
          switch (Cs = Cs.type, Cs) {
            case la:
            case Ma:
            case Xi:
            case ta:
            case Qi:
            case to:
              return Cs;
            default:
              switch (Cs = Cs && Cs.$$typeof, Cs) {
                case na:
                case Va:
                case eo:
                case So:
                case ra:
                  return Cs;
                default:
                  return Fs;
              }
          }
        case qi:
          return Fs;
      }
    }
  }
  function Xs(Cs) {
    return Ys(Cs) === Ma;
  }
  return reactIs_production_min.AsyncMode = la, reactIs_production_min.ConcurrentMode = Ma, reactIs_production_min.ContextConsumer = na, reactIs_production_min.ContextProvider = ra, reactIs_production_min.Element = e, reactIs_production_min.ForwardRef = Va, reactIs_production_min.Fragment = Xi, reactIs_production_min.Lazy = eo, reactIs_production_min.Memo = So, reactIs_production_min.Portal = qi, reactIs_production_min.Profiler = ta, reactIs_production_min.StrictMode = Qi, reactIs_production_min.Suspense = to, reactIs_production_min.isAsyncMode = function(Cs) {
    return Xs(Cs) || Ys(Cs) === la;
  }, reactIs_production_min.isConcurrentMode = Xs, reactIs_production_min.isContextConsumer = function(Cs) {
    return Ys(Cs) === na;
  }, reactIs_production_min.isContextProvider = function(Cs) {
    return Ys(Cs) === ra;
  }, reactIs_production_min.isElement = function(Cs) {
    return typeof Cs == "object" && Cs !== null && Cs.$$typeof === e;
  }, reactIs_production_min.isForwardRef = function(Cs) {
    return Ys(Cs) === Va;
  }, reactIs_production_min.isFragment = function(Cs) {
    return Ys(Cs) === Xi;
  }, reactIs_production_min.isLazy = function(Cs) {
    return Ys(Cs) === eo;
  }, reactIs_production_min.isMemo = function(Cs) {
    return Ys(Cs) === So;
  }, reactIs_production_min.isPortal = function(Cs) {
    return Ys(Cs) === qi;
  }, reactIs_production_min.isProfiler = function(Cs) {
    return Ys(Cs) === ta;
  }, reactIs_production_min.isStrictMode = function(Cs) {
    return Ys(Cs) === Qi;
  }, reactIs_production_min.isSuspense = function(Cs) {
    return Ys(Cs) === to;
  }, reactIs_production_min.isValidElementType = function(Cs) {
    return typeof Cs == "string" || typeof Cs == "function" || Cs === Xi || Cs === Ma || Cs === ta || Cs === Qi || Cs === to || Cs === Eo || typeof Cs == "object" && Cs !== null && (Cs.$$typeof === eo || Cs.$$typeof === So || Cs.$$typeof === ra || Cs.$$typeof === na || Cs.$$typeof === Va || Cs.$$typeof === ko || Cs.$$typeof === Hs || Cs.$$typeof === Ks || Cs.$$typeof === rs);
  }, reactIs_production_min.typeOf = Ys, reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Bi = typeof Symbol == "function" && Symbol.for, e = Bi ? Symbol.for("react.element") : 60103, qi = Bi ? Symbol.for("react.portal") : 60106, Xi = Bi ? Symbol.for("react.fragment") : 60107, Qi = Bi ? Symbol.for("react.strict_mode") : 60108, ta = Bi ? Symbol.for("react.profiler") : 60114, ra = Bi ? Symbol.for("react.provider") : 60109, na = Bi ? Symbol.for("react.context") : 60110, la = Bi ? Symbol.for("react.async_mode") : 60111, Ma = Bi ? Symbol.for("react.concurrent_mode") : 60111, Va = Bi ? Symbol.for("react.forward_ref") : 60112, to = Bi ? Symbol.for("react.suspense") : 60113, Eo = Bi ? Symbol.for("react.suspense_list") : 60120, So = Bi ? Symbol.for("react.memo") : 60115, eo = Bi ? Symbol.for("react.lazy") : 60116, rs = Bi ? Symbol.for("react.block") : 60121, ko = Bi ? Symbol.for("react.fundamental") : 60117, Hs = Bi ? Symbol.for("react.responder") : 60118, Ks = Bi ? Symbol.for("react.scope") : 60119;
    function Ys(gl) {
      return typeof gl == "string" || typeof gl == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      gl === Xi || gl === Ma || gl === ta || gl === Qi || gl === to || gl === Eo || typeof gl == "object" && gl !== null && (gl.$$typeof === eo || gl.$$typeof === So || gl.$$typeof === ra || gl.$$typeof === na || gl.$$typeof === Va || gl.$$typeof === ko || gl.$$typeof === Hs || gl.$$typeof === Ks || gl.$$typeof === rs);
    }
    function Xs(gl) {
      if (typeof gl == "object" && gl !== null) {
        var El = gl.$$typeof;
        switch (El) {
          case e:
            var Ol = gl.type;
            switch (Ol) {
              case la:
              case Ma:
              case Xi:
              case ta:
              case Qi:
              case to:
                return Ol;
              default:
                var wl = Ol && Ol.$$typeof;
                switch (wl) {
                  case na:
                  case Va:
                  case eo:
                  case So:
                  case ra:
                    return wl;
                  default:
                    return El;
                }
            }
          case qi:
            return El;
        }
      }
    }
    var Cs = la, Fs = Ma, ws = na, ls = ra, ks = e, Js = Va, pl = Xi, _l = eo, bl = So, xl = qi, Rl = ta, Cl = Qi, Dl = to, kl = !1;
    function Ul(gl) {
      return kl || (kl = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Bl(gl) || Xs(gl) === la;
    }
    function Bl(gl) {
      return Xs(gl) === Ma;
    }
    function Zl(gl) {
      return Xs(gl) === na;
    }
    function Pl(gl) {
      return Xs(gl) === ra;
    }
    function yl(gl) {
      return typeof gl == "object" && gl !== null && gl.$$typeof === e;
    }
    function hl(gl) {
      return Xs(gl) === Va;
    }
    function Tl(gl) {
      return Xs(gl) === Xi;
    }
    function Il(gl) {
      return Xs(gl) === eo;
    }
    function jl(gl) {
      return Xs(gl) === So;
    }
    function Al(gl) {
      return Xs(gl) === qi;
    }
    function _s(gl) {
      return Xs(gl) === ta;
    }
    function Gs(gl) {
      return Xs(gl) === Qi;
    }
    function vl(gl) {
      return Xs(gl) === to;
    }
    reactIs_development.AsyncMode = Cs, reactIs_development.ConcurrentMode = Fs, reactIs_development.ContextConsumer = ws, reactIs_development.ContextProvider = ls, reactIs_development.Element = ks, reactIs_development.ForwardRef = Js, reactIs_development.Fragment = pl, reactIs_development.Lazy = _l, reactIs_development.Memo = bl, reactIs_development.Portal = xl, reactIs_development.Profiler = Rl, reactIs_development.StrictMode = Cl, reactIs_development.Suspense = Dl, reactIs_development.isAsyncMode = Ul, reactIs_development.isConcurrentMode = Bl, reactIs_development.isContextConsumer = Zl, reactIs_development.isContextProvider = Pl, reactIs_development.isElement = yl, reactIs_development.isForwardRef = hl, reactIs_development.isFragment = Tl, reactIs_development.isLazy = Il, reactIs_development.isMemo = jl, reactIs_development.isPortal = Al, reactIs_development.isProfiler = _s, reactIs_development.isStrictMode = Gs, reactIs_development.isSuspense = vl, reactIs_development.isValidElementType = Ys, reactIs_development.typeOf = Xs;
  }()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var Bi = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, qi = Object.prototype.propertyIsEnumerable;
  function Xi(ta) {
    if (ta == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(ta);
  }
  function Qi() {
    try {
      if (!Object.assign)
        return !1;
      var ta = new String("abc");
      if (ta[5] = "de", Object.getOwnPropertyNames(ta)[0] === "5")
        return !1;
      for (var ra = {}, na = 0; na < 10; na++)
        ra["_" + String.fromCharCode(na)] = na;
      var la = Object.getOwnPropertyNames(ra).map(function(Va) {
        return ra[Va];
      });
      if (la.join("") !== "0123456789")
        return !1;
      var Ma = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(Va) {
        Ma[Va] = Va;
      }), Object.keys(Object.assign({}, Ma)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = Qi() ? Object.assign : function(ta, ra) {
    for (var na, la = Xi(ta), Ma, Va = 1; Va < arguments.length; Va++) {
      na = Object(arguments[Va]);
      for (var to in na)
        e.call(na, to) && (la[to] = na[to]);
      if (Bi) {
        Ma = Bi(na);
        for (var Eo = 0; Eo < Ma.length; Eo++)
          qi.call(na, Ma[Eo]) && (la[Ma[Eo]] = na[Ma[Eo]]);
      }
    }
    return la;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var Bi = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = Bi, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var Bi = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ requireReactPropTypesSecret(), qi = {}, Xi = /* @__PURE__ */ requireHas();
    Bi = function(ta) {
      var ra = "Warning: " + ta;
      typeof console < "u" && console.error(ra);
      try {
        throw new Error(ra);
      } catch {
      }
    };
  }
  function Qi(ta, ra, na, la, Ma) {
    if (process.env.NODE_ENV !== "production") {
      for (var Va in ta)
        if (Xi(ta, Va)) {
          var to;
          try {
            if (typeof ta[Va] != "function") {
              var Eo = Error(
                (la || "React class") + ": " + na + " type `" + Va + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ta[Va] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw Eo.name = "Invariant Violation", Eo;
            }
            to = ta[Va](ra, Va, la, na, null, e);
          } catch (eo) {
            to = eo;
          }
          if (to && !(to instanceof Error) && Bi(
            (la || "React class") + ": type specification of " + na + " `" + Va + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof to + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), to instanceof Error && !(to.message in qi)) {
            qi[to.message] = !0;
            var So = Ma ? Ma() : "";
            Bi(
              "Failed " + na + " type: " + to.message + (So ?? "")
            );
          }
        }
    }
  }
  return Qi.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (qi = {});
  }, checkPropTypes_1 = Qi, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var Bi = requireReactIs(), e = requireObjectAssign(), qi = /* @__PURE__ */ requireReactPropTypesSecret(), Xi = /* @__PURE__ */ requireHas(), Qi = /* @__PURE__ */ requireCheckPropTypes(), ta = function() {
  };
  process.env.NODE_ENV !== "production" && (ta = function(na) {
    var la = "Warning: " + na;
    typeof console < "u" && console.error(la);
    try {
      throw new Error(la);
    } catch {
    }
  });
  function ra() {
    return null;
  }
  return factoryWithTypeCheckers = function(na, la) {
    var Ma = typeof Symbol == "function" && Symbol.iterator, Va = "@@iterator";
    function to(Bl) {
      var Zl = Bl && (Ma && Bl[Ma] || Bl[Va]);
      if (typeof Zl == "function")
        return Zl;
    }
    var Eo = "<<anonymous>>", So = {
      array: Hs("array"),
      bigint: Hs("bigint"),
      bool: Hs("boolean"),
      func: Hs("function"),
      number: Hs("number"),
      object: Hs("object"),
      string: Hs("string"),
      symbol: Hs("symbol"),
      any: Ks(),
      arrayOf: Ys,
      element: Xs(),
      elementType: Cs(),
      instanceOf: Fs,
      node: Js(),
      objectOf: ls,
      oneOf: ws,
      oneOfType: ks,
      shape: _l,
      exact: bl
    };
    function eo(Bl, Zl) {
      return Bl === Zl ? Bl !== 0 || 1 / Bl === 1 / Zl : Bl !== Bl && Zl !== Zl;
    }
    function rs(Bl, Zl) {
      this.message = Bl, this.data = Zl && typeof Zl == "object" ? Zl : {}, this.stack = "";
    }
    rs.prototype = Error.prototype;
    function ko(Bl) {
      if (process.env.NODE_ENV !== "production")
        var Zl = {}, Pl = 0;
      function yl(Tl, Il, jl, Al, _s, Gs, vl) {
        if (Al = Al || Eo, Gs = Gs || jl, vl !== qi) {
          if (la) {
            var gl = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw gl.name = "Invariant Violation", gl;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var El = Al + ":" + jl;
            !Zl[El] && // Avoid spamming the console because they are often not actionable except for lib authors
            Pl < 3 && (ta(
              "You are manually calling a React.PropTypes validation function for the `" + Gs + "` prop on `" + Al + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Zl[El] = !0, Pl++);
          }
        }
        return Il[jl] == null ? Tl ? Il[jl] === null ? new rs("The " + _s + " `" + Gs + "` is marked as required " + ("in `" + Al + "`, but its value is `null`.")) : new rs("The " + _s + " `" + Gs + "` is marked as required in " + ("`" + Al + "`, but its value is `undefined`.")) : null : Bl(Il, jl, Al, _s, Gs);
      }
      var hl = yl.bind(null, !1);
      return hl.isRequired = yl.bind(null, !0), hl;
    }
    function Hs(Bl) {
      function Zl(Pl, yl, hl, Tl, Il, jl) {
        var Al = Pl[yl], _s = Cl(Al);
        if (_s !== Bl) {
          var Gs = Dl(Al);
          return new rs(
            "Invalid " + Tl + " `" + Il + "` of type " + ("`" + Gs + "` supplied to `" + hl + "`, expected ") + ("`" + Bl + "`."),
            { expectedType: Bl }
          );
        }
        return null;
      }
      return ko(Zl);
    }
    function Ks() {
      return ko(ra);
    }
    function Ys(Bl) {
      function Zl(Pl, yl, hl, Tl, Il) {
        if (typeof Bl != "function")
          return new rs("Property `" + Il + "` of component `" + hl + "` has invalid PropType notation inside arrayOf.");
        var jl = Pl[yl];
        if (!Array.isArray(jl)) {
          var Al = Cl(jl);
          return new rs("Invalid " + Tl + " `" + Il + "` of type " + ("`" + Al + "` supplied to `" + hl + "`, expected an array."));
        }
        for (var _s = 0; _s < jl.length; _s++) {
          var Gs = Bl(jl, _s, hl, Tl, Il + "[" + _s + "]", qi);
          if (Gs instanceof Error)
            return Gs;
        }
        return null;
      }
      return ko(Zl);
    }
    function Xs() {
      function Bl(Zl, Pl, yl, hl, Tl) {
        var Il = Zl[Pl];
        if (!na(Il)) {
          var jl = Cl(Il);
          return new rs("Invalid " + hl + " `" + Tl + "` of type " + ("`" + jl + "` supplied to `" + yl + "`, expected a single ReactElement."));
        }
        return null;
      }
      return ko(Bl);
    }
    function Cs() {
      function Bl(Zl, Pl, yl, hl, Tl) {
        var Il = Zl[Pl];
        if (!Bi.isValidElementType(Il)) {
          var jl = Cl(Il);
          return new rs("Invalid " + hl + " `" + Tl + "` of type " + ("`" + jl + "` supplied to `" + yl + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return ko(Bl);
    }
    function Fs(Bl) {
      function Zl(Pl, yl, hl, Tl, Il) {
        if (!(Pl[yl] instanceof Bl)) {
          var jl = Bl.name || Eo, Al = Ul(Pl[yl]);
          return new rs("Invalid " + Tl + " `" + Il + "` of type " + ("`" + Al + "` supplied to `" + hl + "`, expected ") + ("instance of `" + jl + "`."));
        }
        return null;
      }
      return ko(Zl);
    }
    function ws(Bl) {
      if (!Array.isArray(Bl))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? ta(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : ta("Invalid argument supplied to oneOf, expected an array.")), ra;
      function Zl(Pl, yl, hl, Tl, Il) {
        for (var jl = Pl[yl], Al = 0; Al < Bl.length; Al++)
          if (eo(jl, Bl[Al]))
            return null;
        var _s = JSON.stringify(Bl, function(vl, gl) {
          var El = Dl(gl);
          return El === "symbol" ? String(gl) : gl;
        });
        return new rs("Invalid " + Tl + " `" + Il + "` of value `" + String(jl) + "` " + ("supplied to `" + hl + "`, expected one of " + _s + "."));
      }
      return ko(Zl);
    }
    function ls(Bl) {
      function Zl(Pl, yl, hl, Tl, Il) {
        if (typeof Bl != "function")
          return new rs("Property `" + Il + "` of component `" + hl + "` has invalid PropType notation inside objectOf.");
        var jl = Pl[yl], Al = Cl(jl);
        if (Al !== "object")
          return new rs("Invalid " + Tl + " `" + Il + "` of type " + ("`" + Al + "` supplied to `" + hl + "`, expected an object."));
        for (var _s in jl)
          if (Xi(jl, _s)) {
            var Gs = Bl(jl, _s, hl, Tl, Il + "." + _s, qi);
            if (Gs instanceof Error)
              return Gs;
          }
        return null;
      }
      return ko(Zl);
    }
    function ks(Bl) {
      if (!Array.isArray(Bl))
        return process.env.NODE_ENV !== "production" && ta("Invalid argument supplied to oneOfType, expected an instance of array."), ra;
      for (var Zl = 0; Zl < Bl.length; Zl++) {
        var Pl = Bl[Zl];
        if (typeof Pl != "function")
          return ta(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + kl(Pl) + " at index " + Zl + "."
          ), ra;
      }
      function yl(hl, Tl, Il, jl, Al) {
        for (var _s = [], Gs = 0; Gs < Bl.length; Gs++) {
          var vl = Bl[Gs], gl = vl(hl, Tl, Il, jl, Al, qi);
          if (gl == null)
            return null;
          gl.data && Xi(gl.data, "expectedType") && _s.push(gl.data.expectedType);
        }
        var El = _s.length > 0 ? ", expected one of type [" + _s.join(", ") + "]" : "";
        return new rs("Invalid " + jl + " `" + Al + "` supplied to " + ("`" + Il + "`" + El + "."));
      }
      return ko(yl);
    }
    function Js() {
      function Bl(Zl, Pl, yl, hl, Tl) {
        return xl(Zl[Pl]) ? null : new rs("Invalid " + hl + " `" + Tl + "` supplied to " + ("`" + yl + "`, expected a ReactNode."));
      }
      return ko(Bl);
    }
    function pl(Bl, Zl, Pl, yl, hl) {
      return new rs(
        (Bl || "React class") + ": " + Zl + " type `" + Pl + "." + yl + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + hl + "`."
      );
    }
    function _l(Bl) {
      function Zl(Pl, yl, hl, Tl, Il) {
        var jl = Pl[yl], Al = Cl(jl);
        if (Al !== "object")
          return new rs("Invalid " + Tl + " `" + Il + "` of type `" + Al + "` " + ("supplied to `" + hl + "`, expected `object`."));
        for (var _s in Bl) {
          var Gs = Bl[_s];
          if (typeof Gs != "function")
            return pl(hl, Tl, Il, _s, Dl(Gs));
          var vl = Gs(jl, _s, hl, Tl, Il + "." + _s, qi);
          if (vl)
            return vl;
        }
        return null;
      }
      return ko(Zl);
    }
    function bl(Bl) {
      function Zl(Pl, yl, hl, Tl, Il) {
        var jl = Pl[yl], Al = Cl(jl);
        if (Al !== "object")
          return new rs("Invalid " + Tl + " `" + Il + "` of type `" + Al + "` " + ("supplied to `" + hl + "`, expected `object`."));
        var _s = e({}, Pl[yl], Bl);
        for (var Gs in _s) {
          var vl = Bl[Gs];
          if (Xi(Bl, Gs) && typeof vl != "function")
            return pl(hl, Tl, Il, Gs, Dl(vl));
          if (!vl)
            return new rs(
              "Invalid " + Tl + " `" + Il + "` key `" + Gs + "` supplied to `" + hl + "`.\nBad object: " + JSON.stringify(Pl[yl], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Bl), null, "  ")
            );
          var gl = vl(jl, Gs, hl, Tl, Il + "." + Gs, qi);
          if (gl)
            return gl;
        }
        return null;
      }
      return ko(Zl);
    }
    function xl(Bl) {
      switch (typeof Bl) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Bl;
        case "object":
          if (Array.isArray(Bl))
            return Bl.every(xl);
          if (Bl === null || na(Bl))
            return !0;
          var Zl = to(Bl);
          if (Zl) {
            var Pl = Zl.call(Bl), yl;
            if (Zl !== Bl.entries) {
              for (; !(yl = Pl.next()).done; )
                if (!xl(yl.value))
                  return !1;
            } else
              for (; !(yl = Pl.next()).done; ) {
                var hl = yl.value;
                if (hl && !xl(hl[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Rl(Bl, Zl) {
      return Bl === "symbol" ? !0 : Zl ? Zl["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Zl instanceof Symbol : !1;
    }
    function Cl(Bl) {
      var Zl = typeof Bl;
      return Array.isArray(Bl) ? "array" : Bl instanceof RegExp ? "object" : Rl(Zl, Bl) ? "symbol" : Zl;
    }
    function Dl(Bl) {
      if (typeof Bl > "u" || Bl === null)
        return "" + Bl;
      var Zl = Cl(Bl);
      if (Zl === "object") {
        if (Bl instanceof Date)
          return "date";
        if (Bl instanceof RegExp)
          return "regexp";
      }
      return Zl;
    }
    function kl(Bl) {
      var Zl = Dl(Bl);
      switch (Zl) {
        case "array":
        case "object":
          return "an " + Zl;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Zl;
        default:
          return Zl;
      }
    }
    function Ul(Bl) {
      return !Bl.constructor || !Bl.constructor.name ? Eo : Bl.constructor.name;
    }
    return So.checkPropTypes = Qi, So.resetWarningCache = Qi.resetWarningCache, So.PropTypes = So, So;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var Bi = /* @__PURE__ */ requireReactPropTypesSecret();
  function e() {
  }
  function qi() {
  }
  return qi.resetWarningCache = e, factoryWithThrowingShims = function() {
    function Xi(ra, na, la, Ma, Va, to) {
      if (to !== Bi) {
        var Eo = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw Eo.name = "Invariant Violation", Eo;
      }
    }
    Xi.isRequired = Xi;
    function Qi() {
      return Xi;
    }
    var ta = {
      array: Xi,
      bigint: Xi,
      bool: Xi,
      func: Xi,
      number: Xi,
      object: Xi,
      string: Xi,
      symbol: Xi,
      any: Xi,
      arrayOf: Qi,
      element: Xi,
      elementType: Xi,
      instanceOf: Qi,
      node: Xi,
      objectOf: Qi,
      oneOf: Qi,
      oneOfType: Qi,
      shape: Qi,
      exact: Qi,
      checkPropTypes: qi,
      resetWarningCache: e
    };
    return ta.PropTypes = ta, ta;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var Bi = requireReactIs(), e = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(Bi.isElement, e);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function ownKeys$3(Bi, e) {
  var qi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Xi = Object.getOwnPropertySymbols(Bi);
    e && (Xi = Xi.filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(Bi, Qi).enumerable;
    })), qi.push.apply(qi, Xi);
  }
  return qi;
}
function _objectSpread2(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$3(Object(qi), !0).forEach(function(Xi) {
      _defineProperty$7(Bi, Xi, qi[Xi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(qi)) : ownKeys$3(Object(qi)).forEach(function(Xi) {
      Object.defineProperty(Bi, Xi, Object.getOwnPropertyDescriptor(qi, Xi));
    });
  }
  return Bi;
}
function _typeof(Bi) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _typeof(Bi);
}
function _defineProperty$7(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function _objectWithoutPropertiesLoose$2(Bi, e) {
  if (Bi == null) return {};
  var qi = {}, Xi = Object.keys(Bi), Qi, ta;
  for (ta = 0; ta < Xi.length; ta++)
    Qi = Xi[ta], !(e.indexOf(Qi) >= 0) && (qi[Qi] = Bi[Qi]);
  return qi;
}
function _objectWithoutProperties$2(Bi, e) {
  if (Bi == null) return {};
  var qi = _objectWithoutPropertiesLoose$2(Bi, e), Xi, Qi;
  if (Object.getOwnPropertySymbols) {
    var ta = Object.getOwnPropertySymbols(Bi);
    for (Qi = 0; Qi < ta.length; Qi++)
      Xi = ta[Qi], !(e.indexOf(Xi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Xi) && (qi[Xi] = Bi[Xi]);
  }
  return qi;
}
function _toConsumableArray$2(Bi) {
  return _arrayWithoutHoles$2(Bi) || _iterableToArray$2(Bi) || _unsupportedIterableToArray$3(Bi) || _nonIterableSpread$2();
}
function _arrayWithoutHoles$2(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray$3(Bi);
}
function _iterableToArray$2(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _unsupportedIterableToArray$3(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$3(Bi, e);
    var qi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (qi === "Object" && Bi.constructor && (qi = Bi.constructor.name), qi === "Map" || qi === "Set") return Array.from(Bi);
    if (qi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(qi)) return _arrayLikeToArray$3(Bi, e);
  }
}
function _arrayLikeToArray$3(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var qi = 0, Xi = new Array(e); qi < e; qi++) Xi[qi] = Bi[qi];
  return Xi;
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function classList(Bi) {
  var e, qi = Bi.beat, Xi = Bi.fade, Qi = Bi.beatFade, ta = Bi.bounce, ra = Bi.shake, na = Bi.flash, la = Bi.spin, Ma = Bi.spinPulse, Va = Bi.spinReverse, to = Bi.pulse, Eo = Bi.fixedWidth, So = Bi.inverse, eo = Bi.border, rs = Bi.listItem, ko = Bi.flip, Hs = Bi.size, Ks = Bi.rotation, Ys = Bi.pull, Xs = (e = {
    "fa-beat": qi,
    "fa-fade": Xi,
    "fa-beat-fade": Qi,
    "fa-bounce": ta,
    "fa-shake": ra,
    "fa-flash": na,
    "fa-spin": la,
    "fa-spin-reverse": Va,
    "fa-spin-pulse": Ma,
    "fa-pulse": to,
    "fa-fw": Eo,
    "fa-inverse": So,
    "fa-border": eo,
    "fa-li": rs,
    "fa-flip-horizontal": ko === "horizontal" || ko === "both",
    "fa-flip-vertical": ko === "vertical" || ko === "both"
  }, _defineProperty$7(e, "fa-".concat(Hs), typeof Hs < "u" && Hs !== null), _defineProperty$7(e, "fa-rotate-".concat(Ks), typeof Ks < "u" && Ks !== null && Ks !== 0), _defineProperty$7(e, "fa-pull-".concat(Ys), typeof Ys < "u" && Ys !== null), _defineProperty$7(e, "fa-swap-opacity", Bi.swapOpacity), e);
  return Object.keys(Xs).map(function(Cs) {
    return Xs[Cs] ? Cs : null;
  }).filter(function(Cs) {
    return Cs;
  });
}
function _isNumerical(Bi) {
  return Bi = Bi - 0, Bi === Bi;
}
function camelize(Bi) {
  return _isNumerical(Bi) ? Bi : (Bi = Bi.replace(/[\-_\s]+(.)?/g, function(e, qi) {
    return qi ? qi.toUpperCase() : "";
  }), Bi.substr(0, 1).toLowerCase() + Bi.substr(1));
}
var _excluded$1 = ["style"];
function capitalize(Bi) {
  return Bi.charAt(0).toUpperCase() + Bi.slice(1);
}
function styleToObject(Bi) {
  return Bi.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, qi) {
    var Xi = qi.indexOf(":"), Qi = camelize(qi.slice(0, Xi)), ta = qi.slice(Xi + 1).trim();
    return Qi.startsWith("webkit") ? e[capitalize(Qi)] = ta : e[Qi] = ta, e;
  }, {});
}
function convert(Bi, e) {
  var qi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var Xi = (e.children || []).map(function(la) {
    return convert(Bi, la);
  }), Qi = Object.keys(e.attributes || {}).reduce(function(la, Ma) {
    var Va = e.attributes[Ma];
    switch (Ma) {
      case "class":
        la.attrs.className = Va, delete e.attributes.class;
        break;
      case "style":
        la.attrs.style = styleToObject(Va);
        break;
      default:
        Ma.indexOf("aria-") === 0 || Ma.indexOf("data-") === 0 ? la.attrs[Ma.toLowerCase()] = Va : la.attrs[camelize(Ma)] = Va;
    }
    return la;
  }, {
    attrs: {}
  }), ta = qi.style, ra = ta === void 0 ? {} : ta, na = _objectWithoutProperties$2(qi, _excluded$1);
  return Qi.attrs.style = _objectSpread2(_objectSpread2({}, Qi.attrs.style), ra), Bi.apply(void 0, [e.tag, _objectSpread2(_objectSpread2({}, Qi.attrs), na)].concat(_toConsumableArray$2(Xi)));
}
var PRODUCTION = !1;
try {
  PRODUCTION = process.env.NODE_ENV === "production";
} catch {
}
function log() {
  if (!PRODUCTION && console && typeof console.error == "function") {
    var Bi;
    (Bi = console).error.apply(Bi, arguments);
  }
}
function normalizeIconArgs(Bi) {
  if (Bi && _typeof(Bi) === "object" && Bi.prefix && Bi.iconName && Bi.icon)
    return Bi;
  if (parse$1$1.icon)
    return parse$1$1.icon(Bi);
  if (Bi === null)
    return null;
  if (Bi && _typeof(Bi) === "object" && Bi.prefix && Bi.iconName)
    return Bi;
  if (Array.isArray(Bi) && Bi.length === 2)
    return {
      prefix: Bi[0],
      iconName: Bi[1]
    };
  if (typeof Bi == "string")
    return {
      prefix: "fas",
      iconName: Bi
    };
}
function objectWithKey(Bi, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? _defineProperty$7({}, Bi, e) : {};
}
var _excluded$2 = ["forwardedRef"];
function FontAwesomeIcon(Bi) {
  var e = Bi.forwardedRef, qi = _objectWithoutProperties$2(Bi, _excluded$2), Xi = qi.icon, Qi = qi.mask, ta = qi.symbol, ra = qi.className, na = qi.title, la = qi.titleId, Ma = qi.maskId, Va = normalizeIconArgs(Xi), to = objectWithKey("classes", [].concat(_toConsumableArray$2(classList(qi)), _toConsumableArray$2(ra.split(" ")))), Eo = objectWithKey("transform", typeof qi.transform == "string" ? parse$1$1.transform(qi.transform) : qi.transform), So = objectWithKey("mask", normalizeIconArgs(Qi)), eo = icon(Va, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, to), Eo), So), {}, {
    symbol: ta,
    title: na,
    titleId: la,
    maskId: Ma
  }));
  if (!eo)
    return log("Could not find icon", Va), null;
  var rs = eo.abstract, ko = {
    ref: e
  };
  return Object.keys(qi).forEach(function(Hs) {
    FontAwesomeIcon.defaultProps.hasOwnProperty(Hs) || (ko[Hs] = qi[Hs]);
  }), convertCurry(rs[0], ko);
}
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(["horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: null,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var convertCurry = convert.bind(null, a__default.createElement);
const copiedMessageStyles = cva(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), CopiedMessage = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: copiedMessageStyles({ visible: Bi.visible }), children: "Copied!" }), CopyButton = ({
  text: Bi,
  onCopy: e,
  element: qi,
  copyElement: Xi,
  disabled: Qi = !1,
  className: ta = ""
}) => {
  const [ra, na] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      disabled: Qi,
      className: `${ta} relative w-3 h-3`,
      onClick: () => {
        e?.(Bi), navigator.clipboard.writeText(Bi), na(!0), setTimeout(() => na(!1), 1500);
      },
      children: [
        qi || /* @__PURE__ */ jsxRuntimeExports.jsx(
          FontAwesomeIcon,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: faClipboard
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(CopiedMessage, { visible: ra, children: Xi || "Copied!" })
      ]
    }
  );
};
var extendStatics = function(Bi, e) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(qi, Xi) {
    qi.__proto__ = Xi;
  } || function(qi, Xi) {
    for (var Qi in Xi) Object.prototype.hasOwnProperty.call(Xi, Qi) && (qi[Qi] = Xi[Qi]);
  }, extendStatics(Bi, e);
};
function __extends(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  extendStatics(Bi, e);
  function qi() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (qi.prototype = e.prototype, new qi());
}
var __assign = function() {
  return __assign = Object.assign || function(e) {
    for (var qi, Xi = 1, Qi = arguments.length; Xi < Qi; Xi++) {
      qi = arguments[Xi];
      for (var ta in qi) Object.prototype.hasOwnProperty.call(qi, ta) && (e[ta] = qi[ta]);
    }
    return e;
  }, __assign.apply(this, arguments);
};
function __rest$1(Bi, e) {
  var qi = {};
  for (var Xi in Bi) Object.prototype.hasOwnProperty.call(Bi, Xi) && e.indexOf(Xi) < 0 && (qi[Xi] = Bi[Xi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Qi = 0, Xi = Object.getOwnPropertySymbols(Bi); Qi < Xi.length; Qi++)
      e.indexOf(Xi[Qi]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Xi[Qi]) && (qi[Xi[Qi]] = Bi[Xi[Qi]]);
  return qi;
}
function __values(Bi) {
  var e = typeof Symbol == "function" && Symbol.iterator, qi = e && Bi[e], Xi = 0;
  if (qi) return qi.call(Bi);
  if (Bi && typeof Bi.length == "number") return {
    next: function() {
      return Bi && Xi >= Bi.length && (Bi = void 0), { value: Bi && Bi[Xi++], done: !Bi };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(Bi, e) {
  var qi = typeof Symbol == "function" && Bi[Symbol.iterator];
  if (!qi) return Bi;
  var Xi = qi.call(Bi), Qi, ta = [], ra;
  try {
    for (; (e === void 0 || e-- > 0) && !(Qi = Xi.next()).done; ) ta.push(Qi.value);
  } catch (na) {
    ra = { error: na };
  } finally {
    try {
      Qi && !Qi.done && (qi = Xi.return) && qi.call(Xi);
    } finally {
      if (ra) throw ra.error;
    }
  }
  return ta;
}
function __spreadArray(Bi, e, qi) {
  if (qi || arguments.length === 2) for (var Xi = 0, Qi = e.length, ta; Xi < Qi; Xi++)
    (ta || !(Xi in e)) && (ta || (ta = Array.prototype.slice.call(e, 0, Xi)), ta[Xi] = e[Xi]);
  return Bi.concat(ta || Array.prototype.slice.call(e));
}
typeof SuppressedError == "function" && SuppressedError;
var defaultEnvironment = "production", env = typeof process > "u" || process.env === void 0 ? defaultEnvironment : process.env.NODE_ENV || defaultEnvironment, createDefinition$1 = function(Bi) {
  return {
    isEnabled: function(e) {
      return Bi.some(function(qi) {
        return !!e[qi];
      });
    }
  };
}, featureDefinitions = {
  measureLayout: createDefinition$1(["layout", "layoutId", "drag"]),
  animation: createDefinition$1([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: createDefinition$1(["exit"]),
  drag: createDefinition$1(["drag", "dragControls"]),
  focus: createDefinition$1(["whileFocus"]),
  hover: createDefinition$1(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition$1(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition$1([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: createDefinition$1([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function loadFeatures(Bi) {
  for (var e in Bi)
    Bi[e] !== null && (e === "projectionNodeConstructor" ? featureDefinitions.projectionNodeConstructor = Bi[e] : featureDefinitions[e].Component = Bi[e]);
}
var warning$1 = function() {
}, invariant$1 = function() {
};
process.env.NODE_ENV !== "production" && (warning$1 = function(Bi, e) {
  !Bi && typeof console < "u" && console.warn(e);
}, invariant$1 = function(Bi, e) {
  if (!Bi)
    throw new Error(e);
});
var LazyContext = createContext({ strict: !1 }), featureNames = Object.keys(featureDefinitions), numFeatures = featureNames.length;
function useFeatures(Bi, e, qi) {
  var Xi = [], Qi = useContext(LazyContext);
  if (!e)
    return null;
  env !== "production" && qi && Qi.strict && invariant$1(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var ta = 0; ta < numFeatures; ta++) {
    var ra = featureNames[ta], na = featureDefinitions[ra], la = na.isEnabled, Ma = na.Component;
    la(Bi) && Ma && Xi.push(a$8.createElement(Ma, __assign({ key: ra }, Bi, { visualElement: e })));
  }
  return Xi;
}
var MotionConfigContext = createContext({
  transformPagePoint: function(Bi) {
    return Bi;
  },
  isStatic: !1,
  reducedMotion: "never"
}), MotionContext = createContext({});
function useVisualElementContext() {
  return useContext(MotionContext).visualElement;
}
var PresenceContext = createContext(null), isBrowser = typeof document < "u", useIsomorphicLayoutEffect$1 = isBrowser ? useLayoutEffect : useEffect, prefersReducedMotion = { current: null }, hasDetected = !1;
function initPrefersReducedMotion() {
  if (hasDetected = !0, !!isBrowser)
    if (window.matchMedia) {
      var Bi = window.matchMedia("(prefers-reduced-motion)"), e = function() {
        return prefersReducedMotion.current = Bi.matches;
      };
      Bi.addListener(e), e();
    } else
      prefersReducedMotion.current = !1;
}
function useReducedMotion() {
  !hasDetected && initPrefersReducedMotion();
  var Bi = __read(useState(prefersReducedMotion.current), 1), e = Bi[0];
  return e;
}
function useReducedMotionConfig() {
  var Bi = useReducedMotion(), e = useContext(MotionConfigContext).reducedMotion;
  return e === "never" ? !1 : e === "always" ? !0 : Bi;
}
function useVisualElement(Bi, e, qi, Xi) {
  var Qi = useContext(LazyContext), ta = useVisualElementContext(), ra = useContext(PresenceContext), na = useReducedMotionConfig(), la = useRef(void 0);
  Xi || (Xi = Qi.renderer), !la.current && Xi && (la.current = Xi(Bi, {
    visualState: e,
    parent: ta,
    props: qi,
    presenceId: ra?.id,
    blockInitialAnimation: ra?.initial === !1,
    shouldReduceMotion: na
  }));
  var Ma = la.current;
  return useIsomorphicLayoutEffect$1(function() {
    Ma?.syncRender();
  }), useEffect(function() {
    var Va;
    (Va = Ma?.animationState) === null || Va === void 0 || Va.animateChanges();
  }), useIsomorphicLayoutEffect$1(function() {
    return function() {
      return Ma?.notifyUnmount();
    };
  }, []), Ma;
}
function isRefObject(Bi) {
  return typeof Bi == "object" && Object.prototype.hasOwnProperty.call(Bi, "current");
}
function useMotionRef(Bi, e, qi) {
  return useCallback(
    function(Xi) {
      var Qi;
      Xi && ((Qi = Bi.mount) === null || Qi === void 0 || Qi.call(Bi, Xi)), e && (Xi ? e.mount(Xi) : e.unmount()), qi && (typeof qi == "function" ? qi(Xi) : isRefObject(qi) && (qi.current = Xi));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function isVariantLabels(Bi) {
  return Array.isArray(Bi);
}
function isVariantLabel(Bi) {
  return typeof Bi == "string" || isVariantLabels(Bi);
}
function getCurrent(Bi) {
  var e = {};
  return Bi.forEachValue(function(qi, Xi) {
    return e[Xi] = qi.get();
  }), e;
}
function getVelocity$1(Bi) {
  var e = {};
  return Bi.forEachValue(function(qi, Xi) {
    return e[Xi] = qi.getVelocity();
  }), e;
}
function resolveVariantFromProps(Bi, e, qi, Xi, Qi) {
  var ta;
  return Xi === void 0 && (Xi = {}), Qi === void 0 && (Qi = {}), typeof e == "function" && (e = e(qi ?? Bi.custom, Xi, Qi)), typeof e == "string" && (e = (ta = Bi.variants) === null || ta === void 0 ? void 0 : ta[e]), typeof e == "function" && (e = e(qi ?? Bi.custom, Xi, Qi)), e;
}
function resolveVariant(Bi, e, qi) {
  var Xi = Bi.getProps();
  return resolveVariantFromProps(Xi, e, qi ?? Xi.custom, getCurrent(Bi), getVelocity$1(Bi));
}
function checkIfControllingVariants(Bi) {
  var e;
  return typeof ((e = Bi.animate) === null || e === void 0 ? void 0 : e.start) == "function" || isVariantLabel(Bi.initial) || isVariantLabel(Bi.animate) || isVariantLabel(Bi.whileHover) || isVariantLabel(Bi.whileDrag) || isVariantLabel(Bi.whileTap) || isVariantLabel(Bi.whileFocus) || isVariantLabel(Bi.exit);
}
function checkIfVariantNode(Bi) {
  return !!(checkIfControllingVariants(Bi) || Bi.variants);
}
function getCurrentTreeVariants(Bi, e) {
  if (checkIfControllingVariants(Bi)) {
    var qi = Bi.initial, Xi = Bi.animate;
    return {
      initial: qi === !1 || isVariantLabel(qi) ? qi : void 0,
      animate: isVariantLabel(Xi) ? Xi : void 0
    };
  }
  return Bi.inherit !== !1 ? e : {};
}
function useCreateMotionContext(Bi) {
  var e = getCurrentTreeVariants(Bi, useContext(MotionContext)), qi = e.initial, Xi = e.animate;
  return useMemo(function() {
    return { initial: qi, animate: Xi };
  }, [variantLabelsAsDependency(qi), variantLabelsAsDependency(Xi)]);
}
function variantLabelsAsDependency(Bi) {
  return Array.isArray(Bi) ? Bi.join(" ") : Bi;
}
function useConstant(Bi) {
  var e = useRef(null);
  return e.current === null && (e.current = Bi()), e.current;
}
var globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, id$1 = 1;
function useProjectionId() {
  return useConstant(function() {
    if (globalProjectionState.hasEverUpdated)
      return id$1++;
  });
}
var LayoutGroupContext = createContext({}), SwitchLayoutGroupContext = createContext({});
function useProjection(Bi, e, qi, Xi) {
  var Qi, ta = e.layoutId, ra = e.layout, na = e.drag, la = e.dragConstraints, Ma = e.layoutScroll, Va = useContext(SwitchLayoutGroupContext);
  !Xi || !qi || qi?.projection || (qi.projection = new Xi(Bi, qi.getLatestValues(), (Qi = qi.parent) === null || Qi === void 0 ? void 0 : Qi.projection), qi.projection.setOptions({
    layoutId: ta,
    layout: ra,
    alwaysMeasureLayout: !!na || la && isRefObject(la),
    visualElement: qi,
    scheduleRender: function() {
      return qi.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof ra == "string" ? ra : "both",
    initialPromotionConfig: Va,
    layoutScroll: Ma
  }));
}
var VisualElementHandler = (
  /** @class */
  function(Bi) {
    __extends(e, Bi);
    function e() {
      return Bi !== null && Bi.apply(this, arguments) || this;
    }
    return e.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, e.prototype.componentDidUpdate = function() {
    }, e.prototype.updateProps = function() {
      var qi = this.props, Xi = qi.visualElement, Qi = qi.props;
      Xi && Xi.setProps(Qi);
    }, e.prototype.render = function() {
      return this.props.children;
    }, e;
  }(a__default.Component)
);
function createMotionComponent(Bi) {
  var e = Bi.preloadedFeatures, qi = Bi.createVisualElement, Xi = Bi.projectionNodeConstructor, Qi = Bi.useRender, ta = Bi.useVisualState, ra = Bi.Component;
  e && loadFeatures(e);
  function na(la, Ma) {
    var Va = useLayoutId(la);
    la = __assign(__assign({}, la), { layoutId: Va });
    var to = useContext(MotionConfigContext), Eo = null, So = useCreateMotionContext(la), eo = to.isStatic ? void 0 : useProjectionId(), rs = ta(la, to.isStatic);
    return !to.isStatic && isBrowser && (So.visualElement = useVisualElement(ra, rs, __assign(__assign({}, to), la), qi), useProjection(eo, la, So.visualElement, Xi || featureDefinitions.projectionNodeConstructor), Eo = useFeatures(la, So.visualElement, e)), a$8.createElement(
      VisualElementHandler,
      { visualElement: So.visualElement, props: __assign(__assign({}, to), la) },
      Eo,
      a$8.createElement(MotionContext.Provider, { value: So }, Qi(ra, la, eo, useMotionRef(rs, So.visualElement, Ma), rs, to.isStatic, So.visualElement))
    );
  }
  return forwardRef(na);
}
function useLayoutId(Bi) {
  var e, qi = Bi.layoutId, Xi = (e = useContext(LayoutGroupContext)) === null || e === void 0 ? void 0 : e.id;
  return Xi && qi !== void 0 ? Xi + "-" + qi : qi;
}
function createMotionProxy(Bi) {
  function e(Xi, Qi) {
    return Qi === void 0 && (Qi = {}), createMotionComponent(Bi(Xi, Qi));
  }
  if (typeof Proxy > "u")
    return e;
  var qi = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(Xi, Qi) {
      return qi.has(Qi) || qi.set(Qi, e(Qi)), qi.get(Qi);
    }
  });
}
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(Bi) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Bi != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    Bi.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(Bi) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(Bi))
    )
  );
}
var scaleCorrectors = {};
function addScaleCorrector(Bi) {
  Object.assign(scaleCorrectors, Bi);
}
var transformAxes = ["", "X", "Y", "Z"], order = ["translate", "scale", "rotate", "skew"], transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function(Bi) {
  return transformAxes.forEach(function(e) {
    return transformProps.push(Bi + e);
  });
});
function sortTransformProps(Bi, e) {
  return transformProps.indexOf(Bi) - transformProps.indexOf(e);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(Bi) {
  return transformPropSet.has(Bi);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(Bi) {
  return transformOriginProps.has(Bi);
}
function isForcedMotionValue(Bi, e) {
  var qi = e.layout, Xi = e.layoutId;
  return isTransformProp(Bi) || isTransformOriginProp(Bi) || (qi || Xi !== void 0) && (!!scaleCorrectors[Bi] || Bi === "opacity");
}
var isMotionValue = function(Bi) {
  return !!(Bi !== null && typeof Bi == "object" && Bi.getVelocity);
}, translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(Bi, e, qi, Xi) {
  var Qi = Bi.transform, ta = Bi.transformKeys, ra = e.enableHardwareAcceleration, na = ra === void 0 ? !0 : ra, la = e.allowTransformNone, Ma = la === void 0 ? !0 : la, Va = "";
  ta.sort(sortTransformProps);
  for (var to = !1, Eo = ta.length, So = 0; So < Eo; So++) {
    var eo = ta[So];
    Va += "".concat(translateAlias[eo] || eo, "(").concat(Qi[eo], ") "), eo === "z" && (to = !0);
  }
  return !to && na ? Va += "translateZ(0)" : Va = Va.trim(), Xi ? Va = Xi(Qi, qi ? "" : Va) : Ma && qi && (Va = "none"), Va;
}
function buildTransformOrigin(Bi) {
  var e = Bi.originX, qi = e === void 0 ? "50%" : e, Xi = Bi.originY, Qi = Xi === void 0 ? "50%" : Xi, ta = Bi.originZ, ra = ta === void 0 ? 0 : ta;
  return "".concat(qi, " ").concat(Qi, " ").concat(ra);
}
function isCSSVariable$1(Bi) {
  return Bi.startsWith("--");
}
var getValueAsType = function(Bi, e) {
  return e && typeof Bi == "number" ? e.transform(Bi) : Bi;
};
const clamp$1 = (Bi, e) => (qi) => Math.max(Math.min(qi, e), Bi), sanitize = (Bi) => Bi % 1 ? Number(Bi.toFixed(5)) : Bi, floatRegex = /(-)?([\d]*\.?[\d])+/g, colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(Bi) {
  return typeof Bi == "string";
}
const number = {
  test: (Bi) => typeof Bi == "number",
  parse: parseFloat,
  transform: (Bi) => Bi
}, alpha = Object.assign(Object.assign({}, number), { transform: clamp$1(0, 1) }), scale = Object.assign(Object.assign({}, number), { default: 1 }), createUnitType = (Bi) => ({
  test: (e) => isString$1(e) && e.endsWith(Bi) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${Bi}`
}), degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = Object.assign(Object.assign({}, percent), { parse: (Bi) => percent.parse(Bi) / 100, transform: (Bi) => percent.transform(Bi * 100) }), isColorString = (Bi, e) => (qi) => !!(isString$1(qi) && singleColorRegex.test(qi) && qi.startsWith(Bi) || e && Object.prototype.hasOwnProperty.call(qi, e)), splitColor = (Bi, e, qi) => (Xi) => {
  if (!isString$1(Xi))
    return Xi;
  const [Qi, ta, ra, na] = Xi.match(floatRegex);
  return {
    [Bi]: parseFloat(Qi),
    [e]: parseFloat(ta),
    [qi]: parseFloat(ra),
    alpha: na !== void 0 ? parseFloat(na) : 1
  };
}, hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: ({ hue: Bi, saturation: e, lightness: qi, alpha: Xi = 1 }) => "hsla(" + Math.round(Bi) + ", " + percent.transform(sanitize(e)) + ", " + percent.transform(sanitize(qi)) + ", " + sanitize(alpha.transform(Xi)) + ")"
}, clampRgbUnit = clamp$1(0, 255), rgbUnit = Object.assign(Object.assign({}, number), { transform: (Bi) => Math.round(clampRgbUnit(Bi)) }), rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: ({ red: Bi, green: e, blue: qi, alpha: Xi = 1 }) => "rgba(" + rgbUnit.transform(Bi) + ", " + rgbUnit.transform(e) + ", " + rgbUnit.transform(qi) + ", " + sanitize(alpha.transform(Xi)) + ")"
};
function parseHex(Bi) {
  let e = "", qi = "", Xi = "", Qi = "";
  return Bi.length > 5 ? (e = Bi.substr(1, 2), qi = Bi.substr(3, 2), Xi = Bi.substr(5, 2), Qi = Bi.substr(7, 2)) : (e = Bi.substr(1, 1), qi = Bi.substr(2, 1), Xi = Bi.substr(3, 1), Qi = Bi.substr(4, 1), e += e, qi += qi, Xi += Xi, Qi += Qi), {
    red: parseInt(e, 16),
    green: parseInt(qi, 16),
    blue: parseInt(Xi, 16),
    alpha: Qi ? parseInt(Qi, 16) / 255 : 1
  };
}
const hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
}, color = {
  test: (Bi) => rgba.test(Bi) || hex.test(Bi) || hsla.test(Bi),
  parse: (Bi) => rgba.test(Bi) ? rgba.parse(Bi) : hsla.test(Bi) ? hsla.parse(Bi) : hex.parse(Bi),
  transform: (Bi) => isString$1(Bi) ? Bi : Bi.hasOwnProperty("red") ? rgba.transform(Bi) : hsla.transform(Bi)
}, colorToken = "${c}", numberToken = "${n}";
function test(Bi) {
  var e, qi, Xi, Qi;
  return isNaN(Bi) && isString$1(Bi) && ((qi = (e = Bi.match(floatRegex)) === null || e === void 0 ? void 0 : e.length) !== null && qi !== void 0 ? qi : 0) + ((Qi = (Xi = Bi.match(colorRegex)) === null || Xi === void 0 ? void 0 : Xi.length) !== null && Qi !== void 0 ? Qi : 0) > 0;
}
function analyse$1(Bi) {
  typeof Bi == "number" && (Bi = `${Bi}`);
  const e = [];
  let qi = 0;
  const Xi = Bi.match(colorRegex);
  Xi && (qi = Xi.length, Bi = Bi.replace(colorRegex, colorToken), e.push(...Xi.map(color.parse)));
  const Qi = Bi.match(floatRegex);
  return Qi && (Bi = Bi.replace(floatRegex, numberToken), e.push(...Qi.map(number.parse))), { values: e, numColors: qi, tokenised: Bi };
}
function parse(Bi) {
  return analyse$1(Bi).values;
}
function createTransformer(Bi) {
  const { values: e, numColors: qi, tokenised: Xi } = analyse$1(Bi), Qi = e.length;
  return (ta) => {
    let ra = Xi;
    for (let na = 0; na < Qi; na++)
      ra = ra.replace(na < qi ? colorToken : numberToken, na < qi ? color.transform(ta[na]) : sanitize(ta[na]));
    return ra;
  };
}
const convertNumbersToZero = (Bi) => typeof Bi == "number" ? 0 : Bi;
function getAnimatableNone$1(Bi) {
  const e = parse(Bi);
  return createTransformer(Bi)(e.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 }, maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(Bi) {
  let [e, qi] = Bi.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return Bi;
  const [Xi] = qi.match(floatRegex) || [];
  if (!Xi)
    return Bi;
  const Qi = qi.replace(Xi, "");
  let ta = maxDefaults.has(e) ? 1 : 0;
  return Xi !== qi && (ta *= 100), e + "(" + ta + Qi + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g, filter = Object.assign(Object.assign({}, complex), { getAnimatableNone: (Bi) => {
  const e = Bi.match(functionRegex);
  return e ? e.map(applyDefaultFilter).join(" ") : Bi;
} });
var int = __assign(__assign({}, number), { transform: Math.round }), numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
function buildHTMLStyles(Bi, e, qi, Xi) {
  var Qi, ta = Bi.style, ra = Bi.vars, na = Bi.transform, la = Bi.transformKeys, Ma = Bi.transformOrigin;
  la.length = 0;
  var Va = !1, to = !1, Eo = !0;
  for (var So in e) {
    var eo = e[So];
    if (isCSSVariable$1(So)) {
      ra[So] = eo;
      continue;
    }
    var rs = numberValueTypes[So], ko = getValueAsType(eo, rs);
    if (isTransformProp(So)) {
      if (Va = !0, na[So] = ko, la.push(So), !Eo)
        continue;
      eo !== ((Qi = rs.default) !== null && Qi !== void 0 ? Qi : 0) && (Eo = !1);
    } else isTransformOriginProp(So) ? (Ma[So] = ko, to = !0) : ta[So] = ko;
  }
  Va ? ta.transform = buildTransform(Bi, qi, Eo, Xi) : Xi ? ta.transform = Xi({}, "") : !e.transform && ta.transform && (ta.transform = "none"), to && (ta.transformOrigin = buildTransformOrigin(Ma));
}
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function copyRawValuesOnly(Bi, e, qi) {
  for (var Xi in e)
    !isMotionValue(e[Xi]) && !isForcedMotionValue(Xi, qi) && (Bi[Xi] = e[Xi]);
}
function useInitialMotionValues(Bi, e, qi) {
  var Xi = Bi.transformTemplate;
  return useMemo(function() {
    var Qi = createHtmlRenderState();
    buildHTMLStyles(Qi, e, { enableHardwareAcceleration: !qi }, Xi);
    var ta = Qi.vars, ra = Qi.style;
    return __assign(__assign({}, ta), ra);
  }, [e]);
}
function useStyle(Bi, e, qi) {
  var Xi = Bi.style || {}, Qi = {};
  return copyRawValuesOnly(Qi, Xi, Bi), Object.assign(Qi, useInitialMotionValues(Bi, e, qi)), Bi.transformValues && (Qi = Bi.transformValues(Qi)), Qi;
}
function useHTMLProps(Bi, e, qi) {
  var Xi = {}, Qi = useStyle(Bi, e, qi);
  return Bi.drag && Bi.dragListener !== !1 && (Xi.draggable = !1, Qi.userSelect = Qi.WebkitUserSelect = Qi.WebkitTouchCallout = "none", Qi.touchAction = Bi.drag === !0 ? "none" : "pan-".concat(Bi.drag === "x" ? "y" : "x")), Xi.style = Qi, Xi;
}
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function isValidMotionProp(Bi) {
  return validMotionProps.has(Bi);
}
var shouldForward = function(Bi) {
  return !isValidMotionProp(Bi);
};
function loadExternalIsValidProp(Bi) {
  Bi && (shouldForward = function(e) {
    return e.startsWith("on") ? !isValidMotionProp(e) : Bi(e);
  });
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch {
}
function filterProps(Bi, e, qi) {
  var Xi = {};
  for (var Qi in Bi)
    (shouldForward(Qi) || qi === !0 && isValidMotionProp(Qi) || !e && !isValidMotionProp(Qi) || // If trying to use native HTML drag events, forward drag listeners
    Bi.draggable && Qi.startsWith("onDrag")) && (Xi[Qi] = Bi[Qi]);
  return Xi;
}
function calcOrigin$1(Bi, e, qi) {
  return typeof Bi == "string" ? Bi : px.transform(e + qi * Bi);
}
function calcSVGTransformOrigin(Bi, e, qi) {
  var Xi = calcOrigin$1(e, Bi.x, Bi.width), Qi = calcOrigin$1(qi, Bi.y, Bi.height);
  return "".concat(Xi, " ").concat(Qi);
}
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(Bi, e, qi, Xi, Qi) {
  qi === void 0 && (qi = 1), Xi === void 0 && (Xi = 0), Bi.pathLength = 1;
  var ta = camelKeys;
  Bi[ta.offset] = px.transform(-Xi);
  var ra = px.transform(e), na = px.transform(qi);
  Bi[ta.array] = "".concat(ra, " ").concat(na);
}
function buildSVGAttrs(Bi, e, qi, Xi) {
  var Qi = e.attrX, ta = e.attrY, ra = e.originX, na = e.originY, la = e.pathLength, Ma = e.pathSpacing, Va = Ma === void 0 ? 1 : Ma, to = e.pathOffset, Eo = to === void 0 ? 0 : to, So = __rest$1(e, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(Bi, So, qi, Xi), Bi.attrs = Bi.style, Bi.style = {};
  var eo = Bi.attrs, rs = Bi.style, ko = Bi.dimensions;
  eo.transform && (ko && (rs.transform = eo.transform), delete eo.transform), ko && (ra !== void 0 || na !== void 0 || rs.transform) && (rs.transformOrigin = calcSVGTransformOrigin(ko, ra !== void 0 ? ra : 0.5, na !== void 0 ? na : 0.5)), Qi !== void 0 && (eo.x = Qi), ta !== void 0 && (eo.y = ta), la !== void 0 && buildSVGPath(eo, la, Va, Eo);
}
var createSvgRenderState = function() {
  return __assign(__assign({}, createHtmlRenderState()), { attrs: {} });
};
function useSVGProps(Bi, e) {
  var qi = useMemo(function() {
    var Qi = createSvgRenderState();
    return buildSVGAttrs(Qi, e, { enableHardwareAcceleration: !1 }, Bi.transformTemplate), __assign(__assign({}, Qi.attrs), { style: __assign({}, Qi.style) });
  }, [e]);
  if (Bi.style) {
    var Xi = {};
    copyRawValuesOnly(Xi, Bi.style, Bi), qi.style = __assign(__assign({}, Xi), qi.style);
  }
  return qi;
}
function createUseRender(Bi) {
  Bi === void 0 && (Bi = !1);
  var e = function(qi, Xi, Qi, ta, ra, na) {
    var la = ra.latestValues, Ma = isSVGComponent(qi) ? useSVGProps : useHTMLProps, Va = Ma(Xi, la, na), to = filterProps(Xi, typeof qi == "string", Bi), Eo = __assign(__assign(__assign({}, to), Va), { ref: ta });
    return Qi && (Eo["data-projection-id"] = Qi), createElement$1(qi, Eo);
  };
  return e;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g, REPLACE_TEMPLATE = "$1-$2", camelToDash = function(Bi) {
  return Bi.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(Bi, e, qi, Xi) {
  var Qi = e.style, ta = e.vars;
  Object.assign(Bi.style, Qi, Xi && Xi.getProjectionStyles(qi));
  for (var ra in ta)
    Bi.style.setProperty(ra, ta[ra]);
}
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function renderSVG(Bi, e, qi, Xi) {
  renderHTML(Bi, e, void 0, Xi);
  for (var Qi in e.attrs)
    Bi.setAttribute(camelCaseAttributes.has(Qi) ? Qi : camelToDash(Qi), e.attrs[Qi]);
}
function scrapeMotionValuesFromProps$1(Bi) {
  var e = Bi.style, qi = {};
  for (var Xi in e)
    (isMotionValue(e[Xi]) || isForcedMotionValue(Xi, Bi)) && (qi[Xi] = e[Xi]);
  return qi;
}
function scrapeMotionValuesFromProps(Bi) {
  var e = scrapeMotionValuesFromProps$1(Bi);
  for (var qi in Bi)
    if (isMotionValue(Bi[qi])) {
      var Xi = qi === "x" || qi === "y" ? "attr" + qi.toUpperCase() : qi;
      e[Xi] = Bi[qi];
    }
  return e;
}
function isAnimationControls(Bi) {
  return typeof Bi == "object" && typeof Bi.start == "function";
}
var isKeyframesTarget = function(Bi) {
  return Array.isArray(Bi);
}, isCustomValue = function(Bi) {
  return !!(Bi && typeof Bi == "object" && Bi.mix && Bi.toValue);
}, resolveFinalValueInKeyframes = function(Bi) {
  return isKeyframesTarget(Bi) ? Bi[Bi.length - 1] || 0 : Bi;
};
function resolveMotionValue(Bi) {
  var e = isMotionValue(Bi) ? Bi.get() : Bi;
  return isCustomValue(e) ? e.toValue() : e;
}
function makeState(Bi, e, qi, Xi) {
  var Qi = Bi.scrapeMotionValuesFromProps, ta = Bi.createRenderState, ra = Bi.onMount, na = {
    latestValues: makeLatestValues(e, qi, Xi, Qi),
    renderState: ta()
  };
  return ra && (na.mount = function(la) {
    return ra(e, la, na);
  }), na;
}
var makeUseVisualState = function(Bi) {
  return function(e, qi) {
    var Xi = useContext(MotionContext), Qi = useContext(PresenceContext);
    return qi ? makeState(Bi, e, Xi, Qi) : useConstant(function() {
      return makeState(Bi, e, Xi, Qi);
    });
  };
};
function makeLatestValues(Bi, e, qi, Xi) {
  var Qi = {}, ta = qi?.initial === !1, ra = Xi(Bi);
  for (var na in ra)
    Qi[na] = resolveMotionValue(ra[na]);
  var la = Bi.initial, Ma = Bi.animate, Va = checkIfControllingVariants(Bi), to = checkIfVariantNode(Bi);
  e && to && !Va && Bi.inherit !== !1 && (la ?? (la = e.initial), Ma ?? (Ma = e.animate));
  var Eo = ta || la === !1, So = Eo ? Ma : la;
  if (So && typeof So != "boolean" && !isAnimationControls(So)) {
    var eo = Array.isArray(So) ? So : [So];
    eo.forEach(function(rs) {
      var ko = resolveVariantFromProps(Bi, rs);
      if (ko) {
        var Hs = ko.transitionEnd;
        ko.transition;
        var Ks = __rest$1(ko, ["transitionEnd", "transition"]);
        for (var Ys in Ks) {
          var Xs = Ks[Ys];
          if (Array.isArray(Xs)) {
            var Cs = Eo ? Xs.length - 1 : 0;
            Xs = Xs[Cs];
          }
          Xs !== null && (Qi[Ys] = Xs);
        }
        for (var Ys in Hs)
          Qi[Ys] = Hs[Ys];
      }
    });
  }
  return Qi;
}
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onMount: function(Bi, e, qi) {
      var Xi = qi.renderState, Qi = qi.latestValues;
      try {
        Xi.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
      } catch {
        Xi.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      buildSVGAttrs(Xi, Qi, { enableHardwareAcceleration: !1 }, Bi.transformTemplate), renderSVG(e, Xi);
    }
  })
}, htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function createDomMotionConfig(Bi, e, qi, Xi, Qi) {
  var ta = e.forwardMotionProps, ra = ta === void 0 ? !1 : ta, na = isSVGComponent(Bi) ? svgMotionConfig : htmlMotionConfig;
  return __assign(__assign({}, na), { preloadedFeatures: qi, useRender: createUseRender(ra), createVisualElement: Xi, projectionNodeConstructor: Qi, Component: Bi });
}
var AnimationType;
(function(Bi) {
  Bi.Animate = "animate", Bi.Hover = "whileHover", Bi.Tap = "whileTap", Bi.Drag = "whileDrag", Bi.Focus = "whileFocus", Bi.InView = "whileInView", Bi.Exit = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(Bi, e, qi, Xi) {
  return Xi === void 0 && (Xi = { passive: !0 }), Bi.addEventListener(e, qi, Xi), function() {
    return Bi.removeEventListener(e, qi);
  };
}
function useDomEvent(Bi, e, qi, Xi) {
  useEffect(function() {
    var Qi = Bi.current;
    if (qi && Qi)
      return addDomEvent(Qi, e, qi, Xi);
  }, [Bi, e, qi, Xi]);
}
function useFocusGesture(Bi) {
  var e = Bi.whileFocus, qi = Bi.visualElement, Xi = function() {
    var ta;
    (ta = qi.animationState) === null || ta === void 0 || ta.setActive(AnimationType.Focus, !0);
  }, Qi = function() {
    var ta;
    (ta = qi.animationState) === null || ta === void 0 || ta.setActive(AnimationType.Focus, !1);
  };
  useDomEvent(qi, "focus", e ? Xi : void 0), useDomEvent(qi, "blur", e ? Qi : void 0);
}
function isMouseEvent(Bi) {
  return typeof PointerEvent < "u" && Bi instanceof PointerEvent ? Bi.pointerType === "mouse" : Bi instanceof MouseEvent;
}
function isTouchEvent(Bi) {
  var e = !!Bi.touches;
  return e;
}
function filterPrimaryPointer(Bi) {
  return function(e) {
    var qi = e instanceof MouseEvent, Xi = !qi || qi && e.button === 0;
    Xi && Bi(e);
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(Bi, e) {
  e === void 0 && (e = "page");
  var qi = Bi.touches[0] || Bi.changedTouches[0], Xi = qi || defaultPagePoint;
  return {
    x: Xi[e + "X"],
    y: Xi[e + "Y"]
  };
}
function pointFromMouse(Bi, e) {
  return e === void 0 && (e = "page"), {
    x: Bi[e + "X"],
    y: Bi[e + "Y"]
  };
}
function extractEventInfo(Bi, e) {
  return e === void 0 && (e = "page"), {
    point: isTouchEvent(Bi) ? pointFromTouch(Bi, e) : pointFromMouse(Bi, e)
  };
}
var wrapHandler = function(Bi, e) {
  e === void 0 && (e = !1);
  var qi = function(Xi) {
    return Bi(Xi, extractEventInfo(Xi));
  };
  return e ? filterPrimaryPointer(qi) : qi;
}, supportsPointerEvents = function() {
  return isBrowser && window.onpointerdown === null;
}, supportsTouchEvents = function() {
  return isBrowser && window.ontouchstart === null;
}, supportsMouseEvents = function() {
  return isBrowser && window.onmousedown === null;
}, mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(Bi) {
  return supportsPointerEvents() ? Bi : supportsTouchEvents() ? touchEventNames[Bi] : supportsMouseEvents() ? mouseEventNames[Bi] : Bi;
}
function addPointerEvent(Bi, e, qi, Xi) {
  return addDomEvent(Bi, getPointerEventName(e), wrapHandler(qi, e === "pointerdown"), Xi);
}
function usePointerEvent(Bi, e, qi, Xi) {
  return useDomEvent(Bi, getPointerEventName(e), qi && wrapHandler(qi, e === "pointerdown"), Xi);
}
function createLock(Bi) {
  var e = null;
  return function() {
    var qi = function() {
      e = null;
    };
    return e === null ? (e = Bi, qi) : !1;
  };
}
var globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(Bi) {
  var e = !1;
  if (Bi === "y")
    e = globalVerticalLock();
  else if (Bi === "x")
    e = globalHorizontalLock();
  else {
    var qi = globalHorizontalLock(), Xi = globalVerticalLock();
    qi && Xi ? e = function() {
      qi(), Xi();
    } : (qi && qi(), Xi && Xi());
  }
  return e;
}
function isDragActive() {
  var Bi = getGlobalLock(!0);
  return Bi ? (Bi(), !1) : !0;
}
function createHoverEvent(Bi, e, qi) {
  return function(Xi, Qi) {
    var ta;
    !isMouseEvent(Xi) || isDragActive() || ((ta = Bi.animationState) === null || ta === void 0 || ta.setActive(AnimationType.Hover, e), qi?.(Xi, Qi));
  };
}
function useHoverGesture(Bi) {
  var e = Bi.onHoverStart, qi = Bi.onHoverEnd, Xi = Bi.whileHover, Qi = Bi.visualElement;
  usePointerEvent(Qi, "pointerenter", e || Xi ? createHoverEvent(Qi, !0, e) : void 0, { passive: !e }), usePointerEvent(Qi, "pointerleave", qi || Xi ? createHoverEvent(Qi, !1, qi) : void 0, { passive: !qi });
}
var isNodeOrChild = function(Bi, e) {
  return e ? Bi === e ? !0 : isNodeOrChild(Bi, e.parentElement) : !1;
};
function useUnmountEffect(Bi) {
  return useEffect(function() {
    return function() {
      return Bi();
    };
  }, []);
}
function __rest(Bi, e) {
  var qi = {};
  for (var Xi in Bi) Object.prototype.hasOwnProperty.call(Bi, Xi) && e.indexOf(Xi) < 0 && (qi[Xi] = Bi[Xi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Qi = 0, Xi = Object.getOwnPropertySymbols(Bi); Qi < Xi.length; Qi++)
      e.indexOf(Xi[Qi]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Xi[Qi]) && (qi[Xi[Qi]] = Bi[Xi[Qi]]);
  return qi;
}
function __awaiter(Bi, e, qi, Xi) {
  function Qi(ta) {
    return ta instanceof qi ? ta : new qi(function(ra) {
      ra(ta);
    });
  }
  return new (qi || (qi = Promise))(function(ta, ra) {
    function na(Va) {
      try {
        Ma(Xi.next(Va));
      } catch (to) {
        ra(to);
      }
    }
    function la(Va) {
      try {
        Ma(Xi.throw(Va));
      } catch (to) {
        ra(to);
      }
    }
    function Ma(Va) {
      Va.done ? ta(Va.value) : Qi(Va.value).then(na, la);
    }
    Ma((Xi = Xi.apply(Bi, e || [])).next());
  });
}
typeof SuppressedError == "function" && SuppressedError;
const clamp = (Bi, e, qi) => Math.min(Math.max(qi, Bi), e), safeMin = 1e-3, minDuration = 0.01, maxDuration = 10, minDamping = 0.05, maxDamping = 1;
function findSpring({ duration: Bi = 800, bounce: e = 0.25, velocity: qi = 0, mass: Xi = 1 }) {
  let Qi, ta;
  warning$1(Bi <= maxDuration * 1e3, "Spring duration must be 10 seconds or less");
  let ra = 1 - e;
  ra = clamp(minDamping, maxDamping, ra), Bi = clamp(minDuration, maxDuration, Bi / 1e3), ra < 1 ? (Qi = (Ma) => {
    const Va = Ma * ra, to = Va * Bi, Eo = Va - qi, So = calcAngularFreq(Ma, ra), eo = Math.exp(-to);
    return safeMin - Eo / So * eo;
  }, ta = (Ma) => {
    const to = Ma * ra * Bi, Eo = to * qi + qi, So = Math.pow(ra, 2) * Math.pow(Ma, 2) * Bi, eo = Math.exp(-to), rs = calcAngularFreq(Math.pow(Ma, 2), ra);
    return (-Qi(Ma) + safeMin > 0 ? -1 : 1) * ((Eo - So) * eo) / rs;
  }) : (Qi = (Ma) => {
    const Va = Math.exp(-Ma * Bi), to = (Ma - qi) * Bi + 1;
    return -safeMin + Va * to;
  }, ta = (Ma) => {
    const Va = Math.exp(-Ma * Bi), to = (qi - Ma) * (Bi * Bi);
    return Va * to;
  });
  const na = 5 / Bi, la = approximateRoot(Qi, ta, na);
  if (Bi = Bi * 1e3, isNaN(la))
    return {
      stiffness: 100,
      damping: 10,
      duration: Bi
    };
  {
    const Ma = Math.pow(la, 2) * Xi;
    return {
      stiffness: Ma,
      damping: ra * 2 * Math.sqrt(Xi * Ma),
      duration: Bi
    };
  }
}
const rootIterations = 12;
function approximateRoot(Bi, e, qi) {
  let Xi = qi;
  for (let Qi = 1; Qi < rootIterations; Qi++)
    Xi = Xi - Bi(Xi) / e(Xi);
  return Xi;
}
function calcAngularFreq(Bi, e) {
  return Bi * Math.sqrt(1 - e * e);
}
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(Bi, e) {
  return e.some((qi) => Bi[qi] !== void 0);
}
function getSpringOptions(Bi) {
  let e = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, Bi);
  if (!isSpringType(Bi, physicsKeys) && isSpringType(Bi, durationKeys)) {
    const qi = findSpring(Bi);
    e = Object.assign(Object.assign(Object.assign({}, e), qi), { velocity: 0, mass: 1 }), e.isResolvedFromDuration = !0;
  }
  return e;
}
function spring(Bi) {
  var { from: e = 0, to: qi = 1, restSpeed: Xi = 2, restDelta: Qi } = Bi, ta = __rest(Bi, ["from", "to", "restSpeed", "restDelta"]);
  const ra = { done: !1, value: e };
  let { stiffness: na, damping: la, mass: Ma, velocity: Va, duration: to, isResolvedFromDuration: Eo } = getSpringOptions(ta), So = zero, eo = zero;
  function rs() {
    const ko = Va ? -(Va / 1e3) : 0, Hs = qi - e, Ks = la / (2 * Math.sqrt(na * Ma)), Ys = Math.sqrt(na / Ma) / 1e3;
    if (Qi === void 0 && (Qi = Math.min(Math.abs(qi - e) / 100, 0.4)), Ks < 1) {
      const Xs = calcAngularFreq(Ys, Ks);
      So = (Cs) => {
        const Fs = Math.exp(-Ks * Ys * Cs);
        return qi - Fs * ((ko + Ks * Ys * Hs) / Xs * Math.sin(Xs * Cs) + Hs * Math.cos(Xs * Cs));
      }, eo = (Cs) => {
        const Fs = Math.exp(-Ks * Ys * Cs);
        return Ks * Ys * Fs * (Math.sin(Xs * Cs) * (ko + Ks * Ys * Hs) / Xs + Hs * Math.cos(Xs * Cs)) - Fs * (Math.cos(Xs * Cs) * (ko + Ks * Ys * Hs) - Xs * Hs * Math.sin(Xs * Cs));
      };
    } else if (Ks === 1)
      So = (Xs) => qi - Math.exp(-Ys * Xs) * (Hs + (ko + Ys * Hs) * Xs);
    else {
      const Xs = Ys * Math.sqrt(Ks * Ks - 1);
      So = (Cs) => {
        const Fs = Math.exp(-Ks * Ys * Cs), ws = Math.min(Xs * Cs, 300);
        return qi - Fs * ((ko + Ks * Ys * Hs) * Math.sinh(ws) + Xs * Hs * Math.cosh(ws)) / Xs;
      };
    }
  }
  return rs(), {
    next: (ko) => {
      const Hs = So(ko);
      if (Eo)
        ra.done = ko >= to;
      else {
        const Ks = eo(ko) * 1e3, Ys = Math.abs(Ks) <= Xi, Xs = Math.abs(qi - Hs) <= Qi;
        ra.done = Ys && Xs;
      }
      return ra.value = ra.done ? qi : Hs, ra;
    },
    flipTarget: () => {
      Va = -Va, [e, qi] = [qi, e], rs();
    }
  };
}
spring.needsInterpolation = (Bi, e) => typeof Bi == "string" || typeof e == "string";
const zero = (Bi) => 0, progress = (Bi, e, qi) => {
  const Xi = e - Bi;
  return Xi === 0 ? 1 : (qi - Bi) / Xi;
}, mix = (Bi, e, qi) => -qi * Bi + qi * e + Bi;
function hueToRgb(Bi, e, qi) {
  return qi < 0 && (qi += 1), qi > 1 && (qi -= 1), qi < 1 / 6 ? Bi + (e - Bi) * 6 * qi : qi < 1 / 2 ? e : qi < 2 / 3 ? Bi + (e - Bi) * (2 / 3 - qi) * 6 : Bi;
}
function hslaToRgba({ hue: Bi, saturation: e, lightness: qi, alpha: Xi }) {
  Bi /= 360, e /= 100, qi /= 100;
  let Qi = 0, ta = 0, ra = 0;
  if (!e)
    Qi = ta = ra = qi;
  else {
    const na = qi < 0.5 ? qi * (1 + e) : qi + e - qi * e, la = 2 * qi - na;
    Qi = hueToRgb(la, na, Bi + 1 / 3), ta = hueToRgb(la, na, Bi), ra = hueToRgb(la, na, Bi - 1 / 3);
  }
  return {
    red: Math.round(Qi * 255),
    green: Math.round(ta * 255),
    blue: Math.round(ra * 255),
    alpha: Xi
  };
}
const mixLinearColor = (Bi, e, qi) => {
  const Xi = Bi * Bi, Qi = e * e;
  return Math.sqrt(Math.max(0, qi * (Qi - Xi) + Xi));
}, colorTypes = [hex, rgba, hsla], getColorType = (Bi) => colorTypes.find((e) => e.test(Bi)), notAnimatable = (Bi) => `'${Bi}' is not an animatable color. Use the equivalent color code instead.`, mixColor = (Bi, e) => {
  let qi = getColorType(Bi), Xi = getColorType(e);
  invariant$1(!!qi, notAnimatable(Bi)), invariant$1(!!Xi, notAnimatable(e));
  let Qi = qi.parse(Bi), ta = Xi.parse(e);
  qi === hsla && (Qi = hslaToRgba(Qi), qi = rgba), Xi === hsla && (ta = hslaToRgba(ta), Xi = rgba);
  const ra = Object.assign({}, Qi);
  return (na) => {
    for (const la in ra)
      la !== "alpha" && (ra[la] = mixLinearColor(Qi[la], ta[la], na));
    return ra.alpha = mix(Qi.alpha, ta.alpha, na), qi.transform(ra);
  };
}, isNum = (Bi) => typeof Bi == "number", combineFunctions = (Bi, e) => (qi) => e(Bi(qi)), pipe = (...Bi) => Bi.reduce(combineFunctions);
function getMixer(Bi, e) {
  return isNum(Bi) ? (qi) => mix(Bi, e, qi) : color.test(Bi) ? mixColor(Bi, e) : mixComplex(Bi, e);
}
const mixArray = (Bi, e) => {
  const qi = [...Bi], Xi = qi.length, Qi = Bi.map((ta, ra) => getMixer(ta, e[ra]));
  return (ta) => {
    for (let ra = 0; ra < Xi; ra++)
      qi[ra] = Qi[ra](ta);
    return qi;
  };
}, mixObject = (Bi, e) => {
  const qi = Object.assign(Object.assign({}, Bi), e), Xi = {};
  for (const Qi in qi)
    Bi[Qi] !== void 0 && e[Qi] !== void 0 && (Xi[Qi] = getMixer(Bi[Qi], e[Qi]));
  return (Qi) => {
    for (const ta in Xi)
      qi[ta] = Xi[ta](Qi);
    return qi;
  };
};
function analyse(Bi) {
  const e = complex.parse(Bi), qi = e.length;
  let Xi = 0, Qi = 0, ta = 0;
  for (let ra = 0; ra < qi; ra++)
    Xi || typeof e[ra] == "number" ? Xi++ : e[ra].hue !== void 0 ? ta++ : Qi++;
  return { parsed: e, numNumbers: Xi, numRGB: Qi, numHSL: ta };
}
const mixComplex = (Bi, e) => {
  const qi = complex.createTransformer(e), Xi = analyse(Bi), Qi = analyse(e);
  return Xi.numHSL === Qi.numHSL && Xi.numRGB === Qi.numRGB && Xi.numNumbers >= Qi.numNumbers ? pipe(mixArray(Xi.parsed, Qi.parsed), qi) : (warning$1(!0, `Complex values '${Bi}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (ra) => `${ra > 0 ? e : Bi}`);
}, mixNumber = (Bi, e) => (qi) => mix(Bi, e, qi);
function detectMixerFactory(Bi) {
  if (typeof Bi == "number")
    return mixNumber;
  if (typeof Bi == "string")
    return color.test(Bi) ? mixColor : mixComplex;
  if (Array.isArray(Bi))
    return mixArray;
  if (typeof Bi == "object")
    return mixObject;
}
function createMixers(Bi, e, qi) {
  const Xi = [], Qi = qi || detectMixerFactory(Bi[0]), ta = Bi.length - 1;
  for (let ra = 0; ra < ta; ra++) {
    let na = Qi(Bi[ra], Bi[ra + 1]);
    if (e) {
      const la = Array.isArray(e) ? e[ra] : e;
      na = pipe(la, na);
    }
    Xi.push(na);
  }
  return Xi;
}
function fastInterpolate([Bi, e], [qi]) {
  return (Xi) => qi(progress(Bi, e, Xi));
}
function slowInterpolate(Bi, e) {
  const qi = Bi.length, Xi = qi - 1;
  return (Qi) => {
    let ta = 0, ra = !1;
    if (Qi <= Bi[0] ? ra = !0 : Qi >= Bi[Xi] && (ta = Xi - 1, ra = !0), !ra) {
      let la = 1;
      for (; la < qi && !(Bi[la] > Qi || la === Xi); la++)
        ;
      ta = la - 1;
    }
    const na = progress(Bi[ta], Bi[ta + 1], Qi);
    return e[ta](na);
  };
}
function interpolate(Bi, e, { clamp: qi = !0, ease: Xi, mixer: Qi } = {}) {
  const ta = Bi.length;
  invariant$1(ta === e.length, "Both input and output ranges must be the same length"), invariant$1(!Xi || !Array.isArray(Xi) || Xi.length === ta - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), Bi[0] > Bi[ta - 1] && (Bi = [].concat(Bi), e = [].concat(e), Bi.reverse(), e.reverse());
  const ra = createMixers(e, Xi, Qi), na = ta === 2 ? fastInterpolate(Bi, ra) : slowInterpolate(Bi, ra);
  return qi ? (la) => na(clamp(Bi[0], Bi[ta - 1], la)) : na;
}
const reverseEasing = (Bi) => (e) => 1 - Bi(1 - e), mirrorEasing = (Bi) => (e) => e <= 0.5 ? Bi(2 * e) / 2 : (2 - Bi(2 * (1 - e))) / 2, createExpoIn = (Bi) => (e) => Math.pow(e, Bi), createBackIn = (Bi) => (e) => e * e * ((Bi + 1) * e - Bi), createAnticipate = (Bi) => {
  const e = createBackIn(Bi);
  return (qi) => (qi *= 2) < 1 ? 0.5 * e(qi) : 0.5 * (2 - Math.pow(2, -10 * (qi - 1)));
}, DEFAULT_OVERSHOOT_STRENGTH = 1.525, BOUNCE_FIRST_THRESHOLD = 4 / 11, BOUNCE_SECOND_THRESHOLD = 8 / 11, BOUNCE_THIRD_THRESHOLD = 9 / 10, linear = (Bi) => Bi, easeIn = createExpoIn(2), easeOut = reverseEasing(easeIn), easeInOut = mirrorEasing(easeIn), circIn = (Bi) => 1 - Math.sin(Math.acos(Bi)), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circOut), backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH), backOut = reverseEasing(backIn), backInOut = mirrorEasing(backIn), anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH), ca$1 = 4356 / 361, cb = 35442 / 1805, cc$1 = 16061 / 1805, bounceOut = (Bi) => {
  if (Bi === 1 || Bi === 0)
    return Bi;
  const e = Bi * Bi;
  return Bi < BOUNCE_FIRST_THRESHOLD ? 7.5625 * e : Bi < BOUNCE_SECOND_THRESHOLD ? 9.075 * e - 9.9 * Bi + 3.4 : Bi < BOUNCE_THIRD_THRESHOLD ? ca$1 * e - cb * Bi + cc$1 : 10.8 * Bi * Bi - 20.52 * Bi + 10.72;
}, bounceIn = reverseEasing(bounceOut), bounceInOut = (Bi) => Bi < 0.5 ? 0.5 * (1 - bounceOut(1 - Bi * 2)) : 0.5 * bounceOut(Bi * 2 - 1) + 0.5;
function defaultEasing(Bi, e) {
  return Bi.map(() => e || easeInOut).splice(0, Bi.length - 1);
}
function defaultOffset(Bi) {
  const e = Bi.length;
  return Bi.map((qi, Xi) => Xi !== 0 ? Xi / (e - 1) : 0);
}
function convertOffsetToTimes(Bi, e) {
  return Bi.map((qi) => qi * e);
}
function keyframes$1({ from: Bi = 0, to: e = 1, ease: qi, offset: Xi, duration: Qi = 300 }) {
  const ta = { done: !1, value: Bi }, ra = Array.isArray(e) ? e : [Bi, e], na = convertOffsetToTimes(Xi && Xi.length === ra.length ? Xi : defaultOffset(ra), Qi);
  function la() {
    return interpolate(na, ra, {
      ease: Array.isArray(qi) ? qi : defaultEasing(ra, qi)
    });
  }
  let Ma = la();
  return {
    next: (Va) => (ta.value = Ma(Va), ta.done = Va >= Qi, ta),
    flipTarget: () => {
      ra.reverse(), Ma = la();
    }
  };
}
function decay({ velocity: Bi = 0, from: e = 0, power: qi = 0.8, timeConstant: Xi = 350, restDelta: Qi = 0.5, modifyTarget: ta }) {
  const ra = { done: !1, value: e };
  let na = qi * Bi;
  const la = e + na, Ma = ta === void 0 ? la : ta(la);
  return Ma !== la && (na = Ma - e), {
    next: (Va) => {
      const to = -na * Math.exp(-Va / Xi);
      return ra.done = !(to > Qi || to < -Qi), ra.value = ra.done ? Ma : Ma + to, ra;
    },
    flipTarget: () => {
    }
  };
}
const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(Bi) {
  if (Array.isArray(Bi.to))
    return keyframes$1;
  if (types[Bi.type])
    return types[Bi.type];
  const e = new Set(Object.keys(Bi));
  return e.has("ease") || e.has("duration") && !e.has("dampingRatio") ? keyframes$1 : e.has("dampingRatio") || e.has("stiffness") || e.has("mass") || e.has("damping") || e.has("restSpeed") || e.has("restDelta") ? spring : keyframes$1;
}
const defaultTimestep = 1 / 60 * 1e3, getCurrentTime = typeof performance < "u" ? () => performance.now() : () => Date.now(), onNextFrame = typeof window < "u" ? (Bi) => window.requestAnimationFrame(Bi) : (Bi) => setTimeout(() => Bi(getCurrentTime()), defaultTimestep);
function createRenderStep(Bi) {
  let e = [], qi = [], Xi = 0, Qi = !1, ta = !1;
  const ra = /* @__PURE__ */ new WeakSet(), na = {
    schedule: (la, Ma = !1, Va = !1) => {
      const to = Va && Qi, Eo = to ? e : qi;
      return Ma && ra.add(la), Eo.indexOf(la) === -1 && (Eo.push(la), to && Qi && (Xi = e.length)), la;
    },
    cancel: (la) => {
      const Ma = qi.indexOf(la);
      Ma !== -1 && qi.splice(Ma, 1), ra.delete(la);
    },
    process: (la) => {
      if (Qi) {
        ta = !0;
        return;
      }
      if (Qi = !0, [e, qi] = [qi, e], qi.length = 0, Xi = e.length, Xi)
        for (let Ma = 0; Ma < Xi; Ma++) {
          const Va = e[Ma];
          Va(la), ra.has(Va) && (na.schedule(Va), Bi());
        }
      Qi = !1, ta && (ta = !1, na.process(la));
    }
  };
  return na;
}
const maxElapsed = 40;
let useDefaultElapsed = !0, runNextFrame = !1, isProcessing = !1;
const frame = {
  delta: 0,
  timestamp: 0
}, stepsOrder = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], steps = stepsOrder.reduce((Bi, e) => (Bi[e] = createRenderStep(() => runNextFrame = !0), Bi), {}), sync = stepsOrder.reduce((Bi, e) => {
  const qi = steps[e];
  return Bi[e] = (Xi, Qi = !1, ta = !1) => (runNextFrame || startLoop(), qi.schedule(Xi, Qi, ta)), Bi;
}, {}), cancelSync = stepsOrder.reduce((Bi, e) => (Bi[e] = steps[e].cancel, Bi), {}), flushSync = stepsOrder.reduce((Bi, e) => (Bi[e] = () => steps[e].process(frame), Bi), {}), processStep = (Bi) => steps[Bi].process(frame), processFrame = (Bi) => {
  runNextFrame = !1, frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(Bi - frame.timestamp, maxElapsed), 1), frame.timestamp = Bi, isProcessing = !0, stepsOrder.forEach(processStep), isProcessing = !1, runNextFrame && (useDefaultElapsed = !1, onNextFrame(processFrame));
}, startLoop = () => {
  runNextFrame = !0, useDefaultElapsed = !0, isProcessing || onNextFrame(processFrame);
}, getFrameData = () => frame;
function loopElapsed(Bi, e, qi = 0) {
  return Bi - e - qi;
}
function reverseElapsed(Bi, e, qi = 0, Xi = !0) {
  return Xi ? loopElapsed(e + -Bi, e, qi) : e - (Bi - e) + qi;
}
function hasRepeatDelayElapsed(Bi, e, qi, Xi) {
  return Xi ? Bi >= e + qi : Bi <= -qi;
}
const framesync = (Bi) => {
  const e = ({ delta: qi }) => Bi(qi);
  return {
    start: () => sync.update(e, !0),
    stop: () => cancelSync.update(e)
  };
};
function animate$1(Bi) {
  var e, qi, { from: Xi, autoplay: Qi = !0, driver: ta = framesync, elapsed: ra = 0, repeat: na = 0, repeatType: la = "loop", repeatDelay: Ma = 0, onPlay: Va, onStop: to, onComplete: Eo, onRepeat: So, onUpdate: eo } = Bi, rs = __rest(Bi, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: ko } = rs, Hs, Ks = 0, Ys = rs.duration, Xs, Cs = !1, Fs = !0, ws;
  const ls = detectAnimationFromOptions(rs);
  !((qi = (e = ls).needsInterpolation) === null || qi === void 0) && qi.call(e, Xi, ko) && (ws = interpolate([0, 100], [Xi, ko], {
    clamp: !1
  }), Xi = 0, ko = 100);
  const ks = ls(Object.assign(Object.assign({}, rs), { from: Xi, to: ko }));
  function Js() {
    Ks++, la === "reverse" ? (Fs = Ks % 2 === 0, ra = reverseElapsed(ra, Ys, Ma, Fs)) : (ra = loopElapsed(ra, Ys, Ma), la === "mirror" && ks.flipTarget()), Cs = !1, So && So();
  }
  function pl() {
    Hs.stop(), Eo && Eo();
  }
  function _l(xl) {
    if (Fs || (xl = -xl), ra += xl, !Cs) {
      const Rl = ks.next(Math.max(0, ra));
      Xs = Rl.value, ws && (Xs = ws(Xs)), Cs = Fs ? Rl.done : ra <= 0;
    }
    eo?.(Xs), Cs && (Ks === 0 && (Ys ?? (Ys = ra)), Ks < na ? hasRepeatDelayElapsed(ra, Ys, Ma, Fs) && Js() : pl());
  }
  function bl() {
    Va?.(), Hs = ta(_l), Hs.start();
  }
  return Qi && bl(), {
    stop: () => {
      to?.(), Hs.stop();
    }
  };
}
function velocityPerSecond(Bi, e) {
  return e ? Bi * (1e3 / e) : 0;
}
function inertia({ from: Bi = 0, velocity: e = 0, min: qi, max: Xi, power: Qi = 0.8, timeConstant: ta = 750, bounceStiffness: ra = 500, bounceDamping: na = 10, restDelta: la = 1, modifyTarget: Ma, driver: Va, onUpdate: to, onComplete: Eo, onStop: So }) {
  let eo;
  function rs(Ys) {
    return qi !== void 0 && Ys < qi || Xi !== void 0 && Ys > Xi;
  }
  function ko(Ys) {
    return qi === void 0 ? Xi : Xi === void 0 || Math.abs(qi - Ys) < Math.abs(Xi - Ys) ? qi : Xi;
  }
  function Hs(Ys) {
    eo?.stop(), eo = animate$1(Object.assign(Object.assign({}, Ys), {
      driver: Va,
      onUpdate: (Xs) => {
        var Cs;
        to?.(Xs), (Cs = Ys.onUpdate) === null || Cs === void 0 || Cs.call(Ys, Xs);
      },
      onComplete: Eo,
      onStop: So
    }));
  }
  function Ks(Ys) {
    Hs(Object.assign({ type: "spring", stiffness: ra, damping: na, restDelta: la }, Ys));
  }
  if (rs(Bi))
    Ks({ from: Bi, velocity: e, to: ko(Bi) });
  else {
    let Ys = Qi * e + Bi;
    typeof Ma < "u" && (Ys = Ma(Ys));
    const Xs = ko(Ys), Cs = Xs === qi ? -1 : 1;
    let Fs, ws;
    const ls = (ks) => {
      Fs = ws, ws = ks, e = velocityPerSecond(ks - Fs, getFrameData().delta), (Cs === 1 && ks > Xs || Cs === -1 && ks < Xs) && Ks({ from: ks, to: Xs, velocity: e });
    };
    Hs({
      type: "decay",
      from: Bi,
      velocity: e,
      timeConstant: ta,
      power: Qi,
      restDelta: la,
      modifyTarget: Ma,
      onUpdate: rs(Ys) ? ls : void 0
    });
  }
  return {
    stop: () => eo?.stop()
  };
}
const isPoint = (Bi) => Bi.hasOwnProperty("x") && Bi.hasOwnProperty("y"), isPoint3D = (Bi) => isPoint(Bi) && Bi.hasOwnProperty("z"), distance1D = (Bi, e) => Math.abs(Bi - e);
function distance(Bi, e) {
  if (isNum(Bi) && isNum(e))
    return distance1D(Bi, e);
  if (isPoint(Bi) && isPoint(e)) {
    const qi = distance1D(Bi.x, e.x), Xi = distance1D(Bi.y, e.y), Qi = isPoint3D(Bi) && isPoint3D(e) ? distance1D(Bi.z, e.z) : 0;
    return Math.sqrt(Math.pow(qi, 2) + Math.pow(Xi, 2) + Math.pow(Qi, 2));
  }
}
const a$7 = (Bi, e) => 1 - 3 * e + 3 * Bi, b$3 = (Bi, e) => 3 * e - 6 * Bi, c$6 = (Bi) => 3 * Bi, calcBezier = (Bi, e, qi) => ((a$7(e, qi) * Bi + b$3(e, qi)) * Bi + c$6(e)) * Bi, getSlope = (Bi, e, qi) => 3 * a$7(e, qi) * Bi * Bi + 2 * b$3(e, qi) * Bi + c$6(e), subdivisionPrecision = 1e-7, subdivisionMaxIterations = 10;
function binarySubdivide(Bi, e, qi, Xi, Qi) {
  let ta, ra, na = 0;
  do
    ra = e + (qi - e) / 2, ta = calcBezier(ra, Xi, Qi) - Bi, ta > 0 ? qi = ra : e = ra;
  while (Math.abs(ta) > subdivisionPrecision && ++na < subdivisionMaxIterations);
  return ra;
}
const newtonIterations = 8, newtonMinSlope = 1e-3;
function newtonRaphsonIterate(Bi, e, qi, Xi) {
  for (let Qi = 0; Qi < newtonIterations; ++Qi) {
    const ta = getSlope(e, qi, Xi);
    if (ta === 0)
      return e;
    const ra = calcBezier(e, qi, Xi) - Bi;
    e -= ra / ta;
  }
  return e;
}
const kSplineTableSize = 11, kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier(Bi, e, qi, Xi) {
  if (Bi === e && qi === Xi)
    return linear;
  const Qi = new Float32Array(kSplineTableSize);
  for (let ra = 0; ra < kSplineTableSize; ++ra)
    Qi[ra] = calcBezier(ra * kSampleStepSize, Bi, qi);
  function ta(ra) {
    let na = 0, la = 1;
    const Ma = kSplineTableSize - 1;
    for (; la !== Ma && Qi[la] <= ra; ++la)
      na += kSampleStepSize;
    --la;
    const Va = (ra - Qi[la]) / (Qi[la + 1] - Qi[la]), to = na + Va * kSampleStepSize, Eo = getSlope(to, Bi, qi);
    return Eo >= newtonMinSlope ? newtonRaphsonIterate(ra, to, Bi, qi) : Eo === 0 ? to : binarySubdivide(ra, na, na + kSampleStepSize, Bi, qi);
  }
  return (ra) => ra === 0 || ra === 1 ? ra : calcBezier(ta(ra), e, Xi);
}
function useTapGesture(Bi) {
  var e = Bi.onTap, qi = Bi.onTapStart, Xi = Bi.onTapCancel, Qi = Bi.whileTap, ta = Bi.visualElement, ra = e || qi || Xi || Qi, na = useRef(!1), la = useRef(null), Ma = {
    passive: !(qi || e || Xi || eo)
  };
  function Va() {
    var rs;
    (rs = la.current) === null || rs === void 0 || rs.call(la), la.current = null;
  }
  function to() {
    var rs;
    return Va(), na.current = !1, (rs = ta.animationState) === null || rs === void 0 || rs.setActive(AnimationType.Tap, !1), !isDragActive();
  }
  function Eo(rs, ko) {
    to() && (isNodeOrChild(ta.getInstance(), rs.target) ? e?.(rs, ko) : Xi?.(rs, ko));
  }
  function So(rs, ko) {
    to() && Xi?.(rs, ko);
  }
  function eo(rs, ko) {
    var Hs;
    Va(), !na.current && (na.current = !0, la.current = pipe(addPointerEvent(window, "pointerup", Eo, Ma), addPointerEvent(window, "pointercancel", So, Ma)), (Hs = ta.animationState) === null || Hs === void 0 || Hs.setActive(AnimationType.Tap, !0), qi?.(rs, ko));
  }
  usePointerEvent(ta, "pointerdown", ra ? eo : void 0, Ma), useUnmountEffect(Va);
}
var warned = /* @__PURE__ */ new Set();
function warnOnce(Bi, e, qi) {
  Bi || warned.has(e) || (console.warn(e), warned.add(e));
}
var observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = function(Bi) {
  var e;
  (e = observerCallbacks.get(Bi.target)) === null || e === void 0 || e(Bi);
}, fireAllObserverCallbacks = function(Bi) {
  Bi.forEach(fireObserverCallback);
};
function initIntersectionObserver(Bi) {
  var e = Bi.root, qi = __rest$1(Bi, ["root"]), Xi = e || document;
  observers.has(Xi) || observers.set(Xi, {});
  var Qi = observers.get(Xi), ta = JSON.stringify(qi);
  return Qi[ta] || (Qi[ta] = new IntersectionObserver(fireAllObserverCallbacks, __assign({ root: e }, qi))), Qi[ta];
}
function observeIntersection(Bi, e, qi) {
  var Xi = initIntersectionObserver(e);
  return observerCallbacks.set(Bi, qi), Xi.observe(Bi), function() {
    observerCallbacks.delete(Bi), Xi.unobserve(Bi);
  };
}
function useViewport(Bi) {
  var e = Bi.visualElement, qi = Bi.whileInView, Xi = Bi.onViewportEnter, Qi = Bi.onViewportLeave, ta = Bi.viewport, ra = ta === void 0 ? {} : ta, na = useRef({
    hasEnteredView: !1,
    isInView: !1
  }), la = !!(qi || Xi || Qi);
  ra.once && na.current.hasEnteredView && (la = !1);
  var Ma = typeof IntersectionObserver > "u" ? useMissingIntersectionObserver : useIntersectionObserver;
  Ma(la, na.current, e, ra);
}
var thresholdNames = {
  some: 0,
  all: 1
};
function useIntersectionObserver(Bi, e, qi, Xi) {
  var Qi = Xi.root, ta = Xi.margin, ra = Xi.amount, na = ra === void 0 ? "some" : ra, la = Xi.once;
  useEffect(function() {
    if (Bi) {
      var Ma = {
        root: Qi?.current,
        rootMargin: ta,
        threshold: typeof na == "number" ? na : thresholdNames[na]
      }, Va = function(to) {
        var Eo, So = to.isIntersecting;
        if (e.isInView !== So && (e.isInView = So, !(la && !So && e.hasEnteredView))) {
          So && (e.hasEnteredView = !0), (Eo = qi.animationState) === null || Eo === void 0 || Eo.setActive(AnimationType.InView, So);
          var eo = qi.getProps(), rs = So ? eo.onViewportEnter : eo.onViewportLeave;
          rs?.(to);
        }
      };
      return observeIntersection(qi.getInstance(), Ma, Va);
    }
  }, [Bi, Qi, ta, na]);
}
function useMissingIntersectionObserver(Bi, e, qi, Xi) {
  var Qi = Xi.fallback, ta = Qi === void 0 ? !0 : Qi;
  useEffect(function() {
    !Bi || !ta || (env !== "production" && warnOnce(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var ra;
      e.hasEnteredView = !0;
      var na = qi.getProps().onViewportEnter;
      na?.(null), (ra = qi.animationState) === null || ra === void 0 || ra.setActive(AnimationType.InView, !0);
    }));
  }, [Bi]);
}
var makeRenderlessComponent = function(Bi) {
  return function(e) {
    return Bi(e), null;
  };
}, gestureAnimations = {
  inView: makeRenderlessComponent(useViewport),
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
}, counter = 0, incrementId = function() {
  return counter++;
}, useId = function() {
  return useConstant(incrementId);
};
function usePresence() {
  var Bi = useContext(PresenceContext);
  if (Bi === null)
    return [!0, null];
  var e = Bi.isPresent, qi = Bi.onExitComplete, Xi = Bi.register, Qi = useId();
  useEffect(function() {
    return Xi(Qi);
  }, []);
  var ta = function() {
    return qi?.(Qi);
  };
  return !e && qi ? [!1, ta] : [!0];
}
function shallowCompare(Bi, e) {
  if (!Array.isArray(e))
    return !1;
  var qi = e.length;
  if (qi !== Bi.length)
    return !1;
  for (var Xi = 0; Xi < qi; Xi++)
    if (e[Xi] !== Bi[Xi])
      return !1;
  return !0;
}
var secondsToMilliseconds = function(Bi) {
  return Bi * 1e3;
}, easingLookup = {
  linear,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
}, easingDefinitionToFunction = function(Bi) {
  if (Array.isArray(Bi)) {
    invariant$1(Bi.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var e = __read(Bi, 4), qi = e[0], Xi = e[1], Qi = e[2], ta = e[3];
    return cubicBezier(qi, Xi, Qi, ta);
  } else if (typeof Bi == "string")
    return invariant$1(easingLookup[Bi] !== void 0, "Invalid easing type '".concat(Bi, "'")), easingLookup[Bi];
  return Bi;
}, isEasingArray = function(Bi) {
  return Array.isArray(Bi) && typeof Bi[0] != "number";
}, isAnimatable = function(Bi, e) {
  return Bi === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
  complex.test(e) && // And it contains numbers and/or colors
  !e.startsWith("url("));
}, underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, criticallyDampedSpring = function(Bi) {
  return {
    type: "spring",
    stiffness: 550,
    damping: Bi === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, keyframes = function(Bi) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: Bi
  };
}, defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
}, getDefaultTransition = function(Bi, e) {
  var qi;
  return isKeyframesTarget(e) ? qi = keyframes : qi = defaultTransitions[Bi] || defaultTransitions.default, __assign({ to: e }, qi(e));
}, defaultValueTypes = __assign(__assign({}, numberValueTypes), {
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
}), getDefaultValueType = function(Bi) {
  return defaultValueTypes[Bi];
};
function getAnimatableNone(Bi, e) {
  var qi, Xi = getDefaultValueType(Bi);
  return Xi !== filter && (Xi = complex), (qi = Xi.getAnimatableNone) === null || qi === void 0 ? void 0 : qi.call(Xi, e);
}
function isTransitionDefined(Bi) {
  Bi.when, Bi.delay, Bi.delayChildren, Bi.staggerChildren, Bi.staggerDirection, Bi.repeat, Bi.repeatType, Bi.repeatDelay, Bi.from;
  var e = __rest$1(Bi, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(e).length;
}
var legacyRepeatWarning = !1;
function convertTransitionToAnimationOptions(Bi) {
  var e = Bi.ease, qi = Bi.times, Xi = Bi.yoyo, Qi = Bi.flip, ta = Bi.loop, ra = __rest$1(Bi, ["ease", "times", "yoyo", "flip", "loop"]), na = __assign({}, ra);
  return qi && (na.offset = qi), ra.duration && (na.duration = secondsToMilliseconds(ra.duration)), ra.repeatDelay && (na.repeatDelay = secondsToMilliseconds(ra.repeatDelay)), e && (na.ease = isEasingArray(e) ? e.map(easingDefinitionToFunction) : easingDefinitionToFunction(e)), ra.type === "tween" && (na.type = "keyframes"), (Xi || ta || Qi) && (warning$1(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), legacyRepeatWarning = !0, Xi ? na.repeatType = "reverse" : ta ? na.repeatType = "loop" : Qi && (na.repeatType = "mirror"), na.repeat = ta || Xi || Qi || ra.repeat), ra.type !== "spring" && (na.type = "keyframes"), na;
}
function getDelayFromTransition(Bi, e) {
  var qi, Xi, Qi = getValueTransition(Bi, e) || {};
  return (Xi = (qi = Qi.delay) !== null && qi !== void 0 ? qi : Bi.delay) !== null && Xi !== void 0 ? Xi : 0;
}
function hydrateKeyframes(Bi) {
  return Array.isArray(Bi.to) && Bi.to[0] === null && (Bi.to = __spreadArray([], __read(Bi.to), !1), Bi.to[0] = Bi.from), Bi;
}
function getPopmotionAnimationOptions(Bi, e, qi) {
  var Xi;
  return Array.isArray(e.to) && ((Xi = Bi.duration) !== null && Xi !== void 0 || (Bi.duration = 0.8)), hydrateKeyframes(e), isTransitionDefined(Bi) || (Bi = __assign(__assign({}, Bi), getDefaultTransition(qi, e.to))), __assign(__assign({}, e), convertTransitionToAnimationOptions(Bi));
}
function getAnimation(Bi, e, qi, Xi, Qi) {
  var ta, ra = getValueTransition(Xi, Bi), na = (ta = ra.from) !== null && ta !== void 0 ? ta : e.get(), la = isAnimatable(Bi, qi);
  na === "none" && la && typeof qi == "string" ? na = getAnimatableNone(Bi, qi) : isZero(na) && typeof qi == "string" ? na = getZeroUnit(qi) : !Array.isArray(qi) && isZero(qi) && typeof na == "string" && (qi = getZeroUnit(na));
  var Ma = isAnimatable(Bi, na);
  warning$1(Ma === la, "You are trying to animate ".concat(Bi, ' from "').concat(na, '" to "').concat(qi, '". ').concat(na, " is not an animatable value - to enable this animation set ").concat(na, " to a value animatable to ").concat(qi, " via the `style` property."));
  function Va() {
    var Eo = {
      from: na,
      to: qi,
      velocity: e.getVelocity(),
      onComplete: Qi,
      onUpdate: function(So) {
        return e.set(So);
      }
    };
    return ra.type === "inertia" || ra.type === "decay" ? inertia(__assign(__assign({}, Eo), ra)) : animate$1(__assign(__assign({}, getPopmotionAnimationOptions(ra, Eo, Bi)), { onUpdate: function(So) {
      var eo;
      Eo.onUpdate(So), (eo = ra.onUpdate) === null || eo === void 0 || eo.call(ra, So);
    }, onComplete: function() {
      var So;
      Eo.onComplete(), (So = ra.onComplete) === null || So === void 0 || So.call(ra);
    } }));
  }
  function to() {
    var Eo, So, eo = resolveFinalValueInKeyframes(qi);
    return e.set(eo), Qi(), (Eo = ra?.onUpdate) === null || Eo === void 0 || Eo.call(ra, eo), (So = ra?.onComplete) === null || So === void 0 || So.call(ra), { stop: function() {
    } };
  }
  return !Ma || !la || ra.type === !1 ? to : Va;
}
function isZero(Bi) {
  return Bi === 0 || typeof Bi == "string" && parseFloat(Bi) === 0 && Bi.indexOf(" ") === -1;
}
function getZeroUnit(Bi) {
  return typeof Bi == "number" ? 0 : getAnimatableNone("", Bi);
}
function getValueTransition(Bi, e) {
  return Bi[e] || Bi.default || Bi;
}
function startAnimation(Bi, e, qi, Xi) {
  return Xi === void 0 && (Xi = {}), e.start(function(Qi) {
    var ta, ra, na = getAnimation(Bi, e, qi, Xi, Qi), la = getDelayFromTransition(Xi, Bi), Ma = function() {
      return ra = na();
    };
    return la ? ta = window.setTimeout(Ma, secondsToMilliseconds(la)) : Ma(), function() {
      clearTimeout(ta), ra?.stop();
    };
  });
}
var isNumericalString = function(Bi) {
  return /^\-?\d*\.?\d+$/.test(Bi);
}, isZeroValueString = function(Bi) {
  return /^0[^.\s]+$/.test(Bi);
};
function addUniqueItem(Bi, e) {
  Bi.indexOf(e) === -1 && Bi.push(e);
}
function removeItem(Bi, e) {
  var qi = Bi.indexOf(e);
  qi > -1 && Bi.splice(qi, 1);
}
var SubscriptionManager = (
  /** @class */
  function() {
    function Bi() {
      this.subscriptions = [];
    }
    return Bi.prototype.add = function(e) {
      var qi = this;
      return addUniqueItem(this.subscriptions, e), function() {
        return removeItem(qi.subscriptions, e);
      };
    }, Bi.prototype.notify = function(e, qi, Xi) {
      var Qi = this.subscriptions.length;
      if (Qi)
        if (Qi === 1)
          this.subscriptions[0](e, qi, Xi);
        else
          for (var ta = 0; ta < Qi; ta++) {
            var ra = this.subscriptions[ta];
            ra && ra(e, qi, Xi);
          }
    }, Bi.prototype.getSize = function() {
      return this.subscriptions.length;
    }, Bi.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, Bi;
  }()
), isFloat = function(Bi) {
  return !isNaN(parseFloat(Bi));
}, MotionValue = (
  /** @class */
  function() {
    function Bi(e) {
      var qi = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new SubscriptionManager(), this.velocityUpdateSubscribers = new SubscriptionManager(), this.renderSubscribers = new SubscriptionManager(), this.canTrackVelocity = !1, this.updateAndNotify = function(Xi, Qi) {
        Qi === void 0 && (Qi = !0), qi.prev = qi.current, qi.current = Xi;
        var ta = getFrameData(), ra = ta.delta, na = ta.timestamp;
        qi.lastUpdated !== na && (qi.timeDelta = ra, qi.lastUpdated = na, sync.postRender(qi.scheduleVelocityCheck)), qi.prev !== qi.current && qi.updateSubscribers.notify(qi.current), qi.velocityUpdateSubscribers.getSize() && qi.velocityUpdateSubscribers.notify(qi.getVelocity()), Qi && qi.renderSubscribers.notify(qi.current);
      }, this.scheduleVelocityCheck = function() {
        return sync.postRender(qi.velocityCheck);
      }, this.velocityCheck = function(Xi) {
        var Qi = Xi.timestamp;
        Qi !== qi.lastUpdated && (qi.prev = qi.current, qi.velocityUpdateSubscribers.notify(qi.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = isFloat(this.current);
    }
    return Bi.prototype.onChange = function(e) {
      return this.updateSubscribers.add(e);
    }, Bi.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, Bi.prototype.onRenderRequest = function(e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, Bi.prototype.attach = function(e) {
      this.passiveEffect = e;
    }, Bi.prototype.set = function(e, qi) {
      qi === void 0 && (qi = !0), !qi || !this.passiveEffect ? this.updateAndNotify(e, qi) : this.passiveEffect(e, this.updateAndNotify);
    }, Bi.prototype.get = function() {
      return this.current;
    }, Bi.prototype.getPrevious = function() {
      return this.prev;
    }, Bi.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, Bi.prototype.start = function(e) {
      var qi = this;
      return this.stop(), new Promise(function(Xi) {
        qi.hasAnimated = !0, qi.stopAnimation = e(Xi);
      }).then(function() {
        return qi.clearAnimation();
      });
    }, Bi.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, Bi.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, Bi.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, Bi.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, Bi;
  }()
);
function motionValue(Bi) {
  return new MotionValue(Bi);
}
var testValueType = function(Bi) {
  return function(e) {
    return e.test(Bi);
  };
}, auto = {
  test: function(Bi) {
    return Bi === "auto";
  },
  parse: function(Bi) {
    return Bi;
  }
}, dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto], findDimensionValueType = function(Bi) {
  return dimensionValueTypes.find(testValueType(Bi));
}, valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), !1), [color, complex], !1), findValueType = function(Bi) {
  return valueTypes.find(testValueType(Bi));
};
function setMotionValue(Bi, e, qi) {
  Bi.hasValue(e) ? Bi.getValue(e).set(qi) : Bi.addValue(e, motionValue(qi));
}
function setTarget(Bi, e) {
  var qi = resolveVariant(Bi, e), Xi = qi ? Bi.makeTargetAnimatable(qi, !1) : {}, Qi = Xi.transitionEnd, ta = Qi === void 0 ? {} : Qi;
  Xi.transition;
  var ra = __rest$1(Xi, ["transitionEnd", "transition"]);
  ra = __assign(__assign({}, ra), ta);
  for (var na in ra) {
    var la = resolveFinalValueInKeyframes(ra[na]);
    setMotionValue(Bi, na, la);
  }
}
function checkTargetForNewValues(Bi, e, qi) {
  var Xi, Qi, ta, ra, na = Object.keys(e).filter(function(So) {
    return !Bi.hasValue(So);
  }), la = na.length;
  if (la)
    for (var Ma = 0; Ma < la; Ma++) {
      var Va = na[Ma], to = e[Va], Eo = null;
      Array.isArray(to) && (Eo = to[0]), Eo === null && (Eo = (Qi = (Xi = qi[Va]) !== null && Xi !== void 0 ? Xi : Bi.readValue(Va)) !== null && Qi !== void 0 ? Qi : e[Va]), Eo != null && (typeof Eo == "string" && (isNumericalString(Eo) || isZeroValueString(Eo)) ? Eo = parseFloat(Eo) : !findValueType(Eo) && complex.test(to) && (Eo = getAnimatableNone(Va, to)), Bi.addValue(Va, motionValue(Eo)), (ta = (ra = qi)[Va]) !== null && ta !== void 0 || (ra[Va] = Eo), Bi.setBaseTarget(Va, Eo));
    }
}
function getOriginFromTransition(Bi, e) {
  if (e) {
    var qi = e[Bi] || e.default || e;
    return qi.from;
  }
}
function getOrigin(Bi, e, qi) {
  var Xi, Qi, ta = {};
  for (var ra in Bi)
    ta[ra] = (Xi = getOriginFromTransition(ra, e)) !== null && Xi !== void 0 ? Xi : (Qi = qi.getValue(ra)) === null || Qi === void 0 ? void 0 : Qi.get();
  return ta;
}
function animateVisualElement(Bi, e, qi) {
  qi === void 0 && (qi = {}), Bi.notifyAnimationStart(e);
  var Xi;
  if (Array.isArray(e)) {
    var Qi = e.map(function(ra) {
      return animateVariant(Bi, ra, qi);
    });
    Xi = Promise.all(Qi);
  } else if (typeof e == "string")
    Xi = animateVariant(Bi, e, qi);
  else {
    var ta = typeof e == "function" ? resolveVariant(Bi, e, qi.custom) : e;
    Xi = animateTarget(Bi, ta, qi);
  }
  return Xi.then(function() {
    return Bi.notifyAnimationComplete(e);
  });
}
function animateVariant(Bi, e, qi) {
  var Xi;
  qi === void 0 && (qi = {});
  var Qi = resolveVariant(Bi, e, qi.custom), ta = (Qi || {}).transition, ra = ta === void 0 ? Bi.getDefaultTransition() || {} : ta;
  qi.transitionOverride && (ra = qi.transitionOverride);
  var na = Qi ? function() {
    return animateTarget(Bi, Qi, qi);
  } : function() {
    return Promise.resolve();
  }, la = !((Xi = Bi.variantChildren) === null || Xi === void 0) && Xi.size ? function(So) {
    So === void 0 && (So = 0);
    var eo = ra.delayChildren, rs = eo === void 0 ? 0 : eo, ko = ra.staggerChildren, Hs = ra.staggerDirection;
    return animateChildren(Bi, e, rs + So, ko, Hs, qi);
  } : function() {
    return Promise.resolve();
  }, Ma = ra.when;
  if (Ma) {
    var Va = __read(Ma === "beforeChildren" ? [na, la] : [la, na], 2), to = Va[0], Eo = Va[1];
    return to().then(Eo);
  } else
    return Promise.all([na(), la(qi.delay)]);
}
function animateTarget(Bi, e, qi) {
  var Xi, Qi = qi === void 0 ? {} : qi, ta = Qi.delay, ra = ta === void 0 ? 0 : ta, na = Qi.transitionOverride, la = Qi.type, Ma = Bi.makeTargetAnimatable(e), Va = Ma.transition, to = Va === void 0 ? Bi.getDefaultTransition() : Va, Eo = Ma.transitionEnd, So = __rest$1(Ma, ["transition", "transitionEnd"]);
  na && (to = na);
  var eo = [], rs = la && ((Xi = Bi.animationState) === null || Xi === void 0 ? void 0 : Xi.getState()[la]);
  for (var ko in So) {
    var Hs = Bi.getValue(ko), Ks = So[ko];
    if (!(!Hs || Ks === void 0 || rs && shouldBlockAnimation(rs, ko))) {
      var Ys = __assign({ delay: ra }, to);
      Bi.shouldReduceMotion && isTransformProp(ko) && (Ys = __assign(__assign({}, Ys), { type: !1, delay: 0 }));
      var Xs = startAnimation(ko, Hs, Ks, Ys);
      eo.push(Xs);
    }
  }
  return Promise.all(eo).then(function() {
    Eo && setTarget(Bi, Eo);
  });
}
function animateChildren(Bi, e, qi, Xi, Qi, ta) {
  qi === void 0 && (qi = 0), Xi === void 0 && (Xi = 0), Qi === void 0 && (Qi = 1);
  var ra = [], na = (Bi.variantChildren.size - 1) * Xi, la = Qi === 1 ? function(Ma) {
    return Ma === void 0 && (Ma = 0), Ma * Xi;
  } : function(Ma) {
    return Ma === void 0 && (Ma = 0), na - Ma * Xi;
  };
  return Array.from(Bi.variantChildren).sort(sortByTreeOrder).forEach(function(Ma, Va) {
    ra.push(animateVariant(Ma, e, __assign(__assign({}, ta), { delay: qi + la(Va) })).then(function() {
      return Ma.notifyAnimationComplete(e);
    }));
  }), Promise.all(ra);
}
function sortByTreeOrder(Bi, e) {
  return Bi.sortNodePosition(e);
}
function shouldBlockAnimation(Bi, e) {
  var qi = Bi.protectedKeys, Xi = Bi.needsAnimating, Qi = qi.hasOwnProperty(e) && Xi[e] !== !0;
  return Xi[e] = !1, Qi;
}
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.InView,
  AnimationType.Focus,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Exit
], reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), !1).reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(Bi) {
  return function(e) {
    return Promise.all(e.map(function(qi) {
      var Xi = qi.animation, Qi = qi.options;
      return animateVisualElement(Bi, Xi, Qi);
    }));
  };
}
function createAnimationState(Bi) {
  var e = animateList(Bi), qi = createState(), Xi = {}, Qi = !0, ta = function(Va, to) {
    var Eo = resolveVariant(Bi, to);
    if (Eo) {
      Eo.transition;
      var So = Eo.transitionEnd, eo = __rest$1(Eo, ["transition", "transitionEnd"]);
      Va = __assign(__assign(__assign({}, Va), eo), So);
    }
    return Va;
  };
  function ra(Va) {
    return Xi[Va] !== void 0;
  }
  function na(Va) {
    e = Va(Bi);
  }
  function la(Va, to) {
    for (var Eo, So = Bi.getProps(), eo = Bi.getVariantContext(!0) || {}, rs = [], ko = /* @__PURE__ */ new Set(), Hs = {}, Ks = 1 / 0, Ys = function(ws) {
      var ls = reversePriorityOrder[ws], ks = qi[ls], Js = (Eo = So[ls]) !== null && Eo !== void 0 ? Eo : eo[ls], pl = isVariantLabel(Js), _l = ls === to ? ks.isActive : null;
      _l === !1 && (Ks = ws);
      var bl = Js === eo[ls] && Js !== So[ls] && pl;
      if (bl && Qi && Bi.manuallyAnimateOnMount && (bl = !1), ks.protectedKeys = __assign({}, Hs), // If it isn't active and hasn't *just* been set as inactive
      !ks.isActive && _l === null || // If we didn't and don't have any defined prop for this animation type
      !Js && !ks.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(Js) || typeof Js == "boolean")
        return "continue";
      var xl = checkVariantsDidChange(ks.prevProp, Js), Rl = xl || // If we're making this variant active, we want to always make it active
      ls === to && ks.isActive && !bl && pl || // If we removed a higher-priority variant (i is in reverse order)
      ws > Ks && pl, Cl = Array.isArray(Js) ? Js : [Js], Dl = Cl.reduce(ta, {});
      _l === !1 && (Dl = {});
      var kl = ks.prevResolvedValues, Ul = kl === void 0 ? {} : kl, Bl = __assign(__assign({}, Ul), Dl), Zl = function(Tl) {
        Rl = !0, ko.delete(Tl), ks.needsAnimating[Tl] = !0;
      };
      for (var Pl in Bl) {
        var yl = Dl[Pl], hl = Ul[Pl];
        Hs.hasOwnProperty(Pl) || (yl !== hl ? isKeyframesTarget(yl) && isKeyframesTarget(hl) ? !shallowCompare(yl, hl) || xl ? Zl(Pl) : ks.protectedKeys[Pl] = !0 : yl !== void 0 ? Zl(Pl) : ko.add(Pl) : yl !== void 0 && ko.has(Pl) ? Zl(Pl) : ks.protectedKeys[Pl] = !0);
      }
      ks.prevProp = Js, ks.prevResolvedValues = Dl, ks.isActive && (Hs = __assign(__assign({}, Hs), Dl)), Qi && Bi.blockInitialAnimation && (Rl = !1), Rl && !bl && rs.push.apply(rs, __spreadArray([], __read(Cl.map(function(Tl) {
        return {
          animation: Tl,
          options: __assign({ type: ls }, Va)
        };
      })), !1));
    }, Xs = 0; Xs < numAnimationTypes; Xs++)
      Ys(Xs);
    if (Xi = __assign({}, Hs), ko.size) {
      var Cs = {};
      ko.forEach(function(ws) {
        var ls = Bi.getBaseTarget(ws);
        ls !== void 0 && (Cs[ws] = ls);
      }), rs.push({ animation: Cs });
    }
    var Fs = !!rs.length;
    return Qi && So.initial === !1 && !Bi.manuallyAnimateOnMount && (Fs = !1), Qi = !1, Fs ? e(rs) : Promise.resolve();
  }
  function Ma(Va, to, Eo) {
    var So;
    if (qi[Va].isActive === to)
      return Promise.resolve();
    (So = Bi.variantChildren) === null || So === void 0 || So.forEach(function(ko) {
      var Hs;
      return (Hs = ko.animationState) === null || Hs === void 0 ? void 0 : Hs.setActive(Va, to);
    }), qi[Va].isActive = to;
    var eo = la(Eo, Va);
    for (var rs in qi)
      qi[rs].protectedKeys = {};
    return eo;
  }
  return {
    isAnimated: ra,
    animateChanges: la,
    setActive: Ma,
    setAnimateFunction: na,
    getState: function() {
      return qi;
    }
  };
}
function checkVariantsDidChange(Bi, e) {
  return typeof e == "string" ? e !== Bi : isVariantLabels(e) ? !shallowCompare(e, Bi) : !1;
}
function createTypeState(Bi) {
  return Bi === void 0 && (Bi = !1), {
    isActive: Bi,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  var Bi;
  return Bi = {}, Bi[AnimationType.Animate] = createTypeState(!0), Bi[AnimationType.InView] = createTypeState(), Bi[AnimationType.Hover] = createTypeState(), Bi[AnimationType.Tap] = createTypeState(), Bi[AnimationType.Drag] = createTypeState(), Bi[AnimationType.Focus] = createTypeState(), Bi[AnimationType.Exit] = createTypeState(), Bi;
}
var animations = {
  animation: makeRenderlessComponent(function(Bi) {
    var e = Bi.visualElement, qi = Bi.animate;
    e.animationState || (e.animationState = createAnimationState(e)), isAnimationControls(qi) && useEffect(function() {
      return qi.subscribe(e);
    }, [qi]);
  }),
  exit: makeRenderlessComponent(function(Bi) {
    var e = Bi.custom, qi = Bi.visualElement, Xi = __read(usePresence(), 2), Qi = Xi[0], ta = Xi[1], ra = useContext(PresenceContext);
    useEffect(function() {
      var na, la;
      qi.isPresent = Qi;
      var Ma = (na = qi.animationState) === null || na === void 0 ? void 0 : na.setActive(AnimationType.Exit, !Qi, { custom: (la = ra?.custom) !== null && la !== void 0 ? la : e });
      !Qi && Ma?.then(ta);
    }, [Qi]);
  })
}, PanSession = (
  /** @class */
  function() {
    function Bi(e, qi, Xi) {
      var Qi = this, ta = Xi === void 0 ? {} : Xi, ra = ta.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (Qi.lastMoveEvent && Qi.lastMoveEventInfo) {
          var Eo = getPanInfo(Qi.lastMoveEventInfo, Qi.history), So = Qi.startEvent !== null, eo = distance(Eo.offset, { x: 0, y: 0 }) >= 3;
          if (!(!So && !eo)) {
            var rs = Eo.point, ko = getFrameData().timestamp;
            Qi.history.push(__assign(__assign({}, rs), { timestamp: ko }));
            var Hs = Qi.handlers, Ks = Hs.onStart, Ys = Hs.onMove;
            So || (Ks && Ks(Qi.lastMoveEvent, Eo), Qi.startEvent = Qi.lastMoveEvent), Ys && Ys(Qi.lastMoveEvent, Eo);
          }
        }
      }, this.handlePointerMove = function(Eo, So) {
        if (Qi.lastMoveEvent = Eo, Qi.lastMoveEventInfo = transformPoint(So, Qi.transformPagePoint), isMouseEvent(Eo) && Eo.buttons === 0) {
          Qi.handlePointerUp(Eo, So);
          return;
        }
        sync.update(Qi.updatePoint, !0);
      }, this.handlePointerUp = function(Eo, So) {
        Qi.end();
        var eo = Qi.handlers, rs = eo.onEnd, ko = eo.onSessionEnd, Hs = getPanInfo(transformPoint(So, Qi.transformPagePoint), Qi.history);
        Qi.startEvent && rs && rs(Eo, Hs), ko && ko(Eo, Hs);
      }, !(isTouchEvent(e) && e.touches.length > 1)) {
        this.handlers = qi, this.transformPagePoint = ra;
        var na = extractEventInfo(e), la = transformPoint(na, this.transformPagePoint), Ma = la.point, Va = getFrameData().timestamp;
        this.history = [__assign(__assign({}, Ma), { timestamp: Va })];
        var to = qi.onSessionStart;
        to && to(e, getPanInfo(la, this.history)), this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
      }
    }
    return Bi.prototype.updateHandlers = function(e) {
      this.handlers = e;
    }, Bi.prototype.end = function() {
      this.removeListeners && this.removeListeners(), cancelSync.update(this.updatePoint);
    }, Bi;
  }()
);
function transformPoint(Bi, e) {
  return e ? { point: e(Bi.point) } : Bi;
}
function subtractPoint(Bi, e) {
  return { x: Bi.x - e.x, y: Bi.y - e.y };
}
function getPanInfo(Bi, e) {
  var qi = Bi.point;
  return {
    point: qi,
    delta: subtractPoint(qi, lastDevicePoint(e)),
    offset: subtractPoint(qi, startDevicePoint(e)),
    velocity: getVelocity(e, 0.1)
  };
}
function startDevicePoint(Bi) {
  return Bi[0];
}
function lastDevicePoint(Bi) {
  return Bi[Bi.length - 1];
}
function getVelocity(Bi, e) {
  if (Bi.length < 2)
    return { x: 0, y: 0 };
  for (var qi = Bi.length - 1, Xi = null, Qi = lastDevicePoint(Bi); qi >= 0 && (Xi = Bi[qi], !(Qi.timestamp - Xi.timestamp > secondsToMilliseconds(e))); )
    qi--;
  if (!Xi)
    return { x: 0, y: 0 };
  var ta = (Qi.timestamp - Xi.timestamp) / 1e3;
  if (ta === 0)
    return { x: 0, y: 0 };
  var ra = {
    x: (Qi.x - Xi.x) / ta,
    y: (Qi.y - Xi.y) / ta
  };
  return ra.x === 1 / 0 && (ra.x = 0), ra.y === 1 / 0 && (ra.y = 0), ra;
}
function calcLength(Bi) {
  return Bi.max - Bi.min;
}
function isNear(Bi, e, qi) {
  return e === void 0 && (e = 0), qi === void 0 && (qi = 0.01), distance(Bi, e) < qi;
}
function calcAxisDelta(Bi, e, qi, Xi) {
  Xi === void 0 && (Xi = 0.5), Bi.origin = Xi, Bi.originPoint = mix(e.min, e.max, Bi.origin), Bi.scale = calcLength(qi) / calcLength(e), (isNear(Bi.scale, 1, 1e-4) || isNaN(Bi.scale)) && (Bi.scale = 1), Bi.translate = mix(qi.min, qi.max, Bi.origin) - Bi.originPoint, (isNear(Bi.translate) || isNaN(Bi.translate)) && (Bi.translate = 0);
}
function calcBoxDelta(Bi, e, qi, Xi) {
  calcAxisDelta(Bi.x, e.x, qi.x, Xi?.originX), calcAxisDelta(Bi.y, e.y, qi.y, Xi?.originY);
}
function calcRelativeAxis(Bi, e, qi) {
  Bi.min = qi.min + e.min, Bi.max = Bi.min + calcLength(e);
}
function calcRelativeBox(Bi, e, qi) {
  calcRelativeAxis(Bi.x, e.x, qi.x), calcRelativeAxis(Bi.y, e.y, qi.y);
}
function calcRelativeAxisPosition(Bi, e, qi) {
  Bi.min = e.min - qi.min, Bi.max = Bi.min + calcLength(e);
}
function calcRelativePosition(Bi, e, qi) {
  calcRelativeAxisPosition(Bi.x, e.x, qi.x), calcRelativeAxisPosition(Bi.y, e.y, qi.y);
}
function applyConstraints(Bi, e, qi) {
  var Xi = e.min, Qi = e.max;
  return Xi !== void 0 && Bi < Xi ? Bi = qi ? mix(Xi, Bi, qi.min) : Math.max(Bi, Xi) : Qi !== void 0 && Bi > Qi && (Bi = qi ? mix(Qi, Bi, qi.max) : Math.min(Bi, Qi)), Bi;
}
function calcRelativeAxisConstraints(Bi, e, qi) {
  return {
    min: e !== void 0 ? Bi.min + e : void 0,
    max: qi !== void 0 ? Bi.max + qi - (Bi.max - Bi.min) : void 0
  };
}
function calcRelativeConstraints(Bi, e) {
  var qi = e.top, Xi = e.left, Qi = e.bottom, ta = e.right;
  return {
    x: calcRelativeAxisConstraints(Bi.x, Xi, ta),
    y: calcRelativeAxisConstraints(Bi.y, qi, Qi)
  };
}
function calcViewportAxisConstraints(Bi, e) {
  var qi, Xi = e.min - Bi.min, Qi = e.max - Bi.max;
  return e.max - e.min < Bi.max - Bi.min && (qi = __read([Qi, Xi], 2), Xi = qi[0], Qi = qi[1]), { min: Xi, max: Qi };
}
function calcViewportConstraints(Bi, e) {
  return {
    x: calcViewportAxisConstraints(Bi.x, e.x),
    y: calcViewportAxisConstraints(Bi.y, e.y)
  };
}
function calcOrigin(Bi, e) {
  var qi = 0.5, Xi = calcLength(Bi), Qi = calcLength(e);
  return Qi > Xi ? qi = progress(e.min, e.max - Xi, Bi.min) : Xi > Qi && (qi = progress(Bi.min, Bi.max - Qi, e.min)), clamp(0, 1, qi);
}
function rebaseAxisConstraints(Bi, e) {
  var qi = {};
  return e.min !== void 0 && (qi.min = e.min - Bi.min), e.max !== void 0 && (qi.max = e.max - Bi.min), qi;
}
var defaultElastic = 0.35;
function resolveDragElastic(Bi) {
  return Bi === void 0 && (Bi = defaultElastic), Bi === !1 ? Bi = 0 : Bi === !0 && (Bi = defaultElastic), {
    x: resolveAxisElastic(Bi, "left", "right"),
    y: resolveAxisElastic(Bi, "top", "bottom")
  };
}
function resolveAxisElastic(Bi, e, qi) {
  return {
    min: resolvePointElastic(Bi, e),
    max: resolvePointElastic(Bi, qi)
  };
}
function resolvePointElastic(Bi, e) {
  var qi;
  return typeof Bi == "number" ? Bi : (qi = Bi[e]) !== null && qi !== void 0 ? qi : 0;
}
var createAxisDelta = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, createDelta = function() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
}, createAxis = function() {
  return { min: 0, max: 0 };
}, createBox = function() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};
function eachAxis(Bi) {
  return [Bi("x"), Bi("y")];
}
function convertBoundingBoxToBox(Bi) {
  var e = Bi.top, qi = Bi.left, Xi = Bi.right, Qi = Bi.bottom;
  return {
    x: { min: qi, max: Xi },
    y: { min: e, max: Qi }
  };
}
function convertBoxToBoundingBox(Bi) {
  var e = Bi.x, qi = Bi.y;
  return { top: qi.min, right: e.max, bottom: qi.max, left: e.min };
}
function transformBoxPoints(Bi, e) {
  if (!e)
    return Bi;
  var qi = e({ x: Bi.left, y: Bi.top }), Xi = e({ x: Bi.right, y: Bi.bottom });
  return {
    top: qi.y,
    left: qi.x,
    bottom: Xi.y,
    right: Xi.x
  };
}
function isIdentityScale(Bi) {
  return Bi === void 0 || Bi === 1;
}
function hasScale(Bi) {
  var e = Bi.scale, qi = Bi.scaleX, Xi = Bi.scaleY;
  return !isIdentityScale(e) || !isIdentityScale(qi) || !isIdentityScale(Xi);
}
function hasTransform(Bi) {
  return hasScale(Bi) || hasTranslate(Bi.x) || hasTranslate(Bi.y) || Bi.z || Bi.rotate || Bi.rotateX || Bi.rotateY;
}
function hasTranslate(Bi) {
  return Bi && Bi !== "0%";
}
function scalePoint(Bi, e, qi) {
  var Xi = Bi - qi, Qi = e * Xi;
  return qi + Qi;
}
function applyPointDelta(Bi, e, qi, Xi, Qi) {
  return Qi !== void 0 && (Bi = scalePoint(Bi, Qi, Xi)), scalePoint(Bi, qi, Xi) + e;
}
function applyAxisDelta(Bi, e, qi, Xi, Qi) {
  e === void 0 && (e = 0), qi === void 0 && (qi = 1), Bi.min = applyPointDelta(Bi.min, e, qi, Xi, Qi), Bi.max = applyPointDelta(Bi.max, e, qi, Xi, Qi);
}
function applyBoxDelta(Bi, e) {
  var qi = e.x, Xi = e.y;
  applyAxisDelta(Bi.x, qi.translate, qi.scale, qi.originPoint), applyAxisDelta(Bi.y, Xi.translate, Xi.scale, Xi.originPoint);
}
function applyTreeDeltas(Bi, e, qi, Xi) {
  var Qi, ta;
  Xi === void 0 && (Xi = !1);
  var ra = qi.length;
  if (ra) {
    e.x = e.y = 1;
    for (var na, la, Ma = 0; Ma < ra; Ma++)
      na = qi[Ma], la = na.projectionDelta, ((ta = (Qi = na.instance) === null || Qi === void 0 ? void 0 : Qi.style) === null || ta === void 0 ? void 0 : ta.display) !== "contents" && (Xi && na.options.layoutScroll && na.scroll && na !== na.root && transformBox(Bi, { x: -na.scroll.x, y: -na.scroll.y }), la && (e.x *= la.x.scale, e.y *= la.y.scale, applyBoxDelta(Bi, la)), Xi && hasTransform(na.latestValues) && transformBox(Bi, na.latestValues));
  }
}
function translateAxis(Bi, e) {
  Bi.min = Bi.min + e, Bi.max = Bi.max + e;
}
function transformAxis(Bi, e, qi) {
  var Xi = __read(qi, 3), Qi = Xi[0], ta = Xi[1], ra = Xi[2], na = e[ra] !== void 0 ? e[ra] : 0.5, la = mix(Bi.min, Bi.max, na);
  applyAxisDelta(Bi, e[Qi], e[ta], la, e.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"], yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(Bi, e) {
  transformAxis(Bi.x, e, xKeys$1), transformAxis(Bi.y, e, yKeys$1);
}
function measureViewportBox(Bi, e) {
  return convertBoundingBoxToBox(transformBoxPoints(Bi.getBoundingClientRect(), e));
}
function measurePageBox(Bi, e, qi) {
  var Xi = measureViewportBox(Bi, qi), Qi = e.scroll;
  return Qi && (translateAxis(Xi.x, Qi.x), translateAxis(Xi.y, Qi.y)), Xi;
}
var elementDragControls = /* @__PURE__ */ new WeakMap(), VisualElementDragControls = (
  /** @class */
  function() {
    function Bi(e) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.visualElement = e;
    }
    return Bi.prototype.start = function(e, qi) {
      var Xi = this, Qi = qi === void 0 ? {} : qi, ta = Qi.snapToCursor, ra = ta === void 0 ? !1 : ta;
      if (this.visualElement.isPresent !== !1) {
        var na = function(to) {
          Xi.stopAnimation(), ra && Xi.snapToCursor(extractEventInfo(to, "page").point);
        }, la = function(to, Eo) {
          var So, eo = Xi.getProps(), rs = eo.drag, ko = eo.dragPropagation, Hs = eo.onDragStart;
          rs && !ko && (Xi.openGlobalLock && Xi.openGlobalLock(), Xi.openGlobalLock = getGlobalLock(rs), !Xi.openGlobalLock) || (Xi.isDragging = !0, Xi.currentDirection = null, Xi.resolveConstraints(), Xi.visualElement.projection && (Xi.visualElement.projection.isAnimationBlocked = !0, Xi.visualElement.projection.target = void 0), eachAxis(function(Ks) {
            var Ys, Xs, Cs = Xi.getAxisMotionValue(Ks).get() || 0;
            if (percent.test(Cs)) {
              var Fs = (Xs = (Ys = Xi.visualElement.projection) === null || Ys === void 0 ? void 0 : Ys.layout) === null || Xs === void 0 ? void 0 : Xs.actual[Ks];
              if (Fs) {
                var ws = calcLength(Fs);
                Cs = ws * (parseFloat(Cs) / 100);
              }
            }
            Xi.originPoint[Ks] = Cs;
          }), Hs?.(to, Eo), (So = Xi.visualElement.animationState) === null || So === void 0 || So.setActive(AnimationType.Drag, !0));
        }, Ma = function(to, Eo) {
          var So = Xi.getProps(), eo = So.dragPropagation, rs = So.dragDirectionLock, ko = So.onDirectionLock, Hs = So.onDrag;
          if (!(!eo && !Xi.openGlobalLock)) {
            var Ks = Eo.offset;
            if (rs && Xi.currentDirection === null) {
              Xi.currentDirection = getCurrentDirection(Ks), Xi.currentDirection !== null && ko?.(Xi.currentDirection);
              return;
            }
            Xi.updateAxis("x", Eo.point, Ks), Xi.updateAxis("y", Eo.point, Ks), Xi.visualElement.syncRender(), Hs?.(to, Eo);
          }
        }, Va = function(to, Eo) {
          return Xi.stop(to, Eo);
        };
        this.panSession = new PanSession(e, {
          onSessionStart: na,
          onStart: la,
          onMove: Ma,
          onSessionEnd: Va
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, Bi.prototype.stop = function(e, qi) {
      var Xi = this.isDragging;
      if (this.cancel(), !!Xi) {
        var Qi = qi.velocity;
        this.startAnimation(Qi);
        var ta = this.getProps().onDragEnd;
        ta?.(e, qi);
      }
    }, Bi.prototype.cancel = function() {
      var e, qi;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (e = this.panSession) === null || e === void 0 || e.end(), this.panSession = void 0;
      var Xi = this.getProps().dragPropagation;
      !Xi && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (qi = this.visualElement.animationState) === null || qi === void 0 || qi.setActive(AnimationType.Drag, !1);
    }, Bi.prototype.updateAxis = function(e, qi, Xi) {
      var Qi = this.getProps().drag;
      if (!(!Xi || !shouldDrag(e, Qi, this.currentDirection))) {
        var ta = this.getAxisMotionValue(e), ra = this.originPoint[e] + Xi[e];
        this.constraints && this.constraints[e] && (ra = applyConstraints(ra, this.constraints[e], this.elastic[e])), ta.set(ra);
      }
    }, Bi.prototype.resolveConstraints = function() {
      var e = this, qi = this.getProps(), Xi = qi.dragConstraints, Qi = qi.dragElastic, ta = (this.visualElement.projection || {}).layout, ra = this.constraints;
      Xi && isRefObject(Xi) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : Xi && ta ? this.constraints = calcRelativeConstraints(ta.actual, Xi) : this.constraints = !1, this.elastic = resolveDragElastic(Qi), ra !== this.constraints && ta && this.constraints && !this.hasMutatedConstraints && eachAxis(function(na) {
        e.getAxisMotionValue(na) && (e.constraints[na] = rebaseAxisConstraints(ta.actual[na], e.constraints[na]));
      });
    }, Bi.prototype.resolveRefConstraints = function() {
      var e = this.getProps(), qi = e.dragConstraints, Xi = e.onMeasureDragConstraints;
      if (!qi || !isRefObject(qi))
        return !1;
      var Qi = qi.current;
      invariant$1(Qi !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var ta = this.visualElement.projection;
      if (!ta || !ta.layout)
        return !1;
      var ra = measurePageBox(Qi, ta.root, this.visualElement.getTransformPagePoint()), na = calcViewportConstraints(ta.layout.actual, ra);
      if (Xi) {
        var la = Xi(convertBoxToBoundingBox(na));
        this.hasMutatedConstraints = !!la, la && (na = convertBoundingBoxToBox(la));
      }
      return na;
    }, Bi.prototype.startAnimation = function(e) {
      var qi = this, Xi = this.getProps(), Qi = Xi.drag, ta = Xi.dragMomentum, ra = Xi.dragElastic, na = Xi.dragTransition, la = Xi.dragSnapToOrigin, Ma = Xi.onDragTransitionEnd, Va = this.constraints || {}, to = eachAxis(function(Eo) {
        var So;
        if (shouldDrag(Eo, Qi, qi.currentDirection)) {
          var eo = (So = Va?.[Eo]) !== null && So !== void 0 ? So : {};
          la && (eo = { min: 0, max: 0 });
          var rs = ra ? 200 : 1e6, ko = ra ? 40 : 1e7, Hs = __assign(__assign({ type: "inertia", velocity: ta ? e[Eo] : 0, bounceStiffness: rs, bounceDamping: ko, timeConstant: 750, restDelta: 1, restSpeed: 10 }, na), eo);
          return qi.startAxisValueAnimation(Eo, Hs);
        }
      });
      return Promise.all(to).then(Ma);
    }, Bi.prototype.startAxisValueAnimation = function(e, qi) {
      var Xi = this.getAxisMotionValue(e);
      return startAnimation(e, Xi, 0, qi);
    }, Bi.prototype.stopAnimation = function() {
      var e = this;
      eachAxis(function(qi) {
        return e.getAxisMotionValue(qi).stop();
      });
    }, Bi.prototype.getAxisMotionValue = function(e) {
      var qi, Xi, Qi = "_drag" + e.toUpperCase(), ta = this.visualElement.getProps()[Qi];
      return ta || this.visualElement.getValue(e, (Xi = (qi = this.visualElement.getProps().initial) === null || qi === void 0 ? void 0 : qi[e]) !== null && Xi !== void 0 ? Xi : 0);
    }, Bi.prototype.snapToCursor = function(e) {
      var qi = this;
      eachAxis(function(Xi) {
        var Qi = qi.getProps().drag;
        if (shouldDrag(Xi, Qi, qi.currentDirection)) {
          var ta = qi.visualElement.projection, ra = qi.getAxisMotionValue(Xi);
          if (ta && ta.layout) {
            var na = ta.layout.actual[Xi], la = na.min, Ma = na.max;
            ra.set(e[Xi] - mix(la, Ma, 0.5));
          }
        }
      });
    }, Bi.prototype.scalePositionWithinConstraints = function() {
      var e = this, qi, Xi = this.getProps(), Qi = Xi.drag, ta = Xi.dragConstraints, ra = this.visualElement.projection;
      if (!(!isRefObject(ta) || !ra || !this.constraints)) {
        this.stopAnimation();
        var na = { x: 0, y: 0 };
        eachAxis(function(Ma) {
          var Va = e.getAxisMotionValue(Ma);
          if (Va) {
            var to = Va.get();
            na[Ma] = calcOrigin({ min: to, max: to }, e.constraints[Ma]);
          }
        });
        var la = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = la ? la({}, "") : "none", (qi = ra.root) === null || qi === void 0 || qi.updateScroll(), ra.updateLayout(), this.resolveConstraints(), eachAxis(function(Ma) {
          if (shouldDrag(Ma, Qi, null)) {
            var Va = e.getAxisMotionValue(Ma), to = e.constraints[Ma], Eo = to.min, So = to.max;
            Va.set(mix(Eo, So, na[Ma]));
          }
        });
      }
    }, Bi.prototype.addListeners = function() {
      var e = this, qi;
      elementDragControls.set(this.visualElement, this);
      var Xi = this.visualElement.getInstance(), Qi = addPointerEvent(Xi, "pointerdown", function(Ma) {
        var Va = e.getProps(), to = Va.drag, Eo = Va.dragListener, So = Eo === void 0 ? !0 : Eo;
        to && So && e.start(Ma);
      }), ta = function() {
        var Ma = e.getProps().dragConstraints;
        isRefObject(Ma) && (e.constraints = e.resolveRefConstraints());
      }, ra = this.visualElement.projection, na = ra.addEventListener("measure", ta);
      ra && !ra.layout && ((qi = ra.root) === null || qi === void 0 || qi.updateScroll(), ra.updateLayout()), ta();
      var la = addDomEvent(window, "resize", function() {
        return e.scalePositionWithinConstraints();
      });
      return ra.addEventListener("didUpdate", function(Ma) {
        var Va = Ma.delta, to = Ma.hasLayoutChanged;
        e.isDragging && to && (eachAxis(function(Eo) {
          var So = e.getAxisMotionValue(Eo);
          So && (e.originPoint[Eo] += Va[Eo].translate, So.set(So.get() + Va[Eo].translate));
        }), e.visualElement.syncRender());
      }), function() {
        la(), Qi(), na();
      };
    }, Bi.prototype.getProps = function() {
      var e = this.visualElement.getProps(), qi = e.drag, Xi = qi === void 0 ? !1 : qi, Qi = e.dragDirectionLock, ta = Qi === void 0 ? !1 : Qi, ra = e.dragPropagation, na = ra === void 0 ? !1 : ra, la = e.dragConstraints, Ma = la === void 0 ? !1 : la, Va = e.dragElastic, to = Va === void 0 ? defaultElastic : Va, Eo = e.dragMomentum, So = Eo === void 0 ? !0 : Eo;
      return __assign(__assign({}, e), { drag: Xi, dragDirectionLock: ta, dragPropagation: na, dragConstraints: Ma, dragElastic: to, dragMomentum: So });
    }, Bi;
  }()
);
function shouldDrag(Bi, e, qi) {
  return (e === !0 || e === Bi) && (qi === null || qi === Bi);
}
function getCurrentDirection(Bi, e) {
  e === void 0 && (e = 10);
  var qi = null;
  return Math.abs(Bi.y) > e ? qi = "y" : Math.abs(Bi.x) > e && (qi = "x"), qi;
}
function useDrag$1(Bi) {
  var e = Bi.dragControls, qi = Bi.visualElement, Xi = useConstant(function() {
    return new VisualElementDragControls(qi);
  });
  useEffect(function() {
    return e && e.subscribe(Xi);
  }, [Xi, e]), useEffect(function() {
    return Xi.addListeners();
  }, [Xi]);
}
function usePanGesture(Bi) {
  var e = Bi.onPan, qi = Bi.onPanStart, Xi = Bi.onPanEnd, Qi = Bi.onPanSessionStart, ta = Bi.visualElement, ra = e || qi || Xi || Qi, na = useRef(null), la = useContext(MotionConfigContext).transformPagePoint, Ma = {
    onSessionStart: Qi,
    onStart: qi,
    onMove: e,
    onEnd: function(to, Eo) {
      na.current = null, Xi && Xi(to, Eo);
    }
  };
  useEffect(function() {
    na.current !== null && na.current.updateHandlers(Ma);
  });
  function Va(to) {
    na.current = new PanSession(to, Ma, {
      transformPagePoint: la
    });
  }
  usePointerEvent(ta, "pointerdown", ra && Va), useUnmountEffect(function() {
    return na.current && na.current.end();
  });
}
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag$1)
}, names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var Bi = names.map(function() {
    return new SubscriptionManager();
  }), e = {}, qi = {
    clearAllListeners: function() {
      return Bi.forEach(function(Xi) {
        return Xi.clear();
      });
    },
    updatePropListeners: function(Xi) {
      names.forEach(function(Qi) {
        var ta, ra = "on" + Qi, na = Xi[ra];
        (ta = e[Qi]) === null || ta === void 0 || ta.call(e), na && (e[Qi] = qi[ra](na));
      });
    }
  };
  return Bi.forEach(function(Xi, Qi) {
    qi["on" + names[Qi]] = function(ta) {
      return Xi.add(ta);
    }, qi["notify" + names[Qi]] = function() {
      for (var ta = [], ra = 0; ra < arguments.length; ra++)
        ta[ra] = arguments[ra];
      return Xi.notify.apply(Xi, __spreadArray([], __read(ta), !1));
    };
  }), qi;
}
function updateMotionValuesFromProps(Bi, e, qi) {
  var Xi;
  for (var Qi in e) {
    var ta = e[Qi], ra = qi[Qi];
    if (isMotionValue(ta))
      Bi.addValue(Qi, ta), process.env.NODE_ENV === "development" && warnOnce(ta.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(ta.version, " with 6.5.1 may not work as expected."));
    else if (isMotionValue(ra))
      Bi.addValue(Qi, motionValue(ta));
    else if (ra !== ta)
      if (Bi.hasValue(Qi)) {
        var na = Bi.getValue(Qi);
        !na.hasAnimated && na.set(ta);
      } else
        Bi.addValue(Qi, motionValue((Xi = Bi.getStaticValue(Qi)) !== null && Xi !== void 0 ? Xi : ta));
  }
  for (var Qi in qi)
    e[Qi] === void 0 && Bi.removeValue(Qi);
  return e;
}
var visualElement = function(Bi) {
  var e = Bi.treeType, qi = e === void 0 ? "" : e, Xi = Bi.build, Qi = Bi.getBaseTarget, ta = Bi.makeTargetAnimatable, ra = Bi.measureViewportBox, na = Bi.render, la = Bi.readValueFromInstance, Ma = Bi.removeValueFromRenderState, Va = Bi.sortNodePosition, to = Bi.scrapeMotionValuesFromProps;
  return function(Eo, So) {
    var eo = Eo.parent, rs = Eo.props, ko = Eo.presenceId, Hs = Eo.blockInitialAnimation, Ks = Eo.visualState, Ys = Eo.shouldReduceMotion;
    So === void 0 && (So = {});
    var Xs = !1, Cs = Ks.latestValues, Fs = Ks.renderState, ws, ls = createLifecycles(), ks = /* @__PURE__ */ new Map(), Js = /* @__PURE__ */ new Map(), pl = {}, _l = __assign({}, Cs), bl;
    function xl() {
      !ws || !Xs || (Rl(), na(ws, Fs, rs.style, yl.projection));
    }
    function Rl() {
      Xi(yl, Fs, Cs, So, rs);
    }
    function Cl() {
      ls.notifyUpdate(Cs);
    }
    function Dl(hl, Tl) {
      var Il = Tl.onChange(function(Al) {
        Cs[hl] = Al, rs.onUpdate && sync.update(Cl, !1, !0);
      }), jl = Tl.onRenderRequest(yl.scheduleRender);
      Js.set(hl, function() {
        Il(), jl();
      });
    }
    var kl = to(rs);
    for (var Ul in kl) {
      var Bl = kl[Ul];
      Cs[Ul] !== void 0 && isMotionValue(Bl) && Bl.set(Cs[Ul], !1);
    }
    var Zl = checkIfControllingVariants(rs), Pl = checkIfVariantNode(rs), yl = __assign(__assign({
      treeType: qi,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: eo ? eo.depth + 1 : 0,
      parent: eo,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: ko,
      shouldReduceMotion: Ys,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: Pl ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!eo?.isMounted(),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: Hs,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!ws;
      },
      mount: function(hl) {
        Xs = !0, ws = yl.current = hl, yl.projection && yl.projection.mount(hl), Pl && eo && !Zl && (bl = eo?.addVariantChild(yl)), ks.forEach(function(Tl, Il) {
          return Dl(Il, Tl);
        }), eo?.children.add(yl), yl.setProps(rs);
      },
      /**
       *
       */
      unmount: function() {
        var hl;
        (hl = yl.projection) === null || hl === void 0 || hl.unmount(), cancelSync.update(Cl), cancelSync.render(xl), Js.forEach(function(Tl) {
          return Tl();
        }), bl?.(), eo?.children.delete(yl), ls.clearAllListeners(), ws = void 0, Xs = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(hl) {
        var Tl, Il = yl.getClosestVariantNode();
        if (Il)
          return (Tl = Il.variantChildren) === null || Tl === void 0 || Tl.add(hl), function() {
            return Il.variantChildren.delete(hl);
          };
      },
      sortNodePosition: function(hl) {
        return !Va || qi !== hl.treeType ? 0 : Va(yl.getInstance(), hl.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return Pl ? yl : eo?.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return rs.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return ws;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(hl) {
        return Cs[hl];
      },
      setStaticValue: function(hl, Tl) {
        return Cs[hl] = Tl;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return Cs;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(hl) {
        yl.isVisible !== hl && (yl.isVisible = hl, yl.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(hl, Tl) {
        return Tl === void 0 && (Tl = !0), ta(yl, hl, rs, Tl);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return ra(ws, rs);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(hl, Tl) {
        yl.hasValue(hl) && yl.removeValue(hl), ks.set(hl, Tl), Cs[hl] = Tl.get(), Dl(hl, Tl);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(hl) {
        var Tl;
        ks.delete(hl), (Tl = Js.get(hl)) === null || Tl === void 0 || Tl(), Js.delete(hl), delete Cs[hl], Ma(hl, Fs);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(hl) {
        return ks.has(hl);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(hl, Tl) {
        var Il = ks.get(hl);
        return Il === void 0 && Tl !== void 0 && (Il = motionValue(Tl), yl.addValue(hl, Il)), Il;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(hl) {
        return ks.forEach(hl);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(hl) {
        var Tl;
        return (Tl = Cs[hl]) !== null && Tl !== void 0 ? Tl : la(ws, hl, So);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(hl, Tl) {
        _l[hl] = Tl;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(hl) {
        if (Qi) {
          var Tl = Qi(rs, hl);
          if (Tl !== void 0 && !isMotionValue(Tl))
            return Tl;
        }
        return _l[hl];
      }
    }, ls), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return Rl(), Fs;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        sync.render(xl, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: xl,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(hl) {
        (hl.transformTemplate || rs.transformTemplate) && yl.scheduleRender(), rs = hl, ls.updatePropListeners(hl), pl = updateMotionValuesFromProps(yl, to(rs), pl);
      },
      getProps: function() {
        return rs;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(hl) {
        var Tl;
        return (Tl = rs.variants) === null || Tl === void 0 ? void 0 : Tl[hl];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return rs.transition;
      },
      getTransformPagePoint: function() {
        return rs.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(hl) {
        if (hl === void 0 && (hl = !1), hl)
          return eo?.getVariantContext();
        if (!Zl) {
          var Tl = eo?.getVariantContext() || {};
          return rs.initial !== void 0 && (Tl.initial = rs.initial), Tl;
        }
        for (var Il = {}, jl = 0; jl < numVariantProps; jl++) {
          var Al = variantProps[jl], _s = rs[Al];
          (isVariantLabel(_s) || _s === !1) && (Il[Al] = _s);
        }
        return Il;
      }
    });
    return yl;
  };
}, variantProps = __spreadArray(["initial"], __read(variantPriorityOrder), !1), numVariantProps = variantProps.length;
function isCSSVariable(Bi) {
  return typeof Bi == "string" && Bi.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(Bi) {
  var e = cssVariableRegex.exec(Bi);
  if (!e)
    return [,];
  var qi = __read(e, 3), Xi = qi[1], Qi = qi[2];
  return [Xi, Qi];
}
var maxDepth = 4;
function getVariableValue(Bi, e, qi) {
  qi === void 0 && (qi = 1), invariant$1(qi <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(Bi, '". This may indicate a circular fallback dependency.'));
  var Xi = __read(parseCSSVariable(Bi), 2), Qi = Xi[0], ta = Xi[1];
  if (Qi) {
    var ra = window.getComputedStyle(e).getPropertyValue(Qi);
    return ra ? ra.trim() : isCSSVariable(ta) ? getVariableValue(ta, e, qi + 1) : ta;
  }
}
function resolveCSSVariables(Bi, e, qi) {
  var Xi, Qi = __rest$1(e, []), ta = Bi.getInstance();
  if (!(ta instanceof Element))
    return { target: Qi, transitionEnd: qi };
  qi && (qi = __assign({}, qi)), Bi.forEachValue(function(Ma) {
    var Va = Ma.get();
    if (isCSSVariable(Va)) {
      var to = getVariableValue(Va, ta);
      to && Ma.set(to);
    }
  });
  for (var ra in Qi) {
    var na = Qi[ra];
    if (isCSSVariable(na)) {
      var la = getVariableValue(na, ta);
      la && (Qi[ra] = la, qi && ((Xi = qi[ra]) !== null && Xi !== void 0 || (qi[ra] = na)));
    }
  }
  return { target: Qi, transitionEnd: qi };
}
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), isPositionalKey = function(Bi) {
  return positionalKeys.has(Bi);
}, hasPositionalKey = function(Bi) {
  return Object.keys(Bi).some(isPositionalKey);
}, setAndResetVelocity = function(Bi, e) {
  Bi.set(e, !1), Bi.set(e);
}, isNumOrPxType = function(Bi) {
  return Bi === number || Bi === px;
}, BoundingBoxDimension;
(function(Bi) {
  Bi.width = "width", Bi.height = "height", Bi.left = "left", Bi.right = "right", Bi.top = "top", Bi.bottom = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(Bi, e) {
  return parseFloat(Bi.split(", ")[e]);
}, getTranslateFromMatrix = function(Bi, e) {
  return function(qi, Xi) {
    var Qi = Xi.transform;
    if (Qi === "none" || !Qi)
      return 0;
    var ta = Qi.match(/^matrix3d\((.+)\)$/);
    if (ta)
      return getPosFromMatrix(ta[1], e);
    var ra = Qi.match(/^matrix\((.+)\)$/);
    return ra ? getPosFromMatrix(ra[1], Bi) : 0;
  };
}, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformProps.filter(function(Bi) {
  return !transformKeys.has(Bi);
});
function removeNonTranslationalTransform(Bi) {
  var e = [];
  return nonTranslationalTransformKeys.forEach(function(qi) {
    var Xi = Bi.getValue(qi);
    Xi !== void 0 && (e.push([qi, Xi.get()]), Xi.set(qi.startsWith("scale") ? 1 : 0));
  }), e.length && Bi.syncRender(), e;
}
var positionalValues = {
  // Dimensions
  width: function(Bi, e) {
    var qi = Bi.x, Xi = e.paddingLeft, Qi = Xi === void 0 ? "0" : Xi, ta = e.paddingRight, ra = ta === void 0 ? "0" : ta;
    return qi.max - qi.min - parseFloat(Qi) - parseFloat(ra);
  },
  height: function(Bi, e) {
    var qi = Bi.y, Xi = e.paddingTop, Qi = Xi === void 0 ? "0" : Xi, ta = e.paddingBottom, ra = ta === void 0 ? "0" : ta;
    return qi.max - qi.min - parseFloat(Qi) - parseFloat(ra);
  },
  top: function(Bi, e) {
    var qi = e.top;
    return parseFloat(qi);
  },
  left: function(Bi, e) {
    var qi = e.left;
    return parseFloat(qi);
  },
  bottom: function(Bi, e) {
    var qi = Bi.y, Xi = e.top;
    return parseFloat(Xi) + (qi.max - qi.min);
  },
  right: function(Bi, e) {
    var qi = Bi.x, Xi = e.left;
    return parseFloat(Xi) + (qi.max - qi.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
}, convertChangedValueTypes = function(Bi, e, qi) {
  var Xi = e.measureViewportBox(), Qi = e.getInstance(), ta = getComputedStyle(Qi), ra = ta.display, na = {};
  ra === "none" && e.setStaticValue("display", Bi.display || "block"), qi.forEach(function(Ma) {
    na[Ma] = positionalValues[Ma](Xi, ta);
  }), e.syncRender();
  var la = e.measureViewportBox();
  return qi.forEach(function(Ma) {
    var Va = e.getValue(Ma);
    setAndResetVelocity(Va, na[Ma]), Bi[Ma] = positionalValues[Ma](la, ta);
  }), Bi;
}, checkAndConvertChangedValueTypes = function(Bi, e, qi, Xi) {
  qi === void 0 && (qi = {}), Xi === void 0 && (Xi = {}), e = __assign({}, e), Xi = __assign({}, Xi);
  var Qi = Object.keys(e).filter(isPositionalKey), ta = [], ra = !1, na = [];
  if (Qi.forEach(function(Va) {
    var to = Bi.getValue(Va);
    if (Bi.hasValue(Va)) {
      var Eo = qi[Va], So = findDimensionValueType(Eo), eo = e[Va], rs;
      if (isKeyframesTarget(eo)) {
        var ko = eo.length, Hs = eo[0] === null ? 1 : 0;
        Eo = eo[Hs], So = findDimensionValueType(Eo);
        for (var Ks = Hs; Ks < ko; Ks++)
          rs ? invariant$1(findDimensionValueType(eo[Ks]) === rs, "All keyframes must be of the same type") : (rs = findDimensionValueType(eo[Ks]), invariant$1(rs === So || isNumOrPxType(So) && isNumOrPxType(rs), "Keyframes must be of the same dimension as the current value"));
      } else
        rs = findDimensionValueType(eo);
      if (So !== rs)
        if (isNumOrPxType(So) && isNumOrPxType(rs)) {
          var Ys = to.get();
          typeof Ys == "string" && to.set(parseFloat(Ys)), typeof eo == "string" ? e[Va] = parseFloat(eo) : Array.isArray(eo) && rs === px && (e[Va] = eo.map(parseFloat));
        } else So?.transform && rs?.transform && (Eo === 0 || eo === 0) ? Eo === 0 ? to.set(rs.transform(Eo)) : e[Va] = So.transform(eo) : (ra || (ta = removeNonTranslationalTransform(Bi), ra = !0), na.push(Va), Xi[Va] = Xi[Va] !== void 0 ? Xi[Va] : e[Va], setAndResetVelocity(to, eo));
    }
  }), na.length) {
    var la = na.indexOf("height") >= 0 ? window.pageYOffset : null, Ma = convertChangedValueTypes(e, Bi, na);
    return ta.length && ta.forEach(function(Va) {
      var to = __read(Va, 2), Eo = to[0], So = to[1];
      Bi.getValue(Eo).set(So);
    }), Bi.syncRender(), la !== null && window.scrollTo({ top: la }), { target: Ma, transitionEnd: Xi };
  } else
    return { target: e, transitionEnd: Xi };
};
function unitConversion(Bi, e, qi, Xi) {
  return hasPositionalKey(e) ? checkAndConvertChangedValueTypes(Bi, e, qi, Xi) : { target: e, transitionEnd: Xi };
}
var parseDomVariant = function(Bi, e, qi, Xi) {
  var Qi = resolveCSSVariables(Bi, e, Xi);
  return e = Qi.target, Xi = Qi.transitionEnd, unitConversion(Bi, e, qi, Xi);
};
function getComputedStyle$1(Bi) {
  return window.getComputedStyle(Bi);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(Bi, e) {
    if (isTransformProp(e)) {
      var qi = getDefaultValueType(e);
      return qi && qi.default || 0;
    } else {
      var Xi = getComputedStyle$1(Bi);
      return (isCSSVariable$1(e) ? Xi.getPropertyValue(e) : Xi[e]) || 0;
    }
  },
  sortNodePosition: function(Bi, e) {
    return Bi.compareDocumentPosition(e) & 2 ? 1 : -1;
  },
  getBaseTarget: function(Bi, e) {
    var qi;
    return (qi = Bi.style) === null || qi === void 0 ? void 0 : qi[e];
  },
  measureViewportBox: function(Bi, e) {
    var qi = e.transformPagePoint;
    return measureViewportBox(Bi, qi);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(Bi, e, qi) {
    var Xi = qi.transformTemplate;
    e.style.transform = Xi ? Xi({}, "") : "none", Bi.scheduleRender();
  },
  restoreTransform: function(Bi, e) {
    Bi.style.transform = e.style.transform;
  },
  removeValueFromRenderState: function(Bi, e) {
    var qi = e.vars, Xi = e.style;
    delete qi[Bi], delete Xi[Bi];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(Bi, e, qi, Xi) {
    var Qi = qi.transformValues;
    Xi === void 0 && (Xi = !0);
    var ta = e.transition, ra = e.transitionEnd, na = __rest$1(e, ["transition", "transitionEnd"]), la = getOrigin(na, ta || {}, Bi);
    if (Qi && (ra && (ra = Qi(ra)), na && (na = Qi(na)), la && (la = Qi(la))), Xi) {
      checkTargetForNewValues(Bi, na, la);
      var Ma = parseDomVariant(Bi, na, la, ra);
      ra = Ma.transitionEnd, na = Ma.target;
    }
    return __assign({ transition: ta, transitionEnd: ra }, na);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  build: function(Bi, e, qi, Xi, Qi) {
    Bi.isVisible !== void 0 && (e.style.visibility = Bi.isVisible ? "visible" : "hidden"), buildHTMLStyles(e, qi, Xi, Qi.transformTemplate);
  },
  render: renderHTML
}, htmlVisualElement = visualElement(htmlConfig), svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), { getBaseTarget: function(Bi, e) {
  return Bi[e];
}, readValueFromInstance: function(Bi, e) {
  var qi;
  return isTransformProp(e) ? ((qi = getDefaultValueType(e)) === null || qi === void 0 ? void 0 : qi.default) || 0 : (e = camelCaseAttributes.has(e) ? e : camelToDash(e), Bi.getAttribute(e));
}, scrapeMotionValuesFromProps, build: function(Bi, e, qi, Xi, Qi) {
  buildSVGAttrs(e, qi, Xi, Qi.transformTemplate);
}, render: renderSVG })), createDomVisualElement = function(Bi, e) {
  return isSVGComponent(Bi) ? svgVisualElement(e, { enableHardwareAcceleration: !1 }) : htmlVisualElement(e, { enableHardwareAcceleration: !0 });
};
function pixelsToPercent(Bi, e) {
  return e.max === e.min ? 0 : Bi / (e.max - e.min) * 100;
}
var correctBorderRadius = {
  correct: function(Bi, e) {
    if (!e.target)
      return Bi;
    if (typeof Bi == "string")
      if (px.test(Bi))
        Bi = parseFloat(Bi);
      else
        return Bi;
    var qi = pixelsToPercent(Bi, e.target.x), Xi = pixelsToPercent(Bi, e.target.y);
    return "".concat(qi, "% ").concat(Xi, "%");
  }
}, varToken = "_$css", correctBoxShadow = {
  correct: function(Bi, e) {
    var qi = e.treeScale, Xi = e.projectionDelta, Qi = Bi, ta = Bi.includes("var("), ra = [];
    ta && (Bi = Bi.replace(cssVariableRegex, function(rs) {
      return ra.push(rs), varToken;
    }));
    var na = complex.parse(Bi);
    if (na.length > 5)
      return Qi;
    var la = complex.createTransformer(Bi), Ma = typeof na[0] != "number" ? 1 : 0, Va = Xi.x.scale * qi.x, to = Xi.y.scale * qi.y;
    na[0 + Ma] /= Va, na[1 + Ma] /= to;
    var Eo = mix(Va, to, 0.5);
    typeof na[2 + Ma] == "number" && (na[2 + Ma] /= Eo), typeof na[3 + Ma] == "number" && (na[3 + Ma] /= Eo);
    var So = la(na);
    if (ta) {
      var eo = 0;
      So = So.replace(varToken, function() {
        var rs = ra[eo];
        return eo++, rs;
      });
    }
    return So;
  }
}, MeasureLayoutWithContext = (
  /** @class */
  function(Bi) {
    __extends(e, Bi);
    function e() {
      return Bi !== null && Bi.apply(this, arguments) || this;
    }
    return e.prototype.componentDidMount = function() {
      var qi = this, Xi = this.props, Qi = Xi.visualElement, ta = Xi.layoutGroup, ra = Xi.switchLayoutGroup, na = Xi.layoutId, la = Qi.projection;
      addScaleCorrector(defaultScaleCorrectors), la && (ta?.group && ta.group.add(la), ra?.register && na && ra.register(la), la.root.didUpdate(), la.addEventListener("animationComplete", function() {
        qi.safeToRemove();
      }), la.setOptions(__assign(__assign({}, la.options), { onExitComplete: function() {
        return qi.safeToRemove();
      } }))), globalProjectionState.hasEverUpdated = !0;
    }, e.prototype.getSnapshotBeforeUpdate = function(qi) {
      var Xi = this, Qi = this.props, ta = Qi.layoutDependency, ra = Qi.visualElement, na = Qi.drag, la = Qi.isPresent, Ma = ra.projection;
      return Ma && (Ma.isPresent = la, na || qi.layoutDependency !== ta || ta === void 0 ? Ma.willUpdate() : this.safeToRemove(), qi.isPresent !== la && (la ? Ma.promote() : Ma.relegate() || sync.postRender(function() {
        var Va;
        !((Va = Ma.getStack()) === null || Va === void 0) && Va.members.length || Xi.safeToRemove();
      }))), null;
    }, e.prototype.componentDidUpdate = function() {
      var qi = this.props.visualElement.projection;
      qi && (qi.root.didUpdate(), !qi.currentAnimation && qi.isLead() && this.safeToRemove());
    }, e.prototype.componentWillUnmount = function() {
      var qi = this.props, Xi = qi.visualElement, Qi = qi.layoutGroup, ta = qi.switchLayoutGroup, ra = Xi.projection;
      ra && (ra.scheduleCheckAfterUnmount(), Qi?.group && Qi.group.remove(ra), ta?.deregister && ta.deregister(ra));
    }, e.prototype.safeToRemove = function() {
      var qi = this.props.safeToRemove;
      qi?.();
    }, e.prototype.render = function() {
      return null;
    }, e;
  }(a__default.Component)
);
function MeasureLayout(Bi) {
  var e = __read(usePresence(), 2), qi = e[0], Xi = e[1], Qi = useContext(LayoutGroupContext);
  return a__default.createElement(MeasureLayoutWithContext, __assign({}, Bi, { layoutGroup: Qi, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: qi, safeToRemove: Xi }));
}
var defaultScaleCorrectors = {
  borderRadius: __assign(__assign({}, correctBorderRadius), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
}, layoutFeatures = {
  measureLayout: MeasureLayout
};
function animate(Bi, e, qi) {
  qi === void 0 && (qi = {});
  var Xi = isMotionValue(Bi) ? Bi : motionValue(Bi);
  return startAnimation("", Xi, e, qi), {
    stop: function() {
      return Xi.stop();
    },
    isAnimating: function() {
      return Xi.isAnimating();
    }
  };
}
var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = function(Bi) {
  return typeof Bi == "string" ? parseFloat(Bi) : Bi;
}, isPx = function(Bi) {
  return typeof Bi == "number" || px.test(Bi);
};
function mixValues(Bi, e, qi, Xi, Qi, ta) {
  var ra, na, la, Ma;
  Qi ? (Bi.opacity = mix(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (ra = qi.opacity) !== null && ra !== void 0 ? ra : 1,
    easeCrossfadeIn(Xi)
  ), Bi.opacityExit = mix((na = e.opacity) !== null && na !== void 0 ? na : 1, 0, easeCrossfadeOut(Xi))) : ta && (Bi.opacity = mix((la = e.opacity) !== null && la !== void 0 ? la : 1, (Ma = qi.opacity) !== null && Ma !== void 0 ? Ma : 1, Xi));
  for (var Va = 0; Va < numBorders; Va++) {
    var to = "border".concat(borders[Va], "Radius"), Eo = getRadius(e, to), So = getRadius(qi, to);
    if (!(Eo === void 0 && So === void 0)) {
      Eo || (Eo = 0), So || (So = 0);
      var eo = Eo === 0 || So === 0 || isPx(Eo) === isPx(So);
      eo ? (Bi[to] = Math.max(mix(asNumber(Eo), asNumber(So), Xi), 0), (percent.test(So) || percent.test(Eo)) && (Bi[to] += "%")) : Bi[to] = So;
    }
  }
  (e.rotate || qi.rotate) && (Bi.rotate = mix(e.rotate || 0, qi.rotate || 0, Xi));
}
function getRadius(Bi, e) {
  var qi;
  return (qi = Bi[e]) !== null && qi !== void 0 ? qi : Bi.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut), easeCrossfadeOut = compress(0.5, 0.95, linear);
function compress(Bi, e, qi) {
  return function(Xi) {
    return Xi < Bi ? 0 : Xi > e ? 1 : qi(progress(Bi, e, Xi));
  };
}
function copyAxisInto(Bi, e) {
  Bi.min = e.min, Bi.max = e.max;
}
function copyBoxInto(Bi, e) {
  copyAxisInto(Bi.x, e.x), copyAxisInto(Bi.y, e.y);
}
function removePointDelta(Bi, e, qi, Xi, Qi) {
  return Bi -= e, Bi = scalePoint(Bi, 1 / qi, Xi), Qi !== void 0 && (Bi = scalePoint(Bi, 1 / Qi, Xi)), Bi;
}
function removeAxisDelta(Bi, e, qi, Xi, Qi, ta, ra) {
  if (e === void 0 && (e = 0), qi === void 0 && (qi = 1), Xi === void 0 && (Xi = 0.5), ta === void 0 && (ta = Bi), ra === void 0 && (ra = Bi), percent.test(e)) {
    e = parseFloat(e);
    var na = mix(ra.min, ra.max, e / 100);
    e = na - ra.min;
  }
  if (typeof e == "number") {
    var la = mix(ta.min, ta.max, Xi);
    Bi === ta && (la -= e), Bi.min = removePointDelta(Bi.min, e, qi, la, Qi), Bi.max = removePointDelta(Bi.max, e, qi, la, Qi);
  }
}
function removeAxisTransforms(Bi, e, qi, Xi, Qi) {
  var ta = __read(qi, 3), ra = ta[0], na = ta[1], la = ta[2];
  removeAxisDelta(Bi, e[ra], e[na], e[la], e.scale, Xi, Qi);
}
var xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(Bi, e, qi, Xi) {
  removeAxisTransforms(Bi.x, e, xKeys, qi?.x, Xi?.x), removeAxisTransforms(Bi.y, e, yKeys, qi?.y, Xi?.y);
}
function isAxisDeltaZero(Bi) {
  return Bi.translate === 0 && Bi.scale === 1;
}
function isDeltaZero(Bi) {
  return isAxisDeltaZero(Bi.x) && isAxisDeltaZero(Bi.y);
}
function boxEquals(Bi, e) {
  return Bi.x.min === e.x.min && Bi.x.max === e.x.max && Bi.y.min === e.y.min && Bi.y.max === e.y.max;
}
var NodeStack = (
  /** @class */
  function() {
    function Bi() {
      this.members = [];
    }
    return Bi.prototype.add = function(e) {
      addUniqueItem(this.members, e), e.scheduleRender();
    }, Bi.prototype.remove = function(e) {
      if (removeItem(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
        var qi = this.members[this.members.length - 1];
        qi && this.promote(qi);
      }
    }, Bi.prototype.relegate = function(e) {
      var qi = this.members.findIndex(function(ra) {
        return e === ra;
      });
      if (qi === 0)
        return !1;
      for (var Xi, Qi = qi; Qi >= 0; Qi--) {
        var ta = this.members[Qi];
        if (ta.isPresent !== !1) {
          Xi = ta;
          break;
        }
      }
      return Xi ? (this.promote(Xi), !0) : !1;
    }, Bi.prototype.promote = function(e, qi) {
      var Xi, Qi = this.lead;
      if (e !== Qi && (this.prevLead = Qi, this.lead = e, e.show(), Qi)) {
        Qi.instance && Qi.scheduleRender(), e.scheduleRender(), e.resumeFrom = Qi, qi && (e.resumeFrom.preserveOpacity = !0), Qi.snapshot && (e.snapshot = Qi.snapshot, e.snapshot.latestValues = Qi.animationValues || Qi.latestValues, e.snapshot.isShared = !0), !((Xi = e.root) === null || Xi === void 0) && Xi.isUpdating && (e.isLayoutDirty = !0);
        var ta = e.options.crossfade;
        ta === !1 && Qi.hide();
      }
    }, Bi.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(e) {
        var qi, Xi, Qi, ta, ra;
        (Xi = (qi = e.options).onExitComplete) === null || Xi === void 0 || Xi.call(qi), (ra = (Qi = e.resumingFrom) === null || Qi === void 0 ? void 0 : (ta = Qi.options).onExitComplete) === null || ra === void 0 || ra.call(ta);
      });
    }, Bi.prototype.scheduleRender = function() {
      this.members.forEach(function(e) {
        e.instance && e.scheduleRender(!1);
      });
    }, Bi.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, Bi;
  }()
), identityProjection = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function buildProjectionTransform(Bi, e, qi) {
  var Xi = Bi.x.translate / e.x, Qi = Bi.y.translate / e.y, ta = "translate3d(".concat(Xi, "px, ").concat(Qi, "px, 0) ");
  if (ta += "scale(".concat(1 / e.x, ", ").concat(1 / e.y, ") "), qi) {
    var ra = qi.rotate, na = qi.rotateX, la = qi.rotateY;
    ra && (ta += "rotate(".concat(ra, "deg) ")), na && (ta += "rotateX(".concat(na, "deg) ")), la && (ta += "rotateY(".concat(la, "deg) "));
  }
  var Ma = Bi.x.scale * e.x, Va = Bi.y.scale * e.y;
  return ta += "scale(".concat(Ma, ", ").concat(Va, ")"), ta === identityProjection ? "none" : ta;
}
var compareByDepth = function(Bi, e) {
  return Bi.depth - e.depth;
}, FlatTree = (
  /** @class */
  function() {
    function Bi() {
      this.children = [], this.isDirty = !1;
    }
    return Bi.prototype.add = function(e) {
      addUniqueItem(this.children, e), this.isDirty = !0;
    }, Bi.prototype.remove = function(e) {
      removeItem(this.children, e), this.isDirty = !0;
    }, Bi.prototype.forEach = function(e) {
      this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(e);
    }, Bi;
  }()
), animationTarget = 1e3;
function createProjectionNode(Bi) {
  var e = Bi.attachResizeListener, qi = Bi.defaultParent, Xi = Bi.measureScroll, Qi = Bi.checkIsScrollRoot, ta = Bi.resetTransform;
  return (
    /** @class */
    function() {
      function ra(na, la, Ma) {
        var Va = this;
        la === void 0 && (la = {}), Ma === void 0 && (Ma = qi?.()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          Va.isUpdating && (Va.isUpdating = !1, Va.clearAllSnapshots());
        }, this.updateProjection = function() {
          Va.nodes.forEach(resolveTargetDelta), Va.nodes.forEach(calcProjection);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = na, this.latestValues = la, this.root = Ma ? Ma.root || Ma : this, this.path = Ma ? __spreadArray(__spreadArray([], __read(Ma.path), !1), [Ma], !1) : [], this.parent = Ma, this.depth = Ma ? Ma.depth + 1 : 0, na && this.root.registerPotentialNode(na, this);
        for (var to = 0; to < this.path.length; to++)
          this.path[to].shouldResetTransform = !0;
        this.root === this && (this.nodes = new FlatTree());
      }
      return ra.prototype.addEventListener = function(na, la) {
        return this.eventHandlers.has(na) || this.eventHandlers.set(na, new SubscriptionManager()), this.eventHandlers.get(na).add(la);
      }, ra.prototype.notifyListeners = function(na) {
        for (var la = [], Ma = 1; Ma < arguments.length; Ma++)
          la[Ma - 1] = arguments[Ma];
        var Va = this.eventHandlers.get(na);
        Va?.notify.apply(Va, __spreadArray([], __read(la), !1));
      }, ra.prototype.hasListeners = function(na) {
        return this.eventHandlers.has(na);
      }, ra.prototype.registerPotentialNode = function(na, la) {
        this.potentialNodes.set(na, la);
      }, ra.prototype.mount = function(na, la) {
        var Ma = this, Va;
        if (la === void 0 && (la = !1), !this.instance) {
          this.isSVG = na instanceof SVGElement && na.tagName !== "svg", this.instance = na;
          var to = this.options, Eo = to.layoutId, So = to.layout, eo = to.visualElement;
          if (eo && !eo.getInstance() && eo.mount(na), this.root.nodes.add(this), (Va = this.parent) === null || Va === void 0 || Va.children.add(this), this.id && this.root.potentialNodes.delete(this.id), la && (So || Eo) && (this.isLayoutDirty = !0), e) {
            var rs, ko = function() {
              return Ma.root.updateBlockedByResize = !1;
            };
            e(na, function() {
              Ma.root.updateBlockedByResize = !0, clearTimeout(rs), rs = window.setTimeout(ko, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, Ma.nodes.forEach(finishAnimation));
            });
          }
          Eo && this.root.registerSharedNode(Eo, this), this.options.animate !== !1 && eo && (Eo || So) && this.addEventListener("didUpdate", function(Hs) {
            var Ks, Ys, Xs, Cs, Fs, ws = Hs.delta, ls = Hs.hasLayoutChanged, ks = Hs.hasRelativeTargetChanged, Js = Hs.layout;
            if (Ma.isTreeAnimationBlocked()) {
              Ma.target = void 0, Ma.relativeTarget = void 0;
              return;
            }
            var pl = (Ys = (Ks = Ma.options.transition) !== null && Ks !== void 0 ? Ks : eo.getDefaultTransition()) !== null && Ys !== void 0 ? Ys : defaultLayoutTransition, _l = eo.getProps(), bl = _l.onLayoutAnimationStart, xl = _l.onLayoutAnimationComplete, Rl = !Ma.targetLayout || !boxEquals(Ma.targetLayout, Js) || ks, Cl = !ls && ks;
            if (!((Xs = Ma.resumeFrom) === null || Xs === void 0) && Xs.instance || Cl || ls && (Rl || !Ma.currentAnimation)) {
              Ma.resumeFrom && (Ma.resumingFrom = Ma.resumeFrom, Ma.resumingFrom.resumingFrom = void 0), Ma.setAnimationOrigin(ws, Cl);
              var Dl = __assign(__assign({}, getValueTransition(pl, "layout")), { onPlay: bl, onComplete: xl });
              eo.shouldReduceMotion && (Dl.delay = 0, Dl.type = !1), Ma.startAnimation(Dl);
            } else
              !ls && Ma.animationProgress === 0 && Ma.finishAnimation(), Ma.isLead() && ((Fs = (Cs = Ma.options).onExitComplete) === null || Fs === void 0 || Fs.call(Cs));
            Ma.targetLayout = Js;
          });
        }
      }, ra.prototype.unmount = function() {
        var na, la;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (na = this.getStack()) === null || na === void 0 || na.remove(this), (la = this.parent) === null || la === void 0 || la.children.delete(this), this.instance = void 0, cancelSync.preRender(this.updateProjection);
      }, ra.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, ra.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, ra.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, ra.prototype.isTreeAnimationBlocked = function() {
        var na;
        return this.isAnimationBlocked || ((na = this.parent) === null || na === void 0 ? void 0 : na.isTreeAnimationBlocked()) || !1;
      }, ra.prototype.startUpdate = function() {
        var na;
        this.isUpdateBlocked() || (this.isUpdating = !0, (na = this.nodes) === null || na === void 0 || na.forEach(resetRotation));
      }, ra.prototype.willUpdate = function(na) {
        var la, Ma, Va;
        if (na === void 0 && (na = !0), this.root.isUpdateBlocked()) {
          (Ma = (la = this.options).onExitComplete) === null || Ma === void 0 || Ma.call(la);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var to = 0; to < this.path.length; to++) {
            var Eo = this.path[to];
            Eo.shouldResetTransform = !0, Eo.updateScroll();
          }
          var So = this.options, eo = So.layoutId, rs = So.layout;
          if (!(eo === void 0 && !rs)) {
            var ko = (Va = this.options.visualElement) === null || Va === void 0 ? void 0 : Va.getProps().transformTemplate;
            this.prevTransformTemplateValue = ko?.(this.latestValues, ""), this.updateSnapshot(), na && this.notifyListeners("willUpdate");
          }
        }
      }, ra.prototype.didUpdate = function() {
        var na = this.isUpdateBlocked();
        if (na) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(mountNodeEarly), this.potentialNodes.clear()), this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate), this.clearAllSnapshots(), flushSync.update(), flushSync.preRender(), flushSync.render());
      }, ra.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
      }, ra.prototype.scheduleUpdateProjection = function() {
        sync.preRender(this.updateProjection, !1, !0);
      }, ra.prototype.scheduleCheckAfterUnmount = function() {
        var na = this;
        sync.postRender(function() {
          na.isLayoutDirty ? na.root.didUpdate() : na.root.checkUpdateFailed();
        });
      }, ra.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var na = this.measure(), la = this.removeTransform(this.removeElementScroll(na));
          roundBox(la), this.snapshot = {
            measured: na,
            layout: la,
            latestValues: {}
          };
        }
      }, ra.prototype.updateLayout = function() {
        var na;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var la = 0; la < this.path.length; la++) {
              var Ma = this.path[la];
              Ma.updateScroll();
            }
          var Va = this.measure();
          roundBox(Va);
          var to = this.layout;
          this.layout = {
            measured: Va,
            actual: this.removeElementScroll(Va)
          }, this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (na = this.options.visualElement) === null || na === void 0 || na.notifyLayoutMeasure(this.layout.actual, to?.actual);
        }
      }, ra.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = Qi(this.instance), this.scroll = Xi(this.instance));
      }, ra.prototype.resetTransform = function() {
        var na;
        if (ta) {
          var la = this.isLayoutDirty || this.shouldResetTransform, Ma = this.projectionDelta && !isDeltaZero(this.projectionDelta), Va = (na = this.options.visualElement) === null || na === void 0 ? void 0 : na.getProps().transformTemplate, to = Va?.(this.latestValues, ""), Eo = to !== this.prevTransformTemplateValue;
          la && (Ma || hasTransform(this.latestValues) || Eo) && (ta(this.instance, to), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, ra.prototype.measure = function() {
        var na = this.options.visualElement;
        if (!na)
          return createBox();
        var la = na.measureViewportBox(), Ma = this.root.scroll;
        return Ma && (translateAxis(la.x, Ma.x), translateAxis(la.y, Ma.y)), la;
      }, ra.prototype.removeElementScroll = function(na) {
        var la = createBox();
        copyBoxInto(la, na);
        for (var Ma = 0; Ma < this.path.length; Ma++) {
          var Va = this.path[Ma], to = Va.scroll, Eo = Va.options, So = Va.isScrollRoot;
          if (Va !== this.root && to && Eo.layoutScroll) {
            if (So) {
              copyBoxInto(la, na);
              var eo = this.root.scroll;
              eo && (translateAxis(la.x, -eo.x), translateAxis(la.y, -eo.y));
            }
            translateAxis(la.x, to.x), translateAxis(la.y, to.y);
          }
        }
        return la;
      }, ra.prototype.applyTransform = function(na, la) {
        la === void 0 && (la = !1);
        var Ma = createBox();
        copyBoxInto(Ma, na);
        for (var Va = 0; Va < this.path.length; Va++) {
          var to = this.path[Va];
          !la && to.options.layoutScroll && to.scroll && to !== to.root && transformBox(Ma, {
            x: -to.scroll.x,
            y: -to.scroll.y
          }), hasTransform(to.latestValues) && transformBox(Ma, to.latestValues);
        }
        return hasTransform(this.latestValues) && transformBox(Ma, this.latestValues), Ma;
      }, ra.prototype.removeTransform = function(na) {
        var la, Ma = createBox();
        copyBoxInto(Ma, na);
        for (var Va = 0; Va < this.path.length; Va++) {
          var to = this.path[Va];
          if (to.instance && hasTransform(to.latestValues)) {
            hasScale(to.latestValues) && to.updateSnapshot();
            var Eo = createBox(), So = to.measure();
            copyBoxInto(Eo, So), removeBoxTransforms(Ma, to.latestValues, (la = to.snapshot) === null || la === void 0 ? void 0 : la.layout, Eo);
          }
        }
        return hasTransform(this.latestValues) && removeBoxTransforms(Ma, this.latestValues), Ma;
      }, ra.prototype.setTargetDelta = function(na) {
        this.targetDelta = na, this.root.scheduleUpdateProjection();
      }, ra.prototype.setOptions = function(na) {
        var la;
        this.options = __assign(__assign(__assign({}, this.options), na), { crossfade: (la = na.crossfade) !== null && la !== void 0 ? la : !0 });
      }, ra.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, ra.prototype.resolveTargetDelta = function() {
        var na, la = this.options, Ma = la.layout, Va = la.layoutId;
        !this.layout || !(Ma || Va) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && (!((na = this.relativeParent) === null || na === void 0) && na.target) ? calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : copyBoxInto(this.target, this.layout.actual), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)))));
      }, ra.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || hasTransform(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, ra.prototype.calcProjection = function() {
        var na, la = this.options, Ma = la.layout, Va = la.layoutId;
        if (this.isTreeAnimating = !!(!((na = this.parent) === null || na === void 0) && na.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(Ma || Va))) {
          var to = this.getLead();
          copyBoxInto(this.layoutCorrected, this.layout.actual), applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== to);
          var Eo = to.target;
          if (Eo) {
            this.projectionDelta || (this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta());
            var So = this.treeScale.x, eo = this.treeScale.y, rs = this.projectionTransform;
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, Eo, this.latestValues), this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale), (this.projectionTransform !== rs || this.treeScale.x !== So || this.treeScale.y !== eo) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", Eo));
          }
        }
      }, ra.prototype.hide = function() {
        this.isVisible = !1;
      }, ra.prototype.show = function() {
        this.isVisible = !0;
      }, ra.prototype.scheduleRender = function(na) {
        var la, Ma, Va;
        na === void 0 && (na = !0), (Ma = (la = this.options).scheduleRender) === null || Ma === void 0 || Ma.call(la), na && ((Va = this.getStack()) === null || Va === void 0 || Va.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, ra.prototype.setAnimationOrigin = function(na, la) {
        var Ma = this, Va;
        la === void 0 && (la = !1);
        var to = this.snapshot, Eo = to?.latestValues || {}, So = __assign({}, this.latestValues), eo = createDelta();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !la;
        var rs = createBox(), ko = to?.isShared, Hs = (((Va = this.getStack()) === null || Va === void 0 ? void 0 : Va.members.length) || 0) <= 1, Ks = !!(ko && !Hs && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
        this.animationProgress = 0, this.mixTargetDelta = function(Ys) {
          var Xs, Cs = Ys / 1e3;
          mixAxisDelta(eo.x, na.x, Cs), mixAxisDelta(eo.y, na.y, Cs), Ma.setTargetDelta(eo), Ma.relativeTarget && Ma.relativeTargetOrigin && Ma.layout && (!((Xs = Ma.relativeParent) === null || Xs === void 0) && Xs.layout) && (calcRelativePosition(rs, Ma.layout.actual, Ma.relativeParent.layout.actual), mixBox(Ma.relativeTarget, Ma.relativeTargetOrigin, rs, Cs)), ko && (Ma.animationValues = So, mixValues(So, Eo, Ma.latestValues, Cs, Ks, Hs)), Ma.root.scheduleUpdateProjection(), Ma.scheduleRender(), Ma.animationProgress = Cs;
        }, this.mixTargetDelta(0);
      }, ra.prototype.startAnimation = function(na) {
        var la = this, Ma, Va;
        this.notifyListeners("animationStart"), (Ma = this.currentAnimation) === null || Ma === void 0 || Ma.stop(), this.resumingFrom && ((Va = this.resumingFrom.currentAnimation) === null || Va === void 0 || Va.stop()), this.pendingAnimation && (cancelSync.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = sync.update(function() {
          globalProjectionState.hasAnimatedSinceResize = !0, la.currentAnimation = animate(0, animationTarget, __assign(__assign({}, na), { onUpdate: function(to) {
            var Eo;
            la.mixTargetDelta(to), (Eo = na.onUpdate) === null || Eo === void 0 || Eo.call(na, to);
          }, onComplete: function() {
            var to;
            (to = na.onComplete) === null || to === void 0 || to.call(na), la.completeAnimation();
          } })), la.resumingFrom && (la.resumingFrom.currentAnimation = la.currentAnimation), la.pendingAnimation = void 0;
        });
      }, ra.prototype.completeAnimation = function() {
        var na;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (na = this.getStack()) === null || na === void 0 || na.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, ra.prototype.finishAnimation = function() {
        var na;
        this.currentAnimation && ((na = this.mixTargetDelta) === null || na === void 0 || na.call(this, animationTarget), this.currentAnimation.stop()), this.completeAnimation();
      }, ra.prototype.applyTransformsToTarget = function() {
        var na = this.getLead(), la = na.targetWithTransforms, Ma = na.target, Va = na.layout, to = na.latestValues;
        !la || !Ma || !Va || (copyBoxInto(la, Ma), transformBox(la, to), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, la, to));
      }, ra.prototype.registerSharedNode = function(na, la) {
        var Ma, Va, to;
        this.sharedNodes.has(na) || this.sharedNodes.set(na, new NodeStack());
        var Eo = this.sharedNodes.get(na);
        Eo.add(la), la.promote({
          transition: (Ma = la.options.initialPromotionConfig) === null || Ma === void 0 ? void 0 : Ma.transition,
          preserveFollowOpacity: (to = (Va = la.options.initialPromotionConfig) === null || Va === void 0 ? void 0 : Va.shouldPreserveFollowOpacity) === null || to === void 0 ? void 0 : to.call(Va, la)
        });
      }, ra.prototype.isLead = function() {
        var na = this.getStack();
        return na ? na.lead === this : !0;
      }, ra.prototype.getLead = function() {
        var na, la = this.options.layoutId;
        return la ? ((na = this.getStack()) === null || na === void 0 ? void 0 : na.lead) || this : this;
      }, ra.prototype.getPrevLead = function() {
        var na, la = this.options.layoutId;
        return la ? (na = this.getStack()) === null || na === void 0 ? void 0 : na.prevLead : void 0;
      }, ra.prototype.getStack = function() {
        var na = this.options.layoutId;
        if (na)
          return this.root.sharedNodes.get(na);
      }, ra.prototype.promote = function(na) {
        var la = na === void 0 ? {} : na, Ma = la.needsReset, Va = la.transition, to = la.preserveFollowOpacity, Eo = this.getStack();
        Eo && Eo.promote(this, to), Ma && (this.projectionDelta = void 0, this.needsReset = !0), Va && this.setOptions({ transition: Va });
      }, ra.prototype.relegate = function() {
        var na = this.getStack();
        return na ? na.relegate(this) : !1;
      }, ra.prototype.resetRotation = function() {
        var na = this.options.visualElement;
        if (na) {
          for (var la = !1, Ma = {}, Va = 0; Va < transformAxes.length; Va++) {
            var to = transformAxes[Va], Eo = "rotate" + to;
            na.getStaticValue(Eo) && (la = !0, Ma[Eo] = na.getStaticValue(Eo), na.setStaticValue(Eo, 0));
          }
          if (la) {
            na?.syncRender();
            for (var Eo in Ma)
              na.setStaticValue(Eo, Ma[Eo]);
            na.scheduleRender();
          }
        }
      }, ra.prototype.getProjectionStyles = function(na) {
        var la, Ma, Va, to, Eo, So;
        na === void 0 && (na = {});
        var eo = {};
        if (!this.instance || this.isSVG)
          return eo;
        if (this.isVisible)
          eo.visibility = "";
        else
          return { visibility: "hidden" };
        var rs = (la = this.options.visualElement) === null || la === void 0 ? void 0 : la.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, eo.opacity = "", eo.pointerEvents = resolveMotionValue(na.pointerEvents) || "", eo.transform = rs ? rs(this.latestValues, "") : "none", eo;
        var ko = this.getLead();
        if (!this.projectionDelta || !this.layout || !ko.target) {
          var Hs = {};
          return this.options.layoutId && (Hs.opacity = (Ma = this.latestValues.opacity) !== null && Ma !== void 0 ? Ma : 1, Hs.pointerEvents = resolveMotionValue(na.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (Hs.transform = rs ? rs({}, "") : "none", this.hasProjected = !1), Hs;
        }
        var Ks = ko.animationValues || ko.latestValues;
        this.applyTransformsToTarget(), eo.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, Ks), rs && (eo.transform = rs(Ks, eo.transform));
        var Ys = this.projectionDelta, Xs = Ys.x, Cs = Ys.y;
        eo.transformOrigin = "".concat(Xs.origin * 100, "% ").concat(Cs.origin * 100, "% 0"), ko.animationValues ? eo.opacity = ko === this ? (to = (Va = Ks.opacity) !== null && Va !== void 0 ? Va : this.latestValues.opacity) !== null && to !== void 0 ? to : 1 : this.preserveOpacity ? this.latestValues.opacity : Ks.opacityExit : eo.opacity = ko === this ? (Eo = Ks.opacity) !== null && Eo !== void 0 ? Eo : "" : (So = Ks.opacityExit) !== null && So !== void 0 ? So : 0;
        for (var Fs in scaleCorrectors)
          if (Ks[Fs] !== void 0) {
            var ws = scaleCorrectors[Fs], ls = ws.correct, ks = ws.applyTo, Js = ls(Ks[Fs], ko);
            if (ks)
              for (var pl = ks.length, _l = 0; _l < pl; _l++)
                eo[ks[_l]] = Js;
            else
              eo[Fs] = Js;
          }
        return this.options.layoutId && (eo.pointerEvents = ko === this ? resolveMotionValue(na.pointerEvents) || "" : "none"), eo;
      }, ra.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, ra.prototype.resetTree = function() {
        this.root.nodes.forEach(function(na) {
          var la;
          return (la = na.currentAnimation) === null || la === void 0 ? void 0 : la.stop();
        }), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
      }, ra;
    }()
  );
}
function updateLayout(Bi) {
  Bi.updateLayout();
}
function notifyLayoutUpdate(Bi) {
  var e, qi, Xi, Qi, ta = (qi = (e = Bi.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) !== null && qi !== void 0 ? qi : Bi.snapshot;
  if (Bi.isLead() && Bi.layout && ta && Bi.hasListeners("didUpdate")) {
    var ra = Bi.layout, na = ra.actual, la = ra.measured;
    Bi.options.animationType === "size" ? eachAxis(function(Ks) {
      var Ys = ta.isShared ? ta.measured[Ks] : ta.layout[Ks], Xs = calcLength(Ys);
      Ys.min = na[Ks].min, Ys.max = Ys.min + Xs;
    }) : Bi.options.animationType === "position" && eachAxis(function(Ks) {
      var Ys = ta.isShared ? ta.measured[Ks] : ta.layout[Ks], Xs = calcLength(na[Ks]);
      Ys.max = Ys.min + Xs;
    });
    var Ma = createDelta();
    calcBoxDelta(Ma, na, ta.layout);
    var Va = createDelta();
    ta.isShared ? calcBoxDelta(Va, Bi.applyTransform(la, !0), ta.measured) : calcBoxDelta(Va, na, ta.layout);
    var to = !isDeltaZero(Ma), Eo = !1;
    if (!Bi.resumeFrom && (Bi.relativeParent = Bi.getClosestProjectingParent(), Bi.relativeParent && !Bi.relativeParent.resumeFrom)) {
      var So = Bi.relativeParent, eo = So.snapshot, rs = So.layout;
      if (eo && rs) {
        var ko = createBox();
        calcRelativePosition(ko, ta.layout, eo.layout);
        var Hs = createBox();
        calcRelativePosition(Hs, na, rs.actual), boxEquals(ko, Hs) || (Eo = !0);
      }
    }
    Bi.notifyListeners("didUpdate", {
      layout: na,
      snapshot: ta,
      delta: Va,
      layoutDelta: Ma,
      hasLayoutChanged: to,
      hasRelativeTargetChanged: Eo
    });
  } else Bi.isLead() && ((Qi = (Xi = Bi.options).onExitComplete) === null || Qi === void 0 || Qi.call(Xi));
  Bi.options.transition = void 0;
}
function clearSnapshot(Bi) {
  Bi.clearSnapshot();
}
function clearMeasurements(Bi) {
  Bi.clearMeasurements();
}
function resetTransformStyle(Bi) {
  var e = Bi.options.visualElement;
  e?.getProps().onBeforeLayoutMeasure && e.notifyBeforeLayoutMeasure(), Bi.resetTransform();
}
function finishAnimation(Bi) {
  Bi.finishAnimation(), Bi.targetDelta = Bi.relativeTarget = Bi.target = void 0;
}
function resolveTargetDelta(Bi) {
  Bi.resolveTargetDelta();
}
function calcProjection(Bi) {
  Bi.calcProjection();
}
function resetRotation(Bi) {
  Bi.resetRotation();
}
function removeLeadSnapshots(Bi) {
  Bi.removeLeadSnapshot();
}
function mixAxisDelta(Bi, e, qi) {
  Bi.translate = mix(e.translate, 0, qi), Bi.scale = mix(e.scale, 1, qi), Bi.origin = e.origin, Bi.originPoint = e.originPoint;
}
function mixAxis(Bi, e, qi, Xi) {
  Bi.min = mix(e.min, qi.min, Xi), Bi.max = mix(e.max, qi.max, Xi);
}
function mixBox(Bi, e, qi, Xi) {
  mixAxis(Bi.x, e.x, qi.x, Xi), mixAxis(Bi.y, e.y, qi.y, Xi);
}
function hasOpacityCrossfade(Bi) {
  return Bi.animationValues && Bi.animationValues.opacityExit !== void 0;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function mountNodeEarly(Bi, e) {
  for (var qi = Bi.root, Xi = Bi.path.length - 1; Xi >= 0; Xi--)
    if (Bi.path[Xi].instance) {
      qi = Bi.path[Xi];
      break;
    }
  var Qi = qi && qi !== Bi.root ? qi.instance : document, ta = Qi.querySelector('[data-projection-id="'.concat(e, '"]'));
  ta && Bi.mount(ta, !0);
}
function roundAxis(Bi) {
  Bi.min = Math.round(Bi.min), Bi.max = Math.round(Bi.max);
}
function roundBox(Bi) {
  roundAxis(Bi.x), roundAxis(Bi.y);
}
var DocumentProjectionNode = createProjectionNode({
  attachResizeListener: function(Bi, e) {
    return addDomEvent(Bi, "resize", e);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: function(Bi) {
    return {
      x: Bi.scrollLeft,
      y: Bi.scrollTop
    };
  },
  defaultParent: function() {
    if (!rootProjectionNode.current) {
      var Bi = new DocumentProjectionNode(0, {});
      Bi.mount(window), Bi.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = Bi;
    }
    return rootProjectionNode.current;
  },
  resetTransform: function(Bi, e) {
    Bi.style.transform = e ?? "none";
  },
  checkIsScrollRoot: function(Bi) {
    return window.getComputedStyle(Bi).position === "fixed";
  }
}), featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutFeatures), motion = /* @__PURE__ */ createMotionProxy(function(Bi, e) {
  return createDomMotionConfig(Bi, e, featureBundle, createDomVisualElement, HTMLProjectionNode);
});
function useIsMounted() {
  var Bi = useRef(!1);
  return useIsomorphicLayoutEffect$1(function() {
    return Bi.current = !0, function() {
      Bi.current = !1;
    };
  }, []), Bi;
}
function useForceUpdate() {
  var Bi = useIsMounted(), e = __read(useState(0), 2), qi = e[0], Xi = e[1], Qi = useCallback(function() {
    Bi.current && Xi(qi + 1);
  }, [qi]), ta = useCallback(function() {
    return sync.postRender(Qi);
  }, [Qi]);
  return [ta, qi];
}
var PresenceChild = function(Bi) {
  var e = Bi.children, qi = Bi.initial, Xi = Bi.isPresent, Qi = Bi.onExitComplete, ta = Bi.custom, ra = Bi.presenceAffectsLayout, na = useConstant(newChildrenMap), la = useId(), Ma = useMemo(
    function() {
      return {
        id: la,
        initial: qi,
        isPresent: Xi,
        custom: ta,
        onExitComplete: function(Va) {
          var to, Eo;
          na.set(Va, !0);
          try {
            for (var So = __values(na.values()), eo = So.next(); !eo.done; eo = So.next()) {
              var rs = eo.value;
              if (!rs)
                return;
            }
          } catch (ko) {
            to = { error: ko };
          } finally {
            try {
              eo && !eo.done && (Eo = So.return) && Eo.call(So);
            } finally {
              if (to) throw to.error;
            }
          }
          Qi?.();
        },
        register: function(Va) {
          return na.set(Va, !1), function() {
            return na.delete(Va);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    ra ? void 0 : [Xi]
  );
  return useMemo(function() {
    na.forEach(function(Va, to) {
      return na.set(to, !1);
    });
  }, [Xi]), a$8.useEffect(function() {
    !Xi && !na.size && Qi?.();
  }, [Xi]), a$8.createElement(PresenceContext.Provider, { value: Ma }, e);
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}
var getChildKey = function(Bi) {
  return Bi.key || "";
};
function updateChildLookup(Bi, e) {
  Bi.forEach(function(qi) {
    var Xi = getChildKey(qi);
    e.set(Xi, qi);
  });
}
function onlyElements(Bi) {
  var e = [];
  return Children.forEach(Bi, function(qi) {
    isValidElement(qi) && e.push(qi);
  }), e;
}
var AnimatePresence = function(Bi) {
  var e = Bi.children, qi = Bi.custom, Xi = Bi.initial, Qi = Xi === void 0 ? !0 : Xi, ta = Bi.onExitComplete, ra = Bi.exitBeforeEnter, na = Bi.presenceAffectsLayout, la = na === void 0 ? !0 : na, Ma = __read(useForceUpdate(), 1), Va = Ma[0], to = useContext(LayoutGroupContext).forceRender;
  to && (Va = to);
  var Eo = useIsMounted(), So = onlyElements(e), eo = So, rs = /* @__PURE__ */ new Set(), ko = useRef(eo), Hs = useRef(/* @__PURE__ */ new Map()).current, Ks = useRef(!0);
  if (useIsomorphicLayoutEffect$1(function() {
    Ks.current = !1, updateChildLookup(So, Hs), ko.current = eo;
  }), useUnmountEffect(function() {
    Ks.current = !0, Hs.clear(), rs.clear();
  }), Ks.current)
    return a$8.createElement(a$8.Fragment, null, eo.map(function(ls) {
      return a$8.createElement(PresenceChild, { key: getChildKey(ls), isPresent: !0, initial: Qi ? void 0 : !1, presenceAffectsLayout: la }, ls);
    }));
  eo = __spreadArray([], __read(eo), !1);
  for (var Ys = ko.current.map(getChildKey), Xs = So.map(getChildKey), Cs = Ys.length, Fs = 0; Fs < Cs; Fs++) {
    var ws = Ys[Fs];
    Xs.indexOf(ws) === -1 && rs.add(ws);
  }
  return ra && rs.size && (eo = []), rs.forEach(function(ls) {
    if (Xs.indexOf(ls) === -1) {
      var ks = Hs.get(ls);
      if (ks) {
        var Js = Ys.indexOf(ls), pl = function() {
          Hs.delete(ls), rs.delete(ls);
          var _l = ko.current.findIndex(function(bl) {
            return bl.key === ls;
          });
          if (ko.current.splice(_l, 1), !rs.size) {
            if (ko.current = So, Eo.current === !1)
              return;
            Va(), ta && ta();
          }
        };
        eo.splice(Js, 0, a$8.createElement(PresenceChild, { key: getChildKey(ks), isPresent: !1, onExitComplete: pl, custom: qi, presenceAffectsLayout: la }, ks));
      }
    }
  }), eo = eo.map(function(ls) {
    var ks = ls.key;
    return rs.has(ks) ? ls : a$8.createElement(PresenceChild, { key: getChildKey(ls), isPresent: !0, presenceAffectsLayout: la }, ls);
  }), env !== "production" && ra && eo.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), a$8.createElement(a$8.Fragment, null, rs.size ? eo : eo.map(function(ls) {
    return cloneElement(ls);
  }));
}, DeprecatedLayoutGroupContext = createContext(null), notify = function(Bi) {
  return !Bi.isLayoutDirty && Bi.willUpdate(!1);
};
function nodeGroup() {
  var Bi = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new WeakMap(), qi = function() {
    return Bi.forEach(notify);
  };
  return {
    add: function(Xi) {
      Bi.add(Xi), e.set(Xi, Xi.addEventListener("willUpdate", qi));
    },
    remove: function(Xi) {
      var Qi;
      Bi.delete(Xi), (Qi = e.get(Xi)) === null || Qi === void 0 || Qi(), e.delete(Xi), qi();
    },
    dirty: qi
  };
}
var shouldInheritGroup = function(Bi) {
  return Bi === !0;
}, shouldInheritId = function(Bi) {
  return shouldInheritGroup(Bi === !0) || Bi === "id";
}, LayoutGroup = function(Bi) {
  var e, qi, Xi = Bi.children, Qi = Bi.id, ta = Bi.inheritId, ra = Bi.inherit, na = ra === void 0 ? !0 : ra;
  ta !== void 0 && (na = ta);
  var la = useContext(LayoutGroupContext), Ma = useContext(DeprecatedLayoutGroupContext), Va = __read(useForceUpdate(), 2), to = Va[0], Eo = Va[1], So = useRef(null), eo = (e = la.id) !== null && e !== void 0 ? e : Ma;
  So.current === null && (shouldInheritId(na) && eo && (Qi = Qi ? eo + "-" + Qi : eo), So.current = {
    id: Qi,
    group: shouldInheritGroup(na) && (qi = la?.group) !== null && qi !== void 0 ? qi : nodeGroup()
  });
  var rs = useMemo(function() {
    return __assign(__assign({}, So.current), { forceRender: to });
  }, [Eo]);
  return a$8.createElement(LayoutGroupContext.Provider, { value: rs }, Xi);
}, id = 0, AnimateSharedLayout = function(Bi) {
  var e = Bi.children;
  return a$8.useEffect(function() {
    warning$1(!1, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
  }, []), a$8.createElement(LayoutGroup, { id: useConstant(function() {
    return "asl-".concat(id++);
  }) }, e);
};
const exit = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, initial = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, Delete = ({ onDelete: Bi, className: e = "" }) => {
  const [qi, Xi] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    motion.button,
    {
      layout: !0,
      className: `${e} relative cursor-pointer bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400 z-0 px-4 py-2 text-sm text-white transition-all rounded-lg focus:outline-none focus:ring-2 focus:ring-opacity-75 disabled:opacity-50 disabled:cursor-default`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "opacity-0", children: qi ? "Sure?" : "Delete" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.p,
          {
            className: "absolute text-white",
            onClick: () => Xi(!0),
            exit,
            initial,
            children: !qi && "Delete"
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: qi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          motion.p,
          {
            className: "absolute text-white",
            onClick: () => Bi(),
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: "Sure?"
          }
        ) })
      ]
    }
  );
}, Divider = () => /* @__PURE__ */ jsxRuntimeExports.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), containerStyles$1 = cva(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), Drawer = ({
  visible: Bi,
  children: e,
  onClose: qi
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  Bi && /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => qi()
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: containerStyles$1({ visible: Bi }), children: e })
] }), size = 16, DrawerButton = ({
  sideBarVisible: Bi,
  onClick: e,
  className: qi = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  motion.svg,
  {
    className: `my-auto cursor-pointer ${qi}`,
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`,
    animate: Bi ? "open" : "closed",
    onClick: () => e(),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${size} 1` },
            open: { d: `M ${size} 0 L 0 ${size}` }
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${size / 2} L ${size} ${size / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${size - 1} L ${size} ${size - 1}` },
            open: { d: `M 0 0 L ${size} ${size}` }
          }
        }
      )
    ]
  }
), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document < "u" ? a__default.useLayoutEffect : () => {
};
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(Bi) {
  const e = useRef(null);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    e.current = Bi;
  }, [
    Bi
  ]), useCallback((...qi) => {
    const Xi = e.current;
    return Xi?.(...qi);
  }, []);
}
function $1dbecbe27a04f9af$export$14d238f342723f25(Bi) {
  let [e, qi] = useState(Bi), Xi = useRef(null), Qi = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (!Xi.current) return;
    let ra = Xi.current.next();
    if (ra.done) {
      Xi.current = null;
      return;
    }
    e === ra.value ? Qi() : qi(ra.value);
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Xi.current && Qi();
  });
  let ta = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ra) => {
    Xi.current = ra(e), Qi();
  });
  return [
    e,
    ta
  ];
}
const $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */ a__default.createContext($b5e257d569688ac6$var$defaultContext), $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */ a__default.createContext(!1);
let $b5e257d569688ac6$var$canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), $b5e257d569688ac6$var$componentIds = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter(Bi = !1) {
  let e = useContext($b5e257d569688ac6$var$SSRContext), qi = useRef(null);
  if (qi.current === null && !Bi) {
    var Xi, Qi;
    let ta = (Qi = a__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || Qi === void 0 || (Xi = Qi.ReactCurrentOwner) === null || Xi === void 0 ? void 0 : Xi.current;
    if (ta) {
      let ra = $b5e257d569688ac6$var$componentIds.get(ta);
      ra == null ? $b5e257d569688ac6$var$componentIds.set(ta, {
        id: e.current,
        state: ta.memoizedState
      }) : ta.memoizedState !== ra.state && (e.current = ra.id, $b5e257d569688ac6$var$componentIds.delete(ta));
    }
    qi.current = ++e.current;
  }
  return qi.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(Bi) {
  let e = useContext($b5e257d569688ac6$var$SSRContext);
  e === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let qi = $b5e257d569688ac6$var$useCounter(!!Bi), Xi = e === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${e.prefix}`;
  return Bi || `${Xi}-${qi}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(Bi) {
  let e = a__default.useId(), [qi] = useState($b5e257d569688ac6$export$535bd6ca7f90a273()), Xi = qi || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return Bi || `${Xi}-${e}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof a__default.useId == "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return !1;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return !0;
}
function $b5e257d569688ac6$var$subscribe(Bi) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  return typeof a__default.useSyncExternalStore == "function" ? a__default.useSyncExternalStore($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot) : useContext($b5e257d569688ac6$var$IsSSRContext);
}
let $bdb11010cef70236$var$canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), $bdb11010cef70236$var$idsUpdaterMap = /* @__PURE__ */ new Map();
function $bdb11010cef70236$export$f680877a34711e37(Bi) {
  let [e, qi] = useState(Bi), Xi = useRef(null), Qi = $b5e257d569688ac6$export$619500959fc48b26(e), ta = useCallback((ra) => {
    Xi.current = ra;
  }, []);
  return $bdb11010cef70236$var$canUseDOM && ($bdb11010cef70236$var$idsUpdaterMap.has(Qi) && !$bdb11010cef70236$var$idsUpdaterMap.get(Qi).includes(ta) ? $bdb11010cef70236$var$idsUpdaterMap.set(Qi, [
    ...$bdb11010cef70236$var$idsUpdaterMap.get(Qi),
    ta
  ]) : $bdb11010cef70236$var$idsUpdaterMap.set(Qi, [
    ta
  ])), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let ra = Qi;
    return () => {
      $bdb11010cef70236$var$idsUpdaterMap.delete(ra);
    };
  }, [
    Qi
  ]), useEffect(() => {
    let ra = Xi.current;
    ra && (Xi.current = null, qi(ra));
  }), Qi;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(Bi, e) {
  if (Bi === e) return Bi;
  let qi = $bdb11010cef70236$var$idsUpdaterMap.get(Bi);
  if (qi)
    return qi.forEach((Qi) => Qi(e)), e;
  let Xi = $bdb11010cef70236$var$idsUpdaterMap.get(e);
  return Xi ? (Xi.forEach((Qi) => Qi(Bi)), Bi) : e;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(Bi = []) {
  let e = $bdb11010cef70236$export$f680877a34711e37(), [qi, Xi] = $1dbecbe27a04f9af$export$14d238f342723f25(e), Qi = useCallback(() => {
    Xi(function* () {
      yield e, yield document.getElementById(e) ? e : void 0;
    });
  }, [
    e,
    Xi
  ]);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(Qi, [
    e,
    Qi,
    ...Bi
  ]), qi;
}
function $ff5963eb1fccf552$export$e08e3b67e392101e(...Bi) {
  return (...e) => {
    for (let qi of Bi) typeof qi == "function" && qi(...e);
  };
}
const $431fbd86ca7dc216$export$b204af158042fbac = (Bi) => {
  var e;
  return (e = Bi?.ownerDocument) !== null && e !== void 0 ? e : document;
}, $431fbd86ca7dc216$export$f21a1ffae260145a = (Bi) => Bi && "window" in Bi && Bi.window === Bi ? Bi : $431fbd86ca7dc216$export$b204af158042fbac(Bi).defaultView || window;
function $3ef42575df84b30b$export$9d1611c77c2fe928(...Bi) {
  let e = {
    ...Bi[0]
  };
  for (let qi = 1; qi < Bi.length; qi++) {
    let Xi = Bi[qi];
    for (let Qi in Xi) {
      let ta = e[Qi], ra = Xi[Qi];
      typeof ta == "function" && typeof ra == "function" && // This is a lot faster than a regex.
      Qi[0] === "o" && Qi[1] === "n" && Qi.charCodeAt(2) >= /* 'A' */
      65 && Qi.charCodeAt(2) <= /* 'Z' */
      90 ? e[Qi] = $ff5963eb1fccf552$export$e08e3b67e392101e(ta, ra) : (Qi === "className" || Qi === "UNSAFE_className") && typeof ta == "string" && typeof ra == "string" ? e[Qi] = clsx(ta, ra) : Qi === "id" && ta && ra ? e.id = $bdb11010cef70236$export$cd8c9cb68f842629(ta, ra) : e[Qi] = ra !== void 0 ? ra : ta;
    }
  }
  return e;
}
function $5dc95899b306f630$export$c9058316764c140e(...Bi) {
  return Bi.length === 1 && Bi[0] ? Bi[0] : (e) => {
    for (let qi of Bi)
      typeof qi == "function" ? qi(e) : qi != null && (qi.current = e);
  };
}
const $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]), $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, e = {}) {
  let { labelable: qi, isLink: Xi, propNames: Qi } = e, ta = {};
  for (const ra in Bi) Object.prototype.hasOwnProperty.call(Bi, ra) && ($65484d02dcb7eb3e$var$DOMPropNames.has(ra) || qi && $65484d02dcb7eb3e$var$labelablePropNames.has(ra) || Xi && $65484d02dcb7eb3e$var$linkPropNames.has(ra) || Qi?.has(ra) || $65484d02dcb7eb3e$var$propRe.test(ra)) && (ta[ra] = Bi[ra]);
  return ta;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(Bi) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) Bi.focus({
    preventScroll: !0
  });
  else {
    let e = $7215afc6de606d6b$var$getScrollableElements(Bi);
    Bi.focus(), $7215afc6de606d6b$var$restoreScrollPosition(e);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return $7215afc6de606d6b$var$supportsPreventScrollCached = !0, !0;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(Bi) {
  let e = Bi.parentNode, qi = [], Xi = document.scrollingElement || document.documentElement;
  for (; e instanceof HTMLElement && e !== Xi; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && qi.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return Xi instanceof HTMLElement && qi.push({
    element: Xi,
    scrollTop: Xi.scrollTop,
    scrollLeft: Xi.scrollLeft
  }), qi;
}
function $7215afc6de606d6b$var$restoreScrollPosition(Bi) {
  for (let { element: e, scrollTop: qi, scrollLeft: Xi } of Bi)
    e.scrollTop = qi, e.scrollLeft = Xi;
}
function $c87311424ea30a05$var$testUserAgent(Bi) {
  var e;
  return typeof window > "u" || window.navigator == null ? !1 : ((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.brands.some((qi) => Bi.test(qi.brand))) || Bi.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(Bi) {
  var e;
  return typeof window < "u" && window.navigator != null ? Bi.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function $c87311424ea30a05$var$cached(Bi) {
  let e = null;
  return () => (e == null && (e = Bi()), e);
}
const $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}), $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}), $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}), $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}), $c87311424ea30a05$export$e1865c3bedcd822b = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}), $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}), $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}), $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
}), $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
}), $ea8dcbcb9ea1b556$var$RouterContext = /* @__PURE__ */ createContext({
  isNative: !0,
  open: $ea8dcbcb9ea1b556$var$openSyntheticLink,
  useHref: (Bi) => Bi
});
function $ea8dcbcb9ea1b556$export$9a302a45f65d0572() {
  return useContext($ea8dcbcb9ea1b556$var$RouterContext);
}
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(Bi, e, qi = !0) {
  var Xi, Qi;
  let { metaKey: ta, ctrlKey: ra, altKey: na, shiftKey: la } = e;
  $c87311424ea30a05$export$b7d78993b74f766d() && (!((Qi = window.event) === null || Qi === void 0 || (Xi = Qi.type) === null || Xi === void 0) && Xi.startsWith("key")) && Bi.target === "_blank" && ($c87311424ea30a05$export$9ac100e40613ea10() ? ta = !0 : ra = !0);
  let Ma = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: ta,
    ctrlKey: ra,
    altKey: na,
    shiftKey: la
  }) : new MouseEvent("click", {
    metaKey: ta,
    ctrlKey: ra,
    altKey: na,
    shiftKey: la,
    bubbles: !0,
    cancelable: !0
  });
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = qi, $7215afc6de606d6b$export$de79e2c695e052f3(Bi), Bi.dispatchEvent(Ma), $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = !1;
}
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = !1;
function $ea8dcbcb9ea1b556$var$getSyntheticLink(Bi, e) {
  if (Bi instanceof HTMLAnchorElement) e(Bi);
  else if (Bi.hasAttribute("data-href")) {
    let qi = document.createElement("a");
    qi.href = Bi.getAttribute("data-href"), Bi.hasAttribute("data-target") && (qi.target = Bi.getAttribute("data-target")), Bi.hasAttribute("data-rel") && (qi.rel = Bi.getAttribute("data-rel")), Bi.hasAttribute("data-download") && (qi.download = Bi.getAttribute("data-download")), Bi.hasAttribute("data-ping") && (qi.ping = Bi.getAttribute("data-ping")), Bi.hasAttribute("data-referrer-policy") && (qi.referrerPolicy = Bi.getAttribute("data-referrer-policy")), Bi.appendChild(qi), e(qi), Bi.removeChild(qi);
  }
}
function $ea8dcbcb9ea1b556$var$openSyntheticLink(Bi, e) {
  $ea8dcbcb9ea1b556$var$getSyntheticLink(Bi, (qi) => $ea8dcbcb9ea1b556$export$95185d699e05d4d7(qi, e));
}
function $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(Bi) {
  let e = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  var qi;
  const Xi = e.useHref((qi = Bi?.href) !== null && qi !== void 0 ? qi : "");
  return {
    href: Bi?.href ? Xi : void 0,
    target: Bi?.target,
    rel: Bi?.rel,
    download: Bi?.download,
    ping: Bi?.ping,
    referrerPolicy: Bi?.referrerPolicy
  };
}
let $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map(), $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window > "u") return;
  function Bi(Xi) {
    return "propertyName" in Xi;
  }
  let e = (Xi) => {
    if (!Bi(Xi) || !Xi.target) return;
    let Qi = $bbed8b41f857bcc0$var$transitionsByElement.get(Xi.target);
    Qi || (Qi = /* @__PURE__ */ new Set(), $bbed8b41f857bcc0$var$transitionsByElement.set(Xi.target, Qi), Xi.target.addEventListener("transitioncancel", qi, {
      once: !0
    })), Qi.add(Xi.propertyName);
  }, qi = (Xi) => {
    if (!Bi(Xi) || !Xi.target) return;
    let Qi = $bbed8b41f857bcc0$var$transitionsByElement.get(Xi.target);
    if (Qi && (Qi.delete(Xi.propertyName), Qi.size === 0 && (Xi.target.removeEventListener("transitioncancel", qi), $bbed8b41f857bcc0$var$transitionsByElement.delete(Xi.target)), $bbed8b41f857bcc0$var$transitionsByElement.size === 0)) {
      for (let ta of $bbed8b41f857bcc0$var$transitionCallbacks) ta();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", qi);
}
typeof document < "u" && (document.readyState !== "loading" ? $bbed8b41f857bcc0$var$setupGlobalEvents() : document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents));
function $bbed8b41f857bcc0$export$24490316f764c430(Bi) {
  requestAnimationFrame(() => {
    $bbed8b41f857bcc0$var$transitionsByElement.size === 0 ? Bi() : $bbed8b41f857bcc0$var$transitionCallbacks.add(Bi);
  });
}
function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let Bi = useRef(/* @__PURE__ */ new Map()), e = useCallback((Qi, ta, ra, na) => {
    let la = na?.once ? (...Ma) => {
      Bi.current.delete(ra), ra(...Ma);
    } : ra;
    Bi.current.set(ra, {
      type: ta,
      eventTarget: Qi,
      fn: la,
      options: na
    }), Qi.addEventListener(ta, la, na);
  }, []), qi = useCallback((Qi, ta, ra, na) => {
    var la;
    let Ma = ((la = Bi.current.get(ra)) === null || la === void 0 ? void 0 : la.fn) || ra;
    Qi.removeEventListener(ta, Ma, na), Bi.current.delete(ra);
  }, []), Xi = useCallback(() => {
    Bi.current.forEach((Qi, ta) => {
      qi(Qi.eventTarget, Qi.type, ta, Qi.options);
    });
  }, [
    qi
  ]);
  return useEffect(() => Xi, [
    Xi
  ]), {
    addGlobalListener: e,
    removeGlobalListener: qi,
    removeAllGlobalListeners: Xi
  };
}
function $313b98861ee5dd6c$export$d6875122194c7b44(Bi, e) {
  let { id: qi, "aria-label": Xi, "aria-labelledby": Qi } = Bi;
  return qi = $bdb11010cef70236$export$f680877a34711e37(qi), Qi && Xi ? Qi = [
    .../* @__PURE__ */ new Set([
      qi,
      ...Qi.trim().split(/\s+/)
    ])
  ].join(" ") : Qi && (Qi = Qi.trim().split(/\s+/).join(" ")), !Xi && !Qi && e && (Xi = e), {
    id: qi,
    "aria-label": Xi,
    "aria-labelledby": Qi
  };
}
function $df56164dff5785e2$export$4338b53315abf666(Bi) {
  const e = useRef(null);
  return useMemo(() => ({
    get current() {
      return e.current;
    },
    set current(qi) {
      e.current = qi, typeof Bi == "function" ? Bi(qi) : Bi && (Bi.current = qi);
    }
  }), [
    Bi
  ]);
}
function $ca9b37712f007381$export$72ef708ab07251f1(Bi, e) {
  const qi = useRef(!0), Xi = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (qi.current = !0, () => {
    qi.current = !1;
  }), []), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    qi.current ? qi.current = !1 : (!Xi.current || e.some((Qi, ta) => !Object.is(Qi, Xi[ta]))) && Bi(), Xi.current = e;
  }, e);
}
function $9daab02d461809db$var$hasResizeObserver() {
  return typeof window.ResizeObserver < "u";
}
function $9daab02d461809db$export$683480f191c0e3ea(Bi) {
  const { ref: e, box: qi, onResize: Xi } = Bi;
  useEffect(() => {
    let Qi = e?.current;
    if (Qi)
      if ($9daab02d461809db$var$hasResizeObserver()) {
        const ta = new window.ResizeObserver((ra) => {
          ra.length && Xi();
        });
        return ta.observe(Qi, {
          box: qi
        }), () => {
          Qi && ta.unobserve(Qi);
        };
      } else
        return window.addEventListener("resize", Xi, !1), () => {
          window.removeEventListener("resize", Xi, !1);
        };
  }, [
    Xi,
    e,
    qi
  ]);
}
function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(Bi, e) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Bi && Bi.ref && e)
      return Bi.ref.current = e.current, () => {
        Bi.ref && (Bi.ref.current = null);
      };
  });
}
function $cc38e7bd3fc7b213$export$2bb74740c4e19def(Bi, e) {
  if (!Bi) return !1;
  let qi = window.getComputedStyle(Bi), Xi = /(auto|scroll)/.test(qi.overflow + qi.overflowX + qi.overflowY);
  return Xi && e && (Xi = Bi.scrollHeight !== Bi.clientHeight || Bi.scrollWidth !== Bi.clientWidth), Xi;
}
function $62d8ded9296f3872$export$cfa2225e87938781(Bi, e) {
  let qi = Bi;
  for ($cc38e7bd3fc7b213$export$2bb74740c4e19def(qi, e) && (qi = qi.parentElement); qi && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(qi, e); ) qi = qi.parentElement;
  return qi || document.scrollingElement || document.documentElement;
}
function $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(Bi, e) {
  const qi = [];
  for (; Bi && Bi !== document.documentElement; )
    $cc38e7bd3fc7b213$export$2bb74740c4e19def(Bi, e) && qi.push(Bi), Bi = Bi.parentElement;
  return qi;
}
let $ef06256079686ba0$var$descriptionId = 0;
const $ef06256079686ba0$var$descriptionNodes = /* @__PURE__ */ new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(Bi) {
  let [e, qi] = useState();
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!Bi) return;
    let Xi = $ef06256079686ba0$var$descriptionNodes.get(Bi);
    if (Xi)
      qi(Xi.element.id);
    else {
      let Qi = `react-aria-description-${$ef06256079686ba0$var$descriptionId++}`;
      qi(Qi);
      let ta = document.createElement("div");
      ta.id = Qi, ta.style.display = "none", ta.textContent = Bi, document.body.appendChild(ta), Xi = {
        refCount: 0,
        element: ta
      }, $ef06256079686ba0$var$descriptionNodes.set(Bi, Xi);
    }
    return Xi.refCount++, () => {
      Xi && --Xi.refCount === 0 && (Xi.element.remove(), $ef06256079686ba0$var$descriptionNodes.delete(Bi));
    };
  }, [
    Bi
  ]), {
    "aria-describedby": Bi ? e : void 0
  };
}
function $e9faafb641e167db$export$90fc3a17d93f704c(Bi, e, qi, Xi) {
  let Qi = $8ae05eaa5c114e9c$export$7f54fc3180508a52(qi), ta = qi == null;
  useEffect(() => {
    if (ta || !Bi.current) return;
    let ra = Bi.current;
    return ra.addEventListener(e, Qi, Xi), () => {
      ra.removeEventListener(e, Qi, Xi);
    };
  }, [
    Bi,
    e,
    Xi,
    ta,
    Qi
  ]);
}
function $2f04cbc44ee30ce0$export$53a0910f038337bd(Bi, e) {
  let qi = $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, "left"), Xi = $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, "top"), Qi = e.offsetWidth, ta = e.offsetHeight, ra = Bi.scrollLeft, na = Bi.scrollTop, { borderTopWidth: la, borderLeftWidth: Ma, scrollPaddingTop: Va, scrollPaddingRight: to, scrollPaddingBottom: Eo, scrollPaddingLeft: So } = getComputedStyle(Bi), eo = ra + parseInt(Ma, 10), rs = na + parseInt(la, 10), ko = eo + Bi.clientWidth, Hs = rs + Bi.clientHeight, Ks = parseInt(Va, 10) || 0, Ys = parseInt(Eo, 10) || 0, Xs = parseInt(to, 10) || 0, Cs = parseInt(So, 10) || 0;
  qi <= ra + Cs ? ra = qi - parseInt(Ma, 10) - Cs : qi + Qi > ko - Xs && (ra += qi + Qi - ko + Xs), Xi <= rs + Ks ? na = Xi - parseInt(la, 10) - Ks : Xi + ta > Hs - Ys && (na += Xi + ta - Hs + Ys), Bi.scrollLeft = ra, Bi.scrollTop = na;
}
function $2f04cbc44ee30ce0$var$relativeOffset(Bi, e, qi) {
  const Xi = qi === "left" ? "offsetLeft" : "offsetTop";
  let Qi = 0;
  for (; e.offsetParent && (Qi += e[Xi], e.offsetParent !== Bi); ) {
    if (e.offsetParent.contains(Bi)) {
      Qi -= Bi[Xi];
      break;
    }
    e = e.offsetParent;
  }
  return Qi;
}
function $2f04cbc44ee30ce0$export$c826860796309d1b(Bi, e) {
  if (Bi && document.contains(Bi)) {
    let ra = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(ra).overflow === "hidden") {
      let la = $a40c673dc9f6d9c7$export$94ed1c92c7beeb22(Bi);
      for (let Ma of la) $2f04cbc44ee30ce0$export$53a0910f038337bd(Ma, Bi);
    } else {
      var qi;
      let { left: la, top: Ma } = Bi.getBoundingClientRect();
      Bi == null || (qi = Bi.scrollIntoView) === null || qi === void 0 || qi.call(Bi, {
        block: "nearest"
      });
      let { left: Va, top: to } = Bi.getBoundingClientRect();
      if (Math.abs(la - Va) > 1 || Math.abs(Ma - to) > 1) {
        var Xi, Qi, ta;
        e == null || (Qi = e.containingElement) === null || Qi === void 0 || (Xi = Qi.scrollIntoView) === null || Xi === void 0 || Xi.call(Qi, {
          block: "center",
          inline: "center"
        }), (ta = Bi.scrollIntoView) === null || ta === void 0 || ta.call(Bi, {
          block: "nearest"
        });
      }
    }
  }
}
function $6a7db85432448f7f$export$60278871457622de(Bi) {
  return Bi.mozInputSource === 0 && Bi.isTrusted ? !0 : $c87311424ea30a05$export$a11b0059900ceec8() && Bi.pointerType ? Bi.type === "click" && Bi.buttons === 1 : Bi.detail === 0 && !Bi.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(Bi) {
  return !$c87311424ea30a05$export$a11b0059900ceec8() && Bi.width === 0 && Bi.height === 0 || Bi.width === 1 && Bi.height === 1 && Bi.pressure === 0 && Bi.detail === 0 && Bi.pointerType === "mouse";
}
function $99facab73266f662$export$5add1d006293d136(Bi, e, qi) {
  let Xi = useRef(e), Qi = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    qi && qi(Xi.current);
  });
  useEffect(() => {
    var ta;
    let ra = Bi == null || (ta = Bi.current) === null || ta === void 0 ? void 0 : ta.form;
    return ra?.addEventListener("reset", Qi), () => {
      ra?.removeEventListener("reset", Qi);
    };
  }, [
    Bi,
    Qi
  ]);
}
const $5671b20cf9b562b2$export$447a38995de2c711 = "react-aria-clear-focus", $5671b20cf9b562b2$export$831c820ad60f9d12 = "react-aria-focus", $5671b20cf9b562b2$export$9db568f6321ad9dc = "react-aria-update-activedescendant";
function $21f1aa98acb08317$export$16792effe837dba3(Bi) {
  return $c87311424ea30a05$export$9ac100e40613ea10() ? Bi.metaKey : Bi.ctrlKey;
}
function $d3f049242431219c$export$6d3443f2c48bfc20(Bi, e = !0) {
  let [qi, Xi] = useState(!0), Qi = qi && e;
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Qi && Bi.current && "getAnimations" in Bi.current)
      for (let ta of Bi.current.getAnimations()) ta instanceof CSSTransition && ta.cancel();
  }, [
    Bi,
    Qi
  ]), $d3f049242431219c$var$useAnimation(Bi, Qi, useCallback(() => Xi(!1), [])), Qi;
}
function $d3f049242431219c$export$45fda7c47f93fd48(Bi, e) {
  let [qi, Xi] = useState(e ? "open" : "closed");
  switch (qi) {
    case "open":
      e || Xi("exiting");
      break;
    case "closed":
    case "exiting":
      e && Xi("open");
      break;
  }
  let Qi = qi === "exiting";
  return $d3f049242431219c$var$useAnimation(Bi, Qi, useCallback(() => {
    Xi((ta) => ta === "exiting" ? "closed" : ta);
  }, [])), Qi;
}
function $d3f049242431219c$var$useAnimation(Bi, e, qi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e && Bi.current) {
      if (!("getAnimations" in Bi.current)) {
        qi();
        return;
      }
      let Xi = Bi.current.getAnimations();
      if (Xi.length === 0) {
        qi();
        return;
      }
      let Qi = !1;
      return Promise.all(Xi.map((ta) => ta.finished)).then(() => {
        Qi || flushSync$1(() => {
          qi();
        });
      }).catch(() => {
      }), () => {
        Qi = !0;
      };
    }
  }, [
    Bi,
    e,
    qi
  ]);
}
function $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi, e, qi) {
  let [Xi, Qi] = useState(Bi || e), ta = useRef(Bi !== void 0), ra = Bi !== void 0;
  useEffect(() => {
    let Ma = ta.current;
    Ma !== ra && console.warn(`WARN: A component changed from ${Ma ? "controlled" : "uncontrolled"} to ${ra ? "controlled" : "uncontrolled"}.`), ta.current = ra;
  }, [
    ra
  ]);
  let na = ra ? Bi : Xi, la = useCallback((Ma, ...Va) => {
    let to = (Eo, ...So) => {
      qi && (Object.is(na, Eo) || qi(Eo, ...So)), ra || (na = Eo);
    };
    typeof Ma == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), Qi((So, ...eo) => {
      let rs = Ma(ra ? na : So, ...eo);
      return to(rs, ...Va), ra ? So : rs;
    })) : (ra || Qi(Ma), to(Ma, ...Va));
  }, [
    ra,
    na,
    qi
  ]);
  return [
    na,
    la
  ];
}
function $9446cca9a3875146$export$7d15b64cf5a3a4c4(Bi, e = -1 / 0, qi = 1 / 0) {
  return Math.min(Math.max(Bi, e), qi);
}
const $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol("default");
function $64fa3d84918910a7$export$2881499e37b75b9a({ values: Bi, children: e }) {
  for (let [qi, Xi] of Bi)
    e = /* @__PURE__ */ a__default.createElement(qi.Provider, {
      value: Xi
    }, e);
  return e;
}
function $64fa3d84918910a7$export$4d86445c2cf5e3(Bi) {
  let { className: e, style: qi, children: Xi, defaultClassName: Qi, defaultChildren: ta, defaultStyle: ra, values: na } = Bi;
  return useMemo(() => {
    let la, Ma, Va;
    return typeof e == "function" ? la = e({
      ...na,
      defaultClassName: Qi
    }) : la = e, typeof qi == "function" ? Ma = qi({
      ...na,
      defaultStyle: ra || {}
    }) : Ma = qi, typeof Xi == "function" ? Va = Xi({
      ...na,
      defaultChildren: ta
    }) : Xi == null ? Va = ta : Va = Xi, {
      className: la ?? Qi,
      style: Ma || ra ? {
        ...ra,
        ...Ma
      } : void 0,
      children: Va ?? ta,
      "data-rac": ""
    };
  }, [
    e,
    qi,
    Xi,
    Qi,
    ta,
    ra,
    na
  ]);
}
function $64fa3d84918910a7$export$fabf2dc03a41866e(Bi, e) {
  let qi = useContext(Bi);
  if (e === null)
    return null;
  if (qi && typeof qi == "object" && "slots" in qi && qi.slots) {
    let Xi = new Intl.ListFormat().format(Object.keys(qi.slots).map((ta) => `"${ta}"`));
    if (!e && !qi.slots[$64fa3d84918910a7$export$c62b8e45d58ddad9]) throw new Error(`A slot prop is required. Valid slot names are ${Xi}.`);
    let Qi = e || $64fa3d84918910a7$export$c62b8e45d58ddad9;
    if (!qi.slots[Qi])
      throw new Error(`Invalid slot "${e}". Valid slot names are ${Xi}.`);
    return qi.slots[Qi];
  }
  return qi;
}
function $64fa3d84918910a7$export$29f1550f4b0d4415(Bi, e, qi) {
  let Xi = $64fa3d84918910a7$export$fabf2dc03a41866e(qi, Bi.slot) || {}, { ref: Qi, ...ta } = Xi, ra = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(e, Qi), [
    e,
    Qi
  ])), na = $3ef42575df84b30b$export$9d1611c77c2fe928(ta, Bi);
  return "style" in ta && ta.style && "style" in Bi && Bi.style && (typeof ta.style == "function" || typeof Bi.style == "function" ? na.style = (la) => {
    let Ma = typeof ta.style == "function" ? ta.style(la) : ta.style, Va = {
      ...la.defaultStyle,
      ...Ma
    }, to = typeof Bi.style == "function" ? Bi.style({
      ...la,
      defaultStyle: Va
    }) : Bi.style;
    return {
      ...Va,
      ...to
    };
  } : na.style = {
    ...ta.style,
    ...Bi.style
  }), [
    na,
    ra
  ];
}
function $64fa3d84918910a7$export$9d4c57ee4c6ffdd8() {
  let [Bi, e] = useState(!0), qi = useRef(!1), Xi = useCallback((Qi) => {
    qi.current = !0, e(!!Qi);
  }, []);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    qi.current || e(!1);
  }, []), [
    Xi,
    Bi
  ];
}
function $64fa3d84918910a7$export$ef03459518577ad4(Bi) {
  const e = /^(data-.*)$/;
  let qi = {};
  for (const Xi in Bi) e.test(Xi) || (qi[Xi] = Bi[Xi]);
  return qi;
}
class $23b9f4fcf0fe224b$export$d68d59712b04d9d1 {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let e = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(this.type, this.key);
    return e.value = this.value, e.level = this.level, e.hasChildNodes = this.hasChildNodes, e.rendered = this.rendered, e.textValue = this.textValue, e["aria-label"] = this["aria-label"], e.index = this.index, e.parentKey = this.parentKey, e.prevKey = this.prevKey, e.nextKey = this.nextKey, e.firstChildKey = this.firstChildKey, e.lastChildKey = this.lastChildKey, e.props = this.props, e.render = this.render, e;
  }
  constructor(e, qi) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.type = e, this.key = qi;
  }
}
class $23b9f4fcf0fe224b$export$408d25a4e12db025 {
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let e = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; e; )
      yield e, e = e.nextKey != null ? this.keyMap.get(e.nextKey) : void 0;
  }
  getChildren(e) {
    let qi = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let Xi = qi.get(e), Qi = Xi?.firstChildKey != null ? qi.get(Xi.firstChildKey) : null;
        for (; Qi; )
          yield Qi, Qi = Qi.nextKey != null ? qi.get(Qi.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(e) {
    let qi = this.keyMap.get(e);
    if (!qi) return null;
    if (qi.prevKey != null) {
      for (qi = this.keyMap.get(qi.prevKey); qi && qi.type !== "item" && qi.lastChildKey != null; ) qi = this.keyMap.get(qi.lastChildKey);
      var Xi;
      return (Xi = qi?.key) !== null && Xi !== void 0 ? Xi : null;
    }
    return qi.parentKey;
  }
  getKeyAfter(e) {
    let qi = this.keyMap.get(e);
    if (!qi) return null;
    if (qi.type !== "item" && qi.firstChildKey != null) return qi.firstChildKey;
    for (; qi; ) {
      if (qi.nextKey != null) return qi.nextKey;
      if (qi.parentKey != null) qi = this.keyMap.get(qi.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let e = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; e?.lastChildKey != null; ) e = this.keyMap.get(e.lastChildKey);
    var qi;
    return (qi = e?.key) !== null && qi !== void 0 ? qi : null;
  }
  getItem(e) {
    var qi;
    return (qi = this.keyMap.get(e)) !== null && qi !== void 0 ? qi : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let e = this.constructor, qi = new e();
    return qi.keyMap = new Map(this.keyMap), qi.firstKey = this.firstKey, qi.lastKey = this.lastKey, qi;
  }
  addNode(e) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    this.keyMap.set(e.key, e);
  }
  removeNode(e) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    this.keyMap.delete(e);
  }
  commit(e, qi, Xi = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = e, this.lastKey = qi, this.frozen = !Xi;
  }
  // TODO: this is pretty specific to menu, will need to check if it is generic enough
  // Will need to handle varying levels I assume but will revisit after I get searchable menu working for base menu
  // TODO: an alternative is to simply walk the collection and add all item nodes that match the filter and any sections/separators we encounter
  // to an array, then walk that new array and fix all the next/Prev keys while adding them to the new collection
  filter(e) {
    let qi = new $23b9f4fcf0fe224b$export$408d25a4e12db025(), Xi = null;
    for (let Qi of this)
      if (Qi.type === "section" && Qi.hasChildNodes) {
        let ta = Qi.clone(), ra = null;
        for (let na of this.getChildren(Qi.key)) if (e(na.textValue) || na.type === "header") {
          let la = na.clone();
          ra == null && (ta.firstChildKey = la.key), qi.firstKey == null && (qi.firstKey = ta.key), ra && ra.parentKey === la.parentKey ? (ra.nextKey = la.key, la.prevKey = ra.key) : la.prevKey = null, la.nextKey = null, qi.addNode(la), ra = la;
        }
        ra && (ra.type !== "header" ? (ta.lastChildKey = ra.key, Xi == null ? ta.prevKey = null : (Xi.type === "section" || Xi.type === "separator") && (Xi.nextKey = ta.key, ta.prevKey = Xi.key), ta.nextKey = null, Xi = ta, qi.addNode(ta)) : (qi.firstKey === ta.key && (qi.firstKey = null), qi.removeNode(ra.key)));
      } else if (Qi.type === "separator") {
        let ta = Qi.clone();
        ta.nextKey = null, Xi?.type === "section" && (Xi.nextKey = ta.key, ta.prevKey = Xi.key, Xi = ta, qi.addNode(ta));
      } else if (e(Qi.textValue)) {
        let ta = Qi.clone();
        qi.firstKey == null && (qi.firstKey = ta.key), Xi != null && Xi.type !== "section" && Xi.type !== "separator" && Xi.parentKey === ta.parentKey ? (Xi.nextKey = ta.key, ta.prevKey = Xi.key) : ta.prevKey = null, ta.nextKey = null, qi.addNode(ta), Xi = ta;
      }
    if (Xi?.type === "separator" && Xi.nextKey === null) {
      let Qi;
      Xi.prevKey != null && (Qi = qi.getItem(Xi.prevKey), Qi.nextKey = null), qi.removeNode(Xi.key), Xi = Qi;
    }
    return qi.lastKey = Xi?.key || null, qi;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1;
  }
}
class $681cc3c98f569e39$export$410b0c854570d131 {
  *[Symbol.iterator]() {
    let e = this.firstChild;
    for (; e; )
      yield e, e = e.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(e) {
    this._firstChild = e, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(e) {
    this._lastChild = e, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(e) {
    this._previousSibling = e, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(e) {
    this._nextSibling = e, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(e) {
    this._parentNode = e, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var e;
    return ((e = this.parentNode) === null || e === void 0 ? void 0 : e.isConnected) || !1;
  }
  appendChild(e) {
    this.ownerDocument.startTransaction(), e.parentNode && e.parentNode.removeChild(e), this.firstChild == null && (this.firstChild = e), this.lastChild ? (this.lastChild.nextSibling = e, e.index = this.lastChild.index + 1, e.previousSibling = this.lastChild) : (e.previousSibling = null, e.index = 0), e.parentNode = this, e.nextSibling = null, this.lastChild = e, this.ownerDocument.markDirty(this), e.hasSetProps && this.ownerDocument.addNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  insertBefore(e, qi) {
    if (qi == null) return this.appendChild(e);
    this.ownerDocument.startTransaction(), e.parentNode && e.parentNode.removeChild(e), e.nextSibling = qi, e.previousSibling = qi.previousSibling, e.index = qi.index, this.firstChild === qi ? this.firstChild = e : qi.previousSibling && (qi.previousSibling.nextSibling = e), qi.previousSibling = e, e.parentNode = qi.parentNode;
    let Xi = qi;
    for (; Xi; )
      Xi.index++, Xi = Xi.nextSibling;
    e.hasSetProps && this.ownerDocument.addNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  removeChild(e) {
    if (e.parentNode !== this || !this.ownerDocument.isMounted) return;
    this.ownerDocument.startTransaction();
    let qi = e.nextSibling;
    for (; qi; )
      qi.index--, qi = qi.nextSibling;
    e.nextSibling && (e.nextSibling.previousSibling = e.previousSibling), e.previousSibling && (e.previousSibling.nextSibling = e.nextSibling), this.firstChild === e && (this.firstChild = e.nextSibling), this.lastChild === e && (this.lastChild = e.previousSibling), e.parentNode = null, e.nextSibling = null, e.previousSibling = null, e.index = 0, this.ownerDocument.removeNode(e), this.ownerDocument.endTransaction(), this.ownerDocument.queueUpdate();
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  constructor(e) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this.ownerDocument = e;
  }
}
class $681cc3c98f569e39$export$dc064fe9e59310fd extends $681cc3c98f569e39$export$410b0c854570d131 {
  get index() {
    return this._index;
  }
  set index(e) {
    this._index = e, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.level + (this.node.type === "item" ? 1 : 0) : 0;
  }
  updateNode() {
    var e, qi, Xi, Qi;
    let ta = this.ownerDocument.getMutableNode(this);
    ta.index = this.index, ta.level = this.level, ta.parentKey = this.parentNode instanceof $681cc3c98f569e39$export$dc064fe9e59310fd ? this.parentNode.node.key : null;
    var ra;
    ta.prevKey = (ra = (e = this.previousSibling) === null || e === void 0 ? void 0 : e.node.key) !== null && ra !== void 0 ? ra : null;
    var na;
    ta.nextKey = (na = (qi = this.nextSibling) === null || qi === void 0 ? void 0 : qi.node.key) !== null && na !== void 0 ? na : null, ta.hasChildNodes = !!this.firstChild;
    var la;
    ta.firstChildKey = (la = (Xi = this.firstChild) === null || Xi === void 0 ? void 0 : Xi.node.key) !== null && la !== void 0 ? la : null;
    var Ma;
    ta.lastChildKey = (Ma = (Qi = this.lastChild) === null || Qi === void 0 ? void 0 : Qi.node.key) !== null && Ma !== void 0 ? Ma : null;
  }
  setProps(e, qi, Xi, Qi) {
    let ta = this.ownerDocument.getMutableNode(this), { value: ra, textValue: na, id: la, ...Ma } = e;
    if (Ma.ref = qi, ta.props = Ma, ta.rendered = Xi, ta.render = Qi, ta.value = ra, ta.textValue = na || (typeof Ma.children == "string" ? Ma.children : "") || e["aria-label"] || "", la != null && la !== ta.key) {
      if (this.hasSetProps) throw new Error("Cannot change the id of an item");
      ta.key = la;
    }
    this.hasSetProps || (this.ownerDocument.addNode(this), this.ownerDocument.endTransaction(), this.hasSetProps = !0), this.ownerDocument.queueUpdate();
  }
  get style() {
    return {};
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(e, qi) {
    super(qi), this.nodeType = 8, this._index = 0, this.hasSetProps = !1, this.node = new $23b9f4fcf0fe224b$export$d68d59712b04d9d1(e, `react-aria-${++qi.nodeId}`), this.ownerDocument.startTransaction();
  }
}
class $681cc3c98f569e39$export$b34a105447964f9f extends $681cc3c98f569e39$export$410b0c854570d131 {
  get isConnected() {
    return this.isMounted;
  }
  createElement(e) {
    return new $681cc3c98f569e39$export$dc064fe9e59310fd(e, this);
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode(e) {
    let qi = e.node;
    return this.mutatedNodes.has(e) || (qi = e.node.clone(), this.mutatedNodes.add(e), e.node = qi), this.markDirty(e), qi;
  }
  getMutableCollection() {
    return !this.isSSR && !this.collectionMutated && (this.collection = this.collection.clone(), this.collectionMutated = !0), this.collection;
  }
  markDirty(e) {
    this.dirtyNodes.add(e);
  }
  startTransaction() {
    this.transactionCount++;
  }
  endTransaction() {
    this.transactionCount--;
  }
  addNode(e) {
    let qi = this.getMutableCollection();
    if (!qi.getItem(e.node.key)) {
      qi.addNode(e.node);
      for (let Xi of e) this.addNode(Xi);
    }
    this.markDirty(e);
  }
  removeNode(e) {
    for (let Xi of e) this.removeNode(Xi);
    this.getMutableCollection().removeNode(e.node.key), this.markDirty(e);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.transactionCount > 0 ? this.collection : (this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let ta of this.dirtyNodes) ta instanceof $681cc3c98f569e39$export$dc064fe9e59310fd && ta.isConnected && ta.updateNode();
    if (this.dirtyNodes.clear(), this.mutatedNodes.size || this.collectionMutated) {
      var e, qi;
      let ta = this.getMutableCollection();
      for (let ra of this.mutatedNodes) ra.isConnected && ta.addNode(ra.node);
      var Xi, Qi;
      ta.commit((Xi = (e = this.firstChild) === null || e === void 0 ? void 0 : e.node.key) !== null && Xi !== void 0 ? Xi : null, (Qi = (qi = this.lastChild) === null || qi === void 0 ? void 0 : qi.node.key) !== null && Qi !== void 0 ? Qi : null, this.isSSR), this.mutatedNodes.clear();
    }
    this.collectionMutated = !1;
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.transactionCount > 0))
      for (let e of this.subscriptions) e();
  }
  subscribe(e) {
    return this.subscriptions.add(e), () => this.subscriptions.delete(e);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(e) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.isMounted = !0, this.mutatedNodes = /* @__PURE__ */ new Set(), this.subscriptions = /* @__PURE__ */ new Set(), this.transactionCount = 0, this.collection = e, this.collectionMutated = !0;
  }
}
function $e948873055cbafe4$export$727c8fc270210f13(Bi) {
  let { children: e, items: qi, idScope: Xi, addIdAndValue: Qi, dependencies: ta = [] } = Bi, ra = useMemo(() => /* @__PURE__ */ new WeakMap(), ta);
  return useMemo(() => {
    if (qi && typeof e == "function") {
      let Ma = [];
      for (let Va of qi) {
        let to = ra.get(Va);
        if (!to) {
          to = e(Va);
          var na, la;
          let Eo = (la = (na = to.props.id) !== null && na !== void 0 ? na : Va.key) !== null && la !== void 0 ? la : Va.id;
          if (Eo == null) throw new Error("Could not determine key for item");
          Xi && (Eo = Xi + ":" + Eo), to = cloneElement(to, Qi ? {
            key: Eo,
            id: Eo,
            value: Va
          } : {
            key: Eo
          }), ra.set(Va, to);
        }
        Ma.push(to);
      }
      return Ma;
    } else if (typeof e != "function") return e;
  }, [
    e,
    qi,
    ra,
    Xi,
    Qi
  ]);
}
if (typeof HTMLTemplateElement < "u") {
  const Bi = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : Bi.call(this);
    }
  });
}
const $f39a9eba43920ace$export$94b6d0abf7d33e8c = /* @__PURE__ */ createContext(!1), $f39a9eba43920ace$var$hiddenFragment = typeof DocumentFragment < "u" ? new DocumentFragment() : null;
function $f39a9eba43920ace$export$8dc98ba7eadeaa56(Bi) {
  let e = useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c), qi = $b5e257d569688ac6$export$535bd6ca7f90a273();
  if (e)
    return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Bi.children);
  let Xi = /* @__PURE__ */ a__default.createElement($f39a9eba43920ace$export$94b6d0abf7d33e8c.Provider, {
    value: !0
  }, Bi.children);
  return qi ? /* @__PURE__ */ a__default.createElement("template", {
    "data-react-aria-hidden": !0
  }, Xi) : /* @__PURE__ */ createPortal(Xi, $f39a9eba43920ace$var$hiddenFragment);
}
function $f39a9eba43920ace$export$86427a43e3e48ebb(Bi) {
  let e = (qi, Xi) => useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c) ? null : Bi(qi, Xi);
  return e.displayName = Bi.displayName || Bi.name, forwardRef(e);
}
function $f39a9eba43920ace$export$b5d7cc18bb8d2b59() {
  return useContext($f39a9eba43920ace$export$94b6d0abf7d33e8c);
}
var shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var Bi = a__default;
  function e(to, Eo) {
    return to === Eo && (to !== 0 || 1 / to === 1 / Eo) || to !== to && Eo !== Eo;
  }
  var qi = typeof Object.is == "function" ? Object.is : e, Xi = Bi.useState, Qi = Bi.useEffect, ta = Bi.useLayoutEffect, ra = Bi.useDebugValue;
  function na(to, Eo) {
    var So = Eo(), eo = Xi({ inst: { value: So, getSnapshot: Eo } }), rs = eo[0].inst, ko = eo[1];
    return ta(
      function() {
        rs.value = So, rs.getSnapshot = Eo, la(rs) && ko({ inst: rs });
      },
      [to, So, Eo]
    ), Qi(
      function() {
        return la(rs) && ko({ inst: rs }), to(function() {
          la(rs) && ko({ inst: rs });
        });
      },
      [to]
    ), ra(So), So;
  }
  function la(to) {
    var Eo = to.getSnapshot;
    to = to.value;
    try {
      var So = Eo();
      return !qi(to, So);
    } catch {
      return !0;
    }
  }
  function Ma(to, Eo) {
    return Eo();
  }
  var Va = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Ma : na;
  return useSyncExternalStoreShim_production.useSyncExternalStore = Bi.useSyncExternalStore !== void 0 ? Bi.useSyncExternalStore : Va, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && function() {
    function Bi(So, eo) {
      return So === eo && (So !== 0 || 1 / So === 1 / eo) || So !== So && eo !== eo;
    }
    function e(So, eo) {
      Va || Qi.startTransition === void 0 || (Va = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var rs = eo();
      if (!to) {
        var ko = eo();
        ta(rs, ko) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), to = !0);
      }
      ko = ra({
        inst: { value: rs, getSnapshot: eo }
      });
      var Hs = ko[0].inst, Ks = ko[1];
      return la(
        function() {
          Hs.value = rs, Hs.getSnapshot = eo, qi(Hs) && Ks({ inst: Hs });
        },
        [So, rs, eo]
      ), na(
        function() {
          return qi(Hs) && Ks({ inst: Hs }), So(function() {
            qi(Hs) && Ks({ inst: Hs });
          });
        },
        [So]
      ), Ma(rs), rs;
    }
    function qi(So) {
      var eo = So.getSnapshot;
      So = So.value;
      try {
        var rs = eo();
        return !ta(So, rs);
      } catch {
        return !0;
      }
    }
    function Xi(So, eo) {
      return eo();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Qi = a__default, ta = typeof Object.is == "function" ? Object.is : Bi, ra = Qi.useState, na = Qi.useEffect, la = Qi.useLayoutEffect, Ma = Qi.useDebugValue, Va = !1, to = !1, Eo = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? Xi : e;
    useSyncExternalStoreShim_development.useSyncExternalStore = Qi.useSyncExternalStore !== void 0 ? Qi.useSyncExternalStore : Eo, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  return hasRequiredShim || (hasRequiredShim = 1, process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development()), shim.exports;
}
var shimExports = requireShim();
const $e1995378a142960e$var$ShallowRenderContext = /* @__PURE__ */ createContext(!1), $e1995378a142960e$var$CollectionDocumentContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$export$bf788dd355e3a401(Bi) {
  if (useContext($e1995378a142960e$var$CollectionDocumentContext))
    return Bi.content;
  let { collection: qi, document: Xi } = $e1995378a142960e$var$useCollectionDocument(Bi.createCollection);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement($f39a9eba43920ace$export$8dc98ba7eadeaa56, null, /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionDocumentContext.Provider, {
    value: Xi
  }, Bi.content)), /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionInner, {
    render: Bi.children,
    collection: qi
  }));
}
function $e1995378a142960e$var$CollectionInner({ collection: Bi, render: e }) {
  return e(Bi);
}
function $e1995378a142960e$var$useSyncExternalStoreFallback(Bi, e, qi) {
  let Xi = $b5e257d569688ac6$export$535bd6ca7f90a273(), Qi = useRef(Xi);
  Qi.current = Xi;
  let ta = useCallback(() => Qi.current ? qi() : e(), [
    e,
    qi
  ]);
  return shimExports.useSyncExternalStore(Bi, ta);
}
const $e1995378a142960e$var$useSyncExternalStore = typeof a__default.useSyncExternalStore == "function" ? a__default.useSyncExternalStore : $e1995378a142960e$var$useSyncExternalStoreFallback;
function $e1995378a142960e$var$useCollectionDocument(Bi) {
  let [e] = useState(() => new $681cc3c98f569e39$export$b34a105447964f9f(Bi?.() || new $23b9f4fcf0fe224b$export$408d25a4e12db025())), qi = useCallback((ra) => e.subscribe(ra), [
    e
  ]), Xi = useCallback(() => {
    let ra = e.getCollection();
    return e.isSSR && e.resetAfterSSR(), ra;
  }, [
    e
  ]), Qi = useCallback(() => (e.isSSR = !0, e.getCollection()), [
    e
  ]), ta = $e1995378a142960e$var$useSyncExternalStore(qi, Xi, Qi);
  return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (e.isMounted = !0, () => {
    e.isMounted = !1;
  }), [
    e
  ]), {
    collection: ta,
    document: e
  };
}
const $e1995378a142960e$var$SSRContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$var$useSSRCollectionNode(Bi, e, qi, Xi, Qi, ta) {
  let ra = useCallback((la) => {
    la?.setProps(e, qi, Xi, ta);
  }, [
    e,
    qi,
    Xi,
    ta
  ]), na = useContext($e1995378a142960e$var$SSRContext);
  if (na) {
    let la = na.ownerDocument.nodesByProps.get(e);
    return la || (la = na.ownerDocument.createElement(Bi), la.setProps(e, qi, Xi, ta), na.appendChild(la), na.ownerDocument.updateCollection(), na.ownerDocument.nodesByProps.set(e, la)), Qi ? /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$SSRContext.Provider, {
      value: la
    }, Qi) : null;
  }
  return /* @__PURE__ */ a__default.createElement(Bi, {
    ref: ra
  }, Qi);
}
function $e1995378a142960e$export$18af5c7a9e9b3664(Bi, e) {
  let qi = ({ node: Qi }) => e(Qi.props, Qi.props.ref, Qi), Xi = forwardRef((Qi, ta) => {
    if (!useContext($e1995378a142960e$var$ShallowRenderContext)) {
      if (e.length >= 3) throw new Error(e.name + " cannot be rendered outside a collection.");
      return e(Qi, ta);
    }
    return $e1995378a142960e$var$useSSRCollectionNode(Bi, Qi, ta, "children" in Qi ? Qi.children : null, null, (na) => /* @__PURE__ */ a__default.createElement(qi, {
      node: na
    }));
  });
  return Xi.displayName = e.name, Xi;
}
function $e1995378a142960e$var$useCollectionChildren(Bi) {
  return $e948873055cbafe4$export$727c8fc270210f13({
    ...Bi,
    addIdAndValue: !0
  });
}
const $e1995378a142960e$var$CollectionContext = /* @__PURE__ */ createContext(null);
function $e1995378a142960e$export$fb8073518f34e6ec(Bi) {
  let e = useContext($e1995378a142960e$var$CollectionContext), qi = (e?.dependencies || []).concat(Bi.dependencies), Xi = Bi.idScope || e?.idScope, Qi = $e1995378a142960e$var$useCollectionChildren({
    ...Bi,
    idScope: Xi,
    dependencies: qi
  });
  return useContext($e1995378a142960e$var$CollectionDocumentContext) && (Qi = /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionRoot, null, Qi)), e = useMemo(() => ({
    dependencies: qi,
    idScope: Xi
  }), [
    Xi,
    ...qi
  ]), /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionContext.Provider, {
    value: e
  }, Qi);
}
function $e1995378a142960e$var$CollectionRoot({ children: Bi }) {
  let e = useContext($e1995378a142960e$var$CollectionDocumentContext), qi = useMemo(() => /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$CollectionDocumentContext.Provider, {
    value: null
  }, /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$ShallowRenderContext.Provider, {
    value: !0
  }, Bi)), [
    Bi
  ]);
  return $b5e257d569688ac6$export$535bd6ca7f90a273() ? /* @__PURE__ */ a__default.createElement($e1995378a142960e$var$SSRContext.Provider, {
    value: e
  }, qi) : /* @__PURE__ */ createPortal(qi, e);
}
const $01b77f81d0f07f68$export$75b6ee27786ba447 = /* @__PURE__ */ createContext({}), $01b77f81d0f07f68$export$b04be29aa201d4f5 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, qi) {
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $01b77f81d0f07f68$export$75b6ee27786ba447);
  let { elementType: Xi = "label", ...Qi } = e;
  return /* @__PURE__ */ a__default.createElement(Xi, {
    className: "react-aria-Label",
    ...Qi,
    ref: qi
  });
});
let $14c0b72509d70225$var$state = "default", $14c0b72509d70225$var$savedUserSelect = "", $14c0b72509d70225$var$modifiedElementMap = /* @__PURE__ */ new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(Bi) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === "default") {
      const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
      $14c0b72509d70225$var$savedUserSelect = e.documentElement.style.webkitUserSelect, e.documentElement.style.webkitUserSelect = "none";
    }
    $14c0b72509d70225$var$state = "disabled";
  } else (Bi instanceof HTMLElement || Bi instanceof SVGElement) && ($14c0b72509d70225$var$modifiedElementMap.set(Bi, Bi.style.userSelect), Bi.style.userSelect = "none");
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(Bi) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state !== "disabled") return;
    $14c0b72509d70225$var$state = "restoring", setTimeout(() => {
      $bbed8b41f857bcc0$export$24490316f764c430(() => {
        if ($14c0b72509d70225$var$state === "restoring") {
          const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
          e.documentElement.style.webkitUserSelect === "none" && (e.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || ""), $14c0b72509d70225$var$savedUserSelect = "", $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if ((Bi instanceof HTMLElement || Bi instanceof SVGElement) && Bi && $14c0b72509d70225$var$modifiedElementMap.has(Bi)) {
    let e = $14c0b72509d70225$var$modifiedElementMap.get(Bi);
    Bi.style.userSelect === "none" && (Bi.style.userSelect = e), Bi.getAttribute("style") === "" && Bi.removeAttribute("style"), $14c0b72509d70225$var$modifiedElementMap.delete(Bi);
  }
}
const $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = a__default.createContext({
  register: () => {
  }
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function _class_apply_descriptor_get(Bi, e) {
  return e.get ? e.get.call(Bi) : e.value;
}
function _class_extract_field_descriptor(Bi, e, qi) {
  if (!e.has(Bi)) throw new TypeError("attempted to " + qi + " private field on non-instance");
  return e.get(Bi);
}
function _class_private_field_get(Bi, e) {
  var qi = _class_extract_field_descriptor(Bi, e, "get");
  return _class_apply_descriptor_get(Bi, qi);
}
function _check_private_redeclaration(Bi, e) {
  if (e.has(Bi))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _class_private_field_init(Bi, e, qi) {
  _check_private_redeclaration(Bi, e), e.set(Bi, qi);
}
function _class_apply_descriptor_set(Bi, e, qi) {
  if (e.set) e.set.call(Bi, qi);
  else {
    if (!e.writable)
      throw new TypeError("attempted to set read only private field");
    e.value = qi;
  }
}
function _class_private_field_set(Bi, e, qi) {
  var Xi = _class_extract_field_descriptor(Bi, e, "set");
  return _class_apply_descriptor_set(Bi, Xi, qi), qi;
}
function $f6c31cce2adf654f$var$usePressResponderContext(Bi) {
  let e = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  if (e) {
    let { register: qi, ...Xi } = e;
    Bi = $3ef42575df84b30b$export$9d1611c77c2fe928(Xi, Bi), qi();
  }
  return $e7801be82b4b2a53$export$4debdb1a3f0fa79e(e, Bi.ref), Bi;
}
var $f6c31cce2adf654f$var$_shouldStopPropagation = /* @__PURE__ */ new WeakMap();
class $f6c31cce2adf654f$var$PressEvent {
  continuePropagation() {
    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, !1);
  }
  get shouldStopPropagation() {
    return _class_private_field_get(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
  }
  constructor(e, qi, Xi, Qi) {
    _class_private_field_init(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
      writable: !0,
      value: void 0
    }), _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, !0);
    var ta;
    let ra = (ta = Qi?.target) !== null && ta !== void 0 ? ta : Xi.currentTarget;
    const na = ra?.getBoundingClientRect();
    let la, Ma = 0, Va, to = null;
    Xi.clientX != null && Xi.clientY != null && (Va = Xi.clientX, to = Xi.clientY), na && (Va != null && to != null ? (la = Va - na.left, Ma = to - na.top) : (la = na.width / 2, Ma = na.height / 2)), this.type = e, this.pointerType = qi, this.target = Xi.currentTarget, this.shiftKey = Xi.shiftKey, this.metaKey = Xi.metaKey, this.ctrlKey = Xi.ctrlKey, this.altKey = Xi.altKey, this.x = la, this.y = Ma;
  }
}
const $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f6c31cce2adf654f$export$45712eceda6fad21(Bi) {
  let {
    onPress: e,
    onPressChange: qi,
    onPressStart: Xi,
    onPressEnd: Qi,
    onPressUp: ta,
    isDisabled: ra,
    isPressed: na,
    preventFocusOnPress: la,
    shouldCancelOnPointerExit: Ma,
    allowTextSelectionOnPress: Va,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: to,
    ...Eo
  } = $f6c31cce2adf654f$var$usePressResponderContext(Bi), [So, eo] = useState(!1), rs = useRef({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: ko, removeAllGlobalListeners: Hs } = $03deb23ff14920c4$export$4eaf04e54aa8eed6(), Ks = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ls, ks) => {
    let Js = rs.current;
    if (ra || Js.didFirePressStart) return !1;
    let pl = !0;
    if (Js.isTriggeringEvent = !0, Xi) {
      let _l = new $f6c31cce2adf654f$var$PressEvent("pressstart", ks, ls);
      Xi(_l), pl = _l.shouldStopPropagation;
    }
    return qi && qi(!0), Js.isTriggeringEvent = !1, Js.didFirePressStart = !0, eo(!0), pl;
  }), Ys = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ls, ks, Js = !0) => {
    let pl = rs.current;
    if (!pl.didFirePressStart) return !1;
    pl.ignoreClickAfterPress = !0, pl.didFirePressStart = !1, pl.isTriggeringEvent = !0;
    let _l = !0;
    if (Qi) {
      let bl = new $f6c31cce2adf654f$var$PressEvent("pressend", ks, ls);
      Qi(bl), _l = bl.shouldStopPropagation;
    }
    if (qi && qi(!1), eo(!1), e && Js && !ra) {
      let bl = new $f6c31cce2adf654f$var$PressEvent("press", ks, ls);
      e(bl), _l && (_l = bl.shouldStopPropagation);
    }
    return pl.isTriggeringEvent = !1, _l;
  }), Xs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ls, ks) => {
    let Js = rs.current;
    if (ra) return !1;
    if (ta) {
      Js.isTriggeringEvent = !0;
      let pl = new $f6c31cce2adf654f$var$PressEvent("pressup", ks, ls);
      return ta(pl), Js.isTriggeringEvent = !1, pl.shouldStopPropagation;
    }
    return !0;
  }), Cs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ls) => {
    let ks = rs.current;
    ks.isPressed && ks.target && (ks.isOverTarget && ks.pointerType != null && Ys($f6c31cce2adf654f$var$createEvent(ks.target, ls), ks.pointerType, !1), ks.isPressed = !1, ks.isOverTarget = !1, ks.activePointerId = null, ks.pointerType = null, Hs(), Va || $14c0b72509d70225$export$b0d6fa1ab32e3295(ks.target));
  }), Fs = $8ae05eaa5c114e9c$export$7f54fc3180508a52((ls) => {
    Ma && Cs(ls);
  }), ws = useMemo(() => {
    let ls = rs.current, ks = {
      onKeyDown(pl) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(pl.nativeEvent, pl.currentTarget) && pl.currentTarget.contains(pl.target)) {
          var _l;
          $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(pl.target, pl.key) && pl.preventDefault();
          let bl = !0;
          if (!ls.isPressed && !pl.repeat) {
            ls.target = pl.currentTarget, ls.isPressed = !0, bl = Ks(pl, "keyboard");
            let xl = pl.currentTarget, Rl = (Cl) => {
              $f6c31cce2adf654f$var$isValidKeyboardEvent(Cl, xl) && !Cl.repeat && xl.contains(Cl.target) && ls.target && Xs($f6c31cce2adf654f$var$createEvent(ls.target, Cl), "keyboard");
            };
            ko($431fbd86ca7dc216$export$b204af158042fbac(pl.currentTarget), "keyup", $ff5963eb1fccf552$export$e08e3b67e392101e(Rl, Js), !0);
          }
          bl && pl.stopPropagation(), pl.metaKey && $c87311424ea30a05$export$9ac100e40613ea10() && ((_l = ls.metaKeyEvents) === null || _l === void 0 || _l.set(pl.key, pl.nativeEvent));
        } else pl.key === "Meta" && (ls.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(pl) {
        if (!(pl && !pl.currentTarget.contains(pl.target)) && pl && pl.button === 0 && !ls.isTriggeringEvent && !$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening) {
          let _l = !0;
          if (ra && pl.preventDefault(), !ls.ignoreClickAfterPress && !ls.ignoreEmulatedMouseEvents && !ls.isPressed && (ls.pointerType === "virtual" || $6a7db85432448f7f$export$60278871457622de(pl.nativeEvent))) {
            !ra && !la && $7215afc6de606d6b$export$de79e2c695e052f3(pl.currentTarget);
            let bl = Ks(pl, "virtual"), xl = Xs(pl, "virtual"), Rl = Ys(pl, "virtual");
            _l = bl && xl && Rl;
          }
          ls.ignoreEmulatedMouseEvents = !1, ls.ignoreClickAfterPress = !1, _l && pl.stopPropagation();
        }
      }
    }, Js = (pl) => {
      var _l;
      if (ls.isPressed && ls.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(pl, ls.target)) {
        var bl;
        $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(pl.target, pl.key) && pl.preventDefault();
        let Rl = pl.target;
        Ys($f6c31cce2adf654f$var$createEvent(ls.target, pl), "keyboard", ls.target.contains(Rl)), Hs(), pl.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(ls.target) && ls.target.contains(Rl) && !pl[$f6c31cce2adf654f$var$LINK_CLICKED] && (pl[$f6c31cce2adf654f$var$LINK_CLICKED] = !0, $ea8dcbcb9ea1b556$export$95185d699e05d4d7(ls.target, pl, !1)), ls.isPressed = !1, (bl = ls.metaKeyEvents) === null || bl === void 0 || bl.delete(pl.key);
      } else if (pl.key === "Meta" && (!((_l = ls.metaKeyEvents) === null || _l === void 0) && _l.size)) {
        var xl;
        let Rl = ls.metaKeyEvents;
        ls.metaKeyEvents = void 0;
        for (let Cl of Rl.values()) (xl = ls.target) === null || xl === void 0 || xl.dispatchEvent(new KeyboardEvent("keyup", Cl));
      }
    };
    if (typeof PointerEvent < "u") {
      ks.onPointerDown = (xl) => {
        if (xl.button !== 0 || !xl.currentTarget.contains(xl.target)) return;
        if ($6a7db85432448f7f$export$29bf1b5f2c56cf63(xl.nativeEvent)) {
          ls.pointerType = "virtual";
          return;
        }
        $f6c31cce2adf654f$var$shouldPreventDefaultDown(xl.currentTarget) && xl.preventDefault(), ls.pointerType = xl.pointerType;
        let Rl = !0;
        if (!ls.isPressed) {
          ls.isPressed = !0, ls.isOverTarget = !0, ls.activePointerId = xl.pointerId, ls.target = xl.currentTarget, !ra && !la && $7215afc6de606d6b$export$de79e2c695e052f3(xl.currentTarget), Va || $14c0b72509d70225$export$16a4697467175487(ls.target), Rl = Ks(xl, ls.pointerType);
          let Cl = xl.target;
          "releasePointerCapture" in Cl && Cl.releasePointerCapture(xl.pointerId), ko($431fbd86ca7dc216$export$b204af158042fbac(xl.currentTarget), "pointerup", pl, !1), ko($431fbd86ca7dc216$export$b204af158042fbac(xl.currentTarget), "pointercancel", bl, !1);
        }
        Rl && xl.stopPropagation();
      }, ks.onMouseDown = (xl) => {
        xl.currentTarget.contains(xl.target) && xl.button === 0 && ($f6c31cce2adf654f$var$shouldPreventDefaultDown(xl.currentTarget) && xl.preventDefault(), xl.stopPropagation());
      }, ks.onPointerUp = (xl) => {
        !xl.currentTarget.contains(xl.target) || ls.pointerType === "virtual" || xl.button === 0 && Xs(xl, ls.pointerType || xl.pointerType);
      }, ks.onPointerEnter = (xl) => {
        xl.pointerId === ls.activePointerId && ls.target && !ls.isOverTarget && ls.pointerType != null && (ls.isOverTarget = !0, Ks($f6c31cce2adf654f$var$createEvent(ls.target, xl), ls.pointerType));
      }, ks.onPointerLeave = (xl) => {
        xl.pointerId === ls.activePointerId && ls.target && ls.isOverTarget && ls.pointerType != null && (ls.isOverTarget = !1, Ys($f6c31cce2adf654f$var$createEvent(ls.target, xl), ls.pointerType, !1), Fs(xl));
      };
      let pl = (xl) => {
        xl.pointerId === ls.activePointerId && ls.isPressed && xl.button === 0 && ls.target && (ls.target.contains(xl.target) && ls.pointerType != null ? Ys($f6c31cce2adf654f$var$createEvent(ls.target, xl), ls.pointerType) : ls.isOverTarget && ls.pointerType != null && Ys($f6c31cce2adf654f$var$createEvent(ls.target, xl), ls.pointerType, !1), ls.isPressed = !1, ls.isOverTarget = !1, ls.activePointerId = null, ls.pointerType = null, Hs(), Va || $14c0b72509d70225$export$b0d6fa1ab32e3295(ls.target), "ontouchend" in ls.target && xl.pointerType !== "mouse" && ko(ls.target, "touchend", _l, {
          once: !0
        }));
      }, _l = (xl) => {
        $f6c31cce2adf654f$var$shouldPreventDefaultUp(xl.currentTarget) && xl.preventDefault();
      }, bl = (xl) => {
        Cs(xl);
      };
      ks.onDragStart = (xl) => {
        xl.currentTarget.contains(xl.target) && Cs(xl);
      };
    } else {
      ks.onMouseDown = (bl) => {
        if (bl.button !== 0 || !bl.currentTarget.contains(bl.target)) return;
        if ($f6c31cce2adf654f$var$shouldPreventDefaultDown(bl.currentTarget) && bl.preventDefault(), ls.ignoreEmulatedMouseEvents) {
          bl.stopPropagation();
          return;
        }
        ls.isPressed = !0, ls.isOverTarget = !0, ls.target = bl.currentTarget, ls.pointerType = $6a7db85432448f7f$export$60278871457622de(bl.nativeEvent) ? "virtual" : "mouse", !ra && !la && $7215afc6de606d6b$export$de79e2c695e052f3(bl.currentTarget), Ks(bl, ls.pointerType) && bl.stopPropagation(), ko($431fbd86ca7dc216$export$b204af158042fbac(bl.currentTarget), "mouseup", pl, !1);
      }, ks.onMouseEnter = (bl) => {
        if (!bl.currentTarget.contains(bl.target)) return;
        let xl = !0;
        ls.isPressed && !ls.ignoreEmulatedMouseEvents && ls.pointerType != null && (ls.isOverTarget = !0, xl = Ks(bl, ls.pointerType)), xl && bl.stopPropagation();
      }, ks.onMouseLeave = (bl) => {
        if (!bl.currentTarget.contains(bl.target)) return;
        let xl = !0;
        ls.isPressed && !ls.ignoreEmulatedMouseEvents && ls.pointerType != null && (ls.isOverTarget = !1, xl = Ys(bl, ls.pointerType, !1), Fs(bl)), xl && bl.stopPropagation();
      }, ks.onMouseUp = (bl) => {
        bl.currentTarget.contains(bl.target) && !ls.ignoreEmulatedMouseEvents && bl.button === 0 && Xs(bl, ls.pointerType || "mouse");
      };
      let pl = (bl) => {
        if (bl.button === 0) {
          if (ls.isPressed = !1, Hs(), ls.ignoreEmulatedMouseEvents) {
            ls.ignoreEmulatedMouseEvents = !1;
            return;
          }
          ls.target && $f6c31cce2adf654f$var$isOverTarget(bl, ls.target) && ls.pointerType != null ? Ys($f6c31cce2adf654f$var$createEvent(ls.target, bl), ls.pointerType) : ls.target && ls.isOverTarget && ls.pointerType != null && Ys($f6c31cce2adf654f$var$createEvent(ls.target, bl), ls.pointerType, !1), ls.isOverTarget = !1;
        }
      };
      ks.onTouchStart = (bl) => {
        if (!bl.currentTarget.contains(bl.target)) return;
        let xl = $f6c31cce2adf654f$var$getTouchFromEvent(bl.nativeEvent);
        if (!xl) return;
        ls.activePointerId = xl.identifier, ls.ignoreEmulatedMouseEvents = !0, ls.isOverTarget = !0, ls.isPressed = !0, ls.target = bl.currentTarget, ls.pointerType = "touch", !ra && !la && $7215afc6de606d6b$export$de79e2c695e052f3(bl.currentTarget), Va || $14c0b72509d70225$export$16a4697467175487(ls.target), Ks($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl), ls.pointerType) && bl.stopPropagation(), ko($431fbd86ca7dc216$export$f21a1ffae260145a(bl.currentTarget), "scroll", _l, !0);
      }, ks.onTouchMove = (bl) => {
        if (!bl.currentTarget.contains(bl.target)) return;
        if (!ls.isPressed) {
          bl.stopPropagation();
          return;
        }
        let xl = $f6c31cce2adf654f$var$getTouchById(bl.nativeEvent, ls.activePointerId), Rl = !0;
        xl && $f6c31cce2adf654f$var$isOverTarget(xl, bl.currentTarget) ? !ls.isOverTarget && ls.pointerType != null && (ls.isOverTarget = !0, Rl = Ks($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl), ls.pointerType)) : ls.isOverTarget && ls.pointerType != null && (ls.isOverTarget = !1, Rl = Ys($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl), ls.pointerType, !1), Fs($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl))), Rl && bl.stopPropagation();
      }, ks.onTouchEnd = (bl) => {
        if (!bl.currentTarget.contains(bl.target)) return;
        if (!ls.isPressed) {
          bl.stopPropagation();
          return;
        }
        let xl = $f6c31cce2adf654f$var$getTouchById(bl.nativeEvent, ls.activePointerId), Rl = !0;
        xl && $f6c31cce2adf654f$var$isOverTarget(xl, bl.currentTarget) && ls.pointerType != null ? (Xs($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl), ls.pointerType), Rl = Ys($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl), ls.pointerType)) : ls.isOverTarget && ls.pointerType != null && (Rl = Ys($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl), ls.pointerType, !1)), Rl && bl.stopPropagation(), ls.isPressed = !1, ls.activePointerId = null, ls.isOverTarget = !1, ls.ignoreEmulatedMouseEvents = !0, ls.target && !Va && $14c0b72509d70225$export$b0d6fa1ab32e3295(ls.target), Hs();
      }, ks.onTouchCancel = (bl) => {
        bl.currentTarget.contains(bl.target) && (bl.stopPropagation(), ls.isPressed && Cs($f6c31cce2adf654f$var$createTouchEvent(ls.target, bl)));
      };
      let _l = (bl) => {
        ls.isPressed && bl.target.contains(ls.target) && Cs({
          currentTarget: ls.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      ks.onDragStart = (bl) => {
        bl.currentTarget.contains(bl.target) && Cs(bl);
      };
    }
    return ks;
  }, [
    ko,
    ra,
    la,
    Hs,
    Va,
    Cs,
    Fs,
    Ys,
    Ks,
    Xs
  ]);
  return useEffect(() => () => {
    var ls;
    Va || $14c0b72509d70225$export$b0d6fa1ab32e3295((ls = rs.current.target) !== null && ls !== void 0 ? ls : void 0);
  }, [
    Va
  ]), {
    isPressed: na || So,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Eo, ws)
  };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(Bi) {
  return Bi.tagName === "A" && Bi.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(Bi, e) {
  const { key: qi, code: Xi } = Bi, Qi = e, ta = Qi.getAttribute("role");
  return (qi === "Enter" || qi === " " || qi === "Spacebar" || Xi === "Space") && !(Qi instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(Qi).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(Qi, qi) || Qi instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(Qi).HTMLTextAreaElement || Qi.isContentEditable) && // Links should only trigger with Enter key
  !((ta === "link" || !ta && $f6c31cce2adf654f$var$isHTMLAnchorLink(Qi)) && qi !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(Bi) {
  const { targetTouches: e } = Bi;
  return e.length > 0 ? e[0] : null;
}
function $f6c31cce2adf654f$var$getTouchById(Bi, e) {
  const qi = Bi.changedTouches;
  for (let Xi = 0; Xi < qi.length; Xi++) {
    const Qi = qi[Xi];
    if (Qi.identifier === e) return Qi;
  }
  return null;
}
function $f6c31cce2adf654f$var$createTouchEvent(Bi, e) {
  let qi = 0, Xi = 0;
  return e.targetTouches && e.targetTouches.length === 1 && (qi = e.targetTouches[0].clientX, Xi = e.targetTouches[0].clientY), {
    currentTarget: Bi,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: qi,
    clientY: Xi
  };
}
function $f6c31cce2adf654f$var$createEvent(Bi, e) {
  let qi = e.clientX, Xi = e.clientY;
  return {
    currentTarget: Bi,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX: qi,
    clientY: Xi
  };
}
function $f6c31cce2adf654f$var$getPointClientRect(Bi) {
  let e = 0, qi = 0;
  return Bi.width !== void 0 ? e = Bi.width / 2 : Bi.radiusX !== void 0 && (e = Bi.radiusX), Bi.height !== void 0 ? qi = Bi.height / 2 : Bi.radiusY !== void 0 && (qi = Bi.radiusY), {
    top: Bi.clientY - qi,
    right: Bi.clientX + e,
    bottom: Bi.clientY + qi,
    left: Bi.clientX - e
  };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(Bi, e) {
  return !(Bi.left > e.right || e.left > Bi.right || Bi.top > e.bottom || e.top > Bi.bottom);
}
function $f6c31cce2adf654f$var$isOverTarget(Bi, e) {
  let qi = e.getBoundingClientRect(), Xi = $f6c31cce2adf654f$var$getPointClientRect(Bi);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(qi, Xi);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultDown(Bi) {
  return !(Bi instanceof HTMLElement) || !Bi.hasAttribute("draggable");
}
function $f6c31cce2adf654f$var$shouldPreventDefaultUp(Bi) {
  return Bi instanceof HTMLInputElement ? !1 : Bi instanceof HTMLButtonElement ? Bi.type !== "submit" && Bi.type !== "reset" : !$f6c31cce2adf654f$var$isHTMLAnchorLink(Bi);
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(Bi, e) {
  return Bi instanceof HTMLInputElement ? !$f6c31cce2adf654f$var$isValidInputKey(Bi, e) : $f6c31cce2adf654f$var$shouldPreventDefaultUp(Bi);
}
const $f6c31cce2adf654f$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(Bi, e) {
  return Bi.type === "checkbox" || Bi.type === "radio" ? e === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(Bi.type);
}
const $f1ab8c75478c6f73$export$3351871ee4b288b8 = /* @__PURE__ */ a__default.forwardRef(({ children: Bi, ...e }, qi) => {
  let Xi = useRef(!1), Qi = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
  qi = $df56164dff5785e2$export$4338b53315abf666(qi || Qi?.ref);
  let ta = $3ef42575df84b30b$export$9d1611c77c2fe928(Qi || {}, {
    ...e,
    ref: qi,
    register() {
      Xi.current = !0, Qi && Qi.register();
    }
  });
  return $e7801be82b4b2a53$export$4debdb1a3f0fa79e(Qi, qi), useEffect(() => {
    Xi.current || (console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), Xi.current = !0);
  }, []), /* @__PURE__ */ a__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
    value: ta
  }, Bi);
});
function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea({ children: Bi }) {
  let e = useMemo(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ a__default.createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
    value: e
  }, Bi);
}
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(e, qi) {
    this.nativeEvent = qi, this.target = qi.target, this.currentTarget = qi.currentTarget, this.relatedTarget = qi.relatedTarget, this.bubbles = qi.bubbles, this.cancelable = qi.cancelable, this.defaultPrevented = qi.defaultPrevented, this.eventPhase = qi.eventPhase, this.isTrusted = qi.isTrusted, this.timeStamp = qi.timeStamp, this.type = e;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(Bi) {
  let e = useRef({
    isFocused: !1,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const Xi = e.current;
    return () => {
      Xi.observer && (Xi.observer.disconnect(), Xi.observer = null);
    };
  }, []);
  let qi = $8ae05eaa5c114e9c$export$7f54fc3180508a52((Xi) => {
    Bi?.(Xi);
  });
  return useCallback((Xi) => {
    if (Xi.target instanceof HTMLButtonElement || Xi.target instanceof HTMLInputElement || Xi.target instanceof HTMLTextAreaElement || Xi.target instanceof HTMLSelectElement) {
      e.current.isFocused = !0;
      let Qi = Xi.target, ta = (ra) => {
        e.current.isFocused = !1, Qi.disabled && qi(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", ra)), e.current.observer && (e.current.observer.disconnect(), e.current.observer = null);
      };
      Qi.addEventListener("focusout", ta, {
        once: !0
      }), e.current.observer = new MutationObserver(() => {
        if (e.current.isFocused && Qi.disabled) {
          var ra;
          (ra = e.current.observer) === null || ra === void 0 || ra.disconnect();
          let na = Qi === document.activeElement ? null : document.activeElement;
          Qi.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: na
          })), Qi.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: na
          }));
        }
      }), e.current.observer.observe(Qi, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    qi
  ]);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(Bi) {
  let { isDisabled: e, onFocus: qi, onBlur: Xi, onFocusChange: Qi } = Bi;
  const ta = useCallback((la) => {
    if (la.target === la.currentTarget)
      return Xi && Xi(la), Qi && Qi(!1), !0;
  }, [
    Xi,
    Qi
  ]), ra = $8a9cb279dc87e130$export$715c682d09d639cc(ta), na = useCallback((la) => {
    const Ma = $431fbd86ca7dc216$export$b204af158042fbac(la.target);
    la.target === la.currentTarget && Ma.activeElement === la.target && (qi && qi(la), Qi && Qi(!0), ra(la));
  }, [
    Qi,
    qi,
    ra
  ]);
  return {
    focusProps: {
      onFocus: !e && (qi || Qi || Xi) ? na : void 0,
      onBlur: !e && (Xi || Qi) ? ta : void 0
    }
  };
}
let $507fabe10e71c6fb$var$currentModality = null, $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set(), $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map(), $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !1;
const $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: !0,
  Escape: !0
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(Bi, e) {
  for (let qi of $507fabe10e71c6fb$var$changeHandlers) qi(Bi, e);
}
function $507fabe10e71c6fb$var$isValidKey(Bi) {
  return !(Bi.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && Bi.altKey || Bi.ctrlKey || Bi.key === "Control" || Bi.key === "Shift" || Bi.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(Bi) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$isValidKey(Bi) && ($507fabe10e71c6fb$var$currentModality = "keyboard", $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", Bi));
}
function $507fabe10e71c6fb$var$handlePointerEvent(Bi) {
  $507fabe10e71c6fb$var$currentModality = "pointer", (Bi.type === "mousedown" || Bi.type === "pointerdown") && ($507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", Bi));
}
function $507fabe10e71c6fb$var$handleClickEvent(Bi) {
  $6a7db85432448f7f$export$60278871457622de(Bi) && ($507fabe10e71c6fb$var$hasEventBeforeFocus = !0, $507fabe10e71c6fb$var$currentModality = "virtual");
}
function $507fabe10e71c6fb$var$handleFocusEvent(Bi) {
  Bi.target === window || Bi.target === document || (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently && ($507fabe10e71c6fb$var$currentModality = "virtual", $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", Bi)), $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !1);
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = !1, $507fabe10e71c6fb$var$hasBlurredWindowRecently = !0;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi) {
  if (typeof window > "u" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(Bi))) return;
  const e = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi), qi = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  let Xi = e.HTMLElement.prototype.focus;
  e.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = !0, Xi.apply(this, arguments);
  }, qi.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), qi.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), qi.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, !0), e.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, !0), e.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, !1), typeof PointerEvent < "u" ? (qi.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, !0), qi.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, !0), qi.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, !0)) : (qi.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, !0), qi.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, !0), qi.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, !0)), e.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(Bi);
  }, {
    once: !0
  }), $507fabe10e71c6fb$export$d90243b58daecda7.set(e, {
    focus: Xi
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (Bi, e) => {
  const qi = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi), Xi = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  e && Xi.removeEventListener("DOMContentLoaded", e), $507fabe10e71c6fb$export$d90243b58daecda7.has(qi) && (qi.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(qi).focus, Xi.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Xi.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, !0), Xi.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, !0), qi.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, !0), qi.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, !1), typeof PointerEvent < "u" ? (Xi.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Xi.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Xi.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, !0)) : (Xi.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, !0), Xi.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, !0), Xi.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, !0)), $507fabe10e71c6fb$export$d90243b58daecda7.delete(qi));
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(Bi) {
  const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  let qi;
  return e.readyState !== "loading" ? $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi) : (qi = () => {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents(Bi);
  }, e.addEventListener("DOMContentLoaded", qi)), () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(Bi, qi);
}
typeof document < "u" && $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(Bi) {
  $507fabe10e71c6fb$var$currentModality = Bi, $507fabe10e71c6fb$var$triggerChangeHandlers(Bi, null);
}
const $507fabe10e71c6fb$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $507fabe10e71c6fb$var$isKeyboardFocusEvent(Bi, e, qi) {
  var Xi;
  const Qi = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(qi?.target).HTMLInputElement : HTMLInputElement, ta = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(qi?.target).HTMLTextAreaElement : HTMLTextAreaElement, ra = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(qi?.target).HTMLElement : HTMLElement, na = typeof window < "u" ? $431fbd86ca7dc216$export$f21a1ffae260145a(qi?.target).KeyboardEvent : KeyboardEvent;
  return Bi = Bi || qi?.target instanceof Qi && !$507fabe10e71c6fb$var$nonTextInputTypes.has(qi == null || (Xi = qi.target) === null || Xi === void 0 ? void 0 : Xi.type) || qi?.target instanceof ta || qi?.target instanceof ra && qi?.target.isContentEditable, !(Bi && e === "keyboard" && qi instanceof na && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[qi.key]);
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(Bi, e, qi) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents(), useEffect(() => {
    let Xi = (Qi, ta) => {
      $507fabe10e71c6fb$var$isKeyboardFocusEvent(!!qi?.isTextInput, Qi, ta) && Bi($507fabe10e71c6fb$export$b9b3dfddab17db27());
    };
    return $507fabe10e71c6fb$var$changeHandlers.add(Xi), () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(Xi);
    };
  }, e);
}
function $9ab94262bd0047c7$export$420e68273165f4ec(Bi) {
  let { isDisabled: e, onBlurWithin: qi, onFocusWithin: Xi, onFocusWithinChange: Qi } = Bi, ta = useRef({
    isFocusWithin: !1
  }), ra = useCallback((Ma) => {
    ta.current.isFocusWithin && !Ma.currentTarget.contains(Ma.relatedTarget) && (ta.current.isFocusWithin = !1, qi && qi(Ma), Qi && Qi(!1));
  }, [
    qi,
    Qi,
    ta
  ]), na = $8a9cb279dc87e130$export$715c682d09d639cc(ra), la = useCallback((Ma) => {
    !ta.current.isFocusWithin && document.activeElement === Ma.target && (Xi && Xi(Ma), Qi && Qi(!0), ta.current.isFocusWithin = !0, na(Ma));
  }, [
    Xi,
    Qi,
    na
  ]);
  return e ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: la,
      onBlur: ra
    }
  };
}
let $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !1, $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !0, setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = !1;
  }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(Bi) {
  Bi.pointerType === "touch" && $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent) : document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents), $6179b936705e76d3$var$hoverCount++, () => {
      $6179b936705e76d3$var$hoverCount--, !($6179b936705e76d3$var$hoverCount > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent) : document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents));
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(Bi) {
  let { onHoverStart: e, onHoverChange: qi, onHoverEnd: Xi, isDisabled: Qi } = Bi, [ta, ra] = useState(!1), na = useRef({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let { hoverProps: la, triggerHoverEnd: Ma } = useMemo(() => {
    let Va = (So, eo) => {
      if (na.pointerType = eo, Qi || eo === "touch" || na.isHovered || !So.currentTarget.contains(So.target)) return;
      na.isHovered = !0;
      let rs = So.currentTarget;
      na.target = rs, e && e({
        type: "hoverstart",
        target: rs,
        pointerType: eo
      }), qi && qi(!0), ra(!0);
    }, to = (So, eo) => {
      if (na.pointerType = "", na.target = null, eo === "touch" || !na.isHovered) return;
      na.isHovered = !1;
      let rs = So.currentTarget;
      Xi && Xi({
        type: "hoverend",
        target: rs,
        pointerType: eo
      }), qi && qi(!1), ra(!1);
    }, Eo = {};
    return typeof PointerEvent < "u" ? (Eo.onPointerEnter = (So) => {
      $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && So.pointerType === "mouse" || Va(So, So.pointerType);
    }, Eo.onPointerLeave = (So) => {
      !Qi && So.currentTarget.contains(So.target) && to(So, So.pointerType);
    }) : (Eo.onTouchStart = () => {
      na.ignoreEmulatedMouseEvents = !0;
    }, Eo.onMouseEnter = (So) => {
      !na.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && Va(So, "mouse"), na.ignoreEmulatedMouseEvents = !1;
    }, Eo.onMouseLeave = (So) => {
      !Qi && So.currentTarget.contains(So.target) && to(So, "mouse");
    }), {
      hoverProps: Eo,
      triggerHoverEnd: to
    };
  }, [
    e,
    qi,
    Xi,
    Qi,
    na
  ]);
  return useEffect(() => {
    Qi && Ma({
      currentTarget: na.target
    }, na.pointerType);
  }, [
    Qi
  ]), {
    hoverProps: la,
    isHovered: ta
  };
}
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(Bi) {
  let { ref: e, onInteractOutside: qi, isDisabled: Xi, onInteractOutsideStart: Qi } = Bi, ta = useRef({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), ra = $8ae05eaa5c114e9c$export$7f54fc3180508a52((la) => {
    qi && $e0b6e0b68ec7f50f$var$isValidEvent(la, e) && (Qi && Qi(la), ta.current.isPointerDown = !0);
  }), na = $8ae05eaa5c114e9c$export$7f54fc3180508a52((la) => {
    qi && qi(la);
  });
  useEffect(() => {
    let la = ta.current;
    if (Xi) return;
    const Ma = e.current, Va = $431fbd86ca7dc216$export$b204af158042fbac(Ma);
    if (typeof PointerEvent < "u") {
      let to = (Eo) => {
        la.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(Eo, e) && na(Eo), la.isPointerDown = !1;
      };
      return Va.addEventListener("pointerdown", ra, !0), Va.addEventListener("pointerup", to, !0), () => {
        Va.removeEventListener("pointerdown", ra, !0), Va.removeEventListener("pointerup", to, !0);
      };
    } else {
      let to = (So) => {
        la.ignoreEmulatedMouseEvents ? la.ignoreEmulatedMouseEvents = !1 : la.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(So, e) && na(So), la.isPointerDown = !1;
      }, Eo = (So) => {
        la.ignoreEmulatedMouseEvents = !0, la.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(So, e) && na(So), la.isPointerDown = !1;
      };
      return Va.addEventListener("mousedown", ra, !0), Va.addEventListener("mouseup", to, !0), Va.addEventListener("touchstart", ra, !0), Va.addEventListener("touchend", Eo, !0), () => {
        Va.removeEventListener("mousedown", ra, !0), Va.removeEventListener("mouseup", to, !0), Va.removeEventListener("touchstart", ra, !0), Va.removeEventListener("touchend", Eo, !0);
      };
    }
  }, [
    e,
    Xi,
    ra,
    na
  ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(Bi, e) {
  if (Bi.button > 0) return !1;
  if (Bi.target) {
    const qi = Bi.target.ownerDocument;
    if (!qi || !qi.documentElement.contains(Bi.target) || Bi.target.closest("[data-react-aria-top-layer]")) return !1;
  }
  return e.current && !e.current.contains(Bi.target);
}
function $93925083ecbb358c$export$48d1ea6320830260(Bi) {
  if (!Bi) return;
  let e = !0;
  return (qi) => {
    let Xi = {
      ...qi,
      preventDefault() {
        qi.preventDefault();
      },
      isDefaultPrevented() {
        return qi.isDefaultPrevented();
      },
      stopPropagation() {
        e ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : e = !0;
      },
      continuePropagation() {
        e = !1;
      },
      isPropagationStopped() {
        return e;
      }
    };
    Bi(Xi), e && qi.stopPropagation();
  };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(Bi) {
  return {
    keyboardProps: Bi.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(Bi.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(Bi.onKeyUp)
    }
  };
}
const $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(Bi) {
  let { isDisabled: e, onLongPressStart: qi, onLongPressEnd: Xi, onLongPress: Qi, threshold: ta = $8a26561d2877236e$var$DEFAULT_THRESHOLD, accessibilityDescription: ra } = Bi;
  const na = useRef(void 0);
  let { addGlobalListener: la, removeGlobalListener: Ma } = $03deb23ff14920c4$export$4eaf04e54aa8eed6(), { pressProps: Va } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled: e,
    onPressStart(Eo) {
      if (Eo.continuePropagation(), (Eo.pointerType === "mouse" || Eo.pointerType === "touch") && (qi && qi({
        ...Eo,
        type: "longpressstart"
      }), na.current = setTimeout(() => {
        Eo.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), Qi && Qi({
          ...Eo,
          type: "longpress"
        }), na.current = void 0;
      }, ta), Eo.pointerType === "touch")) {
        let So = (eo) => {
          eo.preventDefault();
        };
        la(Eo.target, "contextmenu", So, {
          once: !0
        }), la(window, "pointerup", () => {
          setTimeout(() => {
            Ma(Eo.target, "contextmenu", So);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(Eo) {
      na.current && clearTimeout(na.current), Xi && (Eo.pointerType === "mouse" || Eo.pointerType === "touch") && Xi({
        ...Eo,
        type: "longpressend"
      });
    }
  }), to = $ef06256079686ba0$export$f8aeda7b10753fa1(Qi && !e ? ra : void 0);
  return {
    longPressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Va, to)
  };
}
function $6a99195332edec8b$export$80f3e147d781571c(Bi) {
  const e = $431fbd86ca7dc216$export$b204af158042fbac(Bi);
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let qi = e.activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      e.activeElement === qi && Bi.isConnected && $7215afc6de606d6b$export$de79e2c695e052f3(Bi);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(Bi);
}
function $645f2e67b85a24c9$var$isStyleVisible(Bi) {
  const e = $431fbd86ca7dc216$export$f21a1ffae260145a(Bi);
  if (!(Bi instanceof e.HTMLElement) && !(Bi instanceof e.SVGElement)) return !1;
  let { display: qi, visibility: Xi } = Bi.style, Qi = qi !== "none" && Xi !== "hidden" && Xi !== "collapse";
  if (Qi) {
    const { getComputedStyle: ta } = Bi.ownerDocument.defaultView;
    let { display: ra, visibility: na } = ta(Bi);
    Qi = ra !== "none" && na !== "hidden" && na !== "collapse";
  }
  return Qi;
}
function $645f2e67b85a24c9$var$isAttributeVisible(Bi, e) {
  return !Bi.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !Bi.hasAttribute("data-react-aria-prevent-focus") && (Bi.nodeName === "DETAILS" && e && e.nodeName !== "SUMMARY" ? Bi.hasAttribute("open") : !0);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(Bi, e) {
  return Bi.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(Bi) && $645f2e67b85a24c9$var$isAttributeVisible(Bi, e) && (!Bi.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(Bi.parentElement, Bi));
}
const $9bf71ea28793e738$var$FocusContext = /* @__PURE__ */ a__default.createContext(null), $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(Bi) {
  let { children: e, contain: qi, restoreFocus: Xi, autoFocus: Qi } = Bi, ta = useRef(null), ra = useRef(null), na = useRef([]), { parentNode: la } = useContext($9bf71ea28793e738$var$FocusContext) || {}, Ma = useMemo(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef: na
  }), [
    na
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Eo = la || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Eo.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Eo.scopeRef)) {
      let So = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      So && (Eo = So);
    }
    Eo.addChild(Ma), $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(Ma);
  }, [
    Ma,
    la
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Eo = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(na);
    Eo && (Eo.contain = !!qi);
  }, [
    qi
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    var Eo;
    let So = (Eo = ta.current) === null || Eo === void 0 ? void 0 : Eo.nextSibling, eo = [], rs = (ko) => ko.stopPropagation();
    for (; So && So !== ra.current; )
      eo.push(So), So.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, rs), So = So.nextSibling;
    return na.current = eo, () => {
      for (let ko of eo) ko.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, rs);
    };
  }, [
    e
  ]), $9bf71ea28793e738$var$useActiveScopeTracker(na, Xi, qi), $9bf71ea28793e738$var$useFocusContainment(na, qi), $9bf71ea28793e738$var$useRestoreFocus(na, Xi, qi), $9bf71ea28793e738$var$useAutoFocus(na, Qi), useEffect(() => {
    const Eo = $431fbd86ca7dc216$export$b204af158042fbac(na.current ? na.current[0] : void 0).activeElement;
    let So = null;
    if ($9bf71ea28793e738$var$isElementInScope(Eo, na.current)) {
      for (let eo of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()) eo.scopeRef && $9bf71ea28793e738$var$isElementInScope(Eo, eo.scopeRef.current) && (So = eo);
      So === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(na) && ($9bf71ea28793e738$var$activeScope = So.scopeRef);
    }
  }, [
    na
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => () => {
    var Eo, So, eo;
    let rs = (eo = (So = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(na)) === null || So === void 0 || (Eo = So.parent) === null || Eo === void 0 ? void 0 : Eo.scopeRef) !== null && eo !== void 0 ? eo : null;
    (na === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(na, $9bf71ea28793e738$var$activeScope)) && (!rs || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(rs)) && ($9bf71ea28793e738$var$activeScope = rs), $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(na);
  }, [
    na
  ]);
  let Va = useMemo(() => $9bf71ea28793e738$var$createFocusManagerForScope(na), []), to = useMemo(() => ({
    focusManager: Va,
    parentNode: Ma
  }), [
    Ma,
    Va
  ]);
  return /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value: to
  }, /* @__PURE__ */ a__default.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: ta
  }), e, /* @__PURE__ */ a__default.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: ra
  }));
}
function $9bf71ea28793e738$var$createFocusManagerForScope(Bi) {
  return {
    focusNext(e = {}) {
      let qi = Bi.current, { from: Xi, tabbable: Qi, wrap: ta, accept: ra } = e, na = Xi || $431fbd86ca7dc216$export$b204af158042fbac(qi[0]).activeElement, la = qi[0].previousElementSibling, Ma = $9bf71ea28793e738$var$getScopeRoot(qi), Va = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Ma, {
        tabbable: Qi,
        accept: ra
      }, qi);
      Va.currentNode = $9bf71ea28793e738$var$isElementInScope(na, qi) ? na : la;
      let to = Va.nextNode();
      return !to && ta && (Va.currentNode = la, to = Va.nextNode()), to && $9bf71ea28793e738$var$focusElement(to, !0), to;
    },
    focusPrevious(e = {}) {
      let qi = Bi.current, { from: Xi, tabbable: Qi, wrap: ta, accept: ra } = e, na = Xi || $431fbd86ca7dc216$export$b204af158042fbac(qi[0]).activeElement, la = qi[qi.length - 1].nextElementSibling, Ma = $9bf71ea28793e738$var$getScopeRoot(qi), Va = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Ma, {
        tabbable: Qi,
        accept: ra
      }, qi);
      Va.currentNode = $9bf71ea28793e738$var$isElementInScope(na, qi) ? na : la;
      let to = Va.previousNode();
      return !to && ta && (Va.currentNode = la, to = Va.previousNode()), to && $9bf71ea28793e738$var$focusElement(to, !0), to;
    },
    focusFirst(e = {}) {
      let qi = Bi.current, { tabbable: Xi, accept: Qi } = e, ta = $9bf71ea28793e738$var$getScopeRoot(qi), ra = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ta, {
        tabbable: Xi,
        accept: Qi
      }, qi);
      ra.currentNode = qi[0].previousElementSibling;
      let na = ra.nextNode();
      return na && $9bf71ea28793e738$var$focusElement(na, !0), na;
    },
    focusLast(e = {}) {
      let qi = Bi.current, { tabbable: Xi, accept: Qi } = e, ta = $9bf71ea28793e738$var$getScopeRoot(qi), ra = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ta, {
        tabbable: Xi,
        accept: Qi
      }, qi);
      ra.currentNode = qi[qi.length - 1].nextElementSibling;
      let na = ra.previousNode();
      return na && $9bf71ea28793e738$var$focusElement(na, !0), na;
    }
  };
}
const $9bf71ea28793e738$var$focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
], $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(Bi) {
  return Bi[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(Bi) {
  let e = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  for (; e && e.scopeRef !== Bi; ) {
    if (e.contain) return !1;
    e = e.parent;
  }
  return !0;
}
function $9bf71ea28793e738$var$useFocusContainment(Bi, e) {
  let qi = useRef(void 0), Xi = useRef(void 0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Qi = Bi.current;
    if (!e) {
      Xi.current && (cancelAnimationFrame(Xi.current), Xi.current = void 0);
      return;
    }
    const ta = $431fbd86ca7dc216$export$b204af158042fbac(Qi ? Qi[0] : void 0);
    let ra = (Ma) => {
      if (Ma.key !== "Tab" || Ma.altKey || Ma.ctrlKey || Ma.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(Bi) || Ma.isComposing) return;
      let Va = ta.activeElement, to = Bi.current;
      if (!to || !$9bf71ea28793e738$var$isElementInScope(Va, to)) return;
      let Eo = $9bf71ea28793e738$var$getScopeRoot(to), So = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Eo, {
        tabbable: !0
      }, to);
      if (!Va) return;
      So.currentNode = Va;
      let eo = Ma.shiftKey ? So.previousNode() : So.nextNode();
      eo || (So.currentNode = Ma.shiftKey ? to[to.length - 1].nextElementSibling : to[0].previousElementSibling, eo = Ma.shiftKey ? So.previousNode() : So.nextNode()), Ma.preventDefault(), eo && $9bf71ea28793e738$var$focusElement(eo, !0);
    }, na = (Ma) => {
      (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Bi)) && $9bf71ea28793e738$var$isElementInScope(Ma.target, Bi.current) ? ($9bf71ea28793e738$var$activeScope = Bi, qi.current = Ma.target) : $9bf71ea28793e738$var$shouldContainFocus(Bi) && !$9bf71ea28793e738$var$isElementInChildScope(Ma.target, Bi) ? qi.current ? qi.current.focus() : $9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current && $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current) : $9bf71ea28793e738$var$shouldContainFocus(Bi) && (qi.current = Ma.target);
    }, la = (Ma) => {
      Xi.current && cancelAnimationFrame(Xi.current), Xi.current = requestAnimationFrame(() => {
        let Va = $507fabe10e71c6fb$export$630ff653c5ada6a9();
        if (!((Va === "virtual" || Va === null) && $c87311424ea30a05$export$a11b0059900ceec8() && $c87311424ea30a05$export$6446a186d09e379e()) && ta.activeElement && $9bf71ea28793e738$var$shouldContainFocus(Bi) && !$9bf71ea28793e738$var$isElementInChildScope(ta.activeElement, Bi))
          if ($9bf71ea28793e738$var$activeScope = Bi, ta.body.contains(Ma.target)) {
            var Eo;
            qi.current = Ma.target, (Eo = qi.current) === null || Eo === void 0 || Eo.focus();
          } else $9bf71ea28793e738$var$activeScope.current && $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      });
    };
    return ta.addEventListener("keydown", ra, !1), ta.addEventListener("focusin", na, !1), Qi?.forEach((Ma) => Ma.addEventListener("focusin", na, !1)), Qi?.forEach((Ma) => Ma.addEventListener("focusout", la, !1)), () => {
      ta.removeEventListener("keydown", ra, !1), ta.removeEventListener("focusin", na, !1), Qi?.forEach((Ma) => Ma.removeEventListener("focusin", na, !1)), Qi?.forEach((Ma) => Ma.removeEventListener("focusout", la, !1));
    };
  }, [
    Bi,
    e
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => () => {
    Xi.current && cancelAnimationFrame(Xi.current);
  }, [
    Xi
  ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(Bi) {
  return $9bf71ea28793e738$var$isElementInChildScope(Bi);
}
function $9bf71ea28793e738$var$isElementInScope(Bi, e) {
  return !Bi || !e ? !1 : e.some((qi) => qi.contains(Bi));
}
function $9bf71ea28793e738$var$isElementInChildScope(Bi, e = null) {
  if (Bi instanceof Element && Bi.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: qi } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(e)))
    if (qi && $9bf71ea28793e738$var$isElementInScope(Bi, qi.current)) return !0;
  return !1;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(Bi) {
  return $9bf71ea28793e738$var$isElementInChildScope(Bi, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(Bi, e) {
  var qi;
  let Xi = (qi = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(e)) === null || qi === void 0 ? void 0 : qi.parent;
  for (; Xi; ) {
    if (Xi.scopeRef === Bi) return !0;
    Xi = Xi.parent;
  }
  return !1;
}
function $9bf71ea28793e738$var$focusElement(Bi, e = !1) {
  if (Bi != null && !e) try {
    $6a99195332edec8b$export$80f3e147d781571c(Bi);
  } catch {
  }
  else if (Bi != null) try {
    Bi.focus();
  } catch {
  }
}
function $9bf71ea28793e738$var$getFirstInScope(Bi, e = !0) {
  let qi = Bi[0].previousElementSibling, Xi = $9bf71ea28793e738$var$getScopeRoot(Bi), Qi = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Xi, {
    tabbable: e
  }, Bi);
  Qi.currentNode = qi;
  let ta = Qi.nextNode();
  return e && !ta && (Xi = $9bf71ea28793e738$var$getScopeRoot(Bi), Qi = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Xi, {
    tabbable: !1
  }, Bi), Qi.currentNode = qi, ta = Qi.nextNode()), ta;
}
function $9bf71ea28793e738$var$focusFirstInScope(Bi, e = !0) {
  $9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(Bi, e));
}
function $9bf71ea28793e738$var$useAutoFocus(Bi, e) {
  const qi = a__default.useRef(e);
  useEffect(() => {
    if (qi.current) {
      $9bf71ea28793e738$var$activeScope = Bi;
      const Xi = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
      !$9bf71ea28793e738$var$isElementInScope(Xi.activeElement, $9bf71ea28793e738$var$activeScope.current) && Bi.current && $9bf71ea28793e738$var$focusFirstInScope(Bi.current);
    }
    qi.current = !1;
  }, [
    Bi
  ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(Bi, e, qi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e || qi) return;
    let Xi = Bi.current;
    const Qi = $431fbd86ca7dc216$export$b204af158042fbac(Xi ? Xi[0] : void 0);
    let ta = (ra) => {
      let na = ra.target;
      $9bf71ea28793e738$var$isElementInScope(na, Bi.current) ? $9bf71ea28793e738$var$activeScope = Bi : $9bf71ea28793e738$var$isElementInAnyScope(na) || ($9bf71ea28793e738$var$activeScope = null);
    };
    return Qi.addEventListener("focusin", ta, !1), Xi?.forEach((ra) => ra.addEventListener("focusin", ta, !1)), () => {
      Qi.removeEventListener("focusin", ta, !1), Xi?.forEach((ra) => ra.removeEventListener("focusin", ta, !1));
    };
  }, [
    Bi,
    e,
    qi
  ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(Bi) {
  let e = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  for (; e && e.scopeRef !== Bi; ) {
    if (e.nodeToRestore) return !1;
    e = e.parent;
  }
  return e?.scopeRef === Bi;
}
function $9bf71ea28793e738$var$useRestoreFocus(Bi, e, qi) {
  const Xi = useRef(typeof document < "u" ? $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0).activeElement : null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Qi = Bi.current;
    const ta = $431fbd86ca7dc216$export$b204af158042fbac(Qi ? Qi[0] : void 0);
    if (!e || qi) return;
    let ra = () => {
      (!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, Bi)) && $9bf71ea28793e738$var$isElementInScope(ta.activeElement, Bi.current) && ($9bf71ea28793e738$var$activeScope = Bi);
    };
    return ta.addEventListener("focusin", ra, !1), Qi?.forEach((na) => na.addEventListener("focusin", ra, !1)), () => {
      ta.removeEventListener("focusin", ra, !1), Qi?.forEach((na) => na.removeEventListener("focusin", ra, !1));
    };
  }, [
    Bi,
    qi
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const Qi = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
    if (!e) return;
    let ta = (ra) => {
      if (ra.key !== "Tab" || ra.altKey || ra.ctrlKey || ra.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(Bi) || ra.isComposing) return;
      let na = Qi.activeElement;
      if (!$9bf71ea28793e738$var$isElementInChildScope(na, Bi) || !$9bf71ea28793e738$var$shouldRestoreFocus(Bi)) return;
      let la = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
      if (!la) return;
      let Ma = la.nodeToRestore, Va = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Qi.body, {
        tabbable: !0
      });
      Va.currentNode = na;
      let to = ra.shiftKey ? Va.previousNode() : Va.nextNode();
      if ((!Ma || !Qi.body.contains(Ma) || Ma === Qi.body) && (Ma = void 0, la.nodeToRestore = void 0), (!to || !$9bf71ea28793e738$var$isElementInChildScope(to, Bi)) && Ma) {
        Va.currentNode = Ma;
        do
          to = ra.shiftKey ? Va.previousNode() : Va.nextNode();
        while ($9bf71ea28793e738$var$isElementInChildScope(to, Bi));
        ra.preventDefault(), ra.stopPropagation(), to ? $9bf71ea28793e738$var$focusElement(to, !0) : $9bf71ea28793e738$var$isElementInAnyScope(Ma) ? $9bf71ea28793e738$var$focusElement(Ma, !0) : na.blur();
      }
    };
    return qi || Qi.addEventListener("keydown", ta, !0), () => {
      qi || Qi.removeEventListener("keydown", ta, !0);
    };
  }, [
    Bi,
    e,
    qi
  ]), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const Qi = $431fbd86ca7dc216$export$b204af158042fbac(Bi.current ? Bi.current[0] : void 0);
    if (!e) return;
    let ta = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
    if (ta) {
      var ra;
      return ta.nodeToRestore = (ra = Xi.current) !== null && ra !== void 0 ? ra : void 0, () => {
        let na = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Bi);
        if (!na) return;
        let la = na.nodeToRestore;
        if (e && la && (Qi.activeElement && $9bf71ea28793e738$var$isElementInChildScope(Qi.activeElement, Bi) || Qi.activeElement === Qi.body && $9bf71ea28793e738$var$shouldRestoreFocus(Bi))) {
          let Ma = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
          requestAnimationFrame(() => {
            if (Qi.activeElement === Qi.body) {
              let Va = Ma.getTreeNode(Bi);
              for (; Va; ) {
                if (Va.nodeToRestore && Va.nodeToRestore.isConnected) {
                  $9bf71ea28793e738$var$restoreFocusToElement(Va.nodeToRestore);
                  return;
                }
                Va = Va.parent;
              }
              for (Va = Ma.getTreeNode(Bi); Va; ) {
                if (Va.scopeRef && Va.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(Va.scopeRef)) {
                  let to = $9bf71ea28793e738$var$getFirstInScope(Va.scopeRef.current, !0);
                  $9bf71ea28793e738$var$restoreFocusToElement(to);
                  return;
                }
                Va = Va.parent;
              }
            }
          });
        }
      };
    }
  }, [
    Bi,
    e
  ]);
}
function $9bf71ea28793e738$var$restoreFocusToElement(Bi) {
  Bi.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
    bubbles: !0,
    cancelable: !0
  })) && $9bf71ea28793e738$var$focusElement(Bi);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(Bi, e, qi) {
  let Xi = e?.tabbable ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR, Qi = $431fbd86ca7dc216$export$b204af158042fbac(Bi).createTreeWalker(Bi, NodeFilter.SHOW_ELEMENT, {
    acceptNode(ta) {
      var ra;
      return !(e == null || (ra = e.from) === null || ra === void 0) && ra.contains(ta) ? NodeFilter.FILTER_REJECT : ta.matches(Xi) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(ta) && (!qi || $9bf71ea28793e738$var$isElementInScope(ta, qi)) && (!e?.accept || e.accept(ta)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return e?.from && (Qi.currentNode = e.from), Qi;
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(e) {
    return this.fastMap.get(e);
  }
  addTreeNode(e, qi, Xi) {
    let Qi = this.fastMap.get(qi ?? null);
    if (!Qi) return;
    let ta = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: e
    });
    Qi.addChild(ta), ta.parent = Qi, this.fastMap.set(e, ta), Xi && (ta.nodeToRestore = Xi);
  }
  addNode(e) {
    this.fastMap.set(e.scopeRef, e);
  }
  removeTreeNode(e) {
    if (e === null) return;
    let qi = this.fastMap.get(e);
    if (!qi) return;
    let Xi = qi.parent;
    for (let ta of this.traverse()) ta !== qi && qi.nodeToRestore && ta.nodeToRestore && qi.scopeRef && qi.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(ta.nodeToRestore, qi.scopeRef.current) && (ta.nodeToRestore = qi.nodeToRestore);
    let Qi = qi.children;
    Xi && (Xi.removeChild(qi), Qi.size > 0 && Qi.forEach((ta) => Xi && Xi.addChild(ta))), this.fastMap.delete(qi.scopeRef);
  }
  // Pre Order Depth First
  *traverse(e = this.root) {
    if (e.scopeRef != null && (yield e), e.children.size > 0) for (let qi of e.children) yield* this.traverse(qi);
  }
  clone() {
    var e;
    let qi = new $9bf71ea28793e738$var$Tree();
    var Xi;
    for (let Qi of this.traverse()) qi.addTreeNode(Qi.scopeRef, (Xi = (e = Qi.parent) === null || e === void 0 ? void 0 : e.scopeRef) !== null && Xi !== void 0 ? Xi : null, Qi.nodeToRestore);
    return qi;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(e) {
    this.children.add(e), e.parent = this;
  }
  removeChild(e) {
    this.children.delete(e), e.parent = void 0;
  }
  constructor(e) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
  }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
function $f7dceffc5ad7768b$export$4e328f61c538687f(Bi = {}) {
  let { autoFocus: e = !1, isTextInput: qi, within: Xi } = Bi, Qi = useRef({
    isFocused: !1,
    isFocusVisible: e || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  }), [ta, ra] = useState(!1), [na, la] = useState(() => Qi.current.isFocused && Qi.current.isFocusVisible), Ma = useCallback(() => la(Qi.current.isFocused && Qi.current.isFocusVisible), []), Va = useCallback((So) => {
    Qi.current.isFocused = So, ra(So), Ma();
  }, [
    Ma
  ]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3((So) => {
    Qi.current.isFocusVisible = So, Ma();
  }, [], {
    isTextInput: qi
  });
  let { focusProps: to } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: Xi,
    onFocusChange: Va
  }), { focusWithinProps: Eo } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Xi,
    onFocusWithinChange: Va
  });
  return {
    isFocused: ta,
    isFocusVisible: na,
    focusProps: Xi ? Eo : to
  };
}
let $e6afbd83fe6ebbd2$var$FocusableContext = /* @__PURE__ */ a__default.createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(Bi) {
  let e = useContext($e6afbd83fe6ebbd2$var$FocusableContext) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(e, Bi);
  let { ref: qi, ...Xi } = e;
  return Xi;
}
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(Bi, e) {
  let { focusProps: qi } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(Bi), { keyboardProps: Xi } = $46d819fcbaf35654$export$8f71654801c2f7cd(Bi), Qi = $3ef42575df84b30b$export$9d1611c77c2fe928(qi, Xi), ta = $e6afbd83fe6ebbd2$var$useFocusableContext(e), ra = Bi.isDisabled ? {} : ta, na = useRef(Bi.autoFocus);
  return useEffect(() => {
    na.current && e.current && $6a99195332edec8b$export$80f3e147d781571c(e.current), na.current = !1;
  }, [
    e
  ]), {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928({
      ...Qi,
      tabIndex: Bi.excludeFromTabOrder && !Bi.isDisabled ? -1 : void 0
    }, ra)
  };
}
const $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(Bi) {
  if (Intl.Locale) {
    let qi = new Intl.Locale(Bi).maximize(), Xi = typeof qi.getTextInfo == "function" ? qi.getTextInfo() : qi.textInfo;
    if (Xi) return Xi.direction === "rtl";
    if (qi.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(qi.script);
  }
  let e = Bi.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(e);
}
const $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let Bi = typeof window < "u" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      Bi
    ]);
  } catch {
    Bi = "en-US";
  }
  return {
    locale: Bi,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(Bi) ? "rtl" : "ltr"
  };
}
let $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5(), $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */ new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
  for (let Bi of $1e5a04cdaf7d1af8$var$listeners) Bi($1e5a04cdaf7d1af8$var$currentLocale);
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let Bi = $b5e257d569688ac6$export$535bd6ca7f90a273(), [e, qi] = useState($1e5a04cdaf7d1af8$var$currentLocale);
  return useEffect(() => ($1e5a04cdaf7d1af8$var$listeners.size === 0 && window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale), $1e5a04cdaf7d1af8$var$listeners.add(qi), () => {
    $1e5a04cdaf7d1af8$var$listeners.delete(qi), $1e5a04cdaf7d1af8$var$listeners.size === 0 && window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
  }), []), Bi ? {
    locale: "en-US",
    direction: "ltr"
  } : e;
}
const $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */ a__default.createContext(null);
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let Bi = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  return useContext($18f2051aff69b9bf$var$I18nContext) || Bi;
}
const $5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale"), $5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
let $5b160d28a433310d$var$cachedGlobalStrings;
class $5b160d28a433310d$export$c17fa47878dc55b6 {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(e, qi) {
    let Qi = this.getStringsForLocale(qi)[e];
    if (!Qi) throw new Error(`Could not find intl message ${e} in ${qi} locale`);
    return Qi;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(e) {
    let qi = this.strings[e];
    return qi || (qi = $5b160d28a433310d$var$getStringsForLocale(e, this.strings, this.defaultLocale), this.strings[e] = qi), qi;
  }
  static getGlobalDictionaryForPackage(e) {
    if (typeof window > "u") return null;
    let qi = window[$5b160d28a433310d$var$localeSymbol];
    if ($5b160d28a433310d$var$cachedGlobalStrings === void 0) {
      let Qi = window[$5b160d28a433310d$var$stringsSymbol];
      if (!Qi) return null;
      $5b160d28a433310d$var$cachedGlobalStrings = {};
      for (let ta in Qi) $5b160d28a433310d$var$cachedGlobalStrings[ta] = new $5b160d28a433310d$export$c17fa47878dc55b6({
        [qi]: Qi[ta]
      }, qi);
    }
    let Xi = $5b160d28a433310d$var$cachedGlobalStrings?.[e];
    if (!Xi) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return Xi;
  }
  constructor(e, qi = "en-US") {
    this.strings = Object.fromEntries(Object.entries(e).filter(([, Xi]) => Xi)), this.defaultLocale = qi;
  }
}
function $5b160d28a433310d$var$getStringsForLocale(Bi, e, qi = "en-US") {
  if (e[Bi]) return e[Bi];
  let Xi = $5b160d28a433310d$var$getLanguage(Bi);
  if (e[Xi]) return e[Xi];
  for (let Qi in e)
    if (Qi.startsWith(Xi + "-")) return e[Qi];
  return e[qi];
}
function $5b160d28a433310d$var$getLanguage(Bi) {
  return Intl.Locale ? new Intl.Locale(Bi).language : Bi.split("-")[0];
}
const $6db58dc88e78b024$var$pluralRulesCache = /* @__PURE__ */ new Map(), $6db58dc88e78b024$var$numberFormatCache = /* @__PURE__ */ new Map();
class $6db58dc88e78b024$export$2f817fcdc4b89ae0 {
  /** Formats a localized string for the given key with the provided variables. */
  format(e, qi) {
    let Xi = this.strings.getStringForLocale(e, this.locale);
    return typeof Xi == "function" ? Xi(qi, this) : Xi;
  }
  plural(e, qi, Xi = "cardinal") {
    let Qi = qi["=" + e];
    if (Qi) return typeof Qi == "function" ? Qi() : Qi;
    let ta = this.locale + ":" + Xi, ra = $6db58dc88e78b024$var$pluralRulesCache.get(ta);
    ra || (ra = new Intl.PluralRules(this.locale, {
      type: Xi
    }), $6db58dc88e78b024$var$pluralRulesCache.set(ta, ra));
    let na = ra.select(e);
    return Qi = qi[na] || qi.other, typeof Qi == "function" ? Qi() : Qi;
  }
  number(e) {
    let qi = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
    return qi || (qi = new Intl.NumberFormat(this.locale), $6db58dc88e78b024$var$numberFormatCache.set(this.locale, qi)), qi.format(e);
  }
  select(e, qi) {
    let Xi = e[qi] || e.other;
    return typeof Xi == "function" ? Xi() : Xi;
  }
  constructor(e, qi) {
    this.locale = e, this.strings = qi;
  }
}
const $fca6afa0e843324b$var$cache = /* @__PURE__ */ new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(Bi) {
  let e = $fca6afa0e843324b$var$cache.get(Bi);
  return e || (e = new $5b160d28a433310d$export$c17fa47878dc55b6(Bi), $fca6afa0e843324b$var$cache.set(Bi, e)), e;
}
function $fca6afa0e843324b$export$87b761675e8eaa10(Bi, e) {
  return e && $5b160d28a433310d$export$c17fa47878dc55b6.getGlobalDictionaryForPackage(e) || $fca6afa0e843324b$var$getCachedDictionary(Bi);
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(Bi, e) {
  let { locale: qi } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), Xi = $fca6afa0e843324b$export$87b761675e8eaa10(Bi, e);
  return useMemo(() => new $6db58dc88e78b024$export$2f817fcdc4b89ae0(qi, Xi), [
    qi,
    Xi
  ]);
}
let $325a3faab7a68acd$var$cache = /* @__PURE__ */ new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(Bi) {
  let { locale: e } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), qi = e + (Bi ? Object.entries(Bi).sort((Qi, ta) => Qi[0] < ta[0] ? -1 : 1).join() : "");
  if ($325a3faab7a68acd$var$cache.has(qi)) return $325a3faab7a68acd$var$cache.get(qi);
  let Xi = new Intl.Collator(e, Bi);
  return $325a3faab7a68acd$var$cache.set(qi, Xi), Xi;
}
function $701a24aa0da5b062$export$ea18c227d4417cc3(Bi, e) {
  let {
    elementType: qi = "button",
    isDisabled: Xi,
    onPress: Qi,
    onPressStart: ta,
    onPressEnd: ra,
    onPressUp: na,
    onPressChange: la,
    preventFocusOnPress: Ma,
    allowFocusWhenDisabled: Va,
    // @ts-ignore
    onClick: to,
    href: Eo,
    target: So,
    rel: eo,
    type: rs = "button"
  } = Bi, ko;
  qi === "button" ? ko = {
    type: rs,
    disabled: Xi
  } : ko = {
    role: "button",
    tabIndex: Xi ? void 0 : 0,
    href: qi === "a" && !Xi ? Eo : void 0,
    target: qi === "a" ? So : void 0,
    type: qi === "input" ? rs : void 0,
    disabled: qi === "input" ? Xi : void 0,
    "aria-disabled": !Xi || qi === "input" ? void 0 : Xi,
    rel: qi === "a" ? eo : void 0
  };
  let { pressProps: Hs, isPressed: Ks } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart: ta,
    onPressEnd: ra,
    onPressChange: la,
    onPress: Qi,
    onPressUp: na,
    isDisabled: Xi,
    preventFocusOnPress: Ma,
    ref: e
  }), { focusableProps: Ys } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(Bi, e);
  Va && (Ys.tabIndex = Xi ? -1 : Ys.tabIndex);
  let Xs = $3ef42575df84b30b$export$9d1611c77c2fe928(Ys, Hs, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }));
  return {
    isPressed: Ks,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(ko, Xs, {
      "aria-haspopup": Bi["aria-haspopup"],
      "aria-expanded": Bi["aria-expanded"],
      "aria-controls": Bi["aria-controls"],
      "aria-pressed": Bi["aria-pressed"],
      onClick: (Cs) => {
        to && (to(Cs), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
const $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7e3;
let $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(Bi, e = "assertive", qi = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
  $319e236875307eab$var$liveAnnouncer ? $319e236875307eab$var$liveAnnouncer.announce(Bi, e, qi) : ($319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? $319e236875307eab$var$liveAnnouncer.announce(Bi, e, qi) : setTimeout(() => {
    $319e236875307eab$var$liveAnnouncer?.isAttached() && $319e236875307eab$var$liveAnnouncer?.announce(Bi, e, qi);
  }, 100));
}
class $319e236875307eab$var$LiveAnnouncer {
  isAttached() {
    var e;
    return (e = this.node) === null || e === void 0 ? void 0 : e.isConnected;
  }
  createLog(e) {
    let qi = document.createElement("div");
    return qi.setAttribute("role", "log"), qi.setAttribute("aria-live", e), qi.setAttribute("aria-relevant", "additions"), qi;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(e, qi = "assertive", Xi = $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY) {
    var Qi, ta;
    if (!this.node) return;
    let ra = document.createElement("div");
    typeof e == "object" ? (ra.setAttribute("role", "img"), ra.setAttribute("aria-labelledby", e["aria-labelledby"])) : ra.textContent = e, qi === "assertive" ? (Qi = this.assertiveLog) === null || Qi === void 0 || Qi.appendChild(ra) : (ta = this.politeLog) === null || ta === void 0 || ta.appendChild(ra), e !== "" && setTimeout(() => {
      ra.remove();
    }, Xi);
  }
  clear(e) {
    this.node && ((!e || e === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!e || e === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const $e5be200c675c3b3a$export$aca958c65c314e6c = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = {
  ...$e5be200c675c3b3a$export$aca958c65c314e6c,
  customError: !0,
  valid: !1
}, $e5be200c675c3b3a$export$dad6ae84456c676a = {
  isInvalid: !1,
  validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
  validationErrors: []
}, $e5be200c675c3b3a$export$571b5131b7e65c11 = createContext({}), $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(Bi) {
  if (Bi[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
    let { realtimeValidation: e, displayValidation: qi, updateValidation: Xi, resetValidation: Qi, commitValidation: ta } = Bi[$e5be200c675c3b3a$export$a763b9476acd3eb];
    return {
      realtimeValidation: e,
      displayValidation: qi,
      updateValidation: Xi,
      resetValidation: Qi,
      commitValidation: ta
    };
  }
  return $e5be200c675c3b3a$var$useFormValidationStateImpl(Bi);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(Bi) {
  let { isInvalid: e, validationState: qi, name: Xi, value: Qi, builtinValidation: ta, validate: ra, validationBehavior: na = "aria" } = Bi;
  qi && (e || (e = qi === "invalid"));
  let la = e !== void 0 ? {
    isInvalid: e,
    validationErrors: [],
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null, Ma = useMemo(() => {
    if (!ra || Qi == null) return null;
    let Js = $e5be200c675c3b3a$var$runValidate(ra, Qi);
    return $e5be200c675c3b3a$var$getValidationResult(Js);
  }, [
    ra,
    Qi
  ]);
  ta?.validationDetails.valid && (ta = void 0);
  let Va = useContext($e5be200c675c3b3a$export$571b5131b7e65c11), to = useMemo(() => Xi ? Array.isArray(Xi) ? Xi.flatMap((Js) => $e5be200c675c3b3a$var$asArray(Va[Js])) : $e5be200c675c3b3a$var$asArray(Va[Xi]) : [], [
    Va,
    Xi
  ]), [Eo, So] = useState(Va), [eo, rs] = useState(!1);
  Va !== Eo && (So(Va), rs(!1));
  let ko = useMemo(() => $e5be200c675c3b3a$var$getValidationResult(eo ? [] : to), [
    eo,
    to
  ]), Hs = useRef($e5be200c675c3b3a$export$dad6ae84456c676a), [Ks, Ys] = useState($e5be200c675c3b3a$export$dad6ae84456c676a), Xs = useRef($e5be200c675c3b3a$export$dad6ae84456c676a), Cs = () => {
    if (!Fs) return;
    ws(!1);
    let Js = Ma || ta || Hs.current;
    $e5be200c675c3b3a$var$isEqualValidation(Js, Xs.current) || (Xs.current = Js, Ys(Js));
  }, [Fs, ws] = useState(!1);
  return useEffect(Cs), {
    realtimeValidation: la || ko || Ma || ta || $e5be200c675c3b3a$export$dad6ae84456c676a,
    displayValidation: na === "native" ? la || ko || Ks : la || ko || Ma || ta || Ks,
    updateValidation(Js) {
      na === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(Ks, Js) ? Ys(Js) : Hs.current = Js;
    },
    resetValidation() {
      let Js = $e5be200c675c3b3a$export$dad6ae84456c676a;
      $e5be200c675c3b3a$var$isEqualValidation(Js, Xs.current) || (Xs.current = Js, Ys(Js)), na === "native" && ws(!1), rs(!0);
    },
    commitValidation() {
      na === "native" && ws(!0), rs(!0);
    }
  };
}
function $e5be200c675c3b3a$var$asArray(Bi) {
  return Bi ? Array.isArray(Bi) ? Bi : [
    Bi
  ] : [];
}
function $e5be200c675c3b3a$var$runValidate(Bi, e) {
  if (typeof Bi == "function") {
    let qi = Bi(e);
    if (qi && typeof qi != "boolean") return $e5be200c675c3b3a$var$asArray(qi);
  }
  return [];
}
function $e5be200c675c3b3a$var$getValidationResult(Bi) {
  return Bi.length ? {
    isInvalid: !0,
    validationErrors: Bi,
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(Bi, e) {
  return Bi === e ? !0 : !!Bi && !!e && Bi.isInvalid === e.isInvalid && Bi.validationErrors.length === e.validationErrors.length && Bi.validationErrors.every((qi, Xi) => qi === e.validationErrors[Xi]) && Object.entries(Bi.validationDetails).every(([qi, Xi]) => e.validationDetails[qi] === Xi);
}
function $e93e671b31057976$export$b8473d3665f3a75a(Bi, e, qi) {
  let { validationBehavior: Xi, focus: Qi } = Bi;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (Xi === "native" && qi?.current && !qi.current.disabled) {
      let la = e.realtimeValidation.isInvalid ? e.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      qi.current.setCustomValidity(la), qi.current.hasAttribute("title") || (qi.current.title = ""), e.realtimeValidation.isInvalid || e.updateValidation($e93e671b31057976$var$getNativeValidity(qi.current));
    }
  });
  let ta = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.resetValidation();
  }), ra = $8ae05eaa5c114e9c$export$7f54fc3180508a52((la) => {
    var Ma;
    e.displayValidation.isInvalid || e.commitValidation();
    let Va = qi == null || (Ma = qi.current) === null || Ma === void 0 ? void 0 : Ma.form;
    if (!la.defaultPrevented && qi && Va && $e93e671b31057976$var$getFirstInvalidInput(Va) === qi.current) {
      var to;
      Qi ? Qi() : (to = qi.current) === null || to === void 0 || to.focus(), $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
    }
    la.preventDefault();
  }), na = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.commitValidation();
  });
  useEffect(() => {
    let la = qi?.current;
    if (!la) return;
    let Ma = la.form;
    return la.addEventListener("invalid", ra), la.addEventListener("change", na), Ma?.addEventListener("reset", ta), () => {
      la.removeEventListener("invalid", ra), la.removeEventListener("change", na), Ma?.removeEventListener("reset", ta);
    };
  }, [
    qi,
    ra,
    na,
    ta,
    Xi
  ]);
}
function $e93e671b31057976$var$getValidity(Bi) {
  let e = Bi.validity;
  return {
    badInput: e.badInput,
    customError: e.customError,
    patternMismatch: e.patternMismatch,
    rangeOverflow: e.rangeOverflow,
    rangeUnderflow: e.rangeUnderflow,
    stepMismatch: e.stepMismatch,
    tooLong: e.tooLong,
    tooShort: e.tooShort,
    typeMismatch: e.typeMismatch,
    valueMissing: e.valueMissing,
    valid: e.valid
  };
}
function $e93e671b31057976$var$getNativeValidity(Bi) {
  return {
    isInvalid: !Bi.validity.valid,
    validationDetails: $e93e671b31057976$var$getValidity(Bi),
    validationErrors: Bi.validationMessage ? [
      Bi.validationMessage
    ] : []
  };
}
function $e93e671b31057976$var$getFirstInvalidInput(Bi) {
  for (let e = 0; e < Bi.elements.length; e++) {
    let qi = Bi.elements[e];
    if (!qi.validity.valid) return qi;
  }
  return null;
}
function $d191a55c9702f145$export$8467354a121f1b9f(Bi) {
  let { id: e, label: qi, "aria-labelledby": Xi, "aria-label": Qi, labelElementType: ta = "label" } = Bi;
  e = $bdb11010cef70236$export$f680877a34711e37(e);
  let ra = $bdb11010cef70236$export$f680877a34711e37(), na = {};
  qi ? (Xi = Xi ? `${ra} ${Xi}` : ra, na = {
    id: ra,
    htmlFor: ta === "label" ? e : void 0
  }) : !Xi && !Qi && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let la = $313b98861ee5dd6c$export$d6875122194c7b44({
    id: e,
    "aria-label": Qi,
    "aria-labelledby": Xi
  });
  return {
    labelProps: na,
    fieldProps: la
  };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(Bi) {
  let { description: e, errorMessage: qi, isInvalid: Xi, validationState: Qi } = Bi, { labelProps: ta, fieldProps: ra } = $d191a55c9702f145$export$8467354a121f1b9f(Bi), na = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    !!e,
    !!qi,
    Xi,
    Qi
  ]), la = $bdb11010cef70236$export$b4cc09c592e8fdb8([
    !!e,
    !!qi,
    Xi,
    Qi
  ]);
  return ra = $3ef42575df84b30b$export$9d1611c77c2fe928(ra, {
    "aria-describedby": [
      na,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      la,
      Bi["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: ta,
    fieldProps: ra,
    descriptionProps: {
      id: na
    },
    errorMessageProps: {
      id: la
    }
  };
}
const $5c3e21d68f1c4674$var$styles = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab(Bi = {}) {
  let { style: e, isFocusable: qi } = Bi, [Xi, Qi] = useState(!1), { focusWithinProps: ta } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !qi,
    onFocusWithinChange: (na) => Qi(na)
  }), ra = useMemo(() => Xi ? e : e ? {
    ...$5c3e21d68f1c4674$var$styles,
    ...e
  } : $5c3e21d68f1c4674$var$styles, [
    Xi
  ]);
  return {
    visuallyHiddenProps: {
      ...ta,
      style: ra
    }
  };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(Bi) {
  let { children: e, elementType: qi = "div", isFocusable: Xi, style: Qi, ...ta } = Bi, { visuallyHiddenProps: ra } = $5c3e21d68f1c4674$export$a966af930f325cab(Bi);
  return /* @__PURE__ */ a__default.createElement(qi, $3ef42575df84b30b$export$9d1611c77c2fe928(ta, ra), e);
}
const $edcf132a9284368a$var$AXIS = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, $edcf132a9284368a$var$FLIPPED_DIRECTION = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, $edcf132a9284368a$var$CROSS_AXIS = {
  top: "left",
  left: "top"
}, $edcf132a9284368a$var$AXIS_SIZE = {
  top: "height",
  left: "width"
}, $edcf132a9284368a$var$TOTAL_SIZE = {
  width: "totalWidth",
  height: "totalHeight"
}, $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE = {};
let $edcf132a9284368a$var$visualViewport = typeof document < "u" ? window.visualViewport : null;
function $edcf132a9284368a$var$getContainerDimensions(Bi) {
  let e = 0, qi = 0, Xi = 0, Qi = 0, ta = 0, ra = 0, na = {};
  var la;
  let Ma = ((la = $edcf132a9284368a$var$visualViewport?.scale) !== null && la !== void 0 ? la : 1) > 1;
  if (Bi.tagName === "BODY") {
    let eo = document.documentElement;
    Xi = eo.clientWidth, Qi = eo.clientHeight;
    var Va;
    e = (Va = $edcf132a9284368a$var$visualViewport?.width) !== null && Va !== void 0 ? Va : Xi;
    var to;
    qi = (to = $edcf132a9284368a$var$visualViewport?.height) !== null && to !== void 0 ? to : Qi, na.top = eo.scrollTop || Bi.scrollTop, na.left = eo.scrollLeft || Bi.scrollLeft, $edcf132a9284368a$var$visualViewport && (ta = $edcf132a9284368a$var$visualViewport.offsetTop, ra = $edcf132a9284368a$var$visualViewport.offsetLeft);
  } else
    ({ width: e, height: qi, top: ta, left: ra } = $edcf132a9284368a$var$getOffset(Bi)), na.top = Bi.scrollTop, na.left = Bi.scrollLeft, Xi = e, Qi = qi;
  if ($c87311424ea30a05$export$78551043582a6a98() && (Bi.tagName === "BODY" || Bi.tagName === "HTML") && Ma) {
    na.top = 0, na.left = 0;
    var Eo;
    ta = (Eo = $edcf132a9284368a$var$visualViewport?.pageTop) !== null && Eo !== void 0 ? Eo : 0;
    var So;
    ra = (So = $edcf132a9284368a$var$visualViewport?.pageLeft) !== null && So !== void 0 ? So : 0;
  }
  return {
    width: e,
    height: qi,
    totalWidth: Xi,
    totalHeight: Qi,
    scroll: na,
    top: ta,
    left: ra
  };
}
function $edcf132a9284368a$var$getScroll(Bi) {
  return {
    top: Bi.scrollTop,
    left: Bi.scrollLeft,
    width: Bi.scrollWidth,
    height: Bi.scrollHeight
  };
}
function $edcf132a9284368a$var$getDelta(Bi, e, qi, Xi, Qi, ta, ra) {
  var na;
  let la = (na = Qi.scroll[Bi]) !== null && na !== void 0 ? na : 0, Ma = Xi[$edcf132a9284368a$var$AXIS_SIZE[Bi]], Va = Xi.scroll[$edcf132a9284368a$var$AXIS[Bi]] + ta, to = Ma + Xi.scroll[$edcf132a9284368a$var$AXIS[Bi]] - ta, Eo = e - la + ra[Bi] - Xi[$edcf132a9284368a$var$AXIS[Bi]], So = e - la + qi + ra[Bi] - Xi[$edcf132a9284368a$var$AXIS[Bi]];
  return Eo < Va ? Va - Eo : So > to ? Math.max(to - So, Va - Eo) : 0;
}
function $edcf132a9284368a$var$getMargins(Bi) {
  let e = window.getComputedStyle(Bi);
  return {
    top: parseInt(e.marginTop, 10) || 0,
    bottom: parseInt(e.marginBottom, 10) || 0,
    left: parseInt(e.marginLeft, 10) || 0,
    right: parseInt(e.marginRight, 10) || 0
  };
}
function $edcf132a9284368a$var$parsePlacement(Bi) {
  if ($edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi]) return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi];
  let [e, qi] = Bi.split(" "), Xi = $edcf132a9284368a$var$AXIS[e] || "right", Qi = $edcf132a9284368a$var$CROSS_AXIS[Xi];
  $edcf132a9284368a$var$AXIS[qi] || (qi = "center");
  let ta = $edcf132a9284368a$var$AXIS_SIZE[Xi], ra = $edcf132a9284368a$var$AXIS_SIZE[Qi];
  return $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi] = {
    placement: e,
    crossPlacement: qi,
    axis: Xi,
    crossAxis: Qi,
    size: ta,
    crossSize: ra
  }, $edcf132a9284368a$var$PARSED_PLACEMENT_CACHE[Bi];
}
function $edcf132a9284368a$var$computePosition(Bi, e, qi, Xi, Qi, ta, ra, na, la, Ma) {
  let { placement: Va, crossPlacement: to, axis: Eo, crossAxis: So, size: eo, crossSize: rs } = Xi, ko = {};
  var Hs;
  ko[So] = (Hs = Bi[So]) !== null && Hs !== void 0 ? Hs : 0;
  var Ks, Ys, Xs, Cs;
  to === "center" ? ko[So] += (((Ks = Bi[rs]) !== null && Ks !== void 0 ? Ks : 0) - ((Ys = qi[rs]) !== null && Ys !== void 0 ? Ys : 0)) / 2 : to !== So && (ko[So] += ((Xs = Bi[rs]) !== null && Xs !== void 0 ? Xs : 0) - ((Cs = qi[rs]) !== null && Cs !== void 0 ? Cs : 0)), ko[So] += ta;
  const Fs = Bi[So] - qi[rs] + la + Ma, ws = Bi[So] + Bi[rs] - la - Ma;
  if (ko[So] = $9446cca9a3875146$export$7d15b64cf5a3a4c4(ko[So], Fs, ws), Va === Eo) {
    const ls = na ? ra[eo] : e[$edcf132a9284368a$var$TOTAL_SIZE[eo]];
    ko[$edcf132a9284368a$var$FLIPPED_DIRECTION[Eo]] = Math.floor(ls - Bi[Eo] + Qi);
  } else ko[Eo] = Math.floor(Bi[Eo] + Bi[eo] + Qi);
  return ko;
}
function $edcf132a9284368a$var$getMaxHeight(Bi, e, qi, Xi, Qi, ta, ra, na) {
  const la = Xi ? qi.height : e[$edcf132a9284368a$var$TOTAL_SIZE.height];
  var Ma;
  let Va = Bi.top != null ? qi.top + Bi.top : qi.top + (la - ((Ma = Bi.bottom) !== null && Ma !== void 0 ? Ma : 0) - ra);
  var to, Eo, So, eo, rs, ko;
  let Hs = na !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, e.height + e.top + ((to = e.scroll.top) !== null && to !== void 0 ? to : 0) - Va - (((Eo = Qi.top) !== null && Eo !== void 0 ? Eo : 0) + ((So = Qi.bottom) !== null && So !== void 0 ? So : 0) + ta))
  ) : Math.max(0, Va + ra - (e.top + ((eo = e.scroll.top) !== null && eo !== void 0 ? eo : 0)) - (((rs = Qi.top) !== null && rs !== void 0 ? rs : 0) + ((ko = Qi.bottom) !== null && ko !== void 0 ? ko : 0) + ta));
  return Math.min(e.height - ta * 2, Hs);
}
function $edcf132a9284368a$var$getAvailableSpace(Bi, e, qi, Xi, Qi, ta) {
  let { placement: ra, axis: na, size: la } = ta;
  var Ma, Va;
  if (ra === na) return Math.max(0, qi[na] - Bi[na] - ((Ma = Bi.scroll[na]) !== null && Ma !== void 0 ? Ma : 0) + e[na] - ((Va = Xi[na]) !== null && Va !== void 0 ? Va : 0) - Xi[$edcf132a9284368a$var$FLIPPED_DIRECTION[na]] - Qi);
  var to;
  return Math.max(0, Bi[la] + Bi[na] + Bi.scroll[na] - e[na] - qi[na] - qi[la] - ((to = Xi[na]) !== null && to !== void 0 ? to : 0) - Xi[$edcf132a9284368a$var$FLIPPED_DIRECTION[na]] - Qi);
}
function $edcf132a9284368a$export$6839422d1f33cee9(Bi, e, qi, Xi, Qi, ta, ra, na, la, Ma, Va, to, Eo, So, eo, rs) {
  let ko = $edcf132a9284368a$var$parsePlacement(Bi), { size: Hs, crossAxis: Ks, crossSize: Ys, placement: Xs, crossPlacement: Cs } = ko, Fs = $edcf132a9284368a$var$computePosition(e, na, qi, ko, Va, to, Ma, Eo, eo, rs), ws = Va, ls = $edcf132a9284368a$var$getAvailableSpace(na, Ma, e, Qi, ta + Va, ko);
  if (ra && Xi[Hs] > ls) {
    let hl = $edcf132a9284368a$var$parsePlacement(`${$edcf132a9284368a$var$FLIPPED_DIRECTION[Xs]} ${Cs}`), Tl = $edcf132a9284368a$var$computePosition(e, na, qi, hl, Va, to, Ma, Eo, eo, rs);
    $edcf132a9284368a$var$getAvailableSpace(na, Ma, e, Qi, ta + Va, hl) > ls && (ko = hl, Fs = Tl, ws = Va);
  }
  let ks = "bottom";
  ko.axis === "top" ? ko.placement === "top" ? ks = "top" : ko.placement === "bottom" && (ks = "bottom") : ko.crossAxis === "top" && (ko.crossPlacement === "top" ? ks = "bottom" : ko.crossPlacement === "bottom" && (ks = "top"));
  let Js = $edcf132a9284368a$var$getDelta(Ks, Fs[Ks], qi[Ys], na, la, ta, Ma);
  Fs[Ks] += Js;
  let pl = $edcf132a9284368a$var$getMaxHeight(Fs, na, Ma, Eo, Qi, ta, qi.height, ks);
  So && So < pl && (pl = So), qi.height = Math.min(qi.height, pl), Fs = $edcf132a9284368a$var$computePosition(e, na, qi, ko, ws, to, Ma, Eo, eo, rs), Js = $edcf132a9284368a$var$getDelta(Ks, Fs[Ks], qi[Ys], na, la, ta, Ma), Fs[Ks] += Js;
  let _l = {}, bl = e[Ks] + 0.5 * e[Ys] - Fs[Ks] - Qi[$edcf132a9284368a$var$AXIS[Ks]];
  const xl = eo / 2 + rs;
  var Rl, Cl, Dl, kl;
  const Ul = $edcf132a9284368a$var$AXIS[Ks] === "left" ? ((Rl = Qi.left) !== null && Rl !== void 0 ? Rl : 0) + ((Cl = Qi.right) !== null && Cl !== void 0 ? Cl : 0) : ((Dl = Qi.top) !== null && Dl !== void 0 ? Dl : 0) + ((kl = Qi.bottom) !== null && kl !== void 0 ? kl : 0), Bl = qi[Ys] - Ul - eo / 2 - rs, Zl = e[Ks] + eo / 2 - (Fs[Ks] + Qi[$edcf132a9284368a$var$AXIS[Ks]]), Pl = e[Ks] + e[Ys] - eo / 2 - (Fs[Ks] + Qi[$edcf132a9284368a$var$AXIS[Ks]]), yl = $9446cca9a3875146$export$7d15b64cf5a3a4c4(bl, Zl, Pl);
  return _l[Ks] = $9446cca9a3875146$export$7d15b64cf5a3a4c4(yl, xl, Bl), {
    position: Fs,
    maxHeight: pl,
    arrowOffsetLeft: _l.left,
    arrowOffsetTop: _l.top,
    placement: ko.placement
  };
}
function $edcf132a9284368a$export$b3ceb0cbf1056d98(Bi) {
  let { placement: e, targetNode: qi, overlayNode: Xi, scrollNode: Qi, padding: ta, shouldFlip: ra, boundaryElement: na, offset: la, crossOffset: Ma, maxHeight: Va, arrowSize: to = 0, arrowBoundaryOffset: Eo = 0 } = Bi, So = Xi instanceof HTMLElement ? $edcf132a9284368a$var$getContainingBlock(Xi) : document.documentElement, eo = So === document.documentElement;
  const rs = window.getComputedStyle(So).position;
  let ko = !!rs && rs !== "static", Hs = eo ? $edcf132a9284368a$var$getOffset(qi) : $edcf132a9284368a$var$getPosition(qi, So);
  if (!eo) {
    let { marginTop: _l, marginLeft: bl } = window.getComputedStyle(qi);
    Hs.top += parseInt(_l, 10) || 0, Hs.left += parseInt(bl, 10) || 0;
  }
  let Ks = $edcf132a9284368a$var$getOffset(Xi), Ys = $edcf132a9284368a$var$getMargins(Xi);
  var Xs, Cs;
  Ks.width += ((Xs = Ys.left) !== null && Xs !== void 0 ? Xs : 0) + ((Cs = Ys.right) !== null && Cs !== void 0 ? Cs : 0);
  var Fs, ws;
  Ks.height += ((Fs = Ys.top) !== null && Fs !== void 0 ? Fs : 0) + ((ws = Ys.bottom) !== null && ws !== void 0 ? ws : 0);
  let ls = $edcf132a9284368a$var$getScroll(Qi), ks = $edcf132a9284368a$var$getContainerDimensions(na), Js = $edcf132a9284368a$var$getContainerDimensions(So), pl = na.tagName === "BODY" ? $edcf132a9284368a$var$getOffset(So) : $edcf132a9284368a$var$getPosition(So, na);
  return So.tagName === "HTML" && na.tagName === "BODY" && (Js.scroll.top = 0, Js.scroll.left = 0), $edcf132a9284368a$export$6839422d1f33cee9(e, Hs, Ks, ls, Ys, ta, ra, ks, Js, pl, la, Ma, ko, Va, to, Eo);
}
function $edcf132a9284368a$var$getOffset(Bi) {
  let { top: e, left: qi, width: Xi, height: Qi } = Bi.getBoundingClientRect(), { scrollTop: ta, scrollLeft: ra, clientTop: na, clientLeft: la } = document.documentElement;
  return {
    top: e + ta - na,
    left: qi + ra - la,
    width: Xi,
    height: Qi
  };
}
function $edcf132a9284368a$var$getPosition(Bi, e) {
  let qi = window.getComputedStyle(Bi), Xi;
  if (qi.position === "fixed") {
    let { top: Qi, left: ta, width: ra, height: na } = Bi.getBoundingClientRect();
    Xi = {
      top: Qi,
      left: ta,
      width: ra,
      height: na
    };
  } else {
    Xi = $edcf132a9284368a$var$getOffset(Bi);
    let Qi = $edcf132a9284368a$var$getOffset(e), ta = window.getComputedStyle(e);
    Qi.top += (parseInt(ta.borderTopWidth, 10) || 0) - e.scrollTop, Qi.left += (parseInt(ta.borderLeftWidth, 10) || 0) - e.scrollLeft, Xi.top -= Qi.top, Xi.left -= Qi.left;
  }
  return Xi.top -= parseInt(qi.marginTop, 10) || 0, Xi.left -= parseInt(qi.marginLeft, 10) || 0, Xi;
}
function $edcf132a9284368a$var$getContainingBlock(Bi) {
  let e = Bi.offsetParent;
  if (e && e === document.body && window.getComputedStyle(e).position === "static" && !$edcf132a9284368a$var$isContainingBlock(e) && (e = document.documentElement), e == null)
    for (e = Bi.parentElement; e && !$edcf132a9284368a$var$isContainingBlock(e); ) e = e.parentElement;
  return e || document.documentElement;
}
function $edcf132a9284368a$var$isContainingBlock(Bi) {
  let e = window.getComputedStyle(Bi);
  return e.transform !== "none" || /transform|perspective/.test(e.willChange) || e.filter !== "none" || e.contain === "paint" || "backdropFilter" in e && e.backdropFilter !== "none" || "WebkitBackdropFilter" in e && e.WebkitBackdropFilter !== "none";
}
const $dd149f63282afbbf$export$f6211563215e3b37 = /* @__PURE__ */ new WeakMap();
function $dd149f63282afbbf$export$18fc8428861184da(Bi) {
  let { triggerRef: e, isOpen: qi, onClose: Xi } = Bi;
  useEffect(() => {
    if (!qi || Xi === null) return;
    let Qi = (ta) => {
      let ra = ta.target;
      if (!e.current || ra instanceof Node && !ra.contains(e.current) || ta.target instanceof HTMLInputElement || ta.target instanceof HTMLTextAreaElement) return;
      let na = Xi || $dd149f63282afbbf$export$f6211563215e3b37.get(e.current);
      na && na();
    };
    return window.addEventListener("scroll", Qi, !0), () => {
      window.removeEventListener("scroll", Qi, !0);
    };
  }, [
    qi,
    Xi,
    e
  ]);
}
let $2a41e45df1593e64$var$visualViewport = typeof document < "u" ? window.visualViewport : null;
function $2a41e45df1593e64$export$d39e1813b3bdd0e1(Bi) {
  let { direction: e } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), { arrowSize: qi = 0, targetRef: Xi, overlayRef: Qi, scrollRef: ta = Qi, placement: ra = "bottom", containerPadding: na = 12, shouldFlip: la = !0, boundaryElement: Ma = typeof document < "u" ? document.body : null, offset: Va = 0, crossOffset: to = 0, shouldUpdatePosition: Eo = !0, isOpen: So = !0, onClose: eo, maxHeight: rs, arrowBoundaryOffset: ko = 0 } = Bi, [Hs, Ks] = useState(null), Ys = [
    Eo,
    ra,
    Qi.current,
    Xi.current,
    ta.current,
    na,
    la,
    Ma,
    Va,
    to,
    So,
    e,
    rs,
    ko,
    qi
  ], Xs = useRef($2a41e45df1593e64$var$visualViewport?.scale);
  useEffect(() => {
    So && (Xs.current = $2a41e45df1593e64$var$visualViewport?.scale);
  }, [
    So
  ]);
  let Cs = useCallback(() => {
    if (Eo === !1 || !So || !Qi.current || !Xi.current || !Ma || $2a41e45df1593e64$var$visualViewport?.scale !== Xs.current) return;
    let Js = null;
    if (ta.current && ta.current.contains(document.activeElement)) {
      var pl;
      let kl = (pl = document.activeElement) === null || pl === void 0 ? void 0 : pl.getBoundingClientRect(), Ul = ta.current.getBoundingClientRect();
      var _l;
      if (Js = {
        type: "top",
        offset: ((_l = kl?.top) !== null && _l !== void 0 ? _l : 0) - Ul.top
      }, Js.offset > Ul.height / 2) {
        Js.type = "bottom";
        var bl;
        Js.offset = ((bl = kl?.bottom) !== null && bl !== void 0 ? bl : 0) - Ul.bottom;
      }
    }
    let xl = Qi.current;
    if (!rs && Qi.current) {
      var Rl;
      xl.style.top = "0px", xl.style.bottom = "";
      var Cl;
      xl.style.maxHeight = ((Cl = (Rl = window.visualViewport) === null || Rl === void 0 ? void 0 : Rl.height) !== null && Cl !== void 0 ? Cl : window.innerHeight) + "px";
    }
    let Dl = $edcf132a9284368a$export$b3ceb0cbf1056d98({
      placement: $2a41e45df1593e64$var$translateRTL(ra, e),
      overlayNode: Qi.current,
      targetNode: Xi.current,
      scrollNode: ta.current || Qi.current,
      padding: na,
      shouldFlip: la,
      boundaryElement: Ma,
      offset: Va,
      crossOffset: to,
      maxHeight: rs,
      arrowSize: qi,
      arrowBoundaryOffset: ko
    });
    if (Dl.position) {
      if (xl.style.top = "", xl.style.bottom = "", xl.style.left = "", xl.style.right = "", Object.keys(Dl.position).forEach((kl) => xl.style[kl] = Dl.position[kl] + "px"), xl.style.maxHeight = Dl.maxHeight != null ? Dl.maxHeight + "px" : "", Js && document.activeElement && ta.current) {
        let kl = document.activeElement.getBoundingClientRect(), Ul = ta.current.getBoundingClientRect(), Bl = kl[Js.type] - Ul[Js.type];
        ta.current.scrollTop += Bl - Js.offset;
      }
      Ks(Dl);
    }
  }, Ys);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(Cs, Ys), $2a41e45df1593e64$var$useResize(Cs), $9daab02d461809db$export$683480f191c0e3ea({
    ref: Qi,
    onResize: Cs
  }), $9daab02d461809db$export$683480f191c0e3ea({
    ref: Xi,
    onResize: Cs
  });
  let Fs = useRef(!1);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let Js, pl = () => {
      Fs.current = !0, clearTimeout(Js), Js = setTimeout(() => {
        Fs.current = !1;
      }, 500), Cs();
    }, _l = () => {
      Fs.current && pl();
    };
    return $2a41e45df1593e64$var$visualViewport?.addEventListener("resize", pl), $2a41e45df1593e64$var$visualViewport?.addEventListener("scroll", _l), () => {
      $2a41e45df1593e64$var$visualViewport?.removeEventListener("resize", pl), $2a41e45df1593e64$var$visualViewport?.removeEventListener("scroll", _l);
    };
  }, [
    Cs
  ]);
  let ws = useCallback(() => {
    Fs.current || eo?.();
  }, [
    eo,
    Fs
  ]);
  $dd149f63282afbbf$export$18fc8428861184da({
    triggerRef: Xi,
    isOpen: So,
    onClose: eo && ws
  });
  var ls, ks;
  return {
    overlayProps: {
      style: {
        position: "absolute",
        zIndex: 1e5,
        ...Hs?.position,
        maxHeight: (ls = Hs?.maxHeight) !== null && ls !== void 0 ? ls : "100vh"
      }
    },
    placement: (ks = Hs?.placement) !== null && ks !== void 0 ? ks : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: Hs?.arrowOffsetLeft,
        top: Hs?.arrowOffsetTop
      }
    },
    updatePosition: Cs
  };
}
function $2a41e45df1593e64$var$useResize(Bi) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => (window.addEventListener("resize", Bi, !1), () => {
    window.removeEventListener("resize", Bi, !1);
  }), [
    Bi
  ]);
}
function $2a41e45df1593e64$var$translateRTL(Bi, e) {
  return e === "rtl" ? Bi.replace("start", "right").replace("end", "left") : Bi.replace("start", "left").replace("end", "right");
}
const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(Bi, e) {
  let { onClose: qi, shouldCloseOnBlur: Xi, isOpen: Qi, isDismissable: ta = !1, isKeyboardDismissDisabled: ra = !1, shouldCloseOnInteractOutside: na } = Bi;
  useEffect(() => (Qi && $a11501f3d1d39e6c$var$visibleOverlays.push(e), () => {
    let eo = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(e);
    eo >= 0 && $a11501f3d1d39e6c$var$visibleOverlays.splice(eo, 1);
  }), [
    Qi,
    e
  ]);
  let la = () => {
    $a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && qi && qi();
  }, Ma = (eo) => {
    (!na || na(eo.target)) && $a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && (eo.stopPropagation(), eo.preventDefault());
  }, Va = (eo) => {
    (!na || na(eo.target)) && ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === e && (eo.stopPropagation(), eo.preventDefault()), la());
  }, to = (eo) => {
    eo.key === "Escape" && !ra && !eo.nativeEvent.isComposing && (eo.stopPropagation(), eo.preventDefault(), la());
  };
  $e0b6e0b68ec7f50f$export$872b660ac5a1ff98({
    ref: e,
    onInteractOutside: ta && Qi ? Va : void 0,
    onInteractOutsideStart: Ma
  });
  let { focusWithinProps: Eo } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !Xi,
    onBlurWithin: (eo) => {
      !eo.relatedTarget || $9bf71ea28793e738$export$1258395f99bf9cbf(eo.relatedTarget) || (!na || na(eo.relatedTarget)) && qi?.();
    }
  }), So = (eo) => {
    eo.target === eo.currentTarget && eo.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: to,
      ...Eo
    },
    underlayProps: {
      onPointerDown: So
    }
  };
}
function $628037886ba31236$export$f9d5c8beee7d008d(Bi, e, qi) {
  let { type: Xi } = Bi, { isOpen: Qi } = e;
  useEffect(() => {
    qi && qi.current && $dd149f63282afbbf$export$f6211563215e3b37.set(qi.current, e.close);
  });
  let ta;
  Xi === "menu" ? ta = !0 : Xi === "listbox" && (ta = "listbox");
  let ra = $bdb11010cef70236$export$f680877a34711e37();
  return {
    triggerProps: {
      "aria-haspopup": ta,
      "aria-expanded": Qi,
      "aria-controls": Qi ? ra : void 0,
      onPress: e.toggle
    },
    overlayProps: {
      id: ra
    }
  };
}
const $49c51c25361d4cd2$var$visualViewport = typeof document < "u" && window.visualViewport, $49c51c25361d4cd2$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let $49c51c25361d4cd2$var$preventScrollCount = 0, $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(Bi = {}) {
  let { isDisabled: e } = Bi;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (!e)
      return $49c51c25361d4cd2$var$preventScrollCount++, $49c51c25361d4cd2$var$preventScrollCount === 1 && ($c87311424ea30a05$export$fedb369cb70207f1() ? $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari() : $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard()), () => {
        $49c51c25361d4cd2$var$preventScrollCount--, $49c51c25361d4cd2$var$preventScrollCount === 0 && $49c51c25361d4cd2$var$restore();
      };
  }, [
    e
  ]);
}
function $49c51c25361d4cd2$var$preventScrollStandard() {
  return $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
  let Bi, e, qi = (Ma) => {
    Bi = $62d8ded9296f3872$export$cfa2225e87938781(Ma.target, !0), !(Bi === document.documentElement && Bi === document.body) && Bi instanceof HTMLElement && window.getComputedStyle(Bi).overscrollBehavior === "auto" && (e = $49c51c25361d4cd2$var$setStyle(Bi, "overscrollBehavior", "contain"));
  }, Xi = (Ma) => {
    if (!Bi || Bi === document.documentElement || Bi === document.body) {
      Ma.preventDefault();
      return;
    }
    Bi.scrollHeight === Bi.clientHeight && Bi.scrollWidth === Bi.clientWidth && Ma.preventDefault();
  }, Qi = () => {
    e && e();
  }, ta = (Ma) => {
    let Va = Ma.target;
    $49c51c25361d4cd2$var$willOpenKeyboard(Va) && (na(), Va.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      Va.style.transform = "", $49c51c25361d4cd2$var$visualViewport && ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight ? requestAnimationFrame(() => {
        $49c51c25361d4cd2$var$scrollIntoView(Va);
      }) : $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", () => $49c51c25361d4cd2$var$scrollIntoView(Va), {
        once: !0
      }));
    }));
  }, ra = null, na = () => {
    if (ra) return;
    let Ma = () => {
      window.scrollTo(0, 0);
    }, Va = window.pageXOffset, to = window.pageYOffset;
    ra = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(window, "scroll", Ma), $49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${to}px`), () => {
      window.scrollTo(Va, to);
    }), window.scrollTo(0, 0);
  }, la = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(document, "touchstart", qi, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", Xi, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "touchend", Qi, {
    passive: !1,
    capture: !0
  }), $49c51c25361d4cd2$var$addEvent(document, "focus", ta, !0));
  return () => {
    e?.(), ra?.(), la();
  };
}
function $49c51c25361d4cd2$var$setStyle(Bi, e, qi) {
  let Xi = Bi.style[e];
  return Bi.style[e] = qi, () => {
    Bi.style[e] = Xi;
  };
}
function $49c51c25361d4cd2$var$addEvent(Bi, e, qi, Xi) {
  return Bi.addEventListener(e, qi, Xi), () => {
    Bi.removeEventListener(e, qi, Xi);
  };
}
function $49c51c25361d4cd2$var$scrollIntoView(Bi) {
  let e = document.scrollingElement || document.documentElement, qi = Bi;
  for (; qi && qi !== e; ) {
    let Xi = $62d8ded9296f3872$export$cfa2225e87938781(qi);
    if (Xi !== document.documentElement && Xi !== document.body && Xi !== qi) {
      let Qi = Xi.getBoundingClientRect().top, ta = qi.getBoundingClientRect().top;
      ta > Qi + qi.clientHeight && (Xi.scrollTop += ta - Qi);
    }
    qi = Xi.parentElement;
  }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(Bi) {
  return Bi instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(Bi.type) || Bi instanceof HTMLTextAreaElement || Bi instanceof HTMLElement && Bi.isContentEditable;
}
var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
  dismiss: "تجاهل"
};
var $d11f19852b941573$exports = {};
$d11f19852b941573$exports = {
  dismiss: "Отхвърляне"
};
var $b983974c2ee1efb3$exports = {};
$b983974c2ee1efb3$exports = {
  dismiss: "Odstranit"
};
var $5809cc9d4e92de73$exports = {};
$5809cc9d4e92de73$exports = {
  dismiss: "Luk"
};
var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
  dismiss: "Schließen"
};
var $0898b4c153db2b77$exports = {};
$0898b4c153db2b77$exports = {
  dismiss: "Απόρριψη"
};
var $6d74810286a15183$exports = {};
$6d74810286a15183$exports = {
  dismiss: "Dismiss"
};
var $309d73dc65f78055$exports = {};
$309d73dc65f78055$exports = {
  dismiss: "Descartar"
};
var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
  dismiss: "Lõpeta"
};
var $7c28f5687f0779a9$exports = {};
$7c28f5687f0779a9$exports = {
  dismiss: "Hylkää"
};
var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
  dismiss: "Rejeter"
};
var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
  dismiss: "התעלם"
};
var $553439c3ffb3e492$exports = {};
$553439c3ffb3e492$exports = {
  dismiss: "Odbaci"
};
var $74cf411061b983a2$exports = {};
$74cf411061b983a2$exports = {
  dismiss: "Elutasítás"
};
var $e933f298574dc435$exports = {};
$e933f298574dc435$exports = {
  dismiss: "Ignora"
};
var $ac91fc9fe02f71f6$exports = {};
$ac91fc9fe02f71f6$exports = {
  dismiss: "閉じる"
};
var $52b96f86422025af$exports = {};
$52b96f86422025af$exports = {
  dismiss: "무시"
};
var $c0d724c3e51dafa6$exports = {};
$c0d724c3e51dafa6$exports = {
  dismiss: "Atmesti"
};
var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
  dismiss: "Nerādīt"
};
var $9f576b39d8e7a9d6$exports = {};
$9f576b39d8e7a9d6$exports = {
  dismiss: "Lukk"
};
var $9d025808aeec81a7$exports = {};
$9d025808aeec81a7$exports = {
  dismiss: "Negeren"
};
var $fce709921e2c0fa6$exports = {};
$fce709921e2c0fa6$exports = {
  dismiss: "Zignoruj"
};
var $2599cf0c4ab37f59$exports = {};
$2599cf0c4ab37f59$exports = {
  dismiss: "Descartar"
};
var $3c220ae7ef8a35fd$exports = {};
$3c220ae7ef8a35fd$exports = {
  dismiss: "Dispensar"
};
var $93562b5094072f54$exports = {};
$93562b5094072f54$exports = {
  dismiss: "Revocare"
};
var $cd9e2abd0d06c7b4$exports = {};
$cd9e2abd0d06c7b4$exports = {
  dismiss: "Пропустить"
};
var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
  dismiss: "Zrušiť"
};
var $27fab53a576de9dd$exports = {};
$27fab53a576de9dd$exports = {
  dismiss: "Opusti"
};
var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
  dismiss: "Odbaci"
};
var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
  dismiss: "Avvisa"
};
var $29700c92185d38f8$exports = {};
$29700c92185d38f8$exports = {
  dismiss: "Kapat"
};
var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
  dismiss: "Скасувати"
};
var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
  dismiss: "取消"
};
var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
  dismiss: "關閉"
};
var $a2f21f5f14f60553$exports = {};
$a2f21f5f14f60553$exports = {
  "ar-AE": $773d5888b972f1cf$exports,
  "bg-BG": $d11f19852b941573$exports,
  "cs-CZ": $b983974c2ee1efb3$exports,
  "da-DK": $5809cc9d4e92de73$exports,
  "de-DE": $c68c2e4fc74398d1$exports,
  "el-GR": $0898b4c153db2b77$exports,
  "en-US": $6d74810286a15183$exports,
  "es-ES": $309d73dc65f78055$exports,
  "et-EE": $44ad94f7205cf593$exports,
  "fi-FI": $7c28f5687f0779a9$exports,
  "fr-FR": $e6d75df4b68bd73a$exports,
  "he-IL": $87505c9dab186d0f$exports,
  "hr-HR": $553439c3ffb3e492$exports,
  "hu-HU": $74cf411061b983a2$exports,
  "it-IT": $e933f298574dc435$exports,
  "ja-JP": $ac91fc9fe02f71f6$exports,
  "ko-KR": $52b96f86422025af$exports,
  "lt-LT": $c0d724c3e51dafa6$exports,
  "lv-LV": $c92899672a3fe72e$exports,
  "nb-NO": $9f576b39d8e7a9d6$exports,
  "nl-NL": $9d025808aeec81a7$exports,
  "pl-PL": $fce709921e2c0fa6$exports,
  "pt-BR": $2599cf0c4ab37f59$exports,
  "pt-PT": $3c220ae7ef8a35fd$exports,
  "ro-RO": $93562b5094072f54$exports,
  "ru-RU": $cd9e2abd0d06c7b4$exports,
  "sk-SK": $45375701f409adf1$exports,
  "sl-SI": $27fab53a576de9dd$exports,
  "sr-SP": $4438748d9952e7c7$exports,
  "sv-SE": $0936d7347ef4da4c$exports,
  "tr-TR": $29700c92185d38f8$exports,
  "uk-UA": $662ccaf2be4c25b3$exports,
  "zh-CN": $d80a27deda7cdb3c$exports,
  "zh-TW": $2b2734393847c884$exports
};
function $parcel$interopDefault$1(Bi) {
  return Bi && Bi.__esModule ? Bi.default : Bi;
}
function $86ea4cb521eb2e37$export$2317d149ed6f78c4(Bi) {
  let { onDismiss: e, ...qi } = Bi, Xi = $fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault$1($a2f21f5f14f60553$exports), "@react-aria/overlays"), Qi = $313b98861ee5dd6c$export$d6875122194c7b44(qi, Xi.format("dismiss")), ta = () => {
    e && e();
  };
  return /* @__PURE__ */ a__default.createElement($5c3e21d68f1c4674$export$439d29a4e110a164, null, /* @__PURE__ */ a__default.createElement("button", {
    ...Qi,
    tabIndex: -1,
    onClick: ta,
    style: {
      width: 1,
      height: 1
    }
  }));
}
let $5e3802645cc19319$var$refCountMap = /* @__PURE__ */ new WeakMap(), $5e3802645cc19319$var$observerStack = [];
function $5e3802645cc19319$export$1c3ebcada18427bf(Bi, e = document.body) {
  let qi = new Set(Bi), Xi = /* @__PURE__ */ new Set(), Qi = (la) => {
    for (let Eo of la.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) qi.add(Eo);
    let Ma = (Eo) => {
      if (qi.has(Eo) || Eo.parentElement && Xi.has(Eo.parentElement) && Eo.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let So of qi)
        if (Eo.contains(So)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, Va = document.createTreeWalker(la, NodeFilter.SHOW_ELEMENT, {
      acceptNode: Ma
    }), to = Ma(la);
    if (to === NodeFilter.FILTER_ACCEPT && ta(la), to !== NodeFilter.FILTER_REJECT) {
      let Eo = Va.nextNode();
      for (; Eo != null; )
        ta(Eo), Eo = Va.nextNode();
    }
  }, ta = (la) => {
    var Ma;
    let Va = (Ma = $5e3802645cc19319$var$refCountMap.get(la)) !== null && Ma !== void 0 ? Ma : 0;
    la.getAttribute("aria-hidden") === "true" && Va === 0 || (Va === 0 && la.setAttribute("aria-hidden", "true"), Xi.add(la), $5e3802645cc19319$var$refCountMap.set(la, Va + 1));
  };
  $5e3802645cc19319$var$observerStack.length && $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].disconnect(), Qi(e);
  let ra = new MutationObserver((la) => {
    for (let Ma of la)
      if (!(Ma.type !== "childList" || Ma.addedNodes.length === 0) && ![
        ...qi,
        ...Xi
      ].some((Va) => Va.contains(Ma.target))) {
        for (let Va of Ma.removedNodes) Va instanceof Element && (qi.delete(Va), Xi.delete(Va));
        for (let Va of Ma.addedNodes)
          (Va instanceof HTMLElement || Va instanceof SVGElement) && (Va.dataset.liveAnnouncer === "true" || Va.dataset.reactAriaTopLayer === "true") ? qi.add(Va) : Va instanceof Element && Qi(Va);
      }
  });
  ra.observe(e, {
    childList: !0,
    subtree: !0
  });
  let na = {
    observe() {
      ra.observe(e, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      ra.disconnect();
    }
  };
  return $5e3802645cc19319$var$observerStack.push(na), () => {
    ra.disconnect();
    for (let la of Xi) {
      let Ma = $5e3802645cc19319$var$refCountMap.get(la);
      Ma != null && (Ma === 1 ? (la.removeAttribute("aria-hidden"), $5e3802645cc19319$var$refCountMap.delete(la)) : $5e3802645cc19319$var$refCountMap.set(la, Ma - 1));
    }
    na === $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1] ? ($5e3802645cc19319$var$observerStack.pop(), $5e3802645cc19319$var$observerStack.length && $5e3802645cc19319$var$observerStack[$5e3802645cc19319$var$observerStack.length - 1].observe()) : $5e3802645cc19319$var$observerStack.splice($5e3802645cc19319$var$observerStack.indexOf(na), 1);
  };
}
function $f2f8a6077418541e$export$542a6fd13ac93354(Bi, e) {
  let { triggerRef: qi, popoverRef: Xi, isNonModal: Qi, isKeyboardDismissDisabled: ta, shouldCloseOnInteractOutside: ra, ...na } = Bi, { overlayProps: la, underlayProps: Ma } = $a11501f3d1d39e6c$export$ea8f71083e90600f({
    // If popover is in the top layer, it should not prevent other popovers from being dismissed.
    isOpen: e.isOpen && !na["data-react-aria-top-layer"],
    onClose: e.close,
    shouldCloseOnBlur: !0,
    isDismissable: !Qi,
    isKeyboardDismissDisabled: ta,
    shouldCloseOnInteractOutside: ra
  }, Xi), { overlayProps: Va, arrowProps: to, placement: Eo } = $2a41e45df1593e64$export$d39e1813b3bdd0e1({
    ...na,
    targetRef: qi,
    overlayRef: Xi,
    isOpen: e.isOpen,
    onClose: Qi ? e.close : null
  });
  return $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: Qi || !e.isOpen
  }), $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (e.isOpen && !Qi && Xi.current) return $5e3802645cc19319$export$1c3ebcada18427bf([
      Xi.current
    ]);
  }, [
    Qi,
    e.isOpen,
    Xi
  ]), {
    popoverProps: $3ef42575df84b30b$export$9d1611c77c2fe928(la, Va),
    arrowProps: to,
    underlayProps: Ma,
    placement: Eo
  };
}
const $96b38030c423d352$export$60d741e20e0aa309 = /* @__PURE__ */ createContext({});
function $96b38030c423d352$export$574e9b0fb070c3b0() {
  var Bi;
  return (Bi = useContext($96b38030c423d352$export$60d741e20e0aa309)) !== null && Bi !== void 0 ? Bi : {};
}
const $337b884510726a0d$export$a2200b96afd16271 = /* @__PURE__ */ a__default.createContext(null);
function $337b884510726a0d$export$c6fdb837b070b4ff(Bi) {
  let e = $b5e257d569688ac6$export$535bd6ca7f90a273(), { portalContainer: qi = e ? null : document.body, isExiting: Xi } = Bi, [Qi, ta] = useState(!1), ra = useMemo(() => ({
    contain: Qi,
    setContain: ta
  }), [
    Qi,
    ta
  ]), { getContainer: na } = $96b38030c423d352$export$574e9b0fb070c3b0();
  if (!Bi.portalContainer && na && (qi = na()), !qi) return null;
  let la = Bi.children;
  return Bi.disableFocusManagement || (la = /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, {
    restoreFocus: !0,
    contain: Qi && !Xi
  }, la)), la = /* @__PURE__ */ a__default.createElement($337b884510726a0d$export$a2200b96afd16271.Provider, {
    value: ra
  }, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$cf75428e0b9ed1ea, null, la)), /* @__PURE__ */ $4AOtR$reactdom.createPortal(la, qi);
}
const $b1f0cad8af73213b$export$3585ede4d035bf14 = /* @__PURE__ */ new WeakMap();
function $b1f0cad8af73213b$var$normalizeKey(Bi) {
  return typeof Bi == "string" ? Bi.replace(/\s*/g, "") : "" + Bi;
}
function $b1f0cad8af73213b$export$9145995848b05025(Bi, e) {
  let qi = $b1f0cad8af73213b$export$3585ede4d035bf14.get(Bi);
  if (!qi) throw new Error("Unknown list");
  return `${qi.id}-option-${$b1f0cad8af73213b$var$normalizeKey(e)}`;
}
function $feb5ffebff200149$export$d3e3bd3e26688c04(Bi) {
  return $c87311424ea30a05$export$e1865c3bedcd822b() ? Bi.altKey : Bi.ctrlKey;
}
const $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS = 1e3;
function $fb3050f43d946246$export$e32c88dfddc6e1d8(Bi) {
  let { keyboardDelegate: e, selectionManager: qi, onTypeSelect: Xi } = Bi, Qi = useRef({
    search: "",
    timeout: void 0
  }).current, ta = (ra) => {
    let na = $fb3050f43d946246$var$getStringForKey(ra.key);
    if (!(!na || ra.ctrlKey || ra.metaKey || !ra.currentTarget.contains(ra.target))) {
      if (na === " " && Qi.search.trim().length > 0 && (ra.preventDefault(), "continuePropagation" in ra || ra.stopPropagation()), Qi.search += na, e.getKeyForSearch != null) {
        let la = e.getKeyForSearch(Qi.search, qi.focusedKey);
        la == null && (la = e.getKeyForSearch(Qi.search)), la != null && (qi.setFocusedKey(la), Xi && Xi(la));
      }
      clearTimeout(Qi.timeout), Qi.timeout = setTimeout(() => {
        Qi.search = "";
      }, $fb3050f43d946246$var$TYPEAHEAD_DEBOUNCE_WAIT_MS);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: e.getKeyForSearch ? ta : void 0
    }
  };
}
function $fb3050f43d946246$var$getStringForKey(Bi) {
  return Bi.length === 1 || !/^[A-Z]/i.test(Bi) ? Bi : "";
}
function $ae20dd8cbca75726$export$d6daf82dcd84e87c(Bi) {
  let { selectionManager: e, keyboardDelegate: qi, ref: Xi, autoFocus: Qi = !1, shouldFocusWrap: ta = !1, disallowEmptySelection: ra = !1, disallowSelectAll: na = !1, selectOnFocus: la = e.selectionBehavior === "replace", disallowTypeAhead: Ma = !1, shouldUseVirtualFocus: Va, allowsTabNavigation: to = !1, isVirtualized: Eo, scrollRef: So = Xi, linkBehavior: eo = "action" } = Bi, { direction: rs } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), ko = $ea8dcbcb9ea1b556$export$9a302a45f65d0572(), Hs = (bl) => {
    var xl;
    if (bl.altKey && bl.key === "Tab" && bl.preventDefault(), !(!((xl = Xi.current) === null || xl === void 0) && xl.contains(bl.target))) return;
    const Rl = (Al, _s) => {
      if (Al != null) {
        if (e.isLink(Al) && eo === "selection" && la && !$feb5ffebff200149$export$d3e3bd3e26688c04(bl)) {
          var Gs;
          flushSync$1(() => {
            e.setFocusedKey(Al, _s);
          });
          let vl = (Gs = So.current) === null || Gs === void 0 ? void 0 : Gs.querySelector(`[data-key="${CSS.escape(Al.toString())}"]`), gl = e.getItemProps(Al);
          vl && ko.open(vl, bl, gl.href, gl.routerOptions);
          return;
        }
        if (e.setFocusedKey(Al, _s), e.isLink(Al) && eo === "override") return;
        bl.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Al) : la && !$feb5ffebff200149$export$d3e3bd3e26688c04(bl) && e.replaceSelection(Al);
      }
    };
    switch (bl.key) {
      case "ArrowDown":
        if (qi.getKeyBelow) {
          var Cl, Dl, kl;
          let Al = e.focusedKey != null ? (Cl = qi.getKeyBelow) === null || Cl === void 0 ? void 0 : Cl.call(qi, e.focusedKey) : (Dl = qi.getFirstKey) === null || Dl === void 0 ? void 0 : Dl.call(qi);
          Al == null && ta && (Al = (kl = qi.getFirstKey) === null || kl === void 0 ? void 0 : kl.call(qi, e.focusedKey)), Al != null && (bl.preventDefault(), Rl(Al));
        }
        break;
      case "ArrowUp":
        if (qi.getKeyAbove) {
          var Ul, Bl, Zl;
          let Al = e.focusedKey != null ? (Ul = qi.getKeyAbove) === null || Ul === void 0 ? void 0 : Ul.call(qi, e.focusedKey) : (Bl = qi.getLastKey) === null || Bl === void 0 ? void 0 : Bl.call(qi);
          Al == null && ta && (Al = (Zl = qi.getLastKey) === null || Zl === void 0 ? void 0 : Zl.call(qi, e.focusedKey)), Al != null && (bl.preventDefault(), Rl(Al));
        }
        break;
      case "ArrowLeft":
        if (qi.getKeyLeftOf) {
          var Pl, yl, hl;
          let Al = e.focusedKey != null ? (Pl = qi.getKeyLeftOf) === null || Pl === void 0 ? void 0 : Pl.call(qi, e.focusedKey) : null;
          Al == null && ta && (Al = rs === "rtl" ? (yl = qi.getFirstKey) === null || yl === void 0 ? void 0 : yl.call(qi, e.focusedKey) : (hl = qi.getLastKey) === null || hl === void 0 ? void 0 : hl.call(qi, e.focusedKey)), Al != null && (bl.preventDefault(), Rl(Al, rs === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (qi.getKeyRightOf) {
          var Tl, Il, jl;
          let Al = e.focusedKey != null ? (Tl = qi.getKeyRightOf) === null || Tl === void 0 ? void 0 : Tl.call(qi, e.focusedKey) : null;
          Al == null && ta && (Al = rs === "rtl" ? (Il = qi.getLastKey) === null || Il === void 0 ? void 0 : Il.call(qi, e.focusedKey) : (jl = qi.getFirstKey) === null || jl === void 0 ? void 0 : jl.call(qi, e.focusedKey)), Al != null && (bl.preventDefault(), Rl(Al, rs === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (qi.getFirstKey) {
          if (e.focusedKey === null && bl.shiftKey) return;
          bl.preventDefault();
          let Al = qi.getFirstKey(e.focusedKey, $21f1aa98acb08317$export$16792effe837dba3(bl));
          e.setFocusedKey(Al), Al != null && ($21f1aa98acb08317$export$16792effe837dba3(bl) && bl.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Al) : la && e.replaceSelection(Al));
        }
        break;
      case "End":
        if (qi.getLastKey) {
          if (e.focusedKey === null && bl.shiftKey) return;
          bl.preventDefault();
          let Al = qi.getLastKey(e.focusedKey, $21f1aa98acb08317$export$16792effe837dba3(bl));
          e.setFocusedKey(Al), Al != null && ($21f1aa98acb08317$export$16792effe837dba3(bl) && bl.shiftKey && e.selectionMode === "multiple" ? e.extendSelection(Al) : la && e.replaceSelection(Al));
        }
        break;
      case "PageDown":
        if (qi.getKeyPageBelow && e.focusedKey != null) {
          let Al = qi.getKeyPageBelow(e.focusedKey);
          Al != null && (bl.preventDefault(), Rl(Al));
        }
        break;
      case "PageUp":
        if (qi.getKeyPageAbove && e.focusedKey != null) {
          let Al = qi.getKeyPageAbove(e.focusedKey);
          Al != null && (bl.preventDefault(), Rl(Al));
        }
        break;
      case "a":
        $21f1aa98acb08317$export$16792effe837dba3(bl) && e.selectionMode === "multiple" && na !== !0 && (bl.preventDefault(), e.selectAll());
        break;
      case "Escape":
        !ra && e.selectedKeys.size !== 0 && (bl.stopPropagation(), bl.preventDefault(), e.clearSelection());
        break;
      case "Tab":
        if (!to) {
          if (bl.shiftKey) Xi.current.focus();
          else {
            let Al = $9bf71ea28793e738$export$2d6ec8fc375ceafa(Xi.current, {
              tabbable: !0
            }), _s, Gs;
            do
              Gs = Al.lastChild(), Gs && (_s = Gs);
            while (Gs);
            _s && !_s.contains(document.activeElement) && $7215afc6de606d6b$export$de79e2c695e052f3(_s);
          }
          break;
        }
    }
  }, Ks = useRef({
    top: 0,
    left: 0
  });
  $e9faafb641e167db$export$90fc3a17d93f704c(So, "scroll", Eo ? void 0 : () => {
    var bl, xl, Rl, Cl;
    Ks.current = {
      top: (Rl = (bl = So.current) === null || bl === void 0 ? void 0 : bl.scrollTop) !== null && Rl !== void 0 ? Rl : 0,
      left: (Cl = (xl = So.current) === null || xl === void 0 ? void 0 : xl.scrollLeft) !== null && Cl !== void 0 ? Cl : 0
    };
  });
  let Ys = (bl) => {
    if (e.isFocused) {
      bl.currentTarget.contains(bl.target) || e.setFocused(!1);
      return;
    }
    if (bl.currentTarget.contains(bl.target)) {
      if (e.setFocused(!0), e.focusedKey == null) {
        var xl, Rl;
        let kl = (Bl) => {
          Bl != null && (e.setFocusedKey(Bl), la && e.replaceSelection(Bl));
        }, Ul = bl.relatedTarget;
        var Cl, Dl;
        Ul && bl.currentTarget.compareDocumentPosition(Ul) & Node.DOCUMENT_POSITION_FOLLOWING ? kl((Cl = e.lastSelectedKey) !== null && Cl !== void 0 ? Cl : (xl = qi.getLastKey) === null || xl === void 0 ? void 0 : xl.call(qi)) : kl((Dl = e.firstSelectedKey) !== null && Dl !== void 0 ? Dl : (Rl = qi.getFirstKey) === null || Rl === void 0 ? void 0 : Rl.call(qi));
      } else !Eo && So.current && (So.current.scrollTop = Ks.current.top, So.current.scrollLeft = Ks.current.left);
      if (e.focusedKey != null && So.current) {
        let kl = So.current.querySelector(`[data-key="${CSS.escape(e.focusedKey.toString())}"]`);
        kl && (kl.contains(document.activeElement) || $7215afc6de606d6b$export$de79e2c695e052f3(kl), $507fabe10e71c6fb$export$630ff653c5ada6a9() === "keyboard" && $2f04cbc44ee30ce0$export$c826860796309d1b(kl, {
          containingElement: Xi.current
        }));
      }
    }
  }, Xs = (bl) => {
    bl.currentTarget.contains(bl.relatedTarget) || e.setFocused(!1);
  }, Cs = useRef(!1);
  $e9faafb641e167db$export$90fc3a17d93f704c(Xi, $5671b20cf9b562b2$export$831c820ad60f9d12, Va ? (bl) => {
    let { detail: xl } = bl;
    bl.stopPropagation(), e.setFocused(!0), xl?.focusStrategy === "first" && (Cs.current = !0);
  } : void 0);
  let Fs = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    var bl, xl;
    let Rl = (xl = (bl = qi.getFirstKey) === null || bl === void 0 ? void 0 : bl.call(qi)) !== null && xl !== void 0 ? xl : null;
    if (Rl == null) {
      var Cl;
      (Cl = Xi.current) === null || Cl === void 0 || Cl.dispatchEvent(new CustomEvent($5671b20cf9b562b2$export$9db568f6321ad9dc, {
        cancelable: !0,
        bubbles: !0
      })), e.collection.size > 0 && (Cs.current = !1);
    } else
      e.setFocusedKey(Rl), Cs.current = !1;
  });
  $ca9b37712f007381$export$72ef708ab07251f1(() => {
    Cs.current && Fs();
  }, [
    e.collection,
    Fs
  ]);
  let ws = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    e.collection.size > 0 && (Cs.current = !1);
  });
  $ca9b37712f007381$export$72ef708ab07251f1(() => {
    ws();
  }, [
    e.focusedKey,
    ws
  ]), $e9faafb641e167db$export$90fc3a17d93f704c(Xi, $5671b20cf9b562b2$export$447a38995de2c711, Va ? (bl) => {
    bl.stopPropagation(), e.setFocused(!1), e.setFocusedKey(null);
  } : void 0);
  const ls = useRef(Qi);
  useEffect(() => {
    if (ls.current) {
      var bl, xl;
      let Dl = null;
      var Rl;
      Qi === "first" && (Dl = (Rl = (bl = qi.getFirstKey) === null || bl === void 0 ? void 0 : bl.call(qi)) !== null && Rl !== void 0 ? Rl : null);
      var Cl;
      Qi === "last" && (Dl = (Cl = (xl = qi.getLastKey) === null || xl === void 0 ? void 0 : xl.call(qi)) !== null && Cl !== void 0 ? Cl : null);
      let kl = e.selectedKeys;
      if (kl.size) {
        for (let Ul of kl) if (e.canSelectItem(Ul)) {
          Dl = Ul;
          break;
        }
      }
      e.setFocused(!0), e.setFocusedKey(Dl), Dl == null && !Va && Xi.current && $6a99195332edec8b$export$80f3e147d781571c(Xi.current);
    }
  }, []);
  let ks = useRef(e.focusedKey);
  useEffect(() => {
    if (e.isFocused && e.focusedKey != null && (e.focusedKey !== ks.current || ls.current) && So.current && Xi.current) {
      let bl = $507fabe10e71c6fb$export$630ff653c5ada6a9(), xl = Xi.current.querySelector(`[data-key="${CSS.escape(e.focusedKey.toString())}"]`);
      if (!xl)
        return;
      (bl === "keyboard" || ls.current) && ($2f04cbc44ee30ce0$export$53a0910f038337bd(So.current, xl), bl !== "virtual" && $2f04cbc44ee30ce0$export$c826860796309d1b(xl, {
        containingElement: Xi.current
      }));
    }
    !Va && e.isFocused && e.focusedKey == null && ks.current != null && Xi.current && $6a99195332edec8b$export$80f3e147d781571c(Xi.current), ks.current = e.focusedKey, ls.current = !1;
  }), $e9faafb641e167db$export$90fc3a17d93f704c(Xi, "react-aria-focus-scope-restore", (bl) => {
    bl.preventDefault(), e.setFocused(!0);
  });
  let Js = {
    onKeyDown: Hs,
    onFocus: Ys,
    onBlur: Xs,
    onMouseDown(bl) {
      So.current === bl.target && bl.preventDefault();
    }
  }, { typeSelectProps: pl } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
    keyboardDelegate: qi,
    selectionManager: e
  });
  Ma || (Js = $3ef42575df84b30b$export$9d1611c77c2fe928(pl, Js));
  let _l;
  return Va ? _l = -1 : _l = e.focusedKey == null ? 0 : -1, {
    collectionProps: {
      ...Js,
      tabIndex: _l
    }
  };
}
function $880e95eb8b93ba9a$export$ecf600387e221c37(Bi) {
  let { id: e, selectionManager: qi, key: Xi, ref: Qi, shouldSelectOnPressUp: ta, shouldUseVirtualFocus: ra, focus: na, isDisabled: la, onAction: Ma, allowsDifferentPressOrigin: Va, linkBehavior: to = "action" } = Bi, Eo = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  e = $bdb11010cef70236$export$f680877a34711e37(e);
  let So = (kl) => {
    if (kl.pointerType === "keyboard" && $feb5ffebff200149$export$d3e3bd3e26688c04(kl)) qi.toggleSelection(Xi);
    else {
      if (qi.selectionMode === "none") return;
      if (qi.isLink(Xi)) {
        if (to === "selection" && Qi.current) {
          let Ul = qi.getItemProps(Xi);
          Eo.open(Qi.current, kl, Ul.href, Ul.routerOptions), qi.setSelectedKeys(qi.selectedKeys);
          return;
        } else if (to === "override" || to === "none") return;
      }
      qi.selectionMode === "single" ? qi.isSelected(Xi) && !qi.disallowEmptySelection ? qi.toggleSelection(Xi) : qi.replaceSelection(Xi) : kl && kl.shiftKey ? qi.extendSelection(Xi) : qi.selectionBehavior === "toggle" || kl && ($21f1aa98acb08317$export$16792effe837dba3(kl) || kl.pointerType === "touch" || kl.pointerType === "virtual") ? qi.toggleSelection(Xi) : qi.replaceSelection(Xi);
    }
  };
  useEffect(() => {
    if (Xi === qi.focusedKey && qi.isFocused)
      if (!ra)
        na ? na() : document.activeElement !== Qi.current && Qi.current && $6a99195332edec8b$export$80f3e147d781571c(Qi.current);
      else {
        var Ul;
        let Bl = new CustomEvent($5671b20cf9b562b2$export$9db568f6321ad9dc, {
          cancelable: !0,
          bubbles: !0
        });
        (Ul = Qi.current) === null || Ul === void 0 || Ul.dispatchEvent(Bl);
      }
  }, [
    Qi,
    Xi,
    qi.focusedKey,
    qi.childFocusStrategy,
    qi.isFocused,
    ra
  ]), la = la || qi.isDisabled(Xi);
  let eo = {};
  !ra && !la ? eo = {
    tabIndex: Xi === qi.focusedKey ? 0 : -1,
    onFocus(kl) {
      kl.target === Qi.current && qi.setFocusedKey(Xi);
    }
  } : la && (eo.onMouseDown = (kl) => {
    kl.preventDefault();
  });
  let rs = qi.isLink(Xi) && to === "override", ko = qi.isLink(Xi) && to !== "selection" && to !== "none", Hs = !la && qi.canSelectItem(Xi) && !rs, Ks = (Ma || ko) && !la, Ys = Ks && (qi.selectionBehavior === "replace" ? !Hs : !Hs || qi.isEmpty), Xs = Ks && Hs && qi.selectionBehavior === "replace", Cs = Ys || Xs, Fs = useRef(null), ws = Cs && Hs, ls = useRef(!1), ks = useRef(!1), Js = (kl) => {
    if (Ma && Ma(), ko && Qi.current) {
      let Ul = qi.getItemProps(Xi);
      Eo.open(Qi.current, kl, Ul.href, Ul.routerOptions);
    }
  }, pl = {};
  ta ? (pl.onPressStart = (kl) => {
    Fs.current = kl.pointerType, ls.current = ws, kl.pointerType === "keyboard" && (!Cs || $880e95eb8b93ba9a$var$isSelectionKey()) && So(kl);
  }, Va ? (pl.onPressUp = Ys ? void 0 : (kl) => {
    kl.pointerType === "mouse" && Hs && So(kl);
  }, pl.onPress = Ys ? Js : (kl) => {
    kl.pointerType !== "keyboard" && kl.pointerType !== "mouse" && Hs && So(kl);
  }) : pl.onPress = (kl) => {
    if (Ys || Xs && kl.pointerType !== "mouse") {
      if (kl.pointerType === "keyboard" && !$880e95eb8b93ba9a$var$isActionKey()) return;
      Js(kl);
    } else kl.pointerType !== "keyboard" && Hs && So(kl);
  }) : (pl.onPressStart = (kl) => {
    Fs.current = kl.pointerType, ls.current = ws, ks.current = Ys, Hs && (kl.pointerType === "mouse" && !Ys || kl.pointerType === "keyboard" && (!Ks || $880e95eb8b93ba9a$var$isSelectionKey())) && So(kl);
  }, pl.onPress = (kl) => {
    (kl.pointerType === "touch" || kl.pointerType === "pen" || kl.pointerType === "virtual" || kl.pointerType === "keyboard" && Cs && $880e95eb8b93ba9a$var$isActionKey() || kl.pointerType === "mouse" && ks.current) && (Cs ? Js(kl) : Hs && So(kl));
  }), eo["data-key"] = Xi, pl.preventFocusOnPress = ra;
  let { pressProps: _l, isPressed: bl } = $f6c31cce2adf654f$export$45712eceda6fad21(pl), xl = Xs ? (kl) => {
    Fs.current === "mouse" && (kl.stopPropagation(), kl.preventDefault(), Js(kl));
  } : void 0, { longPressProps: Rl } = $8a26561d2877236e$export$c24ed0104d07eab9({
    isDisabled: !ws,
    onLongPress(kl) {
      kl.pointerType === "touch" && (So(kl), qi.setSelectionBehavior("toggle"));
    }
  }), Cl = (kl) => {
    Fs.current === "touch" && ls.current && kl.preventDefault();
  }, Dl = qi.isLink(Xi) ? (kl) => {
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening || kl.preventDefault();
  } : void 0;
  return {
    itemProps: $3ef42575df84b30b$export$9d1611c77c2fe928(eo, Hs || Ys ? _l : {}, ws ? Rl : {}, {
      onDoubleClick: xl,
      onDragStartCapture: Cl,
      onClick: Dl,
      id: e
    }),
    isPressed: bl,
    isSelected: qi.isSelected(Xi),
    isFocused: qi.isFocused && qi.focusedKey === Xi,
    isDisabled: la,
    allowsSelection: Hs,
    hasAction: Cs
  };
}
function $880e95eb8b93ba9a$var$isActionKey() {
  let Bi = window.event;
  return Bi?.key === "Enter";
}
function $880e95eb8b93ba9a$var$isSelectionKey() {
  let Bi = window.event;
  return Bi?.key === " " || Bi?.code === "Space";
}
class $657e4dc4a6e88df0$export$8f5ed9ff9f511381 {
  getItemRect(e) {
    let qi = this.ref.current;
    if (!qi) return null;
    let Xi = e != null ? qi.querySelector(`[data-key="${CSS.escape(e.toString())}"]`) : null;
    if (!Xi) return null;
    let Qi = qi.getBoundingClientRect(), ta = Xi.getBoundingClientRect();
    return {
      x: ta.left - Qi.left + qi.scrollLeft,
      y: ta.top - Qi.top + qi.scrollTop,
      width: ta.width,
      height: ta.height
    };
  }
  getContentSize() {
    let e = this.ref.current;
    var qi, Xi;
    return {
      width: (qi = e?.scrollWidth) !== null && qi !== void 0 ? qi : 0,
      height: (Xi = e?.scrollHeight) !== null && Xi !== void 0 ? Xi : 0
    };
  }
  getVisibleRect() {
    let e = this.ref.current;
    var qi, Xi, Qi, ta;
    return {
      x: (qi = e?.scrollLeft) !== null && qi !== void 0 ? qi : 0,
      y: (Xi = e?.scrollTop) !== null && Xi !== void 0 ? Xi : 0,
      width: (Qi = e?.offsetWidth) !== null && Qi !== void 0 ? Qi : 0,
      height: (ta = e?.offsetHeight) !== null && ta !== void 0 ? ta : 0
    };
  }
  constructor(e) {
    this.ref = e;
  }
}
class $2a25aae57d74318e$export$a05409b8bb224a5a {
  isDisabled(e) {
    var qi;
    return this.disabledBehavior === "all" && (((qi = e.props) === null || qi === void 0 ? void 0 : qi.isDisabled) || this.disabledKeys.has(e.key));
  }
  findNextNonDisabled(e, qi) {
    let Xi = e;
    for (; Xi != null; ) {
      let Qi = this.collection.getItem(Xi);
      if (Qi?.type === "item" && !this.isDisabled(Qi)) return Xi;
      Xi = qi(Xi);
    }
    return null;
  }
  getNextKey(e) {
    let qi = e;
    return qi = this.collection.getKeyAfter(qi), this.findNextNonDisabled(qi, (Xi) => this.collection.getKeyAfter(Xi));
  }
  getPreviousKey(e) {
    let qi = e;
    return qi = this.collection.getKeyBefore(qi), this.findNextNonDisabled(qi, (Xi) => this.collection.getKeyBefore(Xi));
  }
  findKey(e, qi, Xi) {
    let Qi = e, ta = this.layoutDelegate.getItemRect(Qi);
    if (!ta || Qi == null) return null;
    let ra = ta;
    do {
      if (Qi = qi(Qi), Qi == null) break;
      ta = this.layoutDelegate.getItemRect(Qi);
    } while (ta && Xi(ra, ta) && Qi != null);
    return Qi;
  }
  isSameRow(e, qi) {
    return e.y === qi.y || e.x !== qi.x;
  }
  isSameColumn(e, qi) {
    return e.x === qi.x || e.y !== qi.y;
  }
  getKeyBelow(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (qi) => this.getNextKey(qi), this.isSameRow) : this.getNextKey(e);
  }
  getKeyAbove(e) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(e, (qi) => this.getPreviousKey(qi), this.isSameRow) : this.getPreviousKey(e);
  }
  getNextColumn(e, qi) {
    return qi ? this.getPreviousKey(e) : this.getNextKey(e);
  }
  getKeyRightOf(e) {
    let qi = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[qi] ? (e = this.layoutDelegate[qi](e), this.findNextNonDisabled(e, (Xi) => this.layoutDelegate[qi](Xi))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "rtl") : this.findKey(e, (Xi) => this.getNextColumn(Xi, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "rtl") : null;
  }
  getKeyLeftOf(e) {
    let qi = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[qi] ? (e = this.layoutDelegate[qi](e), this.findNextNonDisabled(e, (Xi) => this.layoutDelegate[qi](Xi))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(e, this.direction === "ltr") : this.findKey(e, (Xi) => this.getNextColumn(Xi, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(e, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let e = this.collection.getFirstKey();
    return this.findNextNonDisabled(e, (qi) => this.collection.getKeyAfter(qi));
  }
  getLastKey() {
    let e = this.collection.getLastKey();
    return this.findNextNonDisabled(e, (qi) => this.collection.getKeyBefore(qi));
  }
  getKeyPageAbove(e) {
    let qi = this.ref.current, Xi = this.layoutDelegate.getItemRect(e);
    if (!Xi) return null;
    if (qi && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(qi)) return this.getFirstKey();
    let Qi = e;
    if (this.orientation === "horizontal") {
      let ta = Math.max(0, Xi.x + Xi.width - this.layoutDelegate.getVisibleRect().width);
      for (; Xi && Xi.x > ta && Qi != null; )
        Qi = this.getKeyAbove(Qi), Xi = Qi == null ? null : this.layoutDelegate.getItemRect(Qi);
    } else {
      let ta = Math.max(0, Xi.y + Xi.height - this.layoutDelegate.getVisibleRect().height);
      for (; Xi && Xi.y > ta && Qi != null; )
        Qi = this.getKeyAbove(Qi), Xi = Qi == null ? null : this.layoutDelegate.getItemRect(Qi);
    }
    return Qi ?? this.getFirstKey();
  }
  getKeyPageBelow(e) {
    let qi = this.ref.current, Xi = this.layoutDelegate.getItemRect(e);
    if (!Xi) return null;
    if (qi && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(qi)) return this.getLastKey();
    let Qi = e;
    if (this.orientation === "horizontal") {
      let ta = Math.min(this.layoutDelegate.getContentSize().width, Xi.y - Xi.width + this.layoutDelegate.getVisibleRect().width);
      for (; Xi && Xi.x < ta && Qi != null; )
        Qi = this.getKeyBelow(Qi), Xi = Qi == null ? null : this.layoutDelegate.getItemRect(Qi);
    } else {
      let ta = Math.min(this.layoutDelegate.getContentSize().height, Xi.y - Xi.height + this.layoutDelegate.getVisibleRect().height);
      for (; Xi && Xi.y < ta && Qi != null; )
        Qi = this.getKeyBelow(Qi), Xi = Qi == null ? null : this.layoutDelegate.getItemRect(Qi);
    }
    return Qi ?? this.getLastKey();
  }
  getKeyForSearch(e, qi) {
    if (!this.collator) return null;
    let Xi = this.collection, Qi = qi || this.getFirstKey();
    for (; Qi != null; ) {
      let ta = Xi.getItem(Qi);
      if (!ta) return null;
      let ra = ta.textValue.slice(0, e.length);
      if (ta.textValue && this.collator.compare(ra, e) === 0) return Qi;
      Qi = this.getNextKey(Qi);
    }
    return null;
  }
  constructor(...e) {
    if (e.length === 1) {
      let qi = e[0];
      this.collection = qi.collection, this.ref = qi.ref, this.collator = qi.collator, this.disabledKeys = qi.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = qi.disabledBehavior || "all", this.orientation = qi.orientation || "vertical", this.direction = qi.direction, this.layout = qi.layout || "stack", this.layoutDelegate = qi.layoutDelegate || new $657e4dc4a6e88df0$export$8f5ed9ff9f511381(qi.ref);
    } else
      this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new $657e4dc4a6e88df0$export$8f5ed9ff9f511381(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function $982254629710d113$export$b95089534ab7c1fd(Bi) {
  let { selectionManager: e, collection: qi, disabledKeys: Xi, ref: Qi, keyboardDelegate: ta, layoutDelegate: ra } = Bi, na = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), la = e.disabledBehavior, Ma = useMemo(() => ta || new $2a25aae57d74318e$export$a05409b8bb224a5a({
    collection: qi,
    disabledKeys: Xi,
    disabledBehavior: la,
    ref: Qi,
    collator: na,
    layoutDelegate: ra
  }), [
    ta,
    ra,
    qi,
    Xi,
    Qi,
    na,
    la
  ]), { collectionProps: Va } = $ae20dd8cbca75726$export$d6daf82dcd84e87c({
    ...Bi,
    ref: Qi,
    selectionManager: e,
    keyboardDelegate: Ma
  });
  return {
    listProps: Va
  };
}
function $c132121280ec012d$export$50eacbbf140a3141(Bi, e, qi) {
  let Xi = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), Qi = Bi.selectionBehavior || "toggle", ta = Bi.linkBehavior || (Qi === "replace" ? "action" : "override");
  Qi === "toggle" && ta === "action" && (ta = "override");
  let { listProps: ra } = $982254629710d113$export$b95089534ab7c1fd({
    ...Bi,
    ref: qi,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    linkBehavior: ta
  }), { focusWithinProps: na } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onFocusWithin: Bi.onFocus,
    onBlurWithin: Bi.onBlur,
    onFocusWithinChange: Bi.onFocusChange
  }), la = $bdb11010cef70236$export$f680877a34711e37(Bi.id);
  $b1f0cad8af73213b$export$3585ede4d035bf14.set(e, {
    id: la,
    shouldUseVirtualFocus: Bi.shouldUseVirtualFocus,
    shouldSelectOnPressUp: Bi.shouldSelectOnPressUp,
    shouldFocusOnHover: Bi.shouldFocusOnHover,
    isVirtualized: Bi.isVirtualized,
    onAction: Bi.onAction,
    linkBehavior: ta
  });
  let { labelProps: Ma, fieldProps: Va } = $d191a55c9702f145$export$8467354a121f1b9f({
    ...Bi,
    id: la,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: Ma,
    listBoxProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Xi, na, e.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(Va, ra)
    })
  };
}
class $eb2240fc39a57fa5$export$bf788dd355e3a401 {
  build(e, qi) {
    return this.context = qi, $eb2240fc39a57fa5$var$iterable(() => this.iterateCollection(e));
  }
  *iterateCollection(e) {
    let { children: qi, items: Xi } = e;
    if (a__default.isValidElement(qi) && qi.type === a__default.Fragment) yield* this.iterateCollection({
      children: qi.props.children,
      items: Xi
    });
    else if (typeof qi == "function") {
      if (!Xi) throw new Error("props.children was a function but props.items is missing");
      let Qi = 0;
      for (let ta of Xi)
        yield* this.getFullNode({
          value: ta,
          index: Qi
        }, {
          renderer: qi
        }), Qi++;
    } else {
      let Qi = [];
      a__default.Children.forEach(qi, (ra) => {
        ra && Qi.push(ra);
      });
      let ta = 0;
      for (let ra of Qi) {
        let na = this.getFullNode({
          element: ra,
          index: ta
        }, {});
        for (let la of na)
          ta++, yield la;
      }
    }
  }
  getKey(e, qi, Xi, Qi) {
    if (e.key != null) return e.key;
    if (qi.type === "cell" && qi.key != null) return `${Qi}${qi.key}`;
    let ta = qi.value;
    if (ta != null) {
      var ra;
      let na = (ra = ta.key) !== null && ra !== void 0 ? ra : ta.id;
      if (na == null) throw new Error("No key found for item");
      return na;
    }
    return Qi ? `${Qi}.${qi.index}` : `$.${qi.index}`;
  }
  getChildState(e, qi) {
    return {
      renderer: qi.renderer || e.renderer
    };
  }
  *getFullNode(e, qi, Xi, Qi) {
    if (a__default.isValidElement(e.element) && e.element.type === a__default.Fragment) {
      let ko = [];
      a__default.Children.forEach(e.element.props.children, (Ks) => {
        ko.push(Ks);
      });
      var ta;
      let Hs = (ta = e.index) !== null && ta !== void 0 ? ta : 0;
      for (const Ks of ko) yield* this.getFullNode({
        element: Ks,
        index: Hs++
      }, qi, Xi, Qi);
      return;
    }
    let ra = e.element;
    if (!ra && e.value && qi && qi.renderer) {
      let ko = this.cache.get(e.value);
      if (ko && (!ko.shouldInvalidate || !ko.shouldInvalidate(this.context))) {
        ko.index = e.index, ko.parentKey = Qi ? Qi.key : null, yield ko;
        return;
      }
      ra = qi.renderer(e.value);
    }
    if (a__default.isValidElement(ra)) {
      let ko = ra.type;
      if (typeof ko != "function" && typeof ko.getCollectionNode != "function") {
        let Xs = ra.type;
        throw new Error(`Unknown element <${Xs}> in collection.`);
      }
      let Hs = ko.getCollectionNode(ra.props, this.context);
      var na;
      let Ks = (na = e.index) !== null && na !== void 0 ? na : 0, Ys = Hs.next();
      for (; !Ys.done && Ys.value; ) {
        let Xs = Ys.value;
        e.index = Ks;
        var la;
        let Cs = (la = Xs.key) !== null && la !== void 0 ? la : null;
        Cs == null && (Cs = Xs.element ? null : this.getKey(ra, e, qi, Xi));
        let ws = [
          ...this.getFullNode({
            ...Xs,
            key: Cs,
            index: Ks,
            wrapper: $eb2240fc39a57fa5$var$compose(e.wrapper, Xs.wrapper)
          }, this.getChildState(qi, Xs), Xi ? `${Xi}${ra.key}` : ra.key, Qi)
        ];
        for (let ls of ws) {
          var Ma, Va;
          ls.value = (Va = (Ma = Xs.value) !== null && Ma !== void 0 ? Ma : e.value) !== null && Va !== void 0 ? Va : null, ls.value && this.cache.set(ls.value, ls);
          var to;
          if (e.type && ls.type !== e.type) throw new Error(`Unsupported type <${$eb2240fc39a57fa5$var$capitalize(ls.type)}> in <${$eb2240fc39a57fa5$var$capitalize((to = Qi?.type) !== null && to !== void 0 ? to : "unknown parent type")}>. Only <${$eb2240fc39a57fa5$var$capitalize(e.type)}> is supported.`);
          Ks++, yield ls;
        }
        Ys = Hs.next(ws);
      }
      return;
    }
    if (e.key == null || e.type == null) return;
    let Eo = this;
    var So, eo;
    let rs = {
      type: e.type,
      props: e.props,
      key: e.key,
      parentKey: Qi ? Qi.key : null,
      value: (So = e.value) !== null && So !== void 0 ? So : null,
      level: Qi ? Qi.level + 1 : 0,
      index: e.index,
      rendered: e.rendered,
      textValue: (eo = e.textValue) !== null && eo !== void 0 ? eo : "",
      "aria-label": e["aria-label"],
      wrapper: e.wrapper,
      shouldInvalidate: e.shouldInvalidate,
      hasChildNodes: e.hasChildNodes || !1,
      childNodes: $eb2240fc39a57fa5$var$iterable(function* () {
        if (!e.hasChildNodes || !e.childNodes) return;
        let ko = 0;
        for (let Hs of e.childNodes()) {
          Hs.key != null && (Hs.key = `${rs.key}${Hs.key}`);
          let Ks = Eo.getFullNode({
            ...Hs,
            index: ko
          }, Eo.getChildState(qi, Hs), rs.key, rs);
          for (let Ys of Ks)
            ko++, yield Ys;
        }
      })
    };
    yield rs;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function $eb2240fc39a57fa5$var$iterable(Bi) {
  let e = [], qi = null;
  return {
    *[Symbol.iterator]() {
      for (let Xi of e) yield Xi;
      qi || (qi = Bi());
      for (let Xi of qi)
        e.push(Xi), yield Xi;
    }
  };
}
function $eb2240fc39a57fa5$var$compose(Bi, e) {
  if (Bi && e) return (qi) => Bi(e(qi));
  if (Bi) return Bi;
  if (e) return e;
}
function $eb2240fc39a57fa5$var$capitalize(Bi) {
  return Bi[0].toUpperCase() + Bi.slice(1);
}
function $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, e, qi) {
  let Xi = useMemo(() => new $eb2240fc39a57fa5$export$bf788dd355e3a401(), []), { children: Qi, items: ta, collection: ra } = Bi;
  return useMemo(() => {
    if (ra) return ra;
    let la = Xi.build({
      children: Qi,
      items: ta
    }, qi);
    return e(la);
  }, [
    Xi,
    Qi,
    ta,
    ra,
    qi,
    e
  ]);
}
function $c5a24bc478652b5f$export$1005530eda016c13(Bi, e) {
  return typeof e.getChildren == "function" ? e.getChildren(Bi.key) : Bi.childNodes;
}
function $c5a24bc478652b5f$export$fbdeaa6a76694f71(Bi) {
  return $c5a24bc478652b5f$export$5f3398f8733f90e2(Bi);
}
function $c5a24bc478652b5f$export$5f3398f8733f90e2(Bi, e) {
  for (let qi of Bi)
    return qi;
}
function $c5a24bc478652b5f$export$8c434b3a7a4dad6(Bi, e, qi) {
  if (e.parentKey === qi.parentKey) return e.index - qi.index;
  let Xi = [
    ...$c5a24bc478652b5f$var$getAncestors(Bi, e),
    e
  ], Qi = [
    ...$c5a24bc478652b5f$var$getAncestors(Bi, qi),
    qi
  ], ta = Xi.slice(0, Qi.length).findIndex((ra, na) => ra !== Qi[na]);
  return ta !== -1 ? (e = Xi[ta], qi = Qi[ta], e.index - qi.index) : Xi.findIndex((ra) => ra === qi) >= 0 ? 1 : (Qi.findIndex((ra) => ra === e) >= 0, -1);
}
function $c5a24bc478652b5f$var$getAncestors(Bi, e) {
  let qi = [], Xi = e;
  for (; Xi?.parentKey != null; )
    Xi = Bi.getItem(Xi.parentKey), Xi && qi.unshift(Xi);
  return qi;
}
const $453cc9f0df89c0a5$var$cache = /* @__PURE__ */ new WeakMap();
function $453cc9f0df89c0a5$export$77d5aafae4e095b2(Bi) {
  let e = $453cc9f0df89c0a5$var$cache.get(Bi);
  if (e != null) return e;
  let qi = 0, Xi = (Qi) => {
    for (let ta of Qi) ta.type === "section" ? Xi($c5a24bc478652b5f$export$1005530eda016c13(ta, Bi)) : qi++;
  };
  return Xi(Bi), $453cc9f0df89c0a5$var$cache.set(Bi, qi), qi;
}
function $293f70390ea03370$export$497855f14858aa34(Bi, e, qi) {
  var Xi, Qi;
  let { key: ta } = Bi, ra = $b1f0cad8af73213b$export$3585ede4d035bf14.get(e);
  var na;
  let la = (na = Bi.isDisabled) !== null && na !== void 0 ? na : e.selectionManager.isDisabled(ta);
  var Ma;
  let Va = (Ma = Bi.isSelected) !== null && Ma !== void 0 ? Ma : e.selectionManager.isSelected(ta);
  var to;
  let Eo = (to = Bi.shouldSelectOnPressUp) !== null && to !== void 0 ? to : ra?.shouldSelectOnPressUp;
  var So;
  let eo = (So = Bi.shouldFocusOnHover) !== null && So !== void 0 ? So : ra?.shouldFocusOnHover;
  var rs;
  let ko = (rs = Bi.shouldUseVirtualFocus) !== null && rs !== void 0 ? rs : ra?.shouldUseVirtualFocus;
  var Hs;
  let Ks = (Hs = Bi.isVirtualized) !== null && Hs !== void 0 ? Hs : ra?.isVirtualized, Ys = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Xs = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Cs = {
    role: "option",
    "aria-disabled": la || void 0,
    "aria-selected": e.selectionManager.selectionMode !== "none" ? Va : void 0
  };
  $c87311424ea30a05$export$9ac100e40613ea10() && $c87311424ea30a05$export$78551043582a6a98() || (Cs["aria-label"] = Bi["aria-label"], Cs["aria-labelledby"] = Ys, Cs["aria-describedby"] = Xs);
  let Fs = e.collection.getItem(ta);
  if (Ks) {
    let Dl = Number(Fs?.index);
    Cs["aria-posinset"] = Number.isNaN(Dl) ? void 0 : Dl + 1, Cs["aria-setsize"] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(e.collection);
  }
  let ws = ra?.onAction ? () => {
    var Dl;
    return ra == null || (Dl = ra.onAction) === null || Dl === void 0 ? void 0 : Dl.call(ra, ta);
  } : void 0, ls = $b1f0cad8af73213b$export$9145995848b05025(e, ta), { itemProps: ks, isPressed: Js, isFocused: pl, hasAction: _l, allowsSelection: bl } = $880e95eb8b93ba9a$export$ecf600387e221c37({
    selectionManager: e.selectionManager,
    key: ta,
    ref: qi,
    shouldSelectOnPressUp: Eo,
    allowsDifferentPressOrigin: Eo && eo,
    isVirtualized: Ks,
    shouldUseVirtualFocus: ko,
    isDisabled: la,
    onAction: ws || !(Fs == null || (Xi = Fs.props) === null || Xi === void 0) && Xi.onAction ? $ff5963eb1fccf552$export$e08e3b67e392101e(Fs == null || (Qi = Fs.props) === null || Qi === void 0 ? void 0 : Qi.onAction, ws) : void 0,
    linkBehavior: ra?.linkBehavior,
    id: ls
  }), { hoverProps: xl } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: la || !eo,
    onHoverStart() {
      $507fabe10e71c6fb$export$b9b3dfddab17db27() || (e.selectionManager.setFocused(!0), e.selectionManager.setFocusedKey(ta));
    }
  }), Rl = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Fs?.props);
  delete Rl.id;
  let Cl = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(Fs?.props);
  return {
    optionProps: {
      ...Cs,
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(Rl, ks, xl, Cl),
      id: ls
    },
    labelProps: {
      id: Ys
    },
    descriptionProps: {
      id: Xs
    },
    isFocused: pl,
    isFocusVisible: pl && $507fabe10e71c6fb$export$b9b3dfddab17db27(),
    isSelected: Va,
    isDisabled: la,
    isPressed: Js,
    allowsSelection: bl,
    hasAction: _l
  };
}
function $af383d3bef1cfdc9$export$c3f9f39876e4bc7(Bi) {
  let { heading: e, "aria-label": qi } = Bi, Xi = $bdb11010cef70236$export$f680877a34711e37();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: Xi,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": qi,
      "aria-labelledby": e ? Xi : void 0
    }
  };
}
var $c0398ad35c3639b7$exports = {};
$c0398ad35c3639b7$exports = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var $7af657c4165927c3$exports = {};
$7af657c4165927c3$exports = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var $d95d4da6d531ab81$exports = {};
$d95d4da6d531ab81$exports = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var $24ebda9c775dca17$exports = {};
$24ebda9c775dca17$exports = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var $743e0dfca6cab1e9$exports = {};
$743e0dfca6cab1e9$exports = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var $a2f41026e05f1c84$exports = {};
$a2f41026e05f1c84$exports = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var $43b800e97c901737$exports = {};
$43b800e97c901737$exports = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var $442f5f6ac211e29f$exports = {};
$442f5f6ac211e29f$exports = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var $51608325613944d7$exports = {};
$51608325613944d7$exports = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var $c4a1b1eabeaa87be$exports = {};
$c4a1b1eabeaa87be$exports = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var $8c74815cdee18d1b$exports = {};
$8c74815cdee18d1b$exports = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var $fd0e9ef6a7fe0ec9$exports = {};
$fd0e9ef6a7fe0ec9$exports = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var $a89a74a39eba465a$exports = {};
$a89a74a39eba465a$exports = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var $f9b672d9b82fa3d6$exports = {};
$f9b672d9b82fa3d6$exports = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var $4f1bde932c441789$exports = {};
$4f1bde932c441789$exports = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var $89aaf803103bb500$exports = {};
$89aaf803103bb500$exports = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var $c685891476dbaaca$exports = {};
$c685891476dbaaca$exports = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var $885879b9b10c2959$exports = {};
$885879b9b10c2959$exports = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var $6b39616688a51692$exports = {};
$6b39616688a51692$exports = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var $f26362aed63f47e2$exports = {};
$f26362aed63f47e2$exports = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var $06cbade644558bf0$exports = {};
$06cbade644558bf0$exports = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var $0a391ff68f9d59b1$exports = {};
$0a391ff68f9d59b1$exports = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var $8193cf0e649c7928$exports = {};
$8193cf0e649c7928$exports = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var $f398debcce5a5c55$exports = {};
$f398debcce5a5c55$exports = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var $9e9fef000aa4c013$exports = {};
$9e9fef000aa4c013$exports = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var $c016c8183bbe3d68$exports = {};
$c016c8183bbe3d68$exports = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var $ca4f6c8462244e62$exports = {};
$ca4f6c8462244e62$exports = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var $2d9960c02ccac927$exports = {};
$2d9960c02ccac927$exports = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var $f1b682a4c8c5631c$exports = {};
$f1b682a4c8c5631c$exports = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var $2cbb7ca666678a14$exports = {};
$2cbb7ca666678a14$exports = {
  "ar-AE": $c0398ad35c3639b7$exports,
  "bg-BG": $7af657c4165927c3$exports,
  "cs-CZ": $d95d4da6d531ab81$exports,
  "da-DK": $24ebda9c775dca17$exports,
  "de-DE": $743e0dfca6cab1e9$exports,
  "el-GR": $a2f41026e05f1c84$exports,
  "en-US": $43b800e97c901737$exports,
  "es-ES": $442f5f6ac211e29f$exports,
  "et-EE": $dff280acfeb2d8ac$exports,
  "fi-FI": $51608325613944d7$exports,
  "fr-FR": $c4a1b1eabeaa87be$exports,
  "he-IL": $8c74815cdee18d1b$exports,
  "hr-HR": $fd0e9ef6a7fe0ec9$exports,
  "hu-HU": $a89a74a39eba465a$exports,
  "it-IT": $edc7c66594a0ae8a$exports,
  "ja-JP": $f1ab51510712db52$exports,
  "ko-KR": $f9b672d9b82fa3d6$exports,
  "lt-LT": $a385f3910feda499$exports,
  "lv-LV": $4f1bde932c441789$exports,
  "nb-NO": $914a51a8a594d5be$exports,
  "nl-NL": $89aaf803103bb500$exports,
  "pl-PL": $c685891476dbaaca$exports,
  "pt-BR": $885879b9b10c2959$exports,
  "pt-PT": $6b39616688a51692$exports,
  "ro-RO": $f26362aed63f47e2$exports,
  "ru-RU": $06cbade644558bf0$exports,
  "sk-SK": $0a391ff68f9d59b1$exports,
  "sl-SI": $8193cf0e649c7928$exports,
  "sr-SP": $f398debcce5a5c55$exports,
  "sv-SE": $9e9fef000aa4c013$exports,
  "tr-TR": $c016c8183bbe3d68$exports,
  "uk-UA": $ca4f6c8462244e62$exports,
  "zh-CN": $2d9960c02ccac927$exports,
  "zh-TW": $f1b682a4c8c5631c$exports
};
function $parcel$interopDefault(Bi) {
  return Bi && Bi.__esModule ? Bi.default : Bi;
}
function $168583247155ddda$export$dc9c12ed27dd1b49(Bi, e, qi) {
  let { type: Xi = "menu", isDisabled: Qi, trigger: ta = "press" } = Bi, ra = $bdb11010cef70236$export$f680877a34711e37(), { triggerProps: na, overlayProps: la } = $628037886ba31236$export$f9d5c8beee7d008d({
    type: Xi
  }, e, qi), Ma = (So) => {
    if (!Qi && !(ta === "longPress" && !So.altKey) && qi && qi.current)
      switch (So.key) {
        case "Enter":
        case " ":
          if (ta === "longPress") return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in So || So.stopPropagation(), So.preventDefault(), e.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in So || So.stopPropagation(), So.preventDefault(), e.toggle("last");
          break;
        default:
          "continuePropagation" in So && So.continuePropagation();
      }
  }, Va = $fca6afa0e843324b$export$f12b703ca79dfbb1($parcel$interopDefault($2cbb7ca666678a14$exports), "@react-aria/menu"), { longPressProps: to } = $8a26561d2877236e$export$c24ed0104d07eab9({
    isDisabled: Qi || ta !== "longPress",
    accessibilityDescription: Va.format("longPressMessage"),
    onLongPressStart() {
      e.close();
    },
    onLongPress() {
      e.open("first");
    }
  }), Eo = {
    onPressStart(So) {
      So.pointerType !== "touch" && So.pointerType !== "keyboard" && !Qi && e.open(So.pointerType === "virtual" ? "first" : null);
    },
    onPress(So) {
      So.pointerType === "touch" && !Qi && e.toggle();
    }
  };
  return delete na.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...na,
      ...ta === "press" ? Eo : to,
      id: ra,
      onKeyDown: Ma
    },
    menuProps: {
      ...la,
      "aria-labelledby": ra,
      autoFocus: e.focusStrategy || !0,
      onClose: e.close
    }
  };
}
const $fc79756100351201$export$6f49b4016bfc8d56 = /* @__PURE__ */ new WeakMap();
function $d5336fe17ce95402$export$38eaa17faae8f579(Bi, e, qi) {
  let { shouldFocusWrap: Xi = !0, onKeyDown: Qi, onKeyUp: ta, ...ra } = Bi;
  !Bi["aria-label"] && !Bi["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let na = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), { listProps: la } = $982254629710d113$export$b95089534ab7c1fd({
    ...ra,
    ref: qi,
    selectionManager: e.selectionManager,
    collection: e.collection,
    disabledKeys: e.disabledKeys,
    shouldFocusWrap: Xi,
    linkBehavior: "override"
  });
  return $fc79756100351201$export$6f49b4016bfc8d56.set(e, {
    onClose: Bi.onClose,
    onAction: Bi.onAction,
    shouldUseVirtualFocus: Bi.shouldUseVirtualFocus
  }), {
    menuProps: $3ef42575df84b30b$export$9d1611c77c2fe928(na, {
      onKeyDown: Qi,
      onKeyUp: ta
    }, {
      role: "menu",
      ...la,
      onKeyDown: (Ma) => {
        var Va;
        (Ma.key !== "Escape" || Bi.shouldUseVirtualFocus) && ((Va = la.onKeyDown) === null || Va === void 0 || Va.call(la, Ma));
      }
    })
  };
}
function $a2e5df62f93c7633$export$9d32628fc2aea7da(Bi, e, qi) {
  let { id: Xi, key: Qi, closeOnSelect: ta, isVirtualized: ra, "aria-haspopup": na, onPressStart: la, onPressUp: Ma, onPress: Va, onPressChange: to, onPressEnd: Eo, onHoverStart: So, onHoverChange: eo, onHoverEnd: rs, onKeyDown: ko, onKeyUp: Hs, onFocus: Ks, onFocusChange: Ys, onBlur: Xs, selectionManager: Cs = e.selectionManager } = Bi, Fs = !!na, ws = Fs && Bi["aria-expanded"] === "true";
  var ls;
  let ks = (ls = Bi.isDisabled) !== null && ls !== void 0 ? ls : Cs.isDisabled(Qi);
  var Js;
  let pl = (Js = Bi.isSelected) !== null && Js !== void 0 ? Js : Cs.isSelected(Qi), _l = $fc79756100351201$export$6f49b4016bfc8d56.get(e), bl = e.collection.getItem(Qi), xl = Bi.onClose || _l.onClose, Rl = $ea8dcbcb9ea1b556$export$9a302a45f65d0572(), Cl = (wl) => {
    var dl;
    if (!Fs) {
      if (!(bl == null || (dl = bl.props) === null || dl === void 0) && dl.onAction ? bl.props.onAction() : Bi.onAction && Bi.onAction(Qi), _l.onAction) {
        let Sl = _l.onAction;
        Sl(Qi);
      }
      wl.target instanceof HTMLAnchorElement && bl && Rl.open(wl.target, wl, bl.props.href, bl.props.routerOptions);
    }
  }, Dl = "menuitem";
  Fs || (Cs.selectionMode === "single" ? Dl = "menuitemradio" : Cs.selectionMode === "multiple" && (Dl = "menuitemcheckbox"));
  let kl = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Ul = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Bl = $bdb11010cef70236$export$b4cc09c592e8fdb8(), Zl = {
    id: Xi,
    "aria-disabled": ks || void 0,
    role: Dl,
    "aria-label": Bi["aria-label"],
    "aria-labelledby": kl,
    "aria-describedby": [
      Ul,
      Bl
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": Bi["aria-controls"],
    "aria-haspopup": na,
    "aria-expanded": Bi["aria-expanded"]
  };
  Cs.selectionMode !== "none" && !Fs && (Zl["aria-checked"] = pl), ra && (Zl["aria-posinset"] = bl?.index, Zl["aria-setsize"] = $453cc9f0df89c0a5$export$77d5aafae4e095b2(e.collection));
  let Pl = (wl) => {
    wl.pointerType === "keyboard" && Cl(wl), la?.(wl);
  }, yl = () => {
    !Fs && xl && (ta ?? (Cs.selectionMode !== "multiple" || Cs.isLink(Qi))) && xl();
  }, hl = (wl) => {
    wl.pointerType === "mouse" && (Cl(wl), yl()), Ma?.(wl);
  }, Tl = (wl) => {
    wl.pointerType !== "keyboard" && wl.pointerType !== "mouse" && (Cl(wl), yl()), Va?.(wl);
  }, { itemProps: Il, isFocused: jl } = $880e95eb8b93ba9a$export$ecf600387e221c37({
    id: Xi,
    selectionManager: Cs,
    key: Qi,
    ref: qi,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: _l.shouldUseVirtualFocus
  }), { pressProps: Al, isPressed: _s } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart: Pl,
    onPress: Tl,
    onPressUp: hl,
    onPressChange: to,
    onPressEnd: Eo,
    isDisabled: ks
  }), { hoverProps: Gs } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: ks,
    onHoverStart(wl) {
      !$507fabe10e71c6fb$export$b9b3dfddab17db27() && !(ws && na === "dialog") && (Cs.setFocused(!0), Cs.setFocusedKey(Qi)), So?.(wl);
    },
    onHoverChange: eo,
    onHoverEnd: rs
  }), { keyboardProps: vl } = $46d819fcbaf35654$export$8f71654801c2f7cd({
    onKeyDown: (wl) => {
      if (wl.repeat) {
        wl.continuePropagation();
        return;
      }
      switch (wl.key) {
        case " ":
          !ks && Cs.selectionMode === "none" && !Fs && ta !== !1 && xl && xl();
          break;
        case "Enter":
          !ks && ta !== !1 && !Fs && xl && xl();
          break;
        default:
          Fs || wl.continuePropagation(), ko?.(wl);
          break;
      }
    },
    onKeyUp: Hs
  }), { focusProps: gl } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    onBlur: Xs,
    onFocus: Ks,
    onFocusChange: Ys
  }), El = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(bl?.props);
  delete El.id;
  let Ol = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(bl?.props);
  return {
    menuItemProps: {
      ...Zl,
      ...$3ef42575df84b30b$export$9d1611c77c2fe928(El, Ol, Fs ? {
        onFocus: Il.onFocus,
        "data-key": Il["data-key"]
      } : Il, Al, Gs, vl, gl),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: Il.tabIndex != null && ws ? -1 : Il.tabIndex
    },
    labelProps: {
      id: kl
    },
    descriptionProps: {
      id: Ul
    },
    keyboardShortcutProps: {
      id: Bl
    },
    isFocused: jl,
    isSelected: pl,
    isPressed: _s,
    isDisabled: ks
  };
}
function $3e5eb2498db5b506$export$73f7a44322579622(Bi) {
  let { heading: e, "aria-label": qi } = Bi, Xi = $bdb11010cef70236$export$f680877a34711e37();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: e ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: Xi,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": qi,
      "aria-labelledby": e ? Xi : void 0
    }
  };
}
const $58aed456727eb0f3$export$703601b7e90536f8 = /* @__PURE__ */ new WeakMap();
function $58aed456727eb0f3$export$e64b2f635402ca43(Bi, e, qi) {
  let { keyboardDelegate: Xi, isDisabled: Qi, isRequired: ta, name: ra, validationBehavior: na = "aria" } = Bi, la = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), Ma = useMemo(() => Xi || new $2a25aae57d74318e$export$a05409b8bb224a5a(e.collection, e.disabledKeys, qi, la), [
    Xi,
    e.collection,
    e.disabledKeys,
    la
  ]), { menuTriggerProps: Va, menuProps: to } = $168583247155ddda$export$dc9c12ed27dd1b49({
    isDisabled: Qi,
    type: "listbox"
  }, e, qi), Eo = (ls) => {
    switch (ls.key) {
      case "ArrowLeft": {
        var ks, Js;
        ls.preventDefault();
        let bl = e.selectedKey != null ? (ks = Ma.getKeyAbove) === null || ks === void 0 ? void 0 : ks.call(Ma, e.selectedKey) : (Js = Ma.getFirstKey) === null || Js === void 0 ? void 0 : Js.call(Ma);
        bl && e.setSelectedKey(bl);
        break;
      }
      case "ArrowRight": {
        var pl, _l;
        ls.preventDefault();
        let bl = e.selectedKey != null ? (pl = Ma.getKeyBelow) === null || pl === void 0 ? void 0 : pl.call(Ma, e.selectedKey) : (_l = Ma.getFirstKey) === null || _l === void 0 ? void 0 : _l.call(Ma);
        bl && e.setSelectedKey(bl);
        break;
      }
    }
  }, { typeSelectProps: So } = $fb3050f43d946246$export$e32c88dfddc6e1d8({
    keyboardDelegate: Ma,
    selectionManager: e.selectionManager,
    onTypeSelect(ls) {
      e.setSelectedKey(ls);
    }
  }), { isInvalid: eo, validationErrors: rs, validationDetails: ko } = e.displayValidation, { labelProps: Hs, fieldProps: Ks, descriptionProps: Ys, errorMessageProps: Xs } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...Bi,
    labelElementType: "span",
    isInvalid: eo,
    errorMessage: Bi.errorMessage || rs
  });
  So.onKeyDown = So.onKeyDownCapture, delete So.onKeyDownCapture;
  let Cs = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi, {
    labelable: !0
  }), Fs = $3ef42575df84b30b$export$9d1611c77c2fe928(So, Va, Ks), ws = $bdb11010cef70236$export$f680877a34711e37();
  return $58aed456727eb0f3$export$703601b7e90536f8.set(e, {
    isDisabled: Qi,
    isRequired: ta,
    name: ra,
    validationBehavior: na
  }), {
    labelProps: {
      ...Hs,
      onClick: () => {
        if (!Bi.isDisabled) {
          var ls;
          (ls = qi.current) === null || ls === void 0 || ls.focus(), $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
        }
      }
    },
    triggerProps: $3ef42575df84b30b$export$9d1611c77c2fe928(Cs, {
      ...Fs,
      isDisabled: Qi,
      onKeyDown: $ff5963eb1fccf552$export$e08e3b67e392101e(Fs.onKeyDown, Eo, Bi.onKeyDown),
      onKeyUp: Bi.onKeyUp,
      "aria-labelledby": [
        ws,
        Fs["aria-labelledby"],
        Fs["aria-label"] && !Fs["aria-labelledby"] ? Fs.id : null
      ].filter(Boolean).join(" "),
      onFocus(ls) {
        e.isFocused || (Bi.onFocus && Bi.onFocus(ls), Bi.onFocusChange && Bi.onFocusChange(!0), e.setFocused(!0));
      },
      onBlur(ls) {
        e.isOpen || (Bi.onBlur && Bi.onBlur(ls), Bi.onFocusChange && Bi.onFocusChange(!1), e.setFocused(!1));
      }
    }),
    valueProps: {
      id: ws
    },
    menuProps: {
      ...to,
      autoFocus: e.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (ls) => {
        ls.currentTarget.contains(ls.relatedTarget) || (Bi.onBlur && Bi.onBlur(ls), Bi.onFocusChange && Bi.onFocusChange(!1), e.setFocused(!1));
      },
      "aria-labelledby": [
        Ks["aria-labelledby"],
        Fs["aria-label"] && !Ks["aria-labelledby"] ? Fs.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: Ys,
    errorMessageProps: Xs,
    isInvalid: eo,
    validationErrors: rs,
    validationDetails: ko
  };
}
function $bdd25dc72710631f$export$f809e80f58e251d1(Bi, e, qi) {
  let Xi = $58aed456727eb0f3$export$703601b7e90536f8.get(e) || {}, { autoComplete: Qi, name: ta = Xi.name, isDisabled: ra = Xi.isDisabled } = Bi, { validationBehavior: na, isRequired: la } = Xi, { visuallyHiddenProps: Ma } = $5c3e21d68f1c4674$export$a966af930f325cab();
  $99facab73266f662$export$5add1d006293d136(Bi.selectRef, e.selectedKey, e.setSelectedKey), $e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior: na,
    focus: () => {
      var to;
      return (to = qi.current) === null || to === void 0 ? void 0 : to.focus();
    }
  }, e, Bi.selectRef);
  var Va;
  return {
    containerProps: {
      ...Ma,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: Qi,
      disabled: ra,
      required: na === "native" && la,
      name: ta,
      value: (Va = e.selectedKey) !== null && Va !== void 0 ? Va : "",
      onChange: (to) => e.setSelectedKey(to.target.value)
    }
  };
}
function $bdd25dc72710631f$export$cbd84cdb2e668835(Bi) {
  let { state: e, triggerRef: qi, label: Xi, name: Qi, isDisabled: ta } = Bi, ra = useRef(null), { containerProps: na, selectProps: la } = $bdd25dc72710631f$export$f809e80f58e251d1({
    ...Bi,
    selectRef: ra
  }, e, qi);
  var Ma;
  return e.collection.size <= 300 ? /* @__PURE__ */ a__default.createElement("div", {
    ...na,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ a__default.createElement("label", null, Xi, /* @__PURE__ */ a__default.createElement("select", {
    ...la,
    ref: ra
  }, /* @__PURE__ */ a__default.createElement("option", null), [
    ...e.collection.getKeys()
  ].map((Va) => {
    let to = e.collection.getItem(Va);
    if (to && to.type === "item") return /* @__PURE__ */ a__default.createElement("option", {
      key: to.key,
      value: to.key
    }, to.textValue);
  })))) : Qi ? /* @__PURE__ */ a__default.createElement("input", {
    type: "hidden",
    autoComplete: la.autoComplete,
    name: Qi,
    disabled: ta,
    value: (Ma = e.selectedKey) !== null && Ma !== void 0 ? Ma : ""
  }) : null;
}
const $0393f8ab869a0f1a$export$e9f3bf65a26ce129 = /* @__PURE__ */ createContext(null), $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), $d2b4bc8c273e7be6$export$24d547caef80ccd1 = /* @__PURE__ */ createContext({}), $d2b4bc8c273e7be6$export$353f5b6fc5456de1 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, qi) {
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $d2b4bc8c273e7be6$export$24d547caef80ccd1), e = $d2b4bc8c273e7be6$var$disablePendingProps(e);
  let Xi = e, { isPending: Qi } = Xi, { buttonProps: ta, isPressed: ra } = $701a24aa0da5b062$export$ea18c227d4417cc3(e, qi), { focusProps: na, isFocused: la, isFocusVisible: Ma } = $f7dceffc5ad7768b$export$4e328f61c538687f(e), { hoverProps: Va, isHovered: to } = $6179b936705e76d3$export$ae780daf29e6d456({
    ...e,
    isDisabled: e.isDisabled || Qi
  }), Eo = {
    isHovered: to,
    isPressed: (Xi.isPressed || ra) && !Qi,
    isFocused: la,
    isFocusVisible: Ma,
    isDisabled: e.isDisabled || !1,
    isPending: Qi ?? !1
  }, So = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    values: Eo,
    defaultClassName: "react-aria-Button"
  }), eo = $bdb11010cef70236$export$f680877a34711e37(ta.id), rs = $bdb11010cef70236$export$f680877a34711e37(), ko = ta["aria-labelledby"];
  Qi && (ko ? ko = `${ko} ${rs}` : ta["aria-label"] && (ko = `${eo} ${rs}`));
  let Hs = useRef(Qi);
  return useEffect(() => {
    let Ks = {
      "aria-labelledby": ko || eo
    };
    (!Hs.current && la && Qi || Hs.current && la && !Qi) && $319e236875307eab$export$a9b970dcc4ae71a9(Ks, "assertive"), Hs.current = Qi;
  }, [
    Qi,
    la,
    ko,
    eo
  ]), /* @__PURE__ */ a__default.createElement("button", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(e, {
      propNames: $d2b4bc8c273e7be6$var$additionalButtonHTMLAttributes
    }),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(ta, na, Va),
    ...So,
    type: ta.type === "submit" && Qi ? "button" : ta.type,
    id: eo,
    ref: qi,
    "aria-labelledby": ko,
    slot: e.slot || void 0,
    "aria-disabled": Qi ? "true" : ta["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": Eo.isPressed || void 0,
    "data-hovered": to || void 0,
    "data-focused": la || void 0,
    "data-pending": Qi || void 0,
    "data-focus-visible": Ma || void 0
  }, /* @__PURE__ */ a__default.createElement($0393f8ab869a0f1a$export$e9f3bf65a26ce129.Provider, {
    value: {
      id: rs
    }
  }, So.children));
});
function $d2b4bc8c273e7be6$var$disablePendingProps(Bi) {
  return Bi.isPending && (Bi.onPress = void 0, Bi.onPressStart = void 0, Bi.onPressEnd = void 0, Bi.onPressChange = void 0, Bi.onPressUp = void 0, Bi.onKeyDown = void 0, Bi.onKeyUp = void 0, Bi.onClick = void 0, Bi.href = void 0), Bi;
}
const $514c0188e459b4c0$export$9afb8bc826b033ea = /* @__PURE__ */ createContext({}), $ee014567cb39d3f0$export$ff05c3ac10437e03 = /* @__PURE__ */ createContext(null);
class $a02d57049d202695$export$d085fb9e920b5ca7 {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let qi = this.keyMap.get(e);
    var Xi;
    return qi && (Xi = qi.prevKey) !== null && Xi !== void 0 ? Xi : null;
  }
  getKeyAfter(e) {
    let qi = this.keyMap.get(e);
    var Xi;
    return qi && (Xi = qi.nextKey) !== null && Xi !== void 0 ? Xi : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var qi;
    return (qi = this.keyMap.get(e)) !== null && qi !== void 0 ? qi : null;
  }
  at(e) {
    const qi = [
      ...this.getKeys()
    ];
    return this.getItem(qi[e]);
  }
  getChildren(e) {
    let qi = this.keyMap.get(e);
    return qi?.childNodes || [];
  }
  constructor(e) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
    let qi = (ra) => {
      if (this.keyMap.set(ra.key, ra), ra.childNodes && ra.type === "section") for (let na of ra.childNodes) qi(na);
    };
    for (let ra of e) qi(ra);
    let Xi = null, Qi = 0;
    for (let [ra, na] of this.keyMap)
      Xi ? (Xi.nextKey = ra, na.prevKey = Xi.key) : (this.firstKey = ra, na.prevKey = void 0), na.type === "item" && (na.index = Qi++), Xi = na, Xi.nextKey = void 0;
    var ta;
    this.lastKey = (ta = Xi?.key) !== null && ta !== void 0 ? ta : null;
  }
}
class $e40ea825a81a3709$export$52baac22726c72bf extends Set {
  constructor(e, qi, Xi) {
    super(e), e instanceof $e40ea825a81a3709$export$52baac22726c72bf ? (this.anchorKey = qi ?? e.anchorKey, this.currentKey = Xi ?? e.currentKey) : (this.anchorKey = qi ?? null, this.currentKey = Xi ?? null);
  }
}
function $7af3f5b51489e0b5$var$equalSets(Bi, e) {
  if (Bi.size !== e.size) return !1;
  for (let qi of Bi)
    if (!e.has(qi)) return !1;
  return !0;
}
function $7af3f5b51489e0b5$export$253fe78d46329472(Bi) {
  let { selectionMode: e = "none", disallowEmptySelection: qi = !1, allowDuplicateSelectionEvents: Xi, selectionBehavior: Qi = "toggle", disabledBehavior: ta = "all" } = Bi, ra = useRef(!1), [, na] = useState(!1), la = useRef(null), Ma = useRef(null), [, Va] = useState(null), to = useMemo(() => $7af3f5b51489e0b5$var$convertSelection(Bi.selectedKeys), [
    Bi.selectedKeys
  ]), Eo = useMemo(() => $7af3f5b51489e0b5$var$convertSelection(Bi.defaultSelectedKeys, new $e40ea825a81a3709$export$52baac22726c72bf()), [
    Bi.defaultSelectedKeys
  ]), [So, eo] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(to, Eo, Bi.onSelectionChange), rs = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), [ko, Hs] = useState(Qi);
  Qi === "replace" && ko === "toggle" && typeof So == "object" && So.size === 0 && Hs("replace");
  let Ks = useRef(Qi);
  return useEffect(() => {
    Qi !== Ks.current && (Hs(Qi), Ks.current = Qi);
  }, [
    Qi
  ]), {
    selectionMode: e,
    disallowEmptySelection: qi,
    selectionBehavior: ko,
    setSelectionBehavior: Hs,
    get isFocused() {
      return ra.current;
    },
    setFocused(Ys) {
      ra.current = Ys, na(Ys);
    },
    get focusedKey() {
      return la.current;
    },
    get childFocusStrategy() {
      return Ma.current;
    },
    setFocusedKey(Ys, Xs = "first") {
      la.current = Ys, Ma.current = Xs, Va(Ys);
    },
    selectedKeys: So,
    setSelectedKeys(Ys) {
      (Xi || !$7af3f5b51489e0b5$var$equalSets(Ys, So)) && eo(Ys);
    },
    disabledKeys: rs,
    disabledBehavior: ta
  };
}
function $7af3f5b51489e0b5$var$convertSelection(Bi, e) {
  return Bi ? Bi === "all" ? "all" : new $e40ea825a81a3709$export$52baac22726c72bf(Bi) : e;
}
class $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(e) {
    this.state.setSelectionBehavior(e);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(e) {
    this.state.setFocused(e);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(e, qi) {
    (e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, qi);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(e) {
    if (this.state.selectionMode === "none") return !1;
    let qi = this.getKey(e);
    return qi == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(qi) : this.state.selectedKeys.has(qi);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let e = this.getSelectAllKeys(), qi = this.state.selectedKeys;
    return this._isSelectAll = e.every((Xi) => qi.has(Xi)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let e = null;
    for (let Xi of this.state.selectedKeys) {
      let Qi = this.collection.getItem(Xi);
      (!e || Qi && $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, Qi, e) < 0) && (e = Qi);
    }
    var qi;
    return (qi = e?.key) !== null && qi !== void 0 ? qi : null;
  }
  get lastSelectedKey() {
    let e = null;
    for (let Xi of this.state.selectedKeys) {
      let Qi = this.collection.getItem(Xi);
      (!e || Qi && $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, Qi, e) > 0) && (e = Qi);
    }
    var qi;
    return (qi = e?.key) !== null && qi !== void 0 ? qi : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(e);
      return;
    }
    let qi = this.getKey(e);
    if (qi == null) return;
    let Xi;
    if (this.state.selectedKeys === "all") Xi = new $e40ea825a81a3709$export$52baac22726c72bf([
      qi
    ], qi, qi);
    else {
      let ra = this.state.selectedKeys;
      var Qi;
      let na = (Qi = ra.anchorKey) !== null && Qi !== void 0 ? Qi : qi;
      Xi = new $e40ea825a81a3709$export$52baac22726c72bf(ra, na, qi);
      var ta;
      for (let la of this.getKeyRange(na, (ta = ra.currentKey) !== null && ta !== void 0 ? ta : qi)) Xi.delete(la);
      for (let la of this.getKeyRange(qi, na)) this.canSelectItem(la) && Xi.add(la);
    }
    this.state.setSelectedKeys(Xi);
  }
  getKeyRange(e, qi) {
    let Xi = this.collection.getItem(e), Qi = this.collection.getItem(qi);
    return Xi && Qi ? $c5a24bc478652b5f$export$8c434b3a7a4dad6(this.collection, Xi, Qi) <= 0 ? this.getKeyRangeInternal(e, qi) : this.getKeyRangeInternal(qi, e) : [];
  }
  getKeyRangeInternal(e, qi) {
    var Xi;
    if (!((Xi = this.layoutDelegate) === null || Xi === void 0) && Xi.getKeyRange) return this.layoutDelegate.getKeyRange(e, qi);
    let Qi = [], ta = e;
    for (; ta != null; ) {
      let ra = this.collection.getItem(ta);
      if (ra && (ra.type === "item" || ra.type === "cell" && this.allowsCellSelection) && Qi.push(ta), ta === qi) return Qi;
      ta = this.collection.getKeyAfter(ta);
    }
    return [];
  }
  getKey(e) {
    let qi = this.collection.getItem(e);
    if (!qi || qi.type === "cell" && this.allowsCellSelection) return e;
    for (; qi && qi.type !== "item" && qi.parentKey != null; ) qi = this.collection.getItem(qi.parentKey);
    return !qi || qi.type !== "item" ? null : qi.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(e) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(e)) {
      this.replaceSelection(e);
      return;
    }
    let qi = this.getKey(e);
    if (qi == null) return;
    let Xi = new $e40ea825a81a3709$export$52baac22726c72bf(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    Xi.has(qi) ? Xi.delete(qi) : this.canSelectItem(qi) && (Xi.add(qi), Xi.anchorKey = qi, Xi.currentKey = qi), !(this.disallowEmptySelection && Xi.size === 0) && this.state.setSelectedKeys(Xi);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(e) {
    if (this.selectionMode === "none") return;
    let qi = this.getKey(e);
    if (qi == null) return;
    let Xi = this.canSelectItem(qi) ? new $e40ea825a81a3709$export$52baac22726c72bf([
      qi
    ], qi, qi) : new $e40ea825a81a3709$export$52baac22726c72bf();
    this.state.setSelectedKeys(Xi);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(e) {
    if (this.selectionMode === "none") return;
    let qi = new $e40ea825a81a3709$export$52baac22726c72bf();
    for (let Xi of e) {
      let Qi = this.getKey(Xi);
      if (Qi != null && (qi.add(Qi), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(qi);
  }
  getSelectAllKeys() {
    let e = [], qi = (Xi) => {
      for (; Xi != null; ) {
        if (this.canSelectItem(Xi)) {
          var Qi;
          let ra = this.collection.getItem(Xi);
          ra?.type === "item" && e.push(Xi);
          var ta;
          ra?.hasChildNodes && (this.allowsCellSelection || ra.type !== "item") && qi((ta = (Qi = $c5a24bc478652b5f$export$fbdeaa6a76694f71($c5a24bc478652b5f$export$1005530eda016c13(ra, this.collection))) === null || Qi === void 0 ? void 0 : Qi.key) !== null && ta !== void 0 ? ta : null);
        }
        Xi = this.collection.getKeyAfter(Xi);
      }
    };
    return qi(this.collection.getFirstKey()), e;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new $e40ea825a81a3709$export$52baac22726c72bf());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(e, qi) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || qi && (qi.pointerType === "touch" || qi.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(e) {
    if (e === this.state.selectedKeys) return !0;
    let qi = this.selectedKeys;
    if (e.size !== qi.size) return !1;
    for (let Xi of e)
      if (!qi.has(Xi)) return !1;
    for (let Xi of qi)
      if (!e.has(Xi)) return !1;
    return !0;
  }
  canSelectItem(e) {
    var qi;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
    let Xi = this.collection.getItem(e);
    return !(!Xi || !(Xi == null || (qi = Xi.props) === null || qi === void 0) && qi.isDisabled || Xi.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(e) {
    var qi, Xi;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!(!((Xi = this.collection.getItem(e)) === null || Xi === void 0 || (qi = Xi.props) === null || qi === void 0) && qi.isDisabled));
  }
  isLink(e) {
    var qi, Xi;
    return !!(!((Xi = this.collection.getItem(e)) === null || Xi === void 0 || (qi = Xi.props) === null || qi === void 0) && qi.href);
  }
  getItemProps(e) {
    var qi;
    return (qi = this.collection.getItem(e)) === null || qi === void 0 ? void 0 : qi.props;
  }
  constructor(e, qi, Xi) {
    this.collection = e, this.state = qi;
    var Qi;
    this.allowsCellSelection = (Qi = Xi?.allowsCellSelection) !== null && Qi !== void 0 ? Qi : !1, this._isSelectAll = null, this.layoutDelegate = Xi?.layoutDelegate || null;
  }
}
function $e72dd72e1c76a225$export$2f645645f7bca764(Bi) {
  let { filter: e, layoutDelegate: qi } = Bi, Xi = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), Qi = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), ta = useCallback((Va) => e ? new $a02d57049d202695$export$d085fb9e920b5ca7(e(Va)) : new $a02d57049d202695$export$d085fb9e920b5ca7(Va), [
    e
  ]), ra = useMemo(() => ({
    suppressTextValueWarning: Bi.suppressTextValueWarning
  }), [
    Bi.suppressTextValueWarning
  ]), na = $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, ta, ra), la = useMemo(() => new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(na, Xi, {
    layoutDelegate: qi
  }), [
    na,
    Xi,
    qi
  ]);
  const Ma = useRef(null);
  return useEffect(() => {
    if (Xi.focusedKey != null && !na.getItem(Xi.focusedKey) && Ma.current) {
      const Hs = Ma.current.getItem(Xi.focusedKey), Ks = [
        ...Ma.current.getKeys()
      ].map((ls) => {
        const ks = Ma.current.getItem(ls);
        return ks?.type === "item" ? ks : null;
      }).filter((ls) => ls !== null), Ys = [
        ...na.getKeys()
      ].map((ls) => {
        const ks = na.getItem(ls);
        return ks?.type === "item" ? ks : null;
      }).filter((ls) => ls !== null);
      var Va, to;
      const Xs = ((Va = Ks?.length) !== null && Va !== void 0 ? Va : 0) - ((to = Ys?.length) !== null && to !== void 0 ? to : 0);
      var Eo, So, eo;
      let Cs = Math.min(Xs > 1 ? Math.max(((Eo = Hs?.index) !== null && Eo !== void 0 ? Eo : 0) - Xs + 1, 0) : (So = Hs?.index) !== null && So !== void 0 ? So : 0, ((eo = Ys?.length) !== null && eo !== void 0 ? eo : 0) - 1), Fs = null, ws = !1;
      for (; Cs >= 0; ) {
        if (!la.isDisabled(Ys[Cs].key)) {
          Fs = Ys[Cs];
          break;
        }
        if (Cs < Ys.length - 1 && !ws) Cs++;
        else {
          ws = !0;
          var rs, ko;
          Cs > ((rs = Hs?.index) !== null && rs !== void 0 ? rs : 0) && (Cs = (ko = Hs?.index) !== null && ko !== void 0 ? ko : 0), Cs--;
        }
      }
      Xi.setFocusedKey(Fs ? Fs.key : null);
    }
    Ma.current = na;
  }, [
    na,
    la,
    Xi,
    Xi.focusedKey
  ]), {
    collection: na,
    disabledKeys: Qi,
    selectionManager: la
  };
}
function $a0d645289fe9b86b$export$e7f05e985daf4b5f(Bi) {
  var e;
  let [qi, Xi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.selectedKey, (e = Bi.defaultSelectedKey) !== null && e !== void 0 ? e : null, Bi.onSelectionChange), Qi = useMemo(() => qi != null ? [
    qi
  ] : [], [
    qi
  ]), { collection: ta, disabledKeys: ra, selectionManager: na } = $e72dd72e1c76a225$export$2f645645f7bca764({
    ...Bi,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: Qi,
    onSelectionChange: (Ma) => {
      if (Ma === "all") return;
      var Va;
      let to = (Va = Ma.values().next().value) !== null && Va !== void 0 ? Va : null;
      to === qi && Bi.onSelectionChange && Bi.onSelectionChange(to), Xi(to);
    }
  }), la = qi != null ? ta.getItem(qi) : null;
  return {
    collection: ta,
    disabledKeys: ra,
    selectionManager: na,
    selectedKey: qi,
    setSelectedKey: Xi,
    selectedItem: la
  };
}
function $fc909762b330b746$export$61c6a8c84e605fb6(Bi) {
  let [e, qi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.isOpen, Bi.defaultOpen || !1, Bi.onOpenChange);
  const Xi = useCallback(() => {
    qi(!0);
  }, [
    qi
  ]), Qi = useCallback(() => {
    qi(!1);
  }, [
    qi
  ]), ta = useCallback(() => {
    qi(!e);
  }, [
    qi,
    e
  ]);
  return {
    isOpen: e,
    setOpen: qi,
    open: Xi,
    close: Qi,
    toggle: ta
  };
}
function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(Bi) {
  let e = $fc909762b330b746$export$61c6a8c84e605fb6(Bi), [qi, Xi] = useState(null), [Qi, ta] = useState([]), ra = () => {
    ta([]), e.close();
  };
  return {
    focusStrategy: qi,
    ...e,
    open(Ma = null) {
      Xi(Ma), e.open();
    },
    toggle(Ma = null) {
      Xi(Ma), e.toggle();
    },
    close() {
      ra();
    },
    expandedKeysStack: Qi,
    openSubmenu: (Ma, Va) => {
      ta((to) => Va > to.length ? to : [
        ...to.slice(0, Va),
        Ma
      ]);
    },
    closeSubmenu: (Ma, Va) => {
      ta((to) => to[Va] === Ma ? to.slice(0, Va) : to);
    }
  };
}
function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(Bi) {
  let e = $fc909762b330b746$export$61c6a8c84e605fb6(Bi), [qi, Xi] = useState(null), Qi = $a0d645289fe9b86b$export$e7f05e985daf4b5f({
    ...Bi,
    onSelectionChange: (la) => {
      Bi.onSelectionChange != null && Bi.onSelectionChange(la), e.close(), ta.commitValidation();
    }
  }), ta = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...Bi,
    value: Qi.selectedKey
  }), [ra, na] = useState(!1);
  return {
    ...ta,
    ...Qi,
    ...e,
    focusStrategy: qi,
    open(la = null) {
      Qi.collection.size !== 0 && (Xi(la), e.open());
    },
    toggle(la = null) {
      Qi.collection.size !== 0 && (Xi(la), e.toggle());
    },
    isFocused: ra,
    setFocused: na
  };
}
class $05ca4cd7c4a5a999$export$863faf230ee2118a {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(e) {
    let qi = this.keyMap.get(e);
    var Xi;
    return qi && (Xi = qi.prevKey) !== null && Xi !== void 0 ? Xi : null;
  }
  getKeyAfter(e) {
    let qi = this.keyMap.get(e);
    var Xi;
    return qi && (Xi = qi.nextKey) !== null && Xi !== void 0 ? Xi : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(e) {
    var qi;
    return (qi = this.keyMap.get(e)) !== null && qi !== void 0 ? qi : null;
  }
  at(e) {
    const qi = [
      ...this.getKeys()
    ];
    return this.getItem(qi[e]);
  }
  constructor(e, { expandedKeys: qi } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e, qi = qi || /* @__PURE__ */ new Set();
    let Xi = (na) => {
      if (this.keyMap.set(na.key, na), na.childNodes && (na.type === "section" || qi.has(na.key))) for (let la of na.childNodes) Xi(la);
    };
    for (let na of e) Xi(na);
    let Qi = null, ta = 0;
    for (let [na, la] of this.keyMap)
      Qi ? (Qi.nextKey = na, la.prevKey = Qi.key) : (this.firstKey = na, la.prevKey = void 0), la.type === "item" && (la.index = ta++), Qi = la, Qi.nextKey = void 0;
    var ra;
    this.lastKey = (ra = Qi?.key) !== null && ra !== void 0 ? ra : null;
  }
}
function $875d6693e12af071$export$728d6ba534403756(Bi) {
  let { onExpandedChange: e } = Bi, [qi, Xi] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(Bi.expandedKeys ? new Set(Bi.expandedKeys) : void 0, Bi.defaultExpandedKeys ? new Set(Bi.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e), Qi = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), ta = useMemo(() => Bi.disabledKeys ? new Set(Bi.disabledKeys) : /* @__PURE__ */ new Set(), [
    Bi.disabledKeys
  ]), ra = $7613b1592d41b092$export$6cd28814d92fa9c9(Bi, useCallback((la) => new $05ca4cd7c4a5a999$export$863faf230ee2118a(la, {
    expandedKeys: qi
  }), [
    qi
  ]), null);
  return useEffect(() => {
    Qi.focusedKey != null && !ra.getItem(Qi.focusedKey) && Qi.setFocusedKey(null);
  }, [
    ra,
    Qi.focusedKey
  ]), {
    collection: ra,
    expandedKeys: qi,
    disabledKeys: ta,
    toggleKey: (la) => {
      Xi($875d6693e12af071$var$toggleKey(qi, la));
    },
    setExpandedKeys: Xi,
    selectionManager: new $d496c0a20b6e58ec$export$6c8a5aaad13c9852(ra, Qi)
  };
}
function $875d6693e12af071$var$toggleKey(Bi, e) {
  let qi = new Set(Bi);
  return qi.has(e) ? qi.delete(e) : qi.add(e), qi;
}
const $d3e0e05bdfcf66bd$export$c24727297075ec6a = /* @__PURE__ */ createContext(null), $3985021b0ad6602f$export$37fb8590cf2c088c = /* @__PURE__ */ createContext({});
let $3985021b0ad6602f$var$filterHoverProps = (Bi) => {
  let { onHoverStart: e, onHoverChange: qi, onHoverEnd: Xi, ...Qi } = Bi;
  return Qi;
};
const $3985021b0ad6602f$export$f5b8910cec6cf069 = /* @__PURE__ */ $f39a9eba43920ace$export$86427a43e3e48ebb(function(e, qi) {
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $3985021b0ad6602f$export$37fb8590cf2c088c);
  let { hoverProps: Xi, isHovered: Qi } = $6179b936705e76d3$export$ae780daf29e6d456(e), { isFocused: ta, isFocusVisible: ra, focusProps: na } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), la = !!e["aria-invalid"] && e["aria-invalid"] !== "false", Ma = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    values: {
      isHovered: Qi,
      isFocused: ta,
      isFocusVisible: ra,
      isDisabled: e.disabled || !1,
      isInvalid: la
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ a__default.createElement("input", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928($3985021b0ad6602f$var$filterHoverProps(e), na, Xi),
    ...Ma,
    ref: qi,
    "data-focused": ta || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": Qi || void 0,
    "data-focus-visible": ra || void 0,
    "data-invalid": la || void 0
  });
}), $d2f53cda644affe3$export$65d2a03b8800d6e3 = /* @__PURE__ */ createContext(null), $7135fc7d473fd974$export$d40e14dec8b060a8 = /* @__PURE__ */ createContext(null), $7135fc7d473fd974$export$a164736487e3f0ae = {
  CollectionRoot({ collection: Bi, renderDropIndicator: e }) {
    return $7135fc7d473fd974$var$useCollectionRender(Bi, null, e);
  },
  CollectionBranch({ collection: Bi, parent: e, renderDropIndicator: qi }) {
    return $7135fc7d473fd974$var$useCollectionRender(Bi, e, qi);
  }
};
function $7135fc7d473fd974$var$useCollectionRender(Bi, e, qi) {
  return $e948873055cbafe4$export$727c8fc270210f13({
    items: e ? Bi.getChildren(e.key) : Bi,
    dependencies: [
      qi
    ],
    children(Xi) {
      var Qi;
      let ta = Xi.render(Xi);
      if (!qi || Xi.type !== "item") return ta;
      let ra = Xi.key, na = Bi.getKeyAfter(ra);
      return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, qi({
        type: "item",
        key: ra,
        dropPosition: "before"
      }), ta, (na == null || ((Qi = Bi.getItem(na)) === null || Qi === void 0 ? void 0 : Qi.type) !== "item") && qi({
        type: "item",
        key: ra,
        dropPosition: "after"
      }));
    }
  });
}
const $7135fc7d473fd974$export$4feb769f8ddf26c5 = /* @__PURE__ */ createContext($7135fc7d473fd974$export$a164736487e3f0ae);
function $7135fc7d473fd974$export$90e00781bc59d8f9(Bi) {
  return useMemo(() => Bi != null ? /* @__PURE__ */ new Set([
    Bi
  ]) : null, [
    Bi
  ]);
}
const $612b8eb6cb90e02d$export$d188a835a7bc5783 = /* @__PURE__ */ createContext({}), $612b8eb6cb90e02d$export$f55761759794cf55 = /* @__PURE__ */ createContext(null), $612b8eb6cb90e02d$export$62ed72bc21f6b8a6 = /* @__PURE__ */ forwardRef(function(e, qi) {
  let { render: Xi } = useContext($612b8eb6cb90e02d$export$f55761759794cf55);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, Xi(e, qi));
});
function $612b8eb6cb90e02d$export$971707d8a129a1f7(Bi, e) {
  var qi;
  let Xi = Bi?.renderDropIndicator, Qi = Bi == null || (qi = Bi.isVirtualDragging) === null || qi === void 0 ? void 0 : qi.call(Bi), ta = useCallback((ra) => {
    if (Qi || e?.isDropTarget(ra)) return Xi ? Xi(ra) : /* @__PURE__ */ a__default.createElement($612b8eb6cb90e02d$export$62ed72bc21f6b8a6, {
      target: ra
    });
  }, [
    e?.target,
    Qi,
    Xi
  ]);
  return Bi?.useDropIndicator ? ta : void 0;
}
function $612b8eb6cb90e02d$export$d1e8e3fbb7461f6(Bi, e, qi) {
  var Xi, Qi;
  let ta = Bi.focusedKey, ra = null;
  if (!(e == null || (Xi = e.isVirtualDragging) === null || Xi === void 0) && Xi.call(e) && (qi == null || (Qi = qi.target) === null || Qi === void 0 ? void 0 : Qi.type) === "item") {
    ra = qi.target.key;
    var na;
    qi.target.dropPosition === "after" && (ra = (na = qi.collection.getKeyAfter(ra)) !== null && na !== void 0 ? na : ra);
  }
  return useMemo(() => new Set([
    ta,
    ra
  ].filter((la) => la != null)), [
    ta,
    ra
  ]);
}
const $72a5793c14baf454$export$e0e4026c12a8bdbb = /* @__PURE__ */ createContext({}), $431f98aba6844401$export$6615d83f6de245ce = /* @__PURE__ */ createContext({}), $eed445e0843c11d0$export$7ff8f37d2d81a48d = /* @__PURE__ */ createContext(null), $eed445e0843c11d0$export$7c5906fe4f1f2af2 = /* @__PURE__ */ createContext(null), $eed445e0843c11d0$export$41f133550aa26f48 = /* @__PURE__ */ forwardRef(function(e, qi) {
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $eed445e0843c11d0$export$7ff8f37d2d81a48d);
  let Xi = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2);
  return Xi ? /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxInner, {
    state: Xi,
    props: e,
    listBoxRef: qi
  }) : /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$fb8073518f34e6ec, e)
  }, (Qi) => /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$StandaloneListBox, {
    props: e,
    listBoxRef: qi,
    collection: Qi
  }));
});
function $eed445e0843c11d0$var$StandaloneListBox({ props: Bi, listBoxRef: e, collection: qi }) {
  Bi = {
    ...Bi,
    collection: qi,
    children: null,
    items: null
  };
  let { layoutDelegate: Xi } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), { filterFn: Qi, collectionProps: ta, collectionRef: ra } = useContext($d2f53cda644affe3$export$65d2a03b8800d6e3) || {};
  e = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(e, ra !== void 0 ? ra : null), [
    ra,
    e
  ]));
  let na = useMemo(() => Qi ? qi.filter(Qi) : qi, [
    qi,
    Qi
  ]), la = $e72dd72e1c76a225$export$2f645645f7bca764({
    ...Bi,
    collection: na,
    layoutDelegate: Xi
  });
  return /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxInner, {
    state: la,
    props: {
      ...Bi,
      ...ta
    },
    listBoxRef: e
  });
}
function $eed445e0843c11d0$var$ListBoxInner({ state: Bi, props: e, listBoxRef: qi }) {
  let { dragAndDropHooks: Xi, layout: Qi = "stack", orientation: ta = "vertical" } = e, { collection: ra, selectionManager: na } = Bi, la = !!Xi?.useDraggableCollectionState, Ma = !!Xi?.useDroppableCollectionState, { direction: Va } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), { disabledBehavior: to, disabledKeys: Eo } = na, So = $325a3faab7a68acd$export$a16aca283550c30d({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: eo, layoutDelegate: rs, dropTargetDelegate: ko, CollectionRoot: Hs } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), Ks = useMemo(() => e.keyboardDelegate || new $2a25aae57d74318e$export$a05409b8bb224a5a({
    collection: ra,
    collator: So,
    ref: qi,
    disabledKeys: Eo,
    disabledBehavior: to,
    layout: Qi,
    orientation: ta,
    direction: Va,
    layoutDelegate: rs
  }), [
    ra,
    So,
    qi,
    to,
    Eo,
    ta,
    Va,
    e.keyboardDelegate,
    Qi,
    rs
  ]), { listBoxProps: Ys } = $c132121280ec012d$export$50eacbbf140a3141({
    ...e,
    shouldSelectOnPressUp: la || e.shouldSelectOnPressUp,
    keyboardDelegate: Ks,
    isVirtualized: eo
  }, Bi, qi), Xs = useRef(la), Cs = useRef(Ma);
  useEffect(() => {
    Xs.current !== la && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), Cs.current !== Ma && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.");
  }, [
    la,
    Ma
  ]);
  let Fs, ws, ls, ks = !1, Js = null, pl = useRef(null);
  if (la && Xi) {
    Fs = Xi.useDraggableCollectionState({
      collection: ra,
      selectionManager: na,
      preview: Xi.renderDragPreview ? pl : void 0
    }), Xi.useDraggableCollection({}, Fs, qi);
    let kl = Xi.DragPreview;
    Js = Xi.renderDragPreview ? /* @__PURE__ */ a__default.createElement(kl, {
      ref: pl
    }, Xi.renderDragPreview) : null;
  }
  if (Ma && Xi) {
    ws = Xi.useDroppableCollectionState({
      collection: ra,
      selectionManager: na
    });
    let kl = Xi.dropTargetDelegate || ko || new Xi.ListDropTargetDelegate(ra, qi, {
      orientation: ta,
      layout: Qi,
      direction: Va
    });
    ls = Xi.useDroppableCollection({
      keyboardDelegate: Ks,
      dropTargetDelegate: kl
    }, ws, qi), ks = ws.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: _l, isFocused: bl, isFocusVisible: xl } = $f7dceffc5ad7768b$export$4e328f61c538687f(), Rl = {
    isDropTarget: ks,
    isEmpty: Bi.collection.size === 0,
    isFocused: bl,
    isFocusVisible: xl,
    layout: e.layout || "stack",
    state: Bi
  }, Cl = $64fa3d84918910a7$export$4d86445c2cf5e3({
    className: e.className,
    style: e.style,
    defaultClassName: "react-aria-ListBox",
    values: Rl
  }), Dl = null;
  return Bi.collection.size === 0 && e.renderEmptyState && (Dl = /* @__PURE__ */ a__default.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState(Rl))), /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ a__default.createElement("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(e),
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(Ys, _l, ls?.collectionProps),
    ...Cl,
    ref: qi,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-drop-target": ks || void 0,
    "data-empty": Bi.collection.size === 0 || void 0,
    "data-focused": bl || void 0,
    "data-focus-visible": xl || void 0,
    "data-layout": e.layout || "stack",
    "data-orientation": e.orientation || "vertical"
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $eed445e0843c11d0$export$7ff8f37d2d81a48d,
        e
      ],
      [
        $eed445e0843c11d0$export$7c5906fe4f1f2af2,
        Bi
      ],
      [
        $612b8eb6cb90e02d$export$d188a835a7bc5783,
        {
          dragAndDropHooks: Xi,
          dragState: Fs,
          dropState: ws
        }
      ],
      [
        $431f98aba6844401$export$6615d83f6de245ce,
        {
          elementType: "div"
        }
      ],
      [
        $612b8eb6cb90e02d$export$f55761759794cf55,
        {
          render: $eed445e0843c11d0$var$ListBoxDropIndicatorWrapper
        }
      ],
      [
        $7135fc7d473fd974$export$d40e14dec8b060a8,
        {
          name: "ListBoxSection",
          render: $eed445e0843c11d0$var$ListBoxSectionInner
        }
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(Hs, {
    collection: ra,
    scrollRef: qi,
    persistedKeys: $612b8eb6cb90e02d$export$d1e8e3fbb7461f6(na, Xi, ws),
    renderDropIndicator: $612b8eb6cb90e02d$export$971707d8a129a1f7(Xi, ws)
  })), Dl, Js));
}
function $eed445e0843c11d0$var$ListBoxSectionInner(Bi, e, qi, Xi = "react-aria-ListBoxSection") {
  let Qi = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2), { dragAndDropHooks: ta, dropState: ra } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { CollectionBranch: na } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), [la, Ma] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8();
  var Va;
  let { headingProps: to, groupProps: Eo } = $af383d3bef1cfdc9$export$c3f9f39876e4bc7({
    heading: Ma,
    "aria-label": (Va = Bi["aria-label"]) !== null && Va !== void 0 ? Va : void 0
  }), So = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: Xi,
    className: Bi.className,
    style: Bi.style,
    values: {}
  });
  return /* @__PURE__ */ a__default.createElement("section", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...Eo,
    ...So,
    ref: e
  }, /* @__PURE__ */ a__default.createElement($72a5793c14baf454$export$e0e4026c12a8bdbb.Provider, {
    value: {
      ...to,
      ref: la
    }
  }, /* @__PURE__ */ a__default.createElement(na, {
    collection: Qi.collection,
    parent: qi,
    renderDropIndicator: $612b8eb6cb90e02d$export$971707d8a129a1f7(ta, ra)
  })));
}
const $eed445e0843c11d0$export$a11e76429ed99b4 = /* @__PURE__ */ $e1995378a142960e$export$18af5c7a9e9b3664("item", function(e, qi, Xi) {
  let Qi = $df56164dff5785e2$export$4338b53315abf666(qi), ta = useContext($eed445e0843c11d0$export$7c5906fe4f1f2af2), { dragAndDropHooks: ra, dragState: na, dropState: la } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { optionProps: Ma, labelProps: Va, descriptionProps: to, ...Eo } = $293f70390ea03370$export$497855f14858aa34({
    key: Xi.key,
    "aria-label": e?.["aria-label"]
  }, ta, Qi), { hoverProps: So, isHovered: eo } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: !Eo.allowsSelection && !Eo.hasAction,
    onHoverStart: Xi.props.onHoverStart,
    onHoverChange: Xi.props.onHoverChange,
    onHoverEnd: Xi.props.onHoverEnd
  }), rs = null;
  na && ra && (rs = ra.useDraggableItem({
    key: Xi.key
  }, na));
  let ko = null;
  la && ra && (ko = ra.useDroppableItem({
    target: {
      type: "item",
      key: Xi.key,
      dropPosition: "on"
    }
  }, la, Qi));
  let Hs = na && na.isDragging(Xi.key), Ks = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    id: void 0,
    children: e.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...Eo,
      isHovered: eo,
      selectionMode: ta.selectionManager.selectionMode,
      selectionBehavior: ta.selectionManager.selectionBehavior,
      allowsDragging: !!na,
      isDragging: Hs,
      isDropTarget: ko?.isDropTarget
    }
  });
  useEffect(() => {
    Xi.textValue || console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    Xi.textValue
  ]);
  let Ys = e.href ? "a" : "div";
  return /* @__PURE__ */ a__default.createElement(Ys, {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(Ma, So, rs?.dragProps, ko?.dropProps),
    ...Ks,
    ref: Qi,
    "data-allows-dragging": !!na || void 0,
    "data-selected": Eo.isSelected || void 0,
    "data-disabled": Eo.isDisabled || void 0,
    "data-hovered": eo || void 0,
    "data-focused": Eo.isFocused || void 0,
    "data-focus-visible": Eo.isFocusVisible || void 0,
    "data-pressed": Eo.isPressed || void 0,
    "data-dragging": Hs || void 0,
    "data-drop-target": ko?.isDropTarget || void 0,
    "data-selection-mode": ta.selectionManager.selectionMode === "none" ? void 0 : ta.selectionManager.selectionMode
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            label: Va,
            description: to
          }
        }
      ]
    ]
  }, Ks.children));
});
function $eed445e0843c11d0$var$ListBoxDropIndicatorWrapper(Bi, e) {
  e = $df56164dff5785e2$export$4338b53315abf666(e);
  let { dragAndDropHooks: qi, dropState: Xi } = useContext($612b8eb6cb90e02d$export$d188a835a7bc5783), { dropIndicatorProps: Qi, isHidden: ta, isDropTarget: ra } = qi.useDropIndicator(Bi, Xi, e);
  return ta ? null : /* @__PURE__ */ a__default.createElement($eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef, {
    ...Bi,
    dropIndicatorProps: Qi,
    isDropTarget: ra,
    ref: e
  });
}
function $eed445e0843c11d0$var$ListBoxDropIndicator(Bi, e) {
  let { dropIndicatorProps: qi, isDropTarget: Xi, ...Qi } = Bi, ta = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Qi,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: Xi
    }
  });
  return /* @__PURE__ */ a__default.createElement("div", {
    ...qi,
    ...ta,
    // eslint-disable-next-line
    role: "option",
    ref: e,
    "data-drop-target": Xi || void 0
  });
}
const $eed445e0843c11d0$var$ListBoxDropIndicatorForwardRef = /* @__PURE__ */ forwardRef($eed445e0843c11d0$var$ListBoxDropIndicator), $44f671af83e7d9e0$export$2de4954e8ae13b9f = /* @__PURE__ */ createContext({
  placement: "bottom"
}), $07b14b47974efb58$export$9b9a0cd73afb7ca4 = /* @__PURE__ */ createContext(null), $07b14b47974efb58$export$5b6b19405a83ff9d = /* @__PURE__ */ forwardRef(function(e, qi) {
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $07b14b47974efb58$export$9b9a0cd73afb7ca4);
  let Xi = useContext($de32f1b87079253c$export$d2f961adcb0afbe), Qi = $fc909762b330b746$export$61c6a8c84e605fb6(e), ta = e.isOpen != null || e.defaultOpen != null || !Xi ? Qi : Xi, ra = $d3f049242431219c$export$45fda7c47f93fd48(qi, ta.isOpen) || e.isExiting || !1;
  if ($f39a9eba43920ace$export$b5d7cc18bb8d2b59()) {
    let la = e.children;
    return typeof la == "function" && (la = la({
      trigger: e.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, la);
  }
  return ta && !ta.isOpen && !ra ? null : /* @__PURE__ */ a__default.createElement($07b14b47974efb58$var$PopoverInner, {
    ...e,
    triggerRef: e.triggerRef,
    state: ta,
    popoverRef: qi,
    isExiting: ra
  });
});
function $07b14b47974efb58$var$PopoverInner({ state: Bi, isExiting: e, UNSTABLE_portalContainer: qi, ...Xi }) {
  let Qi = useRef(null), [ta, ra] = useState(0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    Qi.current && Bi.isOpen && ra(Qi.current.getBoundingClientRect().width);
  }, [
    Bi.isOpen,
    Qi
  ]);
  var na;
  let { popoverProps: la, underlayProps: Ma, arrowProps: Va, placement: to } = $f2f8a6077418541e$export$542a6fd13ac93354({
    ...Xi,
    offset: (na = Xi.offset) !== null && na !== void 0 ? na : 8,
    arrowSize: ta
  }, Bi), Eo = Xi.popoverRef, So = $d3f049242431219c$export$6d3443f2c48bfc20(Eo, !!to) || Xi.isEntering || !1, eo = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Xi,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: Xi.trigger || null,
      placement: to,
      isEntering: So,
      isExiting: e
    }
  }), rs = {
    ...la.style,
    ...eo.style
  };
  return /* @__PURE__ */ a__default.createElement($337b884510726a0d$export$c6fdb837b070b4ff, {
    ...Xi,
    isExiting: e,
    portalContainer: qi
  }, !Xi.isNonModal && Bi.isOpen && /* @__PURE__ */ a__default.createElement("div", {
    "data-testid": "underlay",
    ...Ma,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ a__default.createElement("div", {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928($65484d02dcb7eb3e$export$457c3d6518dd4c6f(Xi), la),
    ...eo,
    ref: Eo,
    slot: Xi.slot || void 0,
    style: rs,
    "data-trigger": Xi.trigger,
    "data-placement": to,
    "data-entering": So || void 0,
    "data-exiting": e || void 0
  }, !Xi.isNonModal && /* @__PURE__ */ a__default.createElement($86ea4cb521eb2e37$export$2317d149ed6f78c4, {
    onDismiss: Bi.close
  }), /* @__PURE__ */ a__default.createElement($44f671af83e7d9e0$export$2de4954e8ae13b9f.Provider, {
    value: {
      ...Va,
      placement: to,
      ref: Qi
    }
  }, eo.children), /* @__PURE__ */ a__default.createElement($86ea4cb521eb2e37$export$2317d149ed6f78c4, {
    onDismiss: Bi.close
  })));
}
const $63df2425e2108aa8$export$744d98a3b8a94e1c = /* @__PURE__ */ createContext({}), $3674c52c6b3c5bce$export$c7e742effb1c51e2 = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$24aad8519b95b41b = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$795aec4671cbae19 = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$var$SelectionManagerContext = /* @__PURE__ */ createContext(null);
function $3674c52c6b3c5bce$export$27d2ad3c5815583e(Bi) {
  let e = $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(Bi), qi = useRef(null), { menuTriggerProps: Xi, menuProps: Qi } = $168583247155ddda$export$dc9c12ed27dd1b49({
    ...Bi,
    type: "menu"
  }, e, qi), [ta, ra] = useState(null), na = useCallback(() => {
    qi.current && ra(qi.current.offsetWidth + "px");
  }, [
    qi
  ]);
  $9daab02d461809db$export$683480f191c0e3ea({
    ref: qi,
    onResize: na
  });
  let la = useRef(null);
  return /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $3674c52c6b3c5bce$export$c7e742effb1c51e2,
        {
          ...Qi,
          ref: la
        }
      ],
      [
        $de32f1b87079253c$export$d2f961adcb0afbe,
        e
      ],
      [
        $3674c52c6b3c5bce$export$795aec4671cbae19,
        e
      ],
      [
        $07b14b47974efb58$export$9b9a0cd73afb7ca4,
        {
          trigger: "MenuTrigger",
          triggerRef: qi,
          scrollRef: la,
          placement: "bottom start",
          style: {
            "--trigger-width": ta
          }
        }
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$3351871ee4b288b8, {
    ...Xi,
    ref: qi,
    isPressed: e.isOpen
  }, Bi.children));
}
const $3674c52c6b3c5bce$var$SubmenuTriggerContext = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$d9b273488cd8ce6f = /* @__PURE__ */ forwardRef(function(e, qi) {
  return [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $3674c52c6b3c5bce$export$c7e742effb1c51e2), /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$fb8073518f34e6ec, e)
  }, (Xi) => Xi.size > 0 && /* @__PURE__ */ a__default.createElement($3674c52c6b3c5bce$var$MenuInner, {
    props: e,
    collection: Xi,
    menuRef: qi
  }));
});
function $3674c52c6b3c5bce$var$MenuInner({ props: Bi, collection: e, menuRef: qi }) {
  let { filterFn: Xi, collectionProps: Qi, collectionRef: ta } = useContext($d2f53cda644affe3$export$65d2a03b8800d6e3) || {};
  qi = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(qi, ta !== void 0 ? ta : null), [
    ta,
    qi
  ]));
  let ra = useMemo(() => Xi ? e.filter(Xi) : e, [
    e,
    Xi
  ]), na = $875d6693e12af071$export$728d6ba534403756({
    ...Bi,
    collection: ra,
    children: void 0
  }), la = useContext($3674c52c6b3c5bce$export$795aec4671cbae19), { isVirtualized: Ma, CollectionRoot: Va } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), { menuProps: to } = $d5336fe17ce95402$export$38eaa17faae8f579({
    ...Bi,
    ...Qi,
    isVirtualized: Ma,
    onClose: Bi.onClose || la?.close
  }, na, qi), Eo = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: "react-aria-Menu",
    className: Bi.className,
    style: Bi.style,
    values: {}
  });
  return /* @__PURE__ */ a__default.createElement($9bf71ea28793e738$export$20e40289641fbbb6, null, /* @__PURE__ */ a__default.createElement("div", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...to,
    ...Eo,
    ref: qi,
    slot: Bi.slot || void 0,
    onScroll: Bi.onScroll
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $3674c52c6b3c5bce$export$24aad8519b95b41b,
        na
      ],
      [
        $431f98aba6844401$export$6615d83f6de245ce,
        {
          elementType: "div"
        }
      ],
      [
        $7135fc7d473fd974$export$d40e14dec8b060a8,
        {
          name: "MenuSection",
          render: $3674c52c6b3c5bce$var$MenuSectionInner
        }
      ],
      [
        $3674c52c6b3c5bce$var$SubmenuTriggerContext,
        {
          parentMenuRef: qi
        }
      ],
      [
        $3674c52c6b3c5bce$var$MenuItemContext,
        null
      ],
      [
        $3674c52c6b3c5bce$var$SelectionManagerContext,
        na.selectionManager
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(Va, {
    collection: na.collection,
    persistedKeys: $7135fc7d473fd974$export$90e00781bc59d8f9(na.selectionManager.focusedKey),
    scrollRef: qi
  }))));
}
class $3674c52c6b3c5bce$var$GroupSelectionManager extends $d496c0a20b6e58ec$export$6c8a5aaad13c9852 {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(e, qi) {
    return this.parent.setFocusedKey(e, qi);
  }
  setFocused(e) {
    this.parent.setFocused(e);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(e, qi) {
    super(e.collection, qi), this.parent = e;
  }
}
function $3674c52c6b3c5bce$var$MenuSectionInner(Bi, e, qi, Xi = "react-aria-MenuSection") {
  var Qi, ta;
  let ra = useContext($3674c52c6b3c5bce$export$24aad8519b95b41b), { CollectionBranch: na } = useContext($7135fc7d473fd974$export$4feb769f8ddf26c5), [la, Ma] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8();
  var Va;
  let { headingProps: to, groupProps: Eo } = $3e5eb2498db5b506$export$73f7a44322579622({
    heading: Ma,
    "aria-label": (Va = qi.props["aria-label"]) !== null && Va !== void 0 ? Va : void 0
  }), So = $64fa3d84918910a7$export$4d86445c2cf5e3({
    defaultClassName: Xi,
    className: (Qi = qi.props) === null || Qi === void 0 ? void 0 : Qi.className,
    style: (ta = qi.props) === null || ta === void 0 ? void 0 : ta.style,
    values: {}
  }), eo = useContext($3674c52c6b3c5bce$var$SelectionManagerContext), rs = $7af3f5b51489e0b5$export$253fe78d46329472(Bi), ko = Bi.selectionMode != null ? new $3674c52c6b3c5bce$var$GroupSelectionManager(eo, rs) : eo;
  return /* @__PURE__ */ a__default.createElement("section", {
    ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi),
    ...Eo,
    ...So,
    ref: e
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $72a5793c14baf454$export$e0e4026c12a8bdbb,
        {
          ...to,
          ref: la
        }
      ],
      [
        $3674c52c6b3c5bce$var$SelectionManagerContext,
        ko
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement(na, {
    collection: ra.collection,
    parent: qi
  })));
}
const $3674c52c6b3c5bce$var$MenuItemContext = /* @__PURE__ */ createContext(null), $3674c52c6b3c5bce$export$2ce376c2cc3355c8 = /* @__PURE__ */ $e1995378a142960e$export$18af5c7a9e9b3664("item", function(e, qi, Xi) {
  var Qi;
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $3674c52c6b3c5bce$var$MenuItemContext);
  let ta = (Qi = $64fa3d84918910a7$export$fabf2dc03a41866e($3674c52c6b3c5bce$var$MenuItemContext)) === null || Qi === void 0 ? void 0 : Qi.id, ra = useContext($3674c52c6b3c5bce$export$24aad8519b95b41b), na = $df56164dff5785e2$export$4338b53315abf666(qi), la = useContext($3674c52c6b3c5bce$var$SelectionManagerContext), { menuItemProps: Ma, labelProps: Va, descriptionProps: to, keyboardShortcutProps: Eo, ...So } = $a2e5df62f93c7633$export$9d32628fc2aea7da({
    ...e,
    id: ta,
    key: Xi.key,
    selectionManager: la
  }, ra, na), { isFocusVisible: eo, focusProps: rs } = $f7dceffc5ad7768b$export$4e328f61c538687f(), { hoverProps: ko, isHovered: Hs } = $6179b936705e76d3$export$ae780daf29e6d456({
    isDisabled: So.isDisabled
  }), Ks = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...e,
    id: void 0,
    children: Xi.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...So,
      isHovered: Hs,
      isFocusVisible: eo,
      selectionMode: la.selectionMode,
      selectionBehavior: la.selectionBehavior,
      hasSubmenu: !!e["aria-haspopup"],
      isOpen: e["aria-expanded"] === "true"
    }
  }), Ys = e.href ? "a" : "div";
  return /* @__PURE__ */ a__default.createElement(Ys, {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(Ma, rs, ko),
    ...Ks,
    ref: na,
    "data-disabled": So.isDisabled || void 0,
    "data-hovered": Hs || void 0,
    "data-focused": So.isFocused || void 0,
    "data-focus-visible": eo || void 0,
    "data-pressed": So.isPressed || void 0,
    "data-selected": So.isSelected || void 0,
    "data-selection-mode": la.selectionMode === "none" ? void 0 : la.selectionMode,
    "data-has-submenu": !!e["aria-haspopup"] || void 0,
    "data-open": e["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            label: Va,
            description: to
          }
        }
      ],
      [
        $63df2425e2108aa8$export$744d98a3b8a94e1c,
        Eo
      ]
    ]
  }, Ks.children));
}), $de32f1b87079253c$export$d2f961adcb0afbe = /* @__PURE__ */ createContext(null), $1e2864c73f66a4da$export$6fb4a10d2c950550 = /* @__PURE__ */ forwardRef(function(e, qi) {
  let { onSelect: Xi, acceptedFileTypes: Qi, allowsMultiple: ta, defaultCamera: ra, children: na, acceptDirectory: la, ...Ma } = e, Va = $df56164dff5785e2$export$4338b53315abf666(qi), to = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Ma);
  return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement($f1ab8c75478c6f73$export$3351871ee4b288b8, {
    onPress: () => {
      var Eo, So;
      !((Eo = Va.current) === null || Eo === void 0) && Eo.value && (Va.current.value = ""), (So = Va.current) === null || So === void 0 || So.click();
    }
  }, na), /* @__PURE__ */ a__default.createElement($3985021b0ad6602f$export$f5b8910cec6cf069, {
    ...to,
    type: "file",
    ref: Va,
    style: {
      display: "none"
    },
    accept: Qi?.toString(),
    onChange: (Eo) => Xi?.(Eo.target.files),
    capture: ra,
    multiple: ta,
    // @ts-expect-error
    webkitdirectory: la ? "" : void 0
  }));
}), $82d7e5349645de74$export$7540cee5be7dc19b = /* @__PURE__ */ createContext(null), $82d7e5349645de74$export$ef445b55be0601bd = /* @__PURE__ */ createContext(null), $82d7e5349645de74$export$ef9b1a59e592288f = /* @__PURE__ */ forwardRef(function(e, qi) {
  [e, qi] = $64fa3d84918910a7$export$29f1550f4b0d4415(e, qi, $82d7e5349645de74$export$7540cee5be7dc19b);
  let { children: Xi, isDisabled: Qi = !1, isInvalid: ta = !1, isRequired: ra = !1 } = e, na = useMemo(() => typeof Xi == "function" ? Xi({
    isOpen: !1,
    isDisabled: Qi,
    isInvalid: ta,
    isRequired: ra,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : Xi, [
    Xi,
    Qi,
    ta,
    ra
  ]);
  return /* @__PURE__ */ a__default.createElement($e1995378a142960e$export$bf788dd355e3a401, {
    content: na
  }, (la) => /* @__PURE__ */ a__default.createElement($82d7e5349645de74$var$SelectInner, {
    props: e,
    collection: la,
    selectRef: qi
  }));
});
function $82d7e5349645de74$var$SelectInner({ props: Bi, selectRef: e, collection: qi }) {
  let { validationBehavior: Xi } = $64fa3d84918910a7$export$fabf2dc03a41866e($d3e0e05bdfcf66bd$export$c24727297075ec6a) || {};
  var Qi, ta;
  let ra = (ta = (Qi = Bi.validationBehavior) !== null && Qi !== void 0 ? Qi : Xi) !== null && ta !== void 0 ? ta : "native", na = $2bc3a590c5373a4e$export$5159ec8b34d4ec12({
    ...Bi,
    collection: qi,
    children: void 0,
    validationBehavior: ra
  }), { isFocusVisible: la, focusProps: Ma } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    within: !0
  }), Va = useRef(null), [to, Eo] = $64fa3d84918910a7$export$9d4c57ee4c6ffdd8(), { labelProps: So, triggerProps: eo, valueProps: rs, menuProps: ko, descriptionProps: Hs, errorMessageProps: Ks, ...Ys } = $58aed456727eb0f3$export$e64b2f635402ca43({
    ...$64fa3d84918910a7$export$ef03459518577ad4(Bi),
    label: Eo,
    validationBehavior: ra
  }, na, Va), [Xs, Cs] = useState(null), Fs = useCallback(() => {
    Va.current && Cs(Va.current.offsetWidth + "px");
  }, [
    Va
  ]);
  $9daab02d461809db$export$683480f191c0e3ea({
    ref: Va,
    onResize: Fs
  });
  let ws = useMemo(() => ({
    isOpen: na.isOpen,
    isFocused: na.isFocused,
    isFocusVisible: la,
    isDisabled: Bi.isDisabled || !1,
    isInvalid: Ys.isInvalid || !1,
    isRequired: Bi.isRequired || !1
  }), [
    na.isOpen,
    na.isFocused,
    la,
    Bi.isDisabled,
    Ys.isInvalid,
    Bi.isRequired
  ]), ls = $64fa3d84918910a7$export$4d86445c2cf5e3({
    ...Bi,
    values: ws,
    defaultClassName: "react-aria-Select"
  }), ks = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(Bi);
  delete ks.id;
  let Js = useRef(null);
  return /* @__PURE__ */ a__default.createElement($64fa3d84918910a7$export$2881499e37b75b9a, {
    values: [
      [
        $82d7e5349645de74$export$7540cee5be7dc19b,
        Bi
      ],
      [
        $82d7e5349645de74$export$ef445b55be0601bd,
        na
      ],
      [
        $82d7e5349645de74$export$f8f745c04421623f,
        rs
      ],
      [
        $01b77f81d0f07f68$export$75b6ee27786ba447,
        {
          ...So,
          ref: to,
          elementType: "span"
        }
      ],
      [
        $d2b4bc8c273e7be6$export$24d547caef80ccd1,
        {
          ...eo,
          ref: Va,
          isPressed: na.isOpen
        }
      ],
      [
        $de32f1b87079253c$export$d2f961adcb0afbe,
        na
      ],
      [
        $07b14b47974efb58$export$9b9a0cd73afb7ca4,
        {
          trigger: "Select",
          triggerRef: Va,
          scrollRef: Js,
          placement: "bottom start",
          style: {
            "--trigger-width": Xs
          }
        }
      ],
      [
        $eed445e0843c11d0$export$7ff8f37d2d81a48d,
        {
          ...ko,
          ref: Js
        }
      ],
      [
        $eed445e0843c11d0$export$7c5906fe4f1f2af2,
        na
      ],
      [
        $514c0188e459b4c0$export$9afb8bc826b033ea,
        {
          slots: {
            description: Hs,
            errorMessage: Ks
          }
        }
      ],
      [
        $ee014567cb39d3f0$export$ff05c3ac10437e03,
        Ys
      ]
    ]
  }, /* @__PURE__ */ a__default.createElement("div", {
    ...ks,
    ...ls,
    ...Ma,
    ref: e,
    slot: Bi.slot || void 0,
    "data-focused": na.isFocused || void 0,
    "data-focus-visible": la || void 0,
    "data-open": na.isOpen || void 0,
    "data-disabled": Bi.isDisabled || void 0,
    "data-invalid": Ys.isInvalid || void 0,
    "data-required": Bi.isRequired || void 0
  }), /* @__PURE__ */ a__default.createElement($bdd25dc72710631f$export$cbd84cdb2e668835, {
    autoComplete: Bi.autoComplete,
    state: na,
    triggerRef: Va,
    label: Eo,
    name: Bi.name,
    isDisabled: Bi.isDisabled
  }));
}
const $82d7e5349645de74$export$f8f745c04421623f = /* @__PURE__ */ createContext(null), Dropdown = ({
  options: Bi,
  onSelect: e,
  label: qi,
  className: Xi = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  $82d7e5349645de74$export$ef9b1a59e592288f,
  {
    className: Xi,
    onSelectionChange: (Qi) => {
      e(Qi);
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { "aria-hidden": "true", children: [
        qi && /* @__PURE__ */ jsxRuntimeExports.jsx($01b77f81d0f07f68$export$b04be29aa201d4f5, { children: qi }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { className: "px-2", icon: faChevronDown, size: "sm" })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx($07b14b47974efb58$export$5b6b19405a83ff9d, { className: "bg-white border border-black", children: /* @__PURE__ */ jsxRuntimeExports.jsx($eed445e0843c11d0$export$41f133550aa26f48, { children: Bi.map((Qi) => /* @__PURE__ */ jsxRuntimeExports.jsx($eed445e0843c11d0$export$a11e76429ed99b4, { id: Qi.id, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: Qi.label }) }, `dropdown-${Qi.id}`)) }) })
    ]
  }
), Field = forwardRef(({ className: Bi, ...e }, qi) => /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ref: qi, className: twMerge(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  Bi
), ...e })), Select = forwardRef(({ className: Bi, ...e }, qi) => /* @__PURE__ */ jsxRuntimeExports.jsx("select", { ref: qi, ...e, className: twMerge("bg-neutral-200 rounded-md p-2 block h-auto", Bi) })), DynamicFormInput = forwardRef(({ field: Bi, onChange: e, other: qi, ...Xi }, Qi) => {
  const [ta, ra] = useState(!1);
  switch (Bi.type) {
    case "textarea":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "textarea",
        {
          ref: Qi,
          onChange: e,
          ...Xi
        }
      );
    case "select":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Select,
          {
            ref: Qi,
            required: !Bi.optional,
            onChange: (na) => {
              na.target.value === "other" ? ra(!0) : ra(!1), e && e(na);
            },
            ...Xi,
            children: [
              Bi.options.map((na, la) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: na, children: na }, la)),
              Bi?.allowOther && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        ta && qi?.()
      ] });
    case "submit":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          ref: Qi,
          onChange: e,
          ...Xi,
          type: "submit",
          children: Bi.text
        }
      );
    case "email":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          required: !Bi.optional,
          ref: Qi,
          onChange: e,
          type: "email",
          ...Xi
        }
      );
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Field,
        {
          required: !Bi.optional,
          ref: Qi,
          onChange: e,
          ...Xi
        }
      );
  }
}), ellispes = keyframes$2`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, Dot = styled.span`
  animation: ${ellispes} 3s linear infinite;
  animation-delay: ${({ index: Bi }) => Bi * 0.1}s;
`, Ellipses = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 0, children: "." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 1, children: "." }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Dot, { index: 2, children: "." })
] }), Error$1 = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { ...Bi, className: "text-red-500 text-sm" });
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    cd(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(qi) {
    return { hasError: !0 };
  }
  componentDidCatch(qi, Xi) {
    console.error("Uncaught error:", qi, Xi);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
var Re$2 = /* @__PURE__ */ ((Bi) => (Bi.ALL = "all", Bi.NONE = "none", Bi.FILE = "file", Bi.DIR = "dir", Bi.FILE_LIST = "file_list", Bi.DIR_LIST = "dir_list", Bi))(Re$2 || {}), b$2;
(function(Bi) {
  Bi.assertEqual = (Qi) => Qi;
  function e(Qi) {
  }
  Bi.assertIs = e;
  function qi(Qi) {
    throw new Error();
  }
  Bi.assertNever = qi, Bi.arrayToEnum = (Qi) => {
    const ta = {};
    for (const ra of Qi)
      ta[ra] = ra;
    return ta;
  }, Bi.getValidEnumValues = (Qi) => {
    const ta = Bi.objectKeys(Qi).filter((na) => typeof Qi[Qi[na]] != "number"), ra = {};
    for (const na of ta)
      ra[na] = Qi[na];
    return Bi.objectValues(ra);
  }, Bi.objectValues = (Qi) => Bi.objectKeys(Qi).map(function(ta) {
    return Qi[ta];
  }), Bi.objectKeys = typeof Object.keys == "function" ? (Qi) => Object.keys(Qi) : (Qi) => {
    const ta = [];
    for (const ra in Qi)
      Object.prototype.hasOwnProperty.call(Qi, ra) && ta.push(ra);
    return ta;
  }, Bi.find = (Qi, ta) => {
    for (const ra of Qi)
      if (ta(ra))
        return ra;
  }, Bi.isInteger = typeof Number.isInteger == "function" ? (Qi) => Number.isInteger(Qi) : (Qi) => typeof Qi == "number" && isFinite(Qi) && Math.floor(Qi) === Qi;
  function Xi(Qi, ta = " | ") {
    return Qi.map((ra) => typeof ra == "string" ? `'${ra}'` : ra).join(ta);
  }
  Bi.joinValues = Xi, Bi.jsonStringifyReplacer = (Qi, ta) => typeof ta == "bigint" ? ta.toString() : ta;
})(b$2 || (b$2 = {}));
var we;
(function(Bi) {
  Bi.mergeShapes = (e, qi) => ({
    ...e,
    ...qi
    // second overwrites first
  });
})(we || (we = {}));
const h$1 = b$2.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), N$2 = (Bi) => {
  switch (typeof Bi) {
    case "undefined":
      return h$1.undefined;
    case "string":
      return h$1.string;
    case "number":
      return isNaN(Bi) ? h$1.nan : h$1.number;
    case "boolean":
      return h$1.boolean;
    case "function":
      return h$1.function;
    case "bigint":
      return h$1.bigint;
    case "symbol":
      return h$1.symbol;
    case "object":
      return Array.isArray(Bi) ? h$1.array : Bi === null ? h$1.null : Bi.then && typeof Bi.then == "function" && Bi.catch && typeof Bi.catch == "function" ? h$1.promise : typeof Map < "u" && Bi instanceof Map ? h$1.map : typeof Set < "u" && Bi instanceof Set ? h$1.set : typeof Date < "u" && Bi instanceof Date ? h$1.date : h$1.object;
    default:
      return h$1.unknown;
  }
}, d$3 = b$2.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Be$2 = (Bi) => JSON.stringify(Bi, null, 2).replace(/"([^"]+)":/g, "$1:");
let S$1 = class xf extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (Xi) => {
      this.issues = [...this.issues, Xi];
    }, this.addIssues = (Xi = []) => {
      this.issues = [...this.issues, ...Xi];
    };
    const qi = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, qi) : this.__proto__ = qi, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const qi = e || function(ta) {
      return ta.message;
    }, Xi = { _errors: [] }, Qi = (ta) => {
      for (const ra of ta.issues)
        if (ra.code === "invalid_union")
          ra.unionErrors.map(Qi);
        else if (ra.code === "invalid_return_type")
          Qi(ra.returnTypeError);
        else if (ra.code === "invalid_arguments")
          Qi(ra.argumentsError);
        else if (ra.path.length === 0)
          Xi._errors.push(qi(ra));
        else {
          let na = Xi, la = 0;
          for (; la < ra.path.length; ) {
            const Ma = ra.path[la];
            la === ra.path.length - 1 ? (na[Ma] = na[Ma] || { _errors: [] }, na[Ma]._errors.push(qi(ra))) : na[Ma] = na[Ma] || { _errors: [] }, na = na[Ma], la++;
          }
        }
    };
    return Qi(this), Xi;
  }
  static assert(e) {
    if (!(e instanceof xf))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b$2.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (qi) => qi.message) {
    const qi = {}, Xi = [];
    for (const Qi of this.issues)
      Qi.path.length > 0 ? (qi[Qi.path[0]] = qi[Qi.path[0]] || [], qi[Qi.path[0]].push(e(Qi))) : Xi.push(e(Qi));
    return { formErrors: Xi, fieldErrors: qi };
  }
  get formErrors() {
    return this.flatten();
  }
};
S$1.create = (Bi) => new S$1(Bi);
const W$2 = (Bi, e) => {
  let qi;
  switch (Bi.code) {
    case d$3.invalid_type:
      Bi.received === h$1.undefined ? qi = "Required" : qi = `Expected ${Bi.expected}, received ${Bi.received}`;
      break;
    case d$3.invalid_literal:
      qi = `Invalid literal value, expected ${JSON.stringify(Bi.expected, b$2.jsonStringifyReplacer)}`;
      break;
    case d$3.unrecognized_keys:
      qi = `Unrecognized key(s) in object: ${b$2.joinValues(Bi.keys, ", ")}`;
      break;
    case d$3.invalid_union:
      qi = "Invalid input";
      break;
    case d$3.invalid_union_discriminator:
      qi = `Invalid discriminator value. Expected ${b$2.joinValues(Bi.options)}`;
      break;
    case d$3.invalid_enum_value:
      qi = `Invalid enum value. Expected ${b$2.joinValues(Bi.options)}, received '${Bi.received}'`;
      break;
    case d$3.invalid_arguments:
      qi = "Invalid function arguments";
      break;
    case d$3.invalid_return_type:
      qi = "Invalid function return type";
      break;
    case d$3.invalid_date:
      qi = "Invalid date";
      break;
    case d$3.invalid_string:
      typeof Bi.validation == "object" ? "includes" in Bi.validation ? (qi = `Invalid input: must include "${Bi.validation.includes}"`, typeof Bi.validation.position == "number" && (qi = `${qi} at one or more positions greater than or equal to ${Bi.validation.position}`)) : "startsWith" in Bi.validation ? qi = `Invalid input: must start with "${Bi.validation.startsWith}"` : "endsWith" in Bi.validation ? qi = `Invalid input: must end with "${Bi.validation.endsWith}"` : b$2.assertNever(Bi.validation) : Bi.validation !== "regex" ? qi = `Invalid ${Bi.validation}` : qi = "Invalid";
      break;
    case d$3.too_small:
      Bi.type === "array" ? qi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "more than"} ${Bi.minimum} element(s)` : Bi.type === "string" ? qi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "over"} ${Bi.minimum} character(s)` : Bi.type === "number" ? qi = `Number must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${Bi.minimum}` : Bi.type === "date" ? qi = `Date must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Bi.minimum))}` : qi = "Invalid input";
      break;
    case d$3.too_big:
      Bi.type === "array" ? qi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "less than"} ${Bi.maximum} element(s)` : Bi.type === "string" ? qi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "under"} ${Bi.maximum} character(s)` : Bi.type === "number" ? qi = `Number must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "bigint" ? qi = `BigInt must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "date" ? qi = `Date must be ${Bi.exact ? "exactly" : Bi.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Bi.maximum))}` : qi = "Invalid input";
      break;
    case d$3.custom:
      qi = "Invalid input";
      break;
    case d$3.invalid_intersection_types:
      qi = "Intersection results could not be merged";
      break;
    case d$3.not_multiple_of:
      qi = `Number must be a multiple of ${Bi.multipleOf}`;
      break;
    case d$3.not_finite:
      qi = "Number must be finite";
      break;
    default:
      qi = e.defaultError, b$2.assertNever(Bi);
  }
  return { message: qi };
};
let Ae$2 = W$2;
function qe$2(Bi) {
  Ae$2 = Bi;
}
function fe$2() {
  return Ae$2;
}
const he$2 = (Bi) => {
  const { data: e, path: qi, errorMaps: Xi, issueData: Qi } = Bi, ta = [...qi, ...Qi.path || []], ra = {
    ...Qi,
    path: ta
  };
  if (Qi.message !== void 0)
    return {
      ...Qi,
      path: ta,
      message: Qi.message
    };
  let na = "";
  const la = Xi.filter((Ma) => !!Ma).slice().reverse();
  for (const Ma of la)
    na = Ma(ra, { data: e, defaultError: na }).message;
  return {
    ...Qi,
    path: ta,
    message: na
  };
}, We$2 = [];
function u(Bi, e) {
  const qi = fe$2(), Xi = he$2({
    issueData: e,
    data: Bi.data,
    path: Bi.path,
    errorMaps: [
      Bi.common.contextualErrorMap,
      // contextual error map is first priority
      Bi.schemaErrorMap,
      // then schema-bound map if available
      qi,
      // then global override map
      qi === W$2 ? void 0 : W$2
      // then global default map
    ].filter((Qi) => !!Qi)
  });
  Bi.common.issues.push(Xi);
}
class k {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, qi) {
    const Xi = [];
    for (const Qi of qi) {
      if (Qi.status === "aborted")
        return y$3;
      Qi.status === "dirty" && e.dirty(), Xi.push(Qi.value);
    }
    return { status: e.value, value: Xi };
  }
  static async mergeObjectAsync(e, qi) {
    const Xi = [];
    for (const Qi of qi) {
      const ta = await Qi.key, ra = await Qi.value;
      Xi.push({
        key: ta,
        value: ra
      });
    }
    return k.mergeObjectSync(e, Xi);
  }
  static mergeObjectSync(e, qi) {
    const Xi = {};
    for (const Qi of qi) {
      const { key: ta, value: ra } = Qi;
      if (ta.status === "aborted" || ra.status === "aborted")
        return y$3;
      ta.status === "dirty" && e.dirty(), ra.status === "dirty" && e.dirty(), ta.value !== "__proto__" && (typeof ra.value < "u" || Qi.alwaysSet) && (Xi[ta.value] = ra.value);
    }
    return { status: e.value, value: Xi };
  }
}
const y$3 = Object.freeze({
  status: "aborted"
}), B$2 = (Bi) => ({ status: "dirty", value: Bi }), T$2 = (Bi) => ({ status: "valid", value: Bi }), Te$2 = (Bi) => Bi.status === "aborted", Se$2 = (Bi) => Bi.status === "dirty", V$1 = (Bi) => Bi.status === "valid", K$1 = (Bi) => typeof Promise < "u" && Bi instanceof Promise;
function pe$2(Bi, e, qi, Xi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(Bi);
}
function Ne$1(Bi, e, qi, Xi, Qi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(Bi, qi), qi;
}
var p$3;
(function(Bi) {
  Bi.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, Bi.toString = (e) => typeof e == "string" ? e : e?.message;
})(p$3 || (p$3 = {}));
var G$2, H$3;
let O$2 = class {
  constructor(e, qi, Xi, Qi) {
    this._cachedPath = [], this.parent = e, this.data = qi, this._path = Xi, this._key = Qi;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const Ee$2 = (Bi, e) => {
  if (V$1(e))
    return { success: !0, data: e.value };
  if (!Bi.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const qi = new S$1(Bi.common.issues);
      return this._error = qi, this._error;
    }
  };
};
function _(Bi) {
  if (!Bi)
    return {};
  const { errorMap: e, invalid_type_error: qi, required_error: Xi, description: Qi } = Bi;
  if (e && (qi || Xi))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: Qi } : { errorMap: (ta, ra) => {
    var na, la;
    const { message: Ma } = Bi;
    return ta.code === "invalid_enum_value" ? { message: Ma ?? ra.defaultError } : typeof ra.data > "u" ? { message: (na = Ma ?? Xi) !== null && na !== void 0 ? na : ra.defaultError } : ta.code !== "invalid_type" ? { message: ra.defaultError } : { message: (la = Ma ?? qi) !== null && la !== void 0 ? la : ra.defaultError };
  }, description: Qi };
}
class v {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return N$2(e.data);
  }
  _getOrReturnCtx(e, qi) {
    return qi || {
      common: e.parent.common,
      data: e.data,
      parsedType: N$2(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new k(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: N$2(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const qi = this._parse(e);
    if (K$1(qi))
      throw new Error("Synchronous parse encountered promise.");
    return qi;
  }
  _parseAsync(e) {
    const qi = this._parse(e);
    return Promise.resolve(qi);
  }
  parse(e, qi) {
    const Xi = this.safeParse(e, qi);
    if (Xi.success)
      return Xi.data;
    throw Xi.error;
  }
  safeParse(e, qi) {
    var Xi;
    const Qi = {
      common: {
        issues: [],
        async: (Xi = qi?.async) !== null && Xi !== void 0 ? Xi : !1,
        contextualErrorMap: qi?.errorMap
      },
      path: qi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$2(e)
    }, ta = this._parseSync({ data: e, path: Qi.path, parent: Qi });
    return Ee$2(Qi, ta);
  }
  "~validate"(e) {
    var qi, Xi;
    const Qi = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$2(e)
    };
    if (!this["~standard"].async)
      try {
        const ta = this._parseSync({ data: e, path: [], parent: Qi });
        return V$1(ta) ? {
          value: ta.value
        } : {
          issues: Qi.common.issues
        };
      } catch (ta) {
        !((Xi = (qi = ta?.message) === null || qi === void 0 ? void 0 : qi.toLowerCase()) === null || Xi === void 0) && Xi.includes("encountered") && (this["~standard"].async = !0), Qi.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: Qi }).then((ta) => V$1(ta) ? {
      value: ta.value
    } : {
      issues: Qi.common.issues
    });
  }
  async parseAsync(e, qi) {
    const Xi = await this.safeParseAsync(e, qi);
    if (Xi.success)
      return Xi.data;
    throw Xi.error;
  }
  async safeParseAsync(e, qi) {
    const Xi = {
      common: {
        issues: [],
        contextualErrorMap: qi?.errorMap,
        async: !0
      },
      path: qi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: N$2(e)
    }, Qi = this._parse({ data: e, path: Xi.path, parent: Xi }), ta = await (K$1(Qi) ? Qi : Promise.resolve(Qi));
    return Ee$2(Xi, ta);
  }
  refine(e, qi) {
    const Xi = (Qi) => typeof qi == "string" || typeof qi > "u" ? { message: qi } : typeof qi == "function" ? qi(Qi) : qi;
    return this._refinement((Qi, ta) => {
      const ra = e(Qi), na = () => ta.addIssue({
        code: d$3.custom,
        ...Xi(Qi)
      });
      return typeof Promise < "u" && ra instanceof Promise ? ra.then((la) => la ? !0 : (na(), !1)) : ra ? !0 : (na(), !1);
    });
  }
  refinement(e, qi) {
    return this._refinement((Xi, Qi) => e(Xi) ? !0 : (Qi.addIssue(typeof qi == "function" ? qi(Xi, Qi) : qi), !1));
  }
  _refinement(e) {
    return new E$2({
      schema: this,
      typeName: g$3.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (qi) => this["~validate"](qi)
    };
  }
  optional() {
    return j$2.create(this, this._def);
  }
  nullable() {
    return $$1.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Z$1.create(this);
  }
  promise() {
    return Y$2.create(this, this._def);
  }
  or(e) {
    return te$2.create([this, e], this._def);
  }
  and(e) {
    return re$2.create(this, e, this._def);
  }
  transform(e) {
    return new E$2({
      ..._(this._def),
      schema: this,
      typeName: g$3.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const qi = typeof e == "function" ? e : () => e;
    return new oe$2({
      ..._(this._def),
      innerType: this,
      defaultValue: qi,
      typeName: g$3.ZodDefault
    });
  }
  brand() {
    return new Ze$2({
      typeName: g$3.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const qi = typeof e == "function" ? e : () => e;
    return new ce$2({
      ..._(this._def),
      innerType: this,
      catchValue: qi,
      typeName: g$3.ZodCatch
    });
  }
  describe(e) {
    const qi = this.constructor;
    return new qi({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return le$1.create(this, e);
  }
  readonly() {
    return de$2.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Je$2 = /^c[^\s-]{8,}$/i, Ye$2 = /^[0-9a-z]+$/, Ge$2 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, He$2 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ke$2 = /^[a-z0-9_-]{21}$/i, Xe$2 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Qe$2 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, et$2 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, tt$1 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ke$1;
const rt$2 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, nt$1 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, st$2 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, at$1 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, it$2 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ot$2 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ie$2 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", ct$2 = new RegExp(`^${Ie$2}$`);
function Me$2(Bi) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Bi.precision ? e = `${e}\\.\\d{${Bi.precision}}` : Bi.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function dt$2(Bi) {
  return new RegExp(`^${Me$2(Bi)}$`);
}
function Pe$2(Bi) {
  let e = `${Ie$2}T${Me$2(Bi)}`;
  const qi = [];
  return qi.push(Bi.local ? "Z?" : "Z"), Bi.offset && qi.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${qi.join("|")})`, new RegExp(`^${e}$`);
}
function lt$2(Bi, e) {
  return !!((e === "v4" || !e) && rt$2.test(Bi) || (e === "v6" || !e) && st$2.test(Bi));
}
function ut$1(Bi, e) {
  if (!Xe$2.test(Bi))
    return !1;
  try {
    const [qi] = Bi.split("."), Xi = qi.replace(/-/g, "+").replace(/_/g, "/").padEnd(qi.length + (4 - qi.length % 4) % 4, "="), Qi = JSON.parse(atob(Xi));
    return !(typeof Qi != "object" || Qi === null || !Qi.typ || !Qi.alg || e && Qi.alg !== e);
  } catch {
    return !1;
  }
}
function ft$2(Bi, e) {
  return !!((e === "v4" || !e) && nt$1.test(Bi) || (e === "v6" || !e) && at$1.test(Bi));
}
let C$1 = class Nd extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== h$1.string) {
      const Qi = this._getOrReturnCtx(e);
      return u(Qi, {
        code: d$3.invalid_type,
        expected: h$1.string,
        received: Qi.parsedType
      }), y$3;
    }
    const qi = new k();
    let Xi;
    for (const Qi of this._def.checks)
      if (Qi.kind === "min")
        e.data.length < Qi.value && (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          code: d$3.too_small,
          minimum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "max")
        e.data.length > Qi.value && (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          code: d$3.too_big,
          maximum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "length") {
        const ta = e.data.length > Qi.value, ra = e.data.length < Qi.value;
        (ta || ra) && (Xi = this._getOrReturnCtx(e, Xi), ta ? u(Xi, {
          code: d$3.too_big,
          maximum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: Qi.message
        }) : ra && u(Xi, {
          code: d$3.too_small,
          minimum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: Qi.message
        }), qi.dirty());
      } else if (Qi.kind === "email")
        et$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "email",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "emoji")
        ke$1 || (ke$1 = new RegExp(tt$1, "u")), ke$1.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "emoji",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "uuid")
        He$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "uuid",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "nanoid")
        Ke$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "nanoid",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "cuid")
        Je$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "cuid",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "cuid2")
        Ye$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "cuid2",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "ulid")
        Ge$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
          validation: "ulid",
          code: d$3.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "url")
        try {
          new URL(e.data);
        } catch {
          Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
            validation: "url",
            code: d$3.invalid_string,
            message: Qi.message
          }), qi.dirty();
        }
      else Qi.kind === "regex" ? (Qi.regex.lastIndex = 0, Qi.regex.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "regex",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty())) : Qi.kind === "trim" ? e.data = e.data.trim() : Qi.kind === "includes" ? e.data.includes(Qi.value, Qi.position) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.invalid_string,
        validation: { includes: Qi.value, position: Qi.position },
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : Qi.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : Qi.kind === "startsWith" ? e.data.startsWith(Qi.value) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.invalid_string,
        validation: { startsWith: Qi.value },
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "endsWith" ? e.data.endsWith(Qi.value) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.invalid_string,
        validation: { endsWith: Qi.value },
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "datetime" ? Pe$2(Qi).test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.invalid_string,
        validation: "datetime",
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "date" ? ct$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.invalid_string,
        validation: "date",
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "time" ? dt$2(Qi).test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.invalid_string,
        validation: "time",
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "duration" ? Qe$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "duration",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "ip" ? lt$2(e.data, Qi.version) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "ip",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "jwt" ? ut$1(e.data, Qi.alg) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "jwt",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "cidr" ? ft$2(e.data, Qi.version) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "cidr",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "base64" ? it$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "base64",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "base64url" ? ot$2.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        validation: "base64url",
        code: d$3.invalid_string,
        message: Qi.message
      }), qi.dirty()) : b$2.assertNever(Qi);
    return { status: qi.value, value: e.data };
  }
  _regex(e, qi, Xi) {
    return this.refinement((Qi) => e.test(Qi), {
      validation: qi,
      code: d$3.invalid_string,
      ...p$3.errToObj(Xi)
    });
  }
  _addCheck(e) {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p$3.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p$3.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p$3.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p$3.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...p$3.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p$3.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p$3.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p$3.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...p$3.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...p$3.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...p$3.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p$3.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...p$3.errToObj(e) });
  }
  datetime(e) {
    var qi, Xi;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (qi = e?.offset) !== null && qi !== void 0 ? qi : !1,
      local: (Xi = e?.local) !== null && Xi !== void 0 ? Xi : !1,
      ...p$3.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...p$3.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...p$3.errToObj(e) });
  }
  regex(e, qi) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p$3.errToObj(qi)
    });
  }
  includes(e, qi) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: qi?.position,
      ...p$3.errToObj(qi?.message)
    });
  }
  startsWith(e, qi) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p$3.errToObj(qi)
    });
  }
  endsWith(e, qi) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p$3.errToObj(qi)
    });
  }
  min(e, qi) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p$3.errToObj(qi)
    });
  }
  max(e, qi) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p$3.errToObj(qi)
    });
  }
  length(e, qi) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p$3.errToObj(qi)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, p$3.errToObj(e));
  }
  trim() {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Nd({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e;
  }
};
C$1.create = (Bi) => {
  var e;
  return new C$1({
    checks: [],
    typeName: g$3.ZodString,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(Bi)
  });
};
function ht$2(Bi, e) {
  const qi = (Bi.toString().split(".")[1] || "").length, Xi = (e.toString().split(".")[1] || "").length, Qi = qi > Xi ? qi : Xi, ta = parseInt(Bi.toFixed(Qi).replace(".", "")), ra = parseInt(e.toFixed(Qi).replace(".", ""));
  return ta % ra / Math.pow(10, Qi);
}
let M$2 = class Zd extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== h$1.number) {
      const Qi = this._getOrReturnCtx(e);
      return u(Qi, {
        code: d$3.invalid_type,
        expected: h$1.number,
        received: Qi.parsedType
      }), y$3;
    }
    let qi;
    const Xi = new k();
    for (const Qi of this._def.checks)
      Qi.kind === "int" ? b$2.isInteger(e.data) || (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.invalid_type,
        expected: "integer",
        received: "float",
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "min" ? (Qi.inclusive ? e.data < Qi.value : e.data <= Qi.value) && (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.too_small,
        minimum: Qi.value,
        type: "number",
        inclusive: Qi.inclusive,
        exact: !1,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "max" ? (Qi.inclusive ? e.data > Qi.value : e.data >= Qi.value) && (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.too_big,
        maximum: Qi.value,
        type: "number",
        inclusive: Qi.inclusive,
        exact: !1,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "multipleOf" ? ht$2(e.data, Qi.value) !== 0 && (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.not_multiple_of,
        multipleOf: Qi.value,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "finite" ? Number.isFinite(e.data) || (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.not_finite,
        message: Qi.message
      }), Xi.dirty()) : b$2.assertNever(Qi);
    return { status: Xi.value, value: e.data };
  }
  gte(e, qi) {
    return this.setLimit("min", e, !0, p$3.toString(qi));
  }
  gt(e, qi) {
    return this.setLimit("min", e, !1, p$3.toString(qi));
  }
  lte(e, qi) {
    return this.setLimit("max", e, !0, p$3.toString(qi));
  }
  lt(e, qi) {
    return this.setLimit("max", e, !1, p$3.toString(qi));
  }
  setLimit(e, qi, Xi, Qi) {
    return new Zd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: qi,
          inclusive: Xi,
          message: p$3.toString(Qi)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Zd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p$3.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  multipleOf(e, qi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p$3.toString(qi)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p$3.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p$3.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p$3.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && b$2.isInteger(e.value));
  }
  get isFinite() {
    let e = null, qi = null;
    for (const Xi of this._def.checks) {
      if (Xi.kind === "finite" || Xi.kind === "int" || Xi.kind === "multipleOf")
        return !0;
      Xi.kind === "min" ? (qi === null || Xi.value > qi) && (qi = Xi.value) : Xi.kind === "max" && (e === null || Xi.value < e) && (e = Xi.value);
    }
    return Number.isFinite(qi) && Number.isFinite(e);
  }
};
M$2.create = (Bi) => new M$2({
  checks: [],
  typeName: g$3.ZodNumber,
  coerce: Bi?.coerce || !1,
  ..._(Bi)
});
let P$2 = class Xd extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== h$1.bigint)
      return this._getInvalidInput(e);
    let qi;
    const Xi = new k();
    for (const Qi of this._def.checks)
      Qi.kind === "min" ? (Qi.inclusive ? e.data < Qi.value : e.data <= Qi.value) && (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.too_small,
        type: "bigint",
        minimum: Qi.value,
        inclusive: Qi.inclusive,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "max" ? (Qi.inclusive ? e.data > Qi.value : e.data >= Qi.value) && (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.too_big,
        type: "bigint",
        maximum: Qi.value,
        inclusive: Qi.inclusive,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "multipleOf" ? e.data % Qi.value !== BigInt(0) && (qi = this._getOrReturnCtx(e, qi), u(qi, {
        code: d$3.not_multiple_of,
        multipleOf: Qi.value,
        message: Qi.message
      }), Xi.dirty()) : b$2.assertNever(Qi);
    return { status: Xi.value, value: e.data };
  }
  _getInvalidInput(e) {
    const qi = this._getOrReturnCtx(e);
    return u(qi, {
      code: d$3.invalid_type,
      expected: h$1.bigint,
      received: qi.parsedType
    }), y$3;
  }
  gte(e, qi) {
    return this.setLimit("min", e, !0, p$3.toString(qi));
  }
  gt(e, qi) {
    return this.setLimit("min", e, !1, p$3.toString(qi));
  }
  lte(e, qi) {
    return this.setLimit("max", e, !0, p$3.toString(qi));
  }
  lt(e, qi) {
    return this.setLimit("max", e, !1, p$3.toString(qi));
  }
  setLimit(e, qi, Xi, Qi) {
    return new Xd({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: qi,
          inclusive: Xi,
          message: p$3.toString(Qi)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Xd({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p$3.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p$3.toString(e)
    });
  }
  multipleOf(e, qi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p$3.toString(qi)
    });
  }
  get minValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e;
  }
};
P$2.create = (Bi) => {
  var e;
  return new P$2({
    checks: [],
    typeName: g$3.ZodBigInt,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ..._(Bi)
  });
};
let X$2 = class extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== h$1.boolean) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.boolean,
        received: qi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
X$2.create = (Bi) => new X$2({
  typeName: g$3.ZodBoolean,
  coerce: Bi?.coerce || !1,
  ..._(Bi)
});
let z$2 = class Ef extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== h$1.date) {
      const Qi = this._getOrReturnCtx(e);
      return u(Qi, {
        code: d$3.invalid_type,
        expected: h$1.date,
        received: Qi.parsedType
      }), y$3;
    }
    if (isNaN(e.data.getTime())) {
      const Qi = this._getOrReturnCtx(e);
      return u(Qi, {
        code: d$3.invalid_date
      }), y$3;
    }
    const qi = new k();
    let Xi;
    for (const Qi of this._def.checks)
      Qi.kind === "min" ? e.data.getTime() < Qi.value && (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.too_small,
        message: Qi.message,
        inclusive: !0,
        exact: !1,
        minimum: Qi.value,
        type: "date"
      }), qi.dirty()) : Qi.kind === "max" ? e.data.getTime() > Qi.value && (Xi = this._getOrReturnCtx(e, Xi), u(Xi, {
        code: d$3.too_big,
        message: Qi.message,
        inclusive: !0,
        exact: !1,
        maximum: Qi.value,
        type: "date"
      }), qi.dirty()) : b$2.assertNever(Qi);
    return {
      status: qi.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ef({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, qi) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p$3.toString(qi)
    });
  }
  max(e, qi) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p$3.toString(qi)
    });
  }
  get minDate() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e != null ? new Date(e) : null;
  }
};
z$2.create = (Bi) => new z$2({
  checks: [],
  coerce: Bi?.coerce || !1,
  typeName: g$3.ZodDate,
  ..._(Bi)
});
let me$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== h$1.symbol) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.symbol,
        received: qi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
me$2.create = (Bi) => new me$2({
  typeName: g$3.ZodSymbol,
  ..._(Bi)
});
let Q$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== h$1.undefined) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.undefined,
        received: qi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
Q$2.create = (Bi) => new Q$2({
  typeName: g$3.ZodUndefined,
  ..._(Bi)
});
let ee$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== h$1.null) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.null,
        received: qi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ee$2.create = (Bi) => new ee$2({
  typeName: g$3.ZodNull,
  ..._(Bi)
});
let J$1 = class extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return T$2(e.data);
  }
};
J$1.create = (Bi) => new J$1({
  typeName: g$3.ZodAny,
  ..._(Bi)
});
let L$2 = class extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return T$2(e.data);
  }
};
L$2.create = (Bi) => new L$2({
  typeName: g$3.ZodUnknown,
  ..._(Bi)
});
let I$2 = class extends v {
  _parse(e) {
    const qi = this._getOrReturnCtx(e);
    return u(qi, {
      code: d$3.invalid_type,
      expected: h$1.never,
      received: qi.parsedType
    }), y$3;
  }
};
I$2.create = (Bi) => new I$2({
  typeName: g$3.ZodNever,
  ..._(Bi)
});
let ge$2 = class extends v {
  _parse(e) {
    if (this._getType(e) !== h$1.undefined) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.void,
        received: qi.parsedType
      }), y$3;
    }
    return T$2(e.data);
  }
};
ge$2.create = (Bi) => new ge$2({
  typeName: g$3.ZodVoid,
  ..._(Bi)
});
let Z$1 = class Bd extends v {
  _parse(e) {
    const { ctx: qi, status: Xi } = this._processInputParams(e), Qi = this._def;
    if (qi.parsedType !== h$1.array)
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.array,
        received: qi.parsedType
      }), y$3;
    if (Qi.exactLength !== null) {
      const ra = qi.data.length > Qi.exactLength.value, na = qi.data.length < Qi.exactLength.value;
      (ra || na) && (u(qi, {
        code: ra ? d$3.too_big : d$3.too_small,
        minimum: na ? Qi.exactLength.value : void 0,
        maximum: ra ? Qi.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: Qi.exactLength.message
      }), Xi.dirty());
    }
    if (Qi.minLength !== null && qi.data.length < Qi.minLength.value && (u(qi, {
      code: d$3.too_small,
      minimum: Qi.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: Qi.minLength.message
    }), Xi.dirty()), Qi.maxLength !== null && qi.data.length > Qi.maxLength.value && (u(qi, {
      code: d$3.too_big,
      maximum: Qi.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: Qi.maxLength.message
    }), Xi.dirty()), qi.common.async)
      return Promise.all([...qi.data].map((ra, na) => Qi.type._parseAsync(new O$2(qi, ra, qi.path, na)))).then((ra) => k.mergeArray(Xi, ra));
    const ta = [...qi.data].map((ra, na) => Qi.type._parseSync(new O$2(qi, ra, qi.path, na)));
    return k.mergeArray(Xi, ta);
  }
  get element() {
    return this._def.type;
  }
  min(e, qi) {
    return new Bd({
      ...this._def,
      minLength: { value: e, message: p$3.toString(qi) }
    });
  }
  max(e, qi) {
    return new Bd({
      ...this._def,
      maxLength: { value: e, message: p$3.toString(qi) }
    });
  }
  length(e, qi) {
    return new Bd({
      ...this._def,
      exactLength: { value: e, message: p$3.toString(qi) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
Z$1.create = (Bi, e) => new Z$1({
  type: Bi,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: g$3.ZodArray,
  ..._(e)
});
function U$1(Bi) {
  if (Bi instanceof x$2) {
    const e = {};
    for (const qi in Bi.shape) {
      const Xi = Bi.shape[qi];
      e[qi] = j$2.create(U$1(Xi));
    }
    return new x$2({
      ...Bi._def,
      shape: () => e
    });
  } else return Bi instanceof Z$1 ? new Z$1({
    ...Bi._def,
    type: U$1(Bi.element)
  }) : Bi instanceof j$2 ? j$2.create(U$1(Bi.unwrap())) : Bi instanceof $$1 ? $$1.create(U$1(Bi.unwrap())) : Bi instanceof R$2 ? R$2.create(Bi.items.map((e) => U$1(e))) : Bi;
}
let x$2 = class Sd extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), qi = b$2.objectKeys(e);
    return this._cached = { shape: e, keys: qi };
  }
  _parse(e) {
    if (this._getType(e) !== h$1.object) {
      const la = this._getOrReturnCtx(e);
      return u(la, {
        code: d$3.invalid_type,
        expected: h$1.object,
        received: la.parsedType
      }), y$3;
    }
    const { status: qi, ctx: Xi } = this._processInputParams(e), { shape: Qi, keys: ta } = this._getCached(), ra = [];
    if (!(this._def.catchall instanceof I$2 && this._def.unknownKeys === "strip"))
      for (const la in Xi.data)
        ta.includes(la) || ra.push(la);
    const na = [];
    for (const la of ta) {
      const Ma = Qi[la], Va = Xi.data[la];
      na.push({
        key: { status: "valid", value: la },
        value: Ma._parse(new O$2(Xi, Va, Xi.path, la)),
        alwaysSet: la in Xi.data
      });
    }
    if (this._def.catchall instanceof I$2) {
      const la = this._def.unknownKeys;
      if (la === "passthrough")
        for (const Ma of ra)
          na.push({
            key: { status: "valid", value: Ma },
            value: { status: "valid", value: Xi.data[Ma] }
          });
      else if (la === "strict")
        ra.length > 0 && (u(Xi, {
          code: d$3.unrecognized_keys,
          keys: ra
        }), qi.dirty());
      else if (la !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const la = this._def.catchall;
      for (const Ma of ra) {
        const Va = Xi.data[Ma];
        na.push({
          key: { status: "valid", value: Ma },
          value: la._parse(
            new O$2(Xi, Va, Xi.path, Ma)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: Ma in Xi.data
        });
      }
    }
    return Xi.common.async ? Promise.resolve().then(async () => {
      const la = [];
      for (const Ma of na) {
        const Va = await Ma.key, to = await Ma.value;
        la.push({
          key: Va,
          value: to,
          alwaysSet: Ma.alwaysSet
        });
      }
      return la;
    }).then((la) => k.mergeObjectSync(qi, la)) : k.mergeObjectSync(qi, na);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p$3.errToObj, new Sd({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (qi, Xi) => {
          var Qi, ta, ra, na;
          const la = (ra = (ta = (Qi = this._def).errorMap) === null || ta === void 0 ? void 0 : ta.call(Qi, qi, Xi).message) !== null && ra !== void 0 ? ra : Xi.defaultError;
          return qi.code === "unrecognized_keys" ? {
            message: (na = p$3.errToObj(e).message) !== null && na !== void 0 ? na : la
          } : {
            message: la
          };
        }
      } : {}
    });
  }
  strip() {
    return new Sd({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Sd({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Sd({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Sd({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: g$3.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, qi) {
    return this.augment({ [e]: qi });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Sd({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const qi = {};
    return b$2.objectKeys(e).forEach((Xi) => {
      e[Xi] && this.shape[Xi] && (qi[Xi] = this.shape[Xi]);
    }), new Sd({
      ...this._def,
      shape: () => qi
    });
  }
  omit(e) {
    const qi = {};
    return b$2.objectKeys(this.shape).forEach((Xi) => {
      e[Xi] || (qi[Xi] = this.shape[Xi]);
    }), new Sd({
      ...this._def,
      shape: () => qi
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return U$1(this);
  }
  partial(e) {
    const qi = {};
    return b$2.objectKeys(this.shape).forEach((Xi) => {
      const Qi = this.shape[Xi];
      e && !e[Xi] ? qi[Xi] = Qi : qi[Xi] = Qi.optional();
    }), new Sd({
      ...this._def,
      shape: () => qi
    });
  }
  required(e) {
    const qi = {};
    return b$2.objectKeys(this.shape).forEach((Xi) => {
      if (e && !e[Xi])
        qi[Xi] = this.shape[Xi];
      else {
        let Qi = this.shape[Xi];
        for (; Qi instanceof j$2; )
          Qi = Qi._def.innerType;
        qi[Xi] = Qi;
      }
    }), new Sd({
      ...this._def,
      shape: () => qi
    });
  }
  keyof() {
    return De$1(b$2.objectKeys(this.shape));
  }
};
x$2.create = (Bi, e) => new x$2({
  shape: () => Bi,
  unknownKeys: "strip",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
x$2.strictCreate = (Bi, e) => new x$2({
  shape: () => Bi,
  unknownKeys: "strict",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
x$2.lazycreate = (Bi, e) => new x$2({
  shape: Bi,
  unknownKeys: "strip",
  catchall: I$2.create(),
  typeName: g$3.ZodObject,
  ..._(e)
});
let te$2 = class extends v {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e), Xi = this._def.options;
    function Qi(ta) {
      for (const na of ta)
        if (na.result.status === "valid")
          return na.result;
      for (const na of ta)
        if (na.result.status === "dirty")
          return qi.common.issues.push(...na.ctx.common.issues), na.result;
      const ra = ta.map((na) => new S$1(na.ctx.common.issues));
      return u(qi, {
        code: d$3.invalid_union,
        unionErrors: ra
      }), y$3;
    }
    if (qi.common.async)
      return Promise.all(Xi.map(async (ta) => {
        const ra = {
          ...qi,
          common: {
            ...qi.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await ta._parseAsync({
            data: qi.data,
            path: qi.path,
            parent: ra
          }),
          ctx: ra
        };
      })).then(Qi);
    {
      let ta;
      const ra = [];
      for (const la of Xi) {
        const Ma = {
          ...qi,
          common: {
            ...qi.common,
            issues: []
          },
          parent: null
        }, Va = la._parseSync({
          data: qi.data,
          path: qi.path,
          parent: Ma
        });
        if (Va.status === "valid")
          return Va;
        Va.status === "dirty" && !ta && (ta = { result: Va, ctx: Ma }), Ma.common.issues.length && ra.push(Ma.common.issues);
      }
      if (ta)
        return qi.common.issues.push(...ta.ctx.common.issues), ta.result;
      const na = ra.map((la) => new S$1(la));
      return u(qi, {
        code: d$3.invalid_union,
        unionErrors: na
      }), y$3;
    }
  }
  get options() {
    return this._def.options;
  }
};
te$2.create = (Bi, e) => new te$2({
  options: Bi,
  typeName: g$3.ZodUnion,
  ..._(e)
});
const A$1 = (Bi) => Bi instanceof se$2 ? A$1(Bi.schema) : Bi instanceof E$2 ? A$1(Bi.innerType()) : Bi instanceof ae$2 ? [Bi.value] : Bi instanceof D$1 ? Bi.options : Bi instanceof ie$1 ? b$2.objectValues(Bi.enum) : Bi instanceof oe$2 ? A$1(Bi._def.innerType) : Bi instanceof Q$2 ? [void 0] : Bi instanceof ee$2 ? [null] : Bi instanceof j$2 ? [void 0, ...A$1(Bi.unwrap())] : Bi instanceof $$1 ? [null, ...A$1(Bi.unwrap())] : Bi instanceof Ze$2 || Bi instanceof de$2 ? A$1(Bi.unwrap()) : Bi instanceof ce$2 ? A$1(Bi._def.innerType) : [];
let be$2 = class Sf extends v {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    if (qi.parsedType !== h$1.object)
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.object,
        received: qi.parsedType
      }), y$3;
    const Xi = this.discriminator, Qi = qi.data[Xi], ta = this.optionsMap.get(Qi);
    return ta ? qi.common.async ? ta._parseAsync({
      data: qi.data,
      path: qi.path,
      parent: qi
    }) : ta._parseSync({
      data: qi.data,
      path: qi.path,
      parent: qi
    }) : (u(qi, {
      code: d$3.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [Xi]
    }), y$3);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, qi, Xi) {
    const Qi = /* @__PURE__ */ new Map();
    for (const ta of qi) {
      const ra = A$1(ta.shape[e]);
      if (!ra.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const na of ra) {
        if (Qi.has(na))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(na)}`);
        Qi.set(na, ta);
      }
    }
    return new Sf({
      typeName: g$3.ZodDiscriminatedUnion,
      discriminator: e,
      options: qi,
      optionsMap: Qi,
      ..._(Xi)
    });
  }
};
function Ce$2(Bi, e) {
  const qi = N$2(Bi), Xi = N$2(e);
  if (Bi === e)
    return { valid: !0, data: Bi };
  if (qi === h$1.object && Xi === h$1.object) {
    const Qi = b$2.objectKeys(e), ta = b$2.objectKeys(Bi).filter((na) => Qi.indexOf(na) !== -1), ra = { ...Bi, ...e };
    for (const na of ta) {
      const la = Ce$2(Bi[na], e[na]);
      if (!la.valid)
        return { valid: !1 };
      ra[na] = la.data;
    }
    return { valid: !0, data: ra };
  } else if (qi === h$1.array && Xi === h$1.array) {
    if (Bi.length !== e.length)
      return { valid: !1 };
    const Qi = [];
    for (let ta = 0; ta < Bi.length; ta++) {
      const ra = Bi[ta], na = e[ta], la = Ce$2(ra, na);
      if (!la.valid)
        return { valid: !1 };
      Qi.push(la.data);
    }
    return { valid: !0, data: Qi };
  } else return qi === h$1.date && Xi === h$1.date && +Bi == +e ? { valid: !0, data: Bi } : { valid: !1 };
}
let re$2 = class extends v {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e), Qi = (ta, ra) => {
      if (Te$2(ta) || Te$2(ra))
        return y$3;
      const na = Ce$2(ta.value, ra.value);
      return na.valid ? ((Se$2(ta) || Se$2(ra)) && qi.dirty(), { status: qi.value, value: na.data }) : (u(Xi, {
        code: d$3.invalid_intersection_types
      }), y$3);
    };
    return Xi.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: Xi.data,
        path: Xi.path,
        parent: Xi
      }),
      this._def.right._parseAsync({
        data: Xi.data,
        path: Xi.path,
        parent: Xi
      })
    ]).then(([ta, ra]) => Qi(ta, ra)) : Qi(this._def.left._parseSync({
      data: Xi.data,
      path: Xi.path,
      parent: Xi
    }), this._def.right._parseSync({
      data: Xi.data,
      path: Xi.path,
      parent: Xi
    }));
  }
};
re$2.create = (Bi, e, qi) => new re$2({
  left: Bi,
  right: e,
  typeName: g$3.ZodIntersection,
  ..._(qi)
});
let R$2 = class wf extends v {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== h$1.array)
      return u(Xi, {
        code: d$3.invalid_type,
        expected: h$1.array,
        received: Xi.parsedType
      }), y$3;
    if (Xi.data.length < this._def.items.length)
      return u(Xi, {
        code: d$3.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y$3;
    !this._def.rest && Xi.data.length > this._def.items.length && (u(Xi, {
      code: d$3.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), qi.dirty());
    const Qi = [...Xi.data].map((ta, ra) => {
      const na = this._def.items[ra] || this._def.rest;
      return na ? na._parse(new O$2(Xi, ta, Xi.path, ra)) : null;
    }).filter((ta) => !!ta);
    return Xi.common.async ? Promise.all(Qi).then((ta) => k.mergeArray(qi, ta)) : k.mergeArray(qi, Qi);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new wf({
      ...this._def,
      rest: e
    });
  }
};
R$2.create = (Bi, e) => {
  if (!Array.isArray(Bi))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new R$2({
    items: Bi,
    typeName: g$3.ZodTuple,
    rest: null,
    ..._(e)
  });
};
let ne$1 = class Qd extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== h$1.object)
      return u(Xi, {
        code: d$3.invalid_type,
        expected: h$1.object,
        received: Xi.parsedType
      }), y$3;
    const Qi = [], ta = this._def.keyType, ra = this._def.valueType;
    for (const na in Xi.data)
      Qi.push({
        key: ta._parse(new O$2(Xi, na, Xi.path, na)),
        value: ra._parse(new O$2(Xi, Xi.data[na], Xi.path, na)),
        alwaysSet: na in Xi.data
      });
    return Xi.common.async ? k.mergeObjectAsync(qi, Qi) : k.mergeObjectSync(qi, Qi);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, qi, Xi) {
    return qi instanceof v ? new Qd({
      keyType: e,
      valueType: qi,
      typeName: g$3.ZodRecord,
      ..._(Xi)
    }) : new Qd({
      keyType: C$1.create(),
      valueType: e,
      typeName: g$3.ZodRecord,
      ..._(qi)
    });
  }
}, ye$2 = class extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== h$1.map)
      return u(Xi, {
        code: d$3.invalid_type,
        expected: h$1.map,
        received: Xi.parsedType
      }), y$3;
    const Qi = this._def.keyType, ta = this._def.valueType, ra = [...Xi.data.entries()].map(([na, la], Ma) => ({
      key: Qi._parse(new O$2(Xi, na, Xi.path, [Ma, "key"])),
      value: ta._parse(new O$2(Xi, la, Xi.path, [Ma, "value"]))
    }));
    if (Xi.common.async) {
      const na = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const la of ra) {
          const Ma = await la.key, Va = await la.value;
          if (Ma.status === "aborted" || Va.status === "aborted")
            return y$3;
          (Ma.status === "dirty" || Va.status === "dirty") && qi.dirty(), na.set(Ma.value, Va.value);
        }
        return { status: qi.value, value: na };
      });
    } else {
      const na = /* @__PURE__ */ new Map();
      for (const la of ra) {
        const Ma = la.key, Va = la.value;
        if (Ma.status === "aborted" || Va.status === "aborted")
          return y$3;
        (Ma.status === "dirty" || Va.status === "dirty") && qi.dirty(), na.set(Ma.value, Va.value);
      }
      return { status: qi.value, value: na };
    }
  }
};
ye$2.create = (Bi, e, qi) => new ye$2({
  valueType: e,
  keyType: Bi,
  typeName: g$3.ZodMap,
  ..._(qi)
});
let F$2 = class Jd extends v {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== h$1.set)
      return u(Xi, {
        code: d$3.invalid_type,
        expected: h$1.set,
        received: Xi.parsedType
      }), y$3;
    const Qi = this._def;
    Qi.minSize !== null && Xi.data.size < Qi.minSize.value && (u(Xi, {
      code: d$3.too_small,
      minimum: Qi.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: Qi.minSize.message
    }), qi.dirty()), Qi.maxSize !== null && Xi.data.size > Qi.maxSize.value && (u(Xi, {
      code: d$3.too_big,
      maximum: Qi.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: Qi.maxSize.message
    }), qi.dirty());
    const ta = this._def.valueType;
    function ra(la) {
      const Ma = /* @__PURE__ */ new Set();
      for (const Va of la) {
        if (Va.status === "aborted")
          return y$3;
        Va.status === "dirty" && qi.dirty(), Ma.add(Va.value);
      }
      return { status: qi.value, value: Ma };
    }
    const na = [...Xi.data.values()].map((la, Ma) => ta._parse(new O$2(Xi, la, Xi.path, Ma)));
    return Xi.common.async ? Promise.all(na).then((la) => ra(la)) : ra(na);
  }
  min(e, qi) {
    return new Jd({
      ...this._def,
      minSize: { value: e, message: p$3.toString(qi) }
    });
  }
  max(e, qi) {
    return new Jd({
      ...this._def,
      maxSize: { value: e, message: p$3.toString(qi) }
    });
  }
  size(e, qi) {
    return this.min(e, qi).max(e, qi);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
F$2.create = (Bi, e) => new F$2({
  valueType: Bi,
  minSize: null,
  maxSize: null,
  typeName: g$3.ZodSet,
  ..._(e)
});
let q$1 = class Ud extends v {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    if (qi.parsedType !== h$1.function)
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.function,
        received: qi.parsedType
      }), y$3;
    function Xi(na, la) {
      return he$2({
        data: na,
        path: qi.path,
        errorMaps: [
          qi.common.contextualErrorMap,
          qi.schemaErrorMap,
          fe$2(),
          W$2
        ].filter((Ma) => !!Ma),
        issueData: {
          code: d$3.invalid_arguments,
          argumentsError: la
        }
      });
    }
    function Qi(na, la) {
      return he$2({
        data: na,
        path: qi.path,
        errorMaps: [
          qi.common.contextualErrorMap,
          qi.schemaErrorMap,
          fe$2(),
          W$2
        ].filter((Ma) => !!Ma),
        issueData: {
          code: d$3.invalid_return_type,
          returnTypeError: la
        }
      });
    }
    const ta = { errorMap: qi.common.contextualErrorMap }, ra = qi.data;
    if (this._def.returns instanceof Y$2) {
      const na = this;
      return T$2(async function(...la) {
        const Ma = new S$1([]), Va = await na._def.args.parseAsync(la, ta).catch((Eo) => {
          throw Ma.addIssue(Xi(la, Eo)), Ma;
        }), to = await Reflect.apply(ra, this, Va);
        return await na._def.returns._def.type.parseAsync(to, ta).catch((Eo) => {
          throw Ma.addIssue(Qi(to, Eo)), Ma;
        });
      });
    } else {
      const na = this;
      return T$2(function(...la) {
        const Ma = na._def.args.safeParse(la, ta);
        if (!Ma.success)
          throw new S$1([Xi(la, Ma.error)]);
        const Va = Reflect.apply(ra, this, Ma.data), to = na._def.returns.safeParse(Va, ta);
        if (!to.success)
          throw new S$1([Qi(Va, to.error)]);
        return to.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Ud({
      ...this._def,
      args: R$2.create(e).rest(L$2.create())
    });
  }
  returns(e) {
    return new Ud({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, qi, Xi) {
    return new Ud({
      args: e || R$2.create([]).rest(L$2.create()),
      returns: qi || L$2.create(),
      typeName: g$3.ZodFunction,
      ..._(Xi)
    });
  }
}, se$2 = class extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    return this._def.getter()._parse({ data: qi.data, path: qi.path, parent: qi });
  }
};
se$2.create = (Bi, e) => new se$2({
  getter: Bi,
  typeName: g$3.ZodLazy,
  ..._(e)
});
let ae$2 = class extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        received: qi.data,
        code: d$3.invalid_literal,
        expected: this._def.value
      }), y$3;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
ae$2.create = (Bi, e) => new ae$2({
  value: Bi,
  typeName: g$3.ZodLiteral,
  ..._(e)
});
function De$1(Bi, e) {
  return new D$1({
    values: Bi,
    typeName: g$3.ZodEnum,
    ..._(e)
  });
}
let D$1 = class ef extends v {
  constructor() {
    super(...arguments), G$2.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const qi = this._getOrReturnCtx(e), Xi = this._def.values;
      return u(qi, {
        expected: b$2.joinValues(Xi),
        received: qi.parsedType,
        code: d$3.invalid_type
      }), y$3;
    }
    if (pe$2(this, G$2) || Ne$1(this, G$2, new Set(this._def.values)), !pe$2(this, G$2).has(e.data)) {
      const qi = this._getOrReturnCtx(e), Xi = this._def.values;
      return u(qi, {
        received: qi.data,
        code: d$3.invalid_enum_value,
        options: Xi
      }), y$3;
    }
    return T$2(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const qi of this._def.values)
      e[qi] = qi;
    return e;
  }
  get Values() {
    const e = {};
    for (const qi of this._def.values)
      e[qi] = qi;
    return e;
  }
  get Enum() {
    const e = {};
    for (const qi of this._def.values)
      e[qi] = qi;
    return e;
  }
  extract(e, qi = this._def) {
    return ef.create(e, {
      ...this._def,
      ...qi
    });
  }
  exclude(e, qi = this._def) {
    return ef.create(this.options.filter((Xi) => !e.includes(Xi)), {
      ...this._def,
      ...qi
    });
  }
};
G$2 = /* @__PURE__ */ new WeakMap();
D$1.create = De$1;
let ie$1 = class extends v {
  constructor() {
    super(...arguments), H$3.set(this, void 0);
  }
  _parse(e) {
    const qi = b$2.getValidEnumValues(this._def.values), Xi = this._getOrReturnCtx(e);
    if (Xi.parsedType !== h$1.string && Xi.parsedType !== h$1.number) {
      const Qi = b$2.objectValues(qi);
      return u(Xi, {
        expected: b$2.joinValues(Qi),
        received: Xi.parsedType,
        code: d$3.invalid_type
      }), y$3;
    }
    if (pe$2(this, H$3) || Ne$1(this, H$3, new Set(b$2.getValidEnumValues(this._def.values))), !pe$2(this, H$3).has(e.data)) {
      const Qi = b$2.objectValues(qi);
      return u(Xi, {
        received: Xi.data,
        code: d$3.invalid_enum_value,
        options: Qi
      }), y$3;
    }
    return T$2(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
H$3 = /* @__PURE__ */ new WeakMap();
ie$1.create = (Bi, e) => new ie$1({
  values: Bi,
  typeName: g$3.ZodNativeEnum,
  ..._(e)
});
let Y$2 = class extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    if (qi.parsedType !== h$1.promise && qi.common.async === !1)
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.promise,
        received: qi.parsedType
      }), y$3;
    const Xi = qi.parsedType === h$1.promise ? qi.data : Promise.resolve(qi.data);
    return T$2(Xi.then((Qi) => this._def.type.parseAsync(Qi, {
      path: qi.path,
      errorMap: qi.common.contextualErrorMap
    })));
  }
};
Y$2.create = (Bi, e) => new Y$2({
  type: Bi,
  typeName: g$3.ZodPromise,
  ..._(e)
});
let E$2 = class extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === g$3.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e), Qi = this._def.effect || null, ta = {
      addIssue: (ra) => {
        u(Xi, ra), ra.fatal ? qi.abort() : qi.dirty();
      },
      get path() {
        return Xi.path;
      }
    };
    if (ta.addIssue = ta.addIssue.bind(ta), Qi.type === "preprocess") {
      const ra = Qi.transform(Xi.data, ta);
      if (Xi.common.async)
        return Promise.resolve(ra).then(async (na) => {
          if (qi.value === "aborted")
            return y$3;
          const la = await this._def.schema._parseAsync({
            data: na,
            path: Xi.path,
            parent: Xi
          });
          return la.status === "aborted" ? y$3 : la.status === "dirty" || qi.value === "dirty" ? B$2(la.value) : la;
        });
      {
        if (qi.value === "aborted")
          return y$3;
        const na = this._def.schema._parseSync({
          data: ra,
          path: Xi.path,
          parent: Xi
        });
        return na.status === "aborted" ? y$3 : na.status === "dirty" || qi.value === "dirty" ? B$2(na.value) : na;
      }
    }
    if (Qi.type === "refinement") {
      const ra = (na) => {
        const la = Qi.refinement(na, ta);
        if (Xi.common.async)
          return Promise.resolve(la);
        if (la instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return na;
      };
      if (Xi.common.async === !1) {
        const na = this._def.schema._parseSync({
          data: Xi.data,
          path: Xi.path,
          parent: Xi
        });
        return na.status === "aborted" ? y$3 : (na.status === "dirty" && qi.dirty(), ra(na.value), { status: qi.value, value: na.value });
      } else
        return this._def.schema._parseAsync({ data: Xi.data, path: Xi.path, parent: Xi }).then((na) => na.status === "aborted" ? y$3 : (na.status === "dirty" && qi.dirty(), ra(na.value).then(() => ({ status: qi.value, value: na.value }))));
    }
    if (Qi.type === "transform")
      if (Xi.common.async === !1) {
        const ra = this._def.schema._parseSync({
          data: Xi.data,
          path: Xi.path,
          parent: Xi
        });
        if (!V$1(ra))
          return ra;
        const na = Qi.transform(ra.value, ta);
        if (na instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: qi.value, value: na };
      } else
        return this._def.schema._parseAsync({ data: Xi.data, path: Xi.path, parent: Xi }).then((ra) => V$1(ra) ? Promise.resolve(Qi.transform(ra.value, ta)).then((na) => ({ status: qi.value, value: na })) : ra);
    b$2.assertNever(Qi);
  }
};
E$2.create = (Bi, e, qi) => new E$2({
  schema: Bi,
  typeName: g$3.ZodEffects,
  effect: e,
  ..._(qi)
});
E$2.createWithPreprocess = (Bi, e, qi) => new E$2({
  schema: e,
  effect: { type: "preprocess", transform: Bi },
  typeName: g$3.ZodEffects,
  ..._(qi)
});
let j$2 = class extends v {
  _parse(e) {
    return this._getType(e) === h$1.undefined ? T$2(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
j$2.create = (Bi, e) => new j$2({
  innerType: Bi,
  typeName: g$3.ZodOptional,
  ..._(e)
});
let $$1 = class extends v {
  _parse(e) {
    return this._getType(e) === h$1.null ? T$2(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
$$1.create = (Bi, e) => new $$1({
  innerType: Bi,
  typeName: g$3.ZodNullable,
  ..._(e)
});
let oe$2 = class extends v {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    let Xi = qi.data;
    return qi.parsedType === h$1.undefined && (Xi = this._def.defaultValue()), this._def.innerType._parse({
      data: Xi,
      path: qi.path,
      parent: qi
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
oe$2.create = (Bi, e) => new oe$2({
  innerType: Bi,
  typeName: g$3.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
let ce$2 = class extends v {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e), Xi = {
      ...qi,
      common: {
        ...qi.common,
        issues: []
      }
    }, Qi = this._def.innerType._parse({
      data: Xi.data,
      path: Xi.path,
      parent: {
        ...Xi
      }
    });
    return K$1(Qi) ? Qi.then((ta) => ({
      status: "valid",
      value: ta.status === "valid" ? ta.value : this._def.catchValue({
        get error() {
          return new S$1(Xi.common.issues);
        },
        input: Xi.data
      })
    })) : {
      status: "valid",
      value: Qi.status === "valid" ? Qi.value : this._def.catchValue({
        get error() {
          return new S$1(Xi.common.issues);
        },
        input: Xi.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ce$2.create = (Bi, e) => new ce$2({
  innerType: Bi,
  typeName: g$3.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
let _e$1 = class extends v {
  _parse(e) {
    if (this._getType(e) !== h$1.nan) {
      const qi = this._getOrReturnCtx(e);
      return u(qi, {
        code: d$3.invalid_type,
        expected: h$1.nan,
        received: qi.parsedType
      }), y$3;
    }
    return { status: "valid", value: e.data };
  }
};
_e$1.create = (Bi) => new _e$1({
  typeName: g$3.ZodNaN,
  ..._(Bi)
});
const pt$2 = Symbol("zod_brand");
let Ze$2 = class extends v {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e), Xi = qi.data;
    return this._def.type._parse({
      data: Xi,
      path: qi.path,
      parent: qi
    });
  }
  unwrap() {
    return this._def.type;
  }
}, le$1 = class Af extends v {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.common.async)
      return (async () => {
        const Qi = await this._def.in._parseAsync({
          data: Xi.data,
          path: Xi.path,
          parent: Xi
        });
        return Qi.status === "aborted" ? y$3 : Qi.status === "dirty" ? (qi.dirty(), B$2(Qi.value)) : this._def.out._parseAsync({
          data: Qi.value,
          path: Xi.path,
          parent: Xi
        });
      })();
    {
      const Qi = this._def.in._parseSync({
        data: Xi.data,
        path: Xi.path,
        parent: Xi
      });
      return Qi.status === "aborted" ? y$3 : Qi.status === "dirty" ? (qi.dirty(), {
        status: "dirty",
        value: Qi.value
      }) : this._def.out._parseSync({
        data: Qi.value,
        path: Xi.path,
        parent: Xi
      });
    }
  }
  static create(e, qi) {
    return new Af({
      in: e,
      out: qi,
      typeName: g$3.ZodPipeline
    });
  }
}, de$2 = class extends v {
  _parse(e) {
    const qi = this._def.innerType._parse(e), Xi = (Qi) => (V$1(Qi) && (Qi.value = Object.freeze(Qi.value)), Qi);
    return K$1(qi) ? qi.then((Qi) => Xi(Qi)) : Xi(qi);
  }
  unwrap() {
    return this._def.innerType;
  }
};
de$2.create = (Bi, e) => new de$2({
  innerType: Bi,
  typeName: g$3.ZodReadonly,
  ..._(e)
});
function je$2(Bi, e) {
  const qi = typeof Bi == "function" ? Bi(e) : typeof Bi == "string" ? { message: Bi } : Bi;
  return typeof qi == "string" ? { message: qi } : qi;
}
function $e$1(Bi, e = {}, qi) {
  return Bi ? J$1.create().superRefine((Xi, Qi) => {
    var ta, ra;
    const na = Bi(Xi);
    if (na instanceof Promise)
      return na.then((la) => {
        var Ma, Va;
        if (!la) {
          const to = je$2(e, Xi), Eo = (Va = (Ma = to.fatal) !== null && Ma !== void 0 ? Ma : qi) !== null && Va !== void 0 ? Va : !0;
          Qi.addIssue({ code: "custom", ...to, fatal: Eo });
        }
      });
    if (!na) {
      const la = je$2(e, Xi), Ma = (ra = (ta = la.fatal) !== null && ta !== void 0 ? ta : qi) !== null && ra !== void 0 ? ra : !0;
      Qi.addIssue({ code: "custom", ...la, fatal: Ma });
    }
  }) : J$1.create();
}
const mt$2 = {
  object: x$2.lazycreate
};
var g$3;
(function(Bi) {
  Bi.ZodString = "ZodString", Bi.ZodNumber = "ZodNumber", Bi.ZodNaN = "ZodNaN", Bi.ZodBigInt = "ZodBigInt", Bi.ZodBoolean = "ZodBoolean", Bi.ZodDate = "ZodDate", Bi.ZodSymbol = "ZodSymbol", Bi.ZodUndefined = "ZodUndefined", Bi.ZodNull = "ZodNull", Bi.ZodAny = "ZodAny", Bi.ZodUnknown = "ZodUnknown", Bi.ZodNever = "ZodNever", Bi.ZodVoid = "ZodVoid", Bi.ZodArray = "ZodArray", Bi.ZodObject = "ZodObject", Bi.ZodUnion = "ZodUnion", Bi.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Bi.ZodIntersection = "ZodIntersection", Bi.ZodTuple = "ZodTuple", Bi.ZodRecord = "ZodRecord", Bi.ZodMap = "ZodMap", Bi.ZodSet = "ZodSet", Bi.ZodFunction = "ZodFunction", Bi.ZodLazy = "ZodLazy", Bi.ZodLiteral = "ZodLiteral", Bi.ZodEnum = "ZodEnum", Bi.ZodEffects = "ZodEffects", Bi.ZodNativeEnum = "ZodNativeEnum", Bi.ZodOptional = "ZodOptional", Bi.ZodNullable = "ZodNullable", Bi.ZodDefault = "ZodDefault", Bi.ZodCatch = "ZodCatch", Bi.ZodPromise = "ZodPromise", Bi.ZodBranded = "ZodBranded", Bi.ZodPipeline = "ZodPipeline", Bi.ZodReadonly = "ZodReadonly";
})(g$3 || (g$3 = {}));
const gt$2 = (Bi, e = {
  message: `Input not instance of ${Bi.name}`
}) => $e$1((qi) => qi instanceof Bi, e), Le$2 = C$1.create, Ve$2 = M$2.create, yt$2 = _e$1.create, _t$2 = P$2.create, ze$2 = X$2.create, vt$2 = z$2.create, bt$2 = me$2.create, xt$2 = Q$2.create, kt$1 = ee$2.create, wt$2 = J$1.create, Tt$1 = L$2.create, St$2 = I$2.create, Ct$2 = ge$2.create, Zt$2 = Z$1.create, Et$2 = x$2.create, jt$2 = x$2.strictCreate, Ot$2 = te$2.create, Rt$2 = be$2.create, At$2 = re$2.create, Nt$2 = R$2.create, It$2 = ne$1.create, Mt$2 = ye$2.create, Pt$2 = F$2.create, Dt$2 = q$1.create, $t$2 = se$2.create, Lt$2 = ae$2.create, Vt$2 = D$1.create, zt$2 = ie$1.create, Ft$2 = Y$2.create, Oe$2 = E$2.create, Ut$2 = j$2.create, Bt$2 = $$1.create, qt$2 = E$2.createWithPreprocess, Wt$2 = le$1.create, Jt$1 = () => Le$2().optional(), Yt$2 = () => Ve$2().optional(), Gt$2 = () => ze$2().optional(), Ht$2 = {
  string: (Bi) => C$1.create({ ...Bi, coerce: !0 }),
  number: (Bi) => M$2.create({ ...Bi, coerce: !0 }),
  boolean: (Bi) => X$2.create({
    ...Bi,
    coerce: !0
  }),
  bigint: (Bi) => P$2.create({ ...Bi, coerce: !0 }),
  date: (Bi) => z$2.create({ ...Bi, coerce: !0 })
}, Kt$1 = y$3;
var i$6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: W$2,
  setErrorMap: qe$2,
  getErrorMap: fe$2,
  makeIssue: he$2,
  EMPTY_PATH: We$2,
  addIssueToContext: u,
  ParseStatus: k,
  INVALID: y$3,
  DIRTY: B$2,
  OK: T$2,
  isAborted: Te$2,
  isDirty: Se$2,
  isValid: V$1,
  isAsync: K$1,
  get util() {
    return b$2;
  },
  get objectUtil() {
    return we;
  },
  ZodParsedType: h$1,
  getParsedType: N$2,
  ZodType: v,
  datetimeRegex: Pe$2,
  ZodString: C$1,
  ZodNumber: M$2,
  ZodBigInt: P$2,
  ZodBoolean: X$2,
  ZodDate: z$2,
  ZodSymbol: me$2,
  ZodUndefined: Q$2,
  ZodNull: ee$2,
  ZodAny: J$1,
  ZodUnknown: L$2,
  ZodNever: I$2,
  ZodVoid: ge$2,
  ZodArray: Z$1,
  ZodObject: x$2,
  ZodUnion: te$2,
  ZodDiscriminatedUnion: be$2,
  ZodIntersection: re$2,
  ZodTuple: R$2,
  ZodRecord: ne$1,
  ZodMap: ye$2,
  ZodSet: F$2,
  ZodFunction: q$1,
  ZodLazy: se$2,
  ZodLiteral: ae$2,
  ZodEnum: D$1,
  ZodNativeEnum: ie$1,
  ZodPromise: Y$2,
  ZodEffects: E$2,
  ZodTransformer: E$2,
  ZodOptional: j$2,
  ZodNullable: $$1,
  ZodDefault: oe$2,
  ZodCatch: ce$2,
  ZodNaN: _e$1,
  BRAND: pt$2,
  ZodBranded: Ze$2,
  ZodPipeline: le$1,
  ZodReadonly: de$2,
  custom: $e$1,
  Schema: v,
  ZodSchema: v,
  late: mt$2,
  get ZodFirstPartyTypeKind() {
    return g$3;
  },
  coerce: Ht$2,
  any: wt$2,
  array: Zt$2,
  bigint: _t$2,
  boolean: ze$2,
  date: vt$2,
  discriminatedUnion: Rt$2,
  effect: Oe$2,
  enum: Vt$2,
  function: Dt$2,
  instanceof: gt$2,
  intersection: At$2,
  lazy: $t$2,
  literal: Lt$2,
  map: Mt$2,
  nan: yt$2,
  nativeEnum: zt$2,
  never: St$2,
  null: kt$1,
  nullable: Bt$2,
  number: Ve$2,
  object: Et$2,
  oboolean: Gt$2,
  onumber: Yt$2,
  optional: Ut$2,
  ostring: Jt$1,
  pipeline: Wt$2,
  preprocess: qt$2,
  promise: Ft$2,
  record: It$2,
  set: Pt$2,
  strictObject: jt$2,
  string: Le$2,
  symbol: bt$2,
  transformer: Oe$2,
  tuple: Nt$2,
  undefined: xt$2,
  union: Ot$2,
  unknown: Tt$1,
  void: Ct$2,
  NEVER: Kt$1,
  ZodIssueCode: d$3,
  quotelessJson: Be$2,
  ZodError: S$1
});
const Xt$2 = i$6.object({
  _type: i$6.literal("string"),
  _validation: i$6.string().optional(),
  _value: i$6.string().optional(),
  _optional: i$6.boolean().optional()
}), Qt$2 = i$6.object({
  _type: i$6.literal("boolean"),
  _value: i$6.boolean().optional(),
  _optional: i$6.boolean().optional()
}), er$2 = i$6.object({
  _type: i$6.literal("selection"),
  _options: i$6.array(i$6.string()),
  _optional: i$6.boolean().optional(),
  _value: i$6.string().optional()
}), tr$2 = i$6.object({
  bucket: i$6.string(),
  fullPath: i$6.string(),
  isFolder: i$6.boolean(),
  key: i$6.string(),
  name: i$6.string()
}), rr$1 = i$6.nativeEnum(Re$2), ve$2 = i$6.lazy(() => i$6.union([
  ar$2,
  nr$2,
  er$2,
  Xt$2,
  sr$2,
  Qt$2
])), nr$2 = i$6.object({
  _type: i$6.literal("path"),
  _value: i$6.array(tr$2).optional(),
  _optional: i$6.boolean().optional(),
  _pathType: rr$1
}), sr$2 = i$6.lazy(() => i$6.object({
  _type: i$6.literal("list"),
  _value: i$6.array(ve$2).optional(),
  _optional: i$6.boolean().optional(),
  _schema: ve$2
})), ar$2 = i$6.lazy(() => i$6.object({
  _type: i$6.literal("object"),
  _optional: i$6.boolean().optional(),
  _fields: i$6.record(ve$2),
  _value: i$6.record(ve$2).optional()
})), Fe$2 = i$6.object({
  permissions: i$6.string(),
  links: i$6.string(),
  owner: i$6.string(),
  group: i$6.string(),
  size: i$6.string(),
  month: i$6.string(),
  date: i$6.string(),
  yearOrTime: i$6.string(),
  name: i$6.string(),
  fullPath: i$6.string()
}), ir$2 = i$6.array(Fe$2);
i$6.object({
  url: i$6.string()
});
i$6.object({
  socketId: i$6.string(),
  hasSavedSession: i$6.boolean().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  directory: i$6.string(),
  contents: ir$2
});
i$6.object({
  syncPwd: i$6.boolean()
});
i$6.object({
  defaultDirectory: i$6.string(),
  termState: i$6.string().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  query: i$6.string()
});
i$6.object({
  results: i$6.array(Fe$2),
  date: i$6.string(),
  query: i$6.string()
});
i$6.object({
  tinkerBoxId: i$6.number(),
  rows: i$6.number(),
  cols: i$6.number(),
  syncPwd: i$6.boolean().nullish()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  path: i$6.string()
});
i$6.object({
  termState: i$6.string()
});
const or$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("select"),
  options: i$6.array(i$6.string()),
  optional: i$6.boolean().optional(),
  allowOther: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), cr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.union([i$6.literal("text"), i$6.literal("textarea")]),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), dr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("email"),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
}), lr$2 = i$6.object({
  name: i$6.string(),
  type: i$6.literal("submit"),
  text: i$6.string().optional(),
  optional: i$6.boolean().optional(),
  validate: i$6.string().optional(),
  question: i$6.string().optional()
});
i$6.array(
  i$6.object({
    name: i$6.string(),
    value: i$6.string()
  })
);
const ur$2 = i$6.union([
  or$2,
  cr$2,
  dr$2,
  lr$2
]);
i$6.array(ur$2);
const fr$2 = i$6.object({
  id: i$6.number(),
  name: i$6.string(),
  labId: i$6.number(),
  status: i$6.string(),
  ipAddress: i$6.string().nullable(),
  lastLogin: i$6.date().nullable()
});
i$6.object({
  tinkerboxes: i$6.array(fr$2)
});
const hr$2 = i$6.object({
  key: i$6.string(),
  name: i$6.string(),
  isFolder: i$6.boolean(),
  bucket: i$6.string(),
  fullPath: i$6.string()
});
i$6.object({
  contents: i$6.array(hr$2)
});
i$6.object({
  buckets: i$6.array(
    i$6.object({
      id: i$6.number().int(),
      bucket: i$6.string(),
      region: i$6.string(),
      prefix: i$6.string().nullish()
    })
  )
});
var niceErrors = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(e, qi) {
    return "Cannot apply '" + e + "' to '" + qi.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(e, qi) {
    return "[mobx.array] Index out of bounds, " + e + " is larger than " + qi;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(e) {
    return "Cannot initialize from classes that inherit from Map: " + e.constructor.name;
  },
  20: function(e) {
    return "Cannot initialize map from " + e;
  },
  21: function(e) {
    return "Cannot convert to map from '" + e + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(e) {
    return "Cannot obtain administration from " + e;
  },
  25: function(e, qi) {
    return "the entry '" + e + "' does not exist in the observable map '" + qi + "'";
  },
  26: "please specify a property",
  27: function(e, qi) {
    return "no observable property '" + e.toString() + "' found on the observable object '" + qi + "'";
  },
  28: function(e) {
    return "Cannot obtain atom from " + e;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(e, qi) {
    return "Cycle detected in computation " + e + ": " + qi;
  },
  33: function(e) {
    return "The setter of computed value '" + e + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(e) {
    return "[ComputedValue '" + e + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(e) {
    return "[mobx] `observableArray." + e + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + e + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, errors = process.env.NODE_ENV !== "production" ? niceErrors : {};
function die(Bi) {
  for (var e = arguments.length, qi = new Array(e > 1 ? e - 1 : 0), Xi = 1; Xi < e; Xi++)
    qi[Xi - 1] = arguments[Xi];
  if (process.env.NODE_ENV !== "production") {
    var Qi = typeof Bi == "string" ? Bi : errors[Bi];
    throw typeof Qi == "function" && (Qi = Qi.apply(null, qi)), new Error("[MobX] " + Qi);
  }
  throw new Error(typeof Bi == "number" ? "[MobX] minified error nr: " + Bi + (qi.length ? " " + qi.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + Bi);
}
var mockGlobal = {};
function getGlobal() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : mockGlobal;
}
var assign = Object.assign, getDescriptor = Object.getOwnPropertyDescriptor, defineProperty = Object.defineProperty, objectPrototype = Object.prototype, EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy < "u", plainObjectString = /* @__PURE__ */ Object.toString();
function assertProxies() {
  hasProxy || die(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function warnAboutProxyRequirement(Bi) {
  process.env.NODE_ENV !== "production" && globalState.verifyProxies && die("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + Bi);
}
function getNextId() {
  return ++globalState.mobxGuid;
}
function once(Bi) {
  var e = !1;
  return function() {
    if (!e)
      return e = !0, Bi.apply(this, arguments);
  };
}
var noop$1 = function() {
};
function isFunction$1(Bi) {
  return typeof Bi == "function";
}
function isStringish(Bi) {
  var e = typeof Bi;
  switch (e) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function isObject$3(Bi) {
  return Bi !== null && typeof Bi == "object";
}
function isPlainObject$2(Bi) {
  if (!isObject$3(Bi))
    return !1;
  var e = Object.getPrototypeOf(Bi);
  if (e == null)
    return !0;
  var qi = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof qi == "function" && qi.toString() === plainObjectString;
}
function isGenerator(Bi) {
  var e = Bi?.constructor;
  return e ? e.name === "GeneratorFunction" || e.displayName === "GeneratorFunction" : !1;
}
function addHiddenProp(Bi, e, qi) {
  defineProperty(Bi, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: qi
  });
}
function addHiddenFinalProp(Bi, e, qi) {
  defineProperty(Bi, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: qi
  });
}
function createInstanceofPredicate(Bi, e) {
  var qi = "isMobX" + Bi;
  return e.prototype[qi] = !0, function(Xi) {
    return isObject$3(Xi) && Xi[qi] === !0;
  };
}
function isES6Map(Bi) {
  return Bi instanceof Map;
}
function isES6Set(Bi) {
  return Bi instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols < "u";
function getPlainObjectKeys(Bi) {
  var e = Object.keys(Bi);
  if (!hasGetOwnPropertySymbols)
    return e;
  var qi = Object.getOwnPropertySymbols(Bi);
  return qi.length ? [].concat(e, qi.filter(function(Xi) {
    return objectPrototype.propertyIsEnumerable.call(Bi, Xi);
  })) : e;
}
var ownKeys$2 = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(Bi) {
  return Object.getOwnPropertyNames(Bi).concat(Object.getOwnPropertySymbols(Bi));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function stringifyKey(Bi) {
  return typeof Bi == "string" ? Bi : typeof Bi == "symbol" ? Bi.toString() : new String(Bi).toString();
}
function toPrimitive(Bi) {
  return Bi === null ? null : typeof Bi == "object" ? "" + Bi : Bi;
}
function hasProp(Bi, e) {
  return objectPrototype.hasOwnProperty.call(Bi, e);
}
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function(e) {
  var qi = {};
  return ownKeys$2(e).forEach(function(Xi) {
    qi[Xi] = getDescriptor(e, Xi);
  }), qi;
};
function _defineProperties(Bi, e) {
  for (var qi = 0; qi < e.length; qi++) {
    var Xi = e[qi];
    Xi.enumerable = Xi.enumerable || !1, Xi.configurable = !0, "value" in Xi && (Xi.writable = !0), Object.defineProperty(Bi, _toPropertyKey(Xi.key), Xi);
  }
}
function _createClass(Bi, e, qi) {
  return e && _defineProperties(Bi.prototype, e), Object.defineProperty(Bi, "prototype", {
    writable: !1
  }), Bi;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(Bi) {
    for (var e = 1; e < arguments.length; e++) {
      var qi = arguments[e];
      for (var Xi in qi)
        Object.prototype.hasOwnProperty.call(qi, Xi) && (Bi[Xi] = qi[Xi]);
    }
    return Bi;
  }, _extends.apply(this, arguments);
}
function _inheritsLoose(Bi, e) {
  Bi.prototype = Object.create(e.prototype), Bi.prototype.constructor = Bi, _setPrototypeOf(Bi, e);
}
function _setPrototypeOf(Bi, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Xi, Qi) {
    return Xi.__proto__ = Qi, Xi;
  }, _setPrototypeOf(Bi, e);
}
function _assertThisInitialized(Bi) {
  if (Bi === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Bi;
}
function _unsupportedIterableToArray$2(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$2(Bi, e);
    var qi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (qi === "Object" && Bi.constructor && (qi = Bi.constructor.name), qi === "Map" || qi === "Set") return Array.from(Bi);
    if (qi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(qi)) return _arrayLikeToArray$2(Bi, e);
  }
}
function _arrayLikeToArray$2(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var qi = 0, Xi = new Array(e); qi < e; qi++) Xi[qi] = Bi[qi];
  return Xi;
}
function _createForOfIteratorHelperLoose(Bi, e) {
  var qi = typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (qi) return (qi = qi.call(Bi)).next.bind(qi);
  if (Array.isArray(Bi) || (qi = _unsupportedIterableToArray$2(Bi)) || e) {
    qi && (Bi = qi);
    var Xi = 0;
    return function() {
      return Xi >= Bi.length ? {
        done: !0
      } : {
        done: !1,
        value: Bi[Xi++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toPrimitive(Bi, e) {
  if (typeof Bi != "object" || Bi === null) return Bi;
  var qi = Bi[Symbol.toPrimitive];
  if (qi !== void 0) {
    var Xi = qi.call(Bi, e);
    if (typeof Xi != "object") return Xi;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Bi);
}
function _toPropertyKey(Bi) {
  var e = _toPrimitive(Bi, "string");
  return typeof e == "symbol" ? e : String(e);
}
var storedAnnotationsSymbol = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function createDecoratorAnnotation(Bi) {
  function e(qi, Xi) {
    if (is20223Decorator(Xi))
      return Bi.decorate_20223_(qi, Xi);
    storeAnnotation(qi, Xi, Bi);
  }
  return Object.assign(e, Bi);
}
function storeAnnotation(Bi, e, qi) {
  if (hasProp(Bi, storedAnnotationsSymbol) || addHiddenProp(Bi, storedAnnotationsSymbol, _extends({}, Bi[storedAnnotationsSymbol])), process.env.NODE_ENV !== "production" && isOverride(qi) && !hasProp(Bi[storedAnnotationsSymbol], e)) {
    var Xi = Bi.constructor.name + ".prototype." + e.toString();
    die("'" + Xi + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  assertNotDecorated(Bi, qi, e), isOverride(qi) || (Bi[storedAnnotationsSymbol][e] = qi);
}
function assertNotDecorated(Bi, e, qi) {
  if (process.env.NODE_ENV !== "production" && !isOverride(e) && hasProp(Bi[storedAnnotationsSymbol], qi)) {
    var Xi = Bi.constructor.name + ".prototype." + qi.toString(), Qi = Bi[storedAnnotationsSymbol][qi].annotationType_, ta = e.annotationType_;
    die("Cannot apply '@" + ta + "' to '" + Xi + "':" + (`
The field is already decorated with '@` + Qi + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function collectStoredAnnotations(Bi) {
  return hasProp(Bi, storedAnnotationsSymbol) || addHiddenProp(Bi, storedAnnotationsSymbol, _extends({}, Bi[storedAnnotationsSymbol])), Bi[storedAnnotationsSymbol];
}
function is20223Decorator(Bi) {
  return typeof Bi == "object" && typeof Bi.kind == "string";
}
function assert20223DecoratorType(Bi, e) {
  process.env.NODE_ENV !== "production" && !e.includes(Bi.kind) && die("The decorator applied to '" + String(Bi.name) + "' cannot be used on a " + Bi.kind + " element");
}
var $mobx = /* @__PURE__ */ Symbol("mobx administration"), Atom = /* @__PURE__ */ function() {
  function Bi(qi) {
    qi === void 0 && (qi = process.env.NODE_ENV !== "production" ? "Atom@" + getNextId() : "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = qi;
  }
  var e = Bi.prototype;
  return e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(Xi) {
      return Xi();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(Xi) {
      return Xi();
    });
  }, e.reportObserved = function() {
    return reportObserved(this);
  }, e.reportChanged = function() {
    startBatch(), propagateChanged(this), endBatch();
  }, e.toString = function() {
    return this.name_;
  }, Bi;
}(), isAtom = /* @__PURE__ */ createInstanceofPredicate("Atom", Atom);
function createAtom(Bi, e, qi) {
  e === void 0 && (e = noop$1), qi === void 0 && (qi = noop$1);
  var Xi = new Atom(Bi);
  return e !== noop$1 && onBecomeObserved(Xi, e), qi !== noop$1 && onBecomeUnobserved(Xi, qi), Xi;
}
function structuralComparer(Bi, e) {
  return deepEqual$1(Bi, e);
}
function defaultComparer(Bi, e) {
  return Object.is ? Object.is(Bi, e) : Bi === e ? Bi !== 0 || 1 / Bi === 1 / e : Bi !== Bi && e !== e;
}
var comparer = {
  structural: structuralComparer,
  default: defaultComparer
};
function deepEnhancer(Bi, e, qi) {
  return isObservable(Bi) ? Bi : Array.isArray(Bi) ? observable.array(Bi, {
    name: qi
  }) : isPlainObject$2(Bi) ? observable.object(Bi, void 0, {
    name: qi
  }) : isES6Map(Bi) ? observable.map(Bi, {
    name: qi
  }) : isES6Set(Bi) ? observable.set(Bi, {
    name: qi
  }) : typeof Bi == "function" && !isAction(Bi) && !isFlow(Bi) ? isGenerator(Bi) ? flow(Bi) : autoAction(qi, Bi) : Bi;
}
function shallowEnhancer(Bi, e, qi) {
  if (Bi == null || isObservableObject(Bi) || isObservableArray(Bi) || isObservableMap(Bi) || isObservableSet(Bi))
    return Bi;
  if (Array.isArray(Bi))
    return observable.array(Bi, {
      name: qi,
      deep: !1
    });
  if (isPlainObject$2(Bi))
    return observable.object(Bi, void 0, {
      name: qi,
      deep: !1
    });
  if (isES6Map(Bi))
    return observable.map(Bi, {
      name: qi,
      deep: !1
    });
  if (isES6Set(Bi))
    return observable.set(Bi, {
      name: qi,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(Bi) {
  return Bi;
}
function refStructEnhancer(Bi, e) {
  return process.env.NODE_ENV !== "production" && isObservable(Bi) && die("observable.struct should not be used with observable values"), deepEqual$1(Bi, e) ? e : Bi;
}
var OVERRIDE = "override";
function isOverride(Bi) {
  return Bi.annotationType_ === OVERRIDE;
}
function createActionAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$1,
    extend_: extend_$1,
    decorate_20223_: decorate_20223_$1
  };
}
function make_$1(Bi, e, qi, Xi) {
  var Qi;
  if ((Qi = this.options_) != null && Qi.bound)
    return this.extend_(Bi, e, qi, !1) === null ? 0 : 1;
  if (Xi === Bi.target_)
    return this.extend_(Bi, e, qi, !1) === null ? 0 : 2;
  if (isAction(qi.value))
    return 1;
  var ta = createActionDescriptor(Bi, this, e, qi, !1);
  return defineProperty(Xi, e, ta), 2;
}
function extend_$1(Bi, e, qi, Xi) {
  var Qi = createActionDescriptor(Bi, this, e, qi);
  return Bi.defineProperty_(e, Qi, Xi);
}
function decorate_20223_$1(Bi, e) {
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["method", "field"]);
  var qi = e.kind, Xi = e.name, Qi = e.addInitializer, ta = this, ra = function(Ma) {
    var Va, to, Eo, So;
    return createAction((Va = (to = ta.options_) == null ? void 0 : to.name) != null ? Va : Xi.toString(), Ma, (Eo = (So = ta.options_) == null ? void 0 : So.autoAction) != null ? Eo : !1);
  };
  if (qi == "field") {
    Qi(function() {
      storeAnnotation(this, Xi, ta);
    });
    return;
  }
  if (qi == "method") {
    var na;
    return isAction(Bi) || (Bi = ra(Bi)), (na = this.options_) != null && na.bound && Qi(function() {
      var la = this, Ma = la[Xi].bind(la);
      Ma.isMobxAction = !0, la[Xi] = Ma;
    }), Bi;
  }
  die("Cannot apply '" + ta.annotationType_ + "' to '" + String(Xi) + "' (kind: " + qi + "):" + (`
'` + ta.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(Bi, e, qi, Xi) {
  var Qi = e.annotationType_, ta = Xi.value;
  process.env.NODE_ENV !== "production" && !isFunction$1(ta) && die("Cannot apply '" + Qi + "' to '" + Bi.name_ + "." + qi.toString() + "':" + (`
'` + Qi + "' can only be used on properties with a function value."));
}
function createActionDescriptor(Bi, e, qi, Xi, Qi) {
  var ta, ra, na, la, Ma, Va, to;
  Qi === void 0 && (Qi = globalState.safeDescriptors), assertActionDescriptor(Bi, e, qi, Xi);
  var Eo = Xi.value;
  if ((ta = e.options_) != null && ta.bound) {
    var So;
    Eo = Eo.bind((So = Bi.proxy_) != null ? So : Bi.target_);
  }
  return {
    value: createAction(
      (ra = (na = e.options_) == null ? void 0 : na.name) != null ? ra : qi.toString(),
      Eo,
      (la = (Ma = e.options_) == null ? void 0 : Ma.autoAction) != null ? la : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (Va = e.options_) != null && Va.bound ? (to = Bi.proxy_) != null ? to : Bi.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: Qi ? Bi.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !Qi
  };
}
function createFlowAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$2,
    extend_: extend_$2,
    decorate_20223_: decorate_20223_$2
  };
}
function make_$2(Bi, e, qi, Xi) {
  var Qi;
  if (Xi === Bi.target_)
    return this.extend_(Bi, e, qi, !1) === null ? 0 : 2;
  if ((Qi = this.options_) != null && Qi.bound && (!hasProp(Bi.target_, e) || !isFlow(Bi.target_[e])) && this.extend_(Bi, e, qi, !1) === null)
    return 0;
  if (isFlow(qi.value))
    return 1;
  var ta = createFlowDescriptor(Bi, this, e, qi, !1, !1);
  return defineProperty(Xi, e, ta), 2;
}
function extend_$2(Bi, e, qi, Xi) {
  var Qi, ta = createFlowDescriptor(Bi, this, e, qi, (Qi = this.options_) == null ? void 0 : Qi.bound);
  return Bi.defineProperty_(e, ta, Xi);
}
function decorate_20223_$2(Bi, e) {
  var qi;
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["method"]);
  var Xi = e.name, Qi = e.addInitializer;
  return isFlow(Bi) || (Bi = flow(Bi)), (qi = this.options_) != null && qi.bound && Qi(function() {
    var ta = this, ra = ta[Xi].bind(ta);
    ra.isMobXFlow = !0, ta[Xi] = ra;
  }), Bi;
}
function assertFlowDescriptor(Bi, e, qi, Xi) {
  var Qi = e.annotationType_, ta = Xi.value;
  process.env.NODE_ENV !== "production" && !isFunction$1(ta) && die("Cannot apply '" + Qi + "' to '" + Bi.name_ + "." + qi.toString() + "':" + (`
'` + Qi + "' can only be used on properties with a generator function value."));
}
function createFlowDescriptor(Bi, e, qi, Xi, Qi, ta) {
  ta === void 0 && (ta = globalState.safeDescriptors), assertFlowDescriptor(Bi, e, qi, Xi);
  var ra = Xi.value;
  if (isFlow(ra) || (ra = flow(ra)), Qi) {
    var na;
    ra = ra.bind((na = Bi.proxy_) != null ? na : Bi.target_), ra.isMobXFlow = !0;
  }
  return {
    value: ra,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: ta ? Bi.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !ta
  };
}
function createComputedAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$3,
    extend_: extend_$3,
    decorate_20223_: decorate_20223_$3
  };
}
function make_$3(Bi, e, qi) {
  return this.extend_(Bi, e, qi, !1) === null ? 0 : 1;
}
function extend_$3(Bi, e, qi, Xi) {
  return assertComputedDescriptor(Bi, this, e, qi), Bi.defineComputedProperty_(e, _extends({}, this.options_, {
    get: qi.get,
    set: qi.set
  }), Xi);
}
function decorate_20223_$3(Bi, e) {
  process.env.NODE_ENV !== "production" && assert20223DecoratorType(e, ["getter"]);
  var qi = this, Xi = e.name, Qi = e.addInitializer;
  return Qi(function() {
    var ta = asObservableObject(this)[$mobx], ra = _extends({}, qi.options_, {
      get: Bi,
      context: this
    });
    ra.name || (ra.name = process.env.NODE_ENV !== "production" ? ta.name_ + "." + Xi.toString() : "ObservableObject." + Xi.toString()), ta.values_.set(Xi, new ComputedValue(ra));
  }), function() {
    return this[$mobx].getObservablePropValue_(Xi);
  };
}
function assertComputedDescriptor(Bi, e, qi, Xi) {
  var Qi = e.annotationType_, ta = Xi.get;
  process.env.NODE_ENV !== "production" && !ta && die("Cannot apply '" + Qi + "' to '" + Bi.name_ + "." + qi.toString() + "':" + (`
'` + Qi + "' can only be used on getter(+setter) properties."));
}
function createObservableAnnotation(Bi, e) {
  return {
    annotationType_: Bi,
    options_: e,
    make_: make_$4,
    extend_: extend_$4,
    decorate_20223_: decorate_20223_$4
  };
}
function make_$4(Bi, e, qi) {
  return this.extend_(Bi, e, qi, !1) === null ? 0 : 1;
}
function extend_$4(Bi, e, qi, Xi) {
  var Qi, ta;
  return assertObservableDescriptor(Bi, this, e, qi), Bi.defineObservableProperty_(e, qi.value, (Qi = (ta = this.options_) == null ? void 0 : ta.enhancer) != null ? Qi : deepEnhancer, Xi);
}
function decorate_20223_$4(Bi, e) {
  if (process.env.NODE_ENV !== "production") {
    if (e.kind === "field")
      throw die("Please use `@observable accessor " + String(e.name) + "` instead of `@observable " + String(e.name) + "`");
    assert20223DecoratorType(e, ["accessor"]);
  }
  var qi = this, Xi = e.kind, Qi = e.name, ta = /* @__PURE__ */ new WeakSet();
  function ra(na, la) {
    var Ma, Va, to = asObservableObject(na)[$mobx], Eo = new ObservableValue(la, (Ma = (Va = qi.options_) == null ? void 0 : Va.enhancer) != null ? Ma : deepEnhancer, process.env.NODE_ENV !== "production" ? to.name_ + "." + Qi.toString() : "ObservableObject." + Qi.toString(), !1);
    to.values_.set(Qi, Eo), ta.add(na);
  }
  if (Xi == "accessor")
    return {
      get: function() {
        return ta.has(this) || ra(this, Bi.get.call(this)), this[$mobx].getObservablePropValue_(Qi);
      },
      set: function(la) {
        return ta.has(this) || ra(this, la), this[$mobx].setObservablePropValue_(Qi, la);
      },
      init: function(la) {
        return ta.has(this) || ra(this, la), la;
      }
    };
}
function assertObservableDescriptor(Bi, e, qi, Xi) {
  var Qi = e.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in Xi) && die("Cannot apply '" + Qi + "' to '" + Bi.name_ + "." + qi.toString() + "':" + (`
'` + Qi + "' cannot be used on getter/setter properties"));
}
var AUTO = "true", autoAnnotation = /* @__PURE__ */ createAutoAnnotation();
function createAutoAnnotation(Bi) {
  return {
    annotationType_: AUTO,
    options_: Bi,
    make_: make_$5,
    extend_: extend_$5,
    decorate_20223_: decorate_20223_$5
  };
}
function make_$5(Bi, e, qi, Xi) {
  var Qi, ta;
  if (qi.get)
    return computed.make_(Bi, e, qi, Xi);
  if (qi.set) {
    var ra = createAction(e.toString(), qi.set);
    return Xi === Bi.target_ ? Bi.defineProperty_(e, {
      configurable: globalState.safeDescriptors ? Bi.isPlainObject_ : !0,
      set: ra
    }) === null ? 0 : 2 : (defineProperty(Xi, e, {
      configurable: !0,
      set: ra
    }), 2);
  }
  if (Xi !== Bi.target_ && typeof qi.value == "function") {
    var na;
    if (isGenerator(qi.value)) {
      var la, Ma = (la = this.options_) != null && la.autoBind ? flow.bound : flow;
      return Ma.make_(Bi, e, qi, Xi);
    }
    var Va = (na = this.options_) != null && na.autoBind ? autoAction.bound : autoAction;
    return Va.make_(Bi, e, qi, Xi);
  }
  var to = ((Qi = this.options_) == null ? void 0 : Qi.deep) === !1 ? observable.ref : observable;
  if (typeof qi.value == "function" && (ta = this.options_) != null && ta.autoBind) {
    var Eo;
    qi.value = qi.value.bind((Eo = Bi.proxy_) != null ? Eo : Bi.target_);
  }
  return to.make_(Bi, e, qi, Xi);
}
function extend_$5(Bi, e, qi, Xi) {
  var Qi, ta;
  if (qi.get)
    return computed.extend_(Bi, e, qi, Xi);
  if (qi.set)
    return Bi.defineProperty_(e, {
      configurable: globalState.safeDescriptors ? Bi.isPlainObject_ : !0,
      set: createAction(e.toString(), qi.set)
    }, Xi);
  if (typeof qi.value == "function" && (Qi = this.options_) != null && Qi.autoBind) {
    var ra;
    qi.value = qi.value.bind((ra = Bi.proxy_) != null ? ra : Bi.target_);
  }
  var na = ((ta = this.options_) == null ? void 0 : ta.deep) === !1 ? observable.ref : observable;
  return na.extend_(Bi, e, qi, Xi);
}
function decorate_20223_$5(Bi, e) {
  die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable", OBSERVABLE_REF = "observable.ref", OBSERVABLE_SHALLOW = "observable.shallow", OBSERVABLE_STRUCT = "observable.struct", defaultCreateObservableOptions = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(Bi) {
  return Bi || defaultCreateObservableOptions;
}
var observableAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE), observableRefAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_REF, {
  enhancer: referenceEnhancer
}), observableShallowAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_SHALLOW, {
  enhancer: shallowEnhancer
}), observableStructAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_STRUCT, {
  enhancer: refStructEnhancer
}), observableDecoratorAnnotation = /* @__PURE__ */ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(Bi) {
  return Bi.deep === !0 ? deepEnhancer : Bi.deep === !1 ? referenceEnhancer : getEnhancerFromAnnotation(Bi.defaultDecorator);
}
function getAnnotationFromOptions(Bi) {
  var e;
  return Bi ? (e = Bi.defaultDecorator) != null ? e : createAutoAnnotation(Bi) : void 0;
}
function getEnhancerFromAnnotation(Bi) {
  var e, qi;
  return Bi && (e = (qi = Bi.options_) == null ? void 0 : qi.enhancer) != null ? e : deepEnhancer;
}
function createObservable(Bi, e, qi) {
  if (is20223Decorator(e))
    return observableAnnotation.decorate_20223_(Bi, e);
  if (isStringish(e)) {
    storeAnnotation(Bi, e, observableAnnotation);
    return;
  }
  return isObservable(Bi) ? Bi : isPlainObject$2(Bi) ? observable.object(Bi, e, qi) : Array.isArray(Bi) ? observable.array(Bi, e) : isES6Map(Bi) ? observable.map(Bi, e) : isES6Set(Bi) ? observable.set(Bi, e) : typeof Bi == "object" && Bi !== null ? Bi : observable.box(Bi, e);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
  box: function(e, qi) {
    var Xi = asCreateObservableOptions(qi);
    return new ObservableValue(e, getEnhancerFromOptions(Xi), Xi.name, !0, Xi.equals);
  },
  array: function(e, qi) {
    var Xi = asCreateObservableOptions(qi);
    return (globalState.useProxies === !1 || Xi.proxy === !1 ? createLegacyArray : createObservableArray)(e, getEnhancerFromOptions(Xi), Xi.name);
  },
  map: function(e, qi) {
    var Xi = asCreateObservableOptions(qi);
    return new ObservableMap(e, getEnhancerFromOptions(Xi), Xi.name);
  },
  set: function(e, qi) {
    var Xi = asCreateObservableOptions(qi);
    return new ObservableSet(e, getEnhancerFromOptions(Xi), Xi.name);
  },
  object: function(e, qi, Xi) {
    return initObservable(function() {
      return extendObservable(globalState.useProxies === !1 || Xi?.proxy === !1 ? asObservableObject({}, Xi) : asDynamicObservableObject({}, Xi), e, qi);
    });
  },
  ref: /* @__PURE__ */ createDecoratorAnnotation(observableRefAnnotation),
  shallow: /* @__PURE__ */ createDecoratorAnnotation(observableShallowAnnotation),
  deep: observableDecoratorAnnotation,
  struct: /* @__PURE__ */ createDecoratorAnnotation(observableStructAnnotation)
}, observable = /* @__PURE__ */ assign(createObservable, observableFactories), COMPUTED = "computed", COMPUTED_STRUCT = "computed.struct", computedAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED), computedStructAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED_STRUCT, {
  equals: comparer.structural
}), computed = function(e, qi) {
  if (is20223Decorator(qi))
    return computedAnnotation.decorate_20223_(e, qi);
  if (isStringish(qi))
    return storeAnnotation(e, qi, computedAnnotation);
  if (isPlainObject$2(e))
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, e));
  process.env.NODE_ENV !== "production" && (isFunction$1(e) || die("First argument to `computed` should be an expression."), isFunction$1(qi) && die("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var Xi = isPlainObject$2(qi) ? qi : {};
  return Xi.get = e, Xi.name || (Xi.name = e.name || ""), new ComputedValue(Xi);
};
Object.assign(computed, computedAnnotation);
computed.struct = /* @__PURE__ */ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor, currentActionId = 0, nextActionId = 1, isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /* @__PURE__ */ getDescriptor(function() {
}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : !1, tmpNameDescriptor = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function createAction(Bi, e, qi, Xi) {
  qi === void 0 && (qi = !1), process.env.NODE_ENV !== "production" && (isFunction$1(e) || die("`action` can only be invoked on functions"), (typeof Bi != "string" || !Bi) && die("actions should have valid names, got: '" + Bi + "'"));
  function Qi() {
    return executeAction(Bi, qi, e, Xi || this, arguments);
  }
  return Qi.isMobxAction = !0, Qi.toString = function() {
    return e.toString();
  }, isFunctionNameConfigurable && (tmpNameDescriptor.value = Bi, defineProperty(Qi, "name", tmpNameDescriptor)), Qi;
}
function executeAction(Bi, e, qi, Xi, Qi) {
  var ta = _startAction(Bi, e, Xi, Qi);
  try {
    return qi.apply(Xi, Qi);
  } catch (ra) {
    throw ta.error_ = ra, ra;
  } finally {
    _endAction(ta);
  }
}
function _startAction(Bi, e, qi, Xi) {
  var Qi = process.env.NODE_ENV !== "production" && isSpyEnabled() && !!Bi, ta = 0;
  if (process.env.NODE_ENV !== "production" && Qi) {
    ta = Date.now();
    var ra = Xi ? Array.from(Xi) : EMPTY_ARRAY;
    spyReportStart({
      type: ACTION,
      name: Bi,
      object: qi,
      arguments: ra
    });
  }
  var na = globalState.trackingDerivation, la = !e || !na;
  startBatch();
  var Ma = globalState.allowStateChanges;
  la && (untrackedStart(), Ma = allowStateChangesStart(!0));
  var Va = allowStateReadsStart(!0), to = {
    runAsAction_: la,
    prevDerivation_: na,
    prevAllowStateChanges_: Ma,
    prevAllowStateReads_: Va,
    notifySpy_: Qi,
    startTime_: ta,
    actionId_: nextActionId++,
    parentActionId_: currentActionId
  };
  return currentActionId = to.actionId_, to;
}
function _endAction(Bi) {
  currentActionId !== Bi.actionId_ && die(30), currentActionId = Bi.parentActionId_, Bi.error_ !== void 0 && (globalState.suppressReactionErrors = !0), allowStateChangesEnd(Bi.prevAllowStateChanges_), allowStateReadsEnd(Bi.prevAllowStateReads_), endBatch(), Bi.runAsAction_ && untrackedEnd(Bi.prevDerivation_), process.env.NODE_ENV !== "production" && Bi.notifySpy_ && spyReportEnd({
    time: Date.now() - Bi.startTime_
  }), globalState.suppressReactionErrors = !1;
}
function allowStateChanges(Bi, e) {
  var qi = allowStateChangesStart(Bi);
  try {
    return e();
  } finally {
    allowStateChangesEnd(qi);
  }
}
function allowStateChangesStart(Bi) {
  var e = globalState.allowStateChanges;
  return globalState.allowStateChanges = Bi, e;
}
function allowStateChangesEnd(Bi) {
  globalState.allowStateChanges = Bi;
}
var _Symbol$toPrimitive, CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /* @__PURE__ */ function(Bi) {
  _inheritsLoose(e, Bi);
  function e(Xi, Qi, ta, ra, na) {
    var la;
    return ta === void 0 && (ta = process.env.NODE_ENV !== "production" ? "ObservableValue@" + getNextId() : "ObservableValue"), ra === void 0 && (ra = !0), na === void 0 && (na = comparer.default), la = Bi.call(this, ta) || this, la.enhancer = void 0, la.name_ = void 0, la.equals = void 0, la.hasUnreportedChange_ = !1, la.interceptors_ = void 0, la.changeListeners_ = void 0, la.value_ = void 0, la.dehancer = void 0, la.enhancer = Qi, la.name_ = ta, la.equals = na, la.value_ = Qi(Xi, void 0, ta), process.env.NODE_ENV !== "production" && ra && isSpyEnabled() && spyReport({
      type: CREATE,
      object: _assertThisInitialized(la),
      observableKind: "value",
      debugObjectName: la.name_,
      newValue: "" + la.value_
    }), la;
  }
  var qi = e.prototype;
  return qi.dehanceValue = function(Qi) {
    return this.dehancer !== void 0 ? this.dehancer(Qi) : Qi;
  }, qi.set = function(Qi) {
    var ta = this.value_;
    if (Qi = this.prepareNewValue_(Qi), Qi !== globalState.UNCHANGED) {
      var ra = isSpyEnabled();
      process.env.NODE_ENV !== "production" && ra && spyReportStart({
        type: UPDATE,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: Qi,
        oldValue: ta
      }), this.setNewValue_(Qi), process.env.NODE_ENV !== "production" && ra && spyReportEnd();
    }
  }, qi.prepareNewValue_ = function(Qi) {
    if (checkIfStateModificationsAreAllowed(this), hasInterceptors(this)) {
      var ta = interceptChange(this, {
        object: this,
        type: UPDATE,
        newValue: Qi
      });
      if (!ta)
        return globalState.UNCHANGED;
      Qi = ta.newValue;
    }
    return Qi = this.enhancer(Qi, this.value_, this.name_), this.equals(this.value_, Qi) ? globalState.UNCHANGED : Qi;
  }, qi.setNewValue_ = function(Qi) {
    var ta = this.value_;
    this.value_ = Qi, this.reportChanged(), hasListeners(this) && notifyListeners(this, {
      type: UPDATE,
      object: this,
      newValue: Qi,
      oldValue: ta
    });
  }, qi.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, qi.intercept_ = function(Qi) {
    return registerInterceptor(this, Qi);
  }, qi.observe_ = function(Qi, ta) {
    return ta && Qi({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: UPDATE,
      newValue: this.value_,
      oldValue: void 0
    }), registerListener(this, Qi);
  }, qi.raw = function() {
    return this.value_;
  }, qi.toJSON = function() {
    return this.get();
  }, qi.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, qi.valueOf = function() {
    return toPrimitive(this.get());
  }, qi[_Symbol$toPrimitive] = function() {
    return this.valueOf();
  }, e;
}(Atom), _Symbol$toPrimitive$1;
_Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /* @__PURE__ */ function() {
  function Bi(qi) {
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new CaughtException(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = TraceMode.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, qi.get || die(31), this.derivation = qi.get, this.name_ = qi.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + getNextId() : "ComputedValue"), qi.set && (this.setter_ = createAction(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", qi.set)), this.equals_ = qi.equals || (qi.compareStructural || qi.struct ? comparer.structural : comparer.default), this.scope_ = qi.context, this.requiresReaction_ = qi.requiresReaction, this.keepAlive_ = !!qi.keepAlive;
  }
  var e = Bi.prototype;
  return e.onBecomeStale_ = function() {
    propagateMaybeChanged(this);
  }, e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(Xi) {
      return Xi();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(Xi) {
      return Xi();
    });
  }, e.get = function() {
    if (this.isComputing_ && die(32, this.name_, this.derivation), globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      shouldCompute(this) && (this.warnAboutUntrackedRead_(), startBatch(), this.value_ = this.computeValue_(!1), endBatch());
    else if (reportObserved(this), shouldCompute(this)) {
      var Xi = globalState.trackingContext;
      this.keepAlive_ && !Xi && (globalState.trackingContext = this), this.trackAndCompute() && propagateChangeConfirmed(this), globalState.trackingContext = Xi;
    }
    var Qi = this.value_;
    if (isCaughtException(Qi))
      throw Qi.cause;
    return Qi;
  }, e.set = function(Xi) {
    if (this.setter_) {
      this.isRunningSetter_ && die(33, this.name_), this.isRunningSetter_ = !0;
      try {
        this.setter_.call(this.scope_, Xi);
      } finally {
        this.isRunningSetter_ = !1;
      }
    } else
      die(34, this.name_);
  }, e.trackAndCompute = function() {
    var Xi = this.value_, Qi = (
      /* see #1208 */
      this.dependenciesState_ === IDerivationState_.NOT_TRACKING_
    ), ta = this.computeValue_(!0), ra = Qi || isCaughtException(Xi) || isCaughtException(ta) || !this.equals_(Xi, ta);
    return ra && (this.value_ = ta, process.env.NODE_ENV !== "production" && isSpyEnabled() && spyReport({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: Xi,
      newValue: ta
    })), ra;
  }, e.computeValue_ = function(Xi) {
    this.isComputing_ = !0;
    var Qi = allowStateChangesStart(!1), ta;
    if (Xi)
      ta = trackDerivedFunction(this, this.derivation, this.scope_);
    else if (globalState.disableErrorBoundaries === !0)
      ta = this.derivation.call(this.scope_);
    else
      try {
        ta = this.derivation.call(this.scope_);
      } catch (ra) {
        ta = new CaughtException(ra);
      }
    return allowStateChangesEnd(Qi), this.isComputing_ = !1, ta;
  }, e.suspend_ = function() {
    this.keepAlive_ || (clearObserving(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== TraceMode.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, e.observe_ = function(Xi, Qi) {
    var ta = this, ra = !0, na = void 0;
    return autorun(function() {
      var la = ta.get();
      if (!ra || Qi) {
        var Ma = untrackedStart();
        Xi({
          observableKind: "computed",
          debugObjectName: ta.name_,
          type: UPDATE,
          object: ta,
          newValue: la,
          oldValue: na
        }), untrackedEnd(Ma);
      }
      ra = !1, na = la;
    });
  }, e.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== TraceMode.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, e.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, e.valueOf = function() {
    return toPrimitive(this.get());
  }, e[_Symbol$toPrimitive$1] = function() {
    return this.valueOf();
  }, Bi;
}(), isComputedValue = /* @__PURE__ */ createInstanceofPredicate("ComputedValue", ComputedValue), IDerivationState_;
(function(Bi) {
  Bi[Bi.NOT_TRACKING_ = -1] = "NOT_TRACKING_", Bi[Bi.UP_TO_DATE_ = 0] = "UP_TO_DATE_", Bi[Bi.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", Bi[Bi.STALE_ = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(Bi) {
  Bi[Bi.NONE = 0] = "NONE", Bi[Bi.LOG = 1] = "LOG", Bi[Bi.BREAK = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function(e) {
  this.cause = void 0, this.cause = e;
};
function isCaughtException(Bi) {
  return Bi instanceof CaughtException;
}
function shouldCompute(Bi) {
  switch (Bi.dependenciesState_) {
    case IDerivationState_.UP_TO_DATE_:
      return !1;
    case IDerivationState_.NOT_TRACKING_:
    case IDerivationState_.STALE_:
      return !0;
    case IDerivationState_.POSSIBLY_STALE_: {
      for (var e = allowStateReadsStart(!0), qi = untrackedStart(), Xi = Bi.observing_, Qi = Xi.length, ta = 0; ta < Qi; ta++) {
        var ra = Xi[ta];
        if (isComputedValue(ra)) {
          if (globalState.disableErrorBoundaries)
            ra.get();
          else
            try {
              ra.get();
            } catch {
              return untrackedEnd(qi), allowStateReadsEnd(e), !0;
            }
          if (Bi.dependenciesState_ === IDerivationState_.STALE_)
            return untrackedEnd(qi), allowStateReadsEnd(e), !0;
        }
      }
      return changeDependenciesStateTo0(Bi), untrackedEnd(qi), allowStateReadsEnd(e), !1;
    }
  }
}
function checkIfStateModificationsAreAllowed(Bi) {
  if (process.env.NODE_ENV !== "production") {
    var e = Bi.observers_.size > 0;
    !globalState.allowStateChanges && (e || globalState.enforceActions === "always") && console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + Bi.name_);
  }
}
function checkIfStateReadsAreAllowed(Bi) {
  process.env.NODE_ENV !== "production" && !globalState.allowStateReads && globalState.observableRequiresReaction && console.warn("[mobx] Observable '" + Bi.name_ + "' being read outside a reactive context.");
}
function trackDerivedFunction(Bi, e, qi) {
  var Xi = allowStateReadsStart(!0);
  changeDependenciesStateTo0(Bi), Bi.newObserving_ = new Array(Bi.observing_.length + 100), Bi.unboundDepsCount_ = 0, Bi.runId_ = ++globalState.runId;
  var Qi = globalState.trackingDerivation;
  globalState.trackingDerivation = Bi, globalState.inBatch++;
  var ta;
  if (globalState.disableErrorBoundaries === !0)
    ta = e.call(qi);
  else
    try {
      ta = e.call(qi);
    } catch (ra) {
      ta = new CaughtException(ra);
    }
  return globalState.inBatch--, globalState.trackingDerivation = Qi, bindDependencies(Bi), warnAboutDerivationWithoutDependencies(Bi), allowStateReadsEnd(Xi), ta;
}
function warnAboutDerivationWithoutDependencies(Bi) {
  process.env.NODE_ENV !== "production" && Bi.observing_.length === 0 && (typeof Bi.requiresObservable_ == "boolean" ? Bi.requiresObservable_ : globalState.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + Bi.name_ + "' is created/updated without reading any observable value.");
}
function bindDependencies(Bi) {
  for (var e = Bi.observing_, qi = Bi.observing_ = Bi.newObserving_, Xi = IDerivationState_.UP_TO_DATE_, Qi = 0, ta = Bi.unboundDepsCount_, ra = 0; ra < ta; ra++) {
    var na = qi[ra];
    na.diffValue_ === 0 && (na.diffValue_ = 1, Qi !== ra && (qi[Qi] = na), Qi++), na.dependenciesState_ > Xi && (Xi = na.dependenciesState_);
  }
  for (qi.length = Qi, Bi.newObserving_ = null, ta = e.length; ta--; ) {
    var la = e[ta];
    la.diffValue_ === 0 && removeObserver(la, Bi), la.diffValue_ = 0;
  }
  for (; Qi--; ) {
    var Ma = qi[Qi];
    Ma.diffValue_ === 1 && (Ma.diffValue_ = 0, addObserver(Ma, Bi));
  }
  Xi !== IDerivationState_.UP_TO_DATE_ && (Bi.dependenciesState_ = Xi, Bi.onBecomeStale_());
}
function clearObserving(Bi) {
  var e = Bi.observing_;
  Bi.observing_ = [];
  for (var qi = e.length; qi--; )
    removeObserver(e[qi], Bi);
  Bi.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(Bi) {
  var e = untrackedStart();
  try {
    return Bi();
  } finally {
    untrackedEnd(e);
  }
}
function untrackedStart() {
  var Bi = globalState.trackingDerivation;
  return globalState.trackingDerivation = null, Bi;
}
function untrackedEnd(Bi) {
  globalState.trackingDerivation = Bi;
}
function allowStateReadsStart(Bi) {
  var e = globalState.allowStateReads;
  return globalState.allowStateReads = Bi, e;
}
function allowStateReadsEnd(Bi) {
  globalState.allowStateReads = Bi;
}
function changeDependenciesStateTo0(Bi) {
  if (Bi.dependenciesState_ !== IDerivationState_.UP_TO_DATE_) {
    Bi.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    for (var e = Bi.observing_, qi = e.length; qi--; )
      e[qi].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
  }
}
var MobXGlobals = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, canMergeGlobalState = !0, isolateCalled = !1, globalState = /* @__PURE__ */ function() {
  var Bi = /* @__PURE__ */ getGlobal();
  return Bi.__mobxInstanceCount > 0 && !Bi.__mobxGlobals && (canMergeGlobalState = !1), Bi.__mobxGlobals && Bi.__mobxGlobals.version !== new MobXGlobals().version && (canMergeGlobalState = !1), canMergeGlobalState ? Bi.__mobxGlobals ? (Bi.__mobxInstanceCount += 1, Bi.__mobxGlobals.UNCHANGED || (Bi.__mobxGlobals.UNCHANGED = {}), Bi.__mobxGlobals) : (Bi.__mobxInstanceCount = 1, Bi.__mobxGlobals = /* @__PURE__ */ new MobXGlobals()) : (setTimeout(function() {
    isolateCalled || die(35);
  }, 1), new MobXGlobals());
}();
function isolateGlobalState() {
  if ((globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) && die(36), isolateCalled = !0, canMergeGlobalState) {
    var Bi = getGlobal();
    --Bi.__mobxInstanceCount === 0 && (Bi.__mobxGlobals = void 0), globalState = new MobXGlobals();
  }
}
function getGlobalState() {
  return globalState;
}
function addObserver(Bi, e) {
  Bi.observers_.add(e), Bi.lowestObserverState_ > e.dependenciesState_ && (Bi.lowestObserverState_ = e.dependenciesState_);
}
function removeObserver(Bi, e) {
  Bi.observers_.delete(e), Bi.observers_.size === 0 && queueForUnobservation(Bi);
}
function queueForUnobservation(Bi) {
  Bi.isPendingUnobservation_ === !1 && (Bi.isPendingUnobservation_ = !0, globalState.pendingUnobservations.push(Bi));
}
function startBatch() {
  globalState.inBatch++;
}
function endBatch() {
  if (--globalState.inBatch === 0) {
    runReactions();
    for (var Bi = globalState.pendingUnobservations, e = 0; e < Bi.length; e++) {
      var qi = Bi[e];
      qi.isPendingUnobservation_ = !1, qi.observers_.size === 0 && (qi.isBeingObserved_ && (qi.isBeingObserved_ = !1, qi.onBUO()), qi instanceof ComputedValue && qi.suspend_());
    }
    globalState.pendingUnobservations = [];
  }
}
function reportObserved(Bi) {
  checkIfStateReadsAreAllowed(Bi);
  var e = globalState.trackingDerivation;
  return e !== null ? (e.runId_ !== Bi.lastAccessedBy_ && (Bi.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = Bi, !Bi.isBeingObserved_ && globalState.trackingContext && (Bi.isBeingObserved_ = !0, Bi.onBO())), Bi.isBeingObserved_) : (Bi.observers_.size === 0 && globalState.inBatch > 0 && queueForUnobservation(Bi), !1);
}
function propagateChanged(Bi) {
  Bi.lowestObserverState_ !== IDerivationState_.STALE_ && (Bi.lowestObserverState_ = IDerivationState_.STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && e.isTracing_ !== TraceMode.NONE && logTraceInfo(e, Bi), e.onBecomeStale_()), e.dependenciesState_ = IDerivationState_.STALE_;
  }));
}
function propagateChangeConfirmed(Bi) {
  Bi.lowestObserverState_ !== IDerivationState_.STALE_ && (Bi.lowestObserverState_ = IDerivationState_.STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_ ? (e.dependenciesState_ = IDerivationState_.STALE_, process.env.NODE_ENV !== "production" && e.isTracing_ !== TraceMode.NONE && logTraceInfo(e, Bi)) : e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (Bi.lowestObserverState_ = IDerivationState_.UP_TO_DATE_);
  }));
}
function propagateMaybeChanged(Bi) {
  Bi.lowestObserverState_ === IDerivationState_.UP_TO_DATE_ && (Bi.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_, Bi.observers_.forEach(function(e) {
    e.dependenciesState_ === IDerivationState_.UP_TO_DATE_ && (e.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_, e.onBecomeStale_());
  }));
}
function logTraceInfo(Bi, e) {
  if (console.log("[mobx.trace] '" + Bi.name_ + "' is invalidated due to a change in: '" + e.name_ + "'"), Bi.isTracing_ === TraceMode.BREAK) {
    var qi = [];
    printDepTree(getDependencyTree(Bi), qi, 1), new Function(`debugger;
/*
Tracing '` + Bi.name_ + `'

You are entering this break point because derivation '` + Bi.name_ + "' is being traced and '" + e.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (Bi instanceof ComputedValue ? Bi.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + qi.join(`
`) + `
*/
    `)();
  }
}
function printDepTree(Bi, e, qi) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }
  e.push("" + "	".repeat(qi - 1) + Bi.name), Bi.dependencies && Bi.dependencies.forEach(function(Xi) {
    return printDepTree(Xi, e, qi + 1);
  });
}
var Reaction = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi, ta) {
    qi === void 0 && (qi = process.env.NODE_ENV !== "production" ? "Reaction@" + getNextId() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = IDerivationState_.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = TraceMode.NONE, this.name_ = qi, this.onInvalidate_ = Xi, this.errorHandler_ = Qi, this.requiresObservable_ = ta;
  }
  var e = Bi.prototype;
  return e.onBecomeStale_ = function() {
    this.schedule_();
  }, e.schedule_ = function() {
    this.isScheduled_ || (this.isScheduled_ = !0, globalState.pendingReactions.push(this), runReactions());
  }, e.isScheduled = function() {
    return this.isScheduled_;
  }, e.runReaction_ = function() {
    if (!this.isDisposed_) {
      startBatch(), this.isScheduled_ = !1;
      var Xi = globalState.trackingContext;
      if (globalState.trackingContext = this, shouldCompute(this)) {
        this.isTrackPending_ = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending_ && isSpyEnabled() && spyReport({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (Qi) {
          this.reportExceptionInDerivation_(Qi);
        }
      }
      globalState.trackingContext = Xi, endBatch();
    }
  }, e.track = function(Xi) {
    if (!this.isDisposed_) {
      startBatch();
      var Qi = isSpyEnabled(), ta;
      process.env.NODE_ENV !== "production" && Qi && (ta = Date.now(), spyReportStart({
        name: this.name_,
        type: "reaction"
      })), this.isRunning_ = !0;
      var ra = globalState.trackingContext;
      globalState.trackingContext = this;
      var na = trackDerivedFunction(this, Xi, void 0);
      globalState.trackingContext = ra, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && clearObserving(this), isCaughtException(na) && this.reportExceptionInDerivation_(na.cause), process.env.NODE_ENV !== "production" && Qi && spyReportEnd({
        time: Date.now() - ta
      }), endBatch();
    }
  }, e.reportExceptionInDerivation_ = function(Xi) {
    var Qi = this;
    if (this.errorHandler_) {
      this.errorHandler_(Xi, this);
      return;
    }
    if (globalState.disableErrorBoundaries)
      throw Xi;
    var ta = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    globalState.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(ta, Xi), process.env.NODE_ENV !== "production" && isSpyEnabled() && spyReport({
      type: "error",
      name: this.name_,
      message: ta,
      error: "" + Xi
    }), globalState.globalReactionErrorHandlers.forEach(function(ra) {
      return ra(Xi, Qi);
    });
  }, e.dispose = function() {
    this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (startBatch(), clearObserving(this), endBatch()));
  }, e.getDisposer_ = function(Xi) {
    var Qi = this, ta = function ra() {
      Qi.dispose(), Xi == null || Xi.removeEventListener == null || Xi.removeEventListener("abort", ra);
    };
    return Xi == null || Xi.addEventListener == null || Xi.addEventListener("abort", ta), ta[$mobx] = this, ta;
  }, e.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, e.trace = function(Xi) {
    Xi === void 0 && (Xi = !1), trace(this, Xi);
  }, Bi;
}(), MAX_REACTION_ITERATIONS = 100, reactionScheduler = function(e) {
  return e();
};
function runReactions() {
  globalState.inBatch > 0 || globalState.isRunningReactions || reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState.isRunningReactions = !0;
  for (var Bi = globalState.pendingReactions, e = 0; Bi.length > 0; ) {
    ++e === MAX_REACTION_ITERATIONS && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + Bi[0]) : "[mobx] cycle in reaction: " + Bi[0]), Bi.splice(0));
    for (var qi = Bi.splice(0), Xi = 0, Qi = qi.length; Xi < Qi; Xi++)
      qi[Xi].runReaction_();
  }
  globalState.isRunningReactions = !1;
}
var isReaction = /* @__PURE__ */ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(Bi) {
  var e = reactionScheduler;
  reactionScheduler = function(Xi) {
    return Bi(function() {
      return e(Xi);
    });
  };
}
function isSpyEnabled() {
  return process.env.NODE_ENV !== "production" && !!globalState.spyListeners.length;
}
function spyReport(Bi) {
  if (process.env.NODE_ENV !== "production" && globalState.spyListeners.length)
    for (var e = globalState.spyListeners, qi = 0, Xi = e.length; qi < Xi; qi++)
      e[qi](Bi);
}
function spyReportStart(Bi) {
  if (process.env.NODE_ENV !== "production") {
    var e = _extends({}, Bi, {
      spyReportStart: !0
    });
    spyReport(e);
  }
}
var END_EVENT = {
  type: "report-end",
  spyReportEnd: !0
};
function spyReportEnd(Bi) {
  process.env.NODE_ENV !== "production" && spyReport(Bi ? _extends({}, Bi, {
    type: "report-end",
    spyReportEnd: !0
  }) : END_EVENT);
}
function spy(Bi) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (globalState.spyListeners.push(Bi), once(function() {
    globalState.spyListeners = globalState.spyListeners.filter(function(e) {
      return e !== Bi;
    });
  }));
}
var ACTION = "action", ACTION_BOUND = "action.bound", AUTOACTION = "autoAction", AUTOACTION_BOUND = "autoAction.bound", DEFAULT_ACTION_NAME = "<unnamed action>", actionAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION), actionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION_BOUND, {
  bound: !0
}), autoActionAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION, {
  autoAction: !0
}), autoActionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION_BOUND, {
  autoAction: !0,
  bound: !0
});
function createActionFactory(Bi) {
  var e = function(Xi, Qi) {
    if (isFunction$1(Xi))
      return createAction(Xi.name || DEFAULT_ACTION_NAME, Xi, Bi);
    if (isFunction$1(Qi))
      return createAction(Xi, Qi, Bi);
    if (is20223Decorator(Qi))
      return (Bi ? autoActionAnnotation : actionAnnotation).decorate_20223_(Xi, Qi);
    if (isStringish(Qi))
      return storeAnnotation(Xi, Qi, Bi ? autoActionAnnotation : actionAnnotation);
    if (isStringish(Xi))
      return createDecoratorAnnotation(createActionAnnotation(Bi ? AUTOACTION : ACTION, {
        name: Xi,
        autoAction: Bi
      }));
    process.env.NODE_ENV !== "production" && die("Invalid arguments for `action`");
  };
  return e;
}
var action = /* @__PURE__ */ createActionFactory(!1);
Object.assign(action, actionAnnotation);
var autoAction = /* @__PURE__ */ createActionFactory(!0);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /* @__PURE__ */ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /* @__PURE__ */ createDecoratorAnnotation(autoActionBoundAnnotation);
function isAction(Bi) {
  return isFunction$1(Bi) && Bi.isMobxAction === !0;
}
function autorun(Bi, e) {
  var qi, Xi, Qi, ta, ra;
  e === void 0 && (e = EMPTY_OBJECT), process.env.NODE_ENV !== "production" && (isFunction$1(Bi) || die("Autorun expects a function as first argument"), isAction(Bi) && die("Autorun does not accept actions since actions are untrackable"));
  var na = (qi = (Xi = e) == null ? void 0 : Xi.name) != null ? qi : process.env.NODE_ENV !== "production" ? Bi.name || "Autorun@" + getNextId() : "Autorun", la = !e.scheduler && !e.delay, Ma;
  if (la)
    Ma = new Reaction(na, function() {
      this.track(Eo);
    }, e.onError, e.requiresObservable);
  else {
    var Va = createSchedulerFromOptions(e), to = !1;
    Ma = new Reaction(na, function() {
      to || (to = !0, Va(function() {
        to = !1, Ma.isDisposed_ || Ma.track(Eo);
      }));
    }, e.onError, e.requiresObservable);
  }
  function Eo() {
    Bi(Ma);
  }
  return (Qi = e) != null && (ta = Qi.signal) != null && ta.aborted || Ma.schedule_(), Ma.getDisposer_((ra = e) == null ? void 0 : ra.signal);
}
var run = function(e) {
  return e();
};
function createSchedulerFromOptions(Bi) {
  return Bi.scheduler ? Bi.scheduler : Bi.delay ? function(e) {
    return setTimeout(e, Bi.delay);
  } : run;
}
var ON_BECOME_OBSERVED = "onBO", ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(Bi, e, qi) {
  return interceptHook(ON_BECOME_OBSERVED, Bi, e, qi);
}
function onBecomeUnobserved(Bi, e, qi) {
  return interceptHook(ON_BECOME_UNOBSERVED, Bi, e, qi);
}
function interceptHook(Bi, e, qi, Xi) {
  var Qi = getAtom(e), ta = isFunction$1(Xi) ? Xi : qi, ra = Bi + "L";
  return Qi[ra] ? Qi[ra].add(ta) : Qi[ra] = /* @__PURE__ */ new Set([ta]), function() {
    var na = Qi[ra];
    na && (na.delete(ta), na.size === 0 && delete Qi[ra]);
  };
}
var NEVER = "never", ALWAYS = "always", OBSERVED = "observed";
function configure(Bi) {
  Bi.isolateGlobalState === !0 && isolateGlobalState();
  var e = Bi.useProxies, qi = Bi.enforceActions;
  if (e !== void 0 && (globalState.useProxies = e === ALWAYS ? !0 : e === NEVER ? !1 : typeof Proxy < "u"), e === "ifavailable" && (globalState.verifyProxies = !0), qi !== void 0) {
    var Xi = qi === ALWAYS ? ALWAYS : qi === OBSERVED;
    globalState.enforceActions = Xi, globalState.allowStateChanges = !(Xi === !0 || Xi === ALWAYS);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(Qi) {
    Qi in Bi && (globalState[Qi] = !!Bi[Qi]);
  }), globalState.allowStateReads = !globalState.observableRequiresReaction, process.env.NODE_ENV !== "production" && globalState.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), Bi.reactionScheduler && setReactionScheduler(Bi.reactionScheduler);
}
function extendObservable(Bi, e, qi, Xi) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && die("'extendObservable' expected 2-4 arguments"), typeof Bi != "object" && die("'extendObservable' expects an object as first argument"), isObservableMap(Bi) && die("'extendObservable' should not be used on maps, use map.merge instead"), isPlainObject$2(e) || die("'extendObservable' only accepts plain objects as second argument"), (isObservable(e) || isObservable(qi)) && die("Extending an object with another observable (object) is not supported"));
  var Qi = getOwnPropertyDescriptors(e);
  return initObservable(function() {
    var ta = asObservableObject(Bi, Xi)[$mobx];
    ownKeys$2(Qi).forEach(function(ra) {
      ta.extend_(
        ra,
        Qi[ra],
        // must pass "undefined" for { key: undefined }
        qi && ra in qi ? qi[ra] : !0
      );
    });
  }), Bi;
}
function getDependencyTree(Bi, e) {
  return nodeToDependencyTree(getAtom(Bi, e));
}
function nodeToDependencyTree(Bi) {
  var e = {
    name: Bi.name_
  };
  return Bi.observing_ && Bi.observing_.length > 0 && (e.dependencies = unique(Bi.observing_).map(nodeToDependencyTree)), e;
}
function unique(Bi) {
  return Array.from(new Set(Bi));
}
var generatorId = 0;
function FlowCancellationError() {
  this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var flowAnnotation = /* @__PURE__ */ createFlowAnnotation("flow"), flowBoundAnnotation = /* @__PURE__ */ createFlowAnnotation("flow.bound", {
  bound: !0
}), flow = /* @__PURE__ */ Object.assign(function(e, qi) {
  if (is20223Decorator(qi))
    return flowAnnotation.decorate_20223_(e, qi);
  if (isStringish(qi))
    return storeAnnotation(e, qi, flowAnnotation);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && die("Flow expects single argument with generator function");
  var Xi = e, Qi = Xi.name || "<unnamed flow>", ta = function() {
    var na = this, la = arguments, Ma = ++generatorId, Va = action(Qi + " - runid: " + Ma + " - init", Xi).apply(na, la), to, Eo = void 0, So = new Promise(function(eo, rs) {
      var ko = 0;
      to = rs;
      function Hs(Xs) {
        Eo = void 0;
        var Cs;
        try {
          Cs = action(Qi + " - runid: " + Ma + " - yield " + ko++, Va.next).call(Va, Xs);
        } catch (Fs) {
          return rs(Fs);
        }
        Ys(Cs);
      }
      function Ks(Xs) {
        Eo = void 0;
        var Cs;
        try {
          Cs = action(Qi + " - runid: " + Ma + " - yield " + ko++, Va.throw).call(Va, Xs);
        } catch (Fs) {
          return rs(Fs);
        }
        Ys(Cs);
      }
      function Ys(Xs) {
        if (isFunction$1(Xs?.then)) {
          Xs.then(Ys, rs);
          return;
        }
        return Xs.done ? eo(Xs.value) : (Eo = Promise.resolve(Xs.value), Eo.then(Hs, Ks));
      }
      Hs(void 0);
    });
    return So.cancel = action(Qi + " - runid: " + Ma + " - cancel", function() {
      try {
        Eo && cancelPromise(Eo);
        var eo = Va.return(void 0), rs = Promise.resolve(eo.value);
        rs.then(noop$1, noop$1), cancelPromise(rs), to(new FlowCancellationError());
      } catch (ko) {
        to(ko);
      }
    }), So;
  };
  return ta.isMobXFlow = !0, ta;
}, flowAnnotation);
flow.bound = /* @__PURE__ */ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(Bi) {
  isFunction$1(Bi.cancel) && Bi.cancel();
}
function isFlow(Bi) {
  return Bi?.isMobXFlow === !0;
}
function _isObservable(Bi, e) {
  return Bi ? isObservableObject(Bi) || !!Bi[$mobx] || isAtom(Bi) || isReaction(Bi) || isComputedValue(Bi) : !1;
}
function isObservable(Bi) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && die("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), _isObservable(Bi);
}
function trace() {
  if (process.env.NODE_ENV !== "production") {
    for (var Bi = !1, e = arguments.length, qi = new Array(e), Xi = 0; Xi < e; Xi++)
      qi[Xi] = arguments[Xi];
    typeof qi[qi.length - 1] == "boolean" && (Bi = qi.pop());
    var Qi = getAtomFromArgs(qi);
    if (!Qi)
      return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    Qi.isTracing_ === TraceMode.NONE && console.log("[mobx.trace] '" + Qi.name_ + "' tracing enabled"), Qi.isTracing_ = Bi ? TraceMode.BREAK : TraceMode.LOG;
  }
}
function getAtomFromArgs(Bi) {
  switch (Bi.length) {
    case 0:
      return globalState.trackingDerivation;
    case 1:
      return getAtom(Bi[0]);
    case 2:
      return getAtom(Bi[0], Bi[1]);
  }
}
function transaction(Bi, e) {
  e === void 0 && (e = void 0), startBatch();
  try {
    return Bi.apply(e);
  } finally {
    endBatch();
  }
}
function getAdm(Bi) {
  return Bi[$mobx];
}
var objectProxyTraps = {
  has: function(e, qi) {
    return process.env.NODE_ENV !== "production" && globalState.trackingDerivation && warnAboutProxyRequirement("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), getAdm(e).has_(qi);
  },
  get: function(e, qi) {
    return getAdm(e).get_(qi);
  },
  set: function(e, qi, Xi) {
    var Qi;
    return isStringish(qi) ? (process.env.NODE_ENV !== "production" && !getAdm(e).values_.has(qi) && warnAboutProxyRequirement("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (Qi = getAdm(e).set_(qi, Xi, !0)) != null ? Qi : !0) : !1;
  },
  deleteProperty: function(e, qi) {
    var Xi;
    return process.env.NODE_ENV !== "production" && warnAboutProxyRequirement("delete properties from an observable object. Use 'remove' from 'mobx' instead."), isStringish(qi) ? (Xi = getAdm(e).delete_(qi, !0)) != null ? Xi : !0 : !1;
  },
  defineProperty: function(e, qi, Xi) {
    var Qi;
    return process.env.NODE_ENV !== "production" && warnAboutProxyRequirement("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (Qi = getAdm(e).defineProperty_(qi, Xi)) != null ? Qi : !0;
  },
  ownKeys: function(e) {
    return process.env.NODE_ENV !== "production" && globalState.trackingDerivation && warnAboutProxyRequirement("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), getAdm(e).ownKeys_();
  },
  preventExtensions: function(e) {
    die(13);
  }
};
function asDynamicObservableObject(Bi, e) {
  var qi, Xi;
  return assertProxies(), Bi = asObservableObject(Bi, e), (Xi = (qi = Bi[$mobx]).proxy_) != null ? Xi : qi.proxy_ = new Proxy(Bi, objectProxyTraps);
}
function hasInterceptors(Bi) {
  return Bi.interceptors_ !== void 0 && Bi.interceptors_.length > 0;
}
function registerInterceptor(Bi, e) {
  var qi = Bi.interceptors_ || (Bi.interceptors_ = []);
  return qi.push(e), once(function() {
    var Xi = qi.indexOf(e);
    Xi !== -1 && qi.splice(Xi, 1);
  });
}
function interceptChange(Bi, e) {
  var qi = untrackedStart();
  try {
    for (var Xi = [].concat(Bi.interceptors_ || []), Qi = 0, ta = Xi.length; Qi < ta && (e = Xi[Qi](e), e && !e.type && die(14), !!e); Qi++)
      ;
    return e;
  } finally {
    untrackedEnd(qi);
  }
}
function hasListeners(Bi) {
  return Bi.changeListeners_ !== void 0 && Bi.changeListeners_.length > 0;
}
function registerListener(Bi, e) {
  var qi = Bi.changeListeners_ || (Bi.changeListeners_ = []);
  return qi.push(e), once(function() {
    var Xi = qi.indexOf(e);
    Xi !== -1 && qi.splice(Xi, 1);
  });
}
function notifyListeners(Bi, e) {
  var qi = untrackedStart(), Xi = Bi.changeListeners_;
  if (Xi) {
    Xi = Xi.slice();
    for (var Qi = 0, ta = Xi.length; Qi < ta; Qi++)
      Xi[Qi](e);
    untrackedEnd(qi);
  }
}
function makeObservable(Bi, e, qi) {
  return initObservable(function() {
    var Xi, Qi = asObservableObject(Bi, qi)[$mobx];
    process.env.NODE_ENV !== "production" && e && Bi[storedAnnotationsSymbol] && die("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (Xi = e) != null || (e = collectStoredAnnotations(Bi)), ownKeys$2(e).forEach(function(ta) {
      return Qi.make_(ta, e[ta]);
    });
  }), Bi;
}
var keysSymbol = /* @__PURE__ */ Symbol("mobx-keys");
function makeAutoObservable(Bi, e, qi) {
  return process.env.NODE_ENV !== "production" && (!isPlainObject$2(Bi) && !isPlainObject$2(Object.getPrototypeOf(Bi)) && die("'makeAutoObservable' can only be used for classes that don't have a superclass"), isObservableObject(Bi) && die("makeAutoObservable can only be used on objects not already made observable")), isPlainObject$2(Bi) ? extendObservable(Bi, Bi, e, qi) : (initObservable(function() {
    var Xi = asObservableObject(Bi, qi)[$mobx];
    if (!Bi[keysSymbol]) {
      var Qi = Object.getPrototypeOf(Bi), ta = new Set([].concat(ownKeys$2(Bi), ownKeys$2(Qi)));
      ta.delete("constructor"), ta.delete($mobx), addHiddenProp(Qi, keysSymbol, ta);
    }
    Bi[keysSymbol].forEach(function(ra) {
      return Xi.make_(
        ra,
        // must pass "undefined" for { key: undefined }
        e && ra in e ? e[ra] : !0
      );
    });
  }), Bi);
}
var SPLICE = "splice", UPDATE = "update", MAX_SPLICE_SIZE = 1e4, arrayTraps = {
  get: function(e, qi) {
    var Xi = e[$mobx];
    return qi === $mobx ? Xi : qi === "length" ? Xi.getArrayLength_() : typeof qi == "string" && !isNaN(qi) ? Xi.get_(parseInt(qi)) : hasProp(arrayExtensions, qi) ? arrayExtensions[qi] : e[qi];
  },
  set: function(e, qi, Xi) {
    var Qi = e[$mobx];
    return qi === "length" && Qi.setArrayLength_(Xi), typeof qi == "symbol" || isNaN(qi) ? e[qi] = Xi : Qi.set_(parseInt(qi), Xi), !0;
  },
  preventExtensions: function() {
    die(15);
  }
}, ObservableArrayAdministration = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi, ta) {
    qi === void 0 && (qi = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = Qi, this.legacyMode_ = ta, this.atom_ = new Atom(qi), this.enhancer_ = function(ra, na) {
      return Xi(ra, na, process.env.NODE_ENV !== "production" ? qi + "[..]" : "ObservableArray[..]");
    };
  }
  var e = Bi.prototype;
  return e.dehanceValue_ = function(Xi) {
    return this.dehancer !== void 0 ? this.dehancer(Xi) : Xi;
  }, e.dehanceValues_ = function(Xi) {
    return this.dehancer !== void 0 && Xi.length > 0 ? Xi.map(this.dehancer) : Xi;
  }, e.intercept_ = function(Xi) {
    return registerInterceptor(this, Xi);
  }, e.observe_ = function(Xi, Qi) {
    return Qi === void 0 && (Qi = !1), Qi && Xi({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), registerListener(this, Xi);
  }, e.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, e.setArrayLength_ = function(Xi) {
    (typeof Xi != "number" || isNaN(Xi) || Xi < 0) && die("Out of range: " + Xi);
    var Qi = this.values_.length;
    if (Xi !== Qi)
      if (Xi > Qi) {
        for (var ta = new Array(Xi - Qi), ra = 0; ra < Xi - Qi; ra++)
          ta[ra] = void 0;
        this.spliceWithArray_(Qi, 0, ta);
      } else
        this.spliceWithArray_(Xi, Qi - Xi);
  }, e.updateArrayLength_ = function(Xi, Qi) {
    Xi !== this.lastKnownLength_ && die(16), this.lastKnownLength_ += Qi, this.legacyMode_ && Qi > 0 && reserveArrayBuffer(Xi + Qi + 1);
  }, e.spliceWithArray_ = function(Xi, Qi, ta) {
    var ra = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    var na = this.values_.length;
    if (Xi === void 0 ? Xi = 0 : Xi > na ? Xi = na : Xi < 0 && (Xi = Math.max(0, na + Xi)), arguments.length === 1 ? Qi = na - Xi : Qi == null ? Qi = 0 : Qi = Math.max(0, Math.min(Qi, na - Xi)), ta === void 0 && (ta = EMPTY_ARRAY), hasInterceptors(this)) {
      var la = interceptChange(this, {
        object: this.proxy_,
        type: SPLICE,
        index: Xi,
        removedCount: Qi,
        added: ta
      });
      if (!la)
        return EMPTY_ARRAY;
      Qi = la.removedCount, ta = la.added;
    }
    if (ta = ta.length === 0 ? ta : ta.map(function(to) {
      return ra.enhancer_(to, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var Ma = ta.length - Qi;
      this.updateArrayLength_(na, Ma);
    }
    var Va = this.spliceItemsIntoValues_(Xi, Qi, ta);
    return (Qi !== 0 || ta.length !== 0) && this.notifyArraySplice_(Xi, ta, Va), this.dehanceValues_(Va);
  }, e.spliceItemsIntoValues_ = function(Xi, Qi, ta) {
    if (ta.length < MAX_SPLICE_SIZE) {
      var ra;
      return (ra = this.values_).splice.apply(ra, [Xi, Qi].concat(ta));
    } else {
      var na = this.values_.slice(Xi, Xi + Qi), la = this.values_.slice(Xi + Qi);
      this.values_.length += ta.length - Qi;
      for (var Ma = 0; Ma < ta.length; Ma++)
        this.values_[Xi + Ma] = ta[Ma];
      for (var Va = 0; Va < la.length; Va++)
        this.values_[Xi + ta.length + Va] = la[Va];
      return na;
    }
  }, e.notifyArrayChildUpdate_ = function(Xi, Qi, ta) {
    var ra = !this.owned_ && isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
      observableKind: "array",
      object: this.proxy_,
      type: UPDATE,
      debugObjectName: this.atom_.name_,
      index: Xi,
      newValue: Qi,
      oldValue: ta
    } : null;
    process.env.NODE_ENV !== "production" && ra && spyReportStart(la), this.atom_.reportChanged(), na && notifyListeners(this, la), process.env.NODE_ENV !== "production" && ra && spyReportEnd();
  }, e.notifyArraySplice_ = function(Xi, Qi, ta) {
    var ra = !this.owned_ && isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: SPLICE,
      index: Xi,
      removed: ta,
      added: Qi,
      removedCount: ta.length,
      addedCount: Qi.length
    } : null;
    process.env.NODE_ENV !== "production" && ra && spyReportStart(la), this.atom_.reportChanged(), na && notifyListeners(this, la), process.env.NODE_ENV !== "production" && ra && spyReportEnd();
  }, e.get_ = function(Xi) {
    if (this.legacyMode_ && Xi >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + Xi + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + Xi);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[Xi]);
  }, e.set_ = function(Xi, Qi) {
    var ta = this.values_;
    if (this.legacyMode_ && Xi > ta.length && die(17, Xi, ta.length), Xi < ta.length) {
      checkIfStateModificationsAreAllowed(this.atom_);
      var ra = ta[Xi];
      if (hasInterceptors(this)) {
        var na = interceptChange(this, {
          type: UPDATE,
          object: this.proxy_,
          index: Xi,
          newValue: Qi
        });
        if (!na)
          return;
        Qi = na.newValue;
      }
      Qi = this.enhancer_(Qi, ra);
      var la = Qi !== ra;
      la && (ta[Xi] = Qi, this.notifyArrayChildUpdate_(Xi, Qi, ra));
    } else {
      for (var Ma = new Array(Xi + 1 - ta.length), Va = 0; Va < Ma.length - 1; Va++)
        Ma[Va] = void 0;
      Ma[Ma.length - 1] = Qi, this.spliceWithArray_(ta.length, 0, Ma);
    }
  }, Bi;
}();
function createObservableArray(Bi, e, qi, Xi) {
  return qi === void 0 && (qi = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), Xi === void 0 && (Xi = !1), assertProxies(), initObservable(function() {
    var Qi = new ObservableArrayAdministration(qi, e, Xi, !1);
    addHiddenFinalProp(Qi.values_, $mobx, Qi);
    var ta = new Proxy(Qi.values_, arrayTraps);
    return Qi.proxy_ = ta, Bi && Bi.length && Qi.spliceWithArray_(0, 0, Bi), ta;
  });
}
var arrayExtensions = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(e) {
    var qi = this[$mobx];
    return qi.spliceWithArray_(0, qi.values_.length, e);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(e, qi) {
    for (var Xi = arguments.length, Qi = new Array(Xi > 2 ? Xi - 2 : 0), ta = 2; ta < Xi; ta++)
      Qi[ta - 2] = arguments[ta];
    var ra = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return ra.spliceWithArray_(e);
      case 2:
        return ra.spliceWithArray_(e, qi);
    }
    return ra.spliceWithArray_(e, qi, Qi);
  },
  spliceWithArray: function(e, qi, Xi) {
    return this[$mobx].spliceWithArray_(e, qi, Xi);
  },
  push: function() {
    for (var e = this[$mobx], qi = arguments.length, Xi = new Array(qi), Qi = 0; Qi < qi; Qi++)
      Xi[Qi] = arguments[Qi];
    return e.spliceWithArray_(e.values_.length, 0, Xi), e.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var e = this[$mobx], qi = arguments.length, Xi = new Array(qi), Qi = 0; Qi < qi; Qi++)
      Xi[Qi] = arguments[Qi];
    return e.spliceWithArray_(0, 0, Xi), e.values_.length;
  },
  reverse: function() {
    return globalState.trackingDerivation && die(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    globalState.trackingDerivation && die(37, "sort");
    var e = this.slice();
    return e.sort.apply(e, arguments), this.replace(e), this;
  },
  remove: function(e) {
    var qi = this[$mobx], Xi = qi.dehanceValues_(qi.values_).indexOf(e);
    return Xi > -1 ? (this.splice(Xi, 1), !0) : !1;
  }
};
addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(Bi, e) {
  typeof Array.prototype[Bi] == "function" && (arrayExtensions[Bi] = e(Bi));
}
function simpleFunc(Bi) {
  return function() {
    var e = this[$mobx];
    e.atom_.reportObserved();
    var qi = e.dehanceValues_(e.values_);
    return qi[Bi].apply(qi, arguments);
  };
}
function mapLikeFunc(Bi) {
  return function(e, qi) {
    var Xi = this, Qi = this[$mobx];
    Qi.atom_.reportObserved();
    var ta = Qi.dehanceValues_(Qi.values_);
    return ta[Bi](function(ra, na) {
      return e.call(qi, ra, na, Xi);
    });
  };
}
function reduceLikeFunc(Bi) {
  return function() {
    var e = this, qi = this[$mobx];
    qi.atom_.reportObserved();
    var Xi = qi.dehanceValues_(qi.values_), Qi = arguments[0];
    return arguments[0] = function(ta, ra, na) {
      return Qi(ta, ra, na, e);
    }, Xi[Bi].apply(Xi, arguments);
  };
}
var isObservableArrayAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(Bi) {
  return isObject$3(Bi) && isObservableArrayAdministration(Bi[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag, ObservableMapMarker = {}, ADD = "add", DELETE = "delete";
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi) {
    var ta = this;
    Xi === void 0 && (Xi = deepEnhancer), Qi === void 0 && (Qi = process.env.NODE_ENV !== "production" ? "ObservableMap@" + getNextId() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[$mobx] = ObservableMapMarker, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = Xi, this.name_ = Qi, isFunction$1(Map) || die(18), initObservable(function() {
      ta.keysAtom_ = createAtom(process.env.NODE_ENV !== "production" ? ta.name_ + ".keys()" : "ObservableMap.keys()"), ta.data_ = /* @__PURE__ */ new Map(), ta.hasMap_ = /* @__PURE__ */ new Map(), qi && ta.merge(qi);
    });
  }
  var e = Bi.prototype;
  return e.has_ = function(Xi) {
    return this.data_.has(Xi);
  }, e.has = function(Xi) {
    var Qi = this;
    if (!globalState.trackingDerivation)
      return this.has_(Xi);
    var ta = this.hasMap_.get(Xi);
    if (!ta) {
      var ra = ta = new ObservableValue(this.has_(Xi), referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(Xi) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(Xi, ra), onBecomeUnobserved(ra, function() {
        return Qi.hasMap_.delete(Xi);
      });
    }
    return ta.get();
  }, e.set = function(Xi, Qi) {
    var ta = this.has_(Xi);
    if (hasInterceptors(this)) {
      var ra = interceptChange(this, {
        type: ta ? UPDATE : ADD,
        object: this,
        newValue: Qi,
        name: Xi
      });
      if (!ra)
        return this;
      Qi = ra.newValue;
    }
    return ta ? this.updateValue_(Xi, Qi) : this.addValue_(Xi, Qi), this;
  }, e.delete = function(Xi) {
    var Qi = this;
    if (checkIfStateModificationsAreAllowed(this.keysAtom_), hasInterceptors(this)) {
      var ta = interceptChange(this, {
        type: DELETE,
        object: this,
        name: Xi
      });
      if (!ta)
        return !1;
    }
    if (this.has_(Xi)) {
      var ra = isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: this.data_.get(Xi).value_,
        name: Xi
      } : null;
      return process.env.NODE_ENV !== "production" && ra && spyReportStart(la), transaction(function() {
        var Ma;
        Qi.keysAtom_.reportChanged(), (Ma = Qi.hasMap_.get(Xi)) == null || Ma.setNewValue_(!1);
        var Va = Qi.data_.get(Xi);
        Va.setNewValue_(void 0), Qi.data_.delete(Xi);
      }), na && notifyListeners(this, la), process.env.NODE_ENV !== "production" && ra && spyReportEnd(), !0;
    }
    return !1;
  }, e.updateValue_ = function(Xi, Qi) {
    var ta = this.data_.get(Xi);
    if (Qi = ta.prepareNewValue_(Qi), Qi !== globalState.UNCHANGED) {
      var ra = isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: UPDATE,
        object: this,
        oldValue: ta.value_,
        name: Xi,
        newValue: Qi
      } : null;
      process.env.NODE_ENV !== "production" && ra && spyReportStart(la), ta.setNewValue_(Qi), na && notifyListeners(this, la), process.env.NODE_ENV !== "production" && ra && spyReportEnd();
    }
  }, e.addValue_ = function(Xi, Qi) {
    var ta = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_), transaction(function() {
      var Ma, Va = new ObservableValue(Qi, ta.enhancer_, process.env.NODE_ENV !== "production" ? ta.name_ + "." + stringifyKey(Xi) : "ObservableMap.key", !1);
      ta.data_.set(Xi, Va), Qi = Va.value_, (Ma = ta.hasMap_.get(Xi)) == null || Ma.setNewValue_(!0), ta.keysAtom_.reportChanged();
    });
    var ra = isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: ADD,
      object: this,
      name: Xi,
      newValue: Qi
    } : null;
    process.env.NODE_ENV !== "production" && ra && spyReportStart(la), na && notifyListeners(this, la), process.env.NODE_ENV !== "production" && ra && spyReportEnd();
  }, e.get = function(Xi) {
    return this.has(Xi) ? this.dehanceValue_(this.data_.get(Xi).get()) : this.dehanceValue_(void 0);
  }, e.dehanceValue_ = function(Xi) {
    return this.dehancer !== void 0 ? this.dehancer(Xi) : Xi;
  }, e.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, e.values = function() {
    var Xi = this, Qi = this.keys();
    return makeIterable({
      next: function() {
        var ra = Qi.next(), na = ra.done, la = ra.value;
        return {
          done: na,
          value: na ? void 0 : Xi.get(la)
        };
      }
    });
  }, e.entries = function() {
    var Xi = this, Qi = this.keys();
    return makeIterable({
      next: function() {
        var ra = Qi.next(), na = ra.done, la = ra.value;
        return {
          done: na,
          value: na ? void 0 : [la, Xi.get(la)]
        };
      }
    });
  }, e[_Symbol$iterator] = function() {
    return this.entries();
  }, e.forEach = function(Xi, Qi) {
    for (var ta = _createForOfIteratorHelperLoose(this), ra; !(ra = ta()).done; ) {
      var na = ra.value, la = na[0], Ma = na[1];
      Xi.call(Qi, Ma, la, this);
    }
  }, e.merge = function(Xi) {
    var Qi = this;
    return isObservableMap(Xi) && (Xi = new Map(Xi)), transaction(function() {
      isPlainObject$2(Xi) ? getPlainObjectKeys(Xi).forEach(function(ta) {
        return Qi.set(ta, Xi[ta]);
      }) : Array.isArray(Xi) ? Xi.forEach(function(ta) {
        var ra = ta[0], na = ta[1];
        return Qi.set(ra, na);
      }) : isES6Map(Xi) ? (Xi.constructor !== Map && die(19, Xi), Xi.forEach(function(ta, ra) {
        return Qi.set(ra, ta);
      })) : Xi != null && die(20, Xi);
    }), this;
  }, e.clear = function() {
    var Xi = this;
    transaction(function() {
      untracked(function() {
        for (var Qi = _createForOfIteratorHelperLoose(Xi.keys()), ta; !(ta = Qi()).done; ) {
          var ra = ta.value;
          Xi.delete(ra);
        }
      });
    });
  }, e.replace = function(Xi) {
    var Qi = this;
    return transaction(function() {
      for (var ta = convertToMap(Xi), ra = /* @__PURE__ */ new Map(), na = !1, la = _createForOfIteratorHelperLoose(Qi.data_.keys()), Ma; !(Ma = la()).done; ) {
        var Va = Ma.value;
        if (!ta.has(Va)) {
          var to = Qi.delete(Va);
          if (to)
            na = !0;
          else {
            var Eo = Qi.data_.get(Va);
            ra.set(Va, Eo);
          }
        }
      }
      for (var So = _createForOfIteratorHelperLoose(ta.entries()), eo; !(eo = So()).done; ) {
        var rs = eo.value, ko = rs[0], Hs = rs[1], Ks = Qi.data_.has(ko);
        if (Qi.set(ko, Hs), Qi.data_.has(ko)) {
          var Ys = Qi.data_.get(ko);
          ra.set(ko, Ys), Ks || (na = !0);
        }
      }
      if (!na)
        if (Qi.data_.size !== ra.size)
          Qi.keysAtom_.reportChanged();
        else
          for (var Xs = Qi.data_.keys(), Cs = ra.keys(), Fs = Xs.next(), ws = Cs.next(); !Fs.done; ) {
            if (Fs.value !== ws.value) {
              Qi.keysAtom_.reportChanged();
              break;
            }
            Fs = Xs.next(), ws = Cs.next();
          }
      Qi.data_ = ra;
    }), this;
  }, e.toString = function() {
    return "[object ObservableMap]";
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.observe_ = function(Xi, Qi) {
    return process.env.NODE_ENV !== "production" && Qi === !0 && die("`observe` doesn't support fireImmediately=true in combination with maps."), registerListener(this, Xi);
  }, e.intercept_ = function(Xi) {
    return registerInterceptor(this, Xi);
  }, _createClass(Bi, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function() {
      return "Map";
    }
  }]), Bi;
}(), isObservableMap = /* @__PURE__ */ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(Bi) {
  if (isES6Map(Bi) || isObservableMap(Bi))
    return Bi;
  if (Array.isArray(Bi))
    return new Map(Bi);
  if (isPlainObject$2(Bi)) {
    var e = /* @__PURE__ */ new Map();
    for (var qi in Bi)
      e.set(qi, Bi[qi]);
    return e;
  } else
    return die(21, Bi);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1, ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi) {
    var ta = this;
    Xi === void 0 && (Xi = deepEnhancer), Qi === void 0 && (Qi = process.env.NODE_ENV !== "production" ? "ObservableSet@" + getNextId() : "ObservableSet"), this.name_ = void 0, this[$mobx] = ObservableSetMarker, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = Qi, isFunction$1(Set) || die(22), this.enhancer_ = function(ra, na) {
      return Xi(ra, na, Qi);
    }, initObservable(function() {
      ta.atom_ = createAtom(ta.name_), qi && ta.replace(qi);
    });
  }
  var e = Bi.prototype;
  return e.dehanceValue_ = function(Xi) {
    return this.dehancer !== void 0 ? this.dehancer(Xi) : Xi;
  }, e.clear = function() {
    var Xi = this;
    transaction(function() {
      untracked(function() {
        for (var Qi = _createForOfIteratorHelperLoose(Xi.data_.values()), ta; !(ta = Qi()).done; ) {
          var ra = ta.value;
          Xi.delete(ra);
        }
      });
    });
  }, e.forEach = function(Xi, Qi) {
    for (var ta = _createForOfIteratorHelperLoose(this), ra; !(ra = ta()).done; ) {
      var na = ra.value;
      Xi.call(Qi, na, na, this);
    }
  }, e.add = function(Xi) {
    var Qi = this;
    if (checkIfStateModificationsAreAllowed(this.atom_), hasInterceptors(this)) {
      var ta = interceptChange(this, {
        type: ADD,
        object: this,
        newValue: Xi
      });
      if (!ta)
        return this;
    }
    if (!this.has(Xi)) {
      transaction(function() {
        Qi.data_.add(Qi.enhancer_(Xi, void 0)), Qi.atom_.reportChanged();
      });
      var ra = process.env.NODE_ENV !== "production" && isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ADD,
        object: this,
        newValue: Xi
      } : null;
      ra && process.env.NODE_ENV !== "production" && spyReportStart(la), na && notifyListeners(this, la), ra && process.env.NODE_ENV !== "production" && spyReportEnd();
    }
    return this;
  }, e.delete = function(Xi) {
    var Qi = this;
    if (hasInterceptors(this)) {
      var ta = interceptChange(this, {
        type: DELETE,
        object: this,
        oldValue: Xi
      });
      if (!ta)
        return !1;
    }
    if (this.has(Xi)) {
      var ra = process.env.NODE_ENV !== "production" && isSpyEnabled(), na = hasListeners(this), la = na || ra ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: Xi
      } : null;
      return ra && process.env.NODE_ENV !== "production" && spyReportStart(la), transaction(function() {
        Qi.atom_.reportChanged(), Qi.data_.delete(Xi);
      }), na && notifyListeners(this, la), ra && process.env.NODE_ENV !== "production" && spyReportEnd(), !0;
    }
    return !1;
  }, e.has = function(Xi) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(Xi));
  }, e.entries = function() {
    var Xi = 0, Qi = Array.from(this.keys()), ta = Array.from(this.values());
    return makeIterable({
      next: function() {
        var na = Xi;
        return Xi += 1, na < ta.length ? {
          value: [Qi[na], ta[na]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.keys = function() {
    return this.values();
  }, e.values = function() {
    this.atom_.reportObserved();
    var Xi = this, Qi = 0, ta = Array.from(this.data_.values());
    return makeIterable({
      next: function() {
        return Qi < ta.length ? {
          value: Xi.dehanceValue_(ta[Qi++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, e.replace = function(Xi) {
    var Qi = this;
    return isObservableSet(Xi) && (Xi = new Set(Xi)), transaction(function() {
      Array.isArray(Xi) ? (Qi.clear(), Xi.forEach(function(ta) {
        return Qi.add(ta);
      })) : isES6Set(Xi) ? (Qi.clear(), Xi.forEach(function(ta) {
        return Qi.add(ta);
      })) : Xi != null && die("Cannot initialize set from " + Xi);
    }), this;
  }, e.observe_ = function(Xi, Qi) {
    return process.env.NODE_ENV !== "production" && Qi === !0 && die("`observe` doesn't support fireImmediately=true in combination with sets."), registerListener(this, Xi);
  }, e.intercept_ = function(Xi) {
    return registerInterceptor(this, Xi);
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.toString = function() {
    return "[object ObservableSet]";
  }, e[_Symbol$iterator$1] = function() {
    return this.values();
  }, _createClass(Bi, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag$1,
    get: function() {
      return "Set";
    }
  }]), Bi;
}(), isObservableSet = /* @__PURE__ */ createInstanceofPredicate("ObservableSet", ObservableSet), descriptorCache = /* @__PURE__ */ Object.create(null), REMOVE = "remove", ObservableObjectAdministration = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi, ta) {
    Xi === void 0 && (Xi = /* @__PURE__ */ new Map()), ta === void 0 && (ta = autoAnnotation), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = qi, this.values_ = Xi, this.name_ = Qi, this.defaultAnnotation_ = ta, this.keysAtom_ = new Atom(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = isPlainObject$2(this.target_), process.env.NODE_ENV !== "production" && !isAnnotation(this.defaultAnnotation_) && die("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var e = Bi.prototype;
  return e.getObservablePropValue_ = function(Xi) {
    return this.values_.get(Xi).get();
  }, e.setObservablePropValue_ = function(Xi, Qi) {
    var ta = this.values_.get(Xi);
    if (ta instanceof ComputedValue)
      return ta.set(Qi), !0;
    if (hasInterceptors(this)) {
      var ra = interceptChange(this, {
        type: UPDATE,
        object: this.proxy_ || this.target_,
        name: Xi,
        newValue: Qi
      });
      if (!ra)
        return null;
      Qi = ra.newValue;
    }
    if (Qi = ta.prepareNewValue_(Qi), Qi !== globalState.UNCHANGED) {
      var na = hasListeners(this), la = process.env.NODE_ENV !== "production" && isSpyEnabled(), Ma = na || la ? {
        type: UPDATE,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: ta.value_,
        name: Xi,
        newValue: Qi
      } : null;
      process.env.NODE_ENV !== "production" && la && spyReportStart(Ma), ta.setNewValue_(Qi), na && notifyListeners(this, Ma), process.env.NODE_ENV !== "production" && la && spyReportEnd();
    }
    return !0;
  }, e.get_ = function(Xi) {
    return globalState.trackingDerivation && !hasProp(this.target_, Xi) && this.has_(Xi), this.target_[Xi];
  }, e.set_ = function(Xi, Qi, ta) {
    return ta === void 0 && (ta = !1), hasProp(this.target_, Xi) ? this.values_.has(Xi) ? this.setObservablePropValue_(Xi, Qi) : ta ? Reflect.set(this.target_, Xi, Qi) : (this.target_[Xi] = Qi, !0) : this.extend_(Xi, {
      value: Qi,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, ta);
  }, e.has_ = function(Xi) {
    if (!globalState.trackingDerivation)
      return Xi in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var Qi = this.pendingKeys_.get(Xi);
    return Qi || (Qi = new ObservableValue(Xi in this.target_, referenceEnhancer, process.env.NODE_ENV !== "production" ? this.name_ + "." + stringifyKey(Xi) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(Xi, Qi)), Qi.get();
  }, e.make_ = function(Xi, Qi) {
    if (Qi === !0 && (Qi = this.defaultAnnotation_), Qi !== !1) {
      if (assertAnnotable(this, Qi, Xi), !(Xi in this.target_)) {
        var ta;
        if ((ta = this.target_[storedAnnotationsSymbol]) != null && ta[Xi])
          return;
        die(1, Qi.annotationType_, this.name_ + "." + Xi.toString());
      }
      for (var ra = this.target_; ra && ra !== objectPrototype; ) {
        var na = getDescriptor(ra, Xi);
        if (na) {
          var la = Qi.make_(this, Xi, na, ra);
          if (la === 0)
            return;
          if (la === 1)
            break;
        }
        ra = Object.getPrototypeOf(ra);
      }
      recordAnnotationApplied(this, Qi, Xi);
    }
  }, e.extend_ = function(Xi, Qi, ta, ra) {
    if (ra === void 0 && (ra = !1), ta === !0 && (ta = this.defaultAnnotation_), ta === !1)
      return this.defineProperty_(Xi, Qi, ra);
    assertAnnotable(this, ta, Xi);
    var na = ta.extend_(this, Xi, Qi, ra);
    return na && recordAnnotationApplied(this, ta, Xi), na;
  }, e.defineProperty_ = function(Xi, Qi, ta) {
    ta === void 0 && (ta = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var ra = this.delete_(Xi);
      if (!ra)
        return ra;
      if (hasInterceptors(this)) {
        var na = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Xi,
          type: ADD,
          newValue: Qi.value
        });
        if (!na)
          return null;
        var la = na.newValue;
        Qi.value !== la && (Qi = _extends({}, Qi, {
          value: la
        }));
      }
      if (ta) {
        if (!Reflect.defineProperty(this.target_, Xi, Qi))
          return !1;
      } else
        defineProperty(this.target_, Xi, Qi);
      this.notifyPropertyAddition_(Xi, Qi.value);
    } finally {
      endBatch();
    }
    return !0;
  }, e.defineObservableProperty_ = function(Xi, Qi, ta, ra) {
    ra === void 0 && (ra = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var na = this.delete_(Xi);
      if (!na)
        return na;
      if (hasInterceptors(this)) {
        var la = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Xi,
          type: ADD,
          newValue: Qi
        });
        if (!la)
          return null;
        Qi = la.newValue;
      }
      var Ma = getCachedObservablePropDescriptor(Xi), Va = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: Ma.get,
        set: Ma.set
      };
      if (ra) {
        if (!Reflect.defineProperty(this.target_, Xi, Va))
          return !1;
      } else
        defineProperty(this.target_, Xi, Va);
      var to = new ObservableValue(Qi, ta, process.env.NODE_ENV !== "production" ? this.name_ + "." + Xi.toString() : "ObservableObject.key", !1);
      this.values_.set(Xi, to), this.notifyPropertyAddition_(Xi, to.value_);
    } finally {
      endBatch();
    }
    return !0;
  }, e.defineComputedProperty_ = function(Xi, Qi, ta) {
    ta === void 0 && (ta = !1), checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      var ra = this.delete_(Xi);
      if (!ra)
        return ra;
      if (hasInterceptors(this)) {
        var na = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: Xi,
          type: ADD,
          newValue: void 0
        });
        if (!na)
          return null;
      }
      Qi.name || (Qi.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + Xi.toString() : "ObservableObject.key"), Qi.context = this.proxy_ || this.target_;
      var la = getCachedObservablePropDescriptor(Xi), Ma = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: la.get,
        set: la.set
      };
      if (ta) {
        if (!Reflect.defineProperty(this.target_, Xi, Ma))
          return !1;
      } else
        defineProperty(this.target_, Xi, Ma);
      this.values_.set(Xi, new ComputedValue(Qi)), this.notifyPropertyAddition_(Xi, void 0);
    } finally {
      endBatch();
    }
    return !0;
  }, e.delete_ = function(Xi, Qi) {
    if (Qi === void 0 && (Qi = !1), checkIfStateModificationsAreAllowed(this.keysAtom_), !hasProp(this.target_, Xi))
      return !0;
    if (hasInterceptors(this)) {
      var ta = interceptChange(this, {
        object: this.proxy_ || this.target_,
        name: Xi,
        type: REMOVE
      });
      if (!ta)
        return null;
    }
    try {
      var ra, na;
      startBatch();
      var la = hasListeners(this), Ma = process.env.NODE_ENV !== "production" && isSpyEnabled(), Va = this.values_.get(Xi), to = void 0;
      if (!Va && (la || Ma)) {
        var Eo;
        to = (Eo = getDescriptor(this.target_, Xi)) == null ? void 0 : Eo.value;
      }
      if (Qi) {
        if (!Reflect.deleteProperty(this.target_, Xi))
          return !1;
      } else
        delete this.target_[Xi];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[Xi], Va && (this.values_.delete(Xi), Va instanceof ObservableValue && (to = Va.value_), propagateChanged(Va)), this.keysAtom_.reportChanged(), (ra = this.pendingKeys_) == null || (na = ra.get(Xi)) == null || na.set(Xi in this.target_), la || Ma) {
        var So = {
          type: REMOVE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: to,
          name: Xi
        };
        process.env.NODE_ENV !== "production" && Ma && spyReportStart(So), la && notifyListeners(this, So), process.env.NODE_ENV !== "production" && Ma && spyReportEnd();
      }
    } finally {
      endBatch();
    }
    return !0;
  }, e.observe_ = function(Xi, Qi) {
    return process.env.NODE_ENV !== "production" && Qi === !0 && die("`observe` doesn't support the fire immediately property for observable objects."), registerListener(this, Xi);
  }, e.intercept_ = function(Xi) {
    return registerInterceptor(this, Xi);
  }, e.notifyPropertyAddition_ = function(Xi, Qi) {
    var ta, ra, na = hasListeners(this), la = process.env.NODE_ENV !== "production" && isSpyEnabled();
    if (na || la) {
      var Ma = na || la ? {
        type: ADD,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: Xi,
        newValue: Qi
      } : null;
      process.env.NODE_ENV !== "production" && la && spyReportStart(Ma), na && notifyListeners(this, Ma), process.env.NODE_ENV !== "production" && la && spyReportEnd();
    }
    (ta = this.pendingKeys_) == null || (ra = ta.get(Xi)) == null || ra.set(!0), this.keysAtom_.reportChanged();
  }, e.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), ownKeys$2(this.target_);
  }, e.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, Bi;
}();
function asObservableObject(Bi, e) {
  var qi;
  if (process.env.NODE_ENV !== "production" && e && isObservableObject(Bi) && die("Options can't be provided for already observable objects."), hasProp(Bi, $mobx))
    return process.env.NODE_ENV !== "production" && !(getAdministration$1(Bi) instanceof ObservableObjectAdministration) && die("Cannot convert '" + getDebugName(Bi) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), Bi;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(Bi) && die("Cannot make the designated object observable; it is not extensible");
  var Xi = (qi = e?.name) != null ? qi : process.env.NODE_ENV !== "production" ? (isPlainObject$2(Bi) ? "ObservableObject" : Bi.constructor.name) + "@" + getNextId() : "ObservableObject", Qi = new ObservableObjectAdministration(Bi, /* @__PURE__ */ new Map(), String(Xi), getAnnotationFromOptions(e));
  return addHiddenProp(Bi, $mobx, Qi), Bi;
}
var isObservableObjectAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(Bi) {
  return descriptorCache[Bi] || (descriptorCache[Bi] = {
    get: function() {
      return this[$mobx].getObservablePropValue_(Bi);
    },
    set: function(qi) {
      return this[$mobx].setObservablePropValue_(Bi, qi);
    }
  });
}
function isObservableObject(Bi) {
  return isObject$3(Bi) ? isObservableObjectAdministration(Bi[$mobx]) : !1;
}
function recordAnnotationApplied(Bi, e, qi) {
  var Xi;
  process.env.NODE_ENV !== "production" && (Bi.appliedAnnotations_[qi] = e), (Xi = Bi.target_[storedAnnotationsSymbol]) == null || delete Xi[qi];
}
function assertAnnotable(Bi, e, qi) {
  if (process.env.NODE_ENV !== "production" && !isAnnotation(e) && die("Cannot annotate '" + Bi.name_ + "." + qi.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !isOverride(e) && hasProp(Bi.appliedAnnotations_, qi)) {
    var Xi = Bi.name_ + "." + qi.toString(), Qi = Bi.appliedAnnotations_[qi].annotationType_, ta = e.annotationType_;
    die("Cannot apply '" + ta + "' to '" + Xi + "':" + (`
The field is already annotated with '` + Qi + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var ENTRY_0 = /* @__PURE__ */ createArrayEntryDescriptor(0), safariPrototypeSetterInheritanceBug = /* @__PURE__ */ function() {
  var Bi = !1, e = {};
  return Object.defineProperty(e, "0", {
    set: function() {
      Bi = !0;
    }
  }), Object.create(e)[0] = 1, Bi === !1;
}(), OBSERVABLE_ARRAY_BUFFER_SIZE = 0, StubArray = function() {
};
function inherit(Bi, e) {
  Object.setPrototypeOf ? Object.setPrototypeOf(Bi.prototype, e) : Bi.prototype.__proto__ !== void 0 ? Bi.prototype.__proto__ = e : Bi.prototype = e;
}
inherit(StubArray, Array.prototype);
var LegacyObservableArray = /* @__PURE__ */ function(Bi, e, qi) {
  _inheritsLoose(Xi, Bi);
  function Xi(ta, ra, na, la) {
    var Ma;
    return na === void 0 && (na = process.env.NODE_ENV !== "production" ? "ObservableArray@" + getNextId() : "ObservableArray"), la === void 0 && (la = !1), Ma = Bi.call(this) || this, initObservable(function() {
      var Va = new ObservableArrayAdministration(na, ra, la, !0);
      Va.proxy_ = _assertThisInitialized(Ma), addHiddenFinalProp(_assertThisInitialized(Ma), $mobx, Va), ta && ta.length && Ma.spliceWithArray(0, 0, ta), safariPrototypeSetterInheritanceBug && Object.defineProperty(_assertThisInitialized(Ma), "0", ENTRY_0);
    }), Ma;
  }
  var Qi = Xi.prototype;
  return Qi.concat = function() {
    this[$mobx].atom_.reportObserved();
    for (var ra = arguments.length, na = new Array(ra), la = 0; la < ra; la++)
      na[la] = arguments[la];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      na.map(function(Ma) {
        return isObservableArray(Ma) ? Ma.slice() : Ma;
      })
    );
  }, Qi[qi] = function() {
    var ta = this, ra = 0;
    return makeIterable({
      next: function() {
        return ra < ta.length ? {
          value: ta[ra++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, _createClass(Xi, [{
    key: "length",
    get: function() {
      return this[$mobx].getArrayLength_();
    },
    set: function(ra) {
      this[$mobx].setArrayLength_(ra);
    }
  }, {
    key: e,
    get: function() {
      return "Array";
    }
  }]), Xi;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(Bi) {
  var e = Bi[0], qi = Bi[1];
  e !== "concat" && addHiddenProp(LegacyObservableArray.prototype, e, qi);
});
function createArrayEntryDescriptor(Bi) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[$mobx].get_(Bi);
    },
    set: function(qi) {
      this[$mobx].set_(Bi, qi);
    }
  };
}
function createArrayBufferItem(Bi) {
  defineProperty(LegacyObservableArray.prototype, "" + Bi, createArrayEntryDescriptor(Bi));
}
function reserveArrayBuffer(Bi) {
  if (Bi > OBSERVABLE_ARRAY_BUFFER_SIZE) {
    for (var e = OBSERVABLE_ARRAY_BUFFER_SIZE; e < Bi + 100; e++)
      createArrayBufferItem(e);
    OBSERVABLE_ARRAY_BUFFER_SIZE = Bi;
  }
}
reserveArrayBuffer(1e3);
function createLegacyArray(Bi, e, qi) {
  return new LegacyObservableArray(Bi, e, qi);
}
function getAtom(Bi, e) {
  if (typeof Bi == "object" && Bi !== null) {
    if (isObservableArray(Bi))
      return e !== void 0 && die(23), Bi[$mobx].atom_;
    if (isObservableSet(Bi))
      return Bi.atom_;
    if (isObservableMap(Bi)) {
      if (e === void 0)
        return Bi.keysAtom_;
      var qi = Bi.data_.get(e) || Bi.hasMap_.get(e);
      return qi || die(25, e, getDebugName(Bi)), qi;
    }
    if (isObservableObject(Bi)) {
      if (!e)
        return die(26);
      var Xi = Bi[$mobx].values_.get(e);
      return Xi || die(27, e, getDebugName(Bi)), Xi;
    }
    if (isAtom(Bi) || isComputedValue(Bi) || isReaction(Bi))
      return Bi;
  } else if (isFunction$1(Bi) && isReaction(Bi[$mobx]))
    return Bi[$mobx];
  die(28);
}
function getAdministration$1(Bi, e) {
  if (Bi || die(29), isAtom(Bi) || isComputedValue(Bi) || isReaction(Bi) || isObservableMap(Bi) || isObservableSet(Bi))
    return Bi;
  if (Bi[$mobx])
    return Bi[$mobx];
  die(24, Bi);
}
function getDebugName(Bi, e) {
  var qi;
  if (e !== void 0)
    qi = getAtom(Bi, e);
  else {
    if (isAction(Bi))
      return Bi.name;
    isObservableObject(Bi) || isObservableMap(Bi) || isObservableSet(Bi) ? qi = getAdministration$1(Bi) : qi = getAtom(Bi);
  }
  return qi.name_;
}
function initObservable(Bi) {
  var e = untrackedStart(), qi = allowStateChangesStart(!0);
  startBatch();
  try {
    return Bi();
  } finally {
    endBatch(), allowStateChangesEnd(qi), untrackedEnd(e);
  }
}
var toString = objectPrototype.toString;
function deepEqual$1(Bi, e, qi) {
  return qi === void 0 && (qi = -1), eq(Bi, e, qi);
}
function eq(Bi, e, qi, Xi, Qi) {
  if (Bi === e)
    return Bi !== 0 || 1 / Bi === 1 / e;
  if (Bi == null || e == null)
    return !1;
  if (Bi !== Bi)
    return e !== e;
  var ta = typeof Bi;
  if (ta !== "function" && ta !== "object" && typeof e != "object")
    return !1;
  var ra = toString.call(Bi);
  if (ra !== toString.call(e))
    return !1;
  switch (ra) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + Bi == "" + e;
    case "[object Number]":
      return +Bi != +Bi ? +e != +e : +Bi == 0 ? 1 / +Bi === 1 / e : +Bi == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +Bi == +e;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(Bi) === Symbol.valueOf.call(e);
    case "[object Map]":
    case "[object Set]":
      qi >= 0 && qi++;
      break;
  }
  Bi = unwrap(Bi), e = unwrap(e);
  var na = ra === "[object Array]";
  if (!na) {
    if (typeof Bi != "object" || typeof e != "object")
      return !1;
    var la = Bi.constructor, Ma = e.constructor;
    if (la !== Ma && !(isFunction$1(la) && la instanceof la && isFunction$1(Ma) && Ma instanceof Ma) && "constructor" in Bi && "constructor" in e)
      return !1;
  }
  if (qi === 0)
    return !1;
  qi < 0 && (qi = -1), Xi = Xi || [], Qi = Qi || [];
  for (var Va = Xi.length; Va--; )
    if (Xi[Va] === Bi)
      return Qi[Va] === e;
  if (Xi.push(Bi), Qi.push(e), na) {
    if (Va = Bi.length, Va !== e.length)
      return !1;
    for (; Va--; )
      if (!eq(Bi[Va], e[Va], qi - 1, Xi, Qi))
        return !1;
  } else {
    var to = Object.keys(Bi), Eo;
    if (Va = to.length, Object.keys(e).length !== Va)
      return !1;
    for (; Va--; )
      if (Eo = to[Va], !(hasProp(e, Eo) && eq(Bi[Eo], e[Eo], qi - 1, Xi, Qi)))
        return !1;
  }
  return Xi.pop(), Qi.pop(), !0;
}
function unwrap(Bi) {
  return isObservableArray(Bi) ? Bi.slice() : isES6Map(Bi) || isObservableMap(Bi) || isES6Set(Bi) || isObservableSet(Bi) ? Array.from(Bi.entries()) : Bi;
}
function makeIterable(Bi) {
  return Bi[Symbol.iterator] = getSelf, Bi;
}
function getSelf() {
  return this;
}
function isAnnotation(Bi) {
  return (
    // Can be function
    Bi instanceof Object && typeof Bi.annotationType_ == "string" && isFunction$1(Bi.make_) && isFunction$1(Bi.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(Bi) {
  var e = getGlobal();
  typeof e[Bi] > "u" && die("MobX requires global '" + Bi + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy,
  extras: {
    getDebugName
  },
  $mobx
});
if (!useState)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!makeObservable)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function defaultNoopBatch(Bi) {
  Bi();
}
function observerBatching(Bi) {
  Bi || (Bi = defaultNoopBatch, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), configure({ reactionScheduler: Bi });
}
function printDebugValue(Bi) {
  return getDependencyTree(Bi);
}
var REGISTRY_FINALIZE_AFTER = 1e4, REGISTRY_SWEEP_INTERVAL = 1e4, TimerBasedFinalizationRegistry = (
  /** @class */
  function() {
    function Bi(e) {
      var qi = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(Xi) {
          Xi === void 0 && (Xi = REGISTRY_FINALIZE_AFTER), clearTimeout(qi.sweepTimeout), qi.sweepTimeout = void 0;
          var Qi = Date.now();
          qi.registrations.forEach(function(ta, ra) {
            Qi - ta.registeredAt >= Xi && (qi.finalize(ta.value), qi.registrations.delete(ra));
          }), qi.registrations.size > 0 && qi.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          qi.sweep(0);
        }
      });
    }
    return Object.defineProperty(Bi.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e, qi, Xi) {
        this.registrations.set(Xi, {
          value: qi,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(Bi.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e) {
        this.registrations.delete(e);
      }
    }), Object.defineProperty(Bi.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL));
      }
    }), Bi;
  }()
), UniversalFinalizationRegistry = typeof FinalizationRegistry < "u" ? FinalizationRegistry : TimerBasedFinalizationRegistry, observerFinalizationRegistry = new UniversalFinalizationRegistry(function(Bi) {
  var e;
  (e = Bi.reaction) === null || e === void 0 || e.dispose(), Bi.reaction = null;
}), getServerSnapshot = function() {
};
function createReaction$1(Bi) {
  Bi.reaction = new Reaction("observer".concat(Bi.name), function() {
    var e;
    Bi.stateVersion = Symbol(), (e = Bi.onStoreChange) === null || e === void 0 || e.call(Bi);
  });
}
function useObserver(Bi, e) {
  e === void 0 && (e = "observed");
  var qi = a__default.useRef(null);
  if (!qi.current) {
    var Xi = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: e,
      subscribe: function(na) {
        return observerFinalizationRegistry.unregister(Xi), Xi.onStoreChange = na, Xi.reaction || (createReaction$1(Xi), Xi.stateVersion = Symbol()), function() {
          var la;
          Xi.onStoreChange = null, (la = Xi.reaction) === null || la === void 0 || la.dispose(), Xi.reaction = null;
        };
      },
      getSnapshot: function() {
        return Xi.stateVersion;
      }
    };
    qi.current = Xi;
  }
  var Qi = qi.current;
  Qi.reaction || (createReaction$1(Qi), observerFinalizationRegistry.register(qi, Qi, Qi)), a__default.useDebugValue(Qi.reaction, printDebugValue), shimExports.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    Qi.subscribe,
    Qi.getSnapshot,
    getServerSnapshot
  );
  var ta, ra;
  if (Qi.reaction.track(function() {
    try {
      ta = Bi();
    } catch (na) {
      ra = na;
    }
  }), ra)
    throw ra;
  return ta;
}
var warnObserverOptionsDeprecated = !0, hasSymbol = typeof Symbol == "function" && Symbol.for, ReactForwardRefSymbol = hasSymbol ? Symbol.for("react.forward_ref") : typeof forwardRef == "function" && forwardRef(function(Bi) {
  return null;
}).$$typeof, ReactMemoSymbol = hasSymbol ? Symbol.for("react.memo") : typeof memo == "function" && memo(function(Bi) {
  return null;
}).$$typeof;
function observer$1(Bi, e) {
  var qi;
  if (process.env.NODE_ENV, ReactMemoSymbol && Bi.$$typeof === ReactMemoSymbol)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var Xi = (qi = void 0) !== null && qi !== void 0 ? qi : !1, Qi = Bi, ta = Bi.displayName || Bi.name;
  if (ReactForwardRefSymbol && Bi.$$typeof === ReactForwardRefSymbol && (Xi = !0, Qi = Bi.render, typeof Qi != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var ra = function(na, la) {
    return useObserver(function() {
      return Qi(na, la);
    }, ta);
  };
  return ra.displayName = Bi.displayName, Object.defineProperty(ra, "name", {
    value: Bi.name,
    writable: !0,
    configurable: !0
  }), Bi.contextTypes && (ra.contextTypes = Bi.contextTypes), Xi && (ra = forwardRef(ra)), ra = memo(ra), copyStaticProperties(Bi, ra), process.env.NODE_ENV !== "production" && Object.defineProperty(ra, "contextTypes", {
    set: function() {
      var na, la;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((na = this.type) === null || na === void 0 ? void 0 : na.displayName) || ((la = this.type) === null || la === void 0 ? void 0 : la.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), ra;
}
var hoistBlackList = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function copyStaticProperties(Bi, e) {
  Object.keys(Bi).forEach(function(qi) {
    hoistBlackList[qi] || Object.defineProperty(e, qi, Object.getOwnPropertyDescriptor(Bi, qi));
  });
}
process.env.NODE_ENV;
function useLocalObservable(Bi, e) {
  return useState(function() {
    return observable(Bi(), e, { autoBind: !0 });
  })[0];
}
var _a$1;
observerBatching(unstable_batchedUpdates);
_a$1 = observerFinalizationRegistry.finalizeAllImmediately;
function shallowEqual$1(Bi, e) {
  if (is$1(Bi, e))
    return !0;
  if (typeof Bi != "object" || Bi === null || typeof e != "object" || e === null)
    return !1;
  var qi = Object.keys(Bi), Xi = Object.keys(e);
  if (qi.length !== Xi.length)
    return !1;
  for (var Qi = 0; Qi < qi.length; Qi++)
    if (!Object.hasOwnProperty.call(e, qi[Qi]) || !is$1(Bi[qi[Qi]], e[qi[Qi]]))
      return !1;
  return !0;
}
function is$1(Bi, e) {
  return Bi === e ? Bi !== 0 || 1 / Bi === 1 / e : Bi !== Bi && e !== e;
}
var mobxMixins = /* @__PURE__ */ Symbol("patchMixins"), mobxPatchedDefinition = /* @__PURE__ */ Symbol("patchedDefinition");
function getMixins(Bi, e) {
  var qi = Bi[mobxMixins] = Bi[mobxMixins] || {}, Xi = qi[e] = qi[e] || {};
  return Xi.locks = Xi.locks || 0, Xi.methods = Xi.methods || [], Xi;
}
function wrapper(Bi, e) {
  for (var qi = this, Xi = arguments.length, Qi = new Array(Xi > 2 ? Xi - 2 : 0), ta = 2; ta < Xi; ta++)
    Qi[ta - 2] = arguments[ta];
  e.locks++;
  try {
    var ra;
    return Bi != null && (ra = Bi.apply(this, Qi)), ra;
  } finally {
    e.locks--, e.locks === 0 && e.methods.forEach(function(na) {
      na.apply(qi, Qi);
    });
  }
}
function wrapFunction(Bi, e) {
  var qi = function() {
    for (var Qi = arguments.length, ta = new Array(Qi), ra = 0; ra < Qi; ra++)
      ta[ra] = arguments[ra];
    wrapper.call.apply(wrapper, [this, Bi, e].concat(ta));
  };
  return qi;
}
function patch(Bi, e, qi) {
  var Xi = getMixins(Bi, e);
  Xi.methods.indexOf(qi) < 0 && Xi.methods.push(qi);
  var Qi = Object.getOwnPropertyDescriptor(Bi, e);
  if (!(Qi && Qi[mobxPatchedDefinition])) {
    var ta = Bi[e], ra = createDefinition(Bi, e, Qi ? Qi.enumerable : void 0, Xi, ta);
    Object.defineProperty(Bi, e, ra);
  }
}
function createDefinition(Bi, e, qi, Xi, Qi) {
  var ta, ra = wrapFunction(Qi, Xi);
  return ta = {}, ta[mobxPatchedDefinition] = !0, ta.get = function() {
    return ra;
  }, ta.set = function(la) {
    if (this === Bi)
      ra = wrapFunction(la, Xi);
    else {
      var Ma = createDefinition(this, e, qi, Xi, la);
      Object.defineProperty(this, e, Ma);
    }
  }, ta.configurable = !0, ta.enumerable = qi, ta;
}
var administrationSymbol = /* @__PURE__ */ Symbol("ObserverAdministration"), isMobXReactObserverSymbol = /* @__PURE__ */ Symbol("isMobXReactObserver"), observablePropDescriptors;
process.env.NODE_ENV !== "production" && (observablePropDescriptors = {
  props: /* @__PURE__ */ createObservablePropDescriptor("props"),
  state: /* @__PURE__ */ createObservablePropDescriptor("state"),
  context: /* @__PURE__ */ createObservablePropDescriptor("context")
});
function getAdministration(Bi) {
  var e;
  return (e = Bi[administrationSymbol]) != null ? e : Bi[administrationSymbol] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: getDisplayName(Bi.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function makeClassComponentObserver(Bi) {
  var e = Bi.prototype;
  if (Bi[isMobXReactObserverSymbol]) {
    var qi = getDisplayName(Bi);
    throw new Error("The provided component class (" + qi + ") has already been declared as an observer component.");
  } else
    Bi[isMobXReactObserverSymbol] = !0;
  if (e.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (Bi.__proto__ !== PureComponent) {
    if (!e.shouldComponentUpdate)
      e.shouldComponentUpdate = observerSCU;
    else if (e.shouldComponentUpdate !== observerSCU)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(e, observablePropDescriptors);
  var Xi = e.render;
  if (typeof Xi != "function") {
    var Qi = getDisplayName(Bi);
    throw new Error("[mobx-react] class component (" + Qi + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  e.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: createReactiveRender.call(this, Xi)
    }), this.render();
  };
  var ta = e.componentDidMount;
  return e.componentDidMount = function() {
    var ra = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var na = getDisplayName(Bi);
      throw new Error("[mobx-react] `observer(" + na + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var la = getAdministration(this);
    return la.mounted = !0, observerFinalizationRegistry.unregister(this), la.forceUpdate = function() {
      return ra.forceUpdate();
    }, (!la.reaction || la.reactionInvalidatedBeforeMount) && la.forceUpdate(), ta?.apply(this, arguments);
  }, patch(e, "componentWillUnmount", function() {
    var ra, na = getAdministration(this);
    (ra = na.reaction) == null || ra.dispose(), na.reaction = null, na.forceUpdate = null, na.mounted = !1, na.reactionInvalidatedBeforeMount = !1;
  }), Bi;
}
function getDisplayName(Bi) {
  return Bi.displayName || Bi.name || "<component>";
}
function createReactiveRender(Bi) {
  var e = Bi.bind(this), qi = getAdministration(this);
  function Xi() {
    qi.reaction || (qi.reaction = createReaction(qi), qi.mounted || observerFinalizationRegistry.register(this, qi, this));
    var Qi = void 0, ta = void 0;
    if (qi.reaction.track(function() {
      try {
        ta = allowStateChanges(!1, e);
      } catch (ra) {
        Qi = ra;
      }
    }), Qi)
      throw Qi;
    return ta;
  }
  return Xi;
}
function createReaction(Bi) {
  return new Reaction(Bi.name + ".render()", function() {
    if (!Bi.mounted) {
      Bi.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      Bi.forceUpdate == null || Bi.forceUpdate();
    } catch {
      var e;
      (e = Bi.reaction) == null || e.dispose(), Bi.reaction = null;
    }
  });
}
function observerSCU(Bi, e) {
  return this.state !== e ? !0 : !shallowEqual$1(this.props, Bi);
}
function createObservablePropDescriptor(Bi) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var qi = getAdministration(this), Xi = getGlobalState().trackingDerivation;
      if (Xi && Xi !== qi.reaction)
        throw new Error('[mobx-react] Cannot read "' + qi.name + "." + Bi + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return qi[Bi];
    },
    set: function(qi) {
      getAdministration(this)[Bi] = qi;
    }
  };
}
function observer(Bi, e) {
  return Bi.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Component, Bi) || Object.prototype.isPrototypeOf.call(PureComponent, Bi) ? makeClassComponentObserver(Bi) : observer$1(Bi);
}
a__default.version.split(".")[0];
if (!Component)
  throw new Error("mobx-react requires React to be available");
if (!observable)
  throw new Error("mobx-react requires mobx to be available");
const DndContext = createContext({
  dragDropManager: void 0
});
function formatProdErrorMessage(Bi) {
  return "Minified Redux error #" + Bi + "; visit https://redux.js.org/Errors?code=" + Bi + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), randomString = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString()
};
function isPlainObject$1(Bi) {
  if (typeof Bi != "object" || Bi === null) return !1;
  for (var e = Bi; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(Bi) === e;
}
function miniKindOf(Bi) {
  if (Bi === void 0) return "undefined";
  if (Bi === null) return "null";
  var e = typeof Bi;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return e;
  }
  if (Array.isArray(Bi)) return "array";
  if (isDate(Bi)) return "date";
  if (isError(Bi)) return "error";
  var qi = ctorName(Bi);
  switch (qi) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return qi;
  }
  return e.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(Bi) {
  return typeof Bi.constructor == "function" ? Bi.constructor.name : null;
}
function isError(Bi) {
  return Bi instanceof Error || typeof Bi.message == "string" && Bi.constructor && typeof Bi.constructor.stackTraceLimit == "number";
}
function isDate(Bi) {
  return Bi instanceof Date ? !0 : typeof Bi.toDateString == "function" && typeof Bi.getDate == "function" && typeof Bi.setDate == "function";
}
function kindOf(Bi) {
  var e = typeof Bi;
  return process.env.NODE_ENV !== "production" && (e = miniKindOf(Bi)), e;
}
function createStore(Bi, e, qi) {
  var Xi;
  if (typeof e == "function" && typeof qi == "function" || typeof qi == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof e == "function" && typeof qi > "u" && (qi = e, e = void 0), typeof qi < "u") {
    if (typeof qi != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(qi) + "'");
    return qi(createStore)(Bi, e);
  }
  if (typeof Bi != "function")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(Bi) + "'");
  var Qi = Bi, ta = e, ra = [], na = ra, la = !1;
  function Ma() {
    na === ra && (na = ra.slice());
  }
  function Va() {
    if (la)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return ta;
  }
  function to(rs) {
    if (typeof rs != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(rs) + "'");
    if (la)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var ko = !0;
    return Ma(), na.push(rs), function() {
      if (ko) {
        if (la)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        ko = !1, Ma();
        var Ks = na.indexOf(rs);
        na.splice(Ks, 1), ra = null;
      }
    };
  }
  function Eo(rs) {
    if (!isPlainObject$1(rs))
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(rs) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof rs.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (la)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    try {
      la = !0, ta = Qi(ta, rs);
    } finally {
      la = !1;
    }
    for (var ko = ra = na, Hs = 0; Hs < ko.length; Hs++) {
      var Ks = ko[Hs];
      Ks();
    }
    return rs;
  }
  function So(rs) {
    if (typeof rs != "function")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(rs));
    Qi = rs, Eo({
      type: ActionTypes.REPLACE
    });
  }
  function eo() {
    var rs, ko = to;
    return rs = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(Ks) {
        if (typeof Ks != "object" || Ks === null)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(Ks) + "'");
        function Ys() {
          Ks.next && Ks.next(Va());
        }
        Ys();
        var Xs = ko(Ys);
        return {
          unsubscribe: Xs
        };
      }
    }, rs[$$observable] = function() {
      return this;
    }, rs;
  }
  return Eo({
    type: ActionTypes.INIT
  }), Xi = {
    dispatch: Eo,
    subscribe: to,
    getState: Va,
    replaceReducer: So
  }, Xi[$$observable] = eo, Xi;
}
function warning(Bi) {
  typeof console < "u" && typeof console.error == "function" && console.error(Bi);
  try {
    throw new Error(Bi);
  } catch {
  }
}
function isCrushed() {
}
process.env.NODE_ENV !== "production" && typeof isCrushed.name == "string" && isCrushed.name !== "isCrushed" && warning('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');
function invariant(Bi, e, ...qi) {
  if (isProduction() && e === void 0)
    throw new Error("invariant requires an error message argument");
  if (!Bi) {
    let Xi;
    if (e === void 0)
      Xi = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let Qi = 0;
      Xi = new Error(e.replace(/%s/g, function() {
        return qi[Qi++];
      })), Xi.name = "Invariant Violation";
    }
    throw Xi.framesToPop = 1, Xi;
  }
}
function isProduction() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function get$1(Bi, e, qi) {
  return e.split(".").reduce(
    (Xi, Qi) => Xi && Xi[Qi] ? Xi[Qi] : qi || null,
    Bi
  );
}
function without$1(Bi, e) {
  return Bi.filter(
    (qi) => qi !== e
  );
}
function isObject$2(Bi) {
  return typeof Bi == "object";
}
function xor(Bi, e) {
  const qi = /* @__PURE__ */ new Map(), Xi = (ta) => {
    qi.set(ta, qi.has(ta) ? qi.get(ta) + 1 : 1);
  };
  Bi.forEach(Xi), e.forEach(Xi);
  const Qi = [];
  return qi.forEach((ta, ra) => {
    ta === 1 && Qi.push(ra);
  }), Qi;
}
function intersection(Bi, e) {
  return Bi.filter(
    (qi) => e.indexOf(qi) > -1
  );
}
const INIT_COORDS = "dnd-core/INIT_COORDS", BEGIN_DRAG = "dnd-core/BEGIN_DRAG", PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE", HOVER = "dnd-core/HOVER", DROP = "dnd-core/DROP", END_DRAG = "dnd-core/END_DRAG";
function setClientOffset(Bi, e) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: e || null,
      clientOffset: Bi || null
    }
  };
}
const ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(Bi) {
  return function(qi = [], Xi = {
    publishSource: !0
  }) {
    const { publishSource: Qi = !0, clientOffset: ta, getSourceClientOffset: ra } = Xi, na = Bi.getMonitor(), la = Bi.getRegistry();
    Bi.dispatch(setClientOffset(ta)), verifyInvariants$1(qi, na, la);
    const Ma = getDraggableSource(qi, na);
    if (Ma == null) {
      Bi.dispatch(ResetCoordinatesAction);
      return;
    }
    let Va = null;
    if (ta) {
      if (!ra)
        throw new Error("getSourceClientOffset must be defined");
      verifyGetSourceClientOffsetIsFunction(ra), Va = ra(Ma);
    }
    Bi.dispatch(setClientOffset(ta, Va));
    const Eo = la.getSource(Ma).beginDrag(na, Ma);
    if (Eo == null)
      return;
    verifyItemIsObject(Eo), la.pinSource(Ma);
    const So = la.getSourceType(Ma);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: So,
        item: Eo,
        sourceId: Ma,
        clientOffset: ta || null,
        sourceClientOffset: Va || null,
        isSourcePublic: !!Qi
      }
    };
  };
}
function verifyInvariants$1(Bi, e, qi) {
  invariant(!e.isDragging(), "Cannot call beginDrag while dragging."), Bi.forEach(function(Xi) {
    invariant(qi.getSource(Xi), "Expected sourceIds to be registered.");
  });
}
function verifyGetSourceClientOffsetIsFunction(Bi) {
  invariant(typeof Bi == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function verifyItemIsObject(Bi) {
  invariant(isObject$2(Bi), "Item must be an object.");
}
function getDraggableSource(Bi, e) {
  let qi = null;
  for (let Xi = Bi.length - 1; Xi >= 0; Xi--)
    if (e.canDragSource(Bi[Xi])) {
      qi = Bi[Xi];
      break;
    }
  return qi;
}
function _defineProperty$6(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function _objectSpread$6(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {}, Xi = Object.keys(qi);
    typeof Object.getOwnPropertySymbols == "function" && (Xi = Xi.concat(Object.getOwnPropertySymbols(qi).filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(qi, Qi).enumerable;
    }))), Xi.forEach(function(Qi) {
      _defineProperty$6(Bi, Qi, qi[Qi]);
    });
  }
  return Bi;
}
function createDrop(Bi) {
  return function(qi = {}) {
    const Xi = Bi.getMonitor(), Qi = Bi.getRegistry();
    verifyInvariants(Xi), getDroppableTargets(Xi).forEach((ra, na) => {
      const la = determineDropResult(ra, na, Qi, Xi), Ma = {
        type: DROP,
        payload: {
          dropResult: _objectSpread$6({}, qi, la)
        }
      };
      Bi.dispatch(Ma);
    });
  };
}
function verifyInvariants(Bi) {
  invariant(Bi.isDragging(), "Cannot call drop while not dragging."), invariant(!Bi.didDrop(), "Cannot call drop twice during one drag operation.");
}
function determineDropResult(Bi, e, qi, Xi) {
  const Qi = qi.getTarget(Bi);
  let ta = Qi ? Qi.drop(Xi, Bi) : void 0;
  return verifyDropResultType(ta), typeof ta > "u" && (ta = e === 0 ? {} : Xi.getDropResult()), ta;
}
function verifyDropResultType(Bi) {
  invariant(typeof Bi > "u" || isObject$2(Bi), "Drop result must either be an object or undefined.");
}
function getDroppableTargets(Bi) {
  const e = Bi.getTargetIds().filter(Bi.canDropOnTarget, Bi);
  return e.reverse(), e;
}
function createEndDrag(Bi) {
  return function() {
    const qi = Bi.getMonitor(), Xi = Bi.getRegistry();
    verifyIsDragging(qi);
    const Qi = qi.getSourceId();
    return Qi != null && (Xi.getSource(Qi, !0).endDrag(qi, Qi), Xi.unpinSource()), {
      type: END_DRAG
    };
  };
}
function verifyIsDragging(Bi) {
  invariant(Bi.isDragging(), "Cannot call endDrag while not dragging.");
}
function matchesType(Bi, e) {
  return e === null ? Bi === null : Array.isArray(Bi) ? Bi.some(
    (qi) => qi === e
  ) : Bi === e;
}
function createHover(Bi) {
  return function(qi, { clientOffset: Xi } = {}) {
    verifyTargetIdsIsArray(qi);
    const Qi = qi.slice(0), ta = Bi.getMonitor(), ra = Bi.getRegistry(), na = ta.getItemType();
    return removeNonMatchingTargetIds(Qi, ra, na), checkInvariants(Qi, ta, ra), hoverAllTargets(Qi, ta, ra), {
      type: HOVER,
      payload: {
        targetIds: Qi,
        clientOffset: Xi || null
      }
    };
  };
}
function verifyTargetIdsIsArray(Bi) {
  invariant(Array.isArray(Bi), "Expected targetIds to be an array.");
}
function checkInvariants(Bi, e, qi) {
  invariant(e.isDragging(), "Cannot call hover while not dragging."), invariant(!e.didDrop(), "Cannot call hover after drop.");
  for (let Xi = 0; Xi < Bi.length; Xi++) {
    const Qi = Bi[Xi];
    invariant(Bi.lastIndexOf(Qi) === Xi, "Expected targetIds to be unique in the passed array.");
    const ta = qi.getTarget(Qi);
    invariant(ta, "Expected targetIds to be registered.");
  }
}
function removeNonMatchingTargetIds(Bi, e, qi) {
  for (let Xi = Bi.length - 1; Xi >= 0; Xi--) {
    const Qi = Bi[Xi], ta = e.getTargetType(Qi);
    matchesType(ta, qi) || Bi.splice(Xi, 1);
  }
}
function hoverAllTargets(Bi, e, qi) {
  Bi.forEach(function(Xi) {
    qi.getTarget(Xi).hover(e, Xi);
  });
}
function createPublishDragSource(Bi) {
  return function() {
    if (Bi.getMonitor().isDragging())
      return {
        type: PUBLISH_DRAG_SOURCE
      };
  };
}
function createDragDropActions(Bi) {
  return {
    beginDrag: createBeginDrag(Bi),
    publishDragSource: createPublishDragSource(Bi),
    hover: createHover(Bi),
    drop: createDrop(Bi),
    endDrag: createEndDrag(Bi)
  };
}
class DragDropManagerImpl {
  receiveBackend(e) {
    this.backend = e;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const e = this, { dispatch: qi } = this.store;
    function Xi(ta) {
      return (...ra) => {
        const na = ta.apply(e, ra);
        typeof na < "u" && qi(na);
      };
    }
    const Qi = createDragDropActions(this);
    return Object.keys(Qi).reduce((ta, ra) => {
      const na = Qi[ra];
      return ta[ra] = Xi(na), ta;
    }, {});
  }
  dispatch(e) {
    this.store.dispatch(e);
  }
  constructor(e, qi) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const Xi = this.store.getState().refCount > 0;
      this.backend && (Xi && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !Xi && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = e, this.monitor = qi, e.subscribe(this.handleRefCountChange);
  }
}
function add(Bi, e) {
  return {
    x: Bi.x + e.x,
    y: Bi.y + e.y
  };
}
function subtract(Bi, e) {
  return {
    x: Bi.x - e.x,
    y: Bi.y - e.y
  };
}
function getSourceClientOffset(Bi) {
  const { clientOffset: e, initialClientOffset: qi, initialSourceClientOffset: Xi } = Bi;
  return !e || !qi || !Xi ? null : subtract(add(e, Xi), qi);
}
function getDifferenceFromInitialOffset(Bi) {
  const { clientOffset: e, initialClientOffset: qi } = Bi;
  return !e || !qi ? null : subtract(e, qi);
}
const NONE = [], ALL = [];
NONE.__IS_NONE__ = !0;
ALL.__IS_ALL__ = !0;
function areDirty(Bi, e) {
  return Bi === NONE ? !1 : Bi === ALL || typeof e > "u" ? !0 : intersection(e, Bi).length > 0;
}
class DragDropMonitorImpl {
  subscribeToStateChange(e, qi = {}) {
    const { handlerIds: Xi } = qi;
    invariant(typeof e == "function", "listener must be a function."), invariant(typeof Xi > "u" || Array.isArray(Xi), "handlerIds, when specified, must be an array of strings.");
    let Qi = this.store.getState().stateId;
    const ta = () => {
      const ra = this.store.getState(), na = ra.stateId;
      try {
        na === Qi || na === Qi + 1 && !areDirty(ra.dirtyHandlerIds, Xi) || e();
      } finally {
        Qi = na;
      }
    };
    return this.store.subscribe(ta);
  }
  subscribeToOffsetChange(e) {
    invariant(typeof e == "function", "listener must be a function.");
    let qi = this.store.getState().dragOffset;
    const Xi = () => {
      const Qi = this.store.getState().dragOffset;
      Qi !== qi && (qi = Qi, e());
    };
    return this.store.subscribe(Xi);
  }
  canDragSource(e) {
    if (!e)
      return !1;
    const qi = this.registry.getSource(e);
    return invariant(qi, `Expected to find a valid source. sourceId=${e}`), this.isDragging() ? !1 : qi.canDrag(this, e);
  }
  canDropOnTarget(e) {
    if (!e)
      return !1;
    const qi = this.registry.getTarget(e);
    if (invariant(qi, `Expected to find a valid target. targetId=${e}`), !this.isDragging() || this.didDrop())
      return !1;
    const Xi = this.registry.getTargetType(e), Qi = this.getItemType();
    return matchesType(Xi, Qi) && qi.canDrop(this, e);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(e) {
    if (!e)
      return !1;
    const qi = this.registry.getSource(e, !0);
    if (invariant(qi, `Expected to find a valid source. sourceId=${e}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const Xi = this.registry.getSourceType(e), Qi = this.getItemType();
    return Xi !== Qi ? !1 : qi.isDragging(this, e);
  }
  isOverTarget(e, qi = {
    shallow: !1
  }) {
    if (!e)
      return !1;
    const { shallow: Xi } = qi;
    if (!this.isDragging())
      return !1;
    const Qi = this.registry.getTargetType(e), ta = this.getItemType();
    if (ta && !matchesType(Qi, ta))
      return !1;
    const ra = this.getTargetIds();
    if (!ra.length)
      return !1;
    const na = ra.indexOf(e);
    return Xi ? na === ra.length - 1 : na > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return getSourceClientOffset(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
  }
  constructor(e, qi) {
    this.store = e, this.registry = qi;
  }
}
const scope = typeof global < "u" ? global : self, BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(Bi) {
  return function() {
    const qi = setTimeout(Qi, 0), Xi = setInterval(Qi, 50);
    function Qi() {
      clearTimeout(qi), clearInterval(Xi), Bi();
    }
  };
}
function makeRequestCallFromMutationObserver(Bi) {
  let e = 1;
  const qi = new BrowserMutationObserver(Bi), Xi = document.createTextNode("");
  return qi.observe(Xi, {
    characterData: !0
  }), function() {
    e = -e, Xi.data = e;
  };
}
const makeRequestCall = typeof BrowserMutationObserver == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  makeRequestCallFromMutationObserver
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  makeRequestCallFromTimer
);
class AsapQueue {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(e) {
    const { queue: qi, requestFlush: Xi } = this;
    qi.length || (Xi(), this.flushing = !0), qi[qi.length] = e;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: e } = this;
      for (; this.index < e.length; ) {
        const qi = this.index;
        if (this.index++, e[qi].call(), this.index > this.capacity) {
          for (let Xi = 0, Qi = e.length - this.index; Xi < Qi; Xi++)
            e[Xi] = e[Xi + this.index];
          e.length -= this.index, this.index = 0;
        }
      }
      e.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (e) => {
      this.pendingErrors.push(e), this.requestErrorThrow();
    }, this.requestFlush = makeRequestCall(this.flush), this.requestErrorThrow = makeRequestCallFromTimer(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class RawTask {
  call() {
    try {
      this.task && this.task();
    } catch (e) {
      this.onError(e);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(e, qi) {
    this.onError = e, this.release = qi, this.task = null;
  }
}
class TaskFactory {
  create(e) {
    const qi = this.freeTasks, Xi = qi.length ? qi.pop() : new RawTask(
      this.onError,
      (Qi) => qi[qi.length] = Qi
    );
    return Xi.task = e, Xi;
  }
  constructor(e) {
    this.onError = e, this.freeTasks = [];
  }
}
const asapQueue = new AsapQueue(), taskFactory = new TaskFactory(asapQueue.registerPendingError);
function asap(Bi) {
  asapQueue.enqueueTask(taskFactory.create(Bi));
}
const ADD_SOURCE = "dnd-core/ADD_SOURCE", ADD_TARGET = "dnd-core/ADD_TARGET", REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE", REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function addSource(Bi) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: Bi
    }
  };
}
function addTarget(Bi) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: Bi
    }
  };
}
function removeSource(Bi) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: Bi
    }
  };
}
function removeTarget(Bi) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: Bi
    }
  };
}
function validateSourceContract(Bi) {
  invariant(typeof Bi.canDrag == "function", "Expected canDrag to be a function."), invariant(typeof Bi.beginDrag == "function", "Expected beginDrag to be a function."), invariant(typeof Bi.endDrag == "function", "Expected endDrag to be a function.");
}
function validateTargetContract(Bi) {
  invariant(typeof Bi.canDrop == "function", "Expected canDrop to be a function."), invariant(typeof Bi.hover == "function", "Expected hover to be a function."), invariant(typeof Bi.drop == "function", "Expected beginDrag to be a function.");
}
function validateType(Bi, e) {
  if (e && Array.isArray(Bi)) {
    Bi.forEach(
      (qi) => validateType(qi, !1)
    );
    return;
  }
  invariant(typeof Bi == "string" || typeof Bi == "symbol", e ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var HandlerRole;
(function(Bi) {
  Bi.SOURCE = "SOURCE", Bi.TARGET = "TARGET";
})(HandlerRole || (HandlerRole = {}));
let nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}
function getNextHandlerId(Bi) {
  const e = getNextUniqueId().toString();
  switch (Bi) {
    case HandlerRole.SOURCE:
      return `S${e}`;
    case HandlerRole.TARGET:
      return `T${e}`;
    default:
      throw new Error(`Unknown Handler Role: ${Bi}`);
  }
}
function parseRoleFromHandlerId(Bi) {
  switch (Bi[0]) {
    case "S":
      return HandlerRole.SOURCE;
    case "T":
      return HandlerRole.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${Bi}`);
  }
}
function mapContainsValue(Bi, e) {
  const qi = Bi.entries();
  let Xi = !1;
  do {
    const { done: Qi, value: [, ta] } = qi.next();
    if (ta === e)
      return !0;
    Xi = !!Qi;
  } while (!Xi);
  return !1;
}
class HandlerRegistryImpl {
  addSource(e, qi) {
    validateType(e), validateSourceContract(qi);
    const Xi = this.addHandler(HandlerRole.SOURCE, e, qi);
    return this.store.dispatch(addSource(Xi)), Xi;
  }
  addTarget(e, qi) {
    validateType(e, !0), validateTargetContract(qi);
    const Xi = this.addHandler(HandlerRole.TARGET, e, qi);
    return this.store.dispatch(addTarget(Xi)), Xi;
  }
  containsHandler(e) {
    return mapContainsValue(this.dragSources, e) || mapContainsValue(this.dropTargets, e);
  }
  getSource(e, qi = !1) {
    return invariant(this.isSourceId(e), "Expected a valid source ID."), qi && e === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e);
  }
  getTarget(e) {
    return invariant(this.isTargetId(e), "Expected a valid target ID."), this.dropTargets.get(e);
  }
  getSourceType(e) {
    return invariant(this.isSourceId(e), "Expected a valid source ID."), this.types.get(e);
  }
  getTargetType(e) {
    return invariant(this.isTargetId(e), "Expected a valid target ID."), this.types.get(e);
  }
  isSourceId(e) {
    return parseRoleFromHandlerId(e) === HandlerRole.SOURCE;
  }
  isTargetId(e) {
    return parseRoleFromHandlerId(e) === HandlerRole.TARGET;
  }
  removeSource(e) {
    invariant(this.getSource(e), "Expected an existing source."), this.store.dispatch(removeSource(e)), asap(() => {
      this.dragSources.delete(e), this.types.delete(e);
    });
  }
  removeTarget(e) {
    invariant(this.getTarget(e), "Expected an existing target."), this.store.dispatch(removeTarget(e)), this.dropTargets.delete(e), this.types.delete(e);
  }
  pinSource(e) {
    const qi = this.getSource(e);
    invariant(qi, "Expected an existing source."), this.pinnedSourceId = e, this.pinnedSource = qi;
  }
  unpinSource() {
    invariant(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(e, qi, Xi) {
    const Qi = getNextHandlerId(e);
    return this.types.set(Qi, qi), e === HandlerRole.SOURCE ? this.dragSources.set(Qi, Xi) : e === HandlerRole.TARGET && this.dropTargets.set(Qi, Xi), Qi;
  }
  constructor(e) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = e;
  }
}
const strictEquality = (Bi, e) => Bi === e;
function areCoordsEqual(Bi, e) {
  return !Bi && !e ? !0 : !Bi || !e ? !1 : Bi.x === e.x && Bi.y === e.y;
}
function areArraysEqual(Bi, e, qi = strictEquality) {
  if (Bi.length !== e.length)
    return !1;
  for (let Xi = 0; Xi < Bi.length; ++Xi)
    if (!qi(Bi[Xi], e[Xi]))
      return !1;
  return !0;
}
function reduce$5(Bi = NONE, e) {
  switch (e.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  const { targetIds: qi = [], prevTargetIds: Xi = [] } = e.payload, Qi = xor(qi, Xi);
  if (!(Qi.length > 0 || !areArraysEqual(qi, Xi)))
    return NONE;
  const ra = Xi[Xi.length - 1], na = qi[qi.length - 1];
  return ra !== na && (ra && Qi.push(ra), na && Qi.push(na)), Qi;
}
function _defineProperty$5(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function _objectSpread$5(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {}, Xi = Object.keys(qi);
    typeof Object.getOwnPropertySymbols == "function" && (Xi = Xi.concat(Object.getOwnPropertySymbols(qi).filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(qi, Qi).enumerable;
    }))), Xi.forEach(function(Qi) {
      _defineProperty$5(Bi, Qi, qi[Qi]);
    });
  }
  return Bi;
}
const initialState$2 = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce$4(Bi = initialState$2, e) {
  const { payload: qi } = e;
  switch (e.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: qi.sourceClientOffset,
        initialClientOffset: qi.clientOffset,
        clientOffset: qi.clientOffset
      };
    case HOVER:
      return areCoordsEqual(Bi.clientOffset, qi.clientOffset) ? Bi : _objectSpread$5({}, Bi, {
        clientOffset: qi.clientOffset
      });
    case END_DRAG:
    case DROP:
      return initialState$2;
    default:
      return Bi;
  }
}
function _defineProperty$4(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function _objectSpread$4(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {}, Xi = Object.keys(qi);
    typeof Object.getOwnPropertySymbols == "function" && (Xi = Xi.concat(Object.getOwnPropertySymbols(qi).filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(qi, Qi).enumerable;
    }))), Xi.forEach(function(Qi) {
      _defineProperty$4(Bi, Qi, qi[Qi]);
    });
  }
  return Bi;
}
const initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function reduce$3(Bi = initialState$1, e) {
  const { payload: qi } = e;
  switch (e.type) {
    case BEGIN_DRAG:
      return _objectSpread$4({}, Bi, {
        itemType: qi.itemType,
        item: qi.item,
        sourceId: qi.sourceId,
        isSourcePublic: qi.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$4({}, Bi, {
        isSourcePublic: !0
      });
    case HOVER:
      return _objectSpread$4({}, Bi, {
        targetIds: qi.targetIds
      });
    case REMOVE_TARGET:
      return Bi.targetIds.indexOf(qi.targetId) === -1 ? Bi : _objectSpread$4({}, Bi, {
        targetIds: without$1(Bi.targetIds, qi.targetId)
      });
    case DROP:
      return _objectSpread$4({}, Bi, {
        dropResult: qi.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case END_DRAG:
      return _objectSpread$4({}, Bi, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return Bi;
  }
}
function reduce$2(Bi = 0, e) {
  switch (e.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return Bi + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return Bi - 1;
    default:
      return Bi;
  }
}
function reduce$1(Bi = 0) {
  return Bi + 1;
}
function _defineProperty$3(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function _objectSpread$3(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {}, Xi = Object.keys(qi);
    typeof Object.getOwnPropertySymbols == "function" && (Xi = Xi.concat(Object.getOwnPropertySymbols(qi).filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(qi, Qi).enumerable;
    }))), Xi.forEach(function(Qi) {
      _defineProperty$3(Bi, Qi, qi[Qi]);
    });
  }
  return Bi;
}
function reduce(Bi = {}, e) {
  return {
    dirtyHandlerIds: reduce$5(Bi.dirtyHandlerIds, {
      type: e.type,
      payload: _objectSpread$3({}, e.payload, {
        prevTargetIds: get$1(Bi, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: reduce$4(Bi.dragOffset, e),
    refCount: reduce$2(Bi.refCount, e),
    dragOperation: reduce$3(Bi.dragOperation, e),
    stateId: reduce$1(Bi.stateId)
  };
}
function createDragDropManager(Bi, e = void 0, qi = {}, Xi = !1) {
  const Qi = makeStoreInstance(Xi), ta = new DragDropMonitorImpl(Qi, new HandlerRegistryImpl(Qi)), ra = new DragDropManagerImpl(Qi, ta), na = Bi(ra, e, qi);
  return ra.receiveBackend(na), ra;
}
function makeStoreInstance(Bi) {
  const e = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, Bi && e && e({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function _objectWithoutProperties$1(Bi, e) {
  if (Bi == null) return {};
  var qi = _objectWithoutPropertiesLoose$1(Bi, e), Xi, Qi;
  if (Object.getOwnPropertySymbols) {
    var ta = Object.getOwnPropertySymbols(Bi);
    for (Qi = 0; Qi < ta.length; Qi++)
      Xi = ta[Qi], !(e.indexOf(Xi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Xi) && (qi[Xi] = Bi[Xi]);
  }
  return qi;
}
function _objectWithoutPropertiesLoose$1(Bi, e) {
  if (Bi == null) return {};
  var qi = {}, Xi = Object.keys(Bi), Qi, ta;
  for (ta = 0; ta < Xi.length; ta++)
    Qi = Xi[ta], !(e.indexOf(Qi) >= 0) && (qi[Qi] = Bi[Qi]);
  return qi;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var DndProvider = /* @__PURE__ */ memo(function(e) {
  var { children: qi } = e, Xi = _objectWithoutProperties$1(e, [
    "children"
  ]);
  const [Qi, ta] = getDndContextValue(Xi);
  return useEffect(() => {
    if (ta) {
      const ra = getGlobalContext();
      return ++refCount, () => {
        --refCount === 0 && (ra[INSTANCE_SYM] = null);
      };
    }
  }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(DndContext.Provider, {
    value: Qi,
    children: qi
  });
});
function getDndContextValue(Bi) {
  if ("manager" in Bi)
    return [
      {
        dragDropManager: Bi.manager
      },
      !1
    ];
  const e = createSingletonDndContext(Bi.backend, Bi.context, Bi.options, Bi.debugMode), qi = !Bi.context;
  return [
    e,
    qi
  ];
}
function createSingletonDndContext(Bi, e = getGlobalContext(), qi, Xi) {
  const Qi = e;
  return Qi[INSTANCE_SYM] || (Qi[INSTANCE_SYM] = {
    dragDropManager: createDragDropManager(Bi, e, qi, Xi)
  }), Qi[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global < "u" ? global : window;
}
var fastDeepEqual, hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  return hasRequiredFastDeepEqual || (hasRequiredFastDeepEqual = 1, fastDeepEqual = function Bi(e, qi) {
    if (e === qi) return !0;
    if (e && qi && typeof e == "object" && typeof qi == "object") {
      if (e.constructor !== qi.constructor) return !1;
      var Xi, Qi, ta;
      if (Array.isArray(e)) {
        if (Xi = e.length, Xi != qi.length) return !1;
        for (Qi = Xi; Qi-- !== 0; )
          if (!Bi(e[Qi], qi[Qi])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === qi.source && e.flags === qi.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === qi.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === qi.toString();
      if (ta = Object.keys(e), Xi = ta.length, Xi !== Object.keys(qi).length) return !1;
      for (Qi = Xi; Qi-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(qi, ta[Qi])) return !1;
      for (Qi = Xi; Qi-- !== 0; ) {
        var ra = ta[Qi];
        if (!Bi(e[ra], qi[ra])) return !1;
      }
      return !0;
    }
    return e !== e && qi !== qi;
  }), fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual();
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports), useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect : useEffect;
function useCollector(Bi, e, qi) {
  const [Xi, Qi] = useState(
    () => e(Bi)
  ), ta = useCallback(() => {
    const ra = e(Bi);
    equal(Xi, ra) || (Qi(ra), qi && qi());
  }, [
    Xi,
    Bi,
    qi
  ]);
  return useIsomorphicLayoutEffect(ta), [
    Xi,
    ta
  ];
}
function useMonitorOutput(Bi, e, qi) {
  const [Xi, Qi] = useCollector(Bi, e, qi);
  return useIsomorphicLayoutEffect(function() {
    const ra = Bi.getHandlerId();
    if (ra != null)
      return Bi.subscribeToStateChange(Qi, {
        handlerIds: [
          ra
        ]
      });
  }, [
    Bi,
    Qi
  ]), Xi;
}
function useCollectedProps(Bi, e, qi) {
  return useMonitorOutput(
    e,
    Bi || (() => ({})),
    () => qi.reconnect()
  );
}
function useOptionalFactory(Bi, e) {
  const qi = [];
  return typeof Bi != "function" && qi.push(Bi), useMemo(() => typeof Bi == "function" ? Bi() : Bi, qi);
}
function useConnectDragSource(Bi) {
  return useMemo(
    () => Bi.hooks.dragSource(),
    [
      Bi
    ]
  );
}
function useConnectDragPreview(Bi) {
  return useMemo(
    () => Bi.hooks.dragPreview(),
    [
      Bi
    ]
  );
}
let isCallingCanDrag = !1, isCallingIsDragging = !1;
class DragSourceMonitorImpl {
  receiveHandlerId(e) {
    this.sourceId = e;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    invariant(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return isCallingCanDrag = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      isCallingCanDrag = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    invariant(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return isCallingIsDragging = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      isCallingIsDragging = !1;
    }
  }
  subscribeToStateChange(e, qi) {
    return this.internalMonitor.subscribeToStateChange(e, qi);
  }
  isDraggingSource(e) {
    return this.internalMonitor.isDraggingSource(e);
  }
  isOverTarget(e, qi) {
    return this.internalMonitor.isOverTarget(e, qi);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(e) {
    return this.internalMonitor.subscribeToOffsetChange(e);
  }
  canDragSource(e) {
    return this.internalMonitor.canDragSource(e);
  }
  canDropOnTarget(e) {
    return this.internalMonitor.canDropOnTarget(e);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.sourceId = null, this.internalMonitor = e.getMonitor();
  }
}
let isCallingCanDrop = !1;
class DropTargetMonitorImpl {
  receiveHandlerId(e) {
    this.targetId = e;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(e, qi) {
    return this.internalMonitor.subscribeToStateChange(e, qi);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    invariant(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return isCallingCanDrop = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      isCallingCanDrop = !1;
    }
  }
  isOver(e) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, e) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.targetId = null, this.internalMonitor = e.getMonitor();
  }
}
function registerTarget(Bi, e, qi) {
  const Xi = qi.getRegistry(), Qi = Xi.addTarget(Bi, e);
  return [
    Qi,
    () => Xi.removeTarget(Qi)
  ];
}
function registerSource(Bi, e, qi) {
  const Xi = qi.getRegistry(), Qi = Xi.addSource(Bi, e);
  return [
    Qi,
    () => Xi.removeSource(Qi)
  ];
}
function shallowEqual(Bi, e, qi, Xi) {
  let Qi;
  if (Qi !== void 0)
    return !!Qi;
  if (Bi === e)
    return !0;
  if (typeof Bi != "object" || !Bi || typeof e != "object" || !e)
    return !1;
  const ta = Object.keys(Bi), ra = Object.keys(e);
  if (ta.length !== ra.length)
    return !1;
  const na = Object.prototype.hasOwnProperty.bind(e);
  for (let la = 0; la < ta.length; la++) {
    const Ma = ta[la];
    if (!na(Ma))
      return !1;
    const Va = Bi[Ma], to = e[Ma];
    if (Qi = void 0, Qi === !1 || Qi === void 0 && Va !== to)
      return !1;
  }
  return !0;
}
function isRef(Bi) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    Bi !== null && typeof Bi == "object" && Object.prototype.hasOwnProperty.call(Bi, "current")
  );
}
function throwIfCompositeComponentElement(Bi) {
  if (typeof Bi.type == "string")
    return;
  const e = Bi.type.displayName || Bi.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${e} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function wrapHookToRecognizeElement(Bi) {
  return (e = null, qi = null) => {
    if (!isValidElement(e)) {
      const ta = e;
      return Bi(ta, qi), ta;
    }
    const Xi = e;
    return throwIfCompositeComponentElement(Xi), cloneWithRef(Xi, qi ? (ta) => Bi(ta, qi) : Bi);
  };
}
function wrapConnectorHooks(Bi) {
  const e = {};
  return Object.keys(Bi).forEach((qi) => {
    const Xi = Bi[qi];
    if (qi.endsWith("Ref"))
      e[qi] = Bi[qi];
    else {
      const Qi = wrapHookToRecognizeElement(Xi);
      e[qi] = () => Qi;
    }
  }), e;
}
function setRef(Bi, e) {
  typeof Bi == "function" ? Bi(e) : Bi.current = e;
}
function cloneWithRef(Bi, e) {
  const qi = Bi.ref;
  return invariant(typeof qi != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), qi ? cloneElement(Bi, {
    ref: (Xi) => {
      setRef(qi, Xi), setRef(e, Xi);
    }
  }) : cloneElement(Bi, {
    ref: e
  });
}
class SourceConnector {
  receiveHandlerId(e) {
    this.handlerId !== e && (this.handlerId = e, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(e) {
    this.dragSourceOptionsInternal = e;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(e) {
    this.dragPreviewOptionsInternal = e;
  }
  reconnect() {
    const e = this.reconnectDragSource();
    this.reconnectDragPreview(e);
  }
  reconnectDragSource() {
    const e = this.dragSource, qi = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return qi && this.disconnectDragSource(), this.handlerId ? e ? (qi && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e, this.dragSourceOptions)), qi) : (this.lastConnectedDragSource = e, qi) : qi;
  }
  reconnectDragPreview(e = !1) {
    const qi = this.dragPreview, Xi = e || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (Xi && this.disconnectDragPreview(), !!this.handlerId) {
      if (!qi) {
        this.lastConnectedDragPreview = qi;
        return;
      }
      Xi && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = qi, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, qi, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(e) {
    this.hooks = wrapConnectorHooks({
      dragSource: (qi, Xi) => {
        this.clearDragSource(), this.dragSourceOptions = Xi || null, isRef(qi) ? this.dragSourceRef = qi : this.dragSourceNode = qi, this.reconnectDragSource();
      },
      dragPreview: (qi, Xi) => {
        this.clearDragPreview(), this.dragPreviewOptions = Xi || null, isRef(qi) ? this.dragPreviewRef = qi : this.dragPreviewNode = qi, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = e;
  }
}
class TargetConnector {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const e = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    e && this.disconnectDropTarget();
    const qi = this.dropTarget;
    if (this.handlerId) {
      if (!qi) {
        this.lastConnectedDropTarget = qi;
        return;
      }
      e && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = qi, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, qi, this.dropTargetOptions));
    }
  }
  receiveHandlerId(e) {
    e !== this.handlerId && (this.handlerId = e, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(e) {
    this.dropTargetOptionsInternal = e;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(e) {
    this.hooks = wrapConnectorHooks({
      dropTarget: (qi, Xi) => {
        this.clearDropTarget(), this.dropTargetOptions = Xi, isRef(qi) ? this.dropTargetRef = qi : this.dropTargetNode = qi, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = e;
  }
}
function useDragDropManager() {
  const { dragDropManager: Bi } = useContext(DndContext);
  return invariant(Bi != null, "Expected drag drop context"), Bi;
}
function useDragSourceConnector(Bi, e) {
  const qi = useDragDropManager(), Xi = useMemo(
    () => new SourceConnector(qi.getBackend()),
    [
      qi
    ]
  );
  return useIsomorphicLayoutEffect(() => (Xi.dragSourceOptions = Bi || null, Xi.reconnect(), () => Xi.disconnectDragSource()), [
    Xi,
    Bi
  ]), useIsomorphicLayoutEffect(() => (Xi.dragPreviewOptions = e || null, Xi.reconnect(), () => Xi.disconnectDragPreview()), [
    Xi,
    e
  ]), Xi;
}
function useDragSourceMonitor() {
  const Bi = useDragDropManager();
  return useMemo(
    () => new DragSourceMonitorImpl(Bi),
    [
      Bi
    ]
  );
}
class DragSourceImpl {
  beginDrag() {
    const e = this.spec, qi = this.monitor;
    let Xi = null;
    return typeof e.item == "object" ? Xi = e.item : typeof e.item == "function" ? Xi = e.item(qi) : Xi = {}, Xi ?? null;
  }
  canDrag() {
    const e = this.spec, qi = this.monitor;
    return typeof e.canDrag == "boolean" ? e.canDrag : typeof e.canDrag == "function" ? e.canDrag(qi) : !0;
  }
  isDragging(e, qi) {
    const Xi = this.spec, Qi = this.monitor, { isDragging: ta } = Xi;
    return ta ? ta(Qi) : qi === e.getSourceId();
  }
  endDrag() {
    const e = this.spec, qi = this.monitor, Xi = this.connector, { end: Qi } = e;
    Qi && Qi(qi.getItem(), qi), Xi.reconnect();
  }
  constructor(e, qi, Xi) {
    this.spec = e, this.monitor = qi, this.connector = Xi;
  }
}
function useDragSource(Bi, e, qi) {
  const Xi = useMemo(
    () => new DragSourceImpl(Bi, e, qi),
    [
      e,
      qi
    ]
  );
  return useEffect(() => {
    Xi.spec = Bi;
  }, [
    Bi
  ]), Xi;
}
function useDragType(Bi) {
  return useMemo(() => {
    const e = Bi.type;
    return invariant(e != null, "spec.type must be defined"), e;
  }, [
    Bi
  ]);
}
function useRegisteredDragSource(Bi, e, qi) {
  const Xi = useDragDropManager(), Qi = useDragSource(Bi, e, qi), ta = useDragType(Bi);
  useIsomorphicLayoutEffect(function() {
    if (ta != null) {
      const [na, la] = registerSource(ta, Qi, Xi);
      return e.receiveHandlerId(na), qi.receiveHandlerId(na), la;
    }
  }, [
    Xi,
    e,
    qi,
    Qi,
    ta
  ]);
}
function useDrag(Bi, e) {
  const qi = useOptionalFactory(Bi);
  invariant(!qi.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const Xi = useDragSourceMonitor(), Qi = useDragSourceConnector(qi.options, qi.previewOptions);
  return useRegisteredDragSource(qi, Xi, Qi), [
    useCollectedProps(qi.collect, Xi, Qi),
    useConnectDragSource(Qi),
    useConnectDragPreview(Qi)
  ];
}
function useConnectDropTarget(Bi) {
  return useMemo(
    () => Bi.hooks.dropTarget(),
    [
      Bi
    ]
  );
}
function useDropTargetConnector(Bi) {
  const e = useDragDropManager(), qi = useMemo(
    () => new TargetConnector(e.getBackend()),
    [
      e
    ]
  );
  return useIsomorphicLayoutEffect(() => (qi.dropTargetOptions = Bi || null, qi.reconnect(), () => qi.disconnectDropTarget()), [
    Bi
  ]), qi;
}
function useDropTargetMonitor() {
  const Bi = useDragDropManager();
  return useMemo(
    () => new DropTargetMonitorImpl(Bi),
    [
      Bi
    ]
  );
}
function useAccept(Bi) {
  const { accept: e } = Bi;
  return useMemo(() => (invariant(Bi.accept != null, "accept must be defined"), Array.isArray(e) ? e : [
    e
  ]), [
    e
  ]);
}
class DropTargetImpl {
  canDrop() {
    const e = this.spec, qi = this.monitor;
    return e.canDrop ? e.canDrop(qi.getItem(), qi) : !0;
  }
  hover() {
    const e = this.spec, qi = this.monitor;
    e.hover && e.hover(qi.getItem(), qi);
  }
  drop() {
    const e = this.spec, qi = this.monitor;
    if (e.drop)
      return e.drop(qi.getItem(), qi);
  }
  constructor(e, qi) {
    this.spec = e, this.monitor = qi;
  }
}
function useDropTarget(Bi, e) {
  const qi = useMemo(
    () => new DropTargetImpl(Bi, e),
    [
      e
    ]
  );
  return useEffect(() => {
    qi.spec = Bi;
  }, [
    Bi
  ]), qi;
}
function useRegisteredDropTarget(Bi, e, qi) {
  const Xi = useDragDropManager(), Qi = useDropTarget(Bi, e), ta = useAccept(Bi);
  useIsomorphicLayoutEffect(function() {
    const [na, la] = registerTarget(ta, Qi, Xi);
    return e.receiveHandlerId(na), qi.receiveHandlerId(na), la;
  }, [
    Xi,
    e,
    Qi,
    qi,
    ta.map(
      (ra) => ra.toString()
    ).join("|")
  ]);
}
function useDrop(Bi, e) {
  const qi = useOptionalFactory(Bi), Xi = useDropTargetMonitor(), Qi = useDropTargetConnector(qi.options);
  return useRegisteredDropTarget(qi, Xi, Qi), [
    useCollectedProps(qi.collect, Xi, Qi),
    useConnectDropTarget(Qi)
  ];
}
function memoize(Bi) {
  let e = null;
  return () => (e == null && (e = Bi()), e);
}
function without(Bi, e) {
  return Bi.filter(
    (qi) => qi !== e
  );
}
function union(Bi, e) {
  const qi = /* @__PURE__ */ new Set(), Xi = (ta) => qi.add(ta);
  Bi.forEach(Xi), e.forEach(Xi);
  const Qi = [];
  return qi.forEach(
    (ta) => Qi.push(ta)
  ), Qi;
}
class EnterLeaveCounter {
  enter(e) {
    const qi = this.entered.length, Xi = (Qi) => this.isNodeInDocument(Qi) && (!Qi.contains || Qi.contains(e));
    return this.entered = union(this.entered.filter(Xi), [
      e
    ]), qi === 0 && this.entered.length > 0;
  }
  leave(e) {
    const qi = this.entered.length;
    return this.entered = without(this.entered.filter(this.isNodeInDocument), e), qi > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(e) {
    this.entered = [], this.isNodeInDocument = e;
  }
}
class NativeDragSource {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((e) => {
      Object.defineProperty(this.item, e, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${e}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(e) {
    if (e) {
      const qi = {};
      Object.keys(this.config.exposeProperties).forEach((Xi) => {
        const Qi = this.config.exposeProperties[Xi];
        Qi != null && (qi[Xi] = {
          value: Qi(e, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, qi);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(e, qi) {
    return qi === e.getSourceId();
  }
  endDrag() {
  }
  constructor(e) {
    this.config = e, this.item = {}, this.initializeExposedProperties();
  }
}
const FILE = "__NATIVE_FILE__", URL$1 = "__NATIVE_URL__", TEXT = "__NATIVE_TEXT__", HTML = "__NATIVE_HTML__", NativeTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE,
  HTML,
  TEXT,
  URL: URL$1
}, Symbol.toStringTag, { value: "Module" }));
function getDataFromDataTransfer(Bi, e, qi) {
  const Xi = e.reduce(
    (Qi, ta) => Qi || Bi.getData(ta),
    ""
  );
  return Xi ?? qi;
}
const nativeTypesConfig = {
  [FILE]: {
    exposeProperties: {
      files: (Bi) => Array.prototype.slice.call(Bi.files),
      items: (Bi) => Bi.items,
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Files"
    ]
  },
  [HTML]: {
    exposeProperties: {
      html: (Bi, e) => getDataFromDataTransfer(Bi, e, ""),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [URL$1]: {
    exposeProperties: {
      urls: (Bi, e) => getDataFromDataTransfer(Bi, e, "").split(`
`),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [TEXT]: {
    exposeProperties: {
      text: (Bi, e) => getDataFromDataTransfer(Bi, e, ""),
      dataTransfer: (Bi) => Bi
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function createNativeDragSource(Bi, e) {
  const qi = nativeTypesConfig[Bi];
  if (!qi)
    throw new Error(`native type ${Bi} has no configuration`);
  const Xi = new NativeDragSource(qi);
  return Xi.loadDataTransfer(e), Xi;
}
function matchNativeItemType(Bi) {
  if (!Bi)
    return null;
  const e = Array.prototype.slice.call(Bi.types || []);
  return Object.keys(nativeTypesConfig).filter((qi) => {
    const Xi = nativeTypesConfig[qi];
    return Xi?.matchesTypes ? Xi.matchesTypes.some(
      (Qi) => e.indexOf(Qi) > -1
    ) : !1;
  })[0] || null;
}
const isFirefox = memoize(
  () => /firefox/i.test(navigator.userAgent)
), isSafari = memoize(
  () => !!window.safari
);
class MonotonicInterpolant {
  interpolate(e) {
    const { xs: qi, ys: Xi, c1s: Qi, c2s: ta, c3s: ra } = this;
    let na = qi.length - 1;
    if (e === qi[na])
      return Xi[na];
    let la = 0, Ma = ra.length - 1, Va;
    for (; la <= Ma; ) {
      Va = Math.floor(0.5 * (la + Ma));
      const So = qi[Va];
      if (So < e)
        la = Va + 1;
      else if (So > e)
        Ma = Va - 1;
      else
        return Xi[Va];
    }
    na = Math.max(0, Ma);
    const to = e - qi[na], Eo = to * to;
    return Xi[na] + Qi[na] * to + ta[na] * Eo + ra[na] * to * Eo;
  }
  constructor(e, qi) {
    const { length: Xi } = e, Qi = [];
    for (let So = 0; So < Xi; So++)
      Qi.push(So);
    Qi.sort(
      (So, eo) => e[So] < e[eo] ? -1 : 1
    );
    const ta = [], ra = [];
    let na, la;
    for (let So = 0; So < Xi - 1; So++)
      na = e[So + 1] - e[So], la = qi[So + 1] - qi[So], ta.push(na), ra.push(la / na);
    const Ma = [
      ra[0]
    ];
    for (let So = 0; So < ta.length - 1; So++) {
      const eo = ra[So], rs = ra[So + 1];
      if (eo * rs <= 0)
        Ma.push(0);
      else {
        na = ta[So];
        const ko = ta[So + 1], Hs = na + ko;
        Ma.push(3 * Hs / ((Hs + ko) / eo + (Hs + na) / rs));
      }
    }
    Ma.push(ra[ra.length - 1]);
    const Va = [], to = [];
    let Eo;
    for (let So = 0; So < Ma.length - 1; So++) {
      Eo = ra[So];
      const eo = Ma[So], rs = 1 / ta[So], ko = eo + Ma[So + 1] - Eo - Eo;
      Va.push((Eo - eo - ko) * rs), to.push(ko * rs * rs);
    }
    this.xs = e, this.ys = qi, this.c1s = Ma, this.c2s = Va, this.c3s = to;
  }
}
const ELEMENT_NODE = 1;
function getNodeClientOffset(Bi) {
  const e = Bi.nodeType === ELEMENT_NODE ? Bi : Bi.parentElement;
  if (!e)
    return null;
  const { top: qi, left: Xi } = e.getBoundingClientRect();
  return {
    x: Xi,
    y: qi
  };
}
function getEventClientOffset(Bi) {
  return {
    x: Bi.clientX,
    y: Bi.clientY
  };
}
function isImageNode(Bi) {
  var e;
  return Bi.nodeName === "IMG" && (isFirefox() || !(!((e = document.documentElement) === null || e === void 0) && e.contains(Bi)));
}
function getDragPreviewSize(Bi, e, qi, Xi) {
  let Qi = Bi ? e.width : qi, ta = Bi ? e.height : Xi;
  return isSafari() && Bi && (ta /= window.devicePixelRatio, Qi /= window.devicePixelRatio), {
    dragPreviewWidth: Qi,
    dragPreviewHeight: ta
  };
}
function getDragPreviewOffset(Bi, e, qi, Xi, Qi) {
  const ta = isImageNode(e), na = getNodeClientOffset(ta ? Bi : e), la = {
    x: qi.x - na.x,
    y: qi.y - na.y
  }, { offsetWidth: Ma, offsetHeight: Va } = Bi, { anchorX: to, anchorY: Eo } = Xi, { dragPreviewWidth: So, dragPreviewHeight: eo } = getDragPreviewSize(ta, e, Ma, Va), rs = () => {
    let Fs = new MonotonicInterpolant([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      la.y,
      // Align at the center
      la.y / Va * eo,
      // Dock to the bottom
      la.y + eo - Va
    ]).interpolate(Eo);
    return isSafari() && ta && (Fs += (window.devicePixelRatio - 1) * eo), Fs;
  }, ko = () => new MonotonicInterpolant([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    la.x,
    // Align at the center
    la.x / Ma * So,
    // Dock to the right
    la.x + So - Ma
  ]).interpolate(to), { offsetX: Hs, offsetY: Ks } = Qi, Ys = Hs === 0 || Hs, Xs = Ks === 0 || Ks;
  return {
    x: Ys ? Hs : ko(),
    y: Xs ? Ks : rs()
  };
}
class OptionsReader {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var e;
    return !((e = this.globalContext) === null || e === void 0) && e.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var e;
    return ((e = this.optionsArgs) === null || e === void 0 ? void 0 : e.rootElement) || this.window;
  }
  constructor(e, qi) {
    this.ownerDocument = null, this.globalContext = e, this.optionsArgs = qi;
  }
}
function _defineProperty$2(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, {
    value: qi,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : Bi[e] = qi, Bi;
}
function _objectSpread$2(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {}, Xi = Object.keys(qi);
    typeof Object.getOwnPropertySymbols == "function" && (Xi = Xi.concat(Object.getOwnPropertySymbols(qi).filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(qi, Qi).enumerable;
    }))), Xi.forEach(function(Qi) {
      _defineProperty$2(Bi, Qi, qi[Qi]);
    });
  }
  return Bi;
}
class HTML5BackendImpl {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var e, qi;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((e = this.dragStartSourceIds) === null || e === void 0 ? void 0 : e.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((qi = this.dragOverTargetIds) === null || qi === void 0 ? void 0 : qi.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const e = this.rootElement;
    if (e !== void 0) {
      if (e.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      e.__isReactDndBackendSetUp = !0, this.addEventListeners(e);
    }
  }
  teardown() {
    const e = this.rootElement;
    if (e !== void 0 && (e.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var qi;
      (qi = this.window) === null || qi === void 0 || qi.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(e, qi, Xi) {
    return this.sourcePreviewNodeOptions.set(e, Xi), this.sourcePreviewNodes.set(e, qi), () => {
      this.sourcePreviewNodes.delete(e), this.sourcePreviewNodeOptions.delete(e);
    };
  }
  connectDragSource(e, qi, Xi) {
    this.sourceNodes.set(e, qi), this.sourceNodeOptions.set(e, Xi);
    const Qi = (ra) => this.handleDragStart(ra, e), ta = (ra) => this.handleSelectStart(ra);
    return qi.setAttribute("draggable", "true"), qi.addEventListener("dragstart", Qi), qi.addEventListener("selectstart", ta), () => {
      this.sourceNodes.delete(e), this.sourceNodeOptions.delete(e), qi.removeEventListener("dragstart", Qi), qi.removeEventListener("selectstart", ta), qi.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(e, qi) {
    const Xi = (ra) => this.handleDragEnter(ra, e), Qi = (ra) => this.handleDragOver(ra, e), ta = (ra) => this.handleDrop(ra, e);
    return qi.addEventListener("dragenter", Xi), qi.addEventListener("dragover", Qi), qi.addEventListener("drop", ta), () => {
      qi.removeEventListener("dragenter", Xi), qi.removeEventListener("dragover", Qi), qi.removeEventListener("drop", ta);
    };
  }
  addEventListeners(e) {
    e.addEventListener && (e.addEventListener("dragstart", this.handleTopDragStart), e.addEventListener("dragstart", this.handleTopDragStartCapture, !0), e.addEventListener("dragend", this.handleTopDragEndCapture, !0), e.addEventListener("dragenter", this.handleTopDragEnter), e.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.addEventListener("dragover", this.handleTopDragOver), e.addEventListener("dragover", this.handleTopDragOverCapture, !0), e.addEventListener("drop", this.handleTopDrop), e.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(e) {
    e.removeEventListener && (e.removeEventListener("dragstart", this.handleTopDragStart), e.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), e.removeEventListener("dragend", this.handleTopDragEndCapture, !0), e.removeEventListener("dragenter", this.handleTopDragEnter), e.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.removeEventListener("dragover", this.handleTopDragOver), e.removeEventListener("dragover", this.handleTopDragOverCapture, !0), e.removeEventListener("drop", this.handleTopDrop), e.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const e = this.monitor.getSourceId(), qi = this.sourceNodeOptions.get(e);
    return _objectSpread$2({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, qi || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const e = this.monitor.getSourceId(), qi = this.sourcePreviewNodeOptions.get(e);
    return _objectSpread$2({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, qi || {});
  }
  isDraggingNativeItem() {
    const e = this.monitor.getItemType();
    return Object.keys(NativeTypes).some(
      (qi) => NativeTypes[qi] === e
    );
  }
  beginDragNativeItem(e, qi) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = createNativeDragSource(e, qi), this.currentNativeHandle = this.registry.addSource(e, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(e) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = e;
    const qi = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var Xi;
      return (Xi = this.rootElement) === null || Xi === void 0 ? void 0 : Xi.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, qi);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var e;
        (e = this.window) === null || e === void 0 || e.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(e, qi) {
    e.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(qi));
  }
  handleDragEnter(e, qi) {
    this.dragEnterTargetIds.unshift(qi);
  }
  handleDragOver(e, qi) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(qi);
  }
  handleDrop(e, qi) {
    this.dropTargetIds.unshift(qi);
  }
  constructor(e, qi, Xi) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (Qi) => {
      const ta = this.sourceNodes.get(Qi);
      return ta && getNodeClientOffset(ta) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (Qi) => !!(Qi && this.document && this.document.body && this.document.body.contains(Qi)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const Qi = this.currentDragSourceNode;
      Qi == null || this.isNodeInDocument(Qi) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (Qi) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(Qi || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (Qi) => {
      if (Qi.defaultPrevented)
        return;
      const { dragStartSourceIds: ta } = this;
      this.dragStartSourceIds = null;
      const ra = getEventClientOffset(Qi);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(ta || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: ra
      });
      const { dataTransfer: na } = Qi, la = matchNativeItemType(na);
      if (this.monitor.isDragging()) {
        if (na && typeof na.setDragImage == "function") {
          const Va = this.monitor.getSourceId(), to = this.sourceNodes.get(Va), Eo = this.sourcePreviewNodes.get(Va) || to;
          if (Eo) {
            const { anchorX: So, anchorY: eo, offsetX: rs, offsetY: ko } = this.getCurrentSourcePreviewNodeOptions(), Ys = getDragPreviewOffset(to, Eo, ra, {
              anchorX: So,
              anchorY: eo
            }, {
              offsetX: rs,
              offsetY: ko
            });
            na.setDragImage(Eo, Ys.x, Ys.y);
          }
        }
        try {
          na?.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(Qi.target);
        const { captureDraggingState: Ma } = this.getCurrentSourcePreviewNodeOptions();
        Ma ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (la)
        this.beginDragNativeItem(la);
      else {
        if (na && !na.types && (Qi.target && !Qi.target.hasAttribute || !Qi.target.hasAttribute("draggable")))
          return;
        Qi.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (Qi) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var ta;
        (ta = this.currentNativeSource) === null || ta === void 0 || ta.loadDataTransfer(Qi.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(Qi.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: na } = Qi, la = matchNativeItemType(na);
      la && this.beginDragNativeItem(la, na);
    }, this.handleTopDragEnter = (Qi) => {
      const { dragEnterTargetIds: ta } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = Qi.altKey, ta.length > 0 && this.actions.hover(ta, {
        clientOffset: getEventClientOffset(Qi)
      }), ta.some(
        (na) => this.monitor.canDropOnTarget(na)
      ) && (Qi.preventDefault(), Qi.dataTransfer && (Qi.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (Qi) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var ta;
        (ta = this.currentNativeSource) === null || ta === void 0 || ta.loadDataTransfer(Qi.dataTransfer);
      }
    }, this.handleTopDragOver = (Qi) => {
      const { dragOverTargetIds: ta } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        Qi.preventDefault(), Qi.dataTransfer && (Qi.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = Qi.altKey, this.lastClientOffset = getEventClientOffset(Qi), this.scheduleHover(ta), (ta || []).some(
        (na) => this.monitor.canDropOnTarget(na)
      ) ? (Qi.preventDefault(), Qi.dataTransfer && (Qi.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? Qi.preventDefault() : (Qi.preventDefault(), Qi.dataTransfer && (Qi.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (Qi) => {
      this.isDraggingNativeItem() && Qi.preventDefault(), this.enterLeaveCounter.leave(Qi.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (Qi) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var ta;
        Qi.preventDefault(), (ta = this.currentNativeSource) === null || ta === void 0 || ta.loadDataTransfer(Qi.dataTransfer);
      } else matchNativeItemType(Qi.dataTransfer) && Qi.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (Qi) => {
      const { dropTargetIds: ta } = this;
      this.dropTargetIds = [], this.actions.hover(ta, {
        clientOffset: getEventClientOffset(Qi)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (Qi) => {
      const ta = Qi.target;
      typeof ta.dragDrop == "function" && (ta.tagName === "INPUT" || ta.tagName === "SELECT" || ta.tagName === "TEXTAREA" || ta.isContentEditable || (Qi.preventDefault(), ta.dragDrop()));
    }, this.options = new OptionsReader(qi, Xi), this.actions = e.getActions(), this.monitor = e.getMonitor(), this.registry = e.getRegistry(), this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
}
const HTML5Backend = function(e, qi, Xi) {
  return new HTML5BackendImpl(e, qi, Xi);
}, COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function toFileWithPath(Bi, e, qi) {
  const Xi = withMimeType(Bi), { webkitRelativePath: Qi } = Bi, ta = typeof e == "string" ? e : typeof Qi == "string" && Qi.length > 0 ? Qi : `./${Bi.name}`;
  return typeof Xi.path != "string" && setObjProp(Xi, "path", ta), setObjProp(Xi, "relativePath", ta), Xi;
}
function withMimeType(Bi) {
  const { name: e } = Bi;
  if (e && e.lastIndexOf(".") !== -1 && !Bi.type) {
    const Xi = e.split(".").pop().toLowerCase(), Qi = COMMON_MIME_TYPES.get(Xi);
    Qi && Object.defineProperty(Bi, "type", {
      value: Qi,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return Bi;
}
function setObjProp(Bi, e, qi) {
  Object.defineProperty(Bi, e, {
    value: qi,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function fromEvent(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return isObject$1(Bi) && isDataTransfer(Bi.dataTransfer) ? getDataTransferFiles(Bi.dataTransfer, Bi.type) : isChangeEvt(Bi) ? getInputFiles(Bi) : Array.isArray(Bi) && Bi.every((e) => "getFile" in e && typeof e.getFile == "function") ? getFsHandleFiles(Bi) : [];
  });
}
function isDataTransfer(Bi) {
  return isObject$1(Bi);
}
function isChangeEvt(Bi) {
  return isObject$1(Bi) && isObject$1(Bi.target);
}
function isObject$1(Bi) {
  return typeof Bi == "object" && Bi !== null;
}
function getInputFiles(Bi) {
  return fromList(Bi.target.files).map((e) => toFileWithPath(e));
}
function getFsHandleFiles(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return (yield Promise.all(Bi.map((qi) => qi.getFile()))).map((qi) => toFileWithPath(qi));
  });
}
function getDataTransferFiles(Bi, e) {
  return __awaiter(this, void 0, void 0, function* () {
    if (Bi.items) {
      const qi = fromList(Bi.items).filter((Qi) => Qi.kind === "file");
      if (e !== "drop")
        return qi;
      const Xi = yield Promise.all(qi.map(toFilePromises));
      return noIgnoredFiles(flatten(Xi));
    }
    return noIgnoredFiles(fromList(Bi.files).map((qi) => toFileWithPath(qi)));
  });
}
function noIgnoredFiles(Bi) {
  return Bi.filter((e) => FILES_TO_IGNORE.indexOf(e.name) === -1);
}
function fromList(Bi) {
  if (Bi === null)
    return [];
  const e = [];
  for (let qi = 0; qi < Bi.length; qi++) {
    const Xi = Bi[qi];
    e.push(Xi);
  }
  return e;
}
function toFilePromises(Bi) {
  if (typeof Bi.webkitGetAsEntry != "function")
    return fromDataTransferItem(Bi);
  const e = Bi.webkitGetAsEntry();
  return e && e.isDirectory ? fromDirEntry(e) : fromDataTransferItem(Bi, e);
}
function flatten(Bi) {
  return Bi.reduce((e, qi) => [
    ...e,
    ...Array.isArray(qi) ? flatten(qi) : [qi]
  ], []);
}
function fromDataTransferItem(Bi, e) {
  return __awaiter(this, void 0, void 0, function* () {
    var qi;
    if (globalThis.isSecureContext && typeof Bi.getAsFileSystemHandle == "function") {
      const ta = yield Bi.getAsFileSystemHandle();
      if (ta === null)
        throw new Error(`${Bi} is not a File`);
      if (ta !== void 0) {
        const ra = yield ta.getFile();
        return ra.handle = ta, toFileWithPath(ra);
      }
    }
    const Xi = Bi.getAsFile();
    if (!Xi)
      throw new Error(`${Bi} is not a File`);
    return toFileWithPath(Xi, (qi = e?.fullPath) !== null && qi !== void 0 ? qi : void 0);
  });
}
function fromEntry(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return Bi.isDirectory ? fromDirEntry(Bi) : fromFileEntry(Bi);
  });
}
function fromDirEntry(Bi) {
  const e = Bi.createReader();
  return new Promise((qi, Xi) => {
    const Qi = [];
    function ta() {
      e.readEntries((ra) => __awaiter(this, void 0, void 0, function* () {
        if (ra.length) {
          const na = Promise.all(ra.map(fromEntry));
          Qi.push(na), ta();
        } else
          try {
            const na = yield Promise.all(Qi);
            qi(na);
          } catch (na) {
            Xi(na);
          }
      }), (ra) => {
        Xi(ra);
      });
    }
    ta();
  });
}
function fromFileEntry(Bi) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((e, qi) => {
      Bi.file((Xi) => {
        const Qi = toFileWithPath(Xi, Bi.fullPath);
        e(Qi);
      }, (Xi) => {
        qi(Xi);
      });
    });
  });
}
var es$1 = {}, hasRequiredEs;
function requireEs() {
  return hasRequiredEs || (hasRequiredEs = 1, es$1.__esModule = !0, es$1.default = function(Bi, e) {
    if (Bi && e) {
      var qi = Array.isArray(e) ? e : e.split(",");
      if (qi.length === 0)
        return !0;
      var Xi = Bi.name || "", Qi = (Bi.type || "").toLowerCase(), ta = Qi.replace(/\/.*$/, "");
      return qi.some(function(ra) {
        var na = ra.trim().toLowerCase();
        return na.charAt(0) === "." ? Xi.toLowerCase().endsWith(na) : na.endsWith("/*") ? ta === na.replace(/\/.*$/, "") : Qi === na;
      });
    }
    return !0;
  }), es$1;
}
var esExports = requireEs();
const _accepts = /* @__PURE__ */ getDefaultExportFromCjs(esExports);
function _toConsumableArray$1(Bi) {
  return _arrayWithoutHoles$1(Bi) || _iterableToArray$1(Bi) || _unsupportedIterableToArray$1(Bi) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$1(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _arrayWithoutHoles$1(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray$1(Bi);
}
function ownKeys$1(Bi, e) {
  var qi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Xi = Object.getOwnPropertySymbols(Bi);
    e && (Xi = Xi.filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(Bi, Qi).enumerable;
    })), qi.push.apply(qi, Xi);
  }
  return qi;
}
function _objectSpread$1(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys$1(Object(qi), !0).forEach(function(Xi) {
      _defineProperty$1(Bi, Xi, qi[Xi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(qi)) : ownKeys$1(Object(qi)).forEach(function(Xi) {
      Object.defineProperty(Bi, Xi, Object.getOwnPropertyDescriptor(qi, Xi));
    });
  }
  return Bi;
}
function _defineProperty$1(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, { value: qi, enumerable: !0, configurable: !0, writable: !0 }) : Bi[e] = qi, Bi;
}
function _slicedToArray$1(Bi, e) {
  return _arrayWithHoles$1(Bi) || _iterableToArrayLimit$1(Bi, e) || _unsupportedIterableToArray$1(Bi, e) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray$1(Bi, e);
    var qi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (qi === "Object" && Bi.constructor && (qi = Bi.constructor.name), qi === "Map" || qi === "Set") return Array.from(Bi);
    if (qi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(qi)) return _arrayLikeToArray$1(Bi, e);
  }
}
function _arrayLikeToArray$1(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var qi = 0, Xi = new Array(e); qi < e; qi++)
    Xi[qi] = Bi[qi];
  return Xi;
}
function _iterableToArrayLimit$1(Bi, e) {
  var qi = Bi == null ? null : typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (qi != null) {
    var Xi = [], Qi = !0, ta = !1, ra, na;
    try {
      for (qi = qi.call(Bi); !(Qi = (ra = qi.next()).done) && (Xi.push(ra.value), !(e && Xi.length === e)); Qi = !0)
        ;
    } catch (la) {
      ta = !0, na = la;
    } finally {
      try {
        !Qi && qi.return != null && qi.return();
      } finally {
        if (ta) throw na;
      }
    }
    return Xi;
  }
}
function _arrayWithHoles$1(Bi) {
  if (Array.isArray(Bi)) return Bi;
}
var accepts = typeof _accepts == "function" ? _accepts : _accepts.default, FILE_INVALID_TYPE = "file-invalid-type", FILE_TOO_LARGE = "file-too-large", FILE_TOO_SMALL = "file-too-small", TOO_MANY_FILES = "too-many-files", getInvalidTypeRejectionErr = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", qi = e.split(","), Xi = qi.length > 1 ? "one of ".concat(qi.join(", ")) : qi[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(Xi)
  };
}, getTooLargeRejectionErr = function(e) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, getTooSmallRejectionErr = function(e) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(e, " ").concat(e === 1 ? "byte" : "bytes")
  };
}, TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(Bi, e) {
  var qi = Bi.type === "application/x-moz-file" || accepts(Bi, e);
  return [qi, qi ? null : getInvalidTypeRejectionErr(e)];
}
function fileMatchSize(Bi, e, qi) {
  if (isDefined(Bi.size))
    if (isDefined(e) && isDefined(qi)) {
      if (Bi.size > qi) return [!1, getTooLargeRejectionErr(qi)];
      if (Bi.size < e) return [!1, getTooSmallRejectionErr(e)];
    } else {
      if (isDefined(e) && Bi.size < e) return [!1, getTooSmallRejectionErr(e)];
      if (isDefined(qi) && Bi.size > qi) return [!1, getTooLargeRejectionErr(qi)];
    }
  return [!0, null];
}
function isDefined(Bi) {
  return Bi != null;
}
function allFilesAccepted(Bi) {
  var e = Bi.files, qi = Bi.accept, Xi = Bi.minSize, Qi = Bi.maxSize, ta = Bi.multiple, ra = Bi.maxFiles, na = Bi.validator;
  return !ta && e.length > 1 || ta && ra >= 1 && e.length > ra ? !1 : e.every(function(la) {
    var Ma = fileAccepted(la, qi), Va = _slicedToArray$1(Ma, 1), to = Va[0], Eo = fileMatchSize(la, Xi, Qi), So = _slicedToArray$1(Eo, 1), eo = So[0], rs = na ? na(la) : null;
    return to && eo && !rs;
  });
}
function isPropagationStopped(Bi) {
  return typeof Bi.isPropagationStopped == "function" ? Bi.isPropagationStopped() : typeof Bi.cancelBubble < "u" ? Bi.cancelBubble : !1;
}
function isEvtWithFiles(Bi) {
  return Bi.dataTransfer ? Array.prototype.some.call(Bi.dataTransfer.types, function(e) {
    return e === "Files" || e === "application/x-moz-file";
  }) : !!Bi.target && !!Bi.target.files;
}
function onDocumentDragOver(Bi) {
  Bi.preventDefault();
}
function isIe(Bi) {
  return Bi.indexOf("MSIE") !== -1 || Bi.indexOf("Trident/") !== -1;
}
function isEdge(Bi) {
  return Bi.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(Bi) || isEdge(Bi);
}
function composeEventHandlers() {
  for (var Bi = arguments.length, e = new Array(Bi), qi = 0; qi < Bi; qi++)
    e[qi] = arguments[qi];
  return function(Xi) {
    for (var Qi = arguments.length, ta = new Array(Qi > 1 ? Qi - 1 : 0), ra = 1; ra < Qi; ra++)
      ta[ra - 1] = arguments[ra];
    return e.some(function(na) {
      return !isPropagationStopped(Xi) && na && na.apply(void 0, [Xi].concat(ta)), isPropagationStopped(Xi);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(Bi) {
  if (isDefined(Bi)) {
    var e = Object.entries(Bi).filter(function(qi) {
      var Xi = _slicedToArray$1(qi, 2), Qi = Xi[0], ta = Xi[1], ra = !0;
      return isMIMEType(Qi) || (console.warn('Skipped "'.concat(Qi, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), ra = !1), (!Array.isArray(ta) || !ta.every(isExt)) && (console.warn('Skipped "'.concat(Qi, '" because an invalid file extension was provided.')), ra = !1), ra;
    }).reduce(function(qi, Xi) {
      var Qi = _slicedToArray$1(Xi, 2), ta = Qi[0], ra = Qi[1];
      return _objectSpread$1(_objectSpread$1({}, qi), {}, _defineProperty$1({}, ta, ra));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: e
    }];
  }
  return Bi;
}
function acceptPropAsAcceptAttr(Bi) {
  if (isDefined(Bi))
    return Object.entries(Bi).reduce(function(e, qi) {
      var Xi = _slicedToArray$1(qi, 2), Qi = Xi[0], ta = Xi[1];
      return [].concat(_toConsumableArray$1(e), [Qi], _toConsumableArray$1(ta));
    }, []).filter(function(e) {
      return isMIMEType(e) || isExt(e);
    }).join(",");
}
function isAbort(Bi) {
  return Bi instanceof DOMException && (Bi.name === "AbortError" || Bi.code === Bi.ABORT_ERR);
}
function isSecurityError(Bi) {
  return Bi instanceof DOMException && (Bi.name === "SecurityError" || Bi.code === Bi.SECURITY_ERR);
}
function isMIMEType(Bi) {
  return Bi === "audio/*" || Bi === "video/*" || Bi === "image/*" || Bi === "text/*" || Bi === "application/*" || /\w+\/[-+.\w]+/g.test(Bi);
}
function isExt(Bi) {
  return /^.*\.[\w]+$/.test(Bi);
}
var _excluded = ["children"], _excluded2 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(Bi) {
  return _arrayWithoutHoles(Bi) || _iterableToArray(Bi) || _unsupportedIterableToArray(Bi) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray(Bi) {
  if (typeof Symbol < "u" && Bi[Symbol.iterator] != null || Bi["@@iterator"] != null) return Array.from(Bi);
}
function _arrayWithoutHoles(Bi) {
  if (Array.isArray(Bi)) return _arrayLikeToArray(Bi);
}
function _slicedToArray(Bi, e) {
  return _arrayWithHoles(Bi) || _iterableToArrayLimit(Bi, e) || _unsupportedIterableToArray(Bi, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return _arrayLikeToArray(Bi, e);
    var qi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (qi === "Object" && Bi.constructor && (qi = Bi.constructor.name), qi === "Map" || qi === "Set") return Array.from(Bi);
    if (qi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(qi)) return _arrayLikeToArray(Bi, e);
  }
}
function _arrayLikeToArray(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var qi = 0, Xi = new Array(e); qi < e; qi++)
    Xi[qi] = Bi[qi];
  return Xi;
}
function _iterableToArrayLimit(Bi, e) {
  var qi = Bi == null ? null : typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (qi != null) {
    var Xi = [], Qi = !0, ta = !1, ra, na;
    try {
      for (qi = qi.call(Bi); !(Qi = (ra = qi.next()).done) && (Xi.push(ra.value), !(e && Xi.length === e)); Qi = !0)
        ;
    } catch (la) {
      ta = !0, na = la;
    } finally {
      try {
        !Qi && qi.return != null && qi.return();
      } finally {
        if (ta) throw na;
      }
    }
    return Xi;
  }
}
function _arrayWithHoles(Bi) {
  if (Array.isArray(Bi)) return Bi;
}
function ownKeys(Bi, e) {
  var qi = Object.keys(Bi);
  if (Object.getOwnPropertySymbols) {
    var Xi = Object.getOwnPropertySymbols(Bi);
    e && (Xi = Xi.filter(function(Qi) {
      return Object.getOwnPropertyDescriptor(Bi, Qi).enumerable;
    })), qi.push.apply(qi, Xi);
  }
  return qi;
}
function _objectSpread(Bi) {
  for (var e = 1; e < arguments.length; e++) {
    var qi = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ownKeys(Object(qi), !0).forEach(function(Xi) {
      _defineProperty(Bi, Xi, qi[Xi]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Bi, Object.getOwnPropertyDescriptors(qi)) : ownKeys(Object(qi)).forEach(function(Xi) {
      Object.defineProperty(Bi, Xi, Object.getOwnPropertyDescriptor(qi, Xi));
    });
  }
  return Bi;
}
function _defineProperty(Bi, e, qi) {
  return e in Bi ? Object.defineProperty(Bi, e, { value: qi, enumerable: !0, configurable: !0, writable: !0 }) : Bi[e] = qi, Bi;
}
function _objectWithoutProperties(Bi, e) {
  if (Bi == null) return {};
  var qi = _objectWithoutPropertiesLoose(Bi, e), Xi, Qi;
  if (Object.getOwnPropertySymbols) {
    var ta = Object.getOwnPropertySymbols(Bi);
    for (Qi = 0; Qi < ta.length; Qi++)
      Xi = ta[Qi], !(e.indexOf(Xi) >= 0) && Object.prototype.propertyIsEnumerable.call(Bi, Xi) && (qi[Xi] = Bi[Xi]);
  }
  return qi;
}
function _objectWithoutPropertiesLoose(Bi, e) {
  if (Bi == null) return {};
  var qi = {}, Xi = Object.keys(Bi), Qi, ta;
  for (ta = 0; ta < Xi.length; ta++)
    Qi = Xi[ta], !(e.indexOf(Qi) >= 0) && (qi[Qi] = Bi[Qi]);
  return qi;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(Bi, e) {
  var qi = Bi.children, Xi = _objectWithoutProperties(Bi, _excluded), Qi = useDropzone(Xi), ta = Qi.open, ra = _objectWithoutProperties(Qi, _excluded2);
  return useImperativeHandle(e, function() {
    return {
      open: ta
    };
  }, [ta]), /* @__PURE__ */ a__default.createElement(Fragment, null, qi(_objectSpread(_objectSpread({}, ra), {}, {
    open: ta
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: !1,
  getFilesFromEvent: fromEvent,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var Bi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = _objectSpread(_objectSpread({}, defaultProps), Bi), qi = e.accept, Xi = e.disabled, Qi = e.getFilesFromEvent, ta = e.maxSize, ra = e.minSize, na = e.multiple, la = e.maxFiles, Ma = e.onDragEnter, Va = e.onDragLeave, to = e.onDragOver, Eo = e.onDrop, So = e.onDropAccepted, eo = e.onDropRejected, rs = e.onFileDialogCancel, ko = e.onFileDialogOpen, Hs = e.useFsAccessApi, Ks = e.autoFocus, Ys = e.preventDropOnDocument, Xs = e.noClick, Cs = e.noKeyboard, Fs = e.noDrag, ws = e.noDragEventsBubbling, ls = e.onError, ks = e.validator, Js = useMemo(function() {
    return acceptPropAsAcceptAttr(qi);
  }, [qi]), pl = useMemo(function() {
    return pickerOptionsFromAccept(qi);
  }, [qi]), _l = useMemo(function() {
    return typeof ko == "function" ? ko : noop;
  }, [ko]), bl = useMemo(function() {
    return typeof rs == "function" ? rs : noop;
  }, [rs]), xl = useRef(null), Rl = useRef(null), Cl = useReducer(reducer, initialState), Dl = _slicedToArray(Cl, 2), kl = Dl[0], Ul = Dl[1], Bl = kl.isFocused, Zl = kl.isFileDialogActive, Pl = useRef(typeof window < "u" && window.isSecureContext && Hs && canUseFileSystemAccessAPI()), yl = function() {
    !Pl.current && Zl && setTimeout(function() {
      if (Rl.current) {
        var tc = Rl.current.files;
        tc.length || (Ul({
          type: "closeDialog"
        }), bl());
      }
    }, 300);
  };
  useEffect(function() {
    return window.addEventListener("focus", yl, !1), function() {
      window.removeEventListener("focus", yl, !1);
    };
  }, [Rl, Zl, bl, Pl]);
  var hl = useRef([]), Tl = function(tc) {
    xl.current && xl.current.contains(tc.target) || (tc.preventDefault(), hl.current = []);
  };
  useEffect(function() {
    return Ys && (document.addEventListener("dragover", onDocumentDragOver, !1), document.addEventListener("drop", Tl, !1)), function() {
      Ys && (document.removeEventListener("dragover", onDocumentDragOver), document.removeEventListener("drop", Tl));
    };
  }, [xl, Ys]), useEffect(function() {
    return !Xi && Ks && xl.current && xl.current.focus(), function() {
    };
  }, [xl, Ks, Xi]);
  var Il = useCallback(function(zl) {
    ls ? ls(zl) : console.error(zl);
  }, [ls]), jl = useCallback(function(zl) {
    zl.preventDefault(), zl.persist(), Ll(zl), hl.current = [].concat(_toConsumableArray(hl.current), [zl.target]), isEvtWithFiles(zl) && Promise.resolve(Qi(zl)).then(function(tc) {
      if (!(isPropagationStopped(zl) && !ws)) {
        var Ku = tc.length, tu = Ku > 0 && allFilesAccepted({
          files: tc,
          accept: Js,
          minSize: ra,
          maxSize: ta,
          multiple: na,
          maxFiles: la,
          validator: ks
        }), Gu = Ku > 0 && !tu;
        Ul({
          isDragAccept: tu,
          isDragReject: Gu,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), Ma && Ma(zl);
      }
    }).catch(function(tc) {
      return Il(tc);
    });
  }, [Qi, Ma, Il, ws, Js, ra, ta, na, la, ks]), Al = useCallback(function(zl) {
    zl.preventDefault(), zl.persist(), Ll(zl);
    var tc = isEvtWithFiles(zl);
    if (tc && zl.dataTransfer)
      try {
        zl.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return tc && to && to(zl), !1;
  }, [to, ws]), _s = useCallback(function(zl) {
    zl.preventDefault(), zl.persist(), Ll(zl);
    var tc = hl.current.filter(function(tu) {
      return xl.current && xl.current.contains(tu);
    }), Ku = tc.indexOf(zl.target);
    Ku !== -1 && tc.splice(Ku, 1), hl.current = tc, !(tc.length > 0) && (Ul({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), isEvtWithFiles(zl) && Va && Va(zl));
  }, [xl, Va, ws]), Gs = useCallback(function(zl, tc) {
    var Ku = [], tu = [];
    zl.forEach(function(Gu) {
      var Qu = fileAccepted(Gu, Js), ed = _slicedToArray(Qu, 2), td = ed[0], od = ed[1], ld = fileMatchSize(Gu, ra, ta), sd = _slicedToArray(ld, 2), bd = sd[0], $d = sd[1], _d = ks ? ks(Gu) : null;
      if (td && bd && !_d)
        Ku.push(Gu);
      else {
        var ec = [od, $d];
        _d && (ec = ec.concat(_d)), tu.push({
          file: Gu,
          errors: ec.filter(function(Xl) {
            return Xl;
          })
        });
      }
    }), (!na && Ku.length > 1 || na && la >= 1 && Ku.length > la) && (Ku.forEach(function(Gu) {
      tu.push({
        file: Gu,
        errors: [TOO_MANY_FILES_REJECTION]
      });
    }), Ku.splice(0)), Ul({
      acceptedFiles: Ku,
      fileRejections: tu,
      isDragReject: tu.length > 0,
      type: "setFiles"
    }), Eo && Eo(Ku, tu, tc), tu.length > 0 && eo && eo(tu, tc), Ku.length > 0 && So && So(Ku, tc);
  }, [Ul, na, Js, ra, ta, la, Eo, So, eo, ks]), vl = useCallback(function(zl) {
    zl.preventDefault(), zl.persist(), Ll(zl), hl.current = [], isEvtWithFiles(zl) && Promise.resolve(Qi(zl)).then(function(tc) {
      isPropagationStopped(zl) && !ws || Gs(tc, zl);
    }).catch(function(tc) {
      return Il(tc);
    }), Ul({
      type: "reset"
    });
  }, [Qi, Gs, Il, ws]), gl = useCallback(function() {
    if (Pl.current) {
      Ul({
        type: "openDialog"
      }), _l();
      var zl = {
        multiple: na,
        types: pl
      };
      window.showOpenFilePicker(zl).then(function(tc) {
        return Qi(tc);
      }).then(function(tc) {
        Gs(tc, null), Ul({
          type: "closeDialog"
        });
      }).catch(function(tc) {
        isAbort(tc) ? (bl(tc), Ul({
          type: "closeDialog"
        })) : isSecurityError(tc) ? (Pl.current = !1, Rl.current ? (Rl.current.value = null, Rl.current.click()) : Il(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Il(tc);
      });
      return;
    }
    Rl.current && (Ul({
      type: "openDialog"
    }), _l(), Rl.current.value = null, Rl.current.click());
  }, [Ul, _l, bl, Hs, Gs, Il, pl, na]), El = useCallback(function(zl) {
    !xl.current || !xl.current.isEqualNode(zl.target) || (zl.key === " " || zl.key === "Enter" || zl.keyCode === 32 || zl.keyCode === 13) && (zl.preventDefault(), gl());
  }, [xl, gl]), Ol = useCallback(function() {
    Ul({
      type: "focus"
    });
  }, []), wl = useCallback(function() {
    Ul({
      type: "blur"
    });
  }, []), dl = useCallback(function() {
    Xs || (isIeOrEdge() ? setTimeout(gl, 0) : gl());
  }, [Xs, gl]), Sl = function(tc) {
    return Xi ? null : tc;
  }, Ml = function(tc) {
    return Cs ? null : Sl(tc);
  }, Fl = function(tc) {
    return Fs ? null : Sl(tc);
  }, Ll = function(tc) {
    ws && tc.stopPropagation();
  }, Nl = useMemo(function() {
    return function() {
      var zl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tc = zl.refKey, Ku = tc === void 0 ? "ref" : tc, tu = zl.role, Gu = zl.onKeyDown, Qu = zl.onFocus, ed = zl.onBlur, td = zl.onClick, od = zl.onDragEnter, ld = zl.onDragOver, sd = zl.onDragLeave, bd = zl.onDrop, $d = _objectWithoutProperties(zl, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: Ml(composeEventHandlers(Gu, El)),
        onFocus: Ml(composeEventHandlers(Qu, Ol)),
        onBlur: Ml(composeEventHandlers(ed, wl)),
        onClick: Sl(composeEventHandlers(td, dl)),
        onDragEnter: Fl(composeEventHandlers(od, jl)),
        onDragOver: Fl(composeEventHandlers(ld, Al)),
        onDragLeave: Fl(composeEventHandlers(sd, _s)),
        onDrop: Fl(composeEventHandlers(bd, vl)),
        role: typeof tu == "string" && tu !== "" ? tu : "presentation"
      }, Ku, xl), !Xi && !Cs ? {
        tabIndex: 0
      } : {}), $d);
    };
  }, [xl, El, Ol, wl, dl, jl, Al, _s, vl, Cs, Fs, Xi]), ql = useCallback(function(zl) {
    zl.stopPropagation();
  }, []), Jl = useMemo(function() {
    return function() {
      var zl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tc = zl.refKey, Ku = tc === void 0 ? "ref" : tc, tu = zl.onChange, Gu = zl.onClick, Qu = _objectWithoutProperties(zl, _excluded4), ed = _defineProperty({
        accept: Js,
        multiple: na,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: Sl(composeEventHandlers(tu, vl)),
        onClick: Sl(composeEventHandlers(Gu, ql)),
        tabIndex: -1
      }, Ku, Rl);
      return _objectSpread(_objectSpread({}, ed), Qu);
    };
  }, [Rl, qi, na, vl, Xi]);
  return _objectSpread(_objectSpread({}, kl), {}, {
    isFocused: Bl && !Xi,
    getRootProps: Nl,
    getInputProps: Jl,
    rootRef: xl,
    inputRef: Rl,
    open: Sl(gl)
  });
}
function reducer(Bi, e) {
  switch (e.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFocused: !0
      });
    case "blur":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFocused: !1
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        isDragActive: e.isDragActive,
        isDragAccept: e.isDragAccept,
        isDragReject: e.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, Bi), {}, {
        acceptedFiles: e.acceptedFiles,
        fileRejections: e.fileRejections,
        isDragReject: e.isDragReject
      });
    case "reset":
      return _objectSpread({}, initialState);
    default:
      return Bi;
  }
}
function noop() {
}
const CheckBox = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", ...Bi, className: "bg-neutral-600 checkbox" });
var isCheckBoxInput = (Bi) => Bi.type === "checkbox", isDateObject = (Bi) => Bi instanceof Date, isNullOrUndefined = (Bi) => Bi == null;
const isObjectType = (Bi) => typeof Bi == "object";
var isObject = (Bi) => !isNullOrUndefined(Bi) && !Array.isArray(Bi) && isObjectType(Bi) && !isDateObject(Bi), getEventValue = (Bi) => isObject(Bi) && Bi.target ? isCheckBoxInput(Bi.target) ? Bi.target.checked : Bi.target.value : Bi, getNodeParentName = (Bi) => Bi.substring(0, Bi.search(/\.\d+(\.|$)/)) || Bi, isNameInFieldArray = (Bi, e) => Bi.has(getNodeParentName(e)), isPlainObject = (Bi) => {
  const e = Bi.constructor && Bi.constructor.prototype;
  return isObject(e) && e.hasOwnProperty("isPrototypeOf");
}, isWeb = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function cloneObject(Bi) {
  let e;
  const qi = Array.isArray(Bi);
  if (Bi instanceof Date)
    e = new Date(Bi);
  else if (Bi instanceof Set)
    e = new Set(Bi);
  else if (!(isWeb && (Bi instanceof Blob || Bi instanceof FileList)) && (qi || isObject(Bi)))
    if (e = qi ? [] : {}, !qi && !isPlainObject(Bi))
      e = Bi;
    else
      for (const Xi in Bi)
        Bi.hasOwnProperty(Xi) && (e[Xi] = cloneObject(Bi[Xi]));
  else
    return Bi;
  return e;
}
var compact = (Bi) => Array.isArray(Bi) ? Bi.filter(Boolean) : [], isUndefined = (Bi) => Bi === void 0, get = (Bi, e, qi) => {
  if (!e || !isObject(Bi))
    return qi;
  const Xi = compact(e.split(/[,[\].]+?/)).reduce((Qi, ta) => isNullOrUndefined(Qi) ? Qi : Qi[ta], Bi);
  return isUndefined(Xi) || Xi === Bi ? isUndefined(Bi[e]) ? qi : Bi[e] : Xi;
};
const EVENTS = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, VALIDATION_MODE = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, INPUT_VALIDATION_RULES = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
a__default.createContext(null);
var getProxyFormState = (Bi, e, qi, Xi = !0) => {
  const Qi = {
    defaultValues: e._defaultValues
  };
  for (const ta in Bi)
    Object.defineProperty(Qi, ta, {
      get: () => {
        const ra = ta;
        return e._proxyFormState[ra] !== VALIDATION_MODE.all && (e._proxyFormState[ra] = !Xi || VALIDATION_MODE.all), Bi[ra];
      }
    });
  return Qi;
}, isEmptyObject = (Bi) => isObject(Bi) && !Object.keys(Bi).length, shouldRenderFormState = (Bi, e, qi, Xi) => {
  qi(Bi);
  const { name: Qi, ...ta } = Bi;
  return isEmptyObject(ta) || Object.keys(ta).length >= Object.keys(e).length || Object.keys(ta).find((ra) => e[ra] === VALIDATION_MODE.all);
}, convertToArrayPayload = (Bi) => Array.isArray(Bi) ? Bi : [Bi];
function useSubscribe(Bi) {
  const e = a__default.useRef(Bi);
  e.current = Bi, a__default.useEffect(() => {
    const qi = !Bi.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      qi && qi.unsubscribe();
    };
  }, [Bi.disabled]);
}
var isString = (Bi) => typeof Bi == "string", generateWatchOutput = (Bi, e, qi, Xi, Qi) => isString(Bi) ? (Xi && e.watch.add(Bi), get(qi, Bi, Qi)) : Array.isArray(Bi) ? Bi.map((ta) => (Xi && e.watch.add(ta), get(qi, ta))) : (Xi && (e.watchAll = !0), qi), isKey = (Bi) => /^\w*$/.test(Bi), stringToPath = (Bi) => compact(Bi.replace(/["|']|\]/g, "").split(/\.|\[/));
function set(Bi, e, qi) {
  let Xi = -1;
  const Qi = isKey(e) ? [e] : stringToPath(e), ta = Qi.length, ra = ta - 1;
  for (; ++Xi < ta; ) {
    const na = Qi[Xi];
    let la = qi;
    if (Xi !== ra) {
      const Ma = Bi[na];
      la = isObject(Ma) || Array.isArray(Ma) ? Ma : isNaN(+Qi[Xi + 1]) ? {} : [];
    }
    Bi[na] = la, Bi = Bi[na];
  }
  return Bi;
}
var appendErrors = (Bi, e, qi, Xi, Qi) => e ? {
  ...qi[Bi],
  types: {
    ...qi[Bi] && qi[Bi].types ? qi[Bi].types : {},
    [Xi]: Qi || !0
  }
} : {};
const focusFieldBy = (Bi, e, qi) => {
  for (const Xi of qi || Object.keys(Bi)) {
    const Qi = get(Bi, Xi);
    if (Qi) {
      const { _f: ta, ...ra } = Qi;
      if (ta && e(ta.name)) {
        if (ta.ref.focus) {
          ta.ref.focus();
          break;
        } else if (ta.refs && ta.refs[0].focus) {
          ta.refs[0].focus();
          break;
        }
      } else isObject(ra) && focusFieldBy(ra, e);
    }
  }
};
var getValidationModes = (Bi) => ({
  isOnSubmit: !Bi || Bi === VALIDATION_MODE.onSubmit,
  isOnBlur: Bi === VALIDATION_MODE.onBlur,
  isOnChange: Bi === VALIDATION_MODE.onChange,
  isOnAll: Bi === VALIDATION_MODE.all,
  isOnTouch: Bi === VALIDATION_MODE.onTouched
}), isWatched = (Bi, e, qi) => !qi && (e.watchAll || e.watch.has(Bi) || [...e.watch].some((Xi) => Bi.startsWith(Xi) && /^\.\w+/.test(Bi.slice(Xi.length)))), updateFieldArrayRootError = (Bi, e, qi) => {
  const Xi = compact(get(Bi, qi));
  return set(Xi, "root", e[qi]), set(Bi, qi, Xi), Bi;
}, isBoolean$1 = (Bi) => typeof Bi == "boolean", isFileInput = (Bi) => Bi.type === "file", isFunction = (Bi) => typeof Bi == "function", isHTMLElement = (Bi) => {
  if (!isWeb)
    return !1;
  const e = Bi ? Bi.ownerDocument : 0;
  return Bi instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, isMessage = (Bi) => isString(Bi), isRadioInput = (Bi) => Bi.type === "radio", isRegex = (Bi) => Bi instanceof RegExp;
const defaultResult = {
  value: !1,
  isValid: !1
}, validResult = { value: !0, isValid: !0 };
var getCheckboxValue = (Bi) => {
  if (Array.isArray(Bi)) {
    if (Bi.length > 1) {
      const e = Bi.filter((qi) => qi && qi.checked && !qi.disabled).map((qi) => qi.value);
      return { value: e, isValid: !!e.length };
    }
    return Bi[0].checked && !Bi[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      Bi[0].attributes && !isUndefined(Bi[0].attributes.value) ? isUndefined(Bi[0].value) || Bi[0].value === "" ? validResult : { value: Bi[0].value, isValid: !0 } : validResult
    ) : defaultResult;
  }
  return defaultResult;
};
const defaultReturn = {
  isValid: !1,
  value: null
};
var getRadioValue = (Bi) => Array.isArray(Bi) ? Bi.reduce((e, qi) => qi && qi.checked && !qi.disabled ? {
  isValid: !0,
  value: qi.value
} : e, defaultReturn) : defaultReturn;
function getValidateError(Bi, e, qi = "validate") {
  if (isMessage(Bi) || Array.isArray(Bi) && Bi.every(isMessage) || isBoolean$1(Bi) && !Bi)
    return {
      type: qi,
      message: isMessage(Bi) ? Bi : "",
      ref: e
    };
}
var getValueAndMessage = (Bi) => isObject(Bi) && !isRegex(Bi) ? Bi : {
  value: Bi,
  message: ""
}, validateField = async (Bi, e, qi, Xi, Qi) => {
  const { ref: ta, refs: ra, required: na, maxLength: la, minLength: Ma, min: Va, max: to, pattern: Eo, validate: So, name: eo, valueAsNumber: rs, mount: ko, disabled: Hs } = Bi._f, Ks = get(e, eo);
  if (!ko || Hs)
    return {};
  const Ys = ra ? ra[0] : ta, Xs = (_l) => {
    Xi && Ys.reportValidity && (Ys.setCustomValidity(isBoolean$1(_l) ? "" : _l || ""), Ys.reportValidity());
  }, Cs = {}, Fs = isRadioInput(ta), ws = isCheckBoxInput(ta), ls = Fs || ws, ks = (rs || isFileInput(ta)) && isUndefined(ta.value) && isUndefined(Ks) || isHTMLElement(ta) && ta.value === "" || Ks === "" || Array.isArray(Ks) && !Ks.length, Js = appendErrors.bind(null, eo, qi, Cs), pl = (_l, bl, xl, Rl = INPUT_VALIDATION_RULES.maxLength, Cl = INPUT_VALIDATION_RULES.minLength) => {
    const Dl = _l ? bl : xl;
    Cs[eo] = {
      type: _l ? Rl : Cl,
      message: Dl,
      ref: ta,
      ...Js(_l ? Rl : Cl, Dl)
    };
  };
  if (Qi ? !Array.isArray(Ks) || !Ks.length : na && (!ls && (ks || isNullOrUndefined(Ks)) || isBoolean$1(Ks) && !Ks || ws && !getCheckboxValue(ra).isValid || Fs && !getRadioValue(ra).isValid)) {
    const { value: _l, message: bl } = isMessage(na) ? { value: !!na, message: na } : getValueAndMessage(na);
    if (_l && (Cs[eo] = {
      type: INPUT_VALIDATION_RULES.required,
      message: bl,
      ref: Ys,
      ...Js(INPUT_VALIDATION_RULES.required, bl)
    }, !qi))
      return Xs(bl), Cs;
  }
  if (!ks && (!isNullOrUndefined(Va) || !isNullOrUndefined(to))) {
    let _l, bl;
    const xl = getValueAndMessage(to), Rl = getValueAndMessage(Va);
    if (!isNullOrUndefined(Ks) && !isNaN(Ks)) {
      const Cl = ta.valueAsNumber || Ks && +Ks;
      isNullOrUndefined(xl.value) || (_l = Cl > xl.value), isNullOrUndefined(Rl.value) || (bl = Cl < Rl.value);
    } else {
      const Cl = ta.valueAsDate || new Date(Ks), Dl = (Bl) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + Bl), kl = ta.type == "time", Ul = ta.type == "week";
      isString(xl.value) && Ks && (_l = kl ? Dl(Ks) > Dl(xl.value) : Ul ? Ks > xl.value : Cl > new Date(xl.value)), isString(Rl.value) && Ks && (bl = kl ? Dl(Ks) < Dl(Rl.value) : Ul ? Ks < Rl.value : Cl < new Date(Rl.value));
    }
    if ((_l || bl) && (pl(!!_l, xl.message, Rl.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min), !qi))
      return Xs(Cs[eo].message), Cs;
  }
  if ((la || Ma) && !ks && (isString(Ks) || Qi && Array.isArray(Ks))) {
    const _l = getValueAndMessage(la), bl = getValueAndMessage(Ma), xl = !isNullOrUndefined(_l.value) && Ks.length > +_l.value, Rl = !isNullOrUndefined(bl.value) && Ks.length < +bl.value;
    if ((xl || Rl) && (pl(xl, _l.message, bl.message), !qi))
      return Xs(Cs[eo].message), Cs;
  }
  if (Eo && !ks && isString(Ks)) {
    const { value: _l, message: bl } = getValueAndMessage(Eo);
    if (isRegex(_l) && !Ks.match(_l) && (Cs[eo] = {
      type: INPUT_VALIDATION_RULES.pattern,
      message: bl,
      ref: ta,
      ...Js(INPUT_VALIDATION_RULES.pattern, bl)
    }, !qi))
      return Xs(bl), Cs;
  }
  if (So) {
    if (isFunction(So)) {
      const _l = await So(Ks, e), bl = getValidateError(_l, Ys);
      if (bl && (Cs[eo] = {
        ...bl,
        ...Js(INPUT_VALIDATION_RULES.validate, bl.message)
      }, !qi))
        return Xs(bl.message), Cs;
    } else if (isObject(So)) {
      let _l = {};
      for (const bl in So) {
        if (!isEmptyObject(_l) && !qi)
          break;
        const xl = getValidateError(await So[bl](Ks, e), Ys, bl);
        xl && (_l = {
          ...xl,
          ...Js(bl, xl.message)
        }, Xs(xl.message), qi && (Cs[eo] = _l));
      }
      if (!isEmptyObject(_l) && (Cs[eo] = {
        ref: Ys,
        ..._l
      }, !qi))
        return Cs;
    }
  }
  return Xs(!0), Cs;
};
function baseGet(Bi, e) {
  const qi = e.slice(0, -1).length;
  let Xi = 0;
  for (; Xi < qi; )
    Bi = isUndefined(Bi) ? Xi++ : Bi[e[Xi++]];
  return Bi;
}
function isEmptyArray(Bi) {
  for (const e in Bi)
    if (Bi.hasOwnProperty(e) && !isUndefined(Bi[e]))
      return !1;
  return !0;
}
function unset(Bi, e) {
  const qi = Array.isArray(e) ? e : isKey(e) ? [e] : stringToPath(e), Xi = qi.length === 1 ? Bi : baseGet(Bi, qi), Qi = qi.length - 1, ta = qi[Qi];
  return Xi && delete Xi[ta], Qi !== 0 && (isObject(Xi) && isEmptyObject(Xi) || Array.isArray(Xi) && isEmptyArray(Xi)) && unset(Bi, qi.slice(0, -1)), Bi;
}
function createSubject() {
  let Bi = [];
  return {
    get observers() {
      return Bi;
    },
    next: (Qi) => {
      for (const ta of Bi)
        ta.next && ta.next(Qi);
    },
    subscribe: (Qi) => (Bi.push(Qi), {
      unsubscribe: () => {
        Bi = Bi.filter((ta) => ta !== Qi);
      }
    }),
    unsubscribe: () => {
      Bi = [];
    }
  };
}
var isPrimitive = (Bi) => isNullOrUndefined(Bi) || !isObjectType(Bi);
function deepEqual(Bi, e) {
  if (isPrimitive(Bi) || isPrimitive(e))
    return Bi === e;
  if (isDateObject(Bi) && isDateObject(e))
    return Bi.getTime() === e.getTime();
  const qi = Object.keys(Bi), Xi = Object.keys(e);
  if (qi.length !== Xi.length)
    return !1;
  for (const Qi of qi) {
    const ta = Bi[Qi];
    if (!Xi.includes(Qi))
      return !1;
    if (Qi !== "ref") {
      const ra = e[Qi];
      if (isDateObject(ta) && isDateObject(ra) || isObject(ta) && isObject(ra) || Array.isArray(ta) && Array.isArray(ra) ? !deepEqual(ta, ra) : ta !== ra)
        return !1;
    }
  }
  return !0;
}
var isMultipleSelect = (Bi) => Bi.type === "select-multiple", isRadioOrCheckbox = (Bi) => isRadioInput(Bi) || isCheckBoxInput(Bi), live = (Bi) => isHTMLElement(Bi) && Bi.isConnected, objectHasFunction = (Bi) => {
  for (const e in Bi)
    if (isFunction(Bi[e]))
      return !0;
  return !1;
};
function markFieldsDirty(Bi, e = {}) {
  const qi = Array.isArray(Bi);
  if (isObject(Bi) || qi)
    for (const Xi in Bi)
      Array.isArray(Bi[Xi]) || isObject(Bi[Xi]) && !objectHasFunction(Bi[Xi]) ? (e[Xi] = Array.isArray(Bi[Xi]) ? [] : {}, markFieldsDirty(Bi[Xi], e[Xi])) : isNullOrUndefined(Bi[Xi]) || (e[Xi] = !0);
  return e;
}
function getDirtyFieldsFromDefaultValues(Bi, e, qi) {
  const Xi = Array.isArray(Bi);
  if (isObject(Bi) || Xi)
    for (const Qi in Bi)
      Array.isArray(Bi[Qi]) || isObject(Bi[Qi]) && !objectHasFunction(Bi[Qi]) ? isUndefined(e) || isPrimitive(qi[Qi]) ? qi[Qi] = Array.isArray(Bi[Qi]) ? markFieldsDirty(Bi[Qi], []) : { ...markFieldsDirty(Bi[Qi]) } : getDirtyFieldsFromDefaultValues(Bi[Qi], isNullOrUndefined(e) ? {} : e[Qi], qi[Qi]) : qi[Qi] = !deepEqual(Bi[Qi], e[Qi]);
  return qi;
}
var getDirtyFields = (Bi, e) => getDirtyFieldsFromDefaultValues(Bi, e, markFieldsDirty(e)), getFieldValueAs = (Bi, { valueAsNumber: e, valueAsDate: qi, setValueAs: Xi }) => isUndefined(Bi) ? Bi : e ? Bi === "" ? NaN : Bi && +Bi : qi && isString(Bi) ? new Date(Bi) : Xi ? Xi(Bi) : Bi;
function getFieldValue(Bi) {
  const e = Bi.ref;
  if (!(Bi.refs ? Bi.refs.every((qi) => qi.disabled) : e.disabled))
    return isFileInput(e) ? e.files : isRadioInput(e) ? getRadioValue(Bi.refs).value : isMultipleSelect(e) ? [...e.selectedOptions].map(({ value: qi }) => qi) : isCheckBoxInput(e) ? getCheckboxValue(Bi.refs).value : getFieldValueAs(isUndefined(e.value) ? Bi.ref.value : e.value, Bi);
}
var getResolverOptions = (Bi, e, qi, Xi) => {
  const Qi = {};
  for (const ta of Bi) {
    const ra = get(e, ta);
    ra && set(Qi, ta, ra._f);
  }
  return {
    criteriaMode: qi,
    names: [...Bi],
    fields: Qi,
    shouldUseNativeValidation: Xi
  };
}, getRuleValue = (Bi) => isUndefined(Bi) ? Bi : isRegex(Bi) ? Bi.source : isObject(Bi) ? isRegex(Bi.value) ? Bi.value.source : Bi.value : Bi, hasValidation = (Bi) => Bi.mount && (Bi.required || Bi.min || Bi.max || Bi.maxLength || Bi.minLength || Bi.pattern || Bi.validate);
function schemaErrorLookup(Bi, e, qi) {
  const Xi = get(Bi, qi);
  if (Xi || isKey(qi))
    return {
      error: Xi,
      name: qi
    };
  const Qi = qi.split(".");
  for (; Qi.length; ) {
    const ta = Qi.join("."), ra = get(e, ta), na = get(Bi, ta);
    if (ra && !Array.isArray(ra) && qi !== ta)
      return { name: qi };
    if (na && na.type)
      return {
        name: ta,
        error: na
      };
    Qi.pop();
  }
  return {
    name: qi
  };
}
var skipValidation = (Bi, e, qi, Xi, Qi) => Qi.isOnAll ? !1 : !qi && Qi.isOnTouch ? !(e || Bi) : (qi ? Xi.isOnBlur : Qi.isOnBlur) ? !Bi : (qi ? Xi.isOnChange : Qi.isOnChange) ? Bi : !0, unsetEmptyArray = (Bi, e) => !compact(get(Bi, e)).length && unset(Bi, e);
const defaultOptions$1 = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: !0
};
function createFormControl(Bi = {}, e) {
  let qi = {
    ...defaultOptions$1,
    ...Bi
  }, Xi = {
    submitCount: 0,
    isDirty: !1,
    isLoading: isFunction(qi.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, Qi = {}, ta = isObject(qi.defaultValues) || isObject(qi.values) ? cloneObject(qi.defaultValues || qi.values) || {} : {}, ra = qi.shouldUnregister ? {} : cloneObject(ta), na = {
    action: !1,
    mount: !1,
    watch: !1
  }, la = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, Ma, Va = 0;
  const to = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, Eo = {
    values: createSubject(),
    array: createSubject(),
    state: createSubject()
  }, So = Bi.resetOptions && Bi.resetOptions.keepDirtyValues, eo = getValidationModes(qi.mode), rs = getValidationModes(qi.reValidateMode), ko = qi.criteriaMode === VALIDATION_MODE.all, Hs = (dl) => (Sl) => {
    clearTimeout(Va), Va = setTimeout(dl, Sl);
  }, Ks = async (dl) => {
    if (to.isValid || dl) {
      const Sl = qi.resolver ? isEmptyObject((await ks()).errors) : await pl(Qi, !0);
      Sl !== Xi.isValid && Eo.state.next({
        isValid: Sl
      });
    }
  }, Ys = (dl) => to.isValidating && Eo.state.next({
    isValidating: dl
  }), Xs = (dl, Sl = [], Ml, Fl, Ll = !0, Nl = !0) => {
    if (Fl && Ml) {
      if (na.action = !0, Nl && Array.isArray(get(Qi, dl))) {
        const ql = Ml(get(Qi, dl), Fl.argA, Fl.argB);
        Ll && set(Qi, dl, ql);
      }
      if (Nl && Array.isArray(get(Xi.errors, dl))) {
        const ql = Ml(get(Xi.errors, dl), Fl.argA, Fl.argB);
        Ll && set(Xi.errors, dl, ql), unsetEmptyArray(Xi.errors, dl);
      }
      if (to.touchedFields && Nl && Array.isArray(get(Xi.touchedFields, dl))) {
        const ql = Ml(get(Xi.touchedFields, dl), Fl.argA, Fl.argB);
        Ll && set(Xi.touchedFields, dl, ql);
      }
      to.dirtyFields && (Xi.dirtyFields = getDirtyFields(ta, ra)), Eo.state.next({
        name: dl,
        isDirty: bl(dl, Sl),
        dirtyFields: Xi.dirtyFields,
        errors: Xi.errors,
        isValid: Xi.isValid
      });
    } else
      set(ra, dl, Sl);
  }, Cs = (dl, Sl) => {
    set(Xi.errors, dl, Sl), Eo.state.next({
      errors: Xi.errors
    });
  }, Fs = (dl, Sl, Ml, Fl) => {
    const Ll = get(Qi, dl);
    if (Ll) {
      const Nl = get(ra, dl, isUndefined(Ml) ? get(ta, dl) : Ml);
      isUndefined(Nl) || Fl && Fl.defaultChecked || Sl ? set(ra, dl, Sl ? Nl : getFieldValue(Ll._f)) : Cl(dl, Nl), na.mount && Ks();
    }
  }, ws = (dl, Sl, Ml, Fl, Ll) => {
    let Nl = !1, ql = !1;
    const Jl = {
      name: dl
    };
    if (!Ml || Fl) {
      to.isDirty && (ql = Xi.isDirty, Xi.isDirty = Jl.isDirty = bl(), Nl = ql !== Jl.isDirty);
      const zl = deepEqual(get(ta, dl), Sl);
      ql = get(Xi.dirtyFields, dl), zl ? unset(Xi.dirtyFields, dl) : set(Xi.dirtyFields, dl, !0), Jl.dirtyFields = Xi.dirtyFields, Nl = Nl || to.dirtyFields && ql !== !zl;
    }
    if (Ml) {
      const zl = get(Xi.touchedFields, dl);
      zl || (set(Xi.touchedFields, dl, Ml), Jl.touchedFields = Xi.touchedFields, Nl = Nl || to.touchedFields && zl !== Ml);
    }
    return Nl && Ll && Eo.state.next(Jl), Nl ? Jl : {};
  }, ls = (dl, Sl, Ml, Fl) => {
    const Ll = get(Xi.errors, dl), Nl = to.isValid && isBoolean$1(Sl) && Xi.isValid !== Sl;
    if (Bi.delayError && Ml ? (Ma = Hs(() => Cs(dl, Ml)), Ma(Bi.delayError)) : (clearTimeout(Va), Ma = null, Ml ? set(Xi.errors, dl, Ml) : unset(Xi.errors, dl)), (Ml ? !deepEqual(Ll, Ml) : Ll) || !isEmptyObject(Fl) || Nl) {
      const ql = {
        ...Fl,
        ...Nl && isBoolean$1(Sl) ? { isValid: Sl } : {},
        errors: Xi.errors,
        name: dl
      };
      Xi = {
        ...Xi,
        ...ql
      }, Eo.state.next(ql);
    }
    Ys(!1);
  }, ks = async (dl) => qi.resolver(ra, qi.context, getResolverOptions(dl || la.mount, Qi, qi.criteriaMode, qi.shouldUseNativeValidation)), Js = async (dl) => {
    const { errors: Sl } = await ks();
    if (dl)
      for (const Ml of dl) {
        const Fl = get(Sl, Ml);
        Fl ? set(Xi.errors, Ml, Fl) : unset(Xi.errors, Ml);
      }
    else
      Xi.errors = Sl;
    return Sl;
  }, pl = async (dl, Sl, Ml = {
    valid: !0
  }) => {
    for (const Fl in dl) {
      const Ll = dl[Fl];
      if (Ll) {
        const { _f: Nl, ...ql } = Ll;
        if (Nl) {
          const Jl = la.array.has(Nl.name), zl = await validateField(Ll, ra, ko, qi.shouldUseNativeValidation && !Sl, Jl);
          if (zl[Nl.name] && (Ml.valid = !1, Sl))
            break;
          !Sl && (get(zl, Nl.name) ? Jl ? updateFieldArrayRootError(Xi.errors, zl, Nl.name) : set(Xi.errors, Nl.name, zl[Nl.name]) : unset(Xi.errors, Nl.name));
        }
        ql && await pl(ql, Sl, Ml);
      }
    }
    return Ml.valid;
  }, _l = () => {
    for (const dl of la.unMount) {
      const Sl = get(Qi, dl);
      Sl && (Sl._f.refs ? Sl._f.refs.every((Ml) => !live(Ml)) : !live(Sl._f.ref)) && Il(dl);
    }
    la.unMount = /* @__PURE__ */ new Set();
  }, bl = (dl, Sl) => (dl && Sl && set(ra, dl, Sl), !deepEqual(Zl(), ta)), xl = (dl, Sl, Ml) => generateWatchOutput(dl, la, {
    ...na.mount ? ra : isUndefined(Sl) ? ta : isString(dl) ? { [dl]: Sl } : Sl
  }, Ml, Sl), Rl = (dl) => compact(get(na.mount ? ra : ta, dl, Bi.shouldUnregister ? get(ta, dl, []) : [])), Cl = (dl, Sl, Ml = {}) => {
    const Fl = get(Qi, dl);
    let Ll = Sl;
    if (Fl) {
      const Nl = Fl._f;
      Nl && (!Nl.disabled && set(ra, dl, getFieldValueAs(Sl, Nl)), Ll = isHTMLElement(Nl.ref) && isNullOrUndefined(Sl) ? "" : Sl, isMultipleSelect(Nl.ref) ? [...Nl.ref.options].forEach((ql) => ql.selected = Ll.includes(ql.value)) : Nl.refs ? isCheckBoxInput(Nl.ref) ? Nl.refs.length > 1 ? Nl.refs.forEach((ql) => (!ql.defaultChecked || !ql.disabled) && (ql.checked = Array.isArray(Ll) ? !!Ll.find((Jl) => Jl === ql.value) : Ll === ql.value)) : Nl.refs[0] && (Nl.refs[0].checked = !!Ll) : Nl.refs.forEach((ql) => ql.checked = ql.value === Ll) : isFileInput(Nl.ref) ? Nl.ref.value = "" : (Nl.ref.value = Ll, Nl.ref.type || Eo.values.next({
        name: dl,
        values: { ...ra }
      })));
    }
    (Ml.shouldDirty || Ml.shouldTouch) && ws(dl, Ll, Ml.shouldTouch, Ml.shouldDirty, !0), Ml.shouldValidate && Bl(dl);
  }, Dl = (dl, Sl, Ml) => {
    for (const Fl in Sl) {
      const Ll = Sl[Fl], Nl = `${dl}.${Fl}`, ql = get(Qi, Nl);
      (la.array.has(dl) || !isPrimitive(Ll) || ql && !ql._f) && !isDateObject(Ll) ? Dl(Nl, Ll, Ml) : Cl(Nl, Ll, Ml);
    }
  }, kl = (dl, Sl, Ml = {}) => {
    const Fl = get(Qi, dl), Ll = la.array.has(dl), Nl = cloneObject(Sl);
    set(ra, dl, Nl), Ll ? (Eo.array.next({
      name: dl,
      values: { ...ra }
    }), (to.isDirty || to.dirtyFields) && Ml.shouldDirty && Eo.state.next({
      name: dl,
      dirtyFields: getDirtyFields(ta, ra),
      isDirty: bl(dl, Nl)
    })) : Fl && !Fl._f && !isNullOrUndefined(Nl) ? Dl(dl, Nl, Ml) : Cl(dl, Nl, Ml), isWatched(dl, la) && Eo.state.next({ ...Xi }), Eo.values.next({
      name: dl,
      values: { ...ra }
    }), !na.mount && e();
  }, Ul = async (dl) => {
    const Sl = dl.target;
    let Ml = Sl.name, Fl = !0;
    const Ll = get(Qi, Ml), Nl = () => Sl.type ? getFieldValue(Ll._f) : getEventValue(dl);
    if (Ll) {
      let ql, Jl;
      const zl = Nl(), tc = dl.type === EVENTS.BLUR || dl.type === EVENTS.FOCUS_OUT, Ku = !hasValidation(Ll._f) && !qi.resolver && !get(Xi.errors, Ml) && !Ll._f.deps || skipValidation(tc, get(Xi.touchedFields, Ml), Xi.isSubmitted, rs, eo), tu = isWatched(Ml, la, tc);
      set(ra, Ml, zl), tc ? (Ll._f.onBlur && Ll._f.onBlur(dl), Ma && Ma(0)) : Ll._f.onChange && Ll._f.onChange(dl);
      const Gu = ws(Ml, zl, tc, !1), Qu = !isEmptyObject(Gu) || tu;
      if (!tc && Eo.values.next({
        name: Ml,
        type: dl.type,
        values: { ...ra }
      }), Ku)
        return to.isValid && Ks(), Qu && Eo.state.next({ name: Ml, ...tu ? {} : Gu });
      if (!tc && tu && Eo.state.next({ ...Xi }), Ys(!0), qi.resolver) {
        const { errors: ed } = await ks([Ml]), td = schemaErrorLookup(Xi.errors, Qi, Ml), od = schemaErrorLookup(ed, Qi, td.name || Ml);
        ql = od.error, Ml = od.name, Jl = isEmptyObject(ed);
      } else
        ql = (await validateField(Ll, ra, ko, qi.shouldUseNativeValidation))[Ml], Fl = isNaN(zl) || zl === get(ra, Ml, zl), Fl && (ql ? Jl = !1 : to.isValid && (Jl = await pl(Qi, !0)));
      Fl && (Ll._f.deps && Bl(Ll._f.deps), ls(Ml, Jl, ql, Gu));
    }
  }, Bl = async (dl, Sl = {}) => {
    let Ml, Fl;
    const Ll = convertToArrayPayload(dl);
    if (Ys(!0), qi.resolver) {
      const Nl = await Js(isUndefined(dl) ? dl : Ll);
      Ml = isEmptyObject(Nl), Fl = dl ? !Ll.some((ql) => get(Nl, ql)) : Ml;
    } else dl ? (Fl = (await Promise.all(Ll.map(async (Nl) => {
      const ql = get(Qi, Nl);
      return await pl(ql && ql._f ? { [Nl]: ql } : ql);
    }))).every(Boolean), !(!Fl && !Xi.isValid) && Ks()) : Fl = Ml = await pl(Qi);
    return Eo.state.next({
      ...!isString(dl) || to.isValid && Ml !== Xi.isValid ? {} : { name: dl },
      ...qi.resolver || !dl ? { isValid: Ml } : {},
      errors: Xi.errors,
      isValidating: !1
    }), Sl.shouldFocus && !Fl && focusFieldBy(Qi, (Nl) => Nl && get(Xi.errors, Nl), dl ? Ll : la.mount), Fl;
  }, Zl = (dl) => {
    const Sl = {
      ...ta,
      ...na.mount ? ra : {}
    };
    return isUndefined(dl) ? Sl : isString(dl) ? get(Sl, dl) : dl.map((Ml) => get(Sl, Ml));
  }, Pl = (dl, Sl) => ({
    invalid: !!get((Sl || Xi).errors, dl),
    isDirty: !!get((Sl || Xi).dirtyFields, dl),
    isTouched: !!get((Sl || Xi).touchedFields, dl),
    error: get((Sl || Xi).errors, dl)
  }), yl = (dl) => {
    dl && convertToArrayPayload(dl).forEach((Sl) => unset(Xi.errors, Sl)), Eo.state.next({
      errors: dl ? Xi.errors : {}
    });
  }, hl = (dl, Sl, Ml) => {
    const Fl = (get(Qi, dl, { _f: {} })._f || {}).ref;
    set(Xi.errors, dl, {
      ...Sl,
      ref: Fl
    }), Eo.state.next({
      name: dl,
      errors: Xi.errors,
      isValid: !1
    }), Ml && Ml.shouldFocus && Fl && Fl.focus && Fl.focus();
  }, Tl = (dl, Sl) => isFunction(dl) ? Eo.values.subscribe({
    next: (Ml) => dl(xl(void 0, Sl), Ml)
  }) : xl(dl, Sl, !0), Il = (dl, Sl = {}) => {
    for (const Ml of dl ? convertToArrayPayload(dl) : la.mount)
      la.mount.delete(Ml), la.array.delete(Ml), Sl.keepValue || (unset(Qi, Ml), unset(ra, Ml)), !Sl.keepError && unset(Xi.errors, Ml), !Sl.keepDirty && unset(Xi.dirtyFields, Ml), !Sl.keepTouched && unset(Xi.touchedFields, Ml), !qi.shouldUnregister && !Sl.keepDefaultValue && unset(ta, Ml);
    Eo.values.next({
      values: { ...ra }
    }), Eo.state.next({
      ...Xi,
      ...Sl.keepDirty ? { isDirty: bl() } : {}
    }), !Sl.keepIsValid && Ks();
  }, jl = (dl, Sl = {}) => {
    let Ml = get(Qi, dl);
    const Fl = isBoolean$1(Sl.disabled);
    return set(Qi, dl, {
      ...Ml || {},
      _f: {
        ...Ml && Ml._f ? Ml._f : { ref: { name: dl } },
        name: dl,
        mount: !0,
        ...Sl
      }
    }), la.mount.add(dl), Ml ? Fl && set(ra, dl, Sl.disabled ? void 0 : get(ra, dl, getFieldValue(Ml._f))) : Fs(dl, !0, Sl.value), {
      ...Fl ? { disabled: Sl.disabled } : {},
      ...qi.progressive ? {
        required: !!Sl.required,
        min: getRuleValue(Sl.min),
        max: getRuleValue(Sl.max),
        minLength: getRuleValue(Sl.minLength),
        maxLength: getRuleValue(Sl.maxLength),
        pattern: getRuleValue(Sl.pattern)
      } : {},
      name: dl,
      onChange: Ul,
      onBlur: Ul,
      ref: (Ll) => {
        if (Ll) {
          jl(dl, Sl), Ml = get(Qi, dl);
          const Nl = isUndefined(Ll.value) && Ll.querySelectorAll && Ll.querySelectorAll("input,select,textarea")[0] || Ll, ql = isRadioOrCheckbox(Nl), Jl = Ml._f.refs || [];
          if (ql ? Jl.find((zl) => zl === Nl) : Nl === Ml._f.ref)
            return;
          set(Qi, dl, {
            _f: {
              ...Ml._f,
              ...ql ? {
                refs: [
                  ...Jl.filter(live),
                  Nl,
                  ...Array.isArray(get(ta, dl)) ? [{}] : []
                ],
                ref: { type: Nl.type, name: dl }
              } : { ref: Nl }
            }
          }), Fs(dl, !1, void 0, Nl);
        } else
          Ml = get(Qi, dl, {}), Ml._f && (Ml._f.mount = !1), (qi.shouldUnregister || Sl.shouldUnregister) && !(isNameInFieldArray(la.array, dl) && na.action) && la.unMount.add(dl);
      }
    };
  }, Al = () => qi.shouldFocusError && focusFieldBy(Qi, (dl) => dl && get(Xi.errors, dl), la.mount), _s = (dl, Sl) => async (Ml) => {
    Ml && (Ml.preventDefault && Ml.preventDefault(), Ml.persist && Ml.persist());
    let Fl = cloneObject(ra);
    if (Eo.state.next({
      isSubmitting: !0
    }), qi.resolver) {
      const { errors: Ll, values: Nl } = await ks();
      Xi.errors = Ll, Fl = Nl;
    } else
      await pl(Qi);
    unset(Xi.errors, "root"), isEmptyObject(Xi.errors) ? (Eo.state.next({
      errors: {}
    }), await dl(Fl, Ml)) : (Sl && await Sl({ ...Xi.errors }, Ml), Al(), setTimeout(Al)), Eo.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: isEmptyObject(Xi.errors),
      submitCount: Xi.submitCount + 1,
      errors: Xi.errors
    });
  }, Gs = (dl, Sl = {}) => {
    get(Qi, dl) && (isUndefined(Sl.defaultValue) ? kl(dl, get(ta, dl)) : (kl(dl, Sl.defaultValue), set(ta, dl, Sl.defaultValue)), Sl.keepTouched || unset(Xi.touchedFields, dl), Sl.keepDirty || (unset(Xi.dirtyFields, dl), Xi.isDirty = Sl.defaultValue ? bl(dl, get(ta, dl)) : bl()), Sl.keepError || (unset(Xi.errors, dl), to.isValid && Ks()), Eo.state.next({ ...Xi }));
  }, vl = (dl, Sl = {}) => {
    const Ml = dl || ta, Fl = cloneObject(Ml), Ll = dl && !isEmptyObject(dl) ? Fl : ta;
    if (Sl.keepDefaultValues || (ta = Ml), !Sl.keepValues) {
      if (Sl.keepDirtyValues || So)
        for (const Nl of la.mount)
          get(Xi.dirtyFields, Nl) ? set(Ll, Nl, get(ra, Nl)) : kl(Nl, get(Ll, Nl));
      else {
        if (isWeb && isUndefined(dl))
          for (const Nl of la.mount) {
            const ql = get(Qi, Nl);
            if (ql && ql._f) {
              const Jl = Array.isArray(ql._f.refs) ? ql._f.refs[0] : ql._f.ref;
              if (isHTMLElement(Jl)) {
                const zl = Jl.closest("form");
                if (zl) {
                  zl.reset();
                  break;
                }
              }
            }
          }
        Qi = {};
      }
      ra = Bi.shouldUnregister ? Sl.keepDefaultValues ? cloneObject(ta) : {} : cloneObject(Ll), Eo.array.next({
        values: { ...Ll }
      }), Eo.values.next({
        values: { ...Ll }
      });
    }
    la = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !na.mount && e(), na.mount = !to.isValid || !!Sl.keepIsValid, na.watch = !!Bi.shouldUnregister, Eo.state.next({
      submitCount: Sl.keepSubmitCount ? Xi.submitCount : 0,
      isDirty: Sl.keepDirty ? Xi.isDirty : !!(Sl.keepDefaultValues && !deepEqual(dl, ta)),
      isSubmitted: Sl.keepIsSubmitted ? Xi.isSubmitted : !1,
      dirtyFields: Sl.keepDirtyValues ? Xi.dirtyFields : Sl.keepDefaultValues && dl ? getDirtyFields(ta, dl) : {},
      touchedFields: Sl.keepTouched ? Xi.touchedFields : {},
      errors: Sl.keepErrors ? Xi.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, gl = (dl, Sl) => vl(isFunction(dl) ? dl(ra) : dl, Sl);
  return {
    control: {
      register: jl,
      unregister: Il,
      getFieldState: Pl,
      handleSubmit: _s,
      setError: hl,
      _executeSchema: ks,
      _getWatch: xl,
      _getDirty: bl,
      _updateValid: Ks,
      _removeUnmounted: _l,
      _updateFieldArray: Xs,
      _getFieldArray: Rl,
      _reset: vl,
      _resetDefaultValues: () => isFunction(qi.defaultValues) && qi.defaultValues().then((dl) => {
        gl(dl, qi.resetOptions), Eo.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (dl) => {
        Xi = {
          ...Xi,
          ...dl
        };
      },
      _subjects: Eo,
      _proxyFormState: to,
      get _fields() {
        return Qi;
      },
      get _formValues() {
        return ra;
      },
      get _state() {
        return na;
      },
      set _state(dl) {
        na = dl;
      },
      get _defaultValues() {
        return ta;
      },
      get _names() {
        return la;
      },
      set _names(dl) {
        la = dl;
      },
      get _formState() {
        return Xi;
      },
      set _formState(dl) {
        Xi = dl;
      },
      get _options() {
        return qi;
      },
      set _options(dl) {
        qi = {
          ...qi,
          ...dl
        };
      }
    },
    trigger: Bl,
    register: jl,
    handleSubmit: _s,
    watch: Tl,
    setValue: kl,
    getValues: Zl,
    reset: gl,
    resetField: Gs,
    clearErrors: yl,
    unregister: Il,
    setError: hl,
    setFocus: (dl, Sl = {}) => {
      const Ml = get(Qi, dl), Fl = Ml && Ml._f;
      if (Fl) {
        const Ll = Fl.refs ? Fl.refs[0] : Fl.ref;
        Ll.focus && (Ll.focus(), Sl.shouldSelect && Ll.select());
      }
    },
    getFieldState: Pl
  };
}
function useForm(Bi = {}) {
  const e = a__default.useRef(), qi = a__default.useRef(), [Xi, Qi] = a__default.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: isFunction(Bi.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: isFunction(Bi.defaultValues) ? void 0 : Bi.defaultValues
  });
  e.current || (e.current = {
    ...createFormControl(Bi, () => Qi((ra) => ({ ...ra }))),
    formState: Xi
  });
  const ta = e.current.control;
  return ta._options = Bi, useSubscribe({
    subject: ta._subjects.state,
    next: (ra) => {
      shouldRenderFormState(ra, ta._proxyFormState, ta._updateFormState) && Qi({ ...ta._formState });
    }
  }), a__default.useEffect(() => {
    Bi.values && !deepEqual(Bi.values, qi.current) ? (ta._reset(Bi.values, ta._options.resetOptions), qi.current = Bi.values) : ta._resetDefaultValues();
  }, [Bi.values, ta]), a__default.useEffect(() => {
    ta._state.mount || (ta._updateValid(), ta._state.mount = !0), ta._state.watch && (ta._state.watch = !1, ta._subjects.state.next({ ...ta._formState })), ta._removeUnmounted();
  }), e.current.formState = getProxyFormState(Xi, ta), e.current;
}
const Input = forwardRef(
  ({ className: Bi, ...e }, qi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "input",
    {
      ref: qi,
      ...e,
      className: twMerge(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        Bi
      )
    }
  )
), vi$1 = (Bi, e) => {
  const qi = (Xi) => {
    Bi.current && !Bi.current.contains(Xi.target) && e();
  };
  useEffect(() => (document.addEventListener("click", qi), () => {
    document.removeEventListener("click", qi);
  }));
};
function li$1(Bi, e, qi = 250) {
  const [Xi, Qi] = useState(0);
  return useEffect(() => {
    const ta = setTimeout(() => {
      Qi(0);
    }, qi);
    return Xi === 2 && e(), () => clearTimeout(ta);
  }, [Xi]), () => Qi((ta) => ta + 1);
}
var Bt$1 = "delete", m$4 = 5, B$1 = 1 << m$4, b$1 = B$1 - 1, y$2 = {};
function pr$1() {
  return { value: !1 };
}
function U(Bi) {
  Bi && (Bi.value = !0);
}
function Er$1() {
}
function ct$1(Bi) {
  return Bi.size === void 0 && (Bi.size = Bi.__iterate(Ee$1)), Bi.size;
}
function rt$1(Bi, e) {
  if (typeof e != "number") {
    var qi = e >>> 0;
    if ("" + qi !== e || qi === 4294967295)
      return NaN;
    e = qi;
  }
  return e < 0 ? ct$1(Bi) + e : e;
}
function Ee$1() {
  return !0;
}
function tr$1(Bi, e, qi) {
  return (Bi === 0 && !ze$1(Bi) || qi !== void 0 && Bi <= -qi) && (e === void 0 || qi !== void 0 && e >= qi);
}
function Ut$1(Bi, e) {
  return Oe$1(Bi, e, 0);
}
function rr(Bi, e) {
  return Oe$1(Bi, e, e);
}
function Oe$1(Bi, e, qi) {
  return Bi === void 0 ? qi : ze$1(Bi) ? e === 1 / 0 ? e : Math.max(0, e + Bi) | 0 : e === void 0 || e === Bi ? Bi : Math.min(e, Bi) | 0;
}
function ze$1(Bi) {
  return Bi < 0 || Bi === 0 && 1 / Bi === -1 / 0;
}
var Ie$1 = "@@__IMMUTABLE_ITERABLE__@@";
function L$1(Bi) {
  return !!(Bi && Bi[Ie$1]);
}
var Me$1 = "@@__IMMUTABLE_KEYED__@@";
function O$1(Bi) {
  return !!(Bi && Bi[Me$1]);
}
var qe$1 = "@@__IMMUTABLE_INDEXED__@@";
function T$1(Bi) {
  return !!(Bi && Bi[qe$1]);
}
function er$1(Bi) {
  return O$1(Bi) || T$1(Bi);
}
var z$1 = function(Bi) {
  return L$1(Bi) ? Bi : N$1(Bi);
}, K = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return O$1(qi) ? qi : it$1(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z$1), at = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return T$1(qi) ? qi : H$2(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z$1), gt$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return L$1(qi) && !er$1(qi) ? qi : Et$1(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e;
}(z$1);
z$1.Keyed = K;
z$1.Indexed = at;
z$1.Set = gt$1;
var Ae$1 = "@@__IMMUTABLE_SEQ__@@";
function Or$1(Bi) {
  return !!(Bi && Bi[Ae$1]);
}
var be$1 = "@@__IMMUTABLE_RECORD__@@";
function St$1(Bi) {
  return !!(Bi && Bi[be$1]);
}
function Z(Bi) {
  return L$1(Bi) || St$1(Bi);
}
var mt$1 = "@@__IMMUTABLE_ORDERED__@@";
function W$1(Bi) {
  return !!(Bi && Bi[mt$1]);
}
var Pt$1 = 0, Y$1 = 1, C = 2, vr$1 = typeof Symbol == "function" && Symbol.iterator, Re$1 = "@@iterator", nr$1 = vr$1 || Re$1, l$5 = function(Bi) {
  this.next = Bi;
};
l$5.prototype.toString = function() {
  return "[Iterator]";
};
l$5.KEYS = Pt$1;
l$5.VALUES = Y$1;
l$5.ENTRIES = C;
l$5.prototype.inspect = l$5.prototype.toSource = function() {
  return this.toString();
};
l$5.prototype[nr$1] = function() {
  return this;
};
function E$1(Bi, e, qi, Xi) {
  var Qi = Bi === 0 ? e : Bi === 1 ? qi : [e, qi];
  return Xi ? Xi.value = Qi : Xi = {
    value: Qi,
    done: !1
  }, Xi;
}
function j$1() {
  return { value: void 0, done: !0 };
}
function Te$1(Bi) {
  return Array.isArray(Bi) ? !0 : !!ir$1(Bi);
}
function Gr$1(Bi) {
  return Bi && typeof Bi.next == "function";
}
function dr$1(Bi) {
  var e = ir$1(Bi);
  return e && e.call(Bi);
}
function ir$1(Bi) {
  var e = Bi && (vr$1 && Bi[vr$1] || Bi[Re$1]);
  if (typeof e == "function")
    return e;
}
function gn$1(Bi) {
  var e = ir$1(Bi);
  return e && e === Bi.entries;
}
function Sn(Bi) {
  var e = ir$1(Bi);
  return e && e === Bi.keys;
}
var wt$1 = Object.prototype.hasOwnProperty;
function Le$1(Bi) {
  return Array.isArray(Bi) || typeof Bi == "string" ? !0 : Bi && typeof Bi == "object" && Number.isInteger(Bi.length) && Bi.length >= 0 && (Bi.length === 0 ? Object.keys(Bi).length === 1 : Bi.hasOwnProperty(Bi.length - 1));
}
var N$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? Ir() : Z(qi) ? qi.toSeq() : wn$1(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this._cache;
    if (Qi) {
      for (var ta = Qi.length, ra = 0; ra !== ta; ) {
        var na = Qi[Xi ? ta - ++ra : ra++];
        if (qi(na[1], na[0], this) === !1)
          break;
      }
      return ra;
    }
    return this.__iterateUncached(qi, Xi);
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this._cache;
    if (Qi) {
      var ta = Qi.length, ra = 0;
      return new l$5(function() {
        if (ra === ta)
          return j$1();
        var na = Qi[Xi ? ta - ++ra : ra++];
        return E$1(qi, na[0], na[1]);
      });
    }
    return this.__iteratorUncached(qi, Xi);
  }, e;
}(z$1), it$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? Ir().toKeyedSeq() : L$1(qi) ? O$1(qi) ? qi.toSeq() : qi.fromEntrySeq() : St$1(qi) ? qi.toSeq() : Mr$1(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(N$1), H$2 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? Ir() : L$1(qi) ? O$1(qi) ? qi.entrySeq() : qi.toIndexedSeq() : St$1(qi) ? qi.toSeq().entrySeq() : je$1(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(N$1), Et$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return (L$1(qi) && !er$1(qi) ? qi : H$2(qi)).toSetSeq();
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(N$1);
N$1.isSeq = Or$1;
N$1.Keyed = it$1;
N$1.Set = Et$1;
N$1.Indexed = H$2;
N$1.prototype[Ae$1] = !0;
var st$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    this._array = qi, this.size = qi.length;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(qi, Xi) {
    return this.has(qi) ? this._array[rt$1(this, qi)] : Xi;
  }, e.prototype.__iterate = function(qi, Xi) {
    for (var Qi = this._array, ta = Qi.length, ra = 0; ra !== ta; ) {
      var na = Xi ? ta - ++ra : ra++;
      if (qi(Qi[na], na, this) === !1)
        break;
    }
    return ra;
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this._array, ta = Qi.length, ra = 0;
    return new l$5(function() {
      if (ra === ta)
        return j$1();
      var na = Xi ? ta - ++ra : ra++;
      return E$1(qi, na, Qi[na]);
    });
  }, e;
}(H$2), zr$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    var Xi = Object.keys(qi).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(qi) : []
    );
    this._object = qi, this._keys = Xi, this.size = Xi.length;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(qi, Xi) {
    return Xi !== void 0 && !this.has(qi) ? Xi : this._object[qi];
  }, e.prototype.has = function(qi) {
    return wt$1.call(this._object, qi);
  }, e.prototype.__iterate = function(qi, Xi) {
    for (var Qi = this._object, ta = this._keys, ra = ta.length, na = 0; na !== ra; ) {
      var la = ta[Xi ? ra - ++na : na++];
      if (qi(Qi[la], la, this) === !1)
        break;
    }
    return na;
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this._object, ta = this._keys, ra = ta.length, na = 0;
    return new l$5(function() {
      if (na === ra)
        return j$1();
      var la = ta[Xi ? ra - ++na : na++];
      return E$1(qi, la, Qi[la]);
    });
  }, e;
}(it$1);
zr$1.prototype[mt$1] = !0;
var mn$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    this._collection = qi, this.size = qi.length || qi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(qi, Xi) {
    if (Xi)
      return this.cacheResult().__iterate(qi, Xi);
    var Qi = this._collection, ta = dr$1(Qi), ra = 0;
    if (Gr$1(ta))
      for (var na; !(na = ta.next()).done && qi(na.value, ra++, this) !== !1; )
        ;
    return ra;
  }, e.prototype.__iteratorUncached = function(qi, Xi) {
    if (Xi)
      return this.cacheResult().__iterator(qi, Xi);
    var Qi = this._collection, ta = dr$1(Qi);
    if (!Gr$1(ta))
      return new l$5(j$1);
    var ra = 0;
    return new l$5(function() {
      var na = ta.next();
      return na.done ? na : E$1(qi, ra++, na.value);
    });
  }, e;
}(H$2), Qr$1;
function Ir() {
  return Qr$1 || (Qr$1 = new st$1([]));
}
function Mr$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return e.fromEntrySeq();
  if (typeof Bi == "object")
    return new zr$1(Bi);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + Bi
  );
}
function je$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + Bi
  );
}
function wn$1(Bi) {
  var e = qr$1(Bi);
  if (e)
    return gn$1(Bi) ? e.fromEntrySeq() : Sn(Bi) ? e.toSetSeq() : e;
  if (typeof Bi == "object")
    return new zr$1(Bi);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + Bi
  );
}
function qr$1(Bi) {
  return Le$1(Bi) ? new st$1(Bi) : Te$1(Bi) ? new mn$1(Bi) : void 0;
}
var ke = "@@__IMMUTABLE_MAP__@@";
function Ar$1(Bi) {
  return !!(Bi && Bi[ke]);
}
function $e(Bi) {
  return Ar$1(Bi) && W$1(Bi);
}
function Vr(Bi) {
  return !!(Bi && typeof Bi.equals == "function" && typeof Bi.hashCode == "function");
}
function D(Bi, e) {
  if (Bi === e || Bi !== Bi && e !== e)
    return !0;
  if (!Bi || !e)
    return !1;
  if (typeof Bi.valueOf == "function" && typeof e.valueOf == "function") {
    if (Bi = Bi.valueOf(), e = e.valueOf(), Bi === e || Bi !== Bi && e !== e)
      return !0;
    if (!Bi || !e)
      return !1;
  }
  return !!(Vr(Bi) && Vr(e) && Bi.equals(e));
}
var Mt$1 = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(Bi, e) {
  Bi |= 0, e |= 0;
  var qi = Bi & 65535, Xi = e & 65535;
  return qi * Xi + ((Bi >>> 16) * Xi + qi * (e >>> 16) << 16 >>> 0) | 0;
};
function ur$1(Bi) {
  return Bi >>> 1 & 1073741824 | Bi & 3221225471;
}
var En$1 = Object.prototype.valueOf;
function $(Bi) {
  if (Bi == null)
    return xr(Bi);
  if (typeof Bi.hashCode == "function")
    return ur$1(Bi.hashCode(Bi));
  var e = An$1(Bi);
  if (e == null)
    return xr(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return On$1(e);
    case "string":
      return e.length > bn$1 ? zn$1(e) : yr$1(e);
    case "object":
    case "function":
      return Mn$1(e);
    case "symbol":
      return In$1(e);
    default:
      if (typeof e.toString == "function")
        return yr$1(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function xr(Bi) {
  return Bi === null ? 1108378658 : 1108378659;
}
function On$1(Bi) {
  if (Bi !== Bi || Bi === 1 / 0)
    return 0;
  var e = Bi | 0;
  for (e !== Bi && (e ^= Bi * 4294967295); Bi > 4294967295; )
    Bi /= 4294967295, e ^= Bi;
  return ur$1(e);
}
function zn$1(Bi) {
  var e = hr$1[Bi];
  return e === void 0 && (e = yr$1(Bi), fr$1 === Rn$1 && (fr$1 = 0, hr$1 = {}), fr$1++, hr$1[Bi] = e), e;
}
function yr$1(Bi) {
  for (var e = 0, qi = 0; qi < Bi.length; qi++)
    e = 31 * e + Bi.charCodeAt(qi) | 0;
  return ur$1(e);
}
function In$1(Bi) {
  var e = ee$1[Bi];
  return e !== void 0 || (e = De(), ee$1[Bi] = e), e;
}
function Mn$1(Bi) {
  var e;
  if (lr$1 && (e = gr$1.get(Bi), e !== void 0) || (e = Bi[ot$1], e !== void 0) || !re$1 && (e = Bi.propertyIsEnumerable && Bi.propertyIsEnumerable[ot$1], e !== void 0 || (e = qn$1(Bi), e !== void 0)))
    return e;
  if (e = De(), lr$1)
    gr$1.set(Bi, e);
  else {
    if (te$1 !== void 0 && te$1(Bi) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (re$1)
      Object.defineProperty(Bi, ot$1, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (Bi.propertyIsEnumerable !== void 0 && Bi.propertyIsEnumerable === Bi.constructor.prototype.propertyIsEnumerable)
      Bi.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, Bi.propertyIsEnumerable[ot$1] = e;
    else if (Bi.nodeType !== void 0)
      Bi[ot$1] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var te$1 = Object.isExtensible, re$1 = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function qn$1(Bi) {
  if (Bi && Bi.nodeType > 0)
    switch (Bi.nodeType) {
      case 1:
        return Bi.uniqueID;
      case 9:
        return Bi.documentElement && Bi.documentElement.uniqueID;
    }
}
function An$1(Bi) {
  return Bi.valueOf !== En$1 && typeof Bi.valueOf == "function" ? Bi.valueOf(Bi) : Bi;
}
function De() {
  var Bi = ++ar$1;
  return ar$1 & 1073741824 && (ar$1 = 0), Bi;
}
var lr$1 = typeof WeakMap == "function", gr$1;
lr$1 && (gr$1 = /* @__PURE__ */ new WeakMap());
var ee$1 = /* @__PURE__ */ Object.create(null), ar$1 = 0, ot$1 = "__immutablehash__";
typeof Symbol == "function" && (ot$1 = Symbol(ot$1));
var bn$1 = 16, Rn$1 = 255, fr$1 = 0, hr$1 = {}, or$1 = /* @__PURE__ */ function(Bi) {
  function e(qi, Xi) {
    this._iter = qi, this._useKeys = Xi, this.size = qi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.get = function(qi, Xi) {
    return this._iter.get(qi, Xi);
  }, e.prototype.has = function(qi) {
    return this._iter.has(qi);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var qi = this, Xi = br$1(this, !0);
    return this._useKeys || (Xi.valueSeq = function() {
      return qi._iter.toSeq().reverse();
    }), Xi;
  }, e.prototype.map = function(qi, Xi) {
    var Qi = this, ta = Ce$1(this, qi, Xi);
    return this._useKeys || (ta.valueSeq = function() {
      return Qi._iter.toSeq().map(qi, Xi);
    }), ta;
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this;
    return this._iter.__iterate(function(ta, ra) {
      return qi(ta, ra, Qi);
    }, Xi);
  }, e.prototype.__iterator = function(qi, Xi) {
    return this._iter.__iterator(qi, Xi);
  }, e;
}(it$1);
or$1.prototype[mt$1] = !0;
var Ne = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    this._iter = qi, this.size = qi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.includes = function(qi) {
    return this._iter.includes(qi);
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this, ta = 0;
    return Xi && ct$1(this), this._iter.__iterate(
      function(ra) {
        return qi(ra, Xi ? Qi.size - ++ta : ta++, Qi);
      },
      Xi
    );
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this, ta = this._iter.__iterator(Y$1, Xi), ra = 0;
    return Xi && ct$1(this), new l$5(function() {
      var na = ta.next();
      return na.done ? na : E$1(
        qi,
        Xi ? Qi.size - ++ra : ra++,
        na.value,
        na
      );
    });
  }, e;
}(H$2), Be$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    this._iter = qi, this.size = qi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.has = function(qi) {
    return this._iter.includes(qi);
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this;
    return this._iter.__iterate(function(ta) {
      return qi(ta, ta, Qi);
    }, Xi);
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this._iter.__iterator(Y$1, Xi);
    return new l$5(function() {
      var ta = Qi.next();
      return ta.done ? ta : E$1(qi, ta.value, ta.value, ta);
    });
  }, e;
}(Et$1), Ue$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    this._iter = qi, this.size = qi.size;
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this;
    return this._iter.__iterate(function(ta) {
      if (ta) {
        ie(ta);
        var ra = L$1(ta);
        return qi(
          ra ? ta.get(1) : ta[1],
          ra ? ta.get(0) : ta[0],
          Qi
        );
      }
    }, Xi);
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this._iter.__iterator(Y$1, Xi);
    return new l$5(function() {
      for (; ; ) {
        var ta = Qi.next();
        if (ta.done)
          return ta;
        var ra = ta.value;
        if (ra) {
          ie(ra);
          var na = L$1(ra);
          return E$1(
            qi,
            na ? ra.get(0) : ra[0],
            na ? ra.get(1) : ra[1],
            ta
          );
        }
      }
    });
  }, e;
}(it$1);
Ne.prototype.cacheResult = or$1.prototype.cacheResult = Be$1.prototype.cacheResult = Ue$1.prototype.cacheResult = Tr$1;
function Pe$1(Bi) {
  var e = G$1(Bi);
  return e._iter = Bi, e.size = Bi.size, e.flip = function() {
    return Bi;
  }, e.reverse = function() {
    var qi = Bi.reverse.apply(this);
    return qi.flip = function() {
      return Bi.reverse();
    }, qi;
  }, e.has = function(qi) {
    return Bi.includes(qi);
  }, e.includes = function(qi) {
    return Bi.has(qi);
  }, e.cacheResult = Tr$1, e.__iterateUncached = function(qi, Xi) {
    var Qi = this;
    return Bi.__iterate(function(ta, ra) {
      return qi(ra, ta, Qi) !== !1;
    }, Xi);
  }, e.__iteratorUncached = function(qi, Xi) {
    if (qi === C) {
      var Qi = Bi.__iterator(qi, Xi);
      return new l$5(function() {
        var ta = Qi.next();
        if (!ta.done) {
          var ra = ta.value[0];
          ta.value[0] = ta.value[1], ta.value[1] = ra;
        }
        return ta;
      });
    }
    return Bi.__iterator(
      qi === Y$1 ? Pt$1 : Y$1,
      Xi
    );
  }, e;
}
function Ce$1(Bi, e, qi) {
  var Xi = G$1(Bi);
  return Xi.size = Bi.size, Xi.has = function(Qi) {
    return Bi.has(Qi);
  }, Xi.get = function(Qi, ta) {
    var ra = Bi.get(Qi, y$2);
    return ra === y$2 ? ta : e.call(qi, ra, Qi, Bi);
  }, Xi.__iterateUncached = function(Qi, ta) {
    var ra = this;
    return Bi.__iterate(
      function(na, la, Ma) {
        return Qi(e.call(qi, na, la, Ma), la, ra) !== !1;
      },
      ta
    );
  }, Xi.__iteratorUncached = function(Qi, ta) {
    var ra = Bi.__iterator(C, ta);
    return new l$5(function() {
      var na = ra.next();
      if (na.done)
        return na;
      var la = na.value, Ma = la[0];
      return E$1(
        Qi,
        Ma,
        e.call(qi, la[1], Ma, Bi),
        na
      );
    });
  }, Xi;
}
function br$1(Bi, e) {
  var qi = this, Xi = G$1(Bi);
  return Xi._iter = Bi, Xi.size = Bi.size, Xi.reverse = function() {
    return Bi;
  }, Bi.flip && (Xi.flip = function() {
    var Qi = Pe$1(Bi);
    return Qi.reverse = function() {
      return Bi.flip();
    }, Qi;
  }), Xi.get = function(Qi, ta) {
    return Bi.get(e ? Qi : -1 - Qi, ta);
  }, Xi.has = function(Qi) {
    return Bi.has(e ? Qi : -1 - Qi);
  }, Xi.includes = function(Qi) {
    return Bi.includes(Qi);
  }, Xi.cacheResult = Tr$1, Xi.__iterate = function(Qi, ta) {
    var ra = this, na = 0;
    return ta && ct$1(Bi), Bi.__iterate(
      function(la, Ma) {
        return Qi(la, e ? Ma : ta ? ra.size - ++na : na++, ra);
      },
      !ta
    );
  }, Xi.__iterator = function(Qi, ta) {
    var ra = 0;
    ta && ct$1(Bi);
    var na = Bi.__iterator(C, !ta);
    return new l$5(function() {
      var la = na.next();
      if (la.done)
        return la;
      var Ma = la.value;
      return E$1(
        Qi,
        e ? Ma[0] : ta ? qi.size - ++ra : ra++,
        Ma[1],
        la
      );
    });
  }, Xi;
}
function Ke$1(Bi, e, qi, Xi) {
  var Qi = G$1(Bi);
  return Xi && (Qi.has = function(ta) {
    var ra = Bi.get(ta, y$2);
    return ra !== y$2 && !!e.call(qi, ra, ta, Bi);
  }, Qi.get = function(ta, ra) {
    var na = Bi.get(ta, y$2);
    return na !== y$2 && e.call(qi, na, ta, Bi) ? na : ra;
  }), Qi.__iterateUncached = function(ta, ra) {
    var na = this, la = 0;
    return Bi.__iterate(function(Ma, Va, to) {
      if (e.call(qi, Ma, Va, to))
        return la++, ta(Ma, Xi ? Va : la - 1, na);
    }, ra), la;
  }, Qi.__iteratorUncached = function(ta, ra) {
    var na = Bi.__iterator(C, ra), la = 0;
    return new l$5(function() {
      for (; ; ) {
        var Ma = na.next();
        if (Ma.done)
          return Ma;
        var Va = Ma.value, to = Va[0], Eo = Va[1];
        if (e.call(qi, Eo, to, Bi))
          return E$1(ta, Xi ? to : la++, Eo, Ma);
      }
    });
  }, Qi;
}
function Tn$1(Bi, e, qi) {
  var Xi = zt$1().asMutable();
  return Bi.__iterate(function(Qi, ta) {
    Xi.update(e.call(qi, Qi, ta, Bi), 0, function(ra) {
      return ra + 1;
    });
  }), Xi.asImmutable();
}
function Ln$1(Bi, e, qi) {
  var Xi = O$1(Bi), Qi = (W$1(Bi) ? V() : zt$1()).asMutable();
  Bi.__iterate(function(ra, na) {
    Qi.update(
      e.call(qi, ra, na, Bi),
      function(la) {
        return la = la || [], la.push(Xi ? [na, ra] : ra), la;
      }
    );
  });
  var ta = Ye$1(Bi);
  return Qi.map(function(ra) {
    return g$2(Bi, ta(ra));
  }).asImmutable();
}
function Rr$1(Bi, e, qi, Xi) {
  var Qi = Bi.size;
  if (tr$1(e, qi, Qi))
    return Bi;
  var ta = Ut$1(e, Qi), ra = rr(qi, Qi);
  if (ta !== ta || ra !== ra)
    return Rr$1(Bi.toSeq().cacheResult(), e, qi, Xi);
  var na = ra - ta, la;
  na === na && (la = na < 0 ? 0 : na);
  var Ma = G$1(Bi);
  return Ma.size = la === 0 ? la : Bi.size && la || void 0, !Xi && Or$1(Bi) && la >= 0 && (Ma.get = function(Va, to) {
    return Va = rt$1(this, Va), Va >= 0 && Va < la ? Bi.get(Va + ta, to) : to;
  }), Ma.__iterateUncached = function(Va, to) {
    var Eo = this;
    if (la === 0)
      return 0;
    if (to)
      return this.cacheResult().__iterate(Va, to);
    var So = 0, eo = !0, rs = 0;
    return Bi.__iterate(function(ko, Hs) {
      if (!(eo && (eo = So++ < ta)))
        return rs++, Va(ko, Xi ? Hs : rs - 1, Eo) !== !1 && rs !== la;
    }), rs;
  }, Ma.__iteratorUncached = function(Va, to) {
    if (la !== 0 && to)
      return this.cacheResult().__iterator(Va, to);
    if (la === 0)
      return new l$5(j$1);
    var Eo = Bi.__iterator(Va, to), So = 0, eo = 0;
    return new l$5(function() {
      for (; So++ < ta; )
        Eo.next();
      if (++eo > la)
        return j$1();
      var rs = Eo.next();
      return Xi || Va === Y$1 || rs.done ? rs : Va === Pt$1 ? E$1(Va, eo - 1, void 0, rs) : E$1(Va, eo - 1, rs.value[1], rs);
    });
  }, Ma;
}
function jn$1(Bi, e, qi) {
  var Xi = G$1(Bi);
  return Xi.__iterateUncached = function(Qi, ta) {
    var ra = this;
    if (ta)
      return this.cacheResult().__iterate(Qi, ta);
    var na = 0;
    return Bi.__iterate(
      function(la, Ma, Va) {
        return e.call(qi, la, Ma, Va) && ++na && Qi(la, Ma, ra);
      }
    ), na;
  }, Xi.__iteratorUncached = function(Qi, ta) {
    var ra = this;
    if (ta)
      return this.cacheResult().__iterator(Qi, ta);
    var na = Bi.__iterator(C, ta), la = !0;
    return new l$5(function() {
      if (!la)
        return j$1();
      var Ma = na.next();
      if (Ma.done)
        return Ma;
      var Va = Ma.value, to = Va[0], Eo = Va[1];
      return e.call(qi, Eo, to, ra) ? Qi === C ? Ma : E$1(Qi, to, Eo, Ma) : (la = !1, j$1());
    });
  }, Xi;
}
function Fe$1(Bi, e, qi, Xi) {
  var Qi = G$1(Bi);
  return Qi.__iterateUncached = function(ta, ra) {
    var na = this;
    if (ra)
      return this.cacheResult().__iterate(ta, ra);
    var la = !0, Ma = 0;
    return Bi.__iterate(function(Va, to, Eo) {
      if (!(la && (la = e.call(qi, Va, to, Eo))))
        return Ma++, ta(Va, Xi ? to : Ma - 1, na);
    }), Ma;
  }, Qi.__iteratorUncached = function(ta, ra) {
    var na = this;
    if (ra)
      return this.cacheResult().__iterator(ta, ra);
    var la = Bi.__iterator(C, ra), Ma = !0, Va = 0;
    return new l$5(function() {
      var to, Eo, So;
      do {
        if (to = la.next(), to.done)
          return Xi || ta === Y$1 ? to : ta === Pt$1 ? E$1(ta, Va++, void 0, to) : E$1(ta, Va++, to.value[1], to);
        var eo = to.value;
        Eo = eo[0], So = eo[1], Ma && (Ma = e.call(qi, So, Eo, na));
      } while (Ma);
      return ta === C ? to : E$1(ta, Eo, So, to);
    });
  }, Qi;
}
function kn$1(Bi, e) {
  var qi = O$1(Bi), Xi = [Bi].concat(e).map(function(ra) {
    return L$1(ra) ? qi && (ra = K(ra)) : ra = qi ? Mr$1(ra) : je$1(Array.isArray(ra) ? ra : [ra]), ra;
  }).filter(function(ra) {
    return ra.size !== 0;
  });
  if (Xi.length === 0)
    return Bi;
  if (Xi.length === 1) {
    var Qi = Xi[0];
    if (Qi === Bi || qi && O$1(Qi) || T$1(Bi) && T$1(Qi))
      return Qi;
  }
  var ta = new st$1(Xi);
  return qi ? ta = ta.toKeyedSeq() : T$1(Bi) || (ta = ta.toSetSeq()), ta = ta.flatten(!0), ta.size = Xi.reduce(function(ra, na) {
    if (ra !== void 0) {
      var la = na.size;
      if (la !== void 0)
        return ra + la;
    }
  }, 0), ta;
}
function We$1(Bi, e, qi) {
  var Xi = G$1(Bi);
  return Xi.__iterateUncached = function(Qi, ta) {
    if (ta)
      return this.cacheResult().__iterate(Qi, ta);
    var ra = 0, na = !1;
    function la(Ma, Va) {
      Ma.__iterate(function(to, Eo) {
        return (!e || Va < e) && L$1(to) ? la(to, Va + 1) : (ra++, Qi(to, qi ? Eo : ra - 1, Xi) === !1 && (na = !0)), !na;
      }, ta);
    }
    return la(Bi, 0), ra;
  }, Xi.__iteratorUncached = function(Qi, ta) {
    if (ta)
      return this.cacheResult().__iterator(Qi, ta);
    var ra = Bi.__iterator(Qi, ta), na = [], la = 0;
    return new l$5(function() {
      for (; ra; ) {
        var Ma = ra.next();
        if (Ma.done !== !1) {
          ra = na.pop();
          continue;
        }
        var Va = Ma.value;
        if (Qi === C && (Va = Va[1]), (!e || na.length < e) && L$1(Va))
          na.push(ra), ra = Va.__iterator(Qi, ta);
        else
          return qi ? Ma : E$1(Qi, la++, Va, Ma);
      }
      return j$1();
    });
  }, Xi;
}
function $n$1(Bi, e, qi) {
  var Xi = Ye$1(Bi);
  return Bi.toSeq().map(function(Qi, ta) {
    return Xi(e.call(qi, Qi, ta, Bi));
  }).flatten(!0);
}
function Dn$1(Bi, e) {
  var qi = G$1(Bi);
  return qi.size = Bi.size && Bi.size * 2 - 1, qi.__iterateUncached = function(Xi, Qi) {
    var ta = this, ra = 0;
    return Bi.__iterate(
      function(na) {
        return (!ra || Xi(e, ra++, ta) !== !1) && Xi(na, ra++, ta) !== !1;
      },
      Qi
    ), ra;
  }, qi.__iteratorUncached = function(Xi, Qi) {
    var ta = Bi.__iterator(Y$1, Qi), ra = 0, na;
    return new l$5(function() {
      return (!na || ra % 2) && (na = ta.next(), na.done) ? na : ra % 2 ? E$1(Xi, ra++, e) : E$1(Xi, ra++, na.value, na);
    });
  }, qi;
}
function _t$1(Bi, e, qi) {
  e || (e = He$1);
  var Xi = O$1(Bi), Qi = 0, ta = Bi.toSeq().map(function(ra, na) {
    return [na, ra, Qi++, qi ? qi(ra, na, Bi) : ra];
  }).valueSeq().toArray();
  return ta.sort(function(ra, na) {
    return e(ra[3], na[3]) || ra[2] - na[2];
  }).forEach(
    Xi ? function(ra, na) {
      ta[na].length = 2;
    } : function(ra, na) {
      ta[na] = ra[1];
    }
  ), Xi ? it$1(ta) : T$1(Bi) ? H$2(ta) : Et$1(ta);
}
function Ht$1(Bi, e, qi) {
  if (e || (e = He$1), qi) {
    var Xi = Bi.toSeq().map(function(Qi, ta) {
      return [Qi, qi(Qi, ta, Bi)];
    }).reduce(function(Qi, ta) {
      return ne(e, Qi[1], ta[1]) ? ta : Qi;
    });
    return Xi && Xi[0];
  }
  return Bi.reduce(function(Qi, ta) {
    return ne(e, Qi, ta) ? ta : Qi;
  });
}
function ne(Bi, e, qi) {
  var Xi = Bi(qi, e);
  return Xi === 0 && qi !== e && (qi == null || qi !== qi) || Xi > 0;
}
function Jt(Bi, e, qi, Xi) {
  var Qi = G$1(Bi), ta = new st$1(qi).map(function(ra) {
    return ra.size;
  });
  return Qi.size = Xi ? ta.max() : ta.min(), Qi.__iterate = function(ra, na) {
    for (var la = this.__iterator(Y$1, na), Ma, Va = 0; !(Ma = la.next()).done && ra(Ma.value, Va++, this) !== !1; )
      ;
    return Va;
  }, Qi.__iteratorUncached = function(ra, na) {
    var la = qi.map(
      function(to) {
        return to = z$1(to), dr$1(na ? to.reverse() : to);
      }
    ), Ma = 0, Va = !1;
    return new l$5(function() {
      var to;
      return Va || (to = la.map(function(Eo) {
        return Eo.next();
      }), Va = Xi ? to.every(function(Eo) {
        return Eo.done;
      }) : to.some(function(Eo) {
        return Eo.done;
      })), Va ? j$1() : E$1(
        ra,
        Ma++,
        e.apply(
          null,
          to.map(function(Eo) {
            return Eo.value;
          })
        )
      );
    });
  }, Qi;
}
function g$2(Bi, e) {
  return Bi === e ? Bi : Or$1(Bi) ? e : Bi.constructor(e);
}
function ie(Bi) {
  if (Bi !== Object(Bi))
    throw new TypeError("Expected [K, V] tuple: " + Bi);
}
function Ye$1(Bi) {
  return O$1(Bi) ? K : T$1(Bi) ? at : gt$1;
}
function G$1(Bi) {
  return Object.create(
    (O$1(Bi) ? it$1 : T$1(Bi) ? H$2 : Et$1).prototype
  );
}
function Tr$1() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : N$1.prototype.cacheResult.call(this);
}
function He$1(Bi, e) {
  return Bi === void 0 && e === void 0 ? 0 : Bi === void 0 ? 1 : e === void 0 ? -1 : Bi > e ? 1 : Bi < e ? -1 : 0;
}
function X$1(Bi, e) {
  e = e || 0;
  for (var qi = Math.max(0, Bi.length - e), Xi = new Array(qi), Qi = 0; Qi < qi; Qi++)
    Xi[Qi] = Bi[Qi + e];
  return Xi;
}
function Lr(Bi, e) {
  if (!Bi)
    throw new Error(e);
}
function P$1(Bi) {
  Lr(
    Bi !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function Je$1(Bi) {
  if (Le$1(Bi) && typeof Bi != "string")
    return Bi;
  if (W$1(Bi))
    return Bi.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + Bi
  );
}
var Nn$1 = Object.prototype.toString;
function Bn$1(Bi) {
  if (!Bi || typeof Bi != "object" || Nn$1.call(Bi) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(Bi);
  if (e === null)
    return !0;
  for (var qi = e, Xi = Object.getPrototypeOf(e); Xi !== null; )
    qi = Xi, Xi = Object.getPrototypeOf(qi);
  return qi === e;
}
function et$1(Bi) {
  return typeof Bi == "object" && (Z(Bi) || Array.isArray(Bi) || Bn$1(Bi));
}
function Lt$1(Bi) {
  try {
    return typeof Bi == "string" ? JSON.stringify(Bi) : String(Bi);
  } catch {
    return JSON.stringify(Bi);
  }
}
function Un$1(Bi, e) {
  return Z(Bi) ? Bi.has(e) : et$1(Bi) && wt$1.call(Bi, e);
}
function Xe$1(Bi, e, qi) {
  return Z(Bi) ? Bi.get(e, qi) : Un$1(Bi, e) ? typeof Bi.get == "function" ? Bi.get(e) : Bi[e] : qi;
}
function Vt$1(Bi) {
  if (Array.isArray(Bi))
    return X$1(Bi);
  var e = {};
  for (var qi in Bi)
    wt$1.call(Bi, qi) && (e[qi] = Bi[qi]);
  return e;
}
function Pn$1(Bi, e) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot update non-data-structure value: " + Bi
    );
  if (Z(Bi)) {
    if (!Bi.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + Bi
      );
    return Bi.remove(e);
  }
  if (!wt$1.call(Bi, e))
    return Bi;
  var qi = Vt$1(Bi);
  return Array.isArray(qi) ? qi.splice(e, 1) : delete qi[e], qi;
}
function Cn$1(Bi, e, qi) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot update non-data-structure value: " + Bi
    );
  if (Z(Bi)) {
    if (!Bi.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + Bi
      );
    return Bi.set(e, qi);
  }
  if (wt$1.call(Bi, e) && qi === Bi[e])
    return Bi;
  var Xi = Vt$1(Bi);
  return Xi[e] = qi, Xi;
}
function Ot$1(Bi, e, qi, Xi) {
  Xi || (Xi = qi, qi = void 0);
  var Qi = Ze$1(
    Z(Bi),
    Bi,
    Je$1(e),
    0,
    qi,
    Xi
  );
  return Qi === y$2 ? qi : Qi;
}
function Ze$1(Bi, e, qi, Xi, Qi, ta) {
  var ra = e === y$2;
  if (Xi === qi.length) {
    var na = ra ? Qi : e, la = ta(na);
    return la === na ? e : la;
  }
  if (!ra && !et$1(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + qi.slice(0, Xi).map(Lt$1) + "]: " + e
    );
  var Ma = qi[Xi], Va = ra ? y$2 : Xe$1(e, Ma, y$2), to = Ze$1(
    Va === y$2 ? Bi : Z(Va),
    Va,
    qi,
    Xi + 1,
    Qi,
    ta
  );
  return to === Va ? e : to === y$2 ? Pn$1(e, Ma) : Cn$1(
    ra ? Bi ? F$1() : {} : e,
    Ma,
    to
  );
}
function Kn$1(Bi, e, qi) {
  return Ot$1(Bi, e, y$2, function() {
    return qi;
  });
}
function jr$1(Bi, e) {
  return Kn$1(this, Bi, e);
}
function Fn$1(Bi, e) {
  return Ot$1(Bi, e, function() {
    return y$2;
  });
}
function kr$1(Bi) {
  return Fn$1(this, Bi);
}
function Ge$1(Bi, e, qi, Xi) {
  return Ot$1(Bi, [e], qi, Xi);
}
function $r$1(Bi, e, qi) {
  return arguments.length === 1 ? Bi(this) : Ge$1(this, Bi, e, qi);
}
function Dr(Bi, e, qi) {
  return Ot$1(this, Bi, e, qi);
}
function Qe$1() {
  for (var Bi = [], e = arguments.length; e--; )
    Bi[e] = arguments[e];
  return xe$1(this, Bi);
}
function Ve$1(Bi) {
  for (var e = [], qi = arguments.length - 1; qi-- > 0; )
    e[qi] = arguments[qi + 1];
  if (typeof Bi != "function")
    throw new TypeError("Invalid merger function: " + Bi);
  return xe$1(this, e, Bi);
}
function xe$1(Bi, e, qi) {
  for (var Xi = [], Qi = 0; Qi < e.length; Qi++) {
    var ta = K(e[Qi]);
    ta.size !== 0 && Xi.push(ta);
  }
  return Xi.length === 0 ? Bi : Bi.toSeq().size === 0 && !Bi.__ownerID && Xi.length === 1 ? Bi.constructor(Xi[0]) : Bi.withMutations(function(ra) {
    for (var na = qi ? function(Ma, Va) {
      Ge$1(
        ra,
        Va,
        y$2,
        function(to) {
          return to === y$2 ? Ma : qi(to, Ma, Va);
        }
      );
    } : function(Ma, Va) {
      ra.set(Va, Ma);
    }, la = 0; la < Xi.length; la++)
      Xi[la].forEach(na);
  });
}
function Nr$1(Bi, e, qi) {
  return Br$1(Bi, e, Wn$1(qi));
}
function Br$1(Bi, e, qi) {
  if (!et$1(Bi))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + Bi
    );
  if (Z(Bi))
    return typeof qi == "function" && Bi.mergeWith ? Bi.mergeWith.apply(Bi, [qi].concat(e)) : Bi.merge ? Bi.merge.apply(Bi, e) : Bi.concat.apply(Bi, e);
  for (var Xi = Array.isArray(Bi), Qi = Bi, ta = Xi ? at : K, ra = Xi ? function(la) {
    Qi === Bi && (Qi = Vt$1(Qi)), Qi.push(la);
  } : function(la, Ma) {
    var Va = wt$1.call(Qi, Ma), to = Va && qi ? qi(Qi[Ma], la, Ma) : la;
    (!Va || to !== Qi[Ma]) && (Qi === Bi && (Qi = Vt$1(Qi)), Qi[Ma] = to);
  }, na = 0; na < e.length; na++)
    ta(e[na]).forEach(ra);
  return Qi;
}
function Wn$1(Bi) {
  function e(qi, Xi, Qi) {
    return et$1(qi) && et$1(Xi) && Yn$1(qi, Xi) ? Br$1(qi, [Xi], e) : Bi ? Bi(qi, Xi, Qi) : Xi;
  }
  return e;
}
function Yn$1(Bi, e) {
  var qi = N$1(Bi), Xi = N$1(e);
  return T$1(qi) === T$1(Xi) && O$1(qi) === O$1(Xi);
}
function tn$1() {
  for (var Bi = [], e = arguments.length; e--; )
    Bi[e] = arguments[e];
  return Nr$1(this, Bi);
}
function rn$1(Bi) {
  for (var e = [], qi = arguments.length - 1; qi-- > 0; )
    e[qi] = arguments[qi + 1];
  return Nr$1(this, e, Bi);
}
function Ur$1(Bi) {
  for (var e = [], qi = arguments.length - 1; qi-- > 0; )
    e[qi] = arguments[qi + 1];
  return Ot$1(this, Bi, F$1(), function(Xi) {
    return Br$1(Xi, e);
  });
}
function Pr$1(Bi) {
  for (var e = [], qi = arguments.length - 1; qi-- > 0; )
    e[qi] = arguments[qi + 1];
  return Ot$1(
    this,
    Bi,
    F$1(),
    function(Xi) {
      return Nr$1(Xi, e);
    }
  );
}
function Ct$1(Bi) {
  var e = this.asMutable();
  return Bi(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function Kt() {
  return this.__ownerID ? this : this.__ensureOwner(new Er$1());
}
function Ft$1() {
  return this.__ensureOwner();
}
function Cr$1() {
  return this.__altered;
}
var zt$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? F$1() : Ar$1(qi) && !W$1(qi) ? qi : F$1().withMutations(function(Xi) {
      var Qi = Bi(qi);
      P$1(Qi.size), Qi.forEach(function(ta, ra) {
        return Xi.set(ra, ta);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    for (var qi = [], Xi = arguments.length; Xi--; )
      qi[Xi] = arguments[Xi];
    return F$1().withMutations(function(Qi) {
      for (var ta = 0; ta < qi.length; ta += 2) {
        if (ta + 1 >= qi.length)
          throw new Error("Missing value for key: " + qi[ta]);
        Qi.set(qi[ta], qi[ta + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(qi, Xi) {
    return this._root ? this._root.get(0, void 0, qi, Xi) : Xi;
  }, e.prototype.set = function(qi, Xi) {
    return se$1(this, qi, Xi);
  }, e.prototype.remove = function(qi) {
    return se$1(this, qi, y$2);
  }, e.prototype.deleteAll = function(qi) {
    var Xi = z$1(qi);
    return Xi.size === 0 ? this : this.withMutations(function(Qi) {
      Xi.forEach(function(ta) {
        return Qi.remove(ta);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : F$1();
  }, e.prototype.sort = function(qi) {
    return V(_t$1(this, qi));
  }, e.prototype.sortBy = function(qi, Xi) {
    return V(_t$1(this, Xi, qi));
  }, e.prototype.map = function(qi, Xi) {
    var Qi = this;
    return this.withMutations(function(ta) {
      ta.forEach(function(ra, na) {
        ta.set(na, qi.call(Xi, ra, na, Qi));
      });
    });
  }, e.prototype.__iterator = function(qi, Xi) {
    return new Hn$1(this, qi, Xi);
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this, ta = 0;
    return this._root && this._root.iterate(function(ra) {
      return ta++, qi(ra[1], ra[0], Qi);
    }, Xi), ta;
  }, e.prototype.__ensureOwner = function(qi) {
    return qi === this.__ownerID ? this : qi ? Kr$1(this.size, this._root, qi, this.__hash) : this.size === 0 ? F$1() : (this.__ownerID = qi, this.__altered = !1, this);
  }, e;
}(K);
zt$1.isMap = Ar$1;
var w$2 = zt$1.prototype;
w$2[ke] = !0;
w$2[Bt$1] = w$2.remove;
w$2.removeAll = w$2.deleteAll;
w$2.setIn = jr$1;
w$2.removeIn = w$2.deleteIn = kr$1;
w$2.update = $r$1;
w$2.updateIn = Dr;
w$2.merge = w$2.concat = Qe$1;
w$2.mergeWith = Ve$1;
w$2.mergeDeep = tn$1;
w$2.mergeDeepWith = rn$1;
w$2.mergeIn = Ur$1;
w$2.mergeDeepIn = Pr$1;
w$2.withMutations = Ct$1;
w$2.wasAltered = Cr$1;
w$2.asImmutable = Ft$1;
w$2["@@transducer/init"] = w$2.asMutable = Kt;
w$2["@@transducer/step"] = function(Bi, e) {
  return Bi.set(e[0], e[1]);
};
w$2["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
var jt$1 = function(Bi, e) {
  this.ownerID = Bi, this.entries = e;
};
jt$1.prototype.get = function(Bi, e, qi, Xi) {
  for (var Qi = this.entries, ta = 0, ra = Qi.length; ta < ra; ta++)
    if (D(qi, Qi[ta][0]))
      return Qi[ta][1];
  return Xi;
};
jt$1.prototype.update = function(Bi, e, qi, Xi, Qi, ta, ra) {
  for (var na = Qi === y$2, la = this.entries, Ma = 0, Va = la.length; Ma < Va && !D(Xi, la[Ma][0]); Ma++)
    ;
  var to = Ma < Va;
  if (to ? la[Ma][1] === Qi : na)
    return this;
  if (U(ra), (na || !to) && U(ta), !(na && la.length === 1)) {
    if (!to && !na && la.length >= Vn$1)
      return Jn$1(Bi, la, Xi, Qi);
    var Eo = Bi && Bi === this.ownerID, So = Eo ? la : X$1(la);
    return to ? na ? Ma === Va - 1 ? So.pop() : So[Ma] = So.pop() : So[Ma] = [Xi, Qi] : So.push([Xi, Qi]), Eo ? (this.entries = So, this) : new jt$1(Bi, So);
  }
};
var pt$1 = function(Bi, e, qi) {
  this.ownerID = Bi, this.bitmap = e, this.nodes = qi;
};
pt$1.prototype.get = function(Bi, e, qi, Xi) {
  e === void 0 && (e = $(qi));
  var Qi = 1 << ((Bi === 0 ? e : e >>> Bi) & b$1), ta = this.bitmap;
  return (ta & Qi) === 0 ? Xi : this.nodes[en(ta & Qi - 1)].get(
    Bi + m$4,
    e,
    qi,
    Xi
  );
};
pt$1.prototype.update = function(Bi, e, qi, Xi, Qi, ta, ra) {
  qi === void 0 && (qi = $(Xi));
  var na = (e === 0 ? qi : qi >>> e) & b$1, la = 1 << na, Ma = this.bitmap, Va = (Ma & la) !== 0;
  if (!Va && Qi === y$2)
    return this;
  var to = en(Ma & la - 1), Eo = this.nodes, So = Va ? Eo[to] : void 0, eo = Fr$1(
    So,
    Bi,
    e + m$4,
    qi,
    Xi,
    Qi,
    ta,
    ra
  );
  if (eo === So)
    return this;
  if (!Va && eo && Eo.length >= xn$1)
    return Zn$1(Bi, Eo, Ma, na, eo);
  if (Va && !eo && Eo.length === 2 && ae$1(Eo[to ^ 1]))
    return Eo[to ^ 1];
  if (Va && eo && Eo.length === 1 && ae$1(eo))
    return eo;
  var rs = Bi && Bi === this.ownerID, ko = Va ? eo ? Ma : Ma ^ la : Ma | la, Hs = Va ? eo ? nn$1(Eo, to, eo, rs) : Qn$1(Eo, to, rs) : Gn$1(Eo, to, eo, rs);
  return rs ? (this.bitmap = ko, this.nodes = Hs, this) : new pt$1(Bi, ko, Hs);
};
var kt = function(Bi, e, qi) {
  this.ownerID = Bi, this.count = e, this.nodes = qi;
};
kt.prototype.get = function(Bi, e, qi, Xi) {
  e === void 0 && (e = $(qi));
  var Qi = (Bi === 0 ? e : e >>> Bi) & b$1, ta = this.nodes[Qi];
  return ta ? ta.get(Bi + m$4, e, qi, Xi) : Xi;
};
kt.prototype.update = function(Bi, e, qi, Xi, Qi, ta, ra) {
  qi === void 0 && (qi = $(Xi));
  var na = (e === 0 ? qi : qi >>> e) & b$1, la = Qi === y$2, Ma = this.nodes, Va = Ma[na];
  if (la && !Va)
    return this;
  var to = Fr$1(
    Va,
    Bi,
    e + m$4,
    qi,
    Xi,
    Qi,
    ta,
    ra
  );
  if (to === Va)
    return this;
  var Eo = this.count;
  if (!Va)
    Eo++;
  else if (!to && (Eo--, Eo < ti$1))
    return Xn$1(Bi, Ma, Eo, na);
  var So = Bi && Bi === this.ownerID, eo = nn$1(Ma, na, to, So);
  return So ? (this.count = Eo, this.nodes = eo, this) : new kt(Bi, Eo, eo);
};
var vt$1 = function(Bi, e, qi) {
  this.ownerID = Bi, this.keyHash = e, this.entries = qi;
};
vt$1.prototype.get = function(Bi, e, qi, Xi) {
  for (var Qi = this.entries, ta = 0, ra = Qi.length; ta < ra; ta++)
    if (D(qi, Qi[ta][0]))
      return Qi[ta][1];
  return Xi;
};
vt$1.prototype.update = function(Bi, e, qi, Xi, Qi, ta, ra) {
  qi === void 0 && (qi = $(Xi));
  var na = Qi === y$2;
  if (qi !== this.keyHash)
    return na ? this : (U(ra), U(ta), Wr$1(this, Bi, e, qi, [Xi, Qi]));
  for (var la = this.entries, Ma = 0, Va = la.length; Ma < Va && !D(Xi, la[Ma][0]); Ma++)
    ;
  var to = Ma < Va;
  if (to ? la[Ma][1] === Qi : na)
    return this;
  if (U(ra), (na || !to) && U(ta), na && Va === 2)
    return new Q$1(Bi, this.keyHash, la[Ma ^ 1]);
  var Eo = Bi && Bi === this.ownerID, So = Eo ? la : X$1(la);
  return to ? na ? Ma === Va - 1 ? So.pop() : So[Ma] = So.pop() : So[Ma] = [Xi, Qi] : So.push([Xi, Qi]), Eo ? (this.entries = So, this) : new vt$1(Bi, this.keyHash, So);
};
var Q$1 = function(Bi, e, qi) {
  this.ownerID = Bi, this.keyHash = e, this.entry = qi;
};
Q$1.prototype.get = function(Bi, e, qi, Xi) {
  return D(qi, this.entry[0]) ? this.entry[1] : Xi;
};
Q$1.prototype.update = function(Bi, e, qi, Xi, Qi, ta, ra) {
  var na = Qi === y$2, la = D(Xi, this.entry[0]);
  if (la ? Qi === this.entry[1] : na)
    return this;
  if (U(ra), na) {
    U(ta);
    return;
  }
  return la ? Bi && Bi === this.ownerID ? (this.entry[1] = Qi, this) : new Q$1(Bi, this.keyHash, [Xi, Qi]) : (U(ta), Wr$1(this, Bi, e, $(Xi), [Xi, Qi]));
};
jt$1.prototype.iterate = vt$1.prototype.iterate = function(Bi, e) {
  for (var qi = this.entries, Xi = 0, Qi = qi.length - 1; Xi <= Qi; Xi++)
    if (Bi(qi[e ? Qi - Xi : Xi]) === !1)
      return !1;
};
pt$1.prototype.iterate = kt.prototype.iterate = function(Bi, e) {
  for (var qi = this.nodes, Xi = 0, Qi = qi.length - 1; Xi <= Qi; Xi++) {
    var ta = qi[e ? Qi - Xi : Xi];
    if (ta && ta.iterate(Bi, e) === !1)
      return !1;
  }
};
Q$1.prototype.iterate = function(Bi, e) {
  return Bi(this.entry);
};
var Hn$1 = /* @__PURE__ */ function(Bi) {
  function e(qi, Xi, Qi) {
    this._type = Xi, this._reverse = Qi, this._stack = qi._root && ue(qi._root);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var qi = this._type, Xi = this._stack; Xi; ) {
      var Qi = Xi.node, ta = Xi.index++, ra = void 0;
      if (Qi.entry) {
        if (ta === 0)
          return cr$1(qi, Qi.entry);
      } else if (Qi.entries) {
        if (ra = Qi.entries.length - 1, ta <= ra)
          return cr$1(
            qi,
            Qi.entries[this._reverse ? ra - ta : ta]
          );
      } else if (ra = Qi.nodes.length - 1, ta <= ra) {
        var na = Qi.nodes[this._reverse ? ra - ta : ta];
        if (na) {
          if (na.entry)
            return cr$1(qi, na.entry);
          Xi = this._stack = ue(na, Xi);
        }
        continue;
      }
      Xi = this._stack = this._stack.__prev;
    }
    return j$1();
  }, e;
}(l$5);
function cr$1(Bi, e) {
  return E$1(Bi, e[0], e[1]);
}
function ue(Bi, e) {
  return {
    node: Bi,
    index: 0,
    __prev: e
  };
}
function Kr$1(Bi, e, qi, Xi) {
  var Qi = Object.create(w$2);
  return Qi.size = Bi, Qi._root = e, Qi.__ownerID = qi, Qi.__hash = Xi, Qi.__altered = !1, Qi;
}
var oe$1;
function F$1() {
  return oe$1 || (oe$1 = Kr$1(0));
}
function se$1(Bi, e, qi) {
  var Xi, Qi;
  if (Bi._root) {
    var ta = pr$1(), ra = pr$1();
    if (Xi = Fr$1(
      Bi._root,
      Bi.__ownerID,
      0,
      void 0,
      e,
      qi,
      ta,
      ra
    ), !ra.value)
      return Bi;
    Qi = Bi.size + (ta.value ? qi === y$2 ? -1 : 1 : 0);
  } else {
    if (qi === y$2)
      return Bi;
    Qi = 1, Xi = new jt$1(Bi.__ownerID, [[e, qi]]);
  }
  return Bi.__ownerID ? (Bi.size = Qi, Bi._root = Xi, Bi.__hash = void 0, Bi.__altered = !0, Bi) : Xi ? Kr$1(Qi, Xi) : F$1();
}
function Fr$1(Bi, e, qi, Xi, Qi, ta, ra, na) {
  return Bi ? Bi.update(
    e,
    qi,
    Xi,
    Qi,
    ta,
    ra,
    na
  ) : ta === y$2 ? Bi : (U(na), U(ra), new Q$1(e, Xi, [Qi, ta]));
}
function ae$1(Bi) {
  return Bi.constructor === Q$1 || Bi.constructor === vt$1;
}
function Wr$1(Bi, e, qi, Xi, Qi) {
  if (Bi.keyHash === Xi)
    return new vt$1(e, Xi, [Bi.entry, Qi]);
  var ta = (qi === 0 ? Bi.keyHash : Bi.keyHash >>> qi) & b$1, ra = (qi === 0 ? Xi : Xi >>> qi) & b$1, na, la = ta === ra ? [Wr$1(Bi, e, qi + m$4, Xi, Qi)] : (na = new Q$1(e, Xi, Qi), ta < ra ? [Bi, na] : [na, Bi]);
  return new pt$1(e, 1 << ta | 1 << ra, la);
}
function Jn$1(Bi, e, qi, Xi) {
  Bi || (Bi = new Er$1());
  for (var Qi = new Q$1(Bi, $(qi), [qi, Xi]), ta = 0; ta < e.length; ta++) {
    var ra = e[ta];
    Qi = Qi.update(Bi, 0, void 0, ra[0], ra[1]);
  }
  return Qi;
}
function Xn$1(Bi, e, qi, Xi) {
  for (var Qi = 0, ta = 0, ra = new Array(qi), na = 0, la = 1, Ma = e.length; na < Ma; na++, la <<= 1) {
    var Va = e[na];
    Va !== void 0 && na !== Xi && (Qi |= la, ra[ta++] = Va);
  }
  return new pt$1(Bi, Qi, ra);
}
function Zn$1(Bi, e, qi, Xi, Qi) {
  for (var ta = 0, ra = new Array(B$1), na = 0; qi !== 0; na++, qi >>>= 1)
    ra[na] = qi & 1 ? e[ta++] : void 0;
  return ra[Xi] = Qi, new kt(Bi, ta + 1, ra);
}
function en(Bi) {
  return Bi -= Bi >> 1 & 1431655765, Bi = (Bi & 858993459) + (Bi >> 2 & 858993459), Bi = Bi + (Bi >> 4) & 252645135, Bi += Bi >> 8, Bi += Bi >> 16, Bi & 127;
}
function nn$1(Bi, e, qi, Xi) {
  var Qi = Xi ? Bi : X$1(Bi);
  return Qi[e] = qi, Qi;
}
function Gn$1(Bi, e, qi, Xi) {
  var Qi = Bi.length + 1;
  if (Xi && e + 1 === Qi)
    return Bi[e] = qi, Bi;
  for (var ta = new Array(Qi), ra = 0, na = 0; na < Qi; na++)
    na === e ? (ta[na] = qi, ra = -1) : ta[na] = Bi[na + ra];
  return ta;
}
function Qn$1(Bi, e, qi) {
  var Xi = Bi.length - 1;
  if (qi && e === Xi)
    return Bi.pop(), Bi;
  for (var Qi = new Array(Xi), ta = 0, ra = 0; ra < Xi; ra++)
    ra === e && (ta = 1), Qi[ra] = Bi[ra + ta];
  return Qi;
}
var Vn$1 = B$1 / 4, xn$1 = B$1 / 2, ti$1 = B$1 / 4, un$1 = "@@__IMMUTABLE_LIST__@@";
function on$1(Bi) {
  return !!(Bi && Bi[un$1]);
}
var sr$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    var Xi = Qt$1();
    if (qi == null)
      return Xi;
    if (on$1(qi))
      return qi;
    var Qi = Bi(qi), ta = Qi.size;
    return ta === 0 ? Xi : (P$1(ta), ta > 0 && ta < B$1 ? $t$1(0, ta, m$4, null, new tt(Qi.toArray())) : Xi.withMutations(function(ra) {
      ra.setSize(ta), Qi.forEach(function(na, la) {
        return ra.set(la, na);
      });
    }));
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(qi, Xi) {
    if (qi = rt$1(this, qi), qi >= 0 && qi < this.size) {
      qi += this._origin;
      var Qi = sn$1(this, qi);
      return Qi && Qi.array[qi & b$1];
    }
    return Xi;
  }, e.prototype.set = function(qi, Xi) {
    return ri(this, qi, Xi);
  }, e.prototype.remove = function(qi) {
    return this.has(qi) ? qi === 0 ? this.shift() : qi === this.size - 1 ? this.pop() : this.splice(qi, 1) : this;
  }, e.prototype.insert = function(qi, Xi) {
    return this.splice(qi, 0, Xi);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = m$4, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : Qt$1();
  }, e.prototype.push = function() {
    var qi = arguments, Xi = this.size;
    return this.withMutations(function(Qi) {
      x$1(Qi, 0, Xi + qi.length);
      for (var ta = 0; ta < qi.length; ta++)
        Qi.set(Xi + ta, qi[ta]);
    });
  }, e.prototype.pop = function() {
    return x$1(this, 0, -1);
  }, e.prototype.unshift = function() {
    var qi = arguments;
    return this.withMutations(function(Xi) {
      x$1(Xi, -qi.length);
      for (var Qi = 0; Qi < qi.length; Qi++)
        Xi.set(Qi, qi[Qi]);
    });
  }, e.prototype.shift = function() {
    return x$1(this, 1);
  }, e.prototype.concat = function() {
    for (var qi = arguments, Xi = [], Qi = 0; Qi < arguments.length; Qi++) {
      var ta = qi[Qi], ra = Bi(
        typeof ta != "string" && Te$1(ta) ? ta : [ta]
      );
      ra.size !== 0 && Xi.push(ra);
    }
    return Xi.length === 0 ? this : this.size === 0 && !this.__ownerID && Xi.length === 1 ? this.constructor(Xi[0]) : this.withMutations(function(na) {
      Xi.forEach(function(la) {
        return la.forEach(function(Ma) {
          return na.push(Ma);
        });
      });
    });
  }, e.prototype.setSize = function(qi) {
    return x$1(this, 0, qi);
  }, e.prototype.map = function(qi, Xi) {
    var Qi = this;
    return this.withMutations(function(ta) {
      for (var ra = 0; ra < Qi.size; ra++)
        ta.set(ra, qi.call(Xi, ta.get(ra), ra, Qi));
    });
  }, e.prototype.slice = function(qi, Xi) {
    var Qi = this.size;
    return tr$1(qi, Xi, Qi) ? this : x$1(
      this,
      Ut$1(qi, Qi),
      rr(Xi, Qi)
    );
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = Xi ? this.size : 0, ta = fe$1(this, Xi);
    return new l$5(function() {
      var ra = ta();
      return ra === Rt$1 ? j$1() : E$1(qi, Xi ? --Qi : Qi++, ra);
    });
  }, e.prototype.__iterate = function(qi, Xi) {
    for (var Qi = Xi ? this.size : 0, ta = fe$1(this, Xi), ra; (ra = ta()) !== Rt$1 && qi(ra, Xi ? --Qi : Qi++, this) !== !1; )
      ;
    return Qi;
  }, e.prototype.__ensureOwner = function(qi) {
    return qi === this.__ownerID ? this : qi ? $t$1(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      qi,
      this.__hash
    ) : this.size === 0 ? Qt$1() : (this.__ownerID = qi, this.__altered = !1, this);
  }, e;
}(at);
sr$1.isList = on$1;
var I$1 = sr$1.prototype;
I$1[un$1] = !0;
I$1[Bt$1] = I$1.remove;
I$1.merge = I$1.concat;
I$1.setIn = jr$1;
I$1.deleteIn = I$1.removeIn = kr$1;
I$1.update = $r$1;
I$1.updateIn = Dr;
I$1.mergeIn = Ur$1;
I$1.mergeDeepIn = Pr$1;
I$1.withMutations = Ct$1;
I$1.wasAltered = Cr$1;
I$1.asImmutable = Ft$1;
I$1["@@transducer/init"] = I$1.asMutable = Kt;
I$1["@@transducer/step"] = function(Bi, e) {
  return Bi.push(e);
};
I$1["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
var tt = function(Bi, e) {
  this.array = Bi, this.ownerID = e;
};
tt.prototype.removeBefore = function(Bi, e, qi) {
  if (qi === e ? 1 << e : this.array.length === 0)
    return this;
  var Xi = qi >>> e & b$1;
  if (Xi >= this.array.length)
    return new tt([], Bi);
  var Qi = Xi === 0, ta;
  if (e > 0) {
    var ra = this.array[Xi];
    if (ta = ra && ra.removeBefore(Bi, e - m$4, qi), ta === ra && Qi)
      return this;
  }
  if (Qi && !ta)
    return this;
  var na = dt$1(this, Bi);
  if (!Qi)
    for (var la = 0; la < Xi; la++)
      na.array[la] = void 0;
  return ta && (na.array[Xi] = ta), na;
};
tt.prototype.removeAfter = function(Bi, e, qi) {
  if (qi === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var Xi = qi - 1 >>> e & b$1;
  if (Xi >= this.array.length)
    return this;
  var Qi;
  if (e > 0) {
    var ta = this.array[Xi];
    if (Qi = ta && ta.removeAfter(Bi, e - m$4, qi), Qi === ta && Xi === this.array.length - 1)
      return this;
  }
  var ra = dt$1(this, Bi);
  return ra.array.splice(Xi + 1), Qi && (ra.array[Xi] = Qi), ra;
};
var Rt$1 = {};
function fe$1(Bi, e) {
  var qi = Bi._origin, Xi = Bi._capacity, Qi = Dt$1(Xi), ta = Bi._tail;
  return ra(Bi._root, Bi._level, 0);
  function ra(Ma, Va, to) {
    return Va === 0 ? na(Ma, to) : la(Ma, Va, to);
  }
  function na(Ma, Va) {
    var to = Va === Qi ? ta && ta.array : Ma && Ma.array, Eo = Va > qi ? 0 : qi - Va, So = Xi - Va;
    return So > B$1 && (So = B$1), function() {
      if (Eo === So)
        return Rt$1;
      var eo = e ? --So : Eo++;
      return to && to[eo];
    };
  }
  function la(Ma, Va, to) {
    var Eo, So = Ma && Ma.array, eo = to > qi ? 0 : qi - to >> Va, rs = (Xi - to >> Va) + 1;
    return rs > B$1 && (rs = B$1), function() {
      for (; ; ) {
        if (Eo) {
          var ko = Eo();
          if (ko !== Rt$1)
            return ko;
          Eo = null;
        }
        if (eo === rs)
          return Rt$1;
        var Hs = e ? --rs : eo++;
        Eo = ra(
          So && So[Hs],
          Va - m$4,
          to + (Hs << Va)
        );
      }
    };
  }
}
function $t$1(Bi, e, qi, Xi, Qi, ta, ra) {
  var na = Object.create(I$1);
  return na.size = e - Bi, na._origin = Bi, na._capacity = e, na._level = qi, na._root = Xi, na._tail = Qi, na.__ownerID = ta, na.__hash = ra, na.__altered = !1, na;
}
var he$1;
function Qt$1() {
  return he$1 || (he$1 = $t$1(0, 0, m$4));
}
function ri(Bi, e, qi) {
  if (e = rt$1(Bi, e), e !== e)
    return Bi;
  if (e >= Bi.size || e < 0)
    return Bi.withMutations(function(ra) {
      e < 0 ? x$1(ra, e).set(0, qi) : x$1(ra, 0, e + 1).set(e, qi);
    });
  e += Bi._origin;
  var Xi = Bi._tail, Qi = Bi._root, ta = pr$1();
  return e >= Dt$1(Bi._capacity) ? Xi = Sr$1(Xi, Bi.__ownerID, 0, e, qi, ta) : Qi = Sr$1(
    Qi,
    Bi.__ownerID,
    Bi._level,
    e,
    qi,
    ta
  ), ta.value ? Bi.__ownerID ? (Bi._root = Qi, Bi._tail = Xi, Bi.__hash = void 0, Bi.__altered = !0, Bi) : $t$1(Bi._origin, Bi._capacity, Bi._level, Qi, Xi) : Bi;
}
function Sr$1(Bi, e, qi, Xi, Qi, ta) {
  var ra = Xi >>> qi & b$1, na = Bi && ra < Bi.array.length;
  if (!na && Qi === void 0)
    return Bi;
  var la;
  if (qi > 0) {
    var Ma = Bi && Bi.array[ra], Va = Sr$1(
      Ma,
      e,
      qi - m$4,
      Xi,
      Qi,
      ta
    );
    return Va === Ma ? Bi : (la = dt$1(Bi, e), la.array[ra] = Va, la);
  }
  return na && Bi.array[ra] === Qi ? Bi : (ta && U(ta), la = dt$1(Bi, e), Qi === void 0 && ra === la.array.length - 1 ? la.array.pop() : la.array[ra] = Qi, la);
}
function dt$1(Bi, e) {
  return e && Bi && e === Bi.ownerID ? Bi : new tt(Bi ? Bi.array.slice() : [], e);
}
function sn$1(Bi, e) {
  if (e >= Dt$1(Bi._capacity))
    return Bi._tail;
  if (e < 1 << Bi._level + m$4) {
    for (var qi = Bi._root, Xi = Bi._level; qi && Xi > 0; )
      qi = qi.array[e >>> Xi & b$1], Xi -= m$4;
    return qi;
  }
}
function x$1(Bi, e, qi) {
  e !== void 0 && (e |= 0), qi !== void 0 && (qi |= 0);
  var Xi = Bi.__ownerID || new Er$1(), Qi = Bi._origin, ta = Bi._capacity, ra = Qi + e, na = qi === void 0 ? ta : qi < 0 ? ta + qi : Qi + qi;
  if (ra === Qi && na === ta)
    return Bi;
  if (ra >= na)
    return Bi.clear();
  for (var la = Bi._level, Ma = Bi._root, Va = 0; ra + Va < 0; )
    Ma = new tt(
      Ma && Ma.array.length ? [void 0, Ma] : [],
      Xi
    ), la += m$4, Va += 1 << la;
  Va && (ra += Va, Qi += Va, na += Va, ta += Va);
  for (var to = Dt$1(ta), Eo = Dt$1(na); Eo >= 1 << la + m$4; )
    Ma = new tt(
      Ma && Ma.array.length ? [Ma] : [],
      Xi
    ), la += m$4;
  var So = Bi._tail, eo = Eo < to ? sn$1(Bi, na - 1) : Eo > to ? new tt([], Xi) : So;
  if (So && Eo > to && ra < ta && So.array.length) {
    Ma = dt$1(Ma, Xi);
    for (var rs = Ma, ko = la; ko > m$4; ko -= m$4) {
      var Hs = to >>> ko & b$1;
      rs = rs.array[Hs] = dt$1(rs.array[Hs], Xi);
    }
    rs.array[to >>> m$4 & b$1] = So;
  }
  if (na < ta && (eo = eo && eo.removeAfter(Xi, 0, na)), ra >= Eo)
    ra -= Eo, na -= Eo, la = m$4, Ma = null, eo = eo && eo.removeBefore(Xi, 0, ra);
  else if (ra > Qi || Eo < to) {
    for (Va = 0; Ma; ) {
      var Ks = ra >>> la & b$1;
      if (Ks !== Eo >>> la & b$1)
        break;
      Ks && (Va += (1 << la) * Ks), la -= m$4, Ma = Ma.array[Ks];
    }
    Ma && ra > Qi && (Ma = Ma.removeBefore(Xi, la, ra - Va)), Ma && Eo < to && (Ma = Ma.removeAfter(
      Xi,
      la,
      Eo - Va
    )), Va && (ra -= Va, na -= Va);
  }
  return Bi.__ownerID ? (Bi.size = na - ra, Bi._origin = ra, Bi._capacity = na, Bi._level = la, Bi._root = Ma, Bi._tail = eo, Bi.__hash = void 0, Bi.__altered = !0, Bi) : $t$1(ra, na, la, Ma, eo);
}
function Dt$1(Bi) {
  return Bi < B$1 ? 0 : Bi - 1 >>> m$4 << m$4;
}
var V = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? qt$1() : $e(qi) ? qi : qt$1().withMutations(function(Xi) {
      var Qi = K(qi);
      P$1(Qi.size), Qi.forEach(function(ta, ra) {
        return Xi.set(ra, ta);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(qi, Xi) {
    var Qi = this._map.get(qi);
    return Qi !== void 0 ? this._list.get(Qi)[1] : Xi;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : qt$1();
  }, e.prototype.set = function(qi, Xi) {
    return _e(this, qi, Xi);
  }, e.prototype.remove = function(qi) {
    return _e(this, qi, y$2);
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this;
    return this._list.__iterate(
      function(ta) {
        return ta && qi(ta[1], ta[0], Qi);
      },
      Xi
    );
  }, e.prototype.__iterator = function(qi, Xi) {
    return this._list.fromEntrySeq().__iterator(qi, Xi);
  }, e.prototype.__ensureOwner = function(qi) {
    if (qi === this.__ownerID)
      return this;
    var Xi = this._map.__ensureOwner(qi), Qi = this._list.__ensureOwner(qi);
    return qi ? Yr$1(Xi, Qi, qi, this.__hash) : this.size === 0 ? qt$1() : (this.__ownerID = qi, this.__altered = !1, this._map = Xi, this._list = Qi, this);
  }, e;
}(zt$1);
V.isOrderedMap = $e;
V.prototype[mt$1] = !0;
V.prototype[Bt$1] = V.prototype.remove;
function Yr$1(Bi, e, qi, Xi) {
  var Qi = Object.create(V.prototype);
  return Qi.size = Bi ? Bi.size : 0, Qi._map = Bi, Qi._list = e, Qi.__ownerID = qi, Qi.__hash = Xi, Qi.__altered = !1, Qi;
}
var ce$1;
function qt$1() {
  return ce$1 || (ce$1 = Yr$1(F$1(), Qt$1()));
}
function _e(Bi, e, qi) {
  var Xi = Bi._map, Qi = Bi._list, ta = Xi.get(e), ra = ta !== void 0, na, la;
  if (qi === y$2) {
    if (!ra)
      return Bi;
    Qi.size >= B$1 && Qi.size >= Xi.size * 2 ? (la = Qi.filter(function(Ma, Va) {
      return Ma !== void 0 && ta !== Va;
    }), na = la.toKeyedSeq().map(function(Ma) {
      return Ma[0];
    }).flip().toMap(), Bi.__ownerID && (na.__ownerID = la.__ownerID = Bi.__ownerID)) : (na = Xi.remove(e), la = ta === Qi.size - 1 ? Qi.pop() : Qi.set(ta, void 0));
  } else if (ra) {
    if (qi === Qi.get(ta)[1])
      return Bi;
    na = Xi, la = Qi.set(ta, [e, qi]);
  } else
    na = Xi.set(e, Qi.size), la = Qi.set(Qi.size, [e, qi]);
  return Bi.__ownerID ? (Bi.size = na.size, Bi._map = na, Bi._list = la, Bi.__hash = void 0, Bi.__altered = !0, Bi) : Yr$1(na, la);
}
var an$1 = "@@__IMMUTABLE_STACK__@@";
function mr$1(Bi) {
  return !!(Bi && Bi[an$1]);
}
var Hr$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? Xt$1() : mr$1(qi) ? qi : Xt$1().pushAll(qi);
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(qi, Xi) {
    var Qi = this._head;
    for (qi = rt$1(this, qi); Qi && qi--; )
      Qi = Qi.next;
    return Qi ? Qi.value : Xi;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var qi = arguments;
    if (arguments.length === 0)
      return this;
    for (var Xi = this.size + arguments.length, Qi = this._head, ta = arguments.length - 1; ta >= 0; ta--)
      Qi = {
        value: qi[ta],
        next: Qi
      };
    return this.__ownerID ? (this.size = Xi, this._head = Qi, this.__hash = void 0, this.__altered = !0, this) : At$1(Xi, Qi);
  }, e.prototype.pushAll = function(qi) {
    if (qi = Bi(qi), qi.size === 0)
      return this;
    if (this.size === 0 && mr$1(qi))
      return qi;
    P$1(qi.size);
    var Xi = this.size, Qi = this._head;
    return qi.__iterate(function(ta) {
      Xi++, Qi = {
        value: ta,
        next: Qi
      };
    }, !0), this.__ownerID ? (this.size = Xi, this._head = Qi, this.__hash = void 0, this.__altered = !0, this) : At$1(Xi, Qi);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Xt$1();
  }, e.prototype.slice = function(qi, Xi) {
    if (tr$1(qi, Xi, this.size))
      return this;
    var Qi = Ut$1(qi, this.size), ta = rr(Xi, this.size);
    if (ta !== this.size)
      return Bi.prototype.slice.call(this, qi, Xi);
    for (var ra = this.size - Qi, na = this._head; Qi--; )
      na = na.next;
    return this.__ownerID ? (this.size = ra, this._head = na, this.__hash = void 0, this.__altered = !0, this) : At$1(ra, na);
  }, e.prototype.__ensureOwner = function(qi) {
    return qi === this.__ownerID ? this : qi ? At$1(this.size, this._head, qi, this.__hash) : this.size === 0 ? Xt$1() : (this.__ownerID = qi, this.__altered = !1, this);
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this;
    if (Xi)
      return new st$1(this.toArray()).__iterate(
        function(na, la) {
          return qi(na, la, Qi);
        },
        Xi
      );
    for (var ta = 0, ra = this._head; ra && qi(ra.value, ta++, this) !== !1; )
      ra = ra.next;
    return ta;
  }, e.prototype.__iterator = function(qi, Xi) {
    if (Xi)
      return new st$1(this.toArray()).__iterator(qi, Xi);
    var Qi = 0, ta = this._head;
    return new l$5(function() {
      if (ta) {
        var ra = ta.value;
        return ta = ta.next, E$1(qi, Qi++, ra);
      }
      return j$1();
    });
  }, e;
}(at);
Hr$1.isStack = mr$1;
var R$1 = Hr$1.prototype;
R$1[an$1] = !0;
R$1.shift = R$1.pop;
R$1.unshift = R$1.push;
R$1.unshiftAll = R$1.pushAll;
R$1.withMutations = Ct$1;
R$1.wasAltered = Cr$1;
R$1.asImmutable = Ft$1;
R$1["@@transducer/init"] = R$1.asMutable = Kt;
R$1["@@transducer/step"] = function(Bi, e) {
  return Bi.unshift(e);
};
R$1["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
function At$1(Bi, e, qi, Xi) {
  var Qi = Object.create(R$1);
  return Qi.size = Bi, Qi._head = e, Qi.__ownerID = qi, Qi.__hash = Xi, Qi.__altered = !1, Qi;
}
var pe$1;
function Xt$1() {
  return pe$1 || (pe$1 = At$1(0));
}
var fn$1 = "@@__IMMUTABLE_SET__@@";
function Jr$1(Bi) {
  return !!(Bi && Bi[fn$1]);
}
function hn$1(Bi) {
  return Jr$1(Bi) && W$1(Bi);
}
function cn$1(Bi, e) {
  if (Bi === e)
    return !0;
  if (!L$1(e) || Bi.size !== void 0 && e.size !== void 0 && Bi.size !== e.size || Bi.__hash !== void 0 && e.__hash !== void 0 && Bi.__hash !== e.__hash || O$1(Bi) !== O$1(e) || T$1(Bi) !== T$1(e) || W$1(Bi) !== W$1(e))
    return !1;
  if (Bi.size === 0 && e.size === 0)
    return !0;
  var qi = !er$1(Bi);
  if (W$1(Bi)) {
    var Xi = Bi.entries();
    return e.every(function(la, Ma) {
      var Va = Xi.next().value;
      return Va && D(Va[1], la) && (qi || D(Va[0], Ma));
    }) && Xi.next().done;
  }
  var Qi = !1;
  if (Bi.size === void 0)
    if (e.size === void 0)
      typeof Bi.cacheResult == "function" && Bi.cacheResult();
    else {
      Qi = !0;
      var ta = Bi;
      Bi = e, e = ta;
    }
  var ra = !0, na = e.__iterate(function(la, Ma) {
    if (qi ? !Bi.has(la) : Qi ? !D(la, Bi.get(Ma, y$2)) : !D(Bi.get(Ma, y$2), la))
      return ra = !1, !1;
  });
  return ra && Bi.size === na;
}
function ft$1(Bi, e) {
  var qi = function(Xi) {
    Bi.prototype[Xi] = e[Xi];
  };
  return Object.keys(e).forEach(qi), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(qi), Bi;
}
function xt$1(Bi) {
  if (!Bi || typeof Bi != "object")
    return Bi;
  if (!L$1(Bi)) {
    if (!et$1(Bi))
      return Bi;
    Bi = N$1(Bi);
  }
  if (O$1(Bi)) {
    var e = {};
    return Bi.__iterate(function(Xi, Qi) {
      e[Qi] = xt$1(Xi);
    }), e;
  }
  var qi = [];
  return Bi.__iterate(function(Xi) {
    qi.push(xt$1(Xi));
  }), qi;
}
var Wt$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? bt$1() : Jr$1(qi) && !W$1(qi) ? qi : bt$1().withMutations(function(Xi) {
      var Qi = Bi(qi);
      P$1(Qi.size), Qi.forEach(function(ta) {
        return Xi.add(ta);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(qi) {
    return this(K(qi).keySeq());
  }, e.intersect = function(qi) {
    return qi = z$1(qi).toArray(), qi.length ? q.intersect.apply(e(qi.pop()), qi) : bt$1();
  }, e.union = function(qi) {
    return qi = z$1(qi).toArray(), qi.length ? q.union.apply(e(qi.pop()), qi) : bt$1();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(qi) {
    return this._map.has(qi);
  }, e.prototype.add = function(qi) {
    return Zt$1(this, this._map.set(qi, qi));
  }, e.prototype.remove = function(qi) {
    return Zt$1(this, this._map.remove(qi));
  }, e.prototype.clear = function() {
    return Zt$1(this, this._map.clear());
  }, e.prototype.map = function(qi, Xi) {
    var Qi = this, ta = !1, ra = Zt$1(
      this,
      this._map.mapEntries(function(na) {
        var la = na[1], Ma = qi.call(Xi, la, la, Qi);
        return Ma !== la && (ta = !0), [Ma, Ma];
      }, Xi)
    );
    return ta ? ra : this;
  }, e.prototype.union = function() {
    for (var qi = [], Xi = arguments.length; Xi--; )
      qi[Xi] = arguments[Xi];
    return qi = qi.filter(function(Qi) {
      return Qi.size !== 0;
    }), qi.length === 0 ? this : this.size === 0 && !this.__ownerID && qi.length === 1 ? this.constructor(qi[0]) : this.withMutations(function(Qi) {
      for (var ta = 0; ta < qi.length; ta++)
        Bi(qi[ta]).forEach(function(ra) {
          return Qi.add(ra);
        });
    });
  }, e.prototype.intersect = function() {
    for (var qi = [], Xi = arguments.length; Xi--; )
      qi[Xi] = arguments[Xi];
    if (qi.length === 0)
      return this;
    qi = qi.map(function(ta) {
      return Bi(ta);
    });
    var Qi = [];
    return this.forEach(function(ta) {
      qi.every(function(ra) {
        return ra.includes(ta);
      }) || Qi.push(ta);
    }), this.withMutations(function(ta) {
      Qi.forEach(function(ra) {
        ta.remove(ra);
      });
    });
  }, e.prototype.subtract = function() {
    for (var qi = [], Xi = arguments.length; Xi--; )
      qi[Xi] = arguments[Xi];
    if (qi.length === 0)
      return this;
    qi = qi.map(function(ta) {
      return Bi(ta);
    });
    var Qi = [];
    return this.forEach(function(ta) {
      qi.some(function(ra) {
        return ra.includes(ta);
      }) && Qi.push(ta);
    }), this.withMutations(function(ta) {
      Qi.forEach(function(ra) {
        ta.remove(ra);
      });
    });
  }, e.prototype.sort = function(qi) {
    return Nt$1(_t$1(this, qi));
  }, e.prototype.sortBy = function(qi, Xi) {
    return Nt$1(_t$1(this, Xi, qi));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(qi, Xi) {
    var Qi = this;
    return this._map.__iterate(function(ta) {
      return qi(ta, ta, Qi);
    }, Xi);
  }, e.prototype.__iterator = function(qi, Xi) {
    return this._map.__iterator(qi, Xi);
  }, e.prototype.__ensureOwner = function(qi) {
    if (qi === this.__ownerID)
      return this;
    var Xi = this._map.__ensureOwner(qi);
    return qi ? this.__make(Xi, qi) : this.size === 0 ? this.__empty() : (this.__ownerID = qi, this._map = Xi, this);
  }, e;
}(gt$1);
Wt$1.isSet = Jr$1;
var q = Wt$1.prototype;
q[fn$1] = !0;
q[Bt$1] = q.remove;
q.merge = q.concat = q.union;
q.withMutations = Ct$1;
q.asImmutable = Ft$1;
q["@@transducer/init"] = q.asMutable = Kt;
q["@@transducer/step"] = function(Bi, e) {
  return Bi.add(e);
};
q["@@transducer/result"] = function(Bi) {
  return Bi.asImmutable();
};
q.__empty = bt$1;
q.__make = _n$1;
function Zt$1(Bi, e) {
  return Bi.__ownerID ? (Bi.size = e.size, Bi._map = e, Bi) : e === Bi._map ? Bi : e.size === 0 ? Bi.__empty() : Bi.__make(e);
}
function _n$1(Bi, e) {
  var qi = Object.create(q);
  return qi.size = Bi ? Bi.size : 0, qi._map = Bi, qi.__ownerID = e, qi;
}
var ve$1;
function bt$1() {
  return ve$1 || (ve$1 = _n$1(F$1()));
}
var ei = /* @__PURE__ */ function(Bi) {
  function e(qi, Xi, Qi) {
    if (!(this instanceof e))
      return new e(qi, Xi, Qi);
    if (Lr(Qi !== 0, "Cannot step a Range by 0"), qi = qi || 0, Xi === void 0 && (Xi = 1 / 0), Qi = Qi === void 0 ? 1 : Math.abs(Qi), Xi < qi && (Qi = -Qi), this._start = qi, this._end = Xi, this._step = Qi, this.size = Math.max(0, Math.ceil((Xi - qi) / Qi - 1) + 1), this.size === 0) {
      if (_r$1)
        return _r$1;
      _r$1 = this;
    }
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(qi, Xi) {
    return this.has(qi) ? this._start + rt$1(this, qi) * this._step : Xi;
  }, e.prototype.includes = function(qi) {
    var Xi = (qi - this._start) / this._step;
    return Xi >= 0 && Xi < this.size && Xi === Math.floor(Xi);
  }, e.prototype.slice = function(qi, Xi) {
    return tr$1(qi, Xi, this.size) ? this : (qi = Ut$1(qi, this.size), Xi = rr(Xi, this.size), Xi <= qi ? new e(0, 0) : new e(
      this.get(qi, this._end),
      this.get(Xi, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(qi) {
    var Xi = qi - this._start;
    if (Xi % this._step === 0) {
      var Qi = Xi / this._step;
      if (Qi >= 0 && Qi < this.size)
        return Qi;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(qi) {
    return this.indexOf(qi);
  }, e.prototype.__iterate = function(qi, Xi) {
    for (var Qi = this.size, ta = this._step, ra = Xi ? this._start + (Qi - 1) * ta : this._start, na = 0; na !== Qi && qi(ra, Xi ? Qi - ++na : na++, this) !== !1; )
      ra += Xi ? -ta : ta;
    return na;
  }, e.prototype.__iterator = function(qi, Xi) {
    var Qi = this.size, ta = this._step, ra = Xi ? this._start + (Qi - 1) * ta : this._start, na = 0;
    return new l$5(function() {
      if (na === Qi)
        return j$1();
      var la = ra;
      return ra += Xi ? -ta : ta, E$1(qi, Xi ? Qi - ++na : na++, la);
    });
  }, e.prototype.equals = function(qi) {
    return qi instanceof e ? this._start === qi._start && this._end === qi._end && this._step === qi._step : cn$1(this, qi);
  }, e;
}(H$2), _r$1;
function pn$1(Bi, e, qi) {
  for (var Xi = Je$1(e), Qi = 0; Qi !== Xi.length; )
    if (Bi = Xe$1(Bi, Xi[Qi++], y$2), Bi === y$2)
      return qi;
  return Bi;
}
function vn$1(Bi, e) {
  return pn$1(this, Bi, e);
}
function ni(Bi, e) {
  return pn$1(Bi, e, y$2) !== y$2;
}
function ii$1(Bi) {
  return ni(this, Bi);
}
function dn() {
  P$1(this.size);
  var Bi = {};
  return this.__iterate(function(e, qi) {
    Bi[qi] = e;
  }), Bi;
}
z$1.isIterable = L$1;
z$1.isKeyed = O$1;
z$1.isIndexed = T$1;
z$1.isAssociative = er$1;
z$1.isOrdered = W$1;
z$1.Iterator = l$5;
ft$1(z$1, {
  toArray: function() {
    P$1(this.size);
    var Bi = new Array(this.size || 0), e = O$1(this), qi = 0;
    return this.__iterate(function(Xi, Qi) {
      Bi[qi++] = e ? [Qi, Xi] : Xi;
    }), Bi;
  },
  toIndexedSeq: function() {
    return new Ne(this);
  },
  toJS: function() {
    return xt$1(this);
  },
  toKeyedSeq: function() {
    return new or$1(this, !0);
  },
  toMap: function() {
    return zt$1(this.toKeyedSeq());
  },
  toObject: dn,
  toOrderedMap: function() {
    return V(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Nt$1(O$1(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Wt$1(O$1(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new Be$1(this);
  },
  toSeq: function() {
    return T$1(this) ? this.toIndexedSeq() : O$1(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return Hr$1(O$1(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return sr$1(O$1(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(Bi, e) {
    return this.size === 0 ? Bi + e : Bi + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  concat: function() {
    for (var Bi = [], e = arguments.length; e--; )
      Bi[e] = arguments[e];
    return g$2(this, kn$1(this, Bi));
  },
  includes: function(Bi) {
    return this.some(function(e) {
      return D(e, Bi);
    });
  },
  entries: function() {
    return this.__iterator(C);
  },
  every: function(Bi, e) {
    P$1(this.size);
    var qi = !0;
    return this.__iterate(function(Xi, Qi, ta) {
      if (!Bi.call(e, Xi, Qi, ta))
        return qi = !1, !1;
    }), qi;
  },
  filter: function(Bi, e) {
    return g$2(this, Ke$1(this, Bi, e, !0));
  },
  find: function(Bi, e, qi) {
    var Xi = this.findEntry(Bi, e);
    return Xi ? Xi[1] : qi;
  },
  forEach: function(Bi, e) {
    return P$1(this.size), this.__iterate(e ? Bi.bind(e) : Bi);
  },
  join: function(Bi) {
    P$1(this.size), Bi = Bi !== void 0 ? "" + Bi : ",";
    var e = "", qi = !0;
    return this.__iterate(function(Xi) {
      qi ? qi = !1 : e += Bi, e += Xi != null ? Xi.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(Pt$1);
  },
  map: function(Bi, e) {
    return g$2(this, Ce$1(this, Bi, e));
  },
  reduce: function(Bi, e, qi) {
    return de$1(
      this,
      Bi,
      e,
      qi,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(Bi, e, qi) {
    return de$1(
      this,
      Bi,
      e,
      qi,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return g$2(this, br$1(this, !0));
  },
  slice: function(Bi, e) {
    return g$2(this, Rr$1(this, Bi, e, !0));
  },
  some: function(Bi, e) {
    return !this.every(Gt$1(Bi), e);
  },
  sort: function(Bi) {
    return g$2(this, _t$1(this, Bi));
  },
  values: function() {
    return this.__iterator(Y$1);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(Bi, e) {
    return ct$1(
      Bi ? this.toSeq().filter(Bi, e) : this
    );
  },
  countBy: function(Bi, e) {
    return Tn$1(this, Bi, e);
  },
  equals: function(Bi) {
    return cn$1(this, Bi);
  },
  entrySeq: function() {
    var Bi = this;
    if (Bi._cache)
      return new st$1(Bi._cache);
    var e = Bi.toSeq().map(oi$1).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return Bi.toSeq();
    }, e;
  },
  filterNot: function(Bi, e) {
    return this.filter(Gt$1(Bi), e);
  },
  findEntry: function(Bi, e, qi) {
    var Xi = qi;
    return this.__iterate(function(Qi, ta, ra) {
      if (Bi.call(e, Qi, ta, ra))
        return Xi = [ta, Qi], !1;
    }), Xi;
  },
  findKey: function(Bi, e) {
    var qi = this.findEntry(Bi, e);
    return qi && qi[0];
  },
  findLast: function(Bi, e, qi) {
    return this.toKeyedSeq().reverse().find(Bi, e, qi);
  },
  findLastEntry: function(Bi, e, qi) {
    return this.toKeyedSeq().reverse().findEntry(Bi, e, qi);
  },
  findLastKey: function(Bi, e) {
    return this.toKeyedSeq().reverse().findKey(Bi, e);
  },
  first: function(Bi) {
    return this.find(Ee$1, null, Bi);
  },
  flatMap: function(Bi, e) {
    return g$2(this, $n$1(this, Bi, e));
  },
  flatten: function(Bi) {
    return g$2(this, We$1(this, Bi, !0));
  },
  fromEntrySeq: function() {
    return new Ue$1(this);
  },
  get: function(Bi, e) {
    return this.find(function(qi, Xi) {
      return D(Xi, Bi);
    }, void 0, e);
  },
  getIn: vn$1,
  groupBy: function(Bi, e) {
    return Ln$1(this, Bi, e);
  },
  has: function(Bi) {
    return this.get(Bi, y$2) !== y$2;
  },
  hasIn: ii$1,
  isSubset: function(Bi) {
    return Bi = typeof Bi.includes == "function" ? Bi : z$1(Bi), this.every(function(e) {
      return Bi.includes(e);
    });
  },
  isSuperset: function(Bi) {
    return Bi = typeof Bi.isSubset == "function" ? Bi : z$1(Bi), Bi.isSubset(this);
  },
  keyOf: function(Bi) {
    return this.findKey(function(e) {
      return D(e, Bi);
    });
  },
  keySeq: function() {
    return this.toSeq().map(ui$1).toIndexedSeq();
  },
  last: function(Bi) {
    return this.toSeq().reverse().first(Bi);
  },
  lastKeyOf: function(Bi) {
    return this.toKeyedSeq().reverse().keyOf(Bi);
  },
  max: function(Bi) {
    return Ht$1(this, Bi);
  },
  maxBy: function(Bi, e) {
    return Ht$1(this, e, Bi);
  },
  min: function(Bi) {
    return Ht$1(
      this,
      Bi ? ye$1(Bi) : ge$1
    );
  },
  minBy: function(Bi, e) {
    return Ht$1(
      this,
      e ? ye$1(e) : ge$1,
      Bi
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(Bi) {
    return Bi === 0 ? this : this.slice(Math.max(0, Bi));
  },
  skipLast: function(Bi) {
    return Bi === 0 ? this : this.slice(0, -Math.max(0, Bi));
  },
  skipWhile: function(Bi, e) {
    return g$2(this, Fe$1(this, Bi, e, !0));
  },
  skipUntil: function(Bi, e) {
    return this.skipWhile(Gt$1(Bi), e);
  },
  sortBy: function(Bi, e) {
    return g$2(this, _t$1(this, e, Bi));
  },
  take: function(Bi) {
    return this.slice(0, Math.max(0, Bi));
  },
  takeLast: function(Bi) {
    return this.slice(-Math.max(0, Bi));
  },
  takeWhile: function(Bi, e) {
    return g$2(this, jn$1(this, Bi, e));
  },
  takeUntil: function(Bi, e) {
    return this.takeWhile(Gt$1(Bi), e);
  },
  update: function(Bi) {
    return Bi(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = si$1(this));
  }
});
var A = z$1.prototype;
A[Ie$1] = !0;
A[nr$1] = A.values;
A.toJSON = A.toArray;
A.__toStringMapper = Lt$1;
A.inspect = A.toSource = function() {
  return this.toString();
};
A.chain = A.flatMap;
A.contains = A.includes;
ft$1(K, {
  flip: function() {
    return g$2(this, Pe$1(this));
  },
  mapEntries: function(Bi, e) {
    var qi = this, Xi = 0;
    return g$2(
      this,
      this.toSeq().map(function(Qi, ta) {
        return Bi.call(e, [ta, Qi], Xi++, qi);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(Bi, e) {
    var qi = this;
    return g$2(
      this,
      this.toSeq().flip().map(function(Xi, Qi) {
        return Bi.call(e, Xi, Qi, qi);
      }).flip()
    );
  }
});
var Yt$1 = K.prototype;
Yt$1[Me$1] = !0;
Yt$1[nr$1] = A.entries;
Yt$1.toJSON = dn;
Yt$1.__toStringMapper = function(Bi, e) {
  return Lt$1(e) + ": " + Lt$1(Bi);
};
ft$1(at, {
  toKeyedSeq: function() {
    return new or$1(this, !1);
  },
  filter: function(Bi, e) {
    return g$2(this, Ke$1(this, Bi, e, !1));
  },
  findIndex: function(Bi, e) {
    var qi = this.findEntry(Bi, e);
    return qi ? qi[0] : -1;
  },
  indexOf: function(Bi) {
    var e = this.keyOf(Bi);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(Bi) {
    var e = this.lastKeyOf(Bi);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return g$2(this, br$1(this, !1));
  },
  slice: function(Bi, e) {
    return g$2(this, Rr$1(this, Bi, e, !1));
  },
  splice: function(Bi, e) {
    var qi = arguments.length;
    if (e = Math.max(e || 0, 0), qi === 0 || qi === 2 && !e)
      return this;
    Bi = Ut$1(Bi, Bi < 0 ? this.count() : this.size);
    var Xi = this.slice(0, Bi);
    return g$2(
      this,
      qi === 1 ? Xi : Xi.concat(X$1(arguments, 2), this.slice(Bi + e))
    );
  },
  findLastIndex: function(Bi, e) {
    var qi = this.findLastEntry(Bi, e);
    return qi ? qi[0] : -1;
  },
  first: function(Bi) {
    return this.get(0, Bi);
  },
  flatten: function(Bi) {
    return g$2(this, We$1(this, Bi, !1));
  },
  get: function(Bi, e) {
    return Bi = rt$1(this, Bi), Bi < 0 || this.size === 1 / 0 || this.size !== void 0 && Bi > this.size ? e : this.find(function(qi, Xi) {
      return Xi === Bi;
    }, void 0, e);
  },
  has: function(Bi) {
    return Bi = rt$1(this, Bi), Bi >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || Bi < this.size : this.indexOf(Bi) !== -1);
  },
  interpose: function(Bi) {
    return g$2(this, Dn$1(this, Bi));
  },
  interleave: function() {
    var Bi = [this].concat(X$1(arguments)), e = Jt(this.toSeq(), H$2.of, Bi), qi = e.flatten(!0);
    return e.size && (qi.size = e.size * Bi.length), g$2(this, qi);
  },
  keySeq: function() {
    return ei(0, this.size);
  },
  last: function(Bi) {
    return this.get(-1, Bi);
  },
  skipWhile: function(Bi, e) {
    return g$2(this, Fe$1(this, Bi, e, !1));
  },
  zip: function() {
    var Bi = [this].concat(X$1(arguments));
    return g$2(this, Jt(this, le, Bi));
  },
  zipAll: function() {
    var Bi = [this].concat(X$1(arguments));
    return g$2(this, Jt(this, le, Bi, !0));
  },
  zipWith: function(Bi) {
    var e = X$1(arguments);
    return e[0] = this, g$2(this, Jt(this, Bi, e));
  }
});
var It$1 = at.prototype;
It$1[qe$1] = !0;
It$1[mt$1] = !0;
ft$1(gt$1, {
  get: function(Bi, e) {
    return this.has(Bi) ? Bi : e;
  },
  includes: function(Bi) {
    return this.has(Bi);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var yt$1 = gt$1.prototype;
yt$1.has = A.includes;
yt$1.contains = yt$1.includes;
yt$1.keys = yt$1.values;
ft$1(it$1, Yt$1);
ft$1(H$2, It$1);
ft$1(Et$1, yt$1);
function de$1(Bi, e, qi, Xi, Qi, ta) {
  return P$1(Bi.size), Bi.__iterate(function(ra, na, la) {
    Qi ? (Qi = !1, qi = ra) : qi = e.call(Xi, qi, ra, na, la);
  }, ta), qi;
}
function ui$1(Bi, e) {
  return e;
}
function oi$1(Bi, e) {
  return [e, Bi];
}
function Gt$1(Bi) {
  return function() {
    return !Bi.apply(this, arguments);
  };
}
function ye$1(Bi) {
  return function() {
    return -Bi.apply(this, arguments);
  };
}
function le() {
  return X$1(arguments);
}
function ge$1(Bi, e) {
  return Bi < e ? 1 : Bi > e ? -1 : 0;
}
function si$1(Bi) {
  if (Bi.size === 1 / 0)
    return 0;
  var e = W$1(Bi), qi = O$1(Bi), Xi = e ? 1 : 0, Qi = Bi.__iterate(
    qi ? e ? function(ta, ra) {
      Xi = 31 * Xi + Se$1($(ta), $(ra)) | 0;
    } : function(ta, ra) {
      Xi = Xi + Se$1($(ta), $(ra)) | 0;
    } : e ? function(ta) {
      Xi = 31 * Xi + $(ta) | 0;
    } : function(ta) {
      Xi = Xi + $(ta) | 0;
    }
  );
  return ai$1(Qi, Xi);
}
function ai$1(Bi, e) {
  return e = Mt$1(e, 3432918353), e = Mt$1(e << 15 | e >>> -15, 461845907), e = Mt$1(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ Bi, e = Mt$1(e ^ e >>> 16, 2246822507), e = Mt$1(e ^ e >>> 13, 3266489909), e = ur$1(e ^ e >>> 16), e;
}
function Se$1(Bi, e) {
  return Bi ^ e + 2654435769 + (Bi << 6) + (Bi >> 2) | 0;
}
var Nt$1 = /* @__PURE__ */ function(Bi) {
  function e(qi) {
    return qi == null ? wr$1() : hn$1(qi) ? qi : wr$1().withMutations(function(Xi) {
      var Qi = gt$1(qi);
      P$1(Qi.size), Qi.forEach(function(ta) {
        return Xi.add(ta);
      });
    });
  }
  return Bi && (e.__proto__ = Bi), e.prototype = Object.create(Bi && Bi.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(qi) {
    return this(K(qi).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(Wt$1);
Nt$1.isOrderedSet = hn$1;
var ht$1 = Nt$1.prototype;
ht$1[mt$1] = !0;
ht$1.zip = It$1.zip;
ht$1.zipWith = It$1.zipWith;
ht$1.zipAll = It$1.zipAll;
ht$1.__empty = wr$1;
ht$1.__make = yn$1;
function yn$1(Bi, e) {
  var qi = Object.create(ht$1);
  return qi.size = Bi ? Bi.size : 0, qi._map = Bi, qi.__ownerID = e, qi;
}
var me$1;
function wr$1() {
  return me$1 || (me$1 = yn$1(qt$1()));
}
function fi$1(Bi) {
  if (St$1(Bi))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Z(Bi))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (Bi === null || typeof Bi != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var M$1 = function(Bi, e) {
  var qi;
  fi$1(Bi);
  var Xi = function(ta) {
    var ra = this;
    if (ta instanceof Xi)
      return ta;
    if (!(this instanceof Xi))
      return new Xi(ta);
    if (!qi) {
      qi = !0;
      var na = Object.keys(Bi), la = Qi._indices = {};
      Qi._name = e, Qi._keys = na, Qi._defaultValues = Bi;
      for (var Ma = 0; Ma < na.length; Ma++) {
        var Va = na[Ma];
        la[Va] = Ma, Qi[Va] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Zr$1(this) + ' with property "' + Va + '" since that property name is part of the Record API.'
        ) : hi$1(Qi, Va);
      }
    }
    return this.__ownerID = void 0, this._values = sr$1().withMutations(function(to) {
      to.setSize(ra._keys.length), K(ta).forEach(function(Eo, So) {
        to.set(ra._indices[So], Eo === ra._defaultValues[So] ? void 0 : Eo);
      });
    }), this;
  }, Qi = Xi.prototype = Object.create(S);
  return Qi.constructor = Xi, e && (Xi.displayName = e), Xi;
};
M$1.prototype.toString = function() {
  for (var Bi = Zr$1(this) + " { ", e = this._keys, qi, Xi = 0, Qi = e.length; Xi !== Qi; Xi++)
    qi = e[Xi], Bi += (Xi ? ", " : "") + qi + ": " + Lt$1(this.get(qi));
  return Bi + " }";
};
M$1.prototype.equals = function(Bi) {
  return this === Bi || St$1(Bi) && lt$1(this).equals(lt$1(Bi));
};
M$1.prototype.hashCode = function() {
  return lt$1(this).hashCode();
};
M$1.prototype.has = function(Bi) {
  return this._indices.hasOwnProperty(Bi);
};
M$1.prototype.get = function(Bi, e) {
  if (!this.has(Bi))
    return e;
  var qi = this._indices[Bi], Xi = this._values.get(qi);
  return Xi === void 0 ? this._defaultValues[Bi] : Xi;
};
M$1.prototype.set = function(Bi, e) {
  if (this.has(Bi)) {
    var qi = this._values.set(
      this._indices[Bi],
      e === this._defaultValues[Bi] ? void 0 : e
    );
    if (qi !== this._values && !this.__ownerID)
      return Xr$1(this, qi);
  }
  return this;
};
M$1.prototype.remove = function(Bi) {
  return this.set(Bi);
};
M$1.prototype.clear = function() {
  var Bi = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : Xr$1(this, Bi);
};
M$1.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
M$1.prototype.toSeq = function() {
  return lt$1(this);
};
M$1.prototype.toJS = function() {
  return xt$1(this);
};
M$1.prototype.entries = function() {
  return this.__iterator(C);
};
M$1.prototype.__iterator = function(Bi, e) {
  return lt$1(this).__iterator(Bi, e);
};
M$1.prototype.__iterate = function(Bi, e) {
  return lt$1(this).__iterate(Bi, e);
};
M$1.prototype.__ensureOwner = function(Bi) {
  if (Bi === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(Bi);
  return Bi ? Xr$1(this, e, Bi) : (this.__ownerID = Bi, this._values = e, this);
};
M$1.isRecord = St$1;
M$1.getDescriptiveName = Zr$1;
var S = M$1.prototype;
S[be$1] = !0;
S[Bt$1] = S.remove;
S.deleteIn = S.removeIn = kr$1;
S.getIn = vn$1;
S.hasIn = A.hasIn;
S.merge = Qe$1;
S.mergeWith = Ve$1;
S.mergeIn = Ur$1;
S.mergeDeep = tn$1;
S.mergeDeepWith = rn$1;
S.mergeDeepIn = Pr$1;
S.setIn = jr$1;
S.update = $r$1;
S.updateIn = Dr;
S.withMutations = Ct$1;
S.asMutable = Kt;
S.asImmutable = Ft$1;
S[nr$1] = S.entries;
S.toJSON = S.toObject = A.toObject;
S.inspect = S.toSource = function() {
  return this.toString();
};
function Xr$1(Bi, e, qi) {
  var Xi = Object.create(Object.getPrototypeOf(Bi));
  return Xi._values = e, Xi.__ownerID = qi, Xi;
}
function Zr$1(Bi) {
  return Bi.constructor.displayName || Bi.constructor.name || "Record";
}
function lt$1(Bi) {
  return Mr$1(Bi._keys.map(function(e) {
    return [e, Bi.get(e)];
  }));
}
function hi$1(Bi, e) {
  try {
    Object.defineProperty(Bi, e, {
      get: function() {
        return this.get(e);
      },
      set: function(qi) {
        Lr(this.__ownerID, "Cannot set on an immutable record."), this.set(e, qi);
      }
    });
  } catch {
  }
}
const Si$1 = (Bi, e) => {
  useEffect(() => (document.addEventListener("keydown", (qi) => {
    Bi[qi.key] && Bi[qi.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), e || []);
}, containerVariants = cva(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), Modal = ({
  children: Bi,
  visible: e,
  onClose: qi,
  className: Xi,
  containerClassName: Qi = "modal-root",
  variant: ta = "lg"
}) => {
  const ra = useRef(null), { root: na } = useModalContext();
  return Si$1({
    Escape: qi
  }), na ? e ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          className: twMerge(
            "absolute top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40",
            Xi
          ),
          onClick: () => qi(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          className: twMerge(
            containerVariants({ size: ta }),
            Qi
          ),
          ref: ra,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: Bi
        }
      )
    ] }) }),
    na
  ) : null : (console.error("No root element found"), null);
}, ModalContext = createContext({ root: null }), useModalContext = () => a__default.useContext(ModalContext), ModalContainer = ({
  className: Bi = "modal-root",
  children: e
}) => {
  const [qi, Xi] = a__default.useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContext.Provider, { value: { root: qi }, children: [
    e,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Xi, className: Bi })
  ] });
}, CreateFolderModal = ({
  visible: Bi,
  onClose: e,
  onCreateFolder: qi
}) => {
  const { register: Xi, handleSubmit: Qi, reset: ta } = useForm({ defaultValues: { name: "" } }), { ref: ra, ...na } = Xi("name"), [la, Ma] = useState(null);
  return useEffect(() => {
    la && la.focus();
  }, [la]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Modal,
    {
      visible: Bi,
      onClose: () => e(!1),
      variant: "fit",
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: Qi((Va) => {
              ta(), qi(Va.name);
            }),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Input,
                {
                  ref: (Va) => {
                    ra(Va), Ma(Va);
                  },
                  className: "block",
                  ...na,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, t$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), a$6 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), H$1 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), t$5 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), t$4 = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), o = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
});
var y$1 = Object.defineProperty, c$5 = Object.getOwnPropertySymbols, f$6 = Object.prototype.hasOwnProperty, g$1 = Object.prototype.propertyIsEnumerable, d$2 = (Bi, e, qi) => e in Bi ? y$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, l$4 = (Bi, e) => {
  for (var qi in e || (e = {}))
    f$6.call(e, qi) && d$2(Bi, qi, e[qi]);
  if (c$5)
    for (var qi of c$5(e))
      g$1.call(e, qi) && d$2(Bi, qi, e[qi]);
  return Bi;
}, a$5 = (Bi, e) => {
  var qi = {};
  for (var Xi in Bi)
    f$6.call(Bi, Xi) && e.indexOf(Xi) < 0 && (qi[Xi] = Bi[Xi]);
  if (Bi != null && c$5)
    for (var Xi of c$5(Bi))
      e.indexOf(Xi) < 0 && g$1.call(Bi, Xi) && (qi[Xi] = Bi[Xi]);
  return qi;
};
const h = forwardRef((Bi, e) => {
  const qi = Bi, {
    alt: Xi,
    color: Qi,
    size: ta,
    weight: ra,
    mirrored: na,
    children: la,
    weights: Ma
  } = qi, Va = a$5(qi, [
    "alt",
    "color",
    "size",
    "weight",
    "mirrored",
    "children",
    "weights"
  ]), to = useContext(o), {
    color: Eo = "currentColor",
    size: So,
    weight: eo = "regular",
    mirrored: rs = !1
  } = to, ko = a$5(to, [
    "color",
    "size",
    "weight",
    "mirrored"
  ]);
  return /* @__PURE__ */ a__default.createElement(
    "svg",
    l$4(l$4({
      ref: e,
      xmlns: "http://www.w3.org/2000/svg",
      width: ta ?? So,
      height: ta ?? So,
      fill: Qi ?? Eo,
      viewBox: "0 0 256 256",
      transform: na || rs ? "scale(-1, 1)" : void 0
    }, ko), Va),
    !!Xi && /* @__PURE__ */ a__default.createElement("title", null, Xi),
    la,
    Ma.get(ra ?? eo)
  );
});
h.displayName = "IconBase";
const b = h;
var f$5 = Object.defineProperty, p$2 = Object.defineProperties, s$4 = Object.getOwnPropertyDescriptors, t$3 = Object.getOwnPropertySymbols, c$4 = Object.prototype.hasOwnProperty, l$3 = Object.prototype.propertyIsEnumerable, m$3 = (Bi, e, qi) => e in Bi ? f$5(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, a$4 = (Bi, e) => {
  for (var qi in e || (e = {}))
    c$4.call(e, qi) && m$3(Bi, qi, e[qi]);
  if (t$3)
    for (var qi of t$3(e))
      l$3.call(e, qi) && m$3(Bi, qi, e[qi]);
  return Bi;
}, i$5 = (Bi, e) => p$2(Bi, s$4(e));
const I = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, i$5(a$4({ ref: e }, Bi), { weights: t$6 })));
I.displayName = "File";
var c$3 = Object.defineProperty, d$1 = Object.defineProperties, f$4 = Object.getOwnPropertyDescriptors, t$2 = Object.getOwnPropertySymbols, i$4 = Object.prototype.hasOwnProperty, l$2 = Object.prototype.propertyIsEnumerable, a$3 = (Bi, e, qi) => e in Bi ? c$3(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, m$2 = (Bi, e) => {
  for (var qi in e || (e = {}))
    i$4.call(e, qi) && a$3(Bi, qi, e[qi]);
  if (t$2)
    for (var qi of t$2(e))
      l$2.call(e, qi) && a$3(Bi, qi, e[qi]);
  return Bi;
}, s$3 = (Bi, e) => d$1(Bi, f$4(e));
const w$1 = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, s$3(m$2({ ref: e }, Bi), { weights: a$6 })));
w$1.displayName = "Folder";
var m$1 = Object.defineProperty, c$2 = Object.defineProperties, d = Object.getOwnPropertyDescriptors, t$1 = Object.getOwnPropertySymbols, f$3 = Object.prototype.hasOwnProperty, i$3 = Object.prototype.propertyIsEnumerable, s$2 = (Bi, e, qi) => e in Bi ? m$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, a$2 = (Bi, e) => {
  for (var qi in e || (e = {}))
    f$3.call(e, qi) && s$2(Bi, qi, e[qi]);
  if (t$1)
    for (var qi of t$1(e))
      i$3.call(e, qi) && s$2(Bi, qi, e[qi]);
  return Bi;
}, l$1 = (Bi, e) => c$2(Bi, d(e));
const P = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, l$1(a$2({ ref: e }, Bi), { weights: H$1 })));
P.displayName = "FolderPlus";
var s$1 = Object.defineProperty, f$2 = Object.defineProperties, p$1 = Object.getOwnPropertyDescriptors, r$1 = Object.getOwnPropertySymbols, c$1 = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable, m = (Bi, e, qi) => e in Bi ? s$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, a$1 = (Bi, e) => {
  for (var qi in e || (e = {}))
    c$1.call(e, qi) && m(Bi, qi, e[qi]);
  if (r$1)
    for (var qi of r$1(e))
      n.call(e, qi) && m(Bi, qi, e[qi]);
  return Bi;
}, i$2 = (Bi, e) => f$2(Bi, p$1(e));
const L = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, i$2(a$1({ ref: e }, Bi), { weights: t$5 })));
L.displayName = "List";
var i$1 = Object.defineProperty, l = Object.defineProperties, f$1 = Object.getOwnPropertyDescriptors, r = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable, a = (Bi, e, qi) => e in Bi ? i$1(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, p = (Bi, e) => {
  for (var qi in e || (e = {}))
    s.call(e, qi) && a(Bi, qi, e[qi]);
  if (r)
    for (var qi of r(e))
      c.call(e, qi) && a(Bi, qi, e[qi]);
  return Bi;
}, t = (Bi, e) => l(Bi, f$1(e));
const R = forwardRef((Bi, e) => /* @__PURE__ */ a__default.createElement(b, t(p({ ref: e }, Bi), { weights: t$4 })));
R.displayName = "UploadSimple";
var pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function Bi(Qi) {
    if (typeof Qi != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(Qi));
  }
  function e(Qi, ta) {
    for (var ra = "", na = 0, la = -1, Ma = 0, Va, to = 0; to <= Qi.length; ++to) {
      if (to < Qi.length)
        Va = Qi.charCodeAt(to);
      else {
        if (Va === 47)
          break;
        Va = 47;
      }
      if (Va === 47) {
        if (!(la === to - 1 || Ma === 1)) if (la !== to - 1 && Ma === 2) {
          if (ra.length < 2 || na !== 2 || ra.charCodeAt(ra.length - 1) !== 46 || ra.charCodeAt(ra.length - 2) !== 46) {
            if (ra.length > 2) {
              var Eo = ra.lastIndexOf("/");
              if (Eo !== ra.length - 1) {
                Eo === -1 ? (ra = "", na = 0) : (ra = ra.slice(0, Eo), na = ra.length - 1 - ra.lastIndexOf("/")), la = to, Ma = 0;
                continue;
              }
            } else if (ra.length === 2 || ra.length === 1) {
              ra = "", na = 0, la = to, Ma = 0;
              continue;
            }
          }
          ta && (ra.length > 0 ? ra += "/.." : ra = "..", na = 2);
        } else
          ra.length > 0 ? ra += "/" + Qi.slice(la + 1, to) : ra = Qi.slice(la + 1, to), na = to - la - 1;
        la = to, Ma = 0;
      } else Va === 46 && Ma !== -1 ? ++Ma : Ma = -1;
    }
    return ra;
  }
  function qi(Qi, ta) {
    var ra = ta.dir || ta.root, na = ta.base || (ta.name || "") + (ta.ext || "");
    return ra ? ra === ta.root ? ra + na : ra + Qi + na : na;
  }
  var Xi = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var ta = "", ra = !1, na, la = arguments.length - 1; la >= -1 && !ra; la--) {
        var Ma;
        la >= 0 ? Ma = arguments[la] : (na === void 0 && (na = process.cwd()), Ma = na), Bi(Ma), Ma.length !== 0 && (ta = Ma + "/" + ta, ra = Ma.charCodeAt(0) === 47);
      }
      return ta = e(ta, !ra), ra ? ta.length > 0 ? "/" + ta : "/" : ta.length > 0 ? ta : ".";
    },
    normalize: function(ta) {
      if (Bi(ta), ta.length === 0) return ".";
      var ra = ta.charCodeAt(0) === 47, na = ta.charCodeAt(ta.length - 1) === 47;
      return ta = e(ta, !ra), ta.length === 0 && !ra && (ta = "."), ta.length > 0 && na && (ta += "/"), ra ? "/" + ta : ta;
    },
    isAbsolute: function(ta) {
      return Bi(ta), ta.length > 0 && ta.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var ta, ra = 0; ra < arguments.length; ++ra) {
        var na = arguments[ra];
        Bi(na), na.length > 0 && (ta === void 0 ? ta = na : ta += "/" + na);
      }
      return ta === void 0 ? "." : Xi.normalize(ta);
    },
    relative: function(ta, ra) {
      if (Bi(ta), Bi(ra), ta === ra || (ta = Xi.resolve(ta), ra = Xi.resolve(ra), ta === ra)) return "";
      for (var na = 1; na < ta.length && ta.charCodeAt(na) === 47; ++na)
        ;
      for (var la = ta.length, Ma = la - na, Va = 1; Va < ra.length && ra.charCodeAt(Va) === 47; ++Va)
        ;
      for (var to = ra.length, Eo = to - Va, So = Ma < Eo ? Ma : Eo, eo = -1, rs = 0; rs <= So; ++rs) {
        if (rs === So) {
          if (Eo > So) {
            if (ra.charCodeAt(Va + rs) === 47)
              return ra.slice(Va + rs + 1);
            if (rs === 0)
              return ra.slice(Va + rs);
          } else Ma > So && (ta.charCodeAt(na + rs) === 47 ? eo = rs : rs === 0 && (eo = 0));
          break;
        }
        var ko = ta.charCodeAt(na + rs), Hs = ra.charCodeAt(Va + rs);
        if (ko !== Hs)
          break;
        ko === 47 && (eo = rs);
      }
      var Ks = "";
      for (rs = na + eo + 1; rs <= la; ++rs)
        (rs === la || ta.charCodeAt(rs) === 47) && (Ks.length === 0 ? Ks += ".." : Ks += "/..");
      return Ks.length > 0 ? Ks + ra.slice(Va + eo) : (Va += eo, ra.charCodeAt(Va) === 47 && ++Va, ra.slice(Va));
    },
    _makeLong: function(ta) {
      return ta;
    },
    dirname: function(ta) {
      if (Bi(ta), ta.length === 0) return ".";
      for (var ra = ta.charCodeAt(0), na = ra === 47, la = -1, Ma = !0, Va = ta.length - 1; Va >= 1; --Va)
        if (ra = ta.charCodeAt(Va), ra === 47) {
          if (!Ma) {
            la = Va;
            break;
          }
        } else
          Ma = !1;
      return la === -1 ? na ? "/" : "." : na && la === 1 ? "//" : ta.slice(0, la);
    },
    basename: function(ta, ra) {
      if (ra !== void 0 && typeof ra != "string") throw new TypeError('"ext" argument must be a string');
      Bi(ta);
      var na = 0, la = -1, Ma = !0, Va;
      if (ra !== void 0 && ra.length > 0 && ra.length <= ta.length) {
        if (ra.length === ta.length && ra === ta) return "";
        var to = ra.length - 1, Eo = -1;
        for (Va = ta.length - 1; Va >= 0; --Va) {
          var So = ta.charCodeAt(Va);
          if (So === 47) {
            if (!Ma) {
              na = Va + 1;
              break;
            }
          } else
            Eo === -1 && (Ma = !1, Eo = Va + 1), to >= 0 && (So === ra.charCodeAt(to) ? --to === -1 && (la = Va) : (to = -1, la = Eo));
        }
        return na === la ? la = Eo : la === -1 && (la = ta.length), ta.slice(na, la);
      } else {
        for (Va = ta.length - 1; Va >= 0; --Va)
          if (ta.charCodeAt(Va) === 47) {
            if (!Ma) {
              na = Va + 1;
              break;
            }
          } else la === -1 && (Ma = !1, la = Va + 1);
        return la === -1 ? "" : ta.slice(na, la);
      }
    },
    extname: function(ta) {
      Bi(ta);
      for (var ra = -1, na = 0, la = -1, Ma = !0, Va = 0, to = ta.length - 1; to >= 0; --to) {
        var Eo = ta.charCodeAt(to);
        if (Eo === 47) {
          if (!Ma) {
            na = to + 1;
            break;
          }
          continue;
        }
        la === -1 && (Ma = !1, la = to + 1), Eo === 46 ? ra === -1 ? ra = to : Va !== 1 && (Va = 1) : ra !== -1 && (Va = -1);
      }
      return ra === -1 || la === -1 || // We saw a non-dot character immediately before the dot
      Va === 0 || // The (right-most) trimmed path component is exactly '..'
      Va === 1 && ra === la - 1 && ra === na + 1 ? "" : ta.slice(ra, la);
    },
    format: function(ta) {
      if (ta === null || typeof ta != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof ta);
      return qi("/", ta);
    },
    parse: function(ta) {
      Bi(ta);
      var ra = { root: "", dir: "", base: "", ext: "", name: "" };
      if (ta.length === 0) return ra;
      var na = ta.charCodeAt(0), la = na === 47, Ma;
      la ? (ra.root = "/", Ma = 1) : Ma = 0;
      for (var Va = -1, to = 0, Eo = -1, So = !0, eo = ta.length - 1, rs = 0; eo >= Ma; --eo) {
        if (na = ta.charCodeAt(eo), na === 47) {
          if (!So) {
            to = eo + 1;
            break;
          }
          continue;
        }
        Eo === -1 && (So = !1, Eo = eo + 1), na === 46 ? Va === -1 ? Va = eo : rs !== 1 && (rs = 1) : Va !== -1 && (rs = -1);
      }
      return Va === -1 || Eo === -1 || // We saw a non-dot character immediately before the dot
      rs === 0 || // The (right-most) trimmed path component is exactly '..'
      rs === 1 && Va === Eo - 1 && Va === to + 1 ? Eo !== -1 && (to === 0 && la ? ra.base = ra.name = ta.slice(1, Eo) : ra.base = ra.name = ta.slice(to, Eo)) : (to === 0 && la ? (ra.name = ta.slice(1, Va), ra.base = ta.slice(1, Eo)) : (ra.name = ta.slice(to, Va), ra.base = ta.slice(to, Eo)), ra.ext = ta.slice(Va, Eo)), to > 0 ? ra.dir = ta.slice(0, to - 1) : la && (ra.dir = "/"), ra;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return Xi.posix = Xi, pathBrowserify = Xi, pathBrowserify;
}
var pathBrowserifyExports = requirePathBrowserify();
const MenuItemStyle = cva([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function MenuItem({ className: Bi = "", ...e }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx($3674c52c6b3c5bce$export$2ce376c2cc3355c8, { ...e, className: MenuItemStyle({}) });
}
const MenuStyle = cva([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function Menu({ children: Bi, button: e, className: qi, isOpen: Xi, setOpen: Qi }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs($3674c52c6b3c5bce$export$27d2ad3c5815583e, { isOpen: Xi, onOpenChange: Qi, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { children: e || /* @__PURE__ */ jsxRuntimeExports.jsx(
      FontAwesomeIcon,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: faBars
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx($07b14b47974efb58$export$5b6b19405a83ff9d, { children: /* @__PURE__ */ jsxRuntimeExports.jsx($3674c52c6b3c5bce$export$d9b273488cd8ce6f, { className: twMerge(MenuStyle({}), qi), children: Bi }) })
  ] });
}
const FileBrowserHeader = observer(
  ({
    store: Bi,
    homeDirectory: e,
    searchDisabled: qi,
    searchBarExtras: Xi
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          disabled: qi,
          value: Bi.searchQuery ?? "",
          onChange: (Qi) => Bi.setSearchQuery(Qi.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          $1e2864c73f66a4da$export$6fb4a10d2c950550,
          {
            onSelect: (Qi) => {
              Qi && Bi.onDrop(Array.from(Qi));
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx($d2b4bc8c273e7be6$export$353f5b6fc5456de1, { className: MenuItemStyle(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { size: 18 }) })
          }
        ),
        Xi && Xi(Bi.searchQuery ?? ""),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, { onAction: () => {
          Bi.setCreateFolderModalVisible(!0);
        }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(P, { size: 18 }),
          " Create Folder"
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => Bi.popToRoot(),
        children: [
          e,
          "/"
        ]
      }
    ),
    Bi.folderHistory.map((Qi, ta) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          ta !== Bi.folderHistory.length - 1 && Bi.popFolderHistoryToIndex(ta);
        },
        children: [
          pathBrowserifyExports.basename(Qi),
          "/"
        ]
      },
      `${Qi}-${ta}`
    ))
  ] })
);
function UploadToast({ files: Bi }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: Bi.map((e) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "pl-4 list-none", children: e.name }, e.name)) })
  ] });
}
class FileBrowserStore {
  constructor(e) {
    cd(this, "searchQuery", null);
    cd(this, "folderHistory", []);
    cd(this, "searchResults", null);
    cd(this, "createFolderModalVisible", !1);
    cd(this, "onSearch");
    cd(this, "onUpload");
    cd(this, "onNavigate");
    cd(this, "searchLoading", !1);
    e ? this.folderHistory = e : this.folderHistory = [], makeAutoObservable(this), this.onDrop = this.onDrop.bind(this), this.pushFolderHistory = this.pushFolderHistory.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(e) {
    this.createFolderModalVisible = e;
  }
  pushFolderHistory(e) {
    this.folderHistory.push(e), this.onNavigate?.(
      this.folderHistory[this.folderHistory.length - 1],
      this.currentFolderPath,
      this.folderHistory
    );
  }
  popFolderHistory() {
    this.folderHistory.pop(), this.onNavigate?.(
      this.folderHistory[this.folderHistory.length - 1],
      this.currentFolderPath,
      this.folderHistory
    );
  }
  popToRoot() {
    this.folderHistory = [], this.onNavigate?.(void 0, this.currentFolderPath, this.folderHistory);
  }
  popFolderHistoryToIndex(e) {
    this.folderHistory = this.folderHistory.slice(0, e + 1), this.onNavigate?.(
      this.folderHistory[e],
      this.currentFolderPath,
      this.folderHistory
    );
  }
  async setSearchResults(e) {
    this.searchResults = e;
  }
  async setSearchQuery(e) {
    if (this.searchQuery = e, e) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(e);
  }
  get currentFolderPath() {
    return this.folderHistory.length === 0 ? "" : this.folderHistory[this.folderHistory.length - 1];
  }
  async onDrop(e) {
    if (e[0].size / (1024 * 1024 * 1024) > 1)
      throw toast("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const Qi = await this.onUpload(e);
        if (!Qi)
          return;
        const ta = toast(/* @__PURE__ */ jsxRuntimeExports.jsx(UploadToast, { files: e }), {
          progress: 0
        });
        Qi.subscribe({
          onProgress: (ra) => {
            toast.update(ta, {
              progress: ra
            });
          },
          onError: (ra) => {
            toast.error("Something went wrong!: " + ra.message);
          },
          onComplete: () => {
            toast.dismiss(ta);
          }
        });
      } catch (Qi) {
        toast.error("Something went wrong!: " + Qi);
      }
  }
}
function selectionIncludes(Bi, e) {
  return !!e.find(
    ({ path: qi, isFolder: Xi }) => Bi.path === qi && Xi === Bi.isFolder
  );
}
function getNewSelection(Bi, e, qi) {
  switch (qi) {
    case Re$2.ALL:
      return selectionIncludes(e, Bi) ? Bi.filter((Xi) => Xi.path !== e.path) : [...Bi, e];
    case Re$2.FILE:
      return e.isFolder ? Bi : selectionIncludes(e, Bi) ? [] : [e];
    case Re$2.DIR:
      return e.isFolder ? selectionIncludes(e, Bi) ? [] : [e] : Bi;
    case Re$2.FILE_LIST:
      return e.isFolder ? Bi : selectionIncludes(e, Bi) ? Bi.filter((Xi) => Xi.path !== e.path) : [...Bi, e];
    case Re$2.NONE:
    default:
      return Bi;
  }
}
const Spacer = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex-grow" });
function PathActions({
  onDelete: Bi,
  path: e,
  onPreview: qi,
  onDownload: Xi,
  onMoveUpAFolder: Qi,
  className: ta = "",
  isOpen: ra,
  setOpen: na
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Menu,
    {
      button: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { className: ta, size: 18, "data-testid": `path-actions-${e.path}` }),
      isOpen: ra,
      setOpen: na,
      children: [
        !e.isFolder && Xi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuItem,
          {
            onAction: async () => {
              Xi(e);
            },
            children: "Download"
          }
        ),
        Qi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          MenuItem,
          {
            onAction: async () => {
              const la = pathBrowserifyExports.dirname(pathBrowserifyExports.dirname(e.path)), Ma = pathBrowserifyExports.basename(e.path), Va = `${la}/${Ma}`;
              Qi(la === "." ? null : { path: e, parent: la, newPath: Va });
            },
            children: "Move Up a Folder"
          }
        ),
        Bi && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onAction: () => Bi(), children: "Delete" }),
        !e.isFolder && qi && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onAction: () => qi(e), children: "Preview" })
      ]
    }
  );
}
const containerStyles = cva(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), S3Container = forwardRef(
  (Bi, e) => {
    const {
      children: qi,
      selected: Xi,
      showCheckbox: Qi = !0,
      style: ta,
      onCheckboxValueChange: ra,
      onClick: na,
      isOver: la,
      path: Ma
    } = Bi;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.div,
      {
        "data-testid": `file-${Ma}`,
        className: containerStyles({ selected: Xi, isOver: la }),
        ref: e,
        style: ta,
        onClick: (Va) => {
          Va.stopPropagation, na?.(Va);
        },
        layout: !0,
        children: [
          Qi && /* @__PURE__ */ jsxRuntimeExports.jsx(
            CheckBox,
            {
              onClick: (Va) => Va.stopPropagation(),
              onChange: (Va) => {
                ra(Va.currentTarget.checked);
              },
              className: "mr-2",
              checked: Xi
            }
          ),
          qi
        ]
      }
    );
  }
), S3File = ({
  path: Bi,
  onClick: e,
  selected: qi,
  readOnly: Xi = !1,
  showFullPath: Qi = !1,
  onDelete: ta,
  style: ra,
  onPreview: na,
  onDownload: la,
  onMoveUpAFolder: Ma,
  showCheckbox: Va = !0
}) => {
  const [, to] = useDrag({
    canDrag: !Xi,
    type: "S3File",
    item: { ...Bi },
    collect: (rs) => ({
      isDragging: rs.isDragging()
    })
  }), Eo = pathBrowserifyExports.basename(Bi.path), [So, eo] = useState(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    S3Container,
    {
      path: Bi.path,
      style: { ...ra },
      onClick: (rs) => {
        rs.stopPropagation();
      },
      showCheckbox: Va,
      onCheckboxValueChange: () => e(Bi),
      selected: qi,
      ref: to,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(I, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Qi ? Bi.path : Eo }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          PathActions,
          {
            className: `${So ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: na,
            path: Bi,
            onDelete: ta ? () => ta?.(Bi) : void 0,
            onMoveUpAFolder: Ma,
            onDownload: la,
            isOpen: So,
            setOpen: eo
          }
        )
      ]
    }
  );
}, S3Folder = ({
  path: Bi,
  onClick: e,
  onDblClick: qi,
  selected: Xi,
  onDrop: Qi,
  readOnly: ta = !1,
  style: ra,
  onDelete: na,
  showActions: la,
  onPreview: Ma,
  showFullPath: Va,
  showCheckbox: to = !0
}) => {
  const Eo = li$1(
    () => {
    },
    () => qi(Bi)
  ), [, So] = useDrag({
    canDrag: !ta,
    type: "S3Folder",
    item: { ...Bi },
    collect: (Hs) => ({
      isDragging: Hs.isDragging()
    })
  }), [eo] = useState(!1), [{ isOver: rs }, ko] = useDrop({
    canDrop: () => !ta,
    accept: ["S3Folder", "S3File"],
    drop: (Hs) => Qi(Hs),
    collect: (Hs) => ({
      isOver: Hs.isOver()
    })
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: ko, style: ra, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    S3Container,
    {
      path: Bi.path,
      selected: Xi,
      isOver: rs,
      onClick: (Hs) => {
        Hs.stopPropagation(), Eo();
      },
      ref: So,
      showCheckbox: to,
      onCheckboxValueChange: () => e(Bi),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(w$1, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: Va ? Bi.path : pathBrowserifyExports.basename(Bi.path) }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        la && Ma && na && eo && /* @__PURE__ */ jsxRuntimeExports.jsx(
          PathActions,
          {
            onPreview: Ma,
            path: Bi,
            onDelete: na ? () => na(Bi) : void 0
          }
        )
      ]
    }
  ) });
};
function useMobxPropSync(Bi, e) {
  useEffect(() => {
    for (const qi in Bi)
      Bi.hasOwnProperty(qi) && Bi[qi] && (e[qi] = Bi[qi]);
  }, [Bi, e]);
}
const FileBrowser = observer(
  ({
    selectionMode: Bi = Re$2.NONE,
    files: e,
    selection: qi,
    onSelectionChange: Xi,
    readOnly: Qi = !1,
    className: ta,
    showActions: ra = !0,
    onDownload: na,
    onMoveUpAFolder: la,
    style: Ma,
    onPreview: Va,
    onDelete: to,
    onMove: Eo,
    onCreateFolder: So,
    onSearch: eo,
    searchDisabled: rs = !1,
    onNavigate: ko,
    filePathHomeDirectory: Hs = "~",
    onUpload: Ks,
    searchBarExtras: Ys,
    initialPath: Xs
  }) => {
    const Cs = useLocalObservable(
      () => new FileBrowserStore(Xs)
    ), { getRootProps: Fs, getInputProps: ws, isDragActive: ls } = useDropzone({
      noClick: !0,
      onDrop: Cs.onDrop
    }), ks = useCallback(
      (bl) => getNewSelection(qi, bl, Bi),
      [qi, Bi]
    ), Js = useCallback(async () => {
      Cs.searchLoading = !0;
      const bl = Cs.searchQuery;
      if (!eo || !bl) {
        Cs.searchLoading = !1;
        return;
      }
      Cs.setSearchResults([]), setTimeout(async () => {
        if (Cs.searchQuery === bl && bl) {
          const xl = await eo(bl);
          if (!xl) return;
          Cs.setSearchResults(xl), Cs.searchLoading = !1;
        }
      }, 500);
    }, [eo, Cs.searchQuery]);
    useEffect(() => {
      Cs.onSearch = Js;
    }, [Js]), useMobxPropSync(
      {
        onUpload: Ks,
        onNavigate: ko
      },
      Cs
    );
    const pl = Cs.searchResults || e, _l = useRef(null);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: twMerge(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          ta
        ),
        style: Ma,
        ...Fs(),
        children: [
          ls && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("input", { className: "z-50 bg-purple-500", ...ws() }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            FileBrowserHeader,
            {
              searchDisabled: rs,
              selection: qi,
              store: Cs,
              homeDirectory: Hs,
              searchBarExtras: Ys
            }
          ) }),
          Bi !== Re$2.NONE && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              CheckBox,
              {
                checked: qi.length > 0,
                onChange: () => {
                  pl && (qi.length === 0 ? Xi?.([...qi, ...pl]) : Xi?.([]));
                }
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: "text-xs", children: [
              qi.length,
              " file",
              qi.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              ref: _l,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(DndProvider, { backend: HTML5Backend, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                pl?.length === 0 && !Cs.searchLoading && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                Cs.searchLoading && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                pl && pl.length > 0 && pl.map((bl) => {
                  const xl = {
                    key: getKey(bl),
                    showActions: ra,
                    readOnly: Qi,
                    onDelete: to ? () => {
                      to([bl]), Xi?.([]);
                    } : void 0,
                    onClick: (Rl) => {
                      const Cl = ks(Rl);
                      Xi?.(Cl);
                    },
                    showFullPath: !!Cs.searchQuery,
                    // show full path if searching
                    path: bl,
                    selected: selectionIncludes(bl, qi),
                    onPreview: Va
                  };
                  return bl.isFolder ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                    S3Folder,
                    {
                      ...xl,
                      showCheckbox: Bi !== Re$2.NONE && Bi !== Re$2.FILE && Bi !== Re$2.FILE_LIST,
                      onDblClick: (Rl) => {
                        Cs.pushFolderHistory(Rl.path), ko?.(
                          Rl.path,
                          Cs.currentFolderPath,
                          Cs.folderHistory
                        );
                      },
                      onDrop: (Rl) => Eo?.(Rl, bl)
                    }
                  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                    S3File,
                    {
                      ...xl,
                      showCheckbox: Bi !== Re$2.NONE && Bi !== Re$2.DIR && Bi !== Re$2.DIR_LIST,
                      onMoveUpAFolder: la,
                      onDownload: na
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CreateFolderModal,
            {
              visible: Cs.createFolderModalVisible,
              onClose: () => Cs.setCreateFolderModalVisible(!1),
              onCreateFolder: async (bl) => {
                const xl = Cs.currentFolderPath, Rl = `${xl}/${bl}`;
                console.log("creating folder", Rl), console.log("current folder", xl), So?.(Rl), Cs.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), getKey = (Bi) => `${Bi.isFolder ? "folder" : "file"}-${Bi.path}`;
var ns = Object.defineProperty, is = (Bi, e, qi) => e in Bi ? ns(Bi, e, { enumerable: !0, configurable: !0, writable: !0, value: qi }) : Bi[e] = qi, mt = (Bi, e, qi) => is(Bi, e + "", qi), Qr = function(Bi, e) {
  return Qr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(qi, Xi) {
    qi.__proto__ = Xi;
  } || function(qi, Xi) {
    for (var Qi in Xi) Object.prototype.hasOwnProperty.call(Xi, Qi) && (qi[Qi] = Xi[Qi]);
  }, Qr(Bi, e);
};
function as(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Qr(Bi, e);
  function qi() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (qi.prototype = e.prototype, new qi());
}
var Sr = "Invariant Violation", Wn = Object.setPrototypeOf, ss = Wn === void 0 ? function(Bi, e) {
  return Bi.__proto__ = e, Bi;
} : Wn, B = (
  /** @class */
  function(Bi) {
    as(e, Bi);
    function e(qi) {
      qi === void 0 && (qi = Sr);
      var Xi = Bi.call(this, typeof qi == "number" ? Sr + ": " + qi + " (see https://github.com/apollographql/invariant-packages)" : qi) || this;
      return Xi.framesToPop = 1, Xi.name = Sr, ss(Xi, e.prototype), Xi;
    }
    return e;
  }(Error)
);
function E(Bi, e) {
  if (!Bi)
    throw new B(e);
}
var Wi = ["debug", "log", "warn", "error", "silent"], os = Wi.indexOf("log");
function Ht(Bi) {
  return function() {
    if (Wi.indexOf(Bi) >= os) {
      var e = console[Bi] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(Bi) {
  Bi.debug = Ht("debug"), Bi.log = Ht("log"), Bi.warn = Ht("warn"), Bi.error = Ht("error");
})(E || (E = {}));
function he(Bi) {
  try {
    return Bi();
  } catch {
  }
}
const Gn = he(function() {
  return globalThis;
}) || he(function() {
  return window;
}) || he(function() {
  return self;
}) || he(function() {
  return global;
}) || he(function() {
  return he.constructor("return this")();
});
var Jn = "__", Hn = [Jn, Jn].join("DEV");
function us() {
  try {
    return !!__DEV__;
  } catch {
    return Object.defineProperty(Gn, Hn, {
      value: he(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), Gn[Hn];
  }
}
const Or = us();
function Fe(Bi) {
  try {
    return Bi();
  } catch {
  }
}
var Br = Fe(function() {
  return globalThis;
}) || Fe(function() {
  return window;
}) || Fe(function() {
  return self;
}) || Fe(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Fe(function() {
  return Fe.constructor("return this")();
}), Zr = !1;
function cs() {
  Br && !Fe(function() {
    return process.env.NODE_ENV;
  }) && !Fe(function() {
    return process;
  }) && (Object.defineProperty(Br, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), Zr = !0);
}
cs();
function Yn() {
  Zr && (delete Br.process, Zr = !1);
}
var Gi = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function fs(Bi, e) {
  throw new Error("Unexpected invariant triggered.");
}
var zr = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function Ji(Bi) {
  var e = Bi.prototype.toJSON;
  typeof e == "function" || fs(), Bi.prototype.inspect = e, zr && (Bi.prototype[zr] = e);
}
var ds = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi) {
    this.start = qi.start, this.end = Xi.end, this.startToken = qi, this.endToken = Xi, this.source = Qi;
  }
  var e = Bi.prototype;
  return e.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, Bi;
}();
Ji(ds);
var hs = /* @__PURE__ */ function() {
  function Bi(qi, Xi, Qi, ta, ra, na, la) {
    this.kind = qi, this.start = Xi, this.end = Qi, this.line = ta, this.column = ra, this.value = la, this.prev = na, this.next = null;
  }
  var e = Bi.prototype;
  return e.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, Bi;
}();
Ji(hs);
function Kn(Bi) {
  return Bi != null && typeof Bi.kind == "string";
}
function Xt(Bi) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xt = function(e) {
    return typeof e;
  } : Xt = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xt(Bi);
}
var ps = 10, Hi = 2;
function Yi(Bi) {
  return yr(Bi, []);
}
function yr(Bi, e) {
  switch (Xt(Bi)) {
    case "string":
      return JSON.stringify(Bi);
    case "function":
      return Bi.name ? "[function ".concat(Bi.name, "]") : "[function]";
    case "object":
      return Bi === null ? "null" : ys(Bi, e);
    default:
      return String(Bi);
  }
}
function ys(Bi, e) {
  if (e.indexOf(Bi) !== -1)
    return "[Circular]";
  var qi = [].concat(e, [Bi]), Xi = gs(Bi);
  if (Xi !== void 0) {
    var Qi = Xi.call(Bi);
    if (Qi !== Bi)
      return typeof Qi == "string" ? Qi : yr(Qi, qi);
  } else if (Array.isArray(Bi))
    return ms(Bi, qi);
  return vs(Bi, qi);
}
function vs(Bi, e) {
  var qi = Object.keys(Bi);
  if (qi.length === 0)
    return "{}";
  if (e.length > Hi)
    return "[" + bs(Bi) + "]";
  var Xi = qi.map(function(Qi) {
    var ta = yr(Bi[Qi], e);
    return Qi + ": " + ta;
  });
  return "{ " + Xi.join(", ") + " }";
}
function ms(Bi, e) {
  if (Bi.length === 0)
    return "[]";
  if (e.length > Hi)
    return "[Array]";
  for (var qi = Math.min(ps, Bi.length), Xi = Bi.length - qi, Qi = [], ta = 0; ta < qi; ++ta)
    Qi.push(yr(Bi[ta], e));
  return Xi === 1 ? Qi.push("... 1 more item") : Xi > 1 && Qi.push("... ".concat(Xi, " more items")), "[" + Qi.join(", ") + "]";
}
function gs(Bi) {
  var e = Bi[String(zr)];
  if (typeof e == "function")
    return e;
  if (typeof Bi.inspect == "function")
    return Bi.inspect;
}
function bs(Bi) {
  var e = Object.prototype.toString.call(Bi).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof Bi.constructor == "function") {
    var qi = Bi.constructor.name;
    if (typeof qi == "string" && qi !== "")
      return qi;
  }
  return e;
}
function Es(Bi) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", qi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, Xi = Bi.indexOf(`
`) === -1, Qi = Bi[0] === " " || Bi[0] === "	", ta = Bi[Bi.length - 1] === '"', ra = Bi[Bi.length - 1] === "\\", na = !Xi || ta || ra || qi, la = "";
  return na && !(Xi && Qi) && (la += `
` + e), la += e ? Bi.replace(/\n/g, `
` + e) : Bi, na && (la += `
`), '"""' + la.replace(/"""/g, '\\"""') + '"""';
}
var Ss = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, mn = Object.freeze({});
function Te(Bi, e) {
  var qi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ss, Xi = void 0, Qi = Array.isArray(Bi), ta = [Bi], ra = -1, na = [], la = void 0, Ma = void 0, Va = void 0, to = [], Eo = [], So = Bi;
  do {
    ra++;
    var eo = ra === ta.length, rs = eo && na.length !== 0;
    if (eo) {
      if (Ma = Eo.length === 0 ? void 0 : to[to.length - 1], la = Va, Va = Eo.pop(), rs) {
        if (Qi)
          la = la.slice();
        else {
          for (var ko = {}, Hs = 0, Ks = Object.keys(la); Hs < Ks.length; Hs++) {
            var Ys = Ks[Hs];
            ko[Ys] = la[Ys];
          }
          la = ko;
        }
        for (var Xs = 0, Cs = 0; Cs < na.length; Cs++) {
          var Fs = na[Cs][0], ws = na[Cs][1];
          Qi && (Fs -= Xs), Qi && ws === null ? (la.splice(Fs, 1), Xs++) : la[Fs] = ws;
        }
      }
      ra = Xi.index, ta = Xi.keys, na = Xi.edits, Qi = Xi.inArray, Xi = Xi.prev;
    } else {
      if (Ma = Va ? Qi ? ra : ta[ra] : void 0, la = Va ? Va[Ma] : So, la == null)
        continue;
      Va && to.push(Ma);
    }
    var ls = void 0;
    if (!Array.isArray(la)) {
      if (!Kn(la))
        throw new Error("Invalid AST Node: ".concat(Yi(la), "."));
      var ks = Os(e, la.kind, eo);
      if (ks) {
        if (ls = ks.call(e, la, Ma, Va, to, Eo), ls === mn)
          break;
        if (ls === !1) {
          if (!eo) {
            to.pop();
            continue;
          }
        } else if (ls !== void 0 && (na.push([Ma, ls]), !eo))
          if (Kn(ls))
            la = ls;
          else {
            to.pop();
            continue;
          }
      }
    }
    if (ls === void 0 && rs && na.push([Ma, la]), eo)
      to.pop();
    else {
      var Js;
      Xi = {
        inArray: Qi,
        index: ra,
        keys: ta,
        edits: na,
        prev: Xi
      }, Qi = Array.isArray(la), ta = Qi ? la : (Js = qi[la.kind]) !== null && Js !== void 0 ? Js : [], ra = -1, na = [], Va && Eo.push(Va), Va = la;
    }
  } while (Xi !== void 0);
  return na.length !== 0 && (So = na[na.length - 1][1]), So;
}
function Os(Bi, e, qi) {
  var Xi = Bi[e];
  if (Xi) {
    if (!qi && typeof Xi == "function")
      return Xi;
    var Qi = qi ? Xi.leave : Xi.enter;
    if (typeof Qi == "function")
      return Qi;
  } else {
    var ta = qi ? Bi.leave : Bi.enter;
    if (ta) {
      if (typeof ta == "function")
        return ta;
      var ra = ta[e];
      if (typeof ra == "function")
        return ra;
    }
  }
}
function Ki(Bi) {
  return Te(Bi, {
    leave: Ts
  });
}
var xs = 80, Ts = {
  Name: function(Bi) {
    return Bi.value;
  },
  Variable: function(Bi) {
    return "$" + Bi.name;
  },
  // Document
  Document: function(Bi) {
    return x(Bi.definitions, `

`) + `
`;
  },
  OperationDefinition: function(Bi) {
    var e = Bi.operation, qi = Bi.name, Xi = J("(", x(Bi.variableDefinitions, ", "), ")"), Qi = x(Bi.directives, " "), ta = Bi.selectionSet;
    return !qi && !Qi && !Xi && e === "query" ? ta : x([e, x([qi, Xi]), Qi, ta], " ");
  },
  VariableDefinition: function(Bi) {
    var e = Bi.variable, qi = Bi.type, Xi = Bi.defaultValue, Qi = Bi.directives;
    return e + ": " + qi + J(" = ", Xi) + J(" ", x(Qi, " "));
  },
  SelectionSet: function(Bi) {
    var e = Bi.selections;
    return ye(e);
  },
  Field: function(Bi) {
    var e = Bi.alias, qi = Bi.name, Xi = Bi.arguments, Qi = Bi.directives, ta = Bi.selectionSet, ra = J("", e, ": ") + qi, na = ra + J("(", x(Xi, ", "), ")");
    return na.length > xs && (na = ra + J(`(
`, er(x(Xi, `
`)), `
)`)), x([na, x(Qi, " "), ta], " ");
  },
  Argument: function(Bi) {
    var e = Bi.name, qi = Bi.value;
    return e + ": " + qi;
  },
  // Fragments
  FragmentSpread: function(Bi) {
    var e = Bi.name, qi = Bi.directives;
    return "..." + e + J(" ", x(qi, " "));
  },
  InlineFragment: function(Bi) {
    var e = Bi.typeCondition, qi = Bi.directives, Xi = Bi.selectionSet;
    return x(["...", J("on ", e), x(qi, " "), Xi], " ");
  },
  FragmentDefinition: function(Bi) {
    var e = Bi.name, qi = Bi.typeCondition, Xi = Bi.variableDefinitions, Qi = Bi.directives, ta = Bi.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(e).concat(J("(", x(Xi, ", "), ")"), " ") + "on ".concat(qi, " ").concat(J("", x(Qi, " "), " ")) + ta
    );
  },
  // Value
  IntValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  FloatValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  StringValue: function(Bi, e) {
    var qi = Bi.value, Xi = Bi.block;
    return Xi ? Es(qi, e === "description" ? "" : "  ") : JSON.stringify(qi);
  },
  BooleanValue: function(Bi) {
    var e = Bi.value;
    return e ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(Bi) {
    var e = Bi.value;
    return e;
  },
  ListValue: function(Bi) {
    var e = Bi.values;
    return "[" + x(e, ", ") + "]";
  },
  ObjectValue: function(Bi) {
    var e = Bi.fields;
    return "{" + x(e, ", ") + "}";
  },
  ObjectField: function(Bi) {
    var e = Bi.name, qi = Bi.value;
    return e + ": " + qi;
  },
  // Directive
  Directive: function(Bi) {
    var e = Bi.name, qi = Bi.arguments;
    return "@" + e + J("(", x(qi, ", "), ")");
  },
  // Type
  NamedType: function(Bi) {
    var e = Bi.name;
    return e;
  },
  ListType: function(Bi) {
    var e = Bi.type;
    return "[" + e + "]";
  },
  NonNullType: function(Bi) {
    var e = Bi.type;
    return e + "!";
  },
  // Type System Definitions
  SchemaDefinition: pe(function(Bi) {
    var e = Bi.directives, qi = Bi.operationTypes;
    return x(["schema", x(e, " "), ye(qi)], " ");
  }),
  OperationTypeDefinition: function(Bi) {
    var e = Bi.operation, qi = Bi.type;
    return e + ": " + qi;
  },
  ScalarTypeDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.directives;
    return x(["scalar", e, x(qi, " ")], " ");
  }),
  ObjectTypeDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.interfaces, Xi = Bi.directives, Qi = Bi.fields;
    return x(["type", e, J("implements ", x(qi, " & ")), x(Xi, " "), ye(Qi)], " ");
  }),
  FieldDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.arguments, Xi = Bi.type, Qi = Bi.directives;
    return e + (Xn(qi) ? J(`(
`, er(x(qi, `
`)), `
)`) : J("(", x(qi, ", "), ")")) + ": " + Xi + J(" ", x(Qi, " "));
  }),
  InputValueDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.type, Xi = Bi.defaultValue, Qi = Bi.directives;
    return x([e + ": " + qi, J("= ", Xi), x(Qi, " ")], " ");
  }),
  InterfaceTypeDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.interfaces, Xi = Bi.directives, Qi = Bi.fields;
    return x(["interface", e, J("implements ", x(qi, " & ")), x(Xi, " "), ye(Qi)], " ");
  }),
  UnionTypeDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.directives, Xi = Bi.types;
    return x(["union", e, x(qi, " "), Xi && Xi.length !== 0 ? "= " + x(Xi, " | ") : ""], " ");
  }),
  EnumTypeDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.directives, Xi = Bi.values;
    return x(["enum", e, x(qi, " "), ye(Xi)], " ");
  }),
  EnumValueDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.directives;
    return x([e, x(qi, " ")], " ");
  }),
  InputObjectTypeDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.directives, Xi = Bi.fields;
    return x(["input", e, x(qi, " "), ye(Xi)], " ");
  }),
  DirectiveDefinition: pe(function(Bi) {
    var e = Bi.name, qi = Bi.arguments, Xi = Bi.repeatable, Qi = Bi.locations;
    return "directive @" + e + (Xn(qi) ? J(`(
`, er(x(qi, `
`)), `
)`) : J("(", x(qi, ", "), ")")) + (Xi ? " repeatable" : "") + " on " + x(Qi, " | ");
  }),
  SchemaExtension: function(Bi) {
    var e = Bi.directives, qi = Bi.operationTypes;
    return x(["extend schema", x(e, " "), ye(qi)], " ");
  },
  ScalarTypeExtension: function(Bi) {
    var e = Bi.name, qi = Bi.directives;
    return x(["extend scalar", e, x(qi, " ")], " ");
  },
  ObjectTypeExtension: function(Bi) {
    var e = Bi.name, qi = Bi.interfaces, Xi = Bi.directives, Qi = Bi.fields;
    return x(["extend type", e, J("implements ", x(qi, " & ")), x(Xi, " "), ye(Qi)], " ");
  },
  InterfaceTypeExtension: function(Bi) {
    var e = Bi.name, qi = Bi.interfaces, Xi = Bi.directives, Qi = Bi.fields;
    return x(["extend interface", e, J("implements ", x(qi, " & ")), x(Xi, " "), ye(Qi)], " ");
  },
  UnionTypeExtension: function(Bi) {
    var e = Bi.name, qi = Bi.directives, Xi = Bi.types;
    return x(["extend union", e, x(qi, " "), Xi && Xi.length !== 0 ? "= " + x(Xi, " | ") : ""], " ");
  },
  EnumTypeExtension: function(Bi) {
    var e = Bi.name, qi = Bi.directives, Xi = Bi.values;
    return x(["extend enum", e, x(qi, " "), ye(Xi)], " ");
  },
  InputObjectTypeExtension: function(Bi) {
    var e = Bi.name, qi = Bi.directives, Xi = Bi.fields;
    return x(["extend input", e, x(qi, " "), ye(Xi)], " ");
  }
};
function pe(Bi) {
  return function(e) {
    return x([e.description, Bi(e)], `
`);
  };
}
function x(Bi) {
  var e, qi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (e = Bi?.filter(function(Xi) {
    return Xi;
  }).join(qi)) !== null && e !== void 0 ? e : "";
}
function ye(Bi) {
  return J(`{
`, er(x(Bi, `
`)), `
}`);
}
function J(Bi, e) {
  var qi = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return e != null && e !== "" ? Bi + e + qi : "";
}
function er(Bi) {
  return J("  ", Bi.replace(/\n/g, `
  `));
}
function Ds(Bi) {
  return Bi.indexOf(`
`) !== -1;
}
function Xn(Bi) {
  return Bi != null && Bi.some(Ds);
}
function Is() {
  return Yn();
}
function Rs() {
  __DEV__ ? E(typeof Or == "boolean", Or) : E(typeof Or == "boolean", 38);
}
Is();
Rs();
var Ur = function(Bi, e) {
  return Ur = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(qi, Xi) {
    qi.__proto__ = Xi;
  } || function(qi, Xi) {
    for (var Qi in Xi) Object.prototype.hasOwnProperty.call(Xi, Qi) && (qi[Qi] = Xi[Qi]);
  }, Ur(Bi, e);
};
function be(Bi, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Ur(Bi, e);
  function qi() {
    this.constructor = Bi;
  }
  Bi.prototype = e === null ? Object.create(e) : (qi.prototype = e.prototype, new qi());
}
var y = function() {
  return y = Object.assign || function(Bi) {
    for (var e, qi = 1, Xi = arguments.length; qi < Xi; qi++) {
      e = arguments[qi];
      for (var Qi in e) Object.prototype.hasOwnProperty.call(e, Qi) && (Bi[Qi] = e[Qi]);
    }
    return Bi;
  }, y.apply(this, arguments);
};
function lt(Bi, e) {
  var qi = {};
  for (var Xi in Bi) Object.prototype.hasOwnProperty.call(Bi, Xi) && e.indexOf(Xi) < 0 && (qi[Xi] = Bi[Xi]);
  if (Bi != null && typeof Object.getOwnPropertySymbols == "function")
    for (var Qi = 0, Xi = Object.getOwnPropertySymbols(Bi); Qi < Xi.length; Qi++)
      e.indexOf(Xi[Qi]) < 0 && Object.prototype.propertyIsEnumerable.call(Bi, Xi[Qi]) && (qi[Xi[Qi]] = Bi[Xi[Qi]]);
  return qi;
}
function Ae(Bi, e, qi, Xi) {
  function Qi(ta) {
    return ta instanceof qi ? ta : new qi(function(ra) {
      ra(ta);
    });
  }
  return new (qi || (qi = Promise))(function(ta, ra) {
    function na(Va) {
      try {
        Ma(Xi.next(Va));
      } catch (to) {
        ra(to);
      }
    }
    function la(Va) {
      try {
        Ma(Xi.throw(Va));
      } catch (to) {
        ra(to);
      }
    }
    function Ma(Va) {
      Va.done ? ta(Va.value) : Qi(Va.value).then(na, la);
    }
    Ma((Xi = Xi.apply(Bi, [])).next());
  });
}
function Me(Bi, e) {
  var qi = { label: 0, sent: function() {
    if (ta[0] & 1) throw ta[1];
    return ta[1];
  }, trys: [], ops: [] }, Xi, Qi, ta, ra;
  return ra = { next: na(0), throw: na(1), return: na(2) }, typeof Symbol == "function" && (ra[Symbol.iterator] = function() {
    return this;
  }), ra;
  function na(Ma) {
    return function(Va) {
      return la([Ma, Va]);
    };
  }
  function la(Ma) {
    if (Xi) throw new TypeError("Generator is already executing.");
    for (; qi; ) try {
      if (Xi = 1, Qi && (ta = Ma[0] & 2 ? Qi.return : Ma[0] ? Qi.throw || ((ta = Qi.return) && ta.call(Qi), 0) : Qi.next) && !(ta = ta.call(Qi, Ma[1])).done) return ta;
      switch (Qi = 0, ta && (Ma = [Ma[0] & 2, ta.value]), Ma[0]) {
        case 0:
        case 1:
          ta = Ma;
          break;
        case 4:
          return qi.label++, { value: Ma[1], done: !1 };
        case 5:
          qi.label++, Qi = Ma[1], Ma = [0];
          continue;
        case 7:
          Ma = qi.ops.pop(), qi.trys.pop();
          continue;
        default:
          if (ta = qi.trys, !(ta = ta.length > 0 && ta[ta.length - 1]) && (Ma[0] === 6 || Ma[0] === 2)) {
            qi = 0;
            continue;
          }
          if (Ma[0] === 3 && (!ta || Ma[1] > ta[0] && Ma[1] < ta[3])) {
            qi.label = Ma[1];
            break;
          }
          if (Ma[0] === 6 && qi.label < ta[1]) {
            qi.label = ta[1], ta = Ma;
            break;
          }
          if (ta && qi.label < ta[2]) {
            qi.label = ta[2], qi.ops.push(Ma);
            break;
          }
          ta[2] && qi.ops.pop(), qi.trys.pop();
          continue;
      }
      Ma = e.call(Bi, qi);
    } catch (Va) {
      Ma = [6, Va], Qi = 0;
    } finally {
      Xi = ta = 0;
    }
    if (Ma[0] & 5) throw Ma[1];
    return { value: Ma[0] ? Ma[1] : void 0, done: !0 };
  }
}
function ir(Bi, e, qi) {
  if (qi || arguments.length === 2) for (var Xi = 0, Qi = e.length, ta; Xi < Qi; Xi++)
    (ta || !(Xi in e)) && (ta || (ta = Array.prototype.slice.call(e, 0, Xi)), ta[Xi] = e[Xi]);
  return Bi.concat(ta || Array.prototype.slice.call(e));
}
function vr(Bi, e) {
  var qi = Bi.directives;
  return !qi || !qi.length ? !0 : Ns(qi).every(function(Xi) {
    var Qi = Xi.directive, ta = Xi.ifArgument, ra = !1;
    return ta.value.kind === "Variable" ? (ra = e && e[ta.value.name.value], __DEV__ ? E(ra !== void 0, "Invalid variable referenced in @".concat(Qi.name.value, " directive.")) : E(ra !== void 0, 39)) : ra = ta.value.value, Qi.name.value === "skip" ? !ra : ra;
  });
}
function gn(Bi, e, qi) {
  var Xi = new Set(Bi), Qi = Xi.size;
  return Te(e, {
    Directive: function(ta) {
      if (Xi.delete(ta.name.value) && !qi)
        return mn;
    }
  }), qi ? !Xi.size : Xi.size < Qi;
}
function js(Bi) {
  var e = Bi.name.value;
  return e === "skip" || e === "include";
}
function Ns(Bi) {
  var e = [];
  return Bi && Bi.length && Bi.forEach(function(qi) {
    if (js(qi)) {
      var Xi = qi.arguments, Qi = qi.name.value;
      __DEV__ ? E(Xi && Xi.length === 1, "Incorrect number of arguments for the @".concat(Qi, " directive.")) : E(Xi && Xi.length === 1, 40);
      var ta = Xi[0];
      __DEV__ ? E(ta.name && ta.name.value === "if", "Invalid argument for the @".concat(Qi, " directive.")) : E(ta.name && ta.name.value === "if", 41);
      var ra = ta.value;
      __DEV__ ? E(ra && (ra.kind === "Variable" || ra.kind === "BooleanValue"), "Argument for the @".concat(Qi, " directive must be a variable or a boolean value.")) : E(ra && (ra.kind === "Variable" || ra.kind === "BooleanValue"), 42), e.push({ directive: qi, ifArgument: ta });
    }
  }), e;
}
function Ps(Bi, e) {
  var qi = e, Xi = [];
  Bi.definitions.forEach(function(ta) {
    if (ta.kind === "OperationDefinition")
      throw __DEV__ ? new B("Found a ".concat(ta.operation, " operation").concat(ta.name ? " named '".concat(ta.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new B(43);
    ta.kind === "FragmentDefinition" && Xi.push(ta);
  }), typeof qi > "u" && (__DEV__ ? E(Xi.length === 1, "Found ".concat(Xi.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : E(Xi.length === 1, 44), qi = Xi[0].name.value);
  var Qi = y(y({}, Bi), { definitions: ir([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: qi
            }
          }
        ]
      }
    }
  ], Bi.definitions, !0) });
  return Qi;
}
function bn(Bi) {
  Bi === void 0 && (Bi = []);
  var e = {};
  return Bi.forEach(function(qi) {
    e[qi.name.value] = qi;
  }), e;
}
function _n(Bi, e) {
  switch (Bi.kind) {
    case "InlineFragment":
      return Bi;
    case "FragmentSpread": {
      var qi = Bi.name.value;
      if (typeof e == "function")
        return e(qi);
      var Xi = e && e[qi];
      return __DEV__ ? E(Xi, "No fragment named ".concat(qi)) : E(Xi, 45), Xi || null;
    }
    default:
      return null;
  }
}
function Y(Bi) {
  return Bi !== null && typeof Bi == "object";
}
function ot(Bi) {
  return { __ref: String(Bi) };
}
function z(Bi) {
  return !!(Bi && typeof Bi == "object" && typeof Bi.__ref == "string");
}
function As(Bi) {
  return Bi.kind === "StringValue";
}
function Ms(Bi) {
  return Bi.kind === "BooleanValue";
}
function Vs(Bi) {
  return Bi.kind === "IntValue";
}
function Ls(Bi) {
  return Bi.kind === "FloatValue";
}
function qs(Bi) {
  return Bi.kind === "Variable";
}
function Qs(Bi) {
  return Bi.kind === "ObjectValue";
}
function Bs(Bi) {
  return Bi.kind === "ListValue";
}
function Zs(Bi) {
  return Bi.kind === "EnumValue";
}
function zs(Bi) {
  return Bi.kind === "NullValue";
}
function ft(Bi, e, qi, Xi) {
  if (Vs(qi) || Ls(qi))
    Bi[e.value] = Number(qi.value);
  else if (Ms(qi) || As(qi))
    Bi[e.value] = qi.value;
  else if (Qs(qi)) {
    var Qi = {};
    qi.fields.map(function(ra) {
      return ft(Qi, ra.name, ra.value, Xi);
    }), Bi[e.value] = Qi;
  } else if (qs(qi)) {
    var ta = (Xi || {})[qi.name.value];
    Bi[e.value] = ta;
  } else if (Bs(qi))
    Bi[e.value] = qi.values.map(function(ra) {
      var na = {};
      return ft(na, e, ra, Xi), na[e.value];
    });
  else if (Zs(qi))
    Bi[e.value] = qi.value;
  else if (zs(qi))
    Bi[e.value] = null;
  else
    throw __DEV__ ? new B('The inline argument "'.concat(e.value, '" of kind "').concat(qi.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new B(54);
}
function Us(Bi, e) {
  var qi = null;
  Bi.directives && (qi = {}, Bi.directives.forEach(function(Qi) {
    qi[Qi.name.value] = {}, Qi.arguments && Qi.arguments.forEach(function(ta) {
      var ra = ta.name, na = ta.value;
      return ft(qi[Qi.name.value], ra, na, e);
    });
  }));
  var Xi = null;
  return Bi.arguments && Bi.arguments.length && (Xi = {}, Bi.arguments.forEach(function(Qi) {
    var ta = Qi.name, ra = Qi.value;
    return ft(Xi, ta, ra, e);
  })), wn(Bi.name.value, Xi, qi);
}
var $s = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], wn = Object.assign(function(Bi, e, qi) {
  if (e && qi && qi.connection && qi.connection.key)
    if (qi.connection.filter && qi.connection.filter.length > 0) {
      var Xi = qi.connection.filter ? qi.connection.filter : [];
      Xi.sort();
      var Qi = {};
      return Xi.forEach(function(na) {
        Qi[na] = e[na];
      }), "".concat(qi.connection.key, "(").concat(gt(Qi), ")");
    } else
      return qi.connection.key;
  var ta = Bi;
  if (e) {
    var ra = gt(e);
    ta += "(".concat(ra, ")");
  }
  return qi && Object.keys(qi).forEach(function(na) {
    $s.indexOf(na) === -1 && (qi[na] && Object.keys(qi[na]).length ? ta += "@".concat(na, "(").concat(gt(qi[na]), ")") : ta += "@".concat(na));
  }), ta;
}, {
  setStringify: function(Bi) {
    var e = gt;
    return gt = Bi, e;
  }
}), gt = function(Bi) {
  return JSON.stringify(Bi, Ws);
};
function Ws(Bi, e) {
  return Y(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(qi, Xi) {
    return qi[Xi] = e[Xi], qi;
  }, {})), e;
}
function mr(Bi, e) {
  if (Bi.arguments && Bi.arguments.length) {
    var qi = {};
    return Bi.arguments.forEach(function(Xi) {
      var Qi = Xi.name, ta = Xi.value;
      return ft(qi, Qi, ta, e);
    }), qi;
  }
  return null;
}
function Je(Bi) {
  return Bi.alias ? Bi.alias.value : Bi.name.value;
}
function $r(Bi, e, qi) {
  if (typeof Bi.__typename == "string")
    return Bi.__typename;
  for (var Xi = 0, Qi = e.selections; Xi < Qi.length; Xi++) {
    var ta = Qi[Xi];
    if (Ce(ta)) {
      if (ta.name.value === "__typename")
        return Bi[Je(ta)];
    } else {
      var ra = $r(Bi, _n(ta, qi).selectionSet, qi);
      if (typeof ra == "string")
        return ra;
    }
  }
}
function Ce(Bi) {
  return Bi.kind === "Field";
}
function gr(Bi) {
  __DEV__ ? E(Bi && Bi.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : E(Bi && Bi.kind === "Document", 46);
  var e = Bi.definitions.filter(function(qi) {
    return qi.kind !== "FragmentDefinition";
  }).map(function(qi) {
    if (qi.kind !== "OperationDefinition")
      throw __DEV__ ? new B('Schema type definitions not allowed in queries. Found: "'.concat(qi.kind, '"')) : new B(47);
    return qi;
  });
  return __DEV__ ? E(e.length <= 1, "Ambiguous GraphQL document: contains ".concat(e.length, " operations")) : E(e.length <= 1, 48), Bi;
}
function Ut(Bi) {
  return gr(Bi), Bi.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function Wr(Bi) {
  return Bi.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function kn(Bi) {
  return Bi.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function ea(Bi) {
  var e = Ut(Bi);
  return __DEV__ ? E(e && e.operation === "query", "Must contain a query definition.") : E(e && e.operation === "query", 49), e;
}
function br(Bi) {
  gr(Bi);
  for (var e, qi = 0, Xi = Bi.definitions; qi < Xi.length; qi++) {
    var Qi = Xi[qi];
    if (Qi.kind === "OperationDefinition") {
      var ta = Qi.operation;
      if (ta === "query" || ta === "mutation" || ta === "subscription")
        return Qi;
    }
    Qi.kind === "FragmentDefinition" && !e && (e = Qi);
  }
  if (e)
    return e;
  throw __DEV__ ? new B("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new B(53);
}
function En(Bi) {
  var e = /* @__PURE__ */ Object.create(null), qi = Bi && Bi.variableDefinitions;
  return qi && qi.length && qi.forEach(function(Xi) {
    Xi.defaultValue && ft(e, Xi.variable.name, Xi.defaultValue);
  }), e;
}
var ti = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
}, On = Object.assign(function(Bi) {
  return Te(Bi, {
    SelectionSet: {
      enter: function(e, qi, Xi) {
        if (!(Xi && Xi.kind === "OperationDefinition")) {
          var Qi = e.selections;
          if (Qi) {
            var ta = Qi.some(function(na) {
              return Ce(na) && (na.name.value === "__typename" || na.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!ta) {
              var ra = Xi;
              if (!(Ce(ra) && ra.directives && ra.directives.some(function(na) {
                return na.name.value === "export";
              })))
                return y(y({}, e), { selections: ir(ir([], Qi, !0), [ti], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(Bi) {
    return Bi === ti;
  }
}), ro = Object.prototype.hasOwnProperty;
function xn(Bi) {
  var e = Bi[0] || {}, qi = Bi.length;
  if (qi > 1)
    for (var Xi = new He(), Qi = 1; Qi < qi; ++Qi)
      e = Xi.merge(e, Bi[Qi]);
  return e;
}
var no = function(Bi, e, qi) {
  return this.merge(Bi[qi], e[qi]);
}, He = function() {
  function Bi(e) {
    e === void 0 && (e = no), this.reconciler = e, this.isObject = Y, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return Bi.prototype.merge = function(e, qi) {
    for (var Xi = this, Qi = [], ta = 2; ta < arguments.length; ta++)
      Qi[ta - 2] = arguments[ta];
    return Y(qi) && Y(e) ? (Object.keys(qi).forEach(function(ra) {
      if (ro.call(e, ra)) {
        var na = e[ra];
        if (qi[ra] !== na) {
          var la = Xi.reconciler.apply(Xi, ir([e, qi, ra], Qi, !1));
          la !== na && (e = Xi.shallowCopyForMerge(e), e[ra] = la);
        }
      } else
        e = Xi.shallowCopyForMerge(e), e[ra] = qi[ra];
    }), e) : qi;
  }, Bi.prototype.shallowCopyForMerge = function(e) {
    return Y(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = y({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
  }, Bi;
}();
function io(Bi, e) {
  var qi = typeof Symbol < "u" && Bi[Symbol.iterator] || Bi["@@iterator"];
  if (qi) return (qi = qi.call(Bi)).next.bind(qi);
  if (Array.isArray(Bi) || (qi = ao(Bi)) || e) {
    qi && (Bi = qi);
    var Xi = 0;
    return function() {
      return Xi >= Bi.length ? { done: !0 } : { done: !1, value: Bi[Xi++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ao(Bi, e) {
  if (Bi) {
    if (typeof Bi == "string") return ii(Bi, e);
    var qi = Object.prototype.toString.call(Bi).slice(8, -1);
    if (qi === "Object" && Bi.constructor && (qi = Bi.constructor.name), qi === "Map" || qi === "Set") return Array.from(Bi);
    if (qi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(qi)) return ii(Bi, e);
  }
}
function ii(Bi, e) {
  (e == null || e > Bi.length) && (e = Bi.length);
  for (var qi = 0, Xi = new Array(e); qi < e; qi++)
    Xi[qi] = Bi[qi];
  return Xi;
}
function ai(Bi, e) {
  for (var qi = 0; qi < e.length; qi++) {
    var Xi = e[qi];
    Xi.enumerable = Xi.enumerable || !1, Xi.configurable = !0, "value" in Xi && (Xi.writable = !0), Object.defineProperty(Bi, Xi.key, Xi);
  }
}
function Tn(Bi, e, qi) {
  return e && ai(Bi.prototype, e), qi && ai(Bi, qi), Object.defineProperty(Bi, "prototype", { writable: !1 }), Bi;
}
var Dn = function() {
  return typeof Symbol == "function";
}, In = function(Bi) {
  return Dn() && !!Symbol[Bi];
}, Rn = function(Bi) {
  return In(Bi) ? Symbol[Bi] : "@@" + Bi;
};
Dn() && !In("observable") && (Symbol.observable = Symbol("observable"));
var so = Rn("iterator"), Gr = Rn("observable"), ia = Rn("species");
function ar(Bi, e) {
  var qi = Bi[e];
  if (qi != null) {
    if (typeof qi != "function") throw new TypeError(qi + " is not a function");
    return qi;
  }
}
function bt(Bi) {
  var e = Bi.constructor;
  return e !== void 0 && (e = e[ia], e === null && (e = void 0)), e !== void 0 ? e : G;
}
function oo(Bi) {
  return Bi instanceof G;
}
function dt(Bi) {
  dt.log ? dt.log(Bi) : setTimeout(function() {
    throw Bi;
  });
}
function tr(Bi) {
  Promise.resolve().then(function() {
    try {
      Bi();
    } catch (e) {
      dt(e);
    }
  });
}
function aa(Bi) {
  var e = Bi._cleanup;
  if (e !== void 0 && (Bi._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var qi = ar(e, "unsubscribe");
        qi && qi.call(e);
      }
    } catch (Xi) {
      dt(Xi);
    }
}
function Jr(Bi) {
  Bi._observer = void 0, Bi._queue = void 0, Bi._state = "closed";
}
function uo(Bi) {
  var e = Bi._queue;
  if (e) {
    Bi._queue = void 0, Bi._state = "ready";
    for (var qi = 0; qi < e.length && (sa(Bi, e[qi].type, e[qi].value), Bi._state !== "closed"); ++qi)
      ;
  }
}
function sa(Bi, e, qi) {
  Bi._state = "running";
  var Xi = Bi._observer;
  try {
    var Qi = ar(Xi, e);
    switch (e) {
      case "next":
        Qi && Qi.call(Xi, qi);
        break;
      case "error":
        if (Jr(Bi), Qi) Qi.call(Xi, qi);
        else throw qi;
        break;
      case "complete":
        Jr(Bi), Qi && Qi.call(Xi);
        break;
    }
  } catch (ta) {
    dt(ta);
  }
  Bi._state === "closed" ? aa(Bi) : Bi._state === "running" && (Bi._state = "ready");
}
function Tr(Bi, e, qi) {
  if (Bi._state !== "closed") {
    if (Bi._state === "buffering") {
      Bi._queue.push({
        type: e,
        value: qi
      });
      return;
    }
    if (Bi._state !== "ready") {
      Bi._state = "buffering", Bi._queue = [{
        type: e,
        value: qi
      }], tr(function() {
        return uo(Bi);
      });
      return;
    }
    sa(Bi, e, qi);
  }
}
var co = /* @__PURE__ */ function() {
  function Bi(qi, Xi) {
    this._cleanup = void 0, this._observer = qi, this._queue = void 0, this._state = "initializing";
    var Qi = new lo(this);
    try {
      this._cleanup = Xi.call(void 0, Qi);
    } catch (ta) {
      Qi.error(ta);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = Bi.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (Jr(this), aa(this));
  }, Tn(Bi, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), Bi;
}(), lo = /* @__PURE__ */ function() {
  function Bi(qi) {
    this._subscription = qi;
  }
  var e = Bi.prototype;
  return e.next = function(qi) {
    Tr(this._subscription, "next", qi);
  }, e.error = function(qi) {
    Tr(this._subscription, "error", qi);
  }, e.complete = function() {
    Tr(this._subscription, "complete");
  }, Tn(Bi, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), Bi;
}(), G = /* @__PURE__ */ function() {
  function Bi(qi) {
    if (!(this instanceof Bi)) throw new TypeError("Observable cannot be called as a function");
    if (typeof qi != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = qi;
  }
  var e = Bi.prototype;
  return e.subscribe = function(qi) {
    return (typeof qi != "object" || qi === null) && (qi = {
      next: qi,
      error: arguments[1],
      complete: arguments[2]
    }), new co(qi, this._subscriber);
  }, e.forEach = function(qi) {
    var Xi = this;
    return new Promise(function(Qi, ta) {
      if (typeof qi != "function") {
        ta(new TypeError(qi + " is not a function"));
        return;
      }
      function ra() {
        na.unsubscribe(), Qi();
      }
      var na = Xi.subscribe({
        next: function(la) {
          try {
            qi(la, ra);
          } catch (Ma) {
            ta(Ma), na.unsubscribe();
          }
        },
        error: ta,
        complete: Qi
      });
    });
  }, e.map = function(qi) {
    var Xi = this;
    if (typeof qi != "function") throw new TypeError(qi + " is not a function");
    var Qi = bt(this);
    return new Qi(function(ta) {
      return Xi.subscribe({
        next: function(ra) {
          try {
            ra = qi(ra);
          } catch (na) {
            return ta.error(na);
          }
          ta.next(ra);
        },
        error: function(ra) {
          ta.error(ra);
        },
        complete: function() {
          ta.complete();
        }
      });
    });
  }, e.filter = function(qi) {
    var Xi = this;
    if (typeof qi != "function") throw new TypeError(qi + " is not a function");
    var Qi = bt(this);
    return new Qi(function(ta) {
      return Xi.subscribe({
        next: function(ra) {
          try {
            if (!qi(ra)) return;
          } catch (na) {
            return ta.error(na);
          }
          ta.next(ra);
        },
        error: function(ra) {
          ta.error(ra);
        },
        complete: function() {
          ta.complete();
        }
      });
    });
  }, e.reduce = function(qi) {
    var Xi = this;
    if (typeof qi != "function") throw new TypeError(qi + " is not a function");
    var Qi = bt(this), ta = arguments.length > 1, ra = !1, na = arguments[1], la = na;
    return new Qi(function(Ma) {
      return Xi.subscribe({
        next: function(Va) {
          var to = !ra;
          if (ra = !0, !to || ta)
            try {
              la = qi(la, Va);
            } catch (Eo) {
              return Ma.error(Eo);
            }
          else
            la = Va;
        },
        error: function(Va) {
          Ma.error(Va);
        },
        complete: function() {
          if (!ra && !ta) return Ma.error(new TypeError("Cannot reduce an empty sequence"));
          Ma.next(la), Ma.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var qi = this, Xi = arguments.length, Qi = new Array(Xi), ta = 0; ta < Xi; ta++)
      Qi[ta] = arguments[ta];
    var ra = bt(this);
    return new ra(function(na) {
      var la, Ma = 0;
      function Va(to) {
        la = to.subscribe({
          next: function(Eo) {
            na.next(Eo);
          },
          error: function(Eo) {
            na.error(Eo);
          },
          complete: function() {
            Ma === Qi.length ? (la = void 0, na.complete()) : Va(ra.from(Qi[Ma++]));
          }
        });
      }
      return Va(qi), function() {
        la && (la.unsubscribe(), la = void 0);
      };
    });
  }, e.flatMap = function(qi) {
    var Xi = this;
    if (typeof qi != "function") throw new TypeError(qi + " is not a function");
    var Qi = bt(this);
    return new Qi(function(ta) {
      var ra = [], na = Xi.subscribe({
        next: function(Ma) {
          if (qi)
            try {
              Ma = qi(Ma);
            } catch (to) {
              return ta.error(to);
            }
          var Va = Qi.from(Ma).subscribe({
            next: function(to) {
              ta.next(to);
            },
            error: function(to) {
              ta.error(to);
            },
            complete: function() {
              var to = ra.indexOf(Va);
              to >= 0 && ra.splice(to, 1), la();
            }
          });
          ra.push(Va);
        },
        error: function(Ma) {
          ta.error(Ma);
        },
        complete: function() {
          la();
        }
      });
      function la() {
        na.closed && ra.length === 0 && ta.complete();
      }
      return function() {
        ra.forEach(function(Ma) {
          return Ma.unsubscribe();
        }), na.unsubscribe();
      };
    });
  }, e[Gr] = function() {
    return this;
  }, Bi.from = function(qi) {
    var Xi = typeof this == "function" ? this : Bi;
    if (qi == null) throw new TypeError(qi + " is not an object");
    var Qi = ar(qi, Gr);
    if (Qi) {
      var ta = Qi.call(qi);
      if (Object(ta) !== ta) throw new TypeError(ta + " is not an object");
      return oo(ta) && ta.constructor === Xi ? ta : new Xi(function(ra) {
        return ta.subscribe(ra);
      });
    }
    if (In("iterator") && (Qi = ar(qi, so), Qi))
      return new Xi(function(ra) {
        tr(function() {
          if (!ra.closed) {
            for (var na = io(Qi.call(qi)), la; !(la = na()).done; ) {
              var Ma = la.value;
              if (ra.next(Ma), ra.closed) return;
            }
            ra.complete();
          }
        });
      });
    if (Array.isArray(qi))
      return new Xi(function(ra) {
        tr(function() {
          if (!ra.closed) {
            for (var na = 0; na < qi.length; ++na)
              if (ra.next(qi[na]), ra.closed) return;
            ra.complete();
          }
        });
      });
    throw new TypeError(qi + " is not observable");
  }, Bi.of = function() {
    for (var qi = arguments.length, Xi = new Array(qi), Qi = 0; Qi < qi; Qi++)
      Xi[Qi] = arguments[Qi];
    var ta = typeof this == "function" ? this : Bi;
    return new ta(function(ra) {
      tr(function() {
        if (!ra.closed) {
          for (var na = 0; na < Xi.length; ++na)
            if (ra.next(Xi[na]), ra.closed) return;
          ra.complete();
        }
      });
    });
  }, Tn(Bi, null, [{
    key: ia,
    get: function() {
      return this;
    }
  }]), Bi;
}();
Dn() && Object.defineProperty(G, Symbol("extensions"), {
  value: {
    symbol: Gr,
    hostReportError: dt
  },
  configurable: !0
});
function fo(Bi) {
  var e, qi = Bi.Symbol;
  if (typeof qi == "function")
    if (qi.observable)
      e = qi.observable;
    else {
      typeof qi.for == "function" ? e = qi.for("https://github.com/benlesh/symbol-observable") : e = qi("https://github.com/benlesh/symbol-observable");
      try {
        qi.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var rt;
typeof self < "u" ? rt = self : typeof window < "u" ? rt = window : typeof global < "u" ? rt = global : typeof module < "u" ? rt = module : rt = Function("return this")();
fo(rt);
var si = G.prototype, oi = "@@observable";
si[oi] || (si[oi] = function() {
  return this;
});
var ho = Object.prototype.toString;
function Cn(Bi) {
  return Hr(Bi);
}
function Hr(Bi, e) {
  switch (ho.call(Bi)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(Bi))
        return e.get(Bi);
      var qi = Bi.slice(0);
      return e.set(Bi, qi), qi.forEach(function(Qi, ta) {
        qi[ta] = Hr(Qi, e);
      }), qi;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(Bi))
        return e.get(Bi);
      var Xi = Object.create(Object.getPrototypeOf(Bi));
      return e.set(Bi, Xi), Object.keys(Bi).forEach(function(Qi) {
        Xi[Qi] = Hr(Bi[Qi], e);
      }), Xi;
    }
    default:
      return Bi;
  }
}
function po(Bi) {
  var e = /* @__PURE__ */ new Set([Bi]);
  return e.forEach(function(qi) {
    Y(qi) && yo(qi) === qi && Object.getOwnPropertyNames(qi).forEach(function(Xi) {
      Y(qi[Xi]) && e.add(qi[Xi]);
    });
  }), Bi;
}
function yo(Bi) {
  if (__DEV__ && !Object.isFrozen(Bi))
    try {
      Object.freeze(Bi);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return Bi;
}
function Yr(Bi) {
  return __DEV__ && po(Bi), Bi;
}
function xt(Bi, e, qi) {
  var Xi = [];
  Bi.forEach(function(Qi) {
    return Qi[e] && Xi.push(Qi);
  }), Xi.forEach(function(Qi) {
    return Qi[e](qi);
  });
}
var et = typeof WeakMap == "function" && he(function() {
  return navigator.product;
}) !== "ReactNative", vo = typeof WeakSet == "function", oa = typeof Symbol == "function" && typeof Symbol.for == "function", _r = oa && Symbol.asyncIterator;
he(function() {
  return window.document.createElement;
});
he(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function ua(Bi) {
  function e(qi) {
    Object.defineProperty(Bi, qi, { value: G });
  }
  return oa && Symbol.species && e(Symbol.species), e("@@species"), Bi;
}
function ui(Bi) {
  return Bi && typeof Bi.then == "function";
}
var Et = function(Bi) {
  be(e, Bi);
  function e(qi) {
    var Xi = Bi.call(this, function(Qi) {
      return Xi.addObserver(Qi), function() {
        return Xi.removeObserver(Qi);
      };
    }) || this;
    return Xi.observers = /* @__PURE__ */ new Set(), Xi.promise = new Promise(function(Qi, ta) {
      Xi.resolve = Qi, Xi.reject = ta;
    }), Xi.handlers = {
      next: function(Qi) {
        Xi.sub !== null && (Xi.latest = ["next", Qi], Xi.notify("next", Qi), xt(Xi.observers, "next", Qi));
      },
      error: function(Qi) {
        var ta = Xi.sub;
        ta !== null && (ta && setTimeout(function() {
          return ta.unsubscribe();
        }), Xi.sub = null, Xi.latest = ["error", Qi], Xi.reject(Qi), Xi.notify("error", Qi), xt(Xi.observers, "error", Qi));
      },
      complete: function() {
        var Qi = Xi.sub;
        if (Qi !== null) {
          var ta = Xi.sources.shift();
          ta ? ui(ta) ? ta.then(function(ra) {
            return Xi.sub = ra.subscribe(Xi.handlers);
          }) : Xi.sub = ta.subscribe(Xi.handlers) : (Qi && setTimeout(function() {
            return Qi.unsubscribe();
          }), Xi.sub = null, Xi.latest && Xi.latest[0] === "next" ? Xi.resolve(Xi.latest[1]) : Xi.resolve(), Xi.notify("complete"), xt(Xi.observers, "complete"));
        }
      }
    }, Xi.nextResultListeners = /* @__PURE__ */ new Set(), Xi.cancel = function(Qi) {
      Xi.reject(Qi), Xi.sources = [], Xi.handlers.complete();
    }, Xi.promise.catch(function(Qi) {
    }), typeof qi == "function" && (qi = [new G(qi)]), ui(qi) ? qi.then(function(Qi) {
      return Xi.start(Qi);
    }, Xi.handlers.error) : Xi.start(qi), Xi;
  }
  return e.prototype.start = function(qi) {
    this.sub === void 0 && (this.sources = Array.from(qi), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(qi) {
    if (this.latest) {
      var Xi = this.latest[0], Qi = qi[Xi];
      Qi && Qi.call(qi, this.latest[1]), this.sub === null && Xi === "next" && qi.complete && qi.complete();
    }
  }, e.prototype.addObserver = function(qi) {
    this.observers.has(qi) || (this.deliverLastMessage(qi), this.observers.add(qi));
  }, e.prototype.removeObserver = function(qi) {
    this.observers.delete(qi) && this.observers.size < 1 && this.handlers.complete();
  }, e.prototype.notify = function(qi, Xi) {
    var Qi = this.nextResultListeners;
    Qi.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), Qi.forEach(function(ta) {
      return ta(qi, Xi);
    }));
  }, e.prototype.beforeNext = function(qi) {
    var Xi = !1;
    this.nextResultListeners.add(function(Qi, ta) {
      Xi || (Xi = !0, qi(Qi, ta));
    });
  }, e;
}(G);
ua(Et);
function Ee(Bi) {
  return Array.isArray(Bi) && Bi.length > 0;
}
function wr() {
  for (var Bi = [], e = 0; e < arguments.length; e++)
    Bi[e] = arguments[e];
  var qi = /* @__PURE__ */ Object.create(null);
  return Bi.forEach(function(Xi) {
    Xi && Object.keys(Xi).forEach(function(Qi) {
      var ta = Xi[Qi];
      ta !== void 0 && (qi[Qi] = ta);
    });
  }), qi;
}
var ci = /* @__PURE__ */ new Map();
function Kr(Bi) {
  var e = ci.get(Bi) || 1;
  return ci.set(Bi, e + 1), "".concat(Bi, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function mo(Bi) {
  var e = Kr("stringifyForDisplay");
  return JSON.stringify(Bi, function(qi, Xi) {
    return Xi === void 0 ? e : Xi;
  }).split(JSON.stringify(e)).join("<undefined>");
}
function li(Bi) {
  return new G(function(e) {
    e.error(Bi);
  });
}
var Xr = function(Bi, e, qi) {
  var Xi = new Error(qi);
  throw Xi.name = "ServerError", Xi.response = Bi, Xi.statusCode = Bi.status, Xi.result = e, Xi;
};
function go(Bi) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], qi = 0, Xi = Object.keys(Bi); qi < Xi.length; qi++) {
    var Qi = Xi[qi];
    if (e.indexOf(Qi) < 0)
      throw __DEV__ ? new B("illegal argument: ".concat(Qi)) : new B(26);
  }
  return Bi;
}
function bo(Bi, e) {
  var qi = y({}, Bi), Xi = function(ta) {
    typeof ta == "function" ? qi = y(y({}, qi), ta(qi)) : qi = y(y({}, qi), ta);
  }, Qi = function() {
    return y({}, qi);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: Xi
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: Qi
  }), e;
}
function _o(Bi) {
  var e = {
    variables: Bi.variables || {},
    extensions: Bi.extensions || {},
    operationName: Bi.operationName,
    query: Bi.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? Wr(e.query) || void 0 : ""), e;
}
function fi(Bi, e) {
  return e ? e(Bi) : G.of();
}
function _t(Bi) {
  return typeof Bi == "function" ? new ze(Bi) : Bi;
}
function Yt(Bi) {
  return Bi.request.length <= 1;
}
var wo = function(Bi) {
  be(e, Bi);
  function e(qi, Xi) {
    var Qi = Bi.call(this, qi) || this;
    return Qi.link = Xi, Qi;
  }
  return e;
}(Error), ze = function() {
  function Bi(e) {
    e && (this.request = e);
  }
  return Bi.empty = function() {
    return new Bi(function() {
      return G.of();
    });
  }, Bi.from = function(e) {
    return e.length === 0 ? Bi.empty() : e.map(_t).reduce(function(qi, Xi) {
      return qi.concat(Xi);
    });
  }, Bi.split = function(e, qi, Xi) {
    var Qi = _t(qi), ta = _t(Xi || new Bi(fi));
    return Yt(Qi) && Yt(ta) ? new Bi(function(ra) {
      return e(ra) ? Qi.request(ra) || G.of() : ta.request(ra) || G.of();
    }) : new Bi(function(ra, na) {
      return e(ra) ? Qi.request(ra, na) || G.of() : ta.request(ra, na) || G.of();
    });
  }, Bi.execute = function(e, qi) {
    return e.request(bo(qi.context, _o(go(qi)))) || G.of();
  }, Bi.concat = function(e, qi) {
    var Xi = _t(e);
    if (Yt(Xi))
      return __DEV__ && E.warn(new wo("You are calling concat on a terminating link, which will have no effect", Xi)), Xi;
    var Qi = _t(qi);
    return Yt(Qi) ? new Bi(function(ta) {
      return Xi.request(ta, function(ra) {
        return Qi.request(ra) || G.of();
      }) || G.of();
    }) : new Bi(function(ta, ra) {
      return Xi.request(ta, function(na) {
        return Qi.request(na, ra) || G.of();
      }) || G.of();
    });
  }, Bi.prototype.split = function(e, qi, Xi) {
    return this.concat(Bi.split(e, qi, Xi || new Bi(fi)));
  }, Bi.prototype.concat = function(e) {
    return Bi.concat(this, e);
  }, Bi.prototype.request = function(e, qi) {
    throw __DEV__ ? new B("request is not implemented") : new B(21);
  }, Bi.prototype.onError = function(e, qi) {
    if (qi && qi.error)
      return qi.error(e), !1;
    throw e;
  }, Bi.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, Bi;
}();
ze.from;
ze.split;
ze.execute;
function Oo(Bi) {
  return !!Bi.body;
}
function xo(Bi) {
  return !!Bi.getReader;
}
function To(Bi) {
  return !!(_r && Bi[Symbol.asyncIterator]);
}
function Do(Bi) {
  return !!Bi.stream;
}
function Io(Bi) {
  return !!Bi.arrayBuffer;
}
function Ro(Bi) {
  return !!Bi.pipe;
}
function Co(Bi) {
  var e, qi = Bi[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return qi.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function jo(Bi) {
  var e = null, qi = null, Xi = !1, Qi = [], ta = [];
  function ra(to) {
    if (!qi) {
      if (ta.length) {
        var Eo = ta.shift();
        if (Array.isArray(Eo) && Eo[0])
          return Eo[0]({ value: to, done: !1 });
      }
      Qi.push(to);
    }
  }
  function na(to) {
    qi = to;
    var Eo = ta.slice();
    Eo.forEach(function(So) {
      So[1](to);
    }), !e || e();
  }
  function la() {
    Xi = !0;
    var to = ta.slice();
    to.forEach(function(Eo) {
      Eo[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, Bi.removeListener("data", ra), Bi.removeListener("error", na), Bi.removeListener("end", la), Bi.removeListener("finish", la), Bi.removeListener("close", la);
  }, Bi.on("data", ra), Bi.on("error", na), Bi.on("end", la), Bi.on("finish", la), Bi.on("close", la);
  function Ma() {
    return new Promise(function(to, Eo) {
      if (qi)
        return Eo(qi);
      if (Qi.length)
        return to({ value: Qi.shift(), done: !1 });
      if (Xi)
        return to({ value: void 0, done: !0 });
      ta.push([to, Eo]);
    });
  }
  var Va = {
    next: function() {
      return Ma();
    }
  };
  return _r && (Va[Symbol.asyncIterator] = function() {
    return this;
  }), Va;
}
function No(Bi) {
  var e = !1, qi = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(Xi, Qi) {
        Bi.then(function(ta) {
          Xi({ value: ta, done: !1 });
        }).catch(Qi);
      }));
    }
  };
  return _r && (qi[Symbol.asyncIterator] = function() {
    return this;
  }), qi;
}
function di(Bi) {
  var e = {
    next: function() {
      return Bi.read();
    }
  };
  return _r && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Po(Bi) {
  var e = Bi;
  if (Oo(Bi) && (e = Bi.body), To(e))
    return Co(e);
  if (xo(e))
    return di(e.getReader());
  if (Do(e))
    return di(e.stream().getReader());
  if (Io(e))
    return No(e.arrayBuffer());
  if (Ro(e))
    return jo(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var hi = Object.prototype.hasOwnProperty;
function Fo(Bi, e) {
  var qi, Xi, Qi;
  return Ae(this, void 0, void 0, function() {
    var ta, ra, na, la, Ma, Va, to, Eo, So, eo, rs, ko, Hs, Ks, Ys, Xs, Cs, Fs, ws, ls;
    return Me(this, function(ks) {
      switch (ks.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          ta = new TextDecoder("utf-8"), ra = (qi = Bi.headers) === null || qi === void 0 ? void 0 : qi.get("content-type"), na = "boundary=", la = ra != null && ra.includes(na) ? ra?.substring(ra?.indexOf(na) + na.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", Ma = "--".concat(la), Va = "", to = Po(Bi), Eo = !0, ks.label = 1;
        case 1:
          return Eo ? [4, to.next()] : [3, 3];
        case 2:
          for (So = ks.sent(), eo = So.value, rs = So.done, ko = typeof eo == "string" ? eo : ta.decode(eo), Eo = !rs, Va += ko, Hs = Va.indexOf(Ma); Hs > -1; ) {
            if (Ks = void 0, ls = [
              Va.slice(0, Hs),
              Va.slice(Hs + Ma.length)
            ], Ks = ls[0], Va = ls[1], Ks.trim()) {
              if (Ys = Ks.indexOf(`\r
\r
`), Xs = Ao(Ks.slice(0, Ys)), Cs = Xs["content-type"], Cs && Cs.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              Fs = Ks.slice(Ys);
              try {
                ws = ca(Bi, Fs.replace(`\r
`, "")), (Object.keys(ws).length > 1 || "data" in ws || "incremental" in ws || "errors" in ws) && ((Xi = e.next) === null || Xi === void 0 || Xi.call(e, ws));
              } catch (Js) {
                jn(Js, e);
              }
            }
            Hs = Va.indexOf(Ma);
          }
          return [3, 1];
        case 3:
          return (Qi = e.complete) === null || Qi === void 0 || Qi.call(e), [2];
      }
    });
  });
}
function Ao(Bi) {
  var e = {};
  return Bi.split(`
`).forEach(function(qi) {
    var Xi = qi.indexOf(":");
    if (Xi > -1) {
      var Qi = qi.slice(0, Xi).trim().toLowerCase(), ta = qi.slice(Xi + 1).trim();
      e[Qi] = ta;
    }
  }), e;
}
function ca(Bi, e) {
  if (Bi.status >= 300) {
    var qi = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    Xr(Bi, qi(), "Response not successful: Received status code ".concat(Bi.status));
  }
  try {
    return JSON.parse(e);
  } catch (Qi) {
    var Xi = Qi;
    throw Xi.name = "ServerParseError", Xi.response = Bi, Xi.statusCode = Bi.status, Xi.bodyText = e, Xi;
  }
}
function jn(Bi, e) {
  var qi, Xi;
  Bi.name !== "AbortError" && (Bi.result && Bi.result.errors && Bi.result.data && ((qi = e.next) === null || qi === void 0 || qi.call(e, Bi.result)), (Xi = e.error) === null || Xi === void 0 || Xi.call(e, Bi));
}
function Mo(Bi, e, qi) {
  Vo(e)(Bi).then(function(Xi) {
    var Qi, ta;
    (Qi = qi.next) === null || Qi === void 0 || Qi.call(qi, Xi), (ta = qi.complete) === null || ta === void 0 || ta.call(qi);
  }).catch(function(Xi) {
    return jn(Xi, qi);
  });
}
function Vo(Bi) {
  return function(e) {
    return e.text().then(function(qi) {
      return ca(e, qi);
    }).then(function(qi) {
      return e.status >= 300 && Xr(e, qi, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(qi) && !hi.call(qi, "data") && !hi.call(qi, "errors") && Xr(e, qi, "Server response was missing for query '".concat(Array.isArray(Bi) ? Bi.map(function(Xi) {
        return Xi.operationName;
      }) : Bi.operationName, "'.")), qi;
    });
  };
}
var tn = function(Bi, e) {
  var qi;
  try {
    qi = JSON.stringify(Bi);
  } catch (Qi) {
    var Xi = __DEV__ ? new B("Network request failed. ".concat(e, " is not serializable: ").concat(Qi.message)) : new B(23);
    throw Xi.parseError = Qi, Xi;
  }
  return qi;
}, Lo = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, qo = {
  accept: "*/*",
  "content-type": "application/json"
}, Qo = {
  method: "POST"
}, Bo = {
  http: Lo,
  headers: qo,
  options: Qo
}, Zo = function(Bi, e) {
  return e(Bi);
};
function zo(Bi, e) {
  for (var qi = [], Xi = 2; Xi < arguments.length; Xi++)
    qi[Xi - 2] = arguments[Xi];
  var Qi = {}, ta = {};
  qi.forEach(function(to) {
    Qi = y(y(y({}, Qi), to.options), { headers: y(y({}, Qi.headers), to.headers) }), to.credentials && (Qi.credentials = to.credentials), ta = y(y({}, ta), to.http);
  }), Qi.headers = Uo(Qi.headers, ta.preserveHeaderCase);
  var ra = Bi.operationName, na = Bi.extensions, la = Bi.variables, Ma = Bi.query, Va = { operationName: ra, variables: la };
  return ta.includeExtensions && (Va.extensions = na), ta.includeQuery && (Va.query = e(Ma, Ki)), {
    options: Qi,
    body: Va
  };
}
function Uo(Bi, e) {
  if (!e) {
    var qi = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(Bi)).forEach(function(ta) {
      qi[ta.toLowerCase()] = Bi[ta];
    }), qi;
  }
  var Xi = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(Bi)).forEach(function(ta) {
    Xi[ta.toLowerCase()] = { originalName: ta, value: Bi[ta] };
  });
  var Qi = /* @__PURE__ */ Object.create(null);
  return Object.keys(Xi).forEach(function(ta) {
    Qi[Xi[ta].originalName] = Xi[ta].value;
  }), Qi;
}
var $o = function(Bi) {
  if (!Bi && typeof fetch > "u")
    throw __DEV__ ? new B(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new B(22);
}, Wo = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var Bi = new AbortController(), e = Bi.signal;
  return { controller: Bi, signal: e };
}, Go = function(Bi, e) {
  var qi = Bi.getContext(), Xi = qi.uri;
  return Xi || (typeof e == "function" ? e(Bi) : e || "/graphql");
};
function Jo(Bi, e) {
  var qi = [], Xi = function(to, Eo) {
    qi.push("".concat(to, "=").concat(encodeURIComponent(Eo)));
  };
  if ("query" in e && Xi("query", e.query), e.operationName && Xi("operationName", e.operationName), e.variables) {
    var Qi = void 0;
    try {
      Qi = tn(e.variables, "Variables map");
    } catch (to) {
      return { parseError: to };
    }
    Xi("variables", Qi);
  }
  if (e.extensions) {
    var ta = void 0;
    try {
      ta = tn(e.extensions, "Extensions map");
    } catch (to) {
      return { parseError: to };
    }
    Xi("extensions", ta);
  }
  var ra = "", na = Bi, la = Bi.indexOf("#");
  la !== -1 && (ra = Bi.substr(la), na = Bi.substr(0, la));
  var Ma = na.indexOf("?") === -1 ? "?" : "&", Va = na + Ma + qi.join("&") + ra;
  return { newURI: Va };
}
var pi = he(function() {
  return fetch;
}), Ho = function(Bi) {
  Bi === void 0 && (Bi = {});
  var e = Bi.uri, qi = e === void 0 ? "/graphql" : e, Xi = Bi.fetch, Qi = Bi.print, ta = Qi === void 0 ? Zo : Qi, ra = Bi.includeExtensions, na = Bi.preserveHeaderCase, la = Bi.useGETForQueries, Ma = Bi.includeUnusedVariables, Va = Ma === void 0 ? !1 : Ma, to = lt(Bi, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && $o(Xi || pi);
  var Eo = {
    http: { includeExtensions: ra, preserveHeaderCase: na },
    options: to.fetchOptions,
    credentials: to.credentials,
    headers: to.headers
  };
  return new ze(function(So) {
    var eo = Go(So, qi), rs = So.getContext(), ko = {};
    if (rs.clientAwareness) {
      var Hs = rs.clientAwareness, Ks = Hs.name, Ys = Hs.version;
      Ks && (ko["apollographql-client-name"] = Ks), Ys && (ko["apollographql-client-version"] = Ys);
    }
    var Xs = y(y({}, ko), rs.headers), Cs = {
      http: rs.http,
      options: rs.fetchOptions,
      credentials: rs.credentials,
      headers: Xs
    }, Fs = zo(So, ta, Bo, Eo, Cs), ws = Fs.options, ls = Fs.body;
    if (ls.variables && !Va) {
      var ks = new Set(Object.keys(ls.variables));
      Te(So.query, {
        Variable: function(kl, Ul, Bl) {
          Bl && Bl.kind !== "VariableDefinition" && ks.delete(kl.name.value);
        }
      }), ks.size && (ls.variables = y({}, ls.variables), ks.forEach(function(kl) {
        delete ls.variables[kl];
      }));
    }
    var Js;
    if (!ws.signal) {
      var pl = Wo(), _l = pl.controller, bl = pl.signal;
      Js = _l, Js && (ws.signal = bl);
    }
    var xl = function(kl) {
      return kl.kind === "OperationDefinition" && kl.operation === "mutation";
    };
    if (la && !So.query.definitions.some(xl) && (ws.method = "GET"), gn(["defer"], So.query) && (ws.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), ws.method === "GET") {
      var Rl = Jo(eo, ls), Cl = Rl.newURI, Dl = Rl.parseError;
      if (Dl)
        return li(Dl);
      eo = Cl;
    } else
      try {
        ws.body = tn(ls, "Payload");
      } catch (kl) {
        return li(kl);
      }
    return new G(function(kl) {
      var Ul = Xi || he(function() {
        return fetch;
      }) || pi;
      return Ul(eo, ws).then(function(Bl) {
        var Zl;
        So.setContext({ response: Bl });
        var Pl = (Zl = Bl.headers) === null || Zl === void 0 ? void 0 : Zl.get("content-type");
        return Pl !== null && /^multipart\/mixed/i.test(Pl) ? Fo(Bl, kl) : Mo(Bl, So, kl);
      }).catch(function(Bl) {
        return jn(Bl, kl);
      }), function() {
        Js && Js.abort();
      };
    });
  });
};
(function(Bi) {
  be(e, Bi);
  function e(qi) {
    qi === void 0 && (qi = {});
    var Xi = Bi.call(this, Ho(qi).request) || this;
    return Xi.options = qi, Xi;
  }
  return e;
})(ze);
var fa = Object.prototype, yi = fa.toString, Yo = fa.hasOwnProperty, vi = Function.prototype.toString, rn = /* @__PURE__ */ new Map();
function re(Bi, e) {
  try {
    return nn(Bi, e);
  } finally {
    rn.clear();
  }
}
function nn(Bi, e) {
  if (Bi === e)
    return !0;
  var qi = yi.call(Bi), Xi = yi.call(e);
  if (qi !== Xi)
    return !1;
  switch (qi) {
    case "[object Array]":
      if (Bi.length !== e.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (gi(Bi, e))
        return !0;
      var Qi = mi(Bi), ta = mi(e), ra = Qi.length;
      if (ra !== ta.length)
        return !1;
      for (var na = 0; na < ra; ++na)
        if (!Yo.call(e, Qi[na]))
          return !1;
      for (var na = 0; na < ra; ++na) {
        var la = Qi[na];
        if (!nn(Bi[la], e[la]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return Bi.name === e.name && Bi.message === e.message;
    case "[object Number]":
      if (Bi !== Bi)
        return e !== e;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +Bi == +e;
    case "[object RegExp]":
    case "[object String]":
      return Bi == "" + e;
    case "[object Map]":
    case "[object Set]": {
      if (Bi.size !== e.size)
        return !1;
      if (gi(Bi, e))
        return !0;
      for (var Ma = Bi.entries(), Va = qi === "[object Map]"; ; ) {
        var to = Ma.next();
        if (to.done)
          break;
        var Eo = to.value, So = Eo[0], eo = Eo[1];
        if (!e.has(So) || Va && !nn(eo, e.get(So)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      Bi = new Uint8Array(Bi), e = new Uint8Array(e);
    // Fall through...
    case "[object DataView]": {
      var rs = Bi.byteLength;
      if (rs === e.byteLength)
        for (; rs-- && Bi[rs] === e[rs]; )
          ;
      return rs === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var ko = vi.call(Bi);
      return ko !== vi.call(e) ? !1 : !eu(ko, Xo);
    }
  }
  return !1;
}
function mi(Bi) {
  return Object.keys(Bi).filter(Ko, Bi);
}
function Ko(Bi) {
  return this[Bi] !== void 0;
}
var Xo = "{ [native code] }";
function eu(Bi, e) {
  var qi = Bi.length - e.length;
  return qi >= 0 && Bi.indexOf(e, qi) === qi;
}
function gi(Bi, e) {
  var qi = rn.get(Bi);
  if (qi) {
    if (qi.has(e))
      return !0;
  } else
    rn.set(Bi, qi = /* @__PURE__ */ new Set());
  return qi.add(e), !1;
}
var ru = function() {
  return /* @__PURE__ */ Object.create(null);
}, da = Array.prototype, nu = da.forEach, iu = da.slice, $t = (
  /** @class */
  function() {
    function Bi(e, qi) {
      e === void 0 && (e = !0), qi === void 0 && (qi = ru), this.weakness = e, this.makeData = qi;
    }
    return Bi.prototype.lookup = function() {
      for (var e = [], qi = 0; qi < arguments.length; qi++)
        e[qi] = arguments[qi];
      return this.lookupArray(e);
    }, Bi.prototype.lookupArray = function(e) {
      var qi = this;
      return nu.call(e, function(Xi) {
        return qi = qi.getChildTrie(Xi);
      }), qi.data || (qi.data = this.makeData(iu.call(e)));
    }, Bi.prototype.getChildTrie = function(e) {
      var qi = this.weakness && au(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), Xi = qi.get(e);
      return Xi || qi.set(e, Xi = new Bi(this.weakness, this.makeData)), Xi;
    }, Bi;
  }()
);
function au(Bi) {
  switch (typeof Bi) {
    case "object":
      if (Bi === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var ae = null, bi = {}, su = 1, ou = function() {
  return (
    /** @class */
    function() {
      function Bi() {
        this.id = [
          "slot",
          su++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return Bi.prototype.hasValue = function() {
        for (var e = ae; e; e = e.parent)
          if (this.id in e.slots) {
            var qi = e.slots[this.id];
            if (qi === bi)
              break;
            return e !== ae && (ae.slots[this.id] = qi), !0;
          }
        return ae && (ae.slots[this.id] = bi), !1;
      }, Bi.prototype.getValue = function() {
        if (this.hasValue())
          return ae.slots[this.id];
      }, Bi.prototype.withValue = function(e, qi, Xi, Qi) {
        var ta, ra = (ta = {
          __proto__: null
        }, ta[this.id] = e, ta), na = ae;
        ae = { parent: na, slots: ra };
        try {
          return qi.apply(Qi, Xi);
        } finally {
          ae = na;
        }
      }, Bi.bind = function(e) {
        var qi = ae;
        return function() {
          var Xi = ae;
          try {
            return ae = qi, e.apply(this, arguments);
          } finally {
            ae = Xi;
          }
        };
      }, Bi.noContext = function(e, qi, Xi) {
        if (ae) {
          var Qi = ae;
          try {
            return ae = null, e.apply(Xi, qi);
          } finally {
            ae = Qi;
          }
        } else
          return e.apply(Xi, qi);
      }, Bi;
    }()
  );
}, Rr = "@wry/context:Slot", Cr = Array, Nn = Cr[Rr] || function() {
  var Bi = ou();
  try {
    Object.defineProperty(Cr, Rr, {
      value: Cr[Rr] = Bi,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return Bi;
  }
}();
Nn.bind;
Nn.noContext;
function uu() {
}
var cu = (
  /** @class */
  function() {
    function Bi(e, qi) {
      e === void 0 && (e = 1 / 0), qi === void 0 && (qi = uu), this.max = e, this.dispose = qi, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    return Bi.prototype.has = function(e) {
      return this.map.has(e);
    }, Bi.prototype.get = function(e) {
      var qi = this.getNode(e);
      return qi && qi.value;
    }, Bi.prototype.getNode = function(e) {
      var qi = this.map.get(e);
      if (qi && qi !== this.newest) {
        var Xi = qi.older, Qi = qi.newer;
        Qi && (Qi.older = Xi), Xi && (Xi.newer = Qi), qi.older = this.newest, qi.older.newer = qi, qi.newer = null, this.newest = qi, qi === this.oldest && (this.oldest = Qi);
      }
      return qi;
    }, Bi.prototype.set = function(e, qi) {
      var Xi = this.getNode(e);
      return Xi ? Xi.value = qi : (Xi = {
        key: e,
        value: qi,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = Xi), this.newest = Xi, this.oldest = this.oldest || Xi, this.map.set(e, Xi), Xi.value);
    }, Bi.prototype.clean = function() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }, Bi.prototype.delete = function(e) {
      var qi = this.map.get(e);
      return qi ? (qi === this.newest && (this.newest = qi.older), qi === this.oldest && (this.oldest = qi.newer), qi.newer && (qi.newer.older = qi.older), qi.older && (qi.older.newer = qi.newer), this.map.delete(e), this.dispose(qi.value, e), !0) : !1;
    }, Bi;
  }()
), kr = new Nn(), jr, lu = Object.prototype.hasOwnProperty, Pn = (jr = Array.from, jr === void 0 ? function(Bi) {
  var e = [];
  return Bi.forEach(function(qi) {
    return e.push(qi);
  }), e;
} : jr);
function Fn(Bi) {
  var e = Bi.unsubscribe;
  typeof e == "function" && (Bi.unsubscribe = void 0, e());
}
var It = [], fu = 100;
function ht(Bi, e) {
  if (!Bi)
    throw new Error(e || "assertion failure");
}
function du(Bi, e) {
  var qi = Bi.length;
  return (
    // Unknown values are not equal to each other.
    qi > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    qi === e.length && // The underlying value or exception must be the same.
    Bi[qi - 1] === e[qi - 1]
  );
}
function ha(Bi) {
  switch (Bi.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return Bi[0];
    case 2:
      throw Bi[1];
  }
}
function hu(Bi) {
  return Bi.slice(0);
}
var pu = (
  /** @class */
  function() {
    function Bi(e) {
      this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Bi.count;
    }
    return Bi.prototype.peek = function() {
      if (this.value.length === 1 && !Ve(this))
        return _i(this), this.value[0];
    }, Bi.prototype.recompute = function(e) {
      return ht(!this.recomputing, "already recomputing"), _i(this), Ve(this) ? yu(this, e) : ha(this.value);
    }, Bi.prototype.setDirty = function() {
      this.dirty || (this.dirty = !0, this.value.length = 0, pa(this), Fn(this));
    }, Bi.prototype.dispose = function() {
      var e = this;
      this.setDirty(), ba(this), An(this, function(qi, Xi) {
        qi.setDirty(), _a(qi, e);
      });
    }, Bi.prototype.forget = function() {
      this.dispose();
    }, Bi.prototype.dependOn = function(e) {
      e.add(this), this.deps || (this.deps = It.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
    }, Bi.prototype.forgetDeps = function() {
      var e = this;
      this.deps && (Pn(this.deps).forEach(function(qi) {
        return qi.delete(e);
      }), this.deps.clear(), It.push(this.deps), this.deps = null);
    }, Bi.count = 0, Bi;
  }()
);
function _i(Bi) {
  var e = kr.getValue();
  if (e)
    return Bi.parents.add(e), e.childValues.has(Bi) || e.childValues.set(Bi, []), Ve(Bi) ? va(e, Bi) : ma(e, Bi), e;
}
function yu(Bi, e) {
  return ba(Bi), kr.withValue(Bi, vu, [Bi, e]), gu(Bi, e) && mu(Bi), ha(Bi.value);
}
function vu(Bi, e) {
  Bi.recomputing = !0, Bi.value.length = 0;
  try {
    Bi.value[0] = Bi.fn.apply(null, e);
  } catch (qi) {
    Bi.value[1] = qi;
  }
  Bi.recomputing = !1;
}
function Ve(Bi) {
  return Bi.dirty || !!(Bi.dirtyChildren && Bi.dirtyChildren.size);
}
function mu(Bi) {
  Bi.dirty = !1, !Ve(Bi) && ya(Bi);
}
function pa(Bi) {
  An(Bi, va);
}
function ya(Bi) {
  An(Bi, ma);
}
function An(Bi, e) {
  var qi = Bi.parents.size;
  if (qi)
    for (var Xi = Pn(Bi.parents), Qi = 0; Qi < qi; ++Qi)
      e(Xi[Qi], Bi);
}
function va(Bi, e) {
  ht(Bi.childValues.has(e)), ht(Ve(e));
  var qi = !Ve(Bi);
  if (!Bi.dirtyChildren)
    Bi.dirtyChildren = It.pop() || /* @__PURE__ */ new Set();
  else if (Bi.dirtyChildren.has(e))
    return;
  Bi.dirtyChildren.add(e), qi && pa(Bi);
}
function ma(Bi, e) {
  ht(Bi.childValues.has(e)), ht(!Ve(e));
  var qi = Bi.childValues.get(e);
  qi.length === 0 ? Bi.childValues.set(e, hu(e.value)) : du(qi, e.value) || Bi.setDirty(), ga(Bi, e), !Ve(Bi) && ya(Bi);
}
function ga(Bi, e) {
  var qi = Bi.dirtyChildren;
  qi && (qi.delete(e), qi.size === 0 && (It.length < fu && It.push(qi), Bi.dirtyChildren = null));
}
function ba(Bi) {
  Bi.childValues.size > 0 && Bi.childValues.forEach(function(e, qi) {
    _a(Bi, qi);
  }), Bi.forgetDeps(), ht(Bi.dirtyChildren === null);
}
function _a(Bi, e) {
  e.parents.delete(Bi), Bi.childValues.delete(e), ga(Bi, e);
}
function gu(Bi, e) {
  if (typeof Bi.subscribe == "function")
    try {
      Fn(Bi), Bi.unsubscribe = Bi.subscribe.apply(null, e);
    } catch {
      return Bi.setDirty(), !1;
    }
  return !0;
}
var bu = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function wa(Bi) {
  var e = /* @__PURE__ */ new Map();
  function qi(Xi) {
    var Qi = kr.getValue();
    if (Qi) {
      var ta = e.get(Xi);
      ta || e.set(Xi, ta = /* @__PURE__ */ new Set()), Qi.dependOn(ta);
    }
  }
  return qi.dirty = function(Xi, Qi) {
    var ta = e.get(Xi);
    if (ta) {
      var ra = Qi && lu.call(bu, Qi) ? Qi : "setDirty";
      Pn(ta).forEach(function(na) {
        return na[ra]();
      }), e.delete(Xi), Fn(ta);
    }
  }, qi;
}
function ka() {
  var Bi = new $t(typeof WeakMap == "function");
  return function() {
    return Bi.lookupArray(arguments);
  };
}
ka();
var Nr = /* @__PURE__ */ new Set();
function sr(Bi, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var qi = new cu(e.max || Math.pow(2, 16), function(Ma) {
    return Ma.dispose();
  }), Xi = e.keyArgs, Qi = e.makeCacheKey || ka(), ta = function() {
    var Ma = Qi.apply(null, Xi ? Xi.apply(null, arguments) : arguments);
    if (Ma === void 0)
      return Bi.apply(null, arguments);
    var Va = qi.get(Ma);
    Va || (qi.set(Ma, Va = new pu(Bi)), Va.subscribe = e.subscribe, Va.forget = function() {
      return qi.delete(Ma);
    });
    var to = Va.recompute(Array.prototype.slice.call(arguments));
    return qi.set(Ma, Va), Nr.add(qi), kr.hasValue() || (Nr.forEach(function(Eo) {
      return Eo.clean();
    }), Nr.clear()), to;
  };
  Object.defineProperty(ta, "size", {
    get: function() {
      return qi.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function ra(Ma) {
    var Va = qi.get(Ma);
    Va && Va.setDirty();
  }
  ta.dirtyKey = ra, ta.dirty = function() {
    ra(Qi.apply(null, arguments));
  };
  function na(Ma) {
    var Va = qi.get(Ma);
    if (Va)
      return Va.peek();
  }
  ta.peekKey = na, ta.peek = function() {
    return na(Qi.apply(null, arguments));
  };
  function la(Ma) {
    return qi.delete(Ma);
  }
  return ta.forgetKey = la, ta.forget = function() {
    return la(Qi.apply(null, arguments));
  }, ta.makeCacheKey = Qi, ta.getKey = Xi ? function() {
    return Qi.apply(null, Xi.apply(null, arguments));
  } : Qi, Object.freeze(ta);
}
var _u = function() {
  function Bi() {
    this.getFragmentDoc = sr(Ps);
  }
  return Bi.prototype.batch = function(e) {
    var qi = this, Xi = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, Qi;
    return this.performTransaction(function() {
      return Qi = e.update(qi);
    }, Xi), Qi;
  }, Bi.prototype.recordOptimisticTransaction = function(e, qi) {
    this.performTransaction(e, qi);
  }, Bi.prototype.transformDocument = function(e) {
    return e;
  }, Bi.prototype.transformForLink = function(e) {
    return e;
  }, Bi.prototype.identify = function(e) {
  }, Bi.prototype.gc = function() {
    return [];
  }, Bi.prototype.modify = function(e) {
    return !1;
  }, Bi.prototype.readQuery = function(e, qi) {
    return qi === void 0 && (qi = !!e.optimistic), this.read(y(y({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: qi }));
  }, Bi.prototype.readFragment = function(e, qi) {
    return qi === void 0 && (qi = !!e.optimistic), this.read(y(y({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: qi }));
  }, Bi.prototype.writeQuery = function(e) {
    var qi = e.id, Xi = e.data, Qi = lt(e, ["id", "data"]);
    return this.write(Object.assign(Qi, {
      dataId: qi || "ROOT_QUERY",
      result: Xi
    }));
  }, Bi.prototype.writeFragment = function(e) {
    var qi = e.id, Xi = e.data, Qi = e.fragment, ta = e.fragmentName, ra = lt(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(ra, {
      query: this.getFragmentDoc(Qi, ta),
      dataId: qi,
      result: Xi
    }));
  }, Bi.prototype.updateQuery = function(e, qi) {
    return this.batch({
      update: function(Xi) {
        var Qi = Xi.readQuery(e), ta = qi(Qi);
        return ta == null ? Qi : (Xi.writeQuery(y(y({}, e), { data: ta })), ta);
      }
    });
  }, Bi.prototype.updateFragment = function(e, qi) {
    return this.batch({
      update: function(Xi) {
        var Qi = Xi.readFragment(e), ta = qi(Qi);
        return ta == null ? Qi : (Xi.writeFragment(y(y({}, e), { data: ta })), ta);
      }
    });
  }, Bi;
}(), Ea = function(Bi) {
  be(e, Bi);
  function e(qi, Xi, Qi, ta) {
    var ra, na = Bi.call(this, qi) || this;
    if (na.message = qi, na.path = Xi, na.query = Qi, na.variables = ta, Array.isArray(na.path)) {
      na.missing = na.message;
      for (var la = na.path.length - 1; la >= 0; --la)
        na.missing = (ra = {}, ra[na.path[la]] = na.missing, ra);
    } else
      na.missing = na.path;
    return na.__proto__ = e.prototype, na;
  }
  return e;
}(Error), te = Object.prototype.hasOwnProperty;
function wt(Bi) {
  return Bi == null;
}
var ee = Array.isArray;
function Sa(Bi, e) {
  var qi = Bi.__typename, Xi = Bi.id, Qi = Bi._id;
  if (typeof qi == "string" && (e && (e.keyObject = wt(Xi) ? wt(Qi) ? void 0 : { _id: Qi } : { id: Xi }), wt(Xi) && !wt(Qi) && (Xi = Qi), !wt(Xi)))
    return "".concat(qi, ":").concat(typeof Xi == "number" || typeof Xi == "string" ? Xi : JSON.stringify(Xi));
}
var Oa = {
  dataIdFromObject: Sa,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function wu(Bi) {
  return wr(Oa, Bi);
}
function xa(Bi) {
  var e = Bi.canonizeResults;
  return e === void 0 ? Oa.canonizeResults : e;
}
function ku(Bi, e) {
  return z(e) ? Bi.get(e.__ref, "__typename") : e && e.__typename;
}
var Ta = /^[_a-z][_0-9a-z]*/i;
function Le(Bi) {
  var e = Bi.match(Ta);
  return e ? e[0] : Bi;
}
function an(Bi, e, qi) {
  return Y(e) ? ee(e) ? e.every(function(Xi) {
    return an(Bi, Xi, qi);
  }) : Bi.selections.every(function(Xi) {
    if (Ce(Xi) && vr(Xi, qi)) {
      var Qi = Je(Xi);
      return te.call(e, Qi) && (!Xi.selectionSet || an(Xi.selectionSet, e[Qi], qi));
    }
    return !0;
  }) : !1;
}
function it(Bi) {
  return Y(Bi) && !z(Bi) && !ee(Bi);
}
function Eu() {
  return new He();
}
function Da(Bi, e) {
  var qi = bn(kn(Bi));
  return {
    fragmentMap: qi,
    lookupFragment: function(Xi) {
      var Qi = qi[Xi];
      return !Qi && e && (Qi = e.lookup(Xi)), Qi || null;
    }
  };
}
var nr = /* @__PURE__ */ Object.create(null), Pr = function() {
  return nr;
}, wi = /* @__PURE__ */ Object.create(null), Rt = function() {
  function Bi(e, qi) {
    var Xi = this;
    this.policies = e, this.group = qi, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(Qi, ta) {
      return Yr(z(Qi) ? Xi.get(Qi.__ref, ta) : Qi && Qi[ta]);
    }, this.canRead = function(Qi) {
      return z(Qi) ? Xi.has(Qi.__ref) : typeof Qi == "object";
    }, this.toReference = function(Qi, ta) {
      if (typeof Qi == "string")
        return ot(Qi);
      if (z(Qi))
        return Qi;
      var ra = Xi.policies.identify(Qi)[0];
      if (ra) {
        var na = ot(ra);
        return ta && Xi.merge(ra, Qi), na;
      }
    };
  }
  return Bi.prototype.toObject = function() {
    return y({}, this.data);
  }, Bi.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, Bi.prototype.get = function(e, qi) {
    if (this.group.depend(e, qi), te.call(this.data, e)) {
      var Xi = this.data[e];
      if (Xi && te.call(Xi, qi))
        return Xi[qi];
    }
    if (qi === "__typename" && te.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof Pe)
      return this.parent.get(e, qi);
  }, Bi.prototype.lookup = function(e, qi) {
    if (qi && this.group.depend(e, "__exists"), te.call(this.data, e))
      return this.data[e];
    if (this instanceof Pe)
      return this.parent.lookup(e, qi);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, Bi.prototype.merge = function(e, qi) {
    var Xi = this, Qi;
    z(e) && (e = e.__ref), z(qi) && (qi = qi.__ref);
    var ta = typeof e == "string" ? this.lookup(Qi = e) : e, ra = typeof qi == "string" ? this.lookup(Qi = qi) : qi;
    if (ra) {
      __DEV__ ? E(typeof Qi == "string", "store.merge expects a string ID") : E(typeof Qi == "string", 1);
      var na = new He(Ou).merge(ta, ra);
      if (this.data[Qi] = na, na !== ta && (delete this.refs[Qi], this.group.caching)) {
        var la = /* @__PURE__ */ Object.create(null);
        ta || (la.__exists = 1), Object.keys(ra).forEach(function(Ma) {
          if (!ta || ta[Ma] !== na[Ma]) {
            la[Ma] = 1;
            var Va = Le(Ma);
            Va !== Ma && !Xi.policies.hasKeyArgs(na.__typename, Va) && (la[Va] = 1), na[Ma] === void 0 && !(Xi instanceof Pe) && delete na[Ma];
          }
        }), la.__typename && !(ta && ta.__typename) && this.policies.rootTypenamesById[Qi] === na.__typename && delete la.__typename, Object.keys(la).forEach(function(Ma) {
          return Xi.group.dirty(Qi, Ma);
        });
      }
    }
  }, Bi.prototype.modify = function(e, qi) {
    var Xi = this, Qi = this.lookup(e);
    if (Qi) {
      var ta = /* @__PURE__ */ Object.create(null), ra = !1, na = !0, la = {
        DELETE: nr,
        INVALIDATE: wi,
        isReference: z,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(Ma, Va) {
          return Xi.policies.readField(typeof Ma == "string" ? {
            fieldName: Ma,
            from: Va || ot(e)
          } : Ma, { store: Xi });
        }
      };
      if (Object.keys(Qi).forEach(function(Ma) {
        var Va = Le(Ma), to = Qi[Ma];
        if (to !== void 0) {
          var Eo = typeof qi == "function" ? qi : qi[Ma] || qi[Va];
          if (Eo) {
            var So = Eo === Pr ? nr : Eo(Yr(to), y(y({}, la), { fieldName: Va, storeFieldName: Ma, storage: Xi.getStorage(e, Ma) }));
            So === wi ? Xi.group.dirty(e, Ma) : (So === nr && (So = void 0), So !== to && (ta[Ma] = So, ra = !0, to = So));
          }
          to !== void 0 && (na = !1);
        }
      }), ra)
        return this.merge(e, ta), na && (this instanceof Pe ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, Bi.prototype.delete = function(e, qi, Xi) {
    var Qi, ta = this.lookup(e);
    if (ta) {
      var ra = this.getFieldValue(ta, "__typename"), na = qi && Xi ? this.policies.getStoreFieldName({ typename: ra, fieldName: qi, args: Xi }) : qi;
      return this.modify(e, na ? (Qi = {}, Qi[na] = Pr, Qi) : Pr);
    }
    return !1;
  }, Bi.prototype.evict = function(e, qi) {
    var Xi = !1;
    return e.id && (te.call(this.data, e.id) && (Xi = this.delete(e.id, e.fieldName, e.args)), this instanceof Pe && this !== qi && (Xi = this.parent.evict(e, qi) || Xi), (e.fieldName || Xi) && this.group.dirty(e.id, e.fieldName || "__exists")), Xi;
  }, Bi.prototype.clear = function() {
    this.replace(null);
  }, Bi.prototype.extract = function() {
    var e = this, qi = this.toObject(), Xi = [];
    return this.getRootIdSet().forEach(function(Qi) {
      te.call(e.policies.rootTypenamesById, Qi) || Xi.push(Qi);
    }), Xi.length && (qi.__META = { extraRootIds: Xi.sort() }), qi;
  }, Bi.prototype.replace = function(e) {
    var qi = this;
    if (Object.keys(this.data).forEach(function(ta) {
      e && te.call(e, ta) || qi.delete(ta);
    }), e) {
      var Xi = e.__META, Qi = lt(e, ["__META"]);
      Object.keys(Qi).forEach(function(ta) {
        qi.merge(ta, Qi[ta]);
      }), Xi && Xi.extraRootIds.forEach(this.retain, this);
    }
  }, Bi.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, Bi.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var qi = --this.rootIds[e];
      return qi || delete this.rootIds[e], qi;
    }
    return 0;
  }, Bi.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Pe ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, Bi.prototype.gc = function() {
    var e = this, qi = this.getRootIdSet(), Xi = this.toObject();
    qi.forEach(function(ra) {
      te.call(Xi, ra) && (Object.keys(e.findChildRefIds(ra)).forEach(qi.add, qi), delete Xi[ra]);
    });
    var Qi = Object.keys(Xi);
    if (Qi.length) {
      for (var ta = this; ta instanceof Pe; )
        ta = ta.parent;
      Qi.forEach(function(ra) {
        return ta.delete(ra);
      });
    }
    return Qi;
  }, Bi.prototype.findChildRefIds = function(e) {
    if (!te.call(this.refs, e)) {
      var qi = this.refs[e] = /* @__PURE__ */ Object.create(null), Xi = this.data[e];
      if (!Xi)
        return qi;
      var Qi = /* @__PURE__ */ new Set([Xi]);
      Qi.forEach(function(ta) {
        z(ta) && (qi[ta.__ref] = !0), Y(ta) && Object.keys(ta).forEach(function(ra) {
          var na = ta[ra];
          Y(na) && Qi.add(na);
        });
      });
    }
    return this.refs[e];
  }, Bi.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, Bi;
}(), Ia = function() {
  function Bi(e, qi) {
    qi === void 0 && (qi = null), this.caching = e, this.parent = qi, this.d = null, this.resetCaching();
  }
  return Bi.prototype.resetCaching = function() {
    this.d = this.caching ? wa() : null, this.keyMaker = new $t(et);
  }, Bi.prototype.depend = function(e, qi) {
    if (this.d) {
      this.d(Fr(e, qi));
      var Xi = Le(qi);
      Xi !== qi && this.d(Fr(e, Xi)), this.parent && this.parent.depend(e, qi);
    }
  }, Bi.prototype.dirty = function(e, qi) {
    this.d && this.d.dirty(Fr(e, qi), qi === "__exists" ? "forget" : "setDirty");
  }, Bi;
}();
function Fr(Bi, e) {
  return e + "#" + Bi;
}
function ki(Bi, e) {
  Tt(Bi) && Bi.group.depend(e, "__exists");
}
(function(Bi) {
  var e = function(qi) {
    be(Xi, qi);
    function Xi(Qi) {
      var ta = Qi.policies, ra = Qi.resultCaching, na = ra === void 0 ? !0 : ra, la = Qi.seed, Ma = qi.call(this, ta, new Ia(na)) || this;
      return Ma.stump = new Su(Ma), Ma.storageTrie = new $t(et), la && Ma.replace(la), Ma;
    }
    return Xi.prototype.addLayer = function(Qi, ta) {
      return this.stump.addLayer(Qi, ta);
    }, Xi.prototype.removeLayer = function() {
      return this;
    }, Xi.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, Xi;
  }(Bi);
  Bi.Root = e;
})(Rt || (Rt = {}));
var Pe = function(Bi) {
  be(e, Bi);
  function e(qi, Xi, Qi, ta) {
    var ra = Bi.call(this, Xi.policies, ta) || this;
    return ra.id = qi, ra.parent = Xi, ra.replay = Qi, ra.group = ta, Qi(ra), ra;
  }
  return e.prototype.addLayer = function(qi, Xi) {
    return new e(qi, this, Xi, this.group);
  }, e.prototype.removeLayer = function(qi) {
    var Xi = this, Qi = this.parent.removeLayer(qi);
    return qi === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(ta) {
      var ra = Xi.data[ta], na = Qi.lookup(ta);
      na ? ra ? ra !== na && Object.keys(ra).forEach(function(la) {
        re(ra[la], na[la]) || Xi.group.dirty(ta, la);
      }) : (Xi.group.dirty(ta, "__exists"), Object.keys(na).forEach(function(la) {
        Xi.group.dirty(ta, la);
      })) : Xi.delete(ta);
    }), Qi) : Qi === this.parent ? this : Qi.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return y(y({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(qi) {
    var Xi = this.parent.findChildRefIds(qi);
    return te.call(this.data, qi) ? y(y({}, Xi), Bi.prototype.findChildRefIds.call(this, qi)) : Xi;
  }, e.prototype.getStorage = function() {
    for (var qi = this.parent; qi.parent; )
      qi = qi.parent;
    return qi.getStorage.apply(qi, arguments);
  }, e;
}(Rt), Su = function(Bi) {
  be(e, Bi);
  function e(qi) {
    return Bi.call(this, "EntityStore.Stump", qi, function() {
    }, new Ia(qi.group.caching, qi.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(Pe);
function Ou(Bi, e, qi) {
  var Xi = Bi[qi], Qi = e[qi];
  return re(Xi, Qi) ? Xi : Qi;
}
function Tt(Bi) {
  return !!(Bi instanceof Rt && Bi.group.caching);
}
function xu(Bi) {
  return Y(Bi) ? ee(Bi) ? Bi.slice(0) : y({ __proto__: Object.getPrototypeOf(Bi) }, Bi) : Bi;
}
var sn = function() {
  function Bi() {
    this.known = new (vo ? WeakSet : Set)(), this.pool = new $t(et), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return Bi.prototype.isKnown = function(e) {
    return Y(e) && this.known.has(e);
  }, Bi.prototype.pass = function(e) {
    if (Y(e)) {
      var qi = xu(e);
      return this.passes.set(qi, e), qi;
    }
    return e;
  }, Bi.prototype.admit = function(e) {
    var qi = this;
    if (Y(e)) {
      var Xi = this.passes.get(e);
      if (Xi)
        return Xi;
      var Qi = Object.getPrototypeOf(e);
      switch (Qi) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var ta = e.map(this.admit, this), ra = this.pool.lookupArray(ta);
          return ra.array || (this.known.add(ra.array = ta), __DEV__ && Object.freeze(ta)), ra.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var na = Object.getPrototypeOf(e), la = [na], Ma = this.sortedKeys(e);
          la.push(Ma.json);
          var Va = la.length;
          Ma.sorted.forEach(function(So) {
            la.push(qi.admit(e[So]));
          });
          var ra = this.pool.lookupArray(la);
          if (!ra.object) {
            var to = ra.object = Object.create(na);
            this.known.add(to), Ma.sorted.forEach(function(So, eo) {
              to[So] = la[Va + eo];
            }), __DEV__ && Object.freeze(to);
          }
          return ra.object;
        }
      }
    }
    return e;
  }, Bi.prototype.sortedKeys = function(e) {
    var qi = Object.keys(e), Xi = this.pool.lookupArray(qi);
    if (!Xi.keys) {
      qi.sort();
      var Qi = JSON.stringify(qi);
      (Xi.keys = this.keysByJSON.get(Qi)) || this.keysByJSON.set(Qi, Xi.keys = { sorted: qi, json: Qi });
    }
    return Xi.keys;
  }, Bi;
}(), We = Object.assign(function(Bi) {
  if (Y(Bi)) {
    on === void 0 && Ei();
    var e = on.admit(Bi), qi = un.get(e);
    return qi === void 0 && un.set(e, qi = JSON.stringify(e)), qi;
  }
  return JSON.stringify(Bi);
}, {
  reset: Ei
}), on, un;
function Ei() {
  on = new sn(), un = new (et ? WeakMap : Map)();
}
function Si(Bi) {
  return [
    Bi.selectionSet,
    Bi.objectOrReference,
    Bi.context,
    Bi.context.canonizeResults
  ];
}
var Tu = function() {
  function Bi(e) {
    var qi = this;
    this.knownResults = new (et ? WeakMap : Map)(), this.config = wr(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: xa(e)
    }), this.canon = e.canon || new sn(), this.executeSelectionSet = sr(function(Xi) {
      var Qi, ta = Xi.context.canonizeResults, ra = Si(Xi);
      ra[3] = !ta;
      var na = (Qi = qi.executeSelectionSet).peek.apply(Qi, ra);
      return na ? ta ? y(y({}, na), { result: qi.canon.admit(na.result) }) : na : (ki(Xi.context.store, Xi.enclosingRef.__ref), qi.execSelectionSetImpl(Xi));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: Si,
      makeCacheKey: function(Xi, Qi, ta, ra) {
        if (Tt(ta.store))
          return ta.store.makeCacheKey(Xi, z(Qi) ? Qi.__ref : Qi, ta.varString, ra);
      }
    }), this.executeSubSelectedArray = sr(function(Xi) {
      return ki(Xi.context.store, Xi.enclosingRef.__ref), qi.execSubSelectedArrayImpl(Xi);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(Xi) {
        var Qi = Xi.field, ta = Xi.array, ra = Xi.context;
        if (Tt(ra.store))
          return ra.store.makeCacheKey(Qi, ta, ra.varString);
      }
    });
  }
  return Bi.prototype.resetCanon = function() {
    this.canon = new sn();
  }, Bi.prototype.diffQueryAgainstStore = function(e) {
    var qi = e.store, Xi = e.query, Qi = e.rootId, ta = Qi === void 0 ? "ROOT_QUERY" : Qi, ra = e.variables, na = e.returnPartialData, la = na === void 0 ? !0 : na, Ma = e.canonizeResults, Va = Ma === void 0 ? this.config.canonizeResults : Ma, to = this.config.cache.policies;
    ra = y(y({}, En(ea(Xi))), ra);
    var Eo = ot(ta), So = this.executeSelectionSet({
      selectionSet: br(Xi).selectionSet,
      objectOrReference: Eo,
      enclosingRef: Eo,
      context: y({ store: qi, query: Xi, policies: to, variables: ra, varString: We(ra), canonizeResults: Va }, Da(Xi, this.config.fragments))
    }), eo;
    if (So.missing && (eo = [new Ea(Du(So.missing), So.missing, Xi, ra)], !la))
      throw eo[0];
    return {
      result: So.result,
      complete: !eo,
      missing: eo
    };
  }, Bi.prototype.isFresh = function(e, qi, Xi, Qi) {
    if (Tt(Qi.store) && this.knownResults.get(e) === Xi) {
      var ta = this.executeSelectionSet.peek(Xi, qi, Qi, this.canon.isKnown(e));
      if (ta && e === ta.result)
        return !0;
    }
    return !1;
  }, Bi.prototype.execSelectionSetImpl = function(e) {
    var qi = this, Xi = e.selectionSet, Qi = e.objectOrReference, ta = e.enclosingRef, ra = e.context;
    if (z(Qi) && !ra.policies.rootTypenamesById[Qi.__ref] && !ra.store.has(Qi.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(Qi.__ref, " object")
      };
    var na = ra.variables, la = ra.policies, Ma = ra.store, Va = Ma.getFieldValue(Qi, "__typename"), to = [], Eo, So = new He();
    this.config.addTypename && typeof Va == "string" && !la.rootIdsByTypename[Va] && to.push({ __typename: Va });
    function eo(Ys, Xs) {
      var Cs;
      return Ys.missing && (Eo = So.merge(Eo, (Cs = {}, Cs[Xs] = Ys.missing, Cs))), Ys.result;
    }
    var rs = new Set(Xi.selections);
    rs.forEach(function(Ys) {
      var Xs, Cs;
      if (vr(Ys, na))
        if (Ce(Ys)) {
          var Fs = la.readField({
            fieldName: Ys.name.value,
            field: Ys,
            variables: ra.variables,
            from: Qi
          }, ra), ws = Je(Ys);
          Fs === void 0 ? On.added(Ys) || (Eo = So.merge(Eo, (Xs = {}, Xs[ws] = "Can't find field '".concat(Ys.name.value, "' on ").concat(z(Qi) ? Qi.__ref + " object" : "object " + JSON.stringify(Qi, null, 2)), Xs))) : ee(Fs) ? Fs = eo(qi.executeSubSelectedArray({
            field: Ys,
            array: Fs,
            enclosingRef: ta,
            context: ra
          }), ws) : Ys.selectionSet ? Fs != null && (Fs = eo(qi.executeSelectionSet({
            selectionSet: Ys.selectionSet,
            objectOrReference: Fs,
            enclosingRef: z(Fs) ? Fs : ta,
            context: ra
          }), ws)) : ra.canonizeResults && (Fs = qi.canon.pass(Fs)), Fs !== void 0 && to.push((Cs = {}, Cs[ws] = Fs, Cs));
        } else {
          var ls = _n(Ys, ra.lookupFragment);
          if (!ls && Ys.kind === Gi.FRAGMENT_SPREAD)
            throw __DEV__ ? new B("No fragment named ".concat(Ys.name.value)) : new B(5);
          ls && la.fragmentMatches(ls, Va) && ls.selectionSet.selections.forEach(rs.add, rs);
        }
    });
    var ko = xn(to), Hs = { result: ko, missing: Eo }, Ks = ra.canonizeResults ? this.canon.admit(Hs) : Yr(Hs);
    return Ks.result && this.knownResults.set(Ks.result, Xi), Ks;
  }, Bi.prototype.execSubSelectedArrayImpl = function(e) {
    var qi = this, Xi = e.field, Qi = e.array, ta = e.enclosingRef, ra = e.context, na, la = new He();
    function Ma(Va, to) {
      var Eo;
      return Va.missing && (na = la.merge(na, (Eo = {}, Eo[to] = Va.missing, Eo))), Va.result;
    }
    return Xi.selectionSet && (Qi = Qi.filter(ra.store.canRead)), Qi = Qi.map(function(Va, to) {
      return Va === null ? null : ee(Va) ? Ma(qi.executeSubSelectedArray({
        field: Xi,
        array: Va,
        enclosingRef: ta,
        context: ra
      }), to) : Xi.selectionSet ? Ma(qi.executeSelectionSet({
        selectionSet: Xi.selectionSet,
        objectOrReference: Va,
        enclosingRef: z(Va) ? Va : ta,
        context: ra
      }), to) : (__DEV__ && Iu(ra.store, Xi, Va), Va);
    }), {
      result: ra.canonizeResults ? this.canon.admit(Qi) : Qi,
      missing: na
    };
  }, Bi;
}();
function Du(Bi) {
  try {
    JSON.stringify(Bi, function(e, qi) {
      if (typeof qi == "string")
        throw qi;
      return qi;
    });
  } catch (e) {
    return e;
  }
}
function Iu(Bi, e, qi) {
  if (!e.selectionSet) {
    var Xi = /* @__PURE__ */ new Set([qi]);
    Xi.forEach(function(Qi) {
      Y(Qi) && (__DEV__ ? E(!z(Qi), "Missing selection set for object of type ".concat(ku(Bi, Qi), " returned for query field ").concat(e.name.value)) : E(!z(Qi), 6), Object.values(Qi).forEach(Xi.add, Xi));
    });
  }
}
var se = null, Oi = {}, Ru = 1, Cu = function() {
  return (
    /** @class */
    function() {
      function Bi() {
        this.id = [
          "slot",
          Ru++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return Bi.prototype.hasValue = function() {
        for (var e = se; e; e = e.parent)
          if (this.id in e.slots) {
            var qi = e.slots[this.id];
            if (qi === Oi)
              break;
            return e !== se && (se.slots[this.id] = qi), !0;
          }
        return se && (se.slots[this.id] = Oi), !1;
      }, Bi.prototype.getValue = function() {
        if (this.hasValue())
          return se.slots[this.id];
      }, Bi.prototype.withValue = function(e, qi, Xi, Qi) {
        var ta, ra = (ta = {
          __proto__: null
        }, ta[this.id] = e, ta), na = se;
        se = { parent: na, slots: ra };
        try {
          return qi.apply(Qi, Xi);
        } finally {
          se = na;
        }
      }, Bi.bind = function(e) {
        var qi = se;
        return function() {
          var Xi = se;
          try {
            return se = qi, e.apply(this, arguments);
          } finally {
            se = Xi;
          }
        };
      }, Bi.noContext = function(e, qi, Xi) {
        if (se) {
          var Qi = se;
          try {
            return se = null, e.apply(Xi, qi);
          } finally {
            se = Qi;
          }
        } else
          return e.apply(Xi, qi);
      }, Bi;
    }()
  );
};
function xi(Bi) {
  try {
    return Bi();
  } catch {
  }
}
var Ar = "@wry/context:Slot", ju = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  xi(function() {
    return globalThis;
  }) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  xi(function() {
    return global;
  }) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), Ti = ju, Mn = Ti[Ar] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Ar] || function(Bi) {
  try {
    Object.defineProperty(Ti, Ar, {
      value: Bi,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return Bi;
  }
}(Cu());
Mn.bind;
Mn.noContext;
var Vn = new Mn(), Di = /* @__PURE__ */ new WeakMap();
function Dt(Bi) {
  var e = Di.get(Bi);
  return e || Di.set(Bi, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: wa()
  }), e;
}
function Ii(Bi) {
  Dt(Bi).vars.forEach(function(e) {
    return e.forgetCache(Bi);
  });
}
function Nu(Bi) {
  Dt(Bi).vars.forEach(function(e) {
    return e.attachCache(Bi);
  });
}
function Pu(Bi) {
  var e = /* @__PURE__ */ new Set(), qi = /* @__PURE__ */ new Set(), Xi = function(ta) {
    if (arguments.length > 0) {
      if (Bi !== ta) {
        Bi = ta, e.forEach(function(la) {
          Dt(la).dep.dirty(Xi), Fu(la);
        });
        var ra = Array.from(qi);
        qi.clear(), ra.forEach(function(la) {
          return la(Bi);
        });
      }
    } else {
      var na = Vn.getValue();
      na && (Qi(na), Dt(na).dep(Xi));
    }
    return Bi;
  };
  Xi.onNextChange = function(ta) {
    return qi.add(ta), function() {
      qi.delete(ta);
    };
  };
  var Qi = Xi.attachCache = function(ta) {
    return e.add(ta), Dt(ta).vars.add(Xi), Xi;
  };
  return Xi.forgetCache = function(ta) {
    return e.delete(ta);
  }, Xi;
}
function Fu(Bi) {
  Bi.broadcastWatches && Bi.broadcastWatches();
}
var Ri = /* @__PURE__ */ Object.create(null);
function Ln(Bi) {
  var e = JSON.stringify(Bi);
  return Ri[e] || (Ri[e] = /* @__PURE__ */ Object.create(null));
}
function Ci(Bi) {
  var e = Ln(Bi);
  return e.keyFieldsFn || (e.keyFieldsFn = function(qi, Xi) {
    var Qi = function(ra, na) {
      return Xi.readField(na, ra);
    }, ta = Xi.keyObject = qn(Bi, function(ra) {
      var na = ut(Xi.storeObject, ra, Qi);
      return na === void 0 && qi !== Xi.storeObject && te.call(qi, ra[0]) && (na = ut(qi, ra, Ca)), __DEV__ ? E(na !== void 0, "Missing field '".concat(ra.join("."), "' while extracting keyFields from ").concat(JSON.stringify(qi))) : E(na !== void 0, 2), na;
    });
    return "".concat(Xi.typename, ":").concat(JSON.stringify(ta));
  });
}
function ji(Bi) {
  var e = Ln(Bi);
  return e.keyArgsFn || (e.keyArgsFn = function(qi, Xi) {
    var Qi = Xi.field, ta = Xi.variables, ra = Xi.fieldName, na = qn(Bi, function(Ma) {
      var Va = Ma[0], to = Va.charAt(0);
      if (to === "@") {
        if (Qi && Ee(Qi.directives)) {
          var Eo = Va.slice(1), So = Qi.directives.find(function(Hs) {
            return Hs.name.value === Eo;
          }), eo = So && mr(So, ta);
          return eo && ut(eo, Ma.slice(1));
        }
        return;
      }
      if (to === "$") {
        var rs = Va.slice(1);
        if (ta && te.call(ta, rs)) {
          var ko = Ma.slice(0);
          return ko[0] = rs, ut(ta, ko);
        }
        return;
      }
      if (qi)
        return ut(qi, Ma);
    }), la = JSON.stringify(na);
    return (qi || la !== "{}") && (ra += ":" + la), ra;
  });
}
function qn(Bi, e) {
  var qi = new He();
  return Ra(Bi).reduce(function(Xi, Qi) {
    var ta, ra = e(Qi);
    if (ra !== void 0) {
      for (var na = Qi.length - 1; na >= 0; --na)
        ra = (ta = {}, ta[Qi[na]] = ra, ta);
      Xi = qi.merge(Xi, ra);
    }
    return Xi;
  }, /* @__PURE__ */ Object.create(null));
}
function Ra(Bi) {
  var e = Ln(Bi);
  if (!e.paths) {
    var qi = e.paths = [], Xi = [];
    Bi.forEach(function(Qi, ta) {
      ee(Qi) ? (Ra(Qi).forEach(function(ra) {
        return qi.push(Xi.concat(ra));
      }), Xi.length = 0) : (Xi.push(Qi), ee(Bi[ta + 1]) || (qi.push(Xi.slice(0)), Xi.length = 0));
    });
  }
  return e.paths;
}
function Ca(Bi, e) {
  return Bi[e];
}
function ut(Bi, e, qi) {
  return qi = qi || Ca, ja(e.reduce(function Xi(Qi, ta) {
    return ee(Qi) ? Qi.map(function(ra) {
      return Xi(ra, ta);
    }) : Qi && qi(Qi, ta);
  }, Bi));
}
function ja(Bi) {
  return Y(Bi) ? ee(Bi) ? Bi.map(ja) : qn(Object.keys(Bi).sort(), function(e) {
    return ut(Bi, e);
  }) : Bi;
}
wn.setStringify(We);
function cn(Bi) {
  return Bi.args !== void 0 ? Bi.args : Bi.field ? mr(Bi.field, Bi.variables) : null;
}
var Au = function() {
}, Ni = function(Bi, e) {
  return e.fieldName;
}, Pi = function(Bi, e, qi) {
  var Xi = qi.mergeObjects;
  return Xi(Bi, e);
}, Fi = function(Bi, e) {
  return e;
}, Mu = function() {
  function Bi(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = y({ dataIdFromObject: Sa }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return Bi.prototype.identify = function(e, qi) {
    var Xi, Qi = this, ta = qi && (qi.typename || ((Xi = qi.storeObject) === null || Xi === void 0 ? void 0 : Xi.__typename)) || e.__typename;
    if (ta === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var ra = qi && qi.storeObject || e, na = y(y({}, qi), { typename: ta, storeObject: ra, readField: qi && qi.readField || function() {
      var Eo = Qn(arguments, ra);
      return Qi.readField(Eo, {
        store: Qi.cache.data,
        variables: Eo.variables
      });
    } }), la, Ma = ta && this.getTypePolicy(ta), Va = Ma && Ma.keyFn || this.config.dataIdFromObject; Va; ) {
      var to = Va(e, na);
      if (ee(to))
        Va = Ci(to);
      else {
        la = to;
        break;
      }
    }
    return la = la ? String(la) : void 0, na.keyObject ? [la, na.keyObject] : [la];
  }, Bi.prototype.addTypePolicies = function(e) {
    var qi = this;
    Object.keys(e).forEach(function(Xi) {
      var Qi = e[Xi], ta = Qi.queryType, ra = Qi.mutationType, na = Qi.subscriptionType, la = lt(Qi, ["queryType", "mutationType", "subscriptionType"]);
      ta && qi.setRootTypename("Query", Xi), ra && qi.setRootTypename("Mutation", Xi), na && qi.setRootTypename("Subscription", Xi), te.call(qi.toBeAdded, Xi) ? qi.toBeAdded[Xi].push(la) : qi.toBeAdded[Xi] = [la];
    });
  }, Bi.prototype.updateTypePolicy = function(e, qi) {
    var Xi = this, Qi = this.getTypePolicy(e), ta = qi.keyFields, ra = qi.fields;
    function na(la, Ma) {
      la.merge = typeof Ma == "function" ? Ma : Ma === !0 ? Pi : Ma === !1 ? Fi : la.merge;
    }
    na(Qi, qi.merge), Qi.keyFn = ta === !1 ? Au : ee(ta) ? Ci(ta) : typeof ta == "function" ? ta : Qi.keyFn, ra && Object.keys(ra).forEach(function(la) {
      var Ma = Xi.getFieldPolicy(e, la, !0), Va = ra[la];
      if (typeof Va == "function")
        Ma.read = Va;
      else {
        var to = Va.keyArgs, Eo = Va.read, So = Va.merge;
        Ma.keyFn = to === !1 ? Ni : ee(to) ? ji(to) : typeof to == "function" ? to : Ma.keyFn, typeof Eo == "function" && (Ma.read = Eo), na(Ma, So);
      }
      Ma.read && Ma.merge && (Ma.keyFn = Ma.keyFn || Ni);
    });
  }, Bi.prototype.setRootTypename = function(e, qi) {
    qi === void 0 && (qi = e);
    var Xi = "ROOT_" + e.toUpperCase(), Qi = this.rootTypenamesById[Xi];
    qi !== Qi && (__DEV__ ? E(!Qi || Qi === e, "Cannot change root ".concat(e, " __typename more than once")) : E(!Qi || Qi === e, 3), Qi && delete this.rootIdsByTypename[Qi], this.rootIdsByTypename[qi] = Xi, this.rootTypenamesById[Xi] = qi);
  }, Bi.prototype.addPossibleTypes = function(e) {
    var qi = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(Xi) {
      qi.getSupertypeSet(Xi, !0), e[Xi].forEach(function(Qi) {
        qi.getSupertypeSet(Qi, !0).add(Xi);
        var ta = Qi.match(Ta);
        (!ta || ta[0] !== Qi) && qi.fuzzySubtypes.set(Qi, new RegExp(Qi));
      });
    });
  }, Bi.prototype.getTypePolicy = function(e) {
    var qi = this;
    if (!te.call(this.typePolicies, e)) {
      var Xi = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      Xi.fields = /* @__PURE__ */ Object.create(null);
      var Qi = this.supertypeMap.get(e);
      Qi && Qi.size && Qi.forEach(function(ra) {
        var na = qi.getTypePolicy(ra), la = na.fields, Ma = lt(na, ["fields"]);
        Object.assign(Xi, Ma), Object.assign(Xi.fields, la);
      });
    }
    var ta = this.toBeAdded[e];
    return ta && ta.length && ta.splice(0).forEach(function(ra) {
      qi.updateTypePolicy(e, ra);
    }), this.typePolicies[e];
  }, Bi.prototype.getFieldPolicy = function(e, qi, Xi) {
    if (e) {
      var Qi = this.getTypePolicy(e).fields;
      return Qi[qi] || Xi && (Qi[qi] = /* @__PURE__ */ Object.create(null));
    }
  }, Bi.prototype.getSupertypeSet = function(e, qi) {
    var Xi = this.supertypeMap.get(e);
    return !Xi && qi && this.supertypeMap.set(e, Xi = /* @__PURE__ */ new Set()), Xi;
  }, Bi.prototype.fragmentMatches = function(e, qi, Xi, Qi) {
    var ta = this;
    if (!e.typeCondition)
      return !0;
    if (!qi)
      return !1;
    var ra = e.typeCondition.name.value;
    if (qi === ra)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(ra))
      for (var na = this.getSupertypeSet(qi, !0), la = [na], Ma = function(eo) {
        var rs = ta.getSupertypeSet(eo, !1);
        rs && rs.size && la.indexOf(rs) < 0 && la.push(rs);
      }, Va = !!(Xi && this.fuzzySubtypes.size), to = !1, Eo = 0; Eo < la.length; ++Eo) {
        var So = la[Eo];
        if (So.has(ra))
          return na.has(ra) || (to && __DEV__ && E.warn("Inferring subtype ".concat(qi, " of supertype ").concat(ra)), na.add(ra)), !0;
        So.forEach(Ma), Va && Eo === la.length - 1 && an(e.selectionSet, Xi, Qi) && (Va = !1, to = !0, this.fuzzySubtypes.forEach(function(eo, rs) {
          var ko = qi.match(eo);
          ko && ko[0] === qi && Ma(rs);
        }));
      }
    return !1;
  }, Bi.prototype.hasKeyArgs = function(e, qi) {
    var Xi = this.getFieldPolicy(e, qi, !1);
    return !!(Xi && Xi.keyFn);
  }, Bi.prototype.getStoreFieldName = function(e) {
    var qi = e.typename, Xi = e.fieldName, Qi = this.getFieldPolicy(qi, Xi, !1), ta, ra = Qi && Qi.keyFn;
    if (ra && qi)
      for (var na = {
        typename: qi,
        fieldName: Xi,
        field: e.field || null,
        variables: e.variables
      }, la = cn(e); ra; ) {
        var Ma = ra(la, na);
        if (ee(Ma))
          ra = ji(Ma);
        else {
          ta = Ma || Xi;
          break;
        }
      }
    return ta === void 0 && (ta = e.field ? Us(e.field, e.variables) : wn(Xi, cn(e))), ta === !1 ? Xi : Xi === Le(ta) ? ta : Xi + ":" + ta;
  }, Bi.prototype.readField = function(e, qi) {
    var Xi = e.from;
    if (Xi) {
      var Qi = e.field || e.fieldName;
      if (Qi) {
        if (e.typename === void 0) {
          var ta = qi.store.getFieldValue(Xi, "__typename");
          ta && (e.typename = ta);
        }
        var ra = this.getStoreFieldName(e), na = Le(ra), la = qi.store.getFieldValue(Xi, ra), Ma = this.getFieldPolicy(e.typename, na, !1), Va = Ma && Ma.read;
        if (Va) {
          var to = Ai(this, Xi, e, qi, qi.store.getStorage(z(Xi) ? Xi.__ref : Xi, ra));
          return Vn.withValue(this.cache, Va, [la, to]);
        }
        return la;
      }
    }
  }, Bi.prototype.getReadFunction = function(e, qi) {
    var Xi = this.getFieldPolicy(e, qi, !1);
    return Xi && Xi.read;
  }, Bi.prototype.getMergeFunction = function(e, qi, Xi) {
    var Qi = this.getFieldPolicy(e, qi, !1), ta = Qi && Qi.merge;
    return !ta && Xi && (Qi = this.getTypePolicy(Xi), ta = Qi && Qi.merge), ta;
  }, Bi.prototype.runMergeFunction = function(e, qi, Xi, Qi, ta) {
    var ra = Xi.field, na = Xi.typename, la = Xi.merge;
    return la === Pi ? Na(Qi.store)(e, qi) : la === Fi ? qi : (Qi.overwrite && (e = void 0), la(e, qi, Ai(this, void 0, { typename: na, fieldName: ra.name.value, field: ra, variables: Qi.variables }, Qi, ta || /* @__PURE__ */ Object.create(null))));
  }, Bi;
}();
function Ai(Bi, e, qi, Xi, Qi) {
  var ta = Bi.getStoreFieldName(qi), ra = Le(ta), na = qi.variables || Xi.variables, la = Xi.store, Ma = la.toReference, Va = la.canRead;
  return {
    args: cn(qi),
    field: qi.field || null,
    fieldName: ra,
    storeFieldName: ta,
    variables: na,
    isReference: z,
    toReference: Ma,
    storage: Qi,
    cache: Bi.cache,
    canRead: Va,
    readField: function() {
      return Bi.readField(Qn(arguments, e, na), Xi);
    },
    mergeObjects: Na(Xi.store)
  };
}
function Qn(Bi, e, qi) {
  var Xi = Bi[0], Qi = Bi[1], ta = Bi.length, ra;
  return typeof Xi == "string" ? ra = {
    fieldName: Xi,
    from: ta > 1 ? Qi : e
  } : (ra = y({}, Xi), te.call(ra, "from") || (ra.from = e)), __DEV__ && ra.from === void 0 && __DEV__ && E.warn("Undefined 'from' passed to readField with arguments ".concat(mo(Array.from(Bi)))), ra.variables === void 0 && (ra.variables = qi), ra;
}
function Na(Bi) {
  return function(e, qi) {
    if (ee(e) || ee(qi))
      throw __DEV__ ? new B("Cannot automatically merge arrays") : new B(4);
    if (Y(e) && Y(qi)) {
      var Xi = Bi.getFieldValue(e, "__typename"), Qi = Bi.getFieldValue(qi, "__typename"), ta = Xi && Qi && Xi !== Qi;
      if (ta)
        return qi;
      if (z(e) && it(qi))
        return Bi.merge(e.__ref, qi), e;
      if (it(e) && z(qi))
        return Bi.merge(e, qi.__ref), qi;
      if (it(e) && it(qi))
        return y(y({}, e), qi);
    }
    return qi;
  };
}
function Mr(Bi, e, qi) {
  var Xi = "".concat(e).concat(qi), Qi = Bi.flavors.get(Xi);
  return Qi || Bi.flavors.set(Xi, Qi = Bi.clientOnly === e && Bi.deferred === qi ? Bi : y(y({}, Bi), { clientOnly: e, deferred: qi })), Qi;
}
var Vu = function() {
  function Bi(e, qi, Xi) {
    this.cache = e, this.reader = qi, this.fragments = Xi;
  }
  return Bi.prototype.writeToStore = function(e, qi) {
    var Xi = this, Qi = qi.query, ta = qi.result, ra = qi.dataId, na = qi.variables, la = qi.overwrite, Ma = Ut(Qi), Va = Eu();
    na = y(y({}, En(Ma)), na);
    var to = y(y({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(So, eo) {
      return Va.merge(So, eo);
    }, variables: na, varString: We(na) }, Da(Qi, this.fragments)), { overwrite: !!la, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), Eo = this.processSelectionSet({
      result: ta || /* @__PURE__ */ Object.create(null),
      dataId: ra,
      selectionSet: Ma.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: to
    });
    if (!z(Eo))
      throw __DEV__ ? new B("Could not identify object ".concat(JSON.stringify(ta))) : new B(7);
    return to.incomingById.forEach(function(So, eo) {
      var rs = So.storeObject, ko = So.mergeTree, Hs = So.fieldNodeSet, Ks = ot(eo);
      if (ko && ko.map.size) {
        var Ys = Xi.applyMerges(ko, Ks, rs, to);
        if (z(Ys))
          return;
        rs = Ys;
      }
      if (__DEV__ && !to.overwrite) {
        var Xs = /* @__PURE__ */ Object.create(null);
        Hs.forEach(function(ws) {
          ws.selectionSet && (Xs[ws.name.value] = !0);
        });
        var Cs = function(ws) {
          return Xs[Le(ws)] === !0;
        }, Fs = function(ws) {
          var ls = ko && ko.map.get(ws);
          return !!(ls && ls.info && ls.info.merge);
        };
        Object.keys(rs).forEach(function(ws) {
          Cs(ws) && !Fs(ws) && Lu(Ks, rs, ws, to.store);
        });
      }
      e.merge(eo, rs);
    }), e.retain(Eo.__ref), Eo;
  }, Bi.prototype.processSelectionSet = function(e) {
    var qi = this, Xi = e.dataId, Qi = e.result, ta = e.selectionSet, ra = e.context, na = e.mergeTree, la = this.cache.policies, Ma = /* @__PURE__ */ Object.create(null), Va = Xi && la.rootTypenamesById[Xi] || $r(Qi, ta, ra.fragmentMap) || Xi && ra.store.get(Xi, "__typename");
    typeof Va == "string" && (Ma.__typename = Va);
    var to = function() {
      var Ys = Qn(arguments, Ma, ra.variables);
      if (z(Ys.from)) {
        var Xs = ra.incomingById.get(Ys.from.__ref);
        if (Xs) {
          var Cs = la.readField(y(y({}, Ys), { from: Xs.storeObject }), ra);
          if (Cs !== void 0)
            return Cs;
        }
      }
      return la.readField(Ys, ra);
    }, Eo = /* @__PURE__ */ new Set();
    this.flattenFields(ta, Qi, ra, Va).forEach(function(Ys, Xs) {
      var Cs, Fs = Je(Xs), ws = Qi[Fs];
      if (Eo.add(Xs), ws !== void 0) {
        var ls = la.getStoreFieldName({
          typename: Va,
          fieldName: Xs.name.value,
          field: Xs,
          variables: Ys.variables
        }), ks = Mi(na, ls), Js = qi.processFieldValue(ws, Xs, Xs.selectionSet ? Mr(Ys, !1, !1) : Ys, ks), pl = void 0;
        Xs.selectionSet && (z(Js) || it(Js)) && (pl = to("__typename", Js));
        var _l = la.getMergeFunction(Va, Xs.name.value, pl);
        _l ? ks.info = {
          field: Xs,
          typename: Va,
          merge: _l
        } : Vi(na, ls), Ma = Ys.merge(Ma, (Cs = {}, Cs[ls] = Js, Cs));
      } else __DEV__ && !Ys.clientOnly && !Ys.deferred && !On.added(Xs) && !la.getReadFunction(Va, Xs.name.value) && __DEV__ && E.error("Missing field '".concat(Je(Xs), "' while writing result ").concat(JSON.stringify(Qi, null, 2)).substring(0, 1e3));
    });
    try {
      var So = la.identify(Qi, {
        typename: Va,
        selectionSet: ta,
        fragmentMap: ra.fragmentMap,
        storeObject: Ma,
        readField: to
      }), eo = So[0], rs = So[1];
      Xi = Xi || eo, rs && (Ma = ra.merge(Ma, rs));
    } catch (Ys) {
      if (!Xi)
        throw Ys;
    }
    if (typeof Xi == "string") {
      var ko = ot(Xi), Hs = ra.written[Xi] || (ra.written[Xi] = []);
      if (Hs.indexOf(ta) >= 0 || (Hs.push(ta), this.reader && this.reader.isFresh(Qi, ko, ta, ra)))
        return ko;
      var Ks = ra.incomingById.get(Xi);
      return Ks ? (Ks.storeObject = ra.merge(Ks.storeObject, Ma), Ks.mergeTree = ln(Ks.mergeTree, na), Eo.forEach(function(Ys) {
        return Ks.fieldNodeSet.add(Ys);
      })) : ra.incomingById.set(Xi, {
        storeObject: Ma,
        mergeTree: or(na) ? void 0 : na,
        fieldNodeSet: Eo
      }), ko;
    }
    return Ma;
  }, Bi.prototype.processFieldValue = function(e, qi, Xi, Qi) {
    var ta = this;
    return !qi.selectionSet || e === null ? __DEV__ ? Cn(e) : e : ee(e) ? e.map(function(ra, na) {
      var la = ta.processFieldValue(ra, qi, Xi, Mi(Qi, na));
      return Vi(Qi, na), la;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: qi.selectionSet,
      context: Xi,
      mergeTree: Qi
    });
  }, Bi.prototype.flattenFields = function(e, qi, Xi, Qi) {
    Qi === void 0 && (Qi = $r(qi, e, Xi.fragmentMap));
    var ta = /* @__PURE__ */ new Map(), ra = this.cache.policies, na = new $t(!1);
    return function la(Ma, Va) {
      var to = na.lookup(Ma, Va.clientOnly, Va.deferred);
      to.visited || (to.visited = !0, Ma.selections.forEach(function(Eo) {
        if (vr(Eo, Xi.variables)) {
          var So = Va.clientOnly, eo = Va.deferred;
          if (!(So && eo) && Ee(Eo.directives) && Eo.directives.forEach(function(Hs) {
            var Ks = Hs.name.value;
            if (Ks === "client" && (So = !0), Ks === "defer") {
              var Ys = mr(Hs, Xi.variables);
              (!Ys || Ys.if !== !1) && (eo = !0);
            }
          }), Ce(Eo)) {
            var rs = ta.get(Eo);
            rs && (So = So && rs.clientOnly, eo = eo && rs.deferred), ta.set(Eo, Mr(Xi, So, eo));
          } else {
            var ko = _n(Eo, Xi.lookupFragment);
            if (!ko && Eo.kind === Gi.FRAGMENT_SPREAD)
              throw __DEV__ ? new B("No fragment named ".concat(Eo.name.value)) : new B(8);
            ko && ra.fragmentMatches(ko, Qi, qi, Xi.variables) && la(ko.selectionSet, Mr(Xi, So, eo));
          }
        }
      }));
    }(e, Xi), ta;
  }, Bi.prototype.applyMerges = function(e, qi, Xi, Qi, ta) {
    var ra, na = this;
    if (e.map.size && !z(Xi)) {
      var la = !ee(Xi) && (z(qi) || it(qi)) ? qi : void 0, Ma = Xi;
      la && !ta && (ta = [z(la) ? la.__ref : la]);
      var Va, to = function(Eo, So) {
        return ee(Eo) ? typeof So == "number" ? Eo[So] : void 0 : Qi.store.getFieldValue(Eo, String(So));
      };
      e.map.forEach(function(Eo, So) {
        var eo = to(la, So), rs = to(Ma, So);
        if (rs !== void 0) {
          ta && ta.push(So);
          var ko = na.applyMerges(Eo, eo, rs, Qi, ta);
          ko !== rs && (Va = Va || /* @__PURE__ */ new Map(), Va.set(So, ko)), ta && E(ta.pop() === So);
        }
      }), Va && (Xi = ee(Ma) ? Ma.slice(0) : y({}, Ma), Va.forEach(function(Eo, So) {
        Xi[So] = Eo;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(qi, Xi, e.info, Qi, ta && (ra = Qi.store).getStorage.apply(ra, ta)) : Xi;
  }, Bi;
}(), Pa = [];
function Mi(Bi, e) {
  var qi = Bi.map;
  return qi.has(e) || qi.set(e, Pa.pop() || { map: /* @__PURE__ */ new Map() }), qi.get(e);
}
function ln(Bi, e) {
  if (Bi === e || !e || or(e))
    return Bi;
  if (!Bi || or(Bi))
    return e;
  var qi = Bi.info && e.info ? y(y({}, Bi.info), e.info) : Bi.info || e.info, Xi = Bi.map.size && e.map.size, Qi = Xi ? /* @__PURE__ */ new Map() : Bi.map.size ? Bi.map : e.map, ta = { info: qi, map: Qi };
  if (Xi) {
    var ra = new Set(e.map.keys());
    Bi.map.forEach(function(na, la) {
      ta.map.set(la, ln(na, e.map.get(la))), ra.delete(la);
    }), ra.forEach(function(na) {
      ta.map.set(na, ln(e.map.get(na), Bi.map.get(na)));
    });
  }
  return ta;
}
function or(Bi) {
  return !Bi || !(Bi.info || Bi.map.size);
}
function Vi(Bi, e) {
  var qi = Bi.map, Xi = qi.get(e);
  Xi && or(Xi) && (Pa.push(Xi), qi.delete(e));
}
var Li = /* @__PURE__ */ new Set();
function Lu(Bi, e, qi, Xi) {
  var Qi = function(to) {
    var Eo = Xi.getFieldValue(to, qi);
    return typeof Eo == "object" && Eo;
  }, ta = Qi(Bi);
  if (ta) {
    var ra = Qi(e);
    if (ra && !z(ta) && !re(ta, ra) && !Object.keys(ta).every(function(to) {
      return Xi.getFieldValue(ra, to) !== void 0;
    })) {
      var na = Xi.getFieldValue(Bi, "__typename") || Xi.getFieldValue(e, "__typename"), la = Le(qi), Ma = "".concat(na, ".").concat(la);
      if (!Li.has(Ma)) {
        Li.add(Ma);
        var Va = [];
        !ee(ta) && !ee(ra) && [ta, ra].forEach(function(to) {
          var Eo = Xi.getFieldValue(to, "__typename");
          typeof Eo == "string" && !Va.includes(Eo) && Va.push(Eo);
        }), __DEV__ && E.warn("Cache data may be lost when replacing the ".concat(la, " field of a ").concat(na, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(Va.length ? "either ensure all objects of type " + Va.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(Ma, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(ta).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(ra).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
(function(Bi) {
  be(e, Bi);
  function e(qi) {
    qi === void 0 && (qi = {});
    var Xi = Bi.call(this) || this;
    return Xi.watches = /* @__PURE__ */ new Set(), Xi.typenameDocumentCache = /* @__PURE__ */ new Map(), Xi.makeVar = Pu, Xi.txCount = 0, Xi.config = wu(qi), Xi.addTypename = !!Xi.config.addTypename, Xi.policies = new Mu({
      cache: Xi,
      dataIdFromObject: Xi.config.dataIdFromObject,
      possibleTypes: Xi.config.possibleTypes,
      typePolicies: Xi.config.typePolicies
    }), Xi.init(), Xi;
  }
  return e.prototype.init = function() {
    var qi = this.data = new Rt.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = qi.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(qi) {
    var Xi = this, Qi = this.storeReader, ta = this.config.fragments;
    this.storeWriter = new Vu(this, this.storeReader = new Tu({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: xa(this.config),
      canon: qi ? void 0 : Qi && Qi.canon,
      fragments: ta
    }), ta), this.maybeBroadcastWatch = sr(function(ra, na) {
      return Xi.broadcastWatch(ra, na);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(ra) {
        var na = ra.optimistic ? Xi.optimisticData : Xi.data;
        if (Tt(na)) {
          var la = ra.optimistic, Ma = ra.id, Va = ra.variables;
          return na.makeCacheKey(ra.query, ra.callback, We({ optimistic: la, id: Ma, variables: Va }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(ra) {
      return ra.resetCaching();
    });
  }, e.prototype.restore = function(qi) {
    return this.init(), qi && this.data.replace(qi), this;
  }, e.prototype.extract = function(qi) {
    return qi === void 0 && (qi = !1), (qi ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(qi) {
    var Xi = qi.returnPartialData, Qi = Xi === void 0 ? !1 : Xi;
    try {
      return this.storeReader.diffQueryAgainstStore(y(y({}, qi), { store: qi.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: Qi })).result || null;
    } catch (ta) {
      if (ta instanceof Ea)
        return null;
      throw ta;
    }
  }, e.prototype.write = function(qi) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, qi);
    } finally {
      !--this.txCount && qi.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(qi) {
    if (te.call(qi, "id") && !qi.id)
      return !1;
    var Xi = qi.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, Xi.modify(qi.id || "ROOT_QUERY", qi.fields);
    } finally {
      !--this.txCount && qi.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(qi) {
    return this.storeReader.diffQueryAgainstStore(y(y({}, qi), { store: qi.optimistic ? this.optimisticData : this.data, rootId: qi.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(qi) {
    var Xi = this;
    return this.watches.size || Nu(this), this.watches.add(qi), qi.immediate && this.maybeBroadcastWatch(qi), function() {
      Xi.watches.delete(qi) && !Xi.watches.size && Ii(Xi), Xi.maybeBroadcastWatch.forget(qi);
    };
  }, e.prototype.gc = function(qi) {
    We.reset();
    var Xi = this.optimisticData.gc();
    return qi && !this.txCount && (qi.resetResultCache ? this.resetResultCache(qi.resetResultIdentities) : qi.resetResultIdentities && this.storeReader.resetCanon()), Xi;
  }, e.prototype.retain = function(qi, Xi) {
    return (Xi ? this.optimisticData : this.data).retain(qi);
  }, e.prototype.release = function(qi, Xi) {
    return (Xi ? this.optimisticData : this.data).release(qi);
  }, e.prototype.identify = function(qi) {
    if (z(qi))
      return qi.__ref;
    try {
      return this.policies.identify(qi)[0];
    } catch (Xi) {
      __DEV__ && E.warn(Xi);
    }
  }, e.prototype.evict = function(qi) {
    if (!qi.id) {
      if (te.call(qi, "id"))
        return !1;
      qi = y(y({}, qi), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(qi, this.data);
    } finally {
      !--this.txCount && qi.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(qi) {
    var Xi = this;
    return this.init(), We.reset(), qi && qi.discardWatches ? (this.watches.forEach(function(Qi) {
      return Xi.maybeBroadcastWatch.forget(Qi);
    }), this.watches.clear(), Ii(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(qi) {
    var Xi = this.optimisticData.removeLayer(qi);
    Xi !== this.optimisticData && (this.optimisticData = Xi, this.broadcastWatches());
  }, e.prototype.batch = function(qi) {
    var Xi = this, Qi = qi.update, ta = qi.optimistic, ra = ta === void 0 ? !0 : ta, na = qi.removeOptimistic, la = qi.onWatchUpdated, Ma, Va = function(Eo) {
      var So = Xi, eo = So.data, rs = So.optimisticData;
      ++Xi.txCount, Eo && (Xi.data = Xi.optimisticData = Eo);
      try {
        return Ma = Qi(Xi);
      } finally {
        --Xi.txCount, Xi.data = eo, Xi.optimisticData = rs;
      }
    }, to = /* @__PURE__ */ new Set();
    return la && !this.txCount && this.broadcastWatches(y(y({}, qi), { onWatchUpdated: function(Eo) {
      return to.add(Eo), !1;
    } })), typeof ra == "string" ? this.optimisticData = this.optimisticData.addLayer(ra, Va) : ra === !1 ? Va(this.data) : Va(), typeof na == "string" && (this.optimisticData = this.optimisticData.removeLayer(na)), la && to.size ? (this.broadcastWatches(y(y({}, qi), { onWatchUpdated: function(Eo, So) {
      var eo = la.call(this, Eo, So);
      return eo !== !1 && to.delete(Eo), eo;
    } })), to.size && to.forEach(function(Eo) {
      return Xi.maybeBroadcastWatch.dirty(Eo);
    })) : this.broadcastWatches(qi), Ma;
  }, e.prototype.performTransaction = function(qi, Xi) {
    return this.batch({
      update: qi,
      optimistic: Xi || Xi !== null
    });
  }, e.prototype.transformDocument = function(qi) {
    if (this.addTypename) {
      var Xi = this.typenameDocumentCache.get(qi);
      return Xi || (Xi = On(qi), this.typenameDocumentCache.set(qi, Xi), this.typenameDocumentCache.set(Xi, Xi)), Xi;
    }
    return qi;
  }, e.prototype.transformForLink = function(qi) {
    var Xi = this.config.fragments;
    return Xi ? Xi.transform(qi) : qi;
  }, e.prototype.broadcastWatches = function(qi) {
    var Xi = this;
    this.txCount || this.watches.forEach(function(Qi) {
      return Xi.maybeBroadcastWatch(Qi, qi);
    });
  }, e.prototype.broadcastWatch = function(qi, Xi) {
    var Qi = qi.lastDiff, ta = this.diff(qi);
    Xi && (qi.optimistic && typeof Xi.optimistic == "string" && (ta.fromOptimisticTransaction = !0), Xi.onWatchUpdated && Xi.onWatchUpdated.call(this, qi, ta, Qi) === !1) || (!Qi || !re(Qi.result, ta.result)) && qi.callback(qi.lastDiff = ta, Qi);
  }, e;
})(_u);
var Bu = function(Bi) {
  var e = "";
  if (Ee(Bi.graphQLErrors) || Ee(Bi.clientErrors)) {
    var qi = (Bi.graphQLErrors || []).concat(Bi.clientErrors || []);
    qi.forEach(function(Xi) {
      var Qi = Xi ? Xi.message : "Error message not found.";
      e += "".concat(Qi, `
`);
    });
  }
  return Bi.networkError && (e += "".concat(Bi.networkError.message, `
`)), e = e.replace(/\n$/, ""), e;
}, Ue = function(Bi) {
  be(e, Bi);
  function e(qi) {
    var Xi = qi.graphQLErrors, Qi = qi.clientErrors, ta = qi.networkError, ra = qi.errorMessage, na = qi.extraInfo, la = Bi.call(this, ra) || this;
    return la.graphQLErrors = Xi || [], la.clientErrors = Qi || [], la.networkError = ta || null, la.message = ra || Bu(la), la.extraInfo = na, la.__proto__ = e.prototype, la;
  }
  return e;
}(Error), W;
(function(Bi) {
  Bi[Bi.loading = 1] = "loading", Bi[Bi.setVariables = 2] = "setVariables", Bi[Bi.fetchMore = 3] = "fetchMore", Bi[Bi.refetch = 4] = "refetch", Bi[Bi.poll = 6] = "poll", Bi[Bi.ready = 7] = "ready", Bi[Bi.error = 8] = "error";
})(W || (W = {}));
function Ct(Bi) {
  return Bi ? Bi < 7 : !1;
}
var Zu = Object.assign, zu = Object.hasOwnProperty, fn = function(Bi) {
  be(e, Bi);
  function e(qi) {
    var Xi = qi.queryManager, Qi = qi.queryInfo, ta = qi.options, ra = Bi.call(this, function(ko) {
      try {
        var Hs = ko._subscription._observer;
        Hs && !Hs.error && (Hs.error = Uu);
      } catch {
      }
      var Ks = !ra.observers.size;
      ra.observers.add(ko);
      var Ys = ra.last;
      return Ys && Ys.error ? ko.error && ko.error(Ys.error) : Ys && Ys.result && ko.next && ko.next(Ys.result), Ks && ra.reobserve().catch(function() {
      }), function() {
        ra.observers.delete(ko) && !ra.observers.size && ra.tearDownQuery();
      };
    }) || this;
    ra.observers = /* @__PURE__ */ new Set(), ra.subscriptions = /* @__PURE__ */ new Set(), ra.queryInfo = Qi, ra.queryManager = Xi, ra.isTornDown = !1;
    var na = Xi.defaultOptions.watchQuery, la = na === void 0 ? {} : na, Ma = la.fetchPolicy, Va = Ma === void 0 ? "cache-first" : Ma, to = ta.fetchPolicy, Eo = to === void 0 ? Va : to, So = ta.initialFetchPolicy, eo = So === void 0 ? Eo === "standby" ? Va : Eo : So;
    ra.options = y(y({}, ta), { initialFetchPolicy: eo, fetchPolicy: Eo }), ra.queryId = Qi.queryId || Xi.generateQueryId();
    var rs = Ut(ra.query);
    return ra.queryName = rs && rs.name && rs.name.value, ra;
  }
  return Object.defineProperty(e.prototype, "query", {
    get: function() {
      return this.queryManager.transform(this.options.query).document;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var qi = this;
    return new Promise(function(Xi, Qi) {
      var ta = {
        next: function(na) {
          Xi(na), qi.observers.delete(ta), qi.observers.size || qi.queryManager.removeQuery(qi.queryId), setTimeout(function() {
            ra.unsubscribe();
          }, 0);
        },
        error: Qi
      }, ra = qi.subscribe(ta);
    });
  }, e.prototype.getCurrentResult = function(qi) {
    qi === void 0 && (qi = !0);
    var Xi = this.getLastResult(!0), Qi = this.queryInfo.networkStatus || Xi && Xi.networkStatus || W.ready, ta = y(y({}, Xi), { loading: Ct(Qi), networkStatus: Qi }), ra = this.options.fetchPolicy, na = ra === void 0 ? "cache-first" : ra;
    if (!(na === "network-only" || na === "no-cache" || na === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var la = this.queryInfo.getDiff();
      (la.complete || this.options.returnPartialData) && (ta.data = la.result), re(ta.data, {}) && (ta.data = void 0), la.complete ? (delete ta.partial, la.complete && ta.networkStatus === W.loading && (na === "cache-first" || na === "cache-only") && (ta.networkStatus = W.ready, ta.loading = !1)) : ta.partial = !0, __DEV__ && !la.complete && !this.options.partialRefetch && !ta.loading && !ta.data && !ta.error && Aa(la.missing);
    }
    return qi && this.updateLastResult(ta), ta;
  }, e.prototype.isDifferentFromLastResult = function(qi) {
    return !this.last || !re(this.last.result, qi);
  }, e.prototype.getLast = function(qi, Xi) {
    var Qi = this.last;
    if (Qi && Qi[qi] && (!Xi || re(Qi.variables, this.variables)))
      return Qi[qi];
  }, e.prototype.getLastResult = function(qi) {
    return this.getLast("result", qi);
  }, e.prototype.getLastError = function(qi) {
    return this.getLast("error", qi);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(qi) {
    var Xi, Qi = {
      pollInterval: 0
    }, ta = this.options.fetchPolicy;
    if (ta === "cache-and-network" ? Qi.fetchPolicy = ta : ta === "no-cache" ? Qi.fetchPolicy = "no-cache" : Qi.fetchPolicy = "network-only", __DEV__ && qi && zu.call(qi, "variables")) {
      var ra = ea(this.query), na = ra.variableDefinitions;
      (!na || !na.some(function(la) {
        return la.variable.name.value === "variables";
      })) && __DEV__ && E.warn("Called refetch(".concat(JSON.stringify(qi), ") for query ").concat(((Xi = ra.name) === null || Xi === void 0 ? void 0 : Xi.value) || JSON.stringify(ra), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return qi && !re(this.options.variables, qi) && (Qi.variables = this.options.variables = y(y({}, this.options.variables), qi)), this.queryInfo.resetLastWrite(), this.reobserve(Qi, W.refetch);
  }, e.prototype.fetchMore = function(qi) {
    var Xi = this, Qi = y(y({}, qi.query ? qi : y(y(y(y({}, this.options), { query: this.query }), qi), { variables: y(y({}, this.options.variables), qi.variables) })), { fetchPolicy: "no-cache" }), ta = this.queryManager.generateQueryId(), ra = this.queryInfo, na = ra.networkStatus;
    ra.networkStatus = W.fetchMore, Qi.notifyOnNetworkStatusChange && this.observe();
    var la = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(ta, Qi, W.fetchMore).then(function(Ma) {
      return Xi.queryManager.removeQuery(ta), ra.networkStatus === W.fetchMore && (ra.networkStatus = na), Xi.queryManager.cache.batch({
        update: function(Va) {
          var to = qi.updateQuery;
          to ? Va.updateQuery({
            query: Xi.query,
            variables: Xi.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(Eo) {
            return to(Eo, {
              fetchMoreResult: Ma.data,
              variables: Qi.variables
            });
          }) : Va.writeQuery({
            query: Qi.query,
            variables: Qi.variables,
            data: Ma.data
          });
        },
        onWatchUpdated: function(Va) {
          la.add(Va.query);
        }
      }), Ma;
    }).finally(function() {
      la.has(Xi.query) || Fa(Xi);
    });
  }, e.prototype.subscribeToMore = function(qi) {
    var Xi = this, Qi = this.queryManager.startGraphQLSubscription({
      query: qi.document,
      variables: qi.variables,
      context: qi.context
    }).subscribe({
      next: function(ta) {
        var ra = qi.updateQuery;
        ra && Xi.updateQuery(function(na, la) {
          var Ma = la.variables;
          return ra(na, {
            subscriptionData: ta,
            variables: Ma
          });
        });
      },
      error: function(ta) {
        if (qi.onError) {
          qi.onError(ta);
          return;
        }
        __DEV__ && E.error("Unhandled GraphQL subscription error", ta);
      }
    });
    return this.subscriptions.add(Qi), function() {
      Xi.subscriptions.delete(Qi) && Qi.unsubscribe();
    };
  }, e.prototype.setOptions = function(qi) {
    return this.reobserve(qi);
  }, e.prototype.setVariables = function(qi) {
    return re(this.variables, qi) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = qi, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: qi
    }, W.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(qi) {
    var Xi = this.queryManager, Qi = Xi.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, ta = qi(Qi, {
      variables: this.variables
    });
    ta && (Xi.cache.writeQuery({
      query: this.options.query,
      data: ta,
      variables: this.variables
    }), Xi.broadcastQueries());
  }, e.prototype.startPolling = function(qi) {
    this.options.pollInterval = qi, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.applyNextFetchPolicy = function(qi, Xi) {
    if (Xi.nextFetchPolicy) {
      var Qi = Xi.fetchPolicy, ta = Qi === void 0 ? "cache-first" : Qi, ra = Xi.initialFetchPolicy, na = ra === void 0 ? ta : ra;
      ta === "standby" || (typeof Xi.nextFetchPolicy == "function" ? Xi.fetchPolicy = Xi.nextFetchPolicy(ta, {
        reason: qi,
        options: Xi,
        observable: this,
        initialFetchPolicy: na
      }) : qi === "variables-changed" ? Xi.fetchPolicy = na : Xi.fetchPolicy = Xi.nextFetchPolicy);
    }
    return Xi.fetchPolicy;
  }, e.prototype.fetch = function(qi, Xi) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, qi, Xi);
  }, e.prototype.updatePolling = function() {
    var qi = this;
    if (!this.queryManager.ssrMode) {
      var Xi = this, Qi = Xi.pollingInfo, ta = Xi.options.pollInterval;
      if (!ta) {
        Qi && (clearTimeout(Qi.timeout), delete this.pollingInfo);
        return;
      }
      if (!(Qi && Qi.interval === ta)) {
        __DEV__ ? E(ta, "Attempted to start a polling query without a polling interval.") : E(ta, 12);
        var ra = Qi || (this.pollingInfo = {});
        ra.interval = ta;
        var na = function() {
          qi.pollingInfo && (Ct(qi.queryInfo.networkStatus) ? la() : qi.reobserve({
            fetchPolicy: qi.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, W.poll).then(la, la));
        }, la = function() {
          var Ma = qi.pollingInfo;
          Ma && (clearTimeout(Ma.timeout), Ma.timeout = setTimeout(na, Ma.interval));
        };
        la();
      }
    }
  }, e.prototype.updateLastResult = function(qi, Xi) {
    return Xi === void 0 && (Xi = this.variables), this.last = y(y({}, this.last), { result: this.queryManager.assumeImmutableResults ? qi : Cn(qi), variables: Xi }), Ee(qi.errors) || delete this.last.error, this.last;
  }, e.prototype.reobserve = function(qi, Xi) {
    var Qi = this;
    this.isTornDown = !1;
    var ta = Xi === W.refetch || Xi === W.fetchMore || Xi === W.poll, ra = this.options.variables, na = this.options.fetchPolicy, la = wr(this.options, qi || {}), Ma = ta ? la : Zu(this.options, la);
    ta || (this.updatePolling(), qi && qi.variables && !re(qi.variables, ra) && Ma.fetchPolicy !== "standby" && Ma.fetchPolicy === na && (this.applyNextFetchPolicy("variables-changed", Ma), Xi === void 0 && (Xi = W.setVariables)));
    var Va = Ma.variables && y({}, Ma.variables), to = this.fetch(Ma, Xi), Eo = {
      next: function(So) {
        Qi.reportResult(So, Va);
      },
      error: function(So) {
        Qi.reportError(So, Va);
      }
    };
    return ta || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = to, this.observer = Eo), to.addObserver(Eo), to.promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(qi, Xi) {
    var Qi = this.getLastError();
    (Qi || this.isDifferentFromLastResult(qi)) && ((Qi || !qi.partial || this.options.returnPartialData) && this.updateLastResult(qi, Xi), xt(this.observers, "next", qi));
  }, e.prototype.reportError = function(qi, Xi) {
    var Qi = y(y({}, this.getLastResult()), { error: qi, errors: qi.graphQLErrors, networkStatus: W.error, loading: !1 });
    this.updateLastResult(Qi, Xi), xt(this.observers, "error", this.last.error = qi);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(qi) {
      return qi.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e;
}(G);
ua(fn);
function Fa(Bi) {
  var e = Bi.options, qi = e.fetchPolicy, Xi = e.nextFetchPolicy;
  return qi === "cache-and-network" || qi === "network-only" ? Bi.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = Xi, typeof Xi == "function" ? Xi.apply(this, arguments) : qi;
    }
  }) : Bi.reobserve();
}
function Uu(Bi) {
  __DEV__ && E.error("Unhandled error", Bi.message, Bi.stack);
}
function Aa(Bi) {
  __DEV__ && Bi && __DEV__ && E.debug("Missing cache result fields: ".concat(JSON.stringify(Bi)), Bi);
}
function Ju(Bi) {
  return Y(Bi) && "code" in Bi && "reason" in Bi;
}
(function(Bi) {
  be(e, Bi);
  function e(qi) {
    var Xi = Bi.call(this) || this;
    return Xi.client = qi, Xi;
  }
  return e.prototype.request = function(qi) {
    var Xi = this;
    return new G(function(Qi) {
      return Xi.client.subscribe(y(y({}, qi), { query: Ki(qi.query) }), {
        next: Qi.next.bind(Qi),
        complete: Qi.complete.bind(Qi),
        error: function(ta) {
          return ta instanceof Error ? Qi.error(ta) : Ju(ta) ? Qi.error(new Error("Socket closed with event ".concat(ta.code, " ").concat(ta.reason || ""))) : Qi.error(new Ue({
            graphQLErrors: Array.isArray(ta) ? ta : [ta]
          }));
        }
      });
    });
  }, e;
})(ze);
var fe;
(function(Bi) {
  Bi[Bi.InternalServerError = 4500] = "InternalServerError", Bi[Bi.InternalClientError = 4005] = "InternalClientError", Bi[Bi.BadRequest = 4400] = "BadRequest", Bi[Bi.BadResponse = 4004] = "BadResponse", Bi[Bi.Unauthorized = 4401] = "Unauthorized", Bi[Bi.Forbidden = 4403] = "Forbidden", Bi[Bi.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", Bi[Bi.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", Bi[Bi.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", Bi[Bi.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", Bi[Bi.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(fe || (fe = {}));
var X;
(function(Bi) {
  Bi.ConnectionInit = "connection_init", Bi.ConnectionAck = "connection_ack", Bi.Ping = "ping", Bi.Pong = "pong", Bi.Subscribe = "subscribe", Bi.Next = "next", Bi.Error = "error", Bi.Complete = "complete";
})(X || (X = {}));
var Q;
(function(Bi) {
  Bi.assertEqual = (Qi) => Qi;
  function e(Qi) {
  }
  Bi.assertIs = e;
  function qi(Qi) {
    throw new Error();
  }
  Bi.assertNever = qi, Bi.arrayToEnum = (Qi) => {
    const ta = {};
    for (const ra of Qi)
      ta[ra] = ra;
    return ta;
  }, Bi.getValidEnumValues = (Qi) => {
    const ta = Bi.objectKeys(Qi).filter((na) => typeof Qi[Qi[na]] != "number"), ra = {};
    for (const na of ta)
      ra[na] = Qi[na];
    return Bi.objectValues(ra);
  }, Bi.objectValues = (Qi) => Bi.objectKeys(Qi).map(function(ta) {
    return Qi[ta];
  }), Bi.objectKeys = typeof Object.keys == "function" ? (Qi) => Object.keys(Qi) : (Qi) => {
    const ta = [];
    for (const ra in Qi)
      Object.prototype.hasOwnProperty.call(Qi, ra) && ta.push(ra);
    return ta;
  }, Bi.find = (Qi, ta) => {
    for (const ra of Qi)
      if (ta(ra))
        return ra;
  }, Bi.isInteger = typeof Number.isInteger == "function" ? (Qi) => Number.isInteger(Qi) : (Qi) => typeof Qi == "number" && isFinite(Qi) && Math.floor(Qi) === Qi;
  function Xi(Qi, ta = " | ") {
    return Qi.map((ra) => typeof ra == "string" ? `'${ra}'` : ra).join(ta);
  }
  Bi.joinValues = Xi, Bi.jsonStringifyReplacer = (Qi, ta) => typeof ta == "bigint" ? ta.toString() : ta;
})(Q || (Q = {}));
var hn;
(function(Bi) {
  Bi.mergeShapes = (e, qi) => ({
    ...e,
    ...qi
    // second overwrites first
  });
})(hn || (hn = {}));
const O = Q.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Re = (Bi) => {
  switch (typeof Bi) {
    case "undefined":
      return O.undefined;
    case "string":
      return O.string;
    case "number":
      return isNaN(Bi) ? O.nan : O.number;
    case "boolean":
      return O.boolean;
    case "function":
      return O.function;
    case "bigint":
      return O.bigint;
    case "symbol":
      return O.symbol;
    case "object":
      return Array.isArray(Bi) ? O.array : Bi === null ? O.null : Bi.then && typeof Bi.then == "function" && Bi.catch && typeof Bi.catch == "function" ? O.promise : typeof Map < "u" && Bi instanceof Map ? O.map : typeof Set < "u" && Bi instanceof Set ? O.set : typeof Date < "u" && Bi instanceof Date ? O.date : O.object;
    default:
      return O.unknown;
  }
}, g = Q.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), ic = (Bi) => JSON.stringify(Bi, null, 2).replace(/"([^"]+)":/g, "$1:");
class de extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (Xi) => {
      this.issues = [...this.issues, Xi];
    }, this.addIssues = (Xi = []) => {
      this.issues = [...this.issues, ...Xi];
    };
    const qi = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, qi) : this.__proto__ = qi, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const qi = e || function(ta) {
      return ta.message;
    }, Xi = { _errors: [] }, Qi = (ta) => {
      for (const ra of ta.issues)
        if (ra.code === "invalid_union")
          ra.unionErrors.map(Qi);
        else if (ra.code === "invalid_return_type")
          Qi(ra.returnTypeError);
        else if (ra.code === "invalid_arguments")
          Qi(ra.argumentsError);
        else if (ra.path.length === 0)
          Xi._errors.push(qi(ra));
        else {
          let na = Xi, la = 0;
          for (; la < ra.path.length; ) {
            const Ma = ra.path[la];
            la === ra.path.length - 1 ? (na[Ma] = na[Ma] || { _errors: [] }, na[Ma]._errors.push(qi(ra))) : na[Ma] = na[Ma] || { _errors: [] }, na = na[Ma], la++;
          }
        }
    };
    return Qi(this), Xi;
  }
  static assert(e) {
    if (!(e instanceof de))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Q.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (qi) => qi.message) {
    const qi = {}, Xi = [];
    for (const Qi of this.issues)
      Qi.path.length > 0 ? (qi[Qi.path[0]] = qi[Qi.path[0]] || [], qi[Qi.path[0]].push(e(Qi))) : Xi.push(e(Qi));
    return { formErrors: Xi, fieldErrors: qi };
  }
  get formErrors() {
    return this.flatten();
  }
}
de.create = (Bi) => new de(Bi);
const pt = (Bi, e) => {
  let qi;
  switch (Bi.code) {
    case g.invalid_type:
      Bi.received === O.undefined ? qi = "Required" : qi = `Expected ${Bi.expected}, received ${Bi.received}`;
      break;
    case g.invalid_literal:
      qi = `Invalid literal value, expected ${JSON.stringify(Bi.expected, Q.jsonStringifyReplacer)}`;
      break;
    case g.unrecognized_keys:
      qi = `Unrecognized key(s) in object: ${Q.joinValues(Bi.keys, ", ")}`;
      break;
    case g.invalid_union:
      qi = "Invalid input";
      break;
    case g.invalid_union_discriminator:
      qi = `Invalid discriminator value. Expected ${Q.joinValues(Bi.options)}`;
      break;
    case g.invalid_enum_value:
      qi = `Invalid enum value. Expected ${Q.joinValues(Bi.options)}, received '${Bi.received}'`;
      break;
    case g.invalid_arguments:
      qi = "Invalid function arguments";
      break;
    case g.invalid_return_type:
      qi = "Invalid function return type";
      break;
    case g.invalid_date:
      qi = "Invalid date";
      break;
    case g.invalid_string:
      typeof Bi.validation == "object" ? "includes" in Bi.validation ? (qi = `Invalid input: must include "${Bi.validation.includes}"`, typeof Bi.validation.position == "number" && (qi = `${qi} at one or more positions greater than or equal to ${Bi.validation.position}`)) : "startsWith" in Bi.validation ? qi = `Invalid input: must start with "${Bi.validation.startsWith}"` : "endsWith" in Bi.validation ? qi = `Invalid input: must end with "${Bi.validation.endsWith}"` : Q.assertNever(Bi.validation) : Bi.validation !== "regex" ? qi = `Invalid ${Bi.validation}` : qi = "Invalid";
      break;
    case g.too_small:
      Bi.type === "array" ? qi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "more than"} ${Bi.minimum} element(s)` : Bi.type === "string" ? qi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at least" : "over"} ${Bi.minimum} character(s)` : Bi.type === "number" ? qi = `Number must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${Bi.minimum}` : Bi.type === "date" ? qi = `Date must be ${Bi.exact ? "exactly equal to " : Bi.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(Bi.minimum))}` : qi = "Invalid input";
      break;
    case g.too_big:
      Bi.type === "array" ? qi = `Array must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "less than"} ${Bi.maximum} element(s)` : Bi.type === "string" ? qi = `String must contain ${Bi.exact ? "exactly" : Bi.inclusive ? "at most" : "under"} ${Bi.maximum} character(s)` : Bi.type === "number" ? qi = `Number must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "bigint" ? qi = `BigInt must be ${Bi.exact ? "exactly" : Bi.inclusive ? "less than or equal to" : "less than"} ${Bi.maximum}` : Bi.type === "date" ? qi = `Date must be ${Bi.exact ? "exactly" : Bi.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(Bi.maximum))}` : qi = "Invalid input";
      break;
    case g.custom:
      qi = "Invalid input";
      break;
    case g.invalid_intersection_types:
      qi = "Intersection results could not be merged";
      break;
    case g.not_multiple_of:
      qi = `Number must be a multiple of ${Bi.multipleOf}`;
      break;
    case g.not_finite:
      qi = "Number must be finite";
      break;
    default:
      qi = e.defaultError, Q.assertNever(Bi);
  }
  return { message: qi };
};
let La = pt;
function ac(Bi) {
  La = Bi;
}
function ur() {
  return La;
}
const cr = (Bi) => {
  const { data: e, path: qi, errorMaps: Xi, issueData: Qi } = Bi, ta = [...qi, ...Qi.path || []], ra = {
    ...Qi,
    path: ta
  };
  if (Qi.message !== void 0)
    return {
      ...Qi,
      path: ta,
      message: Qi.message
    };
  let na = "";
  const la = Xi.filter((Ma) => !!Ma).slice().reverse();
  for (const Ma of la)
    na = Ma(ra, { data: e, defaultError: na }).message;
  return {
    ...Qi,
    path: ta,
    message: na
  };
}, sc = [];
function w(Bi, e) {
  const qi = ur(), Xi = cr({
    issueData: e,
    data: Bi.data,
    path: Bi.path,
    errorMaps: [
      Bi.common.contextualErrorMap,
      // contextual error map is first priority
      Bi.schemaErrorMap,
      // then schema-bound map if available
      qi,
      // then global override map
      qi === pt ? void 0 : pt
      // then global default map
    ].filter((Qi) => !!Qi)
  });
  Bi.common.issues.push(Xi);
}
class oe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, qi) {
    const Xi = [];
    for (const Qi of qi) {
      if (Qi.status === "aborted")
        return N;
      Qi.status === "dirty" && e.dirty(), Xi.push(Qi.value);
    }
    return { status: e.value, value: Xi };
  }
  static async mergeObjectAsync(e, qi) {
    const Xi = [];
    for (const Qi of qi) {
      const ta = await Qi.key, ra = await Qi.value;
      Xi.push({
        key: ta,
        value: ra
      });
    }
    return oe.mergeObjectSync(e, Xi);
  }
  static mergeObjectSync(e, qi) {
    const Xi = {};
    for (const Qi of qi) {
      const { key: ta, value: ra } = Qi;
      if (ta.status === "aborted" || ra.status === "aborted")
        return N;
      ta.status === "dirty" && e.dirty(), ra.status === "dirty" && e.dirty(), ta.value !== "__proto__" && (typeof ra.value < "u" || Qi.alwaysSet) && (Xi[ta.value] = ra.value);
    }
    return { status: e.value, value: Xi };
  }
}
const N = Object.freeze({
  status: "aborted"
}), st = (Bi) => ({ status: "dirty", value: Bi }), ce = (Bi) => ({ status: "valid", value: Bi }), pn = (Bi) => Bi.status === "aborted", yn = (Bi) => Bi.status === "dirty", Ye = (Bi) => Bi.status === "valid", jt = (Bi) => typeof Promise < "u" && Bi instanceof Promise;
function lr(Bi, e, qi, Xi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(Bi);
}
function qa(Bi, e, qi, Xi, Qi) {
  if (typeof e == "function" ? Bi !== e || !0 : !e.has(Bi)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(Bi, qi), qi;
}
var T;
(function(Bi) {
  Bi.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, Bi.toString = (e) => typeof e == "string" ? e : e?.message;
})(T || (T = {}));
var St, Ot;
class Oe {
  constructor(e, qi, Xi, Qi) {
    this._cachedPath = [], this.parent = e, this.data = qi, this._path = Xi, this._key = Qi;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Zi = (Bi, e) => {
  if (Ye(e))
    return { success: !0, data: e.value };
  if (!Bi.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const qi = new de(Bi.common.issues);
      return this._error = qi, this._error;
    }
  };
};
function F(Bi) {
  if (!Bi)
    return {};
  const { errorMap: e, invalid_type_error: qi, required_error: Xi, description: Qi } = Bi;
  if (e && (qi || Xi))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: Qi } : { errorMap: (ta, ra) => {
    var na, la;
    const { message: Ma } = Bi;
    return ta.code === "invalid_enum_value" ? { message: Ma ?? ra.defaultError } : typeof ra.data > "u" ? { message: (na = Ma ?? Xi) !== null && na !== void 0 ? na : ra.defaultError } : ta.code !== "invalid_type" ? { message: ra.defaultError } : { message: (la = Ma ?? qi) !== null && la !== void 0 ? la : ra.defaultError };
  }, description: Qi };
}
class M {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Re(e.data);
  }
  _getOrReturnCtx(e, qi) {
    return qi || {
      common: e.parent.common,
      data: e.data,
      parsedType: Re(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new oe(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Re(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const qi = this._parse(e);
    if (jt(qi))
      throw new Error("Synchronous parse encountered promise.");
    return qi;
  }
  _parseAsync(e) {
    const qi = this._parse(e);
    return Promise.resolve(qi);
  }
  parse(e, qi) {
    const Xi = this.safeParse(e, qi);
    if (Xi.success)
      return Xi.data;
    throw Xi.error;
  }
  safeParse(e, qi) {
    var Xi;
    const Qi = {
      common: {
        issues: [],
        async: (Xi = qi?.async) !== null && Xi !== void 0 ? Xi : !1,
        contextualErrorMap: qi?.errorMap
      },
      path: qi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, ta = this._parseSync({ data: e, path: Qi.path, parent: Qi });
    return Zi(Qi, ta);
  }
  "~validate"(e) {
    var qi, Xi;
    const Qi = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    };
    if (!this["~standard"].async)
      try {
        const ta = this._parseSync({ data: e, path: [], parent: Qi });
        return Ye(ta) ? {
          value: ta.value
        } : {
          issues: Qi.common.issues
        };
      } catch (ta) {
        !((Xi = (qi = ta?.message) === null || qi === void 0 ? void 0 : qi.toLowerCase()) === null || Xi === void 0) && Xi.includes("encountered") && (this["~standard"].async = !0), Qi.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: Qi }).then((ta) => Ye(ta) ? {
      value: ta.value
    } : {
      issues: Qi.common.issues
    });
  }
  async parseAsync(e, qi) {
    const Xi = await this.safeParseAsync(e, qi);
    if (Xi.success)
      return Xi.data;
    throw Xi.error;
  }
  async safeParseAsync(e, qi) {
    const Xi = {
      common: {
        issues: [],
        contextualErrorMap: qi?.errorMap,
        async: !0
      },
      path: qi?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Re(e)
    }, Qi = this._parse({ data: e, path: Xi.path, parent: Xi }), ta = await (jt(Qi) ? Qi : Promise.resolve(Qi));
    return Zi(Xi, ta);
  }
  refine(e, qi) {
    const Xi = (Qi) => typeof qi == "string" || typeof qi > "u" ? { message: qi } : typeof qi == "function" ? qi(Qi) : qi;
    return this._refinement((Qi, ta) => {
      const ra = e(Qi), na = () => ta.addIssue({
        code: g.custom,
        ...Xi(Qi)
      });
      return typeof Promise < "u" && ra instanceof Promise ? ra.then((la) => la ? !0 : (na(), !1)) : ra ? !0 : (na(), !1);
    });
  }
  refinement(e, qi) {
    return this._refinement((Xi, Qi) => e(Xi) ? !0 : (Qi.addIssue(typeof qi == "function" ? qi(Xi, Qi) : qi), !1));
  }
  _refinement(e) {
    return new ge({
      schema: this,
      typeName: j.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (qi) => this["~validate"](qi)
    };
  }
  optional() {
    return Se.create(this, this._def);
  }
  nullable() {
    return Ze.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return me.create(this);
  }
  promise() {
    return vt.create(this, this._def);
  }
  or(e) {
    return At.create([this, e], this._def);
  }
  and(e) {
    return Mt.create(this, e, this._def);
  }
  transform(e) {
    return new ge({
      ...F(this._def),
      schema: this,
      typeName: j.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const qi = typeof e == "function" ? e : () => e;
    return new Bt({
      ...F(this._def),
      innerType: this,
      defaultValue: qi,
      typeName: j.ZodDefault
    });
  }
  brand() {
    return new Bn({
      typeName: j.ZodBranded,
      type: this,
      ...F(this._def)
    });
  }
  catch(e) {
    const qi = typeof e == "function" ? e : () => e;
    return new Zt({
      ...F(this._def),
      innerType: this,
      catchValue: qi,
      typeName: j.ZodCatch
    });
  }
  describe(e) {
    const qi = this.constructor;
    return new qi({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Wt.create(this, e);
  }
  readonly() {
    return zt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const oc = /^c[^\s-]{8,}$/i, uc = /^[0-9a-z]+$/, cc = /^[0-9A-HJKMNP-TV-Z]{26}$/i, lc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, fc = /^[a-z0-9_-]{21}$/i, dc = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, hc = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, pc = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, yc = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let qr;
const vc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, mc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, gc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, bc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _c = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, wc = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Qa = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", kc = new RegExp(`^${Qa}$`);
function Ba(Bi) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return Bi.precision ? e = `${e}\\.\\d{${Bi.precision}}` : Bi.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function Ec(Bi) {
  return new RegExp(`^${Ba(Bi)}$`);
}
function Za(Bi) {
  let e = `${Qa}T${Ba(Bi)}`;
  const qi = [];
  return qi.push(Bi.local ? "Z?" : "Z"), Bi.offset && qi.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${qi.join("|")})`, new RegExp(`^${e}$`);
}
function Sc(Bi, e) {
  return !!((e === "v4" || !e) && vc.test(Bi) || (e === "v6" || !e) && gc.test(Bi));
}
function Oc(Bi, e) {
  if (!dc.test(Bi))
    return !1;
  try {
    const [qi] = Bi.split("."), Xi = qi.replace(/-/g, "+").replace(/_/g, "/").padEnd(qi.length + (4 - qi.length % 4) % 4, "="), Qi = JSON.parse(atob(Xi));
    return !(typeof Qi != "object" || Qi === null || !Qi.typ || !Qi.alg || e && Qi.alg !== e);
  } catch {
    return !1;
  }
}
function xc(Bi, e) {
  return !!((e === "v4" || !e) && mc.test(Bi) || (e === "v6" || !e) && bc.test(Bi));
}
class ve extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== O.string) {
      const Qi = this._getOrReturnCtx(e);
      return w(Qi, {
        code: g.invalid_type,
        expected: O.string,
        received: Qi.parsedType
      }), N;
    }
    const qi = new oe();
    let Xi;
    for (const Qi of this._def.checks)
      if (Qi.kind === "min")
        e.data.length < Qi.value && (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          code: g.too_small,
          minimum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "max")
        e.data.length > Qi.value && (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          code: g.too_big,
          maximum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "length") {
        const ta = e.data.length > Qi.value, ra = e.data.length < Qi.value;
        (ta || ra) && (Xi = this._getOrReturnCtx(e, Xi), ta ? w(Xi, {
          code: g.too_big,
          maximum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: Qi.message
        }) : ra && w(Xi, {
          code: g.too_small,
          minimum: Qi.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: Qi.message
        }), qi.dirty());
      } else if (Qi.kind === "email")
        pc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "email",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "emoji")
        qr || (qr = new RegExp(yc, "u")), qr.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "emoji",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "uuid")
        lc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "uuid",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "nanoid")
        fc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "nanoid",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "cuid")
        oc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "cuid",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "cuid2")
        uc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "cuid2",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "ulid")
        cc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
          validation: "ulid",
          code: g.invalid_string,
          message: Qi.message
        }), qi.dirty());
      else if (Qi.kind === "url")
        try {
          new URL(e.data);
        } catch {
          Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
            validation: "url",
            code: g.invalid_string,
            message: Qi.message
          }), qi.dirty();
        }
      else Qi.kind === "regex" ? (Qi.regex.lastIndex = 0, Qi.regex.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "regex",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty())) : Qi.kind === "trim" ? e.data = e.data.trim() : Qi.kind === "includes" ? e.data.includes(Qi.value, Qi.position) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.invalid_string,
        validation: { includes: Qi.value, position: Qi.position },
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : Qi.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : Qi.kind === "startsWith" ? e.data.startsWith(Qi.value) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.invalid_string,
        validation: { startsWith: Qi.value },
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "endsWith" ? e.data.endsWith(Qi.value) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.invalid_string,
        validation: { endsWith: Qi.value },
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "datetime" ? Za(Qi).test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.invalid_string,
        validation: "datetime",
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "date" ? kc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.invalid_string,
        validation: "date",
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "time" ? Ec(Qi).test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.invalid_string,
        validation: "time",
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "duration" ? hc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "duration",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "ip" ? Sc(e.data, Qi.version) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "ip",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "jwt" ? Oc(e.data, Qi.alg) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "jwt",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "cidr" ? xc(e.data, Qi.version) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "cidr",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "base64" ? _c.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "base64",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Qi.kind === "base64url" ? wc.test(e.data) || (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        validation: "base64url",
        code: g.invalid_string,
        message: Qi.message
      }), qi.dirty()) : Q.assertNever(Qi);
    return { status: qi.value, value: e.data };
  }
  _regex(e, qi, Xi) {
    return this.refinement((Qi) => e.test(Qi), {
      validation: qi,
      code: g.invalid_string,
      ...T.errToObj(Xi)
    });
  }
  _addCheck(e) {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...T.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...T.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...T.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...T.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...T.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...T.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...T.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...T.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...T.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...T.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...T.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...T.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...T.errToObj(e) });
  }
  datetime(e) {
    var qi, Xi;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (qi = e?.offset) !== null && qi !== void 0 ? qi : !1,
      local: (Xi = e?.local) !== null && Xi !== void 0 ? Xi : !1,
      ...T.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ...T.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...T.errToObj(e) });
  }
  regex(e, qi) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...T.errToObj(qi)
    });
  }
  includes(e, qi) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: qi?.position,
      ...T.errToObj(qi?.message)
    });
  }
  startsWith(e, qi) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...T.errToObj(qi)
    });
  }
  endsWith(e, qi) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...T.errToObj(qi)
    });
  }
  min(e, qi) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...T.errToObj(qi)
    });
  }
  max(e, qi) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...T.errToObj(qi)
    });
  }
  length(e, qi) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...T.errToObj(qi)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, T.errToObj(e));
  }
  trim() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new ve({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e;
  }
}
ve.create = (Bi) => {
  var e;
  return new ve({
    checks: [],
    typeName: j.ZodString,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ...F(Bi)
  });
};
function Tc(Bi, e) {
  const qi = (Bi.toString().split(".")[1] || "").length, Xi = (e.toString().split(".")[1] || "").length, Qi = qi > Xi ? qi : Xi, ta = parseInt(Bi.toFixed(Qi).replace(".", "")), ra = parseInt(e.toFixed(Qi).replace(".", ""));
  return ta % ra / Math.pow(10, Qi);
}
class qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== O.number) {
      const Qi = this._getOrReturnCtx(e);
      return w(Qi, {
        code: g.invalid_type,
        expected: O.number,
        received: Qi.parsedType
      }), N;
    }
    let qi;
    const Xi = new oe();
    for (const Qi of this._def.checks)
      Qi.kind === "int" ? Q.isInteger(e.data) || (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.invalid_type,
        expected: "integer",
        received: "float",
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "min" ? (Qi.inclusive ? e.data < Qi.value : e.data <= Qi.value) && (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.too_small,
        minimum: Qi.value,
        type: "number",
        inclusive: Qi.inclusive,
        exact: !1,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "max" ? (Qi.inclusive ? e.data > Qi.value : e.data >= Qi.value) && (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.too_big,
        maximum: Qi.value,
        type: "number",
        inclusive: Qi.inclusive,
        exact: !1,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "multipleOf" ? Tc(e.data, Qi.value) !== 0 && (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.not_multiple_of,
        multipleOf: Qi.value,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "finite" ? Number.isFinite(e.data) || (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.not_finite,
        message: Qi.message
      }), Xi.dirty()) : Q.assertNever(Qi);
    return { status: Xi.value, value: e.data };
  }
  gte(e, qi) {
    return this.setLimit("min", e, !0, T.toString(qi));
  }
  gt(e, qi) {
    return this.setLimit("min", e, !1, T.toString(qi));
  }
  lte(e, qi) {
    return this.setLimit("max", e, !0, T.toString(qi));
  }
  lt(e, qi) {
    return this.setLimit("max", e, !1, T.toString(qi));
  }
  setLimit(e, qi, Xi, Qi) {
    return new qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: qi,
          inclusive: Xi,
          message: T.toString(Qi)
        }
      ]
    });
  }
  _addCheck(e) {
    return new qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: T.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, qi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(qi)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: T.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: T.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: T.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Q.isInteger(e.value));
  }
  get isFinite() {
    let e = null, qi = null;
    for (const Xi of this._def.checks) {
      if (Xi.kind === "finite" || Xi.kind === "int" || Xi.kind === "multipleOf")
        return !0;
      Xi.kind === "min" ? (qi === null || Xi.value > qi) && (qi = Xi.value) : Xi.kind === "max" && (e === null || Xi.value < e) && (e = Xi.value);
    }
    return Number.isFinite(qi) && Number.isFinite(e);
  }
}
qe.create = (Bi) => new qe({
  checks: [],
  typeName: j.ZodNumber,
  coerce: Bi?.coerce || !1,
  ...F(Bi)
});
class Qe extends M {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== O.bigint)
      return this._getInvalidInput(e);
    let qi;
    const Xi = new oe();
    for (const Qi of this._def.checks)
      Qi.kind === "min" ? (Qi.inclusive ? e.data < Qi.value : e.data <= Qi.value) && (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.too_small,
        type: "bigint",
        minimum: Qi.value,
        inclusive: Qi.inclusive,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "max" ? (Qi.inclusive ? e.data > Qi.value : e.data >= Qi.value) && (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.too_big,
        type: "bigint",
        maximum: Qi.value,
        inclusive: Qi.inclusive,
        message: Qi.message
      }), Xi.dirty()) : Qi.kind === "multipleOf" ? e.data % Qi.value !== BigInt(0) && (qi = this._getOrReturnCtx(e, qi), w(qi, {
        code: g.not_multiple_of,
        multipleOf: Qi.value,
        message: Qi.message
      }), Xi.dirty()) : Q.assertNever(Qi);
    return { status: Xi.value, value: e.data };
  }
  _getInvalidInput(e) {
    const qi = this._getOrReturnCtx(e);
    return w(qi, {
      code: g.invalid_type,
      expected: O.bigint,
      received: qi.parsedType
    }), N;
  }
  gte(e, qi) {
    return this.setLimit("min", e, !0, T.toString(qi));
  }
  gt(e, qi) {
    return this.setLimit("min", e, !1, T.toString(qi));
  }
  lte(e, qi) {
    return this.setLimit("max", e, !0, T.toString(qi));
  }
  lt(e, qi) {
    return this.setLimit("max", e, !1, T.toString(qi));
  }
  setLimit(e, qi, Xi, Qi) {
    return new Qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: qi,
          inclusive: Xi,
          message: T.toString(Qi)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: T.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: T.toString(e)
    });
  }
  multipleOf(e, qi) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: T.toString(qi)
    });
  }
  get minValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e;
  }
}
Qe.create = (Bi) => {
  var e;
  return new Qe({
    checks: [],
    typeName: j.ZodBigInt,
    coerce: (e = Bi?.coerce) !== null && e !== void 0 ? e : !1,
    ...F(Bi)
  });
};
class Nt extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== O.boolean) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        code: g.invalid_type,
        expected: O.boolean,
        received: qi.parsedType
      }), N;
    }
    return ce(e.data);
  }
}
Nt.create = (Bi) => new Nt({
  typeName: j.ZodBoolean,
  coerce: Bi?.coerce || !1,
  ...F(Bi)
});
class Ke extends M {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== O.date) {
      const Qi = this._getOrReturnCtx(e);
      return w(Qi, {
        code: g.invalid_type,
        expected: O.date,
        received: Qi.parsedType
      }), N;
    }
    if (isNaN(e.data.getTime())) {
      const Qi = this._getOrReturnCtx(e);
      return w(Qi, {
        code: g.invalid_date
      }), N;
    }
    const qi = new oe();
    let Xi;
    for (const Qi of this._def.checks)
      Qi.kind === "min" ? e.data.getTime() < Qi.value && (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.too_small,
        message: Qi.message,
        inclusive: !0,
        exact: !1,
        minimum: Qi.value,
        type: "date"
      }), qi.dirty()) : Qi.kind === "max" ? e.data.getTime() > Qi.value && (Xi = this._getOrReturnCtx(e, Xi), w(Xi, {
        code: g.too_big,
        message: Qi.message,
        inclusive: !0,
        exact: !1,
        maximum: Qi.value,
        type: "date"
      }), qi.dirty()) : Q.assertNever(Qi);
    return {
      status: qi.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, qi) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: T.toString(qi)
    });
  }
  max(e, qi) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: T.toString(qi)
    });
  }
  get minDate() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "min" && (e === null || qi.value > e) && (e = qi.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const qi of this._def.checks)
      qi.kind === "max" && (e === null || qi.value < e) && (e = qi.value);
    return e != null ? new Date(e) : null;
  }
}
Ke.create = (Bi) => new Ke({
  checks: [],
  coerce: Bi?.coerce || !1,
  typeName: j.ZodDate,
  ...F(Bi)
});
class fr extends M {
  _parse(e) {
    if (this._getType(e) !== O.symbol) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        code: g.invalid_type,
        expected: O.symbol,
        received: qi.parsedType
      }), N;
    }
    return ce(e.data);
  }
}
fr.create = (Bi) => new fr({
  typeName: j.ZodSymbol,
  ...F(Bi)
});
class Pt extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        code: g.invalid_type,
        expected: O.undefined,
        received: qi.parsedType
      }), N;
    }
    return ce(e.data);
  }
}
Pt.create = (Bi) => new Pt({
  typeName: j.ZodUndefined,
  ...F(Bi)
});
class Ft extends M {
  _parse(e) {
    if (this._getType(e) !== O.null) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        code: g.invalid_type,
        expected: O.null,
        received: qi.parsedType
      }), N;
    }
    return ce(e.data);
  }
}
Ft.create = (Bi) => new Ft({
  typeName: j.ZodNull,
  ...F(Bi)
});
class yt extends M {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
yt.create = (Bi) => new yt({
  typeName: j.ZodAny,
  ...F(Bi)
});
class Ge extends M {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return ce(e.data);
  }
}
Ge.create = (Bi) => new Ge({
  typeName: j.ZodUnknown,
  ...F(Bi)
});
class je extends M {
  _parse(e) {
    const qi = this._getOrReturnCtx(e);
    return w(qi, {
      code: g.invalid_type,
      expected: O.never,
      received: qi.parsedType
    }), N;
  }
}
je.create = (Bi) => new je({
  typeName: j.ZodNever,
  ...F(Bi)
});
class dr extends M {
  _parse(e) {
    if (this._getType(e) !== O.undefined) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        code: g.invalid_type,
        expected: O.void,
        received: qi.parsedType
      }), N;
    }
    return ce(e.data);
  }
}
dr.create = (Bi) => new dr({
  typeName: j.ZodVoid,
  ...F(Bi)
});
class me extends M {
  _parse(e) {
    const { ctx: qi, status: Xi } = this._processInputParams(e), Qi = this._def;
    if (qi.parsedType !== O.array)
      return w(qi, {
        code: g.invalid_type,
        expected: O.array,
        received: qi.parsedType
      }), N;
    if (Qi.exactLength !== null) {
      const ra = qi.data.length > Qi.exactLength.value, na = qi.data.length < Qi.exactLength.value;
      (ra || na) && (w(qi, {
        code: ra ? g.too_big : g.too_small,
        minimum: na ? Qi.exactLength.value : void 0,
        maximum: ra ? Qi.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: Qi.exactLength.message
      }), Xi.dirty());
    }
    if (Qi.minLength !== null && qi.data.length < Qi.minLength.value && (w(qi, {
      code: g.too_small,
      minimum: Qi.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: Qi.minLength.message
    }), Xi.dirty()), Qi.maxLength !== null && qi.data.length > Qi.maxLength.value && (w(qi, {
      code: g.too_big,
      maximum: Qi.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: Qi.maxLength.message
    }), Xi.dirty()), qi.common.async)
      return Promise.all([...qi.data].map((ra, na) => Qi.type._parseAsync(new Oe(qi, ra, qi.path, na)))).then((ra) => oe.mergeArray(Xi, ra));
    const ta = [...qi.data].map((ra, na) => Qi.type._parseSync(new Oe(qi, ra, qi.path, na)));
    return oe.mergeArray(Xi, ta);
  }
  get element() {
    return this._def.type;
  }
  min(e, qi) {
    return new me({
      ...this._def,
      minLength: { value: e, message: T.toString(qi) }
    });
  }
  max(e, qi) {
    return new me({
      ...this._def,
      maxLength: { value: e, message: T.toString(qi) }
    });
  }
  length(e, qi) {
    return new me({
      ...this._def,
      exactLength: { value: e, message: T.toString(qi) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
me.create = (Bi, e) => new me({
  type: Bi,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: j.ZodArray,
  ...F(e)
});
function nt(Bi) {
  if (Bi instanceof H) {
    const e = {};
    for (const qi in Bi.shape) {
      const Xi = Bi.shape[qi];
      e[qi] = Se.create(nt(Xi));
    }
    return new H({
      ...Bi._def,
      shape: () => e
    });
  } else return Bi instanceof me ? new me({
    ...Bi._def,
    type: nt(Bi.element)
  }) : Bi instanceof Se ? Se.create(nt(Bi.unwrap())) : Bi instanceof Ze ? Ze.create(nt(Bi.unwrap())) : Bi instanceof xe ? xe.create(Bi.items.map((e) => nt(e))) : Bi;
}
class H extends M {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), qi = Q.objectKeys(e);
    return this._cached = { shape: e, keys: qi };
  }
  _parse(e) {
    if (this._getType(e) !== O.object) {
      const la = this._getOrReturnCtx(e);
      return w(la, {
        code: g.invalid_type,
        expected: O.object,
        received: la.parsedType
      }), N;
    }
    const { status: qi, ctx: Xi } = this._processInputParams(e), { shape: Qi, keys: ta } = this._getCached(), ra = [];
    if (!(this._def.catchall instanceof je && this._def.unknownKeys === "strip"))
      for (const la in Xi.data)
        ta.includes(la) || ra.push(la);
    const na = [];
    for (const la of ta) {
      const Ma = Qi[la], Va = Xi.data[la];
      na.push({
        key: { status: "valid", value: la },
        value: Ma._parse(new Oe(Xi, Va, Xi.path, la)),
        alwaysSet: la in Xi.data
      });
    }
    if (this._def.catchall instanceof je) {
      const la = this._def.unknownKeys;
      if (la === "passthrough")
        for (const Ma of ra)
          na.push({
            key: { status: "valid", value: Ma },
            value: { status: "valid", value: Xi.data[Ma] }
          });
      else if (la === "strict")
        ra.length > 0 && (w(Xi, {
          code: g.unrecognized_keys,
          keys: ra
        }), qi.dirty());
      else if (la !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const la = this._def.catchall;
      for (const Ma of ra) {
        const Va = Xi.data[Ma];
        na.push({
          key: { status: "valid", value: Ma },
          value: la._parse(
            new Oe(Xi, Va, Xi.path, Ma)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: Ma in Xi.data
        });
      }
    }
    return Xi.common.async ? Promise.resolve().then(async () => {
      const la = [];
      for (const Ma of na) {
        const Va = await Ma.key, to = await Ma.value;
        la.push({
          key: Va,
          value: to,
          alwaysSet: Ma.alwaysSet
        });
      }
      return la;
    }).then((la) => oe.mergeObjectSync(qi, la)) : oe.mergeObjectSync(qi, na);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return T.errToObj, new H({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (qi, Xi) => {
          var Qi, ta, ra, na;
          const la = (ra = (ta = (Qi = this._def).errorMap) === null || ta === void 0 ? void 0 : ta.call(Qi, qi, Xi).message) !== null && ra !== void 0 ? ra : Xi.defaultError;
          return qi.code === "unrecognized_keys" ? {
            message: (na = T.errToObj(e).message) !== null && na !== void 0 ? na : la
          } : {
            message: la
          };
        }
      } : {}
    });
  }
  strip() {
    return new H({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new H({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new H({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new H({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: j.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, qi) {
    return this.augment({ [e]: qi });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new H({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const qi = {};
    return Q.objectKeys(e).forEach((Xi) => {
      e[Xi] && this.shape[Xi] && (qi[Xi] = this.shape[Xi]);
    }), new H({
      ...this._def,
      shape: () => qi
    });
  }
  omit(e) {
    const qi = {};
    return Q.objectKeys(this.shape).forEach((Xi) => {
      e[Xi] || (qi[Xi] = this.shape[Xi]);
    }), new H({
      ...this._def,
      shape: () => qi
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return nt(this);
  }
  partial(e) {
    const qi = {};
    return Q.objectKeys(this.shape).forEach((Xi) => {
      const Qi = this.shape[Xi];
      e && !e[Xi] ? qi[Xi] = Qi : qi[Xi] = Qi.optional();
    }), new H({
      ...this._def,
      shape: () => qi
    });
  }
  required(e) {
    const qi = {};
    return Q.objectKeys(this.shape).forEach((Xi) => {
      if (e && !e[Xi])
        qi[Xi] = this.shape[Xi];
      else {
        let Qi = this.shape[Xi];
        for (; Qi instanceof Se; )
          Qi = Qi._def.innerType;
        qi[Xi] = Qi;
      }
    }), new H({
      ...this._def,
      shape: () => qi
    });
  }
  keyof() {
    return za(Q.objectKeys(this.shape));
  }
}
H.create = (Bi, e) => new H({
  shape: () => Bi,
  unknownKeys: "strip",
  catchall: je.create(),
  typeName: j.ZodObject,
  ...F(e)
});
H.strictCreate = (Bi, e) => new H({
  shape: () => Bi,
  unknownKeys: "strict",
  catchall: je.create(),
  typeName: j.ZodObject,
  ...F(e)
});
H.lazycreate = (Bi, e) => new H({
  shape: Bi,
  unknownKeys: "strip",
  catchall: je.create(),
  typeName: j.ZodObject,
  ...F(e)
});
class At extends M {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e), Xi = this._def.options;
    function Qi(ta) {
      for (const na of ta)
        if (na.result.status === "valid")
          return na.result;
      for (const na of ta)
        if (na.result.status === "dirty")
          return qi.common.issues.push(...na.ctx.common.issues), na.result;
      const ra = ta.map((na) => new de(na.ctx.common.issues));
      return w(qi, {
        code: g.invalid_union,
        unionErrors: ra
      }), N;
    }
    if (qi.common.async)
      return Promise.all(Xi.map(async (ta) => {
        const ra = {
          ...qi,
          common: {
            ...qi.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await ta._parseAsync({
            data: qi.data,
            path: qi.path,
            parent: ra
          }),
          ctx: ra
        };
      })).then(Qi);
    {
      let ta;
      const ra = [];
      for (const la of Xi) {
        const Ma = {
          ...qi,
          common: {
            ...qi.common,
            issues: []
          },
          parent: null
        }, Va = la._parseSync({
          data: qi.data,
          path: qi.path,
          parent: Ma
        });
        if (Va.status === "valid")
          return Va;
        Va.status === "dirty" && !ta && (ta = { result: Va, ctx: Ma }), Ma.common.issues.length && ra.push(Ma.common.issues);
      }
      if (ta)
        return qi.common.issues.push(...ta.ctx.common.issues), ta.result;
      const na = ra.map((la) => new de(la));
      return w(qi, {
        code: g.invalid_union,
        unionErrors: na
      }), N;
    }
  }
  get options() {
    return this._def.options;
  }
}
At.create = (Bi, e) => new At({
  options: Bi,
  typeName: j.ZodUnion,
  ...F(e)
});
const Ie = (Bi) => Bi instanceof Lt ? Ie(Bi.schema) : Bi instanceof ge ? Ie(Bi.innerType()) : Bi instanceof qt ? [Bi.value] : Bi instanceof Be ? Bi.options : Bi instanceof Qt ? Q.objectValues(Bi.enum) : Bi instanceof Bt ? Ie(Bi._def.innerType) : Bi instanceof Pt ? [void 0] : Bi instanceof Ft ? [null] : Bi instanceof Se ? [void 0, ...Ie(Bi.unwrap())] : Bi instanceof Ze ? [null, ...Ie(Bi.unwrap())] : Bi instanceof Bn || Bi instanceof zt ? Ie(Bi.unwrap()) : Bi instanceof Zt ? Ie(Bi._def.innerType) : [];
class Er extends M {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    if (qi.parsedType !== O.object)
      return w(qi, {
        code: g.invalid_type,
        expected: O.object,
        received: qi.parsedType
      }), N;
    const Xi = this.discriminator, Qi = qi.data[Xi], ta = this.optionsMap.get(Qi);
    return ta ? qi.common.async ? ta._parseAsync({
      data: qi.data,
      path: qi.path,
      parent: qi
    }) : ta._parseSync({
      data: qi.data,
      path: qi.path,
      parent: qi
    }) : (w(qi, {
      code: g.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [Xi]
    }), N);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, qi, Xi) {
    const Qi = /* @__PURE__ */ new Map();
    for (const ta of qi) {
      const ra = Ie(ta.shape[e]);
      if (!ra.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const na of ra) {
        if (Qi.has(na))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(na)}`);
        Qi.set(na, ta);
      }
    }
    return new Er({
      typeName: j.ZodDiscriminatedUnion,
      discriminator: e,
      options: qi,
      optionsMap: Qi,
      ...F(Xi)
    });
  }
}
function vn(Bi, e) {
  const qi = Re(Bi), Xi = Re(e);
  if (Bi === e)
    return { valid: !0, data: Bi };
  if (qi === O.object && Xi === O.object) {
    const Qi = Q.objectKeys(e), ta = Q.objectKeys(Bi).filter((na) => Qi.indexOf(na) !== -1), ra = { ...Bi, ...e };
    for (const na of ta) {
      const la = vn(Bi[na], e[na]);
      if (!la.valid)
        return { valid: !1 };
      ra[na] = la.data;
    }
    return { valid: !0, data: ra };
  } else if (qi === O.array && Xi === O.array) {
    if (Bi.length !== e.length)
      return { valid: !1 };
    const Qi = [];
    for (let ta = 0; ta < Bi.length; ta++) {
      const ra = Bi[ta], na = e[ta], la = vn(ra, na);
      if (!la.valid)
        return { valid: !1 };
      Qi.push(la.data);
    }
    return { valid: !0, data: Qi };
  } else return qi === O.date && Xi === O.date && +Bi == +e ? { valid: !0, data: Bi } : { valid: !1 };
}
class Mt extends M {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e), Qi = (ta, ra) => {
      if (pn(ta) || pn(ra))
        return N;
      const na = vn(ta.value, ra.value);
      return na.valid ? ((yn(ta) || yn(ra)) && qi.dirty(), { status: qi.value, value: na.data }) : (w(Xi, {
        code: g.invalid_intersection_types
      }), N);
    };
    return Xi.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: Xi.data,
        path: Xi.path,
        parent: Xi
      }),
      this._def.right._parseAsync({
        data: Xi.data,
        path: Xi.path,
        parent: Xi
      })
    ]).then(([ta, ra]) => Qi(ta, ra)) : Qi(this._def.left._parseSync({
      data: Xi.data,
      path: Xi.path,
      parent: Xi
    }), this._def.right._parseSync({
      data: Xi.data,
      path: Xi.path,
      parent: Xi
    }));
  }
}
Mt.create = (Bi, e, qi) => new Mt({
  left: Bi,
  right: e,
  typeName: j.ZodIntersection,
  ...F(qi)
});
class xe extends M {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== O.array)
      return w(Xi, {
        code: g.invalid_type,
        expected: O.array,
        received: Xi.parsedType
      }), N;
    if (Xi.data.length < this._def.items.length)
      return w(Xi, {
        code: g.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), N;
    !this._def.rest && Xi.data.length > this._def.items.length && (w(Xi, {
      code: g.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), qi.dirty());
    const Qi = [...Xi.data].map((ta, ra) => {
      const na = this._def.items[ra] || this._def.rest;
      return na ? na._parse(new Oe(Xi, ta, Xi.path, ra)) : null;
    }).filter((ta) => !!ta);
    return Xi.common.async ? Promise.all(Qi).then((ta) => oe.mergeArray(qi, ta)) : oe.mergeArray(qi, Qi);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new xe({
      ...this._def,
      rest: e
    });
  }
}
xe.create = (Bi, e) => {
  if (!Array.isArray(Bi))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new xe({
    items: Bi,
    typeName: j.ZodTuple,
    rest: null,
    ...F(e)
  });
};
class Vt extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== O.object)
      return w(Xi, {
        code: g.invalid_type,
        expected: O.object,
        received: Xi.parsedType
      }), N;
    const Qi = [], ta = this._def.keyType, ra = this._def.valueType;
    for (const na in Xi.data)
      Qi.push({
        key: ta._parse(new Oe(Xi, na, Xi.path, na)),
        value: ra._parse(new Oe(Xi, Xi.data[na], Xi.path, na)),
        alwaysSet: na in Xi.data
      });
    return Xi.common.async ? oe.mergeObjectAsync(qi, Qi) : oe.mergeObjectSync(qi, Qi);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, qi, Xi) {
    return qi instanceof M ? new Vt({
      keyType: e,
      valueType: qi,
      typeName: j.ZodRecord,
      ...F(Xi)
    }) : new Vt({
      keyType: ve.create(),
      valueType: e,
      typeName: j.ZodRecord,
      ...F(qi)
    });
  }
}
class hr extends M {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== O.map)
      return w(Xi, {
        code: g.invalid_type,
        expected: O.map,
        received: Xi.parsedType
      }), N;
    const Qi = this._def.keyType, ta = this._def.valueType, ra = [...Xi.data.entries()].map(([na, la], Ma) => ({
      key: Qi._parse(new Oe(Xi, na, Xi.path, [Ma, "key"])),
      value: ta._parse(new Oe(Xi, la, Xi.path, [Ma, "value"]))
    }));
    if (Xi.common.async) {
      const na = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const la of ra) {
          const Ma = await la.key, Va = await la.value;
          if (Ma.status === "aborted" || Va.status === "aborted")
            return N;
          (Ma.status === "dirty" || Va.status === "dirty") && qi.dirty(), na.set(Ma.value, Va.value);
        }
        return { status: qi.value, value: na };
      });
    } else {
      const na = /* @__PURE__ */ new Map();
      for (const la of ra) {
        const Ma = la.key, Va = la.value;
        if (Ma.status === "aborted" || Va.status === "aborted")
          return N;
        (Ma.status === "dirty" || Va.status === "dirty") && qi.dirty(), na.set(Ma.value, Va.value);
      }
      return { status: qi.value, value: na };
    }
  }
}
hr.create = (Bi, e, qi) => new hr({
  valueType: e,
  keyType: Bi,
  typeName: j.ZodMap,
  ...F(qi)
});
class Xe extends M {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.parsedType !== O.set)
      return w(Xi, {
        code: g.invalid_type,
        expected: O.set,
        received: Xi.parsedType
      }), N;
    const Qi = this._def;
    Qi.minSize !== null && Xi.data.size < Qi.minSize.value && (w(Xi, {
      code: g.too_small,
      minimum: Qi.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: Qi.minSize.message
    }), qi.dirty()), Qi.maxSize !== null && Xi.data.size > Qi.maxSize.value && (w(Xi, {
      code: g.too_big,
      maximum: Qi.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: Qi.maxSize.message
    }), qi.dirty());
    const ta = this._def.valueType;
    function ra(la) {
      const Ma = /* @__PURE__ */ new Set();
      for (const Va of la) {
        if (Va.status === "aborted")
          return N;
        Va.status === "dirty" && qi.dirty(), Ma.add(Va.value);
      }
      return { status: qi.value, value: Ma };
    }
    const na = [...Xi.data.values()].map((la, Ma) => ta._parse(new Oe(Xi, la, Xi.path, Ma)));
    return Xi.common.async ? Promise.all(na).then((la) => ra(la)) : ra(na);
  }
  min(e, qi) {
    return new Xe({
      ...this._def,
      minSize: { value: e, message: T.toString(qi) }
    });
  }
  max(e, qi) {
    return new Xe({
      ...this._def,
      maxSize: { value: e, message: T.toString(qi) }
    });
  }
  size(e, qi) {
    return this.min(e, qi).max(e, qi);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Xe.create = (Bi, e) => new Xe({
  valueType: Bi,
  minSize: null,
  maxSize: null,
  typeName: j.ZodSet,
  ...F(e)
});
class ct extends M {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    if (qi.parsedType !== O.function)
      return w(qi, {
        code: g.invalid_type,
        expected: O.function,
        received: qi.parsedType
      }), N;
    function Xi(na, la) {
      return cr({
        data: na,
        path: qi.path,
        errorMaps: [
          qi.common.contextualErrorMap,
          qi.schemaErrorMap,
          ur(),
          pt
        ].filter((Ma) => !!Ma),
        issueData: {
          code: g.invalid_arguments,
          argumentsError: la
        }
      });
    }
    function Qi(na, la) {
      return cr({
        data: na,
        path: qi.path,
        errorMaps: [
          qi.common.contextualErrorMap,
          qi.schemaErrorMap,
          ur(),
          pt
        ].filter((Ma) => !!Ma),
        issueData: {
          code: g.invalid_return_type,
          returnTypeError: la
        }
      });
    }
    const ta = { errorMap: qi.common.contextualErrorMap }, ra = qi.data;
    if (this._def.returns instanceof vt) {
      const na = this;
      return ce(async function(...la) {
        const Ma = new de([]), Va = await na._def.args.parseAsync(la, ta).catch((Eo) => {
          throw Ma.addIssue(Xi(la, Eo)), Ma;
        }), to = await Reflect.apply(ra, this, Va);
        return await na._def.returns._def.type.parseAsync(to, ta).catch((Eo) => {
          throw Ma.addIssue(Qi(to, Eo)), Ma;
        });
      });
    } else {
      const na = this;
      return ce(function(...la) {
        const Ma = na._def.args.safeParse(la, ta);
        if (!Ma.success)
          throw new de([Xi(la, Ma.error)]);
        const Va = Reflect.apply(ra, this, Ma.data), to = na._def.returns.safeParse(Va, ta);
        if (!to.success)
          throw new de([Qi(Va, to.error)]);
        return to.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ct({
      ...this._def,
      args: xe.create(e).rest(Ge.create())
    });
  }
  returns(e) {
    return new ct({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, qi, Xi) {
    return new ct({
      args: e || xe.create([]).rest(Ge.create()),
      returns: qi || Ge.create(),
      typeName: j.ZodFunction,
      ...F(Xi)
    });
  }
}
class Lt extends M {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    return this._def.getter()._parse({ data: qi.data, path: qi.path, parent: qi });
  }
}
Lt.create = (Bi, e) => new Lt({
  getter: Bi,
  typeName: j.ZodLazy,
  ...F(e)
});
class qt extends M {
  _parse(e) {
    if (e.data !== this._def.value) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        received: qi.data,
        code: g.invalid_literal,
        expected: this._def.value
      }), N;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
qt.create = (Bi, e) => new qt({
  value: Bi,
  typeName: j.ZodLiteral,
  ...F(e)
});
function za(Bi, e) {
  return new Be({
    values: Bi,
    typeName: j.ZodEnum,
    ...F(e)
  });
}
class Be extends M {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const qi = this._getOrReturnCtx(e), Xi = this._def.values;
      return w(qi, {
        expected: Q.joinValues(Xi),
        received: qi.parsedType,
        code: g.invalid_type
      }), N;
    }
    if (lr(this, St) || qa(this, St, new Set(this._def.values)), !lr(this, St).has(e.data)) {
      const qi = this._getOrReturnCtx(e), Xi = this._def.values;
      return w(qi, {
        received: qi.data,
        code: g.invalid_enum_value,
        options: Xi
      }), N;
    }
    return ce(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const qi of this._def.values)
      e[qi] = qi;
    return e;
  }
  get Values() {
    const e = {};
    for (const qi of this._def.values)
      e[qi] = qi;
    return e;
  }
  get Enum() {
    const e = {};
    for (const qi of this._def.values)
      e[qi] = qi;
    return e;
  }
  extract(e, qi = this._def) {
    return Be.create(e, {
      ...this._def,
      ...qi
    });
  }
  exclude(e, qi = this._def) {
    return Be.create(this.options.filter((Xi) => !e.includes(Xi)), {
      ...this._def,
      ...qi
    });
  }
}
St = /* @__PURE__ */ new WeakMap();
Be.create = za;
class Qt extends M {
  constructor() {
    super(...arguments), Ot.set(this, void 0);
  }
  _parse(e) {
    const qi = Q.getValidEnumValues(this._def.values), Xi = this._getOrReturnCtx(e);
    if (Xi.parsedType !== O.string && Xi.parsedType !== O.number) {
      const Qi = Q.objectValues(qi);
      return w(Xi, {
        expected: Q.joinValues(Qi),
        received: Xi.parsedType,
        code: g.invalid_type
      }), N;
    }
    if (lr(this, Ot) || qa(this, Ot, new Set(Q.getValidEnumValues(this._def.values))), !lr(this, Ot).has(e.data)) {
      const Qi = Q.objectValues(qi);
      return w(Xi, {
        received: Xi.data,
        code: g.invalid_enum_value,
        options: Qi
      }), N;
    }
    return ce(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ot = /* @__PURE__ */ new WeakMap();
Qt.create = (Bi, e) => new Qt({
  values: Bi,
  typeName: j.ZodNativeEnum,
  ...F(e)
});
class vt extends M {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    if (qi.parsedType !== O.promise && qi.common.async === !1)
      return w(qi, {
        code: g.invalid_type,
        expected: O.promise,
        received: qi.parsedType
      }), N;
    const Xi = qi.parsedType === O.promise ? qi.data : Promise.resolve(qi.data);
    return ce(Xi.then((Qi) => this._def.type.parseAsync(Qi, {
      path: qi.path,
      errorMap: qi.common.contextualErrorMap
    })));
  }
}
vt.create = (Bi, e) => new vt({
  type: Bi,
  typeName: j.ZodPromise,
  ...F(e)
});
class ge extends M {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === j.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e), Qi = this._def.effect || null, ta = {
      addIssue: (ra) => {
        w(Xi, ra), ra.fatal ? qi.abort() : qi.dirty();
      },
      get path() {
        return Xi.path;
      }
    };
    if (ta.addIssue = ta.addIssue.bind(ta), Qi.type === "preprocess") {
      const ra = Qi.transform(Xi.data, ta);
      if (Xi.common.async)
        return Promise.resolve(ra).then(async (na) => {
          if (qi.value === "aborted")
            return N;
          const la = await this._def.schema._parseAsync({
            data: na,
            path: Xi.path,
            parent: Xi
          });
          return la.status === "aborted" ? N : la.status === "dirty" || qi.value === "dirty" ? st(la.value) : la;
        });
      {
        if (qi.value === "aborted")
          return N;
        const na = this._def.schema._parseSync({
          data: ra,
          path: Xi.path,
          parent: Xi
        });
        return na.status === "aborted" ? N : na.status === "dirty" || qi.value === "dirty" ? st(na.value) : na;
      }
    }
    if (Qi.type === "refinement") {
      const ra = (na) => {
        const la = Qi.refinement(na, ta);
        if (Xi.common.async)
          return Promise.resolve(la);
        if (la instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return na;
      };
      if (Xi.common.async === !1) {
        const na = this._def.schema._parseSync({
          data: Xi.data,
          path: Xi.path,
          parent: Xi
        });
        return na.status === "aborted" ? N : (na.status === "dirty" && qi.dirty(), ra(na.value), { status: qi.value, value: na.value });
      } else
        return this._def.schema._parseAsync({ data: Xi.data, path: Xi.path, parent: Xi }).then((na) => na.status === "aborted" ? N : (na.status === "dirty" && qi.dirty(), ra(na.value).then(() => ({ status: qi.value, value: na.value }))));
    }
    if (Qi.type === "transform")
      if (Xi.common.async === !1) {
        const ra = this._def.schema._parseSync({
          data: Xi.data,
          path: Xi.path,
          parent: Xi
        });
        if (!Ye(ra))
          return ra;
        const na = Qi.transform(ra.value, ta);
        if (na instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: qi.value, value: na };
      } else
        return this._def.schema._parseAsync({ data: Xi.data, path: Xi.path, parent: Xi }).then((ra) => Ye(ra) ? Promise.resolve(Qi.transform(ra.value, ta)).then((na) => ({ status: qi.value, value: na })) : ra);
    Q.assertNever(Qi);
  }
}
ge.create = (Bi, e, qi) => new ge({
  schema: Bi,
  typeName: j.ZodEffects,
  effect: e,
  ...F(qi)
});
ge.createWithPreprocess = (Bi, e, qi) => new ge({
  schema: e,
  effect: { type: "preprocess", transform: Bi },
  typeName: j.ZodEffects,
  ...F(qi)
});
class Se extends M {
  _parse(e) {
    return this._getType(e) === O.undefined ? ce(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Se.create = (Bi, e) => new Se({
  innerType: Bi,
  typeName: j.ZodOptional,
  ...F(e)
});
class Ze extends M {
  _parse(e) {
    return this._getType(e) === O.null ? ce(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ze.create = (Bi, e) => new Ze({
  innerType: Bi,
  typeName: j.ZodNullable,
  ...F(e)
});
class Bt extends M {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e);
    let Xi = qi.data;
    return qi.parsedType === O.undefined && (Xi = this._def.defaultValue()), this._def.innerType._parse({
      data: Xi,
      path: qi.path,
      parent: qi
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Bt.create = (Bi, e) => new Bt({
  innerType: Bi,
  typeName: j.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...F(e)
});
class Zt extends M {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e), Xi = {
      ...qi,
      common: {
        ...qi.common,
        issues: []
      }
    }, Qi = this._def.innerType._parse({
      data: Xi.data,
      path: Xi.path,
      parent: {
        ...Xi
      }
    });
    return jt(Qi) ? Qi.then((ta) => ({
      status: "valid",
      value: ta.status === "valid" ? ta.value : this._def.catchValue({
        get error() {
          return new de(Xi.common.issues);
        },
        input: Xi.data
      })
    })) : {
      status: "valid",
      value: Qi.status === "valid" ? Qi.value : this._def.catchValue({
        get error() {
          return new de(Xi.common.issues);
        },
        input: Xi.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Zt.create = (Bi, e) => new Zt({
  innerType: Bi,
  typeName: j.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...F(e)
});
class pr extends M {
  _parse(e) {
    if (this._getType(e) !== O.nan) {
      const qi = this._getOrReturnCtx(e);
      return w(qi, {
        code: g.invalid_type,
        expected: O.nan,
        received: qi.parsedType
      }), N;
    }
    return { status: "valid", value: e.data };
  }
}
pr.create = (Bi) => new pr({
  typeName: j.ZodNaN,
  ...F(Bi)
});
const Dc = Symbol("zod_brand");
class Bn extends M {
  _parse(e) {
    const { ctx: qi } = this._processInputParams(e), Xi = qi.data;
    return this._def.type._parse({
      data: Xi,
      path: qi.path,
      parent: qi
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Wt extends M {
  _parse(e) {
    const { status: qi, ctx: Xi } = this._processInputParams(e);
    if (Xi.common.async)
      return (async () => {
        const Qi = await this._def.in._parseAsync({
          data: Xi.data,
          path: Xi.path,
          parent: Xi
        });
        return Qi.status === "aborted" ? N : Qi.status === "dirty" ? (qi.dirty(), st(Qi.value)) : this._def.out._parseAsync({
          data: Qi.value,
          path: Xi.path,
          parent: Xi
        });
      })();
    {
      const Qi = this._def.in._parseSync({
        data: Xi.data,
        path: Xi.path,
        parent: Xi
      });
      return Qi.status === "aborted" ? N : Qi.status === "dirty" ? (qi.dirty(), {
        status: "dirty",
        value: Qi.value
      }) : this._def.out._parseSync({
        data: Qi.value,
        path: Xi.path,
        parent: Xi
      });
    }
  }
  static create(e, qi) {
    return new Wt({
      in: e,
      out: qi,
      typeName: j.ZodPipeline
    });
  }
}
class zt extends M {
  _parse(e) {
    const qi = this._def.innerType._parse(e), Xi = (Qi) => (Ye(Qi) && (Qi.value = Object.freeze(Qi.value)), Qi);
    return jt(qi) ? qi.then((Qi) => Xi(Qi)) : Xi(qi);
  }
  unwrap() {
    return this._def.innerType;
  }
}
zt.create = (Bi, e) => new zt({
  innerType: Bi,
  typeName: j.ZodReadonly,
  ...F(e)
});
function zi(Bi, e) {
  const qi = typeof Bi == "function" ? Bi(e) : typeof Bi == "string" ? { message: Bi } : Bi;
  return typeof qi == "string" ? { message: qi } : qi;
}
function Ua(Bi, e = {}, qi) {
  return Bi ? yt.create().superRefine((Xi, Qi) => {
    var ta, ra;
    const na = Bi(Xi);
    if (na instanceof Promise)
      return na.then((la) => {
        var Ma, Va;
        if (!la) {
          const to = zi(e, Xi), Eo = (Va = (Ma = to.fatal) !== null && Ma !== void 0 ? Ma : qi) !== null && Va !== void 0 ? Va : !0;
          Qi.addIssue({ code: "custom", ...to, fatal: Eo });
        }
      });
    if (!na) {
      const la = zi(e, Xi), Ma = (ra = (ta = la.fatal) !== null && ta !== void 0 ? ta : qi) !== null && ra !== void 0 ? ra : !0;
      Qi.addIssue({ code: "custom", ...la, fatal: Ma });
    }
  }) : yt.create();
}
const Ic = {
  object: H.lazycreate
};
var j;
(function(Bi) {
  Bi.ZodString = "ZodString", Bi.ZodNumber = "ZodNumber", Bi.ZodNaN = "ZodNaN", Bi.ZodBigInt = "ZodBigInt", Bi.ZodBoolean = "ZodBoolean", Bi.ZodDate = "ZodDate", Bi.ZodSymbol = "ZodSymbol", Bi.ZodUndefined = "ZodUndefined", Bi.ZodNull = "ZodNull", Bi.ZodAny = "ZodAny", Bi.ZodUnknown = "ZodUnknown", Bi.ZodNever = "ZodNever", Bi.ZodVoid = "ZodVoid", Bi.ZodArray = "ZodArray", Bi.ZodObject = "ZodObject", Bi.ZodUnion = "ZodUnion", Bi.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", Bi.ZodIntersection = "ZodIntersection", Bi.ZodTuple = "ZodTuple", Bi.ZodRecord = "ZodRecord", Bi.ZodMap = "ZodMap", Bi.ZodSet = "ZodSet", Bi.ZodFunction = "ZodFunction", Bi.ZodLazy = "ZodLazy", Bi.ZodLiteral = "ZodLiteral", Bi.ZodEnum = "ZodEnum", Bi.ZodEffects = "ZodEffects", Bi.ZodNativeEnum = "ZodNativeEnum", Bi.ZodOptional = "ZodOptional", Bi.ZodNullable = "ZodNullable", Bi.ZodDefault = "ZodDefault", Bi.ZodCatch = "ZodCatch", Bi.ZodPromise = "ZodPromise", Bi.ZodBranded = "ZodBranded", Bi.ZodPipeline = "ZodPipeline", Bi.ZodReadonly = "ZodReadonly";
})(j || (j = {}));
const Rc = (Bi, e = {
  message: `Input not instance of ${Bi.name}`
}) => Ua((qi) => qi instanceof Bi, e), $a = ve.create, Wa = qe.create, Cc = pr.create, jc = Qe.create, Ga = Nt.create, Nc = Ke.create, Pc = fr.create, Fc = Pt.create, Ac = Ft.create, Mc = yt.create, Vc = Ge.create, Lc = je.create, qc = dr.create, Qc = me.create, Bc = H.create, Zc = H.strictCreate, zc = At.create, Uc = Er.create, $c = Mt.create, Wc = xe.create, Gc = Vt.create, Jc = hr.create, Hc = Xe.create, Yc = ct.create, Kc = Lt.create, Xc = qt.create, el = Be.create, tl = Qt.create, rl = vt.create, Ui = ge.create, nl = Se.create, il = Ze.create, al = ge.createWithPreprocess, sl = Wt.create, ol = () => $a().optional(), ul = () => Wa().optional(), cl = () => Ga().optional(), ll = {
  string: (Bi) => ve.create({ ...Bi, coerce: !0 }),
  number: (Bi) => qe.create({ ...Bi, coerce: !0 }),
  boolean: (Bi) => Nt.create({
    ...Bi,
    coerce: !0
  }),
  bigint: (Bi) => Qe.create({ ...Bi, coerce: !0 }),
  date: (Bi) => Ke.create({ ...Bi, coerce: !0 })
}, fl = N;
var f = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: pt,
  setErrorMap: ac,
  getErrorMap: ur,
  makeIssue: cr,
  EMPTY_PATH: sc,
  addIssueToContext: w,
  ParseStatus: oe,
  INVALID: N,
  DIRTY: st,
  OK: ce,
  isAborted: pn,
  isDirty: yn,
  isValid: Ye,
  isAsync: jt,
  get util() {
    return Q;
  },
  get objectUtil() {
    return hn;
  },
  ZodParsedType: O,
  getParsedType: Re,
  ZodType: M,
  datetimeRegex: Za,
  ZodString: ve,
  ZodNumber: qe,
  ZodBigInt: Qe,
  ZodBoolean: Nt,
  ZodDate: Ke,
  ZodSymbol: fr,
  ZodUndefined: Pt,
  ZodNull: Ft,
  ZodAny: yt,
  ZodUnknown: Ge,
  ZodNever: je,
  ZodVoid: dr,
  ZodArray: me,
  ZodObject: H,
  ZodUnion: At,
  ZodDiscriminatedUnion: Er,
  ZodIntersection: Mt,
  ZodTuple: xe,
  ZodRecord: Vt,
  ZodMap: hr,
  ZodSet: Xe,
  ZodFunction: ct,
  ZodLazy: Lt,
  ZodLiteral: qt,
  ZodEnum: Be,
  ZodNativeEnum: Qt,
  ZodPromise: vt,
  ZodEffects: ge,
  ZodTransformer: ge,
  ZodOptional: Se,
  ZodNullable: Ze,
  ZodDefault: Bt,
  ZodCatch: Zt,
  ZodNaN: pr,
  BRAND: Dc,
  ZodBranded: Bn,
  ZodPipeline: Wt,
  ZodReadonly: zt,
  custom: Ua,
  Schema: M,
  ZodSchema: M,
  late: Ic,
  get ZodFirstPartyTypeKind() {
    return j;
  },
  coerce: ll,
  any: Mc,
  array: Qc,
  bigint: jc,
  boolean: Ga,
  date: Nc,
  discriminatedUnion: Uc,
  effect: Ui,
  enum: el,
  function: Yc,
  instanceof: Rc,
  intersection: $c,
  lazy: Kc,
  literal: Xc,
  map: Jc,
  nan: Cc,
  nativeEnum: tl,
  never: Lc,
  null: Ac,
  nullable: il,
  number: Wa,
  object: Bc,
  oboolean: cl,
  onumber: ul,
  optional: nl,
  ostring: ol,
  pipeline: sl,
  preprocess: al,
  promise: rl,
  record: Gc,
  set: Hc,
  strictObject: Zc,
  string: $a,
  symbol: Pc,
  transformer: Ui,
  tuple: Wc,
  undefined: Fc,
  union: zc,
  unknown: Vc,
  void: qc,
  NEVER: fl,
  ZodIssueCode: g,
  quotelessJson: ic,
  ZodError: de
});
const Ja = f.enum([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), Zn = f.enum([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), zn = f.object({
  id: f.string(),
  firstname: f.string().nullable(),
  lastname: f.string().nullable(),
  email: f.string().nullable(),
  keyPairId: f.number(),
  roles: f.array(Ja),
  permissions: f.array(Zn)
}).passthrough();
f.object({ user: zn }).partial().passthrough();
f.object({ email: f.string() }).passthrough();
f.object({ success: f.boolean() }).passthrough();
f.object({ otp: f.string() }).passthrough();
f.object({ success: f.boolean() }).passthrough();
const ml = f.object({ success: f.boolean() }).passthrough();
f.object({ token: f.string() }).passthrough();
f.object({ token: f.string() }).passthrough();
f.object({ valid: f.boolean() }).passthrough();
f.object({ name: f.string(), permissions: f.array(Zn) }).passthrough();
const Ha = f.object({
  id: f.number(),
  instanceProfile: f.string().nullable(),
  securityGroup: f.string().nullable()
}).passthrough(), Gt = f.object({
  id: f.number(),
  name: f.string(),
  labId: f.number().nullish(),
  userId: f.string().nullish(),
  status: f.enum([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: f.string().nullish(),
  lastLogin: f.string().nullish(),
  keypairId: f.number().nullish()
}).passthrough();
f.object({
  infra: f.array(Ha),
  keyPairs: f.array(f.string()),
  tinkerBoxes: f.array(Gt)
}).passthrough();
f.object({ count: f.number().gte(1).lte(15) }).passthrough();
f.object({
  firstname: f.string().min(1),
  lastname: f.string().min(1),
  email: f.string().email(),
  password: f.string().min(8)
}).passthrough();
f.object({ users: f.array(zn) }).passthrough();
f.object({
  firstname: f.string().nullable(),
  lastname: f.string().nullable(),
  email: f.string().nullable()
}).partial().passthrough();
const Ya = f.object({ tinkerBox: Gt, keyMaterial: f.string() }).passthrough();
f.object({ tinkerBoxes: f.array(Ya) }).passthrough();
const Ka = f.object({
  labName: f.string(),
  ec2Cost: f.number(),
  s3Cost: f.number(),
  efsCost: f.number(),
  totalCost: f.number()
}).passthrough();
f.object({ clients: f.array(Ka) }).passthrough();
const Xa = f.object({
  name: f.string(),
  labName: f.string(),
  usage: f.string(),
  cost: f.number()
}).passthrough();
f.object({ tinkerBoxes: f.array(Xa) }).passthrough();
f.object({ tinkerboxes: f.array(Gt) }).passthrough();
f.object({ tinkerBox: Gt }).passthrough();
f.object({ name: f.string().nullable() }).partial().passthrough();
const es = f.object({
  id: f.number(),
  name: f.string(),
  s3BucketId: f.number(),
  keyPairId: f.number()
}).passthrough();
f.object({ labs: f.array(es) }).passthrough();
f.object({
  name: f.string(),
  numTinkerBoxes: f.number().optional().default(1)
}).passthrough();
f.object({ labId: f.number(), taskId: f.string() }).passthrough();
f.object({ id: f.string(), labId: f.number(), logs: f.string() }).passthrough();
const Un = f.object({
  id: f.number(),
  labId: f.number(),
  userId: f.string(),
  role: f.enum(["OWNER", "MEMBER"]),
  user: f.object({
    firstname: f.string().nullable(),
    lastname: f.string().nullable(),
    email: f.string().nullable(),
    id: f.string()
  }).partial().passthrough()
}).passthrough();
f.object({ labMember: Un.nullable() }).passthrough();
f.object({ labMembers: f.array(Un) }).passthrough();
f.object({
  labMember: f.object({
    id: f.number().int(),
    labId: f.number().int(),
    userId: f.string(),
    role: f.enum(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough();
f.object({ role: f.string() }).passthrough();
f.object({ labMemberId: f.number(), role: f.string() }).passthrough();
f.object({ success: f.boolean() }).passthrough();
f.object({
  client_secret: f.string().nullable(),
  status: f.string().nullable(),
  payment_status: f.string()
}).passthrough();
f.object({ name: f.string(), email: f.string().email(), message: f.string() }).passthrough();
f.object({ path: f.string(), s3BucketId: f.number().optional() }).passthrough();
const $l = f.object({ success: f.boolean() }).passthrough(), ts = f.object({
  isFolder: f.boolean(),
  bucketId: f.number().optional(),
  path: f.string()
}).passthrough(), Wl = f.object({ contents: f.array(ts) }).passthrough(), Gl = f.object({ files: f.array(f.string()) }).passthrough();
f.object({
  buckets: f.array(
    f.object({
      id: f.number().int(),
      bucket: f.string(),
      region: f.string(),
      prefix: f.string().nullish()
    }).passthrough()
  )
}).passthrough();
f.object({
  source: f.object({
    isFolder: f.boolean(),
    bucketId: f.number().optional(),
    path: f.string()
  }).passthrough(),
  target: f.object({
    isFolder: f.boolean(),
    bucketId: f.number().optional(),
    path: f.string()
  }).passthrough()
}).passthrough();
const Yl = f.object({ url: f.string() }).passthrough(), Kl = f.object({
  fileTransfers: f.array(
    f.object({
      id: f.number().int(),
      name: f.string(),
      userId: f.string(),
      progress: f.number()
    }).passthrough()
  )
}).passthrough();
f.object({ name: f.string(), enabled: f.boolean() }).passthrough();
f.object({
  id: f.number(),
  name: f.string(),
  schema: f.object({}).partial().passthrough()
}).passthrough();
f.object({
  id: f.number(),
  formId: f.number(),
  data: f.object({}).partial().passthrough(),
  dateCreated: f.string()
}).passthrough();
f.object({
  id: f.number(),
  name: f.string(),
  displayName: f.string(),
  hichip: f.string(),
  source: f.string(),
  bucket: f.string(),
  bedpeKey: f.string(),
  hicKey: f.string(),
  category: f.string()
}).passthrough();
f.object({
  id: f.number(),
  sampleId: f.number(),
  cluster: f.string(),
  chr: f.string(),
  start: f.number(),
  end: f.number(),
  size: f.number(),
  genes: f.string()
}).passthrough();
f.object({
  plotId: f.string(),
  status: f.enum(["PENDING", "COMPLETED", "FAILED"]),
  outputBucket: f.string(),
  outputKey: f.string(),
  inputs: f.object({}).partial().passthrough(),
  endedAt: f.string().nullable(),
  downloadUrl: f.string().nullable()
}).passthrough();
f.object({
  sample: f.string(),
  range: f.string(),
  genomeBuild: f.enum(["hg19", "hg38"]),
  color: f.string().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: f.string(),
  flank: f.number(),
  bedpe: f.string()
}).passthrough();
const $n = f.object({
  id: f.number(),
  title: f.string(),
  content: f.string(),
  createdAt: f.string(),
  updatedAt: f.string(),
  isActive: f.boolean()
}).passthrough();
f.object({ announcements: f.array($n) }).passthrough();
f.object({ announcement: $n.nullable() }).passthrough();
const $i = {
  SuccessDto: ml,
  CreateDirectoryResponse: $l,
  ContentsResponse: Wl,
  DeleteFilesResponse: Gl,
  PresignedUrlResponse: Yl,
  FileTransfersResponse: Kl
};
class hf {
  constructor(e) {
    mt(this, "fetch"), this.fetch = e;
  }
  async download(e, qi, Xi = null, Qi = !0) {
    let ta = `/files/presigned/${qi}/url?method=download`;
    e && (ta += `&bucket=${e}`), Xi && (ta += `&limit=${Xi}`);
    const ra = (await this.fetch(
      ta,
      { method: "GET" },
      $i.PresignedUrlResponse
    )).url;
    if (Qi) {
      const na = document.createElement("a");
      na.href = ra, na.download = "", na.target = "_blank", na.click(), document.body.appendChild(na), na.click(), setTimeout(() => {
        document.body.removeChild(na);
      });
    }
    return ra;
  }
  async upload(e, qi, Xi) {
    const Qi = [];
    let ta = `/files/presigned/${encodeURIComponent(Xi)}/url?method=upload`;
    qi && (ta = ta += `&bucket=${qi}`);
    const ra = (await this.fetch(
      ta,
      { method: "GET" },
      $i.PresignedUrlResponse
    )).url, na = new XMLHttpRequest();
    return na.open("PUT", ra), na.addEventListener("error", () => {
      for (const la of Qi)
        la.onError(new Error("Failed to upload file"));
    }), na.onerror = (la) => {
      console.error(la);
      for (const Ma of Qi)
        Ma.onError(new Error("Failed to upload file"));
    }, na.upload.addEventListener("progress", (la) => {
      const Ma = la.loaded / la.total;
      console.log({ progress: Ma });
      for (const Va of Qi)
        Va.onProgress(Ma);
    }), na.upload.addEventListener("load", () => {
      console.log("done", na.status);
      for (const la of Qi)
        la.onComplete();
      na.upload.removeEventListener("progress", () => null);
    }), na.send(e), {
      subscribe(la) {
        Qi.push(la);
      }
    };
  }
}
const Logo = ({ className: Bi = "" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    className: `${Bi} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function useErrorToast(Bi) {
  useEffect(() => {
    Bi && toast.error(Bi.toString());
  }, [Bi]);
}
async function createFolder(Bi, e, qi) {
  await Bi(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ s3BucketId: e, path: qi })
    },
    $i.CreateDirectoryResponse
  );
}
const useCreateFolder = (Bi) => {
  const e = useMutation({
    mutationKey: ["createFolder"],
    mutationFn: async (qi) => createFolder(Bi, qi.s3BucketId, qi.path)
  });
  return { ...e, createFolder: e.mutateAsync };
};
async function deleteFiles(Bi, e, qi) {
  let Qi = `/files/${encodeURIComponent(e)}?`;
  return qi && (Qi += `&bucket=${qi}`), await Bi(
    Qi,
    { method: "DELETE" },
    $i.DeleteFilesResponse
  );
}
const useDeleteFiles = (Bi) => {
  const e = useMutation({
    mutationKey: ["deleteFiles"],
    mutationFn: (qi) => deleteFiles(Bi, qi.path, qi.s3BucketId)
  });
  return { ...e, deleteFiles: e.mutateAsync };
};
async function getFileTranfsers(Bi) {
  return Bi(
    "/file-transfer",
    { method: "GET" },
    $i.FileTransfersResponse
  );
}
const useFileTransfersQuery = (Bi, e) => useQuery({
  queryKey: ["file-transfers"],
  queryFn: () => getFileTranfsers(e),
  refetchInterval: 500,
  enabled: Bi
}), searchFiles = async (Bi, e, qi) => await qi(
  `/files/?search=${e}&bucket=${Bi}`,
  {},
  $i.ContentsResponse
), getFolderContents = async (Bi, e, qi) => {
  let Qi = `/files/${encodeURIComponent(e || "")}?`;
  return Bi && (Qi += `bucket=${Bi}`), await qi(Qi, { method: "GET" }, $i.ContentsResponse);
}, useFolderContentsQuery = (Bi, e, qi) => useQuery({
  queryKey: ["files", Bi, e],
  queryFn: async () => getFolderContents(Bi, e, qi),
  refetchInterval: 2e3
});
async function moveFiles(Bi, e, qi) {
  return qi(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ source: Bi, target: e })
    },
    $i.SuccessDto
  );
}
function useMoveFilesMutation(Bi) {
  const e = useMutation({
    mutationKey: ["moveFiles"],
    mutationFn: ({ src: qi, dest: Xi }) => moveFiles(qi, Xi, Bi)
  });
  return { ...e, moveFiles: e.mutateAsync };
}
function S3FileBrowser({
  s3BucketId: Bi,
  fetch: e,
  selectionMode: qi,
  onSelectionChange: Xi,
  readOnly: Qi = !1,
  selection: ta = [],
  className: ra = ""
}) {
  const [na, la] = useState(""), {
    data: Ma,
    error: Va,
    refetch: to
  } = useFolderContentsQuery(Bi, na, e), [Eo, So] = useState(!1), { createFolder: eo } = useCreateFolder(e), { deleteFiles: rs, error: ko } = useDeleteFiles(e), { moveFiles: Hs, error: Ks } = useMoveFilesMutation(e), { data: Ys, error: Xs } = useFileTransfersQuery(Eo, e);
  useEffect(() => {
    Ys?.fileTransfers && Ys.fileTransfers.length > 0;
  }, [Ys]), useErrorToast(Ks), useErrorToast(Xs), useFileTranfersProgress(Ys), useEffect(() => {
    Va && toast.error(Va.message), ko && toast.error(ko.message);
  }, [Va, ko]);
  const Cs = Ma?.contents ?? [];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    FileBrowser,
    {
      className: ra,
      selectionMode: qi,
      filePathHomeDirectory: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { className: "inline w-3 h-3" }),
      files: Cs,
      selection: ta,
      readOnly: Qi,
      onSelectionChange: Xi,
      onDownload: async (Fs) => {
        await new hf(e).download(Bi, Fs.path, null, !0), to();
      },
      onMoveUpAFolder: async (Fs) => {
        if (!Fs) {
          toast.error("Already at root folder");
          return;
        }
        const { path: ws, parent: ls } = Fs;
        console.log("onMoveUpAFolder", { path: ws, parent: ls }), await Hs({
          src: ws,
          dest: { isFolder: !0, path: ls, bucketId: ws.bucketId }
        }), So(!0), await to();
      },
      onNavigate: (Fs, ws) => {
        la(ws);
      },
      onMove: async (Fs, ws) => {
        if (!ws.isFolder) {
          toast.error("Target must be a folder");
          return;
        }
        await Hs({ src: Fs, dest: ws }), await to(), So(!0);
      },
      onSearch: async (Fs) => (await searchFiles(Bi, Fs, e)).contents,
      onUpload: function(Fs) {
        const ws = new hf(e), ls = `${na}/${Fs[0].name}`;
        return ws.upload(Fs[0], Bi, ls);
      },
      onDelete: async (Fs) => {
        await rs({ s3BucketId: Bi, path: Fs[0].path }), await to();
      },
      onCreateFolder: async (Fs) => {
        await eo({ s3BucketId: Bi, path: Fs }), await to();
      },
      onPreview: async (Fs) => {
        await new hf(e).download(Bi, Fs.path), to();
      }
    }
  );
}
const useFileTranfersProgress = (Bi) => {
  useEffect(() => {
    if (Bi?.fileTransfers.length)
      for (const e of Bi.fileTransfers)
        toast(e.name, {
          progress: e.progress,
          toastId: e.id
        });
  }, [Bi]);
};
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(Bi) {
  return typeof Bi == "string" && REGEX.test(Bi);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i)
  byteToHex.push((i + 256).toString(16).substr(1));
function stringify(Bi) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, qi = (byteToHex[Bi[e + 0]] + byteToHex[Bi[e + 1]] + byteToHex[Bi[e + 2]] + byteToHex[Bi[e + 3]] + "-" + byteToHex[Bi[e + 4]] + byteToHex[Bi[e + 5]] + "-" + byteToHex[Bi[e + 6]] + byteToHex[Bi[e + 7]] + "-" + byteToHex[Bi[e + 8]] + byteToHex[Bi[e + 9]] + "-" + byteToHex[Bi[e + 10]] + byteToHex[Bi[e + 11]] + byteToHex[Bi[e + 12]] + byteToHex[Bi[e + 13]] + byteToHex[Bi[e + 14]] + byteToHex[Bi[e + 15]]).toLowerCase();
  if (!validate(qi))
    throw TypeError("Stringified UUID is invalid");
  return qi;
}
function v4(Bi, e, qi) {
  Bi = Bi || {};
  var Xi = Bi.random || (Bi.rng || rng)();
  return Xi[6] = Xi[6] & 15 | 64, Xi[8] = Xi[8] & 63 | 128, stringify(Xi);
}
const fileListToArray = (Bi) => {
  const e = [];
  for (let qi = 0; qi < Bi.length; qi++) {
    const Xi = Bi.item(qi);
    Xi && e.push(Xi);
  }
  return e;
}, FileInput = ({
  children: Bi,
  onChange: e,
  className: qi
}) => {
  const Xi = useRef(v4());
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `${qi} cursor-pointer`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "label",
      {
        htmlFor: Xi.current,
        onClick: (Qi) => Qi.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (Qi) => {
          Qi.key === "Enter" && Qi.stopPropagation();
        },
        children: Bi
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        onClick: (Qi) => Qi.stopPropagation(),
        onChange: (Qi) => {
          e(Qi.target.files ? fileListToArray(Qi.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: Xi.current
      }
    )
  ] });
}, FormikField = ({ name: Bi, ...e }) => {
  const [qi, Xi] = useField(Bi), { css: Qi, capture: ta, ...ra } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Field, { ...ra, ...qi, placeholder: e.placeholder || Bi }),
    Xi.touched && Xi.error && /* @__PURE__ */ jsxRuntimeExports.jsx(Error$1, { children: Xi.error })
  ] });
};
function GridArea({ area: Bi, children: e, className: qi }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${qi || ""}`, style: { gridArea: Bi }, children: e });
}
var reactResponsive$1 = { exports: {} }, reactResponsive = reactResponsive$1.exports, hasRequiredReactResponsive;
function requireReactResponsive() {
  return hasRequiredReactResponsive || (hasRequiredReactResponsive = 1, function(Bi, e) {
    (function(Xi, Qi) {
      Bi.exports = Qi(a__default);
    })(reactResponsive, (qi) => (
      /******/
      (() => {
        var Xi = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            (na, la) => {
              la.match = eo, la.parse = rs;
              var Ma = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, Va = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, to = /^(?:(min|max)-)?(.+)/, Eo = /(em|rem|px|cm|mm|in|pt|pc)?$/, So = /(dpi|dpcm|dppx)?$/;
              function eo(Ys, Xs) {
                return rs(Ys).some(function(Cs) {
                  var Fs = Cs.inverse, ws = Cs.type === "all" || Xs.type === Cs.type;
                  if (ws && Fs || !(ws || Fs))
                    return !1;
                  var ls = Cs.expressions.every(function(ks) {
                    var Js = ks.feature, pl = ks.modifier, _l = ks.value, bl = Xs[Js];
                    if (!bl)
                      return !1;
                    switch (Js) {
                      case "orientation":
                      case "scan":
                        return bl.toLowerCase() === _l.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        _l = Ks(_l), bl = Ks(bl);
                        break;
                      case "resolution":
                        _l = Hs(_l), bl = Hs(bl);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        _l = ko(_l), bl = ko(bl);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        _l = parseInt(_l, 10) || 1, bl = parseInt(bl, 10) || 0;
                        break;
                    }
                    switch (pl) {
                      case "min":
                        return bl >= _l;
                      case "max":
                        return bl <= _l;
                      default:
                        return bl === _l;
                    }
                  });
                  return ls && !Fs || !ls && Fs;
                });
              }
              function rs(Ys) {
                return Ys.split(",").map(function(Xs) {
                  Xs = Xs.trim();
                  var Cs = Xs.match(Ma), Fs = Cs[1], ws = Cs[2], ls = Cs[3] || "", ks = {};
                  return ks.inverse = !!Fs && Fs.toLowerCase() === "not", ks.type = ws ? ws.toLowerCase() : "all", ls = ls.match(/\([^\)]+\)/g) || [], ks.expressions = ls.map(function(Js) {
                    var pl = Js.match(Va), _l = pl[1].toLowerCase().match(to);
                    return {
                      modifier: _l[1],
                      feature: _l[2],
                      value: pl[2]
                    };
                  }), ks;
                });
              }
              function ko(Ys) {
                var Xs = Number(Ys), Cs;
                return Xs || (Cs = Ys.match(/^(\d+)\s*\/\s*(\d+)$/), Xs = Cs[1] / Cs[2]), Xs;
              }
              function Hs(Ys) {
                var Xs = parseFloat(Ys), Cs = String(Ys).match(So)[1];
                switch (Cs) {
                  case "dpcm":
                    return Xs / 2.54;
                  case "dppx":
                    return Xs * 96;
                  default:
                    return Xs;
                }
              }
              function Ks(Ys) {
                var Xs = parseFloat(Ys), Cs = String(Ys).match(Eo)[1];
                switch (Cs) {
                  case "em":
                    return Xs * 16;
                  case "rem":
                    return Xs * 16;
                  case "cm":
                    return Xs * 96 / 2.54;
                  case "mm":
                    return Xs * 96 / 2.54 / 10;
                  case "in":
                    return Xs * 96;
                  case "pt":
                    return Xs * 72;
                  case "pc":
                    return Xs * 72 / 12;
                  default:
                    return Xs;
                }
              }
            }
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            (na, la, Ma) => {
              Ma.r(la), Ma.d(la, {
                /* harmony export */
                default: () => rs
                /* harmony export */
              });
              var Va = /[A-Z]/g, to = /^ms-/, Eo = {};
              function So(ko) {
                return "-" + ko.toLowerCase();
              }
              function eo(ko) {
                if (Eo.hasOwnProperty(ko))
                  return Eo[ko];
                var Hs = ko.replace(Va, So);
                return Eo[ko] = to.test(Hs) ? "-" + Hs : Hs;
              }
              const rs = eo;
            }
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            (na, la, Ma) => {
              var Va = Ma(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, to = typeof window < "u" ? window.matchMedia : null;
              function Eo(eo, rs, ko) {
                var Hs = this;
                if (to && !ko) {
                  var Ks = to.call(window, eo);
                  this.matches = Ks.matches, this.media = Ks.media, Ks.addListener(Cs);
                } else
                  this.matches = Va(eo, rs), this.media = eo;
                this.addListener = Ys, this.removeListener = Xs, this.dispose = Fs;
                function Ys(ws) {
                  Ks && Ks.addListener(ws);
                }
                function Xs(ws) {
                  Ks && Ks.removeListener(ws);
                }
                function Cs(ws) {
                  Hs.matches = ws.matches, Hs.media = ws.media;
                }
                function Fs() {
                  Ks && Ks.removeListener(Cs);
                }
              }
              function So(eo, rs, ko) {
                return new Eo(eo, rs, ko);
              }
              na.exports = So;
            }
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            (na) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var la = Object.getOwnPropertySymbols, Ma = Object.prototype.hasOwnProperty, Va = Object.prototype.propertyIsEnumerable;
              function to(So) {
                if (So == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(So);
              }
              function Eo() {
                try {
                  if (!Object.assign)
                    return !1;
                  var So = new String("abc");
                  if (So[5] = "de", Object.getOwnPropertyNames(So)[0] === "5")
                    return !1;
                  for (var eo = {}, rs = 0; rs < 10; rs++)
                    eo["_" + String.fromCharCode(rs)] = rs;
                  var ko = Object.getOwnPropertyNames(eo).map(function(Ks) {
                    return eo[Ks];
                  });
                  if (ko.join("") !== "0123456789")
                    return !1;
                  var Hs = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(Ks) {
                    Hs[Ks] = Ks;
                  }), Object.keys(Object.assign({}, Hs)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              na.exports = Eo() ? Object.assign : function(So, eo) {
                for (var rs, ko = to(So), Hs, Ks = 1; Ks < arguments.length; Ks++) {
                  rs = Object(arguments[Ks]);
                  for (var Ys in rs)
                    Ma.call(rs, Ys) && (ko[Ys] = rs[Ys]);
                  if (la) {
                    Hs = la(rs);
                    for (var Xs = 0; Xs < Hs.length; Xs++)
                      Va.call(rs, Hs[Xs]) && (ko[Hs[Xs]] = rs[Hs[Xs]]);
                  }
                }
                return ko;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            (na, la, Ma) => {
              var Va = function() {
              };
              {
                var to = Ma(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), Eo = {}, So = Ma(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                Va = function(rs) {
                  var ko = "Warning: " + rs;
                  typeof console < "u" && console.error(ko);
                  try {
                    throw new Error(ko);
                  } catch {
                  }
                };
              }
              function eo(rs, ko, Hs, Ks, Ys) {
                for (var Xs in rs)
                  if (So(rs, Xs)) {
                    var Cs;
                    try {
                      if (typeof rs[Xs] != "function") {
                        var Fs = Error(
                          (Ks || "React class") + ": " + Hs + " type `" + Xs + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof rs[Xs] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw Fs.name = "Invariant Violation", Fs;
                      }
                      Cs = rs[Xs](ko, Xs, Ks, Hs, null, to);
                    } catch (ls) {
                      Cs = ls;
                    }
                    if (Cs && !(Cs instanceof Error) && Va(
                      (Ks || "React class") + ": type specification of " + Hs + " `" + Xs + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof Cs + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), Cs instanceof Error && !(Cs.message in Eo)) {
                      Eo[Cs.message] = !0;
                      var ws = Ys ? Ys() : "";
                      Va(
                        "Failed " + Hs + " type: " + Cs.message + (ws ?? "")
                      );
                    }
                  }
              }
              eo.resetWarningCache = function() {
                Eo = {};
              }, na.exports = eo;
            }
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            (na, la, Ma) => {
              var Va = Ma(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), to = Ma(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), Eo = Ma(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), So = Ma(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), eo = Ma(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), rs = function() {
              };
              rs = function(Hs) {
                var Ks = "Warning: " + Hs;
                typeof console < "u" && console.error(Ks);
                try {
                  throw new Error(Ks);
                } catch {
                }
              };
              function ko() {
                return null;
              }
              na.exports = function(Hs, Ks) {
                var Ys = typeof Symbol == "function" && Symbol.iterator, Xs = "@@iterator";
                function Cs(Gs) {
                  var vl = Gs && (Ys && Gs[Ys] || Gs[Xs]);
                  if (typeof vl == "function")
                    return vl;
                }
                var Fs = "<<anonymous>>", ws = {
                  array: pl("array"),
                  bigint: pl("bigint"),
                  bool: pl("boolean"),
                  func: pl("function"),
                  number: pl("number"),
                  object: pl("object"),
                  string: pl("string"),
                  symbol: pl("symbol"),
                  any: _l(),
                  arrayOf: bl,
                  element: xl(),
                  elementType: Rl(),
                  instanceOf: Cl,
                  node: Bl(),
                  objectOf: kl,
                  oneOf: Dl,
                  oneOfType: Ul,
                  shape: Pl,
                  exact: yl
                };
                function ls(Gs, vl) {
                  return Gs === vl ? Gs !== 0 || 1 / Gs === 1 / vl : Gs !== Gs && vl !== vl;
                }
                function ks(Gs, vl) {
                  this.message = Gs, this.data = vl && typeof vl == "object" ? vl : {}, this.stack = "";
                }
                ks.prototype = Error.prototype;
                function Js(Gs) {
                  var vl = {}, gl = 0;
                  function El(wl, dl, Sl, Ml, Fl, Ll, Nl) {
                    if (Ml = Ml || Fs, Ll = Ll || Sl, Nl !== Eo) {
                      if (Ks) {
                        var ql = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw ql.name = "Invariant Violation", ql;
                      } else if (typeof console < "u") {
                        var Jl = Ml + ":" + Sl;
                        !vl[Jl] && // Avoid spamming the console because they are often not actionable except for lib authors
                        gl < 3 && (rs(
                          "You are manually calling a React.PropTypes validation function for the `" + Ll + "` prop on `" + Ml + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), vl[Jl] = !0, gl++);
                      }
                    }
                    return dl[Sl] == null ? wl ? dl[Sl] === null ? new ks("The " + Fl + " `" + Ll + "` is marked as required " + ("in `" + Ml + "`, but its value is `null`.")) : new ks("The " + Fl + " `" + Ll + "` is marked as required in " + ("`" + Ml + "`, but its value is `undefined`.")) : null : Gs(dl, Sl, Ml, Fl, Ll);
                  }
                  var Ol = El.bind(null, !1);
                  return Ol.isRequired = El.bind(null, !0), Ol;
                }
                function pl(Gs) {
                  function vl(gl, El, Ol, wl, dl, Sl) {
                    var Ml = gl[El], Fl = Il(Ml);
                    if (Fl !== Gs) {
                      var Ll = jl(Ml);
                      return new ks(
                        "Invalid " + wl + " `" + dl + "` of type " + ("`" + Ll + "` supplied to `" + Ol + "`, expected ") + ("`" + Gs + "`."),
                        { expectedType: Gs }
                      );
                    }
                    return null;
                  }
                  return Js(vl);
                }
                function _l() {
                  return Js(ko);
                }
                function bl(Gs) {
                  function vl(gl, El, Ol, wl, dl) {
                    if (typeof Gs != "function")
                      return new ks("Property `" + dl + "` of component `" + Ol + "` has invalid PropType notation inside arrayOf.");
                    var Sl = gl[El];
                    if (!Array.isArray(Sl)) {
                      var Ml = Il(Sl);
                      return new ks("Invalid " + wl + " `" + dl + "` of type " + ("`" + Ml + "` supplied to `" + Ol + "`, expected an array."));
                    }
                    for (var Fl = 0; Fl < Sl.length; Fl++) {
                      var Ll = Gs(Sl, Fl, Ol, wl, dl + "[" + Fl + "]", Eo);
                      if (Ll instanceof Error)
                        return Ll;
                    }
                    return null;
                  }
                  return Js(vl);
                }
                function xl() {
                  function Gs(vl, gl, El, Ol, wl) {
                    var dl = vl[gl];
                    if (!Hs(dl)) {
                      var Sl = Il(dl);
                      return new ks("Invalid " + Ol + " `" + wl + "` of type " + ("`" + Sl + "` supplied to `" + El + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return Js(Gs);
                }
                function Rl() {
                  function Gs(vl, gl, El, Ol, wl) {
                    var dl = vl[gl];
                    if (!Va.isValidElementType(dl)) {
                      var Sl = Il(dl);
                      return new ks("Invalid " + Ol + " `" + wl + "` of type " + ("`" + Sl + "` supplied to `" + El + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return Js(Gs);
                }
                function Cl(Gs) {
                  function vl(gl, El, Ol, wl, dl) {
                    if (!(gl[El] instanceof Gs)) {
                      var Sl = Gs.name || Fs, Ml = _s(gl[El]);
                      return new ks("Invalid " + wl + " `" + dl + "` of type " + ("`" + Ml + "` supplied to `" + Ol + "`, expected ") + ("instance of `" + Sl + "`."));
                    }
                    return null;
                  }
                  return Js(vl);
                }
                function Dl(Gs) {
                  if (!Array.isArray(Gs))
                    return arguments.length > 1 ? rs(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : rs("Invalid argument supplied to oneOf, expected an array."), ko;
                  function vl(gl, El, Ol, wl, dl) {
                    for (var Sl = gl[El], Ml = 0; Ml < Gs.length; Ml++)
                      if (ls(Sl, Gs[Ml]))
                        return null;
                    var Fl = JSON.stringify(Gs, function(Nl, ql) {
                      var Jl = jl(ql);
                      return Jl === "symbol" ? String(ql) : ql;
                    });
                    return new ks("Invalid " + wl + " `" + dl + "` of value `" + String(Sl) + "` " + ("supplied to `" + Ol + "`, expected one of " + Fl + "."));
                  }
                  return Js(vl);
                }
                function kl(Gs) {
                  function vl(gl, El, Ol, wl, dl) {
                    if (typeof Gs != "function")
                      return new ks("Property `" + dl + "` of component `" + Ol + "` has invalid PropType notation inside objectOf.");
                    var Sl = gl[El], Ml = Il(Sl);
                    if (Ml !== "object")
                      return new ks("Invalid " + wl + " `" + dl + "` of type " + ("`" + Ml + "` supplied to `" + Ol + "`, expected an object."));
                    for (var Fl in Sl)
                      if (So(Sl, Fl)) {
                        var Ll = Gs(Sl, Fl, Ol, wl, dl + "." + Fl, Eo);
                        if (Ll instanceof Error)
                          return Ll;
                      }
                    return null;
                  }
                  return Js(vl);
                }
                function Ul(Gs) {
                  if (!Array.isArray(Gs))
                    return rs("Invalid argument supplied to oneOfType, expected an instance of array."), ko;
                  for (var vl = 0; vl < Gs.length; vl++) {
                    var gl = Gs[vl];
                    if (typeof gl != "function")
                      return rs(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Al(gl) + " at index " + vl + "."
                      ), ko;
                  }
                  function El(Ol, wl, dl, Sl, Ml) {
                    for (var Fl = [], Ll = 0; Ll < Gs.length; Ll++) {
                      var Nl = Gs[Ll], ql = Nl(Ol, wl, dl, Sl, Ml, Eo);
                      if (ql == null)
                        return null;
                      ql.data && So(ql.data, "expectedType") && Fl.push(ql.data.expectedType);
                    }
                    var Jl = Fl.length > 0 ? ", expected one of type [" + Fl.join(", ") + "]" : "";
                    return new ks("Invalid " + Sl + " `" + Ml + "` supplied to " + ("`" + dl + "`" + Jl + "."));
                  }
                  return Js(El);
                }
                function Bl() {
                  function Gs(vl, gl, El, Ol, wl) {
                    return hl(vl[gl]) ? null : new ks("Invalid " + Ol + " `" + wl + "` supplied to " + ("`" + El + "`, expected a ReactNode."));
                  }
                  return Js(Gs);
                }
                function Zl(Gs, vl, gl, El, Ol) {
                  return new ks(
                    (Gs || "React class") + ": " + vl + " type `" + gl + "." + El + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ol + "`."
                  );
                }
                function Pl(Gs) {
                  function vl(gl, El, Ol, wl, dl) {
                    var Sl = gl[El], Ml = Il(Sl);
                    if (Ml !== "object")
                      return new ks("Invalid " + wl + " `" + dl + "` of type `" + Ml + "` " + ("supplied to `" + Ol + "`, expected `object`."));
                    for (var Fl in Gs) {
                      var Ll = Gs[Fl];
                      if (typeof Ll != "function")
                        return Zl(Ol, wl, dl, Fl, jl(Ll));
                      var Nl = Ll(Sl, Fl, Ol, wl, dl + "." + Fl, Eo);
                      if (Nl)
                        return Nl;
                    }
                    return null;
                  }
                  return Js(vl);
                }
                function yl(Gs) {
                  function vl(gl, El, Ol, wl, dl) {
                    var Sl = gl[El], Ml = Il(Sl);
                    if (Ml !== "object")
                      return new ks("Invalid " + wl + " `" + dl + "` of type `" + Ml + "` " + ("supplied to `" + Ol + "`, expected `object`."));
                    var Fl = to({}, gl[El], Gs);
                    for (var Ll in Fl) {
                      var Nl = Gs[Ll];
                      if (So(Gs, Ll) && typeof Nl != "function")
                        return Zl(Ol, wl, dl, Ll, jl(Nl));
                      if (!Nl)
                        return new ks(
                          "Invalid " + wl + " `" + dl + "` key `" + Ll + "` supplied to `" + Ol + "`.\nBad object: " + JSON.stringify(gl[El], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Gs), null, "  ")
                        );
                      var ql = Nl(Sl, Ll, Ol, wl, dl + "." + Ll, Eo);
                      if (ql)
                        return ql;
                    }
                    return null;
                  }
                  return Js(vl);
                }
                function hl(Gs) {
                  switch (typeof Gs) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !Gs;
                    case "object":
                      if (Array.isArray(Gs))
                        return Gs.every(hl);
                      if (Gs === null || Hs(Gs))
                        return !0;
                      var vl = Cs(Gs);
                      if (vl) {
                        var gl = vl.call(Gs), El;
                        if (vl !== Gs.entries) {
                          for (; !(El = gl.next()).done; )
                            if (!hl(El.value))
                              return !1;
                        } else
                          for (; !(El = gl.next()).done; ) {
                            var Ol = El.value;
                            if (Ol && !hl(Ol[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function Tl(Gs, vl) {
                  return Gs === "symbol" ? !0 : vl ? vl["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && vl instanceof Symbol : !1;
                }
                function Il(Gs) {
                  var vl = typeof Gs;
                  return Array.isArray(Gs) ? "array" : Gs instanceof RegExp ? "object" : Tl(vl, Gs) ? "symbol" : vl;
                }
                function jl(Gs) {
                  if (typeof Gs > "u" || Gs === null)
                    return "" + Gs;
                  var vl = Il(Gs);
                  if (vl === "object") {
                    if (Gs instanceof Date)
                      return "date";
                    if (Gs instanceof RegExp)
                      return "regexp";
                  }
                  return vl;
                }
                function Al(Gs) {
                  var vl = jl(Gs);
                  switch (vl) {
                    case "array":
                    case "object":
                      return "an " + vl;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + vl;
                    default:
                      return vl;
                  }
                }
                function _s(Gs) {
                  return !Gs.constructor || !Gs.constructor.name ? Fs : Gs.constructor.name;
                }
                return ws.checkPropTypes = eo, ws.resetWarningCache = eo.resetWarningCache, ws.PropTypes = ws, ws;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            (na, la, Ma) => {
              {
                var Va = Ma(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), to = !0;
                na.exports = Ma(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(Va.isElement, to);
              }
            }
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            (na) => {
              var la = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              na.exports = la;
            }
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            (na) => {
              na.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            }
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            (na, la) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var Ma = typeof Symbol == "function" && Symbol.for, Va = Ma ? Symbol.for("react.element") : 60103, to = Ma ? Symbol.for("react.portal") : 60106, Eo = Ma ? Symbol.for("react.fragment") : 60107, So = Ma ? Symbol.for("react.strict_mode") : 60108, eo = Ma ? Symbol.for("react.profiler") : 60114, rs = Ma ? Symbol.for("react.provider") : 60109, ko = Ma ? Symbol.for("react.context") : 60110, Hs = Ma ? Symbol.for("react.async_mode") : 60111, Ks = Ma ? Symbol.for("react.concurrent_mode") : 60111, Ys = Ma ? Symbol.for("react.forward_ref") : 60112, Xs = Ma ? Symbol.for("react.suspense") : 60113, Cs = Ma ? Symbol.for("react.suspense_list") : 60120, Fs = Ma ? Symbol.for("react.memo") : 60115, ws = Ma ? Symbol.for("react.lazy") : 60116, ls = Ma ? Symbol.for("react.block") : 60121, ks = Ma ? Symbol.for("react.fundamental") : 60117, Js = Ma ? Symbol.for("react.responder") : 60118, pl = Ma ? Symbol.for("react.scope") : 60119;
                function _l(Nl) {
                  return typeof Nl == "string" || typeof Nl == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  Nl === Eo || Nl === Ks || Nl === eo || Nl === So || Nl === Xs || Nl === Cs || typeof Nl == "object" && Nl !== null && (Nl.$$typeof === ws || Nl.$$typeof === Fs || Nl.$$typeof === rs || Nl.$$typeof === ko || Nl.$$typeof === Ys || Nl.$$typeof === ks || Nl.$$typeof === Js || Nl.$$typeof === pl || Nl.$$typeof === ls);
                }
                function bl(Nl) {
                  if (typeof Nl == "object" && Nl !== null) {
                    var ql = Nl.$$typeof;
                    switch (ql) {
                      case Va:
                        var Jl = Nl.type;
                        switch (Jl) {
                          case Hs:
                          case Ks:
                          case Eo:
                          case eo:
                          case So:
                          case Xs:
                            return Jl;
                          default:
                            var zl = Jl && Jl.$$typeof;
                            switch (zl) {
                              case ko:
                              case Ys:
                              case ws:
                              case Fs:
                              case rs:
                                return zl;
                              default:
                                return ql;
                            }
                        }
                      case to:
                        return ql;
                    }
                  }
                }
                var xl = Hs, Rl = Ks, Cl = ko, Dl = rs, kl = Va, Ul = Ys, Bl = Eo, Zl = ws, Pl = Fs, yl = to, hl = eo, Tl = So, Il = Xs, jl = !1;
                function Al(Nl) {
                  return jl || (jl = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _s(Nl) || bl(Nl) === Hs;
                }
                function _s(Nl) {
                  return bl(Nl) === Ks;
                }
                function Gs(Nl) {
                  return bl(Nl) === ko;
                }
                function vl(Nl) {
                  return bl(Nl) === rs;
                }
                function gl(Nl) {
                  return typeof Nl == "object" && Nl !== null && Nl.$$typeof === Va;
                }
                function El(Nl) {
                  return bl(Nl) === Ys;
                }
                function Ol(Nl) {
                  return bl(Nl) === Eo;
                }
                function wl(Nl) {
                  return bl(Nl) === ws;
                }
                function dl(Nl) {
                  return bl(Nl) === Fs;
                }
                function Sl(Nl) {
                  return bl(Nl) === to;
                }
                function Ml(Nl) {
                  return bl(Nl) === eo;
                }
                function Fl(Nl) {
                  return bl(Nl) === So;
                }
                function Ll(Nl) {
                  return bl(Nl) === Xs;
                }
                la.AsyncMode = xl, la.ConcurrentMode = Rl, la.ContextConsumer = Cl, la.ContextProvider = Dl, la.Element = kl, la.ForwardRef = Ul, la.Fragment = Bl, la.Lazy = Zl, la.Memo = Pl, la.Portal = yl, la.Profiler = hl, la.StrictMode = Tl, la.Suspense = Il, la.isAsyncMode = Al, la.isConcurrentMode = _s, la.isContextConsumer = Gs, la.isContextProvider = vl, la.isElement = gl, la.isForwardRef = El, la.isFragment = Ol, la.isLazy = wl, la.isMemo = dl, la.isPortal = Sl, la.isProfiler = Ml, la.isStrictMode = Fl, la.isSuspense = Ll, la.isValidElementType = _l, la.typeOf = bl;
              })();
            }
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            (na, la, Ma) => {
              na.exports = Ma(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            }
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            (na, la, Ma) => {
              Ma.r(la), Ma.d(la, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  to
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  Va
                )
                /* harmony export */
              });
              function Va(Eo, So) {
                if (Eo === So)
                  return !0;
                if (!Eo || !So)
                  return !1;
                var eo = Object.keys(Eo), rs = Object.keys(So), ko = eo.length;
                if (rs.length !== ko)
                  return !1;
                for (var Hs = 0; Hs < ko; Hs++) {
                  var Ks = eo[Hs];
                  if (Eo[Ks] !== So[Ks] || !Object.prototype.hasOwnProperty.call(So, Ks))
                    return !1;
                }
                return !0;
              }
              function to(Eo, So) {
                if (Eo === So)
                  return !0;
                if (!Eo || !So)
                  return !1;
                var eo = Eo.length;
                if (So.length !== eo)
                  return !1;
                for (var rs = 0; rs < eo; rs++)
                  if (Eo[rs] !== So[rs])
                    return !1;
                return !0;
              }
            }
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            function(na, la, Ma) {
              var Va = this && this.__rest || function(eo, rs) {
                var ko = {};
                for (var Hs in eo) Object.prototype.hasOwnProperty.call(eo, Hs) && rs.indexOf(Hs) < 0 && (ko[Hs] = eo[Hs]);
                if (eo != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var Ks = 0, Hs = Object.getOwnPropertySymbols(eo); Ks < Hs.length; Ks++)
                    rs.indexOf(Hs[Ks]) < 0 && Object.prototype.propertyIsEnumerable.call(eo, Hs[Ks]) && (ko[Hs[Ks]] = eo[Hs[Ks]]);
                return ko;
              }, to = this && this.__importDefault || function(eo) {
                return eo && eo.__esModule ? eo : { default: eo };
              };
              Object.defineProperty(la, "__esModule", { value: !0 });
              var Eo = to(Ma(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), So = function(eo) {
                var rs = eo.children, ko = eo.device, Hs = eo.onChange, Ks = Va(eo, ["children", "device", "onChange"]), Ys = (0, Eo.default)(Ks, ko, Hs);
                return typeof rs == "function" ? rs(Ys) : Ys ? rs : null;
              };
              la.default = So;
            }
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            (na, la, Ma) => {
              Object.defineProperty(la, "__esModule", { value: !0 });
              var Va = Ma(
                /*! react */
                "react"
              ), to = (0, Va.createContext)(void 0);
              la.default = to;
            }
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            function(na, la, Ma) {
              var Va = this && this.__importDefault || function(rs) {
                return rs && rs.__esModule ? rs : { default: rs };
              };
              Object.defineProperty(la, "__esModule", { value: !0 }), la.Context = la.toQuery = la.useMediaQuery = la.default = void 0;
              var to = Va(Ma(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              la.useMediaQuery = to.default;
              var Eo = Va(Ma(
                /*! ./Component */
                "./src/Component.ts"
              ));
              la.default = Eo.default;
              var So = Va(Ma(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              la.toQuery = So.default;
              var eo = Va(Ma(
                /*! ./Context */
                "./src/Context.ts"
              ));
              la.Context = eo.default;
            }
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            function(na, la, Ma) {
              var Va = this && this.__assign || function() {
                return Va = Object.assign || function(Xs) {
                  for (var Cs, Fs = 1, ws = arguments.length; Fs < ws; Fs++) {
                    Cs = arguments[Fs];
                    for (var ls in Cs) Object.prototype.hasOwnProperty.call(Cs, ls) && (Xs[ls] = Cs[ls]);
                  }
                  return Xs;
                }, Va.apply(this, arguments);
              }, to = this && this.__rest || function(Xs, Cs) {
                var Fs = {};
                for (var ws in Xs) Object.prototype.hasOwnProperty.call(Xs, ws) && Cs.indexOf(ws) < 0 && (Fs[ws] = Xs[ws]);
                if (Xs != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var ls = 0, ws = Object.getOwnPropertySymbols(Xs); ls < ws.length; ls++)
                    Cs.indexOf(ws[ls]) < 0 && Object.prototype.propertyIsEnumerable.call(Xs, ws[ls]) && (Fs[ws[ls]] = Xs[ws[ls]]);
                return Fs;
              }, Eo = this && this.__importDefault || function(Xs) {
                return Xs && Xs.__esModule ? Xs : { default: Xs };
              };
              Object.defineProperty(la, "__esModule", { value: !0 });
              var So = Eo(Ma(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), eo = So.default.oneOfType([
                So.default.string,
                So.default.number
              ]), rs = {
                all: So.default.bool,
                grid: So.default.bool,
                aural: So.default.bool,
                braille: So.default.bool,
                handheld: So.default.bool,
                print: So.default.bool,
                projection: So.default.bool,
                screen: So.default.bool,
                tty: So.default.bool,
                tv: So.default.bool,
                embossed: So.default.bool
              }, ko = {
                orientation: So.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: So.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: So.default.string,
                deviceAspectRatio: So.default.string,
                height: eo,
                deviceHeight: eo,
                width: eo,
                deviceWidth: eo,
                color: So.default.bool,
                colorIndex: So.default.bool,
                monochrome: So.default.bool,
                resolution: eo,
                type: Object.keys(rs)
              };
              ko.type;
              var Hs = to(
                ko,
                ["type"]
              ), Ks = Va({ minAspectRatio: So.default.string, maxAspectRatio: So.default.string, minDeviceAspectRatio: So.default.string, maxDeviceAspectRatio: So.default.string, minHeight: eo, maxHeight: eo, minDeviceHeight: eo, maxDeviceHeight: eo, minWidth: eo, maxWidth: eo, minDeviceWidth: eo, maxDeviceWidth: eo, minColor: So.default.number, maxColor: So.default.number, minColorIndex: So.default.number, maxColorIndex: So.default.number, minMonochrome: So.default.number, maxMonochrome: So.default.number, minResolution: eo, maxResolution: eo }, Hs), Ys = Va(Va({}, rs), Ks);
              la.default = {
                all: Ys,
                types: rs,
                matchers: ko,
                features: Ks
              };
            }
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            function(na, la, Ma) {
              var Va = this && this.__importDefault || function(Hs) {
                return Hs && Hs.__esModule ? Hs : { default: Hs };
              };
              Object.defineProperty(la, "__esModule", { value: !0 });
              var to = Va(Ma(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), Eo = Va(Ma(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), So = function(Hs) {
                return "not ".concat(Hs);
              }, eo = function(Hs, Ks) {
                var Ys = (0, to.default)(Hs);
                return typeof Ks == "number" && (Ks = "".concat(Ks, "px")), Ks === !0 ? Ys : Ks === !1 ? So(Ys) : "(".concat(Ys, ": ").concat(Ks, ")");
              }, rs = function(Hs) {
                return Hs.join(" and ");
              }, ko = function(Hs) {
                var Ks = [];
                return Object.keys(Eo.default.all).forEach(function(Ys) {
                  var Xs = Hs[Ys];
                  Xs != null && Ks.push(eo(Ys, Xs));
                }), rs(Ks);
              };
              la.default = ko;
            }
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            function(na, la, Ma) {
              var Va = this && this.__importDefault || function(ks) {
                return ks && ks.__esModule ? ks : { default: ks };
              };
              Object.defineProperty(la, "__esModule", { value: !0 });
              var to = Ma(
                /*! react */
                "react"
              ), Eo = Va(Ma(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), So = Va(Ma(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), eo = Ma(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), rs = Va(Ma(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), ko = Va(Ma(
                /*! ./Context */
                "./src/Context.ts"
              )), Hs = function(ks) {
                return ks.query || (0, rs.default)(ks);
              }, Ks = function(ks) {
                if (ks) {
                  var Js = Object.keys(ks);
                  return Js.reduce(function(pl, _l) {
                    return pl[(0, So.default)(_l)] = ks[_l], pl;
                  }, {});
                }
              }, Ys = function() {
                var ks = (0, to.useRef)(!1);
                return (0, to.useEffect)(function() {
                  ks.current = !0;
                }, []), ks.current;
              }, Xs = function(ks) {
                var Js = (0, to.useContext)(ko.default), pl = function() {
                  return Ks(ks) || Ks(Js);
                }, _l = (0, to.useState)(pl), bl = _l[0], xl = _l[1];
                return (0, to.useEffect)(function() {
                  var Rl = pl();
                  (0, eo.shallowEqualObjects)(bl, Rl) || xl(Rl);
                }, [ks, Js]), bl;
              }, Cs = function(ks) {
                var Js = function() {
                  return Hs(ks);
                }, pl = (0, to.useState)(Js), _l = pl[0], bl = pl[1];
                return (0, to.useEffect)(function() {
                  var xl = Js();
                  _l !== xl && bl(xl);
                }, [ks]), _l;
              }, Fs = function(ks, Js) {
                var pl = function() {
                  return (0, Eo.default)(ks, Js || {}, !!Js);
                }, _l = (0, to.useState)(pl), bl = _l[0], xl = _l[1], Rl = Ys();
                return (0, to.useEffect)(function() {
                  if (Rl) {
                    var Cl = pl();
                    return xl(Cl), function() {
                      Cl && Cl.dispose();
                    };
                  }
                }, [ks, Js]), bl;
              }, ws = function(ks) {
                var Js = (0, to.useState)(ks.matches), pl = Js[0], _l = Js[1];
                return (0, to.useEffect)(function() {
                  var bl = function(xl) {
                    _l(xl.matches);
                  };
                  return ks.addListener(bl), _l(ks.matches), function() {
                    ks.removeListener(bl);
                  };
                }, [ks]), pl;
              }, ls = function(ks, Js, pl) {
                var _l = Xs(Js), bl = Cs(ks);
                if (!bl)
                  throw new Error("Invalid or missing MediaQuery!");
                var xl = Fs(bl, _l), Rl = ws(xl), Cl = Ys();
                return (0, to.useEffect)(function() {
                  Cl && pl && pl(Rl);
                }, [Rl]), (0, to.useEffect)(function() {
                  return function() {
                    xl && xl.dispose();
                  };
                }, []), Rl;
              };
              la.default = ls;
            }
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            (na) => {
              na.exports = qi;
            }
          )
          /******/
        }, Qi = {};
        function ta(na) {
          var la = Qi[na];
          if (la !== void 0)
            return la.exports;
          var Ma = Qi[na] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return Xi[na].call(Ma.exports, Ma, Ma.exports, ta), Ma.exports;
        }
        ta.d = (na, la) => {
          for (var Ma in la)
            ta.o(la, Ma) && !ta.o(na, Ma) && Object.defineProperty(na, Ma, { enumerable: !0, get: la[Ma] });
        }, ta.o = (na, la) => Object.prototype.hasOwnProperty.call(na, la), ta.r = (na) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(na, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(na, "__esModule", { value: !0 });
        };
        var ra = ta("./src/index.ts");
        return ra;
      })()
    ));
  }(reactResponsive$1)), reactResponsive$1.exports;
}
var reactResponsiveExports = /* @__PURE__ */ requireReactResponsive();
const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, useTailwindBreakpoint = (Bi) => reactResponsiveExports.useMediaQuery({ minWidth: breakpoints[Bi] }), AppLayoutContext = createContext({}), useAppLayoutContext = () => useContext(AppLayoutContext), AppBar$1 = ({
  children: Bi,
  className: e = "",
  style: qi = {},
  hideDrawerButton: Xi = !0
}) => {
  const { menuVisible: Qi, onMenuToggle: ta, headerRef: ra } = useAppLayoutContext(), na = useTailwindBreakpoint("sm");
  return ra ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "nav",
      {
        className: twMerge(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4",
          e
        ),
        style: qi,
        children: [
          na && !Xi && /* @__PURE__ */ jsxRuntimeExports.jsx(
            DrawerButton,
            {
              className: "mr-8",
              sideBarVisible: Qi,
              onClick: () => ta?.(!Qi)
            }
          ),
          Bi,
          !na && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            DrawerButton,
            {
              sideBarVisible: Qi,
              onClick: () => ta?.(!Qi)
            }
          ) })
        ]
      }
    ),
    ra
  ) : null;
}, AppLayoutBody = ({ children: Bi }) => {
  const { layoutRef: e } = useAppLayoutContext();
  return e ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx("main", { className: "w-full h-full overflow-hidden", children: Bi }),
    e
  ) : null;
}, styles = cva(
  [
    "bg-neutral-200",
    "sm:col-span-2",
    "sm:row-start-2",
    "sm:w-1/4",
    "sm:h-full",
    "sm:static",
    "fixed",
    "w-screen",
    "h-screen",
    "top-0",
    "left-0",
    "p-2"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), AppLayoutMenu = ({ children: Bi }) => {
  const { onMenuToggle: e, menuVisible: qi, layoutRef: Xi } = useAppLayoutContext(), Qi = useTailwindBreakpoint("sm");
  return Xi ? Qi ? qi ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "aside",
      {
        className: styles({ size: "lg" }),
        children: Bi
      },
      "app-layout-menu"
    ),
    Xi
  ) : null : qi ? createPortal(
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "aside",
      {
        className: styles({ size: "sm" }),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => e?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { icon: faX, size: "sm" })
            }
          ),
          Bi
        ]
      },
      "app-layout-menu"
    ),
    Xi
  ) : null : null;
};
function AppLayoutMenuLink({
  to: Bi,
  icon: e,
  name: qi,
  hasNotifications: Xi,
  children: Qi,
  href: ta,
  linkProps: ra
}) {
  if (!ta && !Bi)
    throw new Error("to or href is required");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AnimateSharedLayout, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col my-2", children: ta ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: ta,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex align-middle ", children: [
          Xi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: e,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: qi })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        Qi
      ]
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Link,
    {
      to: Bi,
      ...ra || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex align-middle ", children: [
          Xi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            FontAwesomeIcon,
            {
              icon: e,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: qi })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Spacer, {}),
        Qi
      ]
    }
  ) }) });
}
const AppLayout = ({
  menuVisible: Bi = !1,
  children: e,
  onMenuToggle: qi
}) => {
  const [Xi, Qi] = a__default.useState(null), [ta, ra] = a__default.useState(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AppLayoutContext.Provider,
    {
      value: {
        menuVisible: Bi,
        onMenuToggle: qi,
        layoutRef: Xi,
        headerRef: ta
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          className: "flex w-screen h-screen overflow-hidden bg-neutral-100 flex-col app-layout",
          ref: ra,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              className: "w-full h-full flex overflow-hidden flex-grow order-last",
              ref: Qi,
              children: e
            }
          )
        }
      )
    }
  );
};
AppLayout.Header = AppBar$1;
AppLayout.Body = AppLayoutBody;
AppLayout.Menu = AppLayoutMenu;
AppLayout.Link = AppLayoutMenuLink;
const AppBar = ({
  onClick: Bi,
  sideBarVisible: e,
  className: qi,
  showMenu: Xi = !0,
  isLoggedIn: Qi = !1,
  children: ta
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "nav",
  {
    className: twMerge(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      qi
    ),
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex", children: [
        Xi && /* @__PURE__ */ jsxRuntimeExports.jsx(
          DrawerButton,
          {
            sideBarVisible: e,
            onClick: Bi || (() => null)
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: ta })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Menu,
        {
          className: "my-auto",
          button: /* @__PURE__ */ jsxRuntimeExports.jsx(FontAwesomeIcon, { color: "white", size: "1x", icon: faUserCog }),
          children: [
            Qi && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                MenuItem,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !Qi && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { to: "/login", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), defaultOptions = {};
gql`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
gql`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
gql`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
gql`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
gql`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
gql`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
gql`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const MeDocument = gql`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function useMeQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useQuery(MeDocument, e);
}
function useMeLazyQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useLazyQuery(MeDocument, e);
}
const PresignedDownloadUrlDocument = gql`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
function usePresignedDownloadUrlQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useQuery(PresignedDownloadUrlDocument, e);
}
function usePresignedDownloadUrlLazyQuery(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useLazyQuery(PresignedDownloadUrlDocument, e);
}
gql`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const TaskQueueLogsDocument = gql`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function useTaskQueueLogsSubscription(Bi) {
  const e = { ...defaultOptions, ...Bi };
  return Apollo.useSubscription(TaskQueueLogsDocument, e);
}
const ReaderLayout = ({ appBarTitle: Bi }) => {
  const { data: e } = useMeQuery();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(motion.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      AppBar,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!e?.me,
        children: Bi
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Outlet, {}) }) })
  ] });
}, pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, Page = ({
  children: Bi,
  className: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  motion.div,
  {
    className: twMerge("w-full min-h-full overflow-scroll", e),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: pageVariants,
    children: Bi
  }
), PageHeaderTitle = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: Bi.children }), PageHeader = ({ children: Bi, title: e, className: qi }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${qi}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  typeof e == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeaderTitle, { children: e }) : e,
  Bi
] }) }), NotFound = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Page, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: "Page not found" }) }), ImagePreview = ({ data: Bi }) => {
  const e = URL.createObjectURL(Bi);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: e, alt: "" }) });
}, Spinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "loader" }), CircleSpinner = () => /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." });
function commonjsRequire(Bi) {
  throw new Error('Could not dynamically require "' + Bi + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasRequiredPdf;
function requirePdf() {
  return hasRequiredPdf || (hasRequiredPdf = 1, function(module, exports) {
    (function(e, qi) {
      module.exports = qi();
    })(globalThis, () => (
      /******/
      (() => {
        var __webpack_modules__ = [
          ,
          /* 1 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.VerbosityLevel = e.Util = e.UnknownErrorException = e.UnexpectedResponseException = e.UNSUPPORTED_FEATURES = e.TextRenderingMode = e.StreamType = e.RenderingIntentFlag = e.PermissionFlag = e.PasswordResponses = e.PasswordException = e.PageActionEventType = e.OPS = e.MissingPDFException = e.LINE_FACTOR = e.LINE_DESCENT_FACTOR = e.InvalidPDFException = e.ImageKind = e.IDENTITY_MATRIX = e.FormatError = e.FontType = e.FeatureTest = e.FONT_IDENTITY_MATRIX = e.DocumentActionEventType = e.CMapCompressionType = e.BaseException = e.AnnotationType = e.AnnotationStateModelType = e.AnnotationReviewState = e.AnnotationReplyType = e.AnnotationMode = e.AnnotationMarkedState = e.AnnotationFlag = e.AnnotationFieldFlag = e.AnnotationEditorType = e.AnnotationEditorPrefix = e.AnnotationEditorParamsType = e.AnnotationBorderStyleType = e.AnnotationActionEventType = e.AbortException = void 0, e.arrayByteLength = Sl, e.arraysToBytes = Ml, e.assert = yl, e.bytesToString = wl, e.createPromiseCapability = _d, e.createValidAbsoluteUrl = Tl, e.escapeString = Qu, e.getModificationDate = $d, e.getVerbosityLevel = Ul, e.info = Bl, e.isArrayBuffer = sd, e.isArrayEqual = bd, e.isAscii = ed, e.objectFromMap = Nl, e.objectSize = Ll, e.setVerbosityLevel = kl, e.shadow = Il, e.string32 = Fl, e.stringToBytes = dl, e.stringToPDFString = Gu, e.stringToUTF16BEString = td, e.stringToUTF8String = od, e.unreachable = Pl, e.utf8StringToString = ld, e.warn = Zl, qi(2);
            const Xi = [1, 0, 0, 1, 0, 0];
            e.IDENTITY_MATRIX = Xi;
            const Qi = [1e-3, 0, 0, 1e-3, 0, 0];
            e.FONT_IDENTITY_MATRIX = Qi;
            const ta = 1.35;
            e.LINE_FACTOR = ta;
            const ra = 0.35;
            e.LINE_DESCENT_FACTOR = ra;
            const na = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            e.RenderingIntentFlag = na;
            const la = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            e.AnnotationMode = la;
            const Ma = "pdfjs_internal_editor_";
            e.AnnotationEditorPrefix = Ma;
            const Va = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              INK: 15
            };
            e.AnnotationEditorType = Va;
            const to = {
              FREETEXT_SIZE: 1,
              FREETEXT_COLOR: 2,
              FREETEXT_OPACITY: 3,
              INK_COLOR: 11,
              INK_THICKNESS: 12,
              INK_OPACITY: 13
            };
            e.AnnotationEditorParamsType = to;
            const Eo = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            e.PermissionFlag = Eo;
            const So = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            e.TextRenderingMode = So;
            const eo = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            e.ImageKind = eo;
            const rs = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            e.AnnotationType = rs;
            const ko = {
              MARKED: "Marked",
              REVIEW: "Review"
            };
            e.AnnotationStateModelType = ko;
            const Hs = {
              MARKED: "Marked",
              UNMARKED: "Unmarked"
            };
            e.AnnotationMarkedState = Hs;
            const Ks = {
              ACCEPTED: "Accepted",
              REJECTED: "Rejected",
              CANCELLED: "Cancelled",
              COMPLETED: "Completed",
              NONE: "None"
            };
            e.AnnotationReviewState = Ks;
            const Ys = {
              GROUP: "Group",
              REPLY: "R"
            };
            e.AnnotationReplyType = Ys;
            const Xs = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            e.AnnotationFlag = Xs;
            const Cs = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            e.AnnotationFieldFlag = Cs;
            const Fs = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            e.AnnotationBorderStyleType = Fs;
            const ws = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            e.AnnotationActionEventType = ws;
            const ls = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            e.DocumentActionEventType = ls;
            const ks = {
              O: "PageOpen",
              C: "PageClose"
            };
            e.PageActionEventType = ks;
            const Js = {
              UNKNOWN: "UNKNOWN",
              FLATE: "FLATE",
              LZW: "LZW",
              DCT: "DCT",
              JPX: "JPX",
              JBIG: "JBIG",
              A85: "A85",
              AHX: "AHX",
              CCF: "CCF",
              RLX: "RLX"
            };
            e.StreamType = Js;
            const pl = {
              UNKNOWN: "UNKNOWN",
              TYPE1: "TYPE1",
              TYPE1STANDARD: "TYPE1STANDARD",
              TYPE1C: "TYPE1C",
              CIDFONTTYPE0: "CIDFONTTYPE0",
              CIDFONTTYPE0C: "CIDFONTTYPE0C",
              TRUETYPE: "TRUETYPE",
              CIDFONTTYPE2: "CIDFONTTYPE2",
              TYPE3: "TYPE3",
              OPENTYPE: "OPENTYPE",
              TYPE0: "TYPE0",
              MMTYPE1: "MMTYPE1"
            };
            e.FontType = pl;
            const _l = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            e.VerbosityLevel = _l;
            const bl = {
              NONE: 0,
              BINARY: 1,
              STREAM: 2
            };
            e.CMapCompressionType = bl;
            const xl = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotations: 78,
              endAnnotations: 79,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintJpegXObject: 82,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            e.OPS = xl;
            const Rl = {
              unknown: "unknown",
              forms: "forms",
              javaScript: "javaScript",
              signatures: "signatures",
              smask: "smask",
              shadingPattern: "shadingPattern",
              font: "font",
              errorTilingPattern: "errorTilingPattern",
              errorExtGState: "errorExtGState",
              errorXObject: "errorXObject",
              errorFontLoadType3: "errorFontLoadType3",
              errorFontState: "errorFontState",
              errorFontMissing: "errorFontMissing",
              errorFontTranslate: "errorFontTranslate",
              errorColorSpace: "errorColorSpace",
              errorOperatorList: "errorOperatorList",
              errorFontToUnicode: "errorFontToUnicode",
              errorFontLoadNative: "errorFontLoadNative",
              errorFontBuildPath: "errorFontBuildPath",
              errorFontGetPath: "errorFontGetPath",
              errorMarkedContent: "errorMarkedContent",
              errorContentSubStream: "errorContentSubStream"
            };
            e.UNSUPPORTED_FEATURES = Rl;
            const Cl = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            e.PasswordResponses = Cl;
            let Dl = _l.WARNINGS;
            function kl(ec) {
              Number.isInteger(ec) && (Dl = ec);
            }
            function Ul() {
              return Dl;
            }
            function Bl(ec) {
              Dl >= _l.INFOS && console.log(`Info: ${ec}`);
            }
            function Zl(ec) {
              Dl >= _l.WARNINGS && console.log(`Warning: ${ec}`);
            }
            function Pl(ec) {
              throw new Error(ec);
            }
            function yl(ec, Xl) {
              ec || Pl(Xl);
            }
            function hl(ec) {
              if (!ec)
                return !1;
              switch (ec.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function Tl(ec, Xl = null, Ql = null) {
              if (!ec)
                return null;
              try {
                if (Ql && typeof ec == "string") {
                  if (Ql.addDefaultProtocol && ec.startsWith("www.")) {
                    const Xu = ec.match(/\./g);
                    Xu && Xu.length >= 2 && (ec = `http://${ec}`);
                  }
                  if (Ql.tryConvertEncoding)
                    try {
                      ec = od(ec);
                    } catch {
                    }
                }
                const Wu = Xl ? new URL(ec, Xl) : new URL(ec);
                if (hl(Wu))
                  return Wu;
              } catch {
              }
              return null;
            }
            function Il(ec, Xl, Ql) {
              return Object.defineProperty(ec, Xl, {
                value: Ql,
                enumerable: !0,
                configurable: !0,
                writable: !1
              }), Ql;
            }
            const jl = function() {
              function Xl(Ql, Wu) {
                this.constructor === Xl && Pl("Cannot initialize BaseException."), this.message = Ql, this.name = Wu;
              }
              return Xl.prototype = new Error(), Xl.constructor = Xl, Xl;
            }();
            e.BaseException = jl;
            class Al extends jl {
              constructor(Xl, Ql) {
                super(Xl, "PasswordException"), this.code = Ql;
              }
            }
            e.PasswordException = Al;
            class _s extends jl {
              constructor(Xl, Ql) {
                super(Xl, "UnknownErrorException"), this.details = Ql;
              }
            }
            e.UnknownErrorException = _s;
            class Gs extends jl {
              constructor(Xl) {
                super(Xl, "InvalidPDFException");
              }
            }
            e.InvalidPDFException = Gs;
            class vl extends jl {
              constructor(Xl) {
                super(Xl, "MissingPDFException");
              }
            }
            e.MissingPDFException = vl;
            class gl extends jl {
              constructor(Xl, Ql) {
                super(Xl, "UnexpectedResponseException"), this.status = Ql;
              }
            }
            e.UnexpectedResponseException = gl;
            class El extends jl {
              constructor(Xl) {
                super(Xl, "FormatError");
              }
            }
            e.FormatError = El;
            class Ol extends jl {
              constructor(Xl) {
                super(Xl, "AbortException");
              }
            }
            e.AbortException = Ol;
            function wl(ec) {
              (typeof ec != "object" || ec === null || ec.length === void 0) && Pl("Invalid argument for bytesToString");
              const Xl = ec.length, Ql = 8192;
              if (Xl < Ql)
                return String.fromCharCode.apply(null, ec);
              const Wu = [];
              for (let Xu = 0; Xu < Xl; Xu += Ql) {
                const ud = Math.min(Xu + Ql, Xl), dd = ec.subarray(Xu, ud);
                Wu.push(String.fromCharCode.apply(null, dd));
              }
              return Wu.join("");
            }
            function dl(ec) {
              typeof ec != "string" && Pl("Invalid argument for stringToBytes");
              const Xl = ec.length, Ql = new Uint8Array(Xl);
              for (let Wu = 0; Wu < Xl; ++Wu)
                Ql[Wu] = ec.charCodeAt(Wu) & 255;
              return Ql;
            }
            function Sl(ec) {
              if (ec.length !== void 0)
                return ec.length;
              if (ec.byteLength !== void 0)
                return ec.byteLength;
              Pl("Invalid argument for arrayByteLength");
            }
            function Ml(ec) {
              const Xl = ec.length;
              if (Xl === 1 && ec[0] instanceof Uint8Array)
                return ec[0];
              let Ql = 0;
              for (let ud = 0; ud < Xl; ud++)
                Ql += Sl(ec[ud]);
              let Wu = 0;
              const Xu = new Uint8Array(Ql);
              for (let ud = 0; ud < Xl; ud++) {
                let dd = ec[ud];
                dd instanceof Uint8Array || (typeof dd == "string" ? dd = dl(dd) : dd = new Uint8Array(dd));
                const Ed = dd.byteLength;
                Xu.set(dd, Wu), Wu += Ed;
              }
              return Xu;
            }
            function Fl(ec) {
              return String.fromCharCode(ec >> 24 & 255, ec >> 16 & 255, ec >> 8 & 255, ec & 255);
            }
            function Ll(ec) {
              return Object.keys(ec).length;
            }
            function Nl(ec) {
              const Xl = /* @__PURE__ */ Object.create(null);
              for (const [Ql, Wu] of ec)
                Xl[Ql] = Wu;
              return Xl;
            }
            function ql() {
              const ec = new Uint8Array(4);
              return ec[0] = 1, new Uint32Array(ec.buffer, 0, 1)[0] === 1;
            }
            function Jl() {
              try {
                return new Function(""), !0;
              } catch {
                return !1;
              }
            }
            class zl {
              static get isLittleEndian() {
                return Il(this, "isLittleEndian", ql());
              }
              static get isEvalSupported() {
                return Il(this, "isEvalSupported", Jl());
              }
              static get isOffscreenCanvasSupported() {
                return Il(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
              }
            }
            e.FeatureTest = zl;
            const tc = [...Array(256).keys()].map((ec) => ec.toString(16).padStart(2, "0"));
            class Ku {
              static makeHexColor(Xl, Ql, Wu) {
                return `#${tc[Xl]}${tc[Ql]}${tc[Wu]}`;
              }
              static scaleMinMax(Xl, Ql) {
                let Wu;
                Xl[0] ? (Xl[0] < 0 && (Wu = Ql[0], Ql[0] = Ql[1], Ql[1] = Wu), Ql[0] *= Xl[0], Ql[1] *= Xl[0], Xl[3] < 0 && (Wu = Ql[2], Ql[2] = Ql[3], Ql[3] = Wu), Ql[2] *= Xl[3], Ql[3] *= Xl[3]) : (Wu = Ql[0], Ql[0] = Ql[2], Ql[2] = Wu, Wu = Ql[1], Ql[1] = Ql[3], Ql[3] = Wu, Xl[1] < 0 && (Wu = Ql[2], Ql[2] = Ql[3], Ql[3] = Wu), Ql[2] *= Xl[1], Ql[3] *= Xl[1], Xl[2] < 0 && (Wu = Ql[0], Ql[0] = Ql[1], Ql[1] = Wu), Ql[0] *= Xl[2], Ql[1] *= Xl[2]), Ql[0] += Xl[4], Ql[1] += Xl[4], Ql[2] += Xl[5], Ql[3] += Xl[5];
              }
              static transform(Xl, Ql) {
                return [Xl[0] * Ql[0] + Xl[2] * Ql[1], Xl[1] * Ql[0] + Xl[3] * Ql[1], Xl[0] * Ql[2] + Xl[2] * Ql[3], Xl[1] * Ql[2] + Xl[3] * Ql[3], Xl[0] * Ql[4] + Xl[2] * Ql[5] + Xl[4], Xl[1] * Ql[4] + Xl[3] * Ql[5] + Xl[5]];
              }
              static applyTransform(Xl, Ql) {
                const Wu = Xl[0] * Ql[0] + Xl[1] * Ql[2] + Ql[4], Xu = Xl[0] * Ql[1] + Xl[1] * Ql[3] + Ql[5];
                return [Wu, Xu];
              }
              static applyInverseTransform(Xl, Ql) {
                const Wu = Ql[0] * Ql[3] - Ql[1] * Ql[2], Xu = (Xl[0] * Ql[3] - Xl[1] * Ql[2] + Ql[2] * Ql[5] - Ql[4] * Ql[3]) / Wu, ud = (-Xl[0] * Ql[1] + Xl[1] * Ql[0] + Ql[4] * Ql[1] - Ql[5] * Ql[0]) / Wu;
                return [Xu, ud];
              }
              static getAxialAlignedBoundingBox(Xl, Ql) {
                const Wu = Ku.applyTransform(Xl, Ql), Xu = Ku.applyTransform(Xl.slice(2, 4), Ql), ud = Ku.applyTransform([Xl[0], Xl[3]], Ql), dd = Ku.applyTransform([Xl[2], Xl[1]], Ql);
                return [Math.min(Wu[0], Xu[0], ud[0], dd[0]), Math.min(Wu[1], Xu[1], ud[1], dd[1]), Math.max(Wu[0], Xu[0], ud[0], dd[0]), Math.max(Wu[1], Xu[1], ud[1], dd[1])];
              }
              static inverseTransform(Xl) {
                const Ql = Xl[0] * Xl[3] - Xl[1] * Xl[2];
                return [Xl[3] / Ql, -Xl[1] / Ql, -Xl[2] / Ql, Xl[0] / Ql, (Xl[2] * Xl[5] - Xl[4] * Xl[3]) / Ql, (Xl[4] * Xl[1] - Xl[5] * Xl[0]) / Ql];
              }
              static apply3dTransform(Xl, Ql) {
                return [Xl[0] * Ql[0] + Xl[1] * Ql[1] + Xl[2] * Ql[2], Xl[3] * Ql[0] + Xl[4] * Ql[1] + Xl[5] * Ql[2], Xl[6] * Ql[0] + Xl[7] * Ql[1] + Xl[8] * Ql[2]];
              }
              static singularValueDecompose2dScale(Xl) {
                const Ql = [Xl[0], Xl[2], Xl[1], Xl[3]], Wu = Xl[0] * Ql[0] + Xl[1] * Ql[2], Xu = Xl[0] * Ql[1] + Xl[1] * Ql[3], ud = Xl[2] * Ql[0] + Xl[3] * Ql[2], dd = Xl[2] * Ql[1] + Xl[3] * Ql[3], Ed = (Wu + dd) / 2, Od = Math.sqrt((Wu + dd) ** 2 - 4 * (Wu * dd - ud * Xu)) / 2, wd = Ed + Od || 1, md = Ed - Od || 1;
                return [Math.sqrt(wd), Math.sqrt(md)];
              }
              static normalizeRect(Xl) {
                const Ql = Xl.slice(0);
                return Xl[0] > Xl[2] && (Ql[0] = Xl[2], Ql[2] = Xl[0]), Xl[1] > Xl[3] && (Ql[1] = Xl[3], Ql[3] = Xl[1]), Ql;
              }
              static intersect(Xl, Ql) {
                const Wu = Math.max(Math.min(Xl[0], Xl[2]), Math.min(Ql[0], Ql[2])), Xu = Math.min(Math.max(Xl[0], Xl[2]), Math.max(Ql[0], Ql[2]));
                if (Wu > Xu)
                  return null;
                const ud = Math.max(Math.min(Xl[1], Xl[3]), Math.min(Ql[1], Ql[3])), dd = Math.min(Math.max(Xl[1], Xl[3]), Math.max(Ql[1], Ql[3]));
                return ud > dd ? null : [Wu, ud, Xu, dd];
              }
              static bezierBoundingBox(Xl, Ql, Wu, Xu, ud, dd, Ed, Od) {
                const wd = [], md = [[], []];
                let Pd, Ad, kd, hd, Dd, Rd, jd, Hl;
                for (let nd = 0; nd < 2; ++nd) {
                  if (nd === 0 ? (Ad = 6 * Xl - 12 * Wu + 6 * ud, Pd = -3 * Xl + 9 * Wu - 9 * ud + 3 * Ed, kd = 3 * Wu - 3 * Xl) : (Ad = 6 * Ql - 12 * Xu + 6 * dd, Pd = -3 * Ql + 9 * Xu - 9 * dd + 3 * Od, kd = 3 * Xu - 3 * Ql), Math.abs(Pd) < 1e-12) {
                    if (Math.abs(Ad) < 1e-12)
                      continue;
                    hd = -kd / Ad, 0 < hd && hd < 1 && wd.push(hd);
                    continue;
                  }
                  jd = Ad * Ad - 4 * kd * Pd, Hl = Math.sqrt(jd), !(jd < 0) && (Dd = (-Ad + Hl) / (2 * Pd), 0 < Dd && Dd < 1 && wd.push(Dd), Rd = (-Ad - Hl) / (2 * Pd), 0 < Rd && Rd < 1 && wd.push(Rd));
                }
                let nc = wd.length, qu;
                const Yu = nc;
                for (; nc--; )
                  hd = wd[nc], qu = 1 - hd, md[0][nc] = qu * qu * qu * Xl + 3 * qu * qu * hd * Wu + 3 * qu * hd * hd * ud + hd * hd * hd * Ed, md[1][nc] = qu * qu * qu * Ql + 3 * qu * qu * hd * Xu + 3 * qu * hd * hd * dd + hd * hd * hd * Od;
                return md[0][Yu] = Xl, md[1][Yu] = Ql, md[0][Yu + 1] = Ed, md[1][Yu + 1] = Od, md[0].length = md[1].length = Yu + 2, [Math.min(...md[0]), Math.min(...md[1]), Math.max(...md[0]), Math.max(...md[1])];
              }
            }
            e.Util = Ku;
            const tu = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function Gu(ec) {
              if (ec[0] >= "ï") {
                let Ql;
                if (ec[0] === "þ" && ec[1] === "ÿ" ? Ql = "utf-16be" : ec[0] === "ÿ" && ec[1] === "þ" ? Ql = "utf-16le" : ec[0] === "ï" && ec[1] === "»" && ec[2] === "¿" && (Ql = "utf-8"), Ql)
                  try {
                    const Wu = new TextDecoder(Ql, {
                      fatal: !0
                    }), Xu = dl(ec);
                    return Wu.decode(Xu);
                  } catch (Wu) {
                    Zl(`stringToPDFString: "${Wu}".`);
                  }
              }
              const Xl = [];
              for (let Ql = 0, Wu = ec.length; Ql < Wu; Ql++) {
                const Xu = tu[ec.charCodeAt(Ql)];
                Xl.push(Xu ? String.fromCharCode(Xu) : ec.charAt(Ql));
              }
              return Xl.join("");
            }
            function Qu(ec) {
              return ec.replace(/([()\\\n\r])/g, (Xl) => Xl === `
` ? "\\n" : Xl === "\r" ? "\\r" : `\\${Xl}`);
            }
            function ed(ec) {
              return /^[\x00-\x7F]*$/.test(ec);
            }
            function td(ec) {
              const Xl = ["þÿ"];
              for (let Ql = 0, Wu = ec.length; Ql < Wu; Ql++) {
                const Xu = ec.charCodeAt(Ql);
                Xl.push(String.fromCharCode(Xu >> 8 & 255), String.fromCharCode(Xu & 255));
              }
              return Xl.join("");
            }
            function od(ec) {
              return decodeURIComponent(escape(ec));
            }
            function ld(ec) {
              return unescape(encodeURIComponent(ec));
            }
            function sd(ec) {
              return typeof ec == "object" && ec !== null && ec.byteLength !== void 0;
            }
            function bd(ec, Xl) {
              if (ec.length !== Xl.length)
                return !1;
              for (let Ql = 0, Wu = ec.length; Ql < Wu; Ql++)
                if (ec[Ql] !== Xl[Ql])
                  return !1;
              return !0;
            }
            function $d(ec = /* @__PURE__ */ new Date()) {
              return [ec.getUTCFullYear().toString(), (ec.getUTCMonth() + 1).toString().padStart(2, "0"), ec.getUTCDate().toString().padStart(2, "0"), ec.getUTCHours().toString().padStart(2, "0"), ec.getUTCMinutes().toString().padStart(2, "0"), ec.getUTCSeconds().toString().padStart(2, "0")].join("");
            }
            function _d() {
              const ec = /* @__PURE__ */ Object.create(null);
              let Xl = !1;
              return Object.defineProperty(ec, "settled", {
                get() {
                  return Xl;
                }
              }), ec.promise = new Promise(function(Ql, Wu) {
                ec.resolve = function(Xu) {
                  Xl = !0, Ql(Xu);
                }, ec.reject = function(Xu) {
                  Xl = !0, Wu(Xu);
                };
              }), ec;
            }
          },
          /* 2 */
          /***/
          (Bi, e, qi) => {
            qi(3);
          },
          /* 3 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.isNodeJS = void 0;
            const qi = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            e.isNodeJS = qi;
          },
          /* 4 */
          /***/
          (__unused_webpack_module, exports, __w_pdfjs_require__) => {
            var Bi, qi, Xi, Qi, ta, ra, na, la, tf, Va, to;
            Object.defineProperty(exports, "__esModule", {
              value: !0
            }), exports.build = exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, exports.getDocument = getDocument, exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory, exports.version = void 0;
            var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(5), _display_utils = __w_pdfjs_require__(8), _font_loader = __w_pdfjs_require__(11), _canvas = __w_pdfjs_require__(12), _worker_options = __w_pdfjs_require__(15), _is_node = __w_pdfjs_require__(3), _message_handler = __w_pdfjs_require__(16), _metadata = __w_pdfjs_require__(17), _optional_content_config = __w_pdfjs_require__(18), _transport_stream = __w_pdfjs_require__(19), _xfa_text = __w_pdfjs_require__(20);
            const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100;
            let DefaultCanvasFactory = _display_utils.DOMCanvasFactory;
            exports.DefaultCanvasFactory = DefaultCanvasFactory;
            let DefaultCMapReaderFactory = _display_utils.DOMCMapReaderFactory;
            exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
            let DefaultStandardFontDataFactory = _display_utils.DOMStandardFontDataFactory;
            if (exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory, _is_node.isNodeJS) {
              const {
                NodeCanvasFactory: So,
                NodeCMapReaderFactory: eo,
                NodeStandardFontDataFactory: rs
              } = __w_pdfjs_require__(21);
              exports.DefaultCanvasFactory = DefaultCanvasFactory = So, exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory = eo, exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory = rs;
            }
            let createPDFNetworkStream;
            function setPDFNetworkStreamFactory(So) {
              createPDFNetworkStream = So;
            }
            function getDocument(So) {
              const eo = new PDFDocumentLoadingTask();
              let rs;
              if (typeof So == "string" || So instanceof URL)
                rs = {
                  url: So
                };
              else if ((0, _util.isArrayBuffer)(So))
                rs = {
                  data: So
                };
              else if (So instanceof PDFDataRangeTransport)
                rs = {
                  range: So
                };
              else {
                if (typeof So != "object")
                  throw new Error("Invalid parameter in getDocument, need either string, URL, TypedArray, or parameter object.");
                if (!So.url && !So.data && !So.range)
                  throw new Error("Invalid parameter object: need either .data, .range or .url");
                rs = So;
              }
              const ko = /* @__PURE__ */ Object.create(null);
              let Hs = null, Ks = null;
              for (const Xs in rs) {
                const Cs = rs[Xs];
                switch (Xs) {
                  case "url":
                    if (typeof window < "u")
                      try {
                        ko[Xs] = new URL(Cs, window.location).href;
                        continue;
                      } catch (Fs) {
                        (0, _util.warn)(`Cannot create valid URL: "${Fs}".`);
                      }
                    else if (typeof Cs == "string" || Cs instanceof URL) {
                      ko[Xs] = Cs.toString();
                      continue;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                  case "range":
                    Hs = Cs;
                    continue;
                  case "worker":
                    Ks = Cs;
                    continue;
                  case "data":
                    if (_is_node.isNodeJS && typeof Buffer < "u" && Cs instanceof Buffer)
                      ko[Xs] = new Uint8Array(Cs);
                    else {
                      if (Cs instanceof Uint8Array)
                        break;
                      if (typeof Cs == "string")
                        ko[Xs] = (0, _util.stringToBytes)(Cs);
                      else if (typeof Cs == "object" && Cs !== null && !isNaN(Cs.length))
                        ko[Xs] = new Uint8Array(Cs);
                      else if ((0, _util.isArrayBuffer)(Cs))
                        ko[Xs] = new Uint8Array(Cs);
                      else
                        throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                    }
                    continue;
                }
                ko[Xs] = Cs;
              }
              if (ko.CMapReaderFactory = ko.CMapReaderFactory || DefaultCMapReaderFactory, ko.StandardFontDataFactory = ko.StandardFontDataFactory || DefaultStandardFontDataFactory, ko.ignoreErrors = ko.stopAtErrors !== !0, ko.fontExtraProperties = ko.fontExtraProperties === !0, ko.pdfBug = ko.pdfBug === !0, ko.enableXfa = ko.enableXfa === !0, (!Number.isInteger(ko.rangeChunkSize) || ko.rangeChunkSize < 1) && (ko.rangeChunkSize = DEFAULT_RANGE_CHUNK_SIZE), (typeof ko.docBaseUrl != "string" || (0, _display_utils.isDataScheme)(ko.docBaseUrl)) && (ko.docBaseUrl = null), (!Number.isInteger(ko.maxImageSize) || ko.maxImageSize < -1) && (ko.maxImageSize = -1), typeof ko.cMapUrl != "string" && (ko.cMapUrl = null), typeof ko.standardFontDataUrl != "string" && (ko.standardFontDataUrl = null), typeof ko.useWorkerFetch != "boolean" && (ko.useWorkerFetch = ko.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && ko.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory), typeof ko.isEvalSupported != "boolean" && (ko.isEvalSupported = !0), typeof ko.disableFontFace != "boolean" && (ko.disableFontFace = _is_node.isNodeJS), typeof ko.useSystemFonts != "boolean" && (ko.useSystemFonts = !_is_node.isNodeJS && !ko.disableFontFace), (typeof ko.ownerDocument != "object" || ko.ownerDocument === null) && (ko.ownerDocument = globalThis.document), typeof ko.disableRange != "boolean" && (ko.disableRange = !1), typeof ko.disableStream != "boolean" && (ko.disableStream = !1), typeof ko.disableAutoFetch != "boolean" && (ko.disableAutoFetch = !1), (0, _util.setVerbosityLevel)(ko.verbosity), !Ks) {
                const Xs = {
                  verbosity: ko.verbosity,
                  port: _worker_options.GlobalWorkerOptions.workerPort
                };
                Ks = Xs.port ? PDFWorker.fromPort(Xs) : new PDFWorker(Xs), eo._worker = Ks;
              }
              const Ys = eo.docId;
              return Ks.promise.then(function() {
                if (eo.destroyed)
                  throw new Error("Loading aborted");
                const Xs = _fetchDocument(Ks, ko, Hs, Ys), Cs = new Promise(function(Fs) {
                  let ws;
                  Hs ? ws = new _transport_stream.PDFDataTransportStream({
                    length: ko.length,
                    initialData: ko.initialData,
                    progressiveDone: ko.progressiveDone,
                    contentDispositionFilename: ko.contentDispositionFilename,
                    disableRange: ko.disableRange,
                    disableStream: ko.disableStream
                  }, Hs) : ko.data || (ws = createPDFNetworkStream({
                    url: ko.url,
                    length: ko.length,
                    httpHeaders: ko.httpHeaders,
                    withCredentials: ko.withCredentials,
                    rangeChunkSize: ko.rangeChunkSize,
                    disableRange: ko.disableRange,
                    disableStream: ko.disableStream
                  })), Fs(ws);
                });
                return Promise.all([Xs, Cs]).then(function([Fs, ws]) {
                  if (eo.destroyed)
                    throw new Error("Loading aborted");
                  const ls = new _message_handler.MessageHandler(Ys, Fs, Ks.port), ks = new WorkerTransport(ls, eo, ws, ko);
                  eo._transport = ks, ls.send("Ready", null);
                });
              }).catch(eo._capability.reject), eo;
            }
            async function _fetchDocument(So, eo, rs, ko) {
              if (So.destroyed)
                throw new Error("Worker was destroyed");
              rs && (eo.length = rs.length, eo.initialData = rs.initialData, eo.progressiveDone = rs.progressiveDone, eo.contentDispositionFilename = rs.contentDispositionFilename);
              const Hs = await So.messageHandler.sendWithPromise("GetDocRequest", {
                docId: ko,
                apiVersion: "2.16.105",
                source: {
                  data: eo.data,
                  url: eo.url,
                  password: eo.password,
                  disableAutoFetch: eo.disableAutoFetch,
                  rangeChunkSize: eo.rangeChunkSize,
                  length: eo.length
                },
                maxImageSize: eo.maxImageSize,
                disableFontFace: eo.disableFontFace,
                docBaseUrl: eo.docBaseUrl,
                ignoreErrors: eo.ignoreErrors,
                isEvalSupported: eo.isEvalSupported,
                fontExtraProperties: eo.fontExtraProperties,
                enableXfa: eo.enableXfa,
                useSystemFonts: eo.useSystemFonts,
                cMapUrl: eo.useWorkerFetch ? eo.cMapUrl : null,
                standardFontDataUrl: eo.useWorkerFetch ? eo.standardFontDataUrl : null
              });
              if (eo.data && (eo.data = null), So.destroyed)
                throw new Error("Worker was destroyed");
              return Hs;
            }
            const e = class e {
              constructor() {
                this._capability = (0, _util.createPromiseCapability)(), this._transport = null, this._worker = null, this.docId = `d${Yd(e, Bi)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null, this.onUnsupportedFeature = null;
              }
              get promise() {
                return this._capability.promise;
              }
              async destroy() {
                this.destroyed = !0, await this._transport?.destroy(), this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
              }
            };
            Bi = new WeakMap(), $u(e, Bi, 0);
            let PDFDocumentLoadingTask = e;
            exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
            class PDFDataRangeTransport {
              constructor(eo, rs, ko = !1, Hs = null) {
                this.length = eo, this.initialData = rs, this.progressiveDone = ko, this.contentDispositionFilename = Hs, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = (0, _util.createPromiseCapability)();
              }
              addRangeListener(eo) {
                this._rangeListeners.push(eo);
              }
              addProgressListener(eo) {
                this._progressListeners.push(eo);
              }
              addProgressiveReadListener(eo) {
                this._progressiveReadListeners.push(eo);
              }
              addProgressiveDoneListener(eo) {
                this._progressiveDoneListeners.push(eo);
              }
              onDataRange(eo, rs) {
                for (const ko of this._rangeListeners)
                  ko(eo, rs);
              }
              onDataProgress(eo, rs) {
                this._readyCapability.promise.then(() => {
                  for (const ko of this._progressListeners)
                    ko(eo, rs);
                });
              }
              onDataProgressiveRead(eo) {
                this._readyCapability.promise.then(() => {
                  for (const rs of this._progressiveReadListeners)
                    rs(eo);
                });
              }
              onDataProgressiveDone() {
                this._readyCapability.promise.then(() => {
                  for (const eo of this._progressiveDoneListeners)
                    eo();
                });
              }
              transportReady() {
                this._readyCapability.resolve();
              }
              requestDataRange(eo, rs) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
              abort() {
              }
            }
            exports.PDFDataRangeTransport = PDFDataRangeTransport;
            class PDFDocumentProxy {
              constructor(eo, rs) {
                this._pdfInfo = eo, this._transport = rs, Object.defineProperty(this, "fingerprint", {
                  get() {
                    return (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead."), this.fingerprints[0];
                  }
                }), Object.defineProperty(this, "getStats", {
                  value: async () => ((0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead."), this.stats || {
                    streamTypes: {},
                    fontTypes: {}
                  })
                });
              }
              get annotationStorage() {
                return this._transport.annotationStorage;
              }
              get numPages() {
                return this._pdfInfo.numPages;
              }
              get fingerprints() {
                return this._pdfInfo.fingerprints;
              }
              get stats() {
                return this._transport.stats;
              }
              get isPureXfa() {
                return !!this._transport._htmlForXfa;
              }
              get allXfaHtml() {
                return this._transport._htmlForXfa;
              }
              getPage(eo) {
                return this._transport.getPage(eo);
              }
              getPageIndex(eo) {
                return this._transport.getPageIndex(eo);
              }
              getDestinations() {
                return this._transport.getDestinations();
              }
              getDestination(eo) {
                return this._transport.getDestination(eo);
              }
              getPageLabels() {
                return this._transport.getPageLabels();
              }
              getPageLayout() {
                return this._transport.getPageLayout();
              }
              getPageMode() {
                return this._transport.getPageMode();
              }
              getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
              getOpenAction() {
                return this._transport.getOpenAction();
              }
              getAttachments() {
                return this._transport.getAttachments();
              }
              getJavaScript() {
                return this._transport.getJavaScript();
              }
              getJSActions() {
                return this._transport.getDocJSActions();
              }
              getOutline() {
                return this._transport.getOutline();
              }
              getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
              getPermissions() {
                return this._transport.getPermissions();
              }
              getMetadata() {
                return this._transport.getMetadata();
              }
              getMarkInfo() {
                return this._transport.getMarkInfo();
              }
              getData() {
                return this._transport.getData();
              }
              getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
              cleanup(eo = !1) {
                return this._transport.startCleanup(eo || this.isPureXfa);
              }
              destroy() {
                return this.loadingTask.destroy();
              }
              get loadingParams() {
                return this._transport.loadingParams;
              }
              get loadingTask() {
                return this._transport.loadingTask;
              }
              saveDocument() {
                return this._transport.annotationStorage.size <= 0 && (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead."), this._transport.saveDocument();
              }
              getFieldObjects() {
                return this._transport.getFieldObjects();
              }
              hasJSActions() {
                return this._transport.hasJSActions();
              }
              getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }
            exports.PDFDocumentProxy = PDFDocumentProxy;
            class PDFPageProxy {
              constructor(eo, rs, ko, Hs, Ks = !1) {
                this._pageIndex = eo, this._pageInfo = rs, this._ownerDocument = Hs, this._transport = ko, this._stats = Ks ? new _display_utils.StatTimer() : null, this._pdfBug = Ks, this.commonObjs = ko.commonObjs, this.objs = new PDFObjects(), this._bitmaps = /* @__PURE__ */ new Set(), this.cleanupAfterRender = !1, this.pendingCleanup = !1, this._intentStates = /* @__PURE__ */ new Map(), this._annotationPromises = /* @__PURE__ */ new Map(), this.destroyed = !1;
              }
              get pageNumber() {
                return this._pageIndex + 1;
              }
              get rotate() {
                return this._pageInfo.rotate;
              }
              get ref() {
                return this._pageInfo.ref;
              }
              get userUnit() {
                return this._pageInfo.userUnit;
              }
              get view() {
                return this._pageInfo.view;
              }
              getViewport({
                scale: eo,
                rotation: rs = this.rotate,
                offsetX: ko = 0,
                offsetY: Hs = 0,
                dontFlip: Ks = !1
              } = {}) {
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: eo,
                  rotation: rs,
                  offsetX: ko,
                  offsetY: Hs,
                  dontFlip: Ks
                });
              }
              getAnnotations({
                intent: eo = "display"
              } = {}) {
                const rs = this._transport.getRenderingIntent(eo);
                let ko = this._annotationPromises.get(rs.cacheKey);
                return ko || (ko = this._transport.getAnnotations(this._pageIndex, rs.renderingIntent), this._annotationPromises.set(rs.cacheKey, ko), ko = ko.then((Hs) => {
                  for (const Ks of Hs)
                    Ks.titleObj !== void 0 && Object.defineProperty(Ks, "title", {
                      get() {
                        return (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead."), Ks.titleObj.str;
                      }
                    }), Ks.contentsObj !== void 0 && Object.defineProperty(Ks, "contents", {
                      get() {
                        return (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead."), Ks.contentsObj.str;
                      }
                    });
                  return Hs;
                })), ko;
              }
              getJSActions() {
                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
              }
              async getXfa() {
                return this._transport._htmlForXfa?.children[this._pageIndex] || null;
              }
              render({
                canvasContext: eo,
                viewport: rs,
                intent: ko = "display",
                annotationMode: Hs = _util.AnnotationMode.ENABLE,
                transform: Ks = null,
                imageLayer: Ys = null,
                canvasFactory: Xs = null,
                background: Cs = null,
                optionalContentConfigPromise: Fs = null,
                annotationCanvasMap: ws = null,
                pageColors: ls = null,
                printAnnotationStorage: ks = null
              }) {
                arguments[0]?.renderInteractiveForms !== void 0 && ((0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead."), arguments[0].renderInteractiveForms === !0 && Hs === _util.AnnotationMode.ENABLE && (Hs = _util.AnnotationMode.ENABLE_FORMS)), arguments[0]?.includeAnnotationStorage !== void 0 && ((0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead."), arguments[0].includeAnnotationStorage === !0 && Hs === _util.AnnotationMode.ENABLE && (Hs = _util.AnnotationMode.ENABLE_STORAGE)), this._stats && this._stats.time("Overall");
                const Js = this._transport.getRenderingIntent(ko, Hs, ks);
                this.pendingCleanup = !1, Fs || (Fs = this._transport.getOptionalContentConfig());
                let pl = this._intentStates.get(Js.cacheKey);
                pl || (pl = /* @__PURE__ */ Object.create(null), this._intentStates.set(Js.cacheKey, pl)), pl.streamReaderCancelTimeout && (clearTimeout(pl.streamReaderCancelTimeout), pl.streamReaderCancelTimeout = null);
                const _l = Xs || new DefaultCanvasFactory({
                  ownerDocument: this._ownerDocument
                }), bl = !!(Js.renderingIntent & _util.RenderingIntentFlag.PRINT);
                pl.displayReadyCapability || (pl.displayReadyCapability = (0, _util.createPromiseCapability)(), pl.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList(Js));
                const xl = (Dl) => {
                  pl.renderTasks.delete(Rl), (this.cleanupAfterRender || bl) && (this.pendingCleanup = !0), this._tryCleanup(), Dl ? (Rl.capability.reject(Dl), this._abortOperatorList({
                    intentState: pl,
                    reason: Dl instanceof Error ? Dl : new Error(Dl)
                  })) : Rl.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"));
                }, Rl = new InternalRenderTask({
                  callback: xl,
                  params: {
                    canvasContext: eo,
                    viewport: rs,
                    transform: Ks,
                    imageLayer: Ys,
                    background: Cs
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap: ws,
                  operatorList: pl.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: _l,
                  useRequestAnimationFrame: !bl,
                  pdfBug: this._pdfBug,
                  pageColors: ls
                });
                (pl.renderTasks || (pl.renderTasks = /* @__PURE__ */ new Set())).add(Rl);
                const Cl = Rl.task;
                return Promise.all([pl.displayReadyCapability.promise, Fs]).then(([Dl, kl]) => {
                  if (this.pendingCleanup) {
                    xl();
                    return;
                  }
                  this._stats && this._stats.time("Rendering"), Rl.initializeGraphics({
                    transparency: Dl,
                    optionalContentConfig: kl
                  }), Rl.operatorListChanged();
                }).catch(xl), Cl;
              }
              getOperatorList({
                intent: eo = "display",
                annotationMode: rs = _util.AnnotationMode.ENABLE,
                printAnnotationStorage: ko = null
              } = {}) {
                function Hs() {
                  Ys.operatorList.lastChunk && (Ys.opListReadCapability.resolve(Ys.operatorList), Ys.renderTasks.delete(Xs));
                }
                const Ks = this._transport.getRenderingIntent(eo, rs, ko, !0);
                let Ys = this._intentStates.get(Ks.cacheKey);
                Ys || (Ys = /* @__PURE__ */ Object.create(null), this._intentStates.set(Ks.cacheKey, Ys));
                let Xs;
                return Ys.opListReadCapability || (Xs = /* @__PURE__ */ Object.create(null), Xs.operatorListChanged = Hs, Ys.opListReadCapability = (0, _util.createPromiseCapability)(), (Ys.renderTasks || (Ys.renderTasks = /* @__PURE__ */ new Set())).add(Xs), Ys.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: !1,
                  separateAnnots: null
                }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList(Ks)), Ys.opListReadCapability.promise;
              }
              streamTextContent({
                disableCombineTextItems: eo = !1,
                includeMarkedContent: rs = !1
              } = {}) {
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  combineTextItems: eo !== !0,
                  includeMarkedContent: rs === !0
                }, {
                  highWaterMark: 100,
                  size(Hs) {
                    return Hs.items.length;
                  }
                });
              }
              getTextContent(eo = {}) {
                if (this._transport._htmlForXfa)
                  return this.getXfa().then((ko) => _xfa_text.XfaText.textContent(ko));
                const rs = this.streamTextContent(eo);
                return new Promise(function(ko, Hs) {
                  function Ks() {
                    Ys.read().then(function({
                      value: Cs,
                      done: Fs
                    }) {
                      if (Fs) {
                        ko(Xs);
                        return;
                      }
                      Object.assign(Xs.styles, Cs.styles), Xs.items.push(...Cs.items), Ks();
                    }, Hs);
                  }
                  const Ys = rs.getReader(), Xs = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  Ks();
                });
              }
              getStructTree() {
                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
              }
              _destroy() {
                this.destroyed = !0;
                const eo = [];
                for (const rs of this._intentStates.values())
                  if (this._abortOperatorList({
                    intentState: rs,
                    reason: new Error("Page was destroyed."),
                    force: !0
                  }), !rs.opListReadCapability)
                    for (const ko of rs.renderTasks)
                      eo.push(ko.completed), ko.cancel();
                this.objs.clear();
                for (const rs of this._bitmaps)
                  rs.close();
                return this._bitmaps.clear(), this._annotationPromises.clear(), this._jsActionsPromise = null, this._structTreePromise = null, this.pendingCleanup = !1, Promise.all(eo);
              }
              cleanup(eo = !1) {
                return this.pendingCleanup = !0, this._tryCleanup(eo);
              }
              _tryCleanup(eo = !1) {
                if (!this.pendingCleanup)
                  return !1;
                for (const {
                  renderTasks: rs,
                  operatorList: ko
                } of this._intentStates.values())
                  if (rs.size > 0 || !ko.lastChunk)
                    return !1;
                this._intentStates.clear(), this.objs.clear(), this._annotationPromises.clear(), this._jsActionsPromise = null, this._structTreePromise = null, eo && this._stats && (this._stats = new _display_utils.StatTimer());
                for (const rs of this._bitmaps)
                  rs.close();
                return this._bitmaps.clear(), this.pendingCleanup = !1, !0;
              }
              _startRenderPage(eo, rs) {
                const ko = this._intentStates.get(rs);
                ko && (this._stats && this._stats.timeEnd("Page Request"), ko.displayReadyCapability && ko.displayReadyCapability.resolve(eo));
              }
              _renderPageChunk(eo, rs) {
                for (let ko = 0, Hs = eo.length; ko < Hs; ko++)
                  rs.operatorList.fnArray.push(eo.fnArray[ko]), rs.operatorList.argsArray.push(eo.argsArray[ko]);
                rs.operatorList.lastChunk = eo.lastChunk, rs.operatorList.separateAnnots = eo.separateAnnots;
                for (const ko of rs.renderTasks)
                  ko.operatorListChanged();
                eo.lastChunk && this._tryCleanup();
              }
              _pumpOperatorList({
                renderingIntent: eo,
                cacheKey: rs,
                annotationStorageMap: ko
              }) {
                const Ks = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: eo,
                  cacheKey: rs,
                  annotationStorage: ko
                }).getReader(), Ys = this._intentStates.get(rs);
                Ys.streamReader = Ks;
                const Xs = () => {
                  Ks.read().then(({
                    value: Cs,
                    done: Fs
                  }) => {
                    if (Fs) {
                      Ys.streamReader = null;
                      return;
                    }
                    this._transport.destroyed || (this._renderPageChunk(Cs, Ys), Xs());
                  }, (Cs) => {
                    if (Ys.streamReader = null, !this._transport.destroyed) {
                      if (Ys.operatorList) {
                        Ys.operatorList.lastChunk = !0;
                        for (const Fs of Ys.renderTasks)
                          Fs.operatorListChanged();
                        this._tryCleanup();
                      }
                      if (Ys.displayReadyCapability)
                        Ys.displayReadyCapability.reject(Cs);
                      else if (Ys.opListReadCapability)
                        Ys.opListReadCapability.reject(Cs);
                      else
                        throw Cs;
                    }
                  });
                };
                Xs();
              }
              _abortOperatorList({
                intentState: eo,
                reason: rs,
                force: ko = !1
              }) {
                if (eo.streamReader) {
                  if (!ko) {
                    if (eo.renderTasks.size > 0)
                      return;
                    if (rs instanceof _display_utils.RenderingCancelledException) {
                      eo.streamReaderCancelTimeout = setTimeout(() => {
                        this._abortOperatorList({
                          intentState: eo,
                          reason: rs,
                          force: !0
                        }), eo.streamReaderCancelTimeout = null;
                      }, RENDERING_CANCELLED_TIMEOUT);
                      return;
                    }
                  }
                  if (eo.streamReader.cancel(new _util.AbortException(rs.message)).catch(() => {
                  }), eo.streamReader = null, !this._transport.destroyed) {
                    for (const [Hs, Ks] of this._intentStates)
                      if (Ks === eo) {
                        this._intentStates.delete(Hs);
                        break;
                      }
                    this.cleanup();
                  }
                }
              }
              get stats() {
                return this._stats;
              }
            }
            exports.PDFPageProxy = PDFPageProxy;
            class LoopbackPort {
              constructor() {
                this._listeners = [], this._deferred = Promise.resolve();
              }
              postMessage(eo, rs) {
                const ko = {
                  data: structuredClone(eo, rs)
                };
                this._deferred.then(() => {
                  for (const Hs of this._listeners)
                    Hs.call(this, ko);
                });
              }
              addEventListener(eo, rs) {
                this._listeners.push(rs);
              }
              removeEventListener(eo, rs) {
                const ko = this._listeners.indexOf(rs);
                this._listeners.splice(ko, 1);
              }
              terminate() {
                this._listeners.length = 0;
              }
            }
            exports.LoopbackPort = LoopbackPort;
            const PDFWorkerUtil = {
              isWorkerDisabled: !1,
              fallbackWorkerSrc: null,
              fakeWorkerId: 0
            };
            exports.PDFWorkerUtil = PDFWorkerUtil;
            {
              if (_is_node.isNodeJS && typeof commonjsRequire == "function")
                PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
              else if (typeof document == "object") {
                const So = document?.currentScript?.src;
                So && (PDFWorkerUtil.fallbackWorkerSrc = So.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
              }
              PDFWorkerUtil.isSameOrigin = function(So, eo) {
                let rs;
                try {
                  if (rs = new URL(So), !rs.origin || rs.origin === "null")
                    return !1;
                } catch {
                  return !1;
                }
                const ko = new URL(eo, rs);
                return rs.origin === ko.origin;
              }, PDFWorkerUtil.createCDNWrapper = function(So) {
                const eo = `importScripts("${So}");`;
                return URL.createObjectURL(new Blob([eo]));
              };
            }
            const _PDFWorker = class _PDFWorker {
              constructor({
                name: So = null,
                port: eo = null,
                verbosity: rs = (0, _util.getVerbosityLevel)()
              } = {}) {
                if (eo && Vl(_PDFWorker, qi).has(eo))
                  throw new Error("Cannot use more than one PDFWorker per port.");
                if (this.name = So, this.destroyed = !1, this.verbosity = rs, this._readyCapability = (0, _util.createPromiseCapability)(), this._port = null, this._webWorker = null, this._messageHandler = null, eo) {
                  Vl(_PDFWorker, qi).set(eo, this), this._initializeFromPort(eo);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(So) {
                this._port = So, this._messageHandler = new _message_handler.MessageHandler("main", "worker", So), this._messageHandler.on("ready", function() {
                }), this._readyCapability.resolve();
              }
              _initialize() {
                if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                  let {
                    workerSrc: So
                  } = _PDFWorker;
                  try {
                    PDFWorkerUtil.isSameOrigin(window.location.href, So) || (So = PDFWorkerUtil.createCDNWrapper(new URL(So, window.location).href));
                    const eo = new Worker(So), rs = new _message_handler.MessageHandler("main", "worker", eo), ko = () => {
                      eo.removeEventListener("error", Hs), rs.destroy(), eo.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                    }, Hs = () => {
                      this._webWorker || ko();
                    };
                    eo.addEventListener("error", Hs), rs.on("test", (Ys) => {
                      if (eo.removeEventListener("error", Hs), this.destroyed) {
                        ko();
                        return;
                      }
                      Ys ? (this._messageHandler = rs, this._port = eo, this._webWorker = eo, this._readyCapability.resolve(), rs.send("configure", {
                        verbosity: this.verbosity
                      })) : (this._setupFakeWorker(), rs.destroy(), eo.terminate());
                    }), rs.on("ready", (Ys) => {
                      if (eo.removeEventListener("error", Hs), this.destroyed) {
                        ko();
                        return;
                      }
                      try {
                        Ks();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const Ks = () => {
                      const Ys = new Uint8Array();
                      rs.send("test", Ys, [Ys.buffer]);
                    };
                    Ks();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), _PDFWorker._setupFakeWorkerGlobal.then((So) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const eo = new LoopbackPort();
                  this._port = eo;
                  const rs = `fake${PDFWorkerUtil.fakeWorkerId++}`, ko = new _message_handler.MessageHandler(rs + "_worker", rs, eo);
                  So.setup(ko, eo);
                  const Hs = new _message_handler.MessageHandler(rs, rs + "_worker", eo);
                  this._messageHandler = Hs, this._readyCapability.resolve(), Hs.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((So) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${So.message}".`));
                });
              }
              destroy() {
                this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), Vl(_PDFWorker, qi).delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
              }
              static fromPort(So) {
                if (!So?.port)
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                return Vl(this, qi).has(So.port) ? Vl(this, qi).get(So.port) : new _PDFWorker(So);
              }
              static get workerSrc() {
                if (_worker_options.GlobalWorkerOptions.workerSrc)
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                  return _is_node.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              static get _mainThreadWorkerMessageHandler() {
                try {
                  return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                } catch {
                  return null;
                }
              }
              static get _setupFakeWorkerGlobal() {
                const loader = async () => {
                  const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                  if (mainWorkerMessageHandler)
                    return mainWorkerMessageHandler;
                  if (_is_node.isNodeJS && typeof commonjsRequire == "function") {
                    const worker = eval("require")(this.workerSrc);
                    return worker.WorkerMessageHandler;
                  }
                  return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
                };
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            };
            qi = new WeakMap(), $u(_PDFWorker, qi, /* @__PURE__ */ new WeakMap());
            let PDFWorker = _PDFWorker;
            exports.PDFWorker = PDFWorker, PDFWorker.getWorkerSrc = function() {
              return (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead."), this.workerSrc;
            };
            class WorkerTransport {
              constructor(eo, rs, ko, Hs) {
                $u(this, Xi, null);
                $u(this, Qi, /* @__PURE__ */ new Map());
                $u(this, ta, /* @__PURE__ */ new Map());
                $u(this, ra, null);
                this.messageHandler = eo, this.loadingTask = rs, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                  docId: rs.docId,
                  onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                  ownerDocument: Hs.ownerDocument,
                  styleElement: Hs.styleElement
                }), this._params = Hs, Hs.useWorkerFetch || (this.CMapReaderFactory = new Hs.CMapReaderFactory({
                  baseUrl: Hs.cMapUrl,
                  isCompressed: Hs.cMapPacked
                }), this.StandardFontDataFactory = new Hs.StandardFontDataFactory({
                  baseUrl: Hs.standardFontDataUrl
                })), this.destroyed = !1, this.destroyCapability = null, this._passwordCapability = null, this._networkStream = ko, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = (0, _util.createPromiseCapability)(), this.setupMessageHandler();
              }
              get annotationStorage() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
              get stats() {
                return Vl(this, Xi);
              }
              getRenderingIntent(eo, rs = _util.AnnotationMode.ENABLE, ko = null, Hs = !1) {
                let Ks = _util.RenderingIntentFlag.DISPLAY, Ys = null;
                switch (eo) {
                  case "any":
                    Ks = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    Ks = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid intent: ${eo}`);
                }
                switch (rs) {
                  case _util.AnnotationMode.DISABLE:
                    Ks += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    Ks += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    Ks += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, Ys = (Ks & _util.RenderingIntentFlag.PRINT && ko instanceof _annotation_storage.PrintAnnotationStorage ? ko : this.annotationStorage).serializable;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${rs}`);
                }
                return Hs && (Ks += _util.RenderingIntentFlag.OPLIST), {
                  renderingIntent: Ks,
                  cacheKey: `${Ks}_${_annotation_storage.AnnotationStorage.getHash(Ys)}`,
                  annotationStorageMap: Ys
                };
              }
              destroy() {
                if (this.destroyCapability)
                  return this.destroyCapability.promise;
                this.destroyed = !0, this.destroyCapability = (0, _util.createPromiseCapability)(), this._passwordCapability && this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                const eo = [];
                for (const ko of Vl(this, Qi).values())
                  eo.push(ko._destroy());
                Vl(this, Qi).clear(), Vl(this, ta).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
                const rs = this.messageHandler.sendWithPromise("Terminate", null);
                return eo.push(rs), Promise.all(eo).then(() => {
                  this.commonObjs.clear(), this.fontLoader.clear(), Hu(this, ra, null), this._getFieldObjectsPromise = null, this._hasJSActionsPromise = null, this._networkStream && this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
                }, this.destroyCapability.reject), this.destroyCapability.promise;
              }
              setupMessageHandler() {
                const {
                  messageHandler: eo,
                  loadingTask: rs
                } = this;
                eo.on("GetReader", (ko, Hs) => {
                  (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (Ks) => {
                    this._lastProgress = {
                      loaded: Ks.loaded,
                      total: Ks.total
                    };
                  }, Hs.onPull = () => {
                    this._fullReader.read().then(function({
                      value: Ks,
                      done: Ys
                    }) {
                      if (Ys) {
                        Hs.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(Ks), "GetReader - expected an ArrayBuffer."), Hs.enqueue(new Uint8Array(Ks), 1, [Ks]);
                    }).catch((Ks) => {
                      Hs.error(Ks);
                    });
                  }, Hs.onCancel = (Ks) => {
                    this._fullReader.cancel(Ks), Hs.ready.catch((Ys) => {
                      if (!this.destroyed)
                        throw Ys;
                    });
                  };
                }), eo.on("ReaderHeadersReady", (ko) => {
                  const Hs = (0, _util.createPromiseCapability)(), Ks = this._fullReader;
                  return Ks.headersReady.then(() => {
                    (!Ks.isStreamingSupported || !Ks.isRangeSupported) && (this._lastProgress && rs.onProgress?.(this._lastProgress), Ks.onProgress = (Ys) => {
                      rs.onProgress?.({
                        loaded: Ys.loaded,
                        total: Ys.total
                      });
                    }), Hs.resolve({
                      isStreamingSupported: Ks.isStreamingSupported,
                      isRangeSupported: Ks.isRangeSupported,
                      contentLength: Ks.contentLength
                    });
                  }, Hs.reject), Hs.promise;
                }), eo.on("GetRangeReader", (ko, Hs) => {
                  (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  const Ks = this._networkStream.getRangeReader(ko.begin, ko.end);
                  if (!Ks) {
                    Hs.close();
                    return;
                  }
                  Hs.onPull = () => {
                    Ks.read().then(function({
                      value: Ys,
                      done: Xs
                    }) {
                      if (Xs) {
                        Hs.close();
                        return;
                      }
                      (0, _util.assert)((0, _util.isArrayBuffer)(Ys), "GetRangeReader - expected an ArrayBuffer."), Hs.enqueue(new Uint8Array(Ys), 1, [Ys]);
                    }).catch((Ys) => {
                      Hs.error(Ys);
                    });
                  }, Hs.onCancel = (Ys) => {
                    Ks.cancel(Ys), Hs.ready.catch((Xs) => {
                      if (!this.destroyed)
                        throw Xs;
                    });
                  };
                }), eo.on("GetDoc", ({
                  pdfInfo: ko
                }) => {
                  this._numPages = ko.numPages, this._htmlForXfa = ko.htmlForXfa, delete ko.htmlForXfa, rs._capability.resolve(new PDFDocumentProxy(ko, this));
                }), eo.on("DocException", function(ko) {
                  let Hs;
                  switch (ko.name) {
                    case "PasswordException":
                      Hs = new _util.PasswordException(ko.message, ko.code);
                      break;
                    case "InvalidPDFException":
                      Hs = new _util.InvalidPDFException(ko.message);
                      break;
                    case "MissingPDFException":
                      Hs = new _util.MissingPDFException(ko.message);
                      break;
                    case "UnexpectedResponseException":
                      Hs = new _util.UnexpectedResponseException(ko.message, ko.status);
                      break;
                    case "UnknownErrorException":
                      Hs = new _util.UnknownErrorException(ko.message, ko.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  rs._capability.reject(Hs);
                }), eo.on("PasswordRequest", (ko) => {
                  if (this._passwordCapability = (0, _util.createPromiseCapability)(), rs.onPassword) {
                    const Hs = (Ks) => {
                      Ks instanceof Error ? this._passwordCapability.reject(Ks) : this._passwordCapability.resolve({
                        password: Ks
                      });
                    };
                    try {
                      rs.onPassword(Hs, ko.code);
                    } catch (Ks) {
                      this._passwordCapability.reject(Ks);
                    }
                  } else
                    this._passwordCapability.reject(new _util.PasswordException(ko.message, ko.code));
                  return this._passwordCapability.promise;
                }), eo.on("DataLoaded", (ko) => {
                  rs.onProgress?.({
                    loaded: ko.length,
                    total: ko.length
                  }), this.downloadInfoCapability.resolve(ko);
                }), eo.on("StartRenderPage", (ko) => {
                  if (this.destroyed)
                    return;
                  Vl(this, Qi).get(ko.pageIndex)._startRenderPage(ko.transparency, ko.cacheKey);
                }), eo.on("commonobj", ([ko, Hs, Ks]) => {
                  if (!this.destroyed && !this.commonObjs.has(ko))
                    switch (Hs) {
                      case "Font":
                        const Ys = this._params;
                        if ("error" in Ks) {
                          const Fs = Ks.error;
                          (0, _util.warn)(`Error during font loading: ${Fs}`), this.commonObjs.resolve(ko, Fs);
                          break;
                        }
                        let Xs = null;
                        Ys.pdfBug && globalThis.FontInspector?.enabled && (Xs = {
                          registerFont(Fs, ws) {
                            globalThis.FontInspector.fontAdded(Fs, ws);
                          }
                        });
                        const Cs = new _font_loader.FontFaceObject(Ks, {
                          isEvalSupported: Ys.isEvalSupported,
                          disableFontFace: Ys.disableFontFace,
                          ignoreErrors: Ys.ignoreErrors,
                          onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                          fontRegistry: Xs
                        });
                        this.fontLoader.bind(Cs).catch((Fs) => eo.sendWithPromise("FontFallback", {
                          id: ko
                        })).finally(() => {
                          !Ys.fontExtraProperties && Cs.data && (Cs.data = null), this.commonObjs.resolve(ko, Cs);
                        });
                        break;
                      case "FontPath":
                      case "Image":
                        this.commonObjs.resolve(ko, Ks);
                        break;
                      default:
                        throw new Error(`Got unknown common object type ${Hs}`);
                    }
                }), eo.on("obj", ([ko, Hs, Ks, Ys]) => {
                  if (this.destroyed)
                    return;
                  const Xs = Vl(this, Qi).get(Hs);
                  if (!Xs.objs.has(ko))
                    switch (Ks) {
                      case "Image":
                        Xs.objs.resolve(ko, Ys);
                        const Cs = 8e6;
                        if (Ys) {
                          let Fs;
                          if (Ys.bitmap) {
                            const {
                              bitmap: ws,
                              width: ls,
                              height: ks
                            } = Ys;
                            Fs = ls * ks * 4, Xs._bitmaps.add(ws);
                          } else
                            Fs = Ys.data?.length || 0;
                          Fs > Cs && (Xs.cleanupAfterRender = !0);
                        }
                        break;
                      case "Pattern":
                        Xs.objs.resolve(ko, Ys);
                        break;
                      default:
                        throw new Error(`Got unknown object type ${Ks}`);
                    }
                }), eo.on("DocProgress", (ko) => {
                  this.destroyed || rs.onProgress?.({
                    loaded: ko.loaded,
                    total: ko.total
                  });
                }), eo.on("DocStats", (ko) => {
                  this.destroyed || Hu(this, Xi, Object.freeze({
                    streamTypes: Object.freeze(ko.streamTypes),
                    fontTypes: Object.freeze(ko.fontTypes)
                  }));
                }), eo.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this)), eo.on("FetchBuiltInCMap", (ko) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.CMapReaderFactory ? this.CMapReaderFactory.fetch(ko) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), eo.on("FetchStandardFontData", (ko) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.StandardFontDataFactory ? this.StandardFontDataFactory.fetch(ko) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
              }
              _onUnsupportedFeature({
                featureId: eo
              }) {
                this.destroyed || this.loadingTask.onUnsupportedFeature?.(eo);
              }
              getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
              getPage(eo) {
                if (!Number.isInteger(eo) || eo <= 0 || eo > this._numPages)
                  return Promise.reject(new Error("Invalid page request."));
                const rs = eo - 1, ko = Vl(this, ta).get(rs);
                if (ko)
                  return ko;
                const Hs = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex: rs
                }).then((Ks) => {
                  if (this.destroyed)
                    throw new Error("Transport destroyed");
                  const Ys = new PDFPageProxy(rs, Ks, this, this._params.ownerDocument, this._params.pdfBug);
                  return Vl(this, Qi).set(rs, Ys), Ys;
                });
                return Vl(this, ta).set(rs, Hs), Hs;
              }
              getPageIndex(eo) {
                return typeof eo != "object" || eo === null || !Number.isInteger(eo.num) || eo.num < 0 || !Number.isInteger(eo.gen) || eo.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                  num: eo.num,
                  gen: eo.gen
                });
              }
              getAnnotations(eo, rs) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex: eo,
                  intent: rs
                });
              }
              saveDocument() {
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: this.annotationStorage.serializable,
                  filename: this._fullReader?.filename ?? null
                }).finally(() => {
                  this.annotationStorage.resetModified();
                });
              }
              getFieldObjects() {
                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
              }
              hasJSActions() {
                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
              }
              getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
              getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
              getDestination(eo) {
                return typeof eo != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                  id: eo
                });
              }
              getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
              getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
              getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
              getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
              getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
              getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
              getJavaScript() {
                return this.messageHandler.sendWithPromise("GetJavaScript", null);
              }
              getDocJSActions() {
                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
              }
              getPageJSActions(eo) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex: eo
                });
              }
              getStructTree(eo) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex: eo
                });
              }
              getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
              getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((eo) => new _optional_content_config.OptionalContentConfig(eo));
              }
              getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
              getMetadata() {
                return Vl(this, ra) || Hu(this, ra, this.messageHandler.sendWithPromise("GetMetadata", null).then((eo) => ({
                  info: eo[0],
                  metadata: eo[1] ? new _metadata.Metadata(eo[1]) : null,
                  contentDispositionFilename: this._fullReader?.filename ?? null,
                  contentLength: this._fullReader?.contentLength ?? null
                })));
              }
              getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
              async startCleanup(eo = !1) {
                if (await this.messageHandler.sendWithPromise("Cleanup", null), !this.destroyed) {
                  for (const rs of Vl(this, Qi).values())
                    if (!rs.cleanup())
                      throw new Error(`startCleanup: Page ${rs.pageNumber} is currently rendering.`);
                  this.commonObjs.clear(), eo || this.fontLoader.clear(), Hu(this, ra, null), this._getFieldObjectsPromise = null, this._hasJSActionsPromise = null;
                }
              }
              get loadingParams() {
                const eo = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch: eo.disableAutoFetch,
                  enableXfa: eo.enableXfa
                });
              }
            }
            Xi = new WeakMap(), Qi = new WeakMap(), ta = new WeakMap(), ra = new WeakMap();
            class PDFObjects {
              constructor() {
                $u(this, la);
                $u(this, na, /* @__PURE__ */ Object.create(null));
              }
              get(eo, rs = null) {
                if (rs) {
                  const Hs = rc(this, la, tf).call(this, eo);
                  return Hs.capability.promise.then(() => rs(Hs.data)), null;
                }
                const ko = Vl(this, na)[eo];
                if (!ko?.capability.settled)
                  throw new Error(`Requesting object that isn't resolved yet ${eo}.`);
                return ko.data;
              }
              has(eo) {
                return Vl(this, na)[eo]?.capability.settled || !1;
              }
              resolve(eo, rs = null) {
                const ko = rc(this, la, tf).call(this, eo);
                ko.data = rs, ko.capability.resolve();
              }
              clear() {
                Hu(this, na, /* @__PURE__ */ Object.create(null));
              }
            }
            na = new WeakMap(), la = new WeakSet(), tf = function(eo) {
              const rs = Vl(this, na)[eo];
              return rs || (Vl(this, na)[eo] = {
                capability: (0, _util.createPromiseCapability)(),
                data: null
              });
            };
            class RenderTask {
              constructor(eo) {
                $u(this, Va, null);
                Hu(this, Va, eo), this.onContinue = null;
              }
              get promise() {
                return Vl(this, Va).capability.promise;
              }
              cancel() {
                Vl(this, Va).cancel();
              }
              get separateAnnots() {
                const {
                  separateAnnots: eo
                } = Vl(this, Va).operatorList;
                if (!eo)
                  return !1;
                const {
                  annotationCanvasMap: rs
                } = Vl(this, Va);
                return eo.form || eo.canvas && rs?.size > 0;
              }
            }
            Va = new WeakMap(), exports.RenderTask = RenderTask;
            const Eo = class Eo {
              constructor({
                callback: eo,
                params: rs,
                objs: ko,
                commonObjs: Hs,
                annotationCanvasMap: Ks,
                operatorList: Ys,
                pageIndex: Xs,
                canvasFactory: Cs,
                useRequestAnimationFrame: Fs = !1,
                pdfBug: ws = !1,
                pageColors: ls = null
              }) {
                this.callback = eo, this.params = rs, this.objs = ko, this.commonObjs = Hs, this.annotationCanvasMap = Ks, this.operatorListIdx = null, this.operatorList = Ys, this._pageIndex = Xs, this.canvasFactory = Cs, this._pdfBug = ws, this.pageColors = ls, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = Fs === !0 && typeof window < "u", this.cancelled = !1, this.capability = (0, _util.createPromiseCapability)(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = rs.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency: eo = !1,
                optionalContentConfig: rs
              }) {
                if (this.cancelled)
                  return;
                if (this._canvas) {
                  if (Vl(Eo, to).has(this._canvas))
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  Vl(Eo, to).add(this._canvas);
                }
                this._pdfBug && globalThis.StepperManager?.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                const {
                  canvasContext: ko,
                  viewport: Hs,
                  transform: Ks,
                  imageLayer: Ys,
                  background: Xs
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(ko, this.commonObjs, this.objs, this.canvasFactory, Ys, rs, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                  transform: Ks,
                  viewport: Hs,
                  transparency: eo,
                  background: Xs
                }), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback && this.graphicsReadyCallback();
              }
              cancel(eo = null) {
                this.running = !1, this.cancelled = !0, this.gfx && this.gfx.endDrawing(), this._canvas && Vl(Eo, to).delete(this._canvas), this.callback(eo || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas"));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                  return;
                }
                this.stepper && this.stepper.updateOperatorList(this.operatorList), !this.running && this._continue();
              }
              _continue() {
                this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
              }
              _scheduleNext() {
                this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                  this._nextBound().catch(this._cancelBound);
                }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
              }
              async _next() {
                this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), this._canvas && Vl(Eo, to).delete(this._canvas), this.callback())));
              }
            };
            to = new WeakMap(), $u(Eo, to, /* @__PURE__ */ new WeakSet());
            let InternalRenderTask = Eo;
            const version = "2.16.105";
            exports.version = version;
            const build = "172ccdbe5";
            exports.build = build;
          },
          /* 5 */
          /***/
          (Bi, e, qi) => {
            var la, Tf, Va;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PrintAnnotationStorage = e.AnnotationStorage = void 0;
            var Xi = qi(1), Qi = qi(6), ta = qi(10);
            class ra {
              constructor() {
                $u(this, la);
                this._storage = /* @__PURE__ */ new Map(), this._modified = !1, this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
              }
              getValue(Eo, So) {
                const eo = this._storage.get(Eo);
                return eo === void 0 ? So : Object.assign(So, eo);
              }
              getRawValue(Eo) {
                return this._storage.get(Eo);
              }
              remove(Eo) {
                if (this._storage.delete(Eo), this._storage.size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                  for (const So of this._storage.values())
                    if (So instanceof Qi.AnnotationEditor)
                      return;
                  this.onAnnotationEditor(null);
                }
              }
              setValue(Eo, So) {
                const eo = this._storage.get(Eo);
                let rs = !1;
                if (eo !== void 0)
                  for (const [ko, Hs] of Object.entries(So))
                    eo[ko] !== Hs && (rs = !0, eo[ko] = Hs);
                else
                  rs = !0, this._storage.set(Eo, So);
                rs && rc(this, la, Tf).call(this), So instanceof Qi.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(So.constructor._type);
              }
              has(Eo) {
                return this._storage.has(Eo);
              }
              getAll() {
                return this._storage.size > 0 ? (0, Xi.objectFromMap)(this._storage) : null;
              }
              get size() {
                return this._storage.size;
              }
              resetModified() {
                this._modified && (this._modified = !1, typeof this.onResetModified == "function" && this.onResetModified());
              }
              get print() {
                return new na(this);
              }
              get serializable() {
                if (this._storage.size === 0)
                  return null;
                const Eo = /* @__PURE__ */ new Map();
                for (const [So, eo] of this._storage) {
                  const rs = eo instanceof Qi.AnnotationEditor ? eo.serialize() : eo;
                  rs && Eo.set(So, rs);
                }
                return Eo;
              }
              static getHash(Eo) {
                if (!Eo)
                  return "";
                const So = new ta.MurmurHash3_64();
                for (const [eo, rs] of Eo)
                  So.update(`${eo}:${JSON.stringify(rs)}`);
                return So.hexdigest();
              }
            }
            la = new WeakSet(), Tf = function() {
              this._modified || (this._modified = !0, typeof this.onSetModified == "function" && this.onSetModified());
            }, e.AnnotationStorage = ra;
            class na extends ra {
              constructor(So) {
                super();
                $u(this, Va, null);
                Hu(this, Va, structuredClone(So.serializable));
              }
              get print() {
                (0, Xi.unreachable)("Should not call PrintAnnotationStorage.print");
              }
              get serializable() {
                return Vl(this, Va);
              }
            }
            Va = new WeakMap(), e.PrintAnnotationStorage = na;
          },
          /* 6 */
          /***/
          (Bi, e, qi) => {
            var ra, na, la, Ma, Va, to;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationEditor = void 0;
            var Xi = qi(7), Qi = qi(1);
            const Eo = class Eo {
              constructor(eo) {
                $u(this, ra, this.focusin.bind(this));
                $u(this, na, this.focusout.bind(this));
                $u(this, la, !1);
                $u(this, Ma, !1);
                $u(this, Va, !1);
                $u(this, to, Eo._zIndex++);
                this.constructor === Eo && (0, Qi.unreachable)("Cannot initialize AnnotationEditor."), this.parent = eo.parent, this.id = eo.id, this.width = this.height = null, this.pageIndex = eo.parent.pageIndex, this.name = eo.name, this.div = null;
                const [rs, ko] = this.parent.viewportBaseDimensions;
                this.x = eo.x / rs, this.y = eo.y / ko, this.rotation = this.parent.viewport.rotation, this.isAttachedToDOM = !1;
              }
              static get _defaultLineColor() {
                return (0, Qi.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
              }
              setInBackground() {
                this.div.style.zIndex = 0;
              }
              setInForeground() {
                this.div.style.zIndex = Vl(this, to);
              }
              focusin(eo) {
                Vl(this, la) ? Hu(this, la, !1) : this.parent.setSelected(this);
              }
              focusout(eo) {
                !this.isAttachedToDOM || eo.relatedTarget?.closest(`#${this.id}`) || (eo.preventDefault(), this.parent.isMultipleSelection || this.commitOrRemove());
              }
              commitOrRemove() {
                this.isEmpty() ? this.remove() : this.commit();
              }
              commit() {
                this.parent.addToAnnotationStorage(this);
              }
              dragstart(eo) {
                const rs = this.parent.div.getBoundingClientRect();
                this.startX = eo.clientX - rs.x, this.startY = eo.clientY - rs.y, eo.dataTransfer.setData("text/plain", this.id), eo.dataTransfer.effectAllowed = "move";
              }
              setAt(eo, rs, ko, Hs) {
                const [Ks, Ys] = this.parent.viewportBaseDimensions;
                [ko, Hs] = this.screenToPageTranslation(ko, Hs), this.x = (eo + ko) / Ks, this.y = (rs + Hs) / Ys, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
              }
              translate(eo, rs) {
                const [ko, Hs] = this.parent.viewportBaseDimensions;
                [eo, rs] = this.screenToPageTranslation(eo, rs), this.x += eo / ko, this.y += rs / Hs, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
              }
              screenToPageTranslation(eo, rs) {
                const {
                  rotation: ko
                } = this.parent.viewport;
                switch (ko) {
                  case 90:
                    return [rs, -eo];
                  case 180:
                    return [-eo, -rs];
                  case 270:
                    return [-rs, eo];
                  default:
                    return [eo, rs];
                }
              }
              setDims(eo, rs) {
                const [ko, Hs] = this.parent.viewportBaseDimensions;
                this.div.style.width = `${100 * eo / ko}%`, this.div.style.height = `${100 * rs / Hs}%`;
              }
              getInitialTranslation() {
                return [0, 0];
              }
              render() {
                this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", Vl(this, ra)), this.div.addEventListener("focusout", Vl(this, na));
                const [eo, rs] = this.getInitialTranslation();
                return this.translate(eo, rs), (0, Xi.bindEvents)(this, this.div, ["dragstart", "pointerdown"]), this.div;
              }
              pointerdown(eo) {
                const rs = Xi.KeyboardManager.platform.isMac;
                if (eo.button !== 0 || eo.ctrlKey && rs) {
                  eo.preventDefault();
                  return;
                }
                eo.ctrlKey && !rs || eo.shiftKey || eo.metaKey && rs ? this.parent.toggleSelected(this) : this.parent.setSelected(this), Hu(this, la, !0);
              }
              getRect(eo, rs) {
                const [ko, Hs] = this.parent.viewportBaseDimensions, [Ks, Ys] = this.parent.pageDimensions, Xs = Ks * eo / ko, Cs = Ys * rs / Hs, Fs = this.x * Ks, ws = this.y * Ys, ls = this.width * Ks, ks = this.height * Ys;
                switch (this.rotation) {
                  case 0:
                    return [Fs + Xs, Ys - ws - Cs - ks, Fs + Xs + ls, Ys - ws - Cs];
                  case 90:
                    return [Fs + Cs, Ys - ws + Xs, Fs + Cs + ks, Ys - ws + Xs + ls];
                  case 180:
                    return [Fs - Xs - ls, Ys - ws + Cs, Fs - Xs, Ys - ws + Cs + ks];
                  case 270:
                    return [Fs - Cs - ks, Ys - ws - Xs - ls, Fs - Cs, Ys - ws - Xs];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              getRectInCurrentCoords(eo, rs) {
                const [ko, Hs, Ks, Ys] = eo, Xs = Ks - ko, Cs = Ys - Hs;
                switch (this.rotation) {
                  case 0:
                    return [ko, rs - Ys, Xs, Cs];
                  case 90:
                    return [ko, rs - Hs, Cs, Xs];
                  case 180:
                    return [Ks, rs - Hs, Xs, Cs];
                  case 270:
                    return [Ks, rs - Ys, Cs, Xs];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              onceAdded() {
              }
              isEmpty() {
                return !1;
              }
              enableEditMode() {
                Hu(this, Va, !0);
              }
              disableEditMode() {
                Hu(this, Va, !1);
              }
              isInEditMode() {
                return Vl(this, Va);
              }
              shouldGetKeyboardEvents() {
                return !1;
              }
              needsToBeRebuilt() {
                return this.div && !this.isAttachedToDOM;
              }
              rebuild() {
                this.div?.addEventListener("focusin", Vl(this, ra));
              }
              serialize() {
                (0, Qi.unreachable)("An editor must be serializable");
              }
              static deserialize(eo, rs) {
                const ko = new this.prototype.constructor({
                  parent: rs,
                  id: rs.getNextId()
                });
                ko.rotation = eo.rotation;
                const [Hs, Ks] = rs.pageDimensions, [Ys, Xs, Cs, Fs] = ko.getRectInCurrentCoords(eo.rect, Ks);
                return ko.x = Ys / Hs, ko.y = Xs / Ks, ko.width = Cs / Hs, ko.height = Fs / Ks, ko;
              }
              remove() {
                this.div.removeEventListener("focusin", Vl(this, ra)), this.div.removeEventListener("focusout", Vl(this, na)), this.isEmpty() || this.commit(), this.parent.remove(this);
              }
              select() {
                this.div?.classList.add("selectedEditor");
              }
              unselect() {
                this.div?.classList.remove("selectedEditor");
              }
              updateParams(eo, rs) {
              }
              disableEditing() {
              }
              enableEditing() {
              }
              get propertiesToUpdate() {
                return {};
              }
              get contentDiv() {
                return this.div;
              }
              get isEditing() {
                return Vl(this, Ma);
              }
              set isEditing(eo) {
                Hu(this, Ma, eo), eo ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null);
              }
            };
            ra = new WeakMap(), na = new WeakMap(), la = new WeakMap(), Ma = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), cd(Eo, "_colorManager", new Xi.ColorManager()), cd(Eo, "_zIndex", 1);
            let ta = Eo;
            e.AnnotationEditor = ta;
          },
          /* 7 */
          /***/
          (Bi, e, qi) => {
            var So, eo, rs, ko, Hs, Ks, Cf, Cs, ws, ls, ks, Js, pl, _l, bl, xl, Rl, Cl, Dl, kl, Ul, Bl, Zl, Pl, yl, hl, Of, rf, yd, Ld, Pf, kf, nf, Vd, zd;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.KeyboardManager = e.CommandManager = e.ColorManager = e.AnnotationEditorUIManager = void 0, e.bindEvents = ta, e.opacityToHex = ra;
            var Xi = qi(1), Qi = qi(8);
            function ta(wl, dl, Sl) {
              for (const Ml of Sl)
                dl.addEventListener(Ml, wl[Ml].bind(wl));
            }
            function ra(wl) {
              return Math.round(Math.min(255, Math.max(1, 255 * wl))).toString(16).padStart(2, "0");
            }
            class na {
              constructor() {
                $u(this, So, 0);
              }
              getId() {
                return `${Xi.AnnotationEditorPrefix}${Yd(this, So)._++}`;
              }
            }
            So = new WeakMap();
            class la {
              constructor(dl = 128) {
                $u(this, eo, []);
                $u(this, rs, !1);
                $u(this, ko);
                $u(this, Hs, -1);
                Hu(this, ko, dl);
              }
              add({
                cmd: dl,
                undo: Sl,
                mustExec: Ml,
                type: Fl = NaN,
                overwriteIfSameType: Ll = !1,
                keepUndo: Nl = !1
              }) {
                if (Ml && dl(), Vl(this, rs))
                  return;
                const ql = {
                  cmd: dl,
                  undo: Sl,
                  type: Fl
                };
                if (Vl(this, Hs) === -1) {
                  Vl(this, eo).length > 0 && (Vl(this, eo).length = 0), Hu(this, Hs, 0), Vl(this, eo).push(ql);
                  return;
                }
                if (Ll && Vl(this, eo)[Vl(this, Hs)].type === Fl) {
                  Nl && (ql.undo = Vl(this, eo)[Vl(this, Hs)].undo), Vl(this, eo)[Vl(this, Hs)] = ql;
                  return;
                }
                const Jl = Vl(this, Hs) + 1;
                Jl === Vl(this, ko) ? Vl(this, eo).splice(0, 1) : (Hu(this, Hs, Jl), Jl < Vl(this, eo).length && Vl(this, eo).splice(Jl)), Vl(this, eo).push(ql);
              }
              undo() {
                Vl(this, Hs) !== -1 && (Hu(this, rs, !0), Vl(this, eo)[Vl(this, Hs)].undo(), Hu(this, rs, !1), Hu(this, Hs, Vl(this, Hs) - 1));
              }
              redo() {
                Vl(this, Hs) < Vl(this, eo).length - 1 && (Hu(this, Hs, Vl(this, Hs) + 1), Hu(this, rs, !0), Vl(this, eo)[Vl(this, Hs)].cmd(), Hu(this, rs, !1));
              }
              hasSomethingToUndo() {
                return Vl(this, Hs) !== -1;
              }
              hasSomethingToRedo() {
                return Vl(this, Hs) < Vl(this, eo).length - 1;
              }
              destroy() {
                Hu(this, eo, null);
              }
            }
            eo = new WeakMap(), rs = new WeakMap(), ko = new WeakMap(), Hs = new WeakMap(), e.CommandManager = la;
            const Xs = class Xs {
              constructor(dl) {
                $u(this, Ks);
                this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
                const Sl = Xs.platform.isMac;
                for (const [Ml, Fl] of dl)
                  for (const Ll of Ml) {
                    const Nl = Ll.startsWith("mac+");
                    Sl && Nl ? (this.callbacks.set(Ll.slice(4), Fl), this.allKeys.add(Ll.split("+").at(-1))) : !Sl && !Nl && (this.callbacks.set(Ll, Fl), this.allKeys.add(Ll.split("+").at(-1)));
                  }
              }
              static get platform() {
                const dl = typeof navigator < "u" ? navigator.platform : "";
                return (0, Xi.shadow)(this, "platform", {
                  isWin: dl.includes("Win"),
                  isMac: dl.includes("Mac")
                });
              }
              exec(dl, Sl) {
                if (!this.allKeys.has(Sl.key))
                  return;
                const Ml = this.callbacks.get(rc(this, Ks, Cf).call(this, Sl));
                Ml && (Ml.bind(dl)(), Sl.stopPropagation(), Sl.preventDefault());
              }
            };
            Ks = new WeakSet(), Cf = function(dl) {
              dl.altKey && this.buffer.push("alt"), dl.ctrlKey && this.buffer.push("ctrl"), dl.metaKey && this.buffer.push("meta"), dl.shiftKey && this.buffer.push("shift"), this.buffer.push(dl.key);
              const Sl = this.buffer.join("+");
              return this.buffer.length = 0, Sl;
            };
            let Ma = Xs;
            e.KeyboardManager = Ma;
            class Va {
              constructor() {
                $u(this, Cs, null);
              }
              copy(dl) {
                dl && (Array.isArray(dl) ? Hu(this, Cs, dl.map((Sl) => Sl.serialize())) : Hu(this, Cs, [dl.serialize()]), Hu(this, Cs, Vl(this, Cs).filter((Sl) => !!Sl)), Vl(this, Cs).length === 0 && Hu(this, Cs, null));
              }
              paste() {
                return Vl(this, Cs);
              }
              isEmpty() {
                return Vl(this, Cs) === null;
              }
              destroy() {
                Hu(this, Cs, null);
              }
            }
            Cs = new WeakMap();
            const Fs = class Fs {
              get _colors() {
                const dl = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                return (0, Qi.getColorValues)(dl), (0, Xi.shadow)(this, "_colors", dl);
              }
              convert(dl) {
                const Sl = (0, Qi.getRGB)(dl);
                if (!window.matchMedia("(forced-colors: active)").matches)
                  return Sl;
                for (const [Ml, Fl] of this._colors)
                  if (Fl.every((Ll, Nl) => Ll === Sl[Nl]))
                    return Fs._colorsMapping.get(Ml);
                return Sl;
              }
              getHexCode(dl) {
                const Sl = this._colors.get(dl);
                return Sl ? Xi.Util.makeHexColor(...Sl) : dl;
              }
            };
            cd(Fs, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
            let to = Fs;
            e.ColorManager = to;
            const Ol = class Ol {
              constructor(dl, Sl) {
                $u(this, hl);
                $u(this, ws, null);
                $u(this, ls, /* @__PURE__ */ new Map());
                $u(this, ks, /* @__PURE__ */ new Map());
                $u(this, Js, new Va());
                $u(this, pl, new la());
                $u(this, _l, 0);
                $u(this, bl, null);
                $u(this, xl, null);
                $u(this, Rl, new na());
                $u(this, Cl, !1);
                $u(this, Dl, Xi.AnnotationEditorType.NONE);
                $u(this, kl, /* @__PURE__ */ new Set());
                $u(this, Ul, this.keydown.bind(this));
                $u(this, Bl, this.onEditingAction.bind(this));
                $u(this, Zl, this.onPageChanging.bind(this));
                $u(this, Pl, {
                  isEditing: !1,
                  isEmpty: !0,
                  hasEmptyClipboard: !0,
                  hasSomethingToUndo: !1,
                  hasSomethingToRedo: !1,
                  hasSelectedEditor: !1
                });
                $u(this, yl, null);
                Hu(this, yl, dl), Hu(this, xl, Sl), Vl(this, xl)._on("editingaction", Vl(this, Bl)), Vl(this, xl)._on("pagechanging", Vl(this, Zl));
              }
              destroy() {
                rc(this, hl, rf).call(this), Vl(this, xl)._off("editingaction", Vl(this, Bl)), Vl(this, xl)._off("pagechanging", Vl(this, Zl));
                for (const dl of Vl(this, ks).values())
                  dl.destroy();
                Vl(this, ks).clear(), Vl(this, ls).clear(), Hu(this, ws, null), Vl(this, kl).clear(), Vl(this, Js).destroy(), Vl(this, pl).destroy();
              }
              onPageChanging({
                pageNumber: dl
              }) {
                Hu(this, _l, dl - 1);
              }
              focusMainContainer() {
                Vl(this, yl).focus();
              }
              keydown(dl) {
                this.getActive()?.shouldGetKeyboardEvents() || Ol._keyboardManager.exec(this, dl);
              }
              onEditingAction(dl) {
                ["undo", "redo", "cut", "copy", "paste", "delete", "selectAll"].includes(dl.name) && this[dl.name]();
              }
              setEditingState(dl) {
                dl ? (rc(this, hl, Of).call(this), rc(this, hl, yd).call(this, {
                  isEditing: Vl(this, Dl) !== Xi.AnnotationEditorType.NONE,
                  isEmpty: rc(this, hl, Vd).call(this),
                  hasSomethingToUndo: Vl(this, pl).hasSomethingToUndo(),
                  hasSomethingToRedo: Vl(this, pl).hasSomethingToRedo(),
                  hasSelectedEditor: !1,
                  hasEmptyClipboard: Vl(this, Js).isEmpty()
                })) : (rc(this, hl, rf).call(this), rc(this, hl, yd).call(this, {
                  isEditing: !1
                }));
              }
              registerEditorTypes(dl) {
                Hu(this, bl, dl);
                for (const Sl of Vl(this, bl))
                  rc(this, hl, Ld).call(this, Sl.defaultPropertiesToUpdate);
              }
              getId() {
                return Vl(this, Rl).getId();
              }
              addLayer(dl) {
                Vl(this, ks).set(dl.pageIndex, dl), Vl(this, Cl) ? dl.enable() : dl.disable();
              }
              removeLayer(dl) {
                Vl(this, ks).delete(dl.pageIndex);
              }
              updateMode(dl) {
                if (Hu(this, Dl, dl), dl === Xi.AnnotationEditorType.NONE)
                  this.setEditingState(!1), rc(this, hl, kf).call(this);
                else {
                  this.setEditingState(!0), rc(this, hl, Pf).call(this);
                  for (const Sl of Vl(this, ks).values())
                    Sl.updateMode(dl);
                }
              }
              updateToolbar(dl) {
                dl !== Vl(this, Dl) && Vl(this, xl).dispatch("switchannotationeditormode", {
                  source: this,
                  mode: dl
                });
              }
              updateParams(dl, Sl) {
                for (const Ml of Vl(this, kl))
                  Ml.updateParams(dl, Sl);
                for (const Ml of Vl(this, bl))
                  Ml.updateDefaultParams(dl, Sl);
              }
              getEditors(dl) {
                const Sl = [];
                for (const Ml of Vl(this, ls).values())
                  Ml.pageIndex === dl && Sl.push(Ml);
                return Sl;
              }
              getEditor(dl) {
                return Vl(this, ls).get(dl);
              }
              addEditor(dl) {
                Vl(this, ls).set(dl.id, dl);
              }
              removeEditor(dl) {
                Vl(this, ls).delete(dl.id), this.unselect(dl);
              }
              setActiveEditor(dl) {
                Vl(this, ws) !== dl && (Hu(this, ws, dl), dl && rc(this, hl, Ld).call(this, dl.propertiesToUpdate));
              }
              toggleSelected(dl) {
                if (Vl(this, kl).has(dl)) {
                  Vl(this, kl).delete(dl), dl.unselect(), rc(this, hl, yd).call(this, {
                    hasSelectedEditor: this.hasSelection
                  });
                  return;
                }
                Vl(this, kl).add(dl), dl.select(), rc(this, hl, Ld).call(this, dl.propertiesToUpdate), rc(this, hl, yd).call(this, {
                  hasSelectedEditor: !0
                });
              }
              setSelected(dl) {
                for (const Sl of Vl(this, kl))
                  Sl !== dl && Sl.unselect();
                Vl(this, kl).clear(), Vl(this, kl).add(dl), dl.select(), rc(this, hl, Ld).call(this, dl.propertiesToUpdate), rc(this, hl, yd).call(this, {
                  hasSelectedEditor: !0
                });
              }
              isSelected(dl) {
                return Vl(this, kl).has(dl);
              }
              unselect(dl) {
                dl.unselect(), Vl(this, kl).delete(dl), rc(this, hl, yd).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
              }
              get hasSelection() {
                return Vl(this, kl).size !== 0;
              }
              undo() {
                Vl(this, pl).undo(), rc(this, hl, yd).call(this, {
                  hasSomethingToUndo: Vl(this, pl).hasSomethingToUndo(),
                  hasSomethingToRedo: !0,
                  isEmpty: rc(this, hl, Vd).call(this)
                });
              }
              redo() {
                Vl(this, pl).redo(), rc(this, hl, yd).call(this, {
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: Vl(this, pl).hasSomethingToRedo(),
                  isEmpty: rc(this, hl, Vd).call(this)
                });
              }
              addCommands(dl) {
                Vl(this, pl).add(dl), rc(this, hl, yd).call(this, {
                  hasSomethingToUndo: !0,
                  hasSomethingToRedo: !1,
                  isEmpty: rc(this, hl, Vd).call(this)
                });
              }
              delete() {
                if (Vl(this, ws) && Vl(this, ws).commitOrRemove(), !this.hasSelection)
                  return;
                const dl = [...Vl(this, kl)], Sl = () => {
                  for (const Fl of dl)
                    Fl.remove();
                }, Ml = () => {
                  for (const Fl of dl)
                    rc(this, hl, nf).call(this, Fl);
                };
                this.addCommands({
                  cmd: Sl,
                  undo: Ml,
                  mustExec: !0
                });
              }
              copy() {
                if (Vl(this, ws) && Vl(this, ws).commitOrRemove(), this.hasSelection) {
                  const dl = [];
                  for (const Sl of Vl(this, kl))
                    Sl.isEmpty() || dl.push(Sl);
                  if (dl.length === 0)
                    return;
                  Vl(this, Js).copy(dl), rc(this, hl, yd).call(this, {
                    hasEmptyClipboard: !1
                  });
                }
              }
              cut() {
                this.copy(), this.delete();
              }
              paste() {
                if (Vl(this, Js).isEmpty())
                  return;
                this.unselectAll();
                const dl = Vl(this, ks).get(Vl(this, _l)), Sl = Vl(this, Js).paste().map((Ll) => dl.deserialize(Ll)), Ml = () => {
                  for (const Ll of Sl)
                    rc(this, hl, nf).call(this, Ll);
                  rc(this, hl, zd).call(this, Sl);
                }, Fl = () => {
                  for (const Ll of Sl)
                    Ll.remove();
                };
                this.addCommands({
                  cmd: Ml,
                  undo: Fl,
                  mustExec: !0
                });
              }
              selectAll() {
                for (const dl of Vl(this, kl))
                  dl.commit();
                rc(this, hl, zd).call(this, Vl(this, ls).values());
              }
              unselectAll() {
                if (Vl(this, ws)) {
                  Vl(this, ws).commitOrRemove();
                  return;
                }
                if (rc(this, hl, zd).size !== 0) {
                  for (const dl of Vl(this, kl))
                    dl.unselect();
                  Vl(this, kl).clear(), rc(this, hl, yd).call(this, {
                    hasSelectedEditor: !1
                  });
                }
              }
              isActive(dl) {
                return Vl(this, ws) === dl;
              }
              getActive() {
                return Vl(this, ws);
              }
              getMode() {
                return Vl(this, Dl);
              }
            };
            ws = new WeakMap(), ls = new WeakMap(), ks = new WeakMap(), Js = new WeakMap(), pl = new WeakMap(), _l = new WeakMap(), bl = new WeakMap(), xl = new WeakMap(), Rl = new WeakMap(), Cl = new WeakMap(), Dl = new WeakMap(), kl = new WeakMap(), Ul = new WeakMap(), Bl = new WeakMap(), Zl = new WeakMap(), Pl = new WeakMap(), yl = new WeakMap(), hl = new WeakSet(), Of = function() {
              Vl(this, yl).addEventListener("keydown", Vl(this, Ul));
            }, rf = function() {
              Vl(this, yl).removeEventListener("keydown", Vl(this, Ul));
            }, yd = function(dl) {
              Object.entries(dl).some(([Ml, Fl]) => Vl(this, Pl)[Ml] !== Fl) && Vl(this, xl).dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(Vl(this, Pl), dl)
              });
            }, Ld = function(dl) {
              Vl(this, xl).dispatch("annotationeditorparamschanged", {
                source: this,
                details: dl
              });
            }, Pf = function() {
              if (!Vl(this, Cl)) {
                Hu(this, Cl, !0);
                for (const dl of Vl(this, ks).values())
                  dl.enable();
              }
            }, kf = function() {
              if (this.unselectAll(), Vl(this, Cl)) {
                Hu(this, Cl, !1);
                for (const dl of Vl(this, ks).values())
                  dl.disable();
              }
            }, nf = function(dl) {
              const Sl = Vl(this, ks).get(dl.pageIndex);
              Sl ? Sl.addOrRebuild(dl) : this.addEditor(dl);
            }, Vd = function() {
              if (Vl(this, ls).size === 0)
                return !0;
              if (Vl(this, ls).size === 1)
                for (const dl of Vl(this, ls).values())
                  return dl.isEmpty();
              return !1;
            }, zd = function(dl) {
              Vl(this, kl).clear();
              for (const Sl of dl)
                Sl.isEmpty() || (Vl(this, kl).add(Sl), Sl.select());
              rc(this, hl, yd).call(this, {
                hasSelectedEditor: !0
              });
            }, cd(Ol, "_keyboardManager", new Ma([[["ctrl+a", "mac+meta+a"], Ol.prototype.selectAll], [["ctrl+c", "mac+meta+c"], Ol.prototype.copy], [["ctrl+v", "mac+meta+v"], Ol.prototype.paste], [["ctrl+x", "mac+meta+x"], Ol.prototype.cut], [["ctrl+z", "mac+meta+z"], Ol.prototype.undo], [["ctrl+y", "ctrl+shift+Z", "mac+meta+shift+Z"], Ol.prototype.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete"], Ol.prototype.delete], [["Escape", "mac+Escape"], Ol.prototype.unselectAll]]));
            let Eo = Ol;
            e.AnnotationEditorUIManager = Eo;
          },
          /* 8 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.StatTimer = e.RenderingCancelledException = e.PixelsPerInch = e.PageViewport = e.PDFDateString = e.DOMStandardFontDataFactory = e.DOMSVGFactory = e.DOMCanvasFactory = e.DOMCMapReaderFactory = e.AnnotationPrefix = void 0, e.deprecated = Fs, e.getColorValues = pl, e.getCurrentTransform = _l, e.getCurrentTransformInverse = bl, e.getFilenameFromUrl = Hs, e.getPdfFilenameFromUrl = Ks, e.getRGB = Js, e.getXfaPageViewport = ks, e.isDataScheme = rs, e.isPdfFile = ko, e.isValidFetchUrl = Xs, e.loadScript = Cs;
            var Xi = qi(9), Qi = qi(1);
            const ta = "http://www.w3.org/2000/svg", ra = "pdfjs_internal_id_";
            e.AnnotationPrefix = ra;
            const xl = class xl {
            };
            cd(xl, "CSS", 96), cd(xl, "PDF", 72), cd(xl, "PDF_TO_CSS_UNITS", xl.CSS / xl.PDF);
            let na = xl;
            e.PixelsPerInch = na;
            class la extends Xi.BaseCanvasFactory {
              constructor({
                ownerDocument: Cl = globalThis.document
              } = {}) {
                super(), this._document = Cl;
              }
              _createCanvas(Cl, Dl) {
                const kl = this._document.createElement("canvas");
                return kl.width = Cl, kl.height = Dl, kl;
              }
            }
            e.DOMCanvasFactory = la;
            async function Ma(Rl, Cl = !1) {
              if (Xs(Rl, document.baseURI)) {
                const Dl = await fetch(Rl);
                if (!Dl.ok)
                  throw new Error(Dl.statusText);
                return Cl ? new Uint8Array(await Dl.arrayBuffer()) : (0, Qi.stringToBytes)(await Dl.text());
              }
              return new Promise((Dl, kl) => {
                const Ul = new XMLHttpRequest();
                Ul.open("GET", Rl, !0), Cl && (Ul.responseType = "arraybuffer"), Ul.onreadystatechange = () => {
                  if (Ul.readyState === XMLHttpRequest.DONE) {
                    if (Ul.status === 200 || Ul.status === 0) {
                      let Bl;
                      if (Cl && Ul.response ? Bl = new Uint8Array(Ul.response) : !Cl && Ul.responseText && (Bl = (0, Qi.stringToBytes)(Ul.responseText)), Bl) {
                        Dl(Bl);
                        return;
                      }
                    }
                    kl(new Error(Ul.statusText));
                  }
                }, Ul.send(null);
              });
            }
            class Va extends Xi.BaseCMapReaderFactory {
              _fetchData(Cl, Dl) {
                return Ma(Cl, this.isCompressed).then((kl) => ({
                  cMapData: kl,
                  compressionType: Dl
                }));
              }
            }
            e.DOMCMapReaderFactory = Va;
            class to extends Xi.BaseStandardFontDataFactory {
              _fetchData(Cl) {
                return Ma(Cl, !0);
              }
            }
            e.DOMStandardFontDataFactory = to;
            class Eo extends Xi.BaseSVGFactory {
              _createSVG(Cl) {
                return document.createElementNS(ta, Cl);
              }
            }
            e.DOMSVGFactory = Eo;
            class So {
              constructor({
                viewBox: Cl,
                scale: Dl,
                rotation: kl,
                offsetX: Ul = 0,
                offsetY: Bl = 0,
                dontFlip: Zl = !1
              }) {
                this.viewBox = Cl, this.scale = Dl, this.rotation = kl, this.offsetX = Ul, this.offsetY = Bl;
                const Pl = (Cl[2] + Cl[0]) / 2, yl = (Cl[3] + Cl[1]) / 2;
                let hl, Tl, Il, jl;
                switch (kl %= 360, kl < 0 && (kl += 360), kl) {
                  case 180:
                    hl = -1, Tl = 0, Il = 0, jl = 1;
                    break;
                  case 90:
                    hl = 0, Tl = 1, Il = 1, jl = 0;
                    break;
                  case 270:
                    hl = 0, Tl = -1, Il = -1, jl = 0;
                    break;
                  case 0:
                    hl = 1, Tl = 0, Il = 0, jl = -1;
                    break;
                  default:
                    throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                }
                Zl && (Il = -Il, jl = -jl);
                let Al, _s, Gs, vl;
                hl === 0 ? (Al = Math.abs(yl - Cl[1]) * Dl + Ul, _s = Math.abs(Pl - Cl[0]) * Dl + Bl, Gs = Math.abs(Cl[3] - Cl[1]) * Dl, vl = Math.abs(Cl[2] - Cl[0]) * Dl) : (Al = Math.abs(Pl - Cl[0]) * Dl + Ul, _s = Math.abs(yl - Cl[1]) * Dl + Bl, Gs = Math.abs(Cl[2] - Cl[0]) * Dl, vl = Math.abs(Cl[3] - Cl[1]) * Dl), this.transform = [hl * Dl, Tl * Dl, Il * Dl, jl * Dl, Al - hl * Dl * Pl - Il * Dl * yl, _s - Tl * Dl * Pl - jl * Dl * yl], this.width = Gs, this.height = vl;
              }
              clone({
                scale: Cl = this.scale,
                rotation: Dl = this.rotation,
                offsetX: kl = this.offsetX,
                offsetY: Ul = this.offsetY,
                dontFlip: Bl = !1
              } = {}) {
                return new So({
                  viewBox: this.viewBox.slice(),
                  scale: Cl,
                  rotation: Dl,
                  offsetX: kl,
                  offsetY: Ul,
                  dontFlip: Bl
                });
              }
              convertToViewportPoint(Cl, Dl) {
                return Qi.Util.applyTransform([Cl, Dl], this.transform);
              }
              convertToViewportRectangle(Cl) {
                const Dl = Qi.Util.applyTransform([Cl[0], Cl[1]], this.transform), kl = Qi.Util.applyTransform([Cl[2], Cl[3]], this.transform);
                return [Dl[0], Dl[1], kl[0], kl[1]];
              }
              convertToPdfPoint(Cl, Dl) {
                return Qi.Util.applyInverseTransform([Cl, Dl], this.transform);
              }
            }
            e.PageViewport = So;
            class eo extends Qi.BaseException {
              constructor(Cl, Dl) {
                super(Cl, "RenderingCancelledException"), this.type = Dl;
              }
            }
            e.RenderingCancelledException = eo;
            function rs(Rl) {
              const Cl = Rl.length;
              let Dl = 0;
              for (; Dl < Cl && Rl[Dl].trim() === ""; )
                Dl++;
              return Rl.substring(Dl, Dl + 5).toLowerCase() === "data:";
            }
            function ko(Rl) {
              return typeof Rl == "string" && /\.pdf$/i.test(Rl);
            }
            function Hs(Rl) {
              const Cl = Rl.indexOf("#"), Dl = Rl.indexOf("?"), kl = Math.min(Cl > 0 ? Cl : Rl.length, Dl > 0 ? Dl : Rl.length);
              return Rl.substring(Rl.lastIndexOf("/", kl) + 1, kl);
            }
            function Ks(Rl, Cl = "document.pdf") {
              if (typeof Rl != "string")
                return Cl;
              if (rs(Rl))
                return (0, Qi.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), Cl;
              const Dl = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, kl = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, Ul = Dl.exec(Rl);
              let Bl = kl.exec(Ul[1]) || kl.exec(Ul[2]) || kl.exec(Ul[3]);
              if (Bl && (Bl = Bl[0], Bl.includes("%")))
                try {
                  Bl = kl.exec(decodeURIComponent(Bl))[0];
                } catch {
                }
              return Bl || Cl;
            }
            class Ys {
              constructor() {
                this.started = /* @__PURE__ */ Object.create(null), this.times = [];
              }
              time(Cl) {
                Cl in this.started && (0, Qi.warn)(`Timer is already running for ${Cl}`), this.started[Cl] = Date.now();
              }
              timeEnd(Cl) {
                Cl in this.started || (0, Qi.warn)(`Timer has not been started for ${Cl}`), this.times.push({
                  name: Cl,
                  start: this.started[Cl],
                  end: Date.now()
                }), delete this.started[Cl];
              }
              toString() {
                const Cl = [];
                let Dl = 0;
                for (const kl of this.times) {
                  const Ul = kl.name;
                  Ul.length > Dl && (Dl = Ul.length);
                }
                for (const kl of this.times) {
                  const Ul = kl.end - kl.start;
                  Cl.push(`${kl.name.padEnd(Dl)} ${Ul}ms
`);
                }
                return Cl.join("");
              }
            }
            e.StatTimer = Ys;
            function Xs(Rl, Cl) {
              try {
                const {
                  protocol: Dl
                } = Cl ? new URL(Rl, Cl) : new URL(Rl);
                return Dl === "http:" || Dl === "https:";
              } catch {
                return !1;
              }
            }
            function Cs(Rl, Cl = !1) {
              return new Promise((Dl, kl) => {
                const Ul = document.createElement("script");
                Ul.src = Rl, Ul.onload = function(Bl) {
                  Cl && Ul.remove(), Dl(Bl);
                }, Ul.onerror = function() {
                  kl(new Error(`Cannot load script at: ${Ul.src}`));
                }, (document.head || document.documentElement).append(Ul);
              });
            }
            function Fs(Rl) {
              console.log("Deprecated API usage: " + Rl);
            }
            let ws;
            class ls {
              static toDateObject(Cl) {
                if (!Cl || typeof Cl != "string")
                  return null;
                ws || (ws = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                const Dl = ws.exec(Cl);
                if (!Dl)
                  return null;
                const kl = parseInt(Dl[1], 10);
                let Ul = parseInt(Dl[2], 10);
                Ul = Ul >= 1 && Ul <= 12 ? Ul - 1 : 0;
                let Bl = parseInt(Dl[3], 10);
                Bl = Bl >= 1 && Bl <= 31 ? Bl : 1;
                let Zl = parseInt(Dl[4], 10);
                Zl = Zl >= 0 && Zl <= 23 ? Zl : 0;
                let Pl = parseInt(Dl[5], 10);
                Pl = Pl >= 0 && Pl <= 59 ? Pl : 0;
                let yl = parseInt(Dl[6], 10);
                yl = yl >= 0 && yl <= 59 ? yl : 0;
                const hl = Dl[7] || "Z";
                let Tl = parseInt(Dl[8], 10);
                Tl = Tl >= 0 && Tl <= 23 ? Tl : 0;
                let Il = parseInt(Dl[9], 10) || 0;
                return Il = Il >= 0 && Il <= 59 ? Il : 0, hl === "-" ? (Zl += Tl, Pl += Il) : hl === "+" && (Zl -= Tl, Pl -= Il), new Date(Date.UTC(kl, Ul, Bl, Zl, Pl, yl));
              }
            }
            e.PDFDateString = ls;
            function ks(Rl, {
              scale: Cl = 1,
              rotation: Dl = 0
            }) {
              const {
                width: kl,
                height: Ul
              } = Rl.attributes.style, Bl = [0, 0, parseInt(kl), parseInt(Ul)];
              return new So({
                viewBox: Bl,
                scale: Cl,
                rotation: Dl
              });
            }
            function Js(Rl) {
              if (Rl.startsWith("#")) {
                const Cl = parseInt(Rl.slice(1), 16);
                return [(Cl & 16711680) >> 16, (Cl & 65280) >> 8, Cl & 255];
              }
              return Rl.startsWith("rgb(") ? Rl.slice(4, -1).split(",").map((Cl) => parseInt(Cl)) : Rl.startsWith("rgba(") ? Rl.slice(5, -1).split(",").map((Cl) => parseInt(Cl)).slice(0, 3) : ((0, Qi.warn)(`Not a valid color format: "${Rl}"`), [0, 0, 0]);
            }
            function pl(Rl) {
              const Cl = document.createElement("span");
              Cl.style.visibility = "hidden", document.body.append(Cl);
              for (const Dl of Rl.keys()) {
                Cl.style.color = Dl;
                const kl = window.getComputedStyle(Cl).color;
                Rl.set(Dl, Js(kl));
              }
              Cl.remove();
            }
            function _l(Rl) {
              const {
                a: Cl,
                b: Dl,
                c: kl,
                d: Ul,
                e: Bl,
                f: Zl
              } = Rl.getTransform();
              return [Cl, Dl, kl, Ul, Bl, Zl];
            }
            function bl(Rl) {
              const {
                a: Cl,
                b: Dl,
                c: kl,
                d: Ul,
                e: Bl,
                f: Zl
              } = Rl.getTransform().invertSelf();
              return [Cl, Dl, kl, Ul, Bl, Zl];
            }
          },
          /* 9 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.BaseStandardFontDataFactory = e.BaseSVGFactory = e.BaseCanvasFactory = e.BaseCMapReaderFactory = void 0;
            var Xi = qi(1);
            class Qi {
              constructor() {
                this.constructor === Qi && (0, Xi.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
              create(Ma, Va) {
                if (Ma <= 0 || Va <= 0)
                  throw new Error("Invalid canvas size");
                const to = this._createCanvas(Ma, Va);
                return {
                  canvas: to,
                  context: to.getContext("2d")
                };
              }
              reset(Ma, Va, to) {
                if (!Ma.canvas)
                  throw new Error("Canvas is not specified");
                if (Va <= 0 || to <= 0)
                  throw new Error("Invalid canvas size");
                Ma.canvas.width = Va, Ma.canvas.height = to;
              }
              destroy(Ma) {
                if (!Ma.canvas)
                  throw new Error("Canvas is not specified");
                Ma.canvas.width = 0, Ma.canvas.height = 0, Ma.canvas = null, Ma.context = null;
              }
              _createCanvas(Ma, Va) {
                (0, Xi.unreachable)("Abstract method `_createCanvas` called.");
              }
            }
            e.BaseCanvasFactory = Qi;
            class ta {
              constructor({
                baseUrl: Ma = null,
                isCompressed: Va = !1
              }) {
                this.constructor === ta && (0, Xi.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = Ma, this.isCompressed = Va;
              }
              async fetch({
                name: Ma
              }) {
                if (!this.baseUrl)
                  throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                if (!Ma)
                  throw new Error("CMap name must be specified.");
                const Va = this.baseUrl + Ma + (this.isCompressed ? ".bcmap" : ""), to = this.isCompressed ? Xi.CMapCompressionType.BINARY : Xi.CMapCompressionType.NONE;
                return this._fetchData(Va, to).catch((Eo) => {
                  throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${Va}`);
                });
              }
              _fetchData(Ma, Va) {
                (0, Xi.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            e.BaseCMapReaderFactory = ta;
            class ra {
              constructor({
                baseUrl: Ma = null
              }) {
                this.constructor === ra && (0, Xi.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = Ma;
              }
              async fetch({
                filename: Ma
              }) {
                if (!this.baseUrl)
                  throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                if (!Ma)
                  throw new Error("Font filename must be specified.");
                const Va = `${this.baseUrl}${Ma}`;
                return this._fetchData(Va).catch((to) => {
                  throw new Error(`Unable to load font data at: ${Va}`);
                });
              }
              _fetchData(Ma) {
                (0, Xi.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            e.BaseStandardFontDataFactory = ra;
            class na {
              constructor() {
                this.constructor === na && (0, Xi.unreachable)("Cannot initialize BaseSVGFactory.");
              }
              create(Ma, Va, to = !1) {
                if (Ma <= 0 || Va <= 0)
                  throw new Error("Invalid SVG dimensions");
                const Eo = this._createSVG("svg:svg");
                return Eo.setAttribute("version", "1.1"), to || (Eo.setAttribute("width", `${Ma}px`), Eo.setAttribute("height", `${Va}px`)), Eo.setAttribute("preserveAspectRatio", "none"), Eo.setAttribute("viewBox", `0 0 ${Ma} ${Va}`), Eo;
              }
              createElement(Ma) {
                if (typeof Ma != "string")
                  throw new Error("Invalid SVG element type");
                return this._createSVG(Ma);
              }
              _createSVG(Ma) {
                (0, Xi.unreachable)("Abstract method `_createSVG` called.");
              }
            }
            e.BaseSVGFactory = na;
          },
          /* 10 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.MurmurHash3_64 = void 0;
            var Xi = qi(1);
            const Qi = 3285377520, ta = 4294901760, ra = 65535;
            class na {
              constructor(Ma) {
                this.h1 = Ma ? Ma & 4294967295 : Qi, this.h2 = Ma ? Ma & 4294967295 : Qi;
              }
              update(Ma) {
                let Va, to;
                if (typeof Ma == "string") {
                  Va = new Uint8Array(Ma.length * 2), to = 0;
                  for (let ws = 0, ls = Ma.length; ws < ls; ws++) {
                    const ks = Ma.charCodeAt(ws);
                    ks <= 255 ? Va[to++] = ks : (Va[to++] = ks >>> 8, Va[to++] = ks & 255);
                  }
                } else if ((0, Xi.isArrayBuffer)(Ma))
                  Va = Ma.slice(), to = Va.byteLength;
                else
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                const Eo = to >> 2, So = to - Eo * 4, eo = new Uint32Array(Va.buffer, 0, Eo);
                let rs = 0, ko = 0, Hs = this.h1, Ks = this.h2;
                const Ys = 3432918353, Xs = 461845907, Cs = Ys & ra, Fs = Xs & ra;
                for (let ws = 0; ws < Eo; ws++)
                  ws & 1 ? (rs = eo[ws], rs = rs * Ys & ta | rs * Cs & ra, rs = rs << 15 | rs >>> 17, rs = rs * Xs & ta | rs * Fs & ra, Hs ^= rs, Hs = Hs << 13 | Hs >>> 19, Hs = Hs * 5 + 3864292196) : (ko = eo[ws], ko = ko * Ys & ta | ko * Cs & ra, ko = ko << 15 | ko >>> 17, ko = ko * Xs & ta | ko * Fs & ra, Ks ^= ko, Ks = Ks << 13 | Ks >>> 19, Ks = Ks * 5 + 3864292196);
                switch (rs = 0, So) {
                  case 3:
                    rs ^= Va[Eo * 4 + 2] << 16;
                  case 2:
                    rs ^= Va[Eo * 4 + 1] << 8;
                  case 1:
                    rs ^= Va[Eo * 4], rs = rs * Ys & ta | rs * Cs & ra, rs = rs << 15 | rs >>> 17, rs = rs * Xs & ta | rs * Fs & ra, Eo & 1 ? Hs ^= rs : Ks ^= rs;
                }
                this.h1 = Hs, this.h2 = Ks;
              }
              hexdigest() {
                let Ma = this.h1, Va = this.h2;
                Ma ^= Va >>> 1, Ma = Ma * 3981806797 & ta | Ma * 36045 & ra, Va = Va * 4283543511 & ta | ((Va << 16 | Ma >>> 16) * 2950163797 & ta) >>> 16, Ma ^= Va >>> 1, Ma = Ma * 444984403 & ta | Ma * 60499 & ra, Va = Va * 3301882366 & ta | ((Va << 16 | Ma >>> 16) * 3120437893 & ta) >>> 16, Ma ^= Va >>> 1;
                const to = (Ma >>> 0).toString(16), Eo = (Va >>> 0).toString(16);
                return to.padStart(8, "0") + Eo.padStart(8, "0");
              }
            }
            e.MurmurHash3_64 = na;
          },
          /* 11 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.FontLoader = e.FontFaceObject = void 0;
            var Xi = qi(1);
            class Qi {
              constructor({
                docId: la,
                onUnsupportedFeature: Ma,
                ownerDocument: Va = globalThis.document,
                styleElement: to = null
              }) {
                this.constructor === Qi && (0, Xi.unreachable)("Cannot initialize BaseFontLoader."), this.docId = la, this._onUnsupportedFeature = Ma, this._document = Va, this.nativeFontFaces = [], this.styleElement = null;
              }
              addNativeFontFace(la) {
                this.nativeFontFaces.push(la), this._document.fonts.add(la);
              }
              insertRule(la) {
                let Ma = this.styleElement;
                Ma || (Ma = this.styleElement = this._document.createElement("style"), Ma.id = `PDFJS_FONT_STYLE_TAG_${this.docId}`, this._document.documentElement.getElementsByTagName("head")[0].append(Ma));
                const Va = Ma.sheet;
                Va.insertRule(la, Va.cssRules.length);
              }
              clear() {
                for (const la of this.nativeFontFaces)
                  this._document.fonts.delete(la);
                this.nativeFontFaces.length = 0, this.styleElement && (this.styleElement.remove(), this.styleElement = null);
              }
              async bind(la) {
                if (la.attached || la.missingFile)
                  return;
                if (la.attached = !0, this.isFontLoadingAPISupported) {
                  const Va = la.createNativeFontFace();
                  if (Va) {
                    this.addNativeFontFace(Va);
                    try {
                      await Va.loaded;
                    } catch (to) {
                      throw this._onUnsupportedFeature({
                        featureId: Xi.UNSUPPORTED_FEATURES.errorFontLoadNative
                      }), (0, Xi.warn)(`Failed to load font '${Va.family}': '${to}'.`), la.disableFontFace = !0, to;
                    }
                  }
                  return;
                }
                const Ma = la.createFontFaceRule();
                if (Ma) {
                  if (this.insertRule(Ma), this.isSyncFontLoadingSupported)
                    return;
                  await new Promise((Va) => {
                    const to = this._queueLoadingCallback(Va);
                    this._prepareFontLoadEvent([Ma], [la], to);
                  });
                }
              }
              _queueLoadingCallback(la) {
                (0, Xi.unreachable)("Abstract method `_queueLoadingCallback`.");
              }
              get isFontLoadingAPISupported() {
                const la = !!this._document?.fonts;
                return (0, Xi.shadow)(this, "isFontLoadingAPISupported", la);
              }
              get isSyncFontLoadingSupported() {
                (0, Xi.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
              }
              get _loadTestFont() {
                (0, Xi.unreachable)("Abstract method `_loadTestFont`.");
              }
              _prepareFontLoadEvent(la, Ma, Va) {
                (0, Xi.unreachable)("Abstract method `_prepareFontLoadEvent`.");
              }
            }
            let ta;
            e.FontLoader = ta, e.FontLoader = ta = class extends Qi {
              constructor(la) {
                super(la), this.loadingContext = {
                  requests: [],
                  nextRequestId: 0
                }, this.loadTestFontId = 0;
              }
              get isSyncFontLoadingSupported() {
                let la = !1;
                return (typeof navigator > "u" || /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent)?.[1] >= 14) && (la = !0), (0, Xi.shadow)(this, "isSyncFontLoadingSupported", la);
              }
              _queueLoadingCallback(la) {
                function Ma() {
                  for ((0, Xi.assert)(!to.done, "completeRequest() cannot be called twice."), to.done = !0; Va.requests.length > 0 && Va.requests[0].done; ) {
                    const Eo = Va.requests.shift();
                    setTimeout(Eo.callback, 0);
                  }
                }
                const Va = this.loadingContext, to = {
                  id: `pdfjs-font-loading-${Va.nextRequestId++}`,
                  done: !1,
                  complete: Ma,
                  callback: la
                };
                return Va.requests.push(to), to;
              }
              get _loadTestFont() {
                const la = function() {
                  return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                };
                return (0, Xi.shadow)(this, "_loadTestFont", la());
              }
              _prepareFontLoadEvent(la, Ma, Va) {
                function to(bl, xl) {
                  return bl.charCodeAt(xl) << 24 | bl.charCodeAt(xl + 1) << 16 | bl.charCodeAt(xl + 2) << 8 | bl.charCodeAt(xl + 3) & 255;
                }
                function Eo(bl, xl, Rl, Cl) {
                  const Dl = bl.substring(0, xl), kl = bl.substring(xl + Rl);
                  return Dl + Cl + kl;
                }
                let So, eo;
                const rs = this._document.createElement("canvas");
                rs.width = 1, rs.height = 1;
                const ko = rs.getContext("2d");
                let Hs = 0;
                function Ks(bl, xl) {
                  if (Hs++, Hs > 30) {
                    (0, Xi.warn)("Load test font never loaded."), xl();
                    return;
                  }
                  if (ko.font = "30px " + bl, ko.fillText(".", 0, 20), ko.getImageData(0, 0, 1, 1).data[3] > 0) {
                    xl();
                    return;
                  }
                  setTimeout(Ks.bind(null, bl, xl));
                }
                const Ys = `lt${Date.now()}${this.loadTestFontId++}`;
                let Xs = this._loadTestFont;
                Xs = Eo(Xs, 976, Ys.length, Ys);
                const Fs = 16, ws = 1482184792;
                let ls = to(Xs, Fs);
                for (So = 0, eo = Ys.length - 3; So < eo; So += 4)
                  ls = ls - ws + to(Ys, So) | 0;
                So < Ys.length && (ls = ls - ws + to(Ys + "XXX", So) | 0), Xs = Eo(Xs, Fs, 4, (0, Xi.string32)(ls));
                const ks = `url(data:font/opentype;base64,${btoa(Xs)});`, Js = `@font-face {font-family:"${Ys}";src:${ks}}`;
                this.insertRule(Js);
                const pl = [];
                for (const bl of Ma)
                  pl.push(bl.loadedName);
                pl.push(Ys);
                const _l = this._document.createElement("div");
                _l.style.visibility = "hidden", _l.style.width = _l.style.height = "10px", _l.style.position = "absolute", _l.style.top = _l.style.left = "0px";
                for (const bl of pl) {
                  const xl = this._document.createElement("span");
                  xl.textContent = "Hi", xl.style.fontFamily = bl, _l.append(xl);
                }
                this._document.body.append(_l), Ks(Ys, () => {
                  _l.remove(), Va.complete();
                });
              }
            };
            class ra {
              constructor(la, {
                isEvalSupported: Ma = !0,
                disableFontFace: Va = !1,
                ignoreErrors: to = !1,
                onUnsupportedFeature: Eo,
                fontRegistry: So = null
              }) {
                this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                for (const eo in la)
                  this[eo] = la[eo];
                this.isEvalSupported = Ma !== !1, this.disableFontFace = Va === !0, this.ignoreErrors = to === !0, this._onUnsupportedFeature = Eo, this.fontRegistry = So;
              }
              createNativeFontFace() {
                if (!this.data || this.disableFontFace)
                  return null;
                let la;
                if (!this.cssFontInfo)
                  la = new FontFace(this.loadedName, this.data, {});
                else {
                  const Ma = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  this.cssFontInfo.italicAngle && (Ma.style = `oblique ${this.cssFontInfo.italicAngle}deg`), la = new FontFace(this.cssFontInfo.fontFamily, this.data, Ma);
                }
                return this.fontRegistry && this.fontRegistry.registerFont(this), la;
              }
              createFontFaceRule() {
                if (!this.data || this.disableFontFace)
                  return null;
                const la = (0, Xi.bytesToString)(this.data), Ma = `url(data:${this.mimetype};base64,${btoa(la)});`;
                let Va;
                if (!this.cssFontInfo)
                  Va = `@font-face {font-family:"${this.loadedName}";src:${Ma}}`;
                else {
                  let to = `font-weight: ${this.cssFontInfo.fontWeight};`;
                  this.cssFontInfo.italicAngle && (to += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), Va = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${to}src:${Ma}}`;
                }
                return this.fontRegistry && this.fontRegistry.registerFont(this, Ma), Va;
              }
              getPathGenerator(la, Ma) {
                if (this.compiledGlyphs[Ma] !== void 0)
                  return this.compiledGlyphs[Ma];
                let Va;
                try {
                  Va = la.get(this.loadedName + "_path_" + Ma);
                } catch (to) {
                  if (!this.ignoreErrors)
                    throw to;
                  return this._onUnsupportedFeature({
                    featureId: Xi.UNSUPPORTED_FEATURES.errorFontGetPath
                  }), (0, Xi.warn)(`getPathGenerator - ignoring character: "${to}".`), this.compiledGlyphs[Ma] = function(Eo, So) {
                  };
                }
                if (this.isEvalSupported && Xi.FeatureTest.isEvalSupported) {
                  const to = [];
                  for (const Eo of Va) {
                    const So = Eo.args !== void 0 ? Eo.args.join(",") : "";
                    to.push("c.", Eo.cmd, "(", So, `);
`);
                  }
                  return this.compiledGlyphs[Ma] = new Function("c", "size", to.join(""));
                }
                return this.compiledGlyphs[Ma] = function(to, Eo) {
                  for (const So of Va)
                    So.cmd === "scale" && (So.args = [Eo, -Eo]), to[So.cmd].apply(to, So.args);
                };
              }
            }
            e.FontFaceObject = ra;
          },
          /* 12 */
          /***/
          (Bi, e, qi) => {
            var Ul, af;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.CanvasGraphics = void 0;
            var Xi = qi(8), Qi = qi(1), ta = qi(13), ra = qi(14), na = qi(3);
            const la = 16, Ma = 100, Va = 4096, to = 15, Eo = 10, So = na.isNodeJS && typeof Path2D > "u" ? -1 : 1e3, eo = 16;
            function rs(Pl, yl) {
              if (Pl._removeMirroring)
                throw new Error("Context is already forwarding operations.");
              Pl.__originalSave = Pl.save, Pl.__originalRestore = Pl.restore, Pl.__originalRotate = Pl.rotate, Pl.__originalScale = Pl.scale, Pl.__originalTranslate = Pl.translate, Pl.__originalTransform = Pl.transform, Pl.__originalSetTransform = Pl.setTransform, Pl.__originalResetTransform = Pl.resetTransform, Pl.__originalClip = Pl.clip, Pl.__originalMoveTo = Pl.moveTo, Pl.__originalLineTo = Pl.lineTo, Pl.__originalBezierCurveTo = Pl.bezierCurveTo, Pl.__originalRect = Pl.rect, Pl.__originalClosePath = Pl.closePath, Pl.__originalBeginPath = Pl.beginPath, Pl._removeMirroring = () => {
                Pl.save = Pl.__originalSave, Pl.restore = Pl.__originalRestore, Pl.rotate = Pl.__originalRotate, Pl.scale = Pl.__originalScale, Pl.translate = Pl.__originalTranslate, Pl.transform = Pl.__originalTransform, Pl.setTransform = Pl.__originalSetTransform, Pl.resetTransform = Pl.__originalResetTransform, Pl.clip = Pl.__originalClip, Pl.moveTo = Pl.__originalMoveTo, Pl.lineTo = Pl.__originalLineTo, Pl.bezierCurveTo = Pl.__originalBezierCurveTo, Pl.rect = Pl.__originalRect, Pl.closePath = Pl.__originalClosePath, Pl.beginPath = Pl.__originalBeginPath, delete Pl._removeMirroring;
              }, Pl.save = function() {
                yl.save(), this.__originalSave();
              }, Pl.restore = function() {
                yl.restore(), this.__originalRestore();
              }, Pl.translate = function(Tl, Il) {
                yl.translate(Tl, Il), this.__originalTranslate(Tl, Il);
              }, Pl.scale = function(Tl, Il) {
                yl.scale(Tl, Il), this.__originalScale(Tl, Il);
              }, Pl.transform = function(Tl, Il, jl, Al, _s, Gs) {
                yl.transform(Tl, Il, jl, Al, _s, Gs), this.__originalTransform(Tl, Il, jl, Al, _s, Gs);
              }, Pl.setTransform = function(Tl, Il, jl, Al, _s, Gs) {
                yl.setTransform(Tl, Il, jl, Al, _s, Gs), this.__originalSetTransform(Tl, Il, jl, Al, _s, Gs);
              }, Pl.resetTransform = function() {
                yl.resetTransform(), this.__originalResetTransform();
              }, Pl.rotate = function(Tl) {
                yl.rotate(Tl), this.__originalRotate(Tl);
              }, Pl.clip = function(Tl) {
                yl.clip(Tl), this.__originalClip(Tl);
              }, Pl.moveTo = function(hl, Tl) {
                yl.moveTo(hl, Tl), this.__originalMoveTo(hl, Tl);
              }, Pl.lineTo = function(hl, Tl) {
                yl.lineTo(hl, Tl), this.__originalLineTo(hl, Tl);
              }, Pl.bezierCurveTo = function(hl, Tl, Il, jl, Al, _s) {
                yl.bezierCurveTo(hl, Tl, Il, jl, Al, _s), this.__originalBezierCurveTo(hl, Tl, Il, jl, Al, _s);
              }, Pl.rect = function(hl, Tl, Il, jl) {
                yl.rect(hl, Tl, Il, jl), this.__originalRect(hl, Tl, Il, jl);
              }, Pl.closePath = function() {
                yl.closePath(), this.__originalClosePath();
              }, Pl.beginPath = function() {
                yl.beginPath(), this.__originalBeginPath();
              };
            }
            class ko {
              constructor(yl) {
                this.canvasFactory = yl, this.cache = /* @__PURE__ */ Object.create(null);
              }
              getCanvas(yl, hl, Tl) {
                let Il;
                return this.cache[yl] !== void 0 ? (Il = this.cache[yl], this.canvasFactory.reset(Il, hl, Tl)) : (Il = this.canvasFactory.create(hl, Tl), this.cache[yl] = Il), Il;
              }
              delete(yl) {
                delete this.cache[yl];
              }
              clear() {
                for (const yl in this.cache) {
                  const hl = this.cache[yl];
                  this.canvasFactory.destroy(hl), delete this.cache[yl];
                }
              }
            }
            function Hs(Pl, yl, hl, Tl, Il, jl, Al, _s, Gs, vl) {
              const [gl, El, Ol, wl, dl, Sl] = (0, Xi.getCurrentTransform)(Pl);
              if (El === 0 && Ol === 0) {
                const Ll = Al * gl + dl, Nl = Math.round(Ll), ql = _s * wl + Sl, Jl = Math.round(ql), zl = (Al + Gs) * gl + dl, tc = Math.abs(Math.round(zl) - Nl) || 1, Ku = (_s + vl) * wl + Sl, tu = Math.abs(Math.round(Ku) - Jl) || 1;
                return Pl.setTransform(Math.sign(gl), 0, 0, Math.sign(wl), Nl, Jl), Pl.drawImage(yl, hl, Tl, Il, jl, 0, 0, tc, tu), Pl.setTransform(gl, El, Ol, wl, dl, Sl), [tc, tu];
              }
              if (gl === 0 && wl === 0) {
                const Ll = _s * Ol + dl, Nl = Math.round(Ll), ql = Al * El + Sl, Jl = Math.round(ql), zl = (_s + vl) * Ol + dl, tc = Math.abs(Math.round(zl) - Nl) || 1, Ku = (Al + Gs) * El + Sl, tu = Math.abs(Math.round(Ku) - Jl) || 1;
                return Pl.setTransform(0, Math.sign(El), Math.sign(Ol), 0, Nl, Jl), Pl.drawImage(yl, hl, Tl, Il, jl, 0, 0, tu, tc), Pl.setTransform(gl, El, Ol, wl, dl, Sl), [tu, tc];
              }
              Pl.drawImage(yl, hl, Tl, Il, jl, Al, _s, Gs, vl);
              const Ml = Math.hypot(gl, El), Fl = Math.hypot(Ol, wl);
              return [Ml * Gs, Fl * vl];
            }
            function Ks(Pl) {
              const {
                width: yl,
                height: hl
              } = Pl;
              if (yl > So || hl > So)
                return null;
              const Tl = 1e3, Il = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), jl = yl + 1;
              let Al = new Uint8Array(jl * (hl + 1)), _s, Gs, vl;
              const gl = yl + 7 & -8;
              let El = new Uint8Array(gl * hl), Ol = 0;
              for (const Fl of Pl.data) {
                let Ll = 128;
                for (; Ll > 0; )
                  El[Ol++] = Fl & Ll ? 0 : 255, Ll >>= 1;
              }
              let wl = 0;
              for (Ol = 0, El[Ol] !== 0 && (Al[0] = 1, ++wl), Gs = 1; Gs < yl; Gs++)
                El[Ol] !== El[Ol + 1] && (Al[Gs] = El[Ol] ? 2 : 1, ++wl), Ol++;
              for (El[Ol] !== 0 && (Al[Gs] = 2, ++wl), _s = 1; _s < hl; _s++) {
                Ol = _s * gl, vl = _s * jl, El[Ol - gl] !== El[Ol] && (Al[vl] = El[Ol] ? 1 : 8, ++wl);
                let Fl = (El[Ol] ? 4 : 0) + (El[Ol - gl] ? 8 : 0);
                for (Gs = 1; Gs < yl; Gs++)
                  Fl = (Fl >> 2) + (El[Ol + 1] ? 4 : 0) + (El[Ol - gl + 1] ? 8 : 0), Il[Fl] && (Al[vl + Gs] = Il[Fl], ++wl), Ol++;
                if (El[Ol - gl] !== El[Ol] && (Al[vl + Gs] = El[Ol] ? 2 : 4, ++wl), wl > Tl)
                  return null;
              }
              for (Ol = gl * (hl - 1), vl = _s * jl, El[Ol] !== 0 && (Al[vl] = 8, ++wl), Gs = 1; Gs < yl; Gs++)
                El[Ol] !== El[Ol + 1] && (Al[vl + Gs] = El[Ol] ? 4 : 8, ++wl), Ol++;
              if (El[Ol] !== 0 && (Al[vl + Gs] = 4, ++wl), wl > Tl)
                return null;
              const dl = new Int32Array([0, jl, -1, 0, -jl, 0, 0, 0, 1]), Sl = new Path2D();
              for (_s = 0; wl && _s <= hl; _s++) {
                let Fl = _s * jl;
                const Ll = Fl + yl;
                for (; Fl < Ll && !Al[Fl]; )
                  Fl++;
                if (Fl === Ll)
                  continue;
                Sl.moveTo(Fl % jl, _s);
                const Nl = Fl;
                let ql = Al[Fl];
                do {
                  const Jl = dl[ql];
                  do
                    Fl += Jl;
                  while (!Al[Fl]);
                  const zl = Al[Fl];
                  zl !== 5 && zl !== 10 ? (ql = zl, Al[Fl] = 0) : (ql = zl & 51 * ql >> 4, Al[Fl] &= ql >> 2 | ql << 2), Sl.lineTo(Fl % jl, Fl / jl | 0), Al[Fl] || --wl;
                } while (Nl !== Fl);
                --_s;
              }
              return El = null, Al = null, function(Fl) {
                Fl.save(), Fl.scale(1 / yl, -1 / hl), Fl.translate(0, -hl), Fl.fill(Sl), Fl.beginPath(), Fl.restore();
              };
            }
            class Ys {
              constructor(yl, hl) {
                this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = Qi.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = Qi.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = Qi.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = null, this.startNewPathAndClipBox([0, 0, yl, hl]);
              }
              clone() {
                const yl = Object.create(this);
                return yl.clipBox = this.clipBox.slice(), yl;
              }
              setCurrentPoint(yl, hl) {
                this.x = yl, this.y = hl;
              }
              updatePathMinMax(yl, hl, Tl) {
                [hl, Tl] = Qi.Util.applyTransform([hl, Tl], yl), this.minX = Math.min(this.minX, hl), this.minY = Math.min(this.minY, Tl), this.maxX = Math.max(this.maxX, hl), this.maxY = Math.max(this.maxY, Tl);
              }
              updateRectMinMax(yl, hl) {
                const Tl = Qi.Util.applyTransform(hl, yl), Il = Qi.Util.applyTransform(hl.slice(2), yl);
                this.minX = Math.min(this.minX, Tl[0], Il[0]), this.minY = Math.min(this.minY, Tl[1], Il[1]), this.maxX = Math.max(this.maxX, Tl[0], Il[0]), this.maxY = Math.max(this.maxY, Tl[1], Il[1]);
              }
              updateScalingPathMinMax(yl, hl) {
                Qi.Util.scaleMinMax(yl, hl), this.minX = Math.min(this.minX, hl[0]), this.maxX = Math.max(this.maxX, hl[1]), this.minY = Math.min(this.minY, hl[2]), this.maxY = Math.max(this.maxY, hl[3]);
              }
              updateCurvePathMinMax(yl, hl, Tl, Il, jl, Al, _s, Gs, vl, gl) {
                const El = Qi.Util.bezierBoundingBox(hl, Tl, Il, jl, Al, _s, Gs, vl);
                if (gl) {
                  gl[0] = Math.min(gl[0], El[0], El[2]), gl[1] = Math.max(gl[1], El[0], El[2]), gl[2] = Math.min(gl[2], El[1], El[3]), gl[3] = Math.max(gl[3], El[1], El[3]);
                  return;
                }
                this.updateRectMinMax(yl, El);
              }
              getPathBoundingBox(yl = ta.PathType.FILL, hl = null) {
                const Tl = [this.minX, this.minY, this.maxX, this.maxY];
                if (yl === ta.PathType.STROKE) {
                  hl || (0, Qi.unreachable)("Stroke bounding box must include transform.");
                  const Il = Qi.Util.singularValueDecompose2dScale(hl), jl = Il[0] * this.lineWidth / 2, Al = Il[1] * this.lineWidth / 2;
                  Tl[0] -= jl, Tl[1] -= Al, Tl[2] += jl, Tl[3] += Al;
                }
                return Tl;
              }
              updateClipFromPath() {
                const yl = Qi.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(yl || [0, 0, 0, 0]);
              }
              isEmptyClip() {
                return this.minX === 1 / 0;
              }
              startNewPathAndClipBox(yl) {
                this.clipBox = yl, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
              }
              getClippedPathBoundingBox(yl = ta.PathType.FILL, hl = null) {
                return Qi.Util.intersect(this.clipBox, this.getPathBoundingBox(yl, hl));
              }
            }
            function Xs(Pl, yl, hl = null) {
              if (typeof ImageData < "u" && yl instanceof ImageData) {
                Pl.putImageData(yl, 0, 0);
                return;
              }
              const Tl = yl.height, Il = yl.width, jl = Tl % eo, Al = (Tl - jl) / eo, _s = jl === 0 ? Al : Al + 1, Gs = Pl.createImageData(Il, eo);
              let vl = 0, gl;
              const El = yl.data, Ol = Gs.data;
              let wl, dl, Sl, Ml, Fl, Ll, Nl, ql;
              if (hl)
                switch (hl.length) {
                  case 1:
                    Fl = hl[0], Ll = hl[0], Nl = hl[0], ql = hl[0];
                    break;
                  case 4:
                    Fl = hl[0], Ll = hl[1], Nl = hl[2], ql = hl[3];
                    break;
                }
              if (yl.kind === Qi.ImageKind.GRAYSCALE_1BPP) {
                const Jl = El.byteLength, zl = new Uint32Array(Ol.buffer, 0, Ol.byteLength >> 2), tc = zl.length, Ku = Il + 7 >> 3;
                let tu = 4294967295, Gu = Qi.FeatureTest.isLittleEndian ? 4278190080 : 255;
                for (ql && ql[0] === 255 && ql[255] === 0 && ([tu, Gu] = [Gu, tu]), wl = 0; wl < _s; wl++) {
                  for (Sl = wl < Al ? eo : jl, gl = 0, dl = 0; dl < Sl; dl++) {
                    const Qu = Jl - vl;
                    let ed = 0;
                    const td = Qu > Ku ? Il : Qu * 8 - 7, od = td & -8;
                    let ld = 0, sd = 0;
                    for (; ed < od; ed += 8)
                      sd = El[vl++], zl[gl++] = sd & 128 ? tu : Gu, zl[gl++] = sd & 64 ? tu : Gu, zl[gl++] = sd & 32 ? tu : Gu, zl[gl++] = sd & 16 ? tu : Gu, zl[gl++] = sd & 8 ? tu : Gu, zl[gl++] = sd & 4 ? tu : Gu, zl[gl++] = sd & 2 ? tu : Gu, zl[gl++] = sd & 1 ? tu : Gu;
                    for (; ed < td; ed++)
                      ld === 0 && (sd = El[vl++], ld = 128), zl[gl++] = sd & ld ? tu : Gu, ld >>= 1;
                  }
                  for (; gl < tc; )
                    zl[gl++] = 0;
                  Pl.putImageData(Gs, 0, wl * eo);
                }
              } else if (yl.kind === Qi.ImageKind.RGBA_32BPP) {
                const Jl = !!(Fl || Ll || Nl);
                for (dl = 0, Ml = Il * eo * 4, wl = 0; wl < Al; wl++) {
                  if (Ol.set(El.subarray(vl, vl + Ml)), vl += Ml, Jl)
                    for (let zl = 0; zl < Ml; zl += 4)
                      Fl && (Ol[zl + 0] = Fl[Ol[zl + 0]]), Ll && (Ol[zl + 1] = Ll[Ol[zl + 1]]), Nl && (Ol[zl + 2] = Nl[Ol[zl + 2]]);
                  Pl.putImageData(Gs, 0, dl), dl += eo;
                }
                if (wl < _s) {
                  if (Ml = Il * jl * 4, Ol.set(El.subarray(vl, vl + Ml)), Jl)
                    for (let zl = 0; zl < Ml; zl += 4)
                      Fl && (Ol[zl + 0] = Fl[Ol[zl + 0]]), Ll && (Ol[zl + 1] = Ll[Ol[zl + 1]]), Nl && (Ol[zl + 2] = Nl[Ol[zl + 2]]);
                  Pl.putImageData(Gs, 0, dl);
                }
              } else if (yl.kind === Qi.ImageKind.RGB_24BPP) {
                const Jl = !!(Fl || Ll || Nl);
                for (Sl = eo, Ml = Il * Sl, wl = 0; wl < _s; wl++) {
                  for (wl >= Al && (Sl = jl, Ml = Il * Sl), gl = 0, dl = Ml; dl--; )
                    Ol[gl++] = El[vl++], Ol[gl++] = El[vl++], Ol[gl++] = El[vl++], Ol[gl++] = 255;
                  if (Jl)
                    for (let zl = 0; zl < gl; zl += 4)
                      Fl && (Ol[zl + 0] = Fl[Ol[zl + 0]]), Ll && (Ol[zl + 1] = Ll[Ol[zl + 1]]), Nl && (Ol[zl + 2] = Nl[Ol[zl + 2]]);
                  Pl.putImageData(Gs, 0, wl * eo);
                }
              } else
                throw new Error(`bad image kind: ${yl.kind}`);
            }
            function Cs(Pl, yl) {
              if (yl.bitmap) {
                Pl.drawImage(yl.bitmap, 0, 0);
                return;
              }
              const hl = yl.height, Tl = yl.width, Il = hl % eo, jl = (hl - Il) / eo, Al = Il === 0 ? jl : jl + 1, _s = Pl.createImageData(Tl, eo);
              let Gs = 0;
              const vl = yl.data, gl = _s.data;
              for (let El = 0; El < Al; El++) {
                const Ol = El < jl ? eo : Il;
                ({
                  srcPos: Gs
                } = (0, ra.applyMaskImageData)({
                  src: vl,
                  srcPos: Gs,
                  dest: gl,
                  width: Tl,
                  height: Ol
                })), Pl.putImageData(_s, 0, El * eo);
              }
            }
            function Fs(Pl, yl) {
              const hl = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
              for (let Tl = 0, Il = hl.length; Tl < Il; Tl++) {
                const jl = hl[Tl];
                Pl[jl] !== void 0 && (yl[jl] = Pl[jl]);
              }
              Pl.setLineDash !== void 0 && (yl.setLineDash(Pl.getLineDash()), yl.lineDashOffset = Pl.lineDashOffset);
            }
            function ws(Pl, yl) {
              Pl.strokeStyle = Pl.fillStyle = yl || "#000000", Pl.fillRule = "nonzero", Pl.globalAlpha = 1, Pl.lineWidth = 1, Pl.lineCap = "butt", Pl.lineJoin = "miter", Pl.miterLimit = 10, Pl.globalCompositeOperation = "source-over", Pl.font = "10px sans-serif", Pl.setLineDash !== void 0 && (Pl.setLineDash([]), Pl.lineDashOffset = 0);
            }
            function ls(Pl, yl, hl, Tl) {
              const Il = Pl.length;
              for (let jl = 3; jl < Il; jl += 4) {
                const Al = Pl[jl];
                if (Al === 0)
                  Pl[jl - 3] = yl, Pl[jl - 2] = hl, Pl[jl - 1] = Tl;
                else if (Al < 255) {
                  const _s = 255 - Al;
                  Pl[jl - 3] = Pl[jl - 3] * Al + yl * _s >> 8, Pl[jl - 2] = Pl[jl - 2] * Al + hl * _s >> 8, Pl[jl - 1] = Pl[jl - 1] * Al + Tl * _s >> 8;
                }
              }
            }
            function ks(Pl, yl, hl) {
              const Tl = Pl.length, Il = 1 / 255;
              for (let jl = 3; jl < Tl; jl += 4) {
                const Al = hl ? hl[Pl[jl]] : Pl[jl];
                yl[jl] = yl[jl] * Al * Il | 0;
              }
            }
            function Js(Pl, yl, hl) {
              const Tl = Pl.length;
              for (let Il = 3; Il < Tl; Il += 4) {
                const jl = Pl[Il - 3] * 77 + Pl[Il - 2] * 152 + Pl[Il - 1] * 28;
                yl[Il] = hl ? yl[Il] * hl[jl >> 8] >> 8 : yl[Il] * jl >> 16;
              }
            }
            function pl(Pl, yl, hl, Tl, Il, jl, Al, _s, Gs, vl, gl) {
              const El = !!jl, Ol = El ? jl[0] : 0, wl = El ? jl[1] : 0, dl = El ? jl[2] : 0;
              let Sl;
              Il === "Luminosity" ? Sl = Js : Sl = ks;
              const Fl = Math.min(Tl, Math.ceil(1048576 / hl));
              for (let Ll = 0; Ll < Tl; Ll += Fl) {
                const Nl = Math.min(Fl, Tl - Ll), ql = Pl.getImageData(_s - vl, Ll + (Gs - gl), hl, Nl), Jl = yl.getImageData(_s, Ll + Gs, hl, Nl);
                El && ls(ql.data, Ol, wl, dl), Sl(ql.data, Jl.data, Al), yl.putImageData(Jl, _s, Ll + Gs);
              }
            }
            function _l(Pl, yl, hl, Tl) {
              const Il = Tl[0], jl = Tl[1], Al = Tl[2] - Il, _s = Tl[3] - jl;
              Al === 0 || _s === 0 || (pl(yl.context, hl, Al, _s, yl.subtype, yl.backdrop, yl.transferMap, Il, jl, yl.offsetX, yl.offsetY), Pl.save(), Pl.globalAlpha = 1, Pl.globalCompositeOperation = "source-over", Pl.setTransform(1, 0, 0, 1, 0, 0), Pl.drawImage(hl.canvas, 0, 0), Pl.restore());
            }
            function bl(Pl, yl) {
              const hl = Qi.Util.singularValueDecompose2dScale(Pl);
              hl[0] = Math.fround(hl[0]), hl[1] = Math.fround(hl[1]);
              const Tl = Math.fround((globalThis.devicePixelRatio || 1) * Xi.PixelsPerInch.PDF_TO_CSS_UNITS);
              return yl !== void 0 ? yl : hl[0] <= Tl || hl[1] <= Tl;
            }
            const xl = ["butt", "round", "square"], Rl = ["miter", "round", "bevel"], Cl = {}, Dl = {}, Zl = class Zl {
              constructor(yl, hl, Tl, Il, jl, Al, _s, Gs) {
                $u(this, Ul);
                this.ctx = yl, this.current = new Ys(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = hl, this.objs = Tl, this.canvasFactory = Il, this.imageLayer = jl, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = [], this.optionalContentConfig = Al, this.cachedCanvases = new ko(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = _s, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.backgroundColor = Gs?.background || null, this.foregroundColor = Gs?.foreground || null, this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
              }
              getObject(yl, hl = null) {
                return typeof yl == "string" ? yl.startsWith("g_") ? this.commonObjs.get(yl) : this.objs.get(yl) : hl;
              }
              beginDrawing({
                transform: yl,
                viewport: hl,
                transparency: Tl = !1,
                background: Il = null
              }) {
                const jl = this.ctx.canvas.width, Al = this.ctx.canvas.height, _s = Il || "#ffffff";
                if (this.ctx.save(), this.foregroundColor && this.backgroundColor) {
                  this.ctx.fillStyle = this.foregroundColor;
                  const Gs = this.foregroundColor = this.ctx.fillStyle;
                  this.ctx.fillStyle = this.backgroundColor;
                  const vl = this.backgroundColor = this.ctx.fillStyle;
                  let gl = !0, El = _s;
                  if (this.ctx.fillStyle = _s, El = this.ctx.fillStyle, gl = typeof El == "string" && /^#[0-9A-Fa-f]{6}$/.test(El), Gs === "#000000" && vl === "#ffffff" || Gs === vl || !gl)
                    this.foregroundColor = this.backgroundColor = null;
                  else {
                    const [Ol, wl, dl] = (0, Xi.getRGB)(El), Sl = (Fl) => (Fl /= 255, Fl <= 0.03928 ? Fl / 12.92 : ((Fl + 0.055) / 1.055) ** 2.4), Ml = Math.round(0.2126 * Sl(Ol) + 0.7152 * Sl(wl) + 0.0722 * Sl(dl));
                    this.selectColor = (Fl, Ll, Nl) => {
                      const ql = 0.2126 * Sl(Fl) + 0.7152 * Sl(Ll) + 0.0722 * Sl(Nl);
                      return Math.round(ql) === Ml ? vl : Gs;
                    };
                  }
                }
                if (this.ctx.fillStyle = this.backgroundColor || _s, this.ctx.fillRect(0, 0, jl, Al), this.ctx.restore(), Tl) {
                  const Gs = this.cachedCanvases.getCanvas("transparent", jl, Al);
                  this.compositeCtx = this.ctx, this.transparentCanvas = Gs.canvas, this.ctx = Gs.context, this.ctx.save(), this.ctx.transform(...(0, Xi.getCurrentTransform)(this.compositeCtx));
                }
                this.ctx.save(), ws(this.ctx, this.foregroundColor), yl && (this.ctx.transform(...yl), this.outputScaleX = yl[0], this.outputScaleY = yl[0]), this.ctx.transform(...hl.transform), this.viewportScale = hl.scale, this.baseTransform = (0, Xi.getCurrentTransform)(this.ctx), this.imageLayer && ((0, Xi.deprecated)("The `imageLayer` functionality will be removed in the future."), this.imageLayer.beginLayout());
              }
              executeOperatorList(yl, hl, Tl, Il) {
                const jl = yl.argsArray, Al = yl.fnArray;
                let _s = hl || 0;
                const Gs = jl.length;
                if (Gs === _s)
                  return _s;
                const vl = Gs - _s > Eo && typeof Tl == "function", gl = vl ? Date.now() + to : 0;
                let El = 0;
                const Ol = this.commonObjs, wl = this.objs;
                let dl;
                for (; ; ) {
                  if (Il !== void 0 && _s === Il.nextBreakPoint)
                    return Il.breakIt(_s, Tl), _s;
                  if (dl = Al[_s], dl !== Qi.OPS.dependency)
                    this[dl].apply(this, jl[_s]);
                  else
                    for (const Sl of jl[_s]) {
                      const Ml = Sl.startsWith("g_") ? Ol : wl;
                      if (!Ml.has(Sl))
                        return Ml.get(Sl, Tl), _s;
                    }
                  if (_s++, _s === Gs)
                    return _s;
                  if (vl && ++El > Eo) {
                    if (Date.now() > gl)
                      return Tl(), _s;
                    El = 0;
                  }
                }
              }
              endDrawing() {
                rc(this, Ul, af).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
                for (const yl of this._cachedBitmapsMap.values()) {
                  for (const hl of yl.values())
                    typeof HTMLCanvasElement < "u" && hl instanceof HTMLCanvasElement && (hl.width = hl.height = 0);
                  yl.clear();
                }
                this._cachedBitmapsMap.clear(), this.imageLayer && this.imageLayer.endLayout();
              }
              _scaleImage(yl, hl) {
                const Tl = yl.width, Il = yl.height;
                let jl = Math.max(Math.hypot(hl[0], hl[1]), 1), Al = Math.max(Math.hypot(hl[2], hl[3]), 1), _s = Tl, Gs = Il, vl = "prescale1", gl, El;
                for (; jl > 2 && _s > 1 || Al > 2 && Gs > 1; ) {
                  let Ol = _s, wl = Gs;
                  jl > 2 && _s > 1 && (Ol = Math.ceil(_s / 2), jl /= _s / Ol), Al > 2 && Gs > 1 && (wl = Math.ceil(Gs / 2), Al /= Gs / wl), gl = this.cachedCanvases.getCanvas(vl, Ol, wl), El = gl.context, El.clearRect(0, 0, Ol, wl), El.drawImage(yl, 0, 0, _s, Gs, 0, 0, Ol, wl), yl = gl.canvas, _s = Ol, Gs = wl, vl = vl === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img: yl,
                  paintWidth: _s,
                  paintHeight: Gs
                };
              }
              _createMaskCanvas(yl) {
                const hl = this.ctx, {
                  width: Tl,
                  height: Il
                } = yl, jl = this.current.fillColor, Al = this.current.patternFill, _s = (0, Xi.getCurrentTransform)(hl);
                let Gs, vl, gl, El;
                if ((yl.bitmap || yl.data) && yl.count > 1) {
                  const tc = yl.bitmap || yl.data.buffer, Ku = _s.slice(0, 4);
                  vl = JSON.stringify(Al ? Ku : [Ku, jl]), Gs = this._cachedBitmapsMap.get(tc), Gs || (Gs = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(tc, Gs));
                  const tu = Gs.get(vl);
                  if (tu && !Al) {
                    const Gu = Math.round(Math.min(_s[0], _s[2]) + _s[4]), Qu = Math.round(Math.min(_s[1], _s[3]) + _s[5]);
                    return {
                      canvas: tu,
                      offsetX: Gu,
                      offsetY: Qu
                    };
                  }
                  gl = tu;
                }
                gl || (El = this.cachedCanvases.getCanvas("maskCanvas", Tl, Il), Cs(El.context, yl));
                let Ol = Qi.Util.transform(_s, [1 / Tl, 0, 0, -1 / Il, 0, 0]);
                Ol = Qi.Util.transform(Ol, [1, 0, 0, 1, 0, -Il]);
                const wl = Qi.Util.applyTransform([0, 0], Ol), dl = Qi.Util.applyTransform([Tl, Il], Ol), Sl = Qi.Util.normalizeRect([wl[0], wl[1], dl[0], dl[1]]), Ml = Math.round(Sl[2] - Sl[0]) || 1, Fl = Math.round(Sl[3] - Sl[1]) || 1, Ll = this.cachedCanvases.getCanvas("fillCanvas", Ml, Fl), Nl = Ll.context, ql = Math.min(wl[0], dl[0]), Jl = Math.min(wl[1], dl[1]);
                Nl.translate(-ql, -Jl), Nl.transform(...Ol), gl || (gl = this._scaleImage(El.canvas, (0, Xi.getCurrentTransformInverse)(Nl)), gl = gl.img, Gs && Al && Gs.set(vl, gl)), Nl.imageSmoothingEnabled = bl((0, Xi.getCurrentTransform)(Nl), yl.interpolate), Hs(Nl, gl, 0, 0, gl.width, gl.height, 0, 0, Tl, Il), Nl.globalCompositeOperation = "source-in";
                const zl = Qi.Util.transform((0, Xi.getCurrentTransformInverse)(Nl), [1, 0, 0, 1, -ql, -Jl]);
                return Nl.fillStyle = Al ? jl.getPattern(hl, this, zl, ta.PathType.FILL) : jl, Nl.fillRect(0, 0, Tl, Il), Gs && !Al && (this.cachedCanvases.delete("fillCanvas"), Gs.set(vl, Ll.canvas)), {
                  canvas: Ll.canvas,
                  offsetX: Math.round(ql),
                  offsetY: Math.round(Jl)
                };
              }
              setLineWidth(yl) {
                yl !== this.current.lineWidth && (this._cachedScaleForStroking = null), this.current.lineWidth = yl, this.ctx.lineWidth = yl;
              }
              setLineCap(yl) {
                this.ctx.lineCap = xl[yl];
              }
              setLineJoin(yl) {
                this.ctx.lineJoin = Rl[yl];
              }
              setMiterLimit(yl) {
                this.ctx.miterLimit = yl;
              }
              setDash(yl, hl) {
                const Tl = this.ctx;
                Tl.setLineDash !== void 0 && (Tl.setLineDash(yl), Tl.lineDashOffset = hl);
              }
              setRenderingIntent(yl) {
              }
              setFlatness(yl) {
              }
              setGState(yl) {
                for (let hl = 0, Tl = yl.length; hl < Tl; hl++) {
                  const Il = yl[hl], jl = Il[0], Al = Il[1];
                  switch (jl) {
                    case "LW":
                      this.setLineWidth(Al);
                      break;
                    case "LC":
                      this.setLineCap(Al);
                      break;
                    case "LJ":
                      this.setLineJoin(Al);
                      break;
                    case "ML":
                      this.setMiterLimit(Al);
                      break;
                    case "D":
                      this.setDash(Al[0], Al[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(Al);
                      break;
                    case "FL":
                      this.setFlatness(Al);
                      break;
                    case "Font":
                      this.setFont(Al[0], Al[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = Il[1];
                      break;
                    case "ca":
                      this.current.fillAlpha = Il[1], this.ctx.globalAlpha = Il[1];
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = Al;
                      break;
                    case "SMask":
                      this.current.activeSMask = Al ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                      break;
                    case "TR":
                      this.current.transferMaps = Al;
                  }
                }
              }
              get inSMaskMode() {
                return !!this.suspendedCtx;
              }
              checkSMaskState() {
                const yl = this.inSMaskMode;
                this.current.activeSMask && !yl ? this.beginSMaskMode() : !this.current.activeSMask && yl && this.endSMaskMode();
              }
              beginSMaskMode() {
                if (this.inSMaskMode)
                  throw new Error("beginSMaskMode called while already in smask mode");
                const yl = this.ctx.canvas.width, hl = this.ctx.canvas.height, Tl = "smaskGroupAt" + this.groupLevel, Il = this.cachedCanvases.getCanvas(Tl, yl, hl);
                this.suspendedCtx = this.ctx, this.ctx = Il.context;
                const jl = this.ctx;
                jl.setTransform(...(0, Xi.getCurrentTransform)(this.suspendedCtx)), Fs(this.suspendedCtx, jl), rs(jl, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
              endSMaskMode() {
                if (!this.inSMaskMode)
                  throw new Error("endSMaskMode called while not in smask mode");
                this.ctx._removeMirroring(), Fs(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
              }
              compose(yl) {
                if (!this.current.activeSMask)
                  return;
                yl ? (yl[0] = Math.floor(yl[0]), yl[1] = Math.floor(yl[1]), yl[2] = Math.ceil(yl[2]), yl[3] = Math.ceil(yl[3])) : yl = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                const hl = this.current.activeSMask, Tl = this.suspendedCtx;
                _l(Tl, hl, this.ctx, yl), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
              }
              save() {
                this.inSMaskMode ? (Fs(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
                const yl = this.current;
                this.stateStack.push(yl), this.current = yl.clone();
              }
              restore() {
                this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), Fs(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null);
              }
              transform(yl, hl, Tl, Il, jl, Al) {
                this.ctx.transform(yl, hl, Tl, Il, jl, Al), this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null;
              }
              constructPath(yl, hl, Tl) {
                const Il = this.ctx, jl = this.current;
                let Al = jl.x, _s = jl.y, Gs, vl;
                const gl = (0, Xi.getCurrentTransform)(Il), El = gl[0] === 0 && gl[3] === 0 || gl[1] === 0 && gl[2] === 0, Ol = El ? Tl.slice(0) : null;
                for (let wl = 0, dl = 0, Sl = yl.length; wl < Sl; wl++)
                  switch (yl[wl] | 0) {
                    case Qi.OPS.rectangle:
                      Al = hl[dl++], _s = hl[dl++];
                      const Ml = hl[dl++], Fl = hl[dl++], Ll = Al + Ml, Nl = _s + Fl;
                      Il.moveTo(Al, _s), Ml === 0 || Fl === 0 ? Il.lineTo(Ll, Nl) : (Il.lineTo(Ll, _s), Il.lineTo(Ll, Nl), Il.lineTo(Al, Nl)), El || jl.updateRectMinMax(gl, [Al, _s, Ll, Nl]), Il.closePath();
                      break;
                    case Qi.OPS.moveTo:
                      Al = hl[dl++], _s = hl[dl++], Il.moveTo(Al, _s), El || jl.updatePathMinMax(gl, Al, _s);
                      break;
                    case Qi.OPS.lineTo:
                      Al = hl[dl++], _s = hl[dl++], Il.lineTo(Al, _s), El || jl.updatePathMinMax(gl, Al, _s);
                      break;
                    case Qi.OPS.curveTo:
                      Gs = Al, vl = _s, Al = hl[dl + 4], _s = hl[dl + 5], Il.bezierCurveTo(hl[dl], hl[dl + 1], hl[dl + 2], hl[dl + 3], Al, _s), jl.updateCurvePathMinMax(gl, Gs, vl, hl[dl], hl[dl + 1], hl[dl + 2], hl[dl + 3], Al, _s, Ol), dl += 6;
                      break;
                    case Qi.OPS.curveTo2:
                      Gs = Al, vl = _s, Il.bezierCurveTo(Al, _s, hl[dl], hl[dl + 1], hl[dl + 2], hl[dl + 3]), jl.updateCurvePathMinMax(gl, Gs, vl, Al, _s, hl[dl], hl[dl + 1], hl[dl + 2], hl[dl + 3], Ol), Al = hl[dl + 2], _s = hl[dl + 3], dl += 4;
                      break;
                    case Qi.OPS.curveTo3:
                      Gs = Al, vl = _s, Al = hl[dl + 2], _s = hl[dl + 3], Il.bezierCurveTo(hl[dl], hl[dl + 1], Al, _s, Al, _s), jl.updateCurvePathMinMax(gl, Gs, vl, hl[dl], hl[dl + 1], Al, _s, Al, _s, Ol), dl += 4;
                      break;
                    case Qi.OPS.closePath:
                      Il.closePath();
                      break;
                  }
                El && jl.updateScalingPathMinMax(gl, Ol), jl.setCurrentPoint(Al, _s);
              }
              closePath() {
                this.ctx.closePath();
              }
              stroke(yl) {
                yl = typeof yl < "u" ? yl : !0;
                const hl = this.ctx, Tl = this.current.strokeColor;
                hl.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof Tl == "object" && Tl?.getPattern ? (hl.save(), hl.strokeStyle = Tl.getPattern(hl, this, (0, Xi.getCurrentTransformInverse)(hl), ta.PathType.STROKE), this.rescaleAndStroke(!1), hl.restore()) : this.rescaleAndStroke(!0)), yl && this.consumePath(this.current.getClippedPathBoundingBox()), hl.globalAlpha = this.current.fillAlpha;
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              fill(yl) {
                yl = typeof yl < "u" ? yl : !0;
                const hl = this.ctx, Tl = this.current.fillColor, Il = this.current.patternFill;
                let jl = !1;
                Il && (hl.save(), hl.fillStyle = Tl.getPattern(hl, this, (0, Xi.getCurrentTransformInverse)(hl), ta.PathType.FILL), jl = !0);
                const Al = this.current.getClippedPathBoundingBox();
                this.contentVisible && Al !== null && (this.pendingEOFill ? (hl.fill("evenodd"), this.pendingEOFill = !1) : hl.fill()), jl && hl.restore(), yl && this.consumePath(Al);
              }
              eoFill() {
                this.pendingEOFill = !0, this.fill();
              }
              fillStroke() {
                this.fill(!1), this.stroke(!1), this.consumePath();
              }
              eoFillStroke() {
                this.pendingEOFill = !0, this.fillStroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.pendingEOFill = !0, this.closePath(), this.fillStroke();
              }
              endPath() {
                this.consumePath();
              }
              clip() {
                this.pendingClip = Cl;
              }
              eoClip() {
                this.pendingClip = Dl;
              }
              beginText() {
                this.current.textMatrix = Qi.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              endText() {
                const yl = this.pendingTextPaths, hl = this.ctx;
                if (yl === void 0) {
                  hl.beginPath();
                  return;
                }
                hl.save(), hl.beginPath();
                for (const Tl of yl)
                  hl.setTransform(...Tl.transform), hl.translate(Tl.x, Tl.y), Tl.addToPath(hl, Tl.fontSize);
                hl.restore(), hl.clip(), hl.beginPath(), delete this.pendingTextPaths;
              }
              setCharSpacing(yl) {
                this.current.charSpacing = yl;
              }
              setWordSpacing(yl) {
                this.current.wordSpacing = yl;
              }
              setHScale(yl) {
                this.current.textHScale = yl / 100;
              }
              setLeading(yl) {
                this.current.leading = -yl;
              }
              setFont(yl, hl) {
                const Tl = this.commonObjs.get(yl), Il = this.current;
                if (!Tl)
                  throw new Error(`Can't find font for ${yl}`);
                if (Il.fontMatrix = Tl.fontMatrix || Qi.FONT_IDENTITY_MATRIX, (Il.fontMatrix[0] === 0 || Il.fontMatrix[3] === 0) && (0, Qi.warn)("Invalid font matrix for font " + yl), hl < 0 ? (hl = -hl, Il.fontDirection = -1) : Il.fontDirection = 1, this.current.font = Tl, this.current.fontSize = hl, Tl.isType3Font)
                  return;
                const jl = Tl.loadedName || "sans-serif";
                let Al = "normal";
                Tl.black ? Al = "900" : Tl.bold && (Al = "bold");
                const _s = Tl.italic ? "italic" : "normal", Gs = `"${jl}", ${Tl.fallbackName}`;
                let vl = hl;
                hl < la ? vl = la : hl > Ma && (vl = Ma), this.current.fontSizeScale = hl / vl, this.ctx.font = `${_s} ${Al} ${vl}px ${Gs}`;
              }
              setTextRenderingMode(yl) {
                this.current.textRenderingMode = yl;
              }
              setTextRise(yl) {
                this.current.textRise = yl;
              }
              moveText(yl, hl) {
                this.current.x = this.current.lineX += yl, this.current.y = this.current.lineY += hl;
              }
              setLeadingMoveText(yl, hl) {
                this.setLeading(-hl), this.moveText(yl, hl);
              }
              setTextMatrix(yl, hl, Tl, Il, jl, Al) {
                this.current.textMatrix = [yl, hl, Tl, Il, jl, Al], this.current.textMatrixScale = Math.hypot(yl, hl), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              paintChar(yl, hl, Tl, Il) {
                const jl = this.ctx, Al = this.current, _s = Al.font, Gs = Al.textRenderingMode, vl = Al.fontSize / Al.fontSizeScale, gl = Gs & Qi.TextRenderingMode.FILL_STROKE_MASK, El = !!(Gs & Qi.TextRenderingMode.ADD_TO_PATH_FLAG), Ol = Al.patternFill && !_s.missingFile;
                let wl;
                (_s.disableFontFace || El || Ol) && (wl = _s.getPathGenerator(this.commonObjs, yl)), _s.disableFontFace || Ol ? (jl.save(), jl.translate(hl, Tl), jl.beginPath(), wl(jl, vl), Il && jl.setTransform(...Il), (gl === Qi.TextRenderingMode.FILL || gl === Qi.TextRenderingMode.FILL_STROKE) && jl.fill(), (gl === Qi.TextRenderingMode.STROKE || gl === Qi.TextRenderingMode.FILL_STROKE) && jl.stroke(), jl.restore()) : ((gl === Qi.TextRenderingMode.FILL || gl === Qi.TextRenderingMode.FILL_STROKE) && jl.fillText(yl, hl, Tl), (gl === Qi.TextRenderingMode.STROKE || gl === Qi.TextRenderingMode.FILL_STROKE) && jl.strokeText(yl, hl, Tl)), El && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                  transform: (0, Xi.getCurrentTransform)(jl),
                  x: hl,
                  y: Tl,
                  fontSize: vl,
                  addToPath: wl
                });
              }
              get isFontSubpixelAAEnabled() {
                const {
                  context: yl
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                yl.scale(1.5, 1), yl.fillText("I", 0, 10);
                const hl = yl.getImageData(0, 0, 10, 10).data;
                let Tl = !1;
                for (let Il = 3; Il < hl.length; Il += 4)
                  if (hl[Il] > 0 && hl[Il] < 255) {
                    Tl = !0;
                    break;
                  }
                return (0, Qi.shadow)(this, "isFontSubpixelAAEnabled", Tl);
              }
              showText(yl) {
                const hl = this.current, Tl = hl.font;
                if (Tl.isType3Font)
                  return this.showType3Text(yl);
                const Il = hl.fontSize;
                if (Il === 0)
                  return;
                const jl = this.ctx, Al = hl.fontSizeScale, _s = hl.charSpacing, Gs = hl.wordSpacing, vl = hl.fontDirection, gl = hl.textHScale * vl, El = yl.length, Ol = Tl.vertical, wl = Ol ? 1 : -1, dl = Tl.defaultVMetrics, Sl = Il * hl.fontMatrix[0], Ml = hl.textRenderingMode === Qi.TextRenderingMode.FILL && !Tl.disableFontFace && !hl.patternFill;
                jl.save(), jl.transform(...hl.textMatrix), jl.translate(hl.x, hl.y + hl.textRise), vl > 0 ? jl.scale(gl, -1) : jl.scale(gl, 1);
                let Fl;
                if (hl.patternFill) {
                  jl.save();
                  const zl = hl.fillColor.getPattern(jl, this, (0, Xi.getCurrentTransformInverse)(jl), ta.PathType.FILL);
                  Fl = (0, Xi.getCurrentTransform)(jl), jl.restore(), jl.fillStyle = zl;
                }
                let Ll = hl.lineWidth;
                const Nl = hl.textMatrixScale;
                if (Nl === 0 || Ll === 0) {
                  const zl = hl.textRenderingMode & Qi.TextRenderingMode.FILL_STROKE_MASK;
                  (zl === Qi.TextRenderingMode.STROKE || zl === Qi.TextRenderingMode.FILL_STROKE) && (Ll = this.getSinglePixelWidth());
                } else
                  Ll /= Nl;
                Al !== 1 && (jl.scale(Al, Al), Ll /= Al), jl.lineWidth = Ll;
                let ql = 0, Jl;
                for (Jl = 0; Jl < El; ++Jl) {
                  const zl = yl[Jl];
                  if (typeof zl == "number") {
                    ql += wl * zl * Il / 1e3;
                    continue;
                  }
                  let tc = !1;
                  const Ku = (zl.isSpace ? Gs : 0) + _s, tu = zl.fontChar, Gu = zl.accent;
                  let Qu, ed, td = zl.width;
                  if (Ol) {
                    const ld = zl.vmetric || dl, sd = -(zl.vmetric ? ld[1] : td * 0.5) * Sl, bd = ld[2] * Sl;
                    td = ld ? -ld[0] : td, Qu = sd / Al, ed = (ql + bd) / Al;
                  } else
                    Qu = ql / Al, ed = 0;
                  if (Tl.remeasure && td > 0) {
                    const ld = jl.measureText(tu).width * 1e3 / Il * Al;
                    if (td < ld && this.isFontSubpixelAAEnabled) {
                      const sd = td / ld;
                      tc = !0, jl.save(), jl.scale(sd, 1), Qu /= sd;
                    } else td !== ld && (Qu += (td - ld) / 2e3 * Il / Al);
                  }
                  if (this.contentVisible && (zl.isInFont || Tl.missingFile)) {
                    if (Ml && !Gu)
                      jl.fillText(tu, Qu, ed);
                    else if (this.paintChar(tu, Qu, ed, Fl), Gu) {
                      const ld = Qu + Il * Gu.offset.x / Al, sd = ed - Il * Gu.offset.y / Al;
                      this.paintChar(Gu.fontChar, ld, sd, Fl);
                    }
                  }
                  let od;
                  Ol ? od = td * Sl - Ku * vl : od = td * Sl + Ku * vl, ql += od, tc && jl.restore();
                }
                Ol ? hl.y -= ql : hl.x += ql * gl, jl.restore(), this.compose();
              }
              showType3Text(yl) {
                const hl = this.ctx, Tl = this.current, Il = Tl.font, jl = Tl.fontSize, Al = Tl.fontDirection, _s = Il.vertical ? 1 : -1, Gs = Tl.charSpacing, vl = Tl.wordSpacing, gl = Tl.textHScale * Al, El = Tl.fontMatrix || Qi.FONT_IDENTITY_MATRIX, Ol = yl.length, wl = Tl.textRenderingMode === Qi.TextRenderingMode.INVISIBLE;
                let dl, Sl, Ml, Fl;
                if (!(wl || jl === 0)) {
                  for (this._cachedScaleForStroking = null, this._cachedGetSinglePixelWidth = null, hl.save(), hl.transform(...Tl.textMatrix), hl.translate(Tl.x, Tl.y), hl.scale(gl, Al), dl = 0; dl < Ol; ++dl) {
                    if (Sl = yl[dl], typeof Sl == "number") {
                      Fl = _s * Sl * jl / 1e3, this.ctx.translate(Fl, 0), Tl.x += Fl * gl;
                      continue;
                    }
                    const Ll = (Sl.isSpace ? vl : 0) + Gs, Nl = Il.charProcOperatorList[Sl.operatorListId];
                    if (!Nl) {
                      (0, Qi.warn)(`Type3 character "${Sl.operatorListId}" is not available.`);
                      continue;
                    }
                    this.contentVisible && (this.processingType3 = Sl, this.save(), hl.scale(jl, jl), hl.transform(...El), this.executeOperatorList(Nl), this.restore()), Ml = Qi.Util.applyTransform([Sl.width, 0], El)[0] * jl + Ll, hl.translate(Ml, 0), Tl.x += Ml * gl;
                  }
                  hl.restore(), this.processingType3 = null;
                }
              }
              setCharWidth(yl, hl) {
              }
              setCharWidthAndBounds(yl, hl, Tl, Il, jl, Al) {
                this.ctx.rect(Tl, Il, jl - Tl, Al - Il), this.ctx.clip(), this.endPath();
              }
              getColorN_Pattern(yl) {
                let hl;
                if (yl[0] === "TilingPattern") {
                  const Tl = yl[1], Il = this.baseTransform || (0, Xi.getCurrentTransform)(this.ctx), jl = {
                    createCanvasGraphics: (Al) => new Zl(Al, this.commonObjs, this.objs, this.canvasFactory)
                  };
                  hl = new ta.TilingPattern(yl, Tl, this.ctx, jl, Il);
                } else
                  hl = this._getPattern(yl[1], yl[2]);
                return hl;
              }
              setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
              setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
              }
              setStrokeRGBColor(yl, hl, Tl) {
                const Il = this.selectColor?.(yl, hl, Tl) || Qi.Util.makeHexColor(yl, hl, Tl);
                this.ctx.strokeStyle = Il, this.current.strokeColor = Il;
              }
              setFillRGBColor(yl, hl, Tl) {
                const Il = this.selectColor?.(yl, hl, Tl) || Qi.Util.makeHexColor(yl, hl, Tl);
                this.ctx.fillStyle = Il, this.current.fillColor = Il, this.current.patternFill = !1;
              }
              _getPattern(yl, hl = null) {
                let Tl;
                return this.cachedPatterns.has(yl) ? Tl = this.cachedPatterns.get(yl) : (Tl = (0, ta.getShadingPattern)(this.objs.get(yl)), this.cachedPatterns.set(yl, Tl)), hl && (Tl.matrix = hl), Tl;
              }
              shadingFill(yl) {
                if (!this.contentVisible)
                  return;
                const hl = this.ctx;
                this.save();
                const Tl = this._getPattern(yl);
                hl.fillStyle = Tl.getPattern(hl, this, (0, Xi.getCurrentTransformInverse)(hl), ta.PathType.SHADING);
                const Il = (0, Xi.getCurrentTransformInverse)(hl);
                if (Il) {
                  const jl = hl.canvas, Al = jl.width, _s = jl.height, Gs = Qi.Util.applyTransform([0, 0], Il), vl = Qi.Util.applyTransform([0, _s], Il), gl = Qi.Util.applyTransform([Al, 0], Il), El = Qi.Util.applyTransform([Al, _s], Il), Ol = Math.min(Gs[0], vl[0], gl[0], El[0]), wl = Math.min(Gs[1], vl[1], gl[1], El[1]), dl = Math.max(Gs[0], vl[0], gl[0], El[0]), Sl = Math.max(Gs[1], vl[1], gl[1], El[1]);
                  this.ctx.fillRect(Ol, wl, dl - Ol, Sl - wl);
                } else
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                this.compose(this.current.getClippedPathBoundingBox()), this.restore();
              }
              beginInlineImage() {
                (0, Qi.unreachable)("Should not call beginInlineImage");
              }
              beginImageData() {
                (0, Qi.unreachable)("Should not call beginImageData");
              }
              paintFormXObjectBegin(yl, hl) {
                if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(yl) && yl.length === 6 && this.transform(...yl), this.baseTransform = (0, Xi.getCurrentTransform)(this.ctx), hl)) {
                  const Tl = hl[2] - hl[0], Il = hl[3] - hl[1];
                  this.ctx.rect(hl[0], hl[1], Tl, Il), this.current.updateRectMinMax((0, Xi.getCurrentTransform)(this.ctx), hl), this.clip(), this.endPath();
                }
              }
              paintFormXObjectEnd() {
                this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
              }
              beginGroup(yl) {
                if (!this.contentVisible)
                  return;
                this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
                const hl = this.ctx;
                yl.isolated || (0, Qi.info)("TODO: Support non-isolated groups."), yl.knockout && (0, Qi.warn)("Knockout groups not supported.");
                const Tl = (0, Xi.getCurrentTransform)(hl);
                if (yl.matrix && hl.transform(...yl.matrix), !yl.bbox)
                  throw new Error("Bounding box is required.");
                let Il = Qi.Util.getAxialAlignedBoundingBox(yl.bbox, (0, Xi.getCurrentTransform)(hl));
                const jl = [0, 0, hl.canvas.width, hl.canvas.height];
                Il = Qi.Util.intersect(Il, jl) || [0, 0, 0, 0];
                const Al = Math.floor(Il[0]), _s = Math.floor(Il[1]);
                let Gs = Math.max(Math.ceil(Il[2]) - Al, 1), vl = Math.max(Math.ceil(Il[3]) - _s, 1), gl = 1, El = 1;
                Gs > Va && (gl = Gs / Va, Gs = Va), vl > Va && (El = vl / Va, vl = Va), this.current.startNewPathAndClipBox([0, 0, Gs, vl]);
                let Ol = "groupAt" + this.groupLevel;
                yl.smask && (Ol += "_smask_" + this.smaskCounter++ % 2);
                const wl = this.cachedCanvases.getCanvas(Ol, Gs, vl), dl = wl.context;
                dl.scale(1 / gl, 1 / El), dl.translate(-Al, -_s), dl.transform(...Tl), yl.smask ? this.smaskStack.push({
                  canvas: wl.canvas,
                  context: dl,
                  offsetX: Al,
                  offsetY: _s,
                  scaleX: gl,
                  scaleY: El,
                  subtype: yl.smask.subtype,
                  backdrop: yl.smask.backdrop,
                  transferMap: yl.smask.transferMap || null,
                  startTransformInverse: null
                }) : (hl.setTransform(1, 0, 0, 1, 0, 0), hl.translate(Al, _s), hl.scale(gl, El), hl.save()), Fs(hl, dl), this.ctx = dl, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(hl), this.groupLevel++;
              }
              endGroup(yl) {
                if (!this.contentVisible)
                  return;
                this.groupLevel--;
                const hl = this.ctx, Tl = this.groupStack.pop();
                if (this.ctx = Tl, this.ctx.imageSmoothingEnabled = !1, yl.smask)
                  this.tempSMask = this.smaskStack.pop(), this.restore();
                else {
                  this.ctx.restore();
                  const Il = (0, Xi.getCurrentTransform)(this.ctx);
                  this.restore(), this.ctx.save(), this.ctx.setTransform(...Il);
                  const jl = Qi.Util.getAxialAlignedBoundingBox([0, 0, hl.canvas.width, hl.canvas.height], Il);
                  this.ctx.drawImage(hl.canvas, 0, 0), this.ctx.restore(), this.compose(jl);
                }
              }
              beginAnnotation(yl, hl, Tl, Il, jl) {
                if (rc(this, Ul, af).call(this), ws(this.ctx, this.foregroundColor), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(hl) && hl.length === 4) {
                  const Al = hl[2] - hl[0], _s = hl[3] - hl[1];
                  if (jl && this.annotationCanvasMap) {
                    Tl = Tl.slice(), Tl[4] -= hl[0], Tl[5] -= hl[1], hl = hl.slice(), hl[0] = hl[1] = 0, hl[2] = Al, hl[3] = _s;
                    const [Gs, vl] = Qi.Util.singularValueDecompose2dScale((0, Xi.getCurrentTransform)(this.ctx)), {
                      viewportScale: gl
                    } = this, El = Math.ceil(Al * this.outputScaleX * gl), Ol = Math.ceil(_s * this.outputScaleY * gl);
                    this.annotationCanvas = this.canvasFactory.create(El, Ol);
                    const {
                      canvas: wl,
                      context: dl
                    } = this.annotationCanvas;
                    this.annotationCanvasMap.set(yl, wl), this.annotationCanvas.savedCtx = this.ctx, this.ctx = dl, this.ctx.setTransform(Gs, 0, 0, -vl, 0, _s * vl), ws(this.ctx, this.foregroundColor);
                  } else
                    ws(this.ctx, this.foregroundColor), this.ctx.rect(hl[0], hl[1], Al, _s), this.ctx.clip(), this.endPath();
                }
                this.current = new Ys(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...Tl), this.transform(...Il);
              }
              endAnnotation() {
                this.annotationCanvas && (this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
              }
              paintImageMaskXObject(yl) {
                if (!this.contentVisible)
                  return;
                const hl = yl.count;
                yl = this.getObject(yl.data, yl), yl.count = hl;
                const Tl = this.ctx, Il = this.processingType3;
                if (Il && (Il.compiled === void 0 && (Il.compiled = Ks(yl)), Il.compiled)) {
                  Il.compiled(Tl);
                  return;
                }
                const jl = this._createMaskCanvas(yl), Al = jl.canvas;
                Tl.save(), Tl.setTransform(1, 0, 0, 1, 0, 0), Tl.drawImage(Al, jl.offsetX, jl.offsetY), Tl.restore(), this.compose();
              }
              paintImageMaskXObjectRepeat(yl, hl, Tl = 0, Il = 0, jl, Al) {
                if (!this.contentVisible)
                  return;
                yl = this.getObject(yl.data, yl);
                const _s = this.ctx;
                _s.save();
                const Gs = (0, Xi.getCurrentTransform)(_s);
                _s.transform(hl, Tl, Il, jl, 0, 0);
                const vl = this._createMaskCanvas(yl);
                _s.setTransform(1, 0, 0, 1, 0, 0);
                for (let gl = 0, El = Al.length; gl < El; gl += 2) {
                  const Ol = Qi.Util.transform(Gs, [hl, Tl, Il, jl, Al[gl], Al[gl + 1]]), [wl, dl] = Qi.Util.applyTransform([0, 0], Ol);
                  _s.drawImage(vl.canvas, wl, dl);
                }
                _s.restore(), this.compose();
              }
              paintImageMaskXObjectGroup(yl) {
                if (!this.contentVisible)
                  return;
                const hl = this.ctx, Tl = this.current.fillColor, Il = this.current.patternFill;
                for (const jl of yl) {
                  const {
                    data: Al,
                    width: _s,
                    height: Gs,
                    transform: vl
                  } = jl, gl = this.cachedCanvases.getCanvas("maskCanvas", _s, Gs), El = gl.context;
                  El.save();
                  const Ol = this.getObject(Al, jl);
                  Cs(El, Ol), El.globalCompositeOperation = "source-in", El.fillStyle = Il ? Tl.getPattern(El, this, (0, Xi.getCurrentTransformInverse)(hl), ta.PathType.FILL) : Tl, El.fillRect(0, 0, _s, Gs), El.restore(), hl.save(), hl.transform(...vl), hl.scale(1, -1), Hs(hl, gl.canvas, 0, 0, _s, Gs, 0, -1, 1, 1), hl.restore();
                }
                this.compose();
              }
              paintImageXObject(yl) {
                if (!this.contentVisible)
                  return;
                const hl = this.getObject(yl);
                if (!hl) {
                  (0, Qi.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(hl);
              }
              paintImageXObjectRepeat(yl, hl, Tl, Il) {
                if (!this.contentVisible)
                  return;
                const jl = this.getObject(yl);
                if (!jl) {
                  (0, Qi.warn)("Dependent image isn't ready yet");
                  return;
                }
                const Al = jl.width, _s = jl.height, Gs = [];
                for (let vl = 0, gl = Il.length; vl < gl; vl += 2)
                  Gs.push({
                    transform: [hl, 0, 0, Tl, Il[vl], Il[vl + 1]],
                    x: 0,
                    y: 0,
                    w: Al,
                    h: _s
                  });
                this.paintInlineImageXObjectGroup(jl, Gs);
              }
              paintInlineImageXObject(yl) {
                if (!this.contentVisible)
                  return;
                const hl = yl.width, Tl = yl.height, Il = this.ctx;
                this.save(), Il.scale(1 / hl, -1 / Tl);
                let jl;
                if (typeof HTMLElement == "function" && yl instanceof HTMLElement || !yl.data)
                  jl = yl;
                else {
                  const vl = this.cachedCanvases.getCanvas("inlineImage", hl, Tl), gl = vl.context;
                  Xs(gl, yl, this.current.transferMaps), jl = vl.canvas;
                }
                const Al = this._scaleImage(jl, (0, Xi.getCurrentTransformInverse)(Il));
                Il.imageSmoothingEnabled = bl((0, Xi.getCurrentTransform)(Il), yl.interpolate);
                const [_s, Gs] = Hs(Il, Al.img, 0, 0, Al.paintWidth, Al.paintHeight, 0, -Tl, hl, Tl);
                if (this.imageLayer) {
                  const [vl, gl] = Qi.Util.applyTransform([0, -Tl], (0, Xi.getCurrentTransform)(this.ctx));
                  this.imageLayer.appendImage({
                    imgData: yl,
                    left: vl,
                    top: gl,
                    width: _s,
                    height: Gs
                  });
                }
                this.compose(), this.restore();
              }
              paintInlineImageXObjectGroup(yl, hl) {
                if (!this.contentVisible)
                  return;
                const Tl = this.ctx, Il = yl.width, jl = yl.height, Al = this.cachedCanvases.getCanvas("inlineImage", Il, jl), _s = Al.context;
                Xs(_s, yl, this.current.transferMaps);
                for (const Gs of hl) {
                  if (Tl.save(), Tl.transform(...Gs.transform), Tl.scale(1, -1), Hs(Tl, Al.canvas, Gs.x, Gs.y, Gs.w, Gs.h, 0, -1, 1, 1), this.imageLayer) {
                    const [vl, gl] = Qi.Util.applyTransform([Gs.x, Gs.y], (0, Xi.getCurrentTransform)(this.ctx));
                    this.imageLayer.appendImage({
                      imgData: yl,
                      left: vl,
                      top: gl,
                      width: Il,
                      height: jl
                    });
                  }
                  Tl.restore();
                }
                this.compose();
              }
              paintSolidColorImageMask() {
                this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
              }
              markPoint(yl) {
              }
              markPointProps(yl, hl) {
              }
              beginMarkedContent(yl) {
                this.markedContentStack.push({
                  visible: !0
                });
              }
              beginMarkedContentProps(yl, hl) {
                yl === "OC" ? this.markedContentStack.push({
                  visible: this.optionalContentConfig.isVisible(hl)
                }) : this.markedContentStack.push({
                  visible: !0
                }), this.contentVisible = this.isContentVisible();
              }
              endMarkedContent() {
                this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
              }
              beginCompat() {
              }
              endCompat() {
              }
              consumePath(yl) {
                const hl = this.current.isEmptyClip();
                this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(yl);
                const Tl = this.ctx;
                this.pendingClip && (hl || (this.pendingClip === Dl ? Tl.clip("evenodd") : Tl.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), Tl.beginPath();
              }
              getSinglePixelWidth() {
                if (!this._cachedGetSinglePixelWidth) {
                  const yl = (0, Xi.getCurrentTransform)(this.ctx);
                  if (yl[1] === 0 && yl[2] === 0)
                    this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(yl[0]), Math.abs(yl[3]));
                  else {
                    const hl = Math.abs(yl[0] * yl[3] - yl[2] * yl[1]), Tl = Math.hypot(yl[0], yl[2]), Il = Math.hypot(yl[1], yl[3]);
                    this._cachedGetSinglePixelWidth = Math.max(Tl, Il) / hl;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
              getScaleForStroking() {
                if (!this._cachedScaleForStroking) {
                  const {
                    lineWidth: yl
                  } = this.current, hl = (0, Xi.getCurrentTransform)(this.ctx);
                  let Tl, Il;
                  if (hl[1] === 0 && hl[2] === 0) {
                    const jl = Math.abs(hl[0]), Al = Math.abs(hl[3]);
                    if (yl === 0)
                      Tl = 1 / jl, Il = 1 / Al;
                    else {
                      const _s = jl * yl, Gs = Al * yl;
                      Tl = _s < 1 ? 1 / _s : 1, Il = Gs < 1 ? 1 / Gs : 1;
                    }
                  } else {
                    const jl = Math.abs(hl[0] * hl[3] - hl[2] * hl[1]), Al = Math.hypot(hl[0], hl[1]), _s = Math.hypot(hl[2], hl[3]);
                    if (yl === 0)
                      Tl = _s / jl, Il = Al / jl;
                    else {
                      const Gs = yl * jl;
                      Tl = _s > Gs ? _s / Gs : 1, Il = Al > Gs ? Al / Gs : 1;
                    }
                  }
                  this._cachedScaleForStroking = [Tl, Il];
                }
                return this._cachedScaleForStroking;
              }
              rescaleAndStroke(yl) {
                const {
                  ctx: hl
                } = this, {
                  lineWidth: Tl
                } = this.current, [Il, jl] = this.getScaleForStroking();
                if (hl.lineWidth = Tl || 1, Il === 1 && jl === 1) {
                  hl.stroke();
                  return;
                }
                let Al, _s, Gs;
                yl && (Al = (0, Xi.getCurrentTransform)(hl), _s = hl.getLineDash().slice(), Gs = hl.lineDashOffset), hl.scale(Il, jl);
                const vl = Math.max(Il, jl);
                hl.setLineDash(hl.getLineDash().map((gl) => gl / vl)), hl.lineDashOffset /= vl, hl.stroke(), yl && (hl.setTransform(...Al), hl.setLineDash(_s), hl.lineDashOffset = Gs);
              }
              isContentVisible() {
                for (let yl = this.markedContentStack.length - 1; yl >= 0; yl--)
                  if (!this.markedContentStack[yl].visible)
                    return !1;
                return !0;
              }
            };
            Ul = new WeakSet(), af = function() {
              for (; this.stateStack.length || this.inSMaskMode; )
                this.restore();
              this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
            };
            let kl = Zl;
            e.CanvasGraphics = kl;
            for (const Pl in Qi.OPS)
              kl.prototype[Pl] !== void 0 && (kl.prototype[Qi.OPS[Pl]] = kl.prototype[Pl]);
          },
          /* 13 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TilingPattern = e.PathType = void 0, e.getShadingPattern = eo;
            var Xi = qi(1), Qi = qi(8), ta = qi(3);
            const ra = {
              FILL: "Fill",
              STROKE: "Stroke",
              SHADING: "Shading"
            };
            e.PathType = ra;
            function na(Hs, Ks) {
              if (!Ks || ta.isNodeJS)
                return;
              const Ys = Ks[2] - Ks[0], Xs = Ks[3] - Ks[1], Cs = new Path2D();
              Cs.rect(Ks[0], Ks[1], Ys, Xs), Hs.clip(Cs);
            }
            class la {
              constructor() {
                this.constructor === la && (0, Xi.unreachable)("Cannot initialize BaseShadingPattern.");
              }
              getPattern() {
                (0, Xi.unreachable)("Abstract method `getPattern` called.");
              }
            }
            class Ma extends la {
              constructor(Ks) {
                super(), this._type = Ks[1], this._bbox = Ks[2], this._colorStops = Ks[3], this._p0 = Ks[4], this._p1 = Ks[5], this._r0 = Ks[6], this._r1 = Ks[7], this.matrix = null;
              }
              _createGradient(Ks) {
                let Ys;
                this._type === "axial" ? Ys = Ks.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (Ys = Ks.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
                for (const Xs of this._colorStops)
                  Ys.addColorStop(Xs[0], Xs[1]);
                return Ys;
              }
              getPattern(Ks, Ys, Xs, Cs) {
                let Fs;
                if (Cs === ra.STROKE || Cs === ra.FILL) {
                  const ws = Ys.current.getClippedPathBoundingBox(Cs, (0, Qi.getCurrentTransform)(Ks)) || [0, 0, 0, 0], ls = Math.ceil(ws[2] - ws[0]) || 1, ks = Math.ceil(ws[3] - ws[1]) || 1, Js = Ys.cachedCanvases.getCanvas("pattern", ls, ks, !0), pl = Js.context;
                  pl.clearRect(0, 0, pl.canvas.width, pl.canvas.height), pl.beginPath(), pl.rect(0, 0, pl.canvas.width, pl.canvas.height), pl.translate(-ws[0], -ws[1]), Xs = Xi.Util.transform(Xs, [1, 0, 0, 1, ws[0], ws[1]]), pl.transform(...Ys.baseTransform), this.matrix && pl.transform(...this.matrix), na(pl, this._bbox), pl.fillStyle = this._createGradient(pl), pl.fill(), Fs = Ks.createPattern(Js.canvas, "no-repeat");
                  const _l = new DOMMatrix(Xs);
                  try {
                    Fs.setTransform(_l);
                  } catch (bl) {
                    (0, Xi.warn)(`RadialAxialShadingPattern.getPattern: "${bl?.message}".`);
                  }
                } else
                  na(Ks, this._bbox), Fs = this._createGradient(Ks);
                return Fs;
              }
            }
            function Va(Hs, Ks, Ys, Xs, Cs, Fs, ws, ls) {
              const ks = Ks.coords, Js = Ks.colors, pl = Hs.data, _l = Hs.width * 4;
              let bl;
              ks[Ys + 1] > ks[Xs + 1] && (bl = Ys, Ys = Xs, Xs = bl, bl = Fs, Fs = ws, ws = bl), ks[Xs + 1] > ks[Cs + 1] && (bl = Xs, Xs = Cs, Cs = bl, bl = ws, ws = ls, ls = bl), ks[Ys + 1] > ks[Xs + 1] && (bl = Ys, Ys = Xs, Xs = bl, bl = Fs, Fs = ws, ws = bl);
              const xl = (ks[Ys] + Ks.offsetX) * Ks.scaleX, Rl = (ks[Ys + 1] + Ks.offsetY) * Ks.scaleY, Cl = (ks[Xs] + Ks.offsetX) * Ks.scaleX, Dl = (ks[Xs + 1] + Ks.offsetY) * Ks.scaleY, kl = (ks[Cs] + Ks.offsetX) * Ks.scaleX, Ul = (ks[Cs + 1] + Ks.offsetY) * Ks.scaleY;
              if (Rl >= Ul)
                return;
              const Bl = Js[Fs], Zl = Js[Fs + 1], Pl = Js[Fs + 2], yl = Js[ws], hl = Js[ws + 1], Tl = Js[ws + 2], Il = Js[ls], jl = Js[ls + 1], Al = Js[ls + 2], _s = Math.round(Rl), Gs = Math.round(Ul);
              let vl, gl, El, Ol, wl, dl, Sl, Ml;
              for (let Fl = _s; Fl <= Gs; Fl++) {
                if (Fl < Dl) {
                  let zl;
                  Fl < Rl ? zl = 0 : zl = (Rl - Fl) / (Rl - Dl), vl = xl - (xl - Cl) * zl, gl = Bl - (Bl - yl) * zl, El = Zl - (Zl - hl) * zl, Ol = Pl - (Pl - Tl) * zl;
                } else {
                  let zl;
                  Fl > Ul ? zl = 1 : Dl === Ul ? zl = 0 : zl = (Dl - Fl) / (Dl - Ul), vl = Cl - (Cl - kl) * zl, gl = yl - (yl - Il) * zl, El = hl - (hl - jl) * zl, Ol = Tl - (Tl - Al) * zl;
                }
                let Ll;
                Fl < Rl ? Ll = 0 : Fl > Ul ? Ll = 1 : Ll = (Rl - Fl) / (Rl - Ul), wl = xl - (xl - kl) * Ll, dl = Bl - (Bl - Il) * Ll, Sl = Zl - (Zl - jl) * Ll, Ml = Pl - (Pl - Al) * Ll;
                const Nl = Math.round(Math.min(vl, wl)), ql = Math.round(Math.max(vl, wl));
                let Jl = _l * Fl + Nl * 4;
                for (let zl = Nl; zl <= ql; zl++)
                  Ll = (vl - zl) / (vl - wl), Ll < 0 ? Ll = 0 : Ll > 1 && (Ll = 1), pl[Jl++] = gl - (gl - dl) * Ll | 0, pl[Jl++] = El - (El - Sl) * Ll | 0, pl[Jl++] = Ol - (Ol - Ml) * Ll | 0, pl[Jl++] = 255;
              }
            }
            function to(Hs, Ks, Ys) {
              const Xs = Ks.coords, Cs = Ks.colors;
              let Fs, ws;
              switch (Ks.type) {
                case "lattice":
                  const ls = Ks.verticesPerRow, ks = Math.floor(Xs.length / ls) - 1, Js = ls - 1;
                  for (Fs = 0; Fs < ks; Fs++) {
                    let pl = Fs * ls;
                    for (let _l = 0; _l < Js; _l++, pl++)
                      Va(Hs, Ys, Xs[pl], Xs[pl + 1], Xs[pl + ls], Cs[pl], Cs[pl + 1], Cs[pl + ls]), Va(Hs, Ys, Xs[pl + ls + 1], Xs[pl + 1], Xs[pl + ls], Cs[pl + ls + 1], Cs[pl + 1], Cs[pl + ls]);
                  }
                  break;
                case "triangles":
                  for (Fs = 0, ws = Xs.length; Fs < ws; Fs += 3)
                    Va(Hs, Ys, Xs[Fs], Xs[Fs + 1], Xs[Fs + 2], Cs[Fs], Cs[Fs + 1], Cs[Fs + 2]);
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            class Eo extends la {
              constructor(Ks) {
                super(), this._coords = Ks[2], this._colors = Ks[3], this._figures = Ks[4], this._bounds = Ks[5], this._bbox = Ks[7], this._background = Ks[8], this.matrix = null;
              }
              _createMeshCanvas(Ks, Ys, Xs) {
                const ls = Math.floor(this._bounds[0]), ks = Math.floor(this._bounds[1]), Js = Math.ceil(this._bounds[2]) - ls, pl = Math.ceil(this._bounds[3]) - ks, _l = Math.min(Math.ceil(Math.abs(Js * Ks[0] * 1.1)), 3e3), bl = Math.min(Math.ceil(Math.abs(pl * Ks[1] * 1.1)), 3e3), xl = Js / _l, Rl = pl / bl, Cl = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -ls,
                  offsetY: -ks,
                  scaleX: 1 / xl,
                  scaleY: 1 / Rl
                }, Dl = _l + 4, kl = bl + 4, Ul = Xs.getCanvas("mesh", Dl, kl, !1), Bl = Ul.context, Zl = Bl.createImageData(_l, bl);
                if (Ys) {
                  const yl = Zl.data;
                  for (let hl = 0, Tl = yl.length; hl < Tl; hl += 4)
                    yl[hl] = Ys[0], yl[hl + 1] = Ys[1], yl[hl + 2] = Ys[2], yl[hl + 3] = 255;
                }
                for (const yl of this._figures)
                  to(Zl, yl, Cl);
                return Bl.putImageData(Zl, 2, 2), {
                  canvas: Ul.canvas,
                  offsetX: ls - 2 * xl,
                  offsetY: ks - 2 * Rl,
                  scaleX: xl,
                  scaleY: Rl
                };
              }
              getPattern(Ks, Ys, Xs, Cs) {
                na(Ks, this._bbox);
                let Fs;
                if (Cs === ra.SHADING)
                  Fs = Xi.Util.singularValueDecompose2dScale((0, Qi.getCurrentTransform)(Ks));
                else if (Fs = Xi.Util.singularValueDecompose2dScale(Ys.baseTransform), this.matrix) {
                  const ls = Xi.Util.singularValueDecompose2dScale(this.matrix);
                  Fs = [Fs[0] * ls[0], Fs[1] * ls[1]];
                }
                const ws = this._createMeshCanvas(Fs, Cs === ra.SHADING ? null : this._background, Ys.cachedCanvases);
                return Cs !== ra.SHADING && (Ks.setTransform(...Ys.baseTransform), this.matrix && Ks.transform(...this.matrix)), Ks.translate(ws.offsetX, ws.offsetY), Ks.scale(ws.scaleX, ws.scaleY), Ks.createPattern(ws.canvas, "no-repeat");
              }
            }
            class So extends la {
              getPattern() {
                return "hotpink";
              }
            }
            function eo(Hs) {
              switch (Hs[0]) {
                case "RadialAxial":
                  return new Ma(Hs);
                case "Mesh":
                  return new Eo(Hs);
                case "Dummy":
                  return new So();
              }
              throw new Error(`Unknown IR type: ${Hs[0]}`);
            }
            const rs = {
              COLORED: 1,
              UNCOLORED: 2
            };
            class ko {
              static get MAX_PATTERN_SIZE() {
                return (0, Xi.shadow)(this, "MAX_PATTERN_SIZE", 3e3);
              }
              constructor(Ks, Ys, Xs, Cs, Fs) {
                this.operatorList = Ks[2], this.matrix = Ks[3] || [1, 0, 0, 1, 0, 0], this.bbox = Ks[4], this.xstep = Ks[5], this.ystep = Ks[6], this.paintType = Ks[7], this.tilingType = Ks[8], this.color = Ys, this.ctx = Xs, this.canvasGraphicsFactory = Cs, this.baseTransform = Fs;
              }
              createPatternCanvas(Ks) {
                const Ys = this.operatorList, Xs = this.bbox, Cs = this.xstep, Fs = this.ystep, ws = this.paintType, ls = this.tilingType, ks = this.color, Js = this.canvasGraphicsFactory;
                (0, Xi.info)("TilingType: " + ls);
                const pl = Xs[0], _l = Xs[1], bl = Xs[2], xl = Xs[3], Rl = Xi.Util.singularValueDecompose2dScale(this.matrix), Cl = Xi.Util.singularValueDecompose2dScale(this.baseTransform), Dl = [Rl[0] * Cl[0], Rl[1] * Cl[1]], kl = this.getSizeAndScale(Cs, this.ctx.canvas.width, Dl[0]), Ul = this.getSizeAndScale(Fs, this.ctx.canvas.height, Dl[1]), Bl = Ks.cachedCanvases.getCanvas("pattern", kl.size, Ul.size, !0), Zl = Bl.context, Pl = Js.createCanvasGraphics(Zl);
                Pl.groupLevel = Ks.groupLevel, this.setFillAndStrokeStyleToContext(Pl, ws, ks);
                let yl = pl, hl = _l, Tl = bl, Il = xl;
                return pl < 0 && (yl = 0, Tl += Math.abs(pl)), _l < 0 && (hl = 0, Il += Math.abs(_l)), Zl.translate(-(kl.scale * yl), -(Ul.scale * hl)), Pl.transform(kl.scale, 0, 0, Ul.scale, 0, 0), Zl.save(), this.clipBbox(Pl, yl, hl, Tl, Il), Pl.baseTransform = (0, Qi.getCurrentTransform)(Pl.ctx), Pl.executeOperatorList(Ys), Pl.endDrawing(), {
                  canvas: Bl.canvas,
                  scaleX: kl.scale,
                  scaleY: Ul.scale,
                  offsetX: yl,
                  offsetY: hl
                };
              }
              getSizeAndScale(Ks, Ys, Xs) {
                Ks = Math.abs(Ks);
                const Cs = Math.max(ko.MAX_PATTERN_SIZE, Ys);
                let Fs = Math.ceil(Ks * Xs);
                return Fs >= Cs ? Fs = Cs : Xs = Fs / Ks, {
                  scale: Xs,
                  size: Fs
                };
              }
              clipBbox(Ks, Ys, Xs, Cs, Fs) {
                const ws = Cs - Ys, ls = Fs - Xs;
                Ks.ctx.rect(Ys, Xs, ws, ls), Ks.current.updateRectMinMax((0, Qi.getCurrentTransform)(Ks.ctx), [Ys, Xs, Cs, Fs]), Ks.clip(), Ks.endPath();
              }
              setFillAndStrokeStyleToContext(Ks, Ys, Xs) {
                const Cs = Ks.ctx, Fs = Ks.current;
                switch (Ys) {
                  case rs.COLORED:
                    const ws = this.ctx;
                    Cs.fillStyle = ws.fillStyle, Cs.strokeStyle = ws.strokeStyle, Fs.fillColor = ws.fillStyle, Fs.strokeColor = ws.strokeStyle;
                    break;
                  case rs.UNCOLORED:
                    const ls = Xi.Util.makeHexColor(Xs[0], Xs[1], Xs[2]);
                    Cs.fillStyle = ls, Cs.strokeStyle = ls, Fs.fillColor = ls, Fs.strokeColor = ls;
                    break;
                  default:
                    throw new Xi.FormatError(`Unsupported paint type: ${Ys}`);
                }
              }
              getPattern(Ks, Ys, Xs, Cs) {
                let Fs = Xs;
                Cs !== ra.SHADING && (Fs = Xi.Util.transform(Fs, Ys.baseTransform), this.matrix && (Fs = Xi.Util.transform(Fs, this.matrix)));
                const ws = this.createPatternCanvas(Ys);
                let ls = new DOMMatrix(Fs);
                ls = ls.translate(ws.offsetX, ws.offsetY), ls = ls.scale(1 / ws.scaleX, 1 / ws.scaleY);
                const ks = Ks.createPattern(ws.canvas, "repeat");
                try {
                  ks.setTransform(ls);
                } catch (Js) {
                  (0, Xi.warn)(`TilingPattern.getPattern: "${Js?.message}".`);
                }
                return ks;
              }
            }
            e.TilingPattern = ko;
          },
          /* 14 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.applyMaskImageData = Qi;
            var Xi = qi(1);
            function Qi({
              src: ta,
              srcPos: ra = 0,
              dest: na,
              destPos: la = 0,
              width: Ma,
              height: Va,
              inverseDecode: to = !1
            }) {
              const Eo = Xi.FeatureTest.isLittleEndian ? 4278190080 : 255, [So, eo] = to ? [0, Eo] : [Eo, 0], rs = Ma >> 3, ko = Ma & 7, Hs = ta.length;
              na = new Uint32Array(na.buffer);
              for (let Ks = 0; Ks < Va; Ks++) {
                for (const Xs = ra + rs; ra < Xs; ra++) {
                  const Cs = ra < Hs ? ta[ra] : 255;
                  na[la++] = Cs & 128 ? eo : So, na[la++] = Cs & 64 ? eo : So, na[la++] = Cs & 32 ? eo : So, na[la++] = Cs & 16 ? eo : So, na[la++] = Cs & 8 ? eo : So, na[la++] = Cs & 4 ? eo : So, na[la++] = Cs & 2 ? eo : So, na[la++] = Cs & 1 ? eo : So;
                }
                if (ko === 0)
                  continue;
                const Ys = ra < Hs ? ta[ra++] : 255;
                for (let Xs = 0; Xs < ko; Xs++)
                  na[la++] = Ys & 1 << 7 - Xs ? eo : So;
              }
              return {
                srcPos: ra,
                destPos: la
              };
            }
          },
          /* 15 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.GlobalWorkerOptions = void 0;
            const qi = /* @__PURE__ */ Object.create(null);
            e.GlobalWorkerOptions = qi, qi.workerPort = qi.workerPort === void 0 ? null : qi.workerPort, qi.workerSrc = qi.workerSrc === void 0 ? "" : qi.workerSrc;
          },
          /* 16 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.MessageHandler = void 0;
            var Xi = qi(1);
            const Qi = {
              DATA: 1,
              ERROR: 2
            }, ta = {
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function ra(la) {
              switch (la instanceof Error || typeof la == "object" && la !== null || (0, Xi.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), la.name) {
                case "AbortException":
                  return new Xi.AbortException(la.message);
                case "MissingPDFException":
                  return new Xi.MissingPDFException(la.message);
                case "PasswordException":
                  return new Xi.PasswordException(la.message, la.code);
                case "UnexpectedResponseException":
                  return new Xi.UnexpectedResponseException(la.message, la.status);
                case "UnknownErrorException":
                  return new Xi.UnknownErrorException(la.message, la.details);
                default:
                  return new Xi.UnknownErrorException(la.message, la.toString());
              }
            }
            class na {
              constructor(Ma, Va, to) {
                this.sourceName = Ma, this.targetName = Va, this.comObj = to, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (Eo) => {
                  const So = Eo.data;
                  if (So.targetName !== this.sourceName)
                    return;
                  if (So.stream) {
                    this._processStreamMessage(So);
                    return;
                  }
                  if (So.callback) {
                    const rs = So.callbackId, ko = this.callbackCapabilities[rs];
                    if (!ko)
                      throw new Error(`Cannot resolve callback ${rs}`);
                    if (delete this.callbackCapabilities[rs], So.callback === Qi.DATA)
                      ko.resolve(So.data);
                    else if (So.callback === Qi.ERROR)
                      ko.reject(ra(So.reason));
                    else
                      throw new Error("Unexpected callback case");
                    return;
                  }
                  const eo = this.actionHandler[So.action];
                  if (!eo)
                    throw new Error(`Unknown action from worker: ${So.action}`);
                  if (So.callbackId) {
                    const rs = this.sourceName, ko = So.sourceName;
                    new Promise(function(Hs) {
                      Hs(eo(So.data));
                    }).then(function(Hs) {
                      to.postMessage({
                        sourceName: rs,
                        targetName: ko,
                        callback: Qi.DATA,
                        callbackId: So.callbackId,
                        data: Hs
                      });
                    }, function(Hs) {
                      to.postMessage({
                        sourceName: rs,
                        targetName: ko,
                        callback: Qi.ERROR,
                        callbackId: So.callbackId,
                        reason: ra(Hs)
                      });
                    });
                    return;
                  }
                  if (So.streamId) {
                    this._createStreamSink(So);
                    return;
                  }
                  eo(So.data);
                }, to.addEventListener("message", this._onComObjOnMessage);
              }
              on(Ma, Va) {
                const to = this.actionHandler;
                if (to[Ma])
                  throw new Error(`There is already an actionName called "${Ma}"`);
                to[Ma] = Va;
              }
              send(Ma, Va, to) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: Ma,
                  data: Va
                }, to);
              }
              sendWithPromise(Ma, Va, to) {
                const Eo = this.callbackId++, So = (0, Xi.createPromiseCapability)();
                this.callbackCapabilities[Eo] = So;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: Ma,
                    callbackId: Eo,
                    data: Va
                  }, to);
                } catch (eo) {
                  So.reject(eo);
                }
                return So.promise;
              }
              sendWithStream(Ma, Va, to, Eo) {
                const So = this.streamId++, eo = this.sourceName, rs = this.targetName, ko = this.comObj;
                return new ReadableStream({
                  start: (Hs) => {
                    const Ks = (0, Xi.createPromiseCapability)();
                    return this.streamControllers[So] = {
                      controller: Hs,
                      startCall: Ks,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: !1
                    }, ko.postMessage({
                      sourceName: eo,
                      targetName: rs,
                      action: Ma,
                      streamId: So,
                      data: Va,
                      desiredSize: Hs.desiredSize
                    }, Eo), Ks.promise;
                  },
                  pull: (Hs) => {
                    const Ks = (0, Xi.createPromiseCapability)();
                    return this.streamControllers[So].pullCall = Ks, ko.postMessage({
                      sourceName: eo,
                      targetName: rs,
                      stream: ta.PULL,
                      streamId: So,
                      desiredSize: Hs.desiredSize
                    }), Ks.promise;
                  },
                  cancel: (Hs) => {
                    (0, Xi.assert)(Hs instanceof Error, "cancel must have a valid reason");
                    const Ks = (0, Xi.createPromiseCapability)();
                    return this.streamControllers[So].cancelCall = Ks, this.streamControllers[So].isClosed = !0, ko.postMessage({
                      sourceName: eo,
                      targetName: rs,
                      stream: ta.CANCEL,
                      streamId: So,
                      reason: ra(Hs)
                    }), Ks.promise;
                  }
                }, to);
              }
              _createStreamSink(Ma) {
                const Va = Ma.streamId, to = this.sourceName, Eo = Ma.sourceName, So = this.comObj, eo = this, rs = this.actionHandler[Ma.action], ko = {
                  enqueue(Hs, Ks = 1, Ys) {
                    if (this.isCancelled)
                      return;
                    const Xs = this.desiredSize;
                    this.desiredSize -= Ks, Xs > 0 && this.desiredSize <= 0 && (this.sinkCapability = (0, Xi.createPromiseCapability)(), this.ready = this.sinkCapability.promise), So.postMessage({
                      sourceName: to,
                      targetName: Eo,
                      stream: ta.ENQUEUE,
                      streamId: Va,
                      chunk: Hs
                    }, Ys);
                  },
                  close() {
                    this.isCancelled || (this.isCancelled = !0, So.postMessage({
                      sourceName: to,
                      targetName: Eo,
                      stream: ta.CLOSE,
                      streamId: Va
                    }), delete eo.streamSinks[Va]);
                  },
                  error(Hs) {
                    (0, Xi.assert)(Hs instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, So.postMessage({
                      sourceName: to,
                      targetName: Eo,
                      stream: ta.ERROR,
                      streamId: Va,
                      reason: ra(Hs)
                    }));
                  },
                  sinkCapability: (0, Xi.createPromiseCapability)(),
                  onPull: null,
                  onCancel: null,
                  isCancelled: !1,
                  desiredSize: Ma.desiredSize,
                  ready: null
                };
                ko.sinkCapability.resolve(), ko.ready = ko.sinkCapability.promise, this.streamSinks[Va] = ko, new Promise(function(Hs) {
                  Hs(rs(Ma.data, ko));
                }).then(function() {
                  So.postMessage({
                    sourceName: to,
                    targetName: Eo,
                    stream: ta.START_COMPLETE,
                    streamId: Va,
                    success: !0
                  });
                }, function(Hs) {
                  So.postMessage({
                    sourceName: to,
                    targetName: Eo,
                    stream: ta.START_COMPLETE,
                    streamId: Va,
                    reason: ra(Hs)
                  });
                });
              }
              _processStreamMessage(Ma) {
                const Va = Ma.streamId, to = this.sourceName, Eo = Ma.sourceName, So = this.comObj, eo = this.streamControllers[Va], rs = this.streamSinks[Va];
                switch (Ma.stream) {
                  case ta.START_COMPLETE:
                    Ma.success ? eo.startCall.resolve() : eo.startCall.reject(ra(Ma.reason));
                    break;
                  case ta.PULL_COMPLETE:
                    Ma.success ? eo.pullCall.resolve() : eo.pullCall.reject(ra(Ma.reason));
                    break;
                  case ta.PULL:
                    if (!rs) {
                      So.postMessage({
                        sourceName: to,
                        targetName: Eo,
                        stream: ta.PULL_COMPLETE,
                        streamId: Va,
                        success: !0
                      });
                      break;
                    }
                    rs.desiredSize <= 0 && Ma.desiredSize > 0 && rs.sinkCapability.resolve(), rs.desiredSize = Ma.desiredSize, new Promise(function(ko) {
                      ko(rs.onPull && rs.onPull());
                    }).then(function() {
                      So.postMessage({
                        sourceName: to,
                        targetName: Eo,
                        stream: ta.PULL_COMPLETE,
                        streamId: Va,
                        success: !0
                      });
                    }, function(ko) {
                      So.postMessage({
                        sourceName: to,
                        targetName: Eo,
                        stream: ta.PULL_COMPLETE,
                        streamId: Va,
                        reason: ra(ko)
                      });
                    });
                    break;
                  case ta.ENQUEUE:
                    if ((0, Xi.assert)(eo, "enqueue should have stream controller"), eo.isClosed)
                      break;
                    eo.controller.enqueue(Ma.chunk);
                    break;
                  case ta.CLOSE:
                    if ((0, Xi.assert)(eo, "close should have stream controller"), eo.isClosed)
                      break;
                    eo.isClosed = !0, eo.controller.close(), this._deleteStreamController(eo, Va);
                    break;
                  case ta.ERROR:
                    (0, Xi.assert)(eo, "error should have stream controller"), eo.controller.error(ra(Ma.reason)), this._deleteStreamController(eo, Va);
                    break;
                  case ta.CANCEL_COMPLETE:
                    Ma.success ? eo.cancelCall.resolve() : eo.cancelCall.reject(ra(Ma.reason)), this._deleteStreamController(eo, Va);
                    break;
                  case ta.CANCEL:
                    if (!rs)
                      break;
                    new Promise(function(ko) {
                      ko(rs.onCancel && rs.onCancel(ra(Ma.reason)));
                    }).then(function() {
                      So.postMessage({
                        sourceName: to,
                        targetName: Eo,
                        stream: ta.CANCEL_COMPLETE,
                        streamId: Va,
                        success: !0
                      });
                    }, function(ko) {
                      So.postMessage({
                        sourceName: to,
                        targetName: Eo,
                        stream: ta.CANCEL_COMPLETE,
                        streamId: Va,
                        reason: ra(ko)
                      });
                    }), rs.sinkCapability.reject(ra(Ma.reason)), rs.isCancelled = !0, delete this.streamSinks[Va];
                    break;
                  default:
                    throw new Error("Unexpected stream case");
                }
              }
              async _deleteStreamController(Ma, Va) {
                await Promise.allSettled([Ma.startCall && Ma.startCall.promise, Ma.pullCall && Ma.pullCall.promise, Ma.cancelCall && Ma.cancelCall.promise]), delete this.streamControllers[Va];
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            e.MessageHandler = na;
          },
          /* 17 */
          /***/
          (Bi, e, qi) => {
            var ta, ra;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.Metadata = void 0;
            var Xi = qi(1);
            class Qi {
              constructor({
                parsedData: la,
                rawData: Ma
              }) {
                $u(this, ta);
                $u(this, ra);
                Hu(this, ta, la), Hu(this, ra, Ma);
              }
              getRaw() {
                return Vl(this, ra);
              }
              get(la) {
                return Vl(this, ta).get(la) ?? null;
              }
              getAll() {
                return (0, Xi.objectFromMap)(Vl(this, ta));
              }
              has(la) {
                return Vl(this, ta).has(la);
              }
            }
            ta = new WeakMap(), ra = new WeakMap(), e.Metadata = Qi;
          },
          /* 18 */
          /***/
          (Bi, e, qi) => {
            var na, la, Ma, Va, to, Eo, of;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.OptionalContentConfig = void 0;
            var Xi = qi(1);
            const Qi = Symbol("INTERNAL");
            class ta {
              constructor(rs, ko) {
                $u(this, na, !0);
                this.name = rs, this.intent = ko;
              }
              get visible() {
                return Vl(this, na);
              }
              _setVisible(rs, ko) {
                rs !== Qi && (0, Xi.unreachable)("Internal method `_setVisible` called."), Hu(this, na, ko);
              }
            }
            na = new WeakMap();
            class ra {
              constructor(rs) {
                $u(this, Eo);
                $u(this, la, !0);
                $u(this, Ma, /* @__PURE__ */ new Map());
                $u(this, Va, null);
                $u(this, to, null);
                if (this.name = null, this.creator = null, rs !== null) {
                  this.name = rs.name, this.creator = rs.creator, Hu(this, to, rs.order);
                  for (const ko of rs.groups)
                    Vl(this, Ma).set(ko.id, new ta(ko.name, ko.intent));
                  if (rs.baseState === "OFF")
                    for (const ko of Vl(this, Ma).values())
                      ko._setVisible(Qi, !1);
                  for (const ko of rs.on)
                    Vl(this, Ma).get(ko)._setVisible(Qi, !0);
                  for (const ko of rs.off)
                    Vl(this, Ma).get(ko)._setVisible(Qi, !1);
                  Hu(this, Va, /* @__PURE__ */ new Map());
                  for (const [ko, Hs] of Vl(this, Ma))
                    Vl(this, Va).set(ko, Hs.visible);
                }
              }
              isVisible(rs) {
                if (Vl(this, Ma).size === 0)
                  return !0;
                if (!rs)
                  return (0, Xi.warn)("Optional content group not defined."), !0;
                if (rs.type === "OCG")
                  return Vl(this, Ma).has(rs.id) ? Vl(this, Ma).get(rs.id).visible : ((0, Xi.warn)(`Optional content group not found: ${rs.id}`), !0);
                if (rs.type === "OCMD") {
                  if (rs.expression)
                    return rc(this, Eo, of).call(this, rs.expression);
                  if (!rs.policy || rs.policy === "AnyOn") {
                    for (const ko of rs.ids) {
                      if (!Vl(this, Ma).has(ko))
                        return (0, Xi.warn)(`Optional content group not found: ${ko}`), !0;
                      if (Vl(this, Ma).get(ko).visible)
                        return !0;
                    }
                    return !1;
                  } else if (rs.policy === "AllOn") {
                    for (const ko of rs.ids) {
                      if (!Vl(this, Ma).has(ko))
                        return (0, Xi.warn)(`Optional content group not found: ${ko}`), !0;
                      if (!Vl(this, Ma).get(ko).visible)
                        return !1;
                    }
                    return !0;
                  } else if (rs.policy === "AnyOff") {
                    for (const ko of rs.ids) {
                      if (!Vl(this, Ma).has(ko))
                        return (0, Xi.warn)(`Optional content group not found: ${ko}`), !0;
                      if (!Vl(this, Ma).get(ko).visible)
                        return !0;
                    }
                    return !1;
                  } else if (rs.policy === "AllOff") {
                    for (const ko of rs.ids) {
                      if (!Vl(this, Ma).has(ko))
                        return (0, Xi.warn)(`Optional content group not found: ${ko}`), !0;
                      if (Vl(this, Ma).get(ko).visible)
                        return !1;
                    }
                    return !0;
                  }
                  return (0, Xi.warn)(`Unknown optional content policy ${rs.policy}.`), !0;
                }
                return (0, Xi.warn)(`Unknown group type ${rs.type}.`), !0;
              }
              setVisibility(rs, ko = !0) {
                if (!Vl(this, Ma).has(rs)) {
                  (0, Xi.warn)(`Optional content group not found: ${rs}`);
                  return;
                }
                Vl(this, Ma).get(rs)._setVisible(Qi, !!ko), Hu(this, la, null);
              }
              get hasInitialVisibility() {
                if (Vl(this, la) !== null)
                  return Vl(this, la);
                for (const [rs, ko] of Vl(this, Ma)) {
                  const Hs = Vl(this, Va).get(rs);
                  if (ko.visible !== Hs)
                    return Hu(this, la, !1);
                }
                return Hu(this, la, !0);
              }
              getOrder() {
                return Vl(this, Ma).size ? Vl(this, to) ? Vl(this, to).slice() : [...Vl(this, Ma).keys()] : null;
              }
              getGroups() {
                return Vl(this, Ma).size > 0 ? (0, Xi.objectFromMap)(Vl(this, Ma)) : null;
              }
              getGroup(rs) {
                return Vl(this, Ma).get(rs) || null;
              }
            }
            la = new WeakMap(), Ma = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), Eo = new WeakSet(), of = function(rs) {
              const ko = rs.length;
              if (ko < 2)
                return !0;
              const Hs = rs[0];
              for (let Ks = 1; Ks < ko; Ks++) {
                const Ys = rs[Ks];
                let Xs;
                if (Array.isArray(Ys))
                  Xs = rc(this, Eo, of).call(this, Ys);
                else if (Vl(this, Ma).has(Ys))
                  Xs = Vl(this, Ma).get(Ys).visible;
                else
                  return (0, Xi.warn)(`Optional content group not found: ${Ys}`), !0;
                switch (Hs) {
                  case "And":
                    if (!Xs)
                      return !1;
                    break;
                  case "Or":
                    if (Xs)
                      return !0;
                    break;
                  case "Not":
                    return !Xs;
                  default:
                    return !0;
                }
              }
              return Hs === "And";
            }, e.OptionalContentConfig = ra;
          },
          /* 19 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFDataTransportStream = void 0;
            var Xi = qi(1), Qi = qi(8);
            class ta {
              constructor(Ma, Va) {
                (0, Xi.assert)(Va, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = Ma.progressiveDone || !1, this._contentDispositionFilename = Ma.contentDispositionFilename || null;
                const to = Ma.initialData;
                if (to?.length > 0) {
                  const Eo = new Uint8Array(to).buffer;
                  this._queuedChunks.push(Eo);
                }
                this._pdfDataRangeTransport = Va, this._isStreamingSupported = !Ma.disableStream, this._isRangeSupported = !Ma.disableRange, this._contentLength = Ma.length, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((Eo, So) => {
                  this._onReceiveData({
                    begin: Eo,
                    chunk: So
                  });
                }), this._pdfDataRangeTransport.addProgressListener((Eo, So) => {
                  this._onProgress({
                    loaded: Eo,
                    total: So
                  });
                }), this._pdfDataRangeTransport.addProgressiveReadListener((Eo) => {
                  this._onReceiveData({
                    chunk: Eo
                  });
                }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                  this._onProgressiveDone();
                }), this._pdfDataRangeTransport.transportReady();
              }
              _onReceiveData(Ma) {
                const Va = new Uint8Array(Ma.chunk).buffer;
                if (Ma.begin === void 0)
                  this._fullRequestReader ? this._fullRequestReader._enqueue(Va) : this._queuedChunks.push(Va);
                else {
                  const to = this._rangeReaders.some(function(Eo) {
                    return Eo._begin !== Ma.begin ? !1 : (Eo._enqueue(Va), !0);
                  });
                  (0, Xi.assert)(to, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              _onProgress(Ma) {
                if (Ma.total === void 0) {
                  const Va = this._rangeReaders[0];
                  Va?.onProgress && Va.onProgress({
                    loaded: Ma.loaded
                  });
                } else {
                  const Va = this._fullRequestReader;
                  Va?.onProgress && Va.onProgress({
                    loaded: Ma.loaded,
                    total: Ma.total
                  });
                }
              }
              _onProgressiveDone() {
                this._fullRequestReader && this._fullRequestReader.progressiveDone(), this._progressiveDone = !0;
              }
              _removeRangeReader(Ma) {
                const Va = this._rangeReaders.indexOf(Ma);
                Va >= 0 && this._rangeReaders.splice(Va, 1);
              }
              getFullReader() {
                (0, Xi.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                const Ma = this._queuedChunks;
                return this._queuedChunks = null, new ra(this, Ma, this._progressiveDone, this._contentDispositionFilename);
              }
              getRangeReader(Ma, Va) {
                if (Va <= this._progressiveDataLength)
                  return null;
                const to = new na(this, Ma, Va);
                return this._pdfDataRangeTransport.requestDataRange(Ma, Va), this._rangeReaders.push(to), to;
              }
              cancelAllRequests(Ma) {
                this._fullRequestReader && this._fullRequestReader.cancel(Ma);
                for (const Va of this._rangeReaders.slice(0))
                  Va.cancel(Ma);
                this._pdfDataRangeTransport.abort();
              }
            }
            e.PDFDataTransportStream = ta;
            class ra {
              constructor(Ma, Va, to = !1, Eo = null) {
                this._stream = Ma, this._done = to || !1, this._filename = (0, Qi.isPdfFile)(Eo) ? Eo : null, this._queuedChunks = Va || [], this._loaded = 0;
                for (const So of this._queuedChunks)
                  this._loaded += So.byteLength;
                this._requests = [], this._headersReady = Promise.resolve(), Ma._fullRequestReader = this, this.onProgress = null;
              }
              _enqueue(Ma) {
                this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: Ma,
                  done: !1
                }) : this._queuedChunks.push(Ma), this._loaded += Ma.byteLength);
              }
              get headersReady() {
                return this._headersReady;
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._stream._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._stream._isStreamingSupported;
              }
              get contentLength() {
                return this._stream._contentLength;
              }
              async read() {
                if (this._queuedChunks.length > 0)
                  return {
                    value: this._queuedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const Ma = (0, Xi.createPromiseCapability)();
                return this._requests.push(Ma), Ma.promise;
              }
              cancel(Ma) {
                this._done = !0;
                for (const Va of this._requests)
                  Va.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
              progressiveDone() {
                this._done || (this._done = !0);
              }
            }
            class na {
              constructor(Ma, Va, to) {
                this._stream = Ma, this._begin = Va, this._end = to, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
              }
              _enqueue(Ma) {
                if (!this._done) {
                  if (this._requests.length === 0)
                    this._queuedChunk = Ma;
                  else {
                    this._requests.shift().resolve({
                      value: Ma,
                      done: !1
                    });
                    for (const to of this._requests)
                      to.resolve({
                        value: void 0,
                        done: !0
                      });
                    this._requests.length = 0;
                  }
                  this._done = !0, this._stream._removeRangeReader(this);
                }
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._queuedChunk) {
                  const Va = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: Va,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const Ma = (0, Xi.createPromiseCapability)();
                return this._requests.push(Ma), Ma.promise;
              }
              cancel(Ma) {
                this._done = !0;
                for (const Va of this._requests)
                  Va.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._stream._removeRangeReader(this);
              }
            }
          },
          /* 20 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.XfaText = void 0;
            class qi {
              static textContent(Qi) {
                const ta = [], ra = {
                  items: ta,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function na(la) {
                  if (!la)
                    return;
                  let Ma = null;
                  const Va = la.name;
                  if (Va === "#text")
                    Ma = la.value;
                  else if (qi.shouldBuildText(Va))
                    la?.attributes?.textContent ? Ma = la.attributes.textContent : la.value && (Ma = la.value);
                  else return;
                  if (Ma !== null && ta.push({
                    str: Ma
                  }), !!la.children)
                    for (const to of la.children)
                      na(to);
                }
                return na(Qi), ra;
              }
              static shouldBuildText(Qi) {
                return !(Qi === "textarea" || Qi === "input" || Qi === "option" || Qi === "select");
              }
            }
            e.XfaText = qi;
          },
          /* 21 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.NodeStandardFontDataFactory = e.NodeCanvasFactory = e.NodeCMapReaderFactory = void 0;
            var Xi = qi(9);
            const Qi = function(la) {
              return new Promise((Ma, Va) => {
                require$$5.readFile(la, (Eo, So) => {
                  if (Eo || !So) {
                    Va(new Error(Eo));
                    return;
                  }
                  Ma(new Uint8Array(So));
                });
              });
            };
            class ta extends Xi.BaseCanvasFactory {
              _createCanvas(Ma, Va) {
                return require$$5.createCanvas(Ma, Va);
              }
            }
            e.NodeCanvasFactory = ta;
            class ra extends Xi.BaseCMapReaderFactory {
              _fetchData(Ma, Va) {
                return Qi(Ma).then((to) => ({
                  cMapData: to,
                  compressionType: Va
                }));
              }
            }
            e.NodeCMapReaderFactory = ra;
            class na extends Xi.BaseStandardFontDataFactory {
              _fetchData(Ma) {
                return Qi(Ma);
              }
            }
            e.NodeStandardFontDataFactory = na;
          },
          /* 22 */
          /***/
          (Bi, e, qi) => {
            var la, Ma, Va, to, Eo, So, eo, rs, ko, sf, Df, lf, Rf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationEditorLayer = void 0;
            var Xi = qi(7), Qi = qi(1), ta = qi(23), ra = qi(24);
            const Cs = class Cs {
              constructor(ws) {
                $u(this, ko);
                $u(this, la);
                $u(this, Ma, !1);
                $u(this, Va, this.pointerup.bind(this));
                $u(this, to, this.pointerdown.bind(this));
                $u(this, Eo, /* @__PURE__ */ new Map());
                $u(this, So, !1);
                $u(this, eo, !1);
                $u(this, rs);
                Cs._initialized || (Cs._initialized = !0, ta.FreeTextEditor.initialize(ws.l10n), ra.InkEditor.initialize(ws.l10n), ws.uiManager.registerEditorTypes([ta.FreeTextEditor, ra.InkEditor])), Hu(this, rs, ws.uiManager), this.annotationStorage = ws.annotationStorage, this.pageIndex = ws.pageIndex, this.div = ws.div, Hu(this, la, ws.accessibilityManager), Vl(this, rs).addLayer(this);
              }
              updateToolbar(ws) {
                Vl(this, rs).updateToolbar(ws);
              }
              updateMode(ws = Vl(this, rs).getMode()) {
                rc(this, ko, Rf).call(this), ws === Qi.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), Vl(this, rs).unselectAll();
              }
              addInkEditorIfNeeded(ws) {
                if (!ws && Vl(this, rs).getMode() !== Qi.AnnotationEditorType.INK)
                  return;
                if (!ws) {
                  for (const ks of Vl(this, Eo).values())
                    if (ks.isEmpty()) {
                      ks.setInBackground();
                      return;
                    }
                }
                rc(this, ko, lf).call(this, {
                  offsetX: 0,
                  offsetY: 0
                }).setInBackground();
              }
              setEditingState(ws) {
                Vl(this, rs).setEditingState(ws);
              }
              addCommands(ws) {
                Vl(this, rs).addCommands(ws);
              }
              enable() {
                this.div.style.pointerEvents = "auto";
                for (const ws of Vl(this, Eo).values())
                  ws.enableEditing();
              }
              disable() {
                this.div.style.pointerEvents = "none";
                for (const ws of Vl(this, Eo).values())
                  ws.disableEditing();
              }
              setActiveEditor(ws) {
                Vl(this, rs).getActive() !== ws && Vl(this, rs).setActiveEditor(ws);
              }
              enableClick() {
                this.div.addEventListener("pointerdown", Vl(this, to)), this.div.addEventListener("pointerup", Vl(this, Va));
              }
              disableClick() {
                this.div.removeEventListener("pointerdown", Vl(this, to)), this.div.removeEventListener("pointerup", Vl(this, Va));
              }
              attach(ws) {
                Vl(this, Eo).set(ws.id, ws);
              }
              detach(ws) {
                Vl(this, Eo).delete(ws.id), Vl(this, la)?.removePointerInTextLayer(ws.contentDiv);
              }
              remove(ws) {
                Vl(this, rs).removeEditor(ws), this.detach(ws), this.annotationStorage.remove(ws.id), ws.div.style.display = "none", setTimeout(() => {
                  ws.div.style.display = "", ws.div.remove(), ws.isAttachedToDOM = !1, document.activeElement === document.body && Vl(this, rs).focusMainContainer();
                }, 0), Vl(this, eo) || this.addInkEditorIfNeeded(!1);
              }
              add(ws) {
                if (rc(this, ko, sf).call(this, ws), Vl(this, rs).addEditor(ws), this.attach(ws), !ws.isAttachedToDOM) {
                  const ls = ws.render();
                  this.div.append(ls), ws.isAttachedToDOM = !0;
                }
                this.moveEditorInDOM(ws), ws.onceAdded(), this.addToAnnotationStorage(ws);
              }
              moveEditorInDOM(ws) {
                Vl(this, la)?.moveElementInDOM(this.div, ws.div, ws.contentDiv, !0);
              }
              addToAnnotationStorage(ws) {
                !ws.isEmpty() && !this.annotationStorage.has(ws.id) && this.annotationStorage.setValue(ws.id, ws);
              }
              addOrRebuild(ws) {
                ws.needsToBeRebuilt() ? ws.rebuild() : this.add(ws);
              }
              addANewEditor(ws) {
                const ls = () => {
                  this.addOrRebuild(ws);
                }, ks = () => {
                  ws.remove();
                };
                this.addCommands({
                  cmd: ls,
                  undo: ks,
                  mustExec: !0
                });
              }
              addUndoableEditor(ws) {
                const ls = () => {
                  this.addOrRebuild(ws);
                }, ks = () => {
                  ws.remove();
                };
                this.addCommands({
                  cmd: ls,
                  undo: ks,
                  mustExec: !1
                });
              }
              getNextId() {
                return Vl(this, rs).getId();
              }
              deserialize(ws) {
                switch (ws.annotationType) {
                  case Qi.AnnotationEditorType.FREETEXT:
                    return ta.FreeTextEditor.deserialize(ws, this);
                  case Qi.AnnotationEditorType.INK:
                    return ra.InkEditor.deserialize(ws, this);
                }
                return null;
              }
              setSelected(ws) {
                Vl(this, rs).setSelected(ws);
              }
              toggleSelected(ws) {
                Vl(this, rs).toggleSelected(ws);
              }
              isSelected(ws) {
                return Vl(this, rs).isSelected(ws);
              }
              unselect(ws) {
                Vl(this, rs).unselect(ws);
              }
              pointerup(ws) {
                const ls = Xi.KeyboardManager.platform.isMac;
                if (!(ws.button !== 0 || ws.ctrlKey && ls) && ws.target === this.div && Vl(this, So)) {
                  if (Hu(this, So, !1), !Vl(this, Ma)) {
                    Hu(this, Ma, !0);
                    return;
                  }
                  rc(this, ko, lf).call(this, ws);
                }
              }
              pointerdown(ws) {
                const ls = Xi.KeyboardManager.platform.isMac;
                if (ws.button !== 0 || ws.ctrlKey && ls || ws.target !== this.div)
                  return;
                Hu(this, So, !0);
                const ks = Vl(this, rs).getActive();
                Hu(this, Ma, !ks || ks.isEmpty());
              }
              drop(ws) {
                const ls = ws.dataTransfer.getData("text/plain"), ks = Vl(this, rs).getEditor(ls);
                if (!ks)
                  return;
                ws.preventDefault(), ws.dataTransfer.dropEffect = "move", rc(this, ko, sf).call(this, ks);
                const Js = this.div.getBoundingClientRect(), pl = ws.clientX - Js.x, _l = ws.clientY - Js.y;
                ks.translate(pl - ks.startX, _l - ks.startY), this.moveEditorInDOM(ks), ks.div.focus();
              }
              dragover(ws) {
                ws.preventDefault();
              }
              destroy() {
                Vl(this, rs).getActive()?.parent === this && Vl(this, rs).setActiveEditor(null);
                for (const ws of Vl(this, Eo).values())
                  Vl(this, la)?.removePointerInTextLayer(ws.contentDiv), ws.isAttachedToDOM = !1, ws.div.remove(), ws.parent = null;
                this.div = null, Vl(this, Eo).clear(), Vl(this, rs).removeLayer(this);
              }
              render(ws) {
                this.viewport = ws.viewport, (0, Xi.bindEvents)(this, this.div, ["dragover", "drop"]), this.setDimensions();
                for (const ls of Vl(this, rs).getEditors(this.pageIndex))
                  this.add(ls);
                this.updateMode();
              }
              update(ws) {
                this.viewport = ws.viewport, this.setDimensions(), this.updateMode();
              }
              get scaleFactor() {
                return this.viewport.scale;
              }
              get pageDimensions() {
                const [ws, ls, ks, Js] = this.viewport.viewBox, pl = ks - ws, _l = Js - ls;
                return [pl, _l];
              }
              get viewportBaseDimensions() {
                const {
                  width: ws,
                  height: ls,
                  rotation: ks
                } = this.viewport;
                return ks % 180 === 0 ? [ws, ls] : [ls, ws];
              }
              setDimensions() {
                const {
                  width: ws,
                  height: ls,
                  rotation: ks
                } = this.viewport, Js = ks % 180 !== 0, pl = Math.floor(ws) + "px", _l = Math.floor(ls) + "px";
                this.div.style.width = Js ? _l : pl, this.div.style.height = Js ? pl : _l, this.div.setAttribute("data-main-rotation", ks);
              }
            };
            la = new WeakMap(), Ma = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), Eo = new WeakMap(), So = new WeakMap(), eo = new WeakMap(), rs = new WeakMap(), ko = new WeakSet(), sf = function(ws) {
              ws.parent !== this && (this.attach(ws), ws.pageIndex = this.pageIndex, ws.parent?.detach(ws), ws.parent = this, ws.div && ws.isAttachedToDOM && (ws.div.remove(), this.div.append(ws.div)));
            }, Df = function(ws) {
              switch (Vl(this, rs).getMode()) {
                case Qi.AnnotationEditorType.FREETEXT:
                  return new ta.FreeTextEditor(ws);
                case Qi.AnnotationEditorType.INK:
                  return new ra.InkEditor(ws);
              }
              return null;
            }, lf = function(ws) {
              const ls = this.getNextId(), ks = rc(this, ko, Df).call(this, {
                parent: this,
                id: ls,
                x: ws.offsetX,
                y: ws.offsetY
              });
              return ks && this.add(ks), ks;
            }, Rf = function() {
              Hu(this, eo, !0);
              for (const ws of Vl(this, Eo).values())
                ws.isEmpty() && ws.remove();
              Hu(this, eo, !1);
            }, cd(Cs, "_initialized", !1);
            let na = Cs;
            e.AnnotationEditorLayer = na;
          },
          /* 23 */
          /***/
          (Bi, e, qi) => {
            var na, la, Ma, Va, to, Eo, So, eo, If, Mf, Ff, cf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.FreeTextEditor = void 0;
            var Xi = qi(1), Qi = qi(7), ta = qi(6);
            const Ys = class Ys extends ta.AnnotationEditor {
              constructor(Fs) {
                super({
                  ...Fs,
                  name: "freeTextEditor"
                });
                $u(this, eo);
                $u(this, na, this.editorDivBlur.bind(this));
                $u(this, la, this.editorDivFocus.bind(this));
                $u(this, Ma, this.editorDivKeydown.bind(this));
                $u(this, Va);
                $u(this, to, "");
                $u(this, Eo, !1);
                $u(this, So);
                Hu(this, Va, Fs.color || Ys._defaultColor || ta.AnnotationEditor._defaultLineColor), Hu(this, So, Fs.fontSize || Ys._defaultFontSize);
              }
              static initialize(Fs) {
                this._l10nPromise = new Map(["free_text_default_content", "editor_free_text_aria_label"].map((ls) => [ls, Fs.get(ls)]));
                const ws = getComputedStyle(document.documentElement);
                this._internalPadding = parseFloat(ws.getPropertyValue("--freetext-padding"));
              }
              static updateDefaultParams(Fs, ws) {
                switch (Fs) {
                  case Xi.AnnotationEditorParamsType.FREETEXT_SIZE:
                    Ys._defaultFontSize = ws;
                    break;
                  case Xi.AnnotationEditorParamsType.FREETEXT_COLOR:
                    Ys._defaultColor = ws;
                    break;
                }
              }
              updateParams(Fs, ws) {
                switch (Fs) {
                  case Xi.AnnotationEditorParamsType.FREETEXT_SIZE:
                    rc(this, eo, If).call(this, ws);
                    break;
                  case Xi.AnnotationEditorParamsType.FREETEXT_COLOR:
                    rc(this, eo, Mf).call(this, ws);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[Xi.AnnotationEditorParamsType.FREETEXT_SIZE, Ys._defaultFontSize], [Xi.AnnotationEditorParamsType.FREETEXT_COLOR, Ys._defaultColor || ta.AnnotationEditor._defaultLineColor]];
              }
              get propertiesToUpdate() {
                return [[Xi.AnnotationEditorParamsType.FREETEXT_SIZE, Vl(this, So)], [Xi.AnnotationEditorParamsType.FREETEXT_COLOR, Vl(this, Va)]];
              }
              getInitialTranslation() {
                return [-Ys._internalPadding * this.parent.scaleFactor, -(Ys._internalPadding + Vl(this, So)) * this.parent.scaleFactor];
              }
              rebuild() {
                super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this));
              }
              enableEditMode() {
                this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(Xi.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.enableEditing(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this.div.draggable = !1, this.editorDiv.addEventListener("keydown", Vl(this, Ma)), this.editorDiv.addEventListener("focus", Vl(this, la)), this.editorDiv.addEventListener("blur", Vl(this, na)));
              }
              disableEditMode() {
                this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.disableEditing(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.draggable = !0, this.editorDiv.removeEventListener("keydown", Vl(this, Ma)), this.editorDiv.removeEventListener("focus", Vl(this, la)), this.editorDiv.removeEventListener("blur", Vl(this, na)), this.div.focus(), this.isEditing = !1);
              }
              focusin(Fs) {
                super.focusin(Fs), Fs.target !== this.editorDiv && this.editorDiv.focus();
              }
              onceAdded() {
                this.width || (this.enableEditMode(), this.editorDiv.focus());
              }
              isEmpty() {
                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
              }
              remove() {
                this.isEditing = !1, this.parent.setEditingState(!0), super.remove();
              }
              commit() {
                super.commit(), Vl(this, Eo) || (Hu(this, Eo, !0), this.parent.addUndoableEditor(this)), this.disableEditMode(), Hu(this, to, rc(this, eo, Ff).call(this).trimEnd()), rc(this, eo, cf).call(this);
              }
              shouldGetKeyboardEvents() {
                return this.isInEditMode();
              }
              dblclick(Fs) {
                this.enableEditMode(), this.editorDiv.focus();
              }
              keydown(Fs) {
                Fs.target === this.div && Fs.key === "Enter" && (this.enableEditMode(), this.editorDiv.focus());
              }
              editorDivKeydown(Fs) {
                Ys._keyboardManager.exec(this, Fs);
              }
              editorDivFocus(Fs) {
                this.isEditing = !0;
              }
              editorDivBlur(Fs) {
                this.isEditing = !1;
              }
              disableEditing() {
                this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
              }
              enableEditing() {
                this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
              }
              render() {
                if (this.div)
                  return this.div;
                let Fs, ws;
                this.width && (Fs = this.x, ws = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", `${this.id}-editor`), this.enableEditing(), Ys._l10nPromise.get("editor_free_text_aria_label").then((ks) => this.editorDiv?.setAttribute("aria-label", ks)), Ys._l10nPromise.get("free_text_default_content").then((ks) => this.editorDiv?.setAttribute("default-content", ks)), this.editorDiv.contentEditable = !0;
                const {
                  style: ls
                } = this.editorDiv;
                if (ls.fontSize = `calc(${Vl(this, So)}px * var(--scale-factor))`, ls.color = Vl(this, Va), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, Qi.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                  const [ks, Js] = this.parent.viewportBaseDimensions;
                  this.setAt(Fs * ks, ws * Js, this.width * ks, this.height * Js);
                  for (const pl of Vl(this, to).split(`
`)) {
                    const _l = document.createElement("div");
                    _l.append(pl ? document.createTextNode(pl) : document.createElement("br")), this.editorDiv.append(_l);
                  }
                  this.div.draggable = !0, this.editorDiv.contentEditable = !1;
                } else
                  this.div.draggable = !1, this.editorDiv.contentEditable = !0;
                return this.div;
              }
              get contentDiv() {
                return this.editorDiv;
              }
              static deserialize(Fs, ws) {
                const ls = super.deserialize(Fs, ws);
                return Hu(ls, So, Fs.fontSize), Hu(ls, Va, Xi.Util.makeHexColor(...Fs.color)), Hu(ls, to, Fs.value), ls;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const Fs = Ys._internalPadding * this.parent.scaleFactor, ws = this.getRect(Fs, Fs), ls = ta.AnnotationEditor._colorManager.convert(getComputedStyle(this.editorDiv).color);
                return {
                  annotationType: Xi.AnnotationEditorType.FREETEXT,
                  color: ls,
                  fontSize: Vl(this, So),
                  value: Vl(this, to),
                  pageIndex: this.parent.pageIndex,
                  rect: ws,
                  rotation: this.rotation
                };
              }
            };
            na = new WeakMap(), la = new WeakMap(), Ma = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), Eo = new WeakMap(), So = new WeakMap(), eo = new WeakSet(), If = function(Fs) {
              const ws = (ks) => {
                this.editorDiv.style.fontSize = `calc(${ks}px * var(--scale-factor))`, this.translate(0, -(ks - Vl(this, So)) * this.parent.scaleFactor), Hu(this, So, ks), rc(this, eo, cf).call(this);
              }, ls = Vl(this, So);
              this.parent.addCommands({
                cmd: () => {
                  ws(Fs);
                },
                undo: () => {
                  ws(ls);
                },
                mustExec: !0,
                type: Xi.AnnotationEditorParamsType.FREETEXT_SIZE,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Mf = function(Fs) {
              const ws = Vl(this, Va);
              this.parent.addCommands({
                cmd: () => {
                  Hu(this, Va, Fs), this.editorDiv.style.color = Fs;
                },
                undo: () => {
                  Hu(this, Va, ws), this.editorDiv.style.color = ws;
                },
                mustExec: !0,
                type: Xi.AnnotationEditorParamsType.FREETEXT_COLOR,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Ff = function() {
              const Fs = this.editorDiv.getElementsByTagName("div");
              if (Fs.length === 0)
                return this.editorDiv.innerText;
              const ws = [];
              for (let ls = 0, ks = Fs.length; ls < ks; ls++) {
                const pl = Fs[ls].firstChild;
                pl?.nodeName === "#text" ? ws.push(pl.data) : ws.push("");
              }
              return ws.join(`
`);
            }, cf = function() {
              const [Fs, ws] = this.parent.viewportBaseDimensions, ls = this.div.getBoundingClientRect();
              this.width = ls.width / Fs, this.height = ls.height / ws;
            }, cd(Ys, "_freeTextDefaultContent", ""), cd(Ys, "_l10nPromise"), cd(Ys, "_internalPadding", 0), cd(Ys, "_defaultColor", null), cd(Ys, "_defaultFontSize", 10), cd(Ys, "_keyboardManager", new Qi.KeyboardManager([[["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], Ys.prototype.commitOrRemove]])), cd(Ys, "_type", "freetext");
            let ra = Ys;
            e.FreeTextEditor = ra;
          },
          /* 24 */
          /***/
          (Bi, e, qi) => {
            var Ma, Va, to, Eo, So, eo, rs, ko, Hs, Ks, Ys, Xs, Cs, Fs, ws, jf, Nf, Lf, Vf, uf, Bf, Uf, zf, Td, df, Hd, Kd, Md, ff, qd, yl, pf, Hf, Kf, qf, vf, Wd, Fd, mf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.InkEditor = void 0, Object.defineProperty(e, "fitCurve", {
              enumerable: !0,
              get: function() {
                return ta.fitCurve;
              }
            });
            var Xi = qi(1), Qi = qi(6), ta = qi(25), ra = qi(7);
            const na = 16, gl = class gl extends Qi.AnnotationEditor {
              constructor(wl) {
                super({
                  ...wl,
                  name: "inkEditor"
                });
                $u(this, ws);
                $u(this, Ma, 0);
                $u(this, Va, 0);
                $u(this, to, 0);
                $u(this, Eo, this.canvasPointermove.bind(this));
                $u(this, So, this.canvasPointerleave.bind(this));
                $u(this, eo, this.canvasPointerup.bind(this));
                $u(this, rs, this.canvasPointerdown.bind(this));
                $u(this, ko, !1);
                $u(this, Hs, !1);
                $u(this, Ks, null);
                $u(this, Ys, null);
                $u(this, Xs, 0);
                $u(this, Cs, 0);
                $u(this, Fs, null);
                this.color = wl.color || null, this.thickness = wl.thickness || null, this.opacity = wl.opacity || null, this.paths = [], this.bezierPath2D = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0;
              }
              static initialize(wl) {
                this._l10nPromise = new Map(["editor_ink_canvas_aria_label", "editor_ink_aria_label"].map((dl) => [dl, wl.get(dl)]));
              }
              static updateDefaultParams(wl, dl) {
                switch (wl) {
                  case Xi.AnnotationEditorParamsType.INK_THICKNESS:
                    gl._defaultThickness = dl;
                    break;
                  case Xi.AnnotationEditorParamsType.INK_COLOR:
                    gl._defaultColor = dl;
                    break;
                  case Xi.AnnotationEditorParamsType.INK_OPACITY:
                    gl._defaultOpacity = dl / 100;
                    break;
                }
              }
              updateParams(wl, dl) {
                switch (wl) {
                  case Xi.AnnotationEditorParamsType.INK_THICKNESS:
                    rc(this, ws, jf).call(this, dl);
                    break;
                  case Xi.AnnotationEditorParamsType.INK_COLOR:
                    rc(this, ws, Nf).call(this, dl);
                    break;
                  case Xi.AnnotationEditorParamsType.INK_OPACITY:
                    rc(this, ws, Lf).call(this, dl);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[Xi.AnnotationEditorParamsType.INK_THICKNESS, gl._defaultThickness], [Xi.AnnotationEditorParamsType.INK_COLOR, gl._defaultColor || Qi.AnnotationEditor._defaultLineColor], [Xi.AnnotationEditorParamsType.INK_OPACITY, Math.round(gl._defaultOpacity * 100)]];
              }
              get propertiesToUpdate() {
                return [[Xi.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || gl._defaultThickness], [Xi.AnnotationEditorParamsType.INK_COLOR, this.color || gl._defaultColor || Qi.AnnotationEditor._defaultLineColor], [Xi.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? gl._defaultOpacity))]];
              }
              rebuild() {
                super.rebuild(), this.div !== null && (this.canvas || (rc(this, ws, Hd).call(this), rc(this, ws, Kd).call(this)), this.isAttachedToDOM || (this.parent.add(this), rc(this, ws, Md).call(this)), rc(this, ws, Fd).call(this));
              }
              remove() {
                this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, Vl(this, Ys).disconnect(), Hu(this, Ys, null), super.remove());
              }
              enableEditMode() {
                Vl(this, ko) || this.canvas === null || (super.enableEditMode(), this.div.draggable = !1, this.canvas.addEventListener("pointerdown", Vl(this, rs)), this.canvas.addEventListener("pointerup", Vl(this, eo)));
              }
              disableEditMode() {
                !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this.div.draggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", Vl(this, rs)), this.canvas.removeEventListener("pointerup", Vl(this, eo)));
              }
              onceAdded() {
                this.div.draggable = !this.isEmpty();
              }
              isEmpty() {
                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
              }
              commit() {
                Vl(this, ko) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), Hu(this, ko, !0), this.div.classList.add("disabled"), rc(this, ws, Fd).call(this, !0), this.parent.addInkEditorIfNeeded(!0), this.parent.moveEditorInDOM(this), this.div.focus());
              }
              focusin(wl) {
                super.focusin(wl), this.enableEditMode();
              }
              canvasPointerdown(wl) {
                wl.button !== 0 || !this.isInEditMode() || Vl(this, ko) || (this.setInForeground(), wl.type !== "mouse" && this.div.focus(), wl.stopPropagation(), this.canvas.addEventListener("pointerleave", Vl(this, So)), this.canvas.addEventListener("pointermove", Vl(this, Eo)), rc(this, ws, Bf).call(this, wl.offsetX, wl.offsetY));
              }
              canvasPointermove(wl) {
                wl.stopPropagation(), rc(this, ws, Uf).call(this, wl.offsetX, wl.offsetY);
              }
              canvasPointerup(wl) {
                wl.button === 0 && this.isInEditMode() && this.currentPath.length !== 0 && (wl.stopPropagation(), rc(this, ws, df).call(this, wl), this.setInBackground());
              }
              canvasPointerleave(wl) {
                rc(this, ws, df).call(this, wl), this.setInBackground();
              }
              render() {
                if (this.div)
                  return this.div;
                let wl, dl;
                this.width && (wl = this.x, dl = this.y), super.render(), gl._l10nPromise.get("editor_ink_aria_label").then((Nl) => this.div?.setAttribute("aria-label", Nl));
                const [Sl, Ml, Fl, Ll] = rc(this, ws, Vf).call(this);
                if (this.setAt(Sl, Ml, 0, 0), this.setDims(Fl, Ll), rc(this, ws, Hd).call(this), this.width) {
                  const [Nl, ql] = this.parent.viewportBaseDimensions;
                  this.setAt(wl * Nl, dl * ql, this.width * Nl, this.height * ql), Hu(this, Hs, !0), rc(this, ws, Md).call(this), this.setDims(this.width * Nl, this.height * ql), rc(this, ws, Td).call(this), rc(this, ws, mf).call(this), this.div.classList.add("disabled");
                } else
                  this.div.classList.add("editing"), this.enableEditMode();
                return rc(this, ws, Kd).call(this), this.div;
              }
              setDimensions(wl, dl) {
                const Sl = Math.round(wl), Ml = Math.round(dl);
                if (Vl(this, Xs) === Sl && Vl(this, Cs) === Ml)
                  return;
                Hu(this, Xs, Sl), Hu(this, Cs, Ml), this.canvas.style.visibility = "hidden", Vl(this, Ma) && Math.abs(Vl(this, Ma) - wl / dl) > 0.01 && (dl = Math.ceil(wl / Vl(this, Ma)), this.setDims(wl, dl));
                const [Fl, Ll] = this.parent.viewportBaseDimensions;
                this.width = wl / Fl, this.height = dl / Ll, Vl(this, ko) && rc(this, ws, ff).call(this, wl, dl), rc(this, ws, Md).call(this), rc(this, ws, Td).call(this), this.canvas.style.visibility = "visible";
              }
              static deserialize(wl, dl) {
                var tc, Ku;
                const Sl = super.deserialize(wl, dl);
                Sl.thickness = wl.thickness, Sl.color = Xi.Util.makeHexColor(...wl.color), Sl.opacity = wl.opacity;
                const [Ml, Fl] = dl.pageDimensions, Ll = Sl.width * Ml, Nl = Sl.height * Fl, ql = dl.scaleFactor, Jl = wl.thickness / 2;
                Hu(Sl, Ma, Ll / Nl), Hu(Sl, ko, !0), Hu(Sl, Xs, Math.round(Ll)), Hu(Sl, Cs, Math.round(Nl));
                for (const {
                  bezier: tu
                } of wl.paths) {
                  const Gu = [];
                  Sl.paths.push(Gu);
                  let Qu = ql * (tu[0] - Jl), ed = ql * (Nl - tu[1] - Jl);
                  for (let od = 2, ld = tu.length; od < ld; od += 6) {
                    const sd = ql * (tu[od] - Jl), bd = ql * (Nl - tu[od + 1] - Jl), $d = ql * (tu[od + 2] - Jl), _d = ql * (Nl - tu[od + 3] - Jl), ec = ql * (tu[od + 4] - Jl), Xl = ql * (Nl - tu[od + 5] - Jl);
                    Gu.push([[Qu, ed], [sd, bd], [$d, _d], [ec, Xl]]), Qu = ec, ed = Xl;
                  }
                  const td = rc(this, yl, pf).call(this, Gu);
                  Sl.bezierPath2D.push(td);
                }
                const zl = rc(tc = Sl, ws, vf).call(tc);
                return Hu(Sl, to, Math.max(na, zl[2] - zl[0])), Hu(Sl, Va, Math.max(na, zl[3] - zl[1])), rc(Ku = Sl, ws, ff).call(Ku, Ll, Nl), Sl;
              }
              serialize() {
                if (this.isEmpty())
                  return null;
                const wl = this.getRect(0, 0), dl = this.rotation % 180 === 0 ? wl[3] - wl[1] : wl[2] - wl[0], Sl = Qi.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                return {
                  annotationType: Xi.AnnotationEditorType.INK,
                  color: Sl,
                  thickness: this.thickness,
                  opacity: this.opacity,
                  paths: rc(this, ws, Hf).call(this, this.scaleFactor / this.parent.scaleFactor, this.translationX, this.translationY, dl),
                  pageIndex: this.parent.pageIndex,
                  rect: wl,
                  rotation: this.rotation
                };
              }
            };
            Ma = new WeakMap(), Va = new WeakMap(), to = new WeakMap(), Eo = new WeakMap(), So = new WeakMap(), eo = new WeakMap(), rs = new WeakMap(), ko = new WeakMap(), Hs = new WeakMap(), Ks = new WeakMap(), Ys = new WeakMap(), Xs = new WeakMap(), Cs = new WeakMap(), Fs = new WeakMap(), ws = new WeakSet(), jf = function(wl) {
              const dl = this.thickness;
              this.parent.addCommands({
                cmd: () => {
                  this.thickness = wl, rc(this, ws, Fd).call(this);
                },
                undo: () => {
                  this.thickness = dl, rc(this, ws, Fd).call(this);
                },
                mustExec: !0,
                type: Xi.AnnotationEditorParamsType.INK_THICKNESS,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Nf = function(wl) {
              const dl = this.color;
              this.parent.addCommands({
                cmd: () => {
                  this.color = wl, rc(this, ws, Td).call(this);
                },
                undo: () => {
                  this.color = dl, rc(this, ws, Td).call(this);
                },
                mustExec: !0,
                type: Xi.AnnotationEditorParamsType.INK_COLOR,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Lf = function(wl) {
              wl /= 100;
              const dl = this.opacity;
              this.parent.addCommands({
                cmd: () => {
                  this.opacity = wl, rc(this, ws, Td).call(this);
                },
                undo: () => {
                  this.opacity = dl, rc(this, ws, Td).call(this);
                },
                mustExec: !0,
                type: Xi.AnnotationEditorParamsType.INK_OPACITY,
                overwriteIfSameType: !0,
                keepUndo: !0
              });
            }, Vf = function() {
              const {
                width: wl,
                height: dl,
                rotation: Sl
              } = this.parent.viewport;
              switch (Sl) {
                case 90:
                  return [0, wl, wl, dl];
                case 180:
                  return [wl, dl, wl, dl];
                case 270:
                  return [dl, 0, wl, dl];
                default:
                  return [0, 0, wl, dl];
              }
            }, uf = function() {
              this.ctx.lineWidth = this.thickness * this.parent.scaleFactor / this.scaleFactor, this.ctx.lineCap = "round", this.ctx.lineJoin = "round", this.ctx.miterLimit = 10, this.ctx.strokeStyle = `${this.color}${(0, ra.opacityToHex)(this.opacity)}`;
            }, Bf = function(wl, dl) {
              this.isEditing = !0, Vl(this, Hs) || (Hu(this, Hs, !0), rc(this, ws, Md).call(this), this.thickness || (this.thickness = gl._defaultThickness), this.color || (this.color = gl._defaultColor || Qi.AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = gl._defaultOpacity)), this.currentPath.push([wl, dl]), Hu(this, Ks, null), rc(this, ws, uf).call(this), this.ctx.beginPath(), this.ctx.moveTo(wl, dl), Hu(this, Fs, () => {
                Vl(this, Fs) && (Vl(this, Ks) && (this.isEmpty() ? (this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)) : rc(this, ws, Td).call(this), this.ctx.lineTo(...Vl(this, Ks)), Hu(this, Ks, null), this.ctx.stroke()), window.requestAnimationFrame(Vl(this, Fs)));
              }), window.requestAnimationFrame(Vl(this, Fs));
            }, Uf = function(wl, dl) {
              const [Sl, Ml] = this.currentPath.at(-1);
              wl === Sl && dl === Ml || (this.currentPath.push([wl, dl]), Hu(this, Ks, [wl, dl]));
            }, zf = function(wl, dl) {
              var Jl;
              this.ctx.closePath(), Hu(this, Fs, null), wl = Math.min(Math.max(wl, 0), this.canvas.width), dl = Math.min(Math.max(dl, 0), this.canvas.height);
              const [Sl, Ml] = this.currentPath.at(-1);
              (wl !== Sl || dl !== Ml) && this.currentPath.push([wl, dl]);
              let Fl;
              if (this.currentPath.length !== 1)
                Fl = (0, ta.fitCurve)(this.currentPath, 30, null);
              else {
                const zl = [wl, dl];
                Fl = [[zl, zl.slice(), zl.slice(), zl]];
              }
              const Ll = rc(Jl = gl, yl, pf).call(Jl, Fl);
              this.currentPath.length = 0;
              const Nl = () => {
                this.paths.push(Fl), this.bezierPath2D.push(Ll), this.rebuild();
              }, ql = () => {
                this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (rc(this, ws, Hd).call(this), rc(this, ws, Kd).call(this)), rc(this, ws, Fd).call(this));
              };
              this.parent.addCommands({
                cmd: Nl,
                undo: ql,
                mustExec: !0
              });
            }, Td = function() {
              if (this.isEmpty()) {
                rc(this, ws, qd).call(this);
                return;
              }
              rc(this, ws, uf).call(this);
              const {
                canvas: wl,
                ctx: dl
              } = this;
              dl.setTransform(1, 0, 0, 1, 0, 0), dl.clearRect(0, 0, wl.width, wl.height), rc(this, ws, qd).call(this);
              for (const Sl of this.bezierPath2D)
                dl.stroke(Sl);
            }, df = function(wl) {
              rc(this, ws, zf).call(this, wl.offsetX, wl.offsetY), this.canvas.removeEventListener("pointerleave", Vl(this, So)), this.canvas.removeEventListener("pointermove", Vl(this, Eo)), this.parent.addToAnnotationStorage(this);
            }, Hd = function() {
              this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", gl._l10nPromise.get("editor_ink_canvas_aria_label").then((wl) => this.canvas?.setAttribute("aria-label", wl)), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
            }, Kd = function() {
              Hu(this, Ys, new ResizeObserver((wl) => {
                const dl = wl[0].contentRect;
                dl.width && dl.height && this.setDimensions(dl.width, dl.height);
              })), Vl(this, Ys).observe(this.div);
            }, Md = function() {
              if (!Vl(this, Hs))
                return;
              const [wl, dl] = this.parent.viewportBaseDimensions;
              this.canvas.width = Math.ceil(this.width * wl), this.canvas.height = Math.ceil(this.height * dl), rc(this, ws, qd).call(this);
            }, ff = function(wl, dl) {
              const Sl = rc(this, ws, Wd).call(this), Ml = (wl - Sl) / Vl(this, to), Fl = (dl - Sl) / Vl(this, Va);
              this.scaleFactor = Math.min(Ml, Fl);
            }, qd = function() {
              const wl = rc(this, ws, Wd).call(this) / 2;
              this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + wl, this.translationY * this.scaleFactor + wl);
            }, yl = new WeakSet(), pf = function(wl) {
              const dl = new Path2D();
              for (let Sl = 0, Ml = wl.length; Sl < Ml; Sl++) {
                const [Fl, Ll, Nl, ql] = wl[Sl];
                Sl === 0 && dl.moveTo(...Fl), dl.bezierCurveTo(Ll[0], Ll[1], Nl[0], Nl[1], ql[0], ql[1]);
              }
              return dl;
            }, Hf = function(wl, dl, Sl, Ml) {
              const Ll = [], Nl = this.thickness / 2;
              let ql, Jl;
              for (const zl of this.paths) {
                ql = [], Jl = [];
                for (let tc = 0, Ku = zl.length; tc < Ku; tc++) {
                  const [tu, Gu, Qu, ed] = zl[tc], td = wl * (tu[0] + dl) + Nl, od = Ml - wl * (tu[1] + Sl) - Nl, ld = wl * (Gu[0] + dl) + Nl, sd = Ml - wl * (Gu[1] + Sl) - Nl, bd = wl * (Qu[0] + dl) + Nl, $d = Ml - wl * (Qu[1] + Sl) - Nl, _d = wl * (ed[0] + dl) + Nl, ec = Ml - wl * (ed[1] + Sl) - Nl;
                  tc === 0 && (ql.push(td, od), Jl.push(td, od)), ql.push(ld, sd, bd, $d, _d, ec), rc(this, ws, Kf).call(this, td, od, ld, sd, bd, $d, _d, ec, 4, Jl);
                }
                Ll.push({
                  bezier: ql,
                  points: Jl
                });
              }
              return Ll;
            }, Kf = function(wl, dl, Sl, Ml, Fl, Ll, Nl, ql, Jl, zl) {
              if (rc(this, ws, qf).call(this, wl, dl, Sl, Ml, Fl, Ll, Nl, ql)) {
                zl.push(Nl, ql);
                return;
              }
              for (let tc = 1; tc < Jl - 1; tc++) {
                const Ku = tc / Jl, tu = 1 - Ku;
                let Gu = Ku * wl + tu * Sl, Qu = Ku * dl + tu * Ml, ed = Ku * Sl + tu * Fl, td = Ku * Ml + tu * Ll;
                const od = Ku * Fl + tu * Nl, ld = Ku * Ll + tu * ql;
                Gu = Ku * Gu + tu * ed, Qu = Ku * Qu + tu * td, ed = Ku * ed + tu * od, td = Ku * td + tu * ld, Gu = Ku * Gu + tu * ed, Qu = Ku * Qu + tu * td, zl.push(Gu, Qu);
              }
              zl.push(Nl, ql);
            }, qf = function(wl, dl, Sl, Ml, Fl, Ll, Nl, ql) {
              const zl = (3 * Sl - 2 * wl - Nl) ** 2, tc = (3 * Ml - 2 * dl - ql) ** 2, Ku = (3 * Fl - wl - 2 * Nl) ** 2, tu = (3 * Ll - dl - 2 * ql) ** 2;
              return Math.max(zl, Ku) + Math.max(tc, tu) <= 10;
            }, vf = function() {
              let wl = 1 / 0, dl = -1 / 0, Sl = 1 / 0, Ml = -1 / 0;
              for (const Fl of this.paths)
                for (const [Ll, Nl, ql, Jl] of Fl) {
                  const zl = Xi.Util.bezierBoundingBox(...Ll, ...Nl, ...ql, ...Jl);
                  wl = Math.min(wl, zl[0]), Sl = Math.min(Sl, zl[1]), dl = Math.max(dl, zl[2]), Ml = Math.max(Ml, zl[3]);
                }
              return [wl, Sl, dl, Ml];
            }, Wd = function() {
              return Vl(this, ko) ? Math.ceil(this.thickness * this.parent.scaleFactor) : 0;
            }, Fd = function(wl = !1) {
              if (this.isEmpty())
                return;
              if (!Vl(this, ko)) {
                rc(this, ws, Td).call(this);
                return;
              }
              const dl = rc(this, ws, vf).call(this), Sl = rc(this, ws, Wd).call(this);
              Hu(this, to, Math.max(na, dl[2] - dl[0])), Hu(this, Va, Math.max(na, dl[3] - dl[1]));
              const Ml = Math.ceil(Sl + Vl(this, to) * this.scaleFactor), Fl = Math.ceil(Sl + Vl(this, Va) * this.scaleFactor), [Ll, Nl] = this.parent.viewportBaseDimensions;
              this.width = Ml / Ll, this.height = Fl / Nl, Hu(this, Ma, Ml / Fl), rc(this, ws, mf).call(this);
              const ql = this.translationX, Jl = this.translationY;
              this.translationX = -dl[0], this.translationY = -dl[1], rc(this, ws, Md).call(this), rc(this, ws, Td).call(this), Hu(this, Xs, Ml), Hu(this, Cs, Fl), this.setDims(Ml, Fl);
              const zl = wl ? Sl / this.scaleFactor / 2 : 0;
              this.translate(ql - this.translationX - zl, Jl - this.translationY - zl);
            }, mf = function() {
              const {
                style: wl
              } = this.div;
              Vl(this, Ma) >= 1 ? (wl.minHeight = `${na}px`, wl.minWidth = `${Math.round(Vl(this, Ma) * na)}px`) : (wl.minWidth = `${na}px`, wl.minHeight = `${Math.round(na / Vl(this, Ma))}px`);
            }, $u(gl, yl), cd(gl, "_defaultColor", null), cd(gl, "_defaultOpacity", 1), cd(gl, "_defaultThickness", 1), cd(gl, "_l10nPromise"), cd(gl, "_type", "ink");
            let la = gl;
            e.InkEditor = la;
          },
          /* 25 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.fitCurve = void 0;
            const Xi = qi(26);
            e.fitCurve = Xi;
          },
          /* 26 */
          /***/
          (Bi) => {
            function e(eo, rs, ko) {
              if (!Array.isArray(eo))
                throw new TypeError("First argument should be an array");
              if (eo.forEach((Xs) => {
                if (!Array.isArray(Xs) || Xs.some((Cs) => typeof Cs != "number") || Xs.length !== eo[0].length)
                  throw Error("Each point should be an array of numbers. Each point should have the same amount of numbers.");
              }), eo = eo.filter((Xs, Cs) => Cs === 0 || !Xs.every((Fs, ws) => Fs === eo[Cs - 1][ws])), eo.length < 2)
                return [];
              const Hs = eo.length, Ks = to(eo[1], eo[0]), Ys = to(eo[Hs - 2], eo[Hs - 1]);
              return qi(eo, Ks, Ys, rs, ko);
            }
            function qi(eo, rs, ko, Hs, Ks) {
              var Xs, Cs, Fs, ws, ls, ks, Js, pl, _l, bl, xl, Rl, Cl;
              if (eo.length === 2)
                return Rl = Eo.vectorLen(Eo.subtract(eo[0], eo[1])) / 3, Xs = [eo[0], Eo.addArrays(eo[0], Eo.mulItems(rs, Rl)), Eo.addArrays(eo[1], Eo.mulItems(ko, Rl)), eo[1]], [Xs];
              if (Cs = na(eo), [Xs, ws, ks] = Xi(eo, Cs, Cs, rs, ko, Ks), ws === 0 || ws < Hs)
                return [Xs];
              if (ws < Hs * Hs)
                for (Fs = Cs, ls = ws, Js = ks, Cl = 0; Cl < 20; Cl++) {
                  if (Fs = ta(Xs, eo, Fs), [Xs, ws, ks] = Xi(eo, Cs, Fs, rs, ko, Ks), ws < Hs)
                    return [Xs];
                  if (ks === Js) {
                    let Dl = ws / ls;
                    if (Dl > 0.9999 && Dl < 1.0001)
                      break;
                  }
                  ls = ws, Js = ks;
                }
              return xl = [], pl = Eo.subtract(eo[ks - 1], eo[ks + 1]), pl.every((Dl) => Dl === 0) && (pl = Eo.subtract(eo[ks - 1], eo[ks]), [pl[0], pl[1]] = [-pl[1], pl[0]]), _l = Eo.normalize(pl), bl = Eo.mulItems(_l, -1), xl = xl.concat(qi(eo.slice(0, ks + 1), rs, _l, Hs, Ks)), xl = xl.concat(qi(eo.slice(ks), bl, ko, Hs, Ks)), xl;
            }
            function Xi(eo, rs, ko, Hs, Ks, Ys) {
              var Xs, Cs, Fs;
              return Xs = Qi(eo, ko, Hs, Ks), [Cs, Fs] = la(eo, Xs, rs), Ys && Ys({
                bez: Xs,
                points: eo,
                params: rs,
                maxErr: Cs,
                maxPoint: Fs
              }), [Xs, Cs, Fs];
            }
            function Qi(eo, rs, ko, Hs) {
              var Ks, Ys, Xs, Cs, Fs, ws, ls, ks, Js, pl, _l, bl, xl, Rl, Cl, Dl, kl, Ul = eo[0], Bl = eo[eo.length - 1];
              for (Ks = [Ul, null, null, Bl], Ys = Eo.zeros_Xx2x2(rs.length), xl = 0, Rl = rs.length; xl < Rl; xl++)
                Dl = rs[xl], kl = 1 - Dl, Xs = Ys[xl], Xs[0] = Eo.mulItems(ko, 3 * Dl * (kl * kl)), Xs[1] = Eo.mulItems(Hs, 3 * kl * (Dl * Dl));
              for (Cs = [[0, 0], [0, 0]], Fs = [0, 0], xl = 0, Rl = eo.length; xl < Rl; xl++)
                Dl = rs[xl], Xs = Ys[xl], Cs[0][0] += Eo.dot(Xs[0], Xs[0]), Cs[0][1] += Eo.dot(Xs[0], Xs[1]), Cs[1][0] += Eo.dot(Xs[0], Xs[1]), Cs[1][1] += Eo.dot(Xs[1], Xs[1]), Cl = Eo.subtract(eo[xl], So.q([Ul, Ul, Bl, Bl], Dl)), Fs[0] += Eo.dot(Xs[0], Cl), Fs[1] += Eo.dot(Xs[1], Cl);
              return ws = Cs[0][0] * Cs[1][1] - Cs[1][0] * Cs[0][1], ls = Cs[0][0] * Fs[1] - Cs[1][0] * Fs[0], ks = Fs[0] * Cs[1][1] - Fs[1] * Cs[0][1], Js = ws === 0 ? 0 : ks / ws, pl = ws === 0 ? 0 : ls / ws, bl = Eo.vectorLen(Eo.subtract(Ul, Bl)), _l = 1e-6 * bl, Js < _l || pl < _l ? (Ks[1] = Eo.addArrays(Ul, Eo.mulItems(ko, bl / 3)), Ks[2] = Eo.addArrays(Bl, Eo.mulItems(Hs, bl / 3))) : (Ks[1] = Eo.addArrays(Ul, Eo.mulItems(ko, Js)), Ks[2] = Eo.addArrays(Bl, Eo.mulItems(Hs, pl))), Ks;
            }
            function ta(eo, rs, ko) {
              return ko.map((Hs, Ks) => ra(eo, rs[Ks], Hs));
            }
            function ra(eo, rs, ko) {
              var Hs = Eo.subtract(So.q(eo, ko), rs), Ks = So.qprime(eo, ko), Ys = Eo.mulMatrix(Hs, Ks), Xs = Eo.sum(Eo.squareItems(Ks)) + 2 * Eo.mulMatrix(Hs, So.qprimeprime(eo, ko));
              return Xs === 0 ? ko : ko - Ys / Xs;
            }
            function na(eo) {
              var rs = [], ko, Hs, Ks;
              return eo.forEach((Ys, Xs) => {
                ko = Xs ? Hs + Eo.vectorLen(Eo.subtract(Ys, Ks)) : 0, rs.push(ko), Hs = ko, Ks = Ys;
              }), rs = rs.map((Ys) => Ys / Hs), rs;
            }
            function la(eo, rs, ko) {
              var Hs, Ks, Ys, Xs, Cs, Fs, ws, ls;
              Ks = 0, Ys = Math.floor(eo.length / 2);
              const ks = Ma(rs, 10);
              for (Cs = 0, Fs = eo.length; Cs < Fs; Cs++)
                ws = eo[Cs], ls = Va(rs, ko[Cs], ks, 10), Xs = Eo.subtract(So.q(rs, ls), ws), Hs = Xs[0] * Xs[0] + Xs[1] * Xs[1], Hs > Ks && (Ks = Hs, Ys = Cs);
              return [Ks, Ys];
            }
            var Ma = function(eo, rs) {
              for (var ko, Hs = [0], Ks = eo[0], Ys = 0, Xs = 1; Xs <= rs; Xs++)
                ko = So.q(eo, Xs / rs), Ys += Eo.vectorLen(Eo.subtract(ko, Ks)), Hs.push(Ys), Ks = ko;
              return Hs = Hs.map((Cs) => Cs / Ys), Hs;
            };
            function Va(eo, rs, ko, Hs) {
              if (rs < 0)
                return 0;
              if (rs > 1)
                return 1;
              for (var Ks, Ys, Xs, Cs, Fs, ws = 1; ws <= Hs; ws++)
                if (rs <= ko[ws]) {
                  Cs = (ws - 1) / Hs, Xs = ws / Hs, Ys = ko[ws - 1], Ks = ko[ws], Fs = (rs - Ys) / (Ks - Ys) * (Xs - Cs) + Cs;
                  break;
                }
              return Fs;
            }
            function to(eo, rs) {
              return Eo.normalize(Eo.subtract(eo, rs));
            }
            class Eo {
              static zeros_Xx2x2(rs) {
                for (var ko = []; rs--; )
                  ko.push([0, 0]);
                return ko;
              }
              static mulItems(rs, ko) {
                return rs.map((Hs) => Hs * ko);
              }
              static mulMatrix(rs, ko) {
                return rs.reduce((Hs, Ks, Ys) => Hs + Ks * ko[Ys], 0);
              }
              static subtract(rs, ko) {
                return rs.map((Hs, Ks) => Hs - ko[Ks]);
              }
              static addArrays(rs, ko) {
                return rs.map((Hs, Ks) => Hs + ko[Ks]);
              }
              static addItems(rs, ko) {
                return rs.map((Hs) => Hs + ko);
              }
              static sum(rs) {
                return rs.reduce((ko, Hs) => ko + Hs);
              }
              static dot(rs, ko) {
                return Eo.mulMatrix(rs, ko);
              }
              static vectorLen(rs) {
                return Math.hypot(...rs);
              }
              static divItems(rs, ko) {
                return rs.map((Hs) => Hs / ko);
              }
              static squareItems(rs) {
                return rs.map((ko) => ko * ko);
              }
              static normalize(rs) {
                return this.divItems(rs, this.vectorLen(rs));
              }
            }
            class So {
              static q(rs, ko) {
                var Hs = 1 - ko, Ks = Eo.mulItems(rs[0], Hs * Hs * Hs), Ys = Eo.mulItems(rs[1], 3 * Hs * Hs * ko), Xs = Eo.mulItems(rs[2], 3 * Hs * ko * ko), Cs = Eo.mulItems(rs[3], ko * ko * ko);
                return Eo.addArrays(Eo.addArrays(Ks, Ys), Eo.addArrays(Xs, Cs));
              }
              static qprime(rs, ko) {
                var Hs = 1 - ko, Ks = Eo.mulItems(Eo.subtract(rs[1], rs[0]), 3 * Hs * Hs), Ys = Eo.mulItems(Eo.subtract(rs[2], rs[1]), 6 * Hs * ko), Xs = Eo.mulItems(Eo.subtract(rs[3], rs[2]), 3 * ko * ko);
                return Eo.addArrays(Eo.addArrays(Ks, Ys), Xs);
              }
              static qprimeprime(rs, ko) {
                return Eo.addArrays(Eo.mulItems(Eo.addArrays(Eo.subtract(rs[2], Eo.mulItems(rs[1], 2)), rs[0]), 6 * (1 - ko)), Eo.mulItems(Eo.addArrays(Eo.subtract(rs[3], Eo.mulItems(rs[2], 2)), rs[1]), 6 * ko));
              }
            }
            Bi.exports = e, Bi.exports.fitCubic = qi, Bi.exports.createTangent = to;
          },
          /* 27 */
          /***/
          (Bi, e, qi) => {
            var yl, gf, bf, yf;
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.AnnotationLayer = void 0;
            var Xi = qi(1), Qi = qi(8), ta = qi(5), ra = qi(28), na = qi(29);
            const la = 1e3, Ma = 9, Va = /* @__PURE__ */ new WeakSet();
            function to(Al) {
              return {
                width: Al[2] - Al[0],
                height: Al[3] - Al[1]
              };
            }
            class Eo {
              static create(_s) {
                switch (_s.data.annotationType) {
                  case Xi.AnnotationType.LINK:
                    return new eo(_s);
                  case Xi.AnnotationType.TEXT:
                    return new rs(_s);
                  case Xi.AnnotationType.WIDGET:
                    switch (_s.data.fieldType) {
                      case "Tx":
                        return new Hs(_s);
                      case "Btn":
                        return _s.data.radioButton ? new Ys(_s) : _s.data.checkBox ? new Ks(_s) : new Xs(_s);
                      case "Ch":
                        return new Cs(_s);
                    }
                    return new ko(_s);
                  case Xi.AnnotationType.POPUP:
                    return new Fs(_s);
                  case Xi.AnnotationType.FREETEXT:
                    return new ls(_s);
                  case Xi.AnnotationType.LINE:
                    return new ks(_s);
                  case Xi.AnnotationType.SQUARE:
                    return new Js(_s);
                  case Xi.AnnotationType.CIRCLE:
                    return new pl(_s);
                  case Xi.AnnotationType.POLYLINE:
                    return new _l(_s);
                  case Xi.AnnotationType.CARET:
                    return new xl(_s);
                  case Xi.AnnotationType.INK:
                    return new Rl(_s);
                  case Xi.AnnotationType.POLYGON:
                    return new bl(_s);
                  case Xi.AnnotationType.HIGHLIGHT:
                    return new Cl(_s);
                  case Xi.AnnotationType.UNDERLINE:
                    return new Dl(_s);
                  case Xi.AnnotationType.SQUIGGLY:
                    return new kl(_s);
                  case Xi.AnnotationType.STRIKEOUT:
                    return new Ul(_s);
                  case Xi.AnnotationType.STAMP:
                    return new Bl(_s);
                  case Xi.AnnotationType.FILEATTACHMENT:
                    return new Zl(_s);
                  default:
                    return new So(_s);
                }
              }
            }
            class So {
              constructor(_s, {
                isRenderable: Gs = !1,
                ignoreBorder: vl = !1,
                createQuadrilaterals: gl = !1
              } = {}) {
                this.isRenderable = Gs, this.data = _s.data, this.layer = _s.layer, this.page = _s.page, this.viewport = _s.viewport, this.linkService = _s.linkService, this.downloadManager = _s.downloadManager, this.imageResourcesPath = _s.imageResourcesPath, this.renderForms = _s.renderForms, this.svgFactory = _s.svgFactory, this.annotationStorage = _s.annotationStorage, this.enableScripting = _s.enableScripting, this.hasJSActions = _s.hasJSActions, this._fieldObjects = _s.fieldObjects, this._mouseState = _s.mouseState, Gs && (this.container = this._createContainer(vl)), gl && (this.quadrilaterals = this._createQuadrilaterals(vl));
              }
              _createContainer(_s = !1) {
                const Gs = this.data, vl = this.page, gl = this.viewport, El = document.createElement("section"), {
                  width: Ol,
                  height: wl
                } = to(Gs.rect), [dl, Sl, Ml, Fl] = gl.viewBox, Ll = Ml - dl, Nl = Fl - Sl;
                El.setAttribute("data-annotation-id", Gs.id);
                const ql = Xi.Util.normalizeRect([Gs.rect[0], vl.view[3] - Gs.rect[1] + vl.view[1], Gs.rect[2], vl.view[3] - Gs.rect[3] + vl.view[1]]);
                if (!_s && Gs.borderStyle.width > 0) {
                  El.style.borderWidth = `${Gs.borderStyle.width}px`;
                  const zl = Gs.borderStyle.horizontalCornerRadius, tc = Gs.borderStyle.verticalCornerRadius;
                  if (zl > 0 || tc > 0) {
                    const tu = `calc(${zl}px * var(--scale-factor)) / calc(${tc}px * var(--scale-factor))`;
                    El.style.borderRadius = tu;
                  } else if (this instanceof Ys) {
                    const tu = `calc(${Ol}px * var(--scale-factor)) / calc(${wl}px * var(--scale-factor))`;
                    El.style.borderRadius = tu;
                  }
                  switch (Gs.borderStyle.style) {
                    case Xi.AnnotationBorderStyleType.SOLID:
                      El.style.borderStyle = "solid";
                      break;
                    case Xi.AnnotationBorderStyleType.DASHED:
                      El.style.borderStyle = "dashed";
                      break;
                    case Xi.AnnotationBorderStyleType.BEVELED:
                      (0, Xi.warn)("Unimplemented border style: beveled");
                      break;
                    case Xi.AnnotationBorderStyleType.INSET:
                      (0, Xi.warn)("Unimplemented border style: inset");
                      break;
                    case Xi.AnnotationBorderStyleType.UNDERLINE:
                      El.style.borderBottomStyle = "solid";
                      break;
                  }
                  const Ku = Gs.borderColor || null;
                  Ku ? El.style.borderColor = Xi.Util.makeHexColor(Ku[0] | 0, Ku[1] | 0, Ku[2] | 0) : El.style.borderWidth = 0;
                }
                El.style.left = `${100 * (ql[0] - dl) / Ll}%`, El.style.top = `${100 * (ql[1] - Sl) / Nl}%`;
                const {
                  rotation: Jl
                } = Gs;
                return Gs.hasOwnCanvas || Jl === 0 ? (El.style.width = `${100 * Ol / Ll}%`, El.style.height = `${100 * wl / Nl}%`) : this.setRotation(Jl, El), El;
              }
              setRotation(_s, Gs = this.container) {
                const [vl, gl, El, Ol] = this.viewport.viewBox, wl = El - vl, dl = Ol - gl, {
                  width: Sl,
                  height: Ml
                } = to(this.data.rect);
                let Fl, Ll;
                _s % 180 === 0 ? (Fl = 100 * Sl / wl, Ll = 100 * Ml / dl) : (Fl = 100 * Ml / wl, Ll = 100 * Sl / dl), Gs.style.width = `${Fl}%`, Gs.style.height = `${Ll}%`, Gs.setAttribute("data-main-rotation", (360 - _s) % 360);
              }
              get _commonActions() {
                const _s = (Gs, vl, gl) => {
                  const El = gl.detail[Gs];
                  gl.target.style[vl] = ra.ColorConverters[`${El[0]}_HTML`](El.slice(1));
                };
                return (0, Xi.shadow)(this, "_commonActions", {
                  display: (Gs) => {
                    const vl = Gs.detail.display % 2 === 1;
                    this.container.style.visibility = vl ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      hidden: vl,
                      print: Gs.detail.display === 0 || Gs.detail.display === 3
                    });
                  },
                  print: (Gs) => {
                    this.annotationStorage.setValue(this.data.id, {
                      print: Gs.detail.print
                    });
                  },
                  hidden: (Gs) => {
                    this.container.style.visibility = Gs.detail.hidden ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                      hidden: Gs.detail.hidden
                    });
                  },
                  focus: (Gs) => {
                    setTimeout(() => Gs.target.focus({
                      preventScroll: !1
                    }), 0);
                  },
                  userName: (Gs) => {
                    Gs.target.title = Gs.detail.userName;
                  },
                  readonly: (Gs) => {
                    Gs.detail.readonly ? Gs.target.setAttribute("readonly", "") : Gs.target.removeAttribute("readonly");
                  },
                  required: (Gs) => {
                    this._setRequired(Gs.target, Gs.detail.required);
                  },
                  bgColor: (Gs) => {
                    _s("bgColor", "backgroundColor", Gs);
                  },
                  fillColor: (Gs) => {
                    _s("fillColor", "backgroundColor", Gs);
                  },
                  fgColor: (Gs) => {
                    _s("fgColor", "color", Gs);
                  },
                  textColor: (Gs) => {
                    _s("textColor", "color", Gs);
                  },
                  borderColor: (Gs) => {
                    _s("borderColor", "borderColor", Gs);
                  },
                  strokeColor: (Gs) => {
                    _s("strokeColor", "borderColor", Gs);
                  },
                  rotation: (Gs) => {
                    const vl = Gs.detail.rotation;
                    this.setRotation(vl), this.annotationStorage.setValue(this.data.id, {
                      rotation: vl
                    });
                  }
                });
              }
              _dispatchEventFromSandbox(_s, Gs) {
                const vl = this._commonActions;
                for (const gl of Object.keys(Gs.detail)) {
                  const El = _s[gl] || vl[gl];
                  El && El(Gs);
                }
              }
              _setDefaultPropertiesFromJS(_s) {
                if (!this.enableScripting)
                  return;
                const Gs = this.annotationStorage.getRawValue(this.data.id);
                if (!Gs)
                  return;
                const vl = this._commonActions;
                for (const [gl, El] of Object.entries(Gs)) {
                  const Ol = vl[gl];
                  if (Ol) {
                    const wl = {
                      detail: {
                        [gl]: El
                      },
                      target: _s
                    };
                    Ol(wl), delete Gs[gl];
                  }
                }
              }
              _createQuadrilaterals(_s = !1) {
                if (!this.data.quadPoints)
                  return null;
                const Gs = [], vl = this.data.rect;
                for (const gl of this.data.quadPoints)
                  this.data.rect = [gl[2].x, gl[2].y, gl[1].x, gl[1].y], Gs.push(this._createContainer(_s));
                return this.data.rect = vl, Gs;
              }
              _createPopup(_s, Gs) {
                let vl = this.container;
                this.quadrilaterals && (_s = _s || this.quadrilaterals, vl = this.quadrilaterals[0]), _s || (_s = document.createElement("div"), _s.className = "popupTriggerArea", vl.append(_s));
                const El = new ws({
                  container: vl,
                  trigger: _s,
                  color: Gs.color,
                  titleObj: Gs.titleObj,
                  modificationDate: Gs.modificationDate,
                  contentsObj: Gs.contentsObj,
                  richText: Gs.richText,
                  hideWrapper: !0
                }).render();
                El.style.left = "100%", vl.append(El);
              }
              _renderQuadrilaterals(_s) {
                for (const Gs of this.quadrilaterals)
                  Gs.className = _s;
                return this.quadrilaterals;
              }
              render() {
                (0, Xi.unreachable)("Abstract method `AnnotationElement.render` called");
              }
              _getElementsByName(_s, Gs = null) {
                const vl = [];
                if (this._fieldObjects) {
                  const gl = this._fieldObjects[_s];
                  if (gl)
                    for (const {
                      page: El,
                      id: Ol,
                      exportValues: wl
                    } of gl) {
                      if (El === -1 || Ol === Gs)
                        continue;
                      const dl = typeof wl == "string" ? wl : null, Sl = document.querySelector(`[data-element-id="${Ol}"]`);
                      if (Sl && !Va.has(Sl)) {
                        (0, Xi.warn)(`_getElementsByName - element not allowed: ${Ol}`);
                        continue;
                      }
                      vl.push({
                        id: Ol,
                        exportValue: dl,
                        domElement: Sl
                      });
                    }
                  return vl;
                }
                for (const gl of document.getElementsByName(_s)) {
                  const {
                    id: El,
                    exportValue: Ol
                  } = gl;
                  El !== Gs && Va.has(gl) && vl.push({
                    id: El,
                    exportValue: Ol,
                    domElement: gl
                  });
                }
                return vl;
              }
              static get platform() {
                const _s = typeof navigator < "u" ? navigator.platform : "";
                return (0, Xi.shadow)(this, "platform", {
                  isWin: _s.includes("Win"),
                  isMac: _s.includes("Mac")
                });
              }
            }
            class eo extends So {
              constructor(_s, Gs = null) {
                super(_s, {
                  isRenderable: !0,
                  ignoreBorder: !!Gs?.ignoreBorder,
                  createQuadrilaterals: !0
                }), this.isTooltipOnly = _s.data.isTooltipOnly;
              }
              render() {
                const {
                  data: _s,
                  linkService: Gs
                } = this, vl = document.createElement("a");
                vl.setAttribute("data-element-id", _s.id);
                let gl = !1;
                return _s.url ? (Gs.addLinkAttributes(vl, _s.url, _s.newWindow), gl = !0) : _s.action ? (this._bindNamedAction(vl, _s.action), gl = !0) : _s.dest ? (this._bindLink(vl, _s.dest), gl = !0) : (_s.actions && (_s.actions.Action || _s.actions["Mouse Up"] || _s.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(vl, _s), gl = !0), _s.resetForm ? (this._bindResetFormAction(vl, _s.resetForm), gl = !0) : this.isTooltipOnly && !gl && (this._bindLink(vl, ""), gl = !0)), this.quadrilaterals ? this._renderQuadrilaterals("linkAnnotation").map((El, Ol) => {
                  const wl = Ol === 0 ? vl : vl.cloneNode();
                  return El.append(wl), El;
                }) : (this.container.className = "linkAnnotation", gl && this.container.append(vl), this.container);
              }
              _bindLink(_s, Gs) {
                _s.href = this.linkService.getDestinationHash(Gs), _s.onclick = () => (Gs && this.linkService.goToDestination(Gs), !1), (Gs || Gs === "") && (_s.className = "internalLink");
              }
              _bindNamedAction(_s, Gs) {
                _s.href = this.linkService.getAnchorUrl(""), _s.onclick = () => (this.linkService.executeNamedAction(Gs), !1), _s.className = "internalLink";
              }
              _bindJSAction(_s, Gs) {
                _s.href = this.linkService.getAnchorUrl("");
                const vl = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                for (const gl of Object.keys(Gs.actions)) {
                  const El = vl.get(gl);
                  El && (_s[El] = () => (this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Gs.id,
                      name: gl
                    }
                  }), !1));
                }
                _s.onclick || (_s.onclick = () => !1), _s.className = "internalLink";
              }
              _bindResetFormAction(_s, Gs) {
                const vl = _s.onclick;
                if (vl || (_s.href = this.linkService.getAnchorUrl("")), _s.className = "internalLink", !this._fieldObjects) {
                  (0, Xi.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), vl || (_s.onclick = () => !1);
                  return;
                }
                _s.onclick = () => {
                  vl && vl();
                  const {
                    fields: gl,
                    refs: El,
                    include: Ol
                  } = Gs, wl = [];
                  if (gl.length !== 0 || El.length !== 0) {
                    const Ml = new Set(El);
                    for (const Fl of gl) {
                      const Ll = this._fieldObjects[Fl] || [];
                      for (const {
                        id: Nl
                      } of Ll)
                        Ml.add(Nl);
                    }
                    for (const Fl of Object.values(this._fieldObjects))
                      for (const Ll of Fl)
                        Ml.has(Ll.id) === Ol && wl.push(Ll);
                  } else
                    for (const Ml of Object.values(this._fieldObjects))
                      wl.push(...Ml);
                  const dl = this.annotationStorage, Sl = [];
                  for (const Ml of wl) {
                    const {
                      id: Fl
                    } = Ml;
                    switch (Sl.push(Fl), Ml.type) {
                      case "text": {
                        const Nl = Ml.defaultValue || "";
                        dl.setValue(Fl, {
                          value: Nl
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        const Nl = Ml.defaultValue === Ml.exportValues;
                        dl.setValue(Fl, {
                          value: Nl
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        const Nl = Ml.defaultValue || "";
                        dl.setValue(Fl, {
                          value: Nl
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    const Ll = document.querySelector(`[data-element-id="${Fl}"]`);
                    if (Ll) {
                      if (!Va.has(Ll)) {
                        (0, Xi.warn)(`_bindResetFormAction - element not allowed: ${Fl}`);
                        continue;
                      }
                    } else continue;
                    Ll.dispatchEvent(new Event("resetform"));
                  }
                  return this.enableScripting && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: "app",
                      ids: Sl,
                      name: "ResetForm"
                    }
                  }), !1;
                };
              }
            }
            class rs extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs
                });
              }
              render() {
                this.container.className = "textAnnotation";
                const _s = document.createElement("img");
                return _s.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", _s.alt = "[{{type}} Annotation]", _s.dataset.l10nId = "text_annotation_type", _s.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                }), this.data.hasPopup || this._createPopup(_s, this.data), this.container.append(_s), this.container;
              }
            }
            class ko extends So {
              render() {
                return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
              }
              _getKeyModifier(_s) {
                const {
                  isWin: Gs,
                  isMac: vl
                } = So.platform;
                return Gs && _s.ctrlKey || vl && _s.metaKey;
              }
              _setEventListener(_s, Gs, vl, gl) {
                Gs.includes("mouse") ? _s.addEventListener(Gs, (El) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: vl,
                      value: gl(El),
                      shift: El.shiftKey,
                      modifier: this._getKeyModifier(El)
                    }
                  });
                }) : _s.addEventListener(Gs, (El) => {
                  this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: vl,
                      value: gl(El)
                    }
                  });
                });
              }
              _setEventListeners(_s, Gs, vl) {
                for (const [gl, El] of Gs)
                  (El === "Action" || this.data.actions?.[El]) && this._setEventListener(_s, gl, El, vl);
              }
              _setBackgroundColor(_s) {
                const Gs = this.data.backgroundColor || null;
                _s.style.backgroundColor = Gs === null ? "transparent" : Xi.Util.makeHexColor(Gs[0], Gs[1], Gs[2]);
              }
              _setTextStyle(_s) {
                const Gs = ["left", "center", "right"], {
                  fontColor: vl
                } = this.data.defaultAppearanceData, gl = this.data.defaultAppearanceData.fontSize || Ma, El = _s.style;
                let Ol;
                if (this.data.multiLine) {
                  const wl = Math.abs(this.data.rect[3] - this.data.rect[1]), dl = Math.round(wl / (Xi.LINE_FACTOR * gl)) || 1, Sl = wl / dl;
                  Ol = Math.min(gl, Math.round(Sl / Xi.LINE_FACTOR));
                } else {
                  const wl = Math.abs(this.data.rect[3] - this.data.rect[1]);
                  Ol = Math.min(gl, Math.round(wl / Xi.LINE_FACTOR));
                }
                El.fontSize = `calc(${Ol}px * var(--scale-factor))`, El.color = Xi.Util.makeHexColor(vl[0], vl[1], vl[2]), this.data.textAlignment !== null && (El.textAlign = Gs[this.data.textAlignment]);
              }
              _setRequired(_s, Gs) {
                Gs ? _s.setAttribute("required", !0) : _s.removeAttribute("required"), _s.setAttribute("aria-required", Gs);
              }
            }
            class Hs extends ko {
              constructor(_s) {
                const Gs = _s.renderForms || !_s.data.hasAppearance && !!_s.data.fieldValue;
                super(_s, {
                  isRenderable: Gs
                });
              }
              setPropertyOnSiblings(_s, Gs, vl, gl) {
                const El = this.annotationStorage;
                for (const Ol of this._getElementsByName(_s.name, _s.id))
                  Ol.domElement && (Ol.domElement[Gs] = vl), El.setValue(Ol.id, {
                    [gl]: vl
                  });
              }
              render() {
                const _s = this.annotationStorage, Gs = this.data.id;
                this.container.className = "textWidgetAnnotation";
                let vl = null;
                if (this.renderForms) {
                  const gl = _s.getValue(Gs, {
                    value: this.data.fieldValue
                  });
                  let El = gl.formattedValue || gl.value || "";
                  const Ol = _s.getValue(Gs, {
                    charLimit: this.data.maxLen
                  }).charLimit;
                  Ol && El.length > Ol && (El = El.slice(0, Ol));
                  const wl = {
                    userValue: El,
                    formattedValue: null,
                    valueOnFocus: ""
                  };
                  this.data.multiLine ? (vl = document.createElement("textarea"), vl.textContent = El, this.data.doNotScroll && (vl.style.overflowY = "hidden")) : (vl = document.createElement("input"), vl.type = "text", vl.setAttribute("value", El), this.data.doNotScroll && (vl.style.overflowX = "hidden")), Va.add(vl), vl.setAttribute("data-element-id", Gs), vl.disabled = this.data.readOnly, vl.name = this.data.fieldName, vl.tabIndex = la, this._setRequired(vl, this.data.required), Ol && (vl.maxLength = Ol), vl.addEventListener("input", (Sl) => {
                    _s.setValue(Gs, {
                      value: Sl.target.value
                    }), this.setPropertyOnSiblings(vl, "value", Sl.target.value, "value");
                  }), vl.addEventListener("resetform", (Sl) => {
                    const Ml = this.data.defaultFieldValue ?? "";
                    vl.value = wl.userValue = Ml, wl.formattedValue = null;
                  });
                  let dl = (Sl) => {
                    const {
                      formattedValue: Ml
                    } = wl;
                    Ml != null && (Sl.target.value = Ml), Sl.target.scrollLeft = 0;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    vl.addEventListener("focus", (Ml) => {
                      wl.userValue && (Ml.target.value = wl.userValue), wl.valueOnFocus = Ml.target.value;
                    }), vl.addEventListener("updatefromsandbox", (Ml) => {
                      const Fl = {
                        value(Ll) {
                          wl.userValue = Ll.detail.value ?? "", _s.setValue(Gs, {
                            value: wl.userValue.toString()
                          }), Ll.target.value = wl.userValue;
                        },
                        formattedValue(Ll) {
                          const {
                            formattedValue: Nl
                          } = Ll.detail;
                          wl.formattedValue = Nl, Nl != null && Ll.target !== document.activeElement && (Ll.target.value = Nl), _s.setValue(Gs, {
                            formattedValue: Nl
                          });
                        },
                        selRange(Ll) {
                          Ll.target.setSelectionRange(...Ll.detail.selRange);
                        },
                        charLimit: (Ll) => {
                          const {
                            charLimit: Nl
                          } = Ll.detail, {
                            target: ql
                          } = Ll;
                          if (Nl === 0) {
                            ql.removeAttribute("maxLength");
                            return;
                          }
                          ql.setAttribute("maxLength", Nl);
                          let Jl = wl.userValue;
                          !Jl || Jl.length <= Nl || (Jl = Jl.slice(0, Nl), ql.value = wl.userValue = Jl, _s.setValue(Gs, {
                            value: Jl
                          }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id: Gs,
                              name: "Keystroke",
                              value: Jl,
                              willCommit: !0,
                              commitKey: 1,
                              selStart: ql.selectionStart,
                              selEnd: ql.selectionEnd
                            }
                          }));
                        }
                      };
                      this._dispatchEventFromSandbox(Fl, Ml);
                    }), vl.addEventListener("keydown", (Ml) => {
                      let Fl = -1;
                      if (Ml.key === "Escape" ? Fl = 0 : Ml.key === "Enter" ? Fl = 2 : Ml.key === "Tab" && (Fl = 3), Fl === -1)
                        return;
                      const {
                        value: Ll
                      } = Ml.target;
                      wl.valueOnFocus !== Ll && (wl.userValue = Ll, this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Gs,
                          name: "Keystroke",
                          value: Ll,
                          willCommit: !0,
                          commitKey: Fl,
                          selStart: Ml.target.selectionStart,
                          selEnd: Ml.target.selectionEnd
                        }
                      }));
                    });
                    const Sl = dl;
                    dl = null, vl.addEventListener("blur", (Ml) => {
                      const {
                        value: Fl
                      } = Ml.target;
                      wl.userValue = Fl, this._mouseState.isDown && wl.valueOnFocus !== Fl && this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Gs,
                          name: "Keystroke",
                          value: Fl,
                          willCommit: !0,
                          commitKey: 1,
                          selStart: Ml.target.selectionStart,
                          selEnd: Ml.target.selectionEnd
                        }
                      }), Sl(Ml);
                    }), this.data.actions?.Keystroke && vl.addEventListener("beforeinput", (Ml) => {
                      const {
                        data: Fl,
                        target: Ll
                      } = Ml, {
                        value: Nl,
                        selectionStart: ql,
                        selectionEnd: Jl
                      } = Ll;
                      let zl = ql, tc = Jl;
                      switch (Ml.inputType) {
                        case "deleteWordBackward": {
                          const Ku = Nl.substring(0, ql).match(/\w*[^\w]*$/);
                          Ku && (zl -= Ku[0].length);
                          break;
                        }
                        case "deleteWordForward": {
                          const Ku = Nl.substring(ql).match(/^[^\w]*\w*/);
                          Ku && (tc += Ku[0].length);
                          break;
                        }
                        case "deleteContentBackward":
                          ql === Jl && (zl -= 1);
                          break;
                        case "deleteContentForward":
                          ql === Jl && (tc += 1);
                          break;
                      }
                      Ml.preventDefault(), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id: Gs,
                          name: "Keystroke",
                          value: Nl,
                          change: Fl || "",
                          willCommit: !1,
                          selStart: zl,
                          selEnd: tc
                        }
                      });
                    }), this._setEventListeners(vl, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Ml) => Ml.target.value);
                  }
                  if (dl && vl.addEventListener("blur", dl), this.data.comb) {
                    const Ml = (this.data.rect[2] - this.data.rect[0]) / Ol;
                    vl.classList.add("comb"), vl.style.letterSpacing = `calc(${Ml}px * var(--scale-factor) - 1ch)`;
                  }
                } else
                  vl = document.createElement("div"), vl.textContent = this.data.fieldValue, vl.style.verticalAlign = "middle", vl.style.display = "table-cell";
                return this._setTextStyle(vl), this._setBackgroundColor(vl), this._setDefaultPropertiesFromJS(vl), this.container.append(vl), this.container;
              }
            }
            class Ks extends ko {
              constructor(_s) {
                super(_s, {
                  isRenderable: _s.renderForms
                });
              }
              render() {
                const _s = this.annotationStorage, Gs = this.data, vl = Gs.id;
                let gl = _s.getValue(vl, {
                  value: Gs.exportValue === Gs.fieldValue
                }).value;
                typeof gl == "string" && (gl = gl !== "Off", _s.setValue(vl, {
                  value: gl
                })), this.container.className = "buttonWidgetAnnotation checkBox";
                const El = document.createElement("input");
                return Va.add(El), El.setAttribute("data-element-id", vl), El.disabled = Gs.readOnly, this._setRequired(El, this.data.required), El.type = "checkbox", El.name = Gs.fieldName, gl && El.setAttribute("checked", !0), El.setAttribute("exportValue", Gs.exportValue), El.tabIndex = la, El.addEventListener("change", (Ol) => {
                  const {
                    name: wl,
                    checked: dl
                  } = Ol.target;
                  for (const Sl of this._getElementsByName(wl, vl)) {
                    const Ml = dl && Sl.exportValue === Gs.exportValue;
                    Sl.domElement && (Sl.domElement.checked = Ml), _s.setValue(Sl.id, {
                      value: Ml
                    });
                  }
                  _s.setValue(vl, {
                    value: dl
                  });
                }), El.addEventListener("resetform", (Ol) => {
                  const wl = Gs.defaultFieldValue || "Off";
                  Ol.target.checked = wl === Gs.exportValue;
                }), this.enableScripting && this.hasJSActions && (El.addEventListener("updatefromsandbox", (Ol) => {
                  const wl = {
                    value(dl) {
                      dl.target.checked = dl.detail.value !== "Off", _s.setValue(vl, {
                        value: dl.target.checked
                      });
                    }
                  };
                  this._dispatchEventFromSandbox(wl, Ol);
                }), this._setEventListeners(El, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (Ol) => Ol.target.checked)), this._setBackgroundColor(El), this._setDefaultPropertiesFromJS(El), this.container.append(El), this.container;
              }
            }
            class Ys extends ko {
              constructor(_s) {
                super(_s, {
                  isRenderable: _s.renderForms
                });
              }
              render() {
                this.container.className = "buttonWidgetAnnotation radioButton";
                const _s = this.annotationStorage, Gs = this.data, vl = Gs.id;
                let gl = _s.getValue(vl, {
                  value: Gs.fieldValue === Gs.buttonValue
                }).value;
                typeof gl == "string" && (gl = gl !== Gs.buttonValue, _s.setValue(vl, {
                  value: gl
                }));
                const El = document.createElement("input");
                if (Va.add(El), El.setAttribute("data-element-id", vl), El.disabled = Gs.readOnly, this._setRequired(El, this.data.required), El.type = "radio", El.name = Gs.fieldName, gl && El.setAttribute("checked", !0), El.tabIndex = la, El.addEventListener("change", (Ol) => {
                  const {
                    name: wl,
                    checked: dl
                  } = Ol.target;
                  for (const Sl of this._getElementsByName(wl, vl))
                    _s.setValue(Sl.id, {
                      value: !1
                    });
                  _s.setValue(vl, {
                    value: dl
                  });
                }), El.addEventListener("resetform", (Ol) => {
                  const wl = Gs.defaultFieldValue;
                  Ol.target.checked = wl != null && wl === Gs.buttonValue;
                }), this.enableScripting && this.hasJSActions) {
                  const Ol = Gs.buttonValue;
                  El.addEventListener("updatefromsandbox", (wl) => {
                    const dl = {
                      value: (Sl) => {
                        const Ml = Ol === Sl.detail.value;
                        for (const Fl of this._getElementsByName(Sl.target.name)) {
                          const Ll = Ml && Fl.id === vl;
                          Fl.domElement && (Fl.domElement.checked = Ll), _s.setValue(Fl.id, {
                            value: Ll
                          });
                        }
                      }
                    };
                    this._dispatchEventFromSandbox(dl, wl);
                  }), this._setEventListeners(El, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (wl) => wl.target.checked);
                }
                return this._setBackgroundColor(El), this._setDefaultPropertiesFromJS(El), this.container.append(El), this.container;
              }
            }
            class Xs extends eo {
              constructor(_s) {
                super(_s, {
                  ignoreBorder: _s.data.hasAppearance
                });
              }
              render() {
                const _s = super.render();
                _s.className = "buttonWidgetAnnotation pushButton", this.data.alternativeText && (_s.title = this.data.alternativeText);
                const Gs = _s.lastChild;
                return this.enableScripting && this.hasJSActions && Gs && (this._setDefaultPropertiesFromJS(Gs), Gs.addEventListener("updatefromsandbox", (vl) => {
                  this._dispatchEventFromSandbox({}, vl);
                })), _s;
              }
            }
            class Cs extends ko {
              constructor(_s) {
                super(_s, {
                  isRenderable: _s.renderForms
                });
              }
              render() {
                this.container.className = "choiceWidgetAnnotation";
                const _s = this.annotationStorage, Gs = this.data.id, vl = _s.getValue(Gs, {
                  value: this.data.fieldValue
                }), gl = document.createElement("select");
                Va.add(gl), gl.setAttribute("data-element-id", Gs), gl.disabled = this.data.readOnly, this._setRequired(gl, this.data.required), gl.name = this.data.fieldName, gl.tabIndex = la;
                let El = this.data.combo && this.data.options.length > 0;
                this.data.combo || (gl.size = this.data.options.length, this.data.multiSelect && (gl.multiple = !0)), gl.addEventListener("resetform", (Sl) => {
                  const Ml = this.data.defaultFieldValue;
                  for (const Fl of gl.options)
                    Fl.selected = Fl.value === Ml;
                });
                for (const Sl of this.data.options) {
                  const Ml = document.createElement("option");
                  Ml.textContent = Sl.displayValue, Ml.value = Sl.exportValue, vl.value.includes(Sl.exportValue) && (Ml.setAttribute("selected", !0), El = !1), gl.append(Ml);
                }
                let Ol = null;
                if (El) {
                  const Sl = document.createElement("option");
                  Sl.value = " ", Sl.setAttribute("hidden", !0), Sl.setAttribute("selected", !0), gl.prepend(Sl), Ol = () => {
                    Sl.remove(), gl.removeEventListener("input", Ol), Ol = null;
                  }, gl.addEventListener("input", Ol);
                }
                const wl = (Sl, Ml) => {
                  const Fl = Ml ? "value" : "textContent", Ll = Sl.target.options;
                  return Sl.target.multiple ? Array.prototype.filter.call(Ll, (Nl) => Nl.selected).map((Nl) => Nl[Fl]) : Ll.selectedIndex === -1 ? null : Ll[Ll.selectedIndex][Fl];
                }, dl = (Sl) => {
                  const Ml = Sl.target.options;
                  return Array.prototype.map.call(Ml, (Fl) => ({
                    displayValue: Fl.textContent,
                    exportValue: Fl.value
                  }));
                };
                return this.enableScripting && this.hasJSActions ? (gl.addEventListener("updatefromsandbox", (Sl) => {
                  const Ml = {
                    value(Fl) {
                      Ol?.();
                      const Ll = Fl.detail.value, Nl = new Set(Array.isArray(Ll) ? Ll : [Ll]);
                      for (const ql of gl.options)
                        ql.selected = Nl.has(ql.value);
                      _s.setValue(Gs, {
                        value: wl(Fl, !0)
                      });
                    },
                    multipleSelection(Fl) {
                      gl.multiple = !0;
                    },
                    remove(Fl) {
                      const Ll = gl.options, Nl = Fl.detail.remove;
                      Ll[Nl].selected = !1, gl.remove(Nl), Ll.length > 0 && Array.prototype.findIndex.call(Ll, (Jl) => Jl.selected) === -1 && (Ll[0].selected = !0), _s.setValue(Gs, {
                        value: wl(Fl, !0),
                        items: dl(Fl)
                      });
                    },
                    clear(Fl) {
                      for (; gl.length !== 0; )
                        gl.remove(0);
                      _s.setValue(Gs, {
                        value: null,
                        items: []
                      });
                    },
                    insert(Fl) {
                      const {
                        index: Ll,
                        displayValue: Nl,
                        exportValue: ql
                      } = Fl.detail.insert, Jl = gl.children[Ll], zl = document.createElement("option");
                      zl.textContent = Nl, zl.value = ql, Jl ? Jl.before(zl) : gl.append(zl), _s.setValue(Gs, {
                        value: wl(Fl, !0),
                        items: dl(Fl)
                      });
                    },
                    items(Fl) {
                      const {
                        items: Ll
                      } = Fl.detail;
                      for (; gl.length !== 0; )
                        gl.remove(0);
                      for (const Nl of Ll) {
                        const {
                          displayValue: ql,
                          exportValue: Jl
                        } = Nl, zl = document.createElement("option");
                        zl.textContent = ql, zl.value = Jl, gl.append(zl);
                      }
                      gl.options.length > 0 && (gl.options[0].selected = !0), _s.setValue(Gs, {
                        value: wl(Fl, !0),
                        items: dl(Fl)
                      });
                    },
                    indices(Fl) {
                      const Ll = new Set(Fl.detail.indices);
                      for (const Nl of Fl.target.options)
                        Nl.selected = Ll.has(Nl.index);
                      _s.setValue(Gs, {
                        value: wl(Fl, !0)
                      });
                    },
                    editable(Fl) {
                      Fl.target.disabled = !Fl.detail.editable;
                    }
                  };
                  this._dispatchEventFromSandbox(Ml, Sl);
                }), gl.addEventListener("input", (Sl) => {
                  const Ml = wl(Sl, !0), Fl = wl(Sl, !1);
                  _s.setValue(Gs, {
                    value: Ml
                  }), this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: Gs,
                      name: "Keystroke",
                      value: Fl,
                      changeEx: Ml,
                      willCommit: !0,
                      commitKey: 1,
                      keyDown: !1
                    }
                  });
                }), this._setEventListeners(gl, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"]], (Sl) => Sl.target.checked)) : gl.addEventListener("input", function(Sl) {
                  _s.setValue(Gs, {
                    value: wl(Sl, !0)
                  });
                }), this.data.combo && this._setTextStyle(gl), this._setBackgroundColor(gl), this._setDefaultPropertiesFromJS(gl), this.container.append(gl), this.container;
              }
            }
            class Fs extends So {
              constructor(_s) {
                const Gs = !!(_s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs
                });
              }
              render() {
                const _s = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
                if (this.container.className = "popupAnnotation", _s.includes(this.data.parentType))
                  return this.container;
                const Gs = `[data-annotation-id="${this.data.parentId}"]`, vl = this.layer.querySelectorAll(Gs);
                if (vl.length === 0)
                  return this.container;
                const gl = new ws({
                  container: this.container,
                  trigger: Array.from(vl),
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText
                }), El = this.page, Ol = Xi.Util.normalizeRect([this.data.parentRect[0], El.view[3] - this.data.parentRect[1] + El.view[1], this.data.parentRect[2], El.view[3] - this.data.parentRect[3] + El.view[1]]), wl = Ol[0] + this.data.parentRect[2] - this.data.parentRect[0], dl = Ol[1], [Sl, Ml, Fl, Ll] = this.viewport.viewBox, Nl = Fl - Sl, ql = Ll - Ml;
                return this.container.style.left = `${100 * (wl - Sl) / Nl}%`, this.container.style.top = `${100 * (dl - Ml) / ql}%`, this.container.append(gl.render()), this.container;
              }
            }
            class ws {
              constructor(_s) {
                this.container = _s.container, this.trigger = _s.trigger, this.color = _s.color, this.titleObj = _s.titleObj, this.modificationDate = _s.modificationDate, this.contentsObj = _s.contentsObj, this.richText = _s.richText, this.hideWrapper = _s.hideWrapper || !1, this.pinned = !1;
              }
              render() {
                const Gs = document.createElement("div");
                Gs.className = "popupWrapper", this.hideElement = this.hideWrapper ? Gs : this.container, this.hideElement.hidden = !0;
                const vl = document.createElement("div");
                vl.className = "popup";
                const gl = this.color;
                if (gl) {
                  const wl = 0.7 * (255 - gl[0]) + gl[0], dl = 0.7 * (255 - gl[1]) + gl[1], Sl = 0.7 * (255 - gl[2]) + gl[2];
                  vl.style.backgroundColor = Xi.Util.makeHexColor(wl | 0, dl | 0, Sl | 0);
                }
                const El = document.createElement("h1");
                El.dir = this.titleObj.dir, El.textContent = this.titleObj.str, vl.append(El);
                const Ol = Qi.PDFDateString.toDateObject(this.modificationDate);
                if (Ol) {
                  const wl = document.createElement("span");
                  wl.className = "popupDate", wl.textContent = "{{date}}, {{time}}", wl.dataset.l10nId = "annotation_date_string", wl.dataset.l10nArgs = JSON.stringify({
                    date: Ol.toLocaleDateString(),
                    time: Ol.toLocaleTimeString()
                  }), vl.append(wl);
                }
                if (this.richText?.str && (!this.contentsObj?.str || this.contentsObj.str === this.richText.str))
                  na.XfaLayer.render({
                    xfaHtml: this.richText.html,
                    intent: "richText",
                    div: vl
                  }), vl.lastChild.className = "richText popupContent";
                else {
                  const wl = this._formatContents(this.contentsObj);
                  vl.append(wl);
                }
                Array.isArray(this.trigger) || (this.trigger = [this.trigger]);
                for (const wl of this.trigger)
                  wl.addEventListener("click", this._toggle.bind(this)), wl.addEventListener("mouseover", this._show.bind(this, !1)), wl.addEventListener("mouseout", this._hide.bind(this, !1));
                return vl.addEventListener("click", this._hide.bind(this, !0)), Gs.append(vl), Gs;
              }
              _formatContents({
                str: _s,
                dir: Gs
              }) {
                const vl = document.createElement("p");
                vl.className = "popupContent", vl.dir = Gs;
                const gl = _s.split(/(?:\r\n?|\n)/);
                for (let El = 0, Ol = gl.length; El < Ol; ++El) {
                  const wl = gl[El];
                  vl.append(document.createTextNode(wl)), El < Ol - 1 && vl.append(document.createElement("br"));
                }
                return vl;
              }
              _toggle() {
                this.pinned ? this._hide(!0) : this._show(!0);
              }
              _show(_s = !1) {
                _s && (this.pinned = !0), this.hideElement.hidden && (this.hideElement.hidden = !1, this.container.style.zIndex = parseInt(this.container.style.zIndex) + 1e3);
              }
              _hide(_s = !0) {
                _s && (this.pinned = !1), !this.hideElement.hidden && !this.pinned && (this.hideElement.hidden = !0, this.container.style.zIndex = parseInt(this.container.style.zIndex) - 1e3);
              }
            }
            class ls extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                }), this.textContent = _s.data.textContent;
              }
              render() {
                if (this.container.className = "freeTextAnnotation", this.textContent) {
                  const _s = document.createElement("div");
                  _s.className = "annotationTextContent", _s.setAttribute("role", "comment");
                  for (const Gs of this.textContent) {
                    const vl = document.createElement("span");
                    vl.textContent = Gs, _s.append(vl);
                  }
                  this.container.append(_s);
                }
                return this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class ks extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "lineAnnotation";
                const _s = this.data, {
                  width: Gs,
                  height: vl
                } = to(_s.rect), gl = this.svgFactory.create(Gs, vl, !0), El = this.svgFactory.createElement("svg:line");
                return El.setAttribute("x1", _s.rect[2] - _s.lineCoordinates[0]), El.setAttribute("y1", _s.rect[3] - _s.lineCoordinates[1]), El.setAttribute("x2", _s.rect[2] - _s.lineCoordinates[2]), El.setAttribute("y2", _s.rect[3] - _s.lineCoordinates[3]), El.setAttribute("stroke-width", _s.borderStyle.width || 1), El.setAttribute("stroke", "transparent"), El.setAttribute("fill", "transparent"), gl.append(El), this.container.append(gl), this._createPopup(El, _s), this.container;
              }
            }
            class Js extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "squareAnnotation";
                const _s = this.data, {
                  width: Gs,
                  height: vl
                } = to(_s.rect), gl = this.svgFactory.create(Gs, vl, !0), El = _s.borderStyle.width, Ol = this.svgFactory.createElement("svg:rect");
                return Ol.setAttribute("x", El / 2), Ol.setAttribute("y", El / 2), Ol.setAttribute("width", Gs - El), Ol.setAttribute("height", vl - El), Ol.setAttribute("stroke-width", El || 1), Ol.setAttribute("stroke", "transparent"), Ol.setAttribute("fill", "transparent"), gl.append(Ol), this.container.append(gl), this._createPopup(Ol, _s), this.container;
              }
            }
            class pl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                });
              }
              render() {
                this.container.className = "circleAnnotation";
                const _s = this.data, {
                  width: Gs,
                  height: vl
                } = to(_s.rect), gl = this.svgFactory.create(Gs, vl, !0), El = _s.borderStyle.width, Ol = this.svgFactory.createElement("svg:ellipse");
                return Ol.setAttribute("cx", Gs / 2), Ol.setAttribute("cy", vl / 2), Ol.setAttribute("rx", Gs / 2 - El / 2), Ol.setAttribute("ry", vl / 2 - El / 2), Ol.setAttribute("stroke-width", El || 1), Ol.setAttribute("stroke", "transparent"), Ol.setAttribute("fill", "transparent"), gl.append(Ol), this.container.append(gl), this._createPopup(Ol, _s), this.container;
              }
            }
            class _l extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                }), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.className = this.containerClassName;
                const _s = this.data, {
                  width: Gs,
                  height: vl
                } = to(_s.rect), gl = this.svgFactory.create(Gs, vl, !0);
                let El = [];
                for (const wl of _s.vertices) {
                  const dl = wl.x - _s.rect[0], Sl = _s.rect[3] - wl.y;
                  El.push(dl + "," + Sl);
                }
                El = El.join(" ");
                const Ol = this.svgFactory.createElement(this.svgElementName);
                return Ol.setAttribute("points", El), Ol.setAttribute("stroke-width", _s.borderStyle.width || 1), Ol.setAttribute("stroke", "transparent"), Ol.setAttribute("fill", "transparent"), gl.append(Ol), this.container.append(gl), this._createPopup(Ol, _s), this.container;
              }
            }
            class bl extends _l {
              constructor(_s) {
                super(_s), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
              }
            }
            class xl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.className = "caretAnnotation", this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class Rl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                }), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.className = this.containerClassName;
                const _s = this.data, {
                  width: Gs,
                  height: vl
                } = to(_s.rect), gl = this.svgFactory.create(Gs, vl, !0);
                for (const El of _s.inkLists) {
                  let Ol = [];
                  for (const dl of El) {
                    const Sl = dl.x - _s.rect[0], Ml = _s.rect[3] - dl.y;
                    Ol.push(`${Sl},${Ml}`);
                  }
                  Ol = Ol.join(" ");
                  const wl = this.svgFactory.createElement(this.svgElementName);
                  wl.setAttribute("points", Ol), wl.setAttribute("stroke-width", _s.borderStyle.width || 1), wl.setAttribute("stroke", "transparent"), wl.setAttribute("fill", "transparent"), this._createPopup(wl, _s), gl.append(wl);
                }
                return this.container.append(gl), this.container;
              }
            }
            class Cl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("highlightAnnotation") : (this.container.className = "highlightAnnotation", this.container);
              }
            }
            class Dl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("underlineAnnotation") : (this.container.className = "underlineAnnotation", this.container);
              }
            }
            class kl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("squigglyAnnotation") : (this.container.className = "squigglyAnnotation", this.container);
              }
            }
            class Ul extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0,
                  createQuadrilaterals: !0
                });
              }
              render() {
                return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("strikeoutAnnotation") : (this.container.className = "strikeoutAnnotation", this.container);
              }
            }
            class Bl extends So {
              constructor(_s) {
                const Gs = !!(_s.data.hasPopup || _s.data.titleObj?.str || _s.data.contentsObj?.str || _s.data.richText?.str);
                super(_s, {
                  isRenderable: Gs,
                  ignoreBorder: !0
                });
              }
              render() {
                return this.container.className = "stampAnnotation", this.data.hasPopup || this._createPopup(null, this.data), this.container;
              }
            }
            class Zl extends So {
              constructor(_s) {
                super(_s, {
                  isRenderable: !0
                });
                const {
                  filename: Gs,
                  content: vl
                } = this.data.file;
                this.filename = (0, Qi.getFilenameFromUrl)(Gs), this.content = vl, this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                  source: this,
                  filename: Gs,
                  content: vl
                });
              }
              render() {
                this.container.className = "fileAttachmentAnnotation";
                const _s = document.createElement("div");
                return _s.className = "popupTriggerArea", _s.addEventListener("dblclick", this._download.bind(this)), !this.data.hasPopup && (this.data.titleObj?.str || this.data.contentsObj?.str || this.data.richText) && this._createPopup(_s, this.data), this.container.append(_s), this.container;
              }
              _download() {
                this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
              }
            }
            const jl = class jl {
              static render(_s) {
                var wl, dl;
                const {
                  annotations: Gs,
                  div: vl,
                  viewport: gl,
                  accessibilityManager: El
                } = _s;
                rc(this, yl, bf).call(this, vl, gl);
                let Ol = 0;
                for (const Sl of Gs) {
                  if (Sl.annotationType !== Xi.AnnotationType.POPUP) {
                    const {
                      width: Fl,
                      height: Ll
                    } = to(Sl.rect);
                    if (Fl <= 0 || Ll <= 0)
                      continue;
                  }
                  const Ml = Eo.create({
                    data: Sl,
                    layer: vl,
                    page: _s.page,
                    viewport: gl,
                    linkService: _s.linkService,
                    downloadManager: _s.downloadManager,
                    imageResourcesPath: _s.imageResourcesPath || "",
                    renderForms: _s.renderForms !== !1,
                    svgFactory: new Qi.DOMSVGFactory(),
                    annotationStorage: _s.annotationStorage || new ta.AnnotationStorage(),
                    enableScripting: _s.enableScripting,
                    hasJSActions: _s.hasJSActions,
                    fieldObjects: _s.fieldObjects,
                    mouseState: _s.mouseState || {
                      isDown: !1
                    }
                  });
                  if (Ml.isRenderable) {
                    const Fl = Ml.render();
                    if (Sl.hidden && (Fl.style.visibility = "hidden"), Array.isArray(Fl))
                      for (const Ll of Fl)
                        Ll.style.zIndex = Ol++, rc(wl = jl, yl, gf).call(wl, Ll, Sl.id, vl, El);
                    else
                      Fl.style.zIndex = Ol++, Ml instanceof Fs ? vl.prepend(Fl) : rc(dl = jl, yl, gf).call(dl, Fl, Sl.id, vl, El);
                  }
                }
                rc(this, yl, yf).call(this, vl, _s.annotationCanvasMap);
              }
              static update(_s) {
                const {
                  annotationCanvasMap: Gs,
                  div: vl,
                  viewport: gl
                } = _s;
                rc(this, yl, bf).call(this, vl, gl), rc(this, yl, yf).call(this, vl, Gs), vl.hidden = !1;
              }
            };
            yl = new WeakSet(), gf = function(_s, Gs, vl, gl) {
              const El = _s.firstChild || _s;
              El.id = `${Qi.AnnotationPrefix}${Gs}`, vl.append(_s), gl?.moveElementInDOM(vl, _s, El, !1);
            }, bf = function(_s, {
              width: Gs,
              height: vl,
              rotation: gl
            }) {
              const {
                style: El
              } = _s, Ol = gl % 180 !== 0, wl = Math.floor(Gs) + "px", dl = Math.floor(vl) + "px";
              El.width = Ol ? dl : wl, El.height = Ol ? wl : dl, _s.setAttribute("data-main-rotation", gl);
            }, yf = function(_s, Gs) {
              if (Gs) {
                for (const [vl, gl] of Gs) {
                  const El = _s.querySelector(`[data-annotation-id="${vl}"]`);
                  if (!El)
                    continue;
                  const {
                    firstChild: Ol
                  } = El;
                  Ol ? Ol.nodeName === "CANVAS" ? Ol.replaceWith(gl) : Ol.before(gl) : El.append(gl);
                }
                Gs.clear();
              }
            }, $u(jl, yl);
            let Pl = jl;
            e.AnnotationLayer = Pl;
          },
          /* 28 */
          /***/
          (Bi, e) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.ColorConverters = void 0;
            function qi(Qi) {
              return Math.floor(Math.max(0, Math.min(1, Qi)) * 255).toString(16).padStart(2, "0");
            }
            class Xi {
              static CMYK_G([ta, ra, na, la]) {
                return ["G", 1 - Math.min(1, 0.3 * ta + 0.59 * na + 0.11 * ra + la)];
              }
              static G_CMYK([ta]) {
                return ["CMYK", 0, 0, 0, 1 - ta];
              }
              static G_RGB([ta]) {
                return ["RGB", ta, ta, ta];
              }
              static G_HTML([ta]) {
                const ra = qi(ta);
                return `#${ra}${ra}${ra}`;
              }
              static RGB_G([ta, ra, na]) {
                return ["G", 0.3 * ta + 0.59 * ra + 0.11 * na];
              }
              static RGB_HTML([ta, ra, na]) {
                const la = qi(ta), Ma = qi(ra), Va = qi(na);
                return `#${la}${Ma}${Va}`;
              }
              static T_HTML() {
                return "#00000000";
              }
              static CMYK_RGB([ta, ra, na, la]) {
                return ["RGB", 1 - Math.min(1, ta + la), 1 - Math.min(1, na + la), 1 - Math.min(1, ra + la)];
              }
              static CMYK_HTML(ta) {
                const ra = this.CMYK_RGB(ta).slice(1);
                return this.RGB_HTML(ra);
              }
              static RGB_CMYK([ta, ra, na]) {
                const la = 1 - ta, Ma = 1 - ra, Va = 1 - na, to = Math.min(la, Ma, Va);
                return ["CMYK", la, Ma, Va, to];
              }
            }
            e.ColorConverters = Xi;
          },
          /* 29 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.XfaLayer = void 0;
            var Xi = qi(20);
            class Qi {
              static setupStorage(ra, na, la, Ma, Va) {
                const to = Ma.getValue(na, {
                  value: null
                });
                switch (la.name) {
                  case "textarea":
                    if (to.value !== null && (ra.textContent = to.value), Va === "print")
                      break;
                    ra.addEventListener("input", (Eo) => {
                      Ma.setValue(na, {
                        value: Eo.target.value
                      });
                    });
                    break;
                  case "input":
                    if (la.attributes.type === "radio" || la.attributes.type === "checkbox") {
                      if (to.value === la.attributes.xfaOn ? ra.setAttribute("checked", !0) : to.value === la.attributes.xfaOff && ra.removeAttribute("checked"), Va === "print")
                        break;
                      ra.addEventListener("change", (Eo) => {
                        Ma.setValue(na, {
                          value: Eo.target.checked ? Eo.target.getAttribute("xfaOn") : Eo.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (to.value !== null && ra.setAttribute("value", to.value), Va === "print")
                        break;
                      ra.addEventListener("input", (Eo) => {
                        Ma.setValue(na, {
                          value: Eo.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (to.value !== null)
                      for (const Eo of la.children)
                        Eo.attributes.value === to.value && (Eo.attributes.selected = !0);
                    ra.addEventListener("input", (Eo) => {
                      const So = Eo.target.options, eo = So.selectedIndex === -1 ? "" : So[So.selectedIndex].value;
                      Ma.setValue(na, {
                        value: eo
                      });
                    });
                    break;
                }
              }
              static setAttributes({
                html: ra,
                element: na,
                storage: la = null,
                intent: Ma,
                linkService: Va
              }) {
                const {
                  attributes: to
                } = na, Eo = ra instanceof HTMLAnchorElement;
                to.type === "radio" && (to.name = `${to.name}-${Ma}`);
                for (const [So, eo] of Object.entries(to))
                  if (eo != null)
                    switch (So) {
                      case "class":
                        eo.length && ra.setAttribute(So, eo.join(" "));
                        break;
                      case "dataId":
                        break;
                      case "id":
                        ra.setAttribute("data-element-id", eo);
                        break;
                      case "style":
                        Object.assign(ra.style, eo);
                        break;
                      case "textContent":
                        ra.textContent = eo;
                        break;
                      default:
                        (!Eo || So !== "href" && So !== "newWindow") && ra.setAttribute(So, eo);
                    }
                Eo && Va.addLinkAttributes(ra, to.href, to.newWindow), la && to.dataId && this.setupStorage(ra, to.dataId, na, la);
              }
              static render(ra) {
                const na = ra.annotationStorage, la = ra.linkService, Ma = ra.xfaHtml, Va = ra.intent || "display", to = document.createElement(Ma.name);
                Ma.attributes && this.setAttributes({
                  html: to,
                  element: Ma,
                  intent: Va,
                  linkService: la
                });
                const Eo = [[Ma, -1, to]], So = ra.div;
                if (So.append(to), ra.viewport) {
                  const rs = `matrix(${ra.viewport.transform.join(",")})`;
                  So.style.transform = rs;
                }
                Va !== "richText" && So.setAttribute("class", "xfaLayer xfaFont");
                const eo = [];
                for (; Eo.length > 0; ) {
                  const [rs, ko, Hs] = Eo.at(-1);
                  if (ko + 1 === rs.children.length) {
                    Eo.pop();
                    continue;
                  }
                  const Ks = rs.children[++Eo.at(-1)[1]];
                  if (Ks === null)
                    continue;
                  const {
                    name: Ys
                  } = Ks;
                  if (Ys === "#text") {
                    const Cs = document.createTextNode(Ks.value);
                    eo.push(Cs), Hs.append(Cs);
                    continue;
                  }
                  let Xs;
                  if (Ks?.attributes?.xmlns ? Xs = document.createElementNS(Ks.attributes.xmlns, Ys) : Xs = document.createElement(Ys), Hs.append(Xs), Ks.attributes && this.setAttributes({
                    html: Xs,
                    element: Ks,
                    storage: na,
                    intent: Va,
                    linkService: la
                  }), Ks.children && Ks.children.length > 0)
                    Eo.push([Ks, -1, Xs]);
                  else if (Ks.value) {
                    const Cs = document.createTextNode(Ks.value);
                    Xi.XfaText.shouldBuildText(Ys) && eo.push(Cs), Xs.append(Cs);
                  }
                }
                for (const rs of So.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                  rs.setAttribute("readOnly", !0);
                return {
                  textDivs: eo
                };
              }
              static update(ra) {
                const na = `matrix(${ra.viewport.transform.join(",")})`;
                ra.div.style.transform = na, ra.div.hidden = !1;
              }
            }
            e.XfaLayer = Qi;
          },
          /* 30 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.TextLayerRenderTask = void 0, e.renderTextLayer = Ks;
            var Xi = qi(1), Qi = qi(8);
            const ta = 1e5, ra = 30, na = 0.8, la = /* @__PURE__ */ new Map(), Ma = /^\s+$/g;
            function Va(Ys, Xs) {
              const Cs = la.get(Ys);
              if (Cs)
                return Cs;
              Xs.save(), Xs.font = `${ra}px ${Ys}`;
              const Fs = Xs.measureText("");
              let ws = Fs.fontBoundingBoxAscent, ls = Math.abs(Fs.fontBoundingBoxDescent);
              if (ws) {
                Xs.restore();
                const Js = ws / (ws + ls);
                return la.set(Ys, Js), Js;
              }
              Xs.strokeStyle = "red", Xs.clearRect(0, 0, ra, ra), Xs.strokeText("g", 0, 0);
              let ks = Xs.getImageData(0, 0, ra, ra).data;
              ls = 0;
              for (let Js = ks.length - 1 - 3; Js >= 0; Js -= 4)
                if (ks[Js] > 0) {
                  ls = Math.ceil(Js / 4 / ra);
                  break;
                }
              Xs.clearRect(0, 0, ra, ra), Xs.strokeText("A", 0, ra), ks = Xs.getImageData(0, 0, ra, ra).data, ws = 0;
              for (let Js = 0, pl = ks.length; Js < pl; Js += 4)
                if (ks[Js] > 0) {
                  ws = ra - Math.floor(Js / 4 / ra);
                  break;
                }
              if (Xs.restore(), ws) {
                const Js = ws / (ws + ls);
                return la.set(Ys, Js), Js;
              }
              return la.set(Ys, na), na;
            }
            function to(Ys, Xs, Cs, Fs) {
              const ws = document.createElement("span"), ls = Ys._enhanceTextSelection ? {
                angle: 0,
                canvasWidth: 0,
                hasText: Xs.str !== "",
                hasEOL: Xs.hasEOL,
                originalTransform: null,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                scale: 1,
                fontSize: 0
              } : {
                angle: 0,
                canvasWidth: 0,
                hasText: Xs.str !== "",
                hasEOL: Xs.hasEOL,
                fontSize: 0
              };
              Ys._textDivs.push(ws);
              const ks = Xi.Util.transform(Ys._viewport.transform, Xs.transform);
              let Js = Math.atan2(ks[1], ks[0]);
              const pl = Cs[Xs.fontName];
              pl.vertical && (Js += Math.PI / 2);
              const _l = Math.hypot(ks[2], ks[3]), bl = _l * Va(pl.fontFamily, Fs);
              let xl, Rl;
              Js === 0 ? (xl = ks[4], Rl = ks[5] - bl) : (xl = ks[4] + bl * Math.sin(Js), Rl = ks[5] - bl * Math.cos(Js)), ws.style.left = `${xl}px`, ws.style.top = `${Rl}px`, ws.style.fontSize = `${_l}px`, ws.style.fontFamily = pl.fontFamily, ls.fontSize = _l, ws.setAttribute("role", "presentation"), ws.textContent = Xs.str, ws.dir = Xs.dir, Ys._fontInspectorEnabled && (ws.dataset.fontName = Xs.fontName), Js !== 0 && (ls.angle = Js * (180 / Math.PI));
              let Cl = !1;
              if (Xs.str.length > 1 || Ys._enhanceTextSelection && Ma.test(Xs.str))
                Cl = !0;
              else if (Xs.str !== " " && Xs.transform[0] !== Xs.transform[3]) {
                const Dl = Math.abs(Xs.transform[0]), kl = Math.abs(Xs.transform[3]);
                Dl !== kl && Math.max(Dl, kl) / Math.min(Dl, kl) > 1.5 && (Cl = !0);
              }
              if (Cl && (pl.vertical ? ls.canvasWidth = Xs.height * Ys._viewport.scale : ls.canvasWidth = Xs.width * Ys._viewport.scale), Ys._textDivProperties.set(ws, ls), Ys._textContentStream && Ys._layoutText(ws), Ys._enhanceTextSelection && ls.hasText) {
                let Dl = 1, kl = 0;
                Js !== 0 && (Dl = Math.cos(Js), kl = Math.sin(Js));
                const Ul = (pl.vertical ? Xs.height : Xs.width) * Ys._viewport.scale, Bl = _l;
                let Zl, Pl;
                Js !== 0 ? (Zl = [Dl, kl, -kl, Dl, xl, Rl], Pl = Xi.Util.getAxialAlignedBoundingBox([0, 0, Ul, Bl], Zl)) : Pl = [xl, Rl, xl + Ul, Rl + Bl], Ys._bounds.push({
                  left: Pl[0],
                  top: Pl[1],
                  right: Pl[2],
                  bottom: Pl[3],
                  div: ws,
                  size: [Ul, Bl],
                  m: Zl
                });
              }
            }
            function Eo(Ys) {
              if (Ys._canceled)
                return;
              const Xs = Ys._textDivs, Cs = Ys._capability, Fs = Xs.length;
              if (Fs > ta) {
                Ys._renderingDone = !0, Cs.resolve();
                return;
              }
              if (!Ys._textContentStream)
                for (let ws = 0; ws < Fs; ws++)
                  Ys._layoutText(Xs[ws]);
              Ys._renderingDone = !0, Cs.resolve();
            }
            function So(Ys, Xs, Cs) {
              let Fs = 0;
              for (let ws = 0; ws < Cs; ws++) {
                const ls = Ys[Xs++];
                ls > 0 && (Fs = Fs ? Math.min(ls, Fs) : ls);
              }
              return Fs;
            }
            function eo(Ys) {
              const Xs = Ys._bounds, Cs = Ys._viewport, Fs = rs(Cs.width, Cs.height, Xs);
              for (let ws = 0; ws < Fs.length; ws++) {
                const ls = Xs[ws].div, ks = Ys._textDivProperties.get(ls);
                if (ks.angle === 0) {
                  ks.paddingLeft = Xs[ws].left - Fs[ws].left, ks.paddingTop = Xs[ws].top - Fs[ws].top, ks.paddingRight = Fs[ws].right - Xs[ws].right, ks.paddingBottom = Fs[ws].bottom - Xs[ws].bottom, Ys._textDivProperties.set(ls, ks);
                  continue;
                }
                const Js = Fs[ws], pl = Xs[ws], _l = pl.m, bl = _l[0], xl = _l[1], Rl = [[0, 0], [0, pl.size[1]], [pl.size[0], 0], pl.size], Cl = new Float64Array(64);
                for (let kl = 0, Ul = Rl.length; kl < Ul; kl++) {
                  const Bl = Xi.Util.applyTransform(Rl[kl], _l);
                  Cl[kl + 0] = bl && (Js.left - Bl[0]) / bl, Cl[kl + 4] = xl && (Js.top - Bl[1]) / xl, Cl[kl + 8] = bl && (Js.right - Bl[0]) / bl, Cl[kl + 12] = xl && (Js.bottom - Bl[1]) / xl, Cl[kl + 16] = xl && (Js.left - Bl[0]) / -xl, Cl[kl + 20] = bl && (Js.top - Bl[1]) / bl, Cl[kl + 24] = xl && (Js.right - Bl[0]) / -xl, Cl[kl + 28] = bl && (Js.bottom - Bl[1]) / bl, Cl[kl + 32] = bl && (Js.left - Bl[0]) / -bl, Cl[kl + 36] = xl && (Js.top - Bl[1]) / -xl, Cl[kl + 40] = bl && (Js.right - Bl[0]) / -bl, Cl[kl + 44] = xl && (Js.bottom - Bl[1]) / -xl, Cl[kl + 48] = xl && (Js.left - Bl[0]) / xl, Cl[kl + 52] = bl && (Js.top - Bl[1]) / -bl, Cl[kl + 56] = xl && (Js.right - Bl[0]) / xl, Cl[kl + 60] = bl && (Js.bottom - Bl[1]) / -bl;
                }
                const Dl = 1 + Math.min(Math.abs(bl), Math.abs(xl));
                ks.paddingLeft = So(Cl, 32, 16) / Dl, ks.paddingTop = So(Cl, 48, 16) / Dl, ks.paddingRight = So(Cl, 0, 16) / Dl, ks.paddingBottom = So(Cl, 16, 16) / Dl, Ys._textDivProperties.set(ls, ks);
              }
            }
            function rs(Ys, Xs, Cs) {
              const Fs = Cs.map(function(ls, ks) {
                return {
                  x1: ls.left,
                  y1: ls.top,
                  x2: ls.right,
                  y2: ls.bottom,
                  index: ks,
                  x1New: void 0,
                  x2New: void 0
                };
              });
              ko(Ys, Fs);
              const ws = new Array(Cs.length);
              for (const ls of Fs) {
                const ks = ls.index;
                ws[ks] = {
                  left: ls.x1New,
                  top: 0,
                  right: ls.x2New,
                  bottom: 0
                };
              }
              Cs.map(function(ls, ks) {
                const Js = ws[ks], pl = Fs[ks];
                pl.x1 = ls.top, pl.y1 = Ys - Js.right, pl.x2 = ls.bottom, pl.y2 = Ys - Js.left, pl.index = ks, pl.x1New = void 0, pl.x2New = void 0;
              }), ko(Xs, Fs);
              for (const ls of Fs) {
                const ks = ls.index;
                ws[ks].top = ls.x1New, ws[ks].bottom = ls.x2New;
              }
              return ws;
            }
            function ko(Ys, Xs) {
              Xs.sort(function(ws, ls) {
                return ws.x1 - ls.x1 || ws.index - ls.index;
              });
              const Fs = [{
                start: -1 / 0,
                end: 1 / 0,
                boundary: {
                  x1: -1 / 0,
                  y1: -1 / 0,
                  x2: 0,
                  y2: 1 / 0,
                  index: -1,
                  x1New: 0,
                  x2New: 0
                }
              }];
              for (const ws of Xs) {
                let ls = 0;
                for (; ls < Fs.length && Fs[ls].end <= ws.y1; )
                  ls++;
                let ks = Fs.length - 1;
                for (; ks >= 0 && Fs[ks].start >= ws.y2; )
                  ks--;
                let Js, pl, _l, bl, xl = -1 / 0;
                for (_l = ls; _l <= ks; _l++) {
                  Js = Fs[_l], pl = Js.boundary;
                  let Dl;
                  pl.x2 > ws.x1 ? Dl = pl.index > ws.index ? pl.x1New : ws.x1 : pl.x2New === void 0 ? Dl = (pl.x2 + ws.x1) / 2 : Dl = pl.x2New, Dl > xl && (xl = Dl);
                }
                for (ws.x1New = xl, _l = ls; _l <= ks; _l++)
                  Js = Fs[_l], pl = Js.boundary, pl.x2New === void 0 ? pl.x2 > ws.x1 ? pl.index > ws.index && (pl.x2New = pl.x2) : pl.x2New = xl : pl.x2New > xl && (pl.x2New = Math.max(xl, pl.x2));
                const Rl = [];
                let Cl = null;
                for (_l = ls; _l <= ks; _l++) {
                  Js = Fs[_l], pl = Js.boundary;
                  const Dl = pl.x2 > ws.x2 ? pl : ws;
                  Cl === Dl ? Rl.at(-1).end = Js.end : (Rl.push({
                    start: Js.start,
                    end: Js.end,
                    boundary: Dl
                  }), Cl = Dl);
                }
                for (Fs[ls].start < ws.y1 && (Rl[0].start = ws.y1, Rl.unshift({
                  start: Fs[ls].start,
                  end: ws.y1,
                  boundary: Fs[ls].boundary
                })), ws.y2 < Fs[ks].end && (Rl.at(-1).end = ws.y2, Rl.push({
                  start: ws.y2,
                  end: Fs[ks].end,
                  boundary: Fs[ks].boundary
                })), _l = ls; _l <= ks; _l++) {
                  if (Js = Fs[_l], pl = Js.boundary, pl.x2New !== void 0)
                    continue;
                  let Dl = !1;
                  for (bl = ls - 1; !Dl && bl >= 0 && Fs[bl].start >= pl.y1; bl--)
                    Dl = Fs[bl].boundary === pl;
                  for (bl = ks + 1; !Dl && bl < Fs.length && Fs[bl].end <= pl.y2; bl++)
                    Dl = Fs[bl].boundary === pl;
                  for (bl = 0; !Dl && bl < Rl.length; bl++)
                    Dl = Rl[bl].boundary === pl;
                  Dl || (pl.x2New = xl);
                }
                Array.prototype.splice.apply(Fs, [ls, ks - ls + 1, ...Rl]);
              }
              for (const ws of Fs) {
                const ls = ws.boundary;
                ls.x2New === void 0 && (ls.x2New = Math.max(Ys, ls.x2));
              }
            }
            class Hs {
              constructor({
                textContent: Xs,
                textContentStream: Cs,
                container: Fs,
                viewport: ws,
                textDivs: ls,
                textContentItemsStr: ks,
                enhanceTextSelection: Js
              }) {
                Js && (0, Qi.deprecated)("The `enhanceTextSelection` functionality will be removed in the future."), this._textContent = Xs, this._textContentStream = Cs, this._container = Fs, this._document = Fs.ownerDocument, this._viewport = ws, this._textDivs = ls || [], this._textContentItemsStr = ks || [], this._enhanceTextSelection = !!Js, this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled, this._reader = null, this._layoutTextLastFontSize = null, this._layoutTextLastFontFamily = null, this._layoutTextCtx = null, this._textDivProperties = /* @__PURE__ */ new WeakMap(), this._renderingDone = !1, this._canceled = !1, this._capability = (0, Xi.createPromiseCapability)(), this._renderTimer = null, this._bounds = [], this._devicePixelRatio = globalThis.devicePixelRatio || 1, this._capability.promise.finally(() => {
                  this._enhanceTextSelection || (this._textDivProperties = null), this._layoutTextCtx && (this._layoutTextCtx.canvas.width = 0, this._layoutTextCtx.canvas.height = 0, this._layoutTextCtx = null);
                }).catch(() => {
                });
              }
              get promise() {
                return this._capability.promise;
              }
              cancel() {
                this._canceled = !0, this._reader && (this._reader.cancel(new Xi.AbortException("TextLayer task cancelled.")).catch(() => {
                }), this._reader = null), this._renderTimer !== null && (clearTimeout(this._renderTimer), this._renderTimer = null), this._capability.reject(new Error("TextLayer task cancelled."));
              }
              _processItems(Xs, Cs) {
                for (let Fs = 0, ws = Xs.length; Fs < ws; Fs++) {
                  if (Xs[Fs].str === void 0) {
                    if (Xs[Fs].type === "beginMarkedContentProps" || Xs[Fs].type === "beginMarkedContent") {
                      const ls = this._container;
                      this._container = document.createElement("span"), this._container.classList.add("markedContent"), Xs[Fs].id !== null && this._container.setAttribute("id", `${Xs[Fs].id}`), ls.append(this._container);
                    } else Xs[Fs].type === "endMarkedContent" && (this._container = this._container.parentNode);
                    continue;
                  }
                  this._textContentItemsStr.push(Xs[Fs].str), to(this, Xs[Fs], Cs, this._layoutTextCtx);
                }
              }
              _layoutText(Xs) {
                const Cs = this._textDivProperties.get(Xs);
                let Fs = "";
                if (Cs.canvasWidth !== 0 && Cs.hasText) {
                  const {
                    fontFamily: ws
                  } = Xs.style, {
                    fontSize: ls
                  } = Cs;
                  (ls !== this._layoutTextLastFontSize || ws !== this._layoutTextLastFontFamily) && (this._layoutTextCtx.font = `${ls * this._devicePixelRatio}px ${ws}`, this._layoutTextLastFontSize = ls, this._layoutTextLastFontFamily = ws);
                  const {
                    width: ks
                  } = this._layoutTextCtx.measureText(Xs.textContent);
                  if (ks > 0) {
                    const Js = this._devicePixelRatio * Cs.canvasWidth / ks;
                    this._enhanceTextSelection && (Cs.scale = Js), Fs = `scaleX(${Js})`;
                  }
                }
                if (Cs.angle !== 0 && (Fs = `rotate(${Cs.angle}deg) ${Fs}`), Fs.length > 0 && (this._enhanceTextSelection && (Cs.originalTransform = Fs), Xs.style.transform = Fs), Cs.hasText && this._container.append(Xs), Cs.hasEOL) {
                  const ws = document.createElement("br");
                  ws.setAttribute("role", "presentation"), this._container.append(ws);
                }
              }
              _render(Xs = 0) {
                const Cs = (0, Xi.createPromiseCapability)();
                let Fs = /* @__PURE__ */ Object.create(null);
                const ws = this._document.createElement("canvas");
                if (ws.height = ws.width = ra, this._layoutTextCtx = ws.getContext("2d", {
                  alpha: !1
                }), this._textContent) {
                  const ls = this._textContent.items, ks = this._textContent.styles;
                  this._processItems(ls, ks), Cs.resolve();
                } else if (this._textContentStream) {
                  const ls = () => {
                    this._reader.read().then(({
                      value: ks,
                      done: Js
                    }) => {
                      if (Js) {
                        Cs.resolve();
                        return;
                      }
                      Object.assign(Fs, ks.styles), this._processItems(ks.items, Fs), ls();
                    }, Cs.reject);
                  };
                  this._reader = this._textContentStream.getReader(), ls();
                } else
                  throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                Cs.promise.then(() => {
                  Fs = null, Xs ? this._renderTimer = setTimeout(() => {
                    Eo(this), this._renderTimer = null;
                  }, Xs) : Eo(this);
                }, this._capability.reject);
              }
              expandTextDivs(Xs = !1) {
                if (!this._enhanceTextSelection || !this._renderingDone)
                  return;
                this._bounds !== null && (eo(this), this._bounds = null);
                const Cs = [], Fs = [];
                for (let ws = 0, ls = this._textDivs.length; ws < ls; ws++) {
                  const ks = this._textDivs[ws], Js = this._textDivProperties.get(ks);
                  Js.hasText && (Xs ? (Cs.length = 0, Fs.length = 0, Js.originalTransform && Cs.push(Js.originalTransform), Js.paddingTop > 0 ? (Fs.push(`${Js.paddingTop}px`), Cs.push(`translateY(${-Js.paddingTop}px)`)) : Fs.push(0), Js.paddingRight > 0 ? Fs.push(`${Js.paddingRight / Js.scale}px`) : Fs.push(0), Js.paddingBottom > 0 ? Fs.push(`${Js.paddingBottom}px`) : Fs.push(0), Js.paddingLeft > 0 ? (Fs.push(`${Js.paddingLeft / Js.scale}px`), Cs.push(`translateX(${-Js.paddingLeft / Js.scale}px)`)) : Fs.push(0), ks.style.padding = Fs.join(" "), Cs.length && (ks.style.transform = Cs.join(" "))) : (ks.style.padding = null, ks.style.transform = Js.originalTransform));
                }
              }
            }
            e.TextLayerRenderTask = Hs;
            function Ks(Ys) {
              const Xs = new Hs({
                textContent: Ys.textContent,
                textContentStream: Ys.textContentStream,
                container: Ys.container,
                viewport: Ys.viewport,
                textDivs: Ys.textDivs,
                textContentItemsStr: Ys.textContentItemsStr,
                enhanceTextSelection: Ys.enhanceTextSelection
              });
              return Xs._render(Ys.timeout), Xs;
            }
          },
          /* 31 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.SVGGraphics = void 0;
            var Xi = qi(8), Qi = qi(1), ta = qi(3);
            let ra = class {
              constructor() {
                (0, Qi.unreachable)("Not implemented: SVGGraphics");
              }
            };
            e.SVGGraphics = ra;
            {
              let rs = function(Cs) {
                let Fs = [];
                const ws = [];
                for (const ls of Cs) {
                  if (ls.fn === "save") {
                    Fs.push({
                      fnId: 92,
                      fn: "group",
                      items: []
                    }), ws.push(Fs), Fs = Fs.at(-1).items;
                    continue;
                  }
                  ls.fn === "restore" ? Fs = ws.pop() : Fs.push(ls);
                }
                return Fs;
              }, ko = function(Cs) {
                if (Number.isInteger(Cs))
                  return Cs.toString();
                const Fs = Cs.toFixed(10);
                let ws = Fs.length - 1;
                if (Fs[ws] !== "0")
                  return Fs;
                do
                  ws--;
                while (Fs[ws] === "0");
                return Fs.substring(0, Fs[ws] === "." ? ws : ws + 1);
              }, Hs = function(Cs) {
                if (Cs[4] === 0 && Cs[5] === 0) {
                  if (Cs[1] === 0 && Cs[2] === 0)
                    return Cs[0] === 1 && Cs[3] === 1 ? "" : `scale(${ko(Cs[0])} ${ko(Cs[3])})`;
                  if (Cs[0] === Cs[3] && Cs[1] === -Cs[2]) {
                    const Fs = Math.acos(Cs[0]) * 180 / Math.PI;
                    return `rotate(${ko(Fs)})`;
                  }
                } else if (Cs[0] === 1 && Cs[1] === 0 && Cs[2] === 0 && Cs[3] === 1)
                  return `translate(${ko(Cs[4])} ${ko(Cs[5])})`;
                return `matrix(${ko(Cs[0])} ${ko(Cs[1])} ${ko(Cs[2])} ${ko(Cs[3])} ${ko(Cs[4])} ${ko(Cs[5])})`;
              };
              const na = {
                fontStyle: "normal",
                fontWeight: "normal",
                fillColor: "#000000"
              }, la = "http://www.w3.org/XML/1998/namespace", Ma = "http://www.w3.org/1999/xlink", Va = ["butt", "round", "square"], to = ["miter", "round", "bevel"], Eo = function(Cs, Fs = "", ws = !1) {
                if (URL.createObjectURL && typeof Blob < "u" && !ws)
                  return URL.createObjectURL(new Blob([Cs], {
                    type: Fs
                  }));
                const ls = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                let ks = `data:${Fs};base64,`;
                for (let Js = 0, pl = Cs.length; Js < pl; Js += 3) {
                  const _l = Cs[Js] & 255, bl = Cs[Js + 1] & 255, xl = Cs[Js + 2] & 255, Rl = _l >> 2, Cl = (_l & 3) << 4 | bl >> 4, Dl = Js + 1 < pl ? (bl & 15) << 2 | xl >> 6 : 64, kl = Js + 2 < pl ? xl & 63 : 64;
                  ks += ls[Rl] + ls[Cl] + ls[Dl] + ls[kl];
                }
                return ks;
              }, So = function() {
                const Cs = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), Fs = 12, ws = new Int32Array(256);
                for (let xl = 0; xl < 256; xl++) {
                  let Rl = xl;
                  for (let Cl = 0; Cl < 8; Cl++)
                    Rl & 1 ? Rl = 3988292384 ^ Rl >> 1 & 2147483647 : Rl = Rl >> 1 & 2147483647;
                  ws[xl] = Rl;
                }
                function ls(xl, Rl, Cl) {
                  let Dl = -1;
                  for (let kl = Rl; kl < Cl; kl++) {
                    const Ul = (Dl ^ xl[kl]) & 255, Bl = ws[Ul];
                    Dl = Dl >>> 8 ^ Bl;
                  }
                  return Dl ^ -1;
                }
                function ks(xl, Rl, Cl, Dl) {
                  let kl = Dl;
                  const Ul = Rl.length;
                  Cl[kl] = Ul >> 24 & 255, Cl[kl + 1] = Ul >> 16 & 255, Cl[kl + 2] = Ul >> 8 & 255, Cl[kl + 3] = Ul & 255, kl += 4, Cl[kl] = xl.charCodeAt(0) & 255, Cl[kl + 1] = xl.charCodeAt(1) & 255, Cl[kl + 2] = xl.charCodeAt(2) & 255, Cl[kl + 3] = xl.charCodeAt(3) & 255, kl += 4, Cl.set(Rl, kl), kl += Rl.length;
                  const Bl = ls(Cl, Dl + 4, kl);
                  Cl[kl] = Bl >> 24 & 255, Cl[kl + 1] = Bl >> 16 & 255, Cl[kl + 2] = Bl >> 8 & 255, Cl[kl + 3] = Bl & 255;
                }
                function Js(xl, Rl, Cl) {
                  let Dl = 1, kl = 0;
                  for (let Ul = Rl; Ul < Cl; ++Ul)
                    Dl = (Dl + (xl[Ul] & 255)) % 65521, kl = (kl + Dl) % 65521;
                  return kl << 16 | Dl;
                }
                function pl(xl) {
                  if (!ta.isNodeJS)
                    return _l(xl);
                  try {
                    let Rl;
                    parseInt(process.versions.node) >= 8 ? Rl = xl : Rl = Buffer.from(xl);
                    const Cl = require$$5.deflateSync(Rl, {
                      level: 9
                    });
                    return Cl instanceof Uint8Array ? Cl : new Uint8Array(Cl);
                  } catch (Rl) {
                    (0, Qi.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + Rl);
                  }
                  return _l(xl);
                }
                function _l(xl) {
                  let Rl = xl.length;
                  const Cl = 65535, Dl = Math.ceil(Rl / Cl), kl = new Uint8Array(2 + Rl + Dl * 5 + 4);
                  let Ul = 0;
                  kl[Ul++] = 120, kl[Ul++] = 156;
                  let Bl = 0;
                  for (; Rl > Cl; )
                    kl[Ul++] = 0, kl[Ul++] = 255, kl[Ul++] = 255, kl[Ul++] = 0, kl[Ul++] = 0, kl.set(xl.subarray(Bl, Bl + Cl), Ul), Ul += Cl, Bl += Cl, Rl -= Cl;
                  kl[Ul++] = 1, kl[Ul++] = Rl & 255, kl[Ul++] = Rl >> 8 & 255, kl[Ul++] = ~Rl & 65535 & 255, kl[Ul++] = (~Rl & 65535) >> 8 & 255, kl.set(xl.subarray(Bl), Ul), Ul += xl.length - Bl;
                  const Zl = Js(xl, 0, xl.length);
                  return kl[Ul++] = Zl >> 24 & 255, kl[Ul++] = Zl >> 16 & 255, kl[Ul++] = Zl >> 8 & 255, kl[Ul++] = Zl & 255, kl;
                }
                function bl(xl, Rl, Cl, Dl) {
                  const kl = xl.width, Ul = xl.height;
                  let Bl, Zl, Pl;
                  const yl = xl.data;
                  switch (Rl) {
                    case Qi.ImageKind.GRAYSCALE_1BPP:
                      Zl = 0, Bl = 1, Pl = kl + 7 >> 3;
                      break;
                    case Qi.ImageKind.RGB_24BPP:
                      Zl = 2, Bl = 8, Pl = kl * 3;
                      break;
                    case Qi.ImageKind.RGBA_32BPP:
                      Zl = 6, Bl = 8, Pl = kl * 4;
                      break;
                    default:
                      throw new Error("invalid format");
                  }
                  const hl = new Uint8Array((1 + Pl) * Ul);
                  let Tl = 0, Il = 0;
                  for (let gl = 0; gl < Ul; ++gl)
                    hl[Tl++] = 0, hl.set(yl.subarray(Il, Il + Pl), Tl), Il += Pl, Tl += Pl;
                  if (Rl === Qi.ImageKind.GRAYSCALE_1BPP && Dl) {
                    Tl = 0;
                    for (let gl = 0; gl < Ul; gl++) {
                      Tl++;
                      for (let El = 0; El < Pl; El++)
                        hl[Tl++] ^= 255;
                    }
                  }
                  const jl = new Uint8Array([kl >> 24 & 255, kl >> 16 & 255, kl >> 8 & 255, kl & 255, Ul >> 24 & 255, Ul >> 16 & 255, Ul >> 8 & 255, Ul & 255, Bl, Zl, 0, 0, 0]), Al = pl(hl), _s = Cs.length + Fs * 3 + jl.length + Al.length, Gs = new Uint8Array(_s);
                  let vl = 0;
                  return Gs.set(Cs, vl), vl += Cs.length, ks("IHDR", jl, Gs, vl), vl += Fs + jl.length, ks("IDATA", Al, Gs, vl), vl += Fs + Al.length, ks("IEND", new Uint8Array(0), Gs, vl), Eo(Gs, "image/png", Cl);
                }
                return function(Rl, Cl, Dl) {
                  const kl = Rl.kind === void 0 ? Qi.ImageKind.GRAYSCALE_1BPP : Rl.kind;
                  return bl(Rl, kl, Cl, Dl);
                };
              }();
              class eo {
                constructor() {
                  this.fontSizeScale = 1, this.fontWeight = na.fontWeight, this.fontSize = 0, this.textMatrix = Qi.IDENTITY_MATRIX, this.fontMatrix = Qi.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = Qi.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = na.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
                }
                clone() {
                  return Object.create(this);
                }
                setCurrentPoint(Fs, ws) {
                  this.x = Fs, this.y = ws;
                }
              }
              let Ks = 0, Ys = 0, Xs = 0;
              e.SVGGraphics = ra = class {
                constructor(Cs, Fs, ws = !1) {
                  (0, Xi.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new Xi.DOMSVGFactory(), this.current = new eo(), this.transformMatrix = Qi.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = Cs, this.objs = Fs, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!ws, this._operatorIdMapping = [];
                  for (const ls in Qi.OPS)
                    this._operatorIdMapping[Qi.OPS[ls]] = ls;
                }
                save() {
                  this.transformStack.push(this.transformMatrix);
                  const Cs = this.current;
                  this.extraStack.push(Cs), this.current = Cs.clone();
                }
                restore() {
                  this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
                }
                group(Cs) {
                  this.save(), this.executeOpTree(Cs), this.restore();
                }
                loadDependencies(Cs) {
                  const Fs = Cs.fnArray, ws = Cs.argsArray;
                  for (let ls = 0, ks = Fs.length; ls < ks; ls++)
                    if (Fs[ls] === Qi.OPS.dependency)
                      for (const Js of ws[ls]) {
                        const pl = Js.startsWith("g_") ? this.commonObjs : this.objs, _l = new Promise((bl) => {
                          pl.get(Js, bl);
                        });
                        this.current.dependencies.push(_l);
                      }
                  return Promise.all(this.current.dependencies);
                }
                transform(Cs, Fs, ws, ls, ks, Js) {
                  const pl = [Cs, Fs, ws, ls, ks, Js];
                  this.transformMatrix = Qi.Util.transform(this.transformMatrix, pl), this.tgrp = null;
                }
                getSVG(Cs, Fs) {
                  this.viewport = Fs;
                  const ws = this._initialize(Fs);
                  return this.loadDependencies(Cs).then(() => (this.transformMatrix = Qi.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(Cs)), ws));
                }
                convertOpList(Cs) {
                  const Fs = this._operatorIdMapping, ws = Cs.argsArray, ls = Cs.fnArray, ks = [];
                  for (let Js = 0, pl = ls.length; Js < pl; Js++) {
                    const _l = ls[Js];
                    ks.push({
                      fnId: _l,
                      fn: Fs[_l],
                      args: ws[Js]
                    });
                  }
                  return rs(ks);
                }
                executeOpTree(Cs) {
                  for (const Fs of Cs) {
                    const ws = Fs.fn, ls = Fs.fnId, ks = Fs.args;
                    switch (ls | 0) {
                      case Qi.OPS.beginText:
                        this.beginText();
                        break;
                      case Qi.OPS.dependency:
                        break;
                      case Qi.OPS.setLeading:
                        this.setLeading(ks);
                        break;
                      case Qi.OPS.setLeadingMoveText:
                        this.setLeadingMoveText(ks[0], ks[1]);
                        break;
                      case Qi.OPS.setFont:
                        this.setFont(ks);
                        break;
                      case Qi.OPS.showText:
                        this.showText(ks[0]);
                        break;
                      case Qi.OPS.showSpacedText:
                        this.showText(ks[0]);
                        break;
                      case Qi.OPS.endText:
                        this.endText();
                        break;
                      case Qi.OPS.moveText:
                        this.moveText(ks[0], ks[1]);
                        break;
                      case Qi.OPS.setCharSpacing:
                        this.setCharSpacing(ks[0]);
                        break;
                      case Qi.OPS.setWordSpacing:
                        this.setWordSpacing(ks[0]);
                        break;
                      case Qi.OPS.setHScale:
                        this.setHScale(ks[0]);
                        break;
                      case Qi.OPS.setTextMatrix:
                        this.setTextMatrix(ks[0], ks[1], ks[2], ks[3], ks[4], ks[5]);
                        break;
                      case Qi.OPS.setTextRise:
                        this.setTextRise(ks[0]);
                        break;
                      case Qi.OPS.setTextRenderingMode:
                        this.setTextRenderingMode(ks[0]);
                        break;
                      case Qi.OPS.setLineWidth:
                        this.setLineWidth(ks[0]);
                        break;
                      case Qi.OPS.setLineJoin:
                        this.setLineJoin(ks[0]);
                        break;
                      case Qi.OPS.setLineCap:
                        this.setLineCap(ks[0]);
                        break;
                      case Qi.OPS.setMiterLimit:
                        this.setMiterLimit(ks[0]);
                        break;
                      case Qi.OPS.setFillRGBColor:
                        this.setFillRGBColor(ks[0], ks[1], ks[2]);
                        break;
                      case Qi.OPS.setStrokeRGBColor:
                        this.setStrokeRGBColor(ks[0], ks[1], ks[2]);
                        break;
                      case Qi.OPS.setStrokeColorN:
                        this.setStrokeColorN(ks);
                        break;
                      case Qi.OPS.setFillColorN:
                        this.setFillColorN(ks);
                        break;
                      case Qi.OPS.shadingFill:
                        this.shadingFill(ks[0]);
                        break;
                      case Qi.OPS.setDash:
                        this.setDash(ks[0], ks[1]);
                        break;
                      case Qi.OPS.setRenderingIntent:
                        this.setRenderingIntent(ks[0]);
                        break;
                      case Qi.OPS.setFlatness:
                        this.setFlatness(ks[0]);
                        break;
                      case Qi.OPS.setGState:
                        this.setGState(ks[0]);
                        break;
                      case Qi.OPS.fill:
                        this.fill();
                        break;
                      case Qi.OPS.eoFill:
                        this.eoFill();
                        break;
                      case Qi.OPS.stroke:
                        this.stroke();
                        break;
                      case Qi.OPS.fillStroke:
                        this.fillStroke();
                        break;
                      case Qi.OPS.eoFillStroke:
                        this.eoFillStroke();
                        break;
                      case Qi.OPS.clip:
                        this.clip("nonzero");
                        break;
                      case Qi.OPS.eoClip:
                        this.clip("evenodd");
                        break;
                      case Qi.OPS.paintSolidColorImageMask:
                        this.paintSolidColorImageMask();
                        break;
                      case Qi.OPS.paintImageXObject:
                        this.paintImageXObject(ks[0]);
                        break;
                      case Qi.OPS.paintInlineImageXObject:
                        this.paintInlineImageXObject(ks[0]);
                        break;
                      case Qi.OPS.paintImageMaskXObject:
                        this.paintImageMaskXObject(ks[0]);
                        break;
                      case Qi.OPS.paintFormXObjectBegin:
                        this.paintFormXObjectBegin(ks[0], ks[1]);
                        break;
                      case Qi.OPS.paintFormXObjectEnd:
                        this.paintFormXObjectEnd();
                        break;
                      case Qi.OPS.closePath:
                        this.closePath();
                        break;
                      case Qi.OPS.closeStroke:
                        this.closeStroke();
                        break;
                      case Qi.OPS.closeFillStroke:
                        this.closeFillStroke();
                        break;
                      case Qi.OPS.closeEOFillStroke:
                        this.closeEOFillStroke();
                        break;
                      case Qi.OPS.nextLine:
                        this.nextLine();
                        break;
                      case Qi.OPS.transform:
                        this.transform(ks[0], ks[1], ks[2], ks[3], ks[4], ks[5]);
                        break;
                      case Qi.OPS.constructPath:
                        this.constructPath(ks[0], ks[1]);
                        break;
                      case Qi.OPS.endPath:
                        this.endPath();
                        break;
                      case 92:
                        this.group(Fs.items);
                        break;
                      default:
                        (0, Qi.warn)(`Unimplemented operator ${ws}`);
                        break;
                    }
                  }
                }
                setWordSpacing(Cs) {
                  this.current.wordSpacing = Cs;
                }
                setCharSpacing(Cs) {
                  this.current.charSpacing = Cs;
                }
                nextLine() {
                  this.moveText(0, this.current.leading);
                }
                setTextMatrix(Cs, Fs, ws, ls, ks, Js) {
                  const pl = this.current;
                  pl.textMatrix = pl.lineMatrix = [Cs, Fs, ws, ls, ks, Js], pl.textMatrixScale = Math.hypot(Cs, Fs), pl.x = pl.lineX = 0, pl.y = pl.lineY = 0, pl.xcoords = [], pl.ycoords = [], pl.tspan = this.svgFactory.createElement("svg:tspan"), pl.tspan.setAttributeNS(null, "font-family", pl.fontFamily), pl.tspan.setAttributeNS(null, "font-size", `${ko(pl.fontSize)}px`), pl.tspan.setAttributeNS(null, "y", ko(-pl.y)), pl.txtElement = this.svgFactory.createElement("svg:text"), pl.txtElement.append(pl.tspan);
                }
                beginText() {
                  const Cs = this.current;
                  Cs.x = Cs.lineX = 0, Cs.y = Cs.lineY = 0, Cs.textMatrix = Qi.IDENTITY_MATRIX, Cs.lineMatrix = Qi.IDENTITY_MATRIX, Cs.textMatrixScale = 1, Cs.tspan = this.svgFactory.createElement("svg:tspan"), Cs.txtElement = this.svgFactory.createElement("svg:text"), Cs.txtgrp = this.svgFactory.createElement("svg:g"), Cs.xcoords = [], Cs.ycoords = [];
                }
                moveText(Cs, Fs) {
                  const ws = this.current;
                  ws.x = ws.lineX += Cs, ws.y = ws.lineY += Fs, ws.xcoords = [], ws.ycoords = [], ws.tspan = this.svgFactory.createElement("svg:tspan"), ws.tspan.setAttributeNS(null, "font-family", ws.fontFamily), ws.tspan.setAttributeNS(null, "font-size", `${ko(ws.fontSize)}px`), ws.tspan.setAttributeNS(null, "y", ko(-ws.y));
                }
                showText(Cs) {
                  const Fs = this.current, ws = Fs.font, ls = Fs.fontSize;
                  if (ls === 0)
                    return;
                  const ks = Fs.fontSizeScale, Js = Fs.charSpacing, pl = Fs.wordSpacing, _l = Fs.fontDirection, bl = Fs.textHScale * _l, xl = ws.vertical, Rl = xl ? 1 : -1, Cl = ws.defaultVMetrics, Dl = ls * Fs.fontMatrix[0];
                  let kl = 0;
                  for (const Zl of Cs) {
                    if (Zl === null) {
                      kl += _l * pl;
                      continue;
                    } else if (typeof Zl == "number") {
                      kl += Rl * Zl * ls / 1e3;
                      continue;
                    }
                    const Pl = (Zl.isSpace ? pl : 0) + Js, yl = Zl.fontChar;
                    let hl, Tl, Il = Zl.width;
                    if (xl) {
                      let Al;
                      const _s = Zl.vmetric || Cl;
                      Al = Zl.vmetric ? _s[1] : Il * 0.5, Al = -Al * Dl;
                      const Gs = _s[2] * Dl;
                      Il = _s ? -_s[0] : Il, hl = Al / ks, Tl = (kl + Gs) / ks;
                    } else
                      hl = kl / ks, Tl = 0;
                    (Zl.isInFont || ws.missingFile) && (Fs.xcoords.push(Fs.x + hl), xl && Fs.ycoords.push(-Fs.y + Tl), Fs.tspan.textContent += yl);
                    let jl;
                    xl ? jl = Il * Dl - Pl * _l : jl = Il * Dl + Pl * _l, kl += jl;
                  }
                  Fs.tspan.setAttributeNS(null, "x", Fs.xcoords.map(ko).join(" ")), xl ? Fs.tspan.setAttributeNS(null, "y", Fs.ycoords.map(ko).join(" ")) : Fs.tspan.setAttributeNS(null, "y", ko(-Fs.y)), xl ? Fs.y -= kl : Fs.x += kl * bl, Fs.tspan.setAttributeNS(null, "font-family", Fs.fontFamily), Fs.tspan.setAttributeNS(null, "font-size", `${ko(Fs.fontSize)}px`), Fs.fontStyle !== na.fontStyle && Fs.tspan.setAttributeNS(null, "font-style", Fs.fontStyle), Fs.fontWeight !== na.fontWeight && Fs.tspan.setAttributeNS(null, "font-weight", Fs.fontWeight);
                  const Ul = Fs.textRenderingMode & Qi.TextRenderingMode.FILL_STROKE_MASK;
                  if (Ul === Qi.TextRenderingMode.FILL || Ul === Qi.TextRenderingMode.FILL_STROKE ? (Fs.fillColor !== na.fillColor && Fs.tspan.setAttributeNS(null, "fill", Fs.fillColor), Fs.fillAlpha < 1 && Fs.tspan.setAttributeNS(null, "fill-opacity", Fs.fillAlpha)) : Fs.textRenderingMode === Qi.TextRenderingMode.ADD_TO_PATH ? Fs.tspan.setAttributeNS(null, "fill", "transparent") : Fs.tspan.setAttributeNS(null, "fill", "none"), Ul === Qi.TextRenderingMode.STROKE || Ul === Qi.TextRenderingMode.FILL_STROKE) {
                    const Zl = 1 / (Fs.textMatrixScale || 1);
                    this._setStrokeAttributes(Fs.tspan, Zl);
                  }
                  let Bl = Fs.textMatrix;
                  Fs.textRise !== 0 && (Bl = Bl.slice(), Bl[5] += Fs.textRise), Fs.txtElement.setAttributeNS(null, "transform", `${Hs(Bl)} scale(${ko(bl)}, -1)`), Fs.txtElement.setAttributeNS(la, "xml:space", "preserve"), Fs.txtElement.append(Fs.tspan), Fs.txtgrp.append(Fs.txtElement), this._ensureTransformGroup().append(Fs.txtElement);
                }
                setLeadingMoveText(Cs, Fs) {
                  this.setLeading(-Fs), this.moveText(Cs, Fs);
                }
                addFontStyle(Cs) {
                  if (!Cs.data)
                    throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                  this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
                  const Fs = Eo(Cs.data, Cs.mimetype, this.forceDataSchema);
                  this.cssStyle.textContent += `@font-face { font-family: "${Cs.loadedName}"; src: url(${Fs}); }
`;
                }
                setFont(Cs) {
                  const Fs = this.current, ws = this.commonObjs.get(Cs[0]);
                  let ls = Cs[1];
                  Fs.font = ws, this.embedFonts && !ws.missingFile && !this.embeddedFonts[ws.loadedName] && (this.addFontStyle(ws), this.embeddedFonts[ws.loadedName] = ws), Fs.fontMatrix = ws.fontMatrix || Qi.FONT_IDENTITY_MATRIX;
                  let ks = "normal";
                  ws.black ? ks = "900" : ws.bold && (ks = "bold");
                  const Js = ws.italic ? "italic" : "normal";
                  ls < 0 ? (ls = -ls, Fs.fontDirection = -1) : Fs.fontDirection = 1, Fs.fontSize = ls, Fs.fontFamily = ws.loadedName, Fs.fontWeight = ks, Fs.fontStyle = Js, Fs.tspan = this.svgFactory.createElement("svg:tspan"), Fs.tspan.setAttributeNS(null, "y", ko(-Fs.y)), Fs.xcoords = [], Fs.ycoords = [];
                }
                endText() {
                  const Cs = this.current;
                  Cs.textRenderingMode & Qi.TextRenderingMode.ADD_TO_PATH_FLAG && Cs.txtElement?.hasChildNodes() && (Cs.element = Cs.txtElement, this.clip("nonzero"), this.endPath());
                }
                setLineWidth(Cs) {
                  Cs > 0 && (this.current.lineWidth = Cs);
                }
                setLineCap(Cs) {
                  this.current.lineCap = Va[Cs];
                }
                setLineJoin(Cs) {
                  this.current.lineJoin = to[Cs];
                }
                setMiterLimit(Cs) {
                  this.current.miterLimit = Cs;
                }
                setStrokeAlpha(Cs) {
                  this.current.strokeAlpha = Cs;
                }
                setStrokeRGBColor(Cs, Fs, ws) {
                  this.current.strokeColor = Qi.Util.makeHexColor(Cs, Fs, ws);
                }
                setFillAlpha(Cs) {
                  this.current.fillAlpha = Cs;
                }
                setFillRGBColor(Cs, Fs, ws) {
                  this.current.fillColor = Qi.Util.makeHexColor(Cs, Fs, ws), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
                }
                setStrokeColorN(Cs) {
                  this.current.strokeColor = this._makeColorN_Pattern(Cs);
                }
                setFillColorN(Cs) {
                  this.current.fillColor = this._makeColorN_Pattern(Cs);
                }
                shadingFill(Cs) {
                  const Fs = this.viewport.width, ws = this.viewport.height, ls = Qi.Util.inverseTransform(this.transformMatrix), ks = Qi.Util.applyTransform([0, 0], ls), Js = Qi.Util.applyTransform([0, ws], ls), pl = Qi.Util.applyTransform([Fs, 0], ls), _l = Qi.Util.applyTransform([Fs, ws], ls), bl = Math.min(ks[0], Js[0], pl[0], _l[0]), xl = Math.min(ks[1], Js[1], pl[1], _l[1]), Rl = Math.max(ks[0], Js[0], pl[0], _l[0]), Cl = Math.max(ks[1], Js[1], pl[1], _l[1]), Dl = this.svgFactory.createElement("svg:rect");
                  Dl.setAttributeNS(null, "x", bl), Dl.setAttributeNS(null, "y", xl), Dl.setAttributeNS(null, "width", Rl - bl), Dl.setAttributeNS(null, "height", Cl - xl), Dl.setAttributeNS(null, "fill", this._makeShadingPattern(Cs)), this.current.fillAlpha < 1 && Dl.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(Dl);
                }
                _makeColorN_Pattern(Cs) {
                  return Cs[0] === "TilingPattern" ? this._makeTilingPattern(Cs) : this._makeShadingPattern(Cs);
                }
                _makeTilingPattern(Cs) {
                  const Fs = Cs[1], ws = Cs[2], ls = Cs[3] || Qi.IDENTITY_MATRIX, [ks, Js, pl, _l] = Cs[4], bl = Cs[5], xl = Cs[6], Rl = Cs[7], Cl = `shading${Xs++}`, [Dl, kl, Ul, Bl] = Qi.Util.normalizeRect([...Qi.Util.applyTransform([ks, Js], ls), ...Qi.Util.applyTransform([pl, _l], ls)]), [Zl, Pl] = Qi.Util.singularValueDecompose2dScale(ls), yl = bl * Zl, hl = xl * Pl, Tl = this.svgFactory.createElement("svg:pattern");
                  Tl.setAttributeNS(null, "id", Cl), Tl.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), Tl.setAttributeNS(null, "width", yl), Tl.setAttributeNS(null, "height", hl), Tl.setAttributeNS(null, "x", `${Dl}`), Tl.setAttributeNS(null, "y", `${kl}`);
                  const Il = this.svg, jl = this.transformMatrix, Al = this.current.fillColor, _s = this.current.strokeColor, Gs = this.svgFactory.create(Ul - Dl, Bl - kl);
                  if (this.svg = Gs, this.transformMatrix = ls, Rl === 2) {
                    const vl = Qi.Util.makeHexColor(...Fs);
                    this.current.fillColor = vl, this.current.strokeColor = vl;
                  }
                  return this.executeOpTree(this.convertOpList(ws)), this.svg = Il, this.transformMatrix = jl, this.current.fillColor = Al, this.current.strokeColor = _s, Tl.append(Gs.childNodes[0]), this.defs.append(Tl), `url(#${Cl})`;
                }
                _makeShadingPattern(Cs) {
                  switch (typeof Cs == "string" && (Cs = this.objs.get(Cs)), Cs[0]) {
                    case "RadialAxial":
                      const Fs = `shading${Xs++}`, ws = Cs[3];
                      let ls;
                      switch (Cs[1]) {
                        case "axial":
                          const ks = Cs[4], Js = Cs[5];
                          ls = this.svgFactory.createElement("svg:linearGradient"), ls.setAttributeNS(null, "id", Fs), ls.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), ls.setAttributeNS(null, "x1", ks[0]), ls.setAttributeNS(null, "y1", ks[1]), ls.setAttributeNS(null, "x2", Js[0]), ls.setAttributeNS(null, "y2", Js[1]);
                          break;
                        case "radial":
                          const pl = Cs[4], _l = Cs[5], bl = Cs[6], xl = Cs[7];
                          ls = this.svgFactory.createElement("svg:radialGradient"), ls.setAttributeNS(null, "id", Fs), ls.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), ls.setAttributeNS(null, "cx", _l[0]), ls.setAttributeNS(null, "cy", _l[1]), ls.setAttributeNS(null, "r", xl), ls.setAttributeNS(null, "fx", pl[0]), ls.setAttributeNS(null, "fy", pl[1]), ls.setAttributeNS(null, "fr", bl);
                          break;
                        default:
                          throw new Error(`Unknown RadialAxial type: ${Cs[1]}`);
                      }
                      for (const ks of ws) {
                        const Js = this.svgFactory.createElement("svg:stop");
                        Js.setAttributeNS(null, "offset", ks[0]), Js.setAttributeNS(null, "stop-color", ks[1]), ls.append(Js);
                      }
                      return this.defs.append(ls), `url(#${Fs})`;
                    case "Mesh":
                      return (0, Qi.warn)("Unimplemented pattern Mesh"), null;
                    case "Dummy":
                      return "hotpink";
                    default:
                      throw new Error(`Unknown IR type: ${Cs[0]}`);
                  }
                }
                setDash(Cs, Fs) {
                  this.current.dashArray = Cs, this.current.dashPhase = Fs;
                }
                constructPath(Cs, Fs) {
                  const ws = this.current;
                  let ls = ws.x, ks = ws.y, Js = [], pl = 0;
                  for (const _l of Cs)
                    switch (_l | 0) {
                      case Qi.OPS.rectangle:
                        ls = Fs[pl++], ks = Fs[pl++];
                        const bl = Fs[pl++], xl = Fs[pl++], Rl = ls + bl, Cl = ks + xl;
                        Js.push("M", ko(ls), ko(ks), "L", ko(Rl), ko(ks), "L", ko(Rl), ko(Cl), "L", ko(ls), ko(Cl), "Z");
                        break;
                      case Qi.OPS.moveTo:
                        ls = Fs[pl++], ks = Fs[pl++], Js.push("M", ko(ls), ko(ks));
                        break;
                      case Qi.OPS.lineTo:
                        ls = Fs[pl++], ks = Fs[pl++], Js.push("L", ko(ls), ko(ks));
                        break;
                      case Qi.OPS.curveTo:
                        ls = Fs[pl + 4], ks = Fs[pl + 5], Js.push("C", ko(Fs[pl]), ko(Fs[pl + 1]), ko(Fs[pl + 2]), ko(Fs[pl + 3]), ko(ls), ko(ks)), pl += 6;
                        break;
                      case Qi.OPS.curveTo2:
                        Js.push("C", ko(ls), ko(ks), ko(Fs[pl]), ko(Fs[pl + 1]), ko(Fs[pl + 2]), ko(Fs[pl + 3])), ls = Fs[pl + 2], ks = Fs[pl + 3], pl += 4;
                        break;
                      case Qi.OPS.curveTo3:
                        ls = Fs[pl + 2], ks = Fs[pl + 3], Js.push("C", ko(Fs[pl]), ko(Fs[pl + 1]), ko(ls), ko(ks), ko(ls), ko(ks)), pl += 4;
                        break;
                      case Qi.OPS.closePath:
                        Js.push("Z");
                        break;
                    }
                  Js = Js.join(" "), ws.path && Cs.length > 0 && Cs[0] !== Qi.OPS.rectangle && Cs[0] !== Qi.OPS.moveTo ? Js = ws.path.getAttributeNS(null, "d") + Js : (ws.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(ws.path)), ws.path.setAttributeNS(null, "d", Js), ws.path.setAttributeNS(null, "fill", "none"), ws.element = ws.path, ws.setCurrentPoint(ls, ks);
                }
                endPath() {
                  const Cs = this.current;
                  if (Cs.path = null, !this.pendingClip)
                    return;
                  if (!Cs.element) {
                    this.pendingClip = null;
                    return;
                  }
                  const Fs = `clippath${Ks++}`, ws = this.svgFactory.createElement("svg:clipPath");
                  ws.setAttributeNS(null, "id", Fs), ws.setAttributeNS(null, "transform", Hs(this.transformMatrix));
                  const ls = Cs.element.cloneNode(!0);
                  if (this.pendingClip === "evenodd" ? ls.setAttributeNS(null, "clip-rule", "evenodd") : ls.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, ws.append(ls), this.defs.append(ws), Cs.activeClipUrl) {
                    Cs.clipGroup = null;
                    for (const ks of this.extraStack)
                      ks.clipGroup = null;
                    ws.setAttributeNS(null, "clip-path", Cs.activeClipUrl);
                  }
                  Cs.activeClipUrl = `url(#${Fs})`, this.tgrp = null;
                }
                clip(Cs) {
                  this.pendingClip = Cs;
                }
                closePath() {
                  const Cs = this.current;
                  if (Cs.path) {
                    const Fs = `${Cs.path.getAttributeNS(null, "d")}Z`;
                    Cs.path.setAttributeNS(null, "d", Fs);
                  }
                }
                setLeading(Cs) {
                  this.current.leading = -Cs;
                }
                setTextRise(Cs) {
                  this.current.textRise = Cs;
                }
                setTextRenderingMode(Cs) {
                  this.current.textRenderingMode = Cs;
                }
                setHScale(Cs) {
                  this.current.textHScale = Cs / 100;
                }
                setRenderingIntent(Cs) {
                }
                setFlatness(Cs) {
                }
                setGState(Cs) {
                  for (const [Fs, ws] of Cs)
                    switch (Fs) {
                      case "LW":
                        this.setLineWidth(ws);
                        break;
                      case "LC":
                        this.setLineCap(ws);
                        break;
                      case "LJ":
                        this.setLineJoin(ws);
                        break;
                      case "ML":
                        this.setMiterLimit(ws);
                        break;
                      case "D":
                        this.setDash(ws[0], ws[1]);
                        break;
                      case "RI":
                        this.setRenderingIntent(ws);
                        break;
                      case "FL":
                        this.setFlatness(ws);
                        break;
                      case "Font":
                        this.setFont(ws);
                        break;
                      case "CA":
                        this.setStrokeAlpha(ws);
                        break;
                      case "ca":
                        this.setFillAlpha(ws);
                        break;
                      default:
                        (0, Qi.warn)(`Unimplemented graphic state operator ${Fs}`);
                        break;
                    }
                }
                fill() {
                  const Cs = this.current;
                  Cs.element && (Cs.element.setAttributeNS(null, "fill", Cs.fillColor), Cs.element.setAttributeNS(null, "fill-opacity", Cs.fillAlpha), this.endPath());
                }
                stroke() {
                  const Cs = this.current;
                  Cs.element && (this._setStrokeAttributes(Cs.element), Cs.element.setAttributeNS(null, "fill", "none"), this.endPath());
                }
                _setStrokeAttributes(Cs, Fs = 1) {
                  const ws = this.current;
                  let ls = ws.dashArray;
                  Fs !== 1 && ls.length > 0 && (ls = ls.map(function(ks) {
                    return Fs * ks;
                  })), Cs.setAttributeNS(null, "stroke", ws.strokeColor), Cs.setAttributeNS(null, "stroke-opacity", ws.strokeAlpha), Cs.setAttributeNS(null, "stroke-miterlimit", ko(ws.miterLimit)), Cs.setAttributeNS(null, "stroke-linecap", ws.lineCap), Cs.setAttributeNS(null, "stroke-linejoin", ws.lineJoin), Cs.setAttributeNS(null, "stroke-width", ko(Fs * ws.lineWidth) + "px"), Cs.setAttributeNS(null, "stroke-dasharray", ls.map(ko).join(" ")), Cs.setAttributeNS(null, "stroke-dashoffset", ko(Fs * ws.dashPhase) + "px");
                }
                eoFill() {
                  this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
                }
                fillStroke() {
                  this.stroke(), this.fill();
                }
                eoFillStroke() {
                  this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
                }
                closeStroke() {
                  this.closePath(), this.stroke();
                }
                closeFillStroke() {
                  this.closePath(), this.fillStroke();
                }
                closeEOFillStroke() {
                  this.closePath(), this.eoFillStroke();
                }
                paintSolidColorImageMask() {
                  const Cs = this.svgFactory.createElement("svg:rect");
                  Cs.setAttributeNS(null, "x", "0"), Cs.setAttributeNS(null, "y", "0"), Cs.setAttributeNS(null, "width", "1px"), Cs.setAttributeNS(null, "height", "1px"), Cs.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(Cs);
                }
                paintImageXObject(Cs) {
                  const Fs = Cs.startsWith("g_") ? this.commonObjs.get(Cs) : this.objs.get(Cs);
                  if (!Fs) {
                    (0, Qi.warn)(`Dependent image with object ID ${Cs} is not ready yet`);
                    return;
                  }
                  this.paintInlineImageXObject(Fs);
                }
                paintInlineImageXObject(Cs, Fs) {
                  const ws = Cs.width, ls = Cs.height, ks = So(Cs, this.forceDataSchema, !!Fs), Js = this.svgFactory.createElement("svg:rect");
                  Js.setAttributeNS(null, "x", "0"), Js.setAttributeNS(null, "y", "0"), Js.setAttributeNS(null, "width", ko(ws)), Js.setAttributeNS(null, "height", ko(ls)), this.current.element = Js, this.clip("nonzero");
                  const pl = this.svgFactory.createElement("svg:image");
                  pl.setAttributeNS(Ma, "xlink:href", ks), pl.setAttributeNS(null, "x", "0"), pl.setAttributeNS(null, "y", ko(-ls)), pl.setAttributeNS(null, "width", ko(ws) + "px"), pl.setAttributeNS(null, "height", ko(ls) + "px"), pl.setAttributeNS(null, "transform", `scale(${ko(1 / ws)} ${ko(-1 / ls)})`), Fs ? Fs.append(pl) : this._ensureTransformGroup().append(pl);
                }
                paintImageMaskXObject(Cs) {
                  const Fs = this.current, ws = Cs.width, ls = Cs.height, ks = Fs.fillColor;
                  Fs.maskId = `mask${Ys++}`;
                  const Js = this.svgFactory.createElement("svg:mask");
                  Js.setAttributeNS(null, "id", Fs.maskId);
                  const pl = this.svgFactory.createElement("svg:rect");
                  pl.setAttributeNS(null, "x", "0"), pl.setAttributeNS(null, "y", "0"), pl.setAttributeNS(null, "width", ko(ws)), pl.setAttributeNS(null, "height", ko(ls)), pl.setAttributeNS(null, "fill", ks), pl.setAttributeNS(null, "mask", `url(#${Fs.maskId})`), this.defs.append(Js), this._ensureTransformGroup().append(pl), this.paintInlineImageXObject(Cs, Js);
                }
                paintFormXObjectBegin(Cs, Fs) {
                  if (Array.isArray(Cs) && Cs.length === 6 && this.transform(Cs[0], Cs[1], Cs[2], Cs[3], Cs[4], Cs[5]), Fs) {
                    const ws = Fs[2] - Fs[0], ls = Fs[3] - Fs[1], ks = this.svgFactory.createElement("svg:rect");
                    ks.setAttributeNS(null, "x", Fs[0]), ks.setAttributeNS(null, "y", Fs[1]), ks.setAttributeNS(null, "width", ko(ws)), ks.setAttributeNS(null, "height", ko(ls)), this.current.element = ks, this.clip("nonzero"), this.endPath();
                  }
                }
                paintFormXObjectEnd() {
                }
                _initialize(Cs) {
                  const Fs = this.svgFactory.create(Cs.width, Cs.height), ws = this.svgFactory.createElement("svg:defs");
                  Fs.append(ws), this.defs = ws;
                  const ls = this.svgFactory.createElement("svg:g");
                  return ls.setAttributeNS(null, "transform", Hs(Cs.transform)), Fs.append(ls), this.svg = ls, Fs;
                }
                _ensureClipGroup() {
                  if (!this.current.clipGroup) {
                    const Cs = this.svgFactory.createElement("svg:g");
                    Cs.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(Cs), this.current.clipGroup = Cs;
                  }
                  return this.current.clipGroup;
                }
                _ensureTransformGroup() {
                  return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", Hs(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
                }
              };
            }
          },
          /* 32 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFNodeStream = void 0;
            var Xi = qi(1), Qi = qi(33);
            const ta = require$$5, ra = require$$5, na = require$$5, la = require$$5, Ma = /^file:\/\/\/[a-zA-Z]:\//;
            function Va(Ys) {
              const Xs = la.parse(Ys);
              return Xs.protocol === "file:" || Xs.host ? Xs : /^[a-z]:[/\\]/i.test(Ys) ? la.parse(`file:///${Ys}`) : (Xs.host || (Xs.protocol = "file:"), Xs);
            }
            class to {
              constructor(Xs) {
                this.source = Xs, this.url = Va(Xs.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && Xs.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, Xi.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new Hs(this) : new rs(this), this._fullRequestReader;
              }
              getRangeReader(Xs, Cs) {
                if (Cs <= this._progressiveDataLength)
                  return null;
                const Fs = this.isFsUrl ? new Ks(this, Xs, Cs) : new ko(this, Xs, Cs);
                return this._rangeRequestReaders.push(Fs), Fs;
              }
              cancelAllRequests(Xs) {
                this._fullRequestReader && this._fullRequestReader.cancel(Xs);
                for (const Cs of this._rangeRequestReaders.slice(0))
                  Cs.cancel(Xs);
              }
            }
            e.PDFNodeStream = to;
            class Eo {
              constructor(Xs) {
                this._url = Xs.url, this._done = !1, this._storedError = null, this.onProgress = null;
                const Cs = Xs.source;
                this._contentLength = Cs.length, this._loaded = 0, this._filename = null, this._disableRange = Cs.disableRange || !1, this._rangeChunkSize = Cs.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !Cs.disableStream, this._isRangeSupported = !Cs.disableRange, this._readableStream = null, this._readCapability = (0, Xi.createPromiseCapability)(), this._headersCapability = (0, Xi.createPromiseCapability)();
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const Xs = this._readableStream.read();
                return Xs === null ? (this._readCapability = (0, Xi.createPromiseCapability)(), this.read()) : (this._loaded += Xs.length, this.onProgress && this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(Xs).buffer,
                  done: !1
                });
              }
              cancel(Xs) {
                if (!this._readableStream) {
                  this._error(Xs);
                  return;
                }
                this._readableStream.destroy(Xs);
              }
              _error(Xs) {
                this._storedError = Xs, this._readCapability.resolve();
              }
              _setReadableStream(Xs) {
                this._readableStream = Xs, Xs.on("readable", () => {
                  this._readCapability.resolve();
                }), Xs.on("end", () => {
                  Xs.destroy(), this._done = !0, this._readCapability.resolve();
                }), Xs.on("error", (Cs) => {
                  this._error(Cs);
                }), !this._isStreamingSupported && this._isRangeSupported && this._error(new Xi.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            class So {
              constructor(Xs) {
                this._url = Xs.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = (0, Xi.createPromiseCapability)();
                const Cs = Xs.source;
                this._isStreamingSupported = !Cs.disableStream;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                if (await this._readCapability.promise, this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                if (this._storedError)
                  throw this._storedError;
                const Xs = this._readableStream.read();
                return Xs === null ? (this._readCapability = (0, Xi.createPromiseCapability)(), this.read()) : (this._loaded += Xs.length, this.onProgress && this.onProgress({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(Xs).buffer,
                  done: !1
                });
              }
              cancel(Xs) {
                if (!this._readableStream) {
                  this._error(Xs);
                  return;
                }
                this._readableStream.destroy(Xs);
              }
              _error(Xs) {
                this._storedError = Xs, this._readCapability.resolve();
              }
              _setReadableStream(Xs) {
                this._readableStream = Xs, Xs.on("readable", () => {
                  this._readCapability.resolve();
                }), Xs.on("end", () => {
                  Xs.destroy(), this._done = !0, this._readCapability.resolve();
                }), Xs.on("error", (Cs) => {
                  this._error(Cs);
                }), this._storedError && this._readableStream.destroy(this._storedError);
              }
            }
            function eo(Ys, Xs) {
              return {
                protocol: Ys.protocol,
                auth: Ys.auth,
                host: Ys.hostname,
                port: Ys.port,
                path: Ys.path,
                method: "GET",
                headers: Xs
              };
            }
            class rs extends Eo {
              constructor(Xs) {
                super(Xs);
                const Cs = (Fs) => {
                  if (Fs.statusCode === 404) {
                    const Js = new Xi.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = Js, this._headersCapability.reject(Js);
                    return;
                  }
                  this._headersCapability.resolve(), this._setReadableStream(Fs);
                  const ws = (Js) => this._readableStream.headers[Js.toLowerCase()], {
                    allowRangeRequests: ls,
                    suggestedLength: ks
                  } = (0, Qi.validateRangeRequestCapabilities)({
                    getResponseHeader: ws,
                    isHttp: Xs.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = ls, this._contentLength = ks || this._contentLength, this._filename = (0, Qi.extractFilenameFromHeader)(ws);
                };
                this._request = null, this._url.protocol === "http:" ? this._request = ra.request(eo(this._url, Xs.httpHeaders), Cs) : this._request = na.request(eo(this._url, Xs.httpHeaders), Cs), this._request.on("error", (Fs) => {
                  this._storedError = Fs, this._headersCapability.reject(Fs);
                }), this._request.end();
              }
            }
            class ko extends So {
              constructor(Xs, Cs, Fs) {
                super(Xs), this._httpHeaders = {};
                for (const ls in Xs.httpHeaders) {
                  const ks = Xs.httpHeaders[ls];
                  typeof ks > "u" || (this._httpHeaders[ls] = ks);
                }
                this._httpHeaders.Range = `bytes=${Cs}-${Fs - 1}`;
                const ws = (ls) => {
                  if (ls.statusCode === 404) {
                    const ks = new Xi.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = ks;
                    return;
                  }
                  this._setReadableStream(ls);
                };
                this._request = null, this._url.protocol === "http:" ? this._request = ra.request(eo(this._url, this._httpHeaders), ws) : this._request = na.request(eo(this._url, this._httpHeaders), ws), this._request.on("error", (ls) => {
                  this._storedError = ls;
                }), this._request.end();
              }
            }
            class Hs extends Eo {
              constructor(Xs) {
                super(Xs);
                let Cs = decodeURIComponent(this._url.path);
                Ma.test(this._url.href) && (Cs = Cs.replace(/^\//, "")), ta.lstat(Cs, (Fs, ws) => {
                  if (Fs) {
                    Fs.code === "ENOENT" && (Fs = new Xi.MissingPDFException(`Missing PDF "${Cs}".`)), this._storedError = Fs, this._headersCapability.reject(Fs);
                    return;
                  }
                  this._contentLength = ws.size, this._setReadableStream(ta.createReadStream(Cs)), this._headersCapability.resolve();
                });
              }
            }
            class Ks extends So {
              constructor(Xs, Cs, Fs) {
                super(Xs);
                let ws = decodeURIComponent(this._url.path);
                Ma.test(this._url.href) && (ws = ws.replace(/^\//, "")), this._setReadableStream(ta.createReadStream(ws, {
                  start: Cs,
                  end: Fs - 1
                }));
              }
            }
          },
          /* 33 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.createResponseStatusError = la, e.extractFilenameFromHeader = na, e.validateRangeRequestCapabilities = ra, e.validateResponseStatus = Ma;
            var Xi = qi(1), Qi = qi(34), ta = qi(8);
            function ra({
              getResponseHeader: Va,
              isHttp: to,
              rangeChunkSize: Eo,
              disableRange: So
            }) {
              const eo = {
                allowRangeRequests: !1,
                suggestedLength: void 0
              }, rs = parseInt(Va("Content-Length"), 10);
              return !Number.isInteger(rs) || (eo.suggestedLength = rs, rs <= 2 * Eo) || So || !to || Va("Accept-Ranges") !== "bytes" || (Va("Content-Encoding") || "identity") !== "identity" || (eo.allowRangeRequests = !0), eo;
            }
            function na(Va) {
              const to = Va("Content-Disposition");
              if (to) {
                let Eo = (0, Qi.getFilenameFromContentDispositionHeader)(to);
                if (Eo.includes("%"))
                  try {
                    Eo = decodeURIComponent(Eo);
                  } catch {
                  }
                if ((0, ta.isPdfFile)(Eo))
                  return Eo;
              }
              return null;
            }
            function la(Va, to) {
              return Va === 404 || Va === 0 && to.startsWith("file:") ? new Xi.MissingPDFException('Missing PDF "' + to + '".') : new Xi.UnexpectedResponseException(`Unexpected server response (${Va}) while retrieving PDF "${to}".`, Va);
            }
            function Ma(Va) {
              return Va === 200 || Va === 206;
            }
          },
          /* 34 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.getFilenameFromContentDispositionHeader = Qi;
            var Xi = qi(1);
            function Qi(ta) {
              let ra = !0, na = la("filename\\*", "i").exec(ta);
              if (na) {
                na = na[1];
                let rs = Eo(na);
                return rs = unescape(rs), rs = So(rs), rs = eo(rs), Va(rs);
              }
              if (na = to(ta), na) {
                const rs = eo(na);
                return Va(rs);
              }
              if (na = la("filename", "i").exec(ta), na) {
                na = na[1];
                let rs = Eo(na);
                return rs = eo(rs), Va(rs);
              }
              function la(rs, ko) {
                return new RegExp("(?:^|;)\\s*" + rs + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', ko);
              }
              function Ma(rs, ko) {
                if (rs) {
                  if (!/^[\x00-\xFF]+$/.test(ko))
                    return ko;
                  try {
                    const Hs = new TextDecoder(rs, {
                      fatal: !0
                    }), Ks = (0, Xi.stringToBytes)(ko);
                    ko = Hs.decode(Ks), ra = !1;
                  } catch {
                  }
                }
                return ko;
              }
              function Va(rs) {
                return ra && /[\x80-\xff]/.test(rs) && (rs = Ma("utf-8", rs), ra && (rs = Ma("iso-8859-1", rs))), rs;
              }
              function to(rs) {
                const ko = [];
                let Hs;
                const Ks = la("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                for (; (Hs = Ks.exec(rs)) !== null; ) {
                  let [, Xs, Cs, Fs] = Hs;
                  if (Xs = parseInt(Xs, 10), Xs in ko) {
                    if (Xs === 0)
                      break;
                    continue;
                  }
                  ko[Xs] = [Cs, Fs];
                }
                const Ys = [];
                for (let Xs = 0; Xs < ko.length && Xs in ko; ++Xs) {
                  let [Cs, Fs] = ko[Xs];
                  Fs = Eo(Fs), Cs && (Fs = unescape(Fs), Xs === 0 && (Fs = So(Fs))), Ys.push(Fs);
                }
                return Ys.join("");
              }
              function Eo(rs) {
                if (rs.startsWith('"')) {
                  const ko = rs.slice(1).split('\\"');
                  for (let Hs = 0; Hs < ko.length; ++Hs) {
                    const Ks = ko[Hs].indexOf('"');
                    Ks !== -1 && (ko[Hs] = ko[Hs].slice(0, Ks), ko.length = Hs + 1), ko[Hs] = ko[Hs].replace(/\\(.)/g, "$1");
                  }
                  rs = ko.join('"');
                }
                return rs;
              }
              function So(rs) {
                const ko = rs.indexOf("'");
                if (ko === -1)
                  return rs;
                const Hs = rs.slice(0, ko), Ys = rs.slice(ko + 1).replace(/^[^']*'/, "");
                return Ma(Hs, Ys);
              }
              function eo(rs) {
                return !rs.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(rs) ? rs : rs.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(ko, Hs, Ks, Ys) {
                  if (Ks === "q" || Ks === "Q")
                    return Ys = Ys.replace(/_/g, " "), Ys = Ys.replace(/=([0-9a-fA-F]{2})/g, function(Xs, Cs) {
                      return String.fromCharCode(parseInt(Cs, 16));
                    }), Ma(Hs, Ys);
                  try {
                    Ys = atob(Ys);
                  } catch {
                  }
                  return Ma(Hs, Ys);
                });
              }
              return "";
            }
          },
          /* 35 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFNetworkStream = void 0;
            var Xi = qi(1), Qi = qi(33);
            const ta = 200, ra = 206;
            function na(Eo) {
              const So = Eo.response;
              return typeof So != "string" ? So : (0, Xi.stringToBytes)(So).buffer;
            }
            class la {
              constructor(So, eo = {}) {
                this.url = So, this.isHttp = /^https?:/i.test(So), this.httpHeaders = this.isHttp && eo.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = eo.withCredentials || !1, this.getXhr = eo.getXhr || function() {
                  return new XMLHttpRequest();
                }, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
              }
              requestRange(So, eo, rs) {
                const ko = {
                  begin: So,
                  end: eo
                };
                for (const Hs in rs)
                  ko[Hs] = rs[Hs];
                return this.request(ko);
              }
              requestFull(So) {
                return this.request(So);
              }
              request(So) {
                const eo = this.getXhr(), rs = this.currXhrId++, ko = this.pendingRequests[rs] = {
                  xhr: eo
                };
                eo.open("GET", this.url), eo.withCredentials = this.withCredentials;
                for (const Hs in this.httpHeaders) {
                  const Ks = this.httpHeaders[Hs];
                  typeof Ks > "u" || eo.setRequestHeader(Hs, Ks);
                }
                return this.isHttp && "begin" in So && "end" in So ? (eo.setRequestHeader("Range", `bytes=${So.begin}-${So.end - 1}`), ko.expectedStatus = ra) : ko.expectedStatus = ta, eo.responseType = "arraybuffer", So.onError && (eo.onerror = function(Hs) {
                  So.onError(eo.status);
                }), eo.onreadystatechange = this.onStateChange.bind(this, rs), eo.onprogress = this.onProgress.bind(this, rs), ko.onHeadersReceived = So.onHeadersReceived, ko.onDone = So.onDone, ko.onError = So.onError, ko.onProgress = So.onProgress, eo.send(null), rs;
              }
              onProgress(So, eo) {
                const rs = this.pendingRequests[So];
                rs && rs.onProgress?.(eo);
              }
              onStateChange(So, eo) {
                const rs = this.pendingRequests[So];
                if (!rs)
                  return;
                const ko = rs.xhr;
                if (ko.readyState >= 2 && rs.onHeadersReceived && (rs.onHeadersReceived(), delete rs.onHeadersReceived), ko.readyState !== 4 || !(So in this.pendingRequests))
                  return;
                if (delete this.pendingRequests[So], ko.status === 0 && this.isHttp) {
                  rs.onError?.(ko.status);
                  return;
                }
                const Hs = ko.status || ta;
                if (!(Hs === ta && rs.expectedStatus === ra) && Hs !== rs.expectedStatus) {
                  rs.onError?.(ko.status);
                  return;
                }
                const Ys = na(ko);
                if (Hs === ra) {
                  const Xs = ko.getResponseHeader("Content-Range"), Cs = /bytes (\d+)-(\d+)\/(\d+)/.exec(Xs);
                  rs.onDone({
                    begin: parseInt(Cs[1], 10),
                    chunk: Ys
                  });
                } else Ys ? rs.onDone({
                  begin: 0,
                  chunk: Ys
                }) : rs.onError?.(ko.status);
              }
              getRequestXhr(So) {
                return this.pendingRequests[So].xhr;
              }
              isPendingRequest(So) {
                return So in this.pendingRequests;
              }
              abortRequest(So) {
                const eo = this.pendingRequests[So].xhr;
                delete this.pendingRequests[So], eo.abort();
              }
            }
            class Ma {
              constructor(So) {
                this._source = So, this._manager = new la(So.url, {
                  httpHeaders: So.httpHeaders,
                  withCredentials: So.withCredentials
                }), this._rangeChunkSize = So.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              _onRangeRequestReaderClosed(So) {
                const eo = this._rangeRequestReaders.indexOf(So);
                eo >= 0 && this._rangeRequestReaders.splice(eo, 1);
              }
              getFullReader() {
                return (0, Xi.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new Va(this._manager, this._source), this._fullRequestReader;
              }
              getRangeReader(So, eo) {
                const rs = new to(this._manager, So, eo);
                return rs.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(rs), rs;
              }
              cancelAllRequests(So) {
                this._fullRequestReader?.cancel(So);
                for (const eo of this._rangeRequestReaders.slice(0))
                  eo.cancel(So);
              }
            }
            e.PDFNetworkStream = Ma;
            class Va {
              constructor(So, eo) {
                this._manager = So;
                const rs = {
                  onHeadersReceived: this._onHeadersReceived.bind(this),
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = eo.url, this._fullRequestId = So.requestFull(rs), this._headersReceivedCapability = (0, Xi.createPromiseCapability)(), this._disableRange = eo.disableRange || !1, this._contentLength = eo.length, this._rangeChunkSize = eo.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
              }
              _onHeadersReceived() {
                const So = this._fullRequestId, eo = this._manager.getRequestXhr(So), rs = (Ks) => eo.getResponseHeader(Ks), {
                  allowRangeRequests: ko,
                  suggestedLength: Hs
                } = (0, Qi.validateRangeRequestCapabilities)({
                  getResponseHeader: rs,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                ko && (this._isRangeSupported = !0), this._contentLength = Hs || this._contentLength, this._filename = (0, Qi.extractFilenameFromHeader)(rs), this._isRangeSupported && this._manager.abortRequest(So), this._headersReceivedCapability.resolve();
              }
              _onDone(So) {
                if (So && (this._requests.length > 0 ? this._requests.shift().resolve({
                  value: So.chunk,
                  done: !1
                }) : this._cachedChunks.push(So.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                  for (const eo of this._requests)
                    eo.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
              }
              _onError(So) {
                this._storedError = (0, Qi.createResponseStatusError)(So, this._url), this._headersReceivedCapability.reject(this._storedError);
                for (const eo of this._requests)
                  eo.reject(this._storedError);
                this._requests.length = 0, this._cachedChunks.length = 0;
              }
              _onProgress(So) {
                this.onProgress?.({
                  loaded: So.loaded,
                  total: So.lengthComputable ? So.total : this._contentLength
                });
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get contentLength() {
                return this._contentLength;
              }
              get headersReady() {
                return this._headersReceivedCapability.promise;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._cachedChunks.length > 0)
                  return {
                    value: this._cachedChunks.shift(),
                    done: !1
                  };
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const So = (0, Xi.createPromiseCapability)();
                return this._requests.push(So), So.promise;
              }
              cancel(So) {
                this._done = !0, this._headersReceivedCapability.reject(So);
                for (const eo of this._requests)
                  eo.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
              }
            }
            class to {
              constructor(So, eo, rs) {
                this._manager = So;
                const ko = {
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = So.url, this._requestId = So.requestRange(eo, rs, ko), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
              }
              _close() {
                this.onClosed?.(this);
              }
              _onDone(So) {
                const eo = So.chunk;
                this._requests.length > 0 ? this._requests.shift().resolve({
                  value: eo,
                  done: !1
                }) : this._queuedChunk = eo, this._done = !0;
                for (const rs of this._requests)
                  rs.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._close();
              }
              _onError(So) {
                this._storedError = (0, Qi.createResponseStatusError)(So, this._url);
                for (const eo of this._requests)
                  eo.reject(this._storedError);
                this._requests.length = 0, this._queuedChunk = null;
              }
              _onProgress(So) {
                this.isStreamingSupported || this.onProgress?.({
                  loaded: So.loaded
                });
              }
              get isStreamingSupported() {
                return !1;
              }
              async read() {
                if (this._storedError)
                  throw this._storedError;
                if (this._queuedChunk !== null) {
                  const eo = this._queuedChunk;
                  return this._queuedChunk = null, {
                    value: eo,
                    done: !1
                  };
                }
                if (this._done)
                  return {
                    value: void 0,
                    done: !0
                  };
                const So = (0, Xi.createPromiseCapability)();
                return this._requests.push(So), So.promise;
              }
              cancel(So) {
                this._done = !0;
                for (const eo of this._requests)
                  eo.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
              }
            }
          },
          /* 36 */
          /***/
          (Bi, e, qi) => {
            Object.defineProperty(e, "__esModule", {
              value: !0
            }), e.PDFFetchStream = void 0;
            var Xi = qi(1), Qi = qi(33);
            function ta(Va, to, Eo) {
              return {
                method: "GET",
                headers: Va,
                signal: Eo.signal,
                mode: "cors",
                credentials: to ? "include" : "same-origin",
                redirect: "follow"
              };
            }
            function ra(Va) {
              const to = new Headers();
              for (const Eo in Va) {
                const So = Va[Eo];
                typeof So > "u" || to.append(Eo, So);
              }
              return to;
            }
            class na {
              constructor(to) {
                this.source = to, this.isHttp = /^https?:/i.test(to.url), this.httpHeaders = this.isHttp && to.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                return this._fullRequestReader?._loaded ?? 0;
              }
              getFullReader() {
                return (0, Xi.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new la(this), this._fullRequestReader;
              }
              getRangeReader(to, Eo) {
                if (Eo <= this._progressiveDataLength)
                  return null;
                const So = new Ma(this, to, Eo);
                return this._rangeRequestReaders.push(So), So;
              }
              cancelAllRequests(to) {
                this._fullRequestReader && this._fullRequestReader.cancel(to);
                for (const Eo of this._rangeRequestReaders.slice(0))
                  Eo.cancel(to);
              }
            }
            e.PDFFetchStream = na;
            class la {
              constructor(to) {
                this._stream = to, this._reader = null, this._loaded = 0, this._filename = null;
                const Eo = to.source;
                this._withCredentials = Eo.withCredentials || !1, this._contentLength = Eo.length, this._headersCapability = (0, Xi.createPromiseCapability)(), this._disableRange = Eo.disableRange || !1, this._rangeChunkSize = Eo.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !Eo.disableStream, this._isRangeSupported = !Eo.disableRange, this._headers = ra(this._stream.httpHeaders);
                const So = Eo.url;
                fetch(So, ta(this._headers, this._withCredentials, this._abortController)).then((eo) => {
                  if (!(0, Qi.validateResponseStatus)(eo.status))
                    throw (0, Qi.createResponseStatusError)(eo.status, So);
                  this._reader = eo.body.getReader(), this._headersCapability.resolve();
                  const rs = (Ks) => eo.headers.get(Ks), {
                    allowRangeRequests: ko,
                    suggestedLength: Hs
                  } = (0, Qi.validateRangeRequestCapabilities)({
                    getResponseHeader: rs,
                    isHttp: this._stream.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = ko, this._contentLength = Hs || this._contentLength, this._filename = (0, Qi.extractFilenameFromHeader)(rs), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new Xi.AbortException("Streaming is disabled."));
                }).catch(this._headersCapability.reject), this.onProgress = null;
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._headersCapability.promise;
                const {
                  value: to,
                  done: Eo
                } = await this._reader.read();
                return Eo ? {
                  value: to,
                  done: Eo
                } : (this._loaded += to.byteLength, this.onProgress && this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                }), {
                  value: new Uint8Array(to).buffer,
                  done: !1
                });
              }
              cancel(to) {
                this._reader && this._reader.cancel(to), this._abortController.abort();
              }
            }
            class Ma {
              constructor(to, Eo, So) {
                this._stream = to, this._reader = null, this._loaded = 0;
                const eo = to.source;
                this._withCredentials = eo.withCredentials || !1, this._readCapability = (0, Xi.createPromiseCapability)(), this._isStreamingSupported = !eo.disableStream, this._abortController = new AbortController(), this._headers = ra(this._stream.httpHeaders), this._headers.append("Range", `bytes=${Eo}-${So - 1}`);
                const rs = eo.url;
                fetch(rs, ta(this._headers, this._withCredentials, this._abortController)).then((ko) => {
                  if (!(0, Qi.validateResponseStatus)(ko.status))
                    throw (0, Qi.createResponseStatusError)(ko.status, rs);
                  this._readCapability.resolve(), this._reader = ko.body.getReader();
                }).catch(this._readCapability.reject), this.onProgress = null;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                await this._readCapability.promise;
                const {
                  value: to,
                  done: Eo
                } = await this._reader.read();
                return Eo ? {
                  value: to,
                  done: Eo
                } : (this._loaded += to.byteLength, this.onProgress && this.onProgress({
                  loaded: this._loaded
                }), {
                  value: new Uint8Array(to).buffer,
                  done: !1
                });
              }
              cancel(to) {
                this._reader && this._reader.cancel(to), this._abortController.abort();
              }
            }
          }
          /******/
        ], __webpack_module_cache__ = {};
        function __w_pdfjs_require__(Bi) {
          var e = __webpack_module_cache__[Bi];
          if (e !== void 0)
            return e.exports;
          var qi = __webpack_module_cache__[Bi] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return __webpack_modules__[Bi](qi, qi.exports, __w_pdfjs_require__), qi.exports;
        }
        var __webpack_exports__ = {};
        return (() => {
          var Bi = __webpack_exports__;
          Object.defineProperty(Bi, "__esModule", {
            value: !0
          }), Object.defineProperty(Bi, "AnnotationEditorLayer", {
            enumerable: !0,
            get: function() {
              return Qi.AnnotationEditorLayer;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorParamsType", {
            enumerable: !0,
            get: function() {
              return e.AnnotationEditorParamsType;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorType", {
            enumerable: !0,
            get: function() {
              return e.AnnotationEditorType;
            }
          }), Object.defineProperty(Bi, "AnnotationEditorUIManager", {
            enumerable: !0,
            get: function() {
              return ta.AnnotationEditorUIManager;
            }
          }), Object.defineProperty(Bi, "AnnotationLayer", {
            enumerable: !0,
            get: function() {
              return ra.AnnotationLayer;
            }
          }), Object.defineProperty(Bi, "AnnotationMode", {
            enumerable: !0,
            get: function() {
              return e.AnnotationMode;
            }
          }), Object.defineProperty(Bi, "CMapCompressionType", {
            enumerable: !0,
            get: function() {
              return e.CMapCompressionType;
            }
          }), Object.defineProperty(Bi, "GlobalWorkerOptions", {
            enumerable: !0,
            get: function() {
              return na.GlobalWorkerOptions;
            }
          }), Object.defineProperty(Bi, "InvalidPDFException", {
            enumerable: !0,
            get: function() {
              return e.InvalidPDFException;
            }
          }), Object.defineProperty(Bi, "LoopbackPort", {
            enumerable: !0,
            get: function() {
              return qi.LoopbackPort;
            }
          }), Object.defineProperty(Bi, "MissingPDFException", {
            enumerable: !0,
            get: function() {
              return e.MissingPDFException;
            }
          }), Object.defineProperty(Bi, "OPS", {
            enumerable: !0,
            get: function() {
              return e.OPS;
            }
          }), Object.defineProperty(Bi, "PDFDataRangeTransport", {
            enumerable: !0,
            get: function() {
              return qi.PDFDataRangeTransport;
            }
          }), Object.defineProperty(Bi, "PDFDateString", {
            enumerable: !0,
            get: function() {
              return Xi.PDFDateString;
            }
          }), Object.defineProperty(Bi, "PDFWorker", {
            enumerable: !0,
            get: function() {
              return qi.PDFWorker;
            }
          }), Object.defineProperty(Bi, "PasswordResponses", {
            enumerable: !0,
            get: function() {
              return e.PasswordResponses;
            }
          }), Object.defineProperty(Bi, "PermissionFlag", {
            enumerable: !0,
            get: function() {
              return e.PermissionFlag;
            }
          }), Object.defineProperty(Bi, "PixelsPerInch", {
            enumerable: !0,
            get: function() {
              return Xi.PixelsPerInch;
            }
          }), Object.defineProperty(Bi, "RenderingCancelledException", {
            enumerable: !0,
            get: function() {
              return Xi.RenderingCancelledException;
            }
          }), Object.defineProperty(Bi, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return Va.SVGGraphics;
            }
          }), Object.defineProperty(Bi, "UNSUPPORTED_FEATURES", {
            enumerable: !0,
            get: function() {
              return e.UNSUPPORTED_FEATURES;
            }
          }), Object.defineProperty(Bi, "UnexpectedResponseException", {
            enumerable: !0,
            get: function() {
              return e.UnexpectedResponseException;
            }
          }), Object.defineProperty(Bi, "Util", {
            enumerable: !0,
            get: function() {
              return e.Util;
            }
          }), Object.defineProperty(Bi, "VerbosityLevel", {
            enumerable: !0,
            get: function() {
              return e.VerbosityLevel;
            }
          }), Object.defineProperty(Bi, "XfaLayer", {
            enumerable: !0,
            get: function() {
              return to.XfaLayer;
            }
          }), Object.defineProperty(Bi, "build", {
            enumerable: !0,
            get: function() {
              return qi.build;
            }
          }), Object.defineProperty(Bi, "createPromiseCapability", {
            enumerable: !0,
            get: function() {
              return e.createPromiseCapability;
            }
          }), Object.defineProperty(Bi, "createValidAbsoluteUrl", {
            enumerable: !0,
            get: function() {
              return e.createValidAbsoluteUrl;
            }
          }), Object.defineProperty(Bi, "getDocument", {
            enumerable: !0,
            get: function() {
              return qi.getDocument;
            }
          }), Object.defineProperty(Bi, "getFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return Xi.getFilenameFromUrl;
            }
          }), Object.defineProperty(Bi, "getPdfFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return Xi.getPdfFilenameFromUrl;
            }
          }), Object.defineProperty(Bi, "getXfaPageViewport", {
            enumerable: !0,
            get: function() {
              return Xi.getXfaPageViewport;
            }
          }), Object.defineProperty(Bi, "isPdfFile", {
            enumerable: !0,
            get: function() {
              return Xi.isPdfFile;
            }
          }), Object.defineProperty(Bi, "loadScript", {
            enumerable: !0,
            get: function() {
              return Xi.loadScript;
            }
          }), Object.defineProperty(Bi, "renderTextLayer", {
            enumerable: !0,
            get: function() {
              return Ma.renderTextLayer;
            }
          }), Object.defineProperty(Bi, "shadow", {
            enumerable: !0,
            get: function() {
              return e.shadow;
            }
          }), Object.defineProperty(Bi, "version", {
            enumerable: !0,
            get: function() {
              return qi.version;
            }
          });
          var e = __w_pdfjs_require__(1), qi = __w_pdfjs_require__(4), Xi = __w_pdfjs_require__(8), Qi = __w_pdfjs_require__(22), ta = __w_pdfjs_require__(7), ra = __w_pdfjs_require__(27), na = __w_pdfjs_require__(15), la = __w_pdfjs_require__(3), Ma = __w_pdfjs_require__(30), Va = __w_pdfjs_require__(31), to = __w_pdfjs_require__(29);
          if (la.isNodeJS) {
            const {
              PDFNodeStream: Eo
            } = __w_pdfjs_require__(32);
            (0, qi.setPDFNetworkStreamFactory)((So) => new Eo(So));
          } else {
            const {
              PDFNetworkStream: Eo
            } = __w_pdfjs_require__(35), {
              PDFFetchStream: So
            } = __w_pdfjs_require__(36);
            (0, qi.setPDFNetworkStreamFactory)((eo) => (0, Xi.isValidFetchUrl)(eo.url) ? new So(eo) : new Eo(eo));
          }
        })(), __webpack_exports__;
      })()
    ));
  }(pdf)), pdf.exports;
}
var pdfExports = requirePdf();
async function renderPage(Bi, e, qi, Xi) {
  const Qi = await Bi.getPage(qi), ta = Qi.getViewport({ scale: 5 });
  e.height = ta.height, e.width = ta.width;
  const ra = e.getContext("2d");
  if (!ra)
    return;
  const na = {
    canvasContext: ra,
    viewport: ta
  }, la = ta.height * (qi - 1);
  await Qi.render(na).promise, ra.setTransform(1, 0, 0, 1, 0, 0), Xi.push({
    data: e.toDataURL(),
    offset: la,
    page: qi
  }), qi + 1 <= Bi.numPages && await renderPage(Bi, e, qi + 1, Xi);
}
const usePDF = ({ url: Bi, canvas: e }) => {
  const [qi, Xi] = useState(null), [Qi, ta] = useState([]), [ra, na] = useState(!1), la = useCallback(
    async (Ma) => {
      if (!e || !qi) return;
      const Va = { data: [] };
      await renderPage(qi, e, Ma, Va.data), ta(Va.data), na(!0);
    },
    [qi, na]
  );
  return useEffect(() => {
    la(1);
  }, [qi, la]), useEffect(() => {
    pdfExports.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfExports.version}/pdf.worker.js`, pdfExports.getDocument({ url: Bi }).promise.then((Va) => {
      Xi(Va);
    });
  }, []), {
    ready: ra,
    pageData: Qi,
    totalPages: qi?.numPages
  };
}, PDFPreview = ({ url: Bi }) => {
  const e = useRef(null), { ready: qi, pageData: Xi } = usePDF({
    url: Bi,
    canvas: e.current
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    !qi && /* @__PURE__ */ jsxRuntimeExports.jsx("canvas", { ref: e }),
    Xi.map(({ data: Qi }, ta) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        className: "mb-2 max-w-xl",
        src: Qi
      },
      `pdf-preview-${Bi}=${ta}`
    ))
  ] });
}, SVGPreview = ({ data: Bi }) => {
  const [e, qi] = useState(null), Xi = async () => {
    const Qi = await Bi.text();
    qi(Qi);
  };
  return useEffect(() => {
    Xi();
  }, [Bi]), e ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: e } }) }) : null;
};
var papaparse_min$1 = { exports: {} };
/* @license
Papa Parse
v5.3.2
https://github.com/mholt/PapaParse
License: MIT
*/
var papaparse_min = papaparse_min$1.exports, hasRequiredPapaparse_min;
function requirePapaparse_min() {
  return hasRequiredPapaparse_min || (hasRequiredPapaparse_min = 1, function(Bi, e) {
    (function(qi, Xi) {
      Bi.exports = Xi();
    })(papaparse_min, function qi() {
      var Xi = typeof self < "u" ? self : typeof window < "u" ? window : Xi !== void 0 ? Xi : {}, Qi = !Xi.document && !!Xi.postMessage, ta = Qi && /blob:/i.test((Xi.location || {}).protocol), ra = {}, na = 0, la = { parse: function(ls, ks) {
        var Js = (ks = ks || {}).dynamicTyping || !1;
        if (ws(Js) && (ks.dynamicTypingFunction = Js, Js = {}), ks.dynamicTyping = Js, ks.transform = !!ws(ks.transform) && ks.transform, ks.worker && la.WORKERS_SUPPORTED) {
          var pl = function() {
            if (!la.WORKERS_SUPPORTED) return !1;
            var bl = (Rl = Xi.URL || Xi.webkitURL || null, Cl = qi.toString(), la.BLOB_URL || (la.BLOB_URL = Rl.createObjectURL(new Blob(["(", Cl, ")();"], { type: "text/javascript" })))), xl = new Xi.Worker(bl), Rl, Cl;
            return xl.onmessage = Ks, xl.id = na++, ra[xl.id] = xl;
          }();
          return pl.userStep = ks.step, pl.userChunk = ks.chunk, pl.userComplete = ks.complete, pl.userError = ks.error, ks.step = ws(ks.step), ks.chunk = ws(ks.chunk), ks.complete = ws(ks.complete), ks.error = ws(ks.error), delete ks.worker, void pl.postMessage({ input: ls, config: ks, workerId: pl.id });
        }
        var _l = null;
        return la.NODE_STREAM_INPUT, typeof ls == "string" ? _l = ks.download ? new to(ks) : new So(ks) : ls.readable === !0 && ws(ls.read) && ws(ls.on) ? _l = new eo(ks) : (Xi.File && ls instanceof File || ls instanceof Object) && (_l = new Eo(ks)), _l.stream(ls);
      }, unparse: function(ls, ks) {
        var Js = !1, pl = !0, _l = ",", bl = `\r
`, xl = '"', Rl = xl + xl, Cl = !1, Dl = null, kl = !1;
        (function() {
          if (typeof ks == "object") {
            if (typeof ks.delimiter != "string" || la.BAD_DELIMITERS.filter(function(Pl) {
              return ks.delimiter.indexOf(Pl) !== -1;
            }).length || (_l = ks.delimiter), (typeof ks.quotes == "boolean" || typeof ks.quotes == "function" || Array.isArray(ks.quotes)) && (Js = ks.quotes), typeof ks.skipEmptyLines != "boolean" && typeof ks.skipEmptyLines != "string" || (Cl = ks.skipEmptyLines), typeof ks.newline == "string" && (bl = ks.newline), typeof ks.quoteChar == "string" && (xl = ks.quoteChar), typeof ks.header == "boolean" && (pl = ks.header), Array.isArray(ks.columns)) {
              if (ks.columns.length === 0) throw new Error("Option columns is empty");
              Dl = ks.columns;
            }
            ks.escapeChar !== void 0 && (Rl = ks.escapeChar + xl), (typeof ks.escapeFormulae == "boolean" || ks.escapeFormulae instanceof RegExp) && (kl = ks.escapeFormulae instanceof RegExp ? ks.escapeFormulae : /^[=+\-@\t\r].*$/);
          }
        })();
        var Ul = new RegExp(ko(xl), "g");
        if (typeof ls == "string" && (ls = JSON.parse(ls)), Array.isArray(ls)) {
          if (!ls.length || Array.isArray(ls[0])) return Bl(null, ls, Cl);
          if (typeof ls[0] == "object") return Bl(Dl || Object.keys(ls[0]), ls, Cl);
        } else if (typeof ls == "object") return typeof ls.data == "string" && (ls.data = JSON.parse(ls.data)), Array.isArray(ls.data) && (ls.fields || (ls.fields = ls.meta && ls.meta.fields || Dl), ls.fields || (ls.fields = Array.isArray(ls.data[0]) ? ls.fields : typeof ls.data[0] == "object" ? Object.keys(ls.data[0]) : []), Array.isArray(ls.data[0]) || typeof ls.data[0] == "object" || (ls.data = [ls.data])), Bl(ls.fields || [], ls.data || [], Cl);
        throw new Error("Unable to serialize unrecognized input");
        function Bl(Pl, yl, hl) {
          var Tl = "";
          typeof Pl == "string" && (Pl = JSON.parse(Pl)), typeof yl == "string" && (yl = JSON.parse(yl));
          var Il = Array.isArray(Pl) && 0 < Pl.length, jl = !Array.isArray(yl[0]);
          if (Il && pl) {
            for (var Al = 0; Al < Pl.length; Al++) 0 < Al && (Tl += _l), Tl += Zl(Pl[Al], Al);
            0 < yl.length && (Tl += bl);
          }
          for (var _s = 0; _s < yl.length; _s++) {
            var Gs = Il ? Pl.length : yl[_s].length, vl = !1, gl = Il ? Object.keys(yl[_s]).length === 0 : yl[_s].length === 0;
            if (hl && !Il && (vl = hl === "greedy" ? yl[_s].join("").trim() === "" : yl[_s].length === 1 && yl[_s][0].length === 0), hl === "greedy" && Il) {
              for (var El = [], Ol = 0; Ol < Gs; Ol++) {
                var wl = jl ? Pl[Ol] : Ol;
                El.push(yl[_s][wl]);
              }
              vl = El.join("").trim() === "";
            }
            if (!vl) {
              for (var dl = 0; dl < Gs; dl++) {
                0 < dl && !gl && (Tl += _l);
                var Sl = Il && jl ? Pl[dl] : dl;
                Tl += Zl(yl[_s][Sl], dl);
              }
              _s < yl.length - 1 && (!hl || 0 < Gs && !gl) && (Tl += bl);
            }
          }
          return Tl;
        }
        function Zl(Pl, yl) {
          if (Pl == null) return "";
          if (Pl.constructor === Date) return JSON.stringify(Pl).slice(1, 25);
          var hl = !1;
          kl && typeof Pl == "string" && kl.test(Pl) && (Pl = "'" + Pl, hl = !0);
          var Tl = Pl.toString().replace(Ul, Rl);
          return (hl = hl || Js === !0 || typeof Js == "function" && Js(Pl, yl) || Array.isArray(Js) && Js[yl] || function(Il, jl) {
            for (var Al = 0; Al < jl.length; Al++) if (-1 < Il.indexOf(jl[Al])) return !0;
            return !1;
          }(Tl, la.BAD_DELIMITERS) || -1 < Tl.indexOf(_l) || Tl.charAt(0) === " " || Tl.charAt(Tl.length - 1) === " ") ? xl + Tl + xl : Tl;
        }
      } };
      if (la.RECORD_SEP = "", la.UNIT_SEP = "", la.BYTE_ORDER_MARK = "\uFEFF", la.BAD_DELIMITERS = ["\r", `
`, '"', la.BYTE_ORDER_MARK], la.WORKERS_SUPPORTED = !Qi && !!Xi.Worker, la.NODE_STREAM_INPUT = 1, la.LocalChunkSize = 10485760, la.RemoteChunkSize = 5242880, la.DefaultDelimiter = ",", la.Parser = Hs, la.ParserHandle = rs, la.NetworkStreamer = to, la.FileStreamer = Eo, la.StringStreamer = So, la.ReadableStreamStreamer = eo, Xi.jQuery) {
        var Ma = Xi.jQuery;
        Ma.fn.parse = function(ls) {
          var ks = ls.config || {}, Js = [];
          return this.each(function(bl) {
            if (!(Ma(this).prop("tagName").toUpperCase() === "INPUT" && Ma(this).attr("type").toLowerCase() === "file" && Xi.FileReader) || !this.files || this.files.length === 0) return !0;
            for (var xl = 0; xl < this.files.length; xl++) Js.push({ file: this.files[xl], inputElem: this, instanceConfig: Ma.extend({}, ks) });
          }), pl(), this;
          function pl() {
            if (Js.length !== 0) {
              var bl, xl, Rl, Cl, Dl = Js[0];
              if (ws(ls.before)) {
                var kl = ls.before(Dl.file, Dl.inputElem);
                if (typeof kl == "object") {
                  if (kl.action === "abort") return bl = "AbortError", xl = Dl.file, Rl = Dl.inputElem, Cl = kl.reason, void (ws(ls.error) && ls.error({ name: bl }, xl, Rl, Cl));
                  if (kl.action === "skip") return void _l();
                  typeof kl.config == "object" && (Dl.instanceConfig = Ma.extend(Dl.instanceConfig, kl.config));
                } else if (kl === "skip") return void _l();
              }
              var Ul = Dl.instanceConfig.complete;
              Dl.instanceConfig.complete = function(Bl) {
                ws(Ul) && Ul(Bl, Dl.file, Dl.inputElem), _l();
              }, la.parse(Dl.file, Dl.instanceConfig);
            } else ws(ls.complete) && ls.complete();
          }
          function _l() {
            Js.splice(0, 1), pl();
          }
        };
      }
      function Va(ls) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(ks) {
          var Js = Cs(ks);
          Js.chunkSize = parseInt(Js.chunkSize), ks.step || ks.chunk || (Js.chunkSize = null), this._handle = new rs(Js), (this._handle.streamer = this)._config = Js;
        }.call(this, ls), this.parseChunk = function(ks, Js) {
          if (this.isFirstChunk && ws(this._config.beforeFirstChunk)) {
            var pl = this._config.beforeFirstChunk(ks);
            pl !== void 0 && (ks = pl);
          }
          this.isFirstChunk = !1, this._halted = !1;
          var _l = this._partialLine + ks;
          this._partialLine = "";
          var bl = this._handle.parse(_l, this._baseIndex, !this._finished);
          if (!this._handle.paused() && !this._handle.aborted()) {
            var xl = bl.meta.cursor;
            this._finished || (this._partialLine = _l.substring(xl - this._baseIndex), this._baseIndex = xl), bl && bl.data && (this._rowCount += bl.data.length);
            var Rl = this._finished || this._config.preview && this._rowCount >= this._config.preview;
            if (ta) Xi.postMessage({ results: bl, workerId: la.WORKER_ID, finished: Rl });
            else if (ws(this._config.chunk) && !Js) {
              if (this._config.chunk(bl, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              bl = void 0, this._completeResults = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(bl.data), this._completeResults.errors = this._completeResults.errors.concat(bl.errors), this._completeResults.meta = bl.meta), this._completed || !Rl || !ws(this._config.complete) || bl && bl.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), Rl || bl && bl.meta.paused || this._nextChunk(), bl;
          }
          this._halted = !0;
        }, this._sendError = function(ks) {
          ws(this._config.error) ? this._config.error(ks) : ta && this._config.error && Xi.postMessage({ workerId: la.WORKER_ID, error: ks, finished: !1 });
        };
      }
      function to(ls) {
        var ks;
        (ls = ls || {}).chunkSize || (ls.chunkSize = la.RemoteChunkSize), Va.call(this, ls), this._nextChunk = Qi ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(Js) {
          this._input = Js, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (ks = new XMLHttpRequest(), this._config.withCredentials && (ks.withCredentials = this._config.withCredentials), Qi || (ks.onload = Fs(this._chunkLoaded, this), ks.onerror = Fs(this._chunkError, this)), ks.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !Qi), this._config.downloadRequestHeaders) {
              var Js = this._config.downloadRequestHeaders;
              for (var pl in Js) ks.setRequestHeader(pl, Js[pl]);
            }
            if (this._config.chunkSize) {
              var _l = this._start + this._config.chunkSize - 1;
              ks.setRequestHeader("Range", "bytes=" + this._start + "-" + _l);
            }
            try {
              ks.send(this._config.downloadRequestBody);
            } catch (bl) {
              this._chunkError(bl.message);
            }
            Qi && ks.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          ks.readyState === 4 && (ks.status < 200 || 400 <= ks.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : ks.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(Js) {
            var pl = Js.getResponseHeader("Content-Range");
            return pl === null ? -1 : parseInt(pl.substring(pl.lastIndexOf("/") + 1));
          }(ks), this.parseChunk(ks.responseText)));
        }, this._chunkError = function(Js) {
          var pl = ks.statusText || Js;
          this._sendError(new Error(pl));
        };
      }
      function Eo(ls) {
        var ks, Js;
        (ls = ls || {}).chunkSize || (ls.chunkSize = la.LocalChunkSize), Va.call(this, ls);
        var pl = typeof FileReader < "u";
        this.stream = function(_l) {
          this._input = _l, Js = _l.slice || _l.webkitSlice || _l.mozSlice, pl ? ((ks = new FileReader()).onload = Fs(this._chunkLoaded, this), ks.onerror = Fs(this._chunkError, this)) : ks = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var _l = this._input;
          if (this._config.chunkSize) {
            var bl = Math.min(this._start + this._config.chunkSize, this._input.size);
            _l = Js.call(_l, this._start, bl);
          }
          var xl = ks.readAsText(_l, this._config.encoding);
          pl || this._chunkLoaded({ target: { result: xl } });
        }, this._chunkLoaded = function(_l) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(_l.target.result);
        }, this._chunkError = function() {
          this._sendError(ks.error);
        };
      }
      function So(ls) {
        var ks;
        Va.call(this, ls = ls || {}), this.stream = function(Js) {
          return ks = Js, this._nextChunk();
        }, this._nextChunk = function() {
          if (!this._finished) {
            var Js, pl = this._config.chunkSize;
            return pl ? (Js = ks.substring(0, pl), ks = ks.substring(pl)) : (Js = ks, ks = ""), this._finished = !ks, this.parseChunk(Js);
          }
        };
      }
      function eo(ls) {
        Va.call(this, ls = ls || {});
        var ks = [], Js = !0, pl = !1;
        this.pause = function() {
          Va.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          Va.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(_l) {
          this._input = _l, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          pl && ks.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), ks.length ? this.parseChunk(ks.shift()) : Js = !0;
        }, this._streamData = Fs(function(_l) {
          try {
            ks.push(typeof _l == "string" ? _l : _l.toString(this._config.encoding)), Js && (Js = !1, this._checkIsFinished(), this.parseChunk(ks.shift()));
          } catch (bl) {
            this._streamError(bl);
          }
        }, this), this._streamError = Fs(function(_l) {
          this._streamCleanUp(), this._sendError(_l);
        }, this), this._streamEnd = Fs(function() {
          this._streamCleanUp(), pl = !0, this._streamData("");
        }, this), this._streamCleanUp = Fs(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function rs(ls) {
        var ks, Js, pl, _l = Math.pow(2, 53), bl = -_l, xl = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, Rl = /^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/, Cl = this, Dl = 0, kl = 0, Ul = !1, Bl = !1, Zl = [], Pl = { data: [], errors: [], meta: {} };
        if (ws(ls.step)) {
          var yl = ls.step;
          ls.step = function(_s) {
            if (Pl = _s, Il()) Tl();
            else {
              if (Tl(), Pl.data.length === 0) return;
              Dl += _s.data.length, ls.preview && Dl > ls.preview ? Js.abort() : (Pl.data = Pl.data[0], yl(Pl, Cl));
            }
          };
        }
        function hl(_s) {
          return ls.skipEmptyLines === "greedy" ? _s.join("").trim() === "" : _s.length === 1 && _s[0].length === 0;
        }
        function Tl() {
          return Pl && pl && (Al("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + la.DefaultDelimiter + "'"), pl = !1), ls.skipEmptyLines && (Pl.data = Pl.data.filter(function(_s) {
            return !hl(_s);
          })), Il() && function() {
            if (!Pl) return;
            function _s(vl, gl) {
              ws(ls.transformHeader) && (vl = ls.transformHeader(vl, gl)), Zl.push(vl);
            }
            if (Array.isArray(Pl.data[0])) {
              for (var Gs = 0; Il() && Gs < Pl.data.length; Gs++) Pl.data[Gs].forEach(_s);
              Pl.data.splice(0, 1);
            } else Pl.data.forEach(_s);
          }(), function() {
            if (!Pl || !ls.header && !ls.dynamicTyping && !ls.transform) return Pl;
            function _s(vl, gl) {
              var El, Ol = ls.header ? {} : [];
              for (El = 0; El < vl.length; El++) {
                var wl = El, dl = vl[El];
                ls.header && (wl = El >= Zl.length ? "__parsed_extra" : Zl[El]), ls.transform && (dl = ls.transform(dl, wl)), dl = jl(wl, dl), wl === "__parsed_extra" ? (Ol[wl] = Ol[wl] || [], Ol[wl].push(dl)) : Ol[wl] = dl;
              }
              return ls.header && (El > Zl.length ? Al("FieldMismatch", "TooManyFields", "Too many fields: expected " + Zl.length + " fields but parsed " + El, kl + gl) : El < Zl.length && Al("FieldMismatch", "TooFewFields", "Too few fields: expected " + Zl.length + " fields but parsed " + El, kl + gl)), Ol;
            }
            var Gs = 1;
            return !Pl.data.length || Array.isArray(Pl.data[0]) ? (Pl.data = Pl.data.map(_s), Gs = Pl.data.length) : Pl.data = _s(Pl.data, 0), ls.header && Pl.meta && (Pl.meta.fields = Zl), kl += Gs, Pl;
          }();
        }
        function Il() {
          return ls.header && Zl.length === 0;
        }
        function jl(_s, Gs) {
          return vl = _s, ls.dynamicTypingFunction && ls.dynamicTyping[vl] === void 0 && (ls.dynamicTyping[vl] = ls.dynamicTypingFunction(vl)), (ls.dynamicTyping[vl] || ls.dynamicTyping) === !0 ? Gs === "true" || Gs === "TRUE" || Gs !== "false" && Gs !== "FALSE" && (function(gl) {
            if (xl.test(gl)) {
              var El = parseFloat(gl);
              if (bl < El && El < _l) return !0;
            }
            return !1;
          }(Gs) ? parseFloat(Gs) : Rl.test(Gs) ? new Date(Gs) : Gs === "" ? null : Gs) : Gs;
          var vl;
        }
        function Al(_s, Gs, vl, gl) {
          var El = { type: _s, code: Gs, message: vl };
          gl !== void 0 && (El.row = gl), Pl.errors.push(El);
        }
        this.parse = function(_s, Gs, vl) {
          var gl = ls.quoteChar || '"';
          if (ls.newline || (ls.newline = function(wl, dl) {
            wl = wl.substring(0, 1048576);
            var Sl = new RegExp(ko(dl) + "([^]*?)" + ko(dl), "gm"), Ml = (wl = wl.replace(Sl, "")).split("\r"), Fl = wl.split(`
`), Ll = 1 < Fl.length && Fl[0].length < Ml[0].length;
            if (Ml.length === 1 || Ll) return `
`;
            for (var Nl = 0, ql = 0; ql < Ml.length; ql++) Ml[ql][0] === `
` && Nl++;
            return Nl >= Ml.length / 2 ? `\r
` : "\r";
          }(_s, gl)), pl = !1, ls.delimiter) ws(ls.delimiter) && (ls.delimiter = ls.delimiter(_s), Pl.meta.delimiter = ls.delimiter);
          else {
            var El = function(wl, dl, Sl, Ml, Fl) {
              var Ll, Nl, ql, Jl;
              Fl = Fl || [",", "	", "|", ";", la.RECORD_SEP, la.UNIT_SEP];
              for (var zl = 0; zl < Fl.length; zl++) {
                var tc = Fl[zl], Ku = 0, tu = 0, Gu = 0;
                ql = void 0;
                for (var Qu = new Hs({ comments: Ml, delimiter: tc, newline: dl, preview: 10 }).parse(wl), ed = 0; ed < Qu.data.length; ed++) if (Sl && hl(Qu.data[ed])) Gu++;
                else {
                  var td = Qu.data[ed].length;
                  tu += td, ql !== void 0 ? 0 < td && (Ku += Math.abs(td - ql), ql = td) : ql = td;
                }
                0 < Qu.data.length && (tu /= Qu.data.length - Gu), (Nl === void 0 || Ku <= Nl) && (Jl === void 0 || Jl < tu) && 1.99 < tu && (Nl = Ku, Ll = tc, Jl = tu);
              }
              return { successful: !!(ls.delimiter = Ll), bestDelimiter: Ll };
            }(_s, ls.newline, ls.skipEmptyLines, ls.comments, ls.delimitersToGuess);
            El.successful ? ls.delimiter = El.bestDelimiter : (pl = !0, ls.delimiter = la.DefaultDelimiter), Pl.meta.delimiter = ls.delimiter;
          }
          var Ol = Cs(ls);
          return ls.preview && ls.header && Ol.preview++, ks = _s, Js = new Hs(Ol), Pl = Js.parse(ks, Gs, vl), Tl(), Ul ? { meta: { paused: !0 } } : Pl || { meta: { paused: !1 } };
        }, this.paused = function() {
          return Ul;
        }, this.pause = function() {
          Ul = !0, Js.abort(), ks = ws(ls.chunk) ? "" : ks.substring(Js.getCharIndex());
        }, this.resume = function() {
          Cl.streamer._halted ? (Ul = !1, Cl.streamer.parseChunk(ks, !0)) : setTimeout(Cl.resume, 3);
        }, this.aborted = function() {
          return Bl;
        }, this.abort = function() {
          Bl = !0, Js.abort(), Pl.meta.aborted = !0, ws(ls.complete) && ls.complete(Pl), ks = "";
        };
      }
      function ko(ls) {
        return ls.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function Hs(ls) {
        var ks, Js = (ls = ls || {}).delimiter, pl = ls.newline, _l = ls.comments, bl = ls.step, xl = ls.preview, Rl = ls.fastMode, Cl = ks = ls.quoteChar === void 0 || ls.quoteChar === null ? '"' : ls.quoteChar;
        if (ls.escapeChar !== void 0 && (Cl = ls.escapeChar), (typeof Js != "string" || -1 < la.BAD_DELIMITERS.indexOf(Js)) && (Js = ","), _l === Js) throw new Error("Comment character same as delimiter");
        _l === !0 ? _l = "#" : (typeof _l != "string" || -1 < la.BAD_DELIMITERS.indexOf(_l)) && (_l = !1), pl !== `
` && pl !== "\r" && pl !== `\r
` && (pl = `
`);
        var Dl = 0, kl = !1;
        this.parse = function(Ul, Bl, Zl) {
          if (typeof Ul != "string") throw new Error("Input must be a string");
          var Pl = Ul.length, yl = Js.length, hl = pl.length, Tl = _l.length, Il = ws(bl), jl = [], Al = [], _s = [], Gs = Dl = 0;
          if (!Ul) return Jl();
          if (Rl || Rl !== !1 && Ul.indexOf(ks) === -1) {
            for (var vl = Ul.split(pl), gl = 0; gl < vl.length; gl++) {
              if (_s = vl[gl], Dl += _s.length, gl !== vl.length - 1) Dl += pl.length;
              else if (Zl) return Jl();
              if (!_l || _s.substring(0, Tl) !== _l) {
                if (Il) {
                  if (jl = [], Fl(_s.split(Js)), zl(), kl) return Jl();
                } else Fl(_s.split(Js));
                if (xl && xl <= gl) return jl = jl.slice(0, xl), Jl(!0);
              }
            }
            return Jl();
          }
          for (var El = Ul.indexOf(Js, Dl), Ol = Ul.indexOf(pl, Dl), wl = new RegExp(ko(Cl) + ko(ks), "g"), dl = Ul.indexOf(ks, Dl); ; ) if (Ul[Dl] !== ks) if (_l && _s.length === 0 && Ul.substring(Dl, Dl + Tl) === _l) {
            if (Ol === -1) return Jl();
            Dl = Ol + hl, Ol = Ul.indexOf(pl, Dl), El = Ul.indexOf(Js, Dl);
          } else if (El !== -1 && (El < Ol || Ol === -1)) _s.push(Ul.substring(Dl, El)), Dl = El + yl, El = Ul.indexOf(Js, Dl);
          else {
            if (Ol === -1) break;
            if (_s.push(Ul.substring(Dl, Ol)), ql(Ol + hl), Il && (zl(), kl)) return Jl();
            if (xl && jl.length >= xl) return Jl(!0);
          }
          else for (dl = Dl, Dl++; ; ) {
            if ((dl = Ul.indexOf(ks, dl + 1)) === -1) return Zl || Al.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: jl.length, index: Dl }), Nl();
            if (dl === Pl - 1) return Nl(Ul.substring(Dl, dl).replace(wl, ks));
            if (ks !== Cl || Ul[dl + 1] !== Cl) {
              if (ks === Cl || dl === 0 || Ul[dl - 1] !== Cl) {
                El !== -1 && El < dl + 1 && (El = Ul.indexOf(Js, dl + 1)), Ol !== -1 && Ol < dl + 1 && (Ol = Ul.indexOf(pl, dl + 1));
                var Sl = Ll(Ol === -1 ? El : Math.min(El, Ol));
                if (Ul.substr(dl + 1 + Sl, yl) === Js) {
                  _s.push(Ul.substring(Dl, dl).replace(wl, ks)), Ul[Dl = dl + 1 + Sl + yl] !== ks && (dl = Ul.indexOf(ks, Dl)), El = Ul.indexOf(Js, Dl), Ol = Ul.indexOf(pl, Dl);
                  break;
                }
                var Ml = Ll(Ol);
                if (Ul.substring(dl + 1 + Ml, dl + 1 + Ml + hl) === pl) {
                  if (_s.push(Ul.substring(Dl, dl).replace(wl, ks)), ql(dl + 1 + Ml + hl), El = Ul.indexOf(Js, Dl), dl = Ul.indexOf(ks, Dl), Il && (zl(), kl)) return Jl();
                  if (xl && jl.length >= xl) return Jl(!0);
                  break;
                }
                Al.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: jl.length, index: Dl }), dl++;
              }
            } else dl++;
          }
          return Nl();
          function Fl(tc) {
            jl.push(tc), Gs = Dl;
          }
          function Ll(tc) {
            var Ku = 0;
            if (tc !== -1) {
              var tu = Ul.substring(dl + 1, tc);
              tu && tu.trim() === "" && (Ku = tu.length);
            }
            return Ku;
          }
          function Nl(tc) {
            return Zl || (tc === void 0 && (tc = Ul.substring(Dl)), _s.push(tc), Dl = Pl, Fl(_s), Il && zl()), Jl();
          }
          function ql(tc) {
            Dl = tc, Fl(_s), _s = [], Ol = Ul.indexOf(pl, Dl);
          }
          function Jl(tc) {
            return { data: jl, errors: Al, meta: { delimiter: Js, linebreak: pl, aborted: kl, truncated: !!tc, cursor: Gs + (Bl || 0) } };
          }
          function zl() {
            bl(Jl()), jl = [], Al = [];
          }
        }, this.abort = function() {
          kl = !0;
        }, this.getCharIndex = function() {
          return Dl;
        };
      }
      function Ks(ls) {
        var ks = ls.data, Js = ra[ks.workerId], pl = !1;
        if (ks.error) Js.userError(ks.error, ks.file);
        else if (ks.results && ks.results.data) {
          var _l = { abort: function() {
            pl = !0, Ys(ks.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: Xs, resume: Xs };
          if (ws(Js.userStep)) {
            for (var bl = 0; bl < ks.results.data.length && (Js.userStep({ data: ks.results.data[bl], errors: ks.results.errors, meta: ks.results.meta }, _l), !pl); bl++) ;
            delete ks.results;
          } else ws(Js.userChunk) && (Js.userChunk(ks.results, _l, ks.file), delete ks.results);
        }
        ks.finished && !pl && Ys(ks.workerId, ks.results);
      }
      function Ys(ls, ks) {
        var Js = ra[ls];
        ws(Js.userComplete) && Js.userComplete(ks), Js.terminate(), delete ra[ls];
      }
      function Xs() {
        throw new Error("Not implemented.");
      }
      function Cs(ls) {
        if (typeof ls != "object" || ls === null) return ls;
        var ks = Array.isArray(ls) ? [] : {};
        for (var Js in ls) ks[Js] = Cs(ls[Js]);
        return ks;
      }
      function Fs(ls, ks) {
        return function() {
          ls.apply(ks, arguments);
        };
      }
      function ws(ls) {
        return typeof ls == "function";
      }
      return ta && (Xi.onmessage = function(ls) {
        var ks = ls.data;
        if (la.WORKER_ID === void 0 && ks && (la.WORKER_ID = ks.workerId), typeof ks.input == "string") Xi.postMessage({ workerId: la.WORKER_ID, results: la.parse(ks.input, ks.config), finished: !0 });
        else if (Xi.File && ks.input instanceof File || ks.input instanceof Object) {
          var Js = la.parse(ks.input, ks.config);
          Js && Xi.postMessage({ workerId: la.WORKER_ID, results: Js, finished: !0 });
        }
      }), (to.prototype = Object.create(Va.prototype)).constructor = to, (Eo.prototype = Object.create(Va.prototype)).constructor = Eo, (So.prototype = Object.create(So.prototype)).constructor = So, (eo.prototype = Object.create(Va.prototype)).constructor = eo, la;
    });
  }(papaparse_min$1)), papaparse_min$1.exports;
}
var papaparse_minExports = requirePapaparse_min();
const Table$1 = (Bi) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "table",
  {
    className: "bg-neutral-200 mb-4 border-collapse rounded border-none",
    ...Bi
  }
), TablePreview = ({ data: Bi }) => {
  const [e, qi] = useState(null), Xi = async () => {
    const Qi = await Bi.text();
    papaparse_minExports.parse(Qi, {
      complete: (ta) => qi(ta.data)
    });
  };
  return useEffect(() => {
    Xi();
  }, [Bi]), e ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "p-4 rounded-md bg-neutral-200", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: e.map((Qi, ta) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { children: Object.keys(Qi).map((ra, na) => /* @__PURE__ */ jsxRuntimeExports.jsx("td", { children: Qi[ra] }, `cell-${ta * na}`)) }, `row-${ta}`)) }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading..." }) });
}, fileLimitBytes = 5e3, Preview = ({ bucket: Bi, fileKey: e }) => {
  if (!Bi || !e)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Invalid URL" });
  const qi = e, Xi = qi.endsWith(".pdf"), Qi = qi.split(".").pop(), ta = usePresignedDownloadUrlQuery({
    variables: { bucket: Bi, key: qi, limit: Xi ? void 0 : fileLimitBytes }
  }), [ra] = usePresignedDownloadUrlLazyQuery(), [na, la] = useState(null), Ma = qi.split("/").pop() || qi, Va = useCallback(
    async (Eo) => {
      const eo = await (await fetch(Eo, {
        headers: { Range: `bytes=0-${fileLimitBytes}` }
      })).blob();
      la(eo);
    },
    [la]
  );
  if (useEffect(() => {
    ta.data?.presignedDownloadUrl && Va(ta.data.presignedDownloadUrl);
  }, [ta.data?.presignedDownloadUrl, Va]), !na)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, {}) });
  let to;
  switch (Qi) {
    case "svg":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(SVGPreview, { data: na });
      break;
    case "csv":
    case "bed":
    case "fastq":
    case "tsv":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(TablePreview, { data: na });
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(ImagePreview, { data: na });
      break;
    case "pdf":
      to = /* @__PURE__ */ jsxRuntimeExports.jsx(PDFPreview, { url: ta.data?.presignedDownloadUrl || "" });
      break;
    default:
      to = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col w-full h-full overflow-scroll", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PageHeader, { title: Ma, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: async () => {
          const So = (await ra({ variables: { bucket: Bi, key: qi } })).data?.presignedDownloadUrl;
          So && window.open(So);
        },
        variant: "gray",
        children: "Download"
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex justify-around w-full", children: to })
  ] });
}, Protected = ({
  validate: Bi,
  children: e,
  onFailure: qi
}) => {
  const [Xi, Qi] = useState(!0), ta = useCallback(async () => {
    await Bi() ? Qi(!1) : qi();
  }, []);
  return useEffect(() => {
    ta();
  }, []), Xi ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: e });
};
function hasRole(Bi, e) {
  return e.some(
    (qi) => Bi.some((Xi) => Xi.role === qi)
  );
}
const RequireRoles = ({
  roles: Bi,
  children: e,
  loginUrl: qi
}) => {
  const [Xi] = useMeLazyQuery({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Protected,
    {
      onFailure: () => {
        window.location.href = `${qi}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const Qi = await Xi();
        return !(!Qi.data?.me || !hasRole(Qi.data.me.roles || [], Bi));
      },
      children: e
    }
  );
}, S3DownloadLink = ({
  path: Bi,
  className: e,
  children: qi,
  endpoint: Xi
}) => {
  const Qi = `${Xi}/download?bucket=${Bi.bucket}&key=${Bi.key}&isFolder=${Bi.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: e, href: Qi, download: "asfdkl", children: qi });
};
var object_hash = { exports: {} }, hasRequiredObject_hash;
function requireObject_hash() {
  return hasRequiredObject_hash || (hasRequiredObject_hash = 1, function(Bi, e) {
    (function(qi) {
      Bi.exports = qi();
    })(function() {
      return function qi(Xi, Qi, ta) {
        function ra(Ma, Va) {
          if (!Qi[Ma]) {
            if (!Xi[Ma]) {
              var to = typeof commonjsRequire == "function" && commonjsRequire;
              if (!Va && to) return to(Ma, !0);
              if (na) return na(Ma, !0);
              throw new Error("Cannot find module '" + Ma + "'");
            }
            Va = Qi[Ma] = { exports: {} }, Xi[Ma][0].call(Va.exports, function(Eo) {
              var So = Xi[Ma][1][Eo];
              return ra(So || Eo);
            }, Va, Va.exports, qi, Xi, Qi, ta);
          }
          return Qi[Ma].exports;
        }
        for (var na = typeof commonjsRequire == "function" && commonjsRequire, la = 0; la < ta.length; la++) ra(ta[la]);
        return ra;
      }({ 1: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          var eo = qi("crypto");
          function rs(Fs, ws) {
            ws = Ks(Fs, ws);
            var ls;
            return (ls = ws.algorithm !== "passthrough" ? eo.createHash(ws.algorithm) : new Cs()).write === void 0 && (ls.write = ls.update, ls.end = ls.update), Xs(ws, ls).dispatch(Fs), ls.update || ls.end(""), ls.digest ? ls.digest(ws.encoding === "buffer" ? void 0 : ws.encoding) : (Fs = ls.read(), ws.encoding !== "buffer" ? Fs.toString(ws.encoding) : Fs);
          }
          (Qi = Xi.exports = rs).sha1 = function(Fs) {
            return rs(Fs);
          }, Qi.keys = function(Fs) {
            return rs(Fs, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, Qi.MD5 = function(Fs) {
            return rs(Fs, { algorithm: "md5", encoding: "hex" });
          }, Qi.keysMD5 = function(Fs) {
            return rs(Fs, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var ko = eo.getHashes ? eo.getHashes().slice() : ["sha1", "md5"], Hs = (ko.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function Ks(Fs, ws) {
            var ls = {};
            if (ls.algorithm = (ws = ws || {}).algorithm || "sha1", ls.encoding = ws.encoding || "hex", ls.excludeValues = !!ws.excludeValues, ls.algorithm = ls.algorithm.toLowerCase(), ls.encoding = ls.encoding.toLowerCase(), ls.ignoreUnknown = ws.ignoreUnknown === !0, ls.respectType = ws.respectType !== !1, ls.respectFunctionNames = ws.respectFunctionNames !== !1, ls.respectFunctionProperties = ws.respectFunctionProperties !== !1, ls.unorderedArrays = ws.unorderedArrays === !0, ls.unorderedSets = ws.unorderedSets !== !1, ls.unorderedObjects = ws.unorderedObjects !== !1, ls.replacer = ws.replacer || void 0, ls.excludeKeys = ws.excludeKeys || void 0, Fs === void 0) throw new Error("Object argument required.");
            for (var ks = 0; ks < ko.length; ++ks) ko[ks].toLowerCase() === ls.algorithm.toLowerCase() && (ls.algorithm = ko[ks]);
            if (ko.indexOf(ls.algorithm) === -1) throw new Error('Algorithm "' + ls.algorithm + '"  not supported. supported values: ' + ko.join(", "));
            if (Hs.indexOf(ls.encoding) === -1 && ls.algorithm !== "passthrough") throw new Error('Encoding "' + ls.encoding + '"  not supported. supported values: ' + Hs.join(", "));
            return ls;
          }
          function Ys(Fs) {
            if (typeof Fs == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(Fs)) != null;
          }
          function Xs(Fs, ws, ls) {
            ls = ls || [];
            function ks(Js) {
              return ws.update ? ws.update(Js, "utf8") : ws.write(Js, "utf8");
            }
            return { dispatch: function(Js) {
              return this["_" + ((Js = Fs.replacer ? Fs.replacer(Js) : Js) === null ? "null" : typeof Js)](Js);
            }, _object: function(Js) {
              var pl, _l = Object.prototype.toString.call(Js), bl = /\[object (.*)\]/i.exec(_l);
              if (bl = (bl = bl ? bl[1] : "unknown:[" + _l + "]").toLowerCase(), 0 <= (_l = ls.indexOf(Js))) return this.dispatch("[CIRCULAR:" + _l + "]");
              if (ls.push(Js), na !== void 0 && na.isBuffer && na.isBuffer(Js)) return ks("buffer:"), ks(Js);
              if (bl === "object" || bl === "function" || bl === "asyncfunction") return _l = Object.keys(Js), Fs.unorderedObjects && (_l = _l.sort()), Fs.respectType === !1 || Ys(Js) || _l.splice(0, 0, "prototype", "__proto__", "constructor"), Fs.excludeKeys && (_l = _l.filter(function(xl) {
                return !Fs.excludeKeys(xl);
              })), ks("object:" + _l.length + ":"), pl = this, _l.forEach(function(xl) {
                pl.dispatch(xl), ks(":"), Fs.excludeValues || pl.dispatch(Js[xl]), ks(",");
              });
              if (!this["_" + bl]) {
                if (Fs.ignoreUnknown) return ks("[" + bl + "]");
                throw new Error('Unknown object type "' + bl + '"');
              }
              this["_" + bl](Js);
            }, _array: function(Js, xl) {
              xl = xl !== void 0 ? xl : Fs.unorderedArrays !== !1;
              var _l = this;
              if (ks("array:" + Js.length + ":"), !xl || Js.length <= 1) return Js.forEach(function(Rl) {
                return _l.dispatch(Rl);
              });
              var bl = [], xl = Js.map(function(Rl) {
                var Cl = new Cs(), Dl = ls.slice();
                return Xs(Fs, Cl, Dl).dispatch(Rl), bl = bl.concat(Dl.slice(ls.length)), Cl.read().toString();
              });
              return ls = ls.concat(bl), xl.sort(), this._array(xl, !1);
            }, _date: function(Js) {
              return ks("date:" + Js.toJSON());
            }, _symbol: function(Js) {
              return ks("symbol:" + Js.toString());
            }, _error: function(Js) {
              return ks("error:" + Js.toString());
            }, _boolean: function(Js) {
              return ks("bool:" + Js.toString());
            }, _string: function(Js) {
              ks("string:" + Js.length + ":"), ks(Js.toString());
            }, _function: function(Js) {
              ks("fn:"), Ys(Js) ? this.dispatch("[native]") : this.dispatch(Js.toString()), Fs.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(Js.name)), Fs.respectFunctionProperties && this._object(Js);
            }, _number: function(Js) {
              return ks("number:" + Js.toString());
            }, _xml: function(Js) {
              return ks("xml:" + Js.toString());
            }, _null: function() {
              return ks("Null");
            }, _undefined: function() {
              return ks("Undefined");
            }, _regexp: function(Js) {
              return ks("regex:" + Js.toString());
            }, _uint8array: function(Js) {
              return ks("uint8array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _uint8clampedarray: function(Js) {
              return ks("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _int8array: function(Js) {
              return ks("int8array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _uint16array: function(Js) {
              return ks("uint16array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _int16array: function(Js) {
              return ks("int16array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _uint32array: function(Js) {
              return ks("uint32array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _int32array: function(Js) {
              return ks("int32array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _float32array: function(Js) {
              return ks("float32array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _float64array: function(Js) {
              return ks("float64array:"), this.dispatch(Array.prototype.slice.call(Js));
            }, _arraybuffer: function(Js) {
              return ks("arraybuffer:"), this.dispatch(new Uint8Array(Js));
            }, _url: function(Js) {
              return ks("url:" + Js.toString());
            }, _map: function(Js) {
              return ks("map:"), Js = Array.from(Js), this._array(Js, Fs.unorderedSets !== !1);
            }, _set: function(Js) {
              return ks("set:"), Js = Array.from(Js), this._array(Js, Fs.unorderedSets !== !1);
            }, _file: function(Js) {
              return ks("file:"), this.dispatch([Js.name, Js.size, Js.type, Js.lastModfied]);
            }, _blob: function() {
              if (Fs.ignoreUnknown) return ks("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return ks("domwindow");
            }, _bigint: function(Js) {
              return ks("bigint:" + Js.toString());
            }, _process: function() {
              return ks("process");
            }, _timer: function() {
              return ks("timer");
            }, _pipe: function() {
              return ks("pipe");
            }, _tcp: function() {
              return ks("tcp");
            }, _udp: function() {
              return ks("udp");
            }, _tty: function() {
              return ks("tty");
            }, _statwatcher: function() {
              return ks("statwatcher");
            }, _securecontext: function() {
              return ks("securecontext");
            }, _connection: function() {
              return ks("connection");
            }, _zlib: function() {
              return ks("zlib");
            }, _context: function() {
              return ks("context");
            }, _nodescript: function() {
              return ks("nodescript");
            }, _httpparser: function() {
              return ks("httpparser");
            }, _dataview: function() {
              return ks("dataview");
            }, _signal: function() {
              return ks("signal");
            }, _fsevent: function() {
              return ks("fsevent");
            }, _tlswrap: function() {
              return ks("tlswrap");
            } };
          }
          function Cs() {
            return { buf: "", write: function(Fs) {
              this.buf += Fs;
            }, end: function(Fs) {
              this.buf += Fs;
            }, read: function() {
              return this.buf;
            } };
          }
          Qi.writeToStream = function(Fs, ws, ls) {
            return ls === void 0 && (ls = ws, ws = {}), Xs(ws = Ks(Fs, ws), ls).dispatch(Fs);
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          (function(eo) {
            var rs = typeof Uint8Array < "u" ? Uint8Array : Array, ko = 43, Hs = 47, Ks = 48, Ys = 97, Xs = 65, Cs = 45, Fs = 95;
            function ws(ls) {
              return ls = ls.charCodeAt(0), ls === ko || ls === Cs ? 62 : ls === Hs || ls === Fs ? 63 : ls < Ks ? -1 : ls < Ks + 10 ? ls - Ks + 26 + 26 : ls < Xs + 26 ? ls - Xs : ls < Ys + 26 ? ls - Ys + 26 : void 0;
            }
            eo.toByteArray = function(ls) {
              var ks, Js;
              if (0 < ls.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var pl = ls.length, pl = ls.charAt(pl - 2) === "=" ? 2 : ls.charAt(pl - 1) === "=" ? 1 : 0, _l = new rs(3 * ls.length / 4 - pl), bl = 0 < pl ? ls.length - 4 : ls.length, xl = 0;
              function Rl(Cl) {
                _l[xl++] = Cl;
              }
              for (ks = 0; ks < bl; ks += 4, 0) Rl((16711680 & (Js = ws(ls.charAt(ks)) << 18 | ws(ls.charAt(ks + 1)) << 12 | ws(ls.charAt(ks + 2)) << 6 | ws(ls.charAt(ks + 3)))) >> 16), Rl((65280 & Js) >> 8), Rl(255 & Js);
              return pl == 2 ? Rl(255 & (Js = ws(ls.charAt(ks)) << 2 | ws(ls.charAt(ks + 1)) >> 4)) : pl == 1 && (Rl((Js = ws(ls.charAt(ks)) << 10 | ws(ls.charAt(ks + 1)) << 4 | ws(ls.charAt(ks + 2)) >> 2) >> 8 & 255), Rl(255 & Js)), _l;
            }, eo.fromByteArray = function(ls) {
              var ks, Js, pl, _l, bl = ls.length % 3, xl = "";
              function Rl(Cl) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(Cl);
              }
              for (ks = 0, pl = ls.length - bl; ks < pl; ks += 3) Js = (ls[ks] << 16) + (ls[ks + 1] << 8) + ls[ks + 2], xl += Rl((_l = Js) >> 18 & 63) + Rl(_l >> 12 & 63) + Rl(_l >> 6 & 63) + Rl(63 & _l);
              switch (bl) {
                case 1:
                  xl = (xl += Rl((Js = ls[ls.length - 1]) >> 2)) + Rl(Js << 4 & 63) + "==";
                  break;
                case 2:
                  xl = (xl = (xl += Rl((Js = (ls[ls.length - 2] << 8) + ls[ls.length - 1]) >> 10)) + Rl(Js >> 4 & 63)) + Rl(Js << 2 & 63) + "=";
              }
              return xl;
            };
          })(Qi === void 0 ? this.base64js = {} : Qi);
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(qi, Xi, Qi) {
        (function(ta, ra, ko, la, Ma, Va, to, Eo, So) {
          var eo = qi("base64-js"), rs = qi("ieee754");
          function ko(_s, Gs, vl) {
            if (!(this instanceof ko)) return new ko(_s, Gs, vl);
            var gl, El, Ol, wl, dl = typeof _s;
            if (Gs === "base64" && dl == "string") for (_s = (wl = _s).trim ? wl.trim() : wl.replace(/^\s+|\s+$/g, ""); _s.length % 4 != 0; ) _s += "=";
            if (dl == "number") gl = kl(_s);
            else if (dl == "string") gl = ko.byteLength(_s, Gs);
            else {
              if (dl != "object") throw new Error("First argument needs to be a number, array or string.");
              gl = kl(_s.length);
            }
            if (ko._useTypedArrays ? El = ko._augment(new Uint8Array(gl)) : ((El = this).length = gl, El._isBuffer = !0), ko._useTypedArrays && typeof _s.byteLength == "number") El._set(_s);
            else if (Ul(wl = _s) || ko.isBuffer(wl) || wl && typeof wl == "object" && typeof wl.length == "number") for (Ol = 0; Ol < gl; Ol++) ko.isBuffer(_s) ? El[Ol] = _s.readUInt8(Ol) : El[Ol] = _s[Ol];
            else if (dl == "string") El.write(_s, 0, Gs);
            else if (dl == "number" && !ko._useTypedArrays && !vl) for (Ol = 0; Ol < gl; Ol++) El[Ol] = 0;
            return El;
          }
          function Hs(_s, Gs, vl, gl) {
            return ko._charsWritten = yl(function(El) {
              for (var Ol = [], wl = 0; wl < El.length; wl++) Ol.push(255 & El.charCodeAt(wl));
              return Ol;
            }(Gs), _s, vl, gl);
          }
          function Ks(_s, Gs, vl, gl) {
            return ko._charsWritten = yl(function(El) {
              for (var Ol, wl, dl = [], Sl = 0; Sl < El.length; Sl++) wl = El.charCodeAt(Sl), Ol = wl >> 8, wl = wl % 256, dl.push(wl), dl.push(Ol);
              return dl;
            }(Gs), _s, vl, gl);
          }
          function Ys(_s, Gs, vl) {
            var gl = "";
            vl = Math.min(_s.length, vl);
            for (var El = Gs; El < vl; El++) gl += String.fromCharCode(_s[El]);
            return gl;
          }
          function Xs(_s, Gs, vl, Ol) {
            Ol || (Al(typeof vl == "boolean", "missing or invalid endian"), Al(Gs != null, "missing offset"), Al(Gs + 1 < _s.length, "Trying to read beyond buffer length"));
            var El, Ol = _s.length;
            if (!(Ol <= Gs)) return vl ? (El = _s[Gs], Gs + 1 < Ol && (El |= _s[Gs + 1] << 8)) : (El = _s[Gs] << 8, Gs + 1 < Ol && (El |= _s[Gs + 1])), El;
          }
          function Cs(_s, Gs, vl, Ol) {
            Ol || (Al(typeof vl == "boolean", "missing or invalid endian"), Al(Gs != null, "missing offset"), Al(Gs + 3 < _s.length, "Trying to read beyond buffer length"));
            var El, Ol = _s.length;
            if (!(Ol <= Gs)) return vl ? (Gs + 2 < Ol && (El = _s[Gs + 2] << 16), Gs + 1 < Ol && (El |= _s[Gs + 1] << 8), El |= _s[Gs], Gs + 3 < Ol && (El += _s[Gs + 3] << 24 >>> 0)) : (Gs + 1 < Ol && (El = _s[Gs + 1] << 16), Gs + 2 < Ol && (El |= _s[Gs + 2] << 8), Gs + 3 < Ol && (El |= _s[Gs + 3]), El += _s[Gs] << 24 >>> 0), El;
          }
          function Fs(_s, Gs, vl, gl) {
            if (gl || (Al(typeof vl == "boolean", "missing or invalid endian"), Al(Gs != null, "missing offset"), Al(Gs + 1 < _s.length, "Trying to read beyond buffer length")), !(_s.length <= Gs)) return gl = Xs(_s, Gs, vl, !0), 32768 & gl ? -1 * (65535 - gl + 1) : gl;
          }
          function ws(_s, Gs, vl, gl) {
            if (gl || (Al(typeof vl == "boolean", "missing or invalid endian"), Al(Gs != null, "missing offset"), Al(Gs + 3 < _s.length, "Trying to read beyond buffer length")), !(_s.length <= Gs)) return gl = Cs(_s, Gs, vl, !0), 2147483648 & gl ? -1 * (4294967295 - gl + 1) : gl;
          }
          function ls(_s, Gs, vl, gl) {
            return gl || (Al(typeof vl == "boolean", "missing or invalid endian"), Al(Gs + 3 < _s.length, "Trying to read beyond buffer length")), rs.read(_s, Gs, vl, 23, 4);
          }
          function ks(_s, Gs, vl, gl) {
            return gl || (Al(typeof vl == "boolean", "missing or invalid endian"), Al(Gs + 7 < _s.length, "Trying to read beyond buffer length")), rs.read(_s, Gs, vl, 52, 8);
          }
          function Js(_s, Gs, vl, gl, El) {
            if (El || (Al(Gs != null, "missing value"), Al(typeof gl == "boolean", "missing or invalid endian"), Al(vl != null, "missing offset"), Al(vl + 1 < _s.length, "trying to write beyond buffer length"), Tl(Gs, 65535)), El = _s.length, !(El <= vl)) for (var Ol = 0, wl = Math.min(El - vl, 2); Ol < wl; Ol++) _s[vl + Ol] = (Gs & 255 << 8 * (gl ? Ol : 1 - Ol)) >>> 8 * (gl ? Ol : 1 - Ol);
          }
          function pl(_s, Gs, vl, gl, El) {
            if (El || (Al(Gs != null, "missing value"), Al(typeof gl == "boolean", "missing or invalid endian"), Al(vl != null, "missing offset"), Al(vl + 3 < _s.length, "trying to write beyond buffer length"), Tl(Gs, 4294967295)), El = _s.length, !(El <= vl)) for (var Ol = 0, wl = Math.min(El - vl, 4); Ol < wl; Ol++) _s[vl + Ol] = Gs >>> 8 * (gl ? Ol : 3 - Ol) & 255;
          }
          function _l(_s, Gs, vl, gl, El) {
            El || (Al(Gs != null, "missing value"), Al(typeof gl == "boolean", "missing or invalid endian"), Al(vl != null, "missing offset"), Al(vl + 1 < _s.length, "Trying to write beyond buffer length"), Il(Gs, 32767, -32768)), _s.length <= vl || Js(_s, 0 <= Gs ? Gs : 65535 + Gs + 1, vl, gl, El);
          }
          function bl(_s, Gs, vl, gl, El) {
            El || (Al(Gs != null, "missing value"), Al(typeof gl == "boolean", "missing or invalid endian"), Al(vl != null, "missing offset"), Al(vl + 3 < _s.length, "Trying to write beyond buffer length"), Il(Gs, 2147483647, -2147483648)), _s.length <= vl || pl(_s, 0 <= Gs ? Gs : 4294967295 + Gs + 1, vl, gl, El);
          }
          function xl(_s, Gs, vl, gl, El) {
            El || (Al(Gs != null, "missing value"), Al(typeof gl == "boolean", "missing or invalid endian"), Al(vl != null, "missing offset"), Al(vl + 3 < _s.length, "Trying to write beyond buffer length"), jl(Gs, 34028234663852886e22, -34028234663852886e22)), _s.length <= vl || rs.write(_s, Gs, vl, gl, 23, 4);
          }
          function Rl(_s, Gs, vl, gl, El) {
            El || (Al(Gs != null, "missing value"), Al(typeof gl == "boolean", "missing or invalid endian"), Al(vl != null, "missing offset"), Al(vl + 7 < _s.length, "Trying to write beyond buffer length"), jl(Gs, 17976931348623157e292, -17976931348623157e292)), _s.length <= vl || rs.write(_s, Gs, vl, gl, 52, 8);
          }
          Qi.Buffer = ko, Qi.SlowBuffer = ko, Qi.INSPECT_MAX_BYTES = 50, ko.poolSize = 8192, ko._useTypedArrays = function() {
            try {
              var _s = new ArrayBuffer(0), Gs = new Uint8Array(_s);
              return Gs.foo = function() {
                return 42;
              }, Gs.foo() === 42 && typeof Gs.subarray == "function";
            } catch {
              return !1;
            }
          }(), ko.isEncoding = function(_s) {
            switch (String(_s).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, ko.isBuffer = function(_s) {
            return !(_s == null || !_s._isBuffer);
          }, ko.byteLength = function(_s, Gs) {
            var vl;
            switch (_s += "", Gs || "utf8") {
              case "hex":
                vl = _s.length / 2;
                break;
              case "utf8":
              case "utf-8":
                vl = Zl(_s).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                vl = _s.length;
                break;
              case "base64":
                vl = Pl(_s).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                vl = 2 * _s.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return vl;
          }, ko.concat = function(_s, Gs) {
            if (Al(Ul(_s), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), _s.length === 0) return new ko(0);
            if (_s.length === 1) return _s[0];
            if (typeof Gs != "number") for (El = Gs = 0; El < _s.length; El++) Gs += _s[El].length;
            for (var vl = new ko(Gs), gl = 0, El = 0; El < _s.length; El++) {
              var Ol = _s[El];
              Ol.copy(vl, gl), gl += Ol.length;
            }
            return vl;
          }, ko.prototype.write = function(_s, Gs, vl, gl) {
            isFinite(Gs) ? isFinite(vl) || (gl = vl, vl = void 0) : (Sl = gl, gl = Gs, Gs = vl, vl = Sl), Gs = Number(Gs) || 0;
            var El, Ol, wl, dl, Sl = this.length - Gs;
            switch ((!vl || Sl < (vl = Number(vl))) && (vl = Sl), gl = String(gl || "utf8").toLowerCase()) {
              case "hex":
                El = function(Ml, Fl, Ll, Nl) {
                  Ll = Number(Ll) || 0;
                  var ql = Ml.length - Ll;
                  (!Nl || ql < (Nl = Number(Nl))) && (Nl = ql), Al((ql = Fl.length) % 2 == 0, "Invalid hex string"), ql / 2 < Nl && (Nl = ql / 2);
                  for (var Jl = 0; Jl < Nl; Jl++) {
                    var zl = parseInt(Fl.substr(2 * Jl, 2), 16);
                    Al(!isNaN(zl), "Invalid hex string"), Ml[Ll + Jl] = zl;
                  }
                  return ko._charsWritten = 2 * Jl, Jl;
                }(this, _s, Gs, vl);
                break;
              case "utf8":
              case "utf-8":
                Ol = this, wl = Gs, dl = vl, El = ko._charsWritten = yl(Zl(_s), Ol, wl, dl);
                break;
              case "ascii":
              case "binary":
                El = Hs(this, _s, Gs, vl);
                break;
              case "base64":
                Ol = this, wl = Gs, dl = vl, El = ko._charsWritten = yl(Pl(_s), Ol, wl, dl);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                El = Ks(this, _s, Gs, vl);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return El;
          }, ko.prototype.toString = function(_s, Gs, vl) {
            var gl, El, Ol, wl, dl = this;
            if (_s = String(_s || "utf8").toLowerCase(), Gs = Number(Gs) || 0, (vl = vl !== void 0 ? Number(vl) : dl.length) === Gs) return "";
            switch (_s) {
              case "hex":
                gl = function(Sl, Ml, Fl) {
                  var Ll = Sl.length;
                  (!Ml || Ml < 0) && (Ml = 0), (!Fl || Fl < 0 || Ll < Fl) && (Fl = Ll);
                  for (var Nl = "", ql = Ml; ql < Fl; ql++) Nl += Bl(Sl[ql]);
                  return Nl;
                }(dl, Gs, vl);
                break;
              case "utf8":
              case "utf-8":
                gl = function(Sl, Ml, Fl) {
                  var Ll = "", Nl = "";
                  Fl = Math.min(Sl.length, Fl);
                  for (var ql = Ml; ql < Fl; ql++) Sl[ql] <= 127 ? (Ll += hl(Nl) + String.fromCharCode(Sl[ql]), Nl = "") : Nl += "%" + Sl[ql].toString(16);
                  return Ll + hl(Nl);
                }(dl, Gs, vl);
                break;
              case "ascii":
              case "binary":
                gl = Ys(dl, Gs, vl);
                break;
              case "base64":
                El = dl, wl = vl, gl = (Ol = Gs) === 0 && wl === El.length ? eo.fromByteArray(El) : eo.fromByteArray(El.slice(Ol, wl));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                gl = function(Sl, Ml, Fl) {
                  for (var Ll = Sl.slice(Ml, Fl), Nl = "", ql = 0; ql < Ll.length; ql += 2) Nl += String.fromCharCode(Ll[ql] + 256 * Ll[ql + 1]);
                  return Nl;
                }(dl, Gs, vl);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return gl;
          }, ko.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, ko.prototype.copy = function(_s, Gs, vl, gl) {
            if (Gs = Gs || 0, (gl = gl || gl === 0 ? gl : this.length) !== (vl = vl || 0) && _s.length !== 0 && this.length !== 0) {
              Al(vl <= gl, "sourceEnd < sourceStart"), Al(0 <= Gs && Gs < _s.length, "targetStart out of bounds"), Al(0 <= vl && vl < this.length, "sourceStart out of bounds"), Al(0 <= gl && gl <= this.length, "sourceEnd out of bounds"), gl > this.length && (gl = this.length);
              var El = (gl = _s.length - Gs < gl - vl ? _s.length - Gs + vl : gl) - vl;
              if (El < 100 || !ko._useTypedArrays) for (var Ol = 0; Ol < El; Ol++) _s[Ol + Gs] = this[Ol + vl];
              else _s._set(this.subarray(vl, vl + El), Gs);
            }
          }, ko.prototype.slice = function(_s, Gs) {
            var vl = this.length;
            if (_s = Dl(_s, vl, 0), Gs = Dl(Gs, vl, vl), ko._useTypedArrays) return ko._augment(this.subarray(_s, Gs));
            for (var gl = Gs - _s, El = new ko(gl, void 0, !0), Ol = 0; Ol < gl; Ol++) El[Ol] = this[Ol + _s];
            return El;
          }, ko.prototype.get = function(_s) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(_s);
          }, ko.prototype.set = function(_s, Gs) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(_s, Gs);
          }, ko.prototype.readUInt8 = function(_s, Gs) {
            if (Gs || (Al(_s != null, "missing offset"), Al(_s < this.length, "Trying to read beyond buffer length")), !(_s >= this.length)) return this[_s];
          }, ko.prototype.readUInt16LE = function(_s, Gs) {
            return Xs(this, _s, !0, Gs);
          }, ko.prototype.readUInt16BE = function(_s, Gs) {
            return Xs(this, _s, !1, Gs);
          }, ko.prototype.readUInt32LE = function(_s, Gs) {
            return Cs(this, _s, !0, Gs);
          }, ko.prototype.readUInt32BE = function(_s, Gs) {
            return Cs(this, _s, !1, Gs);
          }, ko.prototype.readInt8 = function(_s, Gs) {
            if (Gs || (Al(_s != null, "missing offset"), Al(_s < this.length, "Trying to read beyond buffer length")), !(_s >= this.length)) return 128 & this[_s] ? -1 * (255 - this[_s] + 1) : this[_s];
          }, ko.prototype.readInt16LE = function(_s, Gs) {
            return Fs(this, _s, !0, Gs);
          }, ko.prototype.readInt16BE = function(_s, Gs) {
            return Fs(this, _s, !1, Gs);
          }, ko.prototype.readInt32LE = function(_s, Gs) {
            return ws(this, _s, !0, Gs);
          }, ko.prototype.readInt32BE = function(_s, Gs) {
            return ws(this, _s, !1, Gs);
          }, ko.prototype.readFloatLE = function(_s, Gs) {
            return ls(this, _s, !0, Gs);
          }, ko.prototype.readFloatBE = function(_s, Gs) {
            return ls(this, _s, !1, Gs);
          }, ko.prototype.readDoubleLE = function(_s, Gs) {
            return ks(this, _s, !0, Gs);
          }, ko.prototype.readDoubleBE = function(_s, Gs) {
            return ks(this, _s, !1, Gs);
          }, ko.prototype.writeUInt8 = function(_s, Gs, vl) {
            vl || (Al(_s != null, "missing value"), Al(Gs != null, "missing offset"), Al(Gs < this.length, "trying to write beyond buffer length"), Tl(_s, 255)), Gs >= this.length || (this[Gs] = _s);
          }, ko.prototype.writeUInt16LE = function(_s, Gs, vl) {
            Js(this, _s, Gs, !0, vl);
          }, ko.prototype.writeUInt16BE = function(_s, Gs, vl) {
            Js(this, _s, Gs, !1, vl);
          }, ko.prototype.writeUInt32LE = function(_s, Gs, vl) {
            pl(this, _s, Gs, !0, vl);
          }, ko.prototype.writeUInt32BE = function(_s, Gs, vl) {
            pl(this, _s, Gs, !1, vl);
          }, ko.prototype.writeInt8 = function(_s, Gs, vl) {
            vl || (Al(_s != null, "missing value"), Al(Gs != null, "missing offset"), Al(Gs < this.length, "Trying to write beyond buffer length"), Il(_s, 127, -128)), Gs >= this.length || (0 <= _s ? this.writeUInt8(_s, Gs, vl) : this.writeUInt8(255 + _s + 1, Gs, vl));
          }, ko.prototype.writeInt16LE = function(_s, Gs, vl) {
            _l(this, _s, Gs, !0, vl);
          }, ko.prototype.writeInt16BE = function(_s, Gs, vl) {
            _l(this, _s, Gs, !1, vl);
          }, ko.prototype.writeInt32LE = function(_s, Gs, vl) {
            bl(this, _s, Gs, !0, vl);
          }, ko.prototype.writeInt32BE = function(_s, Gs, vl) {
            bl(this, _s, Gs, !1, vl);
          }, ko.prototype.writeFloatLE = function(_s, Gs, vl) {
            xl(this, _s, Gs, !0, vl);
          }, ko.prototype.writeFloatBE = function(_s, Gs, vl) {
            xl(this, _s, Gs, !1, vl);
          }, ko.prototype.writeDoubleLE = function(_s, Gs, vl) {
            Rl(this, _s, Gs, !0, vl);
          }, ko.prototype.writeDoubleBE = function(_s, Gs, vl) {
            Rl(this, _s, Gs, !1, vl);
          }, ko.prototype.fill = function(_s, Gs, vl) {
            if (Gs = Gs || 0, vl = vl || this.length, Al(typeof (_s = typeof (_s = _s || 0) == "string" ? _s.charCodeAt(0) : _s) == "number" && !isNaN(_s), "value is not a number"), Al(Gs <= vl, "end < start"), vl !== Gs && this.length !== 0) {
              Al(0 <= Gs && Gs < this.length, "start out of bounds"), Al(0 <= vl && vl <= this.length, "end out of bounds");
              for (var gl = Gs; gl < vl; gl++) this[gl] = _s;
            }
          }, ko.prototype.inspect = function() {
            for (var _s = [], Gs = this.length, vl = 0; vl < Gs; vl++) if (_s[vl] = Bl(this[vl]), vl === Qi.INSPECT_MAX_BYTES) {
              _s[vl + 1] = "...";
              break;
            }
            return "<Buffer " + _s.join(" ") + ">";
          }, ko.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (ko._useTypedArrays) return new ko(this).buffer;
            for (var _s = new Uint8Array(this.length), Gs = 0, vl = _s.length; Gs < vl; Gs += 1) _s[Gs] = this[Gs];
            return _s.buffer;
          };
          var Cl = ko.prototype;
          function Dl(_s, Gs, vl) {
            return typeof _s != "number" ? vl : Gs <= (_s = ~~_s) ? Gs : 0 <= _s || 0 <= (_s += Gs) ? _s : 0;
          }
          function kl(_s) {
            return (_s = ~~Math.ceil(+_s)) < 0 ? 0 : _s;
          }
          function Ul(_s) {
            return (Array.isArray || function(Gs) {
              return Object.prototype.toString.call(Gs) === "[object Array]";
            })(_s);
          }
          function Bl(_s) {
            return _s < 16 ? "0" + _s.toString(16) : _s.toString(16);
          }
          function Zl(_s) {
            for (var Gs = [], vl = 0; vl < _s.length; vl++) {
              var gl = _s.charCodeAt(vl);
              if (gl <= 127) Gs.push(_s.charCodeAt(vl));
              else for (var El = vl, Ol = (55296 <= gl && gl <= 57343 && vl++, encodeURIComponent(_s.slice(El, vl + 1)).substr(1).split("%")), wl = 0; wl < Ol.length; wl++) Gs.push(parseInt(Ol[wl], 16));
            }
            return Gs;
          }
          function Pl(_s) {
            return eo.toByteArray(_s);
          }
          function yl(_s, Gs, vl, gl) {
            for (var El = 0; El < gl && !(El + vl >= Gs.length || El >= _s.length); El++) Gs[El + vl] = _s[El];
            return El;
          }
          function hl(_s) {
            try {
              return decodeURIComponent(_s);
            } catch {
              return "�";
            }
          }
          function Tl(_s, Gs) {
            Al(typeof _s == "number", "cannot write a non-number as a number"), Al(0 <= _s, "specified a negative value for writing an unsigned value"), Al(_s <= Gs, "value is larger than maximum value for type"), Al(Math.floor(_s) === _s, "value has a fractional component");
          }
          function Il(_s, Gs, vl) {
            Al(typeof _s == "number", "cannot write a non-number as a number"), Al(_s <= Gs, "value larger than maximum allowed value"), Al(vl <= _s, "value smaller than minimum allowed value"), Al(Math.floor(_s) === _s, "value has a fractional component");
          }
          function jl(_s, Gs, vl) {
            Al(typeof _s == "number", "cannot write a non-number as a number"), Al(_s <= Gs, "value larger than maximum allowed value"), Al(vl <= _s, "value smaller than minimum allowed value");
          }
          function Al(_s, Gs) {
            if (!_s) throw new Error(Gs || "Failed assertion");
          }
          ko._augment = function(_s) {
            return _s._isBuffer = !0, _s._get = _s.get, _s._set = _s.set, _s.get = Cl.get, _s.set = Cl.set, _s.write = Cl.write, _s.toString = Cl.toString, _s.toLocaleString = Cl.toString, _s.toJSON = Cl.toJSON, _s.copy = Cl.copy, _s.slice = Cl.slice, _s.readUInt8 = Cl.readUInt8, _s.readUInt16LE = Cl.readUInt16LE, _s.readUInt16BE = Cl.readUInt16BE, _s.readUInt32LE = Cl.readUInt32LE, _s.readUInt32BE = Cl.readUInt32BE, _s.readInt8 = Cl.readInt8, _s.readInt16LE = Cl.readInt16LE, _s.readInt16BE = Cl.readInt16BE, _s.readInt32LE = Cl.readInt32LE, _s.readInt32BE = Cl.readInt32BE, _s.readFloatLE = Cl.readFloatLE, _s.readFloatBE = Cl.readFloatBE, _s.readDoubleLE = Cl.readDoubleLE, _s.readDoubleBE = Cl.readDoubleBE, _s.writeUInt8 = Cl.writeUInt8, _s.writeUInt16LE = Cl.writeUInt16LE, _s.writeUInt16BE = Cl.writeUInt16BE, _s.writeUInt32LE = Cl.writeUInt32LE, _s.writeUInt32BE = Cl.writeUInt32BE, _s.writeInt8 = Cl.writeInt8, _s.writeInt16LE = Cl.writeInt16LE, _s.writeInt16BE = Cl.writeInt16BE, _s.writeInt32LE = Cl.writeInt32LE, _s.writeInt32BE = Cl.writeInt32BE, _s.writeFloatLE = Cl.writeFloatLE, _s.writeFloatBE = Cl.writeFloatBE, _s.writeDoubleLE = Cl.writeDoubleLE, _s.writeDoubleBE = Cl.writeDoubleBE, _s.fill = Cl.fill, _s.inspect = Cl.inspect, _s.toArrayBuffer = Cl.toArrayBuffer, _s;
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(qi, Xi, Qi) {
        (function(ta, ra, eo, la, Ma, Va, to, Eo, So) {
          var eo = qi("buffer").Buffer, rs = 4, ko = new eo(rs);
          ko.fill(0), Xi.exports = { hash: function(Hs, Ks, Ys, Xs) {
            for (var Cs = Ks(function(Js, pl) {
              Js.length % rs != 0 && (_l = Js.length + (rs - Js.length % rs), Js = eo.concat([Js, ko], _l));
              for (var _l, bl = [], xl = pl ? Js.readInt32BE : Js.readInt32LE, Rl = 0; Rl < Js.length; Rl += rs) bl.push(xl.call(Js, Rl));
              return bl;
            }(Hs = eo.isBuffer(Hs) ? Hs : new eo(Hs), Xs), 8 * Hs.length), Ks = Xs, Fs = new eo(Ys), ws = Ks ? Fs.writeInt32BE : Fs.writeInt32LE, ls = 0; ls < Cs.length; ls++) ws.call(Fs, Cs[ls], 4 * ls, !0);
            return Fs;
          } };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(qi, Xi, Qi) {
        (function(ta, ra, eo, la, Ma, Va, to, Eo, So) {
          var eo = qi("buffer").Buffer, rs = qi("./sha"), ko = qi("./sha256"), Hs = qi("./rng"), Ks = { sha1: rs, sha256: ko, md5: qi("./md5") }, Ys = 64, Xs = new eo(Ys);
          function Cs(Js, pl) {
            var _l = Ks[Js = Js || "sha1"], bl = [];
            return _l || Fs("algorithm:", Js, "is not yet supported"), { update: function(xl) {
              return eo.isBuffer(xl) || (xl = new eo(xl)), bl.push(xl), xl.length, this;
            }, digest: function(xl) {
              var Rl = eo.concat(bl), Rl = pl ? function(Cl, Dl, kl) {
                eo.isBuffer(Dl) || (Dl = new eo(Dl)), eo.isBuffer(kl) || (kl = new eo(kl)), Dl.length > Ys ? Dl = Cl(Dl) : Dl.length < Ys && (Dl = eo.concat([Dl, Xs], Ys));
                for (var Ul = new eo(Ys), Bl = new eo(Ys), Zl = 0; Zl < Ys; Zl++) Ul[Zl] = 54 ^ Dl[Zl], Bl[Zl] = 92 ^ Dl[Zl];
                return kl = Cl(eo.concat([Ul, kl])), Cl(eo.concat([Bl, kl]));
              }(_l, pl, Rl) : _l(Rl);
              return bl = null, xl ? Rl.toString(xl) : Rl;
            } };
          }
          function Fs() {
            var Js = [].slice.call(arguments).join(" ");
            throw new Error([Js, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          Xs.fill(0), Qi.createHash = function(Js) {
            return Cs(Js);
          }, Qi.createHmac = Cs, Qi.randomBytes = function(Js, pl) {
            if (!pl || !pl.call) return new eo(Hs(Js));
            try {
              pl.call(this, void 0, new eo(Hs(Js)));
            } catch (_l) {
              pl(_l);
            }
          };
          var ws, ls = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], ks = function(Js) {
            Qi[Js] = function() {
              Fs("sorry,", Js, "is not implemented yet");
            };
          };
          for (ws in ls) ks(ls[ws]);
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          var eo = qi("./helpers");
          function rs(Fs, ws) {
            Fs[ws >> 5] |= 128 << ws % 32, Fs[14 + (ws + 64 >>> 9 << 4)] = ws;
            for (var ls = 1732584193, ks = -271733879, Js = -1732584194, pl = 271733878, _l = 0; _l < Fs.length; _l += 16) {
              var bl = ls, xl = ks, Rl = Js, Cl = pl, ls = Hs(ls, ks, Js, pl, Fs[_l + 0], 7, -680876936), pl = Hs(pl, ls, ks, Js, Fs[_l + 1], 12, -389564586), Js = Hs(Js, pl, ls, ks, Fs[_l + 2], 17, 606105819), ks = Hs(ks, Js, pl, ls, Fs[_l + 3], 22, -1044525330);
              ls = Hs(ls, ks, Js, pl, Fs[_l + 4], 7, -176418897), pl = Hs(pl, ls, ks, Js, Fs[_l + 5], 12, 1200080426), Js = Hs(Js, pl, ls, ks, Fs[_l + 6], 17, -1473231341), ks = Hs(ks, Js, pl, ls, Fs[_l + 7], 22, -45705983), ls = Hs(ls, ks, Js, pl, Fs[_l + 8], 7, 1770035416), pl = Hs(pl, ls, ks, Js, Fs[_l + 9], 12, -1958414417), Js = Hs(Js, pl, ls, ks, Fs[_l + 10], 17, -42063), ks = Hs(ks, Js, pl, ls, Fs[_l + 11], 22, -1990404162), ls = Hs(ls, ks, Js, pl, Fs[_l + 12], 7, 1804603682), pl = Hs(pl, ls, ks, Js, Fs[_l + 13], 12, -40341101), Js = Hs(Js, pl, ls, ks, Fs[_l + 14], 17, -1502002290), ls = Ks(ls, ks = Hs(ks, Js, pl, ls, Fs[_l + 15], 22, 1236535329), Js, pl, Fs[_l + 1], 5, -165796510), pl = Ks(pl, ls, ks, Js, Fs[_l + 6], 9, -1069501632), Js = Ks(Js, pl, ls, ks, Fs[_l + 11], 14, 643717713), ks = Ks(ks, Js, pl, ls, Fs[_l + 0], 20, -373897302), ls = Ks(ls, ks, Js, pl, Fs[_l + 5], 5, -701558691), pl = Ks(pl, ls, ks, Js, Fs[_l + 10], 9, 38016083), Js = Ks(Js, pl, ls, ks, Fs[_l + 15], 14, -660478335), ks = Ks(ks, Js, pl, ls, Fs[_l + 4], 20, -405537848), ls = Ks(ls, ks, Js, pl, Fs[_l + 9], 5, 568446438), pl = Ks(pl, ls, ks, Js, Fs[_l + 14], 9, -1019803690), Js = Ks(Js, pl, ls, ks, Fs[_l + 3], 14, -187363961), ks = Ks(ks, Js, pl, ls, Fs[_l + 8], 20, 1163531501), ls = Ks(ls, ks, Js, pl, Fs[_l + 13], 5, -1444681467), pl = Ks(pl, ls, ks, Js, Fs[_l + 2], 9, -51403784), Js = Ks(Js, pl, ls, ks, Fs[_l + 7], 14, 1735328473), ls = Ys(ls, ks = Ks(ks, Js, pl, ls, Fs[_l + 12], 20, -1926607734), Js, pl, Fs[_l + 5], 4, -378558), pl = Ys(pl, ls, ks, Js, Fs[_l + 8], 11, -2022574463), Js = Ys(Js, pl, ls, ks, Fs[_l + 11], 16, 1839030562), ks = Ys(ks, Js, pl, ls, Fs[_l + 14], 23, -35309556), ls = Ys(ls, ks, Js, pl, Fs[_l + 1], 4, -1530992060), pl = Ys(pl, ls, ks, Js, Fs[_l + 4], 11, 1272893353), Js = Ys(Js, pl, ls, ks, Fs[_l + 7], 16, -155497632), ks = Ys(ks, Js, pl, ls, Fs[_l + 10], 23, -1094730640), ls = Ys(ls, ks, Js, pl, Fs[_l + 13], 4, 681279174), pl = Ys(pl, ls, ks, Js, Fs[_l + 0], 11, -358537222), Js = Ys(Js, pl, ls, ks, Fs[_l + 3], 16, -722521979), ks = Ys(ks, Js, pl, ls, Fs[_l + 6], 23, 76029189), ls = Ys(ls, ks, Js, pl, Fs[_l + 9], 4, -640364487), pl = Ys(pl, ls, ks, Js, Fs[_l + 12], 11, -421815835), Js = Ys(Js, pl, ls, ks, Fs[_l + 15], 16, 530742520), ls = Xs(ls, ks = Ys(ks, Js, pl, ls, Fs[_l + 2], 23, -995338651), Js, pl, Fs[_l + 0], 6, -198630844), pl = Xs(pl, ls, ks, Js, Fs[_l + 7], 10, 1126891415), Js = Xs(Js, pl, ls, ks, Fs[_l + 14], 15, -1416354905), ks = Xs(ks, Js, pl, ls, Fs[_l + 5], 21, -57434055), ls = Xs(ls, ks, Js, pl, Fs[_l + 12], 6, 1700485571), pl = Xs(pl, ls, ks, Js, Fs[_l + 3], 10, -1894986606), Js = Xs(Js, pl, ls, ks, Fs[_l + 10], 15, -1051523), ks = Xs(ks, Js, pl, ls, Fs[_l + 1], 21, -2054922799), ls = Xs(ls, ks, Js, pl, Fs[_l + 8], 6, 1873313359), pl = Xs(pl, ls, ks, Js, Fs[_l + 15], 10, -30611744), Js = Xs(Js, pl, ls, ks, Fs[_l + 6], 15, -1560198380), ks = Xs(ks, Js, pl, ls, Fs[_l + 13], 21, 1309151649), ls = Xs(ls, ks, Js, pl, Fs[_l + 4], 6, -145523070), pl = Xs(pl, ls, ks, Js, Fs[_l + 11], 10, -1120210379), Js = Xs(Js, pl, ls, ks, Fs[_l + 2], 15, 718787259), ks = Xs(ks, Js, pl, ls, Fs[_l + 9], 21, -343485551), ls = Cs(ls, bl), ks = Cs(ks, xl), Js = Cs(Js, Rl), pl = Cs(pl, Cl);
            }
            return Array(ls, ks, Js, pl);
          }
          function ko(Fs, ws, ls, ks, Js, pl) {
            return Cs((ws = Cs(Cs(ws, Fs), Cs(ks, pl))) << Js | ws >>> 32 - Js, ls);
          }
          function Hs(Fs, ws, ls, ks, Js, pl, _l) {
            return ko(ws & ls | ~ws & ks, Fs, ws, Js, pl, _l);
          }
          function Ks(Fs, ws, ls, ks, Js, pl, _l) {
            return ko(ws & ks | ls & ~ks, Fs, ws, Js, pl, _l);
          }
          function Ys(Fs, ws, ls, ks, Js, pl, _l) {
            return ko(ws ^ ls ^ ks, Fs, ws, Js, pl, _l);
          }
          function Xs(Fs, ws, ls, ks, Js, pl, _l) {
            return ko(ls ^ (ws | ~ks), Fs, ws, Js, pl, _l);
          }
          function Cs(Fs, ws) {
            var ls = (65535 & Fs) + (65535 & ws);
            return (Fs >> 16) + (ws >> 16) + (ls >> 16) << 16 | 65535 & ls;
          }
          Xi.exports = function(Fs) {
            return eo.hash(Fs, rs, 16);
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          Xi.exports = function(eo) {
            for (var rs, ko = new Array(eo), Hs = 0; Hs < eo; Hs++) (3 & Hs) == 0 && (rs = 4294967296 * Math.random()), ko[Hs] = rs >>> ((3 & Hs) << 3) & 255;
            return ko;
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          var eo = qi("./helpers");
          function rs(Ks, Ys) {
            Ks[Ys >> 5] |= 128 << 24 - Ys % 32, Ks[15 + (Ys + 64 >> 9 << 4)] = Ys;
            for (var Xs, Cs, Fs, ws = Array(80), ls = 1732584193, ks = -271733879, Js = -1732584194, pl = 271733878, _l = -1009589776, bl = 0; bl < Ks.length; bl += 16) {
              for (var xl = ls, Rl = ks, Cl = Js, Dl = pl, kl = _l, Ul = 0; Ul < 80; Ul++) {
                ws[Ul] = Ul < 16 ? Ks[bl + Ul] : Hs(ws[Ul - 3] ^ ws[Ul - 8] ^ ws[Ul - 14] ^ ws[Ul - 16], 1);
                var Bl = ko(ko(Hs(ls, 5), (Bl = ks, Cs = Js, Fs = pl, (Xs = Ul) < 20 ? Bl & Cs | ~Bl & Fs : !(Xs < 40) && Xs < 60 ? Bl & Cs | Bl & Fs | Cs & Fs : Bl ^ Cs ^ Fs)), ko(ko(_l, ws[Ul]), (Xs = Ul) < 20 ? 1518500249 : Xs < 40 ? 1859775393 : Xs < 60 ? -1894007588 : -899497514)), _l = pl, pl = Js, Js = Hs(ks, 30), ks = ls, ls = Bl;
              }
              ls = ko(ls, xl), ks = ko(ks, Rl), Js = ko(Js, Cl), pl = ko(pl, Dl), _l = ko(_l, kl);
            }
            return Array(ls, ks, Js, pl, _l);
          }
          function ko(Ks, Ys) {
            var Xs = (65535 & Ks) + (65535 & Ys);
            return (Ks >> 16) + (Ys >> 16) + (Xs >> 16) << 16 | 65535 & Xs;
          }
          function Hs(Ks, Ys) {
            return Ks << Ys | Ks >>> 32 - Ys;
          }
          Xi.exports = function(Ks) {
            return eo.hash(Ks, rs, 20, !0);
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          function eo(Ys, Xs) {
            var Cs = (65535 & Ys) + (65535 & Xs);
            return (Ys >> 16) + (Xs >> 16) + (Cs >> 16) << 16 | 65535 & Cs;
          }
          function rs(Ys, Xs) {
            var Cs, Fs = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), ws = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), ls = new Array(64);
            Ys[Xs >> 5] |= 128 << 24 - Xs % 32, Ys[15 + (Xs + 64 >> 9 << 4)] = Xs;
            for (var ks, Js, pl = 0; pl < Ys.length; pl += 16) {
              for (var _l = ws[0], bl = ws[1], xl = ws[2], Rl = ws[3], Cl = ws[4], Dl = ws[5], kl = ws[6], Ul = ws[7], Bl = 0; Bl < 64; Bl++) ls[Bl] = Bl < 16 ? Ys[Bl + pl] : eo(eo(eo((Js = ls[Bl - 2], Hs(Js, 17) ^ Hs(Js, 19) ^ Ks(Js, 10)), ls[Bl - 7]), (Js = ls[Bl - 15], Hs(Js, 7) ^ Hs(Js, 18) ^ Ks(Js, 3))), ls[Bl - 16]), Cs = eo(eo(eo(eo(Ul, Hs(Js = Cl, 6) ^ Hs(Js, 11) ^ Hs(Js, 25)), Cl & Dl ^ ~Cl & kl), Fs[Bl]), ls[Bl]), ks = eo(Hs(ks = _l, 2) ^ Hs(ks, 13) ^ Hs(ks, 22), _l & bl ^ _l & xl ^ bl & xl), Ul = kl, kl = Dl, Dl = Cl, Cl = eo(Rl, Cs), Rl = xl, xl = bl, bl = _l, _l = eo(Cs, ks);
              ws[0] = eo(_l, ws[0]), ws[1] = eo(bl, ws[1]), ws[2] = eo(xl, ws[2]), ws[3] = eo(Rl, ws[3]), ws[4] = eo(Cl, ws[4]), ws[5] = eo(Dl, ws[5]), ws[6] = eo(kl, ws[6]), ws[7] = eo(Ul, ws[7]);
            }
            return ws;
          }
          var ko = qi("./helpers"), Hs = function(Ys, Xs) {
            return Ys >>> Xs | Ys << 32 - Xs;
          }, Ks = function(Ys, Xs) {
            return Ys >>> Xs;
          };
          Xi.exports = function(Ys) {
            return ko.hash(Ys, rs, 32, !0);
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          Qi.read = function(eo, rs, ko, Hs, pl) {
            var Ys, Xs, Cs = 8 * pl - Hs - 1, Fs = (1 << Cs) - 1, ws = Fs >> 1, ls = -7, ks = ko ? pl - 1 : 0, Js = ko ? -1 : 1, pl = eo[rs + ks];
            for (ks += Js, Ys = pl & (1 << -ls) - 1, pl >>= -ls, ls += Cs; 0 < ls; Ys = 256 * Ys + eo[rs + ks], ks += Js, ls -= 8) ;
            for (Xs = Ys & (1 << -ls) - 1, Ys >>= -ls, ls += Hs; 0 < ls; Xs = 256 * Xs + eo[rs + ks], ks += Js, ls -= 8) ;
            if (Ys === 0) Ys = 1 - ws;
            else {
              if (Ys === Fs) return Xs ? NaN : 1 / 0 * (pl ? -1 : 1);
              Xs += Math.pow(2, Hs), Ys -= ws;
            }
            return (pl ? -1 : 1) * Xs * Math.pow(2, Ys - Hs);
          }, Qi.write = function(eo, rs, ko, Hs, Ks, _l) {
            var Xs, Cs, Fs = 8 * _l - Ks - 1, ws = (1 << Fs) - 1, ls = ws >> 1, ks = Ks === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, Js = Hs ? 0 : _l - 1, pl = Hs ? 1 : -1, _l = rs < 0 || rs === 0 && 1 / rs < 0 ? 1 : 0;
            for (rs = Math.abs(rs), isNaN(rs) || rs === 1 / 0 ? (Cs = isNaN(rs) ? 1 : 0, Xs = ws) : (Xs = Math.floor(Math.log(rs) / Math.LN2), rs * (Hs = Math.pow(2, -Xs)) < 1 && (Xs--, Hs *= 2), 2 <= (rs += 1 <= Xs + ls ? ks / Hs : ks * Math.pow(2, 1 - ls)) * Hs && (Xs++, Hs /= 2), ws <= Xs + ls ? (Cs = 0, Xs = ws) : 1 <= Xs + ls ? (Cs = (rs * Hs - 1) * Math.pow(2, Ks), Xs += ls) : (Cs = rs * Math.pow(2, ls - 1) * Math.pow(2, Ks), Xs = 0)); 8 <= Ks; eo[ko + Js] = 255 & Cs, Js += pl, Cs /= 256, Ks -= 8) ;
            for (Xs = Xs << Ks | Cs, Fs += Ks; 0 < Fs; eo[ko + Js] = 255 & Xs, Js += pl, Xs /= 256, Fs -= 8) ;
            eo[ko + Js - pl] |= 128 * _l;
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(qi, Xi, Qi) {
        (function(ta, ra, na, la, Ma, Va, to, Eo, So) {
          var eo, rs, ko;
          function Hs() {
          }
          (ta = Xi.exports = {}).nextTick = (rs = typeof window < "u" && window.setImmediate, ko = typeof window < "u" && window.postMessage && window.addEventListener, rs ? function(Ks) {
            return window.setImmediate(Ks);
          } : ko ? (eo = [], window.addEventListener("message", function(Ks) {
            var Ys = Ks.source;
            Ys !== window && Ys !== null || Ks.data !== "process-tick" || (Ks.stopPropagation(), 0 < eo.length && eo.shift()());
          }, !0), function(Ks) {
            eo.push(Ks), window.postMessage("process-tick", "*");
          }) : function(Ks) {
            setTimeout(Ks, 0);
          }), ta.title = "browser", ta.browser = !0, ta.env = {}, ta.argv = [], ta.on = Hs, ta.addListener = Hs, ta.once = Hs, ta.off = Hs, ta.removeListener = Hs, ta.removeAllListeners = Hs, ta.emit = Hs, ta.binding = function(Ks) {
            throw new Error("process.binding is not supported");
          }, ta.cwd = function() {
            return "/";
          }, ta.chdir = function(Ks) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, qi("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, qi("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  }(object_hash)), object_hash.exports;
}
var object_hashExports = requireObject_hash();
const hash = /* @__PURE__ */ getDefaultExportFromCjs(object_hashExports), OptionsContainer = ({
  children: Bi,
  showMenu: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${e ? "block" : "hidden"}`,
    children: Bi
  }
);
function SelectionSearch({
  options: Bi,
  onSelect: e,
  displayKey: qi
}) {
  const [Xi, Qi] = useState(!1), ta = useRef(null), ra = () => Qi(!0), [na, la] = useState(""), Ma = useMemo(() => {
    if (!na) return Bi;
    const Va = new RegExp(na, "i");
    return Bi.filter((to) => qi ? to[qi].match(Va) : to.match(Va));
  }, [na, Bi]);
  return vi$1(ta, () => Qi(!1)), Si$1(
    {
      Escape: () => Qi(!1)
    },
    [Qi]
  ), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "relative", onFocus: ra, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Field,
      {
        autoComplete: "off",
        ref: ta,
        type: "text",
        onChange: (Va) => la(Va.target.value),
        value: na
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(OptionsContainer, { showMenu: Xi, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      motion.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          Ma.length > 0 && Ma.map((Va) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              onClick: () => {
                e(Va), la(
                  qi ? Va[qi] : Va
                );
              },
              children: qi ? Va[qi] : Va
            }
          ) }, hash(Va))),
          Xi && Ma.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
function Table({
  row: Bi,
  data: e,
  extras: qi = [],
  hide: Xi,
  transform: Qi,
  editable: ta = !1,
  onEdit: ra,
  defaultSortKey: na,
  className: la = "",
  render: Ma,
  renderHeading: Va,
  cell: to
}) {
  const [Eo, So] = useState(na ?? ""), [eo, rs] = useState(
    "desc"
    /* Descending */
  ), [ko, Hs] = useState({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), Ks = useMemo(() => [...e], [e]), Ys = useRef(null), Xs = useMemo(() => Eo ? Ks.sort((Js, pl) => {
    const _l = Js[Eo] ?? "", bl = pl[Eo] ?? "";
    return _l < bl ? eo === "asc" ? -1 : 1 : _l > bl ? eo === "asc" ? 1 : -1 : 0;
  }) : Ks, [Eo, Ks, eo]), Cs = useMemo(() => Ks.length === 0 ? [] : Object.getOwnPropertyNames(Ks[0]).reduce(
    (pl, _l) => {
      if (Xi?.[_l])
        return pl;
      if (typeof Va == "boolean") {
        if (!Va)
          return [
            ...pl,
            {
              key: _l,
              transformed: ""
            }
          ];
      } else if (Va?.[_l])
        return [
          ...pl,
          {
            key: _l,
            transformed: Va[_l]()
          }
        ];
      return Qi && isTransformMapFn(Qi) ? [...pl, { key: _l, transformed: Qi[_l](_l) }] : Qi && isTransformFnFn(Qi) ? [...pl, { key: _l, transformed: Qi(_l) }] : [
        ...pl,
        Qi?.[_l] ? { key: _l, transformed: Qi[_l] } : { key: _l, transformed: _l }
      ];
    },
    []
  ), [Ks]), Fs = useCallback(
    (Js, pl) => Ma?.[Js] ? Ma[Js](pl) : Js === ko.key && hash(pl) === ko.hashedRow && ta ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (_l) => {
            _l.preventDefault(), ra && ra({
              column: ko.key,
              newValue: ko.newValue,
              oldValue: ko.value,
              rowData: pl
            }), Hs({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), Ys.current?.blur();
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                ra?.({
                  column: ko.key,
                  newValue: ko.newValue,
                  oldValue: ko.value,
                  rowData: pl
                }), Hs({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: Ys,
              autoFocus: !0,
              value: ko.newValue,
              onChange: (_l) => Hs({
                key: Js,
                value: pl[Js],
                newValue: _l.target.value,
                hashedRow: hash(pl)
              })
            },
            `${hash(pl)}}-${Js}-${pl[Js]}-input`
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: "invisible", children: pl[Js] })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: pl[Js] }),
    [ko, Ma]
  ), ws = Bi ?? ((Js) => /* @__PURE__ */ jsxRuntimeExports.jsx("tr", { ...Js }));
  let ls = !0;
  isBoolean(Va) && (Va ? ls = !0 : ls = !1);
  const ks = to ?? "td";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("table", { className: la, children: [
    ls && /* @__PURE__ */ jsxRuntimeExports.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("tr", { children: [
      Cs.map(
        ({ key: Js, transformed: pl }) => !Xi?.[Js] && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "th",
          {
            onClick: () => {
              Eo == Js ? rs(
                () => eo === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (So(Js), rs(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex justify-start items-center", children: [
              pl,
              Js === Eo && eo === "asc" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: faChevronUp
                }
              ),
              Js === Eo && eo === "desc" && /* @__PURE__ */ jsxRuntimeExports.jsx(
                FontAwesomeIcon,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: faChevronDown
                }
              )
            ] })
          },
          Js
        )
      ),
      (qi || []).map(({ key: Js }, pl) => /* @__PURE__ */ jsxRuntimeExports.jsx("th", { children: Js }, `extras-${Js}-${pl}`))
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: Xs.map(
      (Js) => ws(
        {
          key: hash(Js),
          children: Object.entries(Js).map(([pl, _l]) => Xi?.[pl] ? null : !Xi?.[pl] && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ks,
            {
              title: _l,
              onClick: () => {
                ta && !Ma?.[pl] && Hs({
                  key: pl,
                  value: _l,
                  newValue: _l,
                  hashedRow: hash(Js)
                });
              },
              children: Fs(pl, Js)
            },
            `${hash(Js)}}-${pl}-${_l}`
          ))
        },
        Js
      )
    ) })
  ] });
}
function isBoolean(Bi) {
  return typeof Bi == "boolean";
}
function isTransformMapFn(Bi) {
  return Object.keys(Bi).length === 0 ? !1 : Object.values(Bi)[0] instanceof Function;
}
function isTransformFnFn(Bi) {
  return Bi instanceof Function;
}
const TabsContext = createContext(
  {}
), TabsProvider = TabsContext.Provider, useTabsContext = () => useContext(TabsContext), Tabs = ({ children: Bi, defaultValue: e }) => {
  const [qi, Xi] = useState(e), Qi = useMemo(() => Children.toArray(Bi).find((na) => na.props.__TYPE === "tabs-list") || null, [Bi]), ta = useMemo(() => Children.toArray(Bi).find((ra) => {
    const na = ra;
    return na.props.__TYPE === "tab-content" && na.props.value === qi;
  }), [Bi, qi]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TabsProvider,
    {
      value: { activeTab: qi, setActiveTab: (ra) => Xi(ra) },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "flex flex-col rounded", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex w-full", children: Qi }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex flex-col flex-grow h-full w-full", children: ta })
      ] })
    }
  );
}, Tab = ({ value: Bi, children: e }) => {
  const { activeTab: qi, setActiveTab: Xi } = useTabsContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      className: `rounded px-4 py-2 bg-neutral-50 mr-1 hover:bg-neutral-100 ${qi === Bi ? "text-brand-500" : "text-neutral-800"}`,
      onClick: () => Xi(Bi),
      children: e
    }
  );
}, TabsList = ({ children: Bi }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "flex bg-neutral-300 p-1 py-2 w-full rounded", children: Bi });
TabsList.defaultProps = {
  __TYPE: "tabs-list"
};
const TabContent = ({
  children: Bi,
  className: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `flex-grow w-full bg-neutral-100 p-1 ${e}`, children: Bi });
TabContent.defaultProps = {
  __TYPE: "tab-content"
};
const TaskQueueLogs = ({
  jobId: Bi,
  className: e = ""
}) => {
  const { data: qi } = useTaskQueueLogsSubscription({ variables: { jobId: Bi } }), [Xi, Qi] = useState([]);
  return useEffect(() => {
    qi?.taskQueueLogs && Qi((ta) => [...ta, qi.taskQueueLogs]);
  }, [qi]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: `${e} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: Xi.map((ta, ra) => /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { children: ta.message }, `task-queue-${Bi}-${ta.timestamp}-${ra}`))
    }
  );
}, ThemeContext = createContext({}), useTheme = () => useContext(ThemeContext), useDarkModeState = (Bi = !1) => {
  const [e, qi] = useState(Bi);
  return useEffect(() => {
    const Xi = localStorage.getItem("darkMode");
    try {
      const Qi = JSON.parse(Xi || "");
      qi(Qi.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: Bi })
      );
    }
  }, [qi]), useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: e }));
  }, [e]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (Xi) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !Xi })), qi(Xi);
    }
  };
}, ThemeProvider = ({ children: Bi }) => {
  const { darkMode: e, setDarkMode: qi } = useDarkModeState();
  return useEffect(() => {
    const Xi = document.querySelector("body");
    Xi && Xi.classList.remove("dark");
  }, [e]), /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: { darkMode: e, setDarkMode: qi }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "", children: Bi }) });
}, Title = ({
  order: Bi,
  children: e,
  className: qi = ""
}) => {
  function Xi(Qi, ta) {
    switch (Qi) {
      case 1:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h1", { className: `${qi} text-2xl text-brand-500`, children: ta });
      case 2:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { className: `${qi} text-xl text-brand-600`, children: ta });
      case 3:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h3", { className: `${qi} text-brand-800`, children: ta });
      case 4:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: ta });
      case 5:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: ta });
      default:
      case 6:
        return /* @__PURE__ */ jsxRuntimeExports.jsx("h6", { children: ta });
    }
  }
  return Xi(Bi, e);
};
function Toggle({ on: Bi, onChange: e, className: qi = "" }) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    motion.button,
    {
      layout: !0,
      onClick: () => e(!Bi),
      className: `
                w-12 h-4 p-1 items-center ${qi} flex rounded transition-colors 
                ${Bi ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${Bi ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const Textarea = forwardRef(
  ({ className: Bi, ...e }, qi) => /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", { ref: qi, ...e, className: twMerge(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    Bi
  ) })
);
export {
  AppLayout,
  Button,
  CircleSpinner,
  CopyButton,
  Delete,
  Divider,
  Drawer,
  DrawerButton,
  Dropdown,
  DynamicFormInput,
  Ellipses,
  Error$1 as Error,
  ErrorBoundary,
  Field,
  FileBrowser,
  FileInput,
  FlexBox,
  FormikField,
  GridArea,
  ImagePreview,
  Input,
  Logo,
  Menu,
  MenuItem,
  MenuItemStyle,
  MenuStyle,
  Modal,
  ModalContainer,
  NotFound,
  Page,
  PageHeader,
  PageHeaderTitle,
  Preview,
  Protected,
  ReaderLayout,
  RequireRoles,
  S3DownloadLink,
  S3FileBrowser,
  SVGPreview,
  Select,
  SelectionSearch,
  Spacer,
  Spinner,
  Tab,
  TabContent,
  Table,
  TablePreview,
  Tabs,
  TabsList,
  TaskQueueLogs,
  Textarea,
  ThemeContext,
  ThemeProvider,
  Title,
  Toggle,
  UploadToast,
  fileListToArray,
  pageVariants,
  useModalContext,
  useTailwindBreakpoint,
  useTheme
};
//# sourceMappingURL=components.js.map
